/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 57171:
/***/ ((module) => {

function webpackEmptyContext(req) {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
}
webpackEmptyContext.keys = () => ([]);
webpackEmptyContext.resolve = webpackEmptyContext;
webpackEmptyContext.id = 57171;
module.exports = webpackEmptyContext;

/***/ }),

/***/ 97978:
/***/ ((module) => {

function webpackEmptyContext(req) {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
}
webpackEmptyContext.keys = () => ([]);
webpackEmptyContext.resolve = webpackEmptyContext;
webpackEmptyContext.id = 97978;
module.exports = webpackEmptyContext;

/***/ }),

/***/ 3178:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "ISO693_TO_3", ({
    enumerable: true,
    get: function() {
        return ISO693_TO_3;
    }
}));
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(37815);
var ISO693_TO_3 = {
    aa: "aar",
    ab: "abk",
    ae: "ave",
    af: "afr",
    ak: "aka",
    am: "amh",
    an: "arg",
    ar: "aao",
    as: "asm",
    av: "ava",
    ay: "aym",
    az: "azb",
    ba: "bak",
    be: "bel",
    bg: "bul",
    bi: "bis",
    bm: "bam",
    bn: "ben",
    bo: "bod",
    br: "bre",
    ca: "cat",
    ce: "che",
    ch: "cha",
    co: "cos",
    cr: "cre",
    cs: "ces",
    cu: "chu",
    cv: "chv",
    cy: "cym",
    da: "dan",
    de: "deu",
    dv: "div",
    dz: "dzo",
    ee: "ewe",
    el: "ell",
    en: "eng",
    eo: "epo",
    es: "spa",
    et: "ekk",
    eu: "eus",
    fa: "fas",
    ff: "ffm",
    fi: "fin",
    fj: "fij",
    fo: "fao",
    fr: "fra",
    fy: "fry",
    ga: "gle",
    gd: "gla",
    gl: "glg",
    gn: "gnw",
    gu: "guj",
    gv: "glv",
    ha: "hau",
    he: "heb",
    hi: "hin",
    ho: "hmo",
    ht: "hat",
    hu: "hun",
    hy: "hye",
    hz: "her",
    ia: "ina",
    ie: "ile",
    ig: "ibo",
    ii: "iii",
    ik: "esi",
    io: "ido",
    is: "isl",
    it: "ita",
    iu: "ike",
    ja: "jpn",
    jv: "jav",
    ka: "kat",
    kg: "kng",
    ki: "kik",
    kj: "kua",
    kk: "kaz",
    kl: "kal",
    km: "khm",
    kn: "kan",
    ko: "kor",
    kr: "kau",
    ks: "kas",
    ku: "ckb",
    kv: "koi",
    kw: "cor",
    ky: "kir",
    la: "lat",
    lb: "ltz",
    lg: "lug",
    li: "lim",
    ln: "lin",
    lo: "lao",
    lt: "lit",
    lu: "lub",
    lv: "lav",
    mg: "bhr",
    mh: "mah",
    mi: "mri",
    mk: "mkd",
    ml: "mal",
    mn: "khk",
    mr: "mar",
    ms: "bjn",
    mt: "mlt",
    my: "mya",
    na: "nau",
    nd: "nde",
    ne: "dty",
    ng: "ndo",
    nl: "nld",
    no: "nno",
    nr: "nbl",
    nv: "nav",
    ny: "nya",
    oc: "oci",
    oj: "ojb",
    om: "gax",
    or: "ori",
    os: "oss",
    pa: "pan",
    pi: "pli",
    pl: "pol",
    ps: "pbt",
    pt: "por",
    qu: "qub",
    rm: "roh",
    rn: "run",
    ro: "ron",
    ru: "rus",
    rw: "kin",
    sa: "san",
    sc: "sdc",
    sd: "snd",
    se: "sme",
    sg: "sag",
    sh: "bos",
    si: "sin",
    sk: "slk",
    sl: "slv",
    sm: "smo",
    sn: "sna",
    so: "som",
    sq: "aae",
    ss: "ssw",
    st: "sot",
    su: "sun",
    sv: "swe",
    sw: "swa",
    ta: "tam",
    te: "tel",
    tg: "tgk",
    th: "tha",
    ti: "tir",
    tk: "tuk",
    tl: "tgl",
    tn: "tsn",
    to: "ton",
    tr: "tur",
    ts: "tso",
    tt: "tat",
    ty: "tah",
    ug: "uig",
    uk: "ukr",
    ur: "urd",
    uz: "uzb",
    ve: "ven",
    vi: "vie",
    vo: "vol",
    wa: "wln",
    wo: "wol",
    xh: "xho",
    yi: "ydd",
    yo: "yor",
    za: "zch",
    zh: "cdo",
    zu: "zul"
};


/***/ }),

/***/ 13831:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "ISO693_TO_1", ({
    enumerable: true,
    get: function() {
        return ISO693_TO_1;
    }
}));
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(3009);
var ISO693_TO_1 = {
    aar: "aa",
    abk: "ab",
    ave: "ae",
    afr: "af",
    aka: "ak",
    amh: "am",
    arg: "an",
    ara: "ar",
    asm: "as",
    ava: "av",
    aym: "ay",
    aze: "az",
    bak: "ba",
    bel: "be",
    bul: "bg",
    bih: "bh",
    bis: "bi",
    bam: "bm",
    ben: "bn",
    bod: "bo",
    tib: "bo",
    bre: "br",
    bos: "bs",
    cat: "ca",
    che: "ce",
    cha: "ch",
    cos: "co",
    cre: "cr",
    ces: "cs",
    cze: "cs",
    chu: "cu",
    chv: "cv",
    cym: "cy",
    wel: "cy",
    dan: "da",
    deu: "de",
    ger: "de",
    div: "dv",
    dzo: "dz",
    ewe: "ee",
    ell: "el",
    gre: "el",
    eng: "en",
    epo: "eo",
    spa: "es",
    est: "et",
    baq: "eu",
    eus: "eu",
    fas: "fa",
    per: "fa",
    ful: "ff",
    fin: "fi",
    fij: "fj",
    fao: "fo",
    fra: "fr",
    fre: "fr",
    fry: "fy",
    gle: "ga",
    gla: "gd",
    glg: "gl",
    grn: "gn",
    guj: "gu",
    glv: "gv",
    hau: "ha",
    heb: "he",
    hin: "hi",
    hmo: "ho",
    hrv: "hr",
    hat: "ht",
    hun: "hu",
    arm: "hy",
    hye: "hy",
    her: "hz",
    ina: "ia",
    ind: "id",
    ile: "ie",
    ibo: "ig",
    iii: "ii",
    ipk: "ik",
    ido: "io",
    ice: "is",
    isl: "is",
    ita: "it",
    iku: "iu",
    jpn: "ja",
    jav: "jv",
    geo: "ka",
    kat: "ka",
    kon: "kg",
    kik: "ki",
    kua: "kj",
    kaz: "kk",
    kal: "kl",
    khm: "km",
    kan: "kn",
    kor: "ko",
    kau: "kr",
    kas: "ks",
    kur: "ku",
    kom: "kv",
    cor: "kw",
    kir: "ky",
    lat: "la",
    ltz: "lb",
    lug: "lg",
    lim: "li",
    lin: "ln",
    lao: "lo",
    lit: "lt",
    lub: "lu",
    lav: "lv",
    mlg: "mg",
    mah: "mh",
    mao: "mi",
    mri: "mi",
    mac: "mk",
    mkd: "mk",
    mal: "ml",
    mon: "mn",
    mar: "mr",
    may: "ms",
    msa: "ms",
    mlt: "mt",
    bur: "my",
    mya: "my",
    nau: "na",
    nob: "nb",
    nde: "nd",
    nep: "ne",
    ndo: "ng",
    dut: "nl",
    nld: "nl",
    nno: "nn",
    nor: "no",
    nbl: "nr",
    nav: "nv",
    nya: "ny",
    oci: "oc",
    oji: "oj",
    orm: "om",
    ori: "or",
    oss: "os",
    pan: "pa",
    pli: "pi",
    pol: "pl",
    pus: "ps",
    por: "pt",
    que: "qu",
    roh: "rm",
    run: "rn",
    ron: "ro",
    rum: "ro",
    rus: "ru",
    kin: "rw",
    san: "sa",
    srd: "sc",
    snd: "sd",
    sme: "se",
    sag: "sg",
    sin: "si",
    slk: "sk",
    slo: "sk",
    slv: "sl",
    smo: "sm",
    sna: "sn",
    som: "so",
    alb: "sq",
    sqi: "sq",
    srp: "sr",
    ssw: "ss",
    sot: "st",
    sun: "su",
    swe: "sv",
    swa: "sw",
    tam: "ta",
    tel: "te",
    tgk: "tg",
    tha: "th",
    tir: "ti",
    tuk: "tk",
    tgl: "tl",
    tsn: "tn",
    ton: "to",
    tur: "tr",
    tso: "ts",
    tat: "tt",
    twi: "tw",
    tah: "ty",
    uig: "ug",
    ukr: "uk",
    urd: "ur",
    uzb: "uz",
    ven: "ve",
    vie: "vi",
    vol: "vo",
    wln: "wa",
    wol: "wo",
    xho: "xh",
    yid: "yi",
    yor: "yo",
    zha: "za",
    chi: "zh",
    zho: "zh",
    zul: "zu"
};


/***/ }),

/***/ 67958:
/***/ ((module, exports, __webpack_require__) => {

"use strict";
/* eslint-disable no-negated-condition, import/no-unresolved */ /**
 * @description
 *
 * When LAUNCHING the app (`NODE_ENV` set to "development"),
 * the config is generated on the fly.
 *
 * When BUILDING the app (`NODE_ENV` set to "production"),
 * the config is imported from the pre-built static `<project_root>/build/config.json` file.
 * If the app has been built with "env override" mode enabled, the config is imported from the
 * corresponding environment of the nested `configByEnv` key of the static file.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _object_spread = __webpack_require__(76247);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
var isPlainObject = __webpack_require__(69143);
var _require = __webpack_require__(19561), appEnableEnvOverride = _require.appEnableEnvOverride, appEnv = _require.appEnv, appCustomer = _require.appCustomer, appPlatform = _require.appPlatform;
var config = {};
// ⚠️ KEEP NEGATED CONDITION FOR TREE-SHAKING (remove config.generator require from build)
if (false) {} else {
    config = __webpack_require__(12208);
    if (appEnableEnvOverride) {
        if (!isPlainObject(config.configByEnv)) {
            throw new Error('Cannot get config for "'.concat(appEnv, '" env: `config.configByEnv` is not a valid object.\nEnsure that you have pre-built the config with env override flag: `APP_ENABLE_ENV_OVERRIDE=true ... pnpm build-config`'));
        }
        if (!isPlainObject(config.configByEnv[appEnv])) {
            throw new Error('Cannot get config for "'.concat(appEnv, "\" env: `config.configByEnv['").concat(appEnv, "']` is not a valid object."));
        }
        config = _object_spread._({}, config.configByEnv[appEnv]);
    }
}
module.exports = config;


/***/ }),

/***/ 79290:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ACCOUNT_SETTINGS: function() {
        return ACCOUNT_SETTINGS;
    },
    AUDIO: function() {
        return AUDIO;
    },
    AVATAR_LIST_FOCUS_NAME: function() {
        return AVATAR_LIST_FOCUS_NAME;
    },
    BOOKMARK: function() {
        return BOOKMARK;
    },
    BOOKMARKS: function() {
        return BOOKMARKS;
    },
    CLOSE: function() {
        return CLOSE;
    },
    DISCONNECT_FOCUS_NAME: function() {
        return DISCONNECT_FOCUS_NAME;
    },
    EXPLORE: function() {
        return EXPLORE;
    },
    FEEDBACK: function() {
        return FEEDBACK;
    },
    FOLDER: function() {
        return FOLDER;
    },
    FOLDERS: function() {
        return FOLDERS;
    },
    FRONTSPACE: function() {
        return FRONTSPACE;
    },
    FULL_HD: function() {
        return FULL_HD;
    },
    HD: function() {
        return HD;
    },
    HELP: function() {
        return HELP;
    },
    HOME_ALIAS: function() {
        return HOME_ALIAS;
    },
    INFORMATION: function() {
        return INFORMATION;
    },
    LAYOUT_FIRST_BLOCK: function() {
        return LAYOUT_FIRST_BLOCK;
    },
    LEGAL_CONDITIONS: function() {
        return LEGAL_CONDITIONS;
    },
    LIVE: function() {
        return LIVE;
    },
    LIVES: function() {
        return LIVES;
    },
    LOCK: function() {
        return LOCK;
    },
    LOGOUT: function() {
        return LOGOUT;
    },
    NAV_BACK: function() {
        return NAV_BACK;
    },
    OPTOUT: function() {
        return OPTOUT;
    },
    PLAY: function() {
        return PLAY;
    },
    PRIVACY_POLICY: function() {
        return PRIVACY_POLICY;
    },
    PROFILE: function() {
        return PROFILE;
    },
    PROFILES_GATE: function() {
        return PROFILES_GATE;
    },
    PROGRAM: function() {
        return PROGRAM;
    },
    RADIO: function() {
        return RADIO;
    },
    SEARCH: function() {
        return SEARCH;
    },
    SEASON: function() {
        return SEASON;
    },
    SERVICE: function() {
        return SERVICE;
    },
    SERVICES: function() {
        return SERVICES;
    },
    SETTINGS: function() {
        return SETTINGS;
    },
    SIDENAV: function() {
        return SIDENAV;
    },
    SUBSCRIPTION_TERMS: function() {
        return SUBSCRIPTION_TERMS;
    },
    ULTRA_HD: function() {
        return ULTRA_HD;
    },
    UNBOOKMARK: function() {
        return UNBOOKMARK;
    },
    USAGE_TERMS: function() {
        return USAGE_TERMS;
    },
    VIDEO: function() {
        return VIDEO;
    }
});
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);
var _commonconstants = __webpack_require__(25879);
var AUDIO = "audio";
var BOOKMARK = "bookmark";
var UNBOOKMARK = "unbookmark";
var LIVE = "live";
var LIVES = "lives";
var PROGRAM = "program";
var SEASON = "season";
var VIDEO = "video";
var SERVICE = "service";
var HOME_ALIAS = "alias";
var SERVICES = "services";
var PROFILE = "account";
var SEARCH = "search";
var SETTINGS = "settings";
var FOLDERS = "folders";
var FOLDER = "folder";
var CLOSE = "close";
var SIDENAV = "sidenav";
var NAV_BACK = "backNavigation";
var EXPLORE = "explore";
var DISCONNECT_FOCUS_NAME = "disconnectButton";
var AVATAR_LIST_FOCUS_NAME = "avatarList";
var LAYOUT_FIRST_BLOCK = "block_0";
var LOCK = "lock";
var LOGOUT = "logout";
var FRONTSPACE = "frontspace";
var PROFILES_GATE = "profilesgate";
var PLAY = "play";
var RADIO = "radio";
var BOOKMARKS = "account_bookmarks";
var ACCOUNT_SETTINGS = "account_settings";
var INFORMATION = "account_informations";
var OPTOUT = _commonconstants.OPTOUT;
var USAGE_TERMS = "tos";
var LEGAL_CONDITIONS = "account_legalconditions";
var PRIVACY_POLICY = "privacy_policy";
var HELP = "help";
var FEEDBACK = "feedback";
var SUBSCRIPTION_TERMS = "termsofsubscription";
var HD = "HD";
var FULL_HD = "FULL_HD";
var ULTRA_HD = "ULTRA_HD";


/***/ }),

/***/ 25879:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "OPTOUT", ({
    enumerable: true,
    get: function() {
        return OPTOUT;
    }
}));
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(3009);
var OPTOUT = "consentsmanagement_device";


/***/ }),

/***/ 19:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DEFAULT_IMAGE_FORMAT: function() {
        return _default.DEFAULT_IMAGE_FORMAT;
    },
    IMAGE_FIT_CROP: function() {
        return IMAGE_FIT_CROP;
    },
    IMAGE_FIT_MAX: function() {
        return IMAGE_FIT_MAX;
    },
    IMAGE_FIT_SCALE_CROP: function() {
        return IMAGE_FIT_SCALE_CROP;
    },
    IMAGE_ITEMS_DEFAULT_OPTIONS: function() {
        return IMAGE_ITEMS_DEFAULT_OPTIONS;
    },
    IMAGE_QUALITY: function() {
        return IMAGE_QUALITY;
    },
    TRANSPARENT_IMAGE_FORMAT: function() {
        return _default.TRANSPARENT_IMAGE_FORMAT;
    }
});
var _export_star = __webpack_require__(37668);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(88801);
var _default = __webpack_require__(30350);
_export_star._(__webpack_require__(69482), exports);
var IMAGE_FIT_SCALE_CROP = "scale_crop";
var IMAGE_FIT_CROP = "crop";
var IMAGE_FIT_MAX = "max";
var IMAGE_QUALITY = 80;
var IMAGE_ITEMS_DEFAULT_OPTIONS = {
    image: {
        fit: IMAGE_FIT_SCALE_CROP,
        quality: IMAGE_QUALITY,
        format: _default.DEFAULT_IMAGE_FORMAT,
        interlace: 1,
        blur: 0,
        width: 256,
        height: 256
    },
    logo: {
        fit: IMAGE_FIT_SCALE_CROP,
        quality: IMAGE_QUALITY,
        format: _default.TRANSPARENT_IMAGE_FORMAT,
        interlace: 1
    }
};


/***/ }),

/***/ 69482:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    IMAGE_FORMAT_JPEG: function() {
        return IMAGE_FORMAT_JPEG;
    },
    IMAGE_FORMAT_PNG: function() {
        return IMAGE_FORMAT_PNG;
    },
    IMAGE_FORMAT_WEBP: function() {
        return IMAGE_FORMAT_WEBP;
    }
});
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(52318);
var IMAGE_FORMAT_JPEG = "jpeg";
var IMAGE_FORMAT_PNG = "png";
var IMAGE_FORMAT_WEBP = "webp";


/***/ }),

/***/ 34952:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _export_star = __webpack_require__(37668);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(65759);
_export_star._(__webpack_require__(79290), exports);
_export_star._(__webpack_require__(19), exports);
_export_star._(__webpack_require__(88165), exports);
_export_star._(__webpack_require__(10124), exports);


/***/ }),

/***/ 88165:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "MONITORING_TIMEOUT_ERROR", ({
    enumerable: true,
    get: function() {
        return MONITORING_TIMEOUT_ERROR;
    }
}));
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(52318);
var MONITORING_TIMEOUT_ERROR = "monitoring-timeout-exceeded";


/***/ }),

/***/ 30350:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DEFAULT_IMAGE_FORMAT: function() {
        return DEFAULT_IMAGE_FORMAT;
    },
    TRANSPARENT_IMAGE_FORMAT: function() {
        return TRANSPARENT_IMAGE_FORMAT;
    }
});
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(3009);
var _imageFormatconstants = __webpack_require__(69482);
var DEFAULT_IMAGE_FORMAT = _imageFormatconstants.IMAGE_FORMAT_JPEG;
var TRANSPARENT_IMAGE_FORMAT = _imageFormatconstants.IMAGE_FORMAT_PNG;


/***/ }),

/***/ 10124:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    CONTENT_GAP: function() {
        return CONTENT_GAP;
    },
    LAYOUT_LEFT_PADDING: function() {
        return LAYOUT_LEFT_PADDING;
    },
    SCREEN_HEIGHT: function() {
        return SCREEN_HEIGHT;
    },
    SCREEN_WIDTH: function() {
        return SCREEN_WIDTH;
    },
    SIDENAV_EXPANDED_WIDTH: function() {
        return SIDENAV_EXPANDED_WIDTH;
    },
    SIDENAV_WIDTH: function() {
        return SIDENAV_WIDTH;
    },
    safetyMargins: function() {
        return safetyMargins;
    }
});
var _define_property = __webpack_require__(21228);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
var _commonconstants = __webpack_require__(79290);
var safetyMargins = {
    horizontal: {
        HD: 64,
        FULL_HD: 96
    },
    vertical: {
        HD: 40,
        FULL_HD: 56
    }
};
var _obj;
var SIDENAV_WIDTH = (_obj = {}, _define_property._(_obj, _commonconstants.HD, 152), _define_property._(_obj, _commonconstants.FULL_HD, 224), _obj);
var _obj1;
var SIDENAV_EXPANDED_WIDTH = (_obj1 = {}, _define_property._(_obj1, _commonconstants.HD, 304), _define_property._(_obj1, _commonconstants.FULL_HD, 416), _obj1);
var _obj2;
var LAYOUT_LEFT_PADDING = (_obj2 = {}, _define_property._(_obj2, _commonconstants.HD, 40), _define_property._(_obj2, _commonconstants.FULL_HD, 40), _obj2);
var _obj3;
var SCREEN_WIDTH = (_obj3 = {}, _define_property._(_obj3, _commonconstants.HD, 1280), _define_property._(_obj3, _commonconstants.FULL_HD, 1920), _obj3);
var _obj4;
var SCREEN_HEIGHT = (_obj4 = {}, _define_property._(_obj4, _commonconstants.HD, 720), _define_property._(_obj4, _commonconstants.FULL_HD, 1080), _obj4);
var _obj5;
var CONTENT_GAP = (_obj5 = {}, _define_property._(_obj5, _commonconstants.HD, 12), _define_property._(_obj5, _commonconstants.FULL_HD, 12), _obj5);


/***/ }),

/***/ 12510:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    AUTOPLAY_PREVENTED_ERROR: function() {
        return AUTOPLAY_PREVENTED_ERROR;
    },
    DASH_CAPABILITY_ERROR: function() {
        return DASH_CAPABILITY_ERROR;
    },
    DASH_DOWNLOAD_ERROR: function() {
        return DASH_DOWNLOAD_ERROR;
    },
    DASH_KEY_MESSAGE_ERROR: function() {
        return DASH_KEY_MESSAGE_ERROR;
    },
    DASH_KEY_SESSION_ERROR: function() {
        return DASH_KEY_SESSION_ERROR;
    },
    DASH_MANIFEST_ERROR: function() {
        return DASH_MANIFEST_ERROR;
    },
    DASH_MEDIA_SOURCE_ERROR: function() {
        return DASH_MEDIA_SOURCE_ERROR;
    },
    DASH_OTHER_ERROR: function() {
        return DASH_OTHER_ERROR;
    },
    DASH_TIMED_TEXT_ERROR: function() {
        return DASH_TIMED_TEXT_ERROR;
    },
    ENGINE_ABORTED: function() {
        return ENGINE_ABORTED;
    },
    ENGINE_DECODE: function() {
        return ENGINE_DECODE;
    },
    ENGINE_NETWORK: function() {
        return ENGINE_NETWORK;
    },
    ENGINE_SRC_NOT_SUPPORTED: function() {
        return ENGINE_SRC_NOT_SUPPORTED;
    },
    ENGINE_UNKNOWN: function() {
        return ENGINE_UNKNOWN;
    },
    METHOD_MUST_BE_OVERLOADED: function() {
        return METHOD_MUST_BE_OVERLOADED;
    },
    NO_CONTAINER: function() {
        return NO_CONTAINER;
    },
    NO_PLAYER: function() {
        return NO_PLAYER;
    },
    NO_SOURCE: function() {
        return NO_SOURCE;
    },
    UNKNOWN: function() {
        return UNKNOWN;
    }
});
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(45538);
var UNKNOWN = "UNKNOWN";
var METHOD_MUST_BE_OVERLOADED = "METHOD_MUST_BE_OVERLOADED";
var NO_PLAYER = "NO_PLAYER";
var NO_CONTAINER = "NO_CONTAINER";
var NO_SOURCE = "NO_SOURCE";
var ENGINE_ABORTED = "ENGINE_ABORTED_ERROR";
var ENGINE_NETWORK = "ENGINE_NETWORK_ERROR";
var ENGINE_DECODE = "ENGINE_DECODE_ERROR";
var ENGINE_SRC_NOT_SUPPORTED = "ENGINE_SRC_NOT_SUPPORTED_ERROR";
var ENGINE_UNKNOWN = "ENGINE_UNKNOWN";
var AUTOPLAY_PREVENTED_ERROR = "AUTOPLAY_PREVENTED_ERROR";
var DASH_CAPABILITY_ERROR = "DASH_CAPABILITY_ERROR";
var DASH_DOWNLOAD_ERROR = "DASH_DOWNLOAD_ERROR";
var DASH_MANIFEST_ERROR = "DASH_MANIFEST_ERROR";
var DASH_MEDIA_SOURCE_ERROR = "DASH_MEDIA_SOURCE_ERROR";
var DASH_KEY_SESSION_ERROR = "DASH_KEY_SESSION_ERROR";
var DASH_KEY_MESSAGE_ERROR = "DASH_KEY_MESSAGE_ERROR";
var DASH_TIMED_TEXT_ERROR = "DASH_TIMED_TEXT_ERROR";
var DASH_OTHER_ERROR = "DASH_OTHER_ERROR";


/***/ }),

/***/ 5426:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    INTERNAL_ERROR_GET_PLAYER: function() {
        return INTERNAL_ERROR_GET_PLAYER;
    },
    INTERNAL_ERROR_NO_CONTAINER: function() {
        return INTERNAL_ERROR_NO_CONTAINER;
    },
    INTERNAL_ERROR_NO_SOURCE: function() {
        return INTERNAL_ERROR_NO_SOURCE;
    },
    INTERNAL_ERROR_OVERLOAD: function() {
        return INTERNAL_ERROR_OVERLOAD;
    },
    INTERNAL_ERROR_UNKNOWN: function() {
        return INTERNAL_ERROR_UNKNOWN;
    },
    PLAYER_ERROR: function() {
        return PLAYER_ERROR;
    }
});
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(52318);
var INTERNAL_ERROR_OVERLOAD = "INTERNAL_ERROR_OVERLOAD";
var INTERNAL_ERROR_NO_CONTAINER = "INTERNAL_ERROR_NO_CONTAINER";
var INTERNAL_ERROR_UNKNOWN = "INTERNAL_ERROR_UNKNOWN";
var INTERNAL_ERROR_NO_SOURCE = "INTERNAL_ERROR_NO_SOURCE";
var INTERNAL_ERROR_GET_PLAYER = "INTERNAL_ERROR_GET_PLAYER";
var PLAYER_ERROR = "PLAYER_ERROR";


/***/ }),

/***/ 64702:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BRIDGE_ERROR: function() {
        return BRIDGE_ERROR;
    },
    ENGINE_ERROR: function() {
        return ENGINE_ERROR;
    },
    IMPLEMENTATION_ERROR: function() {
        return IMPLEMENTATION_ERROR;
    },
    UNKNOWN_ERROR: function() {
        return UNKNOWN_ERROR;
    }
});
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(88801);
var UNKNOWN_ERROR = "UNKNOWN_ERROR";
var IMPLEMENTATION_ERROR = "IMPLEMENTATION_ERROR";
var ENGINE_ERROR = "ENGINE_ERROR";
var BRIDGE_ERROR = "BRIDGE_ERROR";


/***/ }),

/***/ 58003:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    AUDIO_TRACK_CHANGED: function() {
        return AUDIO_TRACK_CHANGED;
    },
    LICENSE_LOADED: function() {
        return LICENSE_LOADED;
    },
    MANIFEST_LOADED: function() {
        return MANIFEST_LOADED;
    },
    SUBTITLES_TRACK_CHANGED: function() {
        return SUBTITLES_TRACK_CHANGED;
    },
    SUBTITLES_UPDATED: function() {
        return SUBTITLES_UPDATED;
    },
    TRACKS_CHANGED: function() {
        return TRACKS_CHANGED;
    }
});
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
var MANIFEST_LOADED = "manifest_loaded";
var TRACKS_CHANGED = "tracks_changed";
var AUDIO_TRACK_CHANGED = "audio_track_changed";
var SUBTITLES_TRACK_CHANGED = "subtitles_track_changed";
var SUBTITLES_UPDATED = "subtitles_updated";
var LICENSE_LOADED = "license";


/***/ }),

/***/ 51992:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DISABLED_SUBTITLES: function() {
        return DISABLED_SUBTITLES;
    },
    DISABLED_SUBTITLES_ID: function() {
        return DISABLED_SUBTITLES_ID;
    }
});
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(65759);
var DISABLED_SUBTITLES = "disable";
var DISABLED_SUBTITLES_ID = -1;


/***/ }),

/***/ 78736:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    default: function() {
        return _default;
    },
    engineValues: function() {
        return engineValues;
    }
});
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _interop_require_default = __webpack_require__(81200);
var _interop_require_wildcard = __webpack_require__(95316);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(45538);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _noop = /*#__PURE__*/ _interop_require_default._(__webpack_require__(43226));
var _mediaengine = __webpack_require__(62221);
var _mediaEngineErrorHelpers = __webpack_require__(84338);
var _internal = /*#__PURE__*/ _interop_require_wildcard._(__webpack_require__(5426));
var _details = /*#__PURE__*/ _interop_require_wildcard._(__webpack_require__(12510));
var ERROR = _mediaengine.VIDEO_EVENTS.ERROR;
var engineValues = {
    ABSTRACT_ENGINE: "AbstractEngine",
    GET_ATTAINABLE_LIVE_LATENCY: "getAttainableLiveLatency",
    GET_BUFFER_PROGRESS: "getBufferProgress",
    GET_DURATION: "getDuration",
    GET_INSTANCE: "getInstance",
    GET_PRESENTATION_START_TIME: "getPresentationStartTime",
    GET_SEEK_WINDOW: "getSeekWindow",
    GET_VOLUME: "getVolume",
    INIT: "init",
    IS_MUTED: "isMuted",
    START: "start",
    PLAY: "play",
    PAUSE: "pause",
    RELEASE: "release",
    SEEK: "seek",
    SET_VOLUME: "setVolume",
    SET_MUTED: "setMuted",
    STORE_AUDIO_TRACK: "storeAudioTrack",
    STORE_SUBTITLE_TRACK: "storeSubtitleTrack"
};
var Engine = /*#__PURE__*/ function() {
    "use strict";
    function Engine() {
        _class_call_check._(this, Engine);
        this.name = engineValues.ABSTRACT_ENGINE;
    }
    _create_class._(Engine, [
        {
            key: "dispatchInternalError",
            value: function dispatchInternalError(internalErrorType, reason) {
                var content = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
                var error = "";
                switch(internalErrorType){
                    case _internal.INTERNAL_ERROR_OVERLOAD:
                        error = (0, _mediaEngineErrorHelpers.throwMethodOverloadError)({
                            context: this.name,
                            reason: reason,
                            content: content
                        });
                        break;
                    case _internal.INTERNAL_ERROR_GET_PLAYER:
                        error = (0, _mediaEngineErrorHelpers.throwNoPlayerError)({
                            context: this.name,
                            reason: reason,
                            content: content,
                            detail: _details.NO_PLAYER
                        });
                        break;
                    default:
                        error = (0, _mediaEngineErrorHelpers.throwEngineErrorHelper)({
                            context: this.name,
                            reason: reason,
                            content: content
                        });
                        break;
                }
                // eslint-disable-next-line no-console
                console.error("[".concat(this.name, "][").concat(internalErrorType, "]: ").concat(reason, " ").concat(content));
                (0, _get.default)(this, "options.dispatcher", _noop.default)(ERROR, {
                    error: error
                });
            }
        },
        {
            /**
   * Reset the engine
   * @returns {Promise}
   */ key: "reset",
            value: function reset() {
                return Promise.resolve();
            }
        },
        {
            key: "release",
            value: function release() {
                return this.reset();
            }
        },
        {
            key: "getInstance",
            value: function getInstance() {
                this.dispatchInternalError(_internal.INTERNAL_ERROR_OVERLOAD, engineValues.GET_INSTANCE);
            }
        },
        {
            key: "init",
            value: function init() {
                this.dispatchInternalError(_internal.INTERNAL_ERROR_OVERLOAD, engineValues.INIT);
            }
        },
        {
            key: "setVolume",
            value: function setVolume(volume) {
                this.dispatchInternalError(_internal.INTERNAL_ERROR_OVERLOAD, engineValues.SET_VOLUME, volume);
            }
        },
        {
            key: "isMuted",
            value: function isMuted() {
                this.dispatchInternalError(_internal.INTERNAL_ERROR_OVERLOAD, engineValues.IS_MUTED);
            }
        },
        {
            key: "setMuted",
            value: function setMuted(muted) {
                this.dispatchInternalError(_internal.INTERNAL_ERROR_OVERLOAD, engineValues.SET_MUTED, muted);
            }
        },
        {
            key: "getVolume",
            value: function getVolume() {
                this.dispatchInternalError(_internal.INTERNAL_ERROR_OVERLOAD, engineValues.GET_VOLUME);
            }
        },
        {
            key: "getDuration",
            value: function getDuration() {
                this.dispatchInternalError(_internal.INTERNAL_ERROR_OVERLOAD, engineValues.GET_DURATION);
            }
        },
        {
            key: "getBufferProgress",
            value: function getBufferProgress() {
                this.dispatchInternalError(_internal.INTERNAL_ERROR_OVERLOAD, engineValues.GET_BUFFER_PROGRESS);
            }
        },
        {
            key: "getAttainableLiveLatency",
            value: function getAttainableLiveLatency() {
                this.dispatchInternalError(_internal.INTERNAL_ERROR_OVERLOAD, engineValues.GET_ATTAINABLE_LIVE_LATENCY);
            }
        },
        {
            key: "getSeekWindow",
            value: function getSeekWindow() {
                this.dispatchInternalError(_internal.INTERNAL_ERROR_OVERLOAD, engineValues.GET_SEEK_WINDOW);
            }
        },
        {
            key: "getPresentationStartTime",
            value: function getPresentationStartTime() {
                this.dispatchInternalError(_internal.INTERNAL_ERROR_OVERLOAD, engineValues.GET_PRESENTATION_START_TIME);
            }
        },
        {
            key: "seek",
            value: function seek(position) {
                this.dispatchInternalError(_internal.INTERNAL_ERROR_OVERLOAD, engineValues.SEEK, position);
            }
        },
        {
            key: "play",
            value: function play() {
                this.dispatchInternalError(_internal.INTERNAL_ERROR_OVERLOAD, engineValues.PLAY);
            }
        },
        {
            key: "pause",
            value: function pause() {
                this.dispatchInternalError(_internal.INTERNAL_ERROR_OVERLOAD, engineValues.PAUSE);
            }
        },
        {
            key: "start",
            value: function start() {
                this.dispatchInternalError(_internal.INTERNAL_ERROR_OVERLOAD, engineValues.START);
            }
        },
        {
            key: "setSource",
            value: function setSource(source) {
                this.start(source);
            }
        }
    ]);
    return Engine;
}();
var _default = Engine;


/***/ }),

/***/ 67681:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/* eslint-disable no-console */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "HTML5Engine", ({
    enumerable: true,
    get: function() {
        return HTML5Engine;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(3009);
var _mediaengine = __webpack_require__(62221);
var _mediaEngineErrorHelpers = __webpack_require__(84338);
var _details = __webpack_require__(12510);
var _engine = /*#__PURE__*/ _interop_require_default._(__webpack_require__(78736));
var HTML5Engine = /*#__PURE__*/ function(Engine) {
    "use strict";
    _inherits._(HTML5Engine, Engine);
    var _super = _create_super._(HTML5Engine);
    function HTML5Engine() {
        _class_call_check._(this, HTML5Engine);
        return _super.apply(this, arguments);
    }
    _create_class._(HTML5Engine, [
        {
            key: "configure",
            value: function configure(options) {
                this.options = options;
            }
        },
        {
            key: "init",
            value: function init(element) {
                this.videoElement = element;
            }
        },
        {
            key: "setSource",
            value: function setSource(source) {
                this.start(source);
            }
        },
        {
            key: "start",
            value: function start(source) {
                console.log("[HTML5Engine] Source playback requested:", source);
                this._playbackAvailable = false;
                this._isFirstTickFired = false;
                this._isTimeFixed = false;
                this._seekStarted = false;
                this.source = source;
                if (!source) {
                    this.pause();
                    return;
                }
                this.startTime = this.source.startTime || 0;
                var timeParameter = this.startTime ? "#t=".concat(this.startTime) : "";
                if (this.videoElement) {
                    if (typeof this.source === "string") {
                        this.videoElement.src = "".concat(this.source).concat(timeParameter);
                    } else {
                        this.videoElement.src = "".concat(this.source.reference || this.source.src).concat(timeParameter);
                    }
                }
            }
        },
        {
            key: "play",
            value: function play() {
                if (!this.videoElement) {
                    return Promise.reject(Error("No video element to play"));
                }
                if (!this.videoElement.src) {
                    return Promise.reject(Error("No source set to play"));
                }
                try {
                    return this.videoElement.play();
                } catch (error) {
                    if (this.options) {
                        this.options.dispatcher(_mediaengine.VIDEO_EVENTS.ERROR, {
                            error: (0, _mediaEngineErrorHelpers.throwAutoplayErrorHelper)({
                                type: _details.AUTOPLAY_PREVENTED_ERROR,
                                details: "The user did not interacted with the player",
                                fatal: true,
                                context: this.name
                            })
                        });
                    }
                    return Promise.reject(error);
                }
            }
        },
        {
            key: "pause",
            value: function pause() {
                if (!this.videoElement) {
                    return;
                }
                try {
                    this.videoElement.pause();
                } catch (error) {
                // NOTE: some STBs may pause but throw an error, ignoring it
                }
            }
        },
        {
            key: "seek",
            value: function seek(time) {
                if (!this.videoElement) {
                    return;
                }
                var fastSeekSupported = Boolean(this.videoElement.fastSeek);
                console.log("[HTML5Engine] Seek requested to ".concat(time, " with seek mode ").concat(fastSeekSupported));
                this._seekStarted = true;
                if (fastSeekSupported) {
                    this.videoElement.fastSeek(time);
                } else {
                    this.videoElement.currentTime = time;
                }
            }
        },
        {
            key: "setEventListeners",
            value: function setEventListeners() {
                var _this = this;
                // NOTE: Ensure listeners clean-up if this method was mistakenly called a few times in a row
                this.removeEventListeners();
                if (!this.videoElement) {
                    return;
                }
                this._handlers = {
                    video: {
                        canplay: this.onVideoElementCanPlay.bind(this),
                        canplaythrough: this.onVideoElementCanPlayThrough.bind(this),
                        play: this.onVideoElementPlay.bind(this),
                        pause: this.onVideoElementPause.bind(this),
                        ended: this.onVideoElementEnded.bind(this),
                        error: this.onVideoElementError.bind(this),
                        seeked: this.onVideoElementSeeked.bind(this),
                        seeking: this.onVideoElementSeeking.bind(this),
                        loadstart: this.onVideoElementLoadstart.bind(this),
                        timeupdate: this.onVideoElementTimeupdate.bind(this)
                    }
                };
                Object.keys(this._handlers.video).forEach(function(key) {
                    _this.videoElement.addEventListener(key, _this._handlers.video[key]);
                });
            }
        },
        {
            key: "removeEventListeners",
            value: function removeEventListeners() {
                var _this = this;
                if (!this._handlers) {
                    return;
                }
                if (this.videoElement) {
                    Object.keys(this._handlers.video).forEach(function(key) {
                        _this.videoElement.removeEventListener(key, _this._handlers.video[key]);
                    });
                }
                this._handlers = null;
            }
        },
        {
            key: "getCurrentTime",
            value: function getCurrentTime() {
                return this.videoElement ? this.videoElement.currentTime : 0;
            }
        },
        {
            key: "getDuration",
            value: function getDuration() {
                return this.videoElement ? this.videoElement.duration : 0;
            }
        },
        {
            key: "setVolume",
            value: function setVolume(volume) {
                if (this.videoElement) {
                    this.videoElement.volume = volume;
                }
            }
        },
        {
            /**
   * Handles HTMLMediaElement: canplay event
   * @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/canplay_event
   */ key: "onVideoElementCanPlay",
            value: function onVideoElementCanPlay() {
                if (!this.videoElement || !this.options || !this.source) {
                    return;
                }
                if (!this._playbackAvailable) {
                    this._playbackAvailable = true;
                    // NOTE: will not work for ads as those doesn't have the start time set
                    if (Number.isFinite(this.source.startTime) && this.videoElement.currentTime < this.source.startTime) {
                        this.videoElement.currentTime = this.startTime;
                    }
                    this.options.dispatcher(_mediaengine.VIDEO_EVENTS.CAN_PLAY, {
                        duration: this.videoElement.duration
                    });
                }
            }
        },
        {
            key: "onVideoElementCanPlayThrough",
            value: function onVideoElementCanPlayThrough() {
                if (!this.videoElement || !this.source) {
                    return;
                }
                var duration = this.getDuration();
                console.log("[HTML5Engine] Can play through, duration: ".concat(duration, ", seek started: ").concat(this._seekStarted));
                // NOTE: on Magenta true podcasts duration could be retrieved after this event fired, however sometimes it reports Infinity
                if (!Number.isFinite(duration)) {
                    return;
                }
                this.options.dispatcher(_mediaengine.VIDEO_EVENTS.CAN_PLAY_THROUGH, {
                    duration: this.videoElement.duration
                });
                if (this._seekStarted) {
                    return;
                }
                var diff = Math.abs(this.videoElement.currentTime - this.startTime);
                if (Number.isFinite(this.source.startTime) && diff >= 3 && !this._isTimeFixed) {
                    this.videoElement.currentTime = this.source.startTime;
                }
                if (!this._isTimeFixed) {
                    console.log("[ads] Invoking play on can play through");
                    this.play();
                }
            }
        },
        {
            /**
   * Handles HTMLMediaElement: play event
   * @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/play_event
   */ key: "onVideoElementPlay",
            value: function onVideoElementPlay() {
                if (!this.options) {
                    return;
                }
                this.options.dispatcher(_mediaengine.VIDEO_EVENTS.PLAYING);
            }
        },
        {
            /**
   * Handles HTMLMediaElement: pause event
   * @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/pause_event
   */ key: "onVideoElementPause",
            value: function onVideoElementPause() {
                if (!this.options) {
                    return;
                }
                this.options.dispatcher(_mediaengine.VIDEO_EVENTS.PAUSE);
            }
        },
        {
            /**
   * @param {event} event - Shaka player BufferingEvent.
   * @listens event
   */ key: "onVideoElementBuffering",
            value: function onVideoElementBuffering(event) {
                if (!this.options) {
                    return;
                }
                this.options.dispatcher(_mediaengine.VIDEO_EVENTS.WAITING, event);
            }
        },
        {
            /**
   * Handles HTMLMediaElement: ended event
   * @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/ended_event
   */ key: "onVideoElementEnded",
            value: function onVideoElementEnded() {
                console.log("[HTML5Engine] Playback ended");
                if (!this.options) {
                    return;
                }
                this.options.dispatcher(_mediaengine.VIDEO_EVENTS.ENDED);
            }
        },
        {
            key: "onVideoElementError",
            value: function onVideoElementError(event) {
                if (!this.options) {
                    return;
                }
                this.options.dispatcher(_mediaengine.VIDEO_EVENTS.ERROR, {
                    error: {
                        message: event && event.target && event.target.error ? event.target.error.message : "",
                        fatal: true
                    }
                });
            }
        },
        {
            key: "onVideoElementSeeking",
            value: function onVideoElementSeeking() {
                if (!this.options) {
                    return;
                }
                this.options.dispatcher(_mediaengine.VIDEO_EVENTS.SEEKING, {
                    from: this._seekFrom,
                    to: this._seekTo
                });
            }
        },
        {
            key: "onVideoElementSeeked",
            value: function onVideoElementSeeked(event) {
                if (!this.options) {
                    return;
                }
                this.options.dispatcher(_mediaengine.VIDEO_EVENTS.SEEKED, {
                    from: this._seekFrom,
                    to: Math.round(event.target.currentTime)
                });
            }
        },
        {
            key: "onVideoElementLoadstart",
            value: function onVideoElementLoadstart(event) {
                if (!this.options) {
                    return;
                }
                this.options.dispatcher(_mediaengine.VIDEO_EVENTS.LOAD_START, event);
            }
        },
        {
            key: "onVideoElementTimeupdate",
            value: function onVideoElementTimeupdate(event) {
                if (!this.options) {
                    return;
                }
                var currentTime = event.target.currentTime;
                var shouldJumpToStartTime = Number.isFinite(this.source.startTime);
                if (!this._isFirstTickFired) {
                    this._isFirstTickFired = true;
                    if (shouldJumpToStartTime) {
                        this.videoElement.currentTime = this.startTime;
                        this._watchForStall();
                        return;
                    }
                }
                if (!this._isTimeFixed) {
                    var diff = Math.abs(currentTime - this.startTime);
                    if (shouldJumpToStartTime && diff >= 3) {
                        console.log("[HTML5Engine] Current time ".concat(currentTime, " not aligned with ").concat(this.startTime, ", attempting to fix"));
                        this.videoElement.currentTime = this.startTime;
                        this._watchForStall();
                        return;
                    }
                    if (diff < 3) {
                        this._isTimeFixed = true;
                        clearInterval(this._antiStallTimer);
                    }
                }
                this.options.dispatcher(_mediaengine.VIDEO_EVENTS.TIME_UPDATE, {
                    currentTime: currentTime
                });
            }
        },
        {
            key: "_watchForStall",
            value: function _watchForStall() {
                clearInterval(this._antiStallTimer);
                if (!this.videoElement) {
                    return;
                }
                this._lastTime = this.videoElement.currentTime;
                this._antiStallTimer = setInterval(this._checkForStall.bind(this), 500);
            }
        },
        {
            key: "_checkForStall",
            value: function _checkForStall() {
                if (!this.videoElement) {
                    return;
                }
                if (this._lastTime === this.videoElement.currentTime) {
                    this.videoElement.currentTime += 0.1;
                }
            }
        },
        {
            key: "isEnded",
            value: function isEnded() {
                return this.videoElement ? this.videoElement.ended : false;
            }
        },
        {
            /**
   * Resets current instance state so it could be re-initialized again
   * NOTE: It's critical to ensure this method ends lifecycle of internal player's components so no memory leaks are left
   */ key: "reset",
            value: function reset() {
                console.log("[HTML5Engine] Resetting");
                if (this.videoElement) {
                    var video = this.videoElement;
                    try {
                        video.pause();
                        console.log("[HTML5Engine] Removing player source");
                        video.removeAttribute("src");
                        video.load();
                        video.src = "";
                        video.srcObject = null;
                        if (video.lifecycleCleanup) {
                            video.lifecycleCleanup();
                        }
                    } catch (error) {
                        console.error("[HTML5Engine] Can not cleanup video element source");
                    }
                }
                clearInterval(this._antiStallTimer);
                return Promise.resolve();
            }
        },
        {
            key: "release",
            value: function release() {
                console.log("[HTML5Engine] Destroying");
                this.removeEventListeners();
                this.reset();
                if (this.videoElement) {
                    try {
                        this.videoElement.remove();
                    } catch (error) {
                        console.error("[HTML5Engine] Can not remove video element");
                    }
                }
                this.videoElement = null;
                this.source = null;
                this.options = null;
            }
        }
    ]);
    return HTML5Engine;
}(_engine.default);


/***/ }),

/***/ 97691:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "HTML5NoFrostEngine", ({
    enumerable: true,
    get: function() {
        return HTML5NoFrostEngine;
    }
}));
var _assert_this_initialized = __webpack_require__(99561);
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _get = __webpack_require__(60528);
var _get_prototype_of = __webpack_require__(35196);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
var _html5engine = __webpack_require__(67681);
var HTML5NoFrostEngine = /*#__PURE__*/ function(HTML5Engine) {
    "use strict";
    _inherits._(HTML5NoFrostEngine, HTML5Engine);
    var _super = _create_super._(HTML5NoFrostEngine);
    function HTML5NoFrostEngine() {
        _class_call_check._(this, HTML5NoFrostEngine);
        var _this;
        _this = _super.apply(this, arguments);
        _define_property._(_assert_this_initialized._(_this), "startFreezeDetection", function() {
            if (!_this._shouldDetectFreezes) return;
            _this.stopFreezeDetection();
            _this.freezeCheckInterval = setInterval(function() {
                if (!_this.videoElement.paused && !_this.videoElement.ended) {
                    var currentTime = _this.videoElement.currentTime;
                    if (currentTime === _this._lastPlaybackTime && _this.videoElement.readyState >= 2) {
                        _this.attemptFreezeRecovery();
                    } else {
                        _this._lastPlaybackTime = currentTime;
                    }
                }
            }, 1000);
        });
        _define_property._(_assert_this_initialized._(_this), "recoveryStrategySeek", function() {
            _this.videoElement.currentTime += 0.001;
        });
        _define_property._(_assert_this_initialized._(_this), "recoveryStrategyPlay", function() {
            _this.videoElement.play().catch(function(e) {
                // eslint-disable-next-line no-console
                console.warn("[HTML5Engine] Playback on freeze recovery failed:", e);
            });
        });
        _define_property._(_assert_this_initialized._(_this), "attemptFreezeRecovery", function() {
            _this.stopFreezeDetection();
            var recoveryStrategies = [
                _this.recoveryStrategySeek,
                _this.recoveryStrategyPlay
            ];
            recoveryStrategies.forEach(function(strategy, index) {
                _this._strategyTimeouts.push(setTimeout(strategy, index * 1000));
            });
        });
        _define_property._(_assert_this_initialized._(_this), "stopFreezeDetection", function() {
            if (_this.freezeCheckInterval) {
                clearInterval(_this.freezeCheckInterval);
                _this.freezeCheckInterval = null;
            }
            if (_this._strategyTimeouts) {
                _this._strategyTimeouts.forEach(function(timeout) {
                    clearTimeout(timeout);
                });
                _this._strategyTimeouts = [];
            }
        });
        return _this;
    }
    _create_class._(HTML5NoFrostEngine, [
        {
            key: "start",
            value: function start(source) {
                this._shouldDetectFreezes = window.RDK_MODEL_NAME !== "MR601SAT";
                this._strategyTimeouts = [];
                this._lastPlaybackTime = 0;
                _get._(_get_prototype_of._(HTML5NoFrostEngine.prototype), "start", this).call(this, source);
                this.videoElement.load();
            }
        },
        {
            key: "play",
            value: function play() {
                var _this = this;
                var _this1 = this, _superprop_get_play = function() {
                    return _get._(_get_prototype_of._(HTML5NoFrostEngine.prototype), "play", _this);
                };
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        _this1.startFreezeDetection();
                        return [
                            2,
                            _superprop_get_play().call(_this1)
                        ];
                    });
                })();
            }
        },
        {
            key: "setEventListeners",
            value: function setEventListeners() {
                var _this = this;
                _get._(_get_prototype_of._(HTML5NoFrostEngine.prototype), "setEventListeners", this).call(this);
                this.videoElement.addEventListener("loadedmetadata", function() {
                    _this.videoElement.currentTime = 0.001;
                });
            }
        },
        {
            key: "release",
            value: function release() {
                this.stopFreezeDetection();
                _get._(_get_prototype_of._(HTML5NoFrostEngine.prototype), "release", this).call(this);
            }
        }
    ]);
    return HTML5NoFrostEngine;
}(_html5engine.HTML5Engine);


/***/ }),

/***/ 12787:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    config: function() {
        return config;
    },
    configByContentType: function() {
        return configByContentType;
    }
});
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
var config = {
    abr: {
        switchInterval: 20
    },
    manifest: {
        dash: {
        },
        hls: {
            ignoreManifestProgramDateTime: true,
            ignoreManifestTimestampsInSegmentsMode: true,
            sequenceMode: false
        }
    },
    streaming: {
        // NOTE: In some cases that helped to boost Live loading on Magenta a little though it brings some stalling issues
        // segmentPrefetchLimit: 0,
        // disableAudioPrefetch: true,
        // disableTextPrefetch: true,
        // disableVideoPrefetch: true,
        // The maximum number of seconds of content that the StreamingEngine will keep in buffer behind the playhead when it appends a new media segment.
        // The StreamingEngine will evict content to meet this limit.
        // Defaults to 30.
        bufferBehind: 15,
        bufferingGoal: 15,
        clearDecodingCache: true,
        shouldFixTimestampOffset: true,
        ignoreTextStreamFailures: true,
        retryParameters: {
            maxAttempts: 3,
            timeout: 10000
        },
        stallSkip: 0,
        gapPadding: 2
    }
};
var configByContentType = function(type) {
    switch(type){
        case "radio":
            return {
                streaming: {
                    // We are not seeking radio backwards
                    bufferBehind: 0,
                    // An ugly hack that forces to download HLS segments in paused state
                    bufferingGoal: Infinity,
                    // Play ASAP, you have INFINITE BUFFER
                    rebufferingGoal: 0,
                    // Just to be sure the boxes are not going crazy with their User-Agent
                    useNativeHlsForFairPlay: false,
                    useNativeHlsOnSafari: false
                }
            };
        default:
            return {};
    }
};


/***/ }),

/***/ 34602:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    SHAKA_BUFFERING_EVENT: function() {
        return SHAKA_BUFFERING_EVENT;
    },
    SHAKA_ERROR_EVENT: function() {
        return SHAKA_ERROR_EVENT;
    },
    SHAKA_MANIFEST_PARSED_EVENT: function() {
        return SHAKA_MANIFEST_PARSED_EVENT;
    },
    SHAKA_SEGMENT_APPENDED_EVENT: function() {
        return SHAKA_SEGMENT_APPENDED_EVENT;
    },
    SHAKA_STARTED_EVENT: function() {
        return SHAKA_STARTED_EVENT;
    },
    SHAKA_TEXT_TRACK_CHANGED_EVENT: function() {
        return SHAKA_TEXT_TRACK_CHANGED_EVENT;
    },
    SHAKA_TRACKS_CHANGED_EVENT: function() {
        return SHAKA_TRACKS_CHANGED_EVENT;
    },
    SHAKA_VARIANT_CHANGED_EVENT: function() {
        return SHAKA_VARIANT_CHANGED_EVENT;
    }
});
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(52318);
var SHAKA_ERROR_EVENT = "error";
var SHAKA_BUFFERING_EVENT = "buffering";
var SHAKA_TRACKS_CHANGED_EVENT = "trackschanged";
var SHAKA_TEXT_TRACK_CHANGED_EVENT = "textchanged";
var SHAKA_VARIANT_CHANGED_EVENT = "variantchanged";
var SHAKA_MANIFEST_PARSED_EVENT = "manifestparsed";
var SHAKA_SEGMENT_APPENDED_EVENT = "segmentappended";
var SHAKA_STARTED_EVENT = "started";


/***/ }),

/***/ 52418:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/* eslint-disable no-console */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "ShakaEngine", ({
    enumerable: true,
    get: function() {
        return ShakaEngine;
    }
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _interop_require_wildcard = __webpack_require__(95316);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _object_without_properties = __webpack_require__(46537);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(65759);
var _shakaplayer = /*#__PURE__*/ _interop_require_default._(__webpack_require__(78790));
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _identity = /*#__PURE__*/ _interop_require_default._(__webpack_require__(48148));
var _mediaengine = __webpack_require__(62221);
var _time = __webpack_require__(60942);
var _events = __webpack_require__(58003);
var _internal = /*#__PURE__*/ _interop_require_wildcard._(__webpack_require__(5426));
var _details = __webpack_require__(12510);
var _mediaEngineErrorHelpers = __webpack_require__(84338);
var _utils = __webpack_require__(10764);
var _engine = /*#__PURE__*/ _interop_require_default._(__webpack_require__(78736));
var _textDisplayer = __webpack_require__(72813);
var _shakautils = __webpack_require__(23666);
var _shakaconstants = __webpack_require__(34602);
var _default = __webpack_require__(12787);
var ShakaEngine = /*#__PURE__*/ function(Engine) {
    "use strict";
    _inherits._(ShakaEngine, Engine);
    var _super = _create_super._(ShakaEngine);
    function ShakaEngine() {
        _class_call_check._(this, ShakaEngine);
        var _this;
        _this = _super.call(this);
        _this.name = "ShakaEngine";
        // Drop all the inner values to their defaults
        _this.reset();
        return _this;
    }
    _create_class._(ShakaEngine, [
        {
            key: "init",
            value: function init(options) {
                var _this = this;
                this.options = options;
                this.videoElement = (0, _get.default)(options, "element");
                var drmSettings = (0, _get.default)(options, "drm.settings");
                var isHardwareSupported = (0, _get.default)(options, "drm.isHardwareSupported", false);
                var audioPreferences = (0, _get.default)(options, "userPreferences.audio", {});
                var textPreferences = (0, _get.default)(options, "userPreferences.text", {});
                if (this.options.size) {
                    this.videoElement.style.width = this.options.size.width;
                    this.videoElement.style.height = this.options.size.height;
                    console.log("[ShakaEngine] Player size: ".concat(this.options.size.width, " x ").concat(this.options.size.height));
                }
                // shaka.log.setLevel(shaka.log.Level.DEBUG);
                _shakaplayer.default.polyfill.installAll();
                if (this.options.polyfill) {
                    this.options.polyfill();
                }
                this.player = new _shakaplayer.default.Player(this.videoElement);
                var baseConfig = {
                    drm: drmSettings ? {
                        servers: {
                            "com.widevine.alpha": drmSettings["com.widevine.alpha"].serverURL,
                            "com.microsoft.playready": drmSettings["com.microsoft.playready"].serverURL
                        },
                        advanced: {
                            "com.widevine.alpha": {
                                videoRobustness: isHardwareSupported ? "HW_SECURE_ALL" : "SW_SECURE_CRYPTO",
                                audioRobustness: isHardwareSupported ? "HW_SECURE_CRYPTO" : "SW_SECURE_CRYPTO"
                            }
                        }
                    } : {},
                    preferredAudioLanguage: audioPreferences.language || undefined,
                    preferredVariantRole: audioPreferences.role || undefined,
                    preferredTextLanguage: textPreferences.language || undefined,
                    preferredTextRole: textPreferences.role || undefined,
                    textDisplayFactory: function() {
                        return new _textDisplayer.TextDisplayer(_this.videoElement, (0, _get.default)(_this.options, "dispatcher"));
                    },
                    manifest: {
                        disableAudio: this.options.mute,
                        dash: {}
                    }
                };
                var manifestPreprocessor = this.options.manifestPreprocessor || _identity.default;
                if (_shakaplayer.default.config && _shakaplayer.default.config.AutoShowText) {
                    baseConfig.autoShowText = _shakaplayer.default.config.AutoShowText.IF_PREFERRED_TEXT_LANGUAGE;
                    baseConfig.manifest.dash.manifestPreprocessor = manifestPreprocessor;
                } else {
                    baseConfig.manifest.dash.manifestPreprocessor = manifestPreprocessor;
                }
                this.player.configure((0, _merge.default)(baseConfig, _default.config));
                // This will allow to use Shaka built-in subtitles renderer
                this.player.setVideoContainer(this.videoElement.parentNode);
                this.setEventListeners();
            }
        },
        {
            key: "setSource",
            value: function setSource(source) {
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        return [
                            2,
                            _this.start(source)
                        ];
                    });
                })();
            }
        },
        {
            key: "start",
            value: function start(source) {
                var _this = this;
                return _async_to_generator._(function() {
                    var tokenHandler, error, error1, error2;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.player) {
                                    console.log("[ShakaEngine] Start requested but no player created yet, exiting");
                                    return [
                                        2
                                    ];
                                }
                                if (!source) {
                                    console.log("[ShakaEngine] Start requested but no source provided, exiting");
                                    _this.pause();
                                    return [
                                        2
                                    ];
                                }
                                console.log("[ShakaEngine] Source set:", source.reference);
                                _this.source = source;
                                _this._isLive = Boolean(_this.source.isLive || _this.source.type === "radio");
                                _this._startTime = _this.source.startTime || 0;
                                _this._availabilityStartTimeInSeconds = 0;
                                _this._seekTo = _this._startTime;
                                _this._isStarted = false;
                                _this._isPaused = false;
                                _this.player.configure((0, _default.configByContentType)(_this.source.type));
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    4,
                                    ,
                                    5
                                ]);
                                tokenHandler = (0, _get.default)(_this.options, "drm.token.handler");
                                if (!tokenHandler) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    (0, _utils.fetchUpfrontToken)(tokenHandler)
                                ];
                            case 2:
                                _this.upFrontToken = _state.sent();
                                _state.label = 3;
                            case 3:
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                error = _state.sent();
                                // TODO: dispatch correct error
                                _this.dispatchInternalError(_internal.INTERNAL_ERROR_NO_SOURCE, "ShakaEngine failed to fetch DRM upfront token:", error);
                                return [
                                    2
                                ];
                            case 5:
                                _state.trys.push([
                                    5,
                                    7,
                                    ,
                                    8
                                ]);
                                return [
                                    4,
                                    _this.player.load(_this.source.reference, _this._isLive ? undefined : _this._startTime)
                                ];
                            case 6:
                                _state.sent();
                                return [
                                    3,
                                    8
                                ];
                            case 7:
                                error1 = _state.sent();
                                /*
       * Silence LOAD_INTERRUPTED error since it could have been triggered by an unload or another load
       * https://github.com/google/shaka-player/issues/1006
       */ if (error1.code === _shakaplayer.default.util.Error.Code.LOAD_INTERRUPTED) {
                                    return [
                                        2
                                    ];
                                }
                                _this.player.dispatchEvent(new _shakaplayer.default.util.FakeEvent("error", {
                                    detail: error1
                                }));
                                return [
                                    2
                                ];
                            case 8:
                                _this._availabilityStartTimeInSeconds = _this._getAvailabilityStartTimeInSeconds();
                                _state.label = 9;
                            case 9:
                                _state.trys.push([
                                    9,
                                    12,
                                    ,
                                    13
                                ]);
                                if (!_this.source.shouldAutoPlay) return [
                                    3,
                                    11
                                ];
                                return [
                                    4,
                                    _this.play()
                                ];
                            case 10:
                                _state.sent();
                                _state.label = 11;
                            case 11:
                                return [
                                    3,
                                    13
                                ];
                            case 12:
                                error2 = _state.sent();
                                _this.player.dispatchEvent(new _shakaplayer.default.util.FakeEvent("error", {
                                    detail: error2
                                }));
                                return [
                                    3,
                                    13
                                ];
                            case 13:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "play",
            value: function play() {
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        console.log("[ShakaEngine] Playback requested");
                        try {
                            /**
       * Shaka issue to fix an error which always fire before the VOD launching
       * @see [link](https://github.com/sampotts/plyr/issues/331#issuecomment-341946105)
       */ setTimeout(/*#__PURE__*/ _async_to_generator._(function() {
                                return _ts_generator._(this, function(_state) {
                                    if (!_this.videoElement || !_this.player || !_this.source) {
                                        return [
                                            2
                                        ];
                                    }
                                    if (_this.source.type === "radio") {
                                        if (_this._isPaused || !_this._isStarted) {
                                            console.log("[ShakaEngine] Syncing with live edge");
                                            _this.player.goToLive();
                                        }
                                    }
                                    _this.videoElement.play();
                                    return [
                                        2
                                    ];
                                });
                            }), 0);
                        } catch (error) {
                            _this.options.dispatcher(_mediaengine.VIDEO_EVENTS.ERROR, {
                                error: (0, _mediaEngineErrorHelpers.throwAutoplayErrorHelper)({
                                    type: _details.AUTOPLAY_PREVENTED_ERROR,
                                    details: "The user hasn't interacted with the domain",
                                    fatal: false,
                                    context: _this.name
                                })
                            });
                        }
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "pause",
            value: function pause() {
                if (this.videoElement) {
                    this.videoElement.pause();
                }
            }
        },
        {
            /**
   * Points player to a specific timestamp
   *
   * @param {number} position absolute position to seek, in seconds
   */ key: "seek",
            value: function seek(position) {
                var forceRestart = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                if (!Number.isFinite(position)) {
                    return;
                }
                console.log("[ShakaEngine] Seek requested to ".concat(position));
                if (this.videoElement) {
                    this._seekFrom = Math.round(this.videoElement.currentTime + this._availabilityStartTimeInSeconds);
                    this._seekTo = position - this._availabilityStartTimeInSeconds;
                    this.videoElement.currentTime = this._seekTo;
                }
                if (forceRestart && this.options.restartOnSeekStall) {
                    this.setForcedRestartTimeout(Math.max(this.options.restartOnSeekStall / 100, 10));
                }
            }
        },
        {
            key: "setAudioTrackById",
            value: function setAudioTrackById(trackId) {
                if (!this.player) {
                    return;
                }
                try {
                    var audioTracks = this.player.getVariantTracks().filter(function(variant) {
                        return variant.audioId && variant.audioId === trackId;
                    });
                    // If the track is already active, there is no need to switch to it
                    if (!audioTracks.length || audioTracks.some(function(track) {
                        return track.active;
                    })) {
                        return;
                    }
                    var track = audioTracks[0];
                    this.player.selectAudioLanguage(track.language, track.roles && track.roles[0] || "");
                } catch (error) {
                    this.options.dispatcher(_mediaengine.VIDEO_EVENTS.ERROR, {
                        error: {
                            error: {
                                message: "ShakaEngine failed to set audio track"
                            }
                        }
                    });
                }
            }
        },
        {
            key: "setSubtitlesTrackById",
            value: function setSubtitlesTrackById(trackId) {
                if (!this.player) {
                    return;
                }
                try {
                    var tracks = this.player.getTextTracks();
                    var track = tracks.find(function(param) {
                        var id = param.id;
                        return id === trackId;
                    });
                    // If the track is already active, there is no need to switch to it
                    if (track && track.active) {
                        return;
                    }
                    this._setSubtitlesTrack(track);
                } catch (error) {
                    this.options.dispatcher(_mediaengine.VIDEO_EVENTS.ERROR, {
                        error: {
                            error: {
                                message: "ShakaEngine failed to set text track"
                            }
                        }
                    });
                }
            }
        },
        {
            key: "_setSubtitlesTrack",
            value: function _setSubtitlesTrack(track) {
                if (!track) {
                    this.player.setTextTrackVisibility(false);
                    return;
                }
                this.player.selectTextTrack(track);
                this.player.setTextTrackVisibility(true);
            }
        },
        {
            key: "backToLive",
            value: function backToLive() {
                if (!this.player) {
                    return;
                }
                try {
                    this.player.goToLive();
                } catch (error) {
                    this.dispatchInternalError(_internal.INTERNAL_ERROR_UNKNOWN, "ShakaEngine failed to return in Live:", error);
                }
            }
        },
        {
            key: "responseFilter",
            value: function responseFilter(type, response) {
                var _shaka_util = _shakaplayer.default.util, StringUtils = _shaka_util.StringUtils, Uint8ArrayUtils = _shaka_util.Uint8ArrayUtils;
                if (type === _shakaplayer.default.net.NetworkingEngine.RequestType.LICENSE) {
                    var data = response.data, uri = response.uri;
                    var _this_player_getConfiguration = this.player.getConfiguration(), servers = _this_player_getConfiguration.drm.servers;
                    if (uri === servers["com.widevine.alpha"]) {
                        var wrappedResponse = StringUtils.fromUTF8(data);
                        var parsedResponse = JSON.parse(wrappedResponse);
                        var messageType = parsedResponse.message_type, license = parsedResponse.license;
                        if (license) {
                            response.data = Uint8ArrayUtils.fromBase64(license);
                        }
                        if (messageType === "LICENSE") {
                            // FIXME: waiting the next release from @bedrock/media-engine and replace 'license' by LOADED_DRM_LICENSE_DATA
                            this.options.dispatcher(_events.LICENSE_LOADED, parsedResponse);
                        }
                    }
                } else if (type === _shakaplayer.default.net.NetworkingEngine.RequestType.MANIFEST) {
                    try {
                        if (this.source.type !== "radio" || !this.player || !this.options) {
                            return;
                        }
                        var manifest = StringUtils.fromUTF8(response.data);
                        var match = /#EXTINF:([\d.]+),(.+)/g.exec(manifest);
                        var title = match ? match[2] : "";
                        this.options.dispatcher(_mediaengine.VIDEO_EVENTS.LOADED_METADATA, {
                            extraTitle: title || ""
                        });
                        if (!this._isStarted) {
                            console.log("[ShakaEngine] HLS manifest received, but stream is not started yet, seeking to the live edge");
                            this.player.goToLive();
                            this.setForcedRestartTimeout(this.options.restartOnSeekStallLive, true);
                        }
                    } catch (error) {
                        this.options.dispatcher(_mediaengine.VIDEO_EVENTS.ERROR, {
                            error: (0, _mediaEngineErrorHelpers.throwAutoplayErrorHelper)({
                                type: _details.ENGINE_DECODE,
                                details: error.message,
                                fatal: false,
                                context: this.name
                            })
                        });
                    }
                }
            }
        },
        {
            key: "requestFilter",
            value: function requestFilter(type, request) {
                if (type === _shakaplayer.default.net.NetworkingEngine.RequestType.LICENSE) {
                    request.headers["x-dt-auth-token"] = (0, _get.default)(this.upFrontToken, "value");
                }
            }
        },
        {
            key: "setEventListeners",
            value: function setEventListeners() {
                var _this = this;
                var _obj;
                this._handlers = {
                    network: {
                        requestFilter: this.requestFilter.bind(this),
                        responseFilter: this.responseFilter.bind(this)
                    },
                    player: (_obj = {}, _define_property._(_obj, _shakaconstants.SHAKA_ERROR_EVENT, this.onShakaPlayerError.bind(this)), _define_property._(_obj, _shakaconstants.SHAKA_BUFFERING_EVENT, this.onShakaPlayerBufferingStateChange.bind(this)), _define_property._(_obj, _shakaconstants.SHAKA_TRACKS_CHANGED_EVENT, this.onShakaPlayerTracksChange.bind(this)), _define_property._(_obj, _shakaconstants.SHAKA_TEXT_TRACK_CHANGED_EVENT, this.onShakaTextTrackChange.bind(this)), _define_property._(_obj, _shakaconstants.SHAKA_VARIANT_CHANGED_EVENT, this.onShakaVariantChange.bind(this)), _define_property._(_obj, _shakaconstants.SHAKA_MANIFEST_PARSED_EVENT, this.onShakaManifestParsed.bind(this)), _obj),
                    video: {
                        canplay: this.onVideoElementCanPlay.bind(this),
                        playing: this.onVideoElementPlaying.bind(this),
                        pause: this.onVideoElementPause.bind(this),
                        timeupdate: this.onVideoElementTimeUpdate.bind(this),
                        ended: this.onVideoElementEnded.bind(this),
                        seeked: this.onVideoElementSeeked.bind(this),
                        seeking: this.onVideoElementSeeking.bind(this),
                        loadstart: this.onVideoElementLoadstart.bind(this)
                    }
                };
                var networkingEngine = this.player.getNetworkingEngine();
                networkingEngine.registerRequestFilter(this._handlers.network.requestFilter);
                networkingEngine.registerResponseFilter(this._handlers.network.responseFilter);
                Object.keys(this._handlers.player).forEach(function(key) {
                    _this.player.addEventListener(key, _this._handlers.player[key]);
                });
                Object.keys(this._handlers.video).forEach(function(key) {
                    _this.videoElement.addEventListener(key, _this._handlers.video[key]);
                });
            }
        },
        {
            key: "removeEventListeners",
            value: function removeEventListeners() {
                var _this = this;
                clearInterval(this._timeUpdateInterval);
                if (!this._handlers) {
                    return;
                }
                if (this.player) {
                    var networkingEngine = this.player.getNetworkingEngine();
                    networkingEngine.unregisterRequestFilter(this._handlers.network.requestFilter);
                    networkingEngine.unregisterResponseFilter(this._handlers.network.responseFilter);
                    Object.keys(this._handlers.player).forEach(function(key) {
                        _this.player.removeEventListener(key, _this._handlers.player[key]);
                    });
                }
                if (this.videoElement) {
                    Object.keys(this._handlers.video).forEach(function(key) {
                        _this.videoElement.removeEventListener(key, _this._handlers.video[key]);
                    });
                }
                this._handlers = null;
            }
        },
        {
            key: "onShakaPlayerError",
            value: /**
   * Handles errors fired by the Shaka player
   * @see https://shaka-player-demo.appspot.com/docs/api/shaka.util.Error.html
   *
   * @param {shaka.Player.ErrorEvent} event Shaka player error.
   */ function onShakaPlayerError(event) {
                var _this = this;
                return _async_to_generator._(function() {
                    var detail;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                detail = event.detail;
                                if (!(detail.severity >= _shakaplayer.default.util.Error.Severity.CRITICAL)) return [
                                    3,
                                    2
                                ];
                                _this.dispatchInternalError(_internal.PLAYER_ERROR, "ShakaEngine internal error.", detail);
                                return [
                                    4,
                                    _this.reset()
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onShakaPlayerBufferingStateChange",
            value: function onShakaPlayerBufferingStateChange(event) {
                if (!this.videoElement || !this.player) {
                    return;
                }
                console.log("[ShakaEngine] Buffering at ".concat(this.videoElement.currentTime, " while the start is ").concat(this._startTime, ", and progress ticked: ").concat(this._isStarted));
                var currentTime = this.videoElement.currentTime;
                if (!this._isLive && !this._isStarted && currentTime !== this._startTime) {
                    this.videoElement.currentTime = this._startTime;
                } else if (this._isLive && !this._isStarted && (Number.isNaN(currentTime) || !currentTime)) {
                    // ugly hack for Magenta STBs
                    if (this.options.restartOnSeekStallLive && this.player.isLive()) {
                        console.log("[ShakaEngine] Seeking live stream to the current date and time to resolve stutter");
                        this.player.goToLive();
                        this.setForcedRestartTimeout(this.options.restartOnSeekStallLive, true);
                    }
                }
                this.options.dispatcher(_mediaengine.VIDEO_EVENTS.WAITING, {
                    isBuffering: Boolean(event.buffering)
                });
                if (this.options.restartOnSeekStall) {
                    if (!this._isLive && event.buffering && this._isStarted) {
                        this.setForcedRestartTimeout(this.options.restartOnSeekStall);
                    } else if (!this._isLive && !event.buffering && this._isStarted) {
                        if (this._restartOnSeekStallTimeout) {
                            console.log("[ShakaEngine] Canceling stall seek timeout on buffering ended");
                            clearTimeout(this._restartOnSeekStallTimeout);
                            clearTimeout(this._playOnSeekStallTimeout);
                        }
                    }
                }
            }
        },
        {
            key: "setForcedRestartTimeout",
            value: function setForcedRestartTimeout() {
                var timeout = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 5000, shouldDelayPlayback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                console.log("[ShakaEngine] Canceling previous stall seek timeout");
                clearTimeout(this._restartOnSeekStallTimeout);
                clearTimeout(this._playOnSeekStallTimeout);
                if (shouldDelayPlayback) {
                    this.setForcedPlayTimeout(Math.round(timeout / 3));
                }
                console.log("[ShakaEngine] Scheduling timeout after ".concat(timeout, "ms"));
                var _this = this;
                this._restartOnSeekStallTimeout = setTimeout(/*#__PURE__*/ _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.player) {
                                    console.log("[ShakaEngine] Time to force restart, but no player found, exiting from the routine");
                                    return [
                                        2
                                    ];
                                }
                                console.log("[ShakaEngine] Restarting on stall timeout");
                                _this.removeEventListeners();
                                _this.pause();
                                _this._isStarted = false;
                                return [
                                    4,
                                    _this.player.destroy()
                                ];
                            case 1:
                                _state.sent();
                                _this.init(_this.options);
                                return [
                                    4,
                                    _this.start(_object_spread_props._(_object_spread._({}, _this.source), {
                                        startTime: _this._seekTo,
                                        shouldAutoPlay: true
                                    }))
                                ];
                            case 2:
                                _state.sent();
                                if (shouldDelayPlayback) {
                                    _this.setForcedPlayTimeout(Math.round(timeout / 3));
                                }
                                return [
                                    2
                                ];
                        }
                    });
                }), timeout);
            }
        },
        {
            key: "setForcedPlayTimeout",
            value: function setForcedPlayTimeout(timeout) {
                var _this = this;
                clearTimeout(this._playOnSeekStallTimeout);
                console.log("[ShakaEngine] Activating forced play timeout");
                this._playOnSeekStallTimeout = setTimeout(function() {
                    if (_this.videoElement) {
                        console.log("[ShakaEngine] Starting delayed playback");
                        _this.videoElement.play();
                        if (_this._isLive && _this.player.isLive()) {
                            console.log("[ShakaEngine] Forcing seek to the live edge");
                            _this.player.goToLive();
                        }
                    }
                }, timeout);
            }
        },
        {
            key: "onShakaPlayerTracksChange",
            value: function onShakaPlayerTracksChange() {
                var audioTracks = this._getAudioTracks();
                var subtitleTracks = this._getSubtitleTracks();
                this._activeAudioTrack = audioTracks.find(_shakautils.isActiveTrack);
                this._activeSubtitlesTrack = subtitleTracks.find(_shakautils.isActiveTrack);
                this.options.dispatcher(_events.TRACKS_CHANGED, {
                    audioTracks: audioTracks,
                    subtitleTracks: subtitleTracks
                });
            }
        },
        {
            key: "onShakaTextTrackChange",
            value: function onShakaTextTrackChange() {
                var tracks = this._getSubtitleTracks();
                var previousTrack = this._activeSubtitlesTrack;
                this._activeSubtitlesTrack = tracks.find(_shakautils.isActiveTrack);
                this.options.dispatcher(_events.SUBTITLES_TRACK_CHANGED, {
                    previousTrack: previousTrack,
                    currentTrack: this._activeSubtitlesTrack
                });
            }
        },
        {
            key: "onShakaVariantChange",
            value: function onShakaVariantChange() {
                var tracks = this._getAudioTracks();
                var previousTrack = this._activeAudioTrack;
                this._activeAudioTrack = tracks.find(_shakautils.isActiveTrack);
                this.options.dispatcher(_events.AUDIO_TRACK_CHANGED, {
                    previousTrack: previousTrack,
                    currentTrack: this._activeAudioTrack
                });
            }
        },
        {
            key: "onShakaManifestParsed",
            value: function onShakaManifestParsed() {
                if (!this.player) {
                    return;
                }
                var manifest = this.player.getManifest();
                if (manifest && manifest.presentationTimeline) {
                    var presentationDelay = manifest.presentationTimeline.getDelay();
                    this.options.dispatcher(_events.MANIFEST_LOADED, {
                        presentationDelay: presentationDelay
                    });
                    this.player.removeEventListener(_events.MANIFEST_LOADED, this._handlers.player[_events.MANIFEST_LOADED]);
                }
            }
        },
        {
            /**
   * Handles HTMLMediaElement: play event
   * @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/play_event
   */ key: "onVideoElementPlaying",
            value: function onVideoElementPlaying() {
                console.log("[ShakaEngine] Event fired: Playing");
                if (!this.videoElement) {
                    return;
                }
                this._isPaused = false;
                this.options.dispatcher(_mediaengine.VIDEO_EVENTS.PLAYING);
            }
        },
        {
            /**
   * Handles HTMLMediaElement: pause event
   * @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/pause_event
   */ key: "onVideoElementPause",
            value: function onVideoElementPause() {
                console.log("[ShakaEngine] Event fired: Paused");
                this.options.dispatcher(_mediaengine.VIDEO_EVENTS.PAUSE);
                this._isPaused = true;
                if (!this.player || this.player.isLive()) {
                    return;
                }
                // NOTE: the temporary fix of the discussed here issue - https://github.com/google/shaka-player/issues/1014.
                // Some browsers don't stop the playback when a user seeks or starts a video from the position tightly to the duration.
                // To keep the native Video node events flow need to trigger "ENDED" event only after "PAUSE".
                var targetPoint = this._seekTo && this._seekTo >= this.videoElement.currentTime ? this._seekTo : this.videoElement.currentTime;
                if ((0, _shakautils.isSeekToDuration)(this.videoElement.duration, targetPoint)) {
                    this.videoElement.dispatchEvent(new Event(_mediaengine.VIDEO_EVENTS.ENDED));
                }
            }
        },
        {
            key: "onVideoElementTimeUpdate",
            value: function onVideoElementTimeUpdate() {
                // NOTE: this method only works for VODs, for Live we need to compute both current time and live stream edge
                // see _notifyTimeUpdates for the implementation
                if (this._isLive) {
                    if (this.source && this.source.type === "radio" && this._loadingStarted && !this._isStarted) {
                        this._isStarted = true;
                    }
                    return;
                }
                // NOTE: on some STBs the timeupdate event is fired prior to loading with zero timings
                if (!this._loadingStarted) {
                    return;
                }
                if (!this._isStarted) {
                    this._isStarted = true;
                    console.log("[ShakaEngine] First time update just ticked");
                    var currentTime = this.videoElement.currentTime;
                    if (currentTime !== this._seekTo) {
                        console.log("[ShakaEngine] Stall detected (".concat(currentTime, " != ").concat(this._seekTo, "), scrubbing to the designated timestamp"));
                        this._seekFrom = currentTime;
                        this.videoElement.currentTime = this._seekTo;
                    }
                }
                this.options.dispatcher(_mediaengine.VIDEO_EVENTS.TIME_UPDATE, {
                    currentTime: this.videoElement.currentTime,
                    liveEdge: 0
                });
                if (this.options.shouldPauseAtEnd) {
                    if (Math.abs(this.videoElement.duration - this.videoElement.currentTime) <= 1) {
                        this.pause();
                    }
                }
            }
        },
        {
            /**
   * Handles HTMLMediaElement: ended event
   * @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/ended_event
   */ key: "onVideoElementEnded",
            value: function onVideoElementEnded() {
                console.log("[Shaka.Engine] Event: ended");
                this.options.dispatcher(_mediaengine.VIDEO_EVENTS.ENDED);
                this._isStarted = false;
            }
        },
        {
            /**
   * Handles HTMLMediaElement: ended event
   * @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/seeking_event
   */ key: "onVideoElementSeeking",
            value: function onVideoElementSeeking(event) {
                if (!this.videoElement) {
                    return;
                }
                console.log("[ShakaEngine] Event fired: Seeking ".concat(this._seekFrom, " (").concat(this.videoElement.currentTime, ") -> ").concat(this._seekTo, " (").concat(event.timeStamp, ")"));
                this.options.dispatcher(_mediaengine.VIDEO_EVENTS.SEEKING, {
                    from: this._seekFrom,
                    to: this._seekTo
                });
            }
        },
        {
            /**
   * Handles HTMLMediaElement: ended event
   * @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/seeked_event
   */ key: "onVideoElementSeeked",
            value: function onVideoElementSeeked(event) {
                if (!this.player) {
                    return;
                }
                console.log("[ShakaEngine] Event fired: Seeked");
                this.options.dispatcher(_mediaengine.VIDEO_EVENTS.SEEKED, {
                    from: this._seekFrom,
                    to: Math.round(event.target.currentTime)
                });
                // NOTE: temporal fix of an issue when a Player does not PAUSE the playback when a user seeks to duration.
                // To keep the native Video node events flow need to trigger "PAUSE" event only after "SEEKED".
                if (!this.player.isLive() && (0, _shakautils.isSeekToDuration)(this.videoElement.duration, this.videoElement.currentTime)) {
                    this.pause();
                }
            }
        },
        {
            /**
   * Handles HTMLMediaElement: ended event
   * @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/loadstart_event
   */ key: "onVideoElementLoadstart",
            value: function onVideoElementLoadstart(event) {
                console.log("[ShakaEngine] Event fired: Loadstart");
                this._loadingStarted = true;
                this.options.dispatcher(_mediaengine.VIDEO_EVENTS.LOAD_START, event);
            }
        },
        {
            /**
   * Handles HTMLMediaElement: canplay event
   * @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/canplay_event
   */ key: "onVideoElementCanPlay",
            value: function onVideoElementCanPlay() {
                console.log("[ShakaEngine] Event fired: Can play");
                // NOTE: when auto-play is enabled, on some devices we are seeing a black screen for a second.
                // In order to fix that, the "canplay" event will be fired on first time update tick.
                if (this.source && !this.source.shouldAutoPlay) {
                    this._notifyCanPlay();
                }
                if (!this._isLive) {
                    return;
                }
                if (this._restartOnSeekStallTimeout) {
                    console.log("[ShakaEngine] Canceling stall seek timeout on canplay callback");
                    clearTimeout(this._restartOnSeekStallTimeout);
                    clearTimeout(this._playOnSeekStallTimeout);
                }
                // NOTE: the "canplay" event could be triggered multiple times in some environments
                clearInterval(this._timeUpdateInterval);
                this._timeUpdateInterval = setInterval(this._notifyTimeUpdates.bind(this), _mediaengine.VIDEO_EVENTS_THROTTLE.TIME_UPDATE_THROTTLE);
                this._notifyTimeUpdates();
            }
        },
        {
            key: "_notifyTimeUpdates",
            value: function _notifyTimeUpdates() {
                if (this.source && this.source.shouldAutoPlay) {
                    this._notifyCanPlay();
                }
                this.options.dispatcher(_mediaengine.VIDEO_EVENTS.TIME_UPDATE, {
                    currentTime: this.videoElement.currentTime + this._availabilityStartTimeInSeconds,
                    liveEdge: this._isLive ? this.player.seekRange().end + this._availabilityStartTimeInSeconds : 0
                });
            }
        },
        {
            key: "_notifyCanPlay",
            value: function _notifyCanPlay() {
                if (!this._canPlay) {
                    this._canPlay = true;
                    this.options.dispatcher(_mediaengine.VIDEO_EVENTS.CAN_PLAY, {
                        // Live programs duration is defined per layout metadata
                        duration: this._isLive ? undefined : this.videoElement.duration
                    });
                }
            }
        },
        {
            /**
   * Get the availability start time in seconds.
   * If the player has not loaded a live stream, this will return 0.
   *
   * @returns {Number}
   */ key: "_getAvailabilityStartTimeInSeconds",
            value: function _getAvailabilityStartTimeInSeconds() {
                if (!this.player || !this._isLive) {
                    return 0;
                }
                try {
                    var presentationStartTime = this.player.getPresentationStartTimeAsDate();
                    return (0, _time.toSeconds)(presentationStartTime.getTime());
                } catch (error) {
                    return 0;
                }
            }
        },
        {
            key: "_getAudioTracks",
            value: function _getAudioTracks() {
                var player = this.player;
                try {
                    return player ? (0, _shakautils.getAudioTracksFromVariants)(player.getVariantTracks()) : [];
                } catch (error) {
                    return [];
                }
            }
        },
        {
            key: "_getSubtitleTracks",
            value: function _getSubtitleTracks() {
                var player = this.player;
                if (!player) {
                    return [];
                }
                try {
                    var isTextTrackVisible = player.isTextTrackVisible();
                    return player.getTextTracks().map(_shakautils.parseTextTrack).map(function(_param) {
                        var active = _param.active, rest = _object_without_properties._(_param, [
                            "active"
                        ]);
                        return _object_spread._({
                            active: active && isTextTrackVisible
                        }, rest);
                    });
                } catch (error) {
                    return [];
                }
            }
        },
        {
            key: "_getSubtitleRestricted",
            value: function _getSubtitleRestricted() {
                var player = this.player;
                if (!player) {
                    return [];
                }
                try {
                    return player.getTextTracks().filter(function(track) {
                        return track.forced;
                    });
                } catch (error) {
                    return [];
                }
            }
        },
        {
            /**
   * Resets current instance state so it could be re-initialized again
   * NOTE: It's critical to ensure this method ends lifecycle of internal player's components so no memory leaks are left
   */ key: "reset",
            value: function reset() {
                console.log("[ShakaEngine] Resetting the player");
                this.removeEventListeners();
                if (this._restartOnSeekStallTimeout) {
                    console.log("[ShakaEngine] Canceling stall seek timeout on player reset");
                    clearTimeout(this._restartOnSeekStallTimeout);
                }
                if (this._playOnSeekStallTimeout) {
                    clearTimeout(this._playOnSeekStallTimeout);
                }
                this.videoElement = null;
                this.source = null;
                this.options = null;
                this._activeAudioTrack = null;
                this._activeSubtitlesTrack = null;
                this._isLive = false;
                this._canPlay = false;
                this._loadingStarted = false;
                this._isStarted = false;
                if (this.player) {
                    try {
                        this.player.setVideoContainer(null);
                        return this.player.destroy();
                    } finally{
                        this.player = null;
                    }
                }
                return Promise.resolve();
            }
        }
    ]);
    return ShakaEngine;
}(_engine.default);


/***/ }),

/***/ 23666:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    getAudioTracksFromVariants: function() {
        return getAudioTracksFromVariants;
    },
    getForcedSubtitleTrack: function() {
        return getForcedSubtitleTrack;
    },
    isActiveTrack: function() {
        return isActiveTrack;
    },
    isSeekToDuration: function() {
        return isSeekToDuration;
    },
    parseAudioVariantTrack: function() {
        return parseAudioVariantTrack;
    },
    parseTextTrack: function() {
        return parseTextTrack;
    }
});
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
var parseAudioVariantTrack = function(variant) {
    var active = variant.active, audioId = variant.audioId, audioRoles = variant.audioRoles, label = variant.label, language = variant.language;
    return {
        id: audioId,
        language: language,
        label: label,
        active: active,
        roles: audioRoles
    };
};
var parseTextTrack = function(param) {
    var id = param.id, language = param.language, roles = param.roles, active = param.active, label = param.label;
    return {
        id: id,
        language: language,
        label: label || language,
        active: active,
        roles: roles
    };
};
var isActiveTrack = function(track) {
    return track.active;
};
var getAudioTracksFromVariants = function(variants) {
    return variants && variants.length ? variants.filter(function(variant) {
        return Boolean(variant.audioId);
    }).reduce(function(result, variant) {
        var active = variant.active, audioId = variant.audioId;
        var audioTrack = result.find(function(param) {
            var id = param.id;
            return id === audioId;
        });
        // Ignore duplicates as there could be x variants (x bitrates) of an audio track, but keep the active one
        if (audioTrack) {
            audioTrack.active = audioTrack.active || active;
        } else {
            result.push(parseAudioVariantTrack(variant));
        }
        return result;
    }, []) : [];
};
var getForcedSubtitleTrack = function(restrictedSubs, audioLanguage) {
    return restrictedSubs.find(function(track) {
        return track.language === audioLanguage;
    });
};
var isSeekToDuration = function(duration, seekPosition) {
    var threshold = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
    return Math.abs(duration - seekPosition) <= threshold;
};


/***/ }),

/***/ 33295:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _export_star = __webpack_require__(37668);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(37815);
_export_star._(__webpack_require__(14764), exports);


/***/ }),

/***/ 60288:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _export_star = __webpack_require__(37668);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(3009);
_export_star._(__webpack_require__(31438), exports);


/***/ }),

/***/ 77773:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    CUE_ACTION: function() {
        return CUE_ACTION;
    },
    TEXT_RENDERER_V3: function() {
        return TEXT_RENDERER_V3;
    },
    TEXT_RENDERER_V4: function() {
        return TEXT_RENDERER_V4;
    },
    UPDATE_PERIOD: function() {
        return UPDATE_PERIOD;
    }
});
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(65759);
var UPDATE_PERIOD = 250;
var CUE_ACTION = {
    DISPLAYED: "text_displayed",
    REMOVED: "text_removed"
};
var TEXT_RENDERER_V3 = 3;
var TEXT_RENDERER_V4 = 4;


/***/ }),

/***/ 72813:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _export_star = __webpack_require__(37668);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(3009);
_export_star._(__webpack_require__(33295), exports);


/***/ }),

/***/ 57259:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DOUBLED_RGBA_LENGTH: function() {
        return DOUBLED_RGBA_LENGTH;
    },
    doubledRGBAToARGB: function() {
        return doubledRGBAToARGB;
    },
    getARGBAlpha: function() {
        return getARGBAlpha;
    },
    hexToARGB: function() {
        return hexToARGB;
    },
    isDoubledRGBA: function() {
        return isDoubledRGBA;
    }
});
var _export_star = __webpack_require__(37668);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(88801);
_export_star._(__webpack_require__(60288), exports);
var DOUBLED_RGBA_LENGTH = 9;
var getARGBAlpha = function(alphaHex) {
    return "0x".concat(alphaHex);
};
var isDoubledRGBA = function(color) {
    return color.length === DOUBLED_RGBA_LENGTH && !Number.isInteger(color);
};
var doubledRGBAToARGB = function(color) {
    var alphaHex = getARGBAlpha(color.slice(DOUBLED_RGBA_LENGTH - 2));
    return color.slice(0, -2).replace("#", alphaHex);
};
var hexToARGB = function(color) {
    var fallback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0x00000000;
    if (!color) {
        return fallback;
    }
    if (!isDoubledRGBA(color)) {
        return color;
    }
    return parseInt(doubledRGBAToARGB(color), 16);
};


/***/ }),

/***/ 14764:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "TextDisplayer", ({
    enumerable: true,
    get: function() {
        return TextDisplayer;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
var _events = __webpack_require__(58003);
var _textDisplayerutils = __webpack_require__(57259);
var _textDisplayerconstants = __webpack_require__(77773);
var TextDisplayer = /*#__PURE__*/ function() {
    "use strict";
    function TextDisplayer(video, dispatcher) {
        var _this = this;
        _class_call_check._(this, TextDisplayer);
        this._video = video;
        this._dispatcher = dispatcher;
        this._isTextVisible = false;
        this._cues = [];
        this._currentCuesMap = new Map();
        this._captionsTimer = setInterval(function() {
            _this._updateCaptions();
        }, _textDisplayerconstants.UPDATE_PERIOD);
    }
    _create_class._(TextDisplayer, [
        {
            key: "configure",
            value: function configure() {}
        },
        {
            key: "append",
            value: function append(cues) {
                var _this = this;
                var input = this._extract(cues).filter(function(cue) {
                    return Boolean(cue && !_this._cues.some(function(existing) {
                        return (0, _textDisplayerutils.isEqualCuePoint)(existing, cue);
                    }));
                }).map(function(cue) {
                    return _object_spread_props._(_object_spread._({}, cue), {
                        version: _textDisplayerconstants.TEXT_RENDERER_V4
                    });
                });
                this._cues = this._cues.concat(input);
                this._updateCaptions();
            }
        },
        {
            key: "remove",
            value: function remove(start, end) {
                if (this._cues.length === 0) {
                    return false;
                }
                var count = this._cues.length;
                // Remove the cues out of the time range.
                this._cues = this._cues.filter(function(cue) {
                    return cue.startTime < start || cue.endTime >= end;
                });
                this._updateCaptions(count > this._cues.length);
                return true;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this._cues = [];
                if (this._captionsTimer) {
                    clearInterval(this._captionsTimer);
                }
                this._captionsTimer = null;
                this._isTextVisible = false;
                this._currentCuesMap.clear();
                this._triggerTextUpdate(null, _textDisplayerconstants.CUE_ACTION.REMOVED);
                this._dispatcher = null;
            }
        },
        {
            key: "isTextVisible",
            value: function isTextVisible() {
                return this._isTextVisible;
            }
        },
        {
            key: "setTextVisibility",
            value: function setTextVisibility(on) {
                this._isTextVisible = on;
                if (!this._isTextVisible) {
                    this._triggerTextUpdate(null, _textDisplayerconstants.CUE_ACTION.REMOVED);
                }
            }
        },
        {
            key: "_extract",
            value: function _extract(cues) {
                if (!cues) {
                    return null;
                }
                var result = [];
                for(var i = 0; i < cues.length; i += 1){
                    var cue = cues[i];
                    if (cue.region && cue.region.id || cue.payload) {
                        result.push(cue);
                    } else {
                        result = result.concat(this._extract(cue.nestedCues));
                    }
                }
                return result;
            }
        },
        {
            key: "_shouldCueBeDisplayed",
            value: function _shouldCueBeDisplayed(cue, currentTime) {
                return this._cues.includes(cue) && this._isTextVisible && cue.startTime <= currentTime && cue.endTime > currentTime;
            }
        },
        {
            key: "_updateCaptions",
            value: function _updateCaptions() {
                var forceUpdate = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                var _this = this;
                if (!this._video) {
                    return;
                }
                var currentTime = this._video.currentTime;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // For each cue in the current cues map, if the cue's end time has passed,
                    // remove the entry from the map, and remove the captions from the page.
                    // eslint-disable-next-line no-restricted-syntax
                    for(var _iterator = this._currentCuesMap.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var cue = _step.value;
                        if (!this._shouldCueBeDisplayed(cue, currentTime) || forceUpdate) {
                            this._triggerTextUpdate(cue, _textDisplayerconstants.CUE_ACTION.REMOVED);
                            this._currentCuesMap.delete(cue);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                // Get the current cues that should be added to display. If the cue is not
                // being displayed already, add it to the map, and add the captions onto the page.
                var currentCues = this._cues.filter(function(cue) {
                    return _this._shouldCueBeDisplayed(cue, currentTime) && !_this._currentCuesMap.has(cue);
                }).sort(function(a, b) {
                    if (a.startTime !== b.startTime) {
                        return a.startTime - b.startTime;
                    }
                    return a.endTime - b.endTime;
                });
                currentCues.forEach(function(cue) {
                    _this._triggerTextUpdate(cue, _textDisplayerconstants.CUE_ACTION.DISPLAYED);
                    _this._currentCuesMap.set(cue, undefined);
                });
            }
        },
        {
            key: "_triggerTextUpdate",
            value: function _triggerTextUpdate(cue, action) {
                if (!this._dispatcher) {
                    return;
                }
                this._dispatcher(_events.SUBTITLES_UPDATED, _object_spread_props._(_object_spread._({}, cue), {
                    cuePointState: action
                }));
            }
        }
    ]);
    return TextDisplayer;
}();


/***/ }),

/***/ 31438:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "isEqualCuePoint", ({
    enumerable: true,
    get: function() {
        return isEqualCuePoint;
    }
}));
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(45538);
var isEqualCuePoint = function(existingCue, newCue) {
    if (!existingCue || !newCue) {
        return false;
    }
    return existingCue.startTime === newCue.startTime && existingCue.endTime === newCue.endTime && existingCue.payload === newCue.payload;
};


/***/ }),

/***/ 88918:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    EVENTS: function() {
        return _events;
    },
    getAdPlayerInstance: function() {
        return _default.getAdPlayerInstance;
    },
    getPlayerInstance: function() {
        return _default.getPlayerInstance;
    }
});
var _export_star = __webpack_require__(37668);
var _interop_require_wildcard = __webpack_require__(95316);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(88801);
var _default = __webpack_require__(4910);
var _events = /*#__PURE__*/ _interop_require_wildcard._(__webpack_require__(58003));
_export_star._(__webpack_require__(51992), exports);
_export_star._(__webpack_require__(48649), exports);
_export_star._(__webpack_require__(91464), exports);


/***/ }),

/***/ 4910:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    getAdPlayerInstance: function() {
        return getAdPlayerInstance;
    },
    getPlayerInstance: function() {
        return getPlayerInstance;
    }
});
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(88801);
var _shakaengine = __webpack_require__(52418);
var _html5nofrostengine = __webpack_require__(97691);
var _youborashakaplugin = __webpack_require__(81729);
var getPlayerInstance = function() {
    return Promise.resolve({
        Engine: _shakaengine.ShakaEngine,
        plugins: [
            _youborashakaplugin.YouboraShakaPlugin
        ]
    });
};
var getAdPlayerInstance = function() {
    return Promise.resolve({
        Engine: _html5nofrostengine.HTML5NoFrostEngine
    });
};


/***/ }),

/***/ 10764:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    fetchUpfrontToken: function() {
        return fetchUpfrontToken;
    },
    isDecryptAccessSupported: function() {
        return isDecryptAccessSupported;
    },
    mediaCapabilitiesConfig: function() {
        return mediaCapabilitiesConfig;
    }
});
var _async_to_generator = __webpack_require__(24146);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
var mediaCapabilitiesConfig = {
    initDataTypes: [
        "cenc"
    ],
    audioCapabilities: [
        {
            contentType: 'audio/mp4;codecs="mp4a.40.2"'
        }
    ],
    videoCapabilities: [
        {
            contentType: 'video/mp4;codecs="avc1.42C01E"'
        },
        {
            contentType: 'video/mp4;codecs="avc1.42C01F"'
        },
        {
            contentType: 'video/mp4;codecs="avc1.64001F"'
        },
        {
            contentType: 'video/mp4;codecs="avc1.640028"'
        },
        {
            contentType: 'video/mp4;codecs="avc1.640029"'
        }
    ]
};
var isDecryptAccessSupported = function() {
    var _ref = _async_to_generator._(function(system, robustness) {
        var mediaKeySystemAccess, error;
        return _ts_generator._(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        navigator.requestMediaKeySystemAccess(system, [
                            _object_spread_props._(_object_spread._({}, mediaCapabilitiesConfig), {
                                audioCapabilities: mediaCapabilitiesConfig.audioCapabilities.map(function(capability) {
                                    return _object_spread_props._(_object_spread._({}, capability), {
                                        robustness: robustness.audio
                                    });
                                }),
                                videoCapabilities: mediaCapabilitiesConfig.videoCapabilities.map(function(capability) {
                                    return _object_spread_props._(_object_spread._({}, capability), {
                                        robustness: robustness.video
                                    });
                                })
                            })
                        ])
                    ];
                case 1:
                    mediaKeySystemAccess = _state.sent();
                    return [
                        4,
                        mediaKeySystemAccess.createMediaKeys()
                    ];
                case 2:
                    _state.sent();
                    return [
                        2,
                        true
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        2,
                        false
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function isDecryptAccessSupported(system, robustness) {
        return _ref.apply(this, arguments);
    };
}();
var fetchUpfrontToken = function() {
    var _ref = _async_to_generator._(function(handler) {
        var token;
        return _ts_generator._(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!handler) {
                        throw new Error("No DRM token handler provided");
                    }
                    return [
                        4,
                        handler()
                    ];
                case 1:
                    token = _state.sent();
                    if (!token || !token.value) {
                        throw new Error("DRM token endpoint returned no data");
                    }
                    return [
                        2,
                        token
                    ];
            }
        });
    });
    return function fetchUpfrontToken(handler) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 48649:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    AUDIO_TRACK: function() {
        return _audioTrack;
    },
    getCorrectAudioTrackLabel: function() {
        return getCorrectAudioTrackLabel;
    }
});
var _interop_require_wildcard = __webpack_require__(95316);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(3009);
var _audioTrack = /*#__PURE__*/ _interop_require_wildcard._(__webpack_require__(84131));
var getCorrectAudioTrackLabel = function(label) {
    var labelLower = (label || "").toLowerCase();
    switch(labelLower){
        case _audioTrack.OV:
        case _audioTrack.QTZ:
        case _audioTrack.UND:
        case _audioTrack.QAA:
            return _audioTrack.OV;
        case _audioTrack.MIS:
        case _audioTrack.QAD:
            return _audioTrack.AD;
        default:
            return labelLower;
    }
};


/***/ }),

/***/ 84131:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    AD: function() {
        return AD;
    },
    EN: function() {
        return EN;
    },
    ENG: function() {
        return ENG;
    },
    MIS: function() {
        return MIS;
    },
    OV: function() {
        return OV;
    },
    QAA: function() {
        return QAA;
    },
    QAD: function() {
        return QAD;
    },
    QTZ: function() {
        return QTZ;
    },
    UND: function() {
        return UND;
    },
    VO: function() {
        return VO;
    }
});
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(3009);
var VO = "vo";
var OV = "ov";
var QTZ = "qtz";
var UND = "und";
var QAA = "qaa";
var EN = "en";
var ENG = "eng";
var MIS = "mis";
var QAD = "qad";
var AD = "ad";


/***/ }),

/***/ 91464:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    filterContentProtection: function() {
        return filterContentProtection;
    },
    parseAvailabilityStartTime: function() {
        return parseAvailabilityStartTime;
    },
    removeNonPlayReadyDRM: function() {
        return removeNonPlayReadyDRM;
    },
    removeNonWidevineDRM: function() {
        return removeNonWidevineDRM;
    }
});
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(52318);
var filterContentProtection = function(valueToKeep) {
    return function(result) {
        // NOTE: Shaka 4+ uses object representation of the DASH manifest
        if (!result.querySelectorAll) {
            return _object_spread_props._(_object_spread._({}, result), {
                children: (result.children || []).map(function(period) {
                    return _object_spread_props._(_object_spread._({}, period), {
                        children: (period.children || []).map(function(node) {
                            return node.tagName === "AdaptationSet" ? _object_spread_props._(_object_spread._({}, node), {
                                children: (node.children || []).filter(function(child) {
                                    return child.tagName !== "ContentProtection" || child.attributes && typeof child.attributes.schemeIdUri === "string" && child.attributes.schemeIdUri.toUpperCase() === valueToKeep;
                                })
                            }) : node;
                        })
                    });
                })
            });
        }
        Array.from(result.querySelectorAll("AdaptationSet ContentProtection")).filter(function(child) {
            return (child.getAttribute("schemeIdUri") || "").toUpperCase() !== valueToKeep;
        }).forEach(function(child) {
            child.parentNode.removeChild(child);
        });
        return result;
    };
};
var parseAvailabilityStartTime = function(manifest) {
    if (!manifest) {
        return "";
    }
    return manifest.querySelector("MPD").getAttribute("availabilityStartTime") || "";
};
var removeNonPlayReadyDRM = filterContentProtection("URN:UUID:9A04F079-9840-4286-AB92-E65BE0885F95");
var removeNonWidevineDRM = filterContentProtection("URN:UUID:EDEF8BA9-79D6-4ACE-A3C8-27DCD51D21ED");


/***/ }),

/***/ 84338:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    throwAutoplayErrorHelper: function() {
        return throwAutoplayErrorHelper;
    },
    throwContainerErrorHelper: function() {
        return throwContainerErrorHelper;
    },
    throwEngineErrorHelper: function() {
        return throwEngineErrorHelper;
    },
    throwMethodOverloadError: function() {
        return throwMethodOverloadError;
    },
    throwNoPlayerError: function() {
        return throwNoPlayerError;
    },
    throwNoSourceErrorHelper: function() {
        return throwNoSourceErrorHelper;
    },
    throwUnknownErrorHelper: function() {
        return throwUnknownErrorHelper;
    }
});
var _interop_require_wildcard = __webpack_require__(95316);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
var _types = /*#__PURE__*/ _interop_require_wildcard._(__webpack_require__(64702));
var _details = /*#__PURE__*/ _interop_require_wildcard._(__webpack_require__(12510));
/**
 * Engine error factory
 * @param {string} type
 * @param {string} initDetail
 * @param {boolean} initFatal
 * @param {boolean} initMonitored
 * @returns {function}
 * @param {Object} data
 * @param {string} data.context
 * @param {string} data.reason
 * @param {string} data.content
 * @param {boolean} data.fatal
 * @param {boolean} data.monitored
 * @param {string} data.detail
 */ var throwMediaEngineError = function() {
    var type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _types.UNKNOWN_ERROR, initDetail = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _details.UNKNOWN, initFatal = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, initMonitored = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
    return function(param) {
        var context = param.context, reason = param.reason, content = param.content, _param_fatal = param.fatal, fatal = _param_fatal === void 0 ? initFatal : _param_fatal, _param_monitored = param.monitored, monitored = _param_monitored === void 0 ? initMonitored : _param_monitored, _param_detail = param.detail, detail = _param_detail === void 0 ? initDetail : _param_detail;
        return {
            context: context,
            content: content,
            reason: reason,
            type: type,
            fatal: fatal,
            monitored: monitored,
            detail: detail
        };
    };
};
var throwMethodOverloadError = throwMediaEngineError(_types.IMPLEMENTATION_ERROR, _details.METHOD_MUST_BE_OVERLOADED);
var throwNoPlayerError = throwMediaEngineError(_types.IMPLEMENTATION_ERROR, _details.NO_PLAYER);
var throwContainerErrorHelper = throwMediaEngineError(_types.BRIDGE_ERROR, _details.NO_CONTAINER);
var throwNoSourceErrorHelper = throwMediaEngineError(_types.BRIDGE_ERROR, _details.NO_SOURCE);
var throwEngineErrorHelper = throwMediaEngineError(_types.ENGINE_ERROR, undefined);
var throwUnknownErrorHelper = throwMediaEngineError(_types.UNKNOWN_ERROR, _details.UNKNOWN);
var throwAutoplayErrorHelper = throwMediaEngineError(_types.IMPLEMENTATION_ERROR, _details.AUTOPLAY_PREVENTED_ERROR);


/***/ }),

/***/ 62319:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return YouboraShakaAdapter;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _get = __webpack_require__(60528);
var _get_prototype_of = __webpack_require__(35196);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _sliced_to_array = __webpack_require__(28966);
var _create_super = __webpack_require__(6400);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(65759);
var _youboraadaptershaka = /*#__PURE__*/ _interop_require_default._(__webpack_require__(61268));
var YouboraShakaAdapter = /*#__PURE__*/ function(Adapter) {
    "use strict";
    _inherits._(YouboraShakaAdapter, Adapter);
    var _super = _create_super._(YouboraShakaAdapter);
    function YouboraShakaAdapter() {
        _class_call_check._(this, YouboraShakaAdapter);
        return _super.apply(this, arguments);
    }
    _create_class._(YouboraShakaAdapter, [
        {
            key: "_getTagFromPlayer",
            value: function _getTagFromPlayer() {
                return this.player ? _get._(_get_prototype_of._(YouboraShakaAdapter.prototype), "_getTagFromPlayer", this).call(this) : null;
            }
        },
        {
            key: "setPlayheadMonitorInterval",
            value: function setPlayheadMonitorInterval(interval) {
                this._playheadMonitorInterval = interval;
            }
        },
        {
            key: "registerListeners",
            value: function registerListeners() {
                var _this = this;
                // Enable playhead monitor (buffer = true, seek = true)
                if (this._playheadMonitorInterval) {
                    this.monitorPlayhead(true, true, this._playheadMonitorInterval);
                }
                // References
                this.references = {
                    play: this.playListener.bind(this),
                    loadstart: this.autoplayListener.bind(this),
                    pause: this.pauseListener.bind(this),
                    playing: this.playingListener.bind(this),
                    seeking: this.seekingListener.bind(this),
                    seeked: this.seekedListener.bind(this),
                    // NOTE: we are firing this event externally due to CSAI peculiarities
                    // ended: this.endedListener.bind(this),
                    timeupdate: this.timeupdateListener.bind(this),
                    waiting: this.bufferingListener.bind(this)
                };
                this.referencesPlayer = {
                    error: this.errorListener.bind(this)
                };
                // Register video tag listeners
                this._registerTag();
                if (!this.player) {
                    return;
                }
                // Just in case this method will be triggered twice
                Object.entries(this.referencesPlayer).forEach(function(param) {
                    var _param = _sliced_to_array._(param, 2), key = _param[0], value = _param[1];
                    _this.player.removeEventListener(key, value);
                });
                Object.entries(this.referencesPlayer).forEach(function(param) {
                    var _param = _sliced_to_array._(param, 2), key = _param[0], value = _param[1];
                    _this.player.addEventListener(key, value);
                });
            }
        },
        {
            key: "errorListener",
            value: function errorListener(event) {
                if (!event) {
                    return;
                }
                // Error codes: https://shaka-player-demo.appspot.com/docs/api/shaka.util.Error.html
                var code = event.detail && event.detail.code ? event.detail.code : event.code;
                var category = event.detail && event.detail.category ? event.detail.category : event.category;
                var severity = event.detail && event.detail.severity ? event.detail.severity : event.severity;
                var msg = event.detail && event.detail.message ? event.detail.message : "unknown";
                if (category && category < 10 && category > 0) {
                    var descriptionPerCategory = {
                        1: "network",
                        2: "text",
                        3: "media",
                        4: "manifest",
                        5: "streaming",
                        6: "drm",
                        7: "player",
                        8: "cast",
                        9: "storage"
                    };
                    msg = descriptionPerCategory[category] || msg;
                }
                var metadata;
                if (event.detail && event.detail.data && event.detail.data.length) {
                    var data = event.detail.data;
                    if (code === 1001) {
                        if (data[0] && data[1]) {
                            msg = "Bad HTTP status ".concat(data[1], " on ").concat(data[0]);
                        }
                    } else if (code === 1002) {
                        if (data[0]) {
                            msg = "HTTP error on ".concat(data[0]);
                        }
                    } else if (code === 1003) {
                        if (data[0]) {
                            msg = "Request timeout: ".concat(data[0]);
                        }
                    }
                    // In case if metadata could not be serialized, let's skip it
                    try {
                        metadata = JSON.parse(JSON.stringify(event.detail.data));
                    } catch (error) {
                        metadata = undefined;
                    }
                }
                if (severity === 2 && [
                    1002,
                    3016
                ].indexOf(code) === -1) {
                    // code is not on the list and severity is 2: fatal
                    this.fireFatalError(code, msg, metadata);
                } else {
                    // not severity 2, or in the list: nonfatal
                    this.fireError(code, msg, metadata);
                }
            }
        },
        {
            key: "getPlayerVersion",
            value: function getPlayerVersion() {
                if (this.player) {
                    try {
                        // eslint-disable-next-line no-proto
                        return this.player.__proto__.constructor.version;
                    } catch (error) {
                        return null;
                    }
                }
                return null;
            }
        },
        {
            key: "unregisterListeners",
            value: function unregisterListeners() {
                _get._(_get_prototype_of._(YouboraShakaAdapter.prototype), "unregisterListeners", this).call(this);
                delete this.tag;
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                this._isConnected = false;
                this.unregisterListeners();
            }
        },
        {
            key: "connect",
            value: function connect(player) {
                this._isConnected = true;
                this.player = player;
                this.registerListeners();
            }
        },
        {
            key: "timeupdateListener",
            value: function timeupdateListener() {
                var currentPlayhead = this.getPlayhead();
                if (currentPlayhead !== this.initialPlayhead && typeof this.initialPlayhead === "number") {
                    // NOTE: originally Youbora is trying to call the start event on each time update.
                    // While it may be useful for some (alas, unknown) applications, in our case it's not needed.
                    // Moreover, it'll trigger a fake EBVS on Ziggo devices which sometimes firing time update after ended event (sic!).
                    // Hence, we'll adding a failsafe here to prevent false-positive EBVS tracking
                    if (!this.flags.isEnded) {
                        this._callStart("timeupdateListener");
                    }
                } else {
                    this.initialPlayhead = this.getPlayhead();
                }
            }
        },
        {
            key: "getPlayhead",
            value: function getPlayhead() {
                // Ensure proper content playhead will be available in the ads adapter
                if (this._isConnected) {
                    this._lastRegisteredPlayhead = _get._(_get_prototype_of._(YouboraShakaAdapter.prototype), "getPlayhead", this).call(this);
                }
                return this._lastRegisteredPlayhead;
            }
        },
        {
            key: "getPlayrate",
            value: function getPlayrate() {
                return 1;
            }
        },
        {
            key: "getThroughput",
            value: function getThroughput() {
                if (this.player) {
                    this._lastRegisteredThroughput = _get._(_get_prototype_of._(YouboraShakaAdapter.prototype), "getThroughput", this).call(this);
                }
                return this._lastRegisteredThroughput;
            }
        },
        {
            key: "getIsLive",
            value: function getIsLive() {
                if (this.player) {
                    this._lastRegisteredIsLive = _get._(_get_prototype_of._(YouboraShakaAdapter.prototype), "getIsLive", this).call(this);
                }
                return this._lastRegisteredIsLive;
            }
        },
        {
            key: "endedListener",
            value: function endedListener() {
                this.fireStop({}, "endedListener");
                this.flags.isEnded = true;
            }
        }
    ]);
    return YouboraShakaAdapter;
}(_youboraadaptershaka.default);


/***/ }),

/***/ 81722:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return YouboraPlugin;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(45538);
var _youboralib = /*#__PURE__*/ _interop_require_default._(__webpack_require__(46847));
var YouboraPlugin = /*#__PURE__*/ function() {
    "use strict";
    function YouboraPlugin() {
        _class_call_check._(this, YouboraPlugin);
        this.id = "youbora";
        this.isInitialized = false;
        this.instance = null;
        this._isDisconnected = false;
    }
    _create_class._(YouboraPlugin, [
        {
            /**
   * Initialize the plugin before playback is started
   *
   * @param {Object} options - Youbora options
   */ key: "init",
            value: function init(param) {
                var options = param.options;
                if (this.isInitialized && this.instance) {
                    this.instance.setOptions(options);
                    return;
                }
                // NOTE: uncomment to debug Youbora
                // Youbora.Log.logLevel = Youbora.Log.Level.DEBUG;
                if (options && options.accountCode) {
                    this.instance = new _youboralib.default.Plugin(options);
                    this.isInitialized = true;
                }
            }
        },
        {
            /**
   * Shut down the plugin when playback is finished
   */ key: "release",
            value: function release() {
                if (this.instance) {
                    try {
                        this.instance.removeAdapter();
                    } catch (error) {
                        // TODO: error handling
                        // eslint-disable-next-line no-console
                        console.error("[YouboraPlugin]: Can not remove video adapter");
                    }
                    try {
                        this.instance.removeAdsAdapter();
                    } catch (error) {
                        // TODO: error handling
                        // eslint-disable-next-line no-console
                        console.error("[YouboraPlugin]: Can not remove ads adapter");
                    }
                }
                this.instance = null;
                this.isInitialized = false;
            }
        },
        {
            /**
   * Set or update Youbora options
   *
   * @param {Object} options
   */ key: "setOptions",
            value: function setOptions(options) {
                if (this.instance) {
                    this.instance.setOptions(options);
                }
            }
        },
        {
            key: "getAdapter",
            value: function getAdapter() {
                return this.instance ? this.instance.getAdapter() : null;
            }
        },
        {
            /**
   * Set video content adapter instance
   * @param {Youbora.Adapter} adapter
   */ key: "setAdapter",
            value: function setAdapter(adapter) {
                if (this.instance) {
                    this.instance.setAdapter(adapter);
                }
            }
        },
        {
            /**
   * Set ads adapter instance
   * @param {Youbora.Adapter} adapter
   */ key: "setAdsAdapter",
            value: function setAdsAdapter(adapter) {
                if (this.instance) {
                    this.instance.setAdsAdapter(adapter);
                }
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (!this.instance) {
                    return;
                }
                var adapter = this.instance.getAdapter();
                adapter.disconnect();
                this._isDisconnected = true;
            }
        },
        {
            key: "connect",
            value: function connect(engine) {
                if (!this.instance || !this._isDisconnected) {
                    return;
                }
                var adapter = this.instance.getAdapter();
                adapter.connect(engine.player);
            }
        }
    ]);
    return YouboraPlugin;
}();


/***/ }),

/***/ 81729:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "YouboraShakaPlugin", ({
    enumerable: true,
    get: function() {
        return YouboraShakaPlugin;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _get = __webpack_require__(60528);
var _get_prototype_of = __webpack_require__(35196);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(3009);
var _youborashakaadapter = /*#__PURE__*/ _interop_require_default._(__webpack_require__(62319));
var _youboraplugin = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81722));
var YouboraShakaPlugin = /*#__PURE__*/ function(YouboraPlugin) {
    "use strict";
    _inherits._(YouboraShakaPlugin, YouboraPlugin);
    var _super = _create_super._(YouboraShakaPlugin);
    function YouboraShakaPlugin() {
        _class_call_check._(this, YouboraShakaPlugin);
        return _super.apply(this, arguments);
    }
    _create_class._(YouboraShakaPlugin, [
        {
            /**
   * Initial action of the plugin
   *
   * @param {Object} options Youbora plugin initialization parameters
   * @param {Object} engine Bedrock Shaka Engine
   * @param {Object} options Youbora options
   */ key: "init",
            value: function init(param) {
                var options = param.options, engine = param.engine, _param_sendInitEvent = param.sendInitEvent, sendInitEvent = _param_sendInitEvent === void 0 ? false : _param_sendInitEvent;
                var isInitialized = this.isInitialized;
                _get._(_get_prototype_of._(YouboraShakaPlugin.prototype), "init", this).call(this, {
                    options: options ? options.data : {}
                });
                if (!isInitialized) {
                    var adapter = new _youborashakaadapter.default(engine.player, engine.videoElement);
                    if (options && options.settings) {
                        adapter.setPlayheadMonitorInterval(options.settings.playheadMonitoringInterval || 800);
                    }
                    this.setAdapter(adapter);
                    adapter.connect(engine.player);
                    if (sendInitEvent) {
                        this.instance.fireInit(null, "contentSelected");
                    }
                }
            }
        }
    ]);
    return YouboraShakaPlugin;
}(_youboraplugin.default);


/***/ }),

/***/ 45479:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/** @module applaunchUtils */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "getApplaunchConfig", ({
    enumerable: true,
    get: function() {
        return getApplaunchConfig;
    }
}));
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);
var _config = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67958));
var getApplaunchConfig = function(localId) {
    return _object_spread._({
        app: _config.default.app,
        platform: _config.default.platformCode,
        localDeviceId: localId,
        customizer: _config.default.customizer
    }, _config.default.fido.applaunch);
};


/***/ }),

/***/ 5188:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/** @module clipBoardUtils */ /**
 * @see https://stackoverflow.com/questions/400212/how-do-i-copy-to-the-clipboard-in-javascript
 */ /* eslint-disable no-console */ /**
 * @function fallbackCopyTextToClipboard
 * @param {string} text
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "copyTextToClipboard", ({
    enumerable: true,
    get: function() {
        return copyTextToClipboard;
    }
}));
var _async_to_generator = __webpack_require__(24146);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(65759);
var fallbackCopyTextToClipboard = function(text) {
    var textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
        var successful = document.execCommand("copy");
        var msg = successful ? "successful" : "unsuccessful";
        console.log("Fallback: Copying text command was ".concat(msg));
    } catch (err) {
        console.error("Fallback: Oops, unable to copy", err);
    }
    document.body.removeChild(textArea);
};
var copyTextToClipboard = function() {
    var _ref = _async_to_generator._(function(text) {
        return _ts_generator._(this, function(_state) {
            if (!navigator.clipboard) {
                fallbackCopyTextToClipboard(text);
                return [
                    2
                ];
            }
            try {
                navigator.clipboard.writeText(text);
                console.log("Async: Copying to clipboard was successful!");
            } catch (error) {
                console.error("Async: Could not copy text: ", error);
            }
            return [
                2
            ];
        });
    });
    return function copyTextToClipboard(text) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 73724:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/** @module debugUtils */ /* eslint-disable no-console */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    default: function() {
        return _default;
    },
    format: function() {
        return format;
    },
    sendLog: function() {
        return sendLog;
    }
});
var _async_to_generator = __webpack_require__(24146);
var _interop_require_default = __webpack_require__(81200);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(65759);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _config = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67958));
var _env = __webpack_require__(19561);
var _http = __webpack_require__(40057);
function format(param) {
    // TODO: find a better way to detect refs
    if ((0, _get.default)(param, "current") instanceof HTMLElement) {
        var instance = Object.keys(param.current)[0];
        var fiberNode = param.current[instance];
        if ((0, _get.default)(fiberNode, "pendingProps.children")) {
            var children = fiberNode.pendingProps.children;
            if (Array.isArray(children)) {
                var formatedChildren = children.map(format);
                return {
                    type: fiberNode.elementType,
                    children: formatedChildren
                };
            }
            if (children.$$typeof) {
                return {
                    type: fiberNode.elementType,
                    child: format(children)
                };
            }
        }
        return {
            type: fiberNode.elementType,
            pendingProps: fiberNode.pendingProps
        };
    }
    if (param && param.$$typeof && param.$$typeof.toString() === "Symbol(react.element)") {
        // TODO: make it works recursively
        return {
            type: param.type,
            props: param.props
        };
    }
    if (param instanceof HTMLElement) {
        // https://stackoverflow.com/a/46881092
        return JSON.stringify(param, [
            "name",
            "class",
            "data-testid"
        ], 2);
    }
    if (typeof param === "function") {
        return param.toString();
    }
    return param;
}
var sendLog = function() {
    var _ref = _async_to_generator._(function(messages, type) {
        var logInConsole, APP_REMOTE_DEBUGGER, finalMessage, error;
        var _arguments = arguments;
        return _ts_generator._(this, function(_state) {
            switch(_state.label){
                case 0:
                    logInConsole = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : true;
                    if (!_config.default.debug || _env.isProdApp) {
                        return [
                            2
                        ];
                    }
                    APP_REMOTE_DEBUGGER = null;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    finalMessage = messages.map(format).join(" ");
                    if (console && logInConsole) {
                        (console[type] || console.log).apply(console, [
                            finalMessage
                        ]);
                    }
                    if (!(APP_REMOTE_DEBUGGER && !_env.isProdApp)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        (0, _http.requestPost)("http://".concat(APP_REMOTE_DEBUGGER, ":5555"), {
                            message: finalMessage,
                            type: type
                        })
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    return [
                        3,
                        5
                    ];
                case 4:
                    error = _state.sent();
                    console.warn("Log wasnt sent to remote debugger. Reason:\n".concat(error.message));
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function sendLog(messages, type) {
        return _ref.apply(this, arguments);
    };
}();
var logger = {
    log: function() {
        for(var _len = arguments.length, message = new Array(_len), _key = 0; _key < _len; _key++){
            message[_key] = arguments[_key];
        }
        return sendLog(message, "log");
    },
    info: function() {
        for(var _len = arguments.length, message = new Array(_len), _key = 0; _key < _len; _key++){
            message[_key] = arguments[_key];
        }
        return sendLog(message, "info");
    },
    success: function() {
        for(var _len = arguments.length, message = new Array(_len), _key = 0; _key < _len; _key++){
            message[_key] = arguments[_key];
        }
        return sendLog(message, "success");
    },
    warn: function() {
        for(var _len = arguments.length, message = new Array(_len), _key = 0; _key < _len; _key++){
            message[_key] = arguments[_key];
        }
        return sendLog(message, "warn");
    },
    error: function() {
        for(var _len = arguments.length, message = new Array(_len), _key = 0; _key < _len; _key++){
            message[_key] = arguments[_key];
        }
        return sendLog(message, "error");
    }
};
var _default = logger;


/***/ }),

/***/ 8163:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    default: function() {
        return _default;
    },
    fixDeviceId: function() {
        return fixDeviceId;
    },
    isValidDeviceId: function() {
        return isValidDeviceId;
    }
});
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(42578);
var _hmacsha1 = /*#__PURE__*/ _interop_require_default._(__webpack_require__(69764));
var isValidDeviceId = function(deviceId) {
    return deviceId.indexOf("-Z-") !== -1;
};
var randomInt = function(a, b) {
    var ceilA = Math.ceil(a);
    var floorB = Math.floor(b);
    return Math.floor(Math.random() * (floorB - ceilA)) + ceilA;
};
var fixDeviceId = function(deviceId) {
    return "".concat(deviceId, "-Z-").concat(randomInt(0, 1e6));
};
var generateDeviceId = function() {
    var prefix = "deviceid";
    var uniqueID = (0, _hmacsha1.default)(randomInt(0, 1e6), randomInt(0, 1e6).toString());
    var salt = Date.now();
    var suffix = randomInt(0, 1e6);
    return "".concat(prefix, "-").concat(uniqueID, "-").concat(salt, "-Z-").concat(suffix);
};
var _default = generateDeviceId;


/***/ }),

/***/ 19561:
/***/ ((module, exports, __webpack_require__) => {

"use strict";
/** @module envUtils */ /**
 * @see {@link /docs/utils/env.md|Environment documentation}
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(52318);
var DEVELOPMENT = "development";
var DETECTIVE = "detective";
var STAGING = "staging";
var PROD = "prod";
var TEST = "test";
var DEFAULT_APP_CUSTOMER = "default";
var appEnv = "prod";
var appVersion = "1.51.2";
var appCustomer = {"PELO_PLATFORM":"magenta","APP_VERSION":"1.51.2","OPTIONS":"{\"platform\":\"magenta\",\"packaged\":false,\"debug\":false,\"skipHook\":false,\"skipNativeBuild\":true,\"skipBundler\":false}","GITHUB_STATE":"/runner/_work/_temp/_runner_file_commands/save_state_1aea6be7-8451-44d1-976b-920c5fab1345","npm_package_dependencies__babel_runtime":"7.22.3","npm_package_dependencies__pelo_plugins_screen":"workspace:*","npm_package_dependencies_regenerator_runtime":"0.13.11","npm_package_devDependencies_identity_obj_proxy":"3.0.0","npm_package_scripts_build_config_rtlnl":"APP_CUSTOMER=rtlnl node scripts/build-config","KUBERNETES_SERVICE_PORT":"443","KUBERNETES_PORT":"tcp://[fd24:3fac:1f16::1]:443","npm_package_dependencies_immutable_set":"2.1.0","npm_package_devDependencies__storybook_addon_knobs":"6.2.9","npm_package_devDependencies_prettier_eslint_cli":"7.1.0","npm_package_scripts_preinstall":"npx only-allow pnpm","npm_package_devDependencies__storybook_addon_docs":"6.2.9","npm_package_devDependencies_jest":"29.5.0","npm_package_devDependencies_webpack_bundle_analyzer":"4.10.2","npm_package_scripts_dev_rtlnl":"APP_CUSTOMER=rtlnl pnpm dev","npm_config_user_agent":"pnpm/9.14.4 npm/? node/v22.19.0 linux x64","CI":"true","npm_package_dependencies__bedrock_rdk_constants":"workspace:*","npm_package_dependencies__tornado_rdk_theme":"workspace:*","npm_package_dependencies_abortcontroller_polyfill":"1.7.8","npm_package_devDependencies__lightningjs_cli":"2.2.0","npm_package_scripts_build_config_rtlhu":"APP_CUSTOMER=rtlhu node scripts/build-config","npm_package_scripts_prod_rtlnl":"APP_CUSTOMER=rtlnl pnpm prod","HOSTNAME":"app-bedrock-rdk-deploy-npc97-bp8xd","RUNNER_ENVIRONMENT":"self-hosted","GITHUB_ENV":"/runner/_work/_temp/_runner_file_commands/set_env_1aea6be7-8451-44d1-976b-920c5fab1345","UPLOAD_SOURCE_MAPS":"false","npm_package_dependencies__bedrock_rdk_utils":"workspace:*","npm_node_execpath":"/opt/hostedtoolcache/node/22.19.0/x64/bin/node","GITHUB_ACTIONS_RUNNER_EXTRA_USER_AGENT":"actions-runner-controller/v0.27.6","RUNNER_EPHEMERAL":"true","SHLVL":"4","npm_package_packageManager":"pnpm@9.14.4","npm_package_dependencies__bedrock_rdk_lng_storybook":"workspace:*","npm_package_devDependencies__swc_core":"1.3.95","npm_package_scripts_dev_rtlhu":"APP_CUSTOMER=rtlhu pnpm dev","npm_package_scripts_nr_create_browser_applications":"node scripts/createNewRelicApps.js","HOME":"/home/runner","npm_package_devDependencies__babel_plugin_proposal_class_properties":"7.18.6","npm_package_devDependencies__bedrock_package_json_loader":"1.2.4","npm_package_devDependencies_jest_webgl_canvas_mock":"0.2.3","npm_package_scripts_prod_rtlhu":"APP_CUSTOMER=rtlhu pnpm prod","RUNNER_ORG":"","AWS_ROLE_ARN":"arn:aws:iam::081993058424:role/irsa/runners/app-bedrock-rdk-deploy","RUNNER_TEMP":"/runner/_work/_temp","GITHUB_EVENT_PATH":"/runner/_work/_temp/_github_workflow/event.json","npm_package_devDependencies_eslint_config_prettier":"9.0.0","npm_package_scripts_lint_filenames":"node scripts/checkFileScopes.js","npm_package_scripts_server":"http-server -c-1 build","npm_package_scripts_storybook_rtlde":"APP_CUSTOMER=rtlde start-storybook -p 6006","DOCKER_ENABLED":"true","GITHUB_REPOSITORY_OWNER":"m6web","npm_package_engines_node":"22.x","npm_package_dependencies__bedrock_html5_engine":"3.6.24","npm_package_devDependencies__6play_ryp":"3.2.4","npm_package_devDependencies__bedrock_github_api_utils":"1.0.1","npm_package_scripts_lint_json":"pnpm sort-keys:json --lint && prettier-eslint --list-different '/{.,}*.json' --ignore-path '**/package.json'","RUNNER_WORKDIR":"/runner/_work","GENERATE_SOURCEMAP":"true","AWS_WEB_IDENTITY_TOKEN_FILE":"/var/run/secrets/eks.amazonaws.com/serviceaccount/token","GITHUB_RETENTION_DAYS":"7","npm_package_devDependencies__pelo_platforms_vodafone":"10.0.0-alpha.1","npm_package_devDependencies_minimist":"1.2.8","npm_package_scripts_i18n_pull":"node ./scripts/i18nPull.js","npm_package_scripts_lint_md":"pnpm prettier-eslint --list-different $PWD/'**/*.md' $PWD/'.*/**/*.md'","GITHUB_REPOSITORY_OWNER_ID":"5","GITHUB_HEAD_REF":"","npm_package_dependencies_redux_thunk":"2.3.0","ACTIONS_RUNNER_HOOK_JOB_STARTED":"/etc/arc/hooks/job-started.sh","npm_package_devDependencies__swc_plugin_transform_imports":"1.5.94","npm_package_devDependencies_source_map_explorer":"1.6.0","npm_package_cypress_cucumber_preprocessor_stepDefinitions_0":"cypress/e2e/common/*.js","GITHUB_GRAPHQL_URL":"https://github.m6web.fr/api/graphql","REF":"v1.51.2","npm_package_dependencies__tornado_rdk_icons":"workspace:*","npm_package_dependencies_algoliasearch":"4.12.1","npm_package_dependencies_superagent":"8.0.9","npm_package_devDependencies_babel_loader":"9.1.2","npm_package_devDependencies_slack":"11.0.2","npm_package_scripts_build_config":"node scripts/build-config","npm_package_cypress_cucumber_preprocessor_stepDefinitions_1":"cypress/e2e/[filepart]/**/*.js","npm_package_dependencies_jwt_decode":"2.2.0","npm_package_devDependencies__babel_preset_env":"7.12.1","npm_package_scripts_e2e_rtlnl":"APP_CUSTOMER=rtlnl pnpm cypress open --e2e -b chrome","npm_package_pnpm_overrides__lightningjs_core":"2.9.0","npm_package_cypress_cucumber_preprocessor_stepDefinitions_2":"cypress/e2e/[filepart].js","GITHUB_URL":"https://github.m6web.fr/","RUNNER_ASSETS_DIR":"/runnertmp","AWS_STS_REGIONAL_ENDPOINTS":"regional","npm_package_devDependencies__babel_plugin_transform_runtime":"7.22.4","npm_package_devDependencies_inquirer":"8.1.5","npm_package_scripts_dev":"APP_ENV=development pelo run","RUNNER_OS":"Linux","GITHUB_API_URL":"https://github.m6web.fr/api/v3","MAXPROC":"8","RUNNER_LABELS":"self-hosted,app-bedrock-rdk-deploy","npm_package_devDependencies__pelo_platforms_ziggo":"10.0.0-alpha.1","npm_package_devDependencies_eslint_plugin_import":"2.28.1","npm_package_scripts_logs":"node scripts/logs.js","npm_package_scripts_prod":"APP_ENV=prod pelo run","_":"/home/runner/setup-pnpm/node_modules/.bin/pnpm","RUNNER_GROUP":"blue-gha-eks-bedrock-tech","HELM_REGISTRY_CONFIG":"/home/runner/.docker/config.json","GITHUB_WORKFLOW":"🏷 Release","npm_package_private":"true","npm_package_dependencies_sprintf_js":"1.1.2","npm_package_devDependencies__m6web_eslint_config":"3.5.0","npm_package_devDependencies_jsonlint":"1.6.3","npm_package_scripts_build_rtlnl":"APP_CUSTOMER=rtlnl pnpm build","npm_package_dependencies__bedrock_rdk_media_engine":"workspace:*","npm_package_dependencies_lightningjs_redux":"workspace:*","npm_package_devDependencies__babel_plugin_proposal_decorators":"7.22.3","npm_package_scripts_lint":"pnpm lint:js && pnpm lint:md && pnpm lint:json && pnpm lint:filenames","npm_config_registry":"https://verdaccio.bedrock.tech","GITHUB_RUN_ID":"4275928","npm_package_dependencies__bedrock_fido_sdk":"30.19.0","npm_package_dependencies_core_js":"3.32.1","npm_package_devDependencies__swc_jest":"0.2.29","npm_package_scripts_lint_tf":"terraform fmt -check -recursive -diff .cloud/terraform","npm_package_scripts_sort_keys_json":"node ./scripts/sortKeysJson.js","npm_package_pnpm_overrides_lodash":"4.17.21","GITHUB_REF_TYPE":"branch","GITHUB_WORKFLOW_SHA":"ab23f250364979d926e7565a2779bba0daadf009","KUBERNETES_PORT_443_TCP_ADDR":"fd24:3fac:1f16::1","GITHUB_BASE_REF":"","ImageOS":"ubuntu22","npm_package_devDependencies_dotenv_expand":"5.1.0","npm_package_devDependencies_html_webpack_plugin":"5.5.0","npm_package_scripts_build_rtlhu":"APP_CUSTOMER=rtlhu pnpm build","GITHUB_WORKFLOW_REF":"m6web/app-bedrock-rdk/.github/workflows/release.yml@refs/heads/master","GITHUB_ACTION_REPOSITORY":"","npm_config_node_gyp":"/home/runner/setup-pnpm/node_modules/.pnpm/pnpm@9.14.4/node_modules/pnpm/dist/node_modules/node-gyp/bin/node-gyp.js","PATH":"/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.bin:/home/runner/setup-pnpm/node_modules/.pnpm/pnpm@9.14.4/node_modules/pnpm/dist/node-gyp-bin:/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.bin:/opt/hostedtoolcache/node/22.19.0/x64/bin:/home/runner/setup-pnpm/node_modules/.bin:/usr/local/sbin:/usr/local/bin:/usr/sbin:/usr/bin:/sbin:/bin:/home/runner/.local/bin/","RUNNER_TRACKING_ID":"github_7c5f522c-ab40-4e86-a7b5-77a0008d8715","RUNNER_TOOL_CACHE":"/opt/hostedtoolcache","npm_package_name":"app-bedrock-rdk","npm_package_repository_type":"git","npm_package_dependencies_serve":"14.1.2","npm_package_devDependencies__babel_eslint_parser":"7.22.15","npm_package_scripts_lint_js":"pnpm eslint --max-warnings=0 .pelo.config.js src/ packages/ platforms/ --cache","NODE":"/opt/hostedtoolcache/node/22.19.0/x64/bin/node","GITHUB_ACTION":"__run_4","GITHUB_RUN_NUMBER":"246","GITHUB_TRIGGERING_ACTOR":"skovalchuk-externe","RUNNER_ARCH":"X64","KUBERNETES_PORT_443_TCP_PORT":"443","npm_package_devDependencies_eslint_config_airbnb_base":"15.0.0","npm_package_scripts_analyze":"APP_ENV=detective pnpm build","npm_package_scripts_build_config_rtlde":"APP_CUSTOMER=rtlde node scripts/build-config","npm_config_frozen_lockfile":"","RUN_URL":"https://github.m6web.fr/m6web/app-bedrock-rdk/actions/runs/4275928","KUBERNETES_PORT_443_TCP_PROTO":"tcp","npm_package_dependencies__pelo_plugins_device":"workspace:*","npm_package_devDependencies__bedrock_deploy_event":"0.11.0","npm_package_devDependencies__pelo_platforms_web":"10.0.0-alpha.1","npm_package_devDependencies__swc_helpers":"0.5.3","npm_package_devDependencies_glob":"7.1.6","npm_package_devDependencies_prettier_eslint":"15.0.1","npm_package_dependencies__firebolt_js_sdk":"1.7.0","npm_package_dependencies__lightningjs_core":"2.9.0","npm_package_dependencies_history":"4.9.0","npm_package_dependencies_redux":"4.0.5","npm_package_devDependencies__storybook_theming":"6.2.9","npm_package_devDependencies_eslint":"8.50.0","npm_package_devDependencies_webpack":"5.88.2","npm_package_scripts_dev_rtlde":"APP_CUSTOMER=rtlde pnpm dev","npm_package_scripts_format_md":"prettier-eslint --write $PWD/'**/*.md' $PWD/'.*/**/*.md'","npm_package_scripts_storybook_rtlnl":"APP_CUSTOMER=rtlnl start-storybook -p 6006","RUNNER_NAME":"app-bedrock-rdk-deploy-npc97-bp8xd","PIP_REQUIRE_VIRTUALENV":"true","GITHUB_REF_NAME":"master","GITHUB_REPOSITORY":"m6web/app-bedrock-rdk","S3_PATH":"s3://bedrock-rdk-rtlde-prod-magenta","npm_package_devDependencies__storybook_html":"6.2.9","npm_package_devDependencies_copy_webpack_plugin":"11.0.0","npm_package_devDependencies_dotenv":"16.0.3","npm_package_scripts_e2e":"pnpm cypress open --e2e -b chrome","npm_package_scripts_prod_rtlde":"APP_CUSTOMER=rtlde pnpm prod","npm_lifecycle_script":"pelo build \"magenta\" \"--skip-native-build\"","GITHUB_ACTION_REF":"","DEBIAN_FRONTEND":"noninteractive","npm_package_devDependencies__babel_runtime_corejs3":"7.22.3","npm_package_devDependencies__cypress_webpack_preprocessor":"6.0.0","npm_package_devDependencies__pelo_core":"10.0.0-alpha.1","npm_package_devDependencies__storybook_addons":"6.2.9","npm_package_scripts_test":"PELO_PLATFORM=rdk APP_ENV=test node scripts/test --config=config/jest/config.js","GITHUB_REPOSITORY_ID":"2571","GITHUB_ACTIONS":"true","GOPROXY":"https://goproxy.services.bedrock.tech","NODE_PATH":"/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.pnpm/@pelo+cli@10.0.0-alpha.1_@babel+core@7.27.4_@swc+core@1.3.95_@swc+helpers@0.5.3__@types+webpa_eyh3qr2suoq7louvyapz62n3cq/node_modules/@pelo/cli/bin/node_modules:/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.pnpm/@pelo+cli@10.0.0-alpha.1_@babel+core@7.27.4_@swc+core@1.3.95_@swc+helpers@0.5.3__@types+webpa_eyh3qr2suoq7louvyapz62n3cq/node_modules/@pelo/cli/node_modules:/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.pnpm/@pelo+cli@10.0.0-alpha.1_@babel+core@7.27.4_@swc+core@1.3.95_@swc+helpers@0.5.3__@types+webpa_eyh3qr2suoq7louvyapz62n3cq/node_modules/@pelo/node_modules:/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.pnpm/@pelo+cli@10.0.0-alpha.1_@babel+core@7.27.4_@swc+core@1.3.95_@swc+helpers@0.5.3__@types+webpa_eyh3qr2suoq7louvyapz62n3cq/node_modules:/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.pnpm/node_modules:/home/runner/setup-pnpm/node_modules/.pnpm/pnpm@9.14.4/node_modules/pnpm/bin/node_modules:/home/runner/setup-pnpm/node_modules/.pnpm/pnpm@9.14.4/node_modules/pnpm/node_modules:/home/runner/setup-pnpm/node_modules/.pnpm/pnpm@9.14.4/node_modules:/home/runner/setup-pnpm/node_modules/.pnpm/node_modules","npm_package_repository_url":"https://github.m6web.fr/m6web/app-bedrock-rdk.git","npm_package_version":"1.51.2","npm_package_dependencies__bedrock_ad_engine":"5.39.0","npm_package_devDependencies__m6web_eslint_plugin_i18n":"2.0.1","npm_package_devDependencies_jest_environment_jsdom":"29.5.0","npm_package_scripts_storybook_rtlhu":"APP_CUSTOMER=rtlhu start-storybook -p 6006","npm_package_pnpm_overrides__lightningjs_sdk":"5.5.5","npm_lifecycle_event":"build","ACTIONS_RUNNER_HOOK_JOB_COMPLETED":"/etc/arc/hooks/job-completed.sh","GITHUB_REF_PROTECTED":"true","GONOSUMDB":"github.m6web.fr","GONOPROXY":"none","npm_package_dependencies_uuid":"10.0.0","npm_package_scripts_build":"pelo build \"magenta\" \"--skip-native-build\"","npm_package_scripts_upload":"node scripts/uploadToMetrologicalAppStore","GITHUB_WORKSPACE":"/runner/_work/app-bedrock-rdk/app-bedrock-rdk","GITHUB_JOB":"build_and_deploy","npm_package_author":"Bedrock","npm_package_engines_pnpm":"9.x.x","npm_package_dependencies__bedrock_youbora_adapter_adengine":"1.9.9","npm_package_dependencies_lodash":"4.17.21","npm_package_devDependencies_cypress":"13.3.0","npm_package_devDependencies_http_server":"14.1.1","npm_package_scripts_test_coverage":"PELO_PLATFORM=rdk APP_ENV=test node scripts/test --config=config/jest/config.js --coverage","GITHUB_SHA":"ab23f250364979d926e7565a2779bba0daadf009","GOMAXPROC":"8","GITHUB_RUN_ATTEMPT":"1","DOCKER_HOST":"unix:///run/docker.sock","npm_package_dependencies__bedrock_media_engine":"4.17.1","npm_package_devDependencies__pelo_cli":"10.0.0-alpha.1","KUBERNETES_SERVICE_PORT_HTTPS":"443","GOPRIVATE":"*.m6web.fr,*.bedrock.tech","GITHUB_REF":"refs/heads/master","KUBERNETES_PORT_443_TCP":"tcp://[fd24:3fac:1f16::1]:443","GITHUB_ACTOR":"skovalchuk-externe","npm_package_license":"UNLICENSED","npm_package_dependencies_markdown_it":"12.2.0","DOCKERD_IN_RUNNER":"false","npm_package_dependencies_crypto_js":"4.2.0","npm_package_dependencies_qrcode":"1.5.4","npm_package_dependencies_stream_browserify":"3.0.0","npm_package_devDependencies_eslint_plugin_prettier":"5.0.0","npm_package_scripts_format":"pnpm format:js && pnpm format:md && pnpm format:lang","npm_package_scripts_update_lang":"run-s 'i18n:pull {1}' format:lang --","GITHUB_PATH":"/runner/_work/_temp/_runner_file_commands/add_path_1aea6be7-8451-44d1-976b-920c5fab1345","PWD":"/runner/_work/app-bedrock-rdk/app-bedrock-rdk","IS_STAGING":"false","APP_ENV":"prod","GITHUB_ACTOR_ID":"627","KUBERNETES_SERVICE_HOST":"fd24:3fac:1f16::1","RUNNER_WORKSPACE":"/runner/_work/app-bedrock-rdk","npm_package_dependencies_path_to_regexp":"3.0.0","npm_package_scripts_explore":"source-map-explorer build/static/js/main.*","npm_package_scripts_format_tf":"terraform fmt -recursive -write=true .cloud/terraform","npm_execpath":"/home/runner/setup-pnpm/node_modules/.pnpm/pnpm@9.14.4/node_modules/pnpm/bin/pnpm.cjs","GITHUB_EVENT_NAME":"workflow_dispatch","GITHUB_SERVER_URL":"https://github.m6web.fr","GITHUB_OUTPUT":"/runner/_work/_temp/_runner_file_commands/set_output_1aea6be7-8451-44d1-976b-920c5fab1345","npm_package_dependencies__bedrock_rdk_config":"workspace:*","npm_package_devDependencies__pelo_platforms_kpn":"10.0.0-alpha.1","npm_package_devDependencies_es_check":"7.1.1","npm_package_devDependencies_fs_extra":"9.1.0","npm_package_devDependencies_swc_mut_cjs_exports":"0.86.17","RUNNER_STATUS_UPDATE_HOOK":"false","npm_package_dependencies_browser_cookies":"1.2.0","npm_package_dependencies_date_fns":"2.28.0","npm_package_devDependencies__badeball_cypress_cucumber_preprocessor":"18.0.6","npm_package_devDependencies_svgo_loader":"3.0.1","npm_package_scripts_build_storybook":"build-storybook -o dist-storybook","npm_command":"run-script","PNPM_SCRIPT_SRC_DIR":"/runner/_work/app-bedrock-rdk/app-bedrock-rdk","APP_CUSTOMER":"rtlde","npm_package_dependencies_storybook_addon_themes":"6.1.0","npm_package_devDependencies__storybook_addon_essentials":"6.2.9","npm_package_scripts_format_js":"prettier-eslint --write $PWD/'src/**/*.js' $PWD/'packages/**/*.js' $PWD/'platforms/**/*.js' $PWD/'config/**/*.js'","PNPM_HOME":"/home/runner/setup-pnpm/node_modules/.bin","RUNNER_ENTERPRISE":"","npm_package_dependencies__tornado_rdk_typography":"workspace:*","GITHUB_STEP_SUMMARY":"/runner/_work/_temp/_runner_file_commands/step_summary_1aea6be7-8451-44d1-976b-920c5fab1345","npm_package_dependencies__lightningjs_sdk":"5.5.5","npm_package_dependencies__pelo_plugins_keys":"workspace:*","npm_package_devDependencies_swc_loader":"0.2.3","npm_package_devDependencies_swc_minify_webpack_plugin":"2.1.1","npm_package_scripts_build_rtlde":"APP_CUSTOMER=rtlde pnpm build","npm_package_scripts_format_lang":"prettier-eslint --write $PWD/'lang/**/*.json'","npm_package_pnpm_overrides_webpack":"5.88.2","npm_package_pnpm_peerDependencyRules_allowedVersions_webpack":"5","INIT_CWD":"/runner/_work/app-bedrock-rdk/app-bedrock-rdk","NODE_ENV":"production"}.APP_CUSTOMER || DEFAULT_APP_CUSTOMER;
var appPlatform = "magenta";
var isDevelopmentApp = appEnv === DEVELOPMENT;
var isDetectiveApp = appEnv === DETECTIVE;
var isStagingApp = appEnv === STAGING;
var isProdApp = appEnv === PROD;
var isTestApp = appEnv === TEST;
module.exports = {
    appCustomer: appCustomer,
    appEnv: appEnv,
    appPlatform: appPlatform,
    appVersion: appVersion,
    isDetectiveApp: isDetectiveApp,
    isDevelopmentApp: isDevelopmentApp,
    isProdApp: isProdApp,
    isStagingApp: isStagingApp,
    isTestApp: isTestApp
};


/***/ }),

/***/ 54948:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/** @module errorUtils */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    throwErrorOrNothing: function() {
        return throwErrorOrNothing;
    },
    throwErrorOrReturnValue: function() {
        return throwErrorOrReturnValue;
    }
});
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(42578);
var throwErrorOrNothing = function(shouldThrow, errorMessage) {
    if (shouldThrow) {
        throw new Error(errorMessage);
    }
};
var throwErrorOrReturnValue = function(shouldThrow, errorMessage, value) {
    if (shouldThrow) {
        throw new Error(errorMessage);
    }
    return value;
};


/***/ }),

/***/ 32258:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/** @module eventUtils */ /**
 * Create a custom Event and dispatch it with some associated data
 *
 * @function
 * @param {string} name The event label-name
 * @param {object} detail the data associated with the event
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "createAndDispatchEvent", ({
    enumerable: true,
    get: function() {
        return createAndDispatchEvent;
    }
}));
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
var createAndDispatchEvent = function(name, detail) {
    return window.dispatchEvent(new CustomEvent(name, {
        detail: detail
    }));
};


/***/ }),

/***/ 73651:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    getHomeId: function() {
        return _homeIdutils.getHomeId;
    },
    getPubId: function() {
        return _homeIdutils.getPubId;
    }
});
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(52318);
var _homeIdutils = __webpack_require__(71485);


/***/ }),

/***/ 40057:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/** @module httpUtils */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    httpRequestTimeout: function() {
        return httpRequestTimeout;
    },
    requestGet: function() {
        return requestGet;
    },
    requestPost: function() {
        return requestPost;
    }
});
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(3009);
var _superagent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(54247));
var _src = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67958));
var httpRequestTimeout = 5000;
var getRequestLogger = function() {
    var debug = _src.default.debug;
    var requestLogger = function(x) {
        return x;
    };
    if (debug) {
        requestLogger = function(requestHandler) {
            return requestHandler.on("response", function(response) {
                /* eslint-disable no-console */ console.log("".concat(requestHandler.method, " ").concat(response.status, " ").concat(requestHandler.url));
            });
        };
    }
    return requestLogger;
};
var requestGet = function(path) {
    var query = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, headers = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, timeout = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : httpRequestTimeout;
    return _superagent.default.get(path).set(headers).use(getRequestLogger).query(query).timeout(timeout);
};
var requestPost = function(path, body) {
    var query = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, headers = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, timeout = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : httpRequestTimeout;
    return _superagent.default.post(path).set(headers).use(getRequestLogger).query(query).send(body).timeout(timeout);
};


/***/ }),

/***/ 12119:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "getImageKeyFromRole", ({
    enumerable: true,
    get: function() {
        return getImageKeyFromRole;
    }
}));
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(52318);
var getImageKeyFromRole = function(images, role, currentKey, defaultKey) {
    if (currentKey && currentKey !== defaultKey) {
        return currentKey;
    }
    var image = images.find(function(img) {
        return img.role === role;
    });
    return image ? image.external_key : defaultKey;
};


/***/ }),

/***/ 64188:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    deviceId: function() {
        return _deviceId.default;
    },
    logger: function() {
        return _debug.default;
    },
    storage: function() {
        return _storage.platformStorage;
    }
});
var _export_star = __webpack_require__(37668);
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(3009);
var _debug = /*#__PURE__*/ _interop_require_default._(__webpack_require__(73724));
var _deviceId = /*#__PURE__*/ _interop_require_default._(_export_star._(__webpack_require__(8163), exports));
var _storage = _export_star._(__webpack_require__(23939), exports);
_export_star._(__webpack_require__(45479), exports);
_export_star._(__webpack_require__(5188), exports);
_export_star._(__webpack_require__(19561), exports);
_export_star._(__webpack_require__(54948), exports);
_export_star._(__webpack_require__(32258), exports);
_export_star._(__webpack_require__(73651), exports);
_export_star._(__webpack_require__(40057), exports);
_export_star._(__webpack_require__(12119), exports);
_export_star._(__webpack_require__(38659), exports);
_export_star._(__webpack_require__(9821), exports);
_export_star._(__webpack_require__(80550), exports);
_export_star._(__webpack_require__(77735), exports);
_export_star._(__webpack_require__(72541), exports);
_export_star._(__webpack_require__(25763), exports);
_export_star._(__webpack_require__(24713), exports);
_export_star._(__webpack_require__(60942), exports);
_export_star._(__webpack_require__(14281), exports);
_export_star._(__webpack_require__(65471), exports);


/***/ }),

/***/ 38659:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/** @module objectUtils */ /**
 * Is value an object?
 *
 * @function
 * @param {*} value
 * @returns {boolean}
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    areFieldsMissing: function() {
        return areFieldsMissing;
    },
    deepClone: function() {
        return deepClone;
    },
    getFilteredObject: function() {
        return getFilteredObject;
    },
    getObjectWithLowerCasedAttributes: function() {
        return getObjectWithLowerCasedAttributes;
    },
    isObject: function() {
        return isObject;
    }
});
var _define_property = __webpack_require__(21228);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _sliced_to_array = __webpack_require__(28966);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(37815);
var isObject = function(value) {
    return typeof value === "object" && value === Object(value) && !Array.isArray(value);
};
var getObjectWithLowerCasedAttributes = function(object) {
    return Object.keys(object).reduce(function(lowerCasedObject, attribute) {
        return _object_spread_props._(_object_spread._({}, lowerCasedObject), _define_property._({}, attribute.toLowerCase(), object[attribute]));
    }, {});
};
var getFilteredObject = function(object) {
    var excludedValues = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [
        undefined,
        null,
        false,
        NaN
    ];
    return Object.entries(object).filter(function(param) {
        var _param = _sliced_to_array._(param, 2), value = _param[1];
        return !excludedValues.includes(value);
    }).reduce(function(memo, param) {
        var _param = _sliced_to_array._(param, 2), key = _param[0], value = _param[1];
        return _object_spread_props._(_object_spread._({}, memo), _define_property._({}, key, value));
    }, {});
};
var deepClone = function(object) {
    return JSON.parse(JSON.stringify(object));
};
var areFieldsMissing = function(fields, opts) {
    return !fields.every(function(key) {
        return Object.keys(opts).includes(key);
    });
};


/***/ }),

/***/ 9821:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/** @module paginationUtils */ /**
 * Is the current item the last of the penultimate page
 *
 * @param {number} itemIndex
 * @param {number} itemsPerPage
 * @param {number} nextPageIndex
 * @returns {boolean}
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "isPenultimatePageLastItem", ({
    enumerable: true,
    get: function() {
        return isPenultimatePageLastItem;
    }
}));
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(3009);
var isPenultimatePageLastItem = function(itemIndex, itemsPerPage, nextPageIndex) {
    return itemIndex + 1 === (nextPageIndex - 2) * itemsPerPage;
};


/***/ }),

/***/ 80550:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    CSA_PICTO_INDEX: function() {
        return CSA_PICTO_INDEX;
    },
    LOCK_PICTO_INDEX: function() {
        return LOCK_PICTO_INDEX;
    },
    SERVICE_PICTO_INDEX: function() {
        return SERVICE_PICTO_INDEX;
    },
    getCSAPicto: function() {
        return getCSAPicto;
    },
    getLockPicto: function() {
        return getLockPicto;
    },
    getServicePicto: function() {
        return getServicePicto;
    }
});
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(42578);
var CSA_PICTO_INDEX = 1;
var SERVICE_PICTO_INDEX = 2;
var LOCK_PICTO_INDEX = 4;
var getCSAPicto = function(pictos) {
    return pictos && pictos[CSA_PICTO_INDEX];
};
var getServicePicto = function(pictos) {
    return pictos && pictos[SERVICE_PICTO_INDEX];
};
var getLockPicto = function(pictos) {
    return pictos && pictos[LOCK_PICTO_INDEX];
};


/***/ }),

/***/ 71485:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    getHomeId: function() {
        return getHomeId;
    },
    getPubId: function() {
        return getPubId;
    }
});
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(52318);
var getHomeId = function() {
    return null;
};
var getPubId = function() {
    return null;
};


/***/ }),

/***/ 77735:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/** @module arrayUtils */ /**
 *  renderTimes: render n times the render function passed in arguments
 *
 *  example :
 *
 *  ```
 *    <div>
 *      {renderTimes(9, index => <span key={index}>Nan</span>)}
 *      Batman!
 *    </div>
 *  ```
 *
 *  // will produce
 *  Nan Nan Nan Nan Nan Nan Nan Nan Nan Batman!
 *  ```
 * @function
 * @param {number} iterations
 * @param {function} render
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "renderTimes", ({
    enumerable: true,
    get: function() {
        return renderTimes;
    }
}));
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
function renderTimes(iterations, render) {
    if (!Number.isInteger(iterations)) {
        throw Error("First argument of renderTimes() should be an integer.");
    }
    return Array(iterations).fill(null).map(function(value, index) {
        return render(index);
    });
}


/***/ }),

/***/ 72541:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "getStoredValueFor", ({
    enumerable: true,
    get: function() {
        return getStoredValueFor;
    }
}));
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(88801);
var _error = __webpack_require__(54948);
var getStoredValueFor = function(state) {
    return function(key, reducer) {
        (0, _error.throwErrorOrReturnValue)(state[reducer][key] === undefined, 'This key "'.concat(key, '" does not exist in the "').concat(reducer, '" store'), state[reducer][key]);
    };
};


/***/ }),

/***/ 23939:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _export_star = __webpack_require__(37668);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(45538);
_export_star._(__webpack_require__(90284), exports);


/***/ }),

/***/ 23032:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    isStorageSupported: function() {
        return isStorageSupported;
    },
    platformStorage: function() {
        return platformStorage;
    }
});
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(42578);
var _sdk = __webpack_require__(29956);
var TEST_KEY = "storage";
var TEST_VALUE = "item";
var expirationTimestamp = Date.now() + 365 * 24 * 60 * 60 * 1000;
var maxExpirationTimestamp = 2147483647000;
var expirationDate = function(shouldExpire) {
    return shouldExpire ? expirationTimestamp : maxExpirationTimestamp;
};
var LightningSdkStorage = /*#__PURE__*/ function() {
    "use strict";
    function LightningSdkStorage() {
        _class_call_check._(this, LightningSdkStorage);
        this._storage = _sdk.Storage;
    }
    _create_class._(LightningSdkStorage, [
        {
            key: "getItem",
            value: function getItem(key) {
                var _ref = this._storage.get(key) || {}, _ref_value = _ref.value, value = _ref_value === void 0 ? null : _ref_value, _ref_expires = _ref.expires, expires = _ref_expires === void 0 ? null : _ref_expires;
                var currentTime = Date.now();
                if (expires && currentTime > expires) {
                    this._storage.remove(key);
                    return null;
                }
                return value;
            }
        },
        {
            key: "getItems",
            value: function getItems() {
                var keys = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
                var _this = this;
                return keys.reduce(function(acc, key) {
                    var value = _this.getItem(key);
                    return _object_spread_props._(_object_spread._({}, acc), _define_property._({}, key, value));
                }, {});
            }
        },
        {
            key: "setItem",
            value: function setItem(key, value) {
                var expire = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
                var newStorageItem = {
                    value: value,
                    expires: expirationDate(expire)
                };
                this._storage.set(key, newStorageItem);
                return value;
            }
        },
        {
            key: "setItems",
            value: function setItems() {
                var items = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, expire = arguments.length > 1 ? arguments[1] : void 0;
                var _this = this;
                Object.keys(items).forEach(function(key) {
                    _this.setItem(key, items[key], expire);
                });
                return items;
            }
        },
        {
            key: "removeItem",
            value: function removeItem(key) {
                this._storage.remove(key);
                return null;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this._storage.clear();
                return null;
            }
        }
    ]);
    return LightningSdkStorage;
}();
var isStorageSupported = function(storage) {
    try {
        storage.setItem(TEST_KEY, TEST_VALUE);
        var storageItem = storage.getItem(TEST_KEY);
        storage.removeItem(TEST_KEY);
        return storageItem === TEST_VALUE;
    } catch (e) {
        throw new Error(e);
    }
};
var platformStorage = new LightningSdkStorage();


/***/ }),

/***/ 90284:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _export_star = __webpack_require__(37668);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
_export_star._(__webpack_require__(23032), exports);


/***/ }),

/***/ 25763:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    cutInLines: function() {
        return cutInLines;
    },
    prefixWithOn: function() {
        return prefixWithOn;
    },
    removeGivenTextFromString: function() {
        return removeGivenTextFromString;
    },
    ucfirst: function() {
        return ucfirst;
    }
});
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(52318);
var prefixWithOn = function(text) {
    return "on".concat(text.charAt(0).toUpperCase() + text.slice(1));
};
var removeGivenTextFromString = function(string, givenText) {
    return string ? string.replace(givenText, "") : null;
};
var cutInLines = function(string, maxLengthByLine) {
    if (!string) {
        return "";
    }
    return string.split(" ").reduce(function(acc, part) {
        if (!acc.length) {
            return [
                part
            ];
        }
        var currentLineLength = acc[acc.length - 1].length;
        if (currentLineLength + part.length < maxLengthByLine) {
            acc[acc.length - 1] = "".concat(acc[acc.length - 1], " ").concat(part);
        } else {
            acc[acc.length] = part;
        }
        return acc;
    }, []);
};
var ucfirst = function(str) {
    return "".concat(str.charAt(0).toUpperCase()).concat(str.slice(1));
};


/***/ }),

/***/ 24713:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    expectDispatchActionWithType: function() {
        return expectDispatchActionWithType;
    },
    genericActionCreator: function() {
        return genericActionCreator;
    },
    getMockedStore: function() {
        return getMockedStore;
    },
    renameObjectKeys: function() {
        return renameObjectKeys;
    }
});
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _object_spread = __webpack_require__(76247);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(88801);
var genericActionCreator = function(type) {
    var payload = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return _object_spread._({
        type: type
    }, payload);
};
var renameObjectKeys = function(object, keys, newKeys) {
    var updatedObject = _object_spread._({}, object);
    keys.forEach(function(currentKeys, index) {
        updatedObject[newKeys[index]] = object[currentKeys];
        delete updatedObject[currentKeys];
    });
    return updatedObject;
};
var expectDispatchActionWithType = function(dispatch, type) {
    expect(dispatch).toBeCalledWith(expect.objectContaining({
        type: type
    }));
};
var MockedStore = /*#__PURE__*/ function() {
    "use strict";
    function MockedStore(defaultState) {
        _class_call_check._(this, MockedStore);
        this.currentState = defaultState;
        this.dispatch = jest.fn();
    }
    _create_class._(MockedStore, [
        {
            key: "getState",
            value: function getState() {
                return this.currentState;
            }
        }
    ]);
    return MockedStore;
}();
var getMockedStore = function(defaultState) {
    return new MockedStore(defaultState);
};


/***/ }),

/***/ 60942:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/** @module timeUtils */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ceilValue: function() {
        return ceilValue;
    },
    clearTimeouts: function() {
        return clearTimeouts;
    },
    differenceInMinutes: function() {
        return differenceInMinutes;
    },
    differenceInMs: function() {
        return differenceInMs;
    },
    differenceInSeconds: function() {
        return differenceInSeconds;
    },
    fixedClamp: function() {
        return fixedClamp;
    },
    floorValue: function() {
        return floorValue;
    },
    get6PlayTime: function() {
        return get6PlayTime;
    },
    getCurrentTimeInSeconds: function() {
        return getCurrentTimeInSeconds;
    },
    getElapsedTime: function() {
        return getElapsedTime;
    },
    getMsTimestamp: function() {
        return getMsTimestamp;
    },
    getPercentageOfClipTime: function() {
        return getPercentageOfClipTime;
    },
    getPercentageOfTime: function() {
        return getPercentageOfTime;
    },
    getTimeFormat: function() {
        return getTimeFormat;
    },
    getTimestamp: function() {
        return getTimestamp;
    },
    isInStartoverTimeSlot: function() {
        return isInStartoverTimeSlot;
    },
    timeTitleToSeconds: function() {
        return timeTitleToSeconds;
    },
    toFixedValue: function() {
        return toFixedValue;
    },
    toSeconds: function() {
        return toSeconds;
    },
    videoElapsedTime: function() {
        return videoElapsedTime;
    },
    withLeadingZero: function() {
        return withLeadingZero;
    }
});
var _async_to_generator = __webpack_require__(24146);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(42578);
var _fidosdk = __webpack_require__(5225);
var differenceInSeconds = function(timestampEnd, timestampStart) {
    return timestampEnd - timestampStart;
};
var differenceInMinutes = function(timestampEnd, timestampStart) {
    return (timestampEnd - timestampStart) / 60;
};
var differenceInMs = function(timestampEnd, timestampStart) {
    return (timestampEnd - timestampStart) * 1000;
};
var getElapsedTime = function() {
    return Math.floor(performance.now());
};
var toSeconds = function(msValue) {
    return msValue / 1000;
};
var toMs = function(valueInSeconds) {
    return valueInSeconds * 1000;
};
var secondsToHours = function(valueInSeconds) {
    return valueInSeconds / 3600;
};
var secondsToMinutes = function(valueInSeconds) {
    return valueInSeconds / 60 % 60;
};
var secondsRemainder = function(valueInSeconds) {
    return valueInSeconds % 60;
};
var floorValue = function(value) {
    return Math.floor(value);
};
var ceilValue = function(value) {
    return Math.ceil(value);
};
var toFixedValue = function(value) {
    return parseFloat(value.toFixed(2));
};
var fixedClamp = function(value, min, max) {
    var fixedValue = toFixedValue(value);
    if (fixedValue < min) {
        return min;
    }
    if (fixedValue > max) {
        return max;
    }
    return fixedValue;
};
var getTimestamp = function(serverTime, initialElapsedTime) {
    return floorValue(serverTime + toSeconds(getElapsedTime() - initialElapsedTime));
};
var getMsTimestamp = function(serverTime, initialElapsedTime) {
    return floorValue(toMs(serverTime) + (getElapsedTime() - initialElapsedTime));
};
var get6PlayTime = function() {
    var _ref = _async_to_generator._(function() {
        var serverTime, err;
        return _ts_generator._(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        _fidosdk.timeService.fetch()
                    ];
                case 1:
                    serverTime = _state.sent();
                    if (!serverTime || typeof serverTime.timestamp !== "number") {
                        throw new Error("Invalid timestamp");
                    }
                    return [
                        2,
                        serverTime.timestamp
                    ];
                case 2:
                    err = _state.sent();
                    throw new Error("Unable to retrieve server time: ".concat(err.message));
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function get6PlayTime() {
        return _ref.apply(this, arguments);
    };
}();
var getPercentageOfTime = function(param) {
    var timestampStart = param.timestampStart, timestampEnd = param.timestampEnd, serverTime = param.serverTime, initialElapsedTime = param.initialElapsedTime;
    var currentTime = getTimestamp(serverTime, initialElapsedTime);
    var programLength = timestampEnd - timestampStart;
    var timePassed = currentTime - timestampStart;
    var percentageOfProgram = timePassed / programLength * 100;
    return percentageOfProgram >= 0 ? percentageOfProgram : 0;
};
var getPercentageOfClipTime = function(elapsedTime, clipDuration) {
    var percentageOfClip = elapsedTime / clipDuration * 100;
    return percentageOfClip >= 0 ? percentageOfClip : 0;
};
var withLeadingZero = function(value) {
    return "".concat(value < 10 ? "0" : "").concat(value);
};
var getTimeFormat = function(timestamp) {
    if (!Number.isFinite(timestamp)) {
        return "";
    }
    if (timestamp < 0) return "00:00";
    var hours = floorValue(secondsToHours(timestamp));
    var minutes = floorValue(secondsToMinutes(timestamp));
    var seconds = secondsRemainder(timestamp);
    if (timestamp >= 3600) {
        return "".concat(hours, ":").concat(withLeadingZero(minutes), ":").concat(withLeadingZero(seconds));
    }
    return "".concat(withLeadingZero(minutes), ":").concat(withLeadingZero(seconds));
};
var timeUnitsMultipliers = [
    1,
    60,
    3600
];
var timeTitleToSeconds = function(title) {
    return title ? title.split(":").reverse().slice(0, timeUnitsMultipliers.length).reduce(function(result, current, index) {
        return result + parseInt(current, 10) * timeUnitsMultipliers[index];
    }, 0) : 0;
};
var isInStartoverTimeSlot = function(param) {
    var timestampStartPreroll = param.timestampStartPreroll, timestampEndPreroll = param.timestampEndPreroll, timestampStart = param.timestampStart, timestampEnd = param.timestampEnd, initialElapsedTime = param.initialElapsedTime, serverTime = param.serverTime, startoverMinDepth = param.startoverMinDepth, startoverMaxDepth = param.startoverMaxDepth, startoverMinPercentage = param.startoverMinPercentage, startoverMaxPercentage = param.startoverMaxPercentage;
    var currentTime = getTimestamp(serverTime, initialElapsedTime);
    // Verify if we are still in preroll
    if (currentTime < timestampEndPreroll) {
        return false;
    }
    var programLength = timestampEnd - timestampStart;
    var lowestTimeAllowed = timestampStart + programLength * startoverMinPercentage / 100;
    var highestTimeAllowed = timestampStart + programLength * startoverMaxPercentage / 100;
    // is the clip long enough to be eligible
    if (differenceInMinutes(timestampEnd, timestampStart) < startoverMinDepth) {
        return false;
    }
    // is the max depth to start over reached already
    if (differenceInMinutes(currentTime, timestampStartPreroll) >= startoverMaxDepth) {
        return false;
    }
    // is it the good time in the clip to start over
    if (currentTime < lowestTimeAllowed || currentTime > highestTimeAllowed) {
        return false;
    }
    // we are in the startover established time slot
    return true;
};
var clearTimeouts = function(timeoutIds) {
    timeoutIds.forEach(clearTimeout);
};
var videoElapsedTime = function(currentTime, startTime) {
    return Math.max(Math.round(currentTime - startTime), 0);
};
var getCurrentTimeInSeconds = function() {
    return Math.floor(Date.now() / 1000);
};


/***/ }),

/***/ 14281:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    deleteSetTimeoutSubscriptionByKey: function() {
        return deleteSetTimeoutSubscriptionByKey;
    },
    resetSetTimeoutByKey: function() {
        return resetSetTimeoutByKey;
    }
});
var _interop_require_default = __webpack_require__(81200);
var _to_consumable_array = __webpack_require__(30005);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(88801);
var _isString = /*#__PURE__*/ _interop_require_default._(__webpack_require__(56549));
var _isFunction = /*#__PURE__*/ _interop_require_default._(__webpack_require__(92042));
var _isNumber = /*#__PURE__*/ _interop_require_default._(__webpack_require__(59933));
/**
 * setTimeout subscriptions dictionary
 * @type {Object}
 */ var subscriptions = {};
var resetSetTimeoutByKey = function(key, callback, time) {
    for(var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++){
        args[_key - 3] = arguments[_key];
    }
    if (!(0, _isString.default)(key) || !(0, _isFunction.default)(callback) || !(0, _isNumber.default)(time)) {
        return;
    }
    var subscription = subscriptions[key];
    if (subscription) {
        clearTimeout(subscription);
    }
    subscriptions[key] = setTimeout.apply(void 0, [
        callback,
        time
    ].concat(_to_consumable_array._(args)));
};
var deleteSetTimeoutSubscriptionByKey = function(key) {
    clearTimeout(subscriptions[key]);
};


/***/ }),

/***/ 65471:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/** @module videoUtils */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "isMp4", ({
    enumerable: true,
    get: function() {
        return isMp4;
    }
}));
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(52318);
var fileTypes = {
    MP4: [
        "mp4",
        "MP4"
    ]
};
/**
 * @function
 * @param {string[]} fileExtensions
 * @returns {RegExp}
 */ var buildFileExtensionsRegex = function(fileExtensions) {
    return new RegExp("\\.(".concat(fileExtensions.join("|"), ")$"));
};
var isMp4 = function(fileName) {
    return buildFileExtensionsRegex(fileTypes.MP4).test(fileName);
};


/***/ }),

/***/ 81345:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    controlUpdates: function() {
        return _control.controlUpdates;
    },
    default: function() {
        return _default;
    }
});
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(88801);
var _control = __webpack_require__(44474);
var Store = /*#__PURE__*/ function() {
    "use strict";
    function Store() {
        var _this = this;
        _class_call_check._(this, Store);
        _define_property._(this, "cleanup", function() {
            _this._subscriptions.forEach(function(unsubscribe) {
                unsubscribe();
            });
            _this.dispatch = null;
            _this.getState = null;
            _this.subscribe = null;
            _this.replaceReducers = null;
            _this._subscriptions = [];
        });
    }
    _create_class._(Store, [
        {
            key: "init",
            value: function init(param) {
                var dispatch = param.dispatch, getState = param.getState, subscribe = param.subscribe, replaceReducer = param.replaceReducer;
                this.dispatch = dispatch;
                this.getState = getState;
                this.subscribe = subscribe;
                this.replaceReducers = replaceReducer;
                this._subscriptions = [];
            }
        },
        {
            key: "control",
            value: function control(controllers) {
                var _this = this;
                return function(instance) {
                    var controllersToSubscribe = controllers(instance);
                    // Allow components to receive Redux state on connect
                    var state = _this.getState();
                    var orderControllers = Array.isArray(controllersToSubscribe) ? controllersToSubscribe : Object.values(controllersToSubscribe);
                    orderControllers.forEach(function(param) {
                        var selector = param.selector, callback = param.callback, shouldBeInvokedOnConnect = param.shouldBeInvokedOnConnect;
                        if (shouldBeInvokedOnConnect && callback && selector) {
                            callback(selector(state));
                        }
                    });
                    var unsubscribe = _this.subscribe((0, _control.controlUpdates)(controllersToSubscribe, _this.getState));
                    var result = function() {
                        var keys = Object.keys(controllers);
                        for(var i = 0; i < keys.length; i += 1){
                            var controller = controllers[keys[i]];
                            controller._previousProp = undefined;
                        }
                        _this._subscriptions = _this._subscriptions.filter(function(subscription) {
                            return subscription !== result;
                        });
                        unsubscribe();
                    };
                    _this._subscriptions.push(result);
                    return result;
                };
            }
        }
    ]);
    return Store;
}();
var _default = new Store();


/***/ }),

/***/ 44474:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    CALLBACK_ERROR: function() {
        return CALLBACK_ERROR;
    },
    PREDICATE_ERROR: function() {
        return PREDICATE_ERROR;
    },
    SELECTOR_ERROR: function() {
        return SELECTOR_ERROR;
    },
    controlUpdates: function() {
        return controlUpdates;
    }
});
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(3009);
var CALLBACK_ERROR = "An error occurred while executing your controller's callback";
var SELECTOR_ERROR = "An error occurred inside your controller's selector";
var PREDICATE_ERROR = "An error occurred inside your controller's predicate";
var defaultCondition = function(param) {
    var currentProp = param.currentProp, previousProp = param.previousProp;
    return currentProp !== previousProp;
};
var controlUpdates = function(controllers, getState) {
    return function() {
        var state = getState();
        var keys = Object.keys(controllers);
        for(var i = 0; i < keys.length; i += 1){
            var controller = controllers[keys[i]];
            var condition = controller.condition, selector = controller.selector, callback = controller.callback, _previousProp = controller._previousProp;
            var predicate = condition || defaultCondition;
            var currentProp = void 0;
            try {
                currentProp = selector(state);
            } catch (error) {
                throw new Error("".concat(SELECTOR_ERROR, ' "').concat(keys[i], '": ').concat(error.stack));
            }
            var shouldUpdate = void 0;
            try {
                shouldUpdate = predicate({
                    previousProp: _previousProp,
                    currentProp: currentProp
                });
            } catch (error) {
                throw new Error("".concat(PREDICATE_ERROR, ' "').concat(keys[i], '": ').concat(error.stack));
            }
            if (shouldUpdate) {
                controller._previousProp = currentProp;
                callback(currentProp);
            }
        }
    };
};


/***/ }),

/***/ 34670:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    deviceInfo: function() {
        return deviceInfo;
    },
    getBrand: function() {
        return _device.getBrand;
    },
    getDeviceId: function() {
        return _device.getDeviceId;
    },
    getDeviceType: function() {
        return _device.getDeviceType;
    },
    getModel: function() {
        return _device.getModel;
    },
    getModelCode: function() {
        return _device.getModelCode;
    },
    getVersion: function() {
        return _device.getVersion;
    }
});
var _async_to_generator = __webpack_require__(24146);
var _interop_require_default = __webpack_require__(81200);
var _sliced_to_array = __webpack_require__(28966);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(3009);
var _lodash = /*#__PURE__*/ _interop_require_default._(__webpack_require__(32699));
var _device = __webpack_require__(75298);
/**
 * Retrieve all infos of the given device
 *
 * @async
 * @throws
 * @return {Object}
 */ var getAllDeviceInfo = function() {
    var _ref = _async_to_generator._(function() {
        var _ref, brand, deviceId, deviceType, model, modelCode, version;
        return _ts_generator._(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        Promise.allSettled([
                            (0, _device.getBrand)(),
                            (0, _device.getDeviceId)(),
                            (0, _device.getDeviceType)(),
                            (0, _device.getModel)(),
                            (0, _device.getModelCode)(),
                            (0, _device.getVersion)()
                        ])
                    ];
                case 1:
                    _ref = _sliced_to_array._.apply(void 0, [
                        _state.sent(),
                        6
                    ]), brand = _ref[0], deviceId = _ref[1], deviceType = _ref[2], model = _ref[3], modelCode = _ref[4], version = _ref[5];
                    return [
                        2,
                        _lodash.default.mapValues({
                            brand: brand,
                            deviceId: deviceId,
                            deviceType: deviceType,
                            model: model,
                            modelCode: modelCode,
                            version: version
                        }, function(promiseSettledValue, key) {
                            if (promiseSettledValue.status === "fulfilled") {
                                return promiseSettledValue.value;
                            }
                            // eslint-disable-next-line no-console
                            console.warn("Getting ".concat(key, " failed"), promiseSettledValue.reason);
                            return "";
                        })
                    ];
            }
        });
    });
    return function getAllDeviceInfo() {
        return _ref.apply(this, arguments);
    };
}();
var deviceInfo = {
    getBrand: _device.getBrand,
    getDeviceId: _device.getDeviceId,
    getDeviceType: _device.getDeviceType,
    getModel: _device.getModel,
    getModelCode: _device.getModelCode,
    getVersion: _device.getVersion,
    getAllDeviceInfo: getAllDeviceInfo
};


/***/ }),

/***/ 75298:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/**
 *  https://lightningjs.io/docs/#/lightning-sdk-reference/plugins/profile
 */ /**
 * Get the Tv Brand, temporary hard coded brand, currently is not implemented
 * @returns {string}
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    getBrand: function() {
        return getBrand;
    },
    getDeviceId: function() {
        return getDeviceId;
    },
    getDeviceType: function() {
        return getDeviceType;
    },
    getModel: function() {
        return getModel;
    },
    getModelCode: function() {
        return getModelCode;
    },
    getVersion: function() {
        return getVersion;
    }
});
var _async_to_generator = __webpack_require__(24146);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(52318);
var getBrand = function() {
    var _ref = _async_to_generator._(function() {
        return _ts_generator._(this, function(_state) {
            return [
                2,
                "magenta"
            ];
        });
    });
    return function getBrand() {
        return _ref.apply(this, arguments);
    };
}();
var getDeviceId = function() {
    var _ref = _async_to_generator._(function() {
        return _ts_generator._(this, function(_state) {
            return [
                2,
                ""
            ];
        });
    });
    return function getDeviceId() {
        return _ref.apply(this, arguments);
    };
}();
var getVersion = function() {
    var _ref = _async_to_generator._(function() {
        return _ts_generator._(this, function(_state) {
            try {
                return [
                    2,
                    navigator.userAgent.match(/DT_STB_([A-Za-z0-9]+)/)[1]
                ];
            } catch (e) {
                return [
                    2,
                    ""
                ];
            }
            return [
                2
            ];
        });
    });
    return function getVersion() {
        return _ref.apply(this, arguments);
    };
}();
var getModel = function() {
    var _ref = _async_to_generator._(function() {
        return _ts_generator._(this, function(_state) {
            try {
                return [
                    2,
                    navigator.userAgent.match(/DT,([A-Za-z0-9]+)/)[1]
                ];
            } catch (e) {
                return [
                    2,
                    ""
                ];
            }
            return [
                2
            ];
        });
    });
    return function getModel() {
        return _ref.apply(this, arguments);
    };
}();
var getDeviceType = function() {
    var _ref = _async_to_generator._(function() {
        return _ts_generator._(this, function(_state) {
            return [
                2,
                ""
            ];
        });
    });
    return function getDeviceType() {
        return _ref.apply(this, arguments);
    };
}();
var getModelCode = function() {
    var _ref = _async_to_generator._(function() {
        return _ts_generator._(this, function(_state) {
            return [
                2,
                ""
            ];
        });
    });
    return function getModelCode() {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 3043:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    actionsKeys: function() {
        return _constants.actionsKeys;
    },
    availableActions: function() {
        return _available.availableActions;
    },
    availableDirections: function() {
        return _available.availableDirections;
    },
    availableNumerics: function() {
        return _available.availableNumerics;
    },
    initializeKeys: function() {
        return _registration.initializeKeys;
    },
    keyCodeToNumber: function() {
        return _utils.keyCodeToNumber;
    },
    keyCodes: function() {
        return _mapping.keyCodes;
    },
    numericKeys: function() {
        return _constants.numericKeys;
    },
    updateKeysRegistration: function() {
        return _registration.updateKeysRegistration;
    }
});
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(45538);
var _mapping = __webpack_require__(14515);
var _registration = __webpack_require__(53854);
var _constants = __webpack_require__(82783);
var _available = __webpack_require__(16367);
var _utils = __webpack_require__(8959);


/***/ }),

/***/ 16367:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    availableActions: function() {
        return availableActions;
    },
    availableDirections: function() {
        return availableDirections;
    },
    availableNumerics: function() {
        return availableNumerics;
    }
});
var _to_consumable_array = __webpack_require__(30005);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(3009);
var _constants = __webpack_require__(82783);
var availableNumerics = [
    _constants.numericKeys.KEY_ZERO,
    _constants.numericKeys.KEY_ONE,
    _constants.numericKeys.KEY_TWO,
    _constants.numericKeys.KEY_THREE,
    _constants.numericKeys.KEY_FOUR,
    _constants.numericKeys.KEY_FIVE,
    _constants.numericKeys.KEY_SIX,
    _constants.numericKeys.KEY_SEVEN,
    _constants.numericKeys.KEY_EIGHT,
    _constants.numericKeys.KEY_NINE
];
var availableDirections = [
    _constants.actionsKeys.KEY_UP,
    _constants.actionsKeys.KEY_DOWN,
    _constants.actionsKeys.KEY_RIGHT,
    _constants.actionsKeys.KEY_LEFT,
    _constants.actionsKeys.KEY_ENTER,
    _constants.actionsKeys.KEY_BACK
];
var availableActions = _to_consumable_array._(availableNumerics).concat(_to_consumable_array._(availableDirections), [
    _constants.actionsKeys.KEY_RED,
    _constants.actionsKeys.KEY_GREEN,
    _constants.actionsKeys.KEY_YELLOW,
    _constants.actionsKeys.KEY_BLUE,
    _constants.actionsKeys.KEY_PLAY,
    _constants.actionsKeys.KEY_PAUSE,
    _constants.actionsKeys.KEY_REWIND,
    _constants.actionsKeys.KEY_FASTFORWARD,
    _constants.actionsKeys.KEY_STOP,
    _constants.actionsKeys.KEY_SPACE,
    _constants.actionsKeys.KEY_REWIND_LONGPRESS,
    _constants.actionsKeys.KEY_FASTFORWARD_LONGPRESS
]);


/***/ }),

/***/ 82783:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    actionsKeys: function() {
        return actionsKeys;
    },
    numbers: function() {
        return numbers;
    },
    numericKeys: function() {
        return numericKeys;
    }
});
var _define_property = __webpack_require__(21228);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(52318);
var numericKeys = {
    KEY_ZERO: "zero",
    KEY_ONE: "one",
    KEY_TWO: "two",
    KEY_THREE: "three",
    KEY_FOUR: "four",
    KEY_FIVE: "five",
    KEY_SIX: "six",
    KEY_SEVEN: "seven",
    KEY_EIGHT: "eight",
    KEY_NINE: "nine"
};
var actionsKeys = {
    KEY_SPACE: "space",
    KEY_UP: "up",
    KEY_DOWN: "down",
    KEY_RIGHT: "right",
    KEY_LEFT: "left",
    KEY_ENTER: "enter",
    KEY_RED: "red",
    KEY_GREEN: "green",
    KEY_YELLOW: "yellow",
    KEY_BLUE: "blue",
    KEY_PLAY: "play",
    KEY_PAUSE: "pause",
    KEY_BACK: "back",
    KEY_REWIND: "rewind",
    KEY_FASTFORWARD: "fastForward",
    KEY_STOP: "stop",
    KEY_REWIND_LONGPRESS: "rewindLongPress",
    KEY_FASTFORWARD_LONGPRESS: "fastForwardLongPress",
    KEY_SKIP_REWIND: "skipRewind",
    KEY_SKIP_FASTFORWARD: "skipFastForward",
    KEY_PLAY_PAUSE: "playPause",
    KEY_DONE: "done"
};
var _obj;
var numbers = (_obj = {}, _define_property._(_obj, numericKeys.KEY_ZERO, 0), _define_property._(_obj, numericKeys.KEY_ONE, 1), _define_property._(_obj, numericKeys.KEY_TWO, 2), _define_property._(_obj, numericKeys.KEY_THREE, 3), _define_property._(_obj, numericKeys.KEY_FOUR, 4), _define_property._(_obj, numericKeys.KEY_FIVE, 5), _define_property._(_obj, numericKeys.KEY_SIX, 6), _define_property._(_obj, numericKeys.KEY_SEVEN, 7), _define_property._(_obj, numericKeys.KEY_EIGHT, 8), _define_property._(_obj, numericKeys.KEY_NINE, 9), _obj);


/***/ }),

/***/ 53854:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    initializeKeys: function() {
        return initializeKeys;
    },
    updateKeysRegistration: function() {
        return updateKeysRegistration;
    }
});
var _async_to_generator = __webpack_require__(24146);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(42578);
var updateKeysRegistration = function() {
    var _ref = _async_to_generator._(function() {
        return _ts_generator._(this, function(_state) {
            return [
                2
            ];
        });
    });
    return function updateKeysRegistration() {
        return _ref.apply(this, arguments);
    };
}();
var initializeKeys = function() {
    var _ref = _async_to_generator._(function() {
        return _ts_generator._(this, function(_state) {
            return [
                2
            ];
        });
    });
    return function initializeKeys() {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 14515:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    getKeymap: function() {
        return getKeymap;
    },
    keyCodes: function() {
        return keyCodes;
    }
});
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(88801);
var _constants = __webpack_require__(82783);
var keyCodes = {
    // Keyboard
    48: _constants.numericKeys.KEY_ZERO,
    49: _constants.numericKeys.KEY_ONE,
    50: _constants.numericKeys.KEY_TWO,
    51: _constants.numericKeys.KEY_THREE,
    52: _constants.numericKeys.KEY_FOUR,
    53: _constants.numericKeys.KEY_FIVE,
    54: _constants.numericKeys.KEY_SIX,
    55: _constants.numericKeys.KEY_SEVEN,
    56: _constants.numericKeys.KEY_EIGHT,
    57: _constants.numericKeys.KEY_NINE,
    // actions
    38: _constants.actionsKeys.KEY_UP,
    40: _constants.actionsKeys.KEY_DOWN,
    39: _constants.actionsKeys.KEY_RIGHT,
    37: _constants.actionsKeys.KEY_LEFT,
    13: _constants.actionsKeys.KEY_ENTER,
    275: _constants.actionsKeys.KEY_RED,
    276: _constants.actionsKeys.KEY_GREEN,
    277: _constants.actionsKeys.KEY_YELLOW,
    278: _constants.actionsKeys.KEY_BLUE,
    461: _constants.actionsKeys.KEY_BACK,
    227: _constants.actionsKeys.KEY_REWIND,
    228: _constants.actionsKeys.KEY_FASTFORWARD,
    263: _constants.actionsKeys.KEY_PLAY_PAUSE,
    179: _constants.actionsKeys.KEY_PLAY_PAUSE,
    463: _constants.actionsKeys.KEY_PLAY_PAUSE,
    412: _constants.actionsKeys.KEY_REWIND,
    265: _constants.actionsKeys.KEY_REWIND,
    417: _constants.actionsKeys.KEY_FASTFORWARD,
    264: _constants.actionsKeys.KEY_FASTFORWARD,
    177: _constants.actionsKeys.KEY_SKIP_REWIND,
    266: _constants.actionsKeys.KEY_SKIP_REWIND,
    176: _constants.actionsKeys.KEY_SKIP_FASTFORWARD,
    267: _constants.actionsKeys.KEY_SKIP_FASTFORWARD
};
var getKeymap = function() {};


/***/ }),

/***/ 8959:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "keyCodeToNumber", ({
    enumerable: true,
    get: function() {
        return keyCodeToNumber;
    }
}));
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(52318);
var _constants = __webpack_require__(82783);
var _mapping = __webpack_require__(14515);
var keyCodeToNumber = function(keyCode) {
    return _constants.numbers === null || _constants.numbers === void 0 ? void 0 : _constants.numbers[_mapping.keyCodes === null || _mapping.keyCodes === void 0 ? void 0 : _mapping.keyCodes[keyCode]];
};


/***/ }),

/***/ 43744:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    isDolbyVision: function() {
        return _screen.isDolbyVision;
    },
    isFullHD: function() {
        return _screen.isFullHD;
    },
    isGreaterOrEqual: function() {
        return _screen.isGreaterOrEqual;
    },
    isHD: function() {
        return _screen.isHD;
    },
    isHDR: function() {
        return _screen.isHDR;
    },
    isUHD: function() {
        return _screen.isUHD;
    },
    screenInfo: function() {
        return screenInfo;
    }
});
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(42578);
var _screen = __webpack_require__(65511);
var screenInfo = {
    isHD: _screen.isHD,
    isFullHD: _screen.isFullHD,
    isGreaterOrEqual: _screen.isGreaterOrEqual,
    isUHD: _screen.isUHD,
    isHDR: _screen.isHDR,
    isDolbyVision: _screen.isDolbyVision
};


/***/ }),

/***/ 72832:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "HEIGHTS", ({
    enumerable: true,
    get: function() {
        return HEIGHTS;
    }
}));
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(52318);
var HEIGHTS = {
    HD: 720,
    fullHD: 1080,
    UHD: 2160
};


/***/ }),

/***/ 65511:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    isDolbyVision: function() {
        return isDolbyVision;
    },
    isFullHD: function() {
        return isFullHD;
    },
    isGreaterOrEqual: function() {
        return isGreaterOrEqual;
    },
    isHD: function() {
        return isHD;
    },
    isHDR: function() {
        return isHDR;
    },
    isUHD: function() {
        return isUHD;
    }
});
var _async_to_generator = __webpack_require__(24146);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
var _constants = __webpack_require__(72832);
var isHD = function() {
    var _ref = _async_to_generator._(function() {
        return _ts_generator._(this, function(_state) {
            return [
                2,
                window.innerHeight < _constants.HEIGHTS.fullHD
            ];
        });
    });
    return function isHD() {
        return _ref.apply(this, arguments);
    };
}();
var isFullHD = function() {
    var _ref = _async_to_generator._(function() {
        return _ts_generator._(this, function(_state) {
            return [
                2,
                window.innerHeight >= _constants.HEIGHTS.fullHD
            ];
        });
    });
    return function isFullHD() {
        return _ref.apply(this, arguments);
    };
}();
var isGreaterOrEqual = function() {
    var _ref = _async_to_generator._(function(resolution) {
        return _ts_generator._(this, function(_state) {
            return [
                2,
                window.innerHeight >= resolution
            ];
        });
    });
    return function isGreaterOrEqual(resolution) {
        return _ref.apply(this, arguments);
    };
}();
var isUHD = function() {
    var _ref = _async_to_generator._(function() {
        return _ts_generator._(this, function(_state) {
            return [
                2,
                false
            ];
        });
    });
    return function isUHD() {
        return _ref.apply(this, arguments);
    };
}();
var isHDR = function() {
    var _ref = _async_to_generator._(function() {
        return _ts_generator._(this, function(_state) {
            return [
                2,
                false
            ];
        });
    });
    return function isHDR() {
        return _ref.apply(this, arguments);
    };
}();
var isDolbyVision = function() {
    var _ref = _async_to_generator._(function() {
        return _ts_generator._(this, function(_state) {
            return [
                2,
                false
            ];
        });
    });
    return function isDolbyVision() {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 89378:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/* eslint-disable camelcase */ /**
 * NOTE: This is an auto-generated file
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
var _Accessibilitysvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(37165));
var _ActionPlansvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(27839));
var _AddUsersvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(23298));
var _Agendasvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(96569));
var _Agessvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(64665));
var _AirPlaysvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(43667));
var _AirPlayOffsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(63398));
var _AirPlayOnsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(16738));
var _Alertsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(12275));
var _AlertOffsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(88242));
var _AlertOnsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(27724));
var _AlertUnreadsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(98351));
var _Androidsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(96484));
var _Applesvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(55689));
var _Approvedsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(46966));
var _ArrowDownsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(53421));
var _ArrowLeftsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(75564));
var _ArrowLeftWithBasesvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(52968));
var _ArrowRightsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(82236));
var _ArrowRightWithBasesvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(99680));
var _ArrowSideNavsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(12656));
var _ArrowUpsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(53738));
var _Articlesvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(15131));
var _Audiosvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(2631));
var _AudioDescriptionTagsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(93476));
var _Audiobooksvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(88448));
var _BackSpacesvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(77228));
var _BackToLivesvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(17883));
var _BankCardsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(60186));
var _Brightnesssvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(7513));
var _Brightness1svg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(88234));
var _Brightness2svg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(41448));
var _Brightness3svg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(39121));
var _Brightness4svg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(8870));
var _BrightnessFilledsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(71451));
var _Bufferingsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(6639));
var _Cancelsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(97034));
var _CapsLocksvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(53488));
var _Categorysvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(82989));
var _CategoryFocusedsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(3387));
var _Chaptersvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(7031));
var _Checksvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(38251));
var _CheckFocusedsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(61148));
var _CheckLightsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(43497));
var _Chromecastsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(10117));
var _ChromecastOffsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(87272));
var _ChromecastOff1svg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(53393));
var _ChromecastOff2svg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(28269));
var _ChromecastOnsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(8116));
var _ChromecastOn1svg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(90123));
var _ChromecastOn2svg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67682));
var _Clocksvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67623));
var _ClosedCaptionsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(90294));
var _Connectedsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34692));
var _ConnectedFocusedsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(2182));
var _ConnectedPremiumsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(85569));
var _ConnectedPremiumColorsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(55158));
var _ConnectedPremiumFocusedsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(2926));
var _ConnectedPremiumFocusedColorsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(88324));
var _Contactsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(83202));
var _Cookiesvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(20637));
var _Crosssvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(78463));
var _Csa10svg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(11737));
var _Csa12svg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(15954));
var _Csa14svg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(85256));
var _Csa15svg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(48558));
var _Csa16svg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(36230));
var _Csa18svg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(71725));
var _Csa6svg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(33150));
var _Csa9svg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(52874));
var _CsaALsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(39803));
var _Disconnectedsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(12194));
var _Downloadsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(10378));
var _DownloadIssuesvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(75016));
var _DownloadPausesvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81727));
var _DownloadToGosvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(48965));
var _Downloadedsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(19873));
var _Downloadingsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(49169));
var _Earsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(5629));
var _Editsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(31554));
var _EditFocusedsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(12484));
var _Embedsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(97648));
var _Errorsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(28594));
var _ErrorEmojisvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(76468));
var _Exclamationsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(53467));
var _EyeOffsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(39804));
var _EyeOnsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(97231));
var _FIFA2026svg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65565));
var _Facebooksvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(57662));
var _FacebookRectanglesvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(7551));
var _Firesvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(78252));
var _FontTypesvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(52721));
var _Footballsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(97387));
var _FootballFocusedsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(50260));
var _FreemiumLocksvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(16542));
var _Friendssvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81979));
var _Genressvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(63075));
var _Giftsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(60428));
var _GoBacksvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(77508));
var _Googlesvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(22410));
var _GooglePodcastsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(83248));
var _Helpsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(90344));
var _Historysvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(63606));
var _Homesvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(29291));
var _HomeFocusedsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(26244));
var _IdealColorsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(31648));
var _IdealDefaultsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(9557));
var _Infosvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67720));
var _InfoFocusedsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(84935));
var _InfoLightsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(27975));
var _Instagramsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(56634));
var _Itunessvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(28634));
var _JustInsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(802));
var _KebabMenusvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(38660));
var _Kidssvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(31089));
var _KidsAge1svg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(80263));
var _KidsAge3svg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(8397));
var _KidsAge4svg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(90431));
var _KidsAge6svg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(89704));
var _KidsAge7svg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(61114));
var _KidsFamilysvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(21627));
var _KidsHomesvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(42157));
var _KidsLeavesvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(15628));
var _KidsMoviesvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(15624));
var _KidsSearchsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(51506));
var _KidsSeriessvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(54661));
var _Laptopsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(9907));
var _Leaf1svg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(5398));
var _Leaf2svg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(49585));
var _Likesvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(4854));
var _Likedsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(80821));
var _Linksvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(54468));
var _ListAddsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(98655));
var _ListAddedsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(71891));
var _ListRemovedsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(69805));
var _Livesvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(49367));
var _Loadingsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(68684));
var _Locksvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(2925));
var _Logoutsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(14124));
var _MagicWandsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(22885));
var _Monogramsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(74193));
var _Moviessvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(42272));
var _Offlinesvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(60531));
var _Onesvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(94890));
var _OneColorsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(9274));
var _ParentalGuidanceDiscriminationsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(23657));
var _ParentalGuidanceDrugssvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(26129));
var _ParentalGuidanceFoulLanguagesvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(27209));
var _ParentalGuidanceScarysvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(44644));
var _ParentalGuidanceSexsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(20278));
var _ParentalGuidanceViolencesvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(77894));
var _Pausesvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(70966));
var _Paypalsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(86143));
var _Phonesvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(1888));
var _Pinterestsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(75001));
var _Playsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(47402));
var _Playlistsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(16849));
var _PlaylistFocusedsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(89440));
var _Plussvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(38408));
var _Podcastsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(94042));
var _Premiumsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(43038));
var _PremiumColorsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(44639));
var _PrincipalProfilesvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(32629));
var _Privacysvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(47063));
var _ProductPlacementsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(14796));
var _Programssvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(49134));
var _Purchasesvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(42841));
var _QRCodesvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(57177));
var _RSSsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(57288));
var _Refreshsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(96973));
var _RelatedVideossvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(28682));
var _RelatedVideosFocusedsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(95922));
var _Remotesvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(74808));
var _Removesvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(20174));
var _Searchsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(64324));
var _SearchFocusedsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81365));
var _SeekBackwardsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(28834));
var _SeekBackwardFeedbacksvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(13127));
var _SeekForwardsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(96856));
var _SeekForwardFeedbacksvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(80716));
var _Seriessvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(98823));
var _Settingssvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(30867));
var _SettingsEco1svg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(54032));
var _SettingsEco2svg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(60688));
var _Sharesvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(9184));
var _Share_Androidsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(73039));
var _Share_iOSsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(63882));
var _Shieldsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(92840));
var _SkipNextsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(50729));
var _SkipNextFocusedsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(18270));
var _SkipPrevioussvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(44262));
var _SkipPreviousFocusedsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(88485));
var _Sliderssvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(99639));
var _Slotsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(30211));
var _Spacesvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(16940));
var _Speedsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(4711));
var _Starsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(59963));
var _StartOversvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(91632));
var _Televisionsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(17638));
var _TelevisionFocusedsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(21651));
var _TextIncreasesvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(57981));
var _Tiktoksvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(46644));
var _Timersvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(79090));
var _TimerFocusedsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(64024));
var _Trackssvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(40300));
var _TracksFilledsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(30494));
var _Trailersvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65727));
var _Trashsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(15507));
var _Twittersvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(57419));
var _UEFAsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(62571));
var _Universsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(97625));
var _Unlocksvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(4847));
var _Usabillasvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(78254));
var _Vocalsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(91564));
var _Volumesvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(45046));
var _Volume1svg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(50405));
var _Volume2svg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(86573));
var _Volume3svg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(4913));
var _Volume4svg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(72712));
var _VolumeDownsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67501));
var _VolumeFilledsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(49576));
var _VolumeOffsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(62155));
var _VolumeUpsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(85674));
var _Votingsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(72887));
var _Warningsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(43133));
var _Wavesvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(88344));
var _Wave1svg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(80567));
var _Wave2svg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(61838));
var _Wave3svg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(27640));
var _Wave4svg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(56752));
var _WhatsAppsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(9867));
var _Youtubesvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(95408));
var _default = {
    Accessibility: _Accessibilitysvg.default,
    ActionPlan: _ActionPlansvg.default,
    AddUser: _AddUsersvg.default,
    Agenda: _Agendasvg.default,
    Ages: _Agessvg.default,
    AirPlay: _AirPlaysvg.default,
    AirPlayOff: _AirPlayOffsvg.default,
    AirPlayOn: _AirPlayOnsvg.default,
    Alert: _Alertsvg.default,
    AlertOff: _AlertOffsvg.default,
    AlertOn: _AlertOnsvg.default,
    AlertUnread: _AlertUnreadsvg.default,
    Android: _Androidsvg.default,
    Apple: _Applesvg.default,
    Approved: _Approvedsvg.default,
    ArrowDown: _ArrowDownsvg.default,
    ArrowLeft: _ArrowLeftsvg.default,
    ArrowLeftWithBase: _ArrowLeftWithBasesvg.default,
    ArrowRight: _ArrowRightsvg.default,
    ArrowRightWithBase: _ArrowRightWithBasesvg.default,
    ArrowSideNav: _ArrowSideNavsvg.default,
    ArrowUp: _ArrowUpsvg.default,
    Article: _Articlesvg.default,
    Audio: _Audiosvg.default,
    AudioDescriptionTag: _AudioDescriptionTagsvg.default,
    Audiobook: _Audiobooksvg.default,
    BackSpace: _BackSpacesvg.default,
    BackToLive: _BackToLivesvg.default,
    BankCard: _BankCardsvg.default,
    Brightness: _Brightnesssvg.default,
    Brightness1: _Brightness1svg.default,
    Brightness2: _Brightness2svg.default,
    Brightness3: _Brightness3svg.default,
    Brightness4: _Brightness4svg.default,
    BrightnessFilled: _BrightnessFilledsvg.default,
    Buffering: _Bufferingsvg.default,
    Cancel: _Cancelsvg.default,
    CapsLock: _CapsLocksvg.default,
    Category: _Categorysvg.default,
    CategoryFocused: _CategoryFocusedsvg.default,
    Chapter: _Chaptersvg.default,
    Check: _Checksvg.default,
    CheckFocused: _CheckFocusedsvg.default,
    CheckLight: _CheckLightsvg.default,
    Chromecast: _Chromecastsvg.default,
    ChromecastOff: _ChromecastOffsvg.default,
    ChromecastOff1: _ChromecastOff1svg.default,
    ChromecastOff2: _ChromecastOff2svg.default,
    ChromecastOn: _ChromecastOnsvg.default,
    ChromecastOn1: _ChromecastOn1svg.default,
    ChromecastOn2: _ChromecastOn2svg.default,
    Clock: _Clocksvg.default,
    ClosedCaption: _ClosedCaptionsvg.default,
    Connected: _Connectedsvg.default,
    ConnectedFocused: _ConnectedFocusedsvg.default,
    ConnectedPremium: _ConnectedPremiumsvg.default,
    ConnectedPremiumColor: _ConnectedPremiumColorsvg.default,
    ConnectedPremiumFocused: _ConnectedPremiumFocusedsvg.default,
    ConnectedPremiumFocusedColor: _ConnectedPremiumFocusedColorsvg.default,
    Contact: _Contactsvg.default,
    Cookie: _Cookiesvg.default,
    Cross: _Crosssvg.default,
    Csa10: _Csa10svg.default,
    Csa12: _Csa12svg.default,
    Csa14: _Csa14svg.default,
    Csa15: _Csa15svg.default,
    Csa16: _Csa16svg.default,
    Csa18: _Csa18svg.default,
    Csa6: _Csa6svg.default,
    Csa9: _Csa9svg.default,
    CsaAL: _CsaALsvg.default,
    Disconnected: _Disconnectedsvg.default,
    Download: _Downloadsvg.default,
    DownloadIssue: _DownloadIssuesvg.default,
    DownloadPause: _DownloadPausesvg.default,
    DownloadToGo: _DownloadToGosvg.default,
    Downloaded: _Downloadedsvg.default,
    Downloading: _Downloadingsvg.default,
    Ear: _Earsvg.default,
    Edit: _Editsvg.default,
    EditFocused: _EditFocusedsvg.default,
    Embed: _Embedsvg.default,
    Error: _Errorsvg.default,
    ErrorEmoji: _ErrorEmojisvg.default,
    Exclamation: _Exclamationsvg.default,
    EyeOff: _EyeOffsvg.default,
    EyeOn: _EyeOnsvg.default,
    FIFA2026: _FIFA2026svg.default,
    Facebook: _Facebooksvg.default,
    FacebookRectangle: _FacebookRectanglesvg.default,
    Fire: _Firesvg.default,
    FontType: _FontTypesvg.default,
    Football: _Footballsvg.default,
    FootballFocused: _FootballFocusedsvg.default,
    FreemiumLock: _FreemiumLocksvg.default,
    Friends: _Friendssvg.default,
    Genres: _Genressvg.default,
    Gift: _Giftsvg.default,
    GoBack: _GoBacksvg.default,
    Google: _Googlesvg.default,
    GooglePodcast: _GooglePodcastsvg.default,
    Help: _Helpsvg.default,
    History: _Historysvg.default,
    Home: _Homesvg.default,
    HomeFocused: _HomeFocusedsvg.default,
    IdealColor: _IdealColorsvg.default,
    IdealDefault: _IdealDefaultsvg.default,
    Info: _Infosvg.default,
    InfoFocused: _InfoFocusedsvg.default,
    InfoLight: _InfoLightsvg.default,
    Instagram: _Instagramsvg.default,
    Itunes: _Itunessvg.default,
    JustIn: _JustInsvg.default,
    KebabMenu: _KebabMenusvg.default,
    Kids: _Kidssvg.default,
    KidsAge1: _KidsAge1svg.default,
    KidsAge3: _KidsAge3svg.default,
    KidsAge4: _KidsAge4svg.default,
    KidsAge6: _KidsAge6svg.default,
    KidsAge7: _KidsAge7svg.default,
    KidsFamily: _KidsFamilysvg.default,
    KidsHome: _KidsHomesvg.default,
    KidsLeave: _KidsLeavesvg.default,
    KidsMovie: _KidsMoviesvg.default,
    KidsSearch: _KidsSearchsvg.default,
    KidsSeries: _KidsSeriessvg.default,
    Laptop: _Laptopsvg.default,
    Leaf1: _Leaf1svg.default,
    Leaf2: _Leaf2svg.default,
    Like: _Likesvg.default,
    Liked: _Likedsvg.default,
    Link: _Linksvg.default,
    ListAdd: _ListAddsvg.default,
    ListAdded: _ListAddedsvg.default,
    ListRemoved: _ListRemovedsvg.default,
    Live: _Livesvg.default,
    Loading: _Loadingsvg.default,
    Lock: _Locksvg.default,
    Logout: _Logoutsvg.default,
    MagicWand: _MagicWandsvg.default,
    Monogram: _Monogramsvg.default,
    Movies: _Moviessvg.default,
    Offline: _Offlinesvg.default,
    One: _Onesvg.default,
    OneColor: _OneColorsvg.default,
    ParentalGuidanceDiscrimination: _ParentalGuidanceDiscriminationsvg.default,
    ParentalGuidanceDrugs: _ParentalGuidanceDrugssvg.default,
    ParentalGuidanceFoulLanguage: _ParentalGuidanceFoulLanguagesvg.default,
    ParentalGuidanceScary: _ParentalGuidanceScarysvg.default,
    ParentalGuidanceSex: _ParentalGuidanceSexsvg.default,
    ParentalGuidanceViolence: _ParentalGuidanceViolencesvg.default,
    Pause: _Pausesvg.default,
    Paypal: _Paypalsvg.default,
    Phone: _Phonesvg.default,
    Pinterest: _Pinterestsvg.default,
    Play: _Playsvg.default,
    Playlist: _Playlistsvg.default,
    PlaylistFocused: _PlaylistFocusedsvg.default,
    Plus: _Plussvg.default,
    Podcast: _Podcastsvg.default,
    Premium: _Premiumsvg.default,
    PremiumColor: _PremiumColorsvg.default,
    PrincipalProfile: _PrincipalProfilesvg.default,
    Privacy: _Privacysvg.default,
    ProductPlacement: _ProductPlacementsvg.default,
    Programs: _Programssvg.default,
    Purchase: _Purchasesvg.default,
    QRCode: _QRCodesvg.default,
    RSS: _RSSsvg.default,
    Refresh: _Refreshsvg.default,
    RelatedVideos: _RelatedVideossvg.default,
    RelatedVideosFocused: _RelatedVideosFocusedsvg.default,
    Remote: _Remotesvg.default,
    Remove: _Removesvg.default,
    Search: _Searchsvg.default,
    SearchFocused: _SearchFocusedsvg.default,
    SeekBackward: _SeekBackwardsvg.default,
    SeekBackwardFeedback: _SeekBackwardFeedbacksvg.default,
    SeekForward: _SeekForwardsvg.default,
    SeekForwardFeedback: _SeekForwardFeedbacksvg.default,
    Series: _Seriessvg.default,
    Settings: _Settingssvg.default,
    SettingsEco1: _SettingsEco1svg.default,
    SettingsEco2: _SettingsEco2svg.default,
    Share: _Sharesvg.default,
    Share_Android: _Share_Androidsvg.default,
    Share_iOS: _Share_iOSsvg.default,
    Shield: _Shieldsvg.default,
    SkipNext: _SkipNextsvg.default,
    SkipNextFocused: _SkipNextFocusedsvg.default,
    SkipPrevious: _SkipPrevioussvg.default,
    SkipPreviousFocused: _SkipPreviousFocusedsvg.default,
    Sliders: _Sliderssvg.default,
    Slot: _Slotsvg.default,
    Space: _Spacesvg.default,
    Speed: _Speedsvg.default,
    Star: _Starsvg.default,
    StartOver: _StartOversvg.default,
    Television: _Televisionsvg.default,
    TelevisionFocused: _TelevisionFocusedsvg.default,
    TextIncrease: _TextIncreasesvg.default,
    Tiktok: _Tiktoksvg.default,
    Timer: _Timersvg.default,
    TimerFocused: _TimerFocusedsvg.default,
    Tracks: _Trackssvg.default,
    TracksFilled: _TracksFilledsvg.default,
    Trailer: _Trailersvg.default,
    Trash: _Trashsvg.default,
    Twitter: _Twittersvg.default,
    UEFA: _UEFAsvg.default,
    Univers: _Universsvg.default,
    Unlock: _Unlocksvg.default,
    Usabilla: _Usabillasvg.default,
    Vocal: _Vocalsvg.default,
    Volume: _Volumesvg.default,
    Volume1: _Volume1svg.default,
    Volume2: _Volume2svg.default,
    Volume3: _Volume3svg.default,
    Volume4: _Volume4svg.default,
    VolumeDown: _VolumeDownsvg.default,
    VolumeFilled: _VolumeFilledsvg.default,
    VolumeOff: _VolumeOffsvg.default,
    VolumeUp: _VolumeUpsvg.default,
    Voting: _Votingsvg.default,
    Warning: _Warningsvg.default,
    Wave: _Wavesvg.default,
    Wave1: _Wave1svg.default,
    Wave2: _Wave2svg.default,
    Wave3: _Wave3svg.default,
    Wave4: _Wave4svg.default,
    WhatsApp: _WhatsAppsvg.default,
    Youtube: _Youtubesvg.default
};


/***/ }),

/***/ 9012:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/* eslint-disable camelcase */ /**
 * NOTE: This is an auto-generated file
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(52318);
var _AirPlaysvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(49011));
var _AirPlayOffsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(27834));
var _AirPlayOnsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(73943));
var _ArrowDownsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(13594));
var _ArrowLeftWithBasesvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(57383));
var _ArrowUpsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(46855));
var _AudioDescriptionsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(59028));
var _BackSpacesvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34493));
var _BackToLivesvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(90461));
var _BackToLiveHBBTVsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(30665));
var _Brightnesssvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(41422));
var _Brightness1svg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(66465));
var _Brightness2svg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(6814));
var _Brightness3svg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81877));
var _Brightness4svg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(39180));
var _BrightnessFilledsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(51722));
var _Chaptersvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(22654));
var _Chromecastsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(17031));
var _ChromecastOffsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(86775));
var _ChromecastOff1svg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(54413));
var _ChromecastOff2svg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(7340));
var _ChromecastOnsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(40390));
var _ChromecastOn1svg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(22120));
var _ChromecastOn2svg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(47942));
var _Contactsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(27455));
var _ErrorEmojisvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(55679));
var _FullscreenOffsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65435));
var _FullscreenOnsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(91952));
var _Infosvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(9542));
var _Pausesvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(79421));
var _PictureInPicturesvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(90179));
var _Playsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(64886));
var _Playlistsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65736));
var _PlaylistFocusedsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(8043));
var _RelatedVideossvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(93142));
var _Remotesvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(31860));
var _Replaysvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(73118));
var _SeekBackwardsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(74108));
var _SeekBackwardFeedbacksvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(51423));
var _SeekForwardsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(35260));
var _SeekForwardFeedbacksvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(45105));
var _Settingssvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(73988));
var _SettingsEco1svg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(32396));
var _SettingsEco2svg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(66871));
var _Sharesvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(49058));
var _SkipNextsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(82078));
var _SkipNextFocusedsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(18261));
var _SkipPrevioussvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(57785));
var _SkipPreviousFocusedsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(53883));
var _Spacesvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(18355));
var _Speedsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34618));
var _StartOversvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(79139));
var _SwitchAudioIconsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(50961));
var _SwitchVideoIconsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(52071));
var _Timersvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(38605));
var _TimerFocusedsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(92083));
var _Trackssvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(75987));
var _TracksFilledsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(31666));
var _Usabillasvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(24610));
var _VOSTsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(94066));
var _Volumesvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(83902));
var _Volume1svg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(53845));
var _Volume2svg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(29758));
var _Volume3svg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(37200));
var _Volume4svg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(6500));
var _VolumeDownsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(93770));
var _VolumeFilledsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(29112));
var _VolumeOffsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(11890));
var _VolumeUpsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(49175));
var _default = {
    AirPlay: _AirPlaysvg.default,
    AirPlayOff: _AirPlayOffsvg.default,
    AirPlayOn: _AirPlayOnsvg.default,
    ArrowDown: _ArrowDownsvg.default,
    ArrowLeftWithBase: _ArrowLeftWithBasesvg.default,
    ArrowUp: _ArrowUpsvg.default,
    AudioDescription: _AudioDescriptionsvg.default,
    BackSpace: _BackSpacesvg.default,
    BackToLive: _BackToLivesvg.default,
    BackToLiveHBBTV: _BackToLiveHBBTVsvg.default,
    Brightness: _Brightnesssvg.default,
    Brightness1: _Brightness1svg.default,
    Brightness2: _Brightness2svg.default,
    Brightness3: _Brightness3svg.default,
    Brightness4: _Brightness4svg.default,
    BrightnessFilled: _BrightnessFilledsvg.default,
    Chapter: _Chaptersvg.default,
    Chromecast: _Chromecastsvg.default,
    ChromecastOff: _ChromecastOffsvg.default,
    ChromecastOff1: _ChromecastOff1svg.default,
    ChromecastOff2: _ChromecastOff2svg.default,
    ChromecastOn: _ChromecastOnsvg.default,
    ChromecastOn1: _ChromecastOn1svg.default,
    ChromecastOn2: _ChromecastOn2svg.default,
    Contact: _Contactsvg.default,
    ErrorEmoji: _ErrorEmojisvg.default,
    FullscreenOff: _FullscreenOffsvg.default,
    FullscreenOn: _FullscreenOnsvg.default,
    Info: _Infosvg.default,
    Pause: _Pausesvg.default,
    PictureInPicture: _PictureInPicturesvg.default,
    Play: _Playsvg.default,
    Playlist: _Playlistsvg.default,
    PlaylistFocused: _PlaylistFocusedsvg.default,
    RelatedVideos: _RelatedVideossvg.default,
    Remote: _Remotesvg.default,
    Replay: _Replaysvg.default,
    SeekBackward: _SeekBackwardsvg.default,
    SeekBackwardFeedback: _SeekBackwardFeedbacksvg.default,
    SeekForward: _SeekForwardsvg.default,
    SeekForwardFeedback: _SeekForwardFeedbacksvg.default,
    Settings: _Settingssvg.default,
    SettingsEco1: _SettingsEco1svg.default,
    SettingsEco2: _SettingsEco2svg.default,
    Share: _Sharesvg.default,
    SkipNext: _SkipNextsvg.default,
    SkipNextFocused: _SkipNextFocusedsvg.default,
    SkipPrevious: _SkipPrevioussvg.default,
    SkipPreviousFocused: _SkipPreviousFocusedsvg.default,
    Space: _Spacesvg.default,
    Speed: _Speedsvg.default,
    StartOver: _StartOversvg.default,
    SwitchAudioIcon: _SwitchAudioIconsvg.default,
    SwitchVideoIcon: _SwitchVideoIconsvg.default,
    Timer: _Timersvg.default,
    TimerFocused: _TimerFocusedsvg.default,
    Tracks: _Trackssvg.default,
    TracksFilled: _TracksFilledsvg.default,
    Usabilla: _Usabillasvg.default,
    VOST: _VOSTsvg.default,
    Volume: _Volumesvg.default,
    Volume1: _Volume1svg.default,
    Volume2: _Volume2svg.default,
    Volume3: _Volume3svg.default,
    Volume4: _Volume4svg.default,
    VolumeDown: _VolumeDownsvg.default,
    VolumeFilled: _VolumeFilledsvg.default,
    VolumeOff: _VolumeOffsvg.default,
    VolumeUp: _VolumeUpsvg.default
};


/***/ }),

/***/ 20360:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ICON_COLLECTION: function() {
        return ICON_COLLECTION;
    },
    basic: function() {
        return _basic;
    },
    controls: function() {
        return _controls;
    },
    createSvg: function() {
        return createSvg;
    },
    getBasePath: function() {
        return getBasePath;
    },
    getCollectionById: function() {
        return getCollectionById;
    },
    getSvgTexture: function() {
        return getSvgTexture;
    },
    iconByName: function() {
        return iconByName;
    },
    special: function() {
        return _special;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
var _interop_require_wildcard = __webpack_require__(95316);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(37815);
var _sdk = __webpack_require__(29956);
var _memoize = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34736));
var _mapKeys = /*#__PURE__*/ _interop_require_default._(__webpack_require__(48347));
var _basic = /*#__PURE__*/ _interop_require_wildcard._(__webpack_require__(89378));
var _controls = /*#__PURE__*/ _interop_require_wildcard._(__webpack_require__(9012));
var _special = /*#__PURE__*/ _interop_require_wildcard._(__webpack_require__(39593));
var ICON_COLLECTION = {
    BASIC: "basic",
    CONTROLS: "controls",
    SPECIAL: "special"
};
var objectKeysToLowerCase = function(obj) {
    return (0, _mapKeys.default)(obj, function(_, k) {
        return k.toLowerCase();
    });
};
var _obj;
var mapping = (_obj = {}, _define_property._(_obj, ICON_COLLECTION.BASIC, objectKeysToLowerCase(_basic.default)), _define_property._(_obj, ICON_COLLECTION.CONTROLS, objectKeysToLowerCase(_controls.default)), _define_property._(_obj, ICON_COLLECTION.SPECIAL, objectKeysToLowerCase(_special.default)), _obj);
var getBasePath = (0, _memoize.default)(function() {
    return window.location.origin || "".concat(window.location.protocol, "//").concat(window.location.host || window.location.hostname);
});
var getCollectionById = function(collectionId) {
    return mapping[collectionId] || _basic.default;
};
var iconByName = function(name) {
    var collection = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ICON_COLLECTION.BASIC;
    return getCollectionById(collection)[name];
};
var createSvg = function(callback, stage, url, width, height) {
    var scale = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 1;
    var canvas = stage.platform.getDrawingCanvas();
    var context = canvas.getContext("2d");
    context.imageSmoothingEnabled = scale === 1;
    var image = new Image();
    image.onload = function() {
        var imageWidth = image.width;
        var imageHeight = image.height;
        var viewBoxWidth = width || 0;
        var viewBoxHeight = height;
        var horizontalRatio = viewBoxWidth ? imageWidth / viewBoxWidth : 0;
        var verticalRatio = viewBoxHeight ? imageHeight / viewBoxHeight : 0;
        var scaleRatio = horizontalRatio > verticalRatio ? viewBoxWidth / imageWidth : viewBoxHeight / imageHeight;
        canvas.width = Math.round(imageWidth * scaleRatio);
        canvas.height = Math.round(imageHeight * scaleRatio);
        canvas.width *= scale;
        canvas.height *= scale;
        context.drawImage(image, 0, 0, canvas.width, canvas.height);
        callback(null, canvas);
    };
    image.onError = function(error) {
        callback(error);
    };
    // On the PS4 platform setting the `crossOrigin` attribute on images can cause CORS failures.
    // TODO: use platform replacement
    if (!_sdk.Lightning.Utils.isPS4) {
        image.crossOrigin = "Anonymous";
    }
    image.src = url;
};
var getSvgTexture = function(url, w, h) {
    var scale = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
    var factory = function(callback, stage) {
        if (_sdk.Lightning.Utils.isSpark) {
            stage.platform.createSvg(callback, stage, url, w, h);
        } else {
            createSvg(callback, stage, url, w, h, scale);
        }
    };
    var id = "svg".concat([
        w,
        h,
        scale,
        url
    ].join(","));
    return _sdk.Lightning.Tools.getCanvasTexture(factory, id);
};


/***/ }),

/***/ 39593:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/* eslint-disable camelcase */ /**
 * NOTE: This is an auto-generated file
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(42578);
var _ArrowLeftWithBasesvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(10463));
var _AudioDescriptionsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(29682));
var _BackToLivesvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(44158));
var _Chaptersvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(6113));
var _Crosssvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(94881));
var _Infosvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(80448));
var _Livesvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(66481));
var _MultiDevicessvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(47805));
var _RelatedVideossvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(27872));
var _Remotesvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(62791));
var _SkipNextsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(17748));
var _SkipNextFocusedsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(85645));
var _SkipPrevioussvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(61827));
var _SkipPreviousFocusedsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(70963));
var _StartOversvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(28224));
var _Trackssvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(30464));
var _Usabillasvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(39499));
var _VOSTsvg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(40471));
var _default = {
    ArrowLeftWithBase: _ArrowLeftWithBasesvg.default,
    AudioDescription: _AudioDescriptionsvg.default,
    BackToLive: _BackToLivesvg.default,
    Chapter: _Chaptersvg.default,
    Cross: _Crosssvg.default,
    Info: _Infosvg.default,
    Live: _Livesvg.default,
    MultiDevices: _MultiDevicessvg.default,
    RelatedVideos: _RelatedVideossvg.default,
    Remote: _Remotesvg.default,
    SkipNext: _SkipNextsvg.default,
    SkipNextFocused: _SkipNextFocusedsvg.default,
    SkipPrevious: _SkipPrevioussvg.default,
    SkipPreviousFocused: _SkipPreviousFocusedsvg.default,
    StartOver: _StartOversvg.default,
    Tracks: _Trackssvg.default,
    Usabilla: _Usabillasvg.default,
    VOST: _VOSTsvg.default
};


/***/ }),

/***/ 78306:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    CLOUD_DARK: function() {
        return CLOUD_DARK;
    },
    CLOUD_NORMAL: function() {
        return CLOUD_NORMAL;
    },
    CLOUD_WHITE: function() {
        return CLOUD_WHITE;
    },
    ECO: function() {
        return ECO;
    },
    HIGHLIGHT: function() {
        return HIGHLIGHT;
    },
    LIVE: function() {
        return LIVE;
    },
    PRIMARY: function() {
        return PRIMARY;
    },
    QUATERNARY: function() {
        return QUATERNARY;
    },
    QUINARY: function() {
        return QUINARY;
    },
    SECONDARY: function() {
        return SECONDARY;
    },
    TERTIARY: function() {
        return TERTIARY;
    },
    UTILITY1: function() {
        return UTILITY1;
    },
    UTILITY2: function() {
        return UTILITY2;
    },
    UTILITY3: function() {
        return UTILITY3;
    },
    UTILITY4: function() {
        return UTILITY4;
    },
    colorNames: function() {
        return colorNames;
    }
});
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(3009);
var PRIMARY = "PRIMARY";
var SECONDARY = "SECONDARY";
var TERTIARY = "TERTIARY";
var QUATERNARY = "QUATERNARY";
var QUINARY = "QUINARY";
var UTILITY1 = "UTILITY1";
var UTILITY2 = "UTILITY2";
var UTILITY3 = "UTILITY3";
var UTILITY4 = "UTILITY4";
var ECO = "ECO";
var LIVE = "LIVE";
var HIGHLIGHT = "HIGHLIGHT";
var CLOUD_DARK = "CLOUD_DARK";
var CLOUD_NORMAL = "CLOUD_NORMAL";
var CLOUD_WHITE = "CLOUD_WHITE";
var colorNames = [
    PRIMARY,
    SECONDARY,
    TERTIARY,
    QUATERNARY,
    QUINARY,
    UTILITY1,
    UTILITY2,
    UTILITY3,
    UTILITY4,
    ECO,
    LIVE,
    HIGHLIGHT,
    CLOUD_WHITE,
    CLOUD_NORMAL,
    CLOUD_DARK
];


/***/ }),

/***/ 69886:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    colors: function() {
        return colors;
    },
    staticColors: function() {
        return staticColors;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_wildcard = __webpack_require__(95316);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(88801);
var _modes = __webpack_require__(54066);
var _constants = /*#__PURE__*/ _interop_require_wildcard._(__webpack_require__(78306));
var _utils = __webpack_require__(49568);
var _obj, _obj1, _obj2;
var staticColors = (_obj2 = {}, _define_property._(_obj2, _modes.LIGHT_MODE, (_obj = {}, _define_property._(_obj, _constants.PRIMARY, "#000000"), _define_property._(_obj, _constants.SECONDARY, "#F7F8F9"), _define_property._(_obj, _constants.TERTIARY, "#ffffff"), _define_property._(_obj, _constants.QUATERNARY, "#AFB0B6"), _define_property._(_obj, _constants.QUINARY, "#5B14B8"), _define_property._(_obj, _constants.UTILITY1, "#da3b2b"), _define_property._(_obj, _constants.UTILITY2, "#4ed569"), _define_property._(_obj, _constants.UTILITY3, "#ffb002"), _define_property._(_obj, _constants.UTILITY4, "#4A90E2"), _define_property._(_obj, _constants.ECO, "#48b755"), _define_property._(_obj, _constants.LIVE, "#E71700"), _define_property._(_obj, _constants.HIGHLIGHT, "#e6e6e6"), _define_property._(_obj, _constants.CLOUD_DARK, "#000000"), _define_property._(_obj, _constants.CLOUD_NORMAL, "#6F7175"), _define_property._(_obj, _constants.CLOUD_WHITE, "#ffffff"), _obj)), _define_property._(_obj2, _modes.DARK_MODE, (_obj1 = {}, _define_property._(_obj1, _constants.PRIMARY, "#ffffff"), _define_property._(_obj1, _constants.SECONDARY, "#F7F8F9"), _define_property._(_obj1, _constants.TERTIARY, "#000000"), _define_property._(_obj1, _constants.QUATERNARY, "#AFB0B6"), _define_property._(_obj1, _constants.QUINARY, "#5B14B8"), _define_property._(_obj1, _constants.UTILITY1, "#da3b2b"), _define_property._(_obj1, _constants.UTILITY2, "#4ed569"), _define_property._(_obj1, _constants.UTILITY3, "#ffb002"), _define_property._(_obj1, _constants.UTILITY4, "#4A90E2"), _define_property._(_obj1, _constants.ECO, "#48b755"), _define_property._(_obj1, _constants.LIVE, "#E71700"), _define_property._(_obj1, _constants.HIGHLIGHT, "#252525"), _define_property._(_obj1, _constants.CLOUD_DARK, "#000000"), _define_property._(_obj1, _constants.CLOUD_NORMAL, "#6F7175"), _define_property._(_obj1, _constants.CLOUD_WHITE, "#ffffff"), _obj1)), _obj2);
var colors = (0, _utils.colorsSetToNumbers)(staticColors);


/***/ }),

/***/ 51397:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    getColor: function() {
        return getColor;
    },
    getDarkColor: function() {
        return getDarkColor;
    },
    getLightColor: function() {
        return getLightColor;
    },
    makeThemeColor: function() {
        return makeThemeColor;
    }
});
var _define_property = __webpack_require__(21228);
var _export_star = __webpack_require__(37668);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(52318);
var _colors = _export_star._(__webpack_require__(69886), exports);
var _modes = _export_star._(__webpack_require__(54066), exports);
var _utils = _export_star._(__webpack_require__(49568), exports);
_export_star._(__webpack_require__(78306), exports);
var getColor = function(param) {
    var name = param.name, _param_mode = param.mode, mode = _param_mode === void 0 ? _modes.DEFAULT_MODE : _param_mode, _param_alpha = param.alpha, alpha = _param_alpha === void 0 ? 1.0 : _param_alpha;
    var result = _colors.colors[mode][name];
    if (alpha < 1.0) {
        return (0, _utils.hexToARGB)(_colors.staticColors[mode][name], alpha);
    }
    return result;
};
var getDarkColor = function(name) {
    var alpha = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1.0;
    return getColor({
        name: name,
        alpha: alpha,
        mode: _modes.DARK_MODE
    });
};
var getLightColor = function(name) {
    var alpha = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1.0;
    return getColor({
        name: name,
        alpha: alpha,
        mode: _modes.LIGHT_MODE
    });
};
var makeThemeColor = function(name) {
    var alpha = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1.0;
    var _obj;
    return _obj = {}, _define_property._(_obj, _modes.DARK_MODE, getDarkColor(name, alpha)), _define_property._(_obj, _modes.LIGHT_MODE, getLightColor(name, alpha)), _obj;
};


/***/ }),

/***/ 54066:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DARK_MODE: function() {
        return DARK_MODE;
    },
    DEFAULT_MODE: function() {
        return DEFAULT_MODE;
    },
    LIGHT_MODE: function() {
        return LIGHT_MODE;
    },
    modes: function() {
        return modes;
    }
});
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(65759);
var LIGHT_MODE = "light";
var DARK_MODE = "dark";
var DEFAULT_MODE = DARK_MODE;
var modes = [
    DARK_MODE,
    LIGHT_MODE
];


/***/ }),

/***/ 49568:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    alphaToHex: function() {
        return alphaToHex;
    },
    colorsSetToNumbers: function() {
        return colorsSetToNumbers;
    },
    colorsToNumbers: function() {
        return colorsToNumbers;
    },
    hexToARGB: function() {
        return hexToARGB;
    }
});
var _define_property = __webpack_require__(21228);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(37815);
var alphaToHex = function(alpha) {
    return "0x".concat(Math.ceil(255 * alpha).toString(16));
};
var hexToARGB = function(color) {
    var alpha = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1.0, fallback = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0x00000000;
    return color ? parseInt(color.replace("#", alphaToHex(alpha)), 16) : fallback;
};
var colorsToNumbers = function(strings) {
    return Object.keys(strings).reduce(function(colors, colorName) {
        colors[colorName] = hexToARGB(strings[colorName]);
        return colors;
    }, {});
};
var colorsSetToNumbers = function(colors) {
    return Object.keys(colors).reduce(function(result, mode) {
        var set = colorsToNumbers(colors[mode]);
        return _object_spread_props._(_object_spread._({}, result), _define_property._({}, mode, set));
    }, {});
};


/***/ }),

/***/ 24728:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    FONT: function() {
        return FONT;
    },
    FONT_TYPE: function() {
        return FONT_TYPE;
    },
    FONT_WEIGHT: function() {
        return FONT_WEIGHT;
    },
    OPEN_TYPE_WEIGHT: function() {
        return OPEN_TYPE_WEIGHT;
    }
});
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(65759);
var FONT_TYPE = {
    MAIN: "main",
    ALTERNATE: "alternate"
};
var OPEN_TYPE_WEIGHT = {
    THIN: 100,
    EXTRA_LIGHT: 200,
    LIGHT: 300,
    REGULAR: 400,
    MEDIUM: 500,
    SEMIBOLD: 600,
    BOLD: 700,
    EXTRA_BOLD: 800,
    BLACK: 900
};
var FONT_WEIGHT = {
    ID_1: "FONT_WEIGHT_1",
    ID_2: "FONT_WEIGHT_2",
    ID_3: "FONT_WEIGHT_3",
    ID_4: "FONT_WEIGHT_4"
};
var FONT = {
    TOKYO_4: "tokyo_4",
    OSLO_1: "oslo_1",
    OSLO_2: "oslo_2",
    OSLO_3: "oslo_3",
    PARIS_1: "paris_1",
    PARIS_2: "paris_2",
    PARIS_3: "paris_3",
    KINSHASA_1: "kinshasa_1",
    KINSHASA_2: "kinshasa_2",
    KINSHASA_3: "kinshasa_3",
    OTTAWA_1: "ottawa_1",
    OTTAWA_2: "ottawa_2",
    OTTAWA_3: "ottawa_3",
    BERLIN_1: "berlin_1",
    BERLIN_2: "berlin_2",
    BERLIN_3: "berlin_3",
    MADRID_1: "madrid_1",
    MADRID_2: "madrid_2",
    MADRID_3: "madrid_3",
    BOSTON_1: "boston_1",
    BOSTON_2: "boston_2",
    BOSTON_3: "boston_3",
    MEXICO_1: "mexico_1",
    MEXICO_2: "mexico_2",
    MEXICO_3: "mexico_3",
    LYON_1: "lyon_1",
    LYON_2: "lyon_2",
    LYON_3: "lyon_3"
};


/***/ }),

/***/ 92071:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "fonts", ({
    enumerable: true,
    get: function() {
        return fonts;
    }
}));
var _define_property = __webpack_require__(21228);
var _interop_require_wildcard = __webpack_require__(95316);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
var _constants = __webpack_require__(24728);
var _RTLUniteddescriptors = /*#__PURE__*/ _interop_require_wildcard._(__webpack_require__(55214));
var fonts = _define_property._({}, _constants.FONT_TYPE.MAIN, _RTLUniteddescriptors);


/***/ }),

/***/ 64206:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    FONT: function() {
        return _constants1.FONT;
    },
    FONTS: function() {
        return FONTS;
    },
    FONT_WEIGHT: function() {
        return _constants1.FONT_WEIGHT;
    },
    descriptors: function() {
        return descriptors;
    },
    makeFont: function() {
        return makeFont;
    },
    makeFontBerlin: function() {
        return makeFontBerlin;
    },
    makeFontBoston: function() {
        return makeFontBoston;
    },
    makeFontKinshasa: function() {
        return makeFontKinshasa;
    },
    makeFontLyon: function() {
        return makeFontLyon;
    },
    makeFontMadrid: function() {
        return makeFontMadrid;
    },
    makeFontMexico: function() {
        return makeFontMexico;
    },
    makeFontOslo: function() {
        return makeFontOslo;
    },
    makeFontOttawa: function() {
        return makeFontOttawa;
    },
    makeFontParis: function() {
        return makeFontParis;
    },
    makeFontTokyo: function() {
        return makeFontTokyo;
    }
});
var _define_property = __webpack_require__(21228);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(52318);
var _constants = __webpack_require__(34952);
var _fonts = __webpack_require__(92071);
var _constants1 = __webpack_require__(24728);
var descriptors = Object.keys(_fonts.fonts).flatMap(function(key) {
    return _fonts.fonts[key].descriptors;
});
var byFontType = function(reducer) {
    return Object.keys(_fonts.fonts).reduce(function(result, fontType) {
        return _object_spread_props._(_object_spread._({}, result), _define_property._({}, fontType, reducer(_fonts.fonts[fontType])));
    }, {});
};
var makeFont = function(fontSize, lineHeight, weight) {
    return byFontType(function(param) {
        var fontFamily = param.fontFamily, fontWeightMap = param.fontWeightMap;
        return {
            fontSize: fontSize,
            lineHeight: lineHeight,
            fontFace: fontFamily,
            fontStyle: fontWeightMap[weight],
            // NOTE: it's required for Lightning to vertically position a string rendered onto canvas
            textBaseline: "bottom"
        };
    });
};
var makeFontTokyo = function(weight) {
    var _obj;
    return _obj = {}, _define_property._(_obj, _constants.HD, makeFont(48, 62, weight)), _define_property._(_obj, _constants.FULL_HD, makeFont(64, 83, weight)), _obj;
};
var makeFontOslo = function(weight) {
    var _obj;
    return _obj = {}, _define_property._(_obj, _constants.HD, makeFont(40, 52, weight)), _define_property._(_obj, _constants.FULL_HD, makeFont(48, 62, weight)), _obj;
};
var makeFontParis = function(weight) {
    var _obj;
    return _obj = {}, _define_property._(_obj, _constants.HD, makeFont(32, 48, weight)), _define_property._(_obj, _constants.FULL_HD, makeFont(36, 48, weight)), _obj;
};
var makeFontKinshasa = function(weight) {
    var _obj;
    return _obj = {}, _define_property._(_obj, _constants.HD, makeFont(24, 36, weight)), _define_property._(_obj, _constants.FULL_HD, makeFont(32, 48, weight)), _obj;
};
var makeFontOttawa = function(weight) {
    var _obj;
    return _obj = {}, _define_property._(_obj, _constants.HD, makeFont(20, 30, weight)), _define_property._(_obj, _constants.FULL_HD, makeFont(24, 36, weight)), _obj;
};
var makeFontBerlin = function(weight) {
    var _obj;
    return _obj = {}, _define_property._(_obj, _constants.HD, makeFont(16, 24, weight)), _define_property._(_obj, _constants.FULL_HD, makeFont(20, 30, weight)), _obj;
};
var makeFontMadrid = function(weight) {
    var _obj;
    return _obj = {}, _define_property._(_obj, _constants.HD, makeFont(14, 21, weight)), _define_property._(_obj, _constants.FULL_HD, makeFont(18, 27, weight)), _obj;
};
var makeFontBoston = function(weight) {
    var _obj;
    return _obj = {}, _define_property._(_obj, _constants.HD, makeFont(12, 18, weight)), _define_property._(_obj, _constants.FULL_HD, makeFont(16, 24, weight)), _obj;
};
var makeFontMexico = function(weight) {
    var _obj;
    return _obj = {}, _define_property._(_obj, _constants.HD, makeFont(10, 15, weight)), _define_property._(_obj, _constants.FULL_HD, makeFont(14, 21, weight)), _obj;
};
var makeFontLyon = function(weight) {
    var _obj;
    return _obj = {}, _define_property._(_obj, _constants.HD, makeFont(12, 12, weight)), _define_property._(_obj, _constants.FULL_HD, makeFont(24, 31, weight)), _obj;
};
var _obj;
var FONTS = (_obj = {}, // Tokyo
_define_property._(_obj, _constants1.FONT.TOKYO_4, makeFontTokyo(_constants1.FONT_WEIGHT.ID_4)), // Oslo
_define_property._(_obj, _constants1.FONT.OSLO_1, makeFontOslo(_constants1.FONT_WEIGHT.ID_1)), _define_property._(_obj, _constants1.FONT.OSLO_2, makeFontOslo(_constants1.FONT_WEIGHT.ID_2)), _define_property._(_obj, _constants1.FONT.OSLO_3, makeFontOslo(_constants1.FONT_WEIGHT.ID_3)), // Paris
_define_property._(_obj, _constants1.FONT.PARIS_1, makeFontParis(_constants1.FONT_WEIGHT.ID_1)), _define_property._(_obj, _constants1.FONT.PARIS_2, makeFontParis(_constants1.FONT_WEIGHT.ID_2)), _define_property._(_obj, _constants1.FONT.PARIS_3, makeFontParis(_constants1.FONT_WEIGHT.ID_3)), // Kinshasa
_define_property._(_obj, _constants1.FONT.KINSHASA_1, makeFontKinshasa(_constants1.FONT_WEIGHT.ID_1)), _define_property._(_obj, _constants1.FONT.KINSHASA_2, makeFontKinshasa(_constants1.FONT_WEIGHT.ID_2)), _define_property._(_obj, _constants1.FONT.KINSHASA_3, makeFontKinshasa(_constants1.FONT_WEIGHT.ID_3)), // Ottawa
_define_property._(_obj, _constants1.FONT.OTTAWA_1, makeFontOttawa(_constants1.FONT_WEIGHT.ID_1)), _define_property._(_obj, _constants1.FONT.OTTAWA_2, makeFontOttawa(_constants1.FONT_WEIGHT.ID_2)), _define_property._(_obj, _constants1.FONT.OTTAWA_3, makeFontOttawa(_constants1.FONT_WEIGHT.ID_3)), // Berlin
_define_property._(_obj, _constants1.FONT.BERLIN_1, makeFontBerlin(_constants1.FONT_WEIGHT.ID_1)), _define_property._(_obj, _constants1.FONT.BERLIN_2, makeFontBerlin(_constants1.FONT_WEIGHT.ID_2)), _define_property._(_obj, _constants1.FONT.BERLIN_3, makeFontBerlin(_constants1.FONT_WEIGHT.ID_3)), // Madrid
_define_property._(_obj, _constants1.FONT.MADRID_1, makeFontMadrid(_constants1.FONT_WEIGHT.ID_1)), _define_property._(_obj, _constants1.FONT.MADRID_2, makeFontMadrid(_constants1.FONT_WEIGHT.ID_2)), _define_property._(_obj, _constants1.FONT.MADRID_3, makeFontMadrid(_constants1.FONT_WEIGHT.ID_3)), // Boston
_define_property._(_obj, _constants1.FONT.BOSTON_1, makeFontBoston(_constants1.FONT_WEIGHT.ID_1)), _define_property._(_obj, _constants1.FONT.BOSTON_2, makeFontBoston(_constants1.FONT_WEIGHT.ID_2)), _define_property._(_obj, _constants1.FONT.BOSTON_3, makeFontBoston(_constants1.FONT_WEIGHT.ID_3)), // Mexico
_define_property._(_obj, _constants1.FONT.MEXICO_1, makeFontMexico(_constants1.FONT_WEIGHT.ID_1)), _define_property._(_obj, _constants1.FONT.MEXICO_2, makeFontMexico(_constants1.FONT_WEIGHT.ID_2)), _define_property._(_obj, _constants1.FONT.MEXICO_3, makeFontMexico(_constants1.FONT_WEIGHT.ID_3)), // Lyon
_define_property._(_obj, _constants1.FONT.LYON_1, makeFontLyon(_constants1.FONT_WEIGHT.ID_1)), _define_property._(_obj, _constants1.FONT.LYON_2, makeFontLyon(_constants1.FONT_WEIGHT.ID_2)), _define_property._(_obj, _constants1.FONT.LYON_3, makeFontLyon(_constants1.FONT_WEIGHT.ID_3)), _obj);


/***/ }),

/***/ 55214:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    descriptors: function() {
        return descriptors;
    },
    fontFamily: function() {
        return fontFamily;
    },
    fontWeightMap: function() {
        return fontWeightMap;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
var _RTLUnitedTextRegularwoff = /*#__PURE__*/ _interop_require_default._(__webpack_require__(23713));
var _RTLUnitedTextBoldwoff = /*#__PURE__*/ _interop_require_default._(__webpack_require__(20836));
var _constants = __webpack_require__(24728);
var _utils = __webpack_require__(64083);
var fontFamily = "Source Sans Pro";
var _obj;
var fontWeightMap = (_obj = {}, _define_property._(_obj, _constants.FONT_WEIGHT.ID_1, _constants.OPEN_TYPE_WEIGHT.REGULAR), _define_property._(_obj, _constants.FONT_WEIGHT.ID_2, _constants.OPEN_TYPE_WEIGHT.REGULAR), _define_property._(_obj, _constants.FONT_WEIGHT.ID_3, _constants.OPEN_TYPE_WEIGHT.BOLD), _define_property._(_obj, _constants.FONT_WEIGHT.ID_4, _constants.OPEN_TYPE_WEIGHT.BOLD), _obj);
var makeCurrentFontDescriptor = function(url, weight) {
    return (0, _utils.makeFontDescriptor)(fontFamily, url, weight);
};
var descriptors = [
    makeCurrentFontDescriptor(_RTLUnitedTextRegularwoff.default, fontWeightMap[_constants.FONT_WEIGHT.ID_1]),
    makeCurrentFontDescriptor(_RTLUnitedTextRegularwoff.default, fontWeightMap[_constants.FONT_WEIGHT.ID_2]),
    makeCurrentFontDescriptor(_RTLUnitedTextBoldwoff.default, fontWeightMap[_constants.FONT_WEIGHT.ID_3])
];


/***/ }),

/***/ 18411:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    FONT: function() {
        return _constants1.FONT;
    },
    FONT_TYPE: function() {
        return _constants1.FONT_TYPE;
    },
    descriptors: function() {
        return _dictionary.descriptors;
    },
    getFont: function() {
        return getFont;
    }
});
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _constants = __webpack_require__(34952);
var _dictionary = __webpack_require__(64206);
var _constants1 = __webpack_require__(24728);
var getFont = function(name) {
    var resolution = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _constants.FULL_HD, fontType = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : _constants1.FONT_TYPE.MAIN;
    return (0, _get.default)(_dictionary.FONTS, [
        name,
        resolution,
        fontType
    ], {});
};


/***/ }),

/***/ 64083:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "makeFontDescriptor", ({
    enumerable: true,
    get: function() {
        return makeFontDescriptor;
    }
}));
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(88801);
var makeFontDescriptor = function(family, url, weight) {
    return {
        family: family,
        url: url,
        descriptors: {
            weight: weight
        }
    };
};


/***/ }),

/***/ 20747:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
var _async_to_generator = __webpack_require__(24146);
var _interop_require_default = __webpack_require__(81200);
var _interop_require_wildcard = __webpack_require__(95316);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(88801);
var _device = __webpack_require__(34670);
var _appsettings = __webpack_require__(20944);
var _deeplinkutils = __webpack_require__(38093);
var _index = /*#__PURE__*/ _interop_require_default._(__webpack_require__(27159));
var boot = function() {
    var _ref = _async_to_generator._(function() {
        var model, platformSettings, app, canvas;
        return _ts_generator._(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, _deeplinkutils.handleDeeplink)()
                    ];
                case 1:
                    _state.sent();
                    return [
                        4,
                        _device.deviceInfo.getModel()
                    ];
                case 2:
                    model = _state.sent();
                    window.RDK_MODEL_NAME = model;
                    platformSettings = (0, _appsettings.getSettings)().platformSettings;
                    if (true) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        Promise.resolve().then(function() {
                            return /*#__PURE__*/ _interop_require_wildcard._(__webpack_require__(55573));
                        })
                    ];
                case 3:
                    _state.sent();
                    _state.label = 4;
                case 4:
                    // mount the app renderer on the HTML page
                    app = (0, _index.default)();
                    canvas = app.stage.getCanvas();
                    document.body.appendChild(canvas);
                    return [
                        2
                    ];
            }
        });
    });
    return function boot() {
        return _ref.apply(this, arguments);
    };
}();
boot();


/***/ }),

/***/ 43474:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "CheckBoxBlock", ({
    enumerable: true,
    get: function() {
        return CheckBoxBlock;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(65759);
var _sdk = __webpack_require__(29956);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _checkBoxBlockstyle = __webpack_require__(40571);
var _checkboxcomponent = __webpack_require__(51109);
var CheckBoxBlock = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(CheckBoxBlock, _Lightning_Component);
    var _super = _create_super._(CheckBoxBlock);
    function CheckBoxBlock() {
        _class_call_check._(this, CheckBoxBlock);
        return _super.apply(this, arguments);
    }
    _create_class._(CheckBoxBlock, [
        {
            key: "_build",
            value: function _build() {
                this.checked = false;
            }
        },
        {
            key: "data",
            set: function set(param) {
                var title = param.title, description = param.description;
                this.patch({
                    TextWrapper: {
                        Title: {
                            text: {
                                text: title
                            }
                        },
                        Description: {
                            text: {
                                text: description
                            }
                        }
                    }
                });
            }
        },
        {
            key: "checked",
            get: function get() {
                return this._checked;
            },
            set: function set(value) {
                this.tag("Checkbox").checked = value;
                this._checked = value;
            }
        },
        {
            key: "_handleEnter",
            value: function _handleEnter() {
                this.checked = !this.checked;
                return false;
            }
        },
        {
            key: "_focus",
            value: function _focus() {
                this.patch((0, _checkBoxBlockstyle.getFocusedStyle)());
            }
        },
        {
            key: "_unfocus",
            value: function _unfocus() {
                this.patch((0, _checkBoxBlockstyle.getUnfocusedStyle)());
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    rect: true,
                    Checkbox: {
                        type: _checkboxcomponent.Checkbox
                    },
                    TextWrapper: {
                        Title: {},
                        Description: {}
                    },
                    Border: {
                        type: _sdk.Lightning.components.BorderComponent
                    }
                }, (0, _checkBoxBlockstyle.getInitialStyle)());
            }
        }
    ]);
    return CheckBoxBlock;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 40571:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    PADDING: function() {
        return PADDING;
    },
    TEXT_PADDING_RIGHT: function() {
        return TEXT_PADDING_RIGHT;
    },
    TITLE_PADDING: function() {
        return TITLE_PADDING;
    },
    WIDTH: function() {
        return WIDTH;
    },
    colors: function() {
        return colors;
    },
    getFocusedStyle: function() {
        return getFocusedStyle;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    getUnfocusedStyle: function() {
        return getUnfocusedStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _object_spread = __webpack_require__(76247);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(88801);
var _constants = __webpack_require__(34952);
var _typography = __webpack_require__(18411);
var _theme = __webpack_require__(51397);
var _sizes = __webpack_require__(82699);
var _style = __webpack_require__(65082);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var WIDTH = (_obj = {}, _define_property._(_obj, _constants.HD, 640), _define_property._(_obj, _constants.FULL_HD, 960), _obj);
var _obj1;
var PADDING = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 16), _define_property._(_obj1, _constants.FULL_HD, 24), _obj1);
var _obj2;
var TITLE_PADDING = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 8), _define_property._(_obj2, _constants.FULL_HD, 8), _obj2);
var _obj3;
var TEXT_PADDING_RIGHT = (_obj3 = {}, _define_property._(_obj3, _constants.HD, 48), _define_property._(_obj3, _constants.FULL_HD, 72), _obj3);
var colors = {
    unfocused: (0, _theme.makeThemeColor)(_theme.TERTIARY),
    focused: (0, _theme.makeThemeColor)(_theme.PRIMARY, 0.3)
};
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var screenSize = context.screenSize, colorMode = context.colorMode;
    var width = WIDTH[screenSize];
    var wordWrapWidth = width - TEXT_PADDING_RIGHT[screenSize];
    var titleFont = (0, _typography.getFont)(_typography.FONT.BERLIN_3, screenSize);
    var descriptionFont = (0, _typography.getFont)(_typography.FONT.BERLIN_1, screenSize);
    return {
        w: width,
        color: colors.unfocused[colorMode],
        flex: {
            direction: "row",
            padding: PADDING[screenSize],
            wrap: true
        },
        TextWrapper: {
            flex: {
                direction: "column"
            },
            w: _sizes.identity,
            Title: {
                text: _object_spread._({
                    wordWrapWidth: wordWrapWidth,
                    wordWrap: true
                }, titleFont),
                paddingBottom: TITLE_PADDING[screenSize],
                wordWrap: true
            },
            Description: {
                text: _object_spread._({
                    wordWrapWidth: wordWrapWidth,
                    wordWrap: true
                }, descriptionFont)
            }
        },
        Checkbox: {
            mountX: 1,
            x: width - PADDING[screenSize]
        },
        Border: {
            borderWidthBottom: 1,
            colorBorder: colors.focused[colorMode],
            w: _sizes.identity,
            mountY: 1,
            x: -PADDING[screenSize],
            y: PADDING[screenSize]
        }
    };
};
var getFocusedStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var colorMode = context.colorMode;
    return {
        color: colors.focused[colorMode]
    };
};
var getUnfocusedStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var colorMode = context.colorMode;
    return {
        color: colors.unfocused[colorMode]
    };
};


/***/ }),

/***/ 51109:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "Checkbox", ({
    enumerable: true,
    get: function() {
        return Checkbox;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(52318);
var _sdk = __webpack_require__(29956);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _checkboxstyle = __webpack_require__(89960);
var _iconcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(70160));
var Checkbox = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(Checkbox, _Lightning_Component);
    var _super = _create_super._(Checkbox);
    function Checkbox() {
        _class_call_check._(this, Checkbox);
        return _super.apply(this, arguments);
    }
    _create_class._(Checkbox, [
        {
            key: "_construct",
            value: function _construct() {
                this._checked = false;
                this._disabled = false;
            }
        },
        {
            key: "checked",
            set: function set(value) {
                this._checked = value;
                this.patch(value ? (0, _checkboxstyle.getCheckedStyle)() : (0, _checkboxstyle.getInitialStyle)());
            }
        },
        {
            key: "disabled",
            set: function set(value) {
                this._disabled = value;
                this.patch(value ? (0, _checkboxstyle.getDisabledStyle)() : (0, _checkboxstyle.getInitialStyle)());
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Border: {
                        type: _sdk.Lightning.components.BorderComponent
                    },
                    Icon: {
                        type: _iconcomponent.default
                    }
                }, (0, _checkboxstyle.getInitialStyle)());
            }
        }
    ]);
    return Checkbox;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 89960:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ICON_SIZE: function() {
        return ICON_SIZE;
    },
    SIZE: function() {
        return SIZE;
    },
    colors: function() {
        return colors;
    },
    getCheckedStyle: function() {
        return getCheckedStyle;
    },
    getDisabledStyle: function() {
        return getDisabledStyle;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
var _define_property = __webpack_require__(21228);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(42578);
var _constants = __webpack_require__(34952);
var _theme = __webpack_require__(51397);
var _style = __webpack_require__(65082);
var _sizes = __webpack_require__(82699);
var _iconconstants = __webpack_require__(48112);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var SIZE = (_obj = {}, _define_property._(_obj, _constants.HD, 16), _define_property._(_obj, _constants.FULL_HD, 16), _obj);
var _obj1;
var ICON_SIZE = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 12), _define_property._(_obj1, _constants.FULL_HD, 12), _obj1);
var colors = {
    primary: (0, _theme.makeThemeColor)(_theme.PRIMARY),
    primaryDisabled: (0, _theme.makeThemeColor)(_theme.PRIMARY, 0.3)
};
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var screenSize = context.screenSize, colorMode = context.colorMode;
    return {
        w: SIZE[screenSize],
        h: SIZE[screenSize],
        Border: {
            borderWidth: 1,
            colorBorder: colors.primary[colorMode],
            w: _sizes.identity,
            h: _sizes.identity
        },
        Icon: {
            mount: 0.5,
            x: _sizes.middle,
            y: _sizes.middle,
            w: SIZE[screenSize],
            h: SIZE[screenSize],
            visible: false,
            iconData: {
                picto: {
                    name: "Check",
                    type: _iconconstants.ICON_TYPE.SIMPLE_ICON
                },
                viewBox: {
                    w: ICON_SIZE[screenSize],
                    h: ICON_SIZE[screenSize]
                }
            }
        }
    };
};
var getDisabledStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var colorMode = context.colorMode;
    return {
        color: null,
        Border: {
            colorBorder: colors.primaryDisabled[colorMode]
        },
        Icon: {
            visible: false
        }
    };
};
var getCheckedStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var colorMode = context.colorMode;
    return {
        color: colors.primary[colorMode],
        Border: {
            colorBorder: colors.primary[colorMode]
        },
        Icon: {
            visible: true
        }
    };
};


/***/ }),

/***/ 27159:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
// NOTE: NewRelic could be enabled here however it breaks playback on both Ziggo and KPN therefore it's commented out
// import './thirdParty/newrelic/newrelic.agent';

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
var _sdk = __webpack_require__(29956);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _appcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(92972));
var _polyfills = __webpack_require__(78941);
var _store = __webpack_require__(15426);
var _appsettings = __webpack_require__(20944);
(0, _polyfills.setup)(window);
var appLauncher = function AppLauncher(appSettings, platformSettings, appStoreData) {
    var settings = (0, _appsettings.getSettings)(appSettings, platformSettings);
    _lightningjsredux.default.init((0, _store.initStore)());
    return (0, _sdk.Launch)(_appcomponent.default, settings.appSettings, settings.platformSettings, appStoreData || {});
};
// mimic Lightning pre-build app launcher
if ({"PELO_PLATFORM":"magenta","APP_VERSION":"1.51.2","OPTIONS":"{\"platform\":\"magenta\",\"packaged\":false,\"debug\":false,\"skipHook\":false,\"skipNativeBuild\":true,\"skipBundler\":false}","GITHUB_STATE":"/runner/_work/_temp/_runner_file_commands/save_state_1aea6be7-8451-44d1-976b-920c5fab1345","npm_package_dependencies__babel_runtime":"7.22.3","npm_package_dependencies__pelo_plugins_screen":"workspace:*","npm_package_dependencies_regenerator_runtime":"0.13.11","npm_package_devDependencies_identity_obj_proxy":"3.0.0","npm_package_scripts_build_config_rtlnl":"APP_CUSTOMER=rtlnl node scripts/build-config","KUBERNETES_SERVICE_PORT":"443","KUBERNETES_PORT":"tcp://[fd24:3fac:1f16::1]:443","npm_package_dependencies_immutable_set":"2.1.0","npm_package_devDependencies__storybook_addon_knobs":"6.2.9","npm_package_devDependencies_prettier_eslint_cli":"7.1.0","npm_package_scripts_preinstall":"npx only-allow pnpm","npm_package_devDependencies__storybook_addon_docs":"6.2.9","npm_package_devDependencies_jest":"29.5.0","npm_package_devDependencies_webpack_bundle_analyzer":"4.10.2","npm_package_scripts_dev_rtlnl":"APP_CUSTOMER=rtlnl pnpm dev","npm_config_user_agent":"pnpm/9.14.4 npm/? node/v22.19.0 linux x64","CI":"true","npm_package_dependencies__bedrock_rdk_constants":"workspace:*","npm_package_dependencies__tornado_rdk_theme":"workspace:*","npm_package_dependencies_abortcontroller_polyfill":"1.7.8","npm_package_devDependencies__lightningjs_cli":"2.2.0","npm_package_scripts_build_config_rtlhu":"APP_CUSTOMER=rtlhu node scripts/build-config","npm_package_scripts_prod_rtlnl":"APP_CUSTOMER=rtlnl pnpm prod","HOSTNAME":"app-bedrock-rdk-deploy-npc97-bp8xd","RUNNER_ENVIRONMENT":"self-hosted","GITHUB_ENV":"/runner/_work/_temp/_runner_file_commands/set_env_1aea6be7-8451-44d1-976b-920c5fab1345","UPLOAD_SOURCE_MAPS":"false","npm_package_dependencies__bedrock_rdk_utils":"workspace:*","npm_node_execpath":"/opt/hostedtoolcache/node/22.19.0/x64/bin/node","GITHUB_ACTIONS_RUNNER_EXTRA_USER_AGENT":"actions-runner-controller/v0.27.6","RUNNER_EPHEMERAL":"true","SHLVL":"4","npm_package_packageManager":"pnpm@9.14.4","npm_package_dependencies__bedrock_rdk_lng_storybook":"workspace:*","npm_package_devDependencies__swc_core":"1.3.95","npm_package_scripts_dev_rtlhu":"APP_CUSTOMER=rtlhu pnpm dev","npm_package_scripts_nr_create_browser_applications":"node scripts/createNewRelicApps.js","HOME":"/home/runner","npm_package_devDependencies__babel_plugin_proposal_class_properties":"7.18.6","npm_package_devDependencies__bedrock_package_json_loader":"1.2.4","npm_package_devDependencies_jest_webgl_canvas_mock":"0.2.3","npm_package_scripts_prod_rtlhu":"APP_CUSTOMER=rtlhu pnpm prod","RUNNER_ORG":"","AWS_ROLE_ARN":"arn:aws:iam::081993058424:role/irsa/runners/app-bedrock-rdk-deploy","RUNNER_TEMP":"/runner/_work/_temp","GITHUB_EVENT_PATH":"/runner/_work/_temp/_github_workflow/event.json","npm_package_devDependencies_eslint_config_prettier":"9.0.0","npm_package_scripts_lint_filenames":"node scripts/checkFileScopes.js","npm_package_scripts_server":"http-server -c-1 build","npm_package_scripts_storybook_rtlde":"APP_CUSTOMER=rtlde start-storybook -p 6006","DOCKER_ENABLED":"true","GITHUB_REPOSITORY_OWNER":"m6web","npm_package_engines_node":"22.x","npm_package_dependencies__bedrock_html5_engine":"3.6.24","npm_package_devDependencies__6play_ryp":"3.2.4","npm_package_devDependencies__bedrock_github_api_utils":"1.0.1","npm_package_scripts_lint_json":"pnpm sort-keys:json --lint && prettier-eslint --list-different '/{.,}*.json' --ignore-path '**/package.json'","RUNNER_WORKDIR":"/runner/_work","GENERATE_SOURCEMAP":"true","AWS_WEB_IDENTITY_TOKEN_FILE":"/var/run/secrets/eks.amazonaws.com/serviceaccount/token","GITHUB_RETENTION_DAYS":"7","npm_package_devDependencies__pelo_platforms_vodafone":"10.0.0-alpha.1","npm_package_devDependencies_minimist":"1.2.8","npm_package_scripts_i18n_pull":"node ./scripts/i18nPull.js","npm_package_scripts_lint_md":"pnpm prettier-eslint --list-different $PWD/'**/*.md' $PWD/'.*/**/*.md'","GITHUB_REPOSITORY_OWNER_ID":"5","GITHUB_HEAD_REF":"","npm_package_dependencies_redux_thunk":"2.3.0","ACTIONS_RUNNER_HOOK_JOB_STARTED":"/etc/arc/hooks/job-started.sh","npm_package_devDependencies__swc_plugin_transform_imports":"1.5.94","npm_package_devDependencies_source_map_explorer":"1.6.0","npm_package_cypress_cucumber_preprocessor_stepDefinitions_0":"cypress/e2e/common/*.js","GITHUB_GRAPHQL_URL":"https://github.m6web.fr/api/graphql","REF":"v1.51.2","npm_package_dependencies__tornado_rdk_icons":"workspace:*","npm_package_dependencies_algoliasearch":"4.12.1","npm_package_dependencies_superagent":"8.0.9","npm_package_devDependencies_babel_loader":"9.1.2","npm_package_devDependencies_slack":"11.0.2","npm_package_scripts_build_config":"node scripts/build-config","npm_package_cypress_cucumber_preprocessor_stepDefinitions_1":"cypress/e2e/[filepart]/**/*.js","npm_package_dependencies_jwt_decode":"2.2.0","npm_package_devDependencies__babel_preset_env":"7.12.1","npm_package_scripts_e2e_rtlnl":"APP_CUSTOMER=rtlnl pnpm cypress open --e2e -b chrome","npm_package_pnpm_overrides__lightningjs_core":"2.9.0","npm_package_cypress_cucumber_preprocessor_stepDefinitions_2":"cypress/e2e/[filepart].js","GITHUB_URL":"https://github.m6web.fr/","RUNNER_ASSETS_DIR":"/runnertmp","AWS_STS_REGIONAL_ENDPOINTS":"regional","npm_package_devDependencies__babel_plugin_transform_runtime":"7.22.4","npm_package_devDependencies_inquirer":"8.1.5","npm_package_scripts_dev":"APP_ENV=development pelo run","RUNNER_OS":"Linux","GITHUB_API_URL":"https://github.m6web.fr/api/v3","MAXPROC":"8","RUNNER_LABELS":"self-hosted,app-bedrock-rdk-deploy","npm_package_devDependencies__pelo_platforms_ziggo":"10.0.0-alpha.1","npm_package_devDependencies_eslint_plugin_import":"2.28.1","npm_package_scripts_logs":"node scripts/logs.js","npm_package_scripts_prod":"APP_ENV=prod pelo run","_":"/home/runner/setup-pnpm/node_modules/.bin/pnpm","RUNNER_GROUP":"blue-gha-eks-bedrock-tech","HELM_REGISTRY_CONFIG":"/home/runner/.docker/config.json","GITHUB_WORKFLOW":"🏷 Release","npm_package_private":"true","npm_package_dependencies_sprintf_js":"1.1.2","npm_package_devDependencies__m6web_eslint_config":"3.5.0","npm_package_devDependencies_jsonlint":"1.6.3","npm_package_scripts_build_rtlnl":"APP_CUSTOMER=rtlnl pnpm build","npm_package_dependencies__bedrock_rdk_media_engine":"workspace:*","npm_package_dependencies_lightningjs_redux":"workspace:*","npm_package_devDependencies__babel_plugin_proposal_decorators":"7.22.3","npm_package_scripts_lint":"pnpm lint:js && pnpm lint:md && pnpm lint:json && pnpm lint:filenames","npm_config_registry":"https://verdaccio.bedrock.tech","GITHUB_RUN_ID":"4275928","npm_package_dependencies__bedrock_fido_sdk":"30.19.0","npm_package_dependencies_core_js":"3.32.1","npm_package_devDependencies__swc_jest":"0.2.29","npm_package_scripts_lint_tf":"terraform fmt -check -recursive -diff .cloud/terraform","npm_package_scripts_sort_keys_json":"node ./scripts/sortKeysJson.js","npm_package_pnpm_overrides_lodash":"4.17.21","GITHUB_REF_TYPE":"branch","GITHUB_WORKFLOW_SHA":"ab23f250364979d926e7565a2779bba0daadf009","KUBERNETES_PORT_443_TCP_ADDR":"fd24:3fac:1f16::1","GITHUB_BASE_REF":"","ImageOS":"ubuntu22","npm_package_devDependencies_dotenv_expand":"5.1.0","npm_package_devDependencies_html_webpack_plugin":"5.5.0","npm_package_scripts_build_rtlhu":"APP_CUSTOMER=rtlhu pnpm build","GITHUB_WORKFLOW_REF":"m6web/app-bedrock-rdk/.github/workflows/release.yml@refs/heads/master","GITHUB_ACTION_REPOSITORY":"","npm_config_node_gyp":"/home/runner/setup-pnpm/node_modules/.pnpm/pnpm@9.14.4/node_modules/pnpm/dist/node_modules/node-gyp/bin/node-gyp.js","PATH":"/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.bin:/home/runner/setup-pnpm/node_modules/.pnpm/pnpm@9.14.4/node_modules/pnpm/dist/node-gyp-bin:/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.bin:/opt/hostedtoolcache/node/22.19.0/x64/bin:/home/runner/setup-pnpm/node_modules/.bin:/usr/local/sbin:/usr/local/bin:/usr/sbin:/usr/bin:/sbin:/bin:/home/runner/.local/bin/","RUNNER_TRACKING_ID":"github_7c5f522c-ab40-4e86-a7b5-77a0008d8715","RUNNER_TOOL_CACHE":"/opt/hostedtoolcache","npm_package_name":"app-bedrock-rdk","npm_package_repository_type":"git","npm_package_dependencies_serve":"14.1.2","npm_package_devDependencies__babel_eslint_parser":"7.22.15","npm_package_scripts_lint_js":"pnpm eslint --max-warnings=0 .pelo.config.js src/ packages/ platforms/ --cache","NODE":"/opt/hostedtoolcache/node/22.19.0/x64/bin/node","GITHUB_ACTION":"__run_4","GITHUB_RUN_NUMBER":"246","GITHUB_TRIGGERING_ACTOR":"skovalchuk-externe","RUNNER_ARCH":"X64","KUBERNETES_PORT_443_TCP_PORT":"443","npm_package_devDependencies_eslint_config_airbnb_base":"15.0.0","npm_package_scripts_analyze":"APP_ENV=detective pnpm build","npm_package_scripts_build_config_rtlde":"APP_CUSTOMER=rtlde node scripts/build-config","npm_config_frozen_lockfile":"","RUN_URL":"https://github.m6web.fr/m6web/app-bedrock-rdk/actions/runs/4275928","KUBERNETES_PORT_443_TCP_PROTO":"tcp","npm_package_dependencies__pelo_plugins_device":"workspace:*","npm_package_devDependencies__bedrock_deploy_event":"0.11.0","npm_package_devDependencies__pelo_platforms_web":"10.0.0-alpha.1","npm_package_devDependencies__swc_helpers":"0.5.3","npm_package_devDependencies_glob":"7.1.6","npm_package_devDependencies_prettier_eslint":"15.0.1","npm_package_dependencies__firebolt_js_sdk":"1.7.0","npm_package_dependencies__lightningjs_core":"2.9.0","npm_package_dependencies_history":"4.9.0","npm_package_dependencies_redux":"4.0.5","npm_package_devDependencies__storybook_theming":"6.2.9","npm_package_devDependencies_eslint":"8.50.0","npm_package_devDependencies_webpack":"5.88.2","npm_package_scripts_dev_rtlde":"APP_CUSTOMER=rtlde pnpm dev","npm_package_scripts_format_md":"prettier-eslint --write $PWD/'**/*.md' $PWD/'.*/**/*.md'","npm_package_scripts_storybook_rtlnl":"APP_CUSTOMER=rtlnl start-storybook -p 6006","RUNNER_NAME":"app-bedrock-rdk-deploy-npc97-bp8xd","PIP_REQUIRE_VIRTUALENV":"true","GITHUB_REF_NAME":"master","GITHUB_REPOSITORY":"m6web/app-bedrock-rdk","S3_PATH":"s3://bedrock-rdk-rtlde-prod-magenta","npm_package_devDependencies__storybook_html":"6.2.9","npm_package_devDependencies_copy_webpack_plugin":"11.0.0","npm_package_devDependencies_dotenv":"16.0.3","npm_package_scripts_e2e":"pnpm cypress open --e2e -b chrome","npm_package_scripts_prod_rtlde":"APP_CUSTOMER=rtlde pnpm prod","npm_lifecycle_script":"pelo build \"magenta\" \"--skip-native-build\"","GITHUB_ACTION_REF":"","DEBIAN_FRONTEND":"noninteractive","npm_package_devDependencies__babel_runtime_corejs3":"7.22.3","npm_package_devDependencies__cypress_webpack_preprocessor":"6.0.0","npm_package_devDependencies__pelo_core":"10.0.0-alpha.1","npm_package_devDependencies__storybook_addons":"6.2.9","npm_package_scripts_test":"PELO_PLATFORM=rdk APP_ENV=test node scripts/test --config=config/jest/config.js","GITHUB_REPOSITORY_ID":"2571","GITHUB_ACTIONS":"true","GOPROXY":"https://goproxy.services.bedrock.tech","NODE_PATH":"/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.pnpm/@pelo+cli@10.0.0-alpha.1_@babel+core@7.27.4_@swc+core@1.3.95_@swc+helpers@0.5.3__@types+webpa_eyh3qr2suoq7louvyapz62n3cq/node_modules/@pelo/cli/bin/node_modules:/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.pnpm/@pelo+cli@10.0.0-alpha.1_@babel+core@7.27.4_@swc+core@1.3.95_@swc+helpers@0.5.3__@types+webpa_eyh3qr2suoq7louvyapz62n3cq/node_modules/@pelo/cli/node_modules:/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.pnpm/@pelo+cli@10.0.0-alpha.1_@babel+core@7.27.4_@swc+core@1.3.95_@swc+helpers@0.5.3__@types+webpa_eyh3qr2suoq7louvyapz62n3cq/node_modules/@pelo/node_modules:/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.pnpm/@pelo+cli@10.0.0-alpha.1_@babel+core@7.27.4_@swc+core@1.3.95_@swc+helpers@0.5.3__@types+webpa_eyh3qr2suoq7louvyapz62n3cq/node_modules:/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.pnpm/node_modules:/home/runner/setup-pnpm/node_modules/.pnpm/pnpm@9.14.4/node_modules/pnpm/bin/node_modules:/home/runner/setup-pnpm/node_modules/.pnpm/pnpm@9.14.4/node_modules/pnpm/node_modules:/home/runner/setup-pnpm/node_modules/.pnpm/pnpm@9.14.4/node_modules:/home/runner/setup-pnpm/node_modules/.pnpm/node_modules","npm_package_repository_url":"https://github.m6web.fr/m6web/app-bedrock-rdk.git","npm_package_version":"1.51.2","npm_package_dependencies__bedrock_ad_engine":"5.39.0","npm_package_devDependencies__m6web_eslint_plugin_i18n":"2.0.1","npm_package_devDependencies_jest_environment_jsdom":"29.5.0","npm_package_scripts_storybook_rtlhu":"APP_CUSTOMER=rtlhu start-storybook -p 6006","npm_package_pnpm_overrides__lightningjs_sdk":"5.5.5","npm_lifecycle_event":"build","ACTIONS_RUNNER_HOOK_JOB_COMPLETED":"/etc/arc/hooks/job-completed.sh","GITHUB_REF_PROTECTED":"true","GONOSUMDB":"github.m6web.fr","GONOPROXY":"none","npm_package_dependencies_uuid":"10.0.0","npm_package_scripts_build":"pelo build \"magenta\" \"--skip-native-build\"","npm_package_scripts_upload":"node scripts/uploadToMetrologicalAppStore","GITHUB_WORKSPACE":"/runner/_work/app-bedrock-rdk/app-bedrock-rdk","GITHUB_JOB":"build_and_deploy","npm_package_author":"Bedrock","npm_package_engines_pnpm":"9.x.x","npm_package_dependencies__bedrock_youbora_adapter_adengine":"1.9.9","npm_package_dependencies_lodash":"4.17.21","npm_package_devDependencies_cypress":"13.3.0","npm_package_devDependencies_http_server":"14.1.1","npm_package_scripts_test_coverage":"PELO_PLATFORM=rdk APP_ENV=test node scripts/test --config=config/jest/config.js --coverage","GITHUB_SHA":"ab23f250364979d926e7565a2779bba0daadf009","GOMAXPROC":"8","GITHUB_RUN_ATTEMPT":"1","DOCKER_HOST":"unix:///run/docker.sock","npm_package_dependencies__bedrock_media_engine":"4.17.1","npm_package_devDependencies__pelo_cli":"10.0.0-alpha.1","KUBERNETES_SERVICE_PORT_HTTPS":"443","GOPRIVATE":"*.m6web.fr,*.bedrock.tech","GITHUB_REF":"refs/heads/master","KUBERNETES_PORT_443_TCP":"tcp://[fd24:3fac:1f16::1]:443","GITHUB_ACTOR":"skovalchuk-externe","npm_package_license":"UNLICENSED","npm_package_dependencies_markdown_it":"12.2.0","DOCKERD_IN_RUNNER":"false","npm_package_dependencies_crypto_js":"4.2.0","npm_package_dependencies_qrcode":"1.5.4","npm_package_dependencies_stream_browserify":"3.0.0","npm_package_devDependencies_eslint_plugin_prettier":"5.0.0","npm_package_scripts_format":"pnpm format:js && pnpm format:md && pnpm format:lang","npm_package_scripts_update_lang":"run-s 'i18n:pull {1}' format:lang --","GITHUB_PATH":"/runner/_work/_temp/_runner_file_commands/add_path_1aea6be7-8451-44d1-976b-920c5fab1345","PWD":"/runner/_work/app-bedrock-rdk/app-bedrock-rdk","IS_STAGING":"false","APP_ENV":"prod","GITHUB_ACTOR_ID":"627","KUBERNETES_SERVICE_HOST":"fd24:3fac:1f16::1","RUNNER_WORKSPACE":"/runner/_work/app-bedrock-rdk","npm_package_dependencies_path_to_regexp":"3.0.0","npm_package_scripts_explore":"source-map-explorer build/static/js/main.*","npm_package_scripts_format_tf":"terraform fmt -recursive -write=true .cloud/terraform","npm_execpath":"/home/runner/setup-pnpm/node_modules/.pnpm/pnpm@9.14.4/node_modules/pnpm/bin/pnpm.cjs","GITHUB_EVENT_NAME":"workflow_dispatch","GITHUB_SERVER_URL":"https://github.m6web.fr","GITHUB_OUTPUT":"/runner/_work/_temp/_runner_file_commands/set_output_1aea6be7-8451-44d1-976b-920c5fab1345","npm_package_dependencies__bedrock_rdk_config":"workspace:*","npm_package_devDependencies__pelo_platforms_kpn":"10.0.0-alpha.1","npm_package_devDependencies_es_check":"7.1.1","npm_package_devDependencies_fs_extra":"9.1.0","npm_package_devDependencies_swc_mut_cjs_exports":"0.86.17","RUNNER_STATUS_UPDATE_HOOK":"false","npm_package_dependencies_browser_cookies":"1.2.0","npm_package_dependencies_date_fns":"2.28.0","npm_package_devDependencies__badeball_cypress_cucumber_preprocessor":"18.0.6","npm_package_devDependencies_svgo_loader":"3.0.1","npm_package_scripts_build_storybook":"build-storybook -o dist-storybook","npm_command":"run-script","PNPM_SCRIPT_SRC_DIR":"/runner/_work/app-bedrock-rdk/app-bedrock-rdk","APP_CUSTOMER":"rtlde","npm_package_dependencies_storybook_addon_themes":"6.1.0","npm_package_devDependencies__storybook_addon_essentials":"6.2.9","npm_package_scripts_format_js":"prettier-eslint --write $PWD/'src/**/*.js' $PWD/'packages/**/*.js' $PWD/'platforms/**/*.js' $PWD/'config/**/*.js'","PNPM_HOME":"/home/runner/setup-pnpm/node_modules/.bin","RUNNER_ENTERPRISE":"","npm_package_dependencies__tornado_rdk_typography":"workspace:*","GITHUB_STEP_SUMMARY":"/runner/_work/_temp/_runner_file_commands/step_summary_1aea6be7-8451-44d1-976b-920c5fab1345","npm_package_dependencies__lightningjs_sdk":"5.5.5","npm_package_dependencies__pelo_plugins_keys":"workspace:*","npm_package_devDependencies_swc_loader":"0.2.3","npm_package_devDependencies_swc_minify_webpack_plugin":"2.1.1","npm_package_scripts_build_rtlde":"APP_CUSTOMER=rtlde pnpm build","npm_package_scripts_format_lang":"prettier-eslint --write $PWD/'lang/**/*.json'","npm_package_pnpm_overrides_webpack":"5.88.2","npm_package_pnpm_peerDependencyRules_allowedVersions_webpack":"5","INIT_CWD":"/runner/_work/app-bedrock-rdk/app-bedrock-rdk","NODE_ENV":"production"}.APP_ID) {
    var id = "APP_".concat({"PELO_PLATFORM":"magenta","APP_VERSION":"1.51.2","OPTIONS":"{\"platform\":\"magenta\",\"packaged\":false,\"debug\":false,\"skipHook\":false,\"skipNativeBuild\":true,\"skipBundler\":false}","GITHUB_STATE":"/runner/_work/_temp/_runner_file_commands/save_state_1aea6be7-8451-44d1-976b-920c5fab1345","npm_package_dependencies__babel_runtime":"7.22.3","npm_package_dependencies__pelo_plugins_screen":"workspace:*","npm_package_dependencies_regenerator_runtime":"0.13.11","npm_package_devDependencies_identity_obj_proxy":"3.0.0","npm_package_scripts_build_config_rtlnl":"APP_CUSTOMER=rtlnl node scripts/build-config","KUBERNETES_SERVICE_PORT":"443","KUBERNETES_PORT":"tcp://[fd24:3fac:1f16::1]:443","npm_package_dependencies_immutable_set":"2.1.0","npm_package_devDependencies__storybook_addon_knobs":"6.2.9","npm_package_devDependencies_prettier_eslint_cli":"7.1.0","npm_package_scripts_preinstall":"npx only-allow pnpm","npm_package_devDependencies__storybook_addon_docs":"6.2.9","npm_package_devDependencies_jest":"29.5.0","npm_package_devDependencies_webpack_bundle_analyzer":"4.10.2","npm_package_scripts_dev_rtlnl":"APP_CUSTOMER=rtlnl pnpm dev","npm_config_user_agent":"pnpm/9.14.4 npm/? node/v22.19.0 linux x64","CI":"true","npm_package_dependencies__bedrock_rdk_constants":"workspace:*","npm_package_dependencies__tornado_rdk_theme":"workspace:*","npm_package_dependencies_abortcontroller_polyfill":"1.7.8","npm_package_devDependencies__lightningjs_cli":"2.2.0","npm_package_scripts_build_config_rtlhu":"APP_CUSTOMER=rtlhu node scripts/build-config","npm_package_scripts_prod_rtlnl":"APP_CUSTOMER=rtlnl pnpm prod","HOSTNAME":"app-bedrock-rdk-deploy-npc97-bp8xd","RUNNER_ENVIRONMENT":"self-hosted","GITHUB_ENV":"/runner/_work/_temp/_runner_file_commands/set_env_1aea6be7-8451-44d1-976b-920c5fab1345","UPLOAD_SOURCE_MAPS":"false","npm_package_dependencies__bedrock_rdk_utils":"workspace:*","npm_node_execpath":"/opt/hostedtoolcache/node/22.19.0/x64/bin/node","GITHUB_ACTIONS_RUNNER_EXTRA_USER_AGENT":"actions-runner-controller/v0.27.6","RUNNER_EPHEMERAL":"true","SHLVL":"4","npm_package_packageManager":"pnpm@9.14.4","npm_package_dependencies__bedrock_rdk_lng_storybook":"workspace:*","npm_package_devDependencies__swc_core":"1.3.95","npm_package_scripts_dev_rtlhu":"APP_CUSTOMER=rtlhu pnpm dev","npm_package_scripts_nr_create_browser_applications":"node scripts/createNewRelicApps.js","HOME":"/home/runner","npm_package_devDependencies__babel_plugin_proposal_class_properties":"7.18.6","npm_package_devDependencies__bedrock_package_json_loader":"1.2.4","npm_package_devDependencies_jest_webgl_canvas_mock":"0.2.3","npm_package_scripts_prod_rtlhu":"APP_CUSTOMER=rtlhu pnpm prod","RUNNER_ORG":"","AWS_ROLE_ARN":"arn:aws:iam::081993058424:role/irsa/runners/app-bedrock-rdk-deploy","RUNNER_TEMP":"/runner/_work/_temp","GITHUB_EVENT_PATH":"/runner/_work/_temp/_github_workflow/event.json","npm_package_devDependencies_eslint_config_prettier":"9.0.0","npm_package_scripts_lint_filenames":"node scripts/checkFileScopes.js","npm_package_scripts_server":"http-server -c-1 build","npm_package_scripts_storybook_rtlde":"APP_CUSTOMER=rtlde start-storybook -p 6006","DOCKER_ENABLED":"true","GITHUB_REPOSITORY_OWNER":"m6web","npm_package_engines_node":"22.x","npm_package_dependencies__bedrock_html5_engine":"3.6.24","npm_package_devDependencies__6play_ryp":"3.2.4","npm_package_devDependencies__bedrock_github_api_utils":"1.0.1","npm_package_scripts_lint_json":"pnpm sort-keys:json --lint && prettier-eslint --list-different '/{.,}*.json' --ignore-path '**/package.json'","RUNNER_WORKDIR":"/runner/_work","GENERATE_SOURCEMAP":"true","AWS_WEB_IDENTITY_TOKEN_FILE":"/var/run/secrets/eks.amazonaws.com/serviceaccount/token","GITHUB_RETENTION_DAYS":"7","npm_package_devDependencies__pelo_platforms_vodafone":"10.0.0-alpha.1","npm_package_devDependencies_minimist":"1.2.8","npm_package_scripts_i18n_pull":"node ./scripts/i18nPull.js","npm_package_scripts_lint_md":"pnpm prettier-eslint --list-different $PWD/'**/*.md' $PWD/'.*/**/*.md'","GITHUB_REPOSITORY_OWNER_ID":"5","GITHUB_HEAD_REF":"","npm_package_dependencies_redux_thunk":"2.3.0","ACTIONS_RUNNER_HOOK_JOB_STARTED":"/etc/arc/hooks/job-started.sh","npm_package_devDependencies__swc_plugin_transform_imports":"1.5.94","npm_package_devDependencies_source_map_explorer":"1.6.0","npm_package_cypress_cucumber_preprocessor_stepDefinitions_0":"cypress/e2e/common/*.js","GITHUB_GRAPHQL_URL":"https://github.m6web.fr/api/graphql","REF":"v1.51.2","npm_package_dependencies__tornado_rdk_icons":"workspace:*","npm_package_dependencies_algoliasearch":"4.12.1","npm_package_dependencies_superagent":"8.0.9","npm_package_devDependencies_babel_loader":"9.1.2","npm_package_devDependencies_slack":"11.0.2","npm_package_scripts_build_config":"node scripts/build-config","npm_package_cypress_cucumber_preprocessor_stepDefinitions_1":"cypress/e2e/[filepart]/**/*.js","npm_package_dependencies_jwt_decode":"2.2.0","npm_package_devDependencies__babel_preset_env":"7.12.1","npm_package_scripts_e2e_rtlnl":"APP_CUSTOMER=rtlnl pnpm cypress open --e2e -b chrome","npm_package_pnpm_overrides__lightningjs_core":"2.9.0","npm_package_cypress_cucumber_preprocessor_stepDefinitions_2":"cypress/e2e/[filepart].js","GITHUB_URL":"https://github.m6web.fr/","RUNNER_ASSETS_DIR":"/runnertmp","AWS_STS_REGIONAL_ENDPOINTS":"regional","npm_package_devDependencies__babel_plugin_transform_runtime":"7.22.4","npm_package_devDependencies_inquirer":"8.1.5","npm_package_scripts_dev":"APP_ENV=development pelo run","RUNNER_OS":"Linux","GITHUB_API_URL":"https://github.m6web.fr/api/v3","MAXPROC":"8","RUNNER_LABELS":"self-hosted,app-bedrock-rdk-deploy","npm_package_devDependencies__pelo_platforms_ziggo":"10.0.0-alpha.1","npm_package_devDependencies_eslint_plugin_import":"2.28.1","npm_package_scripts_logs":"node scripts/logs.js","npm_package_scripts_prod":"APP_ENV=prod pelo run","_":"/home/runner/setup-pnpm/node_modules/.bin/pnpm","RUNNER_GROUP":"blue-gha-eks-bedrock-tech","HELM_REGISTRY_CONFIG":"/home/runner/.docker/config.json","GITHUB_WORKFLOW":"🏷 Release","npm_package_private":"true","npm_package_dependencies_sprintf_js":"1.1.2","npm_package_devDependencies__m6web_eslint_config":"3.5.0","npm_package_devDependencies_jsonlint":"1.6.3","npm_package_scripts_build_rtlnl":"APP_CUSTOMER=rtlnl pnpm build","npm_package_dependencies__bedrock_rdk_media_engine":"workspace:*","npm_package_dependencies_lightningjs_redux":"workspace:*","npm_package_devDependencies__babel_plugin_proposal_decorators":"7.22.3","npm_package_scripts_lint":"pnpm lint:js && pnpm lint:md && pnpm lint:json && pnpm lint:filenames","npm_config_registry":"https://verdaccio.bedrock.tech","GITHUB_RUN_ID":"4275928","npm_package_dependencies__bedrock_fido_sdk":"30.19.0","npm_package_dependencies_core_js":"3.32.1","npm_package_devDependencies__swc_jest":"0.2.29","npm_package_scripts_lint_tf":"terraform fmt -check -recursive -diff .cloud/terraform","npm_package_scripts_sort_keys_json":"node ./scripts/sortKeysJson.js","npm_package_pnpm_overrides_lodash":"4.17.21","GITHUB_REF_TYPE":"branch","GITHUB_WORKFLOW_SHA":"ab23f250364979d926e7565a2779bba0daadf009","KUBERNETES_PORT_443_TCP_ADDR":"fd24:3fac:1f16::1","GITHUB_BASE_REF":"","ImageOS":"ubuntu22","npm_package_devDependencies_dotenv_expand":"5.1.0","npm_package_devDependencies_html_webpack_plugin":"5.5.0","npm_package_scripts_build_rtlhu":"APP_CUSTOMER=rtlhu pnpm build","GITHUB_WORKFLOW_REF":"m6web/app-bedrock-rdk/.github/workflows/release.yml@refs/heads/master","GITHUB_ACTION_REPOSITORY":"","npm_config_node_gyp":"/home/runner/setup-pnpm/node_modules/.pnpm/pnpm@9.14.4/node_modules/pnpm/dist/node_modules/node-gyp/bin/node-gyp.js","PATH":"/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.bin:/home/runner/setup-pnpm/node_modules/.pnpm/pnpm@9.14.4/node_modules/pnpm/dist/node-gyp-bin:/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.bin:/opt/hostedtoolcache/node/22.19.0/x64/bin:/home/runner/setup-pnpm/node_modules/.bin:/usr/local/sbin:/usr/local/bin:/usr/sbin:/usr/bin:/sbin:/bin:/home/runner/.local/bin/","RUNNER_TRACKING_ID":"github_7c5f522c-ab40-4e86-a7b5-77a0008d8715","RUNNER_TOOL_CACHE":"/opt/hostedtoolcache","npm_package_name":"app-bedrock-rdk","npm_package_repository_type":"git","npm_package_dependencies_serve":"14.1.2","npm_package_devDependencies__babel_eslint_parser":"7.22.15","npm_package_scripts_lint_js":"pnpm eslint --max-warnings=0 .pelo.config.js src/ packages/ platforms/ --cache","NODE":"/opt/hostedtoolcache/node/22.19.0/x64/bin/node","GITHUB_ACTION":"__run_4","GITHUB_RUN_NUMBER":"246","GITHUB_TRIGGERING_ACTOR":"skovalchuk-externe","RUNNER_ARCH":"X64","KUBERNETES_PORT_443_TCP_PORT":"443","npm_package_devDependencies_eslint_config_airbnb_base":"15.0.0","npm_package_scripts_analyze":"APP_ENV=detective pnpm build","npm_package_scripts_build_config_rtlde":"APP_CUSTOMER=rtlde node scripts/build-config","npm_config_frozen_lockfile":"","RUN_URL":"https://github.m6web.fr/m6web/app-bedrock-rdk/actions/runs/4275928","KUBERNETES_PORT_443_TCP_PROTO":"tcp","npm_package_dependencies__pelo_plugins_device":"workspace:*","npm_package_devDependencies__bedrock_deploy_event":"0.11.0","npm_package_devDependencies__pelo_platforms_web":"10.0.0-alpha.1","npm_package_devDependencies__swc_helpers":"0.5.3","npm_package_devDependencies_glob":"7.1.6","npm_package_devDependencies_prettier_eslint":"15.0.1","npm_package_dependencies__firebolt_js_sdk":"1.7.0","npm_package_dependencies__lightningjs_core":"2.9.0","npm_package_dependencies_history":"4.9.0","npm_package_dependencies_redux":"4.0.5","npm_package_devDependencies__storybook_theming":"6.2.9","npm_package_devDependencies_eslint":"8.50.0","npm_package_devDependencies_webpack":"5.88.2","npm_package_scripts_dev_rtlde":"APP_CUSTOMER=rtlde pnpm dev","npm_package_scripts_format_md":"prettier-eslint --write $PWD/'**/*.md' $PWD/'.*/**/*.md'","npm_package_scripts_storybook_rtlnl":"APP_CUSTOMER=rtlnl start-storybook -p 6006","RUNNER_NAME":"app-bedrock-rdk-deploy-npc97-bp8xd","PIP_REQUIRE_VIRTUALENV":"true","GITHUB_REF_NAME":"master","GITHUB_REPOSITORY":"m6web/app-bedrock-rdk","S3_PATH":"s3://bedrock-rdk-rtlde-prod-magenta","npm_package_devDependencies__storybook_html":"6.2.9","npm_package_devDependencies_copy_webpack_plugin":"11.0.0","npm_package_devDependencies_dotenv":"16.0.3","npm_package_scripts_e2e":"pnpm cypress open --e2e -b chrome","npm_package_scripts_prod_rtlde":"APP_CUSTOMER=rtlde pnpm prod","npm_lifecycle_script":"pelo build \"magenta\" \"--skip-native-build\"","GITHUB_ACTION_REF":"","DEBIAN_FRONTEND":"noninteractive","npm_package_devDependencies__babel_runtime_corejs3":"7.22.3","npm_package_devDependencies__cypress_webpack_preprocessor":"6.0.0","npm_package_devDependencies__pelo_core":"10.0.0-alpha.1","npm_package_devDependencies__storybook_addons":"6.2.9","npm_package_scripts_test":"PELO_PLATFORM=rdk APP_ENV=test node scripts/test --config=config/jest/config.js","GITHUB_REPOSITORY_ID":"2571","GITHUB_ACTIONS":"true","GOPROXY":"https://goproxy.services.bedrock.tech","NODE_PATH":"/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.pnpm/@pelo+cli@10.0.0-alpha.1_@babel+core@7.27.4_@swc+core@1.3.95_@swc+helpers@0.5.3__@types+webpa_eyh3qr2suoq7louvyapz62n3cq/node_modules/@pelo/cli/bin/node_modules:/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.pnpm/@pelo+cli@10.0.0-alpha.1_@babel+core@7.27.4_@swc+core@1.3.95_@swc+helpers@0.5.3__@types+webpa_eyh3qr2suoq7louvyapz62n3cq/node_modules/@pelo/cli/node_modules:/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.pnpm/@pelo+cli@10.0.0-alpha.1_@babel+core@7.27.4_@swc+core@1.3.95_@swc+helpers@0.5.3__@types+webpa_eyh3qr2suoq7louvyapz62n3cq/node_modules/@pelo/node_modules:/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.pnpm/@pelo+cli@10.0.0-alpha.1_@babel+core@7.27.4_@swc+core@1.3.95_@swc+helpers@0.5.3__@types+webpa_eyh3qr2suoq7louvyapz62n3cq/node_modules:/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.pnpm/node_modules:/home/runner/setup-pnpm/node_modules/.pnpm/pnpm@9.14.4/node_modules/pnpm/bin/node_modules:/home/runner/setup-pnpm/node_modules/.pnpm/pnpm@9.14.4/node_modules/pnpm/node_modules:/home/runner/setup-pnpm/node_modules/.pnpm/pnpm@9.14.4/node_modules:/home/runner/setup-pnpm/node_modules/.pnpm/node_modules","npm_package_repository_url":"https://github.m6web.fr/m6web/app-bedrock-rdk.git","npm_package_version":"1.51.2","npm_package_dependencies__bedrock_ad_engine":"5.39.0","npm_package_devDependencies__m6web_eslint_plugin_i18n":"2.0.1","npm_package_devDependencies_jest_environment_jsdom":"29.5.0","npm_package_scripts_storybook_rtlhu":"APP_CUSTOMER=rtlhu start-storybook -p 6006","npm_package_pnpm_overrides__lightningjs_sdk":"5.5.5","npm_lifecycle_event":"build","ACTIONS_RUNNER_HOOK_JOB_COMPLETED":"/etc/arc/hooks/job-completed.sh","GITHUB_REF_PROTECTED":"true","GONOSUMDB":"github.m6web.fr","GONOPROXY":"none","npm_package_dependencies_uuid":"10.0.0","npm_package_scripts_build":"pelo build \"magenta\" \"--skip-native-build\"","npm_package_scripts_upload":"node scripts/uploadToMetrologicalAppStore","GITHUB_WORKSPACE":"/runner/_work/app-bedrock-rdk/app-bedrock-rdk","GITHUB_JOB":"build_and_deploy","npm_package_author":"Bedrock","npm_package_engines_pnpm":"9.x.x","npm_package_dependencies__bedrock_youbora_adapter_adengine":"1.9.9","npm_package_dependencies_lodash":"4.17.21","npm_package_devDependencies_cypress":"13.3.0","npm_package_devDependencies_http_server":"14.1.1","npm_package_scripts_test_coverage":"PELO_PLATFORM=rdk APP_ENV=test node scripts/test --config=config/jest/config.js --coverage","GITHUB_SHA":"ab23f250364979d926e7565a2779bba0daadf009","GOMAXPROC":"8","GITHUB_RUN_ATTEMPT":"1","DOCKER_HOST":"unix:///run/docker.sock","npm_package_dependencies__bedrock_media_engine":"4.17.1","npm_package_devDependencies__pelo_cli":"10.0.0-alpha.1","KUBERNETES_SERVICE_PORT_HTTPS":"443","GOPRIVATE":"*.m6web.fr,*.bedrock.tech","GITHUB_REF":"refs/heads/master","KUBERNETES_PORT_443_TCP":"tcp://[fd24:3fac:1f16::1]:443","GITHUB_ACTOR":"skovalchuk-externe","npm_package_license":"UNLICENSED","npm_package_dependencies_markdown_it":"12.2.0","DOCKERD_IN_RUNNER":"false","npm_package_dependencies_crypto_js":"4.2.0","npm_package_dependencies_qrcode":"1.5.4","npm_package_dependencies_stream_browserify":"3.0.0","npm_package_devDependencies_eslint_plugin_prettier":"5.0.0","npm_package_scripts_format":"pnpm format:js && pnpm format:md && pnpm format:lang","npm_package_scripts_update_lang":"run-s 'i18n:pull {1}' format:lang --","GITHUB_PATH":"/runner/_work/_temp/_runner_file_commands/add_path_1aea6be7-8451-44d1-976b-920c5fab1345","PWD":"/runner/_work/app-bedrock-rdk/app-bedrock-rdk","IS_STAGING":"false","APP_ENV":"prod","GITHUB_ACTOR_ID":"627","KUBERNETES_SERVICE_HOST":"fd24:3fac:1f16::1","RUNNER_WORKSPACE":"/runner/_work/app-bedrock-rdk","npm_package_dependencies_path_to_regexp":"3.0.0","npm_package_scripts_explore":"source-map-explorer build/static/js/main.*","npm_package_scripts_format_tf":"terraform fmt -recursive -write=true .cloud/terraform","npm_execpath":"/home/runner/setup-pnpm/node_modules/.pnpm/pnpm@9.14.4/node_modules/pnpm/bin/pnpm.cjs","GITHUB_EVENT_NAME":"workflow_dispatch","GITHUB_SERVER_URL":"https://github.m6web.fr","GITHUB_OUTPUT":"/runner/_work/_temp/_runner_file_commands/set_output_1aea6be7-8451-44d1-976b-920c5fab1345","npm_package_dependencies__bedrock_rdk_config":"workspace:*","npm_package_devDependencies__pelo_platforms_kpn":"10.0.0-alpha.1","npm_package_devDependencies_es_check":"7.1.1","npm_package_devDependencies_fs_extra":"9.1.0","npm_package_devDependencies_swc_mut_cjs_exports":"0.86.17","RUNNER_STATUS_UPDATE_HOOK":"false","npm_package_dependencies_browser_cookies":"1.2.0","npm_package_dependencies_date_fns":"2.28.0","npm_package_devDependencies__badeball_cypress_cucumber_preprocessor":"18.0.6","npm_package_devDependencies_svgo_loader":"3.0.1","npm_package_scripts_build_storybook":"build-storybook -o dist-storybook","npm_command":"run-script","PNPM_SCRIPT_SRC_DIR":"/runner/_work/app-bedrock-rdk/app-bedrock-rdk","APP_CUSTOMER":"rtlde","npm_package_dependencies_storybook_addon_themes":"6.1.0","npm_package_devDependencies__storybook_addon_essentials":"6.2.9","npm_package_scripts_format_js":"prettier-eslint --write $PWD/'src/**/*.js' $PWD/'packages/**/*.js' $PWD/'platforms/**/*.js' $PWD/'config/**/*.js'","PNPM_HOME":"/home/runner/setup-pnpm/node_modules/.bin","RUNNER_ENTERPRISE":"","npm_package_dependencies__tornado_rdk_typography":"workspace:*","GITHUB_STEP_SUMMARY":"/runner/_work/_temp/_runner_file_commands/step_summary_1aea6be7-8451-44d1-976b-920c5fab1345","npm_package_dependencies__lightningjs_sdk":"5.5.5","npm_package_dependencies__pelo_plugins_keys":"workspace:*","npm_package_devDependencies_swc_loader":"0.2.3","npm_package_devDependencies_swc_minify_webpack_plugin":"2.1.1","npm_package_scripts_build_rtlde":"APP_CUSTOMER=rtlde pnpm build","npm_package_scripts_format_lang":"prettier-eslint --write $PWD/'lang/**/*.json'","npm_package_pnpm_overrides_webpack":"5.88.2","npm_package_pnpm_peerDependencyRules_allowedVersions_webpack":"5","INIT_CWD":"/runner/_work/app-bedrock-rdk/app-bedrock-rdk","NODE_ENV":"production"}.APP_ID.replace(/[^0-9a-zA-Z_$]/g, "_"));
    window[id] = appLauncher;
}
var _default = appLauncher;


/***/ }),

/***/ 86978:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ACCEPT_ENGINES: function() {
        return ACCEPT_ENGINES;
    },
    INITIALIZE_ENGINES: function() {
        return INITIALIZE_ENGINES;
    },
    acceptEngines: function() {
        return acceptEngines;
    },
    bootstrapEngines: function() {
        return bootstrapEngines;
    },
    initAnalyticsEngines: function() {
        return initAnalyticsEngines;
    },
    initializeEngines: function() {
        return initializeEngines;
    }
});
var _async_to_generator = __webpack_require__(24146);
var _interop_require_default = __webpack_require__(81200);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _noop = /*#__PURE__*/ _interop_require_default._(__webpack_require__(43226));
var _config = __webpack_require__(67958);
var _fidosdk = __webpack_require__(19804);
var _appselectors = __webpack_require__(65910);
var _gdprNoticeutils = __webpack_require__(28865);
var _analyticsutils = __webpack_require__(2693);
var _gdprNoticeconstants = __webpack_require__(11661);
var INITIALIZE_ENGINES = "analytics/INITIALIZE_ENGINES";
var initializeEngines = function(engines) {
    return {
        type: INITIALIZE_ENGINES,
        engines: engines
    };
};
var ACCEPT_ENGINES = "analytics/ACCEPT_ENGINES";
var acceptEngines = function(engines) {
    return {
        type: ACCEPT_ENGINES,
        engines: engines
    };
};
var initAnalyticsEngines = function() {
    return function(dispatch, getState) {
        var state = getState();
        // List of names of third party engines, available in current configuration
        var enabledEngines = (0, _appselectors.getAnalyticsEngines)(state);
        // NOTE: tagging plans are merged events of all enabled engines. The service uses them to create the eventFields
        // parameter for sendEvent and other functions.
        // Don't forget to pass taggingPlans (events) in the third party service initParams if we need them there
        var taggingPlans = (0, _appselectors.getAnalyticsEvents)(state);
        _fidosdk.thirdPartyWithLayoutService.init({
            thirdParties: (0, _analyticsutils.getThirdPartyServicesConfigs)(enabledEngines),
            config: {
                taggingPlans: taggingPlans
            },
            options: {
                logger: _noop.default,
                sendErrorToMonitoring: _noop.default,
                isRecording: false
            }
        });
        return dispatch(initializeEngines(enabledEngines));
    };
};
var bootstrapEngines = function() {
    return function() {
        var _ref = _async_to_generator._(function(dispatch, getState) {
            var state, engines, rejectedConsents, acceptedEngines, rejectedEngines, initializedEngines;
            return _ts_generator._(this, function(_state) {
                switch(_state.label){
                    case 0:
                        state = getState();
                        engines = (0, _appselectors.getAnalyticsEngines)(state);
                        rejectedConsents = (0, _gdprNoticeutils.getRejectedConsents)(_config.gdprCookies, (0, _get.default)(state, "user.cookies", []));
                        acceptedEngines = [];
                        rejectedEngines = [];
                        engines.forEach(function(key) {
                            // TODO: figure out app behavior when one engine belongs to two or more categories
                            var isThirdPartyRejected = rejectedConsents.some(function(consent) {
                                return (0, _get.default)(_gdprNoticeconstants.CONSENT_TYPE_TO_ENGINE_MAP, [
                                    consent
                                ], []).includes(key);
                            });
                            if (isThirdPartyRejected) {
                                rejectedEngines.push(key);
                            } else {
                                acceptedEngines.push(key);
                            }
                        });
                        // FIXME: fix this in the thirdPartyWithLayoutService
                        initializedEngines = _fidosdk.thirdPartyWithLayoutService.thirdParties || [];
                        initializedEngines.filter(function(param) {
                            var name = param.name;
                            return acceptedEngines.includes(name);
                        }).forEach(function(engine) {
                            engine.rejected = false;
                        });
                        return [
                            4,
                            (0, _analyticsutils.startEngines)(acceptedEngines, rejectedEngines)
                        ];
                    case 1:
                        _state.sent();
                        (0, _analyticsutils.setInitialAttributes)(getState());
                        return [
                            2,
                            dispatch(acceptEngines(acceptedEngines))
                        ];
                }
            });
        });
        return function(dispatch, getState) {
            return _ref.apply(this, arguments);
        };
    }();
};


/***/ }),

/***/ 17842:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _object_spread = __webpack_require__(76247);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(42578);
var _analyticsactions = __webpack_require__(86978);
var _analyticsutils = __webpack_require__(2693);
var initialState = {};
var _default = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case _analyticsactions.INITIALIZE_ENGINES:
            {
                return _object_spread._({}, state, (0, _analyticsutils.enginesNamesToEnabledStateMap)(action.engines, false));
            }
        case _analyticsactions.ACCEPT_ENGINES:
            {
                return _object_spread._({}, state, (0, _analyticsutils.enginesNamesToEnabledStateMap)(action.engines, true));
            }
        default:
            {
                return state;
            }
    }
};


/***/ }),

/***/ 2693:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    cleanupEngines: function() {
        return cleanupEngines;
    },
    enginesNamesToEnabledStateMap: function() {
        return enginesNamesToEnabledStateMap;
    },
    getThirdPartyServicesConfigs: function() {
        return getThirdPartyServicesConfigs;
    },
    overrideGAPageName: function() {
        return overrideGAPageName;
    },
    sendEvent: function() {
        return sendEvent;
    },
    sendImpressionEvent: function() {
        return sendImpressionEvent;
    },
    sendPageView: function() {
        return sendPageView;
    },
    sendPrintEvent: function() {
        return sendPrintEvent;
    },
    setAttributes: function() {
        return setAttributes;
    },
    setInitialAttributes: function() {
        return setInitialAttributes;
    },
    setUser: function() {
        return setUser;
    },
    startEngines: function() {
        return _utils1.startEngines;
    },
    trackGDPRConsent: function() {
        return trackGDPRConsent;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _to_consumable_array = __webpack_require__(30005);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(52318);
var _invoke = /*#__PURE__*/ _interop_require_default._(__webpack_require__(8957));
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _fidosdk = __webpack_require__(19804);
var _config = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67958));
var _utils = __webpack_require__(64188);
var _engines = __webpack_require__(73332);
var _appselectors = __webpack_require__(65910);
var _layoutselectors = __webpack_require__(53368);
var _userselectors = __webpack_require__(41845);
var _pairingselectors = __webpack_require__(59739);
var _pairingconstants = __webpack_require__(25994);
var _appconstants = __webpack_require__(32128);
var _apputils = __webpack_require__(60368);
var _utils1 = __webpack_require__(83888);
var getThirdPartyServicesConfigs = function(enabledEngines) {
    var engines = (0, _engines.getEngines)();
    return Array.isArray(engines) && Array.isArray(enabledEngines) ? engines.filter(function(param) {
        var key = param.thirdPartyServiceConfig.key;
        return enabledEngines.includes(key);
    }).map(function(engine) {
        return engine.thirdPartyServiceConfig;
    }) : [];
};
var setAttributes = function(attributes) {
    _fidosdk.thirdPartyWithLayoutService.setCustomAttributes(attributes);
};
var sendEvent = function(event, action) {
    var attributes = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    if (!event) {
        return;
    }
    // Search API uses generic platform code (m6group_web), overriding it
    var mappings = _config.default.analytics.attributesKeysMapping;
    var keys = Object.keys(event);
    for(var i = 0; i < keys.length; i += 1){
        var key = keys[i];
        var mapping = mappings[key];
        if (event[key] && mapping && mapping.platformCode) {
            event[key][mapping.platformCode] = _config.default.platformCode;
        }
    }
    _fidosdk.thirdPartyWithLayoutService.sendEvent(event, action || null, attributes);
};
var setUser = function(userData) {
    try {
        _fidosdk.thirdPartyWithLayoutService.userChange(userData);
    } catch (error) {
        // TODO: error handling
        // eslint-disable-next-line no-console
        console.error("[AnalyticsUtils]: Can not set user UID");
    }
};
var trackGDPRConsent = function(cookieConsents) {
    try {
        var audienceMeasurement = cookieConsents.audienceMeasurement, personalization = cookieConsents.personalization, targetedAdvertising = cookieConsents.targetedAdvertising;
        var deviceConsents = {
            tracking: {
                consent: audienceMeasurement
            },
            multiDeviceMatching: {
                consent: personalization
            },
            adTargeting: {
                consent: targetedAdvertising
            }
        };
        _fidosdk.thirdPartyWithLayoutService.gdprChange(deviceConsents);
    } catch (error) {
        // TODO: error handling
        // eslint-disable-next-line no-console
        console.error("[AnalyticsUtils]: Can not set device consents");
    }
};
var sendPageView = function(pathname) {
    _fidosdk.thirdPartyWithLayoutService.sendPageViewEvent(null, {
        pathname: pathname
    }, {});
};
var sendPrintEvent = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _thirdPartyWithLayoutService;
    (_thirdPartyWithLayoutService = _fidosdk.thirdPartyWithLayoutService).sendPrintEvent.apply(_thirdPartyWithLayoutService, _to_consumable_array._(args));
};
var sendImpressionEvent = function(layout, blocks, items) {
    _fidosdk.thirdPartyWithLayoutService.sendImpressionTrackingEvent({
        list_of_block_viewed: blocks,
        list_of_item_viewed: items
    }, "display", layout);
};
var setInitialAttributes = function(state) {
    var geo = (0, _userselectors.getUserState)(state).geo;
    setAttributes({
        deviceID: (0, _userselectors.getDeviceId)(state),
        userId: (0, _userselectors.getUid)(state),
        homeId: (0, _userselectors.getHomeId)(state),
        IPhash: geo ? geo.hashIp : null,
        platformCode: _config.default.platformCode,
        language: _config.default.language,
        // Define is the user logged in, after application is start and user is paired we can change dimension on yes
        authentified: (0, _pairingselectors.getPairingStatus)(state) === _pairingconstants.PAIRING_STATUS_PAIRED ? "yes" : "no",
        // Authentication method. Always set to "pairing" as the only possible on the OTT boxes platform.
        authMethod: "pairing",
        entityType: "app",
        // Defines if a user has an ad blocker or not. Not applicable to OTT boxes, so always set to "no".
        adBlockEnabled: false,
        userStatus: (0, _pairingselectors.getPairingStatus)(state) === _pairingconstants.PAIRING_STATUS_PAIRED ? "connected" : "unknown",
        deviceBrand: (0, _appselectors.getDeviceBrand)(state),
        userAgent: navigator.userAgent,
        deviceModel: (0, _appselectors.getDeviceModel)(state),
        deviceVersion: (0, _appselectors.getDeviceVersion)(state),
        // Box type (same as in the User API call)
        boxType: _config.default.clientCode,
        project: _appconstants.PROJECT_NAME,
        appTenant: (0, _apputils.getTenant)(),
        appEnv: (0, _apputils.getEnv)(),
        appVersion: _utils.appVersion,
        appCustomer: _utils.appCustomer,
        appPlatform: _utils.appPlatform
    });
};
var enginesNamesToEnabledStateMap = function(engines, shouldEnable) {
    return engines.reduce(function(result, engine) {
        return _object_spread_props._(_object_spread._({}, result), _define_property._({}, engine, shouldEnable));
    }, {});
};
var cleanupEngines = function() {
    (0, _utils1.stopEngines)();
    var engines = (0, _engines.getEngines)();
    var cleanedUp = 0;
    if (Array.isArray(engines)) {
        engines.forEach(function(engine) {
            try {
                (0, _invoke.default)(engine, "cleanup");
            } finally{
                cleanedUp += 1;
            }
        });
    }
    // eslint-disable-next-line no-console
    console.log("[analytics.utils] Engines cleaned up: ".concat(cleanedUp));
};
var overrideGAPageName = function(pageName) {
    var state = _lightningjsredux.default.getState();
    var currentLayout = (0, _layoutselectors.getCurrentLayout)(state);
    if (currentLayout && currentLayout.analytics && currentLayout.analytics.googleAnalytics) {
        currentLayout.analytics.googleAnalytics.pageName = pageName;
    }
    if (currentLayout && currentLayout.analytics && currentLayout.analytics.tealium) {
        currentLayout.analytics.tealium.page_name = pageName;
    }
};


/***/ }),

/***/ 83888:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    startEngines: function() {
        return startEngines;
    },
    stopEngines: function() {
        return stopEngines;
    }
});
var _async_to_generator = __webpack_require__(24146);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(52318);
var _fidosdk = __webpack_require__(19804);
var startEngines = function() {
    var _ref = _async_to_generator._(function(acceptedEngines, rejectedEngines) {
        return _ts_generator._(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _fidosdk.thirdPartyWithLayoutService.initThirdPartyEngines(acceptedEngines)
                    ];
                case 1:
                    _state.sent();
                    _fidosdk.thirdPartyWithLayoutService.rejectThirdPartyEngines(rejectedEngines);
                    return [
                        2
                    ];
            }
        });
    });
    return function startEngines(acceptedEngines, rejectedEngines) {
        return _ref.apply(this, arguments);
    };
}();
var stopEngines = function() {};


/***/ }),

/***/ 73332:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "getEngines", ({
    enumerable: true,
    get: function() {
        return getEngines;
    }
}));
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(45538);
var _tealium = __webpack_require__(43736);
var _nielsenMediametrie = __webpack_require__(5471);
var _nielsenStatic = __webpack_require__(27918);
var _fireboltMetrics = __webpack_require__(41742);
// NOTE: creating engines descriptors to allow multiple calls of the "getEngines" without creating of additional instances of the descriptors
var engines = [
    (0, _tealium.getEngine)(),
    (0, _nielsenMediametrie.getEngine)(),
    (0, _nielsenStatic.getEngine)(),
    (0, _fireboltMetrics.getEngine)()
];
var getEngines = function() {
    return engines;
};


/***/ }),

/***/ 41742:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
// eslint-disable-next-line import/no-unresolved

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    engineName: function() {
        return engineName;
    },
    getEngine: function() {
        return getEngine;
    }
});
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(65759);
var _fireboltMetricsengine = /*#__PURE__*/ _interop_require_default._(__webpack_require__(96824));
var engineName = "fireboltMetrics";
var getEngine = function() {
    return {
        thirdPartyServiceConfig: {
            key: engineName,
            name: engineName,
            bootMethod: function() {},
            engine: function() {
                return _fireboltMetricsengine.default;
            },
            initParams: {}
        },
        cleanup: function() {}
    };
};


/***/ }),

/***/ 96824:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
var FireboltMetricsService = /*#__PURE__*/ function() {
    "use strict";
    function FireboltMetricsService() {
        _class_call_check._(this, FireboltMetricsService);
    }
    _create_class._(FireboltMetricsService, [
        {
            key: "init",
            value: function init() {}
        }
    ]);
    return FireboltMetricsService;
}();
var _default = new FireboltMetricsService();


/***/ }),

/***/ 5471:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    engineName: function() {
        return engineName;
    },
    getEngine: function() {
        return getEngine;
    }
});
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(52318);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _config = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67958));
var _nielsenMediametrieengine = /*#__PURE__*/ _interop_require_default._(__webpack_require__(69001));
var engineName = "nielsenMediametrie";
var getEngine = function() {
    var analytics = _config.default.analytics;
    var taggingPlans = analytics.taggingPlans;
    var initParams = (0, _get.default)(analytics, "initParams.".concat(engineName), {});
    return {
        thirdPartyServiceConfig: {
            key: engineName,
            name: engineName,
            bootMethod: function() {
                return __webpack_require__(73632);
            },
            engine: function() {
                return _nielsenMediametrieengine.default;
            },
            initParams: _object_spread._({
                events: (0, _get.default)(taggingPlans, engineName, {})
            }, (0, _merge.default)(initParams, {
                useLayout: true
            }))
        },
        cleanup: function() {
            _nielsenMediametrieengine.default.release();
            delete window.NOLBUNDLE;
            var scripts = Array.from(document.querySelectorAll("script")).filter(function(script) {
                return Boolean(script.src) && (script.src.includes("cdn-gl.nmrodam") || /\/sp-.*\.js/.test(script.src));
            });
            if (scripts && scripts.length) {
                scripts.forEach(function(script) {
                    return script.remove();
                });
            }
        }
    };
};


/***/ }),

/***/ 73632:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
/* eslint-disable no-console */ /* eslint-disable no-return-assign */ /* eslint-disable no-unused-expressions */ /* eslint-disable prettier/prettier */ /* eslint-disable func-names, prefer-rest-params */ (function(e, n) {
    function t(e) {
        return typeof e === "object" ? JSON.parse(JSON.stringify(e)) : e;
    }
    e[n] = e[n] || {
        nlsQ: function(o, r, c) {
            var s = e.document;
            var a = s.createElement("script");
            a.async = 1;
            a.src = "".concat(e.location.protocol === "http:" ? "http:" : "https:", "//cdn-gl.nmrodam.com/conf/").concat(o, ".js#name=").concat(r, "&ns=").concat(n);
            var i = s.getElementsByTagName("script")[0];
            // eslint-disable-next-line no-sequences
            return i.parentNode.insertBefore(a, i), e[n][r] = e[n][r] || {
                g: c || {},
                ggPM: function(o, c, s, a, i) {
                    e[n][r].q = e[n][r].q || [];
                    try {
                        var l = t([
                            o,
                            c,
                            s,
                            a,
                            i
                        ]);
                        e[n][r].q.push(l);
                    } catch (e) {
                        console && console.log && console.log("Error: Cannot register event in Nielsen SDK queue.");
                    }
                },
                trackEvent: function(o) {
                    e[n][r].te = e[n][r].te || [];
                    try {
                        var _$c = t(o);
                        e[n][r].te.push(_$c);
                    } catch (e) {
                        console && console.log && console.log("Error: Cannot register event in Nielsen SDK queue.");
                    }
                }
            }, e[n][r];
        }
    };
})(window, "NOLBUNDLE");


/***/ }),

/***/ 69001:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DEFAULT_ATTRIBUTES: function() {
        return DEFAULT_ATTRIBUTES;
    },
    default: function() {
        return _default;
    }
});
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _object_spread = __webpack_require__(76247);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(42578);
var NIELSEN_MEDIAMETRIE_NAME = "nielsenMediametrie";
var EngineStatus = {
    DEFAULT: "default",
    PLAYING: "playing",
    PAUSED: "paused",
    SEEKING: "seeking"
};
var NielsenEvent = {
    SET_PLAYHEAD_POSITION: "setPlayheadPosition",
    STOP: "stop",
    END: "end",
    LOAD_METADATA: "loadMetadata"
};
var DEFAULT_ATTRIBUTES = [
    "currentTime",
    "contentType"
];
var IS_LIVE_KEY = "nol_c18";
var NielsenMediametrie = /*#__PURE__*/ function() {
    "use strict";
    function NielsenMediametrie() {
        var _this = this;
        _class_call_check._(this, NielsenMediametrie);
        this.name = NIELSEN_MEDIAMETRIE_NAME;
        this.instance = undefined;
        this.status = EngineStatus.DEFAULT;
        this.metadata = {};
        this.lastSentEvent = undefined;
        this.isActive = function() {
            return !!_this.instance;
        };
        this.time = undefined;
        this.isFirstPlayheadSent = false;
        this.isLive = false;
        this.isAudio = false;
        this.shouldLoadMetadataAfterInterruption = false;
        this.sdkDebugEnabled = false;
    }
    _create_class._(NielsenMediametrie, [
        {
            key: "init",
            value: function init(config) {
                var appId = config.appId, instanceName = config.instanceName, metadata = config.metadata, _config_shouldLoadMetadataAfterInterruption = config.shouldLoadMetadataAfterInterruption, shouldLoadMetadataAfterInterruption = _config_shouldLoadMetadataAfterInterruption === void 0 ? false : _config_shouldLoadMetadataAfterInterruption, _config_sdkDebugEnabled = config.sdkDebugEnabled, sdkDebugEnabled = _config_sdkDebugEnabled === void 0 ? false : _config_sdkDebugEnabled, _config_shouldTrackAudio = config.shouldTrackAudio, shouldTrackAudio = _config_shouldTrackAudio === void 0 ? false : _config_shouldTrackAudio;
                this._attributesKeys = DEFAULT_ATTRIBUTES;
                var additionalParams = _object_spread._({}, sdkDebugEnabled && {
                    nol_sdkDebug: "debug"
                });
                this.instance = window.NOLBUNDLE.nlsQ(appId, instanceName, additionalParams);
                this.metadata = metadata;
                this.status = EngineStatus.DEFAULT;
                this.lastSentEvent = undefined;
                this.time = undefined;
                this.isFirstPlayheadSent = false;
                this.shouldLoadMetadataAfterInterruption = shouldLoadMetadataAfterInterruption;
                this.shouldTrackAudio = shouldTrackAudio;
            }
        },
        {
            key: "checkIsLive",
            value: function checkIsLive() {
                if (!this.metadata) return;
                this.isLive = /,Y$/.test(this.metadata[IS_LIVE_KEY]);
            }
        },
        {
            key: "currentTime",
            set: function set(value) {
                if (!Number.isFinite(value) || this.isAudio && !this.shouldTrackAudio) {
                    return;
                }
                var latestTime = Math.max(0, Math.floor(this.isLive ? Date.now() / 1000 : value));
                if (this.time !== latestTime) {
                    this.sendPlayheadEvent(latestTime);
                }
            }
        },
        {
            key: "contentType",
            set: function set(value) {
                this.isAudio = [
                    "radio",
                    "audio"
                ].includes(value);
            }
        },
        {
            key: "setCustomAttributes",
            value: function setCustomAttributes(attributes) {
                var _this = this;
                Object.keys(attributes).filter(function(key) {
                    return _this._attributesKeys.includes(key);
                }).forEach(function(key) {
                    _this[key] = attributes[key];
                });
            }
        },
        {
            key: "sendMetadata",
            value: function sendMetadata() {
                this.instance.ggPM(NielsenEvent.LOAD_METADATA, this.metadata);
                this.lastSentEvent = NielsenEvent.LOAD_METADATA;
            }
        },
        {
            key: "onLoadedData",
            value: function onLoadedData(metadata) {
                this.metadata = metadata;
                this.checkIsLive();
            // this.sendMetadata();
            }
        },
        {
            key: "onPlaying",
            value: function onPlaying() {
                if (this.shouldLoadMetadataAfterInterruption && this.lastSentEvent !== NielsenEvent.LOAD_METADATA) {
                    this.sendMetadata();
                }
                this.status = EngineStatus.PLAYING;
            }
        },
        {
            key: "onPause",
            value: function onPause() {
                this.sendStopEvent();
                this.status = EngineStatus.PAUSED;
            }
        },
        {
            key: "onBuffering",
            value: function onBuffering() {
                this.sendStopEvent();
                this.status = EngineStatus.PAUSED;
            }
        },
        {
            key: "onEnded",
            value: function onEnded() {
                this.sendEndEvent();
                this.status = EngineStatus.DEFAULT;
            }
        },
        {
            key: "onStop",
            value: function onStop() {
                this.sendEndEvent();
                this.status = EngineStatus.DEFAULT;
            }
        },
        {
            key: "onSeeking",
            value: function onSeeking() {
                this.status = EngineStatus.SEEKING;
            }
        },
        {
            // Only used for TV player as they cannot dispatch a Seeking event on setSeekTime
            key: "onSeekTimeUpdate",
            value: function onSeekTimeUpdate() {
                this.status = EngineStatus.SEEKING;
            }
        },
        {
            key: "onSeeked",
            value: function onSeeked(params) {
                this.sendStopEvent(params.currentTime);
                this.status = EngineStatus.PLAYING;
            }
        },
        {
            key: "onUpdatePlayerConfig",
            value: function onUpdatePlayerConfig(params) {
                var currentTime = params.currentTime, analytics = params.analytics;
                this.sendEndEvent(currentTime);
                // @ts-expect-error waiting for BE to update the analytics type
                this.metadata = analytics[this.name].metadata;
                this.instance.ggPM(NielsenEvent.LOAD_METADATA, this.metadata);
                this.lastSentEvent = NielsenEvent.LOAD_METADATA;
            }
        },
        {
            // eslint-disable-next-line no-unused-vars
            key: "sendEvent",
            value: function sendEvent(params, action, eventFields, attributesByThirdParties) {
                if (this.isAudio && !this.shouldTrackAudio) return;
                switch(params.key){
                    case "playbackStarted":
                        if (params.metadata) {
                            this.onLoadedData(params.metadata);
                        }
                        break;
                    case "playVideo":
                        this.onPlaying();
                        break;
                    case "pauseVideo":
                        this.onPause();
                        break;
                    case "playbackStopped":
                        this.onEnded();
                        break;
                    case "buffering":
                        this.onBuffering();
                        break;
                    case "bufferingEnded":
                        this.onPlaying();
                        break;
                    case "complete":
                        this.onEnded();
                        break;
                    case "replayNextVideo":
                        this.sendMetadata();
                        break;
                    case "midrollBegins":
                        // send stop event before midroll begins
                        // since there is no other event between playVideo and midrollBegins
                        this.onPause();
                        break;
                    default:
                        break;
                }
            }
        },
        {
            key: "sendPlayheadEvent",
            value: function sendPlayheadEvent(time) {
                if (this.status !== EngineStatus.PLAYING) {
                    return;
                }
                this.time = time;
                this.instance.ggPM(NielsenEvent.SET_PLAYHEAD_POSITION, this.time);
                this.lastSentEvent = NielsenEvent.SET_PLAYHEAD_POSITION;
                if (!this.isFirstPlayheadSent) {
                    this.isFirstPlayheadSent = true;
                }
            }
        },
        {
            key: "sendStopEvent",
            value: function sendStopEvent() {
                if (this.lastSentEvent === NielsenEvent.STOP || !this.isFirstPlayheadSent) return;
                this.instance.ggPM(NielsenEvent.STOP, this.time);
                this.lastSentEvent = NielsenEvent.STOP;
            }
        },
        {
            key: "sendEndEvent",
            value: function sendEndEvent() {
                if (this.lastSentEvent === NielsenEvent.END) return;
                this.instance.ggPM(NielsenEvent.END, this.time);
                this.lastSentEvent = NielsenEvent.END;
                this.isFirstPlayheadSent = false;
            }
        },
        {
            key: "release",
            value: function release() {
                this.instance = undefined;
                this.status = EngineStatus.DEFAULT;
                this.metadata = {};
                this.isAudio = false;
                this.time = undefined;
            }
        }
    ]);
    return NielsenMediametrie;
}();
var _default = new NielsenMediametrie();


/***/ }),

/***/ 27918:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    engineName: function() {
        return engineName;
    },
    getEngine: function() {
        return getEngine;
    }
});
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(52318);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _config = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67958));
var _nielsenStaticengine = /*#__PURE__*/ _interop_require_default._(__webpack_require__(98903));
var engineName = "nielsenStatic";
var getEngine = function() {
    var analytics = _config.default.analytics;
    var taggingPlans = analytics.taggingPlans;
    var initParams = (0, _get.default)(analytics, "initParams.".concat(engineName), {});
    return {
        thirdPartyServiceConfig: {
            key: engineName,
            name: engineName,
            bootMethod: function() {
                return __webpack_require__(61648);
            },
            engine: function() {
                return _nielsenStaticengine.default;
            },
            initParams: _object_spread._({
                events: (0, _get.default)(taggingPlans, engineName, {})
            }, (0, _merge.default)(initParams, {
                useLayout: true
            }))
        },
        cleanup: function() {
            _nielsenStaticengine.default.release();
            delete window.NOLBUNDLE;
            var scripts = Array.from(document.querySelectorAll("script")).filter(function(script) {
                return Boolean(script.src) && (script.src.includes("cdn-gl.nmrodam") || /\/sp-.*\.js/.test(script.src));
            });
            if (scripts && scripts.length) {
                scripts.forEach(function(script) {
                    return script.remove();
                });
            }
        }
    };
};


/***/ }),

/***/ 61648:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
/* eslint-disable no-console */ /* eslint-disable no-return-assign */ /* eslint-disable no-unused-expressions */ /* eslint-disable prettier/prettier */ /* eslint-disable func-names, prefer-rest-params */ (function(e, n) {
    function t(e) {
        return typeof e === "object" ? JSON.parse(JSON.stringify(e)) : e;
    }
    e[n] = e[n] || {
        nlsQ: function(o, r, c) {
            var s = e.document;
            var a = s.createElement("script");
            a.async = 1;
            a.src = "".concat(e.location.protocol === "http:" ? "http:" : "https:", "//cdn-gl.nmrodam.com/conf/").concat(o, ".js#name=").concat(r, "&ns=").concat(n);
            var i = s.getElementsByTagName("script")[0];
            // eslint-disable-next-line no-sequences
            return i.parentNode.insertBefore(a, i), e[n][r] = e[n][r] || {
                g: c || {},
                ggPM: function(o, c, s, a, i) {
                    e[n][r].q = e[n][r].q || [];
                    try {
                        var l = t([
                            o,
                            c,
                            s,
                            a,
                            i
                        ]);
                        e[n][r].q.push(l);
                    } catch (e) {
                        console && console.log && console.log("Error: Cannot register event in Nielsen SDK queue.");
                    }
                },
                trackEvent: function(o) {
                    e[n][r].te = e[n][r].te || [];
                    try {
                        var _$c = t(o);
                        e[n][r].te.push(_$c);
                    } catch (e) {
                        console && console.log && console.log("Error: Cannot register event in Nielsen SDK queue.");
                    }
                }
            }, e[n][r];
        }
    };
})(window, "NOLBUNDLE");


/***/ }),

/***/ 98903:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _object_spread = __webpack_require__(76247);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(37815);
var NIELSEN_STATIC_NAME = "nielsenStatic";
var NielsenStatic = /*#__PURE__*/ function() {
    "use strict";
    function NielsenStatic() {
        var _this = this;
        _class_call_check._(this, NielsenStatic);
        this.name = NIELSEN_STATIC_NAME;
        this.instance = undefined;
        this.metadata = {};
        this._previousArticleMetadata = undefined;
        this.isActive = function() {
            return !!_this.instance;
        };
    }
    _create_class._(NielsenStatic, [
        {
            key: "init",
            value: function init(config) {
                var appId = config.appId, instanceName = config.instanceName, _config_sdkDebugEnabled = config.sdkDebugEnabled, sdkDebugEnabled = _config_sdkDebugEnabled === void 0 ? false : _config_sdkDebugEnabled;
                this._attributesKeys = {};
                var additionalParams = _object_spread._({}, sdkDebugEnabled && {
                    nol_sdkDebug: "debug"
                });
                this.instance = window.NOLBUNDLE.nlsQ(appId, instanceName, additionalParams);
            }
        },
        {
            // eslint-disable-next-line no-unused-vars
            key: "sendPageViewEvent",
            value: function sendPageViewEvent(params, action, eventFields, attributesByThirdParties) {
                var _this = this;
                if (!this.instance) {
                    return;
                }
                if (this._previousArticleMetadata) {
                    this.instance.ggPM("staticend", this._previousArticleMetadata);
                    this._previousArticleMetadata = undefined;
                }
                var articleMetadata = eventFields[NIELSEN_STATIC_NAME];
                if (!(NIELSEN_STATIC_NAME in eventFields)) {
                    return;
                }
                this._previousArticleMetadata = articleMetadata;
                setTimeout(function() {
                    _this.instance.ggPM("staticstart", _this._previousArticleMetadata);
                }, 100);
            }
        },
        {
            key: "release",
            value: function release() {
                this.instance = undefined;
            }
        }
    ]);
    return NielsenStatic;
}();
var _default = new NielsenStatic();


/***/ }),

/***/ 43736:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    engineName: function() {
        return engineName;
    },
    getEngine: function() {
        return getEngine;
    }
});
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(65759);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _config = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67958));
var _ssaTealiumHttpengine = /*#__PURE__*/ _interop_require_default._(__webpack_require__(33350));
var engineName = "ssaTealiumHttp";
function getBrowserLayer() {
    var getUserAgent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var url = new URL(window.location.href || "");
    // On Magenta we may have a device-ingested SSO token which contains auth info
    url.searchParams.delete("token");
    var sanitizedUrl = url.toString();
    var sanitizedParams = url.searchParams.toString();
    return _object_spread._({
        "dom.url": sanitizedUrl,
        page_url: sanitizedUrl,
        page_path: window.location.pathname,
        page_title: document.title,
        page_query_params: sanitizedParams,
        referrer: document.referrer,
        device_resolution: "".concat(window.screen.width, "x").concat(window.screen.height),
        viewport_size: "".concat(window.innerWidth, "x").concat(window.innerHeight),
        pixel_depth: window.screen.pixelDepth,
        device_language: navigator.language
    }, getUserAgent && {
        user_agent: navigator.userAgent
    });
}
_ssaTealiumHttpengine.default.getBrowserLayer = getBrowserLayer.bind(_ssaTealiumHttpengine.default);
var getEngine = function() {
    var analytics = _config.default.analytics;
    var initParams = analytics.initParams, trackers = analytics.trackers, taggingPlans = analytics.taggingPlans, attributesKeysMapping = analytics.attributesKeysMapping;
    return {
        thirdPartyServiceConfig: {
            key: engineName,
            name: engineName,
            bootMethod: function() {},
            engine: function() {
                return _ssaTealiumHttpengine.default;
            },
            taggingPlan: (0, _get.default)(taggingPlans, engineName, {}),
            initParams: _object_spread._({
                attributesKeysMapping: (0, _get.default)(attributesKeysMapping, engineName, {}),
                events: (0, _get.default)(taggingPlans, engineName, {}),
                trackers: (0, _get.default)(trackers, engineName, {}),
                isSnowplowEnabled: (analytics.engines || []).includes("snowplow")
            }, (0, _get.default)(initParams, engineName, {}))
        },
        cleanup: function() {}
    };
};


/***/ }),

/***/ 20386:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    INITIALIZE_APP: function() {
        return INITIALIZE_APP;
    },
    INITIALIZE_APP_COMPLETED: function() {
        return INITIALIZE_APP_COMPLETED;
    },
    INITIALIZE_APP_FAILURE: function() {
        return INITIALIZE_APP_FAILURE;
    },
    SET_CONNECTED: function() {
        return SET_CONNECTED;
    },
    SET_DEVICE_INFO: function() {
        return SET_DEVICE_INFO;
    },
    SET_SCREEN_SIZE: function() {
        return SET_SCREEN_SIZE;
    },
    SET_SERVER_TIME: function() {
        return SET_SERVER_TIME;
    },
    authenticateUser: function() {
        return authenticateUser;
    },
    fetchDeviceInfo: function() {
        return fetchDeviceInfo;
    },
    fetchScreenSize: function() {
        return fetchScreenSize;
    },
    fetchServerTime: function() {
        return fetchServerTime;
    },
    getAssetsBundle: function() {
        return getAssetsBundle;
    },
    getCurrentScreenSize: function() {
        return getCurrentScreenSize;
    },
    initProfiles: function() {
        return initProfiles;
    },
    initializeApp: function() {
        return initializeApp;
    },
    restoreUserProfile: function() {
        return restoreUserProfile;
    },
    setConnected: function() {
        return setConnected;
    },
    setFallbackServerTime: function() {
        return setFallbackServerTime;
    },
    setScreenSize: function() {
        return setScreenSize;
    },
    setServerTime: function() {
        return setServerTime;
    },
    setUserPrivacy: function() {
        return setUserPrivacy;
    }
});
var _async_to_generator = __webpack_require__(24146);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _sliced_to_array = __webpack_require__(28966);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(65759);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _superagent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(54247));
var _config = __webpack_require__(67958);
var _fidosdk = __webpack_require__(19804);
var _device = __webpack_require__(34670);
var _screen = __webpack_require__(43744);
var _constants = __webpack_require__(34952);
var _utils = __webpack_require__(64188);
var _newrelicerrorHandler = __webpack_require__(40339);
var _appselectors = __webpack_require__(65910);
var _analyticsactions = __webpack_require__(86978);
var _gdprNoticeutils = __webpack_require__(28865);
var _useractions = __webpack_require__(79489);
var _pairingactions = __webpack_require__(83887);
var _featuresselectors = __webpack_require__(76109);
var _userselectors = __webpack_require__(41845);
var _erroractions = __webpack_require__(39258);
var _errorconstants = __webpack_require__(16186);
var _apputils = __webpack_require__(60368);
var _fidoutils = __webpack_require__(37871);
var _appconstants = __webpack_require__(32128);
var _gdprNoticeactions = __webpack_require__(18012);
var _sizes = __webpack_require__(82699);
var _appconfigactions = __webpack_require__(72261);
var _layoutactions = __webpack_require__(8424);
var INITIALIZE_APP = "app/INITIALIZE_APP";
var INITIALIZE_APP_COMPLETED = "app/INITIALIZE_APP_COMPLETED";
var INITIALIZE_APP_FAILURE = "app/INITIALIZE_APP_FAILURE";
var SET_SERVER_TIME = "app/SET_SERVER_TIME";
var SET_CONNECTED = "app/SET_CONNECTED";
var SET_SCREEN_SIZE = "app/SET_SCREEN_SIZE";
var SET_DEVICE_INFO = "app/SET_DEVICE_INFO";
var setScreenSize = function(screenSize) {
    return {
        type: SET_SCREEN_SIZE,
        size: screenSize
    };
};
var getCurrentScreenSize = function() {
    var _ref = _async_to_generator._(function() {
        return _ts_generator._(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _screen.screenInfo.isGreaterOrEqual(_sizes.SCREEN_HEIGHT.HD + 1)
                    ];
                case 1:
                    if (_state.sent()) {
                        return [
                            2,
                            _constants.FULL_HD
                        ];
                    }
                    return [
                        2,
                        _constants.HD
                    ];
            }
        });
    });
    return function getCurrentScreenSize() {
        return _ref.apply(this, arguments);
    };
}();
var fetchScreenSize = function() {
    return function() {
        var _ref = _async_to_generator._(function(dispatch, getState) {
            var previousScreenSize, newScreenSize, error;
            return _ts_generator._(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        previousScreenSize = (0, _appselectors.getScreenSize)(getState());
                        return [
                            4,
                            getCurrentScreenSize()
                        ];
                    case 1:
                        newScreenSize = _state.sent();
                        if (newScreenSize !== previousScreenSize) {
                            dispatch(setScreenSize(newScreenSize));
                        }
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        // eslint-disable-next-line no-console
                        console.warn("Could not get device screen info: ".concat(error.message, " Are you on browser with a specific platform?"));
                        // dispatch(errorAction(ERROR_LEVELS.SILENT, ERROR_TYPES.GENERAL, e.toString()));
                        dispatch(setScreenSize(_constants.HD));
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(dispatch, getState) {
            return _ref.apply(this, arguments);
        };
    }();
};
var fetchDeviceInfo = function() {
    return function() {
        var _ref = _async_to_generator._(function(dispatch) {
            var _ref, deviceBrand, deviceModel, deviceVersion;
            return _ts_generator._(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            Promise.all([
                                _device.deviceInfo.getBrand().catch(function() {
                                    return "";
                                }),
                                _device.deviceInfo.getModel().catch(function() {
                                    return "";
                                }),
                                _device.deviceInfo.getVersion().catch(function() {
                                    return "";
                                })
                            ])
                        ];
                    case 1:
                        _ref = _sliced_to_array._.apply(void 0, [
                            _state.sent(),
                            3
                        ]), deviceBrand = _ref[0], deviceModel = _ref[1], deviceVersion = _ref[2];
                        dispatch({
                            type: SET_DEVICE_INFO,
                            deviceBrand: deviceBrand,
                            deviceModel: deviceModel,
                            deviceVersion: deviceVersion
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
var setServerTime = function(serverTime) {
    return {
        type: SET_SERVER_TIME,
        serverTime: serverTime
    };
};
var getAssetsBundle = function(config) {
    return function() {
        var _ref = _async_to_generator._(function(dispatch) {
            var bundleBaseUrl, bundleVersion, baseUrl, url, manifest, error;
            return _ts_generator._(this, function(_state) {
                switch(_state.label){
                    case 0:
                        bundleBaseUrl = (0, _get.default)(config, "assetsBundle.bundleBaseUrl");
                        bundleVersion = (0, _get.default)(config, "assetsBundle.bundleVersion");
                        if (!bundleBaseUrl || !bundleVersion) {
                            return [
                                2
                            ];
                        }
                        baseUrl = "".concat(bundleBaseUrl, "/").concat(bundleVersion, "/svg-file");
                        url = "".concat(baseUrl, "/manifest.json");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            _superagent.default.get(url).then(function(response) {
                                return JSON.parse(response.text);
                            })
                        ];
                    case 2:
                        manifest = _state.sent();
                        config.assetsBundle.manifest = _object_spread._({
                            baseUrl: baseUrl
                        }, manifest);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        dispatch((0, _erroractions.errorAction)(_errorconstants.ERROR_LEVELS.SILENT, _errorconstants.ERROR_TYPES.GENERAL, "Failed to retrieve assets bundle manifest: ".concat(error.message)));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
var authenticateUser = function() {
    return function() {
        var _ref = _async_to_generator._(function(dispatch, getState) {
            var state, user, error;
            return _ts_generator._(this, function(_state) {
                switch(_state.label){
                    case 0:
                        state = getState();
                        if (!(0, _featuresselectors.getPairingFeature)(state)) {
                            return [
                                2
                            ];
                        }
                        if (!!(0, _userselectors.getPairingStatus)(state)) return [
                            3,
                            5
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            dispatch((0, _pairingactions.getCurrentPairedUser)())
                        ];
                    case 2:
                        user = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        dispatch((0, _erroractions.errorAction)(_errorconstants.ERROR_LEVELS.SILENT, _errorconstants.ERROR_TYPES.GENERAL, "Authentication failed: ".concat(error.message)));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        if (!user) {
                            // No navigation was fetched for a logged-in user, and nothing will be fetched for a profile
                            dispatch((0, _layoutactions.fetchNavigation)());
                        }
                        _state.label = 5;
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(dispatch, getState) {
            return _ref.apply(this, arguments);
        };
    }();
};
var setFallbackServerTime = function() {
    return function(dispatch) {
        return dispatch(setServerTime(Math.floor(Date.now() / 1000)));
    };
};
var fetchServerTime = function() {
    return function() {
        var _ref = _async_to_generator._(function(dispatch) {
            var serverTime, error;
            return _ts_generator._(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            (0, _utils.get6PlayTime)()
                        ];
                    case 1:
                        serverTime = _state.sent();
                        return [
                            2,
                            dispatch(setServerTime(serverTime))
                        ];
                    case 2:
                        error = _state.sent();
                        dispatch((0, _erroractions.errorAction)(_errorconstants.ERROR_LEVELS.SILENT, _errorconstants.ERROR_TYPES.GENERAL, error.message));
                        return [
                            2,
                            dispatch(setFallbackServerTime())
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
var initProfiles = function() {
    return function() {
        var _ref = _async_to_generator._(function(dispatch, getState) {
            var userShouldSelectProfile;
            return _ts_generator._(this, function(_state) {
                userShouldSelectProfile = (0, _featuresselectors.getMultiProfilesGateAlwaysDisplayed)(getState());
                if (userShouldSelectProfile) {
                    dispatch((0, _pairingactions.clearUserProfile)());
                }
                return [
                    2
                ];
            });
        });
        return function(dispatch, getState) {
            return _ref.apply(this, arguments);
        };
    }();
};
var restoreUserProfile = function() {
    return function(dispatch, getState) {
        var state = getState();
        var deviceId = (0, _userselectors.getDeviceId)(state);
        var userId = (0, _userselectors.getUid)(state);
        dispatch((0, _useractions.migrateDeviceId)(deviceId));
        if (userId) {
            dispatch({
                type: _useractions.USER_RESTORE_PROFILE_UID
            });
        }
    };
};
var setUserPrivacy = function() {
    return function(dispatch, getState) {
        var state = getState();
        var areEmptyCookies = (0, _gdprNoticeutils.areCookiesEmpty)((0, _userselectors.getCookies)(state));
        if (!(0, _featuresselectors.getGdprNoticeFeature)(state)) {
            // GDPR Notice feature is disabled, assuming user didn't agreed to any tracking
            dispatch((0, _useractions.setUserConsents)((0, _gdprNoticeutils.setAllCookies)(false)));
        } else if (areEmptyCookies || _config.gdpr.consentVersion > (0, _appselectors.getGivenConsentVersion)(state)) {
            // User didn't set all required tracking preferences, asking for confirmation
            dispatch((0, _gdprNoticeactions.toggleGdprNotice)());
        } else {
            // User already set tracking preferences, using stored values
            return dispatch((0, _analyticsactions.bootstrapEngines)());
        }
        // NOTE: just to keep function interface
        return Promise.resolve();
    };
};
var initializeApp = function(config) {
    return function() {
        var _ref = _async_to_generator._(function(dispatch, getState) {
            var shouldClearLocalStore, query, error;
            return _ts_generator._(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!config) {
                            throw new Error(_appconstants.ERROR_ON_MISSING_CONFIG);
                        }
                        (0, _apputils.preserveGlobals)();
                        try {
                            query = new URL(document.location).searchParams;
                            shouldClearLocalStore = query.get("cleanup") === "true";
                        } catch (error) {
                            shouldClearLocalStore = false;
                        }
                        if (shouldClearLocalStore) {
                            _utils.storage.clear();
                        }
                        // NOTE: it's better to start from less diff with server, should allow to generate proper auth token ASAP and boost app loading a little bit
                        dispatch(setFallbackServerTime());
                        // Start the startup sequence
                        dispatch({
                            type: INITIALIZE_APP,
                            initialElapsedTime: (0, _utils.getElapsedTime)()
                        });
                        // Set the devices data store in cookies in the state
                        dispatch((0, _useractions.restoreDeviceData)());
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            ,
                            7
                        ]);
                        (0, _fidoutils.initFidoSDK)(getState);
                        return [
                            4,
                            dispatch((0, _appconfigactions.fetchAppLaunchConfig)(config))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            Promise.all([
                                dispatch(getAssetsBundle(config)),
                                dispatch(fetchServerTime()),
                                dispatch(fetchScreenSize()),
                                dispatch(fetchDeviceInfo())
                            ])
                        ];
                    case 3:
                        _state.sent();
                        dispatch((0, _analyticsactions.initAnalyticsEngines)());
                        (0, _newrelicerrorHandler.switchToThirdPartyHandlers)();
                        return [
                            4,
                            dispatch(initProfiles())
                        ];
                    case 4:
                        _state.sent();
                        return [
                            4,
                            dispatch(authenticateUser())
                        ];
                    case 5:
                        _state.sent();
                        dispatch(restoreUserProfile());
                        _fidosdk.statsdMonitoringService.sendAppStart(_utils.appVersion);
                        dispatch({
                            type: INITIALIZE_APP_COMPLETED
                        });
                        dispatch(setUserPrivacy());
                        return [
                            3,
                            7
                        ];
                    case 6:
                        error = _state.sent();
                        // eslint-disable-next-line no-console
                        console.error("Can not launch app:", error);
                        dispatch((0, _erroractions.errorAction)(_errorconstants.ERROR_LEVELS.FATAL, _errorconstants.ERROR_TYPES.GENERAL, error.message));
                        (0, _apputils.removeSplashScreen)();
                        return [
                            3,
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function(dispatch, getState) {
            return _ref.apply(this, arguments);
        };
    }();
};
var setConnected = function(isConnected) {
    return {
        type: SET_CONNECTED,
        connected: isConnected
    };
};


/***/ }),

/***/ 72261:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/* eslint-disable no-console */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    CONFIG_INIT: function() {
        return CONFIG_INIT;
    },
    configInitApp: function() {
        return configInitApp;
    },
    fetchAppLaunchConfig: function() {
        return fetchAppLaunchConfig;
    },
    refreshCustomizedConfig: function() {
        return refreshCustomizedConfig;
    }
});
var _async_to_generator = __webpack_require__(24146);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(52318);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _fidosdk = __webpack_require__(19804);
var _mediaengine = __webpack_require__(62221);
var _config = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67958));
var _useractions = __webpack_require__(79489);
var _featuresactions = __webpack_require__(76654);
var _userselectors = __webpack_require__(41845);
var _fidoutils = __webpack_require__(37871);
var _featuresselectors = __webpack_require__(76109);
var _erroractions = __webpack_require__(39258);
var _errorconstants = __webpack_require__(16186);
var _i18n = __webpack_require__(14910);
var CONFIG_INIT = "app/CONFIG_INIT";
var patchAnalyticsEngines = function(result, extension) {
    if (!result.analytics) {
        result.analytics = {};
    }
    // The engines array should be replaced, not merged
    result.analytics.engines = (0, _get.default)(extension, "analytics.engines") || result.analytics.engines || [];
};
var configInitApp = function(config) {
    return {
        type: CONFIG_INIT,
        config: config
    };
};
/**
 * Fetch and return the customized applaunch config for a specific device
 * In case of error, return the config sent as param
 *
 * @param {String} deviceId
 * @param {Object} applaunchRemoteConfig
 * @returns {Promise<*>}
 */ var fetchAppLaunchCustomizer = function(deviceId, applaunchConfig) {
    try {
        var featureFlipping = (0, _featuresactions.getFeatureFlipping)(_config.default.bannedFeatures, _config.default.featureFlipping, applaunchConfig.featureFlipping);
        var customizerFeature = featureFlipping.customizerFeature;
        if (customizerFeature && !_config.default.bannedFeatures.includes("customizerFeature")) {
            return _fidosdk.applaunchService.getCustomization({
                localDeviceId: deviceId
            }).catch(function(error) {
                console.error("[app.config.actions] Error while fetching customized config: ".concat(error.message));
                return applaunchConfig;
            });
        }
        return Promise.resolve(applaunchConfig);
    } catch (error) {
        return Promise.resolve(applaunchConfig);
    }
};
var applyExternalConfig = function(localConfig, externalConfig) {
    var featureFlipping = (0, _featuresactions.getFeatureFlipping)(_config.default.bannedFeatures, _config.default.featureFlipping, externalConfig.featureFlipping);
    var enhancedConfig = (0, _merge.default)(localConfig, _object_spread_props._(_object_spread._({}, externalConfig), {
        featureFlipping: featureFlipping
    }));
    (0, _fidoutils.updateFidoConfig)(enhancedConfig);
    // The engines array should be replaced, not merged
    patchAnalyticsEngines(enhancedConfig, externalConfig);
    return enhancedConfig;
};
var fetchAppLaunchConfig = function(config) {
    return function() {
        var _ref = _async_to_generator._(function(dispatch, getState) {
            var state, deviceId, applaunchConfig, externalConfig, enhancedConfig;
            return _ts_generator._(this, function(_state) {
                switch(_state.label){
                    case 0:
                        state = getState();
                        deviceId = (0, _userselectors.getLocalDeviceId)(state);
                        return [
                            4,
                            _fidosdk.applaunchService.getApplaunch().catch(function() {
                                return {};
                            })
                        ];
                    case 1:
                        applaunchConfig = _state.sent();
                        return [
                            4,
                            fetchAppLaunchCustomizer("deviceid-".concat(deviceId), applaunchConfig)
                        ];
                    case 2:
                        externalConfig = _state.sent();
                        enhancedConfig = applyExternalConfig(config, externalConfig);
                        _mediaengine.mediaEngineConfig.init({
                            lang: enhancedConfig.language,
                            isDebug: Boolean(enhancedConfig.debug)
                        });
                        return [
                            4,
                            dispatch((0, _useractions.setGeoInfo)())
                        ];
                    case 3:
                        _state.sent();
                        (0, _i18n.setupI18NOverrides)(enhancedConfig.translationsOverrides);
                        dispatch(configInitApp(enhancedConfig));
                        return [
                            2
                        ];
                }
            });
        });
        return function(dispatch, getState) {
            return _ref.apply(this, arguments);
        };
    }();
};
var refreshCustomizedConfig = function(id) {
    return function() {
        var _ref = _async_to_generator._(function(dispatch, getState) {
            var state, uid, externalConfig, enhancedConfig, e;
            return _ts_generator._(this, function(_state) {
                switch(_state.label){
                    case 0:
                        state = getState();
                        if (!(0, _featuresselectors.getCustomizerFeature)(state)) return [
                            3,
                            4
                        ];
                        uid = id || (0, _userselectors.getHomeId)(state) || (0, _userselectors.getDeviceId)(state) || (0, _userselectors.getLocalHomeId)(state) || (0, _userselectors.getLocalDeviceId)(state);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            _fidosdk.applaunchService.getCustomization({
                                uid: uid
                            })
                        ];
                    case 2:
                        externalConfig = _state.sent();
                        enhancedConfig = applyExternalConfig(_config.default, externalConfig);
                        _mediaengine.mediaEngineConfig.set("lang", enhancedConfig.language);
                        _mediaengine.mediaEngineConfig.set("isDebug", Boolean(enhancedConfig.debug));
                        patchAnalyticsEngines(enhancedConfig, externalConfig);
                        dispatch(configInitApp(enhancedConfig));
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        dispatch((0, _erroractions.errorAction)(_errorconstants.ERROR_LEVELS.SILENT, _errorconstants.ERROR_TYPES.GENERAL, "Failed to get customization data on config refresh"));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(dispatch, getState) {
            return _ref.apply(this, arguments);
        };
    }();
};


/***/ }),

/***/ 32128:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ERROR_ON_MISSING_CONFIG: function() {
        return ERROR_ON_MISSING_CONFIG;
    },
    PERSISTENT: function() {
        return PERSISTENT;
    },
    PROJECT_NAME: function() {
        return PROJECT_NAME;
    }
});
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(45538);
var ERROR_ON_MISSING_CONFIG = "Something is wrong with the config parameter";
var PROJECT_NAME = "bedrock-rdk";
var PERSISTENT = {
    DEVICE_ID_KEY: "deviceId",
    SYNCHRONIZE_KEY: "synchronize",
    PROFILE_UID_KEY: "profileUid",
    PREVIOUS_PROFILE_KEY: "previousProfile",
    CONSENT_VERSION: "concentVersion"
};


/***/ }),

/***/ 44831:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    default: function() {
        return _default;
    },
    initialState: function() {
        return initialState;
    }
});
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(52318);
var _appactions = __webpack_require__(20386);
var _appconfigactions = __webpack_require__(72261);
var initialState = {
    ads: null,
    deviceBrand: "",
    deviceModel: "",
    deviceVersion: "",
    givenConsentVersion: 0,
    initializing: false,
    initialized: false,
    initialElapsedTime: null,
    initializeRetriesCount: 0,
    serverTime: null,
    hasKeysControl: true,
    startoverMinDepth: null,
    startoverMaxDepth: null,
    startoverMinPercentage: null,
    startoverMaxPercentage: null,
    country: null,
    currentService: null,
    connected: true,
    screenSize: null
};
var _default = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case _appactions.INITIALIZE_APP:
            {
                return _object_spread_props._(_object_spread._({}, state), {
                    initializing: true,
                    initialElapsedTime: action.initialElapsedTime,
                    initializeRetriesCount: state.initializeRetriesCount + 1
                });
            }
        case _appactions.INITIALIZE_APP_COMPLETED:
            {
                return _object_spread_props._(_object_spread._({}, state), {
                    initializing: false,
                    initialized: true
                });
            }
        case _appactions.SET_SERVER_TIME:
            return _object_spread_props._(_object_spread._({}, state), {
                serverTime: action.serverTime
            });
        case _appconfigactions.CONFIG_INIT:
            {
                var _action_config = action.config, ads = _action_config.ads, country = _action_config.country, monitoring = _action_config.monitoring, customizer = _action_config.customizer, analytics = _action_config.analytics, _action_config_startover = _action_config.startover, startoverMinDepth = _action_config_startover.startoverMinDepth, startoverMaxDepth = _action_config_startover.startoverMaxDepth, startoverMinPercentage = _action_config_startover.startoverMinPercentage, startoverMaxPercentage = _action_config_startover.startoverMaxPercentage;
                return _object_spread_props._(_object_spread._({}, state), {
                    ads: ads,
                    country: country,
                    monitoring: monitoring,
                    customizer: customizer,
                    analytics: analytics,
                    givenConsentVersion: action.consentVersion,
                    startoverMinDepth: startoverMinDepth,
                    startoverMaxDepth: startoverMaxDepth,
                    startoverMinPercentage: startoverMinPercentage,
                    startoverMaxPercentage: startoverMaxPercentage
                });
            }
        case _appactions.SET_CONNECTED:
            {
                return _object_spread_props._(_object_spread._({}, state), {
                    connected: action.connected
                });
            }
        case _appactions.SET_SCREEN_SIZE:
            {
                return _object_spread_props._(_object_spread._({}, state), {
                    screenSize: action.size
                });
            }
        case _appactions.SET_DEVICE_INFO:
            {
                var deviceBrand = action.deviceBrand, deviceModel = action.deviceModel, deviceVersion = action.deviceVersion;
                return _object_spread_props._(_object_spread._({}, state), {
                    deviceBrand: deviceBrand || "",
                    deviceModel: deviceModel || "",
                    deviceVersion: deviceVersion || ""
                });
            }
        default:
            return state;
    }
};


/***/ }),

/***/ 65910:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/** @module appSelectors */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    getAnalytics: function() {
        return getAnalytics;
    },
    getAnalyticsEngines: function() {
        return getAnalyticsEngines;
    },
    getAnalyticsEvents: function() {
        return getAnalyticsEvents;
    },
    getAppState: function() {
        return getAppState;
    },
    getCurrentMsTime: function() {
        return getCurrentMsTime;
    },
    getCurrentTime: function() {
        return getCurrentTime;
    },
    getDeviceBrand: function() {
        return getDeviceBrand;
    },
    getDeviceModel: function() {
        return getDeviceModel;
    },
    getDeviceVersion: function() {
        return getDeviceVersion;
    },
    getGivenConsentVersion: function() {
        return getGivenConsentVersion;
    },
    getInitialElapsedTime: function() {
        return getInitialElapsedTime;
    },
    getRetriesCount: function() {
        return getRetriesCount;
    },
    getScreenSize: function() {
        return getScreenSize;
    },
    getServerTime: function() {
        return getServerTime;
    },
    getStartoverMaxDepth: function() {
        return getStartoverMaxDepth;
    },
    getStartoverMaxPercentage: function() {
        return getStartoverMaxPercentage;
    },
    getStartoverMinDepth: function() {
        return getStartoverMinDepth;
    },
    getStartoverMinPercentage: function() {
        return getStartoverMinPercentage;
    },
    isAppInitialized: function() {
        return isAppInitialized;
    },
    isAppInitializing: function() {
        return isAppInitializing;
    },
    isConnected: function() {
        return isConnected;
    },
    isScreensaverVisible: function() {
        return isScreensaverVisible;
    }
});
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _time = __webpack_require__(60942);
var DEFAULT_ARRAY = [];
var DEFAULT_OBJECT = {};
var getAppState = function(param) {
    var app = param.app;
    return app;
};
var isAppInitializing = function(param) {
    var initializing = param.app.initializing;
    return initializing;
};
var isAppInitialized = function(param) {
    var initialized = param.app.initialized;
    return initialized;
};
var getAnalytics = function(state) {
    return (0, _get.default)(state, "app.analytics");
};
var getAnalyticsEngines = function(state) {
    return (0, _get.default)(state, "app.analytics.engines", DEFAULT_ARRAY);
};
var getAnalyticsEvents = function(state) {
    var enabledEngines = getAnalyticsEngines(state);
    var taggingPlans = (0, _get.default)(state, "app.analytics.taggingPlans", DEFAULT_OBJECT);
    return Object.keys(taggingPlans).reduce(function(result, key) {
        if (enabledEngines.indexOf(key) === -1) {
            return result;
        }
        result = _object_spread._({}, result, taggingPlans[key]);
        return result;
    }, {});
};
var getDeviceBrand = function(state) {
    return (0, _get.default)(state, "app.deviceBrand");
};
var getDeviceModel = function(state) {
    return (0, _get.default)(state, "app.deviceModel");
};
var getDeviceVersion = function(state) {
    return (0, _get.default)(state, "app.deviceVersion");
};
var isScreensaverVisible = function(param) {
    var displayScreenSaver = param.screensaver.displayScreenSaver;
    return displayScreenSaver;
};
var getCurrentTime = function(param) {
    var _param_app = param.app, serverTime = _param_app.serverTime, initialElapsedTime = _param_app.initialElapsedTime;
    return (0, _time.getTimestamp)(serverTime, initialElapsedTime);
};
var getCurrentMsTime = function(param) {
    var _param_app = param.app, serverTime = _param_app.serverTime, initialElapsedTime = _param_app.initialElapsedTime;
    return (0, _time.getMsTimestamp)(serverTime, initialElapsedTime);
};
var getServerTime = function(param) {
    var serverTime = param.app.serverTime;
    return serverTime;
};
var getInitialElapsedTime = function(param) {
    var initialElapsedTime = param.app.initialElapsedTime;
    return initialElapsedTime;
};
var getStartoverMinDepth = function(param) {
    var startoverMinDepth = param.app.startoverMinDepth;
    return startoverMinDepth;
};
var getStartoverMaxDepth = function(param) {
    var startoverMaxDepth = param.app.startoverMaxDepth;
    return startoverMaxDepth;
};
var getStartoverMinPercentage = function(param) {
    var startoverMinPercentage = param.app.startoverMinPercentage;
    return startoverMinPercentage;
};
var getStartoverMaxPercentage = function(param) {
    var startoverMaxPercentage = param.app.startoverMaxPercentage;
    return startoverMaxPercentage;
};
var isConnected = function(state) {
    return getAppState(state).connected;
};
var getScreenSize = function(param) {
    var screenSize = param.app.screenSize;
    return screenSize;
};
var getRetriesCount = function(state) {
    return state.app.initializeRetriesCount;
};
var getGivenConsentVersion = function(state) {
    return state.app.givenConsentVersion;
};


/***/ }),

/***/ 60368:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    GLOBALS: function() {
        return GLOBALS;
    },
    cleanupConfig: function() {
        return cleanupConfig;
    },
    cleanupGlobals: function() {
        return cleanupGlobals;
    },
    getEnv: function() {
        return getEnv;
    },
    getTenant: function() {
        return getTenant;
    },
    initLogger: function() {
        return initLogger;
    },
    preserveGlobals: function() {
        return preserveGlobals;
    },
    removeSplashScreen: function() {
        return removeSplashScreen;
    }
});
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(42578);
var _debug = /*#__PURE__*/ _interop_require_default._(__webpack_require__(73724));
var _config = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67958));
var APP_ENV = "prod";
var initLogger = function() {
    // WARN: Keep `process.env.NODE_ENV === 'development'` for tree-shaking
    if (false) {}
};
var removeSplashScreen = function() {
    var splash = document.getElementById("splashscreen");
    if (!splash) {
        return;
    }
    if (!window.splashRemovalTimeout) {
        var transition = "opacity .75s ease-out";
        splash.style.transition = transition;
        splash.setAttribute("style", "-moz-transition: ".concat(transition, ";"));
        splash.setAttribute("style", "-webkit-transition: ".concat(transition, ";"));
        splash.style.opacity = "0";
        window.splashRemovalTimeout = setTimeout(function() {
            return document.body.removeChild(splash);
        }, 1000);
    }
};
var getTenant = function() {
    return _config.default.tenant;
};
var getEnv = function() {
    return APP_ENV || "";
};
var GLOBALS = [
    // Webpack's stuff
    "webpackJsonpapp-bedrock-rdk",
    "webpackChunkapp_bedrock_rdk",
    // The i18n tool
    "sprintf",
    "vsprintf",
    // Lodash
    "_",
    // In case we are testing in dev mode (sic!)
    "devToolsOptions",
    // Loose ends :)
    "globalsToPreserve",
    "splashRemovalTimeout"
];
var preserveGlobals = function() {
    window.globalsToPreserve = Object.keys(window);
};
var cleanupGlobals = function() {
    if (window.splashRemovalTimeout) {
        clearTimeout(window.splashRemovalTimeout);
    }
    // No need to do it twice, the globals were already cleaned up
    if (!window.globalsToPreserve) {
        return;
    }
    var keysToCleanup = Object.keys(window).filter(function(key) {
        return !window.globalsToPreserve.includes(key);
    });
    keysToCleanup.forEach(function(key) {
        try {
            delete window[key];
        } catch (error) {
            // eslint-disable-next-line no-console
            console.log('[app.utils] Can not remove property "'.concat(key, '" in the window object'));
        }
    });
    GLOBALS.forEach(function(key) {
        delete window[key];
    });
    // Should be done by the Metrological store itself...well, we know how "reliable" it is
    if ({"PELO_PLATFORM":"magenta","APP_VERSION":"1.51.2","OPTIONS":"{\"platform\":\"magenta\",\"packaged\":false,\"debug\":false,\"skipHook\":false,\"skipNativeBuild\":true,\"skipBundler\":false}","GITHUB_STATE":"/runner/_work/_temp/_runner_file_commands/save_state_1aea6be7-8451-44d1-976b-920c5fab1345","npm_package_dependencies__babel_runtime":"7.22.3","npm_package_dependencies__pelo_plugins_screen":"workspace:*","npm_package_dependencies_regenerator_runtime":"0.13.11","npm_package_devDependencies_identity_obj_proxy":"3.0.0","npm_package_scripts_build_config_rtlnl":"APP_CUSTOMER=rtlnl node scripts/build-config","KUBERNETES_SERVICE_PORT":"443","KUBERNETES_PORT":"tcp://[fd24:3fac:1f16::1]:443","npm_package_dependencies_immutable_set":"2.1.0","npm_package_devDependencies__storybook_addon_knobs":"6.2.9","npm_package_devDependencies_prettier_eslint_cli":"7.1.0","npm_package_scripts_preinstall":"npx only-allow pnpm","npm_package_devDependencies__storybook_addon_docs":"6.2.9","npm_package_devDependencies_jest":"29.5.0","npm_package_devDependencies_webpack_bundle_analyzer":"4.10.2","npm_package_scripts_dev_rtlnl":"APP_CUSTOMER=rtlnl pnpm dev","npm_config_user_agent":"pnpm/9.14.4 npm/? node/v22.19.0 linux x64","CI":"true","npm_package_dependencies__bedrock_rdk_constants":"workspace:*","npm_package_dependencies__tornado_rdk_theme":"workspace:*","npm_package_dependencies_abortcontroller_polyfill":"1.7.8","npm_package_devDependencies__lightningjs_cli":"2.2.0","npm_package_scripts_build_config_rtlhu":"APP_CUSTOMER=rtlhu node scripts/build-config","npm_package_scripts_prod_rtlnl":"APP_CUSTOMER=rtlnl pnpm prod","HOSTNAME":"app-bedrock-rdk-deploy-npc97-bp8xd","RUNNER_ENVIRONMENT":"self-hosted","GITHUB_ENV":"/runner/_work/_temp/_runner_file_commands/set_env_1aea6be7-8451-44d1-976b-920c5fab1345","UPLOAD_SOURCE_MAPS":"false","npm_package_dependencies__bedrock_rdk_utils":"workspace:*","npm_node_execpath":"/opt/hostedtoolcache/node/22.19.0/x64/bin/node","GITHUB_ACTIONS_RUNNER_EXTRA_USER_AGENT":"actions-runner-controller/v0.27.6","RUNNER_EPHEMERAL":"true","SHLVL":"4","npm_package_packageManager":"pnpm@9.14.4","npm_package_dependencies__bedrock_rdk_lng_storybook":"workspace:*","npm_package_devDependencies__swc_core":"1.3.95","npm_package_scripts_dev_rtlhu":"APP_CUSTOMER=rtlhu pnpm dev","npm_package_scripts_nr_create_browser_applications":"node scripts/createNewRelicApps.js","HOME":"/home/runner","npm_package_devDependencies__babel_plugin_proposal_class_properties":"7.18.6","npm_package_devDependencies__bedrock_package_json_loader":"1.2.4","npm_package_devDependencies_jest_webgl_canvas_mock":"0.2.3","npm_package_scripts_prod_rtlhu":"APP_CUSTOMER=rtlhu pnpm prod","RUNNER_ORG":"","AWS_ROLE_ARN":"arn:aws:iam::081993058424:role/irsa/runners/app-bedrock-rdk-deploy","RUNNER_TEMP":"/runner/_work/_temp","GITHUB_EVENT_PATH":"/runner/_work/_temp/_github_workflow/event.json","npm_package_devDependencies_eslint_config_prettier":"9.0.0","npm_package_scripts_lint_filenames":"node scripts/checkFileScopes.js","npm_package_scripts_server":"http-server -c-1 build","npm_package_scripts_storybook_rtlde":"APP_CUSTOMER=rtlde start-storybook -p 6006","DOCKER_ENABLED":"true","GITHUB_REPOSITORY_OWNER":"m6web","npm_package_engines_node":"22.x","npm_package_dependencies__bedrock_html5_engine":"3.6.24","npm_package_devDependencies__6play_ryp":"3.2.4","npm_package_devDependencies__bedrock_github_api_utils":"1.0.1","npm_package_scripts_lint_json":"pnpm sort-keys:json --lint && prettier-eslint --list-different '/{.,}*.json' --ignore-path '**/package.json'","RUNNER_WORKDIR":"/runner/_work","GENERATE_SOURCEMAP":"true","AWS_WEB_IDENTITY_TOKEN_FILE":"/var/run/secrets/eks.amazonaws.com/serviceaccount/token","GITHUB_RETENTION_DAYS":"7","npm_package_devDependencies__pelo_platforms_vodafone":"10.0.0-alpha.1","npm_package_devDependencies_minimist":"1.2.8","npm_package_scripts_i18n_pull":"node ./scripts/i18nPull.js","npm_package_scripts_lint_md":"pnpm prettier-eslint --list-different $PWD/'**/*.md' $PWD/'.*/**/*.md'","GITHUB_REPOSITORY_OWNER_ID":"5","GITHUB_HEAD_REF":"","npm_package_dependencies_redux_thunk":"2.3.0","ACTIONS_RUNNER_HOOK_JOB_STARTED":"/etc/arc/hooks/job-started.sh","npm_package_devDependencies__swc_plugin_transform_imports":"1.5.94","npm_package_devDependencies_source_map_explorer":"1.6.0","npm_package_cypress_cucumber_preprocessor_stepDefinitions_0":"cypress/e2e/common/*.js","GITHUB_GRAPHQL_URL":"https://github.m6web.fr/api/graphql","REF":"v1.51.2","npm_package_dependencies__tornado_rdk_icons":"workspace:*","npm_package_dependencies_algoliasearch":"4.12.1","npm_package_dependencies_superagent":"8.0.9","npm_package_devDependencies_babel_loader":"9.1.2","npm_package_devDependencies_slack":"11.0.2","npm_package_scripts_build_config":"node scripts/build-config","npm_package_cypress_cucumber_preprocessor_stepDefinitions_1":"cypress/e2e/[filepart]/**/*.js","npm_package_dependencies_jwt_decode":"2.2.0","npm_package_devDependencies__babel_preset_env":"7.12.1","npm_package_scripts_e2e_rtlnl":"APP_CUSTOMER=rtlnl pnpm cypress open --e2e -b chrome","npm_package_pnpm_overrides__lightningjs_core":"2.9.0","npm_package_cypress_cucumber_preprocessor_stepDefinitions_2":"cypress/e2e/[filepart].js","GITHUB_URL":"https://github.m6web.fr/","RUNNER_ASSETS_DIR":"/runnertmp","AWS_STS_REGIONAL_ENDPOINTS":"regional","npm_package_devDependencies__babel_plugin_transform_runtime":"7.22.4","npm_package_devDependencies_inquirer":"8.1.5","npm_package_scripts_dev":"APP_ENV=development pelo run","RUNNER_OS":"Linux","GITHUB_API_URL":"https://github.m6web.fr/api/v3","MAXPROC":"8","RUNNER_LABELS":"self-hosted,app-bedrock-rdk-deploy","npm_package_devDependencies__pelo_platforms_ziggo":"10.0.0-alpha.1","npm_package_devDependencies_eslint_plugin_import":"2.28.1","npm_package_scripts_logs":"node scripts/logs.js","npm_package_scripts_prod":"APP_ENV=prod pelo run","_":"/home/runner/setup-pnpm/node_modules/.bin/pnpm","RUNNER_GROUP":"blue-gha-eks-bedrock-tech","HELM_REGISTRY_CONFIG":"/home/runner/.docker/config.json","GITHUB_WORKFLOW":"🏷 Release","npm_package_private":"true","npm_package_dependencies_sprintf_js":"1.1.2","npm_package_devDependencies__m6web_eslint_config":"3.5.0","npm_package_devDependencies_jsonlint":"1.6.3","npm_package_scripts_build_rtlnl":"APP_CUSTOMER=rtlnl pnpm build","npm_package_dependencies__bedrock_rdk_media_engine":"workspace:*","npm_package_dependencies_lightningjs_redux":"workspace:*","npm_package_devDependencies__babel_plugin_proposal_decorators":"7.22.3","npm_package_scripts_lint":"pnpm lint:js && pnpm lint:md && pnpm lint:json && pnpm lint:filenames","npm_config_registry":"https://verdaccio.bedrock.tech","GITHUB_RUN_ID":"4275928","npm_package_dependencies__bedrock_fido_sdk":"30.19.0","npm_package_dependencies_core_js":"3.32.1","npm_package_devDependencies__swc_jest":"0.2.29","npm_package_scripts_lint_tf":"terraform fmt -check -recursive -diff .cloud/terraform","npm_package_scripts_sort_keys_json":"node ./scripts/sortKeysJson.js","npm_package_pnpm_overrides_lodash":"4.17.21","GITHUB_REF_TYPE":"branch","GITHUB_WORKFLOW_SHA":"ab23f250364979d926e7565a2779bba0daadf009","KUBERNETES_PORT_443_TCP_ADDR":"fd24:3fac:1f16::1","GITHUB_BASE_REF":"","ImageOS":"ubuntu22","npm_package_devDependencies_dotenv_expand":"5.1.0","npm_package_devDependencies_html_webpack_plugin":"5.5.0","npm_package_scripts_build_rtlhu":"APP_CUSTOMER=rtlhu pnpm build","GITHUB_WORKFLOW_REF":"m6web/app-bedrock-rdk/.github/workflows/release.yml@refs/heads/master","GITHUB_ACTION_REPOSITORY":"","npm_config_node_gyp":"/home/runner/setup-pnpm/node_modules/.pnpm/pnpm@9.14.4/node_modules/pnpm/dist/node_modules/node-gyp/bin/node-gyp.js","PATH":"/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.bin:/home/runner/setup-pnpm/node_modules/.pnpm/pnpm@9.14.4/node_modules/pnpm/dist/node-gyp-bin:/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.bin:/opt/hostedtoolcache/node/22.19.0/x64/bin:/home/runner/setup-pnpm/node_modules/.bin:/usr/local/sbin:/usr/local/bin:/usr/sbin:/usr/bin:/sbin:/bin:/home/runner/.local/bin/","RUNNER_TRACKING_ID":"github_7c5f522c-ab40-4e86-a7b5-77a0008d8715","RUNNER_TOOL_CACHE":"/opt/hostedtoolcache","npm_package_name":"app-bedrock-rdk","npm_package_repository_type":"git","npm_package_dependencies_serve":"14.1.2","npm_package_devDependencies__babel_eslint_parser":"7.22.15","npm_package_scripts_lint_js":"pnpm eslint --max-warnings=0 .pelo.config.js src/ packages/ platforms/ --cache","NODE":"/opt/hostedtoolcache/node/22.19.0/x64/bin/node","GITHUB_ACTION":"__run_4","GITHUB_RUN_NUMBER":"246","GITHUB_TRIGGERING_ACTOR":"skovalchuk-externe","RUNNER_ARCH":"X64","KUBERNETES_PORT_443_TCP_PORT":"443","npm_package_devDependencies_eslint_config_airbnb_base":"15.0.0","npm_package_scripts_analyze":"APP_ENV=detective pnpm build","npm_package_scripts_build_config_rtlde":"APP_CUSTOMER=rtlde node scripts/build-config","npm_config_frozen_lockfile":"","RUN_URL":"https://github.m6web.fr/m6web/app-bedrock-rdk/actions/runs/4275928","KUBERNETES_PORT_443_TCP_PROTO":"tcp","npm_package_dependencies__pelo_plugins_device":"workspace:*","npm_package_devDependencies__bedrock_deploy_event":"0.11.0","npm_package_devDependencies__pelo_platforms_web":"10.0.0-alpha.1","npm_package_devDependencies__swc_helpers":"0.5.3","npm_package_devDependencies_glob":"7.1.6","npm_package_devDependencies_prettier_eslint":"15.0.1","npm_package_dependencies__firebolt_js_sdk":"1.7.0","npm_package_dependencies__lightningjs_core":"2.9.0","npm_package_dependencies_history":"4.9.0","npm_package_dependencies_redux":"4.0.5","npm_package_devDependencies__storybook_theming":"6.2.9","npm_package_devDependencies_eslint":"8.50.0","npm_package_devDependencies_webpack":"5.88.2","npm_package_scripts_dev_rtlde":"APP_CUSTOMER=rtlde pnpm dev","npm_package_scripts_format_md":"prettier-eslint --write $PWD/'**/*.md' $PWD/'.*/**/*.md'","npm_package_scripts_storybook_rtlnl":"APP_CUSTOMER=rtlnl start-storybook -p 6006","RUNNER_NAME":"app-bedrock-rdk-deploy-npc97-bp8xd","PIP_REQUIRE_VIRTUALENV":"true","GITHUB_REF_NAME":"master","GITHUB_REPOSITORY":"m6web/app-bedrock-rdk","S3_PATH":"s3://bedrock-rdk-rtlde-prod-magenta","npm_package_devDependencies__storybook_html":"6.2.9","npm_package_devDependencies_copy_webpack_plugin":"11.0.0","npm_package_devDependencies_dotenv":"16.0.3","npm_package_scripts_e2e":"pnpm cypress open --e2e -b chrome","npm_package_scripts_prod_rtlde":"APP_CUSTOMER=rtlde pnpm prod","npm_lifecycle_script":"pelo build \"magenta\" \"--skip-native-build\"","GITHUB_ACTION_REF":"","DEBIAN_FRONTEND":"noninteractive","npm_package_devDependencies__babel_runtime_corejs3":"7.22.3","npm_package_devDependencies__cypress_webpack_preprocessor":"6.0.0","npm_package_devDependencies__pelo_core":"10.0.0-alpha.1","npm_package_devDependencies__storybook_addons":"6.2.9","npm_package_scripts_test":"PELO_PLATFORM=rdk APP_ENV=test node scripts/test --config=config/jest/config.js","GITHUB_REPOSITORY_ID":"2571","GITHUB_ACTIONS":"true","GOPROXY":"https://goproxy.services.bedrock.tech","NODE_PATH":"/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.pnpm/@pelo+cli@10.0.0-alpha.1_@babel+core@7.27.4_@swc+core@1.3.95_@swc+helpers@0.5.3__@types+webpa_eyh3qr2suoq7louvyapz62n3cq/node_modules/@pelo/cli/bin/node_modules:/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.pnpm/@pelo+cli@10.0.0-alpha.1_@babel+core@7.27.4_@swc+core@1.3.95_@swc+helpers@0.5.3__@types+webpa_eyh3qr2suoq7louvyapz62n3cq/node_modules/@pelo/cli/node_modules:/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.pnpm/@pelo+cli@10.0.0-alpha.1_@babel+core@7.27.4_@swc+core@1.3.95_@swc+helpers@0.5.3__@types+webpa_eyh3qr2suoq7louvyapz62n3cq/node_modules/@pelo/node_modules:/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.pnpm/@pelo+cli@10.0.0-alpha.1_@babel+core@7.27.4_@swc+core@1.3.95_@swc+helpers@0.5.3__@types+webpa_eyh3qr2suoq7louvyapz62n3cq/node_modules:/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.pnpm/node_modules:/home/runner/setup-pnpm/node_modules/.pnpm/pnpm@9.14.4/node_modules/pnpm/bin/node_modules:/home/runner/setup-pnpm/node_modules/.pnpm/pnpm@9.14.4/node_modules/pnpm/node_modules:/home/runner/setup-pnpm/node_modules/.pnpm/pnpm@9.14.4/node_modules:/home/runner/setup-pnpm/node_modules/.pnpm/node_modules","npm_package_repository_url":"https://github.m6web.fr/m6web/app-bedrock-rdk.git","npm_package_version":"1.51.2","npm_package_dependencies__bedrock_ad_engine":"5.39.0","npm_package_devDependencies__m6web_eslint_plugin_i18n":"2.0.1","npm_package_devDependencies_jest_environment_jsdom":"29.5.0","npm_package_scripts_storybook_rtlhu":"APP_CUSTOMER=rtlhu start-storybook -p 6006","npm_package_pnpm_overrides__lightningjs_sdk":"5.5.5","npm_lifecycle_event":"build","ACTIONS_RUNNER_HOOK_JOB_COMPLETED":"/etc/arc/hooks/job-completed.sh","GITHUB_REF_PROTECTED":"true","GONOSUMDB":"github.m6web.fr","GONOPROXY":"none","npm_package_dependencies_uuid":"10.0.0","npm_package_scripts_build":"pelo build \"magenta\" \"--skip-native-build\"","npm_package_scripts_upload":"node scripts/uploadToMetrologicalAppStore","GITHUB_WORKSPACE":"/runner/_work/app-bedrock-rdk/app-bedrock-rdk","GITHUB_JOB":"build_and_deploy","npm_package_author":"Bedrock","npm_package_engines_pnpm":"9.x.x","npm_package_dependencies__bedrock_youbora_adapter_adengine":"1.9.9","npm_package_dependencies_lodash":"4.17.21","npm_package_devDependencies_cypress":"13.3.0","npm_package_devDependencies_http_server":"14.1.1","npm_package_scripts_test_coverage":"PELO_PLATFORM=rdk APP_ENV=test node scripts/test --config=config/jest/config.js --coverage","GITHUB_SHA":"ab23f250364979d926e7565a2779bba0daadf009","GOMAXPROC":"8","GITHUB_RUN_ATTEMPT":"1","DOCKER_HOST":"unix:///run/docker.sock","npm_package_dependencies__bedrock_media_engine":"4.17.1","npm_package_devDependencies__pelo_cli":"10.0.0-alpha.1","KUBERNETES_SERVICE_PORT_HTTPS":"443","GOPRIVATE":"*.m6web.fr,*.bedrock.tech","GITHUB_REF":"refs/heads/master","KUBERNETES_PORT_443_TCP":"tcp://[fd24:3fac:1f16::1]:443","GITHUB_ACTOR":"skovalchuk-externe","npm_package_license":"UNLICENSED","npm_package_dependencies_markdown_it":"12.2.0","DOCKERD_IN_RUNNER":"false","npm_package_dependencies_crypto_js":"4.2.0","npm_package_dependencies_qrcode":"1.5.4","npm_package_dependencies_stream_browserify":"3.0.0","npm_package_devDependencies_eslint_plugin_prettier":"5.0.0","npm_package_scripts_format":"pnpm format:js && pnpm format:md && pnpm format:lang","npm_package_scripts_update_lang":"run-s 'i18n:pull {1}' format:lang --","GITHUB_PATH":"/runner/_work/_temp/_runner_file_commands/add_path_1aea6be7-8451-44d1-976b-920c5fab1345","PWD":"/runner/_work/app-bedrock-rdk/app-bedrock-rdk","IS_STAGING":"false","APP_ENV":"prod","GITHUB_ACTOR_ID":"627","KUBERNETES_SERVICE_HOST":"fd24:3fac:1f16::1","RUNNER_WORKSPACE":"/runner/_work/app-bedrock-rdk","npm_package_dependencies_path_to_regexp":"3.0.0","npm_package_scripts_explore":"source-map-explorer build/static/js/main.*","npm_package_scripts_format_tf":"terraform fmt -recursive -write=true .cloud/terraform","npm_execpath":"/home/runner/setup-pnpm/node_modules/.pnpm/pnpm@9.14.4/node_modules/pnpm/bin/pnpm.cjs","GITHUB_EVENT_NAME":"workflow_dispatch","GITHUB_SERVER_URL":"https://github.m6web.fr","GITHUB_OUTPUT":"/runner/_work/_temp/_runner_file_commands/set_output_1aea6be7-8451-44d1-976b-920c5fab1345","npm_package_dependencies__bedrock_rdk_config":"workspace:*","npm_package_devDependencies__pelo_platforms_kpn":"10.0.0-alpha.1","npm_package_devDependencies_es_check":"7.1.1","npm_package_devDependencies_fs_extra":"9.1.0","npm_package_devDependencies_swc_mut_cjs_exports":"0.86.17","RUNNER_STATUS_UPDATE_HOOK":"false","npm_package_dependencies_browser_cookies":"1.2.0","npm_package_dependencies_date_fns":"2.28.0","npm_package_devDependencies__badeball_cypress_cucumber_preprocessor":"18.0.6","npm_package_devDependencies_svgo_loader":"3.0.1","npm_package_scripts_build_storybook":"build-storybook -o dist-storybook","npm_command":"run-script","PNPM_SCRIPT_SRC_DIR":"/runner/_work/app-bedrock-rdk/app-bedrock-rdk","APP_CUSTOMER":"rtlde","npm_package_dependencies_storybook_addon_themes":"6.1.0","npm_package_devDependencies__storybook_addon_essentials":"6.2.9","npm_package_scripts_format_js":"prettier-eslint --write $PWD/'src/**/*.js' $PWD/'packages/**/*.js' $PWD/'platforms/**/*.js' $PWD/'config/**/*.js'","PNPM_HOME":"/home/runner/setup-pnpm/node_modules/.bin","RUNNER_ENTERPRISE":"","npm_package_dependencies__tornado_rdk_typography":"workspace:*","GITHUB_STEP_SUMMARY":"/runner/_work/_temp/_runner_file_commands/step_summary_1aea6be7-8451-44d1-976b-920c5fab1345","npm_package_dependencies__lightningjs_sdk":"5.5.5","npm_package_dependencies__pelo_plugins_keys":"workspace:*","npm_package_devDependencies_swc_loader":"0.2.3","npm_package_devDependencies_swc_minify_webpack_plugin":"2.1.1","npm_package_scripts_build_rtlde":"APP_CUSTOMER=rtlde pnpm build","npm_package_scripts_format_lang":"prettier-eslint --write $PWD/'lang/**/*.json'","npm_package_pnpm_overrides_webpack":"5.88.2","npm_package_pnpm_peerDependencyRules_allowedVersions_webpack":"5","INIT_CWD":"/runner/_work/app-bedrock-rdk/app-bedrock-rdk","NODE_ENV":"production"}.APP_ID) {
        var id = "APP_".concat({"PELO_PLATFORM":"magenta","APP_VERSION":"1.51.2","OPTIONS":"{\"platform\":\"magenta\",\"packaged\":false,\"debug\":false,\"skipHook\":false,\"skipNativeBuild\":true,\"skipBundler\":false}","GITHUB_STATE":"/runner/_work/_temp/_runner_file_commands/save_state_1aea6be7-8451-44d1-976b-920c5fab1345","npm_package_dependencies__babel_runtime":"7.22.3","npm_package_dependencies__pelo_plugins_screen":"workspace:*","npm_package_dependencies_regenerator_runtime":"0.13.11","npm_package_devDependencies_identity_obj_proxy":"3.0.0","npm_package_scripts_build_config_rtlnl":"APP_CUSTOMER=rtlnl node scripts/build-config","KUBERNETES_SERVICE_PORT":"443","KUBERNETES_PORT":"tcp://[fd24:3fac:1f16::1]:443","npm_package_dependencies_immutable_set":"2.1.0","npm_package_devDependencies__storybook_addon_knobs":"6.2.9","npm_package_devDependencies_prettier_eslint_cli":"7.1.0","npm_package_scripts_preinstall":"npx only-allow pnpm","npm_package_devDependencies__storybook_addon_docs":"6.2.9","npm_package_devDependencies_jest":"29.5.0","npm_package_devDependencies_webpack_bundle_analyzer":"4.10.2","npm_package_scripts_dev_rtlnl":"APP_CUSTOMER=rtlnl pnpm dev","npm_config_user_agent":"pnpm/9.14.4 npm/? node/v22.19.0 linux x64","CI":"true","npm_package_dependencies__bedrock_rdk_constants":"workspace:*","npm_package_dependencies__tornado_rdk_theme":"workspace:*","npm_package_dependencies_abortcontroller_polyfill":"1.7.8","npm_package_devDependencies__lightningjs_cli":"2.2.0","npm_package_scripts_build_config_rtlhu":"APP_CUSTOMER=rtlhu node scripts/build-config","npm_package_scripts_prod_rtlnl":"APP_CUSTOMER=rtlnl pnpm prod","HOSTNAME":"app-bedrock-rdk-deploy-npc97-bp8xd","RUNNER_ENVIRONMENT":"self-hosted","GITHUB_ENV":"/runner/_work/_temp/_runner_file_commands/set_env_1aea6be7-8451-44d1-976b-920c5fab1345","UPLOAD_SOURCE_MAPS":"false","npm_package_dependencies__bedrock_rdk_utils":"workspace:*","npm_node_execpath":"/opt/hostedtoolcache/node/22.19.0/x64/bin/node","GITHUB_ACTIONS_RUNNER_EXTRA_USER_AGENT":"actions-runner-controller/v0.27.6","RUNNER_EPHEMERAL":"true","SHLVL":"4","npm_package_packageManager":"pnpm@9.14.4","npm_package_dependencies__bedrock_rdk_lng_storybook":"workspace:*","npm_package_devDependencies__swc_core":"1.3.95","npm_package_scripts_dev_rtlhu":"APP_CUSTOMER=rtlhu pnpm dev","npm_package_scripts_nr_create_browser_applications":"node scripts/createNewRelicApps.js","HOME":"/home/runner","npm_package_devDependencies__babel_plugin_proposal_class_properties":"7.18.6","npm_package_devDependencies__bedrock_package_json_loader":"1.2.4","npm_package_devDependencies_jest_webgl_canvas_mock":"0.2.3","npm_package_scripts_prod_rtlhu":"APP_CUSTOMER=rtlhu pnpm prod","RUNNER_ORG":"","AWS_ROLE_ARN":"arn:aws:iam::081993058424:role/irsa/runners/app-bedrock-rdk-deploy","RUNNER_TEMP":"/runner/_work/_temp","GITHUB_EVENT_PATH":"/runner/_work/_temp/_github_workflow/event.json","npm_package_devDependencies_eslint_config_prettier":"9.0.0","npm_package_scripts_lint_filenames":"node scripts/checkFileScopes.js","npm_package_scripts_server":"http-server -c-1 build","npm_package_scripts_storybook_rtlde":"APP_CUSTOMER=rtlde start-storybook -p 6006","DOCKER_ENABLED":"true","GITHUB_REPOSITORY_OWNER":"m6web","npm_package_engines_node":"22.x","npm_package_dependencies__bedrock_html5_engine":"3.6.24","npm_package_devDependencies__6play_ryp":"3.2.4","npm_package_devDependencies__bedrock_github_api_utils":"1.0.1","npm_package_scripts_lint_json":"pnpm sort-keys:json --lint && prettier-eslint --list-different '/{.,}*.json' --ignore-path '**/package.json'","RUNNER_WORKDIR":"/runner/_work","GENERATE_SOURCEMAP":"true","AWS_WEB_IDENTITY_TOKEN_FILE":"/var/run/secrets/eks.amazonaws.com/serviceaccount/token","GITHUB_RETENTION_DAYS":"7","npm_package_devDependencies__pelo_platforms_vodafone":"10.0.0-alpha.1","npm_package_devDependencies_minimist":"1.2.8","npm_package_scripts_i18n_pull":"node ./scripts/i18nPull.js","npm_package_scripts_lint_md":"pnpm prettier-eslint --list-different $PWD/'**/*.md' $PWD/'.*/**/*.md'","GITHUB_REPOSITORY_OWNER_ID":"5","GITHUB_HEAD_REF":"","npm_package_dependencies_redux_thunk":"2.3.0","ACTIONS_RUNNER_HOOK_JOB_STARTED":"/etc/arc/hooks/job-started.sh","npm_package_devDependencies__swc_plugin_transform_imports":"1.5.94","npm_package_devDependencies_source_map_explorer":"1.6.0","npm_package_cypress_cucumber_preprocessor_stepDefinitions_0":"cypress/e2e/common/*.js","GITHUB_GRAPHQL_URL":"https://github.m6web.fr/api/graphql","REF":"v1.51.2","npm_package_dependencies__tornado_rdk_icons":"workspace:*","npm_package_dependencies_algoliasearch":"4.12.1","npm_package_dependencies_superagent":"8.0.9","npm_package_devDependencies_babel_loader":"9.1.2","npm_package_devDependencies_slack":"11.0.2","npm_package_scripts_build_config":"node scripts/build-config","npm_package_cypress_cucumber_preprocessor_stepDefinitions_1":"cypress/e2e/[filepart]/**/*.js","npm_package_dependencies_jwt_decode":"2.2.0","npm_package_devDependencies__babel_preset_env":"7.12.1","npm_package_scripts_e2e_rtlnl":"APP_CUSTOMER=rtlnl pnpm cypress open --e2e -b chrome","npm_package_pnpm_overrides__lightningjs_core":"2.9.0","npm_package_cypress_cucumber_preprocessor_stepDefinitions_2":"cypress/e2e/[filepart].js","GITHUB_URL":"https://github.m6web.fr/","RUNNER_ASSETS_DIR":"/runnertmp","AWS_STS_REGIONAL_ENDPOINTS":"regional","npm_package_devDependencies__babel_plugin_transform_runtime":"7.22.4","npm_package_devDependencies_inquirer":"8.1.5","npm_package_scripts_dev":"APP_ENV=development pelo run","RUNNER_OS":"Linux","GITHUB_API_URL":"https://github.m6web.fr/api/v3","MAXPROC":"8","RUNNER_LABELS":"self-hosted,app-bedrock-rdk-deploy","npm_package_devDependencies__pelo_platforms_ziggo":"10.0.0-alpha.1","npm_package_devDependencies_eslint_plugin_import":"2.28.1","npm_package_scripts_logs":"node scripts/logs.js","npm_package_scripts_prod":"APP_ENV=prod pelo run","_":"/home/runner/setup-pnpm/node_modules/.bin/pnpm","RUNNER_GROUP":"blue-gha-eks-bedrock-tech","HELM_REGISTRY_CONFIG":"/home/runner/.docker/config.json","GITHUB_WORKFLOW":"🏷 Release","npm_package_private":"true","npm_package_dependencies_sprintf_js":"1.1.2","npm_package_devDependencies__m6web_eslint_config":"3.5.0","npm_package_devDependencies_jsonlint":"1.6.3","npm_package_scripts_build_rtlnl":"APP_CUSTOMER=rtlnl pnpm build","npm_package_dependencies__bedrock_rdk_media_engine":"workspace:*","npm_package_dependencies_lightningjs_redux":"workspace:*","npm_package_devDependencies__babel_plugin_proposal_decorators":"7.22.3","npm_package_scripts_lint":"pnpm lint:js && pnpm lint:md && pnpm lint:json && pnpm lint:filenames","npm_config_registry":"https://verdaccio.bedrock.tech","GITHUB_RUN_ID":"4275928","npm_package_dependencies__bedrock_fido_sdk":"30.19.0","npm_package_dependencies_core_js":"3.32.1","npm_package_devDependencies__swc_jest":"0.2.29","npm_package_scripts_lint_tf":"terraform fmt -check -recursive -diff .cloud/terraform","npm_package_scripts_sort_keys_json":"node ./scripts/sortKeysJson.js","npm_package_pnpm_overrides_lodash":"4.17.21","GITHUB_REF_TYPE":"branch","GITHUB_WORKFLOW_SHA":"ab23f250364979d926e7565a2779bba0daadf009","KUBERNETES_PORT_443_TCP_ADDR":"fd24:3fac:1f16::1","GITHUB_BASE_REF":"","ImageOS":"ubuntu22","npm_package_devDependencies_dotenv_expand":"5.1.0","npm_package_devDependencies_html_webpack_plugin":"5.5.0","npm_package_scripts_build_rtlhu":"APP_CUSTOMER=rtlhu pnpm build","GITHUB_WORKFLOW_REF":"m6web/app-bedrock-rdk/.github/workflows/release.yml@refs/heads/master","GITHUB_ACTION_REPOSITORY":"","npm_config_node_gyp":"/home/runner/setup-pnpm/node_modules/.pnpm/pnpm@9.14.4/node_modules/pnpm/dist/node_modules/node-gyp/bin/node-gyp.js","PATH":"/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.bin:/home/runner/setup-pnpm/node_modules/.pnpm/pnpm@9.14.4/node_modules/pnpm/dist/node-gyp-bin:/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.bin:/opt/hostedtoolcache/node/22.19.0/x64/bin:/home/runner/setup-pnpm/node_modules/.bin:/usr/local/sbin:/usr/local/bin:/usr/sbin:/usr/bin:/sbin:/bin:/home/runner/.local/bin/","RUNNER_TRACKING_ID":"github_7c5f522c-ab40-4e86-a7b5-77a0008d8715","RUNNER_TOOL_CACHE":"/opt/hostedtoolcache","npm_package_name":"app-bedrock-rdk","npm_package_repository_type":"git","npm_package_dependencies_serve":"14.1.2","npm_package_devDependencies__babel_eslint_parser":"7.22.15","npm_package_scripts_lint_js":"pnpm eslint --max-warnings=0 .pelo.config.js src/ packages/ platforms/ --cache","NODE":"/opt/hostedtoolcache/node/22.19.0/x64/bin/node","GITHUB_ACTION":"__run_4","GITHUB_RUN_NUMBER":"246","GITHUB_TRIGGERING_ACTOR":"skovalchuk-externe","RUNNER_ARCH":"X64","KUBERNETES_PORT_443_TCP_PORT":"443","npm_package_devDependencies_eslint_config_airbnb_base":"15.0.0","npm_package_scripts_analyze":"APP_ENV=detective pnpm build","npm_package_scripts_build_config_rtlde":"APP_CUSTOMER=rtlde node scripts/build-config","npm_config_frozen_lockfile":"","RUN_URL":"https://github.m6web.fr/m6web/app-bedrock-rdk/actions/runs/4275928","KUBERNETES_PORT_443_TCP_PROTO":"tcp","npm_package_dependencies__pelo_plugins_device":"workspace:*","npm_package_devDependencies__bedrock_deploy_event":"0.11.0","npm_package_devDependencies__pelo_platforms_web":"10.0.0-alpha.1","npm_package_devDependencies__swc_helpers":"0.5.3","npm_package_devDependencies_glob":"7.1.6","npm_package_devDependencies_prettier_eslint":"15.0.1","npm_package_dependencies__firebolt_js_sdk":"1.7.0","npm_package_dependencies__lightningjs_core":"2.9.0","npm_package_dependencies_history":"4.9.0","npm_package_dependencies_redux":"4.0.5","npm_package_devDependencies__storybook_theming":"6.2.9","npm_package_devDependencies_eslint":"8.50.0","npm_package_devDependencies_webpack":"5.88.2","npm_package_scripts_dev_rtlde":"APP_CUSTOMER=rtlde pnpm dev","npm_package_scripts_format_md":"prettier-eslint --write $PWD/'**/*.md' $PWD/'.*/**/*.md'","npm_package_scripts_storybook_rtlnl":"APP_CUSTOMER=rtlnl start-storybook -p 6006","RUNNER_NAME":"app-bedrock-rdk-deploy-npc97-bp8xd","PIP_REQUIRE_VIRTUALENV":"true","GITHUB_REF_NAME":"master","GITHUB_REPOSITORY":"m6web/app-bedrock-rdk","S3_PATH":"s3://bedrock-rdk-rtlde-prod-magenta","npm_package_devDependencies__storybook_html":"6.2.9","npm_package_devDependencies_copy_webpack_plugin":"11.0.0","npm_package_devDependencies_dotenv":"16.0.3","npm_package_scripts_e2e":"pnpm cypress open --e2e -b chrome","npm_package_scripts_prod_rtlde":"APP_CUSTOMER=rtlde pnpm prod","npm_lifecycle_script":"pelo build \"magenta\" \"--skip-native-build\"","GITHUB_ACTION_REF":"","DEBIAN_FRONTEND":"noninteractive","npm_package_devDependencies__babel_runtime_corejs3":"7.22.3","npm_package_devDependencies__cypress_webpack_preprocessor":"6.0.0","npm_package_devDependencies__pelo_core":"10.0.0-alpha.1","npm_package_devDependencies__storybook_addons":"6.2.9","npm_package_scripts_test":"PELO_PLATFORM=rdk APP_ENV=test node scripts/test --config=config/jest/config.js","GITHUB_REPOSITORY_ID":"2571","GITHUB_ACTIONS":"true","GOPROXY":"https://goproxy.services.bedrock.tech","NODE_PATH":"/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.pnpm/@pelo+cli@10.0.0-alpha.1_@babel+core@7.27.4_@swc+core@1.3.95_@swc+helpers@0.5.3__@types+webpa_eyh3qr2suoq7louvyapz62n3cq/node_modules/@pelo/cli/bin/node_modules:/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.pnpm/@pelo+cli@10.0.0-alpha.1_@babel+core@7.27.4_@swc+core@1.3.95_@swc+helpers@0.5.3__@types+webpa_eyh3qr2suoq7louvyapz62n3cq/node_modules/@pelo/cli/node_modules:/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.pnpm/@pelo+cli@10.0.0-alpha.1_@babel+core@7.27.4_@swc+core@1.3.95_@swc+helpers@0.5.3__@types+webpa_eyh3qr2suoq7louvyapz62n3cq/node_modules/@pelo/node_modules:/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.pnpm/@pelo+cli@10.0.0-alpha.1_@babel+core@7.27.4_@swc+core@1.3.95_@swc+helpers@0.5.3__@types+webpa_eyh3qr2suoq7louvyapz62n3cq/node_modules:/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.pnpm/node_modules:/home/runner/setup-pnpm/node_modules/.pnpm/pnpm@9.14.4/node_modules/pnpm/bin/node_modules:/home/runner/setup-pnpm/node_modules/.pnpm/pnpm@9.14.4/node_modules/pnpm/node_modules:/home/runner/setup-pnpm/node_modules/.pnpm/pnpm@9.14.4/node_modules:/home/runner/setup-pnpm/node_modules/.pnpm/node_modules","npm_package_repository_url":"https://github.m6web.fr/m6web/app-bedrock-rdk.git","npm_package_version":"1.51.2","npm_package_dependencies__bedrock_ad_engine":"5.39.0","npm_package_devDependencies__m6web_eslint_plugin_i18n":"2.0.1","npm_package_devDependencies_jest_environment_jsdom":"29.5.0","npm_package_scripts_storybook_rtlhu":"APP_CUSTOMER=rtlhu start-storybook -p 6006","npm_package_pnpm_overrides__lightningjs_sdk":"5.5.5","npm_lifecycle_event":"build","ACTIONS_RUNNER_HOOK_JOB_COMPLETED":"/etc/arc/hooks/job-completed.sh","GITHUB_REF_PROTECTED":"true","GONOSUMDB":"github.m6web.fr","GONOPROXY":"none","npm_package_dependencies_uuid":"10.0.0","npm_package_scripts_build":"pelo build \"magenta\" \"--skip-native-build\"","npm_package_scripts_upload":"node scripts/uploadToMetrologicalAppStore","GITHUB_WORKSPACE":"/runner/_work/app-bedrock-rdk/app-bedrock-rdk","GITHUB_JOB":"build_and_deploy","npm_package_author":"Bedrock","npm_package_engines_pnpm":"9.x.x","npm_package_dependencies__bedrock_youbora_adapter_adengine":"1.9.9","npm_package_dependencies_lodash":"4.17.21","npm_package_devDependencies_cypress":"13.3.0","npm_package_devDependencies_http_server":"14.1.1","npm_package_scripts_test_coverage":"PELO_PLATFORM=rdk APP_ENV=test node scripts/test --config=config/jest/config.js --coverage","GITHUB_SHA":"ab23f250364979d926e7565a2779bba0daadf009","GOMAXPROC":"8","GITHUB_RUN_ATTEMPT":"1","DOCKER_HOST":"unix:///run/docker.sock","npm_package_dependencies__bedrock_media_engine":"4.17.1","npm_package_devDependencies__pelo_cli":"10.0.0-alpha.1","KUBERNETES_SERVICE_PORT_HTTPS":"443","GOPRIVATE":"*.m6web.fr,*.bedrock.tech","GITHUB_REF":"refs/heads/master","KUBERNETES_PORT_443_TCP":"tcp://[fd24:3fac:1f16::1]:443","GITHUB_ACTOR":"skovalchuk-externe","npm_package_license":"UNLICENSED","npm_package_dependencies_markdown_it":"12.2.0","DOCKERD_IN_RUNNER":"false","npm_package_dependencies_crypto_js":"4.2.0","npm_package_dependencies_qrcode":"1.5.4","npm_package_dependencies_stream_browserify":"3.0.0","npm_package_devDependencies_eslint_plugin_prettier":"5.0.0","npm_package_scripts_format":"pnpm format:js && pnpm format:md && pnpm format:lang","npm_package_scripts_update_lang":"run-s 'i18n:pull {1}' format:lang --","GITHUB_PATH":"/runner/_work/_temp/_runner_file_commands/add_path_1aea6be7-8451-44d1-976b-920c5fab1345","PWD":"/runner/_work/app-bedrock-rdk/app-bedrock-rdk","IS_STAGING":"false","APP_ENV":"prod","GITHUB_ACTOR_ID":"627","KUBERNETES_SERVICE_HOST":"fd24:3fac:1f16::1","RUNNER_WORKSPACE":"/runner/_work/app-bedrock-rdk","npm_package_dependencies_path_to_regexp":"3.0.0","npm_package_scripts_explore":"source-map-explorer build/static/js/main.*","npm_package_scripts_format_tf":"terraform fmt -recursive -write=true .cloud/terraform","npm_execpath":"/home/runner/setup-pnpm/node_modules/.pnpm/pnpm@9.14.4/node_modules/pnpm/bin/pnpm.cjs","GITHUB_EVENT_NAME":"workflow_dispatch","GITHUB_SERVER_URL":"https://github.m6web.fr","GITHUB_OUTPUT":"/runner/_work/_temp/_runner_file_commands/set_output_1aea6be7-8451-44d1-976b-920c5fab1345","npm_package_dependencies__bedrock_rdk_config":"workspace:*","npm_package_devDependencies__pelo_platforms_kpn":"10.0.0-alpha.1","npm_package_devDependencies_es_check":"7.1.1","npm_package_devDependencies_fs_extra":"9.1.0","npm_package_devDependencies_swc_mut_cjs_exports":"0.86.17","RUNNER_STATUS_UPDATE_HOOK":"false","npm_package_dependencies_browser_cookies":"1.2.0","npm_package_dependencies_date_fns":"2.28.0","npm_package_devDependencies__badeball_cypress_cucumber_preprocessor":"18.0.6","npm_package_devDependencies_svgo_loader":"3.0.1","npm_package_scripts_build_storybook":"build-storybook -o dist-storybook","npm_command":"run-script","PNPM_SCRIPT_SRC_DIR":"/runner/_work/app-bedrock-rdk/app-bedrock-rdk","APP_CUSTOMER":"rtlde","npm_package_dependencies_storybook_addon_themes":"6.1.0","npm_package_devDependencies__storybook_addon_essentials":"6.2.9","npm_package_scripts_format_js":"prettier-eslint --write $PWD/'src/**/*.js' $PWD/'packages/**/*.js' $PWD/'platforms/**/*.js' $PWD/'config/**/*.js'","PNPM_HOME":"/home/runner/setup-pnpm/node_modules/.bin","RUNNER_ENTERPRISE":"","npm_package_dependencies__tornado_rdk_typography":"workspace:*","GITHUB_STEP_SUMMARY":"/runner/_work/_temp/_runner_file_commands/step_summary_1aea6be7-8451-44d1-976b-920c5fab1345","npm_package_dependencies__lightningjs_sdk":"5.5.5","npm_package_dependencies__pelo_plugins_keys":"workspace:*","npm_package_devDependencies_swc_loader":"0.2.3","npm_package_devDependencies_swc_minify_webpack_plugin":"2.1.1","npm_package_scripts_build_rtlde":"APP_CUSTOMER=rtlde pnpm build","npm_package_scripts_format_lang":"prettier-eslint --write $PWD/'lang/**/*.json'","npm_package_pnpm_overrides_webpack":"5.88.2","npm_package_pnpm_peerDependencyRules_allowedVersions_webpack":"5","INIT_CWD":"/runner/_work/app-bedrock-rdk/app-bedrock-rdk","NODE_ENV":"production"}.APP_ID.replace(/[^0-9a-zA-Z_$]/g, "_"));
        delete window[id];
    }
};
var cleanupConfig = function() {
    Object.keys(_config.default).forEach(function(key) {
        delete _config.default[key];
    });
};


/***/ }),

/***/ 85669:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "patchOIDC", ({
    enumerable: true,
    get: function() {
        return patchOIDC;
    }
}));
var _async_to_generator = __webpack_require__(24146);
var _interop_require_default = __webpack_require__(81200);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(42578);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _jwtdecode = /*#__PURE__*/ _interop_require_default._(__webpack_require__(30588));
var _useractions = __webpack_require__(79489);
var STORAGE_KEYS = {
    ACCESS_TOKEN: "oidcAccessToken",
    REFRESH_TOKEN: "oidcRefreshToken",
    ID_TOKEN: "oidcIdToken"
};
var patchOIDC = function(base) {
    base.setTokens = function setTokens(param) {
        var accessToken = param.accessToken, refreshToken = param.refreshToken, idToken = param.idToken;
        this.tokenManager.setAccessToken(accessToken);
        this.tokenManager.setRefreshToken(refreshToken);
        this.tokenManager.setIdToken(idToken);
        // This logic is specific to Magenta SSO
        if (accessToken && this.isTokenValid(accessToken)) {
            try {
                var decodedToken = (0, _jwtdecode.default)(accessToken);
                if (decodedToken.birthdate) {
                    _lightningjsredux.default.dispatch((0, _useractions.completeAccount)());
                }
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error("[OIDC] Can not fetch birthdate from JWT".concat(error ? ": ".concat(error.message) : ""));
            }
        }
    };
    base.getOrFetchOidcTokens = function() {
        var _getOrFetchOidcTokens = _async_to_generator._(function() {
            var error;
            return _ts_generator._(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Ensure tokens validity and remove invalid tokens from storage if any
                        this.setTokens({
                            accessToken: localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN),
                            refreshToken: localStorage.getItem(STORAGE_KEYS.REFRESH_TOKEN),
                            idToken: localStorage.getItem(STORAGE_KEYS.ID_TOKEN)
                        });
                        this.checkTokensValidity();
                        // At this moment we need access token only, as it's valid and not expired
                        if (this.getAccessToken()) {
                            return [
                                2,
                                {
                                    accessToken: this.getAccessToken(),
                                    refreshToken: this.getRefreshToken()
                                }
                            ];
                        }
                        if (!this.getRefreshToken()) return [
                            3,
                            5
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            this.renewAccessToken()
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        this.clearTokens();
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            3,
                            7
                        ];
                    case 5:
                        // Once the guest access token will be issues and stored, we will not get there
                        // as the access token validity check performed before will be successful
                        return [
                            4,
                            this.fetchAnonymousTokens()
                        ];
                    case 6:
                        _state.sent();
                        _state.label = 7;
                    case 7:
                        // The refresh token will be always empty as this is the guarantee of entering into this branch
                        return [
                            2,
                            {
                                accessToken: this.getAccessToken() || "",
                                refreshToken: this.getRefreshToken() || ""
                            }
                        ];
                }
            });
        });
        function getOrFetchOidcTokens() {
            return _getOrFetchOidcTokens.apply(this, arguments);
        }
        return getOrFetchOidcTokens;
    }();
};


/***/ }),

/***/ 37871:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    initFidoSDK: function() {
        return initFidoSDK;
    },
    updateFidoConfig: function() {
        return updateFidoConfig;
    }
});
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _sliced_to_array = __webpack_require__(28966);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(3009);
var _fidosdk = __webpack_require__(19804);
var _config = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67958));
var _utils = __webpack_require__(64188);
var _appselectors = __webpack_require__(65910);
var _userselectors = __webpack_require__(41845);
var _fidooidc = __webpack_require__(85669);
var initFidoSDK = function(getState) {
    var state = getState();
    var homeId = (0, _userselectors.getHomeId)(state);
    var localDeviceId = (0, _userselectors.getLocalDeviceId)(state);
    var localHomeId = (0, _userselectors.getLocalHomeId)(state);
    var deviceId = (0, _userselectors.getDeviceId)(state);
    var ID = homeId || deviceId;
    var boxId = homeId || deviceId;
    var localId = localHomeId ? {
        localHomeId: localHomeId
    } : {
        localDeviceId: localDeviceId
    };
    var _Object_values = _sliced_to_array._(Object.values(localId), 1), localIdValue = _Object_values[0];
    if (!(ID && localIdValue)) {
        throw new ReferenceError("The ID and localId are required to initialize fido.");
    }
    (0, _fidooidc.patchOIDC)(_fidosdk.oidcService);
    var customerCode = _config.default.customerCode, platformCode = _config.default.platformCode, clientCode = _config.default.clientCode, _config_fido = _config.default.fido, baseUrlsByAPIType = _config_fido.baseUrlsByAPIType, saltAndSugar = _config_fido.saltAndSugar, imageSalt = _config_fido.imageSalt, oidc = _config.default.oidc;
    var fidoConfig = _object_spread_props._(_object_spread._({
        customerCode: customerCode,
        platformCode: platformCode,
        getCurrentTime: function() {
            return (0, _appselectors.getCurrentMsTime)(getState());
        },
        clientCode: clientCode,
        saltAndSugar: saltAndSugar,
        imageSalt: imageSalt,
        appVersion: _utils.appVersion
    }, localId), {
        baseUrlsByAPIType: {
            monitoring: "https://mon.m6web.fr"
        }
    });
    var boxType = clientCode;
    var applaunchConfig = (0, _utils.getApplaunchConfig)(ID);
    var services = [
        [
            _fidosdk.applaunchService,
            [
                applaunchConfig
            ]
        ],
        _fidosdk.geoService,
        _fidosdk.gdprService,
        _fidosdk.heartbeatService,
        _fidosdk.heartbeatServiceV3,
        _fidosdk.imageService,
        _fidosdk.programService,
        [
            _fidosdk.statsdMonitoringService,
            [
                true,
                {
                    salt: _config.default.monitoring.salt,
                    enabled: true,
                    platformCode: _utils.appPlatform
                }
            ]
        ],
        _fidosdk.timeService,
        [
            _fidosdk.tokenService,
            [
                {
                    advertisingId: (0, _utils.getPubId)(),
                    boxType: boxType,
                    boxId: boxId,
                    deviceModel: _utils.appPlatform,
                    partnerContext: _utils.appPlatform
                }
            ]
        ],
        _fidosdk.userService,
        _fidosdk.videoService,
        _fidosdk.premiumService,
        _fidosdk.freemiumService,
        _fidosdk.upFrontTokenService,
        _fidosdk.profileService,
        _fidosdk.parentalControlService,
        [
            _fidosdk.pairingService,
            [
                {
                    prefixedBoxId: true
                }
            ]
        ]
    ];
    if (oidc.baseUrl) {
        fidoConfig.baseUrlsByAPIType.oidc = oidc.baseUrl;
        fidoConfig.baseUrlsByAPIType.oidcCustomApi = oidc.customApi;
        services.push([
            _fidosdk.oidcService,
            [
                {
                    clientId: oidc.clientId,
                    clientSecret: oidc.clientSecret,
                    endpoints: oidc.endpoints
                }
            ]
        ]);
    }
    _fidosdk.fido.init(fidoConfig, services);
    _fidosdk.fido.setBaseUrls(baseUrlsByAPIType);
};
var updateFidoConfig = function(config) {
    var customerCode = config.customerCode, platformCode = config.platformCode, clientCode = config.clientCode, _config_fido = config.fido, baseUrlsByAPIType = _config_fido.baseUrlsByAPIType, capacityToken = _config_fido.layoutService.capacityToken, saltAndSugar = _config_fido.saltAndSugar, imageSalt = _config_fido.imageSalt;
    var fidoConfig = {
        customerCode: customerCode,
        platformCode: platformCode,
        clientCode: clientCode,
        saltAndSugar: saltAndSugar,
        imageSalt: imageSalt
    };
    Object.entries(fidoConfig).forEach(function(param) {
        var _param = _sliced_to_array._(param, 2), key = _param[0], value = _param[1];
        _fidosdk.fido.set(key, value);
    });
    _fidosdk.fido.setBaseUrls(baseUrlsByAPIType);
    _fidosdk.layoutService.init(capacityToken);
    _fidosdk.layoutForThirdPartyService.init(capacityToken);
};


/***/ }),

/***/ 21890:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    addBookmark: function() {
        return addBookmark;
    },
    invalidateCachedBookmarkState: function() {
        return invalidateCachedBookmarkState;
    },
    removeBookmark: function() {
        return removeBookmark;
    }
});
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
var _layoutactions = __webpack_require__(8424);
var _userselectors = __webpack_require__(41845);
var _bookmarkutils = __webpack_require__(30984);
var invalidateCachedBookmarkState = function(bookmark) {
    return function(dispatch) {
        var blockIndex = bookmark.blockIndex, itemIndex = bookmark.itemIndex, currentBookmarkState = bookmark.state;
        dispatch((0, _layoutactions.invalidateItemCache)(itemIndex, blockIndex, {
            bookmark: {
                state: !currentBookmarkState
            }
        }));
    };
};
var addBookmark = function(bookmark) {
    return function(dispatch, getState) {
        dispatch(invalidateCachedBookmarkState(bookmark));
        return (0, _bookmarkutils.addBookmark)(bookmark, (0, _userselectors.getUid)(getState()));
    };
};
var removeBookmark = function(bookmark) {
    return function(dispatch, getState) {
        dispatch(invalidateCachedBookmarkState(bookmark));
        return (0, _bookmarkutils.removeBookmark)(bookmark, (0, _userselectors.getUid)(getState()));
    };
};


/***/ }),

/***/ 30984:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    addBookmark: function() {
        return addBookmark;
    },
    getBookmarkActionAnalytics: function() {
        return getBookmarkActionAnalytics;
    },
    getUpdatedAnalytics: function() {
        return getUpdatedAnalytics;
    },
    removeBookmark: function() {
        return removeBookmark;
    }
});
var _async_to_generator = __webpack_require__(24146);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(3009);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _fidosdk = __webpack_require__(19804);
var _utils = __webpack_require__(64188);
var _analyticsutils = __webpack_require__(2693);
var getUpdatedAnalytics = function(isBookmarked) {
    return {
        googleAnalytics: {
            eventAction: isBookmarked ? "bookmark" : "unbookmark"
        },
        krxd: {
            appPlatform: _utils.appPlatform,
            key: isBookmarked ? "bookmarkAdd" : "bookmarkRemove"
        },
        ssaTealiumHttp: {
            key: isBookmarked ? "bookmark" : "unbookmark"
        }
    };
};
var getBookmarkActionAnalytics = function(item, bookmarkState) {
    return item.analytics ? Object.keys(item.analytics).reduce(function(result, key) {
        result[key] = _object_spread._({}, item.analytics[key], (0, _get.default)(getUpdatedAnalytics(bookmarkState), key, {}));
        return result;
    }, {}) : {};
};
var addBookmark = function() {
    var _ref = _async_to_generator._(function(bookmark, userId) {
        var error;
        return _ts_generator._(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        _fidosdk.userService.addBookmark({
                            entityId: bookmark.id,
                            entityType: bookmark.type,
                            uid: userId
                        })
                    ];
                case 1:
                    _state.sent();
                    (0, _analyticsutils.sendEvent)({
                        key: "bookmark"
                    });
                    return [
                        3,
                        3
                    ];
                case 2:
                    error = _state.sent();
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function addBookmark(bookmark, userId) {
        return _ref.apply(this, arguments);
    };
}();
var removeBookmark = function() {
    var _ref = _async_to_generator._(function(bookmark, userId) {
        var error;
        return _ts_generator._(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        _fidosdk.userService.removeBookmark({
                            entityId: bookmark.id,
                            entityType: bookmark.type,
                            uid: userId
                        })
                    ];
                case 1:
                    _state.sent();
                    (0, _analyticsutils.sendEvent)({
                        key: "unbookmark"
                    });
                    return [
                        3,
                        3
                    ];
                case 2:
                    error = _state.sent();
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function removeBookmark(bookmark, userId) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 39258:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/* eslint-disable no-console */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ERROR: function() {
        return ERROR;
    },
    RETRY: function() {
        return RETRY;
    },
    RETRYABLE_ERROR: function() {
        return RETRYABLE_ERROR;
    },
    errorAction: function() {
        return errorAction;
    }
});
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(88801);
var _fidosdk = __webpack_require__(19804);
var _errorconstants = __webpack_require__(16186);
var _popupactions = __webpack_require__(47531);
var _popupsconstants = __webpack_require__(60952);
var _lifecyclesutils = __webpack_require__(10126);
var _routesutils = __webpack_require__(14948);
var _unpairactions = __webpack_require__(21219);
var ERROR = "error";
var RETRYABLE_ERROR = "retryable_error";
var RETRY = "retry";
var errorAction = function(level, errorType, message) {
    return function(dispatch) {
        if (!level) {
            console.warn("[Error] Missing error level");
        }
        if (!errorType) {
            console.warn("[Error] Missing error type");
        }
        if (!message) {
            console.warn("[Error] Missing error message");
        }
        console.error("[Error] ".concat(errorType, ": ").concat(message));
        if (level === _errorconstants.ERROR_LEVELS.FATAL) {
            if (typeof message === "string" && message.includes("tokenService") && message.includes("498")) {
                console.log("[Error] Authorization issue detected, logging out");
                dispatch((0, _unpairactions.logout)()).finally(function() {
                    return (0, _routesutils.navigateToLandingPage)();
                });
            } else {
                (0, _lifecyclesutils.setCloseReason)("error");
                dispatch((0, _popupactions.showPopupAction)(_popupsconstants.FATAL_ERROR_POPUP_ID, {}));
            }
        }
        _fidosdk.thirdPartyWithLayoutService.sendErrorEvent(new Error("".concat(errorType, " - ").concat(message)));
    };
};


/***/ }),

/***/ 16186:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/**
 * @typedef {string} ErrorTypes
 */ /**
 * @enum {ErrorTypes}
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ERROR_LEVELS: function() {
        return ERROR_LEVELS;
    },
    ERROR_TYPES: function() {
        return ERROR_TYPES;
    },
    RETRY_ACTIONS: function() {
        return RETRY_ACTIONS;
    }
});
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(45538);
var ERROR_TYPES = {
    GENERAL: "general",
    CSL: "csl",
    PAIRING: "pairing",
    PLAYER: "player",
    LAYOUT: "layout"
};
var ERROR_LEVELS = {
    FATAL: "fatal",
    SILENT: "silent"
};
var RETRY_ACTIONS = {
    LAYOUT_FETCH: "layout_fetch"
};


/***/ }),

/***/ 74386:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    fetchErrorMessage: function() {
        return fetchErrorMessage;
    },
    getErrorLevel: function() {
        return getErrorLevel;
    }
});
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _fidosdk = __webpack_require__(19804);
var _errorconstants = __webpack_require__(16186);
var getErrorLevel = function(error) {
    /**
   * if something went wrong (network issue on client side for example) while requesting data, fido returns an error
   * error object will include request and name field, so we can define type of error using this data
   * in cases where fetching some data is critical, this error must be FATAL
   */ if (error.fatal || error.request && error.name === _fidosdk.FetchError.name) {
        return _errorconstants.ERROR_LEVELS.FATAL;
    }
    return _errorconstants.ERROR_LEVELS.SILENT;
};
var fetchErrorMessage = function(error) {
    var errorCode = (0, _get.default)(error, "content.code", error.code);
    return error.message || errorCode || error.detail;
};


/***/ }),

/***/ 76654:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "getFeatureFlipping", ({
    enumerable: true,
    get: function() {
        return getFeatureFlipping;
    }
}));
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _sliced_to_array = __webpack_require__(28966);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(37815);
var _pick = /*#__PURE__*/ _interop_require_default._(__webpack_require__(19334));
var getFeatureFlipping = function(configuredBannedFeatures, configuredFeatureFlipping) {
    var customizedFeatureFlipping = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    if (!configuredBannedFeatures) {
        throw new Error("Missing banned features from config");
    }
    if (!configuredFeatureFlipping) {
        throw new Error("Missing feature flipping from config");
    }
    var featureFlippingWithCustomization = _object_spread._({}, configuredFeatureFlipping, (0, _pick.default)(customizedFeatureFlipping, Object.keys(configuredFeatureFlipping)));
    return Object.entries(featureFlippingWithCustomization).reduce(function(memo, param) {
        var _param = _sliced_to_array._(param, 2), key = _param[0], value = _param[1];
        return _object_spread_props._(_object_spread._({}, memo), _define_property._({}, key, configuredBannedFeatures.includes(key) ? false : value));
    }, {});
};


/***/ }),

/***/ 2939:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _object_spread = __webpack_require__(76247);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(3009);
var _appconfigactions = __webpack_require__(72261);
var initialState = {};
var _default = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action && action.type){
        case _appconfigactions.CONFIG_INIT:
            {
                return _object_spread._({}, state, action.config.featureFlipping);
            }
        default:
            {
                return state;
            }
    }
};


/***/ }),

/***/ 76109:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    getAdFeature: function() {
        return getAdFeature;
    },
    getAnimateFeature: function() {
        return getAnimateFeature;
    },
    getBffSearchFeature: function() {
        return getBffSearchFeature;
    },
    getBookmarksFeature: function() {
        return getBookmarksFeature;
    },
    getBroadcastLiveFeature: function() {
        return getBroadcastLiveFeature;
    },
    getCheckGeoFeature: function() {
        return getCheckGeoFeature;
    },
    getContentAdvisorFeature: function() {
        return getContentAdvisorFeature;
    },
    getCustomizerFeature: function() {
        return getCustomizerFeature;
    },
    getDisplayLostConnectionFeature: function() {
        return getDisplayLostConnectionFeature;
    },
    getGdprNoticeFeature: function() {
        return getGdprNoticeFeature;
    },
    getKidsSectionFeature: function() {
        return getKidsSectionFeature;
    },
    getKidsSectionLeaveFeature: function() {
        return getKidsSectionLeaveFeature;
    },
    getLiveSeekFeature: function() {
        return getLiveSeekFeature;
    },
    getMenuPopupFeature: function() {
        return getMenuPopupFeature;
    },
    getMultiAudioFeature: function() {
        return getMultiAudioFeature;
    },
    getMultiProfileFeature: function() {
        return getMultiProfileFeature;
    },
    getMultiProfilesGateAlwaysDisplayed: function() {
        return getMultiProfilesGateAlwaysDisplayed;
    },
    getMultiSubtitlesFeature: function() {
        return getMultiSubtitlesFeature;
    },
    getOpenCatalogFeature: function() {
        return getOpenCatalogFeature;
    },
    getPairingFeature: function() {
        return getPairingFeature;
    },
    getParentalFilterFeature: function() {
        return getParentalFilterFeature;
    },
    getPlayerAdFeature: function() {
        return getPlayerAdFeature;
    },
    getPlayerAdsCountFeature: function() {
        return getPlayerAdsCountFeature;
    },
    getPlayerAnalyticsFeature: function() {
        return getPlayerAnalyticsFeature;
    },
    getPlayerJingleFeature: function() {
        return getPlayerJingleFeature;
    },
    getPlayerLBannerFeature: function() {
        return getPlayerLBannerFeature;
    },
    getPlayerLongSeekFeature: function() {
        return getPlayerLongSeekFeature;
    },
    getPlayerNextVideoFeature: function() {
        return getPlayerNextVideoFeature;
    },
    getPlayerPauseAdFeature: function() {
        return getPlayerPauseAdFeature;
    },
    getPlayerRelatedVideosFeature: function() {
        return getPlayerRelatedVideosFeature;
    },
    getPlayerReturnFeature: function() {
        return getPlayerReturnFeature;
    },
    getPlayerThirdPartiesFeature: function() {
        return getPlayerThirdPartiesFeature;
    },
    getPlayerTimeShiftingFeature: function() {
        return getPlayerTimeShiftingFeature;
    },
    getPlayerTrackPreferencesFeature: function() {
        return getPlayerTrackPreferencesFeature;
    },
    getPremiumFeature: function() {
        return getPremiumFeature;
    },
    getPrivilegeNavigationFeature: function() {
        return getPrivilegeNavigationFeature;
    },
    getPromptBeforeExitFeature: function() {
        return getPromptBeforeExitFeature;
    },
    getReplayFeature: function() {
        return getReplayFeature;
    },
    getScreensaverFeature: function() {
        return getScreensaverFeature;
    },
    getSearchFeature: function() {
        return getSearchFeature;
    },
    getServicePageFeature: function() {
        return getServicePageFeature;
    },
    getSplashScreenFeature: function() {
        return getSplashScreenFeature;
    },
    getStartoverFeature: function() {
        return getStartoverFeature;
    },
    getStartoverPopupFeature: function() {
        return getStartoverPopupFeature;
    },
    getStoryboardFeature: function() {
        return getStoryboardFeature;
    },
    getTermsOfUsageFeature: function() {
        return getTermsOfUsageFeature;
    },
    getUserApiFeature: function() {
        return getUserApiFeature;
    },
    getWatchAgainFeature: function() {
        return getWatchAgainFeature;
    }
});
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(42578);
var getAdFeature = function(param) {
    var features = param.features;
    return features.adFeature;
};
var getAnimateFeature = function(param) {
    var features = param.features;
    return features.animateFeature;
};
var getBffSearchFeature = function(param) {
    var features = param.features;
    return features.bffSearchFeature;
};
var getBookmarksFeature = function(param) {
    var features = param.features;
    return features.bookmarksFeature;
};
var getBroadcastLiveFeature = function(param) {
    var features = param.features;
    return features.broadcastLiveFeature;
};
var getCustomizerFeature = function(param) {
    var features = param.features;
    return features.customizerFeature;
};
var getCheckGeoFeature = function(param) {
    var features = param.features;
    return features.checkGeoFeature;
};
var getContentAdvisorFeature = function(param) {
    var features = param.features;
    return features.contentAdvisorFeature;
};
var getDisplayLostConnectionFeature = function(param) {
    var features = param.features;
    return features.displayLostConnectionFeature;
};
var getGdprNoticeFeature = function(param) {
    var features = param.features;
    return features.gdprNoticeFeature;
};
var getKidsSectionFeature = function(param) {
    var features = param.features;
    return features.kidsSectionFeature;
};
var getKidsSectionLeaveFeature = function(param) {
    var features = param.features;
    return features.kidsSectionLeaveFeature;
};
var getLiveSeekFeature = function(param) {
    var features = param.features;
    return features.liveSeekFeature;
};
var getMenuPopupFeature = function(param) {
    var features = param.features;
    return features.menuPopupFeature;
};
var getMultiAudioFeature = function(param) {
    var features = param.features;
    return features.multiAudioFeature;
};
var getMultiProfileFeature = function(param) {
    var features = param.features;
    return features.multiprofile;
};
var getMultiProfilesGateAlwaysDisplayed = function(param) {
    var features = param.features;
    return features.multiProfilesGateAlwaysDisplayed;
};
var getMultiSubtitlesFeature = function(param) {
    var features = param.features;
    return features.multiSubtitlesFeature;
};
var getOpenCatalogFeature = function(param) {
    var features = param.features;
    return features.openCatalogFeature;
};
var getPairingFeature = function(param) {
    var features = param.features;
    return features.pairingFeature;
};
var getParentalFilterFeature = function(param) {
    var features = param.features;
    return features.parentalFilterFeature;
};
var getPlayerAdFeature = function(param) {
    var features = param.features;
    return features.player_adFeature;
};
var getPlayerAnalyticsFeature = function(param) {
    var features = param.features;
    return features.player_analyticsFeature;
};
var getPlayerJingleFeature = function(param) {
    var features = param.features;
    return features.player_jingleFeature;
};
var getPlayerLongSeekFeature = function(param) {
    var features = param.features;
    return features.player_longSeek;
};
var getPlayerNextVideoFeature = function(param) {
    var features = param.features;
    return features.player_nextVideoFeature;
};
var getPlayerRelatedVideosFeature = function(param) {
    var features = param.features;
    return features.player_relatedVideosFeature;
};
var getPlayerReturnFeature = function(param) {
    var features = param.features;
    return features.player_returnFeature;
};
var getPlayerThirdPartiesFeature = function(param) {
    var features = param.features;
    return features.player_thirdPartiesFeature;
};
var getPlayerTimeShiftingFeature = function(param) {
    var features = param.features;
    return features.player_timeShiftingFeature;
};
var getPlayerAdsCountFeature = function(param) {
    var features = param.features;
    return features.player_adsCount;
};
var getPlayerLBannerFeature = function(param) {
    var features = param.features;
    return features.player_lBanner;
};
var getPlayerTrackPreferencesFeature = function(param) {
    var features = param.features;
    return features.player_trackPreferencesFeature;
};
var getPlayerPauseAdFeature = function(param) {
    var features = param.features;
    return features.player_pauseAd;
};
var getPremiumFeature = function(param) {
    var features = param.features;
    return features.premiumFeature;
};
var getPrivilegeNavigationFeature = function(param) {
    var features = param.features;
    return features.privilegeNavigationFeature;
};
var getPromptBeforeExitFeature = function(param) {
    var features = param.features;
    return features.promptBeforeExitFeature;
};
var getReplayFeature = function(param) {
    var features = param.features;
    return features.replayFeature;
};
var getScreensaverFeature = function(param) {
    var features = param.features;
    return features.screensaverFeature;
};
var getSearchFeature = function(param) {
    var features = param.features;
    return features.searchFeature;
};
var getServicePageFeature = function(param) {
    var features = param.features;
    return features.servicePageFeature;
};
var getSplashScreenFeature = function(param) {
    var features = param.features;
    return features.splashScreenFeature;
};
var getStartoverFeature = function(param) {
    var features = param.features;
    return features.startoverFeature;
};
var getStartoverPopupFeature = function(param) {
    var features = param.features;
    return features.startoverPopupFeature;
};
var getStoryboardFeature = function(param) {
    var features = param.features;
    return features.storyboardFeature;
};
var getTermsOfUsageFeature = function(param) {
    var features = param.features;
    return features.termsOfUsageFeature;
};
var getUserApiFeature = function(param) {
    var features = param.features;
    return features.userApiFeature;
};
var getWatchAgainFeature = function(param) {
    var features = param.features;
    return features.watchAgainFeature;
};


/***/ }),

/***/ 18012:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    PRESS_GDPR_NOTICE_DECLINE_BUTTON: function() {
        return PRESS_GDPR_NOTICE_DECLINE_BUTTON;
    },
    PRESS_GDPR_NOTICE_OK_BUTTON: function() {
        return PRESS_GDPR_NOTICE_OK_BUTTON;
    },
    PRESS_GDPR_NOTICE_PARAMETERS_BUTTON: function() {
        return PRESS_GDPR_NOTICE_PARAMETERS_BUTTON;
    },
    TOGGLE_GDPR_NOTICE: function() {
        return TOGGLE_GDPR_NOTICE;
    },
    pressGdprNoticeConsentAllButton: function() {
        return pressGdprNoticeConsentAllButton;
    },
    pressGdprNoticeDeclineAllButton: function() {
        return pressGdprNoticeDeclineAllButton;
    },
    toggleGdprNotice: function() {
        return toggleGdprNotice;
    }
});
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
var _useractions = __webpack_require__(79489);
var _gdprNoticeutils = __webpack_require__(28865);
var _analyticsutils = __webpack_require__(2693);
var TOGGLE_GDPR_NOTICE = "gdpr/TOGGLE_GDPR_NOTICE";
var PRESS_GDPR_NOTICE_OK_BUTTON = "gdpr/PRESS_GDPR_NOTICE_OK_BUTTON";
var PRESS_GDPR_NOTICE_DECLINE_BUTTON = "gdpr/PRESS_GDPR_NOTICE_DECLINE_BUTTON";
var PRESS_GDPR_NOTICE_PARAMETERS_BUTTON = "gdpr/PRESS_GDPR_NOTICE_PARAMETERS_BUTTON";
var toggleGdprNotice = function() {
    return {
        type: TOGGLE_GDPR_NOTICE
    };
};
var getConsentNames = function(consents) {
    return Object.keys(consents).filter(function(key) {
        return consents[key].consent;
    });
};
var handleGdprButtonPress = function(consents) {
    return function(dispatch) {
        dispatch((0, _useractions.setUserConsents)(consents));
        dispatch(toggleGdprNotice());
    };
};
var pressGdprNoticeDeclineAllButton = function() {
    return function(dispatch) {
        var consents = (0, _gdprNoticeutils.setAllCookies)(false);
        dispatch(handleGdprButtonPress(consents));
        (0, _analyticsutils.sendEvent)({
            key: "gdprRefuse",
            consentNames: getConsentNames(consents)
        });
    };
};
var pressGdprNoticeConsentAllButton = function() {
    return function(dispatch) {
        var consents = (0, _gdprNoticeutils.setAllCookies)(true);
        (0, _analyticsutils.sendEvent)({
            key: "pressCookieBannerConsentButton"
        });
        dispatch(handleGdprButtonPress(consents));
        (0, _analyticsutils.sendEvent)({
            key: "gdprAccept",
            consentNames: getConsentNames(consents)
        });
    };
};


/***/ }),

/***/ 11661:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    AUDIENCE_MEASUREMENT: function() {
        return AUDIENCE_MEASUREMENT;
    },
    CONSENT_TYPE_TO_ENGINE_MAP: function() {
        return CONSENT_TYPE_TO_ENGINE_MAP;
    },
    PERSONALIZATION: function() {
        return PERSONALIZATION;
    },
    TARGETED_ADVERTISING: function() {
        return TARGETED_ADVERTISING;
    }
});
var _define_property = __webpack_require__(21228);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(65759);
var AUDIENCE_MEASUREMENT = "audienceMeasurement";
var PERSONALIZATION = "personalization";
var TARGETED_ADVERTISING = "targetedAdvertising";
var _obj;
var CONSENT_TYPE_TO_ENGINE_MAP = (_obj = {}, _define_property._(_obj, AUDIENCE_MEASUREMENT, [
    "googleAnalytics",
    "newrelic"
]), _define_property._(_obj, PERSONALIZATION, [
    // NOTE: placeholder only, engine is not implemented yet, so the name may be changed
    "salesforceCRM"
]), _define_property._(_obj, TARGETED_ADVERTISING, [
    "googleAnalytics",
    "krxd",
    // NOTE: placeholder only, engine is not implemented yet, sp the name may be changed
    "smartclip"
]), _obj);


/***/ }),

/***/ 82596:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    default: function() {
        return _default;
    },
    initialState: function() {
        return initialState;
    }
});
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(52318);
var _gdprNoticeactions = __webpack_require__(18012);
var initialState = {
    isGdprNoticeVisible: false
};
var _default = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case _gdprNoticeactions.TOGGLE_GDPR_NOTICE:
            {
                return _object_spread_props._(_object_spread._({}, state), {
                    isGdprNoticeVisible: !state.isGdprNoticeVisible
                });
            }
        default:
            return state;
    }
};


/***/ }),

/***/ 82369:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    getGdprNoticeDuration: function() {
        return getGdprNoticeDuration;
    },
    getGdprNoticeVisibility: function() {
        return getGdprNoticeVisibility;
    }
});
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(52318);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var getGdprNoticeVisibility = function(state) {
    return (0, _get.default)(state, "gdpr.isGdprNoticeVisible");
};
var getGdprNoticeDuration = function(state) {
    return (0, _get.default)(state, "gdpr.gdprNoticeDuration");
};


/***/ }),

/***/ 28865:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    areCookiesEmpty: function() {
        return areCookiesEmpty;
    },
    getRejectedConsents: function() {
        return getRejectedConsents;
    },
    setAllCookies: function() {
        return setAllCookies;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(65759);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _config = __webpack_require__(67958);
var getRejectedConsents = function(consentCategories, userPreferences) {
    return consentCategories ? consentCategories.filter(function(consent) {
        return (0, _get.default)(userPreferences, [
            consent
        ]) === false;
    }) : [];
};
var setAllCookies = function(value) {
    return _config.gdprCookies.reduce(function(cookies, cookie) {
        return _object_spread_props._(_object_spread._({}, cookies), _define_property._({}, cookie, value));
    }, {});
};
var areCookiesEmpty = function(cookies) {
    return cookies ? Object.values(cookies).some(function(cookie) {
        return typeof cookie !== "boolean";
    }) : true;
};


/***/ }),

/***/ 22013:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    UID_TYPE_DEVICE_ID: function() {
        return UID_TYPE_DEVICE_ID;
    },
    UID_TYPE_GIGYA: function() {
        return UID_TYPE_GIGYA;
    }
});
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(42578);
var UID_TYPE_GIGYA = "gigya";
var UID_TYPE_DEVICE_ID = "deviceid";


/***/ }),

/***/ 99163:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    getHeartbeatInterval: function() {
        return getHeartbeatInterval;
    },
    getHeartbeatSessionId: function() {
        return getHeartbeatSessionId;
    },
    getHeartbeatState: function() {
        return getHeartbeatState;
    },
    getHeartbeatV2: function() {
        return getHeartbeatV2;
    },
    getHeartbeatV3: function() {
        return getHeartbeatV3;
    },
    getProgramId: function() {
        return getProgramId;
    },
    getServiceCode: function() {
        return getServiceCode;
    },
    getVideoClipType: function() {
        return getVideoClipType;
    },
    isHeartbeatEnabled: function() {
        return isHeartbeatEnabled;
    }
});
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(42578);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _playerselectors = __webpack_require__(83318);
var getHeartbeatV2 = (0, _playerselectors.getAnalyticsById)("heartbeat-v2");
var getHeartbeatV3 = (0, _playerselectors.getAnalyticsById)("heartbeat-v3");
var getHeartbeatState = function(state) {
    return (0, _get.default)(state, "heartbeat");
};
var getHeartbeatInterval = function(state) {
    return (0, _get.default)(state, "heartbeat.heartbeatInterval");
};
var isHeartbeatEnabled = function(state) {
    return (0, _get.default)(state, "heartbeat.enabled");
};
var getVideoClipType = function(state) {
    return (0, _get.default)(getHeartbeatV2(state), "session.clipType", "");
};
var getProgramId = function(state) {
    return (0, _get.default)(getHeartbeatV2(state), "session.programId", "");
};
var getServiceCode = function(state) {
    return (0, _get.default)(getHeartbeatV2(state), "session.serviceCode", "");
};
var getHeartbeatSessionId = function(state) {
    return (0, _get.default)(state, "heartbeat.sessionId");
};


/***/ }),

/***/ 8424:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/* eslint-disable no-console */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    CLEAR_CACHE: function() {
        return CLEAR_CACHE;
    },
    FETCH_BLOCK: function() {
        return FETCH_BLOCK;
    },
    FETCH_NAVIGATION_SUCCESS: function() {
        return FETCH_NAVIGATION_SUCCESS;
    },
    GENERATE_BLOCK_PLACEHOLDERS: function() {
        return GENERATE_BLOCK_PLACEHOLDERS;
    },
    INVALIDATE_ITEM_CACHE: function() {
        return INVALIDATE_ITEM_CACHE;
    },
    REPLACE_BLOCK: function() {
        return REPLACE_BLOCK;
    },
    SET_CONTENT_TEMPLATES_OPTIONS: function() {
        return SET_CONTENT_TEMPLATES_OPTIONS;
    },
    SET_CURRENT_ENTITY: function() {
        return SET_CURRENT_ENTITY;
    },
    SET_CURRENT_ENTITY_ID: function() {
        return SET_CURRENT_ENTITY_ID;
    },
    SET_CURRENT_ENTITY_TYPE: function() {
        return SET_CURRENT_ENTITY_TYPE;
    },
    SET_CURRENT_SECTION_CODE: function() {
        return _layoutsectionactions.SET_CURRENT_SECTION_CODE;
    },
    SET_NAVIGATION_ALLOWED: function() {
        return SET_NAVIGATION_ALLOWED;
    },
    SET_REQUESTED_ENTITY: function() {
        return SET_REQUESTED_ENTITY;
    },
    clearCache: function() {
        return clearCache;
    },
    createSuccessActionType: function() {
        return createSuccessActionType;
    },
    fetchBlockPage: function() {
        return fetchBlockPage;
    },
    fetchEPGLayout: function() {
        return fetchEPGLayout;
    },
    fetchFromAlgolia: function() {
        return fetchFromAlgolia;
    },
    fetchLayout: function() {
        return fetchLayout;
    },
    fetchNavigation: function() {
        return fetchNavigation;
    },
    fetchedLayoutAction: function() {
        return fetchedLayoutAction;
    },
    invalidateItemCache: function() {
        return invalidateItemCache;
    },
    setContentTemplateOptions: function() {
        return setContentTemplateOptions;
    },
    setCurrentSectionCode: function() {
        return _layoutsectionactions.setCurrentSectionCode;
    },
    setNavigationAllowed: function() {
        return setNavigationAllowed;
    },
    setRequestedEntity: function() {
        return setRequestedEntity;
    }
});
var _async_to_generator = __webpack_require__(24146);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _sliced_to_array = __webpack_require__(28966);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
var _fidosdk = __webpack_require__(19804);
var _config = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67958));
var _format = /*#__PURE__*/ _interop_require_default._(__webpack_require__(43069));
var _algoliaengine = /*#__PURE__*/ _interop_require_default._(__webpack_require__(11696));
var _layoututils = __webpack_require__(13598);
var _layoutselectors = __webpack_require__(53368);
var _appselectors = __webpack_require__(65910);
var _layoutnavigationutils = __webpack_require__(77214);
var _routesutils = __webpack_require__(14948);
var _popupactions = __webpack_require__(47531);
var _popupsconstants = __webpack_require__(60952);
var _impression = __webpack_require__(62117);
var _virtualization = __webpack_require__(11559);
var _pairingactions = __webpack_require__(83887);
var _errorconstants = __webpack_require__(16186);
var _erroractions = __webpack_require__(39258);
var _screenSaveractions = __webpack_require__(90962);
var _playerselectors = __webpack_require__(83318);
var _playerconstants = __webpack_require__(7602);
var _routingactions = __webpack_require__(78235);
var _useractions = __webpack_require__(79489);
var _apputils = __webpack_require__(60368);
var _accountCompletion = __webpack_require__(35951);
var _layoutprofileactions = __webpack_require__(24659);
var _layoutreducerutils = __webpack_require__(12668);
var _featuresselectors = __webpack_require__(76109);
var _layoutalgoliautils = __webpack_require__(34739);
var _layoutsectionactions = __webpack_require__(19023);
var FETCH_NAVIGATION_SUCCESS = "layout/FETCH_NAVIGATION_SUCCESS";
var SET_CURRENT_ENTITY = "layout/SET_CURRENT_ENTITY";
var SET_CURRENT_ENTITY_ID = "layout/SET_CURRENT_ENTITY_ID";
var SET_CURRENT_ENTITY_TYPE = "layout/SET_CURRENT_ENTITY_TYPE";
var GENERATE_BLOCK_PLACEHOLDERS = "layout/GENERATE_BLOCK_PLACEHOLDERS";
var FETCH_BLOCK = "layout/FETCH_BLOCK";
var REPLACE_BLOCK = "layout/REPLACE_BLOCK";
var CLEAR_CACHE = "layout/CLEAR_CACHE";
var INVALIDATE_ITEM_CACHE = "layout/INVALIDATE_ITEM_CACHE";
var SET_REQUESTED_ENTITY = "layout/SET_REQUESTED_ENTITY";
var SET_CONTENT_TEMPLATES_OPTIONS = "layout/SET_CONTENT_TEMPLATES_OPTIONS";
var SET_NAVIGATION_ALLOWED = "layout/SET_NAVIGATION_ALLOWED";
var createSuccessActionType = function(entity) {
    return "layout/".concat(entity, "/FETCH_LAYOUT_SUCCESS");
};
var fetchedLayoutAction = function(entity, data, id) {
    return {
        type: createSuccessActionType(entity),
        entity: entity,
        data: data,
        id: id
    };
};
var setContentTemplateOptions = function(contentTemplatesOptions) {
    return {
        type: SET_CONTENT_TEMPLATES_OPTIONS,
        contentTemplatesOptions: contentTemplatesOptions
    };
};
var setRequestedEntity = function(entityType, entityId) {
    return {
        type: SET_REQUESTED_ENTITY,
        entityType: entityType,
        entityId: entityId
    };
};
var clearCache = function(entityType, entityId, sectionCode) {
    return {
        type: CLEAR_CACHE,
        entityType: entityType,
        entityId: entityId,
        sectionCode: sectionCode
    };
};
var invalidateItemCache = function(itemIndex, blockIndex, item) {
    return {
        type: INVALIDATE_ITEM_CACHE,
        itemIndex: itemIndex,
        blockIndex: blockIndex,
        item: item
    };
};
var setNavigationAllowed = function(isAllowed) {
    return {
        type: SET_NAVIGATION_ALLOWED,
        isAllowed: isAllowed
    };
};
var fetchNavigation = function(section) {
    return function() {
        var _ref = _async_to_generator._(function(dispatch, getState) {
            var sectionCode, data, navigation, error;
            return _ts_generator._(this, function(_state) {
                switch(_state.label){
                    case 0:
                        sectionCode = section || (0, _layoutselectors.getCurrentSectionCode)(getState());
                        // eslint-disable-next-line no-console
                        console.log("[layout.actions] Loading navigation for ".concat(sectionCode));
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            _fidosdk.layoutForThirdPartyService.fetchNavigation({
                                target: _fidosdk.NAVIGATION_TARGETS.tv,
                                sectionCode: sectionCode
                            })
                        ];
                    case 2:
                        data = _state.sent();
                        navigation = Array.isArray(data) ? (0, _layoutnavigationutils.getNavigationV3)(data) : (0, _layoutnavigationutils.getNavigationV2)(data);
                        return [
                            2,
                            dispatch({
                                type: FETCH_NAVIGATION_SUCCESS,
                                navigation: _object_spread_props._(_object_spread._({}, navigation), {
                                    entries: navigation.entries.map(function(group) {
                                        return (0, _layoututils.handleGroupOnPlatform)(group);
                                    })
                                })
                            })
                        ];
                    case 3:
                        error = _state.sent();
                        return [
                            2,
                            dispatch((0, _erroractions.errorAction)(_errorconstants.ERROR_LEVELS.FATAL, _errorconstants.ERROR_TYPES.LAYOUT, error.message))
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(dispatch, getState) {
            return _ref.apply(this, arguments);
        };
    }();
};
var fetchFromAlgolia = function(query) {
    return function() {
        var _ref = _async_to_generator._(function(dispatch, getState) {
            var algoliaResults, state, screenSize, contentTemplatesOptions, section, searchIndex, results, error;
            return _ts_generator._(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            4,
                            ,
                            5
                        ]);
                        if (!!_algoliaengine.default.sdk) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            _algoliaengine.default.init()
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        algoliaResults = [];
                        state = getState();
                        screenSize = (0, _appselectors.getScreenSize)(state);
                        contentTemplatesOptions = (0, _layoutselectors.getContentTemplatesOptions)(state);
                        section = (0, _layoutselectors.getCurrentSectionCode)(state);
                        searchIndex = section === "kids" ? "kids" : "default";
                        return [
                            4,
                            _algoliaengine.default.search(query, searchIndex)
                        ];
                    case 3:
                        results = _state.sent().results;
                        results.forEach(function(result) {
                            var _result_hits = result.hits, hits = _result_hits === void 0 ? [] : _result_hits, _result_params = result.params, params = _result_params === void 0 ? "" : _result_params;
                            var facet = _algoliaengine.default.extractFacetFromQuery(params);
                            if (hits.length > 0 && facet) {
                                algoliaResults.push((0, _layoutalgoliautils.mapSearchHits)(hits, facet, screenSize, contentTemplatesOptions));
                            }
                        });
                        return [
                            2,
                            algoliaResults
                        ];
                    case 4:
                        error = _state.sent();
                        dispatch((0, _erroractions.errorAction)(_errorconstants.ERROR_LEVELS.SILENT, _errorconstants.ERROR_TYPES.PAIRING, error.message));
                        return [
                            2,
                            []
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(dispatch, getState) {
            return _ref.apply(this, arguments);
        };
    }();
};
var fetchLayout = function(entityType, entityId, queryParameters) {
    return function() {
        var _ref = _async_to_generator._(function(dispatch, getState) {
            var state, current, sectionCode, screenSize, contentTemplateOptions, entity, isPlayableEntity, data, shouldUseAlgolia, hits, error, target, reasonCode, lastViewedProgress, lastViewedId, result;
            return _ts_generator._(this, function(_state) {
                switch(_state.label){
                    case 0:
                        state = getState();
                        if (!(0, _appselectors.isAppInitialized)(state)) {
                            return [
                                2,
                                false
                            ];
                        }
                        current = (0, _layoutselectors.getCurrentLayout)(state);
                        if (current && current.entity && !(0, _layoututils.shouldOmitCache)(current.entity.type)) {
                            (0, _impression.trackImpressions)(current);
                        }
                        sectionCode = (0, _layoutselectors.getCurrentSectionCode)(state);
                        screenSize = (0, _appselectors.getScreenSize)(state);
                        contentTemplateOptions = (0, _layoutselectors.getContentTemplatesOptions)(state);
                        entity = {
                            entityType: entityType,
                            entityId: entityId,
                            sectionCode: sectionCode,
                            queryParameters: queryParameters ? _object_spread_props._(_object_spread._({}, queryParameters), {
                                query: queryParameters.query && queryParameters.query.length >= _config.default.search.charactersToSearch ? queryParameters.query : ""
                            }) : queryParameters
                        };
                        // NOTE: removing redundant query parameter as Fido will add it even when it's empty
                        if (entity.queryParameters && !entity.queryParameters.query) {
                            delete entity.queryParameters.query;
                        }
                        isPlayableEntity = (0, _layoututils.shouldOmitCache)(entityType);
                        if (isPlayableEntity) {
                            dispatch(clearCache(entityType, entityId, sectionCode));
                        }
                        dispatch(setRequestedEntity(entityType, entityId));
                        dispatch((0, _screenSaveractions.fetchScreenSaverData)(sectionCode));
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        shouldUseAlgolia = !(0, _featuresselectors.getBffSearchFeature)(state);
                        if (!(shouldUseAlgolia && (0, _layoutalgoliautils.isAlgoliaRequest)(entity))) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            dispatch(fetchFromAlgolia(queryParameters.query))
                        ];
                    case 2:
                        hits = _state.sent();
                        data = {
                            analytics: {},
                            blocks: (0, _layoutalgoliautils.getResultsAsBlocks)(hits),
                            entity: {
                                type: entityType,
                                id: entityId
                            },
                            layout: {
                                section: sectionCode
                            }
                        };
                        return [
                            3,
                            5
                        ];
                    case 3:
                        return [
                            4,
                            _fidosdk.layoutForThirdPartyService.fetchByEntity(entity)
                        ];
                    case 4:
                        data = _state.sent();
                        _state.label = 5;
                    case 5:
                        return [
                            3,
                            8
                        ];
                    case 6:
                        error = _state.sent();
                        return [
                            2,
                            dispatch((0, _erroractions.errorAction)((0, _layoutselectors.getCurrentLayout)(getState()) ? _errorconstants.ERROR_LEVELS.SILENT : _errorconstants.ERROR_LEVELS.FATAL, _errorconstants.ERROR_TYPES.LAYOUT, error.message))
                        ];
                    case 7:
                        (0, _apputils.removeSplashScreen)();
                        return [
                            7
                        ];
                    case 8:
                        if ((0, _layoututils.shouldDisplaySubscriptionExpiration)(data)) {
                            return [
                                2,
                                (0, _routesutils.navigateToExpiredSubscriptionPage)()
                            ];
                        }
                        if ((0, _layoututils.shouldDisplayLanding)(data)) {
                            // eslint-disable-next-line no-console
                            console.log("[layout.actions] Landing layout received, logging out");
                            if ((0, _featuresselectors.getOpenCatalogFeature)(state)) {
                                dispatch((0, _routingactions.setDeeplinkLocation)(isPlayableEntity ? "".concat(entityType, "/").concat(entityId) : "app/".concat(entityType, "/").concat(entityId)));
                                (0, _routesutils.navigateToLandingPage)();
                                return [
                                    2,
                                    Promise.resolve()
                                ];
                            }
                            return [
                                2,
                                dispatch((0, _pairingactions.logout)()).finally(function() {
                                    return (0, _routesutils.navigateToLandingPage)();
                                })
                            ];
                        }
                        if (data.redirection) {
                            target = "".concat(_routesutils.APP_PATH, "/").concat(data.entity.type, "/").concat(data.entity.id);
                            reasonCode = data.redirection.reasonCode;
                            if (reasonCode === "device_to_revoke") {
                                return [
                                    2,
                                    dispatch((0, _pairingactions.logout)()).finally(function() {
                                        (0, _routesutils.navigateTo)(target, false);
                                        return dispatch(fetchNavigation("main"));
                                    })
                                ];
                            }
                            if (reasonCode === "missing_entity") {
                                return [
                                    2,
                                    (0, _routesutils.navigateTo)(target, false)
                                ];
                            }
                            if (reasonCode === "devices_gate") {
                                dispatch((0, _routingactions.setDeeplinkLocation)(isPlayableEntity ? "".concat(entityType, "/").concat(entityId) : "app/".concat(entityType, "/").concat(entityId)));
                                return [
                                    2,
                                    (0, _routesutils.navigateTo)(_routesutils.DEVICE_GATE_PATH, false)
                                ];
                            }
                        }
                        // In case if need to replace some templates:
                        // data.blocks.forEach(block => {
                        //   if (block.blockTemplateId === 'List') {
                        //     block.content.contentTemplateId = 'Square';
                        //   }
                        // });
                        data.queryParameters = queryParameters;
                        data.blocks = data.blocks.filter(function(block) {
                            return (0, _layoututils.hasContent)(block);
                        }).map(function(block) {
                            if (!block.blockTemplateId && block.content.blockTemplateId) {
                                block.blockTemplateId = block.content.blockTemplateId;
                            }
                            if (!block.templateId && block.content.contentTemplateId) {
                                block.templateId = block.content.contentTemplateId;
                            }
                            return block;
                        }).filter(function(block) {
                            return (0, _layoututils.isKnownBlockTemplateType)(block) && ((0, _layoututils.hasAlternativeContent)(block) ? (0, _layoututils.isKnownSelectorTemplateType)(block) : true) && (0, _layoututils.isKnownTemplateType)(block);
                        }).map((0, _layoututils.prepareBlock)(entity, screenSize, contentTemplateOptions)).map(_layoututils.prepareAlternateContent);
                        if (entityType !== "video" || entityType !== "audio") {
                            lastViewedProgress = (0, _playerselectors.getLastViewedClipProgress)(getState());
                            lastViewedId = (0, _playerselectors.getLastViewedClipId)(getState());
                            if (lastViewedProgress && lastViewedId) {
                                (0, _layoututils.prepareLastViewedProgress)(data.blocks, lastViewedId, lastViewedProgress);
                                dispatch((0, _playerconstants.resetLastViewedData)());
                            }
                        }
                        if ((0, _layoututils.isProfilesGates)(data)) {
                            if ((0, _layoututils.shouldAutoSelectProfile)(data, state)) {
                                return [
                                    2,
                                    dispatch((0, _layoutprofileactions.autoSelectProfile)(data))
                                ];
                            }
                            return [
                                2,
                                dispatch((0, _popupactions.showPopupAction)(_popupsconstants.PROFILES_GATE_POPUP_ID, {
                                    payload: data
                                }))
                            ];
                        }
                        // Preventing stacking of a new search results on top of old ones which will break pagination
                        if (queryParameters) {
                            dispatch(clearCache(entityType, entityId, sectionCode));
                        }
                        result = dispatch(fetchedLayoutAction(entityType, data, entityId));
                        dispatch((0, _routingactions.hideRouteSkeleton)());
                        if (isPlayableEntity) {
                            dispatch((0, _useractions.completeAccount)());
                        } else {
                            dispatch((0, _accountCompletion.checkAccountCompletion)());
                        }
                        if (!(0, _layoutselectors.getLayoutNavigation)(getState())) {
                            dispatch(fetchNavigation());
                        }
                        return [
                            2,
                            result
                        ];
                }
            });
        });
        return function(dispatch, getState) {
            return _ref.apply(this, arguments);
        };
    }();
};
var fetchBlockPage = function(param) {
    var blockId = param.id, page = param.page, start = param.start, _param_parentId = param.parentId, parentId = _param_parentId === void 0 ? undefined : _param_parentId, _param_date = param.date, date = _param_date === void 0 ? undefined : _param_date;
    return function() {
        var _ref = _async_to_generator._(function(dispatch, getState) {
            var state, entityType, entityId, blockInfo, _blockInfo, _, existingBlock, sectionCode, queryParameters, data, error, screenSize, contentTemplateOptions, entity, block;
            return _ts_generator._(this, function(_state) {
                switch(_state.label){
                    case 0:
                        state = getState();
                        entityType = (0, _layoutselectors.getRequestedEntityType)(state);
                        entityId = (0, _layoutselectors.getRequestedEntityId)(state);
                        blockInfo = (0, _layoutreducerutils.getBlockInfo)(state.layout, blockId, parentId);
                        if (!blockInfo) {
                            return [
                                2,
                                Promise.resolve()
                            ];
                        }
                        // eslint-disable-next-line no-unused-vars
                        _blockInfo = _sliced_to_array._(blockInfo, 2), _ = _blockInfo[0], existingBlock = _blockInfo[1];
                        if (!existingBlock || !existingBlock.pages || existingBlock.pages[page - 1] !== _virtualization.PAGE_STATE.MISSING) {
                            return [
                                2,
                                Promise.resolve()
                            ];
                        }
                        sectionCode = (0, _layoutselectors.getCurrentSectionCode)(state);
                        dispatch({
                            type: GENERATE_BLOCK_PLACEHOLDERS,
                            entityType: entityType,
                            entityId: entityId,
                            sectionCode: sectionCode,
                            blockId: blockId,
                            parentId: parentId,
                            page: page,
                            start: start
                        });
                        queryParameters = {};
                        if (date) {
                            queryParameters.day = (0, _format.default)(date, "yyyy-MM-dd");
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            _fidosdk.layoutForThirdPartyService.fetchBlockPage({
                                entityType: entityType,
                                entityId: entityId,
                                blockId: blockId,
                                sectionCode: sectionCode,
                                page: page,
                                queryParameters: queryParameters
                            })
                        ];
                    case 2:
                        data = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        return [
                            2,
                            dispatch((0, _erroractions.errorAction)(_errorconstants.ERROR_LEVELS.SILENT, _errorconstants.ERROR_TYPES.LAYOUT, error.message))
                        ];
                    case 4:
                        screenSize = (0, _appselectors.getScreenSize)(state);
                        contentTemplateOptions = (0, _layoutselectors.getContentTemplatesOptions)(state);
                        entity = {
                            entityType: entityType,
                            entityId: entityId
                        };
                        block = (0, _layoututils.prepareBlock)(entity, screenSize, contentTemplateOptions)(data);
                        return [
                            2,
                            dispatch({
                                type: FETCH_BLOCK,
                                pageIndex: page,
                                blockId: blockId,
                                parentId: parentId,
                                totalItems: block.content.pagination ? block.content.pagination.totalItems : null,
                                items: block.content.items
                            })
                        ];
                }
            });
        });
        return function(dispatch, getState) {
            return _ref.apply(this, arguments);
        };
    }();
};
var fetchEPGLayout = function(param) {
    var date = param.date, blockId = param.blockId;
    return function() {
        var _ref = _async_to_generator._(function(dispatch, getState) {
            var state, sectionCode, day, data, entityType, entityId, entity, screenSize, contentTemplateOptions, block;
            return _ts_generator._(this, function(_state) {
                switch(_state.label){
                    case 0:
                        state = getState();
                        sectionCode = (0, _layoutselectors.getCurrentSectionCode)(state);
                        day = (0, _format.default)(date, "yyyy-MM-dd");
                        return [
                            4,
                            _fidosdk.layoutService.fetchEpgGrid({
                                sectionCode: sectionCode,
                                queryParameters: {
                                    day: day
                                }
                            })
                        ];
                    case 1:
                        data = _state.sent();
                        entityType = (0, _layoutselectors.getRequestedEntityType)(state);
                        entityId = (0, _layoutselectors.getRequestedEntityId)(state);
                        entity = {
                            entityType: entityType,
                            entityId: entityId
                        };
                        screenSize = (0, _appselectors.getScreenSize)(state);
                        contentTemplateOptions = (0, _layoutselectors.getContentTemplatesOptions)(state);
                        block = (0, _layoututils.prepareBlock)(entity, screenSize, contentTemplateOptions)(data);
                        return [
                            2,
                            dispatch({
                                type: REPLACE_BLOCK,
                                blockId: blockId,
                                items: block.content.items,
                                pagination: block.content.pagination,
                                date: day
                            })
                        ];
                }
            });
        });
        return function(dispatch, getState) {
            return _ref.apply(this, arguments);
        };
    }();
};


/***/ }),

/***/ 34739:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/** @module searchUtils */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    getResultsAsBlocks: function() {
        return getResultsAsBlocks;
    },
    isAlgoliaRequest: function() {
        return isAlgoliaRequest;
    },
    mapSearchHits: function() {
        return mapSearchHits;
    }
});
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _object_without_properties = __webpack_require__(46537);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(45538);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _fidosdk = __webpack_require__(19804);
var _searchconstants = __webpack_require__(78884);
var _layoututils = __webpack_require__(13598);
var _layoutimageutils = __webpack_require__(36969);
var _i18n = __webpack_require__(14910);
var isAlgoliaRequest = function(param) {
    var entityType = param.entityType, entityId = param.entityId, queryParameters = param.queryParameters;
    return entityType === _fidosdk.LAYOUT_ENTITIES.frontspace && entityId === _fidosdk.LAYOUT_FRONTSPACES.search && queryParameters && queryParameters.query;
};
var prepareActionAnalyticsItems = function(items) {
    var preparedItems = items.map(function(_param) {
        var action = _param.action, rest = _object_without_properties._(_param, [
            "action"
        ]);
        var googleAnalytics = (0, _get.default)(action, "analytics.googleAnalytics", {});
        var newGoogleAnalytics = _object_spread_props._(_object_spread._({}, googleAnalytics), {
            eventAction: googleAnalytics.eventAction || "program",
            eventCategory: googleAnalytics.eventCategory || "search"
        });
        var tealium = (0, _get.default)(action, "analytics.tealium", {});
        var newTealium = _object_spread_props._(_object_spread._({}, tealium), {
            event_action: tealium.event_action || "program",
            event_category: tealium.event_category || "search"
        });
        return _object_spread_props._(_object_spread._({}, rest), {
            action: _object_spread_props._(_object_spread._({}, action), {
                analytics: _object_spread_props._(_object_spread._({}, action.analytics), {
                    googleAnalytics: newGoogleAnalytics,
                    tealium: newTealium
                })
            })
        });
    });
    return preparedItems;
};
var prepareSearchAnalytics = function(facet) {
    var preparedItems = prepareActionAnalyticsItems(facet.content.items);
    return _object_spread_props._(_object_spread._({}, facet), {
        content: _object_spread_props._(_object_spread._({}, facet.content), {
            items: preparedItems
        })
    });
};
var mapSearchHits = function(hits, facet, screenSize, contentTemplatesOptions) {
    var flattenItems = hits.map(function(param) {
        var item = param.item;
        return item;
    });
    var contentTemplateId = _searchconstants.templateIdForFacets[facet];
    var imageOptions = (0, _layoutimageutils.getContentImageOptions)(contentTemplateId, contentTemplatesOptions, screenSize);
    var forceGhostServiceIcon = contentTemplateId && (contentTemplateId.startsWith("Card") || contentTemplateId.startsWith("Poster"));
    return {
        id: facet,
        content: {
            contentTemplateId: contentTemplateId,
            pagination: {
                itemsPerPage: flattenItems.length,
                nextPage: null,
                totalItems: flattenItems.length
            },
            items: (0, _layoututils.getFormattedItems)(flattenItems, imageOptions, forceGhostServiceIcon)
        }
    };
};
var getResultsAsBlocks = function(results) {
    var blocks = results.filter(function(result) {
        return Boolean((0, _get.default)(result, "content.items", []).length);
    });
    var sortedBlocks = _searchconstants.facetsOrder.reduce(function(acc, facetId) {
        var filteredFacet = blocks.find(function(block) {
            return block.id === facetId;
        });
        if (!filteredFacet) {
            return acc;
        }
        acc.push(_object_spread_props._(_object_spread._({}, prepareSearchAnalytics(filteredFacet)), {
            title: {
                long: (0, _i18n.t)("search.".concat(filteredFacet.id), {
                    numVideos: filteredFacet.content.items.length
                })
            },
            blockTemplateId: "Grid"
        }));
        return acc;
    }, []);
    return sortedBlocks;
};


/***/ }),

/***/ 36969:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    constructImageOptions: function() {
        return constructImageOptions;
    },
    getContentImageOptions: function() {
        return getContentImageOptions;
    },
    getImageQueryString: function() {
        return getImageQueryString;
    },
    getImageUrl: function() {
        return getImageUrl;
    },
    getScreenSaverImageOptions: function() {
        return getScreenSaverImageOptions;
    },
    imageOptionsToQueries: function() {
        return imageOptionsToQueries;
    },
    prepareItemImages: function() {
        return prepareItemImages;
    }
});
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _sliced_to_array = __webpack_require__(28966);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(37815);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _memoize = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34736));
var _sha1 = /*#__PURE__*/ _interop_require_default._(__webpack_require__(99968));
var _fidosdk = __webpack_require__(19804);
var _utils = __webpack_require__(64188);
var _constants = __webpack_require__(34952);
var getImageQueryString = function(options) {
    return Object.entries(options)// eslint-disable-next-line no-unused-vars
    .filter(function(param) {
        var _param = _sliced_to_array._(param, 2), _ = _param[0], value = _param[1];
        return Boolean(value) || Number.isFinite(value);
    }).sort(function(param, param1) {
        var _param = _sliced_to_array._(param, 1), key1 = _param[0], _param1 = _sliced_to_array._(param1, 1), key2 = _param1[0];
        return key1 <= key2 ? -1 : 1;
    }).map(function(param) {
        var _param = _sliced_to_array._(param, 2), key = _param[0], value = _param[1];
        return "".concat(key, "=").concat(encodeURIComponent(value));
    }).join("&");
};
var constructImageOptions = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : undefined;
    return options ? _object_spread_props._(_object_spread._({}, _constants.IMAGE_ITEMS_DEFAULT_OPTIONS), {
        image: _object_spread._({}, _constants.IMAGE_ITEMS_DEFAULT_OPTIONS.image, options.PRIMARY),
        secondaryImage: _object_spread._({}, _constants.IMAGE_ITEMS_DEFAULT_OPTIONS.image, options.SECONDARY),
        logo: _object_spread._({}, _constants.IMAGE_ITEMS_DEFAULT_OPTIONS.logo, options.LOGO)
    }) : _constants.IMAGE_ITEMS_DEFAULT_OPTIONS;
};
var imageOptionsToQueries = function(options) {
    return Object.entries(options).reduce(function(result, param) {
        var _param = _sliced_to_array._(param, 2), key = _param[0], value = _param[1];
        result[key] = getImageQueryString(value);
        return result;
    }, {});
};
var getContentImageOptions = (0, _memoize.default)(function(contentTemplateId, templatesOptions, screenSize) {
    return imageOptionsToQueries(constructImageOptions((0, _get.default)(templatesOptions, "".concat(contentTemplateId, ".imageOptions.").concat(screenSize))));
}, function(id, _, screenSize) {
    return "".concat(id, "_").concat(screenSize);
});
var getScreenSaverImageOptions = (0, _memoize.default)(function(screenSize) {
    return imageOptionsToQueries(constructImageOptions({
        PRIMARY: {
            width: screenSize === _constants.FULL_HD ? 1920 : 1280,
            height: screenSize === _constants.FULL_HD ? 1080 : 720,
            format: _constants.DEFAULT_IMAGE_FORMAT,
            quality: _constants.IMAGE_QUALITY
        }
    }));
});
var getImageUrl = function(id, query) {
    var rawUrl = _fidosdk.imageService.getRouteUrl("".concat(id, "/raw"));
    var path = _fidosdk.imageService.getRoutePath("".concat(id, "/raw?").concat(query), true);
    var hash = (0, _sha1.default)("".concat(path).concat(_fidosdk.fido.get("imageSalt")));
    if (hash) {
        return "".concat(rawUrl, "?").concat(query, "&hash=").concat(hash);
    }
    return rawUrl;
};
/**
 * Adds a `src` key to layout images
 *
 * @param {Object} image a layout image object
 * @param {string} image.id a layout image id
 * @param {ImageOptions} options
 * @returns {Object}
 */ var getItemImage = function(image, options) {
    if (image && options) {
        image.src = getImageUrl(image.id, options);
    }
    return image;
};
var prepareItemImages = function(item, imageOptions) {
    var forceGhostServicePicto = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    // Images
    item.image = getItemImage(item.image, imageOptions.image);
    item.secondaryImage = getItemImage(item.secondaryImage, imageOptions.secondaryImage);
    item.logo = getItemImage(item.logo, imageOptions.logo);
    // Icons
    item.csaPicto = (0, _utils.getCSAPicto)(item.pictos);
    item.servicePicto = (0, _utils.getServicePicto)(item.pictos);
    item.lockPicto = (0, _utils.getLockPicto)(item.pictos);
    if (forceGhostServicePicto && item.servicePicto && item.servicePicto.name) {
        item.servicePicto.name = item.servicePicto.name.endsWith("_ghost") ? item.servicePicto.name : item.servicePicto.name.replace(/(_dark$|$)/, "_ghost");
    }
    return item;
};


/***/ }),

/***/ 77214:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    getNavigationV2: function() {
        return getNavigationV2;
    },
    getNavigationV3: function() {
        return getNavigationV3;
    }
});
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(42578);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var getNavigationV2 = function(data) {
    return data ? {
        entries: [
            data.entries.filter(function(element) {
                return element.entry.id !== "Brand";
            })
        ]
    } : {
        entries: []
    };
};
var getNavigationV3 = function(data) {
    return data ? {
        entries: data.map(function(group) {
            return (0, _get.default)(group, "entries", []).map(function(entry) {
                var subEntries = (0, _get.default)(entry, "groups[0].entries", []);
                entry.groups = [];
                return {
                    entry: entry,
                    subEntries: subEntries
                };
            });
        })
    } : {
        entries: []
    };
};


/***/ }),

/***/ 24659:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "autoSelectProfile", ({
    enumerable: true,
    get: function() {
        return autoSelectProfile;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(3009);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _refreshAuthlockactions = __webpack_require__(30427);
var autoSelectProfile = function(data) {
    return function(dispatch) {
        return dispatch((0, _refreshAuthlockactions.refreshAuth)({
            item: (0, _get.default)(data, "blocks[0].content.items[0]")
        }));
    };
};


/***/ }),

/***/ 60325:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    default: function() {
        return _default;
    },
    initialState: function() {
        return initialState;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _sliced_to_array = __webpack_require__(28966);
var _to_consumable_array = __webpack_require__(30005);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(52318);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _omit = /*#__PURE__*/ _interop_require_default._(__webpack_require__(59245));
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _immutableset = /*#__PURE__*/ _interop_require_default._(__webpack_require__(36449));
var _fidosdk = __webpack_require__(19804);
var _layoutactions = __webpack_require__(8424);
var _layoututils = __webpack_require__(13598);
var _layoutreducerutils = __webpack_require__(12668);
var _virtualization = __webpack_require__(11559);
var initialState = {
    navigation: null,
    navigationAllowed: true,
    currentService: null,
    currentSectionCode: "main",
    currentEntityType: null,
    currentEntityId: null,
    requestedEntityId: null,
    requestedEntityType: null
};
var _default = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    var FETCHED_LAYOUT_ACTION = (0, _layoutactions.createSuccessActionType)(action.entity);
    switch(action.type){
        case FETCHED_LAYOUT_ACTION:
            {
                var entity = action.entity, id = action.id, data = action.data;
                var currentSectionCode = state.currentSectionCode;
                var isBookmarks = entity === _fidosdk.LAYOUT_ENTITIES.frontspace && id === _fidosdk.LAYOUT_FRONTSPACES.bookmarks;
                var oldBlocks = (0, _get.default)(state, [
                    currentSectionCode,
                    entity,
                    id,
                    "blocks"
                ], []);
                data.blocks = data.blocks.map(function(block) {
                    var _block_content = block.content, items = _block_content.items, pagination = _block_content.pagination;
                    block.pages = (0, _layoututils.pagesToLoad)(pagination.totalItems, pagination.itemsPerPage, items);
                    if (block.alternativeContent && block.alternativeContent.concurrentBlocks) {
                        block.alternativeContent.concurrentBlocks = block.alternativeContent.concurrentBlocks.map(function(concurrentBlock, index) {
                            var pagination = concurrentBlock.content.pagination;
                            concurrentBlock.pages = (0, _layoututils.pagesToLoad)(pagination.totalItems, pagination.itemsPerPage, index ? [] : items);
                            return concurrentBlock;
                        });
                    }
                    return block;
                });
                if (oldBlocks.length && oldBlocks.length === data.blocks.length) {
                    data.blocks = oldBlocks.map(function(oldBlock, index) {
                        var newBlock = data.blocks[index];
                        var featureId = newBlock.featureId;
                        var isUserSpecificBlock = isBookmarks || featureId === "bookmarks_by_user" || featureId === "playback_by_user";
                        // When a block was paginated, so there is more data in the cache
                        if (oldBlock.content.items.length !== newBlock.content.items.length) {
                            // User-specific blocks has correct pagination info in the new layout
                            var count = isUserSpecificBlock ? newBlock.content.pagination.totalItems : Math.max(oldBlock.content.items.length, newBlock.content.items.length);
                            var items = [];
                            for(var i = 0; i < count; i += 1){
                                // Placing the new item on top of the old one, or a placeholder if there is no item at this position
                                items.push(newBlock.content.items[i] || oldBlock.content.items[i] || _virtualization.PLACEHOLDER);
                            }
                            newBlock.content.items = items;
                            if (!isUserSpecificBlock) {
                                newBlock.content.pagination = oldBlock.content.pagination;
                            }
                        }
                        var newAlt = newBlock.alternativeContent;
                        var oldAlt = oldBlock.alternativeContent;
                        if (newAlt && oldAlt) {
                            for(var i1 = 0; i1 < newAlt.concurrentBlocks.length; i1 += 1){
                                if (oldAlt.concurrentBlocks[i1]) {
                                    newAlt.concurrentBlocks[i1] = _object_spread_props._(_object_spread._({}, oldAlt.concurrentBlocks[i1]), {
                                        pages: newAlt.concurrentBlocks[i1].pages
                                    });
                                }
                            }
                            if (newAlt.concurrentBlocks.length) {
                                var content = newAlt.concurrentBlocks[0].content;
                                if (content.items) {
                                    var _content_items;
                                    (_content_items = content.items).splice.apply(_content_items, [
                                        0,
                                        newBlock.content.items.length
                                    ].concat(_to_consumable_array._(newBlock.content.items)));
                                } else {
                                    content.items = newBlock.content.items;
                                }
                            }
                        }
                        return newBlock;
                    });
                }
                return _object_spread_props._(_object_spread._({}, state), _define_property._({
                    // Automatically allowing the Sidenav to appear once we have a valid layout
                    navigationAllowed: true,
                    currentService: entity === "service" ? id : state.currentService
                }, currentSectionCode, _object_spread_props._(_object_spread._({}, state[currentSectionCode]), _define_property._({}, entity, _object_spread_props._(_object_spread._({}, state[currentSectionCode] && state[currentSectionCode][entity]), _define_property._({}, id, data))))));
            }
        case _layoutactions.FETCH_BLOCK:
            {
                var blockId = action.blockId, newItems = action.items, pageIndex = action.pageIndex, parentId = action.parentId, newTotalItems = action.totalItems;
                var blockInfo = (0, _layoutreducerutils.getBlockInfo)(state, blockId, parentId);
                if (!blockInfo) {
                    return state;
                }
                var _blockInfo = _sliced_to_array._(blockInfo, 2), path = _blockInfo[0], block = _blockInfo[1];
                var _block_content = block.content, currentItems = _block_content.items, pagination = _block_content.pagination;
                var lastLoadedPage = block.lastLoadedPage || 0;
                // Pages index starts from 1, so transforming it to zero-based index
                var page = pageIndex - 1;
                // Bigger page index means more precise knowledge about the total items count
                var totalItems = page > lastLoadedPage && newTotalItems || pagination.totalItems;
                var start = page * pagination.itemsPerPage;
                var end = start + newItems.length;
                var items = [];
                // NOTE: considering placeholders were made before this action so the current items list already holds placeholders for a new page
                for(var i = 0; i < currentItems.length; i += 1){
                    items.push(i >= start && i < end ? newItems[i - start] : currentItems[i]);
                }
                return (0, _immutableset.default)(state, path.join("."), _object_spread_props._(_object_spread._({}, block), {
                    lastLoadedPage: Math.max(page, lastLoadedPage),
                    pages: _object_spread_props._(_object_spread._({}, (0, _layoututils.pagesToLoad)(totalItems, pagination.itemsPerPage, items), block.pages), _define_property._({}, page, _virtualization.PAGE_STATE.LOADED)),
                    content: _object_spread_props._(_object_spread._({}, block.content), {
                        items: items,
                        pagination: _object_spread_props._(_object_spread._({}, block.content.pagination), {
                            totalItems: totalItems
                        })
                    })
                }));
            }
        case _layoutactions.GENERATE_BLOCK_PLACEHOLDERS:
            {
                var blockInfo1 = (0, _layoutreducerutils.getBlockInfo)(state, action.blockId, action.parentId);
                if (!blockInfo1) {
                    return state;
                }
                var _blockInfo1 = _sliced_to_array._(blockInfo1, 2), path1 = _blockInfo1[0], block1 = _blockInfo1[1];
                var _block_content1 = block1.content, items1 = _block_content1.items, pagination1 = _block_content1.pagination;
                var start1 = Math.min(items1.length, action.start);
                var count = Math.min(pagination1.totalItems - items1.length, Math.max(action.start - items1.length, 0) + pagination1.itemsPerPage);
                var placeholders = [];
                for(var i1 = 0; i1 < count; i1 += 1){
                    if (!items1[start1 + i1]) {
                        placeholders.push(_virtualization.PLACEHOLDER);
                    }
                }
                // NOTE: the page passed via the action is 1-based (as it should be forwarded to BFF)
                var pageIndex1 = action.page - 1;
                return (0, _immutableset.default)(state, path1.join("."), _object_spread_props._(_object_spread._({}, block1), {
                    content: _object_spread_props._(_object_spread._({}, block1.content), {
                        items: items1.concat(placeholders)
                    }),
                    pages: _object_spread_props._(_object_spread._({}, block1.pages), _define_property._({}, pageIndex1, _virtualization.PAGE_STATE.LOADING))
                }));
            }
        case _layoutactions.CLEAR_CACHE:
            {
                var entityType = action.entityType, entityId = action.entityId, sectionCode = action.sectionCode;
                var path2 = [
                    sectionCode,
                    entityType,
                    entityId
                ].filter(Boolean);
                // NOTE: clear the entire cache if no path specified
                if (!path2.length) {
                    return _object_spread_props._(_object_spread._({}, state), {
                        main: {},
                        kids: {}
                    });
                }
                var pathToOmit = path2.pop();
                return _object_spread._({
                    contentTemplatesOptions: state.contentTemplatesOptions
                }, (0, _immutableset.default)(state, path2.join("."), (0, _omit.default)((0, _get.default)(state, path2.join(".")), pathToOmit)));
            }
        case _layoutactions.INVALIDATE_ITEM_CACHE:
            {
                var itemIndex = action.itemIndex, blockIndex = action.blockIndex;
                if (!(0, _layoututils.isValidItemPosition)(blockIndex, itemIndex) || !action.item) {
                    return state;
                }
                var requestedEntityId = state.requestedEntityId, requestedEntityType = state.requestedEntityType, currentSectionCode1 = state.currentSectionCode;
                var path3 = "".concat(currentSectionCode1, ".").concat(requestedEntityType, ".").concat(requestedEntityId, ".blocks[").concat(blockIndex, "].content.items[").concat(itemIndex, "]");
                var item = (0, _get.default)(state, path3);
                return item ? (0, _immutableset.default)(state, path3, (0, _merge.default)({}, item, action.item)) : state;
            }
        case _layoutactions.REPLACE_BLOCK:
            {
                var blockId1 = action.blockId, newItems1 = action.items, newPagination = action.pagination, newDate = action.date;
                var requestedEntityId1 = state.requestedEntityId, requestedEntityType1 = state.requestedEntityType, currentSectionCode2 = state.currentSectionCode;
                var blocks = (0, _get.default)(state, [
                    currentSectionCode2,
                    requestedEntityType1,
                    requestedEntityId1,
                    "blocks"
                ], []);
                var blockIndex1 = blocks.findIndex(function(param) {
                    var id = param.id;
                    return id === blockId1;
                });
                var path4 = [
                    currentSectionCode2,
                    requestedEntityType1,
                    requestedEntityId1,
                    "blocks[".concat(blockIndex1, "]")
                ].join(".");
                var currentState = (0, _get.default)(state, path4, {});
                return (0, _immutableset.default)(state, path4, _object_spread_props._(_object_spread._({}, currentState), {
                    content: _object_spread_props._(_object_spread._({}, currentState.content), {
                        items: newItems1,
                        date: newDate
                    }),
                    pages: (0, _layoututils.pagesToLoad)(newPagination.totalItems, newPagination.itemsPerPage, newItems1)
                }));
            }
        case _layoutactions.FETCH_NAVIGATION_SUCCESS:
            {
                if (!action.navigation) return state;
                return (0, _immutableset.default)(state, [
                    state.currentSectionCode,
                    "navigation"
                ], action.navigation);
            }
        case _layoutactions.SET_CURRENT_ENTITY:
            {
                return _object_spread_props._(_object_spread._({}, state), {
                    currentEntityType: action.entityType,
                    currentEntityId: action.entityId
                });
            }
        case _layoutactions.SET_CURRENT_ENTITY_TYPE:
            {
                return _object_spread_props._(_object_spread._({}, state), {
                    currentEntityType: action.entityType
                });
            }
        case _layoutactions.SET_CURRENT_ENTITY_ID:
            {
                return _object_spread_props._(_object_spread._({}, state), {
                    currentEntityId: action.entityId
                });
            }
        case _layoutactions.SET_CURRENT_SECTION_CODE:
            {
                return _object_spread_props._(_object_spread._({}, state), {
                    currentSectionCode: action.sectionCode
                });
            }
        case _layoutactions.SET_REQUESTED_ENTITY:
            {
                return _object_spread_props._(_object_spread._({}, state), {
                    requestedEntityId: action.entityId,
                    requestedEntityType: action.entityType
                });
            }
        case _layoutactions.SET_CONTENT_TEMPLATES_OPTIONS:
            {
                return _object_spread_props._(_object_spread._({}, state), {
                    contentTemplatesOptions: action.contentTemplatesOptions
                });
            }
        case _layoutactions.SET_NAVIGATION_ALLOWED:
            {
                return _object_spread_props._(_object_spread._({}, state), {
                    navigationAllowed: Boolean(action.isAllowed)
                });
            }
        default:
            {
                return state;
            }
    }
};


/***/ }),

/***/ 12668:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "getBlockInfo", ({
    enumerable: true,
    get: function() {
        return getBlockInfo;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(3009);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var getBlockInfo = function(state, blockId) {
    var parentId = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : undefined;
    if (!state || !blockId) {
        return null;
    }
    var requestedEntityId = state.requestedEntityId, requestedEntityType = state.requestedEntityType, currentSectionCode = state.currentSectionCode;
    var blocks = (0, _get.default)(state, [
        currentSectionCode,
        requestedEntityType,
        requestedEntityId,
        "blocks"
    ], []);
    var blockToFind = parentId || blockId;
    var blockIndex = blocks.findIndex(function(param) {
        var id = param.id;
        return id === blockToFind;
    });
    if (blockIndex < 0) {
        return null;
    }
    var target = parentId ? (0, _get.default)(blocks[blockIndex], "alternativeContent.concurrentBlocks", []).find(function(param) {
        var id = param.id;
        return id === blockId;
    }) : blocks[blockIndex];
    if (!target) {
        return null;
    }
    var path = [
        currentSectionCode,
        requestedEntityType,
        requestedEntityId,
        "blocks[".concat(blockIndex, "]")
    ];
    if (parentId) {
        var targetBlockIndex = blocks[blockIndex].alternativeContent.concurrentBlocks.indexOf(target);
        path.push("alternativeContent", "concurrentBlocks[".concat(targetBlockIndex, "]"));
    }
    return [
        path,
        target
    ];
};


/***/ }),

/***/ 19023:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    SET_CURRENT_SECTION_CODE: function() {
        return SET_CURRENT_SECTION_CODE;
    },
    setCurrentSectionCode: function() {
        return setCurrentSectionCode;
    }
});
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(37815);
var _layoutselectors = __webpack_require__(53368);
var _searchresetactions = __webpack_require__(10193);
var SET_CURRENT_SECTION_CODE = "navigation/SET_CURRENT_SECTION_CODE";
var setCurrentSectionCode = function(sectionCode) {
    return function(dispatch, getState) {
        var currentSectionCode = (0, _layoutselectors.getCurrentSectionCode)(getState());
        if (sectionCode === currentSectionCode || !sectionCode) {
            return;
        }
        dispatch((0, _searchresetactions.resetSearch)());
        dispatch({
            type: SET_CURRENT_SECTION_CODE,
            sectionCode: sectionCode
        });
    };
};


/***/ }),

/***/ 53368:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    getContentTemplatesOptions: function() {
        return getContentTemplatesOptions;
    },
    getCurrentBlockItems: function() {
        return getCurrentBlockItems;
    },
    getCurrentBlockPagination: function() {
        return getCurrentBlockPagination;
    },
    getCurrentLayout: function() {
        return getCurrentLayout;
    },
    getCurrentLayoutDimensions: function() {
        return getCurrentLayoutDimensions;
    },
    getCurrentSectionCode: function() {
        return getCurrentSectionCode;
    },
    getLayoutById: function() {
        return getLayoutById;
    },
    getLayoutNavigation: function() {
        return getLayoutNavigation;
    },
    getNavigationSection: function() {
        return getNavigationSection;
    },
    getRequestedEntityId: function() {
        return getRequestedEntityId;
    },
    getRequestedEntityType: function() {
        return getRequestedEntityType;
    }
});
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(88801);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var getCurrentSectionCode = function(state) {
    return state.layout.currentSectionCode;
};
var getNavigationSection = function(state) {
    return getCurrentSectionCode(state);
};
var getRequestedEntityType = function(state) {
    return state.layout.requestedEntityType;
};
var getRequestedEntityId = function(state) {
    return state.layout.requestedEntityId;
};
var getLayoutById = function(state, entity, id) {
    var section = getCurrentSectionCode(state);
    return (0, _get.default)(state, "layout.".concat(section, ".").concat(entity, ".").concat(id), null);
};
var getCurrentLayout = function(state) {
    var entityType = getRequestedEntityType(state);
    var entityId = getRequestedEntityId(state);
    return getLayoutById(state, entityType, entityId);
};
var getLayoutNavigation = function(state) {
    var section = getCurrentSectionCode(state);
    return (0, _get.default)(state, "layout.".concat(section, ".navigation"), null);
};
var getCurrentBlockPagination = function(state, entityType, entityId, blockIndex) {
    return (0, _get.default)(state, "layout.".concat(getCurrentSectionCode(state), ".").concat(entityType, ".").concat(entityId, ".blocks.").concat(blockIndex, ".content.pagination"));
};
var getCurrentBlockItems = function(state, entityType, entityId, blockIndex) {
    return (0, _get.default)(state, "layout.".concat(getCurrentSectionCode(state), ".").concat(entityType, ".").concat(entityId, ".blocks.").concat(blockIndex, ".content.items"));
};
var getCurrentLayoutDimensions = function(state) {
    var entityId = getRequestedEntityId(state);
    var entityType = getRequestedEntityType(state);
    var currentSectionCode = getCurrentSectionCode(state);
    return (0, _get.default)(state, "layout.".concat(currentSectionCode, ".").concat(entityType, ".").concat(entityId, ".analytics.googleAnalytics"), null);
};
var getContentTemplatesOptions = function(state) {
    return (0, _get.default)(state, "layout.contentTemplatesOptions", null);
};


/***/ }),

/***/ 13598:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    cacheBusters: function() {
        return cacheBusters;
    },
    constructImageOptions: function() {
        return _layoutimageutils.constructImageOptions;
    },
    getFormattedItems: function() {
        return getFormattedItems;
    },
    getLayoutEntityAsString: function() {
        return getLayoutEntityAsString;
    },
    hasAlternativeContent: function() {
        return hasAlternativeContent;
    },
    isKnownBlockTemplateType: function() {
        return isKnownBlockTemplateType;
    },
    isKnownSelectorTemplateType: function() {
        return isKnownSelectorTemplateType;
    },
    isKnownTemplateType: function() {
        return isKnownTemplateType;
    },
    isOffersEntity: function() {
        return isOffersEntity;
    },
    isProfilesGateEntity: function() {
        return isProfilesGateEntity;
    },
    isProfilesGates: function() {
        return isProfilesGates;
    },
    isScreensaverEntity: function() {
        return isScreensaverEntity;
    },
    isTemplateIncluded: function() {
        return isTemplateIncluded;
    },
    isValidItemPosition: function() {
        return isValidItemPosition;
    },
    pagesToLoad: function() {
        return pagesToLoad;
    },
    prepareAlternateContent: function() {
        return prepareAlternateContent;
    },
    prepareBlock: function() {
        return prepareBlock;
    },
    prepareItem: function() {
        return prepareItem;
    },
    prepareLastViewedProgress: function() {
        return prepareLastViewedProgress;
    },
    shouldAutoSelectProfile: function() {
        return shouldAutoSelectProfile;
    },
    shouldDisplayLanding: function() {
        return shouldDisplayLanding;
    },
    shouldDisplaySubscriptionExpiration: function() {
        return shouldDisplaySubscriptionExpiration;
    },
    shouldOmitCache: function() {
        return shouldOmitCache;
    }
});
var _export_star = __webpack_require__(37668);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _object_without_properties = __webpack_require__(46537);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _fidosdk = __webpack_require__(19804);
var _templateTypes = __webpack_require__(43581);
var _virtualization = __webpack_require__(11559);
var _lockselectors = __webpack_require__(79941);
var _layoutFilter = _export_star._(__webpack_require__(67020), exports);
var _layoutimageutils = __webpack_require__(36969);
var isScreensaverEntity = function(entityType, entityId) {
    return entityType === _fidosdk.LAYOUT_ENTITIES.frontspace && entityId === _fidosdk.LAYOUT_FRONTSPACES.tvapppreview;
};
var isOffersEntity = function(entityType, entityId) {
    return entityType === _fidosdk.LAYOUT_ENTITIES.frontspace && entityId === _fidosdk.LAYOUT_FRONTSPACES.offers;
};
var isProfilesGateEntity = function(entityType, entityId) {
    return entityType === _fidosdk.LAYOUT_ENTITIES.frontspace && entityId === _fidosdk.LAYOUT_FRONTSPACES.profilesgate;
};
var shouldDisplayLanding = function(data) {
    return (0, _get.default)(data, "entity.id") === _fidosdk.LAYOUT_FRONTSPACES.landing && (0, _get.default)(data, "entity.type") === _fidosdk.LAYOUT_ENTITIES.frontspace;
};
var shouldDisplaySubscriptionExpiration = function(data) {
    var _data_entity = data.entity, entityId = _data_entity.id, entityType = _data_entity.type;
    var isEmptyLayout = !(0, _get.default)(data, "blocks.length");
    return isOffersEntity(entityType, entityId) && isEmptyLayout;
};
var isProfilesGates = function(data) {
    var _data_entity = data.entity, entityId = _data_entity.id, entityType = _data_entity.type;
    return isProfilesGateEntity(entityType, entityId);
};
var shouldAutoSelectProfile = function(data, state) {
    var isProfilesGatesSelectedByUser = (0, _lockselectors.shouldDisplayProfilesGate)(state);
    if (isProfilesGatesSelectedByUser) {
        return false;
    }
    return (0, _get.default)(data, "blocks[0].content.items.length") === 1;
};
var hasAlternativeContent = function(block) {
    return Boolean(block.alternativeContent);
};
var isTemplateIncluded = function(template, collection) {
    return collection.includes(template);
};
var isKnownSelectorTemplateType = function(block) {
    return Object.keys(_templateTypes.selectorTemplateTypes).includes(block.alternativeContent.selectorTemplateId);
};
var isKnownBlockTemplateType = function(block) {
    return Object.keys(_templateTypes.blockTemplateTypes).includes(block.blockTemplateId);
};
var isKnownTemplateType = function(block) {
    return Object.keys(_templateTypes.templateTypes).includes(block.content.contentTemplateId);
};
var prepareItem = function(item) {
    if (!item) {
        return item;
    }
    var itemContent = item.itemContent, rest = _object_without_properties._(item, [
        "itemContent"
    ]);
    // In case if we are parsing pre-parsed items (i.e. Algolia hits), which don't have the "itemContent" field
    var container = itemContent || item;
    return _object_spread_props._(_object_spread._({}, rest, itemContent), {
        title: (0, _layoutFilter.titleFilter)(container.title),
        extraTitle: (0, _layoutFilter.titleFilter)(container.extraTitle)
    });
};
var getFormattedItems = function(items, imageOptions) {
    var forceGhostServicePicto = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return items.map(function(item) {
        return (0, _layoutimageutils.prepareItemImages)(prepareItem(item), imageOptions, forceGhostServicePicto);
    });
};
var GHOSTY_TEMPLATES = [
    "Card",
    "Jacket",
    "Portrait",
    "Poster",
    "Totem",
    "HorizontalCard"
];
var prepareBlock = function(entity, screenSize, contentTemplateOptions) {
    var _ref = entity || {}, entityId = _ref.entityId, entityType = _ref.entityType;
    return function(_param) {
        var id = _param.id, content = _param.content, block = _object_without_properties._(_param, [
            "id",
            "content"
        ]);
        var items = content ? content.items : [];
        var imageOptions = isScreensaverEntity(entityType, entityId) ? (0, _layoutimageutils.getScreenSaverImageOptions)(screenSize) : (0, _layoutimageutils.getContentImageOptions)(content.contentTemplateId, contentTemplateOptions, screenSize);
        var templateId = block ? block.templateId : "";
        var forceGhostServiceIcon = GHOSTY_TEMPLATES.some(function(templatePrefix) {
            return templateId.startsWith(templatePrefix);
        });
        var title = block.title;
        return _object_spread_props._(_object_spread._({}, block), {
            title: title ? {
                long: (0, _layoutFilter.titleFilter)(title.long),
                short: (0, _layoutFilter.titleFilter)(title.short)
            } : title,
            id: id,
            content: _object_spread_props._(_object_spread._({}, content), {
                items: getFormattedItems(items, imageOptions, forceGhostServiceIcon)
            })
        });
    };
};
var prepareAlternateContent = function(block) {
    var concurrentBlocks = (0, _get.default)(block, "alternativeContent.concurrentBlocks");
    if (concurrentBlocks && concurrentBlocks.length) {
        var alternativeContent = block.alternativeContent;
        // Original block already contains a proper data for the first concurrent block, referencing to the origin
        concurrentBlocks[0].id = block.id;
        concurrentBlocks[0].content = block.content;
        var result = alternativeContent.concurrentBlocks.map(function(_param) {
            var content = _param.content, theme = _param.theme, rest = _object_without_properties._(_param, [
                "content",
                "theme"
            ]);
            return _object_spread_props._(_object_spread._({}, rest), {
                theme: theme || block.theme,
                content: _object_spread_props._(_object_spread._({}, content), {
                    pagination: content.items ? content.pagination : _object_spread_props._(_object_spread._({}, content.pagination), {
                        nextPage: 1
                    }),
                    items: content.items || []
                })
            });
        });
        return _object_spread_props._(_object_spread._({}, block), {
            alternativeContent: _object_spread_props._(_object_spread._({}, block.alternativeContent), {
                concurrentBlocks: result
            })
        });
    }
    return block;
};
var prepareLastViewedProgress = function(blocks, clipId, clipProgress) {
    for(var i = 0; i < blocks.length; i += 1){
        var _blocks_i = blocks[i], _blocks_i_content = _blocks_i.content, _blocks_i_content_items = _blocks_i_content.items, items = _blocks_i_content_items === void 0 ? [] : _blocks_i_content_items;
        for(var j = 0; j < items.length; j += 1){
            var itemId = (0, _get.default)(items[j], "action.target.value_layout.id");
            if (clipId === itemId && items[j].progress === 0) {
                blocks[i].content.items[j].progress = clipProgress;
                return;
            }
        }
    }
};
var cacheBusters = [
    _fidosdk.LAYOUT_ENTITIES.audio,
    _fidosdk.LAYOUT_ENTITIES.video,
    _fidosdk.LAYOUT_ENTITIES.live,
    _fidosdk.LAYOUT_ENTITIES.radio
];
var shouldOmitCache = function(entityType) {
    return cacheBusters.includes(entityType);
};
var getLayoutEntityAsString = function(layout) {
    if (!layout || !layout.entity) {
        return "";
    }
    var _layout_entity = layout.entity, type = _layout_entity.type, id = _layout_entity.id;
    return "".concat(type, "_").concat(id);
};
var isValidItemPosition = function(blockIndex, itemIndex) {
    return Number.isFinite(blockIndex) && Number.isFinite(itemIndex) && blockIndex >= 0 && itemIndex >= 0;
};
var pagesToLoad = function(totalItems, itemsPerPage) {
    var items = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    var result = {};
    if (!totalItems || !itemsPerPage) {
        return result;
    }
    for(var i = 0; i < totalItems; i += itemsPerPage){
        var start = i;
        var end = Math.max(Math.min(start + itemsPerPage, totalItems) - 1, 0);
        var page = i / itemsPerPage;
        result[page] = Boolean(items[start] && items[end]) && items[start].content !== _virtualization.PLACEHOLDER && items[end].content !== _virtualization.PLACEHOLDER ? _virtualization.PAGE_STATE.LOADED : _virtualization.PAGE_STATE.MISSING;
    }
    return result;
};


/***/ }),

/***/ 35951:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "checkAccountCompletion", ({
    enumerable: true,
    get: function() {
        return checkAccountCompletion;
    }
}));
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(3009);
var _popupactions = __webpack_require__(47531);
var _userselectors = __webpack_require__(41845);
var _popupsconstants = __webpack_require__(60952);
var _useractions = __webpack_require__(79489);
var _userutils = __webpack_require__(95031);
var _pairingutils = __webpack_require__(54264);
var _pairingconstants = __webpack_require__(41367);
var checkAccountCompletion = function() {
    return function(dispatch, getState) {
        var state = getState();
        if (!(0, _userselectors.getAccountCompletionStatus)(state) && (0, _userutils.isAccountCompletionCounterReady)() && (0, _pairingutils.getPairingMethod)() === _pairingconstants.PAIRING_METHOD.SSI) {
            (0, _userutils.resetAccountCompletionCounter)();
            dispatch((0, _popupactions.showPopupAction)(_popupsconstants.ACCOUNT_COMPLETION_POPUP_ID));
        }
        dispatch((0, _useractions.completeAccount)());
    };
};


/***/ }),

/***/ 67020:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    handleGroupOnPlatform: function() {
        return handleGroupOnPlatform;
    },
    hasContent: function() {
        return hasContent;
    },
    titleFilter: function() {
        return titleFilter;
    }
});
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(37815);
var _config = __webpack_require__(67958);
var hasContent = function(block) {
    return Boolean(block.content);
};
var handleGroupOnPlatform = function(group) {
    return group.map(function(item) {
        if (!_config.featureFlipping.liveSuppressionOnEPGFeature) {
            return item;
        }
        try {
            return item.entry.id.toLowerCase() === "epggrid" ? _object_spread_props._(_object_spread._({}, item), {
                entry: _object_spread_props._(_object_spread._({}, item.entry), {
                    label: "Sendung verpasst",
                    picto: {
                        name: "Clock",
                        type: "icon"
                    }
                })
            }) : item;
        } catch (error) {
            return item;
        }
    });
};
var EMOJI_REGEX = /([\u2000-\u32FF]|[\ud83c-\ud83e][\udc00-\udfff])(\u200d?([\u2000-\u32FF]|[\ud83c-\ud83e][\udc00-\udfff]))*/g;
var titleFilter = function(value) {
    return value ? value.replace(EMOJI_REGEX, "") : value;
};


/***/ }),

/***/ 77202:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    LIFECYCLES_CURRENT_STATE: function() {
        return LIFECYCLES_CURRENT_STATE;
    },
    LifecycleState: function() {
        return LifecycleState;
    }
});
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(42578);
var LIFECYCLES_CURRENT_STATE = "lifecycles/CURRENT_STATE";
var LifecycleState = {
    INITIALIZING: "initializing",
    INACTIVE: "inactive",
    FOREGROUND: "foreground",
    BACKGROUND: "background",
    UNLOADING: "unloading",
    SUSPENDED: "suspended"
};


/***/ }),

/***/ 90678:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    default: function() {
        return _default;
    },
    initialState: function() {
        return initialState;
    }
});
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _object_without_properties = __webpack_require__(46537);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(52318);
var _lifecyclesconstants = __webpack_require__(77202);
var initialState = {
    currentState: ""
};
var _default = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, _param = arguments.length > 1 ? arguments[1] : void 0;
    var type = _param.type, data = _object_without_properties._(_param, [
        "type"
    ]);
    switch(type){
        case _lifecyclesconstants.LIFECYCLES_CURRENT_STATE:
            {
                return _object_spread_props._(_object_spread._({}, state), {
                    currentState: data.currentState
                });
            }
        default:
            {
                return state;
            }
    }
};


/***/ }),

/***/ 32749:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "getLifecycleState", ({
    enumerable: true,
    get: function() {
        return getLifecycleState;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(88801);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var getLifecycleState = function(state) {
    return (0, _get.default)(state, "lifecycles.currentState", "");
};


/***/ }),

/***/ 10126:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    getCloseReason: function() {
        return getCloseReason;
    },
    setCloseReason: function() {
        return setCloseReason;
    }
});
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(65759);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var getCloseReason = function() {
    return (0, _get.default)(window, "firebolt_closeReason", "");
};
var setCloseReason = function(reason) {
    window.firebolt_closeReason = reason;
};


/***/ }),

/***/ 38940:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return LifecycleService;
    }
}));
var _class_call_check = __webpack_require__(67818);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(88801);
var LifecycleService = function LifecycleService() {
    "use strict";
    _class_call_check._(this, LifecycleService);
};


/***/ }),

/***/ 75250:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    SHOW_PROFILES_GATE: function() {
        return SHOW_PROFILES_GATE;
    },
    checkProfileAutoSelect: function() {
        return checkProfileAutoSelect;
    },
    clearAfterProfileChanged: function() {
        return clearAfterProfileChanged;
    },
    disableProfileAutoSelect: function() {
        return disableProfileAutoSelect;
    },
    handleLock: function() {
        return handleLock;
    },
    unlockByAuth: function() {
        return unlockByAuth;
    }
});
var _async_to_generator = __webpack_require__(24146);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(3009);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _set = /*#__PURE__*/ _interop_require_default._(__webpack_require__(35609));
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _fidosdk = __webpack_require__(19804);
var _routesutils = __webpack_require__(14948);
var _pairingconstants = __webpack_require__(25994);
var _featuresselectors = __webpack_require__(76109);
var _layoutselectors = __webpack_require__(53368);
var _routingactions = __webpack_require__(78235);
var _userselectors = __webpack_require__(41845);
var _tokenactions = __webpack_require__(99619);
var _popupactions = __webpack_require__(47531);
var _layoutactions = __webpack_require__(8424);
var _pairingactions = __webpack_require__(83887);
var _playerconstants = __webpack_require__(7602);
var _refreshAuthlockactions = __webpack_require__(30427);
var _lockutils = __webpack_require__(78414);
var unlockByAuth = function(item) {
    return function() {
        var _ref = _async_to_generator._(function(dispatch, getState) {
            var state, deeplink;
            return _ts_generator._(this, function(_state) {
                switch(_state.label){
                    case 0:
                        state = getState();
                        dispatch((0, _playerconstants.reset)());
                        if (!(0, _featuresselectors.getOpenCatalogFeature)(state)) return [
                            3,
                            1
                        ];
                        deeplink = (0, _lockutils.getDeeplinkFromLock)(item);
                        if (deeplink) {
                            dispatch((0, _routingactions.setDeeplinkLocation)(deeplink));
                        }
                        (0, _routesutils.navigateToPairingPage)();
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            dispatch((0, _pairingactions.logout)())
                        ];
                    case 2:
                        _state.sent();
                        (0, _routesutils.navigateToLandingPage)();
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(dispatch, getState) {
            return _ref.apply(this, arguments);
        };
    }();
};
var handleLock = function(actionOptions, lockOptions) {
    return function() {
        var _ref = _async_to_generator._(function(dispatch, getState) {
            var reason, lock, payload;
            return _ts_generator._(this, function(_state) {
                reason = (0, _lockutils.getReason)(actionOptions);
                if (reason === _pairingconstants.REQUIRE_AUTH) {
                    dispatch(unlockByAuth(actionOptions.item));
                    return [
                        2
                    ];
                }
                if (reason === _pairingconstants.REFRESH_AUTH) {
                    dispatch((0, _refreshAuthlockactions.refreshAuth)(actionOptions));
                    return [
                        2
                    ];
                }
                lock = (0, _get.default)(actionOptions, "item.action.target.value_lock");
                // copy an action and replace lock target with `value_lock.originalTarget` to avoid mutation of origin dataset
                payload = (0, _set.default)((0, _merge.default)({}, actionOptions), "item.action.target", lock ? lock.originalTarget : null);
                dispatch((0, _popupactions.showPopupAction)((0, _lockutils.getMappedLockPopup)(reason), _object_spread_props._(_object_spread._({}, lockOptions), {
                    lock: lock,
                    payload: payload
                })));
                return [
                    2
                ];
            });
        });
        return function(dispatch, getState) {
            return _ref.apply(this, arguments);
        };
    }();
};
var SHOW_PROFILES_GATE = "lock/SHOW_PROFILES_GATE";
var disableProfileAutoSelect = function() {
    return {
        type: SHOW_PROFILES_GATE
    };
};
var clearAfterProfileChanged = function() {
    return function(dispatch, getState) {
        var section = (0, _layoutselectors.getCurrentSectionCode)(getState());
        dispatch(disableProfileAutoSelect());
        dispatch((0, _tokenactions.resetJwtProfile)());
        dispatch((0, _playerconstants.reset)());
        dispatch((0, _layoutactions.clearCache)(_fidosdk.LAYOUT_ENTITIES.alias, _fidosdk.LAYOUT_ALIASES.home, section));
        dispatch((0, _layoutactions.clearCache)(_fidosdk.LAYOUT_ENTITIES.frontspace, _fidosdk.LAYOUT_FRONTSPACES.bookmarks, section));
    };
};
var checkProfileAutoSelect = function(data) {
    return function(dispatch, getState) {
        var items = (0, _get.default)(data, "blocks[0].content.items", []);
        if (items.length === 1) {
            var profileUid = (0, _lockutils.getReasonAttributes)(items[0]).profileUid;
            if ((0, _userselectors.getPreviousProfileUid)(getState()) !== profileUid) {
                dispatch(disableProfileAutoSelect());
            }
        }
    };
};


/***/ }),

/***/ 52816:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "LOCK_POPUPS_MAP", ({
    enumerable: true,
    get: function() {
        return LOCK_POPUPS_MAP;
    }
}));
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(42578);
var _popupsconstants = __webpack_require__(60952);
var LOCK_POPUPS_MAP = {
    geoBlocked: _popupsconstants.GEO_BLOCK_POPUP_ID,
    contentRatingAdvisory: _popupsconstants.AGE_GATE_POPUP_ID,
    leavingKidsSection: _popupsconstants.KIDS_LEAVE_POPUP_ID,
    live: _popupsconstants.BROADCASTING_LOCK_POPUP_ID,
    freemium: _popupsconstants.FREEMIUM_LOCK_POPUP_ID,
    parentalCode: _popupsconstants.PARENTAL_CODE_POPUP_ID,
    requireSubscription: _popupsconstants.SUBSCRIPTION_POPUP_ID,
    default: _popupsconstants.COMMON_POPUP_ID,
    contentRating: _popupsconstants.CONTENT_RATING_POPUP_ID,
    parentalFilter: _popupsconstants.PARENTAL_FILTER_POPUP_ID
};


/***/ }),

/***/ 59706:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(52318);
var _lockactions = __webpack_require__(75250);
var initialState = {
    shouldDisplayProfilesGate: false
};
var _default = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action && action.type){
        case _lockactions.SHOW_PROFILES_GATE:
            {
                return _object_spread_props._(_object_spread._({}, state), {
                    shouldDisplayProfilesGate: true
                });
            }
        default:
            {
                return state;
            }
    }
};


/***/ }),

/***/ 79941:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "shouldDisplayProfilesGate", ({
    enumerable: true,
    get: function() {
        return shouldDisplayProfilesGate;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(37815);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var shouldDisplayProfilesGate = function(state) {
    return (0, _get.default)(state, "lock.shouldDisplayProfilesGate");
};


/***/ }),

/***/ 78414:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    getDeeplinkFromLock: function() {
        return getDeeplinkFromLock;
    },
    getMappedLockPopup: function() {
        return getMappedLockPopup;
    },
    getNestedOriginalTarget: function() {
        return getNestedOriginalTarget;
    },
    getOriginalTarget: function() {
        return getOriginalTarget;
    },
    getReason: function() {
        return getReason;
    },
    getReasonAttributes: function() {
        return getReasonAttributes;
    },
    getUnlockPathPrefix: function() {
        return getUnlockPathPrefix;
    },
    isPlayerLocked: function() {
        return isPlayerLocked;
    }
});
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _constants = __webpack_require__(34952);
var _fidosdk = __webpack_require__(19804);
var _routesutils = __webpack_require__(14948);
var _lockconstants = __webpack_require__(52816);
var getMappedLockPopup = function(lockId) {
    return _lockconstants.LOCK_POPUPS_MAP[lockId] ? _lockconstants.LOCK_POPUPS_MAP[lockId] : _lockconstants.LOCK_POPUPS_MAP.default;
};
var getReason = function(item) {
    return (0, _get.default)(item, "item.action.target.value_lock.reason");
};
var getOriginalTarget = function(item) {
    return (0, _get.default)(item, "item.action.target.value_lock.originalTarget");
};
var getReasonAttributes = function(item) {
    return (0, _get.default)(item, "action.target.value_lock.reasonAttributes", []);
};
var isPlayerLocked = function(entityType) {
    return [
        _fidosdk.LAYOUT_ENTITIES.video,
        _fidosdk.LAYOUT_ENTITIES.audio,
        _fidosdk.LAYOUT_ENTITIES.radio,
        _fidosdk.LAYOUT_ENTITIES.live
    ].includes(entityType);
};
var getUnlockPathPrefix = function(entityType) {
    return isPlayerLocked(entityType) ? "" : "app/";
};
var getNestedOriginalTarget = function(target) {
    if (target.type === "layout") {
        var layout = target["value_".concat(target.type)];
        return "".concat(getUnlockPathPrefix(layout.type)).concat(layout.type, "/").concat(layout.id);
    }
    if (target.type === "app") {
        var original = target["value_".concat(target.type)];
        return original && original.reference === _constants.BOOKMARKS ? _routesutils.BOOKMARKS_PATH : null;
    }
    if (target.type === "lock") {
        return getNestedOriginalTarget(target["value_".concat(target.type)].originalTarget);
    }
    return null;
};
var getDeeplinkFromLock = function(item) {
    if (!item) {
        return null;
    }
    if (item.video) {
        var id = item.video.id;
        if (!id) {
            return null;
        }
        var path = (window.location.hash || "").replace("#", "");
        if ((0, _get.default)(item.video, "progress.live")) {
            var entityType = path.startsWith(_fidosdk.LAYOUT_ENTITIES.radio) ? _fidosdk.LAYOUT_ENTITIES.radio : _fidosdk.LAYOUT_ENTITIES.live;
            return "".concat(entityType, "/").concat(item.video.id);
        }
        var entityType1 = path.startsWith(_fidosdk.LAYOUT_ENTITIES.audio) ? _fidosdk.LAYOUT_ENTITIES.audio : _fidosdk.LAYOUT_ENTITIES.video;
        return "".concat(entityType1, "/").concat(id.startsWith("clip_") ? id : "clip_".concat(id));
    }
    var target = item.target || (0, _get.default)(item, "action.target");
    if (!target || target.type !== "lock") {
        return null;
    }
    return getNestedOriginalTarget(target);
};


/***/ }),

/***/ 30427:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "refreshAuth", ({
    enumerable: true,
    get: function() {
        return refreshAuth;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(3009);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _tokenactions = __webpack_require__(99619);
var _layoutsectionactions = __webpack_require__(19023);
var _lockutils = __webpack_require__(78414);
var refreshAuth = function(item) {
    return function(dispatch) {
        var section = (0, _get.default)((0, _lockutils.getOriginalTarget)(item), "value_layout.section");
        if (section) {
            dispatch((0, _layoutsectionactions.setCurrentSectionCode)(section));
        }
        var reasonAttributes = (0, _get.default)(item, "item.action.target.value_lock.reasonAttributes");
        var profileUid = reasonAttributes.profileUid;
        dispatch((0, _tokenactions.renewJwtWithProfile)(profileUid));
    };
};


/***/ }),

/***/ 65911:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    getCurrentSubscriptions: function() {
        return getCurrentSubscriptions;
    },
    getUserContractModel: function() {
        return getUserContractModel;
    }
});
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(37815);
var _pairingpremiumutils = __webpack_require__(74475);
var getUserContractModel = _pairingpremiumutils.getPremiumUserContractModel;
var getCurrentSubscriptions = _pairingpremiumutils.getPremiumSubscriptions;


/***/ }),

/***/ 35350:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/* eslint-disable no-console */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    fetchOneTimePasscode: function() {
        return fetchOneTimePasscode;
    },
    fetchUser: function() {
        return fetchUser;
    },
    getProviderPairingStatus: function() {
        return getProviderPairingStatus;
    },
    removePairing: function() {
        return removePairing;
    }
});
var _async_to_generator = __webpack_require__(24146);
var _export_star = __webpack_require__(37668);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
var _fidosdk = __webpack_require__(19804);
var _pairingutils = __webpack_require__(54264);
var _appselectors = __webpack_require__(65910);
var _pairingdeviceutils = __webpack_require__(74830);
var _default = _export_star._(__webpack_require__(46066), exports);
var _pairingconstants = __webpack_require__(25994);
var _pairingProviderconstants = __webpack_require__(84968);
var fetchOneTimePasscode = function() {
    return function() {
        var _ref = _async_to_generator._(function(_, getState) {
            var params, deviceBrand, _ref, token, verificationURI;
            return _ts_generator._(this, function(_state) {
                switch(_state.label){
                    case 0:
                        params = {};
                        try {
                            deviceBrand = (0, _appselectors.getDeviceBrand)(getState());
                            if (deviceBrand) {
                                params.boxName = (0, _pairingdeviceutils.formatDeviceTitle)(deviceBrand);
                            }
                        } catch (error) {
                            throw new Error("Failed deviceBrand getting: ".concat(error.message));
                        }
                        return [
                            4,
                            _fidosdk.oidcService.authorizeDevice()
                        ];
                    case 1:
                        _ref = _state.sent(), token = _ref.user_code, verificationURI = _ref.verification_uri_complete;
                        // eslint-disable-next-line no-console
                        console.log("[PairingProvider.actions] URL: ".concat(verificationURI));
                        return [
                            2,
                            {
                                token: token,
                                verificationURI: verificationURI
                            }
                        ];
                }
            });
        });
        return function(_, getState) {
            return _ref.apply(this, arguments);
        };
    }();
};
var getProviderPairingStatus = function() {
    return /*#__PURE__*/ _async_to_generator._(function() {
        var fetchTokensParams, tokens, error, reason;
        return _ts_generator._(this, function(_state) {
            switch(_state.label){
                case 0:
                    fetchTokensParams = {
                        device_code: _fidosdk.oidcService.getDeviceCode(),
                        grant_type: _pairingProviderconstants.GRANT_TYPE
                    };
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        _fidosdk.oidcService.fetchConnectedTokens(fetchTokensParams)
                    ];
                case 2:
                    tokens = _state.sent();
                    if (tokens) {
                        return [
                            2,
                            {
                                status: _pairingconstants.PAIRING_STATUS_PAIRED
                            }
                        ];
                    }
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    if (typeof error.message === "string") {
                        reason = JSON.parse(error.message.replace(/error\s*:\s*/i, ""));
                        if (reason.error === _pairingProviderconstants.ERROR_AUTHORIZATION_PENDING) {
                            return [
                                2,
                                {
                                    status: _pairingconstants.PAIRING_STATUS_PENDING
                                }
                            ];
                        }
                        if (reason.error === _pairingProviderconstants.ERROR_SLOW_DOWN) {
                            return [
                                2,
                                {
                                    status: _pairingconstants.PAIRING_STATUS_PENDING,
                                    slowDown: true
                                }
                            ];
                        }
                    }
                    throw error;
                case 4:
                    return [
                        2,
                        {
                            status: _pairingconstants.PAIRING_STATUS_PENDING
                        }
                    ];
            }
        });
    });
};
var fetchUser = function() {
    var skipRefresh = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    return /*#__PURE__*/ _async_to_generator._(function() {
        var shouldTrySSI, error, userInfo;
        return _ts_generator._(this, function(_state) {
            switch(_state.label){
                case 0:
                    shouldTrySSI = false;
                    if (!!skipRefresh) return [
                        3,
                        4
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        _fidosdk.oidcService.renewAccessToken()
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    shouldTrySSI = true;
                    return [
                        3,
                        4
                    ];
                case 4:
                    // With the recent FIDO update, it issues a guest token upon renewing, so the error will never be triggered, hence the manual check
                    shouldTrySSI = shouldTrySSI || _fidosdk.oidcService.isGuestUser();
                    if (!(shouldTrySSI && !(0, _pairingutils.shouldSkipSSI)())) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        (0, _default.singleSignIn)()
                    ];
                case 5:
                    _state.sent();
                    _state.label = 6;
                case 6:
                    return [
                        4,
                        _fidosdk.oidcService.getUserInfo()
                    ];
                case 7:
                    userInfo = _state.sent();
                    if (userInfo && (userInfo === null || userInfo === void 0 ? void 0 : userInfo.uid)) {
                        userInfo.firstname = (userInfo === null || userInfo === void 0 ? void 0 : userInfo.preferred_username) || "";
                        userInfo.lastname = "";
                    }
                    return [
                        2,
                        userInfo
                    ];
            }
        });
    });
};
var removePairing = function() {
    return /*#__PURE__*/ _async_to_generator._(function() {
        var error, error1;
        return _ts_generator._(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    console.log("[OIDC] Revoking current device");
                    return [
                        4,
                        _fidosdk.userService.revokeCurrentDevice()
                    ];
                case 1:
                    _state.sent();
                    return [
                        3,
                        3
                    ];
                case 2:
                    error = _state.sent();
                    // NOTE: there may be an error if we have invalid BAT
                    console.error("[OIDC] Can not revoke current device: ".concat(error ? error.message : "no data"));
                    return [
                        3,
                        3
                    ];
                case 3:
                    _state.trys.push([
                        3,
                        5,
                        ,
                        6
                    ]);
                    console.log("[OIDC] Logging out from the token provider");
                    return [
                        4,
                        _fidosdk.oidcService.logout()
                    ];
                case 4:
                    _state.sent();
                    return [
                        3,
                        6
                    ];
                case 5:
                    error1 = _state.sent();
                    // NOTE: there may be an error in case of concurrent un-pairing, or if we have incorrect OIDC token
                    console.error("[OIDC] Can not log out: ".concat(error1 ? error1.message : "no data"));
                    return [
                        3,
                        6
                    ];
                case 6:
                    console.log("[OIDC] Clearing local provider tokens");
                    _fidosdk.oidcService.clearTokens();
                    console.log("[OIDC] Clearing BAT");
                    _fidosdk.tokenService.resetUserAndToken();
                    return [
                        2
                    ];
            }
        });
    });
};


/***/ }),

/***/ 84968:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ERROR_AUTHORIZATION_PENDING: function() {
        return ERROR_AUTHORIZATION_PENDING;
    },
    ERROR_SLOW_DOWN: function() {
        return ERROR_SLOW_DOWN;
    },
    GRANT_TYPE: function() {
        return GRANT_TYPE;
    }
});
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
var GRANT_TYPE = "urn:ietf:params:oauth:grant-type:device_code";
var ERROR_AUTHORIZATION_PENDING = "authorization_pending";
var ERROR_SLOW_DOWN = "slow_down";


/***/ }),

/***/ 83887:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/** @module pairingAction */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    CLEAR_USER_PROFILE: function() {
        return CLEAR_USER_PROFILE;
    },
    LANDING_CONNECT_BUTTON: function() {
        return LANDING_CONNECT_BUTTON;
    },
    LANDING_SUBSCRIBE_BUTTON: function() {
        return LANDING_SUBSCRIBE_BUTTON;
    },
    PAIRING_CLEAR_TOKEN: function() {
        return PAIRING_CLEAR_TOKEN;
    },
    PAIRING_CLEAR_UNPAIRED_ENTERING: function() {
        return PAIRING_CLEAR_UNPAIRED_ENTERING;
    },
    PAIRING_FETCH_FREEMIUM_SERVICES_FAILURE: function() {
        return PAIRING_FETCH_FREEMIUM_SERVICES_FAILURE;
    },
    PAIRING_FETCH_FREEMIUM_SERVICES_SUCCESS: function() {
        return PAIRING_FETCH_FREEMIUM_SERVICES_SUCCESS;
    },
    PAIRING_FETCH_STATUS_FAILURE: function() {
        return PAIRING_FETCH_STATUS_FAILURE;
    },
    PAIRING_FETCH_STATUS_SUCCESS: function() {
        return PAIRING_FETCH_STATUS_SUCCESS;
    },
    PAIRING_FETCH_TOKEN_FAILURE: function() {
        return PAIRING_FETCH_TOKEN_FAILURE;
    },
    PAIRING_FETCH_TOKEN_SUCCESS: function() {
        return PAIRING_FETCH_TOKEN_SUCCESS;
    },
    PAIRING_FETCH_USER_CATALOG_ACCESS_FAILURE: function() {
        return PAIRING_FETCH_USER_CATALOG_ACCESS_FAILURE;
    },
    PAIRING_FETCH_USER_CATALOG_ACCESS_SUCCESS: function() {
        return PAIRING_FETCH_USER_CATALOG_ACCESS_SUCCESS;
    },
    PAIRING_FETCH_USER_FAILURE: function() {
        return PAIRING_FETCH_USER_FAILURE;
    },
    PAIRING_FETCH_USER_SUCCESS: function() {
        return PAIRING_FETCH_USER_SUCCESS;
    },
    PAIRING_INCREMENT_POLLING_INTERVAL: function() {
        return PAIRING_INCREMENT_POLLING_INTERVAL;
    },
    PAIRING_LOGOUT_FAILURE: function() {
        return _unpairactions.PAIRING_LOGOUT_FAILURE;
    },
    PAIRING_LOGOUT_SUCCESS: function() {
        return _unpairactions.PAIRING_LOGOUT_SUCCESS;
    },
    PAIRING_SET_PARENTAL_LOCK_STATUS: function() {
        return PAIRING_SET_PARENTAL_LOCK_STATUS;
    },
    PAIRING_SET_POLLING_INTERVAL: function() {
        return PAIRING_SET_POLLING_INTERVAL;
    },
    PAIRING_SET_UNPAIRED_ENTERING: function() {
        return PAIRING_SET_UNPAIRED_ENTERING;
    },
    RENEW_TOKEN_FAILURE: function() {
        return RENEW_TOKEN_FAILURE;
    },
    RENEW_TOKEN_SUCCESS: function() {
        return RENEW_TOKEN_SUCCESS;
    },
    RETRY_CONNECT_BUTTON_FOCUS_NAME: function() {
        return RETRY_CONNECT_BUTTON_FOCUS_NAME;
    },
    SELECT_USER_PROFILE: function() {
        return SELECT_USER_PROFILE;
    },
    SET_SUBSCRIPTIONS: function() {
        return SET_SUBSCRIPTIONS;
    },
    SUBSCRIBE_BACK_BUTTON: function() {
        return SUBSCRIBE_BACK_BUTTON;
    },
    TOKEN_BACK_BUTTON: function() {
        return TOKEN_BACK_BUTTON;
    },
    WELCOME_CONTINUE_BUTTON: function() {
        return WELCOME_CONTINUE_BUTTON;
    },
    clearPairingToken: function() {
        return clearPairingToken;
    },
    clearUnpairedEntering: function() {
        return clearUnpairedEntering;
    },
    clearUserProfile: function() {
        return clearUserProfile;
    },
    fetchParentalLockStatus: function() {
        return fetchParentalLockStatus;
    },
    fetchStatusFailure: function() {
        return fetchStatusFailure;
    },
    fetchStatusSuccess: function() {
        return fetchStatusSuccess;
    },
    fetchToken: function() {
        return fetchToken;
    },
    fetchTokenFailure: function() {
        return fetchTokenFailure;
    },
    fetchTokenSuccess: function() {
        return fetchTokenSuccess;
    },
    fetchUserInformation: function() {
        return fetchUserInformation;
    },
    fetchUserSubscription: function() {
        return fetchUserSubscription;
    },
    fetchUserSuccess: function() {
        return fetchUserSuccess;
    },
    getCurrentPairedUser: function() {
        return getCurrentPairedUser;
    },
    getStatus: function() {
        return getStatus;
    },
    incrementPollingInterval: function() {
        return incrementPollingInterval;
    },
    logout: function() {
        return logout;
    },
    logoutFailure: function() {
        return _unpairactions.logoutFailure;
    },
    logoutSuccess: function() {
        return _unpairactions.logoutSuccess;
    },
    renewTokenFailure: function() {
        return renewTokenFailure;
    },
    renewTokenSuccess: function() {
        return renewTokenSuccess;
    },
    selectUserProfile: function() {
        return selectUserProfile;
    },
    setParentalControl: function() {
        return setParentalControl;
    },
    setPollingInterval: function() {
        return setPollingInterval;
    },
    setSubscriptions: function() {
        return setSubscriptions;
    },
    setUnpairedEntering: function() {
        return setUnpairedEntering;
    }
});
var _async_to_generator = __webpack_require__(24146);
var _interop_require_default = __webpack_require__(81200);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
var _config = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67958));
var _fidosdk = __webpack_require__(19804);
var _utils = __webpack_require__(64188);
var _pairingutils = __webpack_require__(59653);
var _userselectors = __webpack_require__(41845);
var _errorconstants = __webpack_require__(16186);
var _erroractions = __webpack_require__(39258);
var _useractions = __webpack_require__(79489);
var _featuresselectors = __webpack_require__(76109);
var _analyticsutils = __webpack_require__(2693);
var _errorutils = __webpack_require__(74386);
var _routingactions = __webpack_require__(78235);
var _appconfigactions = __webpack_require__(72261);
var _appconstants = __webpack_require__(32128);
var _pairingProvideractions = __webpack_require__(35350);
var _searchresetactions = __webpack_require__(10193);
var _unpairactions = __webpack_require__(21219);
var PAIRING_SET_POLLING_INTERVAL = "pairing/SET_POLLING_INTERVAL";
var PAIRING_INCREMENT_POLLING_INTERVAL = "pairing/PAIRING_INCREMENT_POLLING_INTERVAL";
var PAIRING_FETCH_TOKEN_SUCCESS = "pairing/FETCH_TOKEN_SUCCESS";
var PAIRING_CLEAR_TOKEN = "pairing/PAIRING_CLEAR_TOKEN";
var PAIRING_FETCH_TOKEN_FAILURE = "pairing/FETCH_TOKEN_FAILURE";
var PAIRING_FETCH_STATUS_FAILURE = "pairing/FETCH_STATUS_FAILURE";
var PAIRING_FETCH_STATUS_SUCCESS = "pairing/FETCH_STATUS_SUCCESS";
var PAIRING_FETCH_USER_SUCCESS = "pairing/FETCH_USER_SUCCESS";
var PAIRING_FETCH_USER_FAILURE = "pairing/FETCH_USER_FAILURE";
var SET_SUBSCRIPTIONS = "pairing/SET_SUBSCRIPTIONS";
var WELCOME_CONTINUE_BUTTON = "pairing/WELCOME_CONTINUE_BUTTON";
var TOKEN_BACK_BUTTON = "pairing/TOKEN_BACK_BUTTON";
var SUBSCRIBE_BACK_BUTTON = "pairing/SUBSCRIBE_BACK_BUTTON";
var LANDING_SUBSCRIBE_BUTTON = "pairing/LANDING_SUBSCRIBE_BUTTON";
var LANDING_CONNECT_BUTTON = "pairing/LANDING_CONNECT_BUTTON";
var RETRY_CONNECT_BUTTON_FOCUS_NAME = "pairing/RETRY_CONNECT_BUTTON_FOCUS_NAME";
var PAIRING_FETCH_USER_CATALOG_ACCESS_SUCCESS = "pairing/PAIRING_FETCH_USER_CATALOG_ACCESS_SUCCESS";
var PAIRING_FETCH_USER_CATALOG_ACCESS_FAILURE = "pairing/PAIRING_FETCH_USER_CATALOG_ACCESS_FAILURE";
var PAIRING_FETCH_FREEMIUM_SERVICES_SUCCESS = "pairing/PAIRING_FETCH_FREEMIUM_SERVICES_SUCCESS";
var PAIRING_FETCH_FREEMIUM_SERVICES_FAILURE = "pairing/PAIRING_FETCH_FREEMIUM_SERVICES_FAILURE";
var PAIRING_SET_PARENTAL_LOCK_STATUS = "pairing/SET_PARENTAL_LOCK_STATUS";
var PAIRING_SET_UNPAIRED_ENTERING = "pairing/PAIRING_SET_UNPAIRED_ENTERING";
var PAIRING_CLEAR_UNPAIRED_ENTERING = "pairing/PAIRING_CLEAR_UNPAIRED_ENTERING";
var RENEW_TOKEN_SUCCESS = "token/RENEW_TOKEN_SUCCESS";
var RENEW_TOKEN_FAILURE = "token/RENEW_TOKEN_FAILURE";
var CLEAR_USER_PROFILE = "token/CLEAR_USER_PROFILE";
var SELECT_USER_PROFILE = "token/SELECT_USER_PROFILE";
var setUnpairedEntering = function() {
    return {
        type: PAIRING_SET_UNPAIRED_ENTERING
    };
};
var clearUnpairedEntering = function() {
    return {
        type: PAIRING_CLEAR_UNPAIRED_ENTERING
    };
};
var fetchTokenSuccess = function(token, verificationURI) {
    return {
        type: PAIRING_FETCH_TOKEN_SUCCESS,
        token: token,
        verificationURI: verificationURI
    };
};
var fetchTokenFailure = function() {
    return {
        type: PAIRING_FETCH_TOKEN_FAILURE
    };
};
var fetchStatusSuccess = function(status) {
    return {
        type: PAIRING_FETCH_STATUS_SUCCESS,
        status: status
    };
};
var fetchStatusFailure = function() {
    return {
        type: PAIRING_FETCH_STATUS_FAILURE
    };
};
var setPollingInterval = function(pollingInterval) {
    return {
        type: PAIRING_SET_POLLING_INTERVAL,
        pollingInterval: pollingInterval
    };
};
var incrementPollingInterval = function() {
    var value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 5000;
    return {
        type: PAIRING_INCREMENT_POLLING_INTERVAL,
        value: value
    };
};
var renewTokenSuccess = function(profileUid) {
    return {
        type: RENEW_TOKEN_SUCCESS,
        profileUid: profileUid
    };
};
var renewTokenFailure = function(error) {
    return {
        type: RENEW_TOKEN_FAILURE,
        error: error
    };
};
var setSubscriptions = function(subscriptions) {
    return {
        type: SET_SUBSCRIPTIONS,
        subscriptions: subscriptions
    };
};
var selectUserProfile = function(profileUid) {
    return {
        type: SELECT_USER_PROFILE,
        profileUid: profileUid
    };
};
var clearUserProfile = function() {
    return {
        type: CLEAR_USER_PROFILE
    };
};
var clearPairingToken = function() {
    return {
        type: PAIRING_CLEAR_TOKEN
    };
};
var fetchToken = function() {
    return function() {
        var _ref = _async_to_generator._(function(dispatch) {
            var _ref, token, verificationURI, error;
            return _ts_generator._(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            dispatch((0, _pairingProvideractions.fetchOneTimePasscode)())
                        ];
                    case 1:
                        _ref = _state.sent(), token = _ref.token, verificationURI = _ref.verificationURI;
                        if (_config.default.pairing && _config.default.pairing.pairingPollInterval) {
                            dispatch(setPollingInterval(_config.default.pairing.pairingPollInterval));
                        }
                        dispatch(fetchTokenSuccess(token, verificationURI));
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        dispatch(fetchTokenFailure());
                        dispatch((0, _erroractions.errorAction)(_errorconstants.ERROR_LEVELS.FATAL, _errorconstants.ERROR_TYPES.PAIRING, error.message));
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
var fetchUserSuccess = function(user) {
    return function() {
        var _ref = _async_to_generator._(function(dispatch, getState) {
            var state, cookieConsents, shouldDisplayProfilesGate, profileUid;
            return _ts_generator._(this, function(_state) {
                try {
                    state = getState();
                    cookieConsents = (0, _userselectors.getCookies)(state);
                    _fidosdk.tokenService.resetUserAndToken();
                    _fidosdk.tokenService.setUser({
                        UID: user.uid
                    });
                    (0, _analyticsutils.setUser)({
                        UID: user.uid
                    });
                    (0, _analyticsutils.trackGDPRConsent)(cookieConsents);
                    // There is no need to display the landing page, user successfully signed in
                    dispatch((0, _routingactions.landingShown)());
                    dispatch(clearUnpairedEntering());
                    dispatch({
                        type: PAIRING_FETCH_USER_SUCCESS,
                        user: user
                    });
                    dispatch((0, _useractions.setUserUid)(user.uid));
                    // Analytics
                    (0, _analyticsutils.setAttributes)({
                        authentified: "yes",
                        userStatus: "connected"
                    });
                    (0, _analyticsutils.sendEvent)({
                        key: "pairingSuccess"
                    });
                    // Restore profile if it was previously selected
                    shouldDisplayProfilesGate = (0, _featuresselectors.getMultiProfilesGateAlwaysDisplayed)(state);
                    // NOTE: Since dev mode utilizes hot reload it's annoying to hit the profile selector each time we need to debug something.
                    // If you need to disable this behavior, run an app in STAGING/PRODUCTION environment.
                    // Also don't forget to clear "profileUid" cookie.
                    if (!shouldDisplayProfilesGate) {
                        profileUid = _utils.storage.getItem("".concat(user.uid, ".").concat(_appconstants.PERSISTENT.PROFILE_UID_KEY)) || null;
                        if (profileUid) {
                            _fidosdk.tokenService.setProfile({
                                profileUid: profileUid
                            });
                            dispatch(selectUserProfile(profileUid));
                            dispatch((0, _useractions.fetchProfileInfos)(profileUid));
                            dispatch(renewTokenSuccess(profileUid));
                        } else {
                            _fidosdk.tokenService.setProfile({
                                profileUid: null
                            });
                        }
                    }
                } catch (error) {
                    dispatch({
                        type: PAIRING_FETCH_USER_FAILURE,
                        error: error
                    });
                    dispatch((0, _erroractions.errorAction)(_errorconstants.ERROR_LEVELS.SILENT, _errorconstants.ERROR_TYPES.PAIRING, error.message));
                    (0, _analyticsutils.sendEvent)({
                        key: "pairingFail"
                    });
                }
                return [
                    2
                ];
            });
        });
        return function(dispatch, getState) {
            return _ref.apply(this, arguments);
        };
    }();
};
var setParentalControl = function(parentalControlStatus) {
    return {
        type: PAIRING_SET_PARENTAL_LOCK_STATUS,
        parentalControlStatus: parentalControlStatus
    };
};
var fetchParentalLockStatus = function() {
    return function() {
        var _ref = _async_to_generator._(function(dispatch, getState) {
            var userId, maxCsaId, e;
            return _ts_generator._(this, function(_state) {
                switch(_state.label){
                    case 0:
                        userId = (0, _userselectors.getUid)(getState());
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            _fidosdk.parentalControlService.fetchParentalRestriction({
                                uid: userId
                            })
                        ];
                    case 2:
                        maxCsaId = _state.sent().maxCsaId;
                        dispatch(setParentalControl(maxCsaId));
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        dispatch((0, _erroractions.errorAction)(_errorconstants.ERROR_LEVELS.SILENT, _errorconstants.ERROR_TYPES.PAIRING, e.message));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(dispatch, getState) {
            return _ref.apply(this, arguments);
        };
    }();
};
var fetchUserSubscription = function() {
    return function() {
        var _ref = _async_to_generator._(function(dispatch, getState) {
            var userId, userSubscriptions, error;
            return _ts_generator._(this, function(_state) {
                switch(_state.label){
                    case 0:
                        userId = (0, _userselectors.getUid)(getState());
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            (0, _pairingutils.getCurrentSubscriptions)(userId)
                        ];
                    case 2:
                        userSubscriptions = _state.sent();
                        dispatch(setSubscriptions(userSubscriptions));
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        dispatch((0, _erroractions.errorAction)(_errorconstants.ERROR_LEVELS.SILENT, _errorconstants.ERROR_TYPES.PAIRING, error.message));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(dispatch, getState) {
            return _ref.apply(this, arguments);
        };
    }();
};
var fetchUserInformation = function() {
    return function(dispatch, getState) {
        var isPremiumEnabled = (0, _featuresselectors.getPremiumFeature)(getState());
        if (!isPremiumEnabled) {
            return Promise.resolve();
        }
        return Promise.all([
            dispatch(fetchUserSubscription()),
            dispatch(fetchParentalLockStatus())
        ]);
    };
};
var getCurrentPairedUser = function() {
    var skipRefresh = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    return function() {
        var _ref = _async_to_generator._(function(dispatch) {
            var pairedUser, error;
            return _ts_generator._(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            dispatch((0, _pairingProvideractions.fetchUser)(skipRefresh))
                        ];
                    case 1:
                        pairedUser = _state.sent();
                        if (pairedUser) {
                            dispatch(fetchUserSuccess(pairedUser));
                            dispatch((0, _appconfigactions.refreshCustomizedConfig)(pairedUser.uid));
                            (0, _analyticsutils.setAttributes)({
                                userId: pairedUser.uid
                            });
                            (0, _analyticsutils.sendEvent)({
                                key: "pairingSuccess"
                            });
                        }
                        return [
                            2,
                            pairedUser
                        ];
                    case 2:
                        error = _state.sent();
                        dispatch((0, _erroractions.errorAction)(_errorconstants.ERROR_LEVELS.SILENT, _errorconstants.ERROR_TYPES.PAIRING, error.message));
                        (0, _analyticsutils.sendEvent)({
                            key: "pairingFail"
                        });
                        return [
                            2,
                            null
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
var getStatus = function() {
    return function() {
        var _ref = _async_to_generator._(function(dispatch) {
            var _ref, status, slowDown, error;
            return _ts_generator._(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            5,
                            ,
                            6
                        ]);
                        return [
                            4,
                            dispatch((0, _pairingProvideractions.getProviderPairingStatus)())
                        ];
                    case 1:
                        _ref = _state.sent(), status = _ref.status, slowDown = _ref.slowDown;
                        if (!(0, _pairingutils.isPaired)(status)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            dispatch(getCurrentPairedUser())
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        if (slowDown) {
                            dispatch(incrementPollingInterval());
                        }
                        _state.label = 4;
                    case 4:
                        dispatch(fetchStatusSuccess(status));
                        return [
                            3,
                            6
                        ];
                    case 5:
                        error = _state.sent();
                        dispatch(fetchStatusFailure());
                        dispatch((0, _erroractions.errorAction)((0, _errorutils.getErrorLevel)(error), _errorconstants.ERROR_TYPES.PAIRING, error.message));
                        return [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
var logout = function() {
    return function(dispatch) {
        return dispatch((0, _unpairactions.logout)()).finally(function() {
            return dispatch((0, _searchresetactions.resetSearch)());
        });
    };
};


/***/ }),

/***/ 25994:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    PAIRING_STATUS_PAIRED: function() {
        return PAIRING_STATUS_PAIRED;
    },
    PAIRING_STATUS_PENDING: function() {
        return PAIRING_STATUS_PENDING;
    },
    REFRESH_AUTH: function() {
        return REFRESH_AUTH;
    },
    REQUIRE_AUTH: function() {
        return REQUIRE_AUTH;
    }
});
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(42578);
var PAIRING_STATUS_PAIRED = "paired";
var PAIRING_STATUS_PENDING = "pending";
var REFRESH_AUTH = "refreshAuth";
var REQUIRE_AUTH = "requireAuth";


/***/ }),

/***/ 74830:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "formatDeviceTitle", ({
    enumerable: true,
    get: function() {
        return formatDeviceTitle;
    }
}));
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(37815);
var _i18n = __webpack_require__(14910);
var formatDeviceTitle = function(brand) {
    var it18nKey = "device.".concat(brand);
    var i18nValue = (0, _i18n.t)(it18nKey);
    if (i18nValue && i18nValue !== it18nKey) {
        return i18nValue;
    }
    return brand;
};


/***/ }),

/***/ 74475:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    getPremiumSubscriptions: function() {
        return getPremiumSubscriptions;
    },
    getPremiumUserContractModel: function() {
        return getPremiumUserContractModel;
    }
});
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(37815);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _fidosdk = __webpack_require__(19804);
var getPremiumUserContractModel = function(subscriptions) {
    return subscriptions ? subscriptions.current.map(function(contract) {
        return {
            offer: (0, _get.default)(contract, "offer.title"),
            features: (0, _get.default)(contract, "offer.features", []).map(function(feature) {
                return feature && feature.code;
            }),
            price: (0, _get.default)(contract, "current_contract.variant.recurring_price") || 0,
            products: (0, _get.default)(contract, "offer.short_products", []).map(function(param) {
                var code = param.code;
                return code;
            }),
            currency: (0, _get.default)(contract, "current_contract.variant.currency", "")
        };
    }) : [];
};
var getPremiumSubscriptions = function(userId) {
    return _fidosdk.premiumService.getUserSubscriptions({
        user: {
            UID: userId
        }
    }).then(getPremiumUserContractModel);
};


/***/ }),

/***/ 53308:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
var _config = __webpack_require__(67958);
var _pairingactions = __webpack_require__(83887);
var _pairingutils = __webpack_require__(59653);
var _unpairactions = __webpack_require__(21219);
var initialState = {
    token: null,
    verificationURI: null,
    status: null,
    email: "",
    subscriptions: null,
    catalogAccess: null,
    photoUrl: null,
    firstname: "",
    lastname: "",
    parentalControl: null,
    isUnpairedEntering: false,
    profileUid: null,
    // NOTE: This value represents explicit manual profile selection
    selectedProfileUid: null,
    pollingInterval: _config.pairing.pairingPollInterval
};
var _default = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case _pairingactions.PAIRING_SET_POLLING_INTERVAL:
            {
                return _object_spread_props._(_object_spread._({}, state), {
                    pollingInterval: action.pollingInterval
                });
            }
        case _pairingactions.PAIRING_INCREMENT_POLLING_INTERVAL:
            {
                return _object_spread_props._(_object_spread._({}, state), {
                    pollingInterval: (state.pollingInterval || initialState.pollingInterval) + 5000
                });
            }
        case _pairingactions.PAIRING_SET_PARENTAL_LOCK_STATUS:
            return _object_spread_props._(_object_spread._({}, state), {
                parentalControl: action.parentalControlStatus
            });
        case _pairingactions.PAIRING_FETCH_TOKEN_SUCCESS:
            return _object_spread_props._(_object_spread._({}, state), {
                token: action.token,
                verificationURI: action.verificationURI
            });
        case _pairingactions.PAIRING_CLEAR_TOKEN:
            return _object_spread_props._(_object_spread._({}, state), {
                token: null,
                verificationURI: null
            });
        case _pairingactions.PAIRING_FETCH_STATUS_SUCCESS:
            return _object_spread_props._(_object_spread._({}, state), {
                status: action.status
            });
        case _pairingactions.PAIRING_FETCH_USER_SUCCESS:
            return _object_spread_props._(_object_spread._({}, state, action.user), {
                status: _pairingutils.STATUS_PAIRED
            });
        case _pairingactions.SET_SUBSCRIPTIONS:
            return _object_spread_props._(_object_spread._({}, state), {
                subscriptions: action.subscriptions
            });
        case _pairingactions.PAIRING_LOGOUT_SUCCESS:
            return _object_spread_props._(_object_spread._({}, initialState), {
                isUnpairedEntering: state.isUnpairedEntering
            });
        case _pairingactions.RENEW_TOKEN_SUCCESS:
            return _object_spread_props._(_object_spread._({}, state), {
                profileUid: action.profileUid
            });
        case _pairingactions.SELECT_USER_PROFILE:
            return _object_spread_props._(_object_spread._({}, state), {
                selectedProfileUid: action.profileUid
            });
        case _pairingactions.CLEAR_USER_PROFILE:
            return _object_spread_props._(_object_spread._({}, state), {
                profileUid: null,
                selectedProfileUid: null
            });
        case _pairingactions.PAIRING_SET_UNPAIRED_ENTERING:
            return _object_spread_props._(_object_spread._({}, state), {
                isUnpairedEntering: true
            });
        case _pairingactions.PAIRING_CLEAR_UNPAIRED_ENTERING:
            return _object_spread_props._(_object_spread._({}, state), {
                isUnpairedEntering: false
            });
        case _unpairactions.PAIRING_RESET:
            {
                return initialState;
            }
        default:
            return state;
    }
};


/***/ }),

/***/ 59739:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    getHasOffer: function() {
        return getHasOffer;
    },
    getIsUnpairedEntering: function() {
        return getIsUnpairedEntering;
    },
    getPairingStatus: function() {
        return getPairingStatus;
    },
    getPairingToken: function() {
        return getPairingToken;
    },
    getPairingURI: function() {
        return getPairingURI;
    },
    getParentalLockStatus: function() {
        return getParentalLockStatus;
    },
    getPhotoUrl: function() {
        return getPhotoUrl;
    },
    getPollingInterval: function() {
        return getPollingInterval;
    },
    getPremiumServices: function() {
        return getPremiumServices;
    },
    getSelectedProfile: function() {
        return getSelectedProfile;
    },
    getUserEmail: function() {
        return getUserEmail;
    },
    getUserFullName: function() {
        return getUserFullName;
    },
    isKidsSection: function() {
        return isKidsSection;
    }
});
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
var getPollingInterval = function(param) {
    var pollingInterval = param.pairing.pollingInterval;
    return pollingInterval;
};
var getPairingToken = function(param) {
    var token = param.pairing.token;
    return token;
};
var getPairingURI = function(param) {
    var verificationURI = param.pairing.verificationURI;
    return verificationURI;
};
var getPairingStatus = function(param) {
    var status = param.pairing.status;
    return status;
};
var getUserEmail = function(param) {
    var email = param.pairing.email;
    return email;
};
var getPhotoUrl = function(param) {
    var photoUrl = param.pairing.photoUrl;
    return photoUrl;
};
var getUserFullName = function(param) {
    var _param_pairing = param.pairing, firstname = _param_pairing.firstname, lastname = _param_pairing.lastname;
    return "".concat(firstname, " ").concat(lastname);
};
var getPremiumServices = function(param) {
    var subscriptions = param.pairing.subscriptions;
    return subscriptions;
};
var isKidsSection = function(param) {
    var currentSectionCode = param.layout.currentSectionCode;
    return currentSectionCode === "kids";
};
var getIsUnpairedEntering = function(param) {
    var _param_pairing = param.pairing, _param_pairing_isUnpairedEntering = _param_pairing.isUnpairedEntering, isUnpairedEntering = _param_pairing_isUnpairedEntering === void 0 ? false : _param_pairing_isUnpairedEntering;
    return isUnpairedEntering;
};
var getParentalLockStatus = function(param) {
    var parentalControl = param.pairing.parentalControl, parentalFilterFeature = param.features.parentalFilterFeature;
    return parentalFilterFeature ? parentalControl || 0 : null;
};
var getHasOffer = function(state) {
    return getPremiumServices(state) && getPremiumServices(state).some(function(service) {
        return service.offer;
    });
};
var getSelectedProfile = function(state) {
    return state.pairing.selectedProfileUid;
};


/***/ }),

/***/ 59653:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    STATUS_PAIRED: function() {
        return STATUS_PAIRED;
    },
    getCurrentSubscriptions: function() {
        return _pairingutils.getCurrentSubscriptions;
    },
    getUserContractModel: function() {
        return _pairingutils.getUserContractModel;
    },
    isPaired: function() {
        return isPaired;
    },
    setClipLastTc: function() {
        return setClipLastTc;
    }
});
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(42578);
var _pairingutils = __webpack_require__(65911);
var STATUS_PAIRED = "paired";
var isPaired = function(status) {
    return status === STATUS_PAIRED;
};
var setClipLastTc = function(clips, clipId, tc) {
    var currentClips = _object_spread._({}, clips);
    currentClips[clipId] = _object_spread_props._(_object_spread._({}, currentClips[clipId] || {}), {
        clipid: Number(clipId),
        lasttcseen: tc
    });
    return currentClips;
};


/***/ }),

/***/ 46066:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    exchangePlatformToken: function() {
        return exchangePlatformToken;
    },
    getStatus: function() {
        return getStatus;
    },
    singleSignIn: function() {
        return singleSignIn;
    }
});
var _async_to_generator = __webpack_require__(24146);
var _interop_require_default = __webpack_require__(81200);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(3009);
var _superagent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(54247));
var _fidosdk = __webpack_require__(19804);
var _config = __webpack_require__(67958);
var _pairingconstants = __webpack_require__(41367);
var _pairingutils = __webpack_require__(54264);
var getStatus = function() {
    var params = new URLSearchParams(window.location.search);
    var token = params.get("token");
    return token ? _superagent.default.post("".concat(_config.oidc.ssiApi, "/telekom/status")).send({
        token: token
    }).then(function(response) {
        return {
            status: response.body.status,
            token: token
        };
    }) : Promise.reject(new Error("No token available"));
};
var exchangePlatformToken = function() {
    var _ref = _async_to_generator._(function(token) {
        var _ref, accessToken, refreshToken, idToken;
        return _ts_generator._(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _superagent.default.post("".concat(_config.oidc.baseUrl, "/token")).type("form").send({
                            client_id: _config.oidc.clientId,
                            grant_type: "urn:ietf:params:oauth:grant-type:token-exchange",
                            subject_token: token,
                            subject_issuer: "telekom",
                            scope: "openid profile email bedrock offline_access"
                        }).then(function(response) {
                            return response.body;
                        })
                    ];
                case 1:
                    _ref = _state.sent(), accessToken = _ref.access_token, refreshToken = _ref.refresh_token, idToken = _ref.id_token;
                    if (!(accessToken && refreshToken)) return [
                        3,
                        3
                    ];
                    _fidosdk.oidcService.setTokens({
                        accessToken: accessToken,
                        idToken: idToken,
                        refreshToken: refreshToken
                    });
                    return [
                        4,
                        _fidosdk.tokenService.renewOidcToken()
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    (0, _pairingutils.setPairingMethod)(_pairingconstants.PAIRING_METHOD.SSI);
                    return [
                        2
                    ];
            }
        });
    });
    return function exchangePlatformToken(token) {
        return _ref.apply(this, arguments);
    };
}();
var singleSignIn = function() {
    var _ref = _async_to_generator._(function() {
        var force, _ref, status, token, error;
        var _arguments = arguments;
        return _ts_generator._(this, function(_state) {
            switch(_state.label){
                case 0:
                    force = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        5,
                        ,
                        6
                    ]);
                    return [
                        4,
                        getStatus()
                    ];
                case 2:
                    _ref = _state.sent(), status = _ref.status, token = _ref.token;
                    if (!(status.displayTos === false || force)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        exchangePlatformToken(token)
                    ];
                case 3:
                    _state.sent();
                    return [
                        2,
                        true
                    ];
                case 4:
                    // eslint-disable-next-line no-console
                    console.warn("[pairing.provider] The platform token is OK, however the user should accept ToS");
                    return [
                        2,
                        false
                    ];
                case 5:
                    error = _state.sent();
                    return [
                        2,
                        false
                    ];
                case 6:
                    return [
                        2
                    ];
            }
        });
    });
    return function singleSignIn() {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 21219:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/* eslint-disable no-console */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    PAIRING_LOGOUT_FAILURE: function() {
        return PAIRING_LOGOUT_FAILURE;
    },
    PAIRING_LOGOUT_SUCCESS: function() {
        return PAIRING_LOGOUT_SUCCESS;
    },
    PAIRING_RESET: function() {
        return PAIRING_RESET;
    },
    logout: function() {
        return logout;
    },
    logoutFailure: function() {
        return logoutFailure;
    },
    logoutSuccess: function() {
        return logoutSuccess;
    }
});
var _async_to_generator = __webpack_require__(24146);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(88801);
var _analyticsutils = __webpack_require__(2693);
var _playerconstants = __webpack_require__(7602);
var _pairingProvideractions = __webpack_require__(35350);
var PAIRING_LOGOUT_SUCCESS = "pairing/LOGOUT_SUCCESS";
var PAIRING_LOGOUT_FAILURE = "pairing/LOGOUT_FAILURE";
var PAIRING_RESET = "pairing/RESET";
var logoutSuccess = function() {
    return {
        type: PAIRING_LOGOUT_SUCCESS
    };
};
var logoutFailure = function(error) {
    return {
        type: PAIRING_LOGOUT_FAILURE,
        error: error
    };
};
var logout = function() {
    return function() {
        var _ref = _async_to_generator._(function(dispatch) {
            var error;
            return _ts_generator._(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            3,
                            4
                        ]);
                        console.log("[unpair.actions] Removing pairing");
                        return [
                            4,
                            dispatch((0, _pairingProvideractions.removePairing)())
                        ];
                    case 1:
                        _state.sent();
                        console.log("[unpair.actions] Resetting player state");
                        dispatch((0, _playerconstants.reset)());
                        console.log("[unpair.actions] Resetting analytics state");
                        (0, _analyticsutils.setAttributes)({
                            authentified: "no",
                            userStatus: "unknown"
                        });
                        console.log("[unpair.actions] Dispatching logout success");
                        dispatch(logoutSuccess());
                        return [
                            3,
                            4
                        ];
                    case 2:
                        error = _state.sent();
                        dispatch({
                            type: PAIRING_LOGOUT_FAILURE,
                            error: error
                        });
                        return [
                            3,
                            4
                        ];
                    case 3:
                        console.log("[unpair.actions] Resetting local paring state");
                        dispatch({
                            type: PAIRING_RESET
                        });
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};


/***/ }),

/***/ 26281:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DAI_YOSPACE: function() {
        return DAI_YOSPACE;
    },
    arrangeSources: function() {
        return arrangeSources;
    },
    getDAI: function() {
        return getDAI;
    },
    isYospaceAsset: function() {
        return isYospaceAsset;
    }
});
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _sliced_to_array = __webpack_require__(28966);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(65759);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var DAI_YOSPACE = "yospace";
var isYospaceAsset = function(param) {
    var provider = param.provider;
    return provider === DAI_YOSPACE;
};
var getDAI = function(item) {
    var provider = (0, _get.default)(item, "advertising.providers.dai");
    if (!provider) {
        return null;
    }
    return {
        provider: provider,
        targeting: (0, _get.default)(item.advertising, "".concat(provider, ".targeting")) || {}
    };
};
var arrangeSources = function(item) {
    var _ref = getDAI(item) || {}, provider = _ref.provider, targeting = _ref.targeting;
    return ((0, _get.default)(item, "video.assets") || []).filter(Boolean).map(function(source) {
        if (provider !== DAI_YOSPACE) {
            return source;
        }
        if (source.provider === provider) {
            try {
                var url = new URL(source.path);
                if (url.searchParams.get("yo.eb.os") === "fallback") {
                    url.searchParams.delete("yo.eb.os");
                }
                Object.entries(targeting).forEach(function(param) {
                    var _param = _sliced_to_array._(param, 2), key = _param[0], value = _param[1];
                    url.searchParams.append(key, value);
                });
                var path = url.toString();
                return _object_spread_props._(_object_spread._({}, source), {
                    path: path,
                    reference: path
                });
            } catch (error) {
                return source;
            }
        }
        return source;
    }).sort(function(a, b) {
        if (isYospaceAsset(a)) {
            return -1;
        }
        if (isYospaceAsset(b)) {
            return 1;
        }
        return 0;
    });
};


/***/ }),

/***/ 80222:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BASE: function() {
        return BASE;
    },
    fetchPauseAd: function() {
        return fetchPauseAd;
    }
});
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _object_without_properties = __webpack_require__(46537);
var _sliced_to_array = __webpack_require__(28966);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(52318);
var _superagent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(54247));
var _constants = __webpack_require__(34952);
var _sizes = __webpack_require__(82699);
var BASE = "https://securepubads.g.doubleclick.net/gampad/adx";
var fetchPauseAd = function(data) {
    return new Promise(function(resolve, reject) {
        var _ref = data || {}, path = _ref.path, targeting = _ref.targeting;
        var _ref1 = targeting || {}, rdid = _ref1.rdid, rest = _object_without_properties._(_ref1, [
            "rdid"
        ]);
        var t = rest ? Object.entries(rest).map(function(param) {
            var _param = _sliced_to_array._(param, 2), key = _param[0], value = _param[1];
            return "".concat(key, "=").concat(value);
        }).join("&") : undefined;
        var screenSize = (0, _sizes.getScreenSize)();
        var params = Object.entries({
            iu: path,
            sz: "1x1",
            c: Date.now(),
            rdid: rdid,
            t: t
        }).map(function(param) {
            var _param = _sliced_to_array._(param, 2), key = _param[0], value = _param[1];
            return "".concat(key, "=").concat(encodeURIComponent(value));
        }).join("&");
        _superagent.default.get("".concat(BASE, "?").concat(params)).then(function(response) {
            return JSON.parse(response.text);
        }).then(function(data) {
            if (typeof data.file_url === "string") {
                resolve(data);
            } else {
                resolve(_object_spread_props._(_object_spread._({}, data), {
                    file_url: data.file_url[screenSize === _constants.HD ? "1280x720" : "1920x1080"]
                }));
            }
        }).catch(function(error) {
            return reject(error);
        });
    });
};


/***/ }),

/***/ 81586:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    getLiveEdgeInSeconds: function() {
        return getLiveEdgeInSeconds;
    },
    isOnLive: function() {
        return isOnLive;
    }
});
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(45538);
var getLiveEdgeInSeconds = function(state) {
    return state.player.liveEdgeInSeconds;
};
var isOnLive = function(state) {
    return state.player.isOnLive || false;
};


/***/ }),

/***/ 3672:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    findCurrentLiveItem: function() {
        return findCurrentLiveItem;
    },
    findCurrentMetadataItemIndex: function() {
        return findCurrentMetadataItemIndex;
    },
    findItemByTimestamp: function() {
        return findItemByTimestamp;
    },
    getMetadataItemsFromLayout: function() {
        return getMetadataItemsFromLayout;
    },
    getPlayerBlockFromLayout: function() {
        return getPlayerBlockFromLayout;
    },
    getTimeToRequestNewMetadataInSeconds: function() {
        return getTimeToRequestNewMetadataInSeconds;
    }
});
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(37815);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _playerutils = __webpack_require__(41230);
var findItemByTimestamp = function(items, timestamp) {
    return items.find(function(item) {
        var progress = (0, _get.default)(item, "video.progress.live");
        if (!progress) {
            return false;
        }
        var startTimestamp = progress.startTimestamp, endTimestamp = progress.endTimestamp;
        if (!Number.isFinite(startTimestamp) || !Number.isFinite(endTimestamp)) {
            return false;
        }
        return timestamp >= startTimestamp && timestamp <= endTimestamp;
    });
};
var findCurrentLiveItem = function(layout, timestamp) {
    var blocks = (0, _get.default)(layout, "blocks", []);
    var block = (0, _playerutils.findPlayerBlock)(blocks);
    return findItemByTimestamp((0, _get.default)(block, "content.items", []), timestamp);
};
var getPlayerBlockFromLayout = function(layout) {
    return (0, _playerutils.findPlayerBlock)((0, _get.default)(layout, "blocks", []));
};
var getMetadataItemsFromLayout = function(layout) {
    return (0, _get.default)(getPlayerBlockFromLayout(layout), "content.items", []);
};
var findCurrentMetadataItemIndex = function(layout, currentBlock) {
    return getMetadataItemsFromLayout(layout).indexOf(currentBlock);
};
var getTimeToRequestNewMetadataInSeconds = function(timestamp) {
    return Math.round(timestamp * 0.8 + Math.random() * timestamp * 0.15);
};


/***/ }),

/***/ 90120:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    changeTracksPreferences: function() {
        return changeTracksPreferences;
    },
    fetchPlayerLayout: function() {
        return fetchPlayerLayout;
    },
    fetchUpfrontToken: function() {
        return fetchUpfrontToken;
    },
    getNewMetadataItems: function() {
        return getNewMetadataItems;
    },
    handleLayoutAction: function() {
        return handleLayoutAction;
    },
    initialize: function() {
        return initialize;
    },
    playbackError: function() {
        return playbackError;
    },
    refreshPauseAd: function() {
        return refreshPauseAd;
    },
    selectAudioTrack: function() {
        return selectAudioTrack;
    },
    selectSubtitlesTrack: function() {
        return selectSubtitlesTrack;
    },
    setAudioTrack: function() {
        return setAudioTrack;
    },
    setSubtitlesTrack: function() {
        return setSubtitlesTrack;
    },
    showAdJingle: function() {
        return showAdJingle;
    },
    switchToNextProgram: function() {
        return switchToNextProgram;
    }
});
var _async_to_generator = __webpack_require__(24146);
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _object_without_properties = __webpack_require__(46537);
var _sliced_to_array = __webpack_require__(28966);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _config = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67958));
var _fidosdk = __webpack_require__(19804);
var _utils = __webpack_require__(64188);
var _featuresselectors = __webpack_require__(76109);
var _i18n = __webpack_require__(14910);
var _userselectors = __webpack_require__(41845);
var _routingselectors = __webpack_require__(2001);
var _layoutselectors = __webpack_require__(53368);
var _playerselectors = __webpack_require__(83318);
var _ctaactions = __webpack_require__(32067);
var _ctautils = __webpack_require__(42533);
var _errorutils = __webpack_require__(74386);
var _ctaconstants = /*#__PURE__*/ _interop_require_default._(__webpack_require__(77713));
var _lockactions = __webpack_require__(75250);
var _erroractions = __webpack_require__(39258);
var _errorconstants = __webpack_require__(16186);
var _analyticsutils = __webpack_require__(2693);
var _googlePauseAdsutils = __webpack_require__(80222);
var _liveutils = __webpack_require__(3672);
var _playerutils = __webpack_require__(41230);
var _playerconstants = __webpack_require__(7602);
var handleLayoutAction = function(wrapper, type) {
    return function(dispatch) {
        switch(type){
            case _ctaconstants.default.LOCK:
                {
                    dispatch((0, _playerconstants.lockPlayer)());
                    dispatch((0, _lockactions.handleLock)(wrapper, {
                        routeBackOnClose: true
                    }));
                    break;
                }
            default:
                {
                    dispatch((0, _ctaactions.createItemAction)(wrapper));
                    break;
                }
        }
    };
};
var initialize = function() {
    return function(dispatch, getState) {
        var state = getState();
        var entityId = (0, _layoutselectors.getRequestedEntityId)(state);
        var layout = (0, _layoutselectors.getCurrentLayout)(state);
        var item = (0, _playerutils.findCurrentVideoItem)(layout, entityId);
        var actionType = (0, _ctautils.getItemActionType)(item);
        if (actionType === _ctaconstants.default.PLAY) {
            var entityType = (0, _layoutselectors.getRequestedEntityType)(state);
            dispatch((0, _playerconstants.setPlayerInitialized)({
                entityType: entityType,
                entityId: entityId,
                isLive: entityType === _fidosdk.LAYOUT_ENTITIES.live,
                layout: layout,
                item: item
            }));
            var source = (0, _playerselectors.getVideoSource)(getState());
            if (!source) {
                dispatch((0, _erroractions.errorAction)(_errorconstants.ERROR_LEVELS.FATAL, _errorconstants.ERROR_TYPES.PLAYER, "No sources available"));
            }
        } else {
            dispatch(handleLayoutAction({
                item: item
            }, actionType));
        }
    };
};
var fetchPlayerLayout = function() {
    return function() {
        var _ref = _async_to_generator._(function(dispatch, getState) {
            var state, layout, entityId, dimensions;
            return _ts_generator._(this, function(_state) {
                state = getState();
                layout = (0, _layoutselectors.getCurrentLayout)(state);
                // NOTE: handling a case when a video layout loaded after user pressed Back button during loading
                // It means that a player screen tries to render non-player layout during transition between screens, so no additional handling is required
                if ((0, _playerutils.isPlayerLayout)(layout)) {
                    entityId = (0, _layoutselectors.getRequestedEntityId)(state);
                    dispatch(initialize());
                    try {
                        dimensions = (0, _get.default)((0, _playerutils.findCurrentVideoItem)(layout, entityId), "analytics.googleAnalytics");
                        if (dimensions) {
                            (0, _analyticsutils.setAttributes)(Object.entries(dimensions).filter(function(param) {
                                var _param = _sliced_to_array._(param, 1), key = _param[0];
                                return key.startsWith("dimension");
                            }).reduce(function(acc, param) {
                                var _param = _sliced_to_array._(param, 2), key = _param[0], value = _param[1];
                                return _object_spread_props._(_object_spread._({}, acc), _define_property._({}, key, value));
                            }, {}));
                        }
                    } catch (error) {
                        dispatch((0, _erroractions.errorAction)(_errorconstants.ERROR_LEVELS.SILENT, _errorconstants.ERROR_TYPES.LAYOUT, "No custom dimensions"));
                    }
                }
                return [
                    2
                ];
            });
        });
        return function(dispatch, getState) {
            return _ref.apply(this, arguments);
        };
    }();
};
var fetchUpfrontToken = function(service) {
    return function() {
        var _ref = _async_to_generator._(function(_, getState) {
            var state, uid, source, contentId, token, isLive, tokenRequestHandler, tokenAssetData;
            return _ts_generator._(this, function(_state) {
                switch(_state.label){
                    case 0:
                        state = getState();
                        uid = (0, _userselectors.getUid)(state);
                        // TODO: figure out if we should use the UID from DRM config
                        // const uid = _get(source, 'drm.config.uid');
                        source = (0, _playerselectors.getVideoSource)(state);
                        contentId = (0, _get.default)(source, "drm.config.contentId");
                        token = "";
                        if (!contentId) return [
                            3,
                            2
                        ];
                        isLive = (0, _playerselectors.getIsLive)(state);
                        tokenRequestHandler = isLive ? _fidosdk.upFrontTokenService.getLiveToken : _fidosdk.upFrontTokenService.getVideoToken;
                        tokenAssetData = isLive ? {
                            channelCode: contentId
                        } : {
                            videoId: contentId
                        };
                        return [
                            4,
                            tokenRequestHandler.bind(_fidosdk.upFrontTokenService)(_object_spread._({
                                user: {
                                    UID: uid
                                },
                                service: service
                            }, tokenAssetData))
                        ];
                    case 1:
                        token = _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            2,
                            {
                                value: token,
                                uid: uid
                            }
                        ];
                }
            });
        });
        return function(_, getState) {
            return _ref.apply(this, arguments);
        };
    }();
};
var showAdJingle = function() {
    return function(dispatch, getState) {
        var state = getState();
        dispatch((0, _playerconstants.adJingleStarted)());
        if (!(0, _playerselectors.getAdJingleImageId)(state)) {
            return Promise.resolve();
        }
        return new Promise(function(resolve) {
            setTimeout(function() {
                resolve();
                dispatch((0, _playerconstants.adJingleComplete)());
            }, (0, _playerselectors.getAdJingleDurationInMilliseconds)(state));
        });
    };
};
var switchToNextProgram = function() {
    return function(dispatch, getState) {
        var items = (0, _playerselectors.getMetadataItems)(getState());
        var item = (0, _liveutils.findItemByTimestamp)(items, (0, _utils.getCurrentTimeInSeconds)());
        if (!item) {
            return;
        }
        var actionType = (0, _ctautils.getItemActionType)(item);
        if (actionType === _ctaconstants.default.PLAY) {
            dispatch({
                type: _playerconstants.SET_CURRENT_METADATA_ITEM,
                item: item
            });
        } else {
            dispatch(handleLayoutAction({
                item: item
            }, actionType));
        }
    };
};
var getNewMetadataItems = function() {
    return function() {
        var _ref = _async_to_generator._(function(dispatch, getState) {
            var state, entityId, entityType, sectionCode, entity, data, programs, error;
            return _ts_generator._(this, function(_state) {
                switch(_state.label){
                    case 0:
                        state = getState();
                        entityId = (0, _layoutselectors.getRequestedEntityId)(state);
                        entityType = (0, _layoutselectors.getRequestedEntityType)(state);
                        sectionCode = (0, _layoutselectors.getCurrentSectionCode)(state);
                        entity = {
                            entityId: entityId,
                            entityType: entityType,
                            sectionCode: sectionCode
                        };
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            _fidosdk.layoutForThirdPartyService.fetchByEntity(entity)
                        ];
                    case 2:
                        data = _state.sent();
                        programs = (0, _liveutils.getMetadataItemsFromLayout)(data).filter(function(item) {
                            return item && item.itemContent;
                        }).map(function(_param) {
                            var itemContent = _param.itemContent, rest = _object_without_properties._(_param, [
                                "itemContent"
                            ]);
                            return _object_spread._({}, rest, itemContent);
                        });
                        if (programs.length) {
                            dispatch({
                                type: _playerconstants.APPEND_NEW_METADATA_ITEMS,
                                programs: programs,
                                entityType: entityType,
                                entityId: entityId
                            });
                            return [
                                2,
                                dispatch(switchToNextProgram())
                            ];
                        }
                        return [
                            2,
                            dispatch((0, _erroractions.errorAction)(_errorconstants.ERROR_LEVELS.SILENT, _errorconstants.ERROR_TYPES.LAYOUT, "No Live"))
                        ];
                    case 3:
                        error = _state.sent();
                        return [
                            2,
                            dispatch((0, _erroractions.errorAction)(_errorconstants.ERROR_LEVELS.FATAL, _errorconstants.ERROR_TYPES.LAYOUT, error.message))
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(dispatch, getState) {
            return _ref.apply(this, arguments);
        };
    }();
};
var setAudioTrack = function(track) {
    return {
        type: _playerconstants.SET_AUDIO_TRACK,
        track: track
    };
};
var setSubtitlesTrack = function(track) {
    return {
        type: _playerconstants.SET_SUBTITLE_TRACK,
        track: track
    };
};
var changeTracksPreferences = function(param) {
    var audioTrack = param.audioTrack, subtitlesTrack = param.subtitlesTrack;
    return function(dispatch, getState) {
        dispatch({
            type: _playerconstants.TRACK_PREFERENCES_CHANGED,
            audioTrack: audioTrack,
            subtitlesTrack: subtitlesTrack
        });
        var state = getState();
        var _state_player = state.player, originalLanguage = _state_player.originalLanguage, preferences = _state_player.preferences;
        var shouldTrackPreferencesAcrossDevices = (0, _featuresselectors.getPlayerTrackPreferencesFeature)(state);
        if (!shouldTrackPreferencesAcrossDevices || !originalLanguage) {
            return Promise.resolve();
        }
        return _fidosdk.userService.setTrackPreferences({
            originalLanguage: originalLanguage,
            audioPreference: (0, _playerutils.layoutAudioTrackToUsersPreference)(preferences.audioTrack),
            subtitlesPreference: preferences.textTrack ? (0, _playerutils.layoutTextTrackToUsersPreference)(preferences.textTrack) : null
        }).catch(function(error) {
            dispatch((0, _erroractions.errorAction)(_errorconstants.ERROR_LEVELS.SILENT, _errorconstants.ERROR_TYPES.PLAYER, error.message));
        });
    };
};
var selectAudioTrack = function(trackId) {
    return function(dispatch, getState) {
        var state = getState();
        var _state_player = state.player, audioTracks = _state_player.audioTracks, selectedAudioTrack = _state_player.selectedAudioTrack, subtitleTracks = _state_player.subtitleTracks, selectedSubtitlesTrack = _state_player.selectedSubtitlesTrack;
        if (selectedAudioTrack === trackId) {
            return;
        }
        var audioTrack = audioTracks.find(function(param) {
            var id = param.id;
            return id === trackId;
        });
        if (!audioTrack) {
            return;
        }
        dispatch(setAudioTrack(audioTrack));
        dispatch(changeTracksPreferences({
            audioTrack: audioTrack
        }));
        var subtitlesTrack = subtitleTracks.find(function(param) {
            var id = param.id;
            return id === selectedSubtitlesTrack;
        });
        if (!subtitlesTrack || (0, _playerutils.isForcedSubtitlesTrack)(subtitlesTrack)) {
            var forcedSubtitlesTrack = (0, _playerutils.findForcedSubtitles)(subtitleTracks, audioTrack.language);
            dispatch(setSubtitlesTrack(forcedSubtitlesTrack || null));
        }
    };
};
var selectSubtitlesTrack = function(trackId) {
    return function(dispatch, getState) {
        var state = getState();
        var _state_player = state.player, subtitleTracks = _state_player.subtitleTracks, audioTracks = _state_player.audioTracks, selectedAudioTrack = _state_player.selectedAudioTrack;
        var subtitlesTrack = subtitleTracks.find(function(param) {
            var id = param.id;
            return id === trackId;
        });
        var audioTrack = audioTracks.find(function(param) {
            var id = param.id;
            return id === selectedAudioTrack;
        });
        // User selected to disable subtitles explicitly
        if (!trackId) {
            dispatch(changeTracksPreferences({
                subtitlesTrack: null
            }));
        }
        if (subtitlesTrack) {
            dispatch(setSubtitlesTrack(subtitlesTrack));
            dispatch(changeTracksPreferences({
                subtitlesTrack: subtitlesTrack
            }));
        } else if (audioTrack) {
            var forcedSubtitlesTrack = (0, _playerutils.findForcedSubtitles)(subtitleTracks, audioTrack.language);
            dispatch(setSubtitlesTrack(forcedSubtitlesTrack));
        } else {
            dispatch(setSubtitlesTrack(null));
        }
    };
};
var refreshPauseAd = function() {
    return function(dispatch, getState) {
        var state = getState();
        var currentPauseAd = (0, _playerselectors.getCurrentPauseAd)(state);
        var currentAdReceiveTime = currentPauseAd ? currentPauseAd.receivedAt : 0;
        var timeoutInSeconds = Number.isFinite(_config.default.ads.pauseAdRefreshTimeoutInSeconds) ? _config.default.ads.pauseAdRefreshTimeoutInSeconds : 30;
        if (Date.now() - currentAdReceiveTime > timeoutInSeconds * 1000) {
            var adRequestData = (0, _playerselectors.getPauseAdRequestData)(state);
            if (!adRequestData) {
                return;
            }
            dispatch((0, _playerconstants.setPauseAd)(null));
            (0, _googlePauseAdsutils.fetchPauseAd)(adRequestData).then(function(ad) {
                if (ad) {
                    dispatch((0, _playerconstants.setPauseAd)(_object_spread_props._(_object_spread._({}, ad), {
                        receivedAt: Date.now()
                    })));
                } else {
                    dispatch((0, _playerconstants.pauseAdsError)());
                    dispatch((0, _erroractions.errorAction)(_errorconstants.ERROR_LEVELS.SILENT, _errorconstants.ERROR_TYPES.LAYOUT, "No pause ad data: ad server returned an empty response"));
                }
            }).catch(function(error) {
                dispatch((0, _playerconstants.pauseAdsError)());
                dispatch((0, _erroractions.errorAction)(_errorconstants.ERROR_LEVELS.SILENT, _errorconstants.ERROR_TYPES.LAYOUT, "No pause ad data: ".concat(error.message)));
            });
        }
    };
};
var playbackError = function(error) {
    return function(dispatch, getState) {
        var state = getState();
        var path = (0, _routingselectors.getCurrentRoute)(state);
        var entity = (path || "").split("/")[0];
        var level = (0, _errorutils.getErrorLevel)(error);
        var message = (0, _errorutils.fetchErrorMessage)(error);
        var contentType = (0, _playerselectors.getContentType)(state);
        // In case we are currently on a player screen, handle the error as usual, otherwise display a Snackbar (handled by MiniPlayer)
        dispatch((0, _erroractions.errorAction)(_playerconstants.PLAYER_ENTITIES.includes(entity) || level !== _errorconstants.ERROR_LEVELS.FATAL ? level : _errorconstants.ERROR_LEVELS.SILENT, _errorconstants.ERROR_TYPES.PLAYER, message));
        // The MiniPlayer is listening for this error, it will fire a notification event up on the view tree to the App instance,
        // also it will stop the playback visualization and handle audio player cleanup if needed
        dispatch((0, _playerconstants.setPlayerError)({
            level: level,
            message: contentType === _fidosdk.LAYOUT_ENTITIES.audio || contentType === _fidosdk.LAYOUT_ENTITIES.radio ? (0, _i18n.t)("error.podcast") : message
        }));
    };
};


/***/ }),

/***/ 7602:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    AD_BREAK_ENDED: function() {
        return AD_BREAK_ENDED;
    },
    AD_BREAK_STARTED: function() {
        return AD_BREAK_STARTED;
    },
    AD_BREAK_TIME_UPDATE: function() {
        return AD_BREAK_TIME_UPDATE;
    },
    AD_ENDED: function() {
        return AD_ENDED;
    },
    AD_ERROR: function() {
        return AD_ERROR;
    },
    AD_JINGLE_COMPLETE: function() {
        return AD_JINGLE_COMPLETE;
    },
    AD_JINGLE_DURATION: function() {
        return AD_JINGLE_DURATION;
    },
    AD_JINGLE_STARTED: function() {
        return AD_JINGLE_STARTED;
    },
    AD_MARKERS_LIST: function() {
        return AD_MARKERS_LIST;
    },
    AD_PAUSED: function() {
        return AD_PAUSED;
    },
    AD_PLAYING: function() {
        return AD_PLAYING;
    },
    AD_PROVIDER_LOADED: function() {
        return AD_PROVIDER_LOADED;
    },
    AD_STARTED: function() {
        return AD_STARTED;
    },
    AD_TIME_UPDATE: function() {
        return AD_TIME_UPDATE;
    },
    APPEND_NEW_METADATA_ITEMS: function() {
        return APPEND_NEW_METADATA_ITEMS;
    },
    AUDIO_TRACK_CHANGED: function() {
        return AUDIO_TRACK_CHANGED;
    },
    BUFFERING: function() {
        return BUFFERING;
    },
    CAN_PLAY: function() {
        return CAN_PLAY;
    },
    CAN_PLAY_THROUGH: function() {
        return CAN_PLAY_THROUGH;
    },
    ENDED: function() {
        return ENDED;
    },
    INITIALIZED: function() {
        return INITIALIZED;
    },
    INTERFACE_DISPLAY_DURATION: function() {
        return INTERFACE_DISPLAY_DURATION;
    },
    JINGLE_DURATION: function() {
        return JINGLE_DURATION;
    },
    LBANNER_STATE: function() {
        return LBANNER_STATE;
    },
    LIVE_DURATION: function() {
        return LIVE_DURATION;
    },
    LOAD_START: function() {
        return LOAD_START;
    },
    LOCKED: function() {
        return LOCKED;
    },
    MANIFEST_LOADED: function() {
        return MANIFEST_LOADED;
    },
    MIN_SECONDS_TO_TRACK_PROGRESS: function() {
        return MIN_SECONDS_TO_TRACK_PROGRESS;
    },
    PAUSED: function() {
        return PAUSED;
    },
    PAUSE_AD_STATE: function() {
        return PAUSE_AD_STATE;
    },
    PLAYBACK_STATE_ENDED: function() {
        return PLAYBACK_STATE_ENDED;
    },
    PLAYBACK_STATE_IDLE: function() {
        return PLAYBACK_STATE_IDLE;
    },
    PLAYBACK_STATE_PAUSED: function() {
        return PLAYBACK_STATE_PAUSED;
    },
    PLAYBACK_STATE_PLAYING: function() {
        return PLAYBACK_STATE_PLAYING;
    },
    PLAYER_ACTIONS_PREFIX: function() {
        return PLAYER_ACTIONS_PREFIX;
    },
    PLAYER_ENTITIES: function() {
        return PLAYER_ENTITIES;
    },
    PLAYING: function() {
        return PLAYING;
    },
    RESET: function() {
        return RESET;
    },
    RESET_LAST_VIEWED_VIDEO_DATA: function() {
        return RESET_LAST_VIEWED_VIDEO_DATA;
    },
    SEEKED: function() {
        return SEEKED;
    },
    SEEKING: function() {
        return SEEKING;
    },
    SEEK_DEBOUNCE_MS: function() {
        return SEEK_DEBOUNCE_MS;
    },
    SEEK_STEP_SECONDS: function() {
        return SEEK_STEP_SECONDS;
    },
    SEEK_THROTTLE_MS: function() {
        return SEEK_THROTTLE_MS;
    },
    SET_AUDIO_TRACK: function() {
        return SET_AUDIO_TRACK;
    },
    SET_CURRENT_METADATA_ITEM: function() {
        return SET_CURRENT_METADATA_ITEM;
    },
    SET_LBANNER_STATE: function() {
        return SET_LBANNER_STATE;
    },
    SET_PAUSE_AD: function() {
        return SET_PAUSE_AD;
    },
    SET_PAUSE_AD_STATE: function() {
        return SET_PAUSE_AD_STATE;
    },
    SET_PLAYER_ERROR: function() {
        return SET_PLAYER_ERROR;
    },
    SET_SUBTITLE_TRACK: function() {
        return SET_SUBTITLE_TRACK;
    },
    SUBTITLES_TRACK_CHANGED: function() {
        return SUBTITLES_TRACK_CHANGED;
    },
    SUBTITLES_UPDATED: function() {
        return SUBTITLES_UPDATED;
    },
    TIME_UPDATE: function() {
        return TIME_UPDATE;
    },
    TOP_BAR_BACK: function() {
        return TOP_BAR_BACK;
    },
    TOP_BAR_BACK_TO_LIVE: function() {
        return TOP_BAR_BACK_TO_LIVE;
    },
    TOP_BAR_INFO_PAGE: function() {
        return TOP_BAR_INFO_PAGE;
    },
    TOP_BAR_RELATED_VIDEOS: function() {
        return TOP_BAR_RELATED_VIDEOS;
    },
    TOP_BAR_START_OVER: function() {
        return TOP_BAR_START_OVER;
    },
    TOP_BAR_TRACKS: function() {
        return TOP_BAR_TRACKS;
    },
    TRACKS_CHANGED: function() {
        return TRACKS_CHANGED;
    },
    TRACK_PREFERENCES_CHANGED: function() {
        return TRACK_PREFERENCES_CHANGED;
    },
    UPDATE_METADATA: function() {
        return UPDATE_METADATA;
    },
    WAITING: function() {
        return WAITING;
    },
    adBreakEnded: function() {
        return adBreakEnded;
    },
    adBreakStarted: function() {
        return adBreakStarted;
    },
    adBreakTimeUpdate: function() {
        return adBreakTimeUpdate;
    },
    adEnded: function() {
        return adEnded;
    },
    adError: function() {
        return adError;
    },
    adJingleComplete: function() {
        return adJingleComplete;
    },
    adJingleStarted: function() {
        return adJingleStarted;
    },
    adMarkers: function() {
        return adMarkers;
    },
    adPaused: function() {
        return adPaused;
    },
    adPlaying: function() {
        return adPlaying;
    },
    adProviderLoaded: function() {
        return adProviderLoaded;
    },
    adStarted: function() {
        return adStarted;
    },
    adTimeUpdate: function() {
        return adTimeUpdate;
    },
    loadStart: function() {
        return loadStart;
    },
    lockPlayer: function() {
        return lockPlayer;
    },
    pauseAdsDisplaying: function() {
        return pauseAdsDisplaying;
    },
    pauseAdsError: function() {
        return pauseAdsError;
    },
    paused: function() {
        return paused;
    },
    playing: function() {
        return playing;
    },
    reset: function() {
        return reset;
    },
    resetLastViewedData: function() {
        return resetLastViewedData;
    },
    setLBannerHide: function() {
        return setLBannerHide;
    },
    setLBannerShow: function() {
        return setLBannerShow;
    },
    setPauseAd: function() {
        return setPauseAd;
    },
    setPlayerError: function() {
        return setPlayerError;
    },
    setPlayerInitialized: function() {
        return setPlayerInitialized;
    },
    withPlayerPrefix: function() {
        return withPlayerPrefix;
    }
});
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(65759);
var _mediaengine = __webpack_require__(62221);
var _mediaengine1 = __webpack_require__(88918);
var _fidosdk = __webpack_require__(19804);
var PLAYBACK_STATE_IDLE = "idle";
var PLAYBACK_STATE_PLAYING = "playing";
var PLAYBACK_STATE_PAUSED = "paused";
var PLAYBACK_STATE_ENDED = "ended";
var PAUSE_AD_STATE = {
    IDLE: 0,
    LOADING: 1,
    DISPLAYING: 2,
    ERROR: 3
};
var LBANNER_STATE = {
    HIDE: 0,
    SHOW: 1
};
var PLAYER_ENTITIES = [
    _fidosdk.LAYOUT_ENTITIES.audio,
    _fidosdk.LAYOUT_ENTITIES.radio,
    _fidosdk.LAYOUT_ENTITIES.video,
    _fidosdk.LAYOUT_ENTITIES.live
];
var JINGLE_DURATION = 3000;
var AD_JINGLE_DURATION = 1500;
var INTERFACE_DISPLAY_DURATION = 5000;
var SEEK_DEBOUNCE_MS = 800;
var SEEK_THROTTLE_MS = 220;
var SEEK_STEP_SECONDS = 15;
var LIVE_DURATION = -1;
var MIN_SECONDS_TO_TRACK_PROGRESS = 30;
var PLAYER_ACTIONS_PREFIX = "player";
var withPlayerPrefix = function(event) {
    return "".concat(PLAYER_ACTIONS_PREFIX, "/").concat(event.toUpperCase());
};
var INITIALIZED = withPlayerPrefix("INITIALIZED");
var LOAD_START = withPlayerPrefix("LOAD_START");
var MANIFEST_LOADED = withPlayerPrefix("MANIFEST_LOADED");
var BUFFERING = withPlayerPrefix(_mediaengine.VIDEO_EVENTS.LOAD_START);
var LOCKED = withPlayerPrefix("LOCKED");
var CAN_PLAY = withPlayerPrefix(_mediaengine.VIDEO_EVENTS.CAN_PLAY);
var CAN_PLAY_THROUGH = withPlayerPrefix(_mediaengine.VIDEO_EVENTS.CAN_PLAY_THROUGH);
var PLAYING = withPlayerPrefix(_mediaengine.VIDEO_EVENTS.PLAYING);
var PAUSED = withPlayerPrefix(_mediaengine.VIDEO_EVENTS.PAUSE);
var WAITING = withPlayerPrefix(_mediaengine.VIDEO_EVENTS.WAITING);
var TIME_UPDATE = withPlayerPrefix(_mediaengine.VIDEO_EVENTS.TIME_UPDATE);
var SEEKING = withPlayerPrefix(_mediaengine.VIDEO_EVENTS.SEEKING);
var SEEKED = withPlayerPrefix(_mediaengine.VIDEO_EVENTS.SEEKED);
var ENDED = withPlayerPrefix(_mediaengine.VIDEO_EVENTS.ENDED);
var TRACKS_CHANGED = withPlayerPrefix(_mediaengine1.EVENTS.TRACKS_CHANGED);
var AUDIO_TRACK_CHANGED = withPlayerPrefix(_mediaengine1.EVENTS.AUDIO_TRACK_CHANGED);
var SUBTITLES_TRACK_CHANGED = withPlayerPrefix(_mediaengine1.EVENTS.SUBTITLES_TRACK_CHANGED);
var SUBTITLES_UPDATED = withPlayerPrefix(_mediaengine1.EVENTS.SUBTITLES_UPDATED);
var TOP_BAR_BACK = withPlayerPrefix("TOP_BAR_BACK");
var TOP_BAR_START_OVER = withPlayerPrefix("TOP_BAR_START_OVER");
var TOP_BAR_TRACKS = withPlayerPrefix("TOP_BAR_TRACKS");
var TOP_BAR_RELATED_VIDEOS = withPlayerPrefix("TOP_BAR_RELATED_VIDEOS");
var TOP_BAR_BACK_TO_LIVE = withPlayerPrefix("TOP_BAR_BACK_TO_LIVE");
var TOP_BAR_INFO_PAGE = withPlayerPrefix("TOP_BAR_INFO_PAGE");
var RESET = withPlayerPrefix("RESET");
var RESET_LAST_VIEWED_VIDEO_DATA = withPlayerPrefix("RESET_LAST_VIEWED_VIDEO_DATA");
var AD_PROVIDER_LOADED = withPlayerPrefix("AD_PROVIDER_LOADED");
var AD_MARKERS_LIST = withPlayerPrefix("AD_MARKERS_LIST");
var AD_JINGLE_STARTED = withPlayerPrefix("AD_JINGLE_STARTED");
var AD_JINGLE_COMPLETE = withPlayerPrefix("AD_JINGLE_COMPLETE");
var AD_BREAK_STARTED = withPlayerPrefix("AD_BREAK_STARTED");
var AD_BREAK_TIME_UPDATE = withPlayerPrefix("AD_BREAK_TIME_UPDATE");
var AD_BREAK_ENDED = withPlayerPrefix("AD_BREAK_ENDED");
var AD_STARTED = withPlayerPrefix("AD_STARTED");
var AD_PLAYING = withPlayerPrefix("AD_PLAYING");
var AD_TIME_UPDATE = withPlayerPrefix("AD_TIME_UPDATE");
var AD_PAUSED = withPlayerPrefix("AD_PAUSED");
var AD_ENDED = withPlayerPrefix("AD_ENDED");
var AD_ERROR = withPlayerPrefix("AD_ERROR");
var SET_PAUSE_AD = withPlayerPrefix("SET_PAUSE_AD");
var SET_PAUSE_AD_STATE = withPlayerPrefix("SET_PAUSE_AD_STATE");
var APPEND_NEW_METADATA_ITEMS = withPlayerPrefix("APPEND_NEW_METADATA_ITEMS");
var UPDATE_METADATA = withPlayerPrefix(_mediaengine.VIDEO_EVENTS.LOADED_METADATA);
var SET_AUDIO_TRACK = withPlayerPrefix("SET_AUDIO_TRACK");
var SET_SUBTITLE_TRACK = withPlayerPrefix("SET_SUBTITLE_TRACK");
var TRACK_PREFERENCES_CHANGED = withPlayerPrefix("TRACK_PREFERENCES_CHANGED");
var SET_CURRENT_METADATA_ITEM = withPlayerPrefix("SET_CURRENT_METADATA_ITEM");
var SET_LBANNER_STATE = withPlayerPrefix("SET_LBANNER_STATE");
var SET_PLAYER_ERROR = withPlayerPrefix("SET_PLAYER_ERROR");
var setPlayerInitialized = function(options) {
    return _object_spread_props._(_object_spread._({}, options), {
        type: INITIALIZED
    });
};
var loadStart = function() {
    return {
        type: LOAD_START
    };
};
var lockPlayer = function() {
    return {
        type: LOCKED
    };
};
var playing = function() {
    return {
        type: PLAYING
    };
};
var paused = function() {
    return {
        type: PAUSED
    };
};
var reset = function() {
    return {
        type: RESET
    };
};
var resetLastViewedData = function() {
    return {
        type: RESET_LAST_VIEWED_VIDEO_DATA
    };
};
var adProviderLoaded = function() {
    return {
        type: AD_PROVIDER_LOADED
    };
};
var adMarkers = function(markers) {
    return {
        type: AD_MARKERS_LIST,
        markers: markers
    };
};
var adJingleStarted = function() {
    return {
        type: AD_JINGLE_STARTED
    };
};
var adJingleComplete = function() {
    return {
        type: AD_JINGLE_COMPLETE
    };
};
var adBreakStarted = function(type, totalDuration) {
    return {
        type: AD_BREAK_STARTED,
        adType: type,
        totalDuration: totalDuration
    };
};
var adBreakEnded = function() {
    return {
        type: AD_BREAK_ENDED
    };
};
var adStarted = function(skipOffset) {
    return {
        type: AD_STARTED,
        skipOffset: skipOffset
    };
};
var adPlaying = function() {
    return {
        type: AD_PLAYING
    };
};
var adBreakTimeUpdate = function(timeInSeconds, durationInSeconds) {
    return {
        type: AD_BREAK_TIME_UPDATE,
        currentTime: timeInSeconds,
        totalDuration: durationInSeconds
    };
};
var adTimeUpdate = function(timeInSeconds) {
    return {
        type: AD_TIME_UPDATE,
        currentTime: timeInSeconds
    };
};
var adPaused = function() {
    return {
        type: AD_PAUSED
    };
};
var adEnded = function() {
    return {
        type: AD_ENDED
    };
};
var adError = function(param) {
    var adRequestUrl = param.adRequestUrl, content = param.content, context = param.context, details = param.details, fatal = param.fatal, monitored = param.monitored, reason = param.reason;
    return {
        type: AD_ERROR,
        adRequestUrl: adRequestUrl,
        content: content,
        context: context,
        details: details,
        fatal: fatal,
        monitored: monitored,
        reason: reason
    };
};
var setPauseAd = function(ad) {
    return {
        type: SET_PAUSE_AD,
        ad: ad
    };
};
var pauseAdsError = function() {
    return {
        type: SET_PAUSE_AD_STATE,
        state: PAUSE_AD_STATE.ERROR
    };
};
var pauseAdsDisplaying = function() {
    return {
        type: SET_PAUSE_AD_STATE,
        state: PAUSE_AD_STATE.DISPLAYING
    };
};
var setLBannerShow = function() {
    return {
        type: SET_LBANNER_STATE,
        state: LBANNER_STATE.SHOW
    };
};
var setLBannerHide = function() {
    return {
        type: SET_LBANNER_STATE,
        state: LBANNER_STATE.HIDE
    };
};
var setPlayerError = function(error) {
    return {
        type: SET_PLAYER_ERROR,
        error: error
    };
};


/***/ }),

/***/ 42822:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    default: function() {
        return _default;
    },
    initialState: function() {
        return initialState;
    }
});
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _object_without_properties = __webpack_require__(46537);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _utils = __webpack_require__(64188);
var _liveutils = __webpack_require__(3672);
var _useractions = __webpack_require__(79489);
var _playerconstants = __webpack_require__(7602);
var _playerutils = __webpack_require__(41230);
var _progressutils = __webpack_require__(40779);
var _videoconstants = __webpack_require__(1628);
var initialState = {
    isLive: false,
    isStarted: false,
    canPlay: false,
    isLoadingContent: false,
    isBuffering: false,
    playbackState: _playerconstants.PLAYBACK_STATE_IDLE,
    adPlaybackState: _playerconstants.PLAYBACK_STATE_IDLE,
    videoAds: undefined,
    adBreakDuration: 0,
    adElapsedTime: 0,
    adSkipOffset: undefined,
    adBreakElapsedTime: 0,
    adMarkers: undefined,
    isPlayingAds: false,
    isAdJingleDisplayed: false,
    isAdProviderReady: false,
    isAdError: false,
    isAdBreakDisplayed: false,
    pauseAd: null,
    pauseAdState: _playerconstants.PAUSE_AD_STATE.IDLE,
    displayedAdBreakType: null,
    durationInSeconds: 0,
    startTimeInSeconds: 0,
    elapsedTimeInSeconds: undefined,
    liveEdgeInSeconds: 0,
    timeUpdateTicks: 0,
    isOnLive: false,
    shouldHideVideoLoader: false,
    currentSourceIndex: null,
    sideGlass: null,
    programImageId: "",
    jingleImageId: "",
    sources: [],
    contentType: "",
    preferences: null,
    originalLanguage: "",
    selectedSubtitlesTrack: null,
    selectedAudioTrack: null,
    audioTracks: [],
    subtitleTracks: [],
    subtitleCuePoint: null,
    chapter: null,
    chapters: [],
    isLocked: false,
    shouldLiftParentalLock: false,
    metadataItems: [],
    currentMetadataItemIndex: 0,
    lastMetadataItemIndex: 0,
    isNextLiveLayoutLoading: false,
    timeToLoadNewLayout: 0,
    liveStartOverFeature: false,
    lastViewedClipId: "",
    lastViewedClipProgress: 0,
    lastError: null
};
var _default = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, _param = arguments.length > 1 ? arguments[1] : void 0;
    var type = _param.type, data = _object_without_properties._(_param, [
        "type"
    ]);
    switch(type){
        case _playerconstants.LOCKED:
            {
                return _object_spread_props._(_object_spread._({}, initialState), {
                    isLocked: true
                });
            }
        case _useractions.PARENTAL_LOCK_STATUS:
            {
                var isUnlocked = data.isUnlocked;
                if (!isUnlocked) {
                    return state;
                }
                return _object_spread_props._(_object_spread._({}, state), {
                    shouldLiftParentalLock: true
                });
            }
        case _playerconstants.INITIALIZED:
            {
                var layout = data.layout, isLive = data.isLive, entityId = data.entityId, entityType = data.entityType;
                var items = isLive ? (0, _liveutils.getMetadataItemsFromLayout)(layout) : [
                    data.item
                ];
                var item = isLive && (0, _liveutils.findCurrentLiveItem)(layout, (0, _utils.getCurrentTimeInSeconds)()) || data.item;
                var currentMetadataItemIndex = items.indexOf(item);
                if (currentMetadataItemIndex < 0) {
                    currentMetadataItemIndex = 0;
                }
                var startTimeInSeconds = isLive ? (0, _get.default)(item, "video.progress.live.startTimestamp", 0) : 0;
                var endTimeInSeconds = isLive ? (0, _get.default)(item, "video.progress.live.endTimestamp", 0) : (0, _utils.timeTitleToSeconds)((0, _get.default)(item, "video.progress.endTitle"));
                var durationInSeconds = endTimeInSeconds - startTimeInSeconds;
                var elapsedTimeInSeconds = isLive ? undefined : (0, _get.default)(item, "video.progress.tcResume", 0);
                var sources = (0, _playerutils.arrangeSources)(item).map(function(source) {
                    source.isLive = isLive;
                    source.shouldAutoPlay = isLive || entityType === "radio";
                    source.startTime = endTimeInSeconds - elapsedTimeInSeconds >= 5 ? elapsedTimeInSeconds : undefined;
                    source.type = entityType;
                    return source;
                });
                var videoAdsProvider = (0, _get.default)(item, "advertising.providers.video");
                var videoAds = videoAdsProvider ? (0, _get.default)(item, "advertising.".concat(videoAdsProvider)) : undefined;
                var lastMetadataItemIndex = items.length - 1;
                var timeToLoadNewLayout = (0, _liveutils.getTimeToRequestNewMetadataInSeconds)(durationInSeconds);
                var liveStartOverFeature = isLive ? (0, _get.default)(item, "video.features.startOver", false) : false;
                var originalLanguage = (0, _get.default)(item, "video.originalLanguage") || "";
                var result = _object_spread_props._(_object_spread._({}, initialState), {
                    sources: sources,
                    preferences: (0, _get.default)(item, "video.features.preferences") || {},
                    originalLanguage: originalLanguage,
                    lastMetadataItemIndex: lastMetadataItemIndex,
                    timeToLoadNewLayout: timeToLoadNewLayout,
                    // TODO: find a most appropriate source for current platform(basing on hardware DRM support, for examples)
                    // TODO: repeat it starting from a last-try index in case of error while this functions returns values greater than -1
                    currentSourceIndex: (0, _playerutils.selectNextPlayableSource)({
                        sources: sources
                    }),
                    programImageId: (0, _playerutils.getVideoItemProgramImageId)(item),
                    jingleImageId: (0, _playerutils.getJingleImageId)(item),
                    adJingleImageId: (0, _playerutils.getAdJingleImageId)(item),
                    sideGlass: (0, _playerutils.findSideGlassBlock)(layout),
                    durationInSeconds: durationInSeconds,
                    startTimeInSeconds: startTimeInSeconds,
                    elapsedTimeInSeconds: elapsedTimeInSeconds,
                    chapters: ((0, _get.default)(item, "video.chapters") || []).map(function(param) {
                        var tcEnd = param.tcEnd, tcStart = param.tcStart, type = param.type;
                        return {
                            tcStart: Math.min(tcStart + _videoconstants.CHAPTER_START_OFFSET_IN_SECONDS, tcEnd),
                            tcEnd: tcEnd,
                            type: type
                        };
                    }),
                    metadataItems: state.shouldLiftParentalLock ? (0, _playerutils.removeParentalLock)(items) : items,
                    shouldLiftParentalLock: false,
                    currentMetadataItemIndex: currentMetadataItemIndex,
                    isLive: isLive,
                    liveStartOverFeature: liveStartOverFeature,
                    lastViewedClipId: entityId,
                    contentType: entityType,
                    videoAds: videoAds
                });
                return result;
            }
        case _playerconstants.LOAD_START:
            return _object_spread_props._(_object_spread._({}, state), {
                canPlay: false,
                isLoadingContent: true
            });
        case _playerconstants.MANIFEST_LOADED:
            {
                if (!Number.isFinite(state.elapsedTimeInSeconds) && state.isLive) {
                    return _object_spread_props._(_object_spread._({}, state), {
                        elapsedTimeInSeconds: Math.round(Date.now() / 1000) - state.startTimeInSeconds - (0, _get.default)(data, "payload.presentationDelay", 0)
                    });
                }
                return state;
            }
        case _playerconstants.SET_CURRENT_METADATA_ITEM:
            {
                var item1 = data.item;
                var startTimeInSeconds1 = (0, _get.default)(item1, "video.progress.live.startTimestamp", 0);
                var endTimeInSeconds1 = (0, _get.default)(item1, "video.progress.live.endTimestamp", 0);
                var durationInSeconds1 = endTimeInSeconds1 - startTimeInSeconds1;
                var currentMetadataItemIndex1 = state.metadataItems.indexOf(item1);
                var timeToLoadNewLayout1 = (0, _liveutils.getTimeToRequestNewMetadataInSeconds)(durationInSeconds1);
                return _object_spread_props._(_object_spread._({}, state), {
                    startTimeInSeconds: startTimeInSeconds1,
                    durationInSeconds: durationInSeconds1,
                    currentMetadataItemIndex: currentMetadataItemIndex1,
                    timeToLoadNewLayout: timeToLoadNewLayout1
                });
            }
        case _playerconstants.APPEND_NEW_METADATA_ITEMS:
            {
                return _object_spread_props._(_object_spread._({}, state), {
                    metadataItems: state.metadataItems.concat(state.shouldLiftParentalLock ? (0, _playerutils.removeParentalLock)(data.programs) : data.programs),
                    shouldLiftParentalLock: false
                });
            }
        case _playerconstants.UPDATE_METADATA:
            {
                if (!data.payload) {
                    return state;
                }
                var currentMetadataItemIndex2 = state.currentMetadataItemIndex;
                var currentItem = state.metadataItems[currentMetadataItemIndex2];
                if (!currentItem) {
                    return state;
                }
                var fieldsToUpdate = Object.keys(data.payload).filter(function(key) {
                    return currentItem[key] !== data.payload[key];
                });
                if (!fieldsToUpdate.length) {
                    return state;
                }
                return _object_spread_props._(_object_spread._({}, state), {
                    metadataItems: state.metadataItems.map(function(value, index) {
                        return index === currentMetadataItemIndex2 ? _object_spread._({}, value, data.payload) : value;
                    })
                });
            }
        case _playerconstants.RESET:
            return _object_spread_props._(_object_spread._({}, initialState), {
                lastViewedClipId: state.lastViewedClipId,
                lastViewedClipProgress: state.elapsedTimeInSeconds > _playerconstants.MIN_SECONDS_TO_TRACK_PROGRESS ? (0, _progressutils.getPercentage)(state.elapsedTimeInSeconds, state.durationInSeconds) : 0
            });
        case _playerconstants.RESET_LAST_VIEWED_VIDEO_DATA:
            return _object_spread_props._(_object_spread._({}, state), {
                lastViewedClipId: "",
                lastViewedClipProgress: 0
            });
        case _playerconstants.CAN_PLAY:
            {
                var duration = (0, _get.default)(data, "payload.duration");
                return _object_spread_props._(_object_spread._({}, state), {
                    canPlay: true,
                    durationInSeconds: Number.isFinite(duration) ? Math.round(duration) : state.durationInSeconds,
                    isLoadingContent: false
                });
            }
        case _playerconstants.CAN_PLAY_THROUGH:
            {
                var duration1 = (0, _get.default)(data, "payload.duration");
                return _object_spread_props._(_object_spread._({}, state), {
                    durationInSeconds: Number.isFinite(duration1) ? Math.round(duration1) : state.durationInSeconds
                });
            }
        case _playerconstants.PLAYING:
            return _object_spread_props._(_object_spread._({}, state), {
                timeUpdateTicks: 0,
                isBuffering: false,
                playbackState: _playerconstants.PLAYBACK_STATE_PLAYING
            });
        case _playerconstants.PAUSED:
            return _object_spread_props._(_object_spread._({}, state), {
                playbackState: _playerconstants.PLAYBACK_STATE_PAUSED
            });
        case _playerconstants.WAITING:
            return _object_spread_props._(_object_spread._({}, state), {
                isBuffering: data.payload.isBuffering
            });
        case _playerconstants.TIME_UPDATE:
            {
                var _data_payload = data.payload, currentTime = _data_payload.currentTime, liveEdge = _data_payload.liveEdge;
                var elapsedFromStart = Math.round(currentTime) - state.startTimeInSeconds;
                var elapsedTimeInSeconds1 = !state.isLive && elapsedFromStart > state.durationInSeconds ? state.elapsedTimeInSeconds : elapsedFromStart;
                var liveEdgeInSeconds = Number.isFinite(liveEdge) ? Math.round(liveEdge) - state.startTimeInSeconds : 0;
                var timeUpdateTicks = state.timeUpdateTicks + (state.playbackState === _playerconstants.PLAYBACK_STATE_PLAYING ? 1 : 0);
                var shouldHideVideoLoader = state.shouldHideVideoLoader || timeUpdateTicks >= 2;
                var chapter = state.isLive ? null : state.chapters.find(function(param) {
                    var tcStart = param.tcStart, tcEnd = param.tcEnd;
                    return elapsedTimeInSeconds1 >= tcStart && elapsedTimeInSeconds1 <= tcEnd;
                });
                return _object_spread_props._(_object_spread._({}, state), {
                    isStarted: true,
                    chapter: chapter,
                    timeUpdateTicks: timeUpdateTicks,
                    shouldHideVideoLoader: shouldHideVideoLoader,
                    elapsedTimeInSeconds: elapsedTimeInSeconds1,
                    liveEdgeInSeconds: liveEdgeInSeconds,
                    isOnLive: Math.abs(liveEdgeInSeconds - elapsedTimeInSeconds1) < 5
                });
            }
        case _playerconstants.TRACKS_CHANGED:
            {
                if (!data.payload) {
                    return state;
                }
                var selectedAudioTrack = state.selectedAudioTrack, selectedSubtitlesTrack = state.selectedSubtitlesTrack, originalLanguage1 = state.originalLanguage;
                var subtitleTracks = (data.payload.subtitleTracks || []).map(_playerutils.parseTrack);
                var audioTracks = (data.payload.audioTracks || []).map(_playerutils.parseTrack);
                var preferences = state.preferences || {};
                var audioTrack = selectedAudioTrack && audioTracks.find(function(param) {
                    var id = param.id;
                    return id === selectedAudioTrack;
                }) || (0, _playerutils.findMatchingAudioTrack)(audioTracks, preferences.audioTrack, originalLanguage1);
                var subtitlesTrack = selectedSubtitlesTrack && subtitleTracks.find(function(param) {
                    var id = param.id;
                    return id === selectedSubtitlesTrack;
                }) || (0, _playerutils.findMatchingSubtitlesTrack)(subtitleTracks, preferences.textTrack) || (audioTrack ? (0, _playerutils.findForcedSubtitles)(subtitleTracks, audioTrack.language) : null);
                return _object_spread_props._(_object_spread._({}, state), {
                    subtitleTracks: subtitleTracks,
                    audioTracks: audioTracks,
                    selectedSubtitlesTrack: subtitlesTrack ? subtitlesTrack.id : null,
                    selectedAudioTrack: audioTrack ? audioTrack.id : null
                });
            }
        case _playerconstants.SET_AUDIO_TRACK:
            {
                return _object_spread_props._(_object_spread._({}, state), {
                    selectedAudioTrack: data.track ? data.track.id : null
                });
            }
        case _playerconstants.SET_SUBTITLE_TRACK:
            {
                return _object_spread_props._(_object_spread._({}, state), {
                    selectedSubtitlesTrack: data.track ? data.track.id : null
                });
            }
        case _playerconstants.TRACK_PREFERENCES_CHANGED:
            {
                var audioTrack1 = data.audioTrack, subtitlesTrack1 = data.subtitlesTrack;
                var preferences1 = state.preferences || {};
                var currentTextTrack = preferences1.textTrack, currentAudioTrack = preferences1.audioTrack;
                var preferredAudioTrack = currentAudioTrack;
                if (audioTrack1) {
                    preferredAudioTrack = (0, _playerutils.audioTrackToPreference)(audioTrack1);
                }
                var preferredTextTrack = currentTextTrack;
                if (subtitlesTrack1 === null) {
                    preferredTextTrack = null;
                } else if (subtitlesTrack1) {
                    preferredTextTrack = (0, _playerutils.subtitlesTrackToPreference)(subtitlesTrack1);
                }
                return _object_spread_props._(_object_spread._({}, state), {
                    preferences: _object_spread_props._(_object_spread._({}, preferences1), {
                        audioTrack: preferredAudioTrack,
                        textTrack: preferredTextTrack
                    })
                });
            }
        case _playerconstants.SUBTITLES_UPDATED:
            {
                return _object_spread_props._(_object_spread._({}, state), {
                    subtitleCuePoint: data.payload
                });
            }
        case _playerconstants.ENDED:
            {
                return _object_spread_props._(_object_spread._({}, state), {
                    isBuffering: false,
                    playbackState: _playerconstants.PLAYBACK_STATE_ENDED
                });
            }
        case _playerconstants.AD_JINGLE_STARTED:
            {
                return _object_spread_props._(_object_spread._({}, state), {
                    // The ad-engine sends "ad break start" event only when a jingle is complete,
                    // however we need to switch the player into "displaying ads" mode once it shouldn't display a main content
                    isAdBreakDisplayed: true,
                    isPlayingAds: true,
                    isAdJingleDisplayed: Boolean(state.adJingleImageId),
                    selectedSubtitlesTrack: null,
                    selectedAudioTrack: null
                });
            }
        case _playerconstants.AD_PROVIDER_LOADED:
            {
                return _object_spread_props._(_object_spread._({}, state), {
                    isAdProviderReady: true
                });
            }
        case _playerconstants.AD_MARKERS_LIST:
            {
                if (state.isLive) {
                    return state;
                }
                return _object_spread_props._(_object_spread._({}, state), {
                    adMarkers: (data.markers || []).filter(Boolean)
                });
            }
        case _playerconstants.AD_ERROR:
            {
                return _object_spread_props._(_object_spread._({}, state), {
                    isAdError: true
                });
            }
        case _playerconstants.AD_BREAK_STARTED:
            {
                var adType = data.adType, totalDuration = data.totalDuration;
                return _object_spread_props._(_object_spread._({}, state), {
                    // In case if ad engine failed to fire the jingle event
                    isPlayingAds: true,
                    isAdBreakDisplayed: true,
                    shouldHideVideoLoader: false,
                    timeUpdateTicks: 0,
                    adBreakElapsedTime: 0,
                    adBreakDuration: totalDuration,
                    displayedAdBreakType: adType,
                    selectedSubtitlesTrack: null,
                    selectedAudioTrack: null
                });
            }
        case _playerconstants.AD_BREAK_ENDED:
            {
                return _object_spread_props._(_object_spread._({}, state), {
                    isAdBreakDisplayed: false,
                    isPlayingAds: false,
                    displayedAdBreakType: null
                });
            }
        case _playerconstants.AD_STARTED:
            {
                return _object_spread_props._(_object_spread._({}, state), {
                    adSkipOffset: data.skipOffset
                });
            }
        case _playerconstants.AD_PLAYING:
            {
                return _object_spread_props._(_object_spread._({}, state), {
                    adPlaybackState: _playerconstants.PLAYBACK_STATE_PLAYING,
                    isAdError: false,
                    // NOTE: it allows a smooth transition from Ad Jingle to Ad without blinking of content before ad is loaded
                    isAdJingleDisplayed: false
                });
            }
        case _playerconstants.AD_TIME_UPDATE:
            {
                return _object_spread_props._(_object_spread._({}, state), {
                    adElapsedTime: data.currentTime
                });
            }
        case _playerconstants.AD_BREAK_TIME_UPDATE:
            {
                return _object_spread_props._(_object_spread._({}, state), {
                    adBreakElapsedTime: data.currentTime,
                    adBreakDuration: Number.isFinite(data.totalDuration) ? data.totalDuration : state.adBreakDuration
                });
            }
        case _playerconstants.AD_PAUSED:
            {
                return _object_spread_props._(_object_spread._({}, state), {
                    adPlaybackState: _playerconstants.PLAYBACK_STATE_PAUSED
                });
            }
        case _playerconstants.AD_ENDED:
            {
                return _object_spread_props._(_object_spread._({}, state), {
                    adPlaybackState: _playerconstants.PLAYBACK_STATE_ENDED
                });
            }
        case _playerconstants.SET_PAUSE_AD:
            {
                var pauseAd = data.ad;
                return _object_spread_props._(_object_spread._({}, state), {
                    pauseAd: pauseAd,
                    pauseAdState: _playerconstants.PAUSE_AD_STATE.LOADING
                });
            }
        case _playerconstants.SET_PAUSE_AD_STATE:
            {
                return _object_spread_props._(_object_spread._({}, state), {
                    pauseAdState: data.state
                });
            }
        case _playerconstants.SET_LBANNER_STATE:
            {
                return _object_spread_props._(_object_spread._({}, state), {
                    lBannerState: data.state
                });
            }
        case _playerconstants.SET_PLAYER_ERROR:
            {
                return _object_spread_props._(_object_spread._({}, state), {
                    lastError: data.error
                });
            }
        default:
            return state;
    }
};


/***/ }),

/***/ 83318:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    getAdBreakDuration: function() {
        return getAdBreakDuration;
    },
    getAdBreakElapsedTime: function() {
        return getAdBreakElapsedTime;
    },
    getAdElapsedTime: function() {
        return getAdElapsedTime;
    },
    getAdJingleDurationInMilliseconds: function() {
        return getAdJingleDurationInMilliseconds;
    },
    getAdJingleImageId: function() {
        return getAdJingleImageId;
    },
    getAdMarkers: function() {
        return getAdMarkers;
    },
    getAdPlaybackState: function() {
        return getAdPlaybackState;
    },
    getAdSkipOffset: function() {
        return getAdSkipOffset;
    },
    getAdsProvider: function() {
        return getAdsProvider;
    },
    getAdvertising: function() {
        return getAdvertising;
    },
    getAnalyticsById: function() {
        return getAnalyticsById;
    },
    getAudioTracks: function() {
        return getAudioTracks;
    },
    getCSAPicto: function() {
        return getCSAPicto;
    },
    getCanPlay: function() {
        return getCanPlay;
    },
    getClipId: function() {
        return getClipId;
    },
    getContentAdvisory: function() {
        return getContentAdvisory;
    },
    getContentType: function() {
        return getContentType;
    },
    getCurrentAssetType: function() {
        return getCurrentAssetType;
    },
    getCurrentMetadataItem: function() {
        return getCurrentMetadataItem;
    },
    getCurrentPauseAd: function() {
        return getCurrentPauseAd;
    },
    getDisplayedAdBreakType: function() {
        return getDisplayedAdBreakType;
    },
    getDurationInSeconds: function() {
        return getDurationInSeconds;
    },
    getElapsedTimeInSeconds: function() {
        return getElapsedTimeInSeconds;
    },
    getExtraTitle: function() {
        return getExtraTitle;
    },
    getHasAgeGate: function() {
        return getHasAgeGate;
    },
    getIsAdError: function() {
        return getIsAdError;
    },
    getIsAdProviderReady: function() {
        return getIsAdProviderReady;
    },
    getIsBuffering: function() {
        return getIsBuffering;
    },
    getIsEnded: function() {
        return getIsEnded;
    },
    getIsLive: function() {
        return getIsLive;
    },
    getIsLoadingContent: function() {
        return getIsLoadingContent;
    },
    getIsSeeking: function() {
        return getIsSeeking;
    },
    getIsStarted: function() {
        return getIsStarted;
    },
    getJingleImageId: function() {
        return getJingleImageId;
    },
    getLBannerProvider: function() {
        return getLBannerProvider;
    },
    getLBannerState: function() {
        return getLBannerState;
    },
    getLastPlaybackError: function() {
        return getLastPlaybackError;
    },
    getLastViewedClipId: function() {
        return getLastViewedClipId;
    },
    getLastViewedClipProgress: function() {
        return getLastViewedClipProgress;
    },
    getMetadataItems: function() {
        return getMetadataItems;
    },
    getPauseAdRequestData: function() {
        return getPauseAdRequestData;
    },
    getPauseAdState: function() {
        return getPauseAdState;
    },
    getPlaybackState: function() {
        return getPlaybackState;
    },
    getPlayerLocked: function() {
        return getPlayerLocked;
    },
    getProgramImageId: function() {
        return getProgramImageId;
    },
    getSelectedAudioTrack: function() {
        return getSelectedAudioTrack;
    },
    getSelectedSubtitlesTrack: function() {
        return getSelectedSubtitlesTrack;
    },
    getSideGlassContent: function() {
        return getSideGlassContent;
    },
    getStartTimeInSeconds: function() {
        return getStartTimeInSeconds;
    },
    getSubtitleCuePoint: function() {
        return getSubtitleCuePoint;
    },
    getSubtitleTracks: function() {
        return getSubtitleTracks;
    },
    getTitle: function() {
        return getTitle;
    },
    getVideoAds: function() {
        return getVideoAds;
    },
    getVideoId: function() {
        return getVideoId;
    },
    getVideoSource: function() {
        return getVideoSource;
    },
    isAdBreakDisplayed: function() {
        return isAdBreakDisplayed;
    },
    isAdJingleDisplayed: function() {
        return isAdJingleDisplayed;
    },
    isJingleEnabled: function() {
        return isJingleEnabled;
    },
    isLiveSeekEnabled: function() {
        return isLiveSeekEnabled;
    },
    isLiveStartOverEnabled: function() {
        return isLiveStartOverEnabled;
    },
    isPlayingAds: function() {
        return isPlayingAds;
    },
    shouldHideVideoLoader: function() {
        return shouldHideVideoLoader;
    },
    shouldLoadNewMetadataItems: function() {
        return shouldLoadNewMetadataItems;
    },
    shouldSwitchToNextProgram: function() {
        return shouldSwitchToNextProgram;
    }
});
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(42578);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _playerconstants = __webpack_require__(7602);
var _featuresselectors = __webpack_require__(76109);
var DEFAULT_OBJECT = {};
var getIsAdProviderReady = function(param) {
    var player = param.player;
    return player.isAdProviderReady;
};
var getIsAdError = function(param) {
    var player = param.player;
    return player.isAdError;
};
var getCanPlay = function(param) {
    var player = param.player;
    return player.canPlay;
};
var getIsLoadingContent = function(param) {
    var player = param.player;
    return player.isLoadingContent;
};
var getPlaybackState = function(param) {
    var player = param.player;
    return player.playbackState;
};
var getAdPlaybackState = function(param) {
    var player = param.player;
    return player.adPlaybackState;
};
var getIsStarted = function(param) {
    var player = param.player;
    return player.isStarted;
};
var getIsEnded = function(param) {
    var player = param.player;
    return player.playbackState === _playerconstants.PLAYBACK_STATE_ENDED;
};
var getIsBuffering = function(param) {
    var player = param.player;
    return player.isBuffering;
};
var getIsSeeking = function(param) {
    var player = param.player;
    return player.isSeeking;
};
var getAudioTracks = function(param) {
    var player = param.player;
    return player.audioTracks;
};
var getSubtitleTracks = function(param) {
    var player = param.player;
    return player.subtitleTracks;
};
var getSelectedAudioTrack = function(param) {
    var player = param.player;
    return player.selectedAudioTrack;
};
var getSelectedSubtitlesTrack = function(param) {
    var player = param.player;
    return player.selectedSubtitlesTrack;
};
var getSubtitleCuePoint = function(param) {
    var player = param.player;
    return player.subtitleCuePoint;
};
var shouldHideVideoLoader = function(param) {
    var player = param.player;
    return player.shouldHideVideoLoader;
};
var getLastPlaybackError = function(param) {
    var player = param.player;
    return player.lastError;
};
var getContentType = function(param) {
    var player = param.player;
    return player.contentType;
};
var getCurrentMetadataItem = function(state) {
    return (0, _get.default)(state, "player.metadataItems", [])[(0, _get.default)(state, "player.currentMetadataItemIndex")];
};
var getMetadataItems = function(state) {
    return state.player.metadataItems;
};
var getTitle = function(state) {
    return (0, _get.default)(getCurrentMetadataItem(state), "title", "");
};
var getExtraTitle = function(state) {
    return (0, _get.default)(getCurrentMetadataItem(state), "extraTitle", "");
};
var getCSAPicto = function(state) {
    return (0, _get.default)(getCurrentMetadataItem(state), "csaPicto");
};
var getHasAgeGate = function(state) {
    return (0, _get.default)(getCSAPicto(state), "name") === "Csa18";
};
var getDurationInSeconds = function(state) {
    return (0, _get.default)(state, "player.durationInSeconds", 0);
};
var getElapsedTimeInSeconds = function(state) {
    return (0, _get.default)(state, "player.elapsedTimeInSeconds");
};
var getStartTimeInSeconds = function(state) {
    return (0, _get.default)(state, "player.startTimeInSeconds", 0);
};
var getLastViewedClipId = function(state) {
    return (0, _get.default)(state, "player.lastViewedClipId", "");
};
var getLastViewedClipProgress = function(state) {
    return (0, _get.default)(state, "player.lastViewedClipProgress", 0);
};
var isJingleEnabled = function(state) {
    return (0, _featuresselectors.getPlayerJingleFeature)(state) !== false;
};
var getJingleImageId = function(state) {
    return isJingleEnabled(state) ? (0, _get.default)(state, "player.jingleImageId", "") : "";
};
var getProgramImageId = function(state) {
    return isJingleEnabled(state) ? (0, _get.default)(state, "player.programImageId", "") : "";
};
var getPlayerLocked = function(state) {
    return (0, _get.default)(state, "player.isLocked");
};
var getSideGlassContent = function(state) {
    return (0, _get.default)(state, "player.sideGlass");
};
var getContentAdvisory = function(state) {
    return (0, _get.default)(getCurrentMetadataItem(state), "contentAdvisory", DEFAULT_OBJECT);
};
var getAnalyticsById = function(analyticsId) {
    return function(state) {
        return (0, _get.default)(getCurrentMetadataItem(state), "analytics.".concat(analyticsId), DEFAULT_OBJECT);
    };
};
var getAdvertising = function(state) {
    return (0, _get.default)(getCurrentMetadataItem(state), "advertising", DEFAULT_OBJECT);
};
var getVideoAds = function(state) {
    return state.player.videoAds;
};
var getAdsProvider = function(state) {
    var ads = getAdvertising(state);
    return ads.providers ? ads.providers.video : "";
};
var getPauseAdRequestData = function(state) {
    var isFeatureEnabled = (0, _featuresselectors.getPlayerPauseAdFeature)(state);
    if (!isFeatureEnabled) {
        return false;
    }
    var advertising = (0, _get.default)(getCurrentMetadataItem(state), "advertising");
    if (!advertising) {
        return undefined;
    }
    var provider = (0, _get.default)(advertising, "providers.pause");
    if (!provider) {
        return undefined;
    }
    return advertising[provider];
};
var getPauseAdState = function(state) {
    return state.player.pauseAdState;
};
var getLBannerState = function(state) {
    return state.player.lBannerState && (0, _featuresselectors.getPlayerLBannerFeature)(state);
};
var getCurrentPauseAd = function(state) {
    return state.player.pauseAd;
};
var isAdBreakDisplayed = function(state) {
    return (0, _get.default)(state, "player.isAdBreakDisplayed");
};
var getDisplayedAdBreakType = function(state) {
    return (0, _get.default)(state, "player.displayedAdBreakType");
};
var getAdBreakDuration = function(state) {
    return state.player.adBreakDuration;
};
var getAdElapsedTime = function(state) {
    return state.player.adElapsedTime;
};
var getAdSkipOffset = function(state) {
    return state.player.adSkipOffset;
};
var getAdBreakElapsedTime = function(state) {
    return state.player.adBreakElapsedTime;
};
var getAdJingleDurationInMilliseconds = function(state) {
    return (0, _get.default)(state, "app.ads.adJingleDurationInMilliseconds", _playerconstants.AD_JINGLE_DURATION);
};
var getAdJingleImageId = function(state) {
    return (0, _get.default)(state, "player.adJingleImageId", "");
};
var isPlayingAds = function(state) {
    return (0, _get.default)(state, "player.isPlayingAds");
};
var isAdJingleDisplayed = function(state) {
    return (0, _get.default)(state, "player.isAdJingleDisplayed");
};
var getAdMarkers = function(state) {
    return state.player.adMarkers;
};
var getVideoId = function(state) {
    return (0, _get.default)(getCurrentMetadataItem(state), "video.id", "");
};
var getClipId = function(state) {
    return getVideoId(state).replace("clip_", "");
};
var getVideoSource = function(state) {
    var sourceIndex = (0, _get.default)(state, "player.currentSourceIndex", 0);
    return (0, _get.default)(state, "player.sources[".concat(sourceIndex, "]"));
};
var getCurrentAssetType = function(state) {
    var source = getVideoSource(state);
    if (!source) {
        return "";
    }
    var provider = source.provider, format = source.format, container = source.container;
    return [
        provider,
        format,
        container
    ].join("_");
};
var getIsLive = function(state) {
    return (0, _get.default)(state, "player.isLive", false);
};
var shouldSwitchToNextProgram = function(state) {
    return getElapsedTimeInSeconds(state) >= getDurationInSeconds(state);
};
var shouldLoadNewMetadataItems = function(state) {
    var _state_player = state.player, currentMetadataItemIndex = _state_player.currentMetadataItemIndex, elapsedTimeInSeconds = _state_player.elapsedTimeInSeconds, lastMetadataItemIndex = _state_player.lastMetadataItemIndex, timeToLoadNewLayout = _state_player.timeToLoadNewLayout, isNextLiveLayoutLoading = _state_player.isNextLiveLayoutLoading;
    return Boolean(!isNextLiveLayoutLoading && Number.isFinite(timeToLoadNewLayout) && currentMetadataItemIndex === lastMetadataItemIndex && elapsedTimeInSeconds >= timeToLoadNewLayout);
};
var isLiveStartOverEnabled = function(state) {
    return Boolean(state.player.liveStartOverFeature);
};
var isLiveSeekEnabled = function(state) {
    return Boolean(isLiveStartOverEnabled(state) && (0, _featuresselectors.getLiveSeekFeature)(state));
};
var getLBannerProvider = function(state) {
    var ads = getAdvertising(state);
    return ads.providers ? ads.providers.nonlinear : "";
};


/***/ }),

/***/ 41230:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    audioPreferenceToManifestTrack: function() {
        return audioPreferenceToManifestTrack;
    },
    audioTrackToPreference: function() {
        return audioTrackToPreference;
    },
    findCurrentVideoItem: function() {
        return findCurrentVideoItem;
    },
    findForcedSubtitles: function() {
        return findForcedSubtitles;
    },
    findMatchingAudioTrack: function() {
        return findMatchingAudioTrack;
    },
    findMatchingSubtitlesTrack: function() {
        return findMatchingSubtitlesTrack;
    },
    findPlayerBlock: function() {
        return findPlayerBlock;
    },
    findPreferredAudioTrack: function() {
        return findPreferredAudioTrack;
    },
    findSideGlassBlock: function() {
        return findSideGlassBlock;
    },
    getAdJingleImageId: function() {
        return getAdJingleImageId;
    },
    getJingleImageId: function() {
        return getJingleImageId;
    },
    getVideoItemImageIdByRole: function() {
        return getVideoItemImageIdByRole;
    },
    getVideoItemProgramImageId: function() {
        return getVideoItemProgramImageId;
    },
    isForcedSubtitlesTrack: function() {
        return isForcedSubtitlesTrack;
    },
    isPlayerLayout: function() {
        return isPlayerLayout;
    },
    layoutAudioTrackToUsersPreference: function() {
        return layoutAudioTrackToUsersPreference;
    },
    layoutTextTrackToUsersPreference: function() {
        return layoutTextTrackToUsersPreference;
    },
    parseTrack: function() {
        return parseTrack;
    },
    removeParentalLock: function() {
        return removeParentalLock;
    },
    selectNextPlayableSource: function() {
        return selectNextPlayableSource;
    },
    subtitlesTrackToPreference: function() {
        return subtitlesTrackToPreference;
    },
    textPreferenceToManifestTrack: function() {
        return textPreferenceToManifestTrack;
    },
    toISO693LanguageCode: function() {
        return toISO693LanguageCode;
    }
});
var _export_star = __webpack_require__(37668);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(37815);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _fidosdk = __webpack_require__(19804);
var _ISO6931to3constants = __webpack_require__(3178);
var _lockutils = __webpack_require__(78414);
_export_star._(__webpack_require__(26281), exports);
var selectNextPlayableSource = function(param) {
    var sources = param.sources, _param_hasHardwareDRMSupport = param.hasHardwareDRMSupport, hasHardwareDRMSupport = _param_hasHardwareDRMSupport === void 0 ? false : _param_hasHardwareDRMSupport, _param_startIndex = param.startIndex, startIndex = _param_startIndex === void 0 ? 0 : _param_startIndex;
    return (sources || []).slice(startIndex).findIndex(function(source) {
        if (!source) {
            return false;
        }
        var format = source.format, container = source.container;
        if (format === "dash" || format === "mp3" || format === "hls" && container === "aac") {
            return true;
        }
        if (format === "dashcenc") {
            var drmType = (0, _get.default)(source, "drm.type", "").toLowerCase();
            var supportedDrmType = hasHardwareDRMSupport ? "hardware" : "software";
            return drmType === supportedDrmType;
        }
        return false;
    });
};
var findPlayerBlock = function(blocks) {
    if (!blocks) {
        return null;
    }
    return blocks.find(function(param) {
        var templateId = param.templateId;
        return templateId === "Player";
    });
};
var findCurrentVideoItem = function(layout, entityId) {
    var blocks = (0, _get.default)(layout, "blocks", []);
    var block = findPlayerBlock(blocks);
    return (0, _get.default)(block, "content.items", []).find(function(item) {
        return (0, _get.default)(item, "video.id", "") === entityId;
    });
};
var findSideGlassBlock = function(layout) {
    var blocks = layout && layout.blocks || [];
    var result = blocks.find(function(block) {
        if (!block) {
            return false;
        }
        return block.blockTemplateId === "SideGlass";
    });
    if (!result && blocks.length > 1) {
        return blocks[1];
    }
    return result;
};
var getVideoItemImageIdByRole = function(videoItem, role) {
    return (0, _get.default)(videoItem, "video.images.".concat(role, ".id"), "");
};
var getJingleImageId = function(videoItem) {
    return getVideoItemImageIdByRole(videoItem, "jingle");
};
var getAdJingleImageId = function(videoItem) {
    return getVideoItemImageIdByRole(videoItem, "ad_jingle");
};
var getVideoItemProgramImageId = function(videoItem) {
    return (0, _get.default)(videoItem, "image.id", "");
};
var isPlayerLayout = function(layout) {
    var type = (layout ? layout.entity : {}).type;
    return type === _fidosdk.LAYOUT_ENTITIES.video || type === _fidosdk.LAYOUT_ENTITIES.live || type === _fidosdk.LAYOUT_ENTITIES.audio || type === _fidosdk.LAYOUT_ENTITIES.radio;
};
var toISO693LanguageCode = function(code) {
    if (!code) {
        return "";
    }
    if (code.length === 3) {
        return code;
    }
    return _ISO6931to3constants.ISO693_TO_3[code] || "";
};
var parseTrack = function(track) {
    return track ? _object_spread_props._(_object_spread._({}, track), {
        language: toISO693LanguageCode(track.language)
    }) : null;
};
var isForcedSubtitlesTrack = function(track) {
    return Array.isArray(track.roles) ? track.roles.includes("forced_subtitle") : false;
};
var findForcedSubtitles = function(tracks, language) {
    return tracks.filter(isForcedSubtitlesTrack).find(function(track) {
        return track.language === language;
    });
};
var findPreferredAudioTrack = function(tracks, preference) {
    return preference.audioDescription ? tracks.find(function(param) {
        var language = param.language, roles = param.roles;
        return Array.isArray(roles) && roles.includes("alternate") && language === preference.language;
    }) : tracks.find(function(param) {
        var language = param.language;
        return language === preference.language;
    });
};
var findMatchingAudioTrack = function(tracks, preference, originalLanguage) {
    if (!tracks) {
        return null;
    }
    return preference && findPreferredAudioTrack(tracks, preference) || tracks.find(function(param) {
        var language = param.language;
        return language === originalLanguage;
    }) || tracks[0];
};
var findMatchingSubtitlesTrack = function(tracks, preference) {
    if (!tracks || !preference) {
        return null;
    }
    return preference.role ? tracks.find(function(param) {
        var language = param.language, roles = param.roles;
        if (language !== preference.language || !Array.isArray(roles)) {
            return false;
        }
        switch(preference.role){
            case "sdh":
                return roles.includes("caption");
            case "standard":
                // NOTE: subtitle role should be an exact match
                return roles.length === 1 && roles.includes("subtitle");
            default:
                return false;
        }
    }) : tracks.find(function(param) {
        var language = param.language;
        return language === preference.language;
    });
};
var layoutAudioTrackToUsersPreference = function(track) {
    return {
        audioLanguage: _ISO6931to3constants.ISO693_TO_3[track.language] || track.language,
        audioDescription: track.audioDescription || false
    };
};
var layoutTextTrackToUsersPreference = function(track) {
    return {
        subtitleLanguage: _ISO6931to3constants.ISO693_TO_3[track.language] || track.language,
        role: track.role || "standard"
    };
};
var audioTrackToPreference = function(track) {
    return {
        language: _ISO6931to3constants.ISO693_TO_3[track.language] || track.language,
        audioDescription: track.roles ? track.roles.includes("alternate") : false
    };
};
var subtitlesTrackToPreference = function(track) {
    return {
        language: _ISO6931to3constants.ISO693_TO_3[track.language] || track.language,
        // See https://bedrock.tpondemand.com/entity/195625-brrdk22-track-preferences-cross-devices-info/comments/249273
        role: track.roles && track.roles.includes("caption") ? "sdh" : "standard"
    };
};
var audioPreferenceToManifestTrack = function(preference) {
    return preference ? {
        language: preference.language,
        role: preference.audioDescription ? "alternate" : "main"
    } : undefined;
};
var textPreferenceToManifestTrack = function(preference) {
    return preference ? {
        language: preference.language,
        role: preference.role === "sdh" ? "caption" : "main"
    } : undefined;
};
var removeParentalLock = function(items) {
    return items.map(function(item) {
        var wrapper = {
            item: item
        };
        var originalTarget = (0, _lockutils.getReason)(wrapper) === "parentalCode" && (0, _lockutils.getOriginalTarget)(wrapper);
        if (!originalTarget) {
            return item;
        }
        return _object_spread_props._(_object_spread._({}, item), {
            action: _object_spread_props._(_object_spread._({}, item.action), {
                target: originalTarget
            })
        });
    });
};


/***/ }),

/***/ 1628:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ADVISORY_DISPLAY_DURATION_IN_SECONDS: function() {
        return ADVISORY_DISPLAY_DURATION_IN_SECONDS;
    },
    CHAPTER_START_OFFSET_IN_SECONDS: function() {
        return CHAPTER_START_OFFSET_IN_SECONDS;
    },
    ENDING_CREDITS_CHAPTER_TYPE: function() {
        return ENDING_CREDITS_CHAPTER_TYPE;
    },
    END_CHAPTERS_TYPES: function() {
        return END_CHAPTERS_TYPES;
    },
    INTRO_CHAPTER_TYPE: function() {
        return INTRO_CHAPTER_TYPE;
    },
    OPENING_CREDITS_CHAPTER_TYPE: function() {
        return OPENING_CREDITS_CHAPTER_TYPE;
    },
    START_CHAPTERS_TYPES: function() {
        return START_CHAPTERS_TYPES;
    }
});
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(3009);
var ADVISORY_DISPLAY_DURATION_IN_SECONDS = 5;
var CHAPTER_START_OFFSET_IN_SECONDS = 5.2;
var OPENING_CREDITS_CHAPTER_TYPE = "opening_credits";
var INTRO_CHAPTER_TYPE = "intro";
var ENDING_CREDITS_CHAPTER_TYPE = "ending_credits";
var START_CHAPTERS_TYPES = [
    OPENING_CREDITS_CHAPTER_TYPE,
    INTRO_CHAPTER_TYPE
];
var END_CHAPTERS_TYPES = [
    ENDING_CREDITS_CHAPTER_TYPE
];


/***/ }),

/***/ 23035:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    getCurrentChapter: function() {
        return getCurrentChapter;
    },
    getCurrentVideoItem: function() {
        return getCurrentVideoItem;
    },
    getNextVideoItem: function() {
        return getNextVideoItem;
    },
    hasNextVideo: function() {
        return hasNextVideo;
    },
    isVideoEnding: function() {
        return isVideoEnding;
    },
    shouldDisplayNextVideo: function() {
        return shouldDisplayNextVideo;
    }
});
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(42578);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _playerselectors = __webpack_require__(83318);
var _layoutselectors = __webpack_require__(53368);
var _videoconstants = __webpack_require__(1628);
var getNextVideoItem = function(state) {
    var section = (0, _layoutselectors.getCurrentSectionCode)(state);
    var layout = (0, _get.default)(state, "layout.".concat(section, ".video.").concat((0, _playerselectors.getVideoId)(state)));
    return (0, _get.default)(layout, "blocks[0].content.items", []).find(function(item) {
        return item.itemType === "classic";
    });
};
var getCurrentVideoItem = function(state) {
    return (0, _playerselectors.getCurrentMetadataItem)(state);
};
var hasNextVideo = function(state) {
    return Boolean(getNextVideoItem(state));
};
var shouldDisplayNextVideo = function(state) {
    return (0, _playerselectors.getIsEnded)(state) && hasNextVideo(state);
};
var getCurrentChapter = function(state) {
    return state.player.isPlayingAds ? null : state.player.chapter;
};
var isVideoEnding = function(state) {
    var timeLeft = (0, _playerselectors.getDurationInSeconds)(state) - (0, _playerselectors.getElapsedTimeInSeconds)(state);
    return timeLeft >= 0 && timeLeft <= _videoconstants.ADVISORY_DISPLAY_DURATION_IN_SECONDS;
};


/***/ }),

/***/ 47531:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "showPopupAction", ({
    enumerable: true,
    get: function() {
        return showPopupAction;
    }
}));
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(52318);
var _popupconstants = __webpack_require__(57084);
var showPopupAction = function(popupId) {
    var popupOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return function(dispatch) {
        dispatch({
            type: _popupconstants.POPUP_ID,
            popupId: popupId,
            popupOptions: popupOptions
        });
    };
};


/***/ }),

/***/ 57084:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "POPUP_ID", ({
    enumerable: true,
    get: function() {
        return POPUP_ID;
    }
}));
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(37815);
var POPUP_ID = "popup/POPUP_ID";


/***/ }),

/***/ 44269:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    default: function() {
        return _default;
    },
    initialState: function() {
        return initialState;
    }
});
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(37815);
var _popupconstants = __webpack_require__(57084);
var initialState = {
    popupData: null
};
var _default = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case _popupconstants.POPUP_ID:
            {
                return _object_spread_props._(_object_spread._({}, state), {
                    popupData: {
                        id: action.popupId,
                        options: action.popupOptions
                    }
                });
            }
        default:
            return state;
    }
};


/***/ }),

/***/ 47746:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "getPopupData", ({
    enumerable: true,
    get: function() {
        return getPopupData;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var getPopupData = function(state) {
    return (0, _get.default)(state, "popup.popupData");
};


/***/ }),

/***/ 78235:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    LANDING_SHOWN: function() {
        return LANDING_SHOWN;
    },
    ROUTING_LOCATION_CHANGE: function() {
        return ROUTING_LOCATION_CHANGE;
    },
    ROUTING_SAVE_DEEPLINK: function() {
        return ROUTING_SAVE_DEEPLINK;
    },
    ROUTING_SET_IS_TOP_LEVEL_ROUTE: function() {
        return ROUTING_SET_IS_TOP_LEVEL_ROUTE;
    },
    SET_ROUTE_SKELETON: function() {
        return SET_ROUTE_SKELETON;
    },
    SHOULD_DISPLAY_LANDING: function() {
        return SHOULD_DISPLAY_LANDING;
    },
    hideRouteSkeleton: function() {
        return hideRouteSkeleton;
    },
    landingShouldBeShown: function() {
        return landingShouldBeShown;
    },
    landingShown: function() {
        return landingShown;
    },
    setCurrentLocation: function() {
        return setCurrentLocation;
    },
    setDeeplinkLocation: function() {
        return setDeeplinkLocation;
    },
    setIsTopLevelRoute: function() {
        return setIsTopLevelRoute;
    },
    setRouteSkeleton: function() {
        return setRouteSkeleton;
    },
    setRouteSkeletonByEntity: function() {
        return setRouteSkeletonByEntity;
    }
});
var _async_to_generator = __webpack_require__(24146);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(45538);
var _featuresselectors = __webpack_require__(76109);
var _layoutselectors = __webpack_require__(53368);
var _pairingselectors = __webpack_require__(59739);
var _routingutils = __webpack_require__(86567);
var ROUTING_LOCATION_CHANGE = "routing/LOCATION_CHANGE";
var ROUTING_SAVE_DEEPLINK = "routing/SAVE_DEEPLINK";
var ROUTING_SET_IS_TOP_LEVEL_ROUTE = "routing/SET_IS_TOP_LEVEL_ROUTE";
var LANDING_SHOWN = "routing/ROUTING_SET_IS_LANDING_SHOWN";
var SHOULD_DISPLAY_LANDING = "routing/SHOULD_DISPLAY_LANDING";
var SET_ROUTE_SKELETON = "routing/SET_ROUTE_SKELETON";
var setDeeplinkLocation = function(deeplink) {
    return {
        type: ROUTING_SAVE_DEEPLINK,
        deeplink: deeplink
    };
};
var setCurrentLocation = function(location, path) {
    return {
        type: ROUTING_LOCATION_CHANGE,
        location: location,
        path: path
    };
};
var setIsTopLevelRoute = function(isTopLevelRoute) {
    return {
        type: ROUTING_SET_IS_TOP_LEVEL_ROUTE,
        isTopLevelRoute: isTopLevelRoute
    };
};
var landingShown = function() {
    return {
        type: LANDING_SHOWN
    };
};
var landingShouldBeShown = function() {
    return {
        type: SHOULD_DISPLAY_LANDING
    };
};
var setRouteSkeleton = function(skeleton) {
    return {
        type: SET_ROUTE_SKELETON,
        skeleton: skeleton
    };
};
var hideRouteSkeleton = function() {
    return {
        type: SET_ROUTE_SKELETON,
        skeleton: null
    };
};
var setRouteSkeletonByEntity = function(entityType, entityId) {
    return function() {
        var _ref = _async_to_generator._(function(dispatch, getState) {
            var state, currentLayout, hasProfiles, selectedProfileUid, isProfileSelected;
            return _ts_generator._(this, function(_state) {
                state = getState();
                currentLayout = (0, _layoutselectors.getCurrentLayout)(state);
                hasProfiles = (0, _featuresselectors.getMultiProfileFeature)(state);
                selectedProfileUid = (0, _pairingselectors.getSelectedProfile)(state);
                isProfileSelected = hasProfiles ? Boolean(selectedProfileUid) : true;
                // NOTE: Handling possible profiles gate
                if (currentLayout || !isProfileSelected) {
                    dispatch(setRouteSkeleton());
                } else {
                    dispatch(setRouteSkeleton((0, _routingutils.getMatchingSkeleton)(entityType, entityId)));
                }
                return [
                    2
                ];
            });
        });
        return function(dispatch, getState) {
            return _ref.apply(this, arguments);
        };
    }();
};


/***/ }),

/***/ 10093:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(52318);
var _routesutils = __webpack_require__(14948);
var _routingactions = __webpack_require__(78235);
var initialState = {
    deeplink: "",
    isOpenedViaDeeplink: false,
    currentRoute: "",
    currentPath: "",
    skeleton: null,
    isTopLevelRoute: false,
    shouldDisplayLanding: true
};
var _default = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case _routingactions.ROUTING_SAVE_DEEPLINK:
            {
                var deeplink = action.deeplink && !_routesutils.DEEP_LINK_EXCLUSIONS.includes(action.deeplink) ? action.deeplink : "";
                return _object_spread_props._(_object_spread._({}, state), {
                    deeplink: deeplink,
                    isOpenedViaDeeplink: state.isOpenedViaDeeplink || Boolean(deeplink)
                });
            }
        case _routingactions.ROUTING_LOCATION_CHANGE:
            return _object_spread_props._(_object_spread._({}, state), {
                currentRoute: action.location,
                currentPath: action.path
            });
        case _routingactions.ROUTING_SET_IS_TOP_LEVEL_ROUTE:
            return _object_spread_props._(_object_spread._({}, state), {
                isTopLevelRoute: action.isTopLevelRoute
            });
        case _routingactions.LANDING_SHOWN:
            return _object_spread_props._(_object_spread._({}, state), {
                shouldDisplayLanding: false
            });
        case _routingactions.SHOULD_DISPLAY_LANDING:
            return _object_spread_props._(_object_spread._({}, state), {
                shouldDisplayLanding: true
            });
        case _routingactions.SET_ROUTE_SKELETON:
            return _object_spread_props._(_object_spread._({}, state), {
                skeleton: action.skeleton || null
            });
        default:
            return state;
    }
};


/***/ }),

/***/ 2001:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    getCurrentPath: function() {
        return getCurrentPath;
    },
    getCurrentRoute: function() {
        return getCurrentRoute;
    },
    getDeepLink: function() {
        return getDeepLink;
    },
    getRouteSkeleton: function() {
        return getRouteSkeleton;
    },
    isNavigationAllowed: function() {
        return isNavigationAllowed;
    },
    isOpenedViaDeeplink: function() {
        return isOpenedViaDeeplink;
    },
    isTopLevelRoute: function() {
        return isTopLevelRoute;
    },
    shouldDisplayLanding: function() {
        return shouldDisplayLanding;
    }
});
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(52318);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var getCurrentPath = function(state) {
    return (0, _get.default)(state, "routing.currentPath", "");
};
var getCurrentRoute = function(state) {
    return (0, _get.default)(state, "routing.currentRoute", "");
};
var isTopLevelRoute = function(state) {
    return (0, _get.default)(state, "routing.isTopLevelRoute", false);
};
var isOpenedViaDeeplink = function(state) {
    return (0, _get.default)(state, "routing.isOpenedViaDeeplink", false);
};
var shouldDisplayLanding = function(state) {
    return (0, _get.default)(state, "routing.shouldDisplayLanding");
};
var isNavigationAllowed = function(state) {
    var isAllowedByRoute = isTopLevelRoute(state);
    return isAllowedByRoute && state.layout.navigationAllowed;
};
var getDeepLink = function(state) {
    return (0, _get.default)(state, "routing.deeplink");
};
var getRouteSkeleton = function(state) {
    return (0, _get.default)(state, "routing.skeleton", "");
};


/***/ }),

/***/ 86567:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "getMatchingSkeleton", ({
    enumerable: true,
    get: function() {
        return getMatchingSkeleton;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(37815);
var _config = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67958));
var getMatchingSkeleton = function(entityType, entityId) {
    var section = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "main";
    var hasSkeletonConfig = _config.default.skeleton && Array.isArray(_config.default.skeleton.patterns);
    if (!hasSkeletonConfig || !entityType) {
        return null;
    }
    return _config.default.skeleton.patterns.filter(function(param) {
        var pattern = param.section;
        return !pattern || section === pattern;
    }).find(function(param) {
        var pattern = param.path;
        try {
            return new RegExp(pattern, "i").test("app/".concat(entityType, "/").concat(entityId));
        } catch (error) {
            return false;
        }
    }) || null;
};


/***/ }),

/***/ 90962:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    fetchScreenSaverData: function() {
        return fetchScreenSaverData;
    },
    setScreenSaverIsLocked: function() {
        return setScreenSaverIsLocked;
    }
});
var _async_to_generator = __webpack_require__(24146);
var _interop_require_default = __webpack_require__(81200);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(3009);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _fidosdk = __webpack_require__(19804);
var _erroractions = __webpack_require__(39258);
var _errorconstants = __webpack_require__(16186);
var _screenSaverconstants = __webpack_require__(42429);
var _screenSaverselectors = __webpack_require__(57677);
var _featuresselectors = __webpack_require__(76109);
var fetchScreenSaverData = function() {
    var sectionCode = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "main";
    return function() {
        var _ref = _async_to_generator._(function(dispatch, getState) {
            var state, entity, data, error;
            return _ts_generator._(this, function(_state) {
                switch(_state.label){
                    case 0:
                        state = getState();
                        if ((0, _get.default)((0, _screenSaverselectors.getScreenSaverData)(state), "section") === sectionCode || !(0, _featuresselectors.getScreensaverFeature)(state)) {
                            return [
                                2
                            ];
                        }
                        entity = {
                            entityType: _fidosdk.LAYOUT_ENTITIES.frontspace,
                            entityId: _fidosdk.LAYOUT_FRONTSPACES.screensaver,
                            sectionCode: sectionCode
                        };
                        data = null;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            _fidosdk.layoutService.fetchByEntity(entity)
                        ];
                    case 2:
                        data = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        dispatch((0, _erroractions.errorAction)(_errorconstants.ERROR_LEVELS.SILENT, _errorconstants.ERROR_TYPES.GENERAL, "Screen Saver fetching error"));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        dispatch({
                            type: _screenSaverconstants.SCREEN_SAVER_DATA,
                            data: data
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function(dispatch, getState) {
            return _ref.apply(this, arguments);
        };
    }();
};
var setScreenSaverIsLocked = function(isLocked) {
    return {
        type: _screenSaverconstants.SCREEN_SAVER_IS_LOCKED,
        data: {
            isLocked: isLocked
        }
    };
};


/***/ }),

/***/ 42429:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    SCREEN_SAVER_DATA: function() {
        return SCREEN_SAVER_DATA;
    },
    SCREEN_SAVER_IS_LOCKED: function() {
        return SCREEN_SAVER_IS_LOCKED;
    }
});
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(37815);
var SCREEN_SAVER_DATA = "screenSaver/SCREEN_SAVER_DATA";
var SCREEN_SAVER_IS_LOCKED = "screenSaver/IS_LOCKED";


/***/ }),

/***/ 294:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    default: function() {
        return _default;
    },
    initialState: function() {
        return initialState;
    }
});
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _screenSaverconstants = __webpack_require__(42429);
var _screenSaverutils = __webpack_require__(34849);
var initialState = {
    screenSaverData: null,
    isLocked: false
};
var _default = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    var screenSaverData = {
        section: (0, _get.default)(action.data, "layout.section"),
        layoutId: (0, _get.default)(action.data, "layout.id"),
        items: (0, _screenSaverutils.getScreenSaverItemsData)(action.data)
    };
    switch(action.type){
        case _screenSaverconstants.SCREEN_SAVER_DATA:
            {
                return _object_spread_props._(_object_spread._({}, state), {
                    screenSaverData: screenSaverData
                });
            }
        case _screenSaverconstants.SCREEN_SAVER_IS_LOCKED:
            {
                return _object_spread_props._(_object_spread._({}, state), {
                    isLocked: (0, _get.default)(action.data, "isLocked")
                });
            }
        default:
            return state;
    }
};


/***/ }),

/***/ 57677:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    getScreenSaverData: function() {
        return getScreenSaverData;
    },
    getScreenSaverIsLocked: function() {
        return getScreenSaverIsLocked;
    }
});
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var getScreenSaverData = function(state) {
    return (0, _get.default)(state, "screenSaver.screenSaverData");
};
var getScreenSaverIsLocked = function(state) {
    return (0, _get.default)(state, "screenSaver.isLocked");
};


/***/ }),

/***/ 34849:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    checkLayoutsNotEqual: function() {
        return checkLayoutsNotEqual;
    },
    getNextIndex: function() {
        return getNextIndex;
    },
    getScreenSaverItemsData: function() {
        return getScreenSaverItemsData;
    }
});
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(45538);
var _fidosdk = __webpack_require__(19804);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var getItemTitle = function(item) {
    var content = (0, _get.default)(item, "itemContent");
    return (0, _get.default)(content, "title") || (0, _get.default)(content, "extraTitle") || (0, _get.default)(content, "image.caption") || "";
};
var getScreenSaverItemsData = function(data) {
    var entity = (0, _get.default)(data, "entity.id");
    if (entity === _fidosdk.LAYOUT_FRONTSPACES.screensaver) {
        var items = (0, _get.default)(data, "blocks[0].content.items") || [];
        return items.filter(function(item) {
            return (0, _get.default)(item, "itemContent.image.id");
        }).map(function(item) {
            return {
                details: (0, _get.default)(item, "itemContent.extraDetails") || "",
                title: getItemTitle(item),
                imageId: (0, _get.default)(item, "itemContent.image.id"),
                logoId: (0, _get.default)(item, "itemContent.logo.id")
            };
        });
    }
    return [];
};
var getNextIndex = function(index, collection) {
    return (index + 1) % collection.length;
};
var checkLayoutsNotEqual = function(a, b) {
    return a && b ? a.layoutId !== b.layoutId : !a && b;
};


/***/ }),

/***/ 75986:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    getSearchedItems: function() {
        return getSearchedItems;
    },
    saveSearchedItem: function() {
        return saveSearchedItem;
    },
    searchAll: function() {
        return searchAll;
    },
    searchKeyInput: function() {
        return searchKeyInput;
    },
    stopSearch: function() {
        return stopSearch;
    },
    updateSearchedItems: function() {
        return updateSearchedItems;
    }
});
var _async_to_generator = __webpack_require__(24146);
var _interop_require_default = __webpack_require__(81200);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(37815);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _fidosdk = __webpack_require__(19804);
var _config = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67958));
var _layoutactions = __webpack_require__(8424);
var _layoutselectors = __webpack_require__(53368);
var _searchselectors = __webpack_require__(72321);
var _searchutils = __webpack_require__(97968);
var _searchconstants = __webpack_require__(81828);
var _analyticsutils = __webpack_require__(2693);
var stopSearch = function() {
    return function(_, getState) {
        var timeoutId = (0, _searchselectors.getSearchDebounceId)(getState());
        clearTimeout(timeoutId);
    };
};
var searchAll = function(query) {
    var fromHistory = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return function() {
        var _ref = _async_to_generator._(function(dispatch, getState) {
            var state, entityId, entityType, currentResults, currentQuery, hasEnoughCharsInCurrentQuery, results, blocks, resultNumber;
            return _ts_generator._(this, function(_state) {
                switch(_state.label){
                    case 0:
                        state = getState();
                        entityId = (0, _layoutselectors.getRequestedEntityId)(state);
                        entityType = (0, _layoutselectors.getRequestedEntityType)(state);
                        if (fromHistory) {
                            dispatch(stopSearch());
                        }
                        currentResults = (0, _layoutselectors.getCurrentLayout)(getState());
                        currentQuery = currentResults.queryParameters && currentResults.queryParameters.query || "";
                        hasEnoughCharsInCurrentQuery = currentQuery.length >= _config.default.search.charactersToSearch;
                        if (!(query && query.length >= _config.default.search.charactersToSearch)) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            dispatch((0, _layoutactions.fetchLayout)(entityType, entityId, query ? {
                                query: query
                            } : null))
                        ];
                    case 1:
                        _state.sent();
                        results = (0, _layoutselectors.getCurrentLayout)(getState());
                        blocks = results.blocks;
                        resultNumber = 0;
                        blocks.forEach(function(item) {
                            resultNumber += (0, _get.default)(item, "content.items.length", 0);
                        });
                        (0, _analyticsutils.sendEvent)({
                            key: "searchInput",
                            input: query,
                            results: resultNumber
                        });
                        if (!(results && results.blocks && !results.blocks.length)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            dispatch((0, _layoutactions.fetchLayout)(_fidosdk.LAYOUT_ENTITIES.frontspace, _fidosdk.LAYOUT_FRONTSPACES.search))
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        return [
                            3,
                            6
                        ];
                    case 4:
                        if (!hasEnoughCharsInCurrentQuery) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            dispatch((0, _layoutactions.fetchLayout)(_fidosdk.LAYOUT_ENTITIES.frontspace, _fidosdk.LAYOUT_FRONTSPACES.search))
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        dispatch({
                            type: _searchconstants.SEARCH_RESULTS,
                            query: fromHistory ? query : null
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function(dispatch, getState) {
            return _ref.apply(this, arguments);
        };
    }();
};
var searchKeyInput = function(symbol) {
    return function(dispatch, getState) {
        var state = getState();
        var query = (0, _searchutils.formattingInput)(symbol, (0, _searchselectors.getSearchQuery)(state) || "");
        if (query.length >= _searchconstants.MAX_TEXT_LENGTH_TO_SEARCH) {
            return;
        }
        dispatch(stopSearch());
        var debounceId = setTimeout(function() {
            dispatch(searchAll(query));
        }, _searchconstants.SEARCH_DEBOUNCE_MS);
        dispatch({
            type: _searchconstants.SEARCH_INPUT,
            debounceId: debounceId,
            query: query
        });
    };
};
var saveSearchedItem = function(searchedItem) {
    return {
        searchedItem: searchedItem,
        type: _searchconstants.SAVE_SEARCHED_ITEM
    };
};
var getSearchedItems = function() {
    return {
        type: _searchconstants.GET_SEARCHED_ITEM
    };
};
var updateSearchedItems = function(searchedItems) {
    return {
        searchedItems: searchedItems,
        type: _searchconstants.UPDATE_SEARCHED_ITEMS
    };
};


/***/ }),

/***/ 81828:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BACKSPACE: function() {
        return BACKSPACE;
    },
    GET_SEARCHED_ITEM: function() {
        return GET_SEARCHED_ITEM;
    },
    MAX_TEXT_LENGTH_TO_SEARCH: function() {
        return MAX_TEXT_LENGTH_TO_SEARCH;
    },
    MIN_TEXT_LENGTH_TO_SEARCH: function() {
        return MIN_TEXT_LENGTH_TO_SEARCH;
    },
    SAVE_SEARCHED_ITEM: function() {
        return SAVE_SEARCHED_ITEM;
    },
    SEARCH_DEBOUNCE_MS: function() {
        return SEARCH_DEBOUNCE_MS;
    },
    SEARCH_HISTORY_CAPACITY: function() {
        return SEARCH_HISTORY_CAPACITY;
    },
    SEARCH_HISTORY_KEY: function() {
        return SEARCH_HISTORY_KEY;
    },
    SEARCH_INPUT: function() {
        return SEARCH_INPUT;
    },
    SEARCH_RESET: function() {
        return SEARCH_RESET;
    },
    SEARCH_RESULTS: function() {
        return SEARCH_RESULTS;
    },
    SPACE: function() {
        return SPACE;
    },
    UPDATE_SEARCHED_ITEMS: function() {
        return UPDATE_SEARCHED_ITEMS;
    }
});
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(88801);
var SEARCH_RESET = "search/RESET";
var SEARCH_INPUT = "search/SEARCH_INPUT";
var GET_SEARCHED_ITEM = "search/GET_SEARCHED_ITEM";
var SAVE_SEARCHED_ITEM = "search/SAVE_SEARCHED_ITEM";
var UPDATE_SEARCHED_ITEMS = "search/UPDATE_SEARCHED_ITEMS";
var SEARCH_RESULTS = "search/SEARCH_RESULTS";
var SPACE = "_";
var BACKSPACE = "<";
var SEARCH_HISTORY_CAPACITY = 4;
var SEARCH_HISTORY_KEY = "_history";
var SEARCH_DEBOUNCE_MS = 800;
var MIN_TEXT_LENGTH_TO_SEARCH = 3;
var MAX_TEXT_LENGTH_TO_SEARCH = 128;


/***/ }),

/***/ 28320:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    default: function() {
        return _default;
    },
    initialState: function() {
        return initialState;
    }
});
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
var _searchconstants = __webpack_require__(81828);
var initialState = {
    debounceId: undefined,
    searchInput: "",
    searchHistory: []
};
var _default = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case _searchconstants.SEARCH_RESULTS:
            return _object_spread_props._(_object_spread._({}, state), {
                searchInput: action.query || state.searchInput
            });
        case _searchconstants.SEARCH_INPUT:
            return _object_spread_props._(_object_spread._({}, state), {
                searchInput: action.query,
                debounceId: action.debounceId
            });
        case _searchconstants.UPDATE_SEARCHED_ITEMS:
            return _object_spread_props._(_object_spread._({}, state), {
                searchHistory: action.searchedItems
            });
        case _searchconstants.SEARCH_RESET:
            return initialState;
        default:
            return state;
    }
};


/***/ }),

/***/ 10193:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "resetSearch", ({
    enumerable: true,
    get: function() {
        return resetSearch;
    }
}));
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(52318);
var _searchconstants = __webpack_require__(81828);
var resetSearch = function() {
    return {
        type: _searchconstants.SEARCH_RESET
    };
};


/***/ }),

/***/ 72321:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    getDefaultResults: function() {
        return getDefaultResults;
    },
    getSearchDebounceId: function() {
        return getSearchDebounceId;
    },
    getSearchQuery: function() {
        return getSearchQuery;
    },
    getSearchedHistory: function() {
        return getSearchedHistory;
    }
});
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
var getSearchQuery = function(param) {
    var search = param.search;
    return search.searchInput;
};
var getSearchDebounceId = function(param) {
    var search = param.search;
    return search.debounceId;
};
var getSearchedHistory = function(param) {
    var search = param.search;
    return search.searchHistory;
};
var getDefaultResults = function(param) {
    var search = param.search;
    return search.defaultResults;
};


/***/ }),

/***/ 97968:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/** @module searchUtils */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "formattingInput", ({
    enumerable: true,
    get: function() {
        return formattingInput;
    }
}));
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(3009);
var _searchconstants = __webpack_require__(81828);
var formattingInput = function(symbol, input) {
    var isDoubleSpace = symbol === _searchconstants.SPACE && input[input.length - 1] === " ";
    var isSpaceAtTheBeginning = symbol === _searchconstants.SPACE && input.length === 0;
    if (isDoubleSpace || isSpaceAtTheBeginning) {
        return input;
    }
    switch(symbol){
        case _searchconstants.SPACE:
            input += " ";
            break;
        case _searchconstants.BACKSPACE:
            input = input.slice(0, input.length - 1);
            break;
        default:
            input += symbol;
            break;
    }
    return input;
};


/***/ }),

/***/ 22119:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    refreshToken: function() {
        return refreshToken;
    },
    renewToken: function() {
        return renewToken;
    }
});
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
var _fidosdk = __webpack_require__(19804);
var renewToken = function() {
    return _fidosdk.tokenService.renewOidcToken();
};
var refreshToken = function() {
    return _fidosdk.oidcService.renewAccessToken();
};


/***/ }),

/***/ 99619:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    renewJwtWithProfile: function() {
        return renewJwtWithProfile;
    },
    resetJwtProfile: function() {
        return resetJwtProfile;
    }
});
var _async_to_generator = __webpack_require__(24146);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(3009);
var _fidosdk = __webpack_require__(19804);
var _erroractions = __webpack_require__(39258);
var _errorconstants = __webpack_require__(16186);
var _layoutsectionactions = __webpack_require__(19023);
var _routingactions = __webpack_require__(78235);
var _searchresetactions = __webpack_require__(10193);
var _useractions = __webpack_require__(79489);
var _pairingactions = __webpack_require__(83887);
var _tokenactions = __webpack_require__(22119);
var _userselectors = __webpack_require__(41845);
var renewJwtWithProfile = function(profileUid) {
    return function() {
        var _ref = _async_to_generator._(function(dispatch, getState) {
            var _getState, _getState_layout, requestedEntityId, requestedEntityType;
            return _ts_generator._(this, function(_state) {
                try {
                    _getState = getState(), _getState_layout = _getState.layout, requestedEntityId = _getState_layout.requestedEntityId, requestedEntityType = _getState_layout.requestedEntityType;
                    dispatch((0, _pairingactions.selectUserProfile)(profileUid));
                    dispatch((0, _routingactions.setRouteSkeletonByEntity)(requestedEntityType, requestedEntityId));
                    _fidosdk.tokenService.setProfile({
                        profileUid: profileUid
                    });
                    return [
                        2,
                        (0, _tokenactions.renewToken)().then(function() {
                            dispatch((0, _pairingactions.renewTokenSuccess)(profileUid));
                            dispatch((0, _useractions.fetchProfileInfos)(profileUid)).then(function() {
                                dispatch((0, _layoutsectionactions.setCurrentSectionCode)((0, _userselectors.isKidsProfile)(getState()) ? "kids" : "main"));
                            });
                            dispatch((0, _searchresetactions.resetSearch)());
                        })
                    ];
                // NOTE: the requested (unlocked) layout fetching will be done in the routing middleware
                } catch (error) {
                    _fidosdk.tokenService.setProfile(null);
                    dispatch((0, _pairingactions.renewTokenFailure)(error));
                    dispatch((0, _erroractions.errorAction)(_errorconstants.ERROR_LEVELS.SILENT, _errorconstants.ERROR_TYPES.PAIRING, error.message));
                    return [
                        2,
                        Promise.resolve(null)
                    ];
                }
                return [
                    2
                ];
            });
        });
        return function(dispatch, getState) {
            return _ref.apply(this, arguments);
        };
    }();
};
var resetJwtProfile = function() {
    return function(dispatch) {
        _fidosdk.tokenService.setProfile(null);
        dispatch((0, _layoutsectionactions.setCurrentSectionCode)("main"));
        dispatch((0, _pairingactions.clearUserProfile)());
    };
};


/***/ }),

/***/ 79489:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    CALL_GEO_FAILURE: function() {
        return CALL_GEO_FAILURE;
    },
    CALL_GEO_SUCCESS: function() {
        return CALL_GEO_SUCCESS;
    },
    CALL_USER_CONSENTS_FAILURE: function() {
        return CALL_USER_CONSENTS_FAILURE;
    },
    CALL_USER_CONSENTS_SUCCESS: function() {
        return CALL_USER_CONSENTS_SUCCESS;
    },
    FETCH_PROFILE_INFOS_FAILURE: function() {
        return FETCH_PROFILE_INFOS_FAILURE;
    },
    FETCH_PROFILE_INFOS_SUCCESS: function() {
        return FETCH_PROFILE_INFOS_SUCCESS;
    },
    GENERATE_DEVICE_ID: function() {
        return GENERATE_DEVICE_ID;
    },
    GET_USER_CONSENTS_FAILURE: function() {
        return GET_USER_CONSENTS_FAILURE;
    },
    GET_USER_CONSENTS_SUCCESS: function() {
        return GET_USER_CONSENTS_SUCCESS;
    },
    PARENTAL_LOCK_STATUS: function() {
        return PARENTAL_LOCK_STATUS;
    },
    PARING_SET_PREVIOUS_PROFILE_UID: function() {
        return PARING_SET_PREVIOUS_PROFILE_UID;
    },
    RESET_DEVICE_DATA: function() {
        return RESET_DEVICE_DATA;
    },
    RESTORE_DEVICE_DATA: function() {
        return RESTORE_DEVICE_DATA;
    },
    SET_ACCOUNT_COMPLETE: function() {
        return SET_ACCOUNT_COMPLETE;
    },
    SET_DO_NOT_TRACK: function() {
        return SET_DO_NOT_TRACK;
    },
    SET_USER_CONSENTS: function() {
        return SET_USER_CONSENTS;
    },
    SET_USER_UID: function() {
        return SET_USER_UID;
    },
    STORAGE_SUPPORT_FAILURE: function() {
        return STORAGE_SUPPORT_FAILURE;
    },
    STORAGE_WRITE_FAILURE: function() {
        return STORAGE_WRITE_FAILURE;
    },
    SYNCHRONIZE_USER_CONSENTS: function() {
        return SYNCHRONIZE_USER_CONSENTS;
    },
    UPDATE_DEVICE_ID: function() {
        return UPDATE_DEVICE_ID;
    },
    USER_FETCH_LAST_CLIPS_FAILURE: function() {
        return USER_FETCH_LAST_CLIPS_FAILURE;
    },
    USER_FETCH_LAST_CLIPS_SUCCESS: function() {
        return USER_FETCH_LAST_CLIPS_SUCCESS;
    },
    USER_RESTORE_PROFILE_UID: function() {
        return USER_RESTORE_PROFILE_UID;
    },
    checkParentalRestrictionCode: function() {
        return checkParentalRestrictionCode;
    },
    closeParentalLock: function() {
        return closeParentalLock;
    },
    completeAccount: function() {
        return completeAccount;
    },
    fetchLastViewedClipsSuccess: function() {
        return fetchLastViewedClipsSuccess;
    },
    fetchProfileInfos: function() {
        return fetchProfileInfos;
    },
    fetchProfileInfosSuccess: function() {
        return fetchProfileInfosSuccess;
    },
    generateDeviceId: function() {
        return generateDeviceId;
    },
    getUserConsentsFailure: function() {
        return getUserConsentsFailure;
    },
    getUserConsentsSuccess: function() {
        return getUserConsentsSuccess;
    },
    migrateDeviceId: function() {
        return migrateDeviceId;
    },
    openParentalLock: function() {
        return openParentalLock;
    },
    restoreDeviceData: function() {
        return restoreDeviceData;
    },
    setGeoInfo: function() {
        return setGeoInfo;
    },
    setLocalUserConsents: function() {
        return setLocalUserConsents;
    },
    setPreviousProfileUID: function() {
        return setPreviousProfileUID;
    },
    setRemoteConsents: function() {
        return setRemoteConsents;
    },
    setUserConsents: function() {
        return setUserConsents;
    },
    setUserConsentsOnApi: function() {
        return setUserConsentsOnApi;
    },
    setUserUid: function() {
        return setUserUid;
    },
    storageSupportFailure: function() {
        return storageSupportFailure;
    },
    storageWriteFailure: function() {
        return storageWriteFailure;
    },
    updateDeviceId: function() {
        return updateDeviceId;
    }
});
var _async_to_generator = __webpack_require__(24146);
var _interop_require_default = __webpack_require__(81200);
var _interop_require_wildcard = __webpack_require__(95316);
var _object_spread = __webpack_require__(76247);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(88801);
var _isEqual = /*#__PURE__*/ _interop_require_default._(__webpack_require__(31223));
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _fidosdk = __webpack_require__(19804);
var _deviceId = /*#__PURE__*/ _interop_require_wildcard._(__webpack_require__(8163));
var _userselectors = __webpack_require__(41845);
var _featuresselectors = __webpack_require__(76109);
var _userutils = __webpack_require__(95031);
var _analyticsactions = __webpack_require__(86978);
var _erroractions = __webpack_require__(39258);
var _errorconstants = __webpack_require__(16186);
var _popupactions = __webpack_require__(47531);
var _popupsconstants = __webpack_require__(60952);
var _analyticsutils = __webpack_require__(2693);
var STORAGE_WRITE_FAILURE = "user/STORAGE_WRITE_FAILURE";
var STORAGE_SUPPORT_FAILURE = "user/STORAGE_SUPPORT_FAILURE";
var RESTORE_DEVICE_DATA = "user/RESTORE_DEVICE_DATA";
var RESET_DEVICE_DATA = "user/RESET_DEVICE_DATA";
var SET_DO_NOT_TRACK = "user/SET_DO_NOT_TRACK";
var SET_USER_CONSENTS = "user/SET_USER_CONSENTS";
var GENERATE_DEVICE_ID = "user/GENERATE_DEVICE_ID";
var UPDATE_DEVICE_ID = "user/UPDATE_DEVICE_ID";
var SYNCHRONIZE_USER_CONSENTS = "user/SYNCHRONIZE_USER_CONSENTS";
var CALL_USER_CONSENTS_SUCCESS = "user/CALL_USER_CONSENTS_SUCCESS";
var CALL_USER_CONSENTS_FAILURE = "user/CALL_USER_CONSENTS_FAILURE";
var GET_USER_CONSENTS_SUCCESS = "user/GET_USER_CONSENTS_SUCCESS";
var GET_USER_CONSENTS_FAILURE = "user/GET_USER_CONSENTS_FAILURE";
var SET_USER_UID = "user/SET_USER_UID";
var USER_FETCH_LAST_CLIPS_SUCCESS = "user/FETCH_LAST_CLIPS_SUCCESS";
var USER_FETCH_LAST_CLIPS_FAILURE = "user/FETCH_LAST_CLIPS_FAILURE";
var USER_RESTORE_PROFILE_UID = "user/RESTORE_PROFILE_UID";
var PARING_SET_PREVIOUS_PROFILE_UID = "user/PARING_SET_PREVIOUS_PROFILE_UID";
var CALL_GEO_SUCCESS = "app/CALL_GEO_SUCCESS";
var CALL_GEO_FAILURE = "app/CALL_GEO_FAILURE";
var FETCH_PROFILE_INFOS_SUCCESS = "user/FETCH_PROFILE_INFOS_SUCCESS";
var FETCH_PROFILE_INFOS_FAILURE = "user/FETCH_PROFILE_INFOS_FAILURE";
var PARENTAL_LOCK_STATUS = "user/PARENTAL_LOCK_STATUS";
var SET_ACCOUNT_COMPLETE = "user/SET_ACCOUNT_COMPLETE";
var storageWriteFailure = function(error) {
    return {
        type: STORAGE_WRITE_FAILURE,
        error: error
    };
};
var storageSupportFailure = function(error) {
    return {
        type: STORAGE_SUPPORT_FAILURE,
        error: error
    };
};
var setPreviousProfileUID = function(previousProfileUid) {
    return {
        type: PARING_SET_PREVIOUS_PROFILE_UID,
        previousProfileUid: previousProfileUid
    };
};
var generateDeviceId = function() {
    return {
        type: GENERATE_DEVICE_ID,
        deviceId: (0, _deviceId.default)()
    };
};
var fetchProfileInfosSuccess = function(payload) {
    return _object_spread._({
        type: FETCH_PROFILE_INFOS_SUCCESS
    }, payload);
};
var getUserConsentsSuccess = function() {
    return {
        type: GET_USER_CONSENTS_SUCCESS
    };
};
var getUserConsentsFailure = function(error) {
    return {
        type: GET_USER_CONSENTS_FAILURE,
        error: error.message
    };
};
var completeAccount = function() {
    return {
        type: SET_ACCOUNT_COMPLETE
    };
};
var fetchProfileInfos = function(profileUid) {
    return function() {
        var _ref = _async_to_generator._(function(dispatch, getState) {
            var _getState, uid, profileInfos, username, imageExternalKey, isKidsProfile, error;
            return _ts_generator._(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _getState = getState(), uid = _getState.pairing.uid;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            _fidosdk.profileService.getProfile({
                                profileUid: profileUid,
                                userUid: uid
                            })
                        ];
                    case 2:
                        profileInfos = _state.sent();
                        username = profileInfos.username, imageExternalKey = profileInfos.avatar.imageExternalKey, isKidsProfile = profileInfos.is_kid;
                        dispatch(fetchProfileInfosSuccess({
                            profileAvatarId: imageExternalKey,
                            username: username,
                            isKidsProfile: isKidsProfile,
                            profileUid: profileUid
                        }));
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        dispatch({
                            type: FETCH_PROFILE_INFOS_FAILURE
                        });
                        dispatch((0, _erroractions.errorAction)(_errorconstants.ERROR_LEVELS.SILENT, _errorconstants.ERROR_TYPES.GENERAL, error.message));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(dispatch, getState) {
            return _ref.apply(this, arguments);
        };
    }();
};
var restoreDeviceData = function() {
    return {
        type: RESTORE_DEVICE_DATA
    };
};
var updateDeviceId = function(deviceId) {
    return {
        type: UPDATE_DEVICE_ID,
        deviceId: deviceId
    };
};
var setLocalUserConsents = function(consents) {
    return _object_spread._({
        type: SET_USER_CONSENTS
    }, consents);
};
var migrateDeviceId = function(deviceId) {
    return function(dispatch) {
        if (!deviceId || (0, _deviceId.isValidDeviceId)(deviceId)) {
            return;
        }
        var updatedDeviceId = (0, _deviceId.fixDeviceId)(deviceId);
        dispatch(updateDeviceId(updatedDeviceId));
    };
};
var setUserConsentsOnApi = function(consents) {
    return function() {
        var _ref = _async_to_generator._(function(dispatch, getState) {
            var cookies, state, deviceId, homeId, formattedConsents, error;
            return _ts_generator._(this, function(_state) {
                switch(_state.label){
                    case 0:
                        cookies = consents.cookies;
                        state = getState();
                        deviceId = (0, _userselectors.getDeviceId)(state);
                        homeId = (0, _userselectors.getHomeId)(state);
                        formattedConsents = (0, _userutils.getFormattedConsents)(cookies);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            _fidosdk.gdprService.setUserConsents({
                                uid: homeId || deviceId,
                                consents: formattedConsents
                            })
                        ];
                    case 2:
                        _state.sent();
                        dispatch({
                            type: CALL_USER_CONSENTS_SUCCESS
                        });
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        dispatch({
                            type: CALL_USER_CONSENTS_FAILURE,
                            error: error.message
                        });
                        dispatch((0, _erroractions.errorAction)(_errorconstants.ERROR_LEVELS.SILENT, _errorconstants.ERROR_TYPES.GENERAL, error.message));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(dispatch, getState) {
            return _ref.apply(this, arguments);
        };
    }();
};
var setRemoteConsents = function(consents) {
    return function() {
        var _ref = _async_to_generator._(function(dispatch, getState) {
            var state, _getUserState, deviceId, synchronize, areUserPreferencesSet, cookies, userApiFeature, currentConsents, remoteConsents, error;
            return _ts_generator._(this, function(_state) {
                switch(_state.label){
                    case 0:
                        state = getState();
                        _getUserState = (0, _userselectors.getUserState)(state), deviceId = _getUserState.deviceId, synchronize = _getUserState.synchronize, areUserPreferencesSet = _getUserState.areUserPreferencesSet, cookies = _getUserState.cookies;
                        userApiFeature = (0, _featuresselectors.getUserApiFeature)(state);
                        currentConsents = _object_spread._({}, consents, cookies);
                        if ((0, _isEqual.default)(currentConsents, consents)) {
                            return [
                                2
                            ];
                        }
                        if (!(synchronize === null && !areUserPreferencesSet)) return [
                            3,
                            4
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            _fidosdk.gdprService.getUserConsents({
                                uid: deviceId
                            })
                        ];
                    case 2:
                        remoteConsents = _state.sent();
                        dispatch(getUserConsentsSuccess());
                        if (Object.keys(remoteConsents).length !== 0) {
                            dispatch(generateDeviceId());
                            dispatch(setRemoteConsents(consents));
                            return [
                                2
                            ];
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        dispatch(getUserConsentsFailure(error));
                        dispatch((0, _erroractions.errorAction)(_errorconstants.ERROR_LEVELS.SILENT, _errorconstants.ERROR_TYPES.GENERAL, error.message));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        if (userApiFeature) {
                            dispatch(setUserConsentsOnApi({
                                cookies: consents
                            }));
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function(dispatch, getState) {
            return _ref.apply(this, arguments);
        };
    }();
};
var setUserConsents = function(consents) {
    return function(dispatch) {
        (0, _analyticsutils.trackGDPRConsent)(consents);
        dispatch(setRemoteConsents(consents));
        dispatch(setLocalUserConsents(consents));
        dispatch((0, _analyticsactions.bootstrapEngines)());
    };
};
var setGeoInfo = function() {
    return function() {
        var _ref = _async_to_generator._(function(dispatch) {
            var geoInfo, e;
            return _ts_generator._(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            _fidosdk.geoService.fetch()
                        ];
                    case 1:
                        geoInfo = _state.sent();
                        dispatch({
                            type: CALL_GEO_SUCCESS,
                            data: geoInfo
                        });
                        return [
                            3,
                            3
                        ];
                    case 2:
                        e = _state.sent();
                        dispatch({
                            type: CALL_GEO_FAILURE
                        });
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
var setUserUid = function(uid) {
    return function(dispatch) {
        return dispatch({
            type: SET_USER_UID,
            uid: uid
        });
    };
};
var closeParentalLock = function() {
    return function(dispatch) {
        return dispatch({
            type: PARENTAL_LOCK_STATUS,
            isUnlocked: false
        });
    };
};
var openParentalLock = function() {
    return function(dispatch) {
        return dispatch({
            type: PARENTAL_LOCK_STATUS,
            isUnlocked: true
        });
    };
};
var fetchLastViewedClipsSuccess = function(lastViewdClips) {
    return function(dispatch) {
        try {
            dispatch({
                type: USER_FETCH_LAST_CLIPS_SUCCESS,
                lastClips: lastViewdClips
            });
        } catch (error) {
            dispatch({
                type: USER_FETCH_LAST_CLIPS_FAILURE,
                error: error
            });
            dispatch((0, _erroractions.errorAction)(_errorconstants.ERROR_LEVELS.SILENT, _errorconstants.ERROR_TYPES.GENERAL, error.message));
        }
    };
};
var checkParentalRestrictionCode = function(code) {
    return function() {
        var _ref = _async_to_generator._(function(dispatch, getState) {
            var _getState, uid, error, errorStatus, errorMessage;
            return _ts_generator._(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _getState = getState(), uid = _getState.user.uid;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            _fidosdk.parentalControlService.checkParentalRestrictionCode({
                                uid: uid,
                                code: code
                            })
                        ];
                    case 2:
                        _state.sent();
                        dispatch(openParentalLock());
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        errorStatus = (0, _get.default)(error, "status");
                        errorMessage = (0, _get.default)(error, "message", "");
                        if (errorStatus && errorStatus === 400) {
                            dispatch(closeParentalLock());
                        } else if (errorStatus && errorStatus === 403) {
                            dispatch((0, _popupactions.showPopupAction)(_popupsconstants.MAX_PARENTAL_CODE_POPUP_ID, {}));
                        } else {
                            dispatch((0, _erroractions.errorAction)(_errorconstants.ERROR_LEVELS.FATAL, _errorconstants.ERROR_TYPES.GENERAL, errorMessage));
                        }
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(dispatch, getState) {
            return _ref.apply(this, arguments);
        };
    }();
};


/***/ }),

/***/ 44612:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    default: function() {
        return _default;
    },
    initialState: function() {
        return initialState;
    }
});
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _object_without_properties = __webpack_require__(46537);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(3009);
var _sha256 = /*#__PURE__*/ _interop_require_default._(__webpack_require__(57735));
var _string = __webpack_require__(25763);
var _useractions = __webpack_require__(79489);
var _pairingactions = __webpack_require__(83887);
var _userutils = __webpack_require__(95031);
var _gdprNoticeutils = __webpack_require__(28865);
var _appconfigactions = __webpack_require__(72261);
var _unpairactions = __webpack_require__(21219);
var initialState = {
    accountComplete: false,
    cookies: {},
    areUserPreferencesSet: false,
    deviceId: null,
    homeId: null,
    synchronize: false,
    localDeviceId: null,
    localHomeId: null,
    uid: null,
    profileUid: null,
    geo: null,
    lastClips: {},
    profileAvatarId: null,
    profileUsername: null,
    parentalLockStatus: false,
    previousProfileUid: null
};
var _default = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case _appconfigactions.CONFIG_INIT:
            {
                var cookies = action.cookies;
                return _object_spread_props._(_object_spread._({}, state), {
                    cookies: cookies,
                    areUserPreferencesSet: !(0, _gdprNoticeutils.areCookiesEmpty)(cookies)
                });
            }
        case _useractions.RESTORE_DEVICE_DATA:
            {
                var deviceId = action.deviceId, homeId = action.homeId, synchronize = action.synchronize;
                return _object_spread_props._(_object_spread._({}, state), {
                    deviceId: deviceId,
                    homeId: (0, _userutils.prefixWithHomeId)(homeId),
                    localDeviceId: (0, _string.removeGivenTextFromString)(deviceId, "deviceid-"),
                    localHomeId: homeId,
                    synchronize: synchronize
                });
            }
        case _useractions.SET_USER_CONSENTS:
            {
                var type = action.type, cookies1 = _object_without_properties._(action, [
                    "type"
                ]);
                return _object_spread_props._(_object_spread._({}, state), {
                    cookies: cookies1,
                    areUserPreferencesSet: true,
                    synchronize: false
                });
            }
        case _useractions.GENERATE_DEVICE_ID:
            {
                return _object_spread_props._(_object_spread._({}, state), {
                    deviceId: action.deviceId,
                    localDeviceId: (0, _string.removeGivenTextFromString)(action.deviceId, "deviceid-")
                });
            }
        case _useractions.UPDATE_DEVICE_ID:
            {
                return _object_spread_props._(_object_spread._({}, state), {
                    deviceId: action.deviceId,
                    localDeviceId: (0, _string.removeGivenTextFromString)(action.deviceId, "deviceid-"),
                    synchronize: false
                });
            }
        case _useractions.SYNCHRONIZE_USER_CONSENTS:
            {
                return _object_spread_props._(_object_spread._({}, state), {
                    synchronize: true
                });
            }
        case _useractions.CALL_GEO_SUCCESS:
            {
                var ip = action.data.ip;
                return _object_spread_props._(_object_spread._({}, state), {
                    geo: _object_spread_props._(_object_spread._({}, action.data), {
                        hashIp: (0, _sha256.default)(ip).toString()
                    })
                });
            }
        case _useractions.SET_USER_UID:
            {
                return _object_spread_props._(_object_spread._({}, state), {
                    uid: action.uid
                });
            }
        case _useractions.USER_FETCH_LAST_CLIPS_SUCCESS:
            return _object_spread_props._(_object_spread._({}, state), {
                lastClips: (0, _userutils.formatClipsObject)(action.lastClips)
            });
        case _useractions.FETCH_PROFILE_INFOS_SUCCESS:
            return _object_spread_props._(_object_spread._({}, state), {
                profileAvatarId: action.profileAvatarId,
                profileUsername: action.username,
                isKidsProfile: action.isKidsProfile
            });
        case _pairingactions.RENEW_TOKEN_SUCCESS:
            return _object_spread_props._(_object_spread._({}, state), {
                profileUid: action.profileUid
            });
        case _useractions.PARENTAL_LOCK_STATUS:
            return _object_spread_props._(_object_spread._({}, state), {
                parentalLockStatus: action.isUnlocked
            });
        case _useractions.PARING_SET_PREVIOUS_PROFILE_UID:
            return _object_spread_props._(_object_spread._({}, state), {
                previousProfileUid: action.previousProfileUid
            });
        case _useractions.SET_ACCOUNT_COMPLETE:
            {
                return _object_spread_props._(_object_spread._({}, state), {
                    accountComplete: true
                });
            }
        case _unpairactions.PAIRING_RESET:
            {
                return _object_spread_props._(_object_spread._({}, initialState), {
                    cookies: state.cookies || {}
                });
            }
        default:
            return state;
    }
};


/***/ }),

/***/ 41845:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    areGdprCookiesSet: function() {
        return areGdprCookiesSet;
    },
    getAccountCompletionStatus: function() {
        return getAccountCompletionStatus;
    },
    getCatalogAccess: function() {
        return getCatalogAccess;
    },
    getCookies: function() {
        return getCookies;
    },
    getDeviceId: function() {
        return getDeviceId;
    },
    getHasGeoInfo: function() {
        return getHasGeoInfo;
    },
    getHomeId: function() {
        return getHomeId;
    },
    getLastViewedClips: function() {
        return getLastViewedClips;
    },
    getLocalDeviceId: function() {
        return getLocalDeviceId;
    },
    getLocalHomeId: function() {
        return getLocalHomeId;
    },
    getPairedUser: function() {
        return getPairedUser;
    },
    getPairingStatus: function() {
        return getPairingStatus;
    },
    getPairingUid: function() {
        return getPairingUid;
    },
    getParentalLockStatus: function() {
        return getParentalLockStatus;
    },
    getPreviousProfileUid: function() {
        return getPreviousProfileUid;
    },
    getProfilePhotoId: function() {
        return getProfilePhotoId;
    },
    getProfileUsername: function() {
        return getProfileUsername;
    },
    getSelectedProfile: function() {
        return getSelectedProfile;
    },
    getUid: function() {
        return getUid;
    },
    getUserState: function() {
        return getUserState;
    },
    isKidsProfile: function() {
        return isKidsProfile;
    },
    shouldSynchronizeConsents: function() {
        return shouldSynchronizeConsents;
    }
});
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(42578);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var shouldSynchronizeConsents = function(isSynchronized, param) {
    var userApiFeature = param.features.userApiFeature, _param_user = param.user, deviceId = _param_user.deviceId, areConsentsSet = _param_user.areUserPreferencesSet;
    return !isSynchronized && userApiFeature && areConsentsSet && deviceId;
};
var getDeviceId = function(param) {
    var deviceId = param.user.deviceId;
    return deviceId;
};
var getHomeId = function(param) {
    var homeId = param.user.homeId;
    return homeId;
};
var getLocalDeviceId = function(param) {
    var localDeviceId = param.user.localDeviceId;
    return localDeviceId;
};
var getLocalHomeId = function(param) {
    var localHomeId = param.user.localHomeId;
    return localHomeId;
};
var getPairingStatus = function(param) {
    var status = param.pairing.status;
    return status;
};
var getUserState = function(param) {
    var user = param.user, userApiFeature = param.features.userApiFeature;
    return _object_spread_props._(_object_spread._({}, user), {
        userApiFeature: userApiFeature
    });
};
var getPairedUser = function(param) {
    var pairing = param.pairing;
    return pairing;
};
var getSelectedProfile = function(state) {
    return (0, _get.default)(state, "pairing.profileUid");
};
var getPairingUid = function(state) {
    return (0, _get.default)(getPairedUser(state), "uid");
};
var getCatalogAccess = function(param) {
    var catalogAccess = param.pairing.catalogAccess;
    return catalogAccess;
};
var getUid = function(param) {
    var uid = param.user.uid;
    return uid;
};
var getLastViewedClips = function(param) {
    var lastClips = param.user.lastClips;
    return lastClips;
};
var getProfileUsername = function(param) {
    var profileUsername = param.user.profileUsername;
    return profileUsername;
};
var getProfilePhotoId = function(param) {
    var profileAvatarId = param.user.profileAvatarId;
    return profileAvatarId;
};
var isKidsProfile = function(param) {
    var isKidsProfile = param.user.isKidsProfile;
    return isKidsProfile;
};
var getHasGeoInfo = function(param) {
    var geo = param.user.geo;
    return Boolean(geo);
};
var getCookies = function(param) {
    var cookies = param.user.cookies;
    return cookies;
};
var areGdprCookiesSet = function(param) {
    var areUserPreferencesSet = param.user.areUserPreferencesSet;
    return areUserPreferencesSet;
};
var getParentalLockStatus = function(param) {
    var parentalLockStatus = param.user.parentalLockStatus;
    return parentalLockStatus;
};
var getPreviousProfileUid = function(state) {
    return (0, _get.default)(state, "user.previousProfileUid", null);
};
var getAccountCompletionStatus = function(param) {
    var accountComplete = param.user.accountComplete;
    return accountComplete;
};


/***/ }),

/***/ 95031:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    formatClipsObject: function() {
        return formatClipsObject;
    },
    getFormattedConsents: function() {
        return getFormattedConsents;
    },
    incrementAccountCompletionCounter: function() {
        return incrementAccountCompletionCounter;
    },
    isAccountCompletionCounterReady: function() {
        return isAccountCompletionCounterReady;
    },
    prefixWithHomeId: function() {
        return prefixWithHomeId;
    },
    resetAccountCompletionCounter: function() {
        return resetAccountCompletionCounter;
    }
});
var _define_property = __webpack_require__(21228);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _sliced_to_array = __webpack_require__(28966);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
var _pairingutils = __webpack_require__(54264);
var _pairingconstants = __webpack_require__(41367);
var GDPR_API_CONSENT_KEY_MAPPING = {
    personalization: "personalization",
    audienceMeasurement: "analytics",
    targetedAdvertising: "adtargeting",
    devicePairing: "multidevicematching"
};
var formatClipsObject = function(clips) {
    return (clips || []).filter(function(clip) {
        return Boolean(clip && clip.clipid);
    }).reduceRight(function(acc, clip) {
        return _object_spread_props._(_object_spread._({}, acc), _define_property._({}, clip.clipid, clip));
    }, {});
};
var getFormattedConsents = function(consents) {
    var consentEntries = Object.entries(consents);
    return consentEntries.filter(function(param) {
        var _param = _sliced_to_array._(param, 2), key = _param[0], value = _param[1];
        return key !== undefined && value !== undefined;
    }).reduce(function(formattedConsents, param) {
        var _param = _sliced_to_array._(param, 2), key = _param[0], value = _param[1];
        return _object_spread_props._(_object_spread._({}, formattedConsents), _define_property._({}, GDPR_API_CONSENT_KEY_MAPPING[key] || key, {
            consent: value,
            form: "explicit"
        }));
    }, {});
};
var prefixWithHomeId = function(homeId) {
    if (typeof homeId !== "string") return null;
    return "homeid-".concat(homeId);
};
var ACCOUNT_COMPLETION_COUNTER = "account_completion_counter";
var getAccountCompletionCount = function() {
    return parseInt(localStorage.getItem(ACCOUNT_COMPLETION_COUNTER), 10) || 0;
};
var isAccountCompletionCounterReady = function() {
    return getAccountCompletionCount() >= 5;
};
var incrementAccountCompletionCounter = function() {
    if ((0, _pairingutils.getPairingMethod)() !== _pairingconstants.PAIRING_METHOD.SSI) {
        return;
    }
    localStorage.setItem(ACCOUNT_COMPLETION_COUNTER, getAccountCompletionCount() + 1);
};
var resetAccountCompletionCounter = function() {
    localStorage.setItem(ACCOUNT_COMPLETION_COUNTER, 0);
};


/***/ }),

/***/ 98107:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ACTION_TO_TAGGING_PLAN: function() {
        return ACTION_TO_TAGGING_PLAN;
    },
    default: function() {
        return _default;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(65759);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _analyticsutils = __webpack_require__(2693);
var _playerconstants = __webpack_require__(7602);
var _playerselectors = __webpack_require__(83318);
var _useractions = __webpack_require__(79489);
var _obj;
var ACTION_TO_TAGGING_PLAN = (_obj = {}, _define_property._(_obj, _playerconstants.TOP_BAR_RELATED_VIDEOS, "pressViewRelatedVideo"), _define_property._(_obj, _playerconstants.TOP_BAR_TRACKS, "pressAudioSettingsVideo"), _define_property._(_obj, _playerconstants.TOP_BAR_START_OVER, "pressStartOverVideo"), _define_property._(_obj, _playerconstants.TOP_BAR_BACK_TO_LIVE, "pressBackToLiveVideo"), _define_property._(_obj, _playerconstants.TOP_BAR_BACK, "pressBackButtonDuringVideo"), _obj);
var _default = function(param) {
    var getState = param.getState;
    return function(next) {
        return function(action) {
            switch(action.type){
                case _useractions.FETCH_PROFILE_INFOS_SUCCESS:
                    {
                        (0, _analyticsutils.setAttributes)({
                            isKidsProfile: action.isKidsProfile,
                            userProfile: action.profileUid
                        });
                        (0, _analyticsutils.sendEvent)({
                            key: "profileSelected"
                        });
                        break;
                    }
                case _playerconstants.INITIALIZED:
                    {
                        var analytics = action.item.analytics || {};
                        var progress = (0, _get.default)(action.item, "video.progress") || {};
                        var currentTime = progress.tcResume || 0;
                        (0, _analyticsutils.setAttributes)({
                            currentTime: currentTime,
                            isLive: action.isLive,
                            duration: action.item.video.duration,
                            videoEndScreen: progress.endscreenDisplayTc || 0,
                            newProgramAnalyticsConfiguration: analytics,
                            contentType: action.entityType
                        });
                        break;
                    }
                case _playerconstants.PLAYING:
                    {
                        (0, _analyticsutils.sendEvent)({
                            key: "playVideo"
                        });
                        break;
                    }
                case _playerconstants.AUDIO_TRACK_CHANGED:
                    {
                        var state = getState();
                        var player = state.player;
                        var language = (0, _get.default)(action, "payload.currentTrack.language");
                        (0, _analyticsutils.setAttributes)({
                            playerActiveAudioLanguage: language,
                            player_audio: language,
                            switch_language: player.originalLanguage === language ? "no" : "yes"
                        });
                        (0, _analyticsutils.sendEvent)({
                            key: "audioTrackChanged",
                            language: language
                        });
                        break;
                    }
                case _playerconstants.SUBTITLES_TRACK_CHANGED:
                    {
                        var language1 = (0, _get.default)(action, "payload.currentTrack.language");
                        (0, _analyticsutils.setAttributes)({
                            playerActiveTextLanguage: language1,
                            subtitle_active: language1 ? "yes" : "no",
                            player_subtitles: language1
                        });
                        (0, _analyticsutils.sendEvent)({
                            key: "subtitlesTrackChanged",
                            language: language1
                        });
                        break;
                    }
                case _playerconstants.TIME_UPDATE:
                    {
                        var state1 = getState();
                        var isStarted = (0, _playerselectors.getIsStarted)(state1);
                        if (!isStarted) {
                            (0, _analyticsutils.sendEvent)({
                                key: "autoPlay"
                            });
                        }
                        (0, _analyticsutils.setAttributes)({
                            currentTime: action.payload.currentTime - (state1.player.startTimeInSeconds || 0)
                        });
                        break;
                    }
                case _playerconstants.WAITING:
                    {
                        var isBuffering = (0, _get.default)(action, "payload.isBuffering") || false;
                        (0, _analyticsutils.sendEvent)({
                            key: isBuffering ? "buffering" : "bufferingEnded"
                        });
                        break;
                    }
                case _playerconstants.SEEKING:
                    {
                        (0, _analyticsutils.sendEvent)({
                            key: "seek"
                        });
                        break;
                    }
                case _playerconstants.SEEKED:
                    {
                        var state2 = getState();
                        if (!state2.player.isLive) {
                            (0, _analyticsutils.setAttributes)({
                                currentTime: (action.payload.to || 0) - (state2.player.startTimeInSeconds || 0)
                            });
                        }
                        (0, _analyticsutils.sendEvent)({
                            key: "seekEnded"
                        });
                        break;
                    }
                case _playerconstants.PAUSED:
                    {
                        var state3 = getState();
                        (0, _analyticsutils.setAttributes)({
                            duration: state3.player.durationInSeconds
                        });
                        (0, _analyticsutils.sendEvent)({
                            key: "pauseVideo"
                        });
                        break;
                    }
                case _playerconstants.ENDED:
                    {
                        (0, _analyticsutils.sendEvent)({
                            key: "complete"
                        });
                        break;
                    }
                default:
                    break;
            }
            var key = ACTION_TO_TAGGING_PLAN[action.type];
            if (key) {
                (0, _analyticsutils.sendEvent)({
                    key: key
                });
            }
            var result = next(action);
            // NOTE: the video source will be selected after the INITIALIZED action dispatched in a newly reduced state
            switch(action.type){
                case _playerconstants.INITIALIZED:
                    {
                        var state4 = getState();
                        var source = (0, _playerselectors.getVideoSource)(state4);
                        if (source) {
                            (0, _analyticsutils.setAttributes)({
                                videoQuality: source.video_quality && typeof source.video_quality === "string" ? source.video_quality.toLowerCase() : null
                            });
                            (0, _analyticsutils.sendEvent)({
                                key: "playbackStarted",
                                analytics: action.item.analytics
                            });
                        }
                        break;
                    }
                case _playerconstants.TRACKS_CHANGED:
                    {
                        var state5 = getState();
                        var player1 = state5.player;
                        var originalLanguage = player1.originalLanguage, selectedSubtitlesTrack = player1.selectedSubtitlesTrack, selectedAudioTrack = player1.selectedAudioTrack;
                        var activeSubtitlesTrack = (0, _get.default)(action, "payload.subtitleTracks").find(function(param) {
                            var id = param.id;
                            return id === selectedSubtitlesTrack;
                        });
                        var activeAudioTrack = (0, _get.default)(action, "payload.audioTracks").find(function(param) {
                            var id = param.id;
                            return id === selectedAudioTrack;
                        });
                        (0, _analyticsutils.setAttributes)({
                            subtitle_active: activeSubtitlesTrack ? "yes" : "no",
                            player_audio: activeAudioTrack ? activeAudioTrack.language : null,
                            player_subtitles: activeSubtitlesTrack ? activeSubtitlesTrack.language : null,
                            switch_language: originalLanguage === (activeAudioTrack === null || activeAudioTrack === void 0 ? void 0 : activeAudioTrack.language) ? "no" : "yes"
                        });
                        break;
                    }
                default:
                    break;
            }
            return result;
        };
    };
};


/***/ }),

/***/ 95225:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _analyticsutils = __webpack_require__(2693);
var _playerselectors = __webpack_require__(83318);
var _playerconstants = __webpack_require__(7602);
var _heartbeat = __webpack_require__(86437);
var _popupactions = __webpack_require__(47531);
var _popupsconstants = __webpack_require__(60952);
var _heartbeatselectors = __webpack_require__(99163);
// TODO: Figure out what is expected in case of Heartbeat CSL error after deeplink
var cslErrorHandler = function(dispatch) {
    return function() {
        dispatch((0, _popupactions.showPopupAction)(_popupsconstants.CSL_BLOCK_POPUP_ID, {}));
        dispatch((0, _playerconstants.reset)());
    };
};
var _default = function(param) {
    var getState = param.getState, dispatch = param.dispatch;
    return function(next) {
        return function(action) {
            var forward = next(action);
            switch(action.type){
                case _playerconstants.INITIALIZED:
                    {
                        var state = getState();
                        var analyticsFromLayout = (0, _heartbeatselectors.getHeartbeatV2)(state);
                        _heartbeat.Heartbeat.createSession(_object_spread_props._(_object_spread._({}, analyticsFromLayout), {
                            startTime: (0, _playerselectors.getIsLive)(state) ? (0, _playerselectors.getStartTimeInSeconds)(state) : (0, _playerselectors.getElapsedTimeInSeconds)(state),
                            cslErrorHandler: cslErrorHandler(dispatch)
                        })).then(function(sessionId) {
                            if (sessionId) {
                                (0, _analyticsutils.setAttributes)({
                                    heartbeatSessionId: sessionId
                                });
                            }
                        });
                        break;
                    }
                case _playerconstants.PLAYING:
                    {
                        _heartbeat.Heartbeat.resume();
                        break;
                    }
                case _playerconstants.PAUSED:
                    {
                        _heartbeat.Heartbeat.pause();
                        break;
                    }
                case _playerconstants.TIME_UPDATE:
                    {
                        _heartbeat.Heartbeat.currentPlayerTime = (0, _playerselectors.getElapsedTimeInSeconds)(getState());
                        break;
                    }
                case _playerconstants.SEEKING:
                    {
                        var from = (0, _get.default)(action, "payload.from");
                        if (Number.isFinite(from)) {
                            _heartbeat.Heartbeat.currentPlayerTime = from;
                            // Stopping heartbeats since seek may take significant time due to buffering
                            _heartbeat.Heartbeat.pause();
                        }
                        break;
                    }
                case _playerconstants.SEEKED:
                    {
                        var state1 = getState();
                        var playbackState = (0, _playerselectors.getPlaybackState)(state1);
                        // Using current time as a fallback in case if something went wrong with seek event
                        _heartbeat.Heartbeat.currentPlayerTime = (0, _playerselectors.getIsLive)(state1) ? (0, _playerselectors.getElapsedTimeInSeconds)(state1) : (0, _get.default)(action, "payload.to", (0, _playerselectors.getElapsedTimeInSeconds)(state1));
                        var from1 = (0, _get.default)(action, "payload.from");
                        if (!Number.isFinite(from1)) {
                            break;
                        }
                        // PLAYING event will be issued anyway after SEEKED, no need to duplicate it
                        if (playbackState !== _playerconstants.PLAYBACK_STATE_PLAYING) {
                            _heartbeat.Heartbeat.pause();
                        }
                        break;
                    }
                case _playerconstants.RESET:
                    {
                        _heartbeat.Heartbeat.destroy();
                        break;
                    }
                default:
                    break;
            }
            return forward;
        };
    };
};


/***/ }),

/***/ 17104:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    actionsToPaths: function() {
        return actionsToPaths;
    },
    default: function() {
        return _default;
    },
    isTopLevelRoute: function() {
        return isTopLevelRoute;
    }
});
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(3009);
var _memoize = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34736));
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _routingactions = __webpack_require__(78235);
var _layoutactions = __webpack_require__(8424);
var _layoutselectors = __webpack_require__(53368);
var _routingselectors = __webpack_require__(2001);
var _sidenavutils = __webpack_require__(54463);
var _sidenavconstants = __webpack_require__(74842);
var _pairingactions = __webpack_require__(83887);
var _useractions = __webpack_require__(79489);
var actionsToPaths = (0, _memoize.default)(function(navigation) {
    return (0, _get.default)(navigation, "entries", []).flatMap(function(group) {
        return group.map(function(param) {
            var entry = param.entry;
            return (0, _sidenavutils.actionToPath)({
                action: entry
            });
        });
    });
});
var isTopLevelRoute = function(route) {
    return !_sidenavconstants.RESTRICTED_PATHS.some(function(path) {
        return route.startsWith(path);
    });
};
var _default = function(param) {
    var getState = param.getState, dispatch = param.dispatch;
    return function(next) {
        return function(action) {
            switch(action.type){
                case _routingactions.ROUTING_LOCATION_CHANGE:
                    {
                        var navigation = (0, _layoutselectors.getLayoutNavigation)(getState());
                        dispatch((0, _routingactions.setIsTopLevelRoute)(isTopLevelRoute(action.path, navigation)));
                        break;
                    }
                case _layoutactions.FETCH_NAVIGATION_SUCCESS:
                    {
                        var navigation1 = action.navigation;
                        var route = (0, _routingselectors.getCurrentPath)(getState());
                        dispatch((0, _routingactions.setIsTopLevelRoute)(isTopLevelRoute(route, navigation1)));
                        break;
                    }
                // In order to avoid circular dependencies between layout fetching and locks resolution,
                // each time a new profile is selected (i.e. profile gate is unlocked), a target layout
                // is fetched to replace currently displaying profile gates that was returned by BFF
                // instead of the original layout.
                case _pairingactions.RENEW_TOKEN_SUCCESS:
                    {
                        var _getState = getState(), _getState_layout = _getState.layout, requestedEntityId = _getState_layout.requestedEntityId, requestedEntityType = _getState_layout.requestedEntityType;
                        if (!requestedEntityType || !requestedEntityId) {
                            break;
                        }
                        dispatch((0, _layoutactions.fetchLayout)(requestedEntityType, requestedEntityId));
                        break;
                    }
                case _useractions.FETCH_PROFILE_INFOS_SUCCESS:
                    {
                        var section = action.isKidsProfile ? "kids" : "main";
                        dispatch((0, _layoutactions.fetchNavigation)(section));
                        break;
                    }
                case _useractions.FETCH_PROFILE_INFOS_FAILURE:
                    {
                        dispatch((0, _layoutactions.fetchNavigation)("main"));
                        break;
                    }
                default:
                    break;
            }
            return next(action);
        };
    };
};


/***/ }),

/***/ 29572:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _define_property = __webpack_require__(21228);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _sliced_to_array = __webpack_require__(28966);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(3009);
var _config = __webpack_require__(67958);
var _utils = __webpack_require__(64188);
var _useractions = __webpack_require__(79489);
var _playerconstants = __webpack_require__(7602);
var _searchactions = __webpack_require__(75986);
var _videoconstants = __webpack_require__(70223);
var _searchconstants = __webpack_require__(81828);
var _appactions = __webpack_require__(20386);
var _appconfigactions = __webpack_require__(72261);
var _userselectors = __webpack_require__(41845);
var _pairingactions = __webpack_require__(83887);
var _unpairactions = __webpack_require__(21219);
var _pairingutils = __webpack_require__(54264);
var _userutils = __webpack_require__(95031);
var _pairingconstants = __webpack_require__(41367);
var _featuresselectors = __webpack_require__(76109);
var _layoutselectors = __webpack_require__(53368);
var _appconstants = __webpack_require__(32128);
/**
 * Retrieve the value of the consent cookies, using the
 * mapped cookie name from the config (with the typos and all).
 *
 * @returns {Object}
 */ var getConsents = function() {
    return _config.gdprCookies.reduce(function(memo, cookieName) {
        if (!cookieName) {
            return memo;
        }
        return _object_spread_props._(_object_spread._({}, memo), _define_property._({}, cookieName, _utils.storage.getItem(cookieName)));
    }, {});
};
/**
 * Filter the cookies sent from the action, to keep only the ones
 * defined in the config (with the typos and all).
 *
 * @param {Object} action
 * @returns {Object}
 */ var getFilteredConsents = function(action) {
    return Object.entries(action).reduce(function(memo, param) {
        var _param = _sliced_to_array._(param, 2), cookieName = _param[0], cookieValue = _param[1];
        // Do not include cookies that are not defined in the config
        if (!_config.gdprCookies.includes(cookieName)) {
            return memo;
        }
        return _object_spread_props._(_object_spread._({}, memo), _define_property._({}, cookieName, cookieValue));
    }, {});
};
var getUserId = function(store) {
    try {
        var _store_getState = store.getState(), _store_getState_user = _store_getState.user, profileUid = _store_getState_user.profileUid, uid = _store_getState_user.uid;
        return profileUid || uid;
    } catch (error) {
        return null;
    }
};
var makeSynchronizeKey = function(uid) {
    return "".concat(uid || "anonymous", ".").concat(_appconstants.PERSISTENT.SYNCHRONIZE_KEY);
};
var makePreferencesKey = function(key, userProfile) {
    return [
        userProfile,
        key
    ].filter(Boolean).join(".");
};
var saveSearchedItem = function(store, item) {
    var id = getUserId(store);
    var section = (0, _layoutselectors.getCurrentSectionCode)(store.getState());
    if (id && section) {
        var history = _utils.storage.getItem("".concat(id + _searchconstants.SEARCH_HISTORY_KEY, "_").concat(section));
        var parsedHistory = history ? JSON.parse(history) : [];
        parsedHistory.unshift(item);
        // remove duplicates
        var result = parsedHistory.filter(function(historyItem, index) {
            return historyItem !== item || index === 0;
        });
        try {
            _utils.storage.setItem("".concat(id + _searchconstants.SEARCH_HISTORY_KEY, "_").concat(section), JSON.stringify(result.slice(0, _searchconstants.SEARCH_HISTORY_CAPACITY)));
        } catch (error) {
            store.dispatch((0, _useractions.storageWriteFailure)(error));
        }
    }
};
var getSearchedItems = function(store) {
    var id = getUserId(store);
    var section = (0, _layoutselectors.getCurrentSectionCode)(store.getState());
    try {
        return JSON.parse(_utils.storage.getItem("".concat(id + _searchconstants.SEARCH_HISTORY_KEY, "_").concat(section))) || [];
    } catch (error) {
        return null;
    }
};
var _default = function(store) {
    return function(next) {
        return function(action) {
            var state = store.getState();
            var currentAction = _object_spread._({}, action);
            switch(currentAction.type){
                case _useractions.RESTORE_DEVICE_DATA:
                    {
                        currentAction[_appconstants.PERSISTENT.DEVICE_ID_KEY] = _utils.storage.getItem(_appconstants.PERSISTENT.DEVICE_ID_KEY);
                        currentAction[_appconstants.PERSISTENT.SYNCHRONIZE_KEY] = _utils.storage.getItem(makeSynchronizeKey((0, _userselectors.getUid)(state)));
                        currentAction.homeId = (0, _utils.getHomeId)();
                        currentAction = _object_spread._({}, currentAction);
                        break;
                    }
                case _appconfigactions.CONFIG_INIT:
                    {
                        var consentVersion = _utils.storage.getItem(_appconstants.PERSISTENT.CONSENT_VERSION);
                        currentAction = _object_spread_props._(_object_spread._({}, currentAction), {
                            cookies: getConsents(),
                            consentVersion: Number.isFinite(consentVersion) ? consentVersion : 0
                        });
                        break;
                    }
                case _playerconstants.INITIALIZED:
                    {
                        (0, _userutils.incrementAccountCompletionCounter)();
                        var shouldTrackPreferencesAcrossDevices = (0, _featuresselectors.getPlayerTrackPreferencesFeature)(state);
                        if (!shouldTrackPreferencesAcrossDevices) {
                            var audioLanguage = _utils.storage.getItem(makePreferencesKey(_videoconstants.TRACK_KEYS.PREFERRED_AUDIO_TRACK_LANGUAGE, state.user.profileUid));
                            var subtitlesLanguage = _utils.storage.getItem(makePreferencesKey(_videoconstants.TRACK_KEYS.PREFERRED_SUBTITLE_TRACK_LANGUAGE, state.user.profileUid));
                            var subtitles = null;
                            var audio = null;
                            if (subtitlesLanguage) {
                                subtitles = {
                                    language: subtitlesLanguage,
                                    role: "standard"
                                };
                                if (subtitlesLanguage.language) {
                                    subtitles = {
                                        language: subtitlesLanguage.language,
                                        role: subtitlesLanguage.role || "standard"
                                    };
                                }
                            }
                            if (audioLanguage) {
                                audio = {
                                    language: audioLanguage,
                                    audioDescription: false
                                };
                                if (audioLanguage.language) {
                                    audio = {
                                        language: audioLanguage.language,
                                        audioDescription: audioLanguage.audioDescription || false
                                    };
                                }
                            }
                            currentAction = _object_spread_props._(_object_spread._({}, currentAction), {
                                item: _object_spread_props._(_object_spread._({}, currentAction.item), {
                                    video: _object_spread_props._(_object_spread._({}, currentAction.item.video), {
                                        features: _object_spread_props._(_object_spread._({}, currentAction.item.video.features), {
                                            preferences: _object_spread_props._(_object_spread._({}, currentAction.item.video.features.preferences), {
                                                textTrack: subtitles,
                                                audioTrack: audio || currentAction.item.video.features.preferences.audioTrack
                                            })
                                        })
                                    })
                                })
                            });
                        }
                        break;
                    }
                case _unpairactions.PAIRING_RESET:
                    {
                        var uid = (0, _userselectors.getUid)(state);
                        _utils.storage.setItem(makeSynchronizeKey(uid), false);
                        break;
                    }
                default:
                    break;
            }
            next(currentAction);
            var uid1 = (0, _userselectors.getUid)(state);
            switch(currentAction.type){
                case _useractions.RESTORE_DEVICE_DATA:
                    {
                        try {
                            (0, _utils.isStorageSupported)(_utils.storage);
                        } catch (error) {
                            store.dispatch((0, _useractions.storageSupportFailure)(error));
                        }
                        if (!currentAction.deviceId && !currentAction.homeId) {
                            store.dispatch((0, _useractions.generateDeviceId)());
                        }
                        break;
                    }
                case _appactions.INITIALIZE_APP_COMPLETED:
                case _useractions.SET_USER_UID:
                    {
                        var isSynchronized = _utils.storage.getItem(makeSynchronizeKey(currentAction.uid || uid1));
                        // Ensure we are not sending consent data on each login
                        if (isSynchronized) {
                            store.dispatch({
                                type: _useractions.SYNCHRONIZE_USER_CONSENTS
                            });
                        }
                        if ((0, _userselectors.shouldSynchronizeConsents)(isSynchronized, store.getState())) {
                            var userConsents = getConsents();
                            store.dispatch((0, _useractions.setUserConsentsOnApi)({
                                cookies: userConsents
                            }));
                        }
                        break;
                    }
                case _useractions.RESET_DEVICE_DATA:
                    {
                        _utils.storage.clear();
                        break;
                    }
                case _useractions.SET_USER_CONSENTS:
                    {
                        try {
                            var consentCookies = getFilteredConsents(currentAction);
                            var currentVersion = parseInt(_config.gdpr.consentVersion, 10);
                            var _obj;
                            _utils.storage.setItems(_object_spread_props._(_object_spread._({}, consentCookies), (_obj = {}, _define_property._(_obj, _appconstants.PERSISTENT.CONSENT_VERSION, Number.isFinite(currentVersion) ? currentVersion : 0), _define_property._(_obj, makeSynchronizeKey(uid1), false), _obj)));
                        } catch (error) {
                            store.dispatch((0, _useractions.storageWriteFailure)(error));
                        }
                        break;
                    }
                case _useractions.GENERATE_DEVICE_ID:
                    {
                        try {
                            _utils.storage.setItem(_appconstants.PERSISTENT.DEVICE_ID_KEY, currentAction.deviceId, false);
                        } catch (error) {
                            store.dispatch((0, _useractions.storageWriteFailure)(error));
                        }
                        break;
                    }
                case _useractions.UPDATE_DEVICE_ID:
                    {
                        _utils.storage.setItem(_appconstants.PERSISTENT.DEVICE_ID_KEY, currentAction.deviceId, false);
                        _utils.storage.setItem(makeSynchronizeKey(uid1), false);
                        break;
                    }
                case _useractions.CALL_USER_CONSENTS_SUCCESS:
                    {
                        try {
                            _utils.storage.setItem(makeSynchronizeKey(uid1), true);
                            store.dispatch({
                                type: _useractions.SYNCHRONIZE_USER_CONSENTS
                            });
                        } catch (error) {
                            store.dispatch((0, _useractions.storageWriteFailure)(error));
                        }
                        break;
                    }
                case _pairingactions.RENEW_TOKEN_SUCCESS:
                    {
                        try {
                            var shouldDisplayProfilesGateOnNextVisit = (0, _featuresselectors.getMultiProfilesGateAlwaysDisplayed)(state);
                            // NOTE: Since dev mode utilizes hot reload it's annoying to hit the profile selector each time we need to debug something.
                            // If you need to disable this behavior, run an app in STAGING/PRODUCTION environment.
                            // Also don't forget to clear "profileUid" cookie.
                            if (!shouldDisplayProfilesGateOnNextVisit) {
                                _utils.storage.setItem("".concat(uid1, ".").concat(_appconstants.PERSISTENT.PROFILE_UID_KEY), currentAction.profileUid);
                            }
                        } catch (error) {
                            store.dispatch((0, _useractions.storageWriteFailure)(error));
                        }
                        break;
                    }
                case _pairingactions.CLEAR_USER_PROFILE:
                    {
                        try {
                            _utils.storage.removeItem("".concat(uid1, ".").concat(_appconstants.PERSISTENT.PROFILE_UID_KEY));
                        } catch (error) {
                            store.dispatch((0, _useractions.storageWriteFailure)(error));
                        }
                        break;
                    }
                case _useractions.USER_RESTORE_PROFILE_UID:
                    {
                        var previousProfileUid = _utils.storage.getItem(_appconstants.PERSISTENT.PREVIOUS_PROFILE_KEY);
                        if (previousProfileUid) {
                            store.dispatch((0, _useractions.setPreviousProfileUID)(previousProfileUid));
                        }
                        break;
                    }
                case _useractions.FETCH_PROFILE_INFOS_SUCCESS:
                    {
                        var profileUid = currentAction.profileUid;
                        try {
                            _utils.storage.setItem(_appconstants.PERSISTENT.PREVIOUS_PROFILE_KEY, profileUid, true);
                        } catch (error) {
                            store.dispatch((0, _useractions.storageWriteFailure)(error));
                        }
                        break;
                    }
                case _pairingactions.PAIRING_LOGOUT_SUCCESS:
                    {
                        try {
                            _utils.storage.removeItem(_appconstants.PERSISTENT.PREVIOUS_PROFILE_KEY);
                        } catch (error) {
                            store.dispatch((0, _useractions.storageWriteFailure)(error));
                        }
                        break;
                    }
                case _playerconstants.TRACK_PREFERENCES_CHANGED:
                    {
                        try {
                            var _store_getState = store.getState(), preferences = _store_getState.player.preferences, profileUid1 = _store_getState.user.profileUid;
                            if (preferences.audioTrack) {
                                _utils.storage.setItem(makePreferencesKey(_videoconstants.TRACK_KEYS.PREFERRED_AUDIO_TRACK_LANGUAGE, profileUid1), preferences.audioTrack);
                            }
                            _utils.storage.setItem(makePreferencesKey(_videoconstants.TRACK_KEYS.PREFERRED_SUBTITLE_TRACK_LANGUAGE, profileUid1), preferences.textTrack);
                        } catch (error) {
                            store.dispatch((0, _useractions.storageWriteFailure)(error));
                        }
                        break;
                    }
                case _searchconstants.SAVE_SEARCHED_ITEM:
                    {
                        try {
                            var title = action.searchedItem.title;
                            if (title) {
                                saveSearchedItem(store, title);
                            }
                        } catch (error) {
                            store.dispatch((0, _useractions.storageWriteFailure)(error));
                        }
                        break;
                    }
                case _searchconstants.GET_SEARCHED_ITEM:
                    {
                        var searchedItems = getSearchedItems(store);
                        if (searchedItems) {
                            store.dispatch((0, _searchactions.updateSearchedItems)(searchedItems));
                        }
                        break;
                    }
                case _unpairactions.PAIRING_RESET:
                    {
                        (0, _pairingutils.setPairingMethod)(_pairingconstants.PAIRING_METHOD.NONE);
                        break;
                    }
                default:
            }
        };
    };
};


/***/ }),

/***/ 97070:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "ITEM_CONFIG", ({
    enumerable: true,
    get: function() {
        return ITEM_CONFIG;
    }
}));
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
var _mosaicCardcomponent = __webpack_require__(22772);
var _mosaicCardstyle = __webpack_require__(79478);
var ITEM_CONFIG = {
    services: {
        item: _mosaicCardcomponent.MosaicCard,
        sizes: _mosaicCardstyle.MOSAIC_CARD_SIZE
    },
    lives: {
        item: _mosaicCardcomponent.MosaicCard,
        sizes: _mosaicCardstyle.MOSAIC_CARD_SIZE
    },
    folders: {
        item: _mosaicCardcomponent.MosaicCard,
        sizes: _mosaicCardstyle.MOSAIC_CARD_SIZE
    }
};


/***/ }),

/***/ 20533:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "AbstractMosaic", ({
    enumerable: true,
    get: function() {
        return AbstractMosaic;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _create_super = __webpack_require__(6400);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(52318);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _constants = __webpack_require__(34952);
var _apputils = __webpack_require__(60368);
var _mosaicGridcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(3478));
var _abstractMosaicconnector = /*#__PURE__*/ _interop_require_default._(__webpack_require__(11958));
var _signals = __webpack_require__(2109);
var _ctaactions = __webpack_require__(32067);
var _abstractMosaicstyle = __webpack_require__(40497);
var _abstractMosaicutils = __webpack_require__(49914);
var _abstarctMosaicconstants = __webpack_require__(97070);
var AbstractMosaic = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(AbstractMosaic, _Lightning_Component);
    var _super = _create_super._(AbstractMosaic);
    function AbstractMosaic() {
        _class_call_check._(this, AbstractMosaic);
        return _super.apply(this, arguments);
    }
    _create_class._(AbstractMosaic, [
        {
            key: "_init",
            value: function _init() {
                this._style = _abstractMosaicstyle.defaultContext;
            }
        },
        {
            key: "_attach",
            value: function _attach() {
                this._unsubscribe = (0, _abstractMosaicconnector.default)(this);
            }
        },
        {
            key: "_active",
            value: function _active() {
                (0, _apputils.removeSplashScreen)();
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                if (this._unsubscribe) {
                    this._unsubscribe();
                    this._unsubscribe = null;
                }
            }
        },
        {
            key: "navigation",
            set: function set(entries) {
                if (!(entries && this._pageName)) {
                    return;
                }
                this.tag("Grid").data = {
                    items: (0, _abstractMosaicutils.filterNavigationEntries)(entries, this._pageName),
                    itemType: _abstarctMosaicconstants.ITEM_CONFIG[this._pageName].item,
                    itemSize: _abstarctMosaicconstants.ITEM_CONFIG[this._pageName].sizes[this._style.screenSize],
                    itemsPerRow: _abstarctMosaicconstants.ITEM_CONFIG[this._pageName].itemsPerRow
                };
            }
        },
        {
            key: "path",
            set: function set(value) {
                if (!value) {
                    return;
                }
                this._pageName = [
                    _constants.LIVES,
                    _constants.FOLDERS,
                    _constants.SERVICES
                ].find(function(item) {
                    return value.includes(item);
                });
            }
        },
        {
            key: "_handleSelected",
            value: function _handleSelected(item) {
                _lightningjsredux.default.dispatch((0, _ctaactions.createItemAction)({
                    item: _object_spread_props._(_object_spread._({}, item), {
                        action: item
                    })
                }));
            }
        },
        {
            key: "_getFocused",
            value: function _getFocused() {
                return this.tag("Grid");
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Background: {
                        rect: true
                    },
                    Grid: {
                        type: _mosaicGridcomponent.default,
                        signals: _define_property._({}, _signals.SELECTED_SIGNAL, "_handleSelected")
                    }
                }, (0, _abstractMosaicstyle.getInitialStyle)());
            }
        }
    ]);
    return AbstractMosaic;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 11958:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(52318);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _layoutselectors = __webpack_require__(53368);
var _routingselectors = __webpack_require__(2001);
var mapControllers = function(instance) {
    return {
        currentPath: {
            selector: _routingselectors.getCurrentPath,
            shouldBeInvokedOnConnect: true,
            callback: function(value) {
                instance.path = value;
            }
        },
        layoutNavigation: {
            selector: _layoutselectors.getLayoutNavigation,
            shouldBeInvokedOnConnect: true,
            callback: function(value) {
                instance.navigation = value;
            }
        }
    };
};
var _default = _lightningjsredux.default.control(mapControllers);


/***/ }),

/***/ 40497:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    LEFT_PADDING: function() {
        return LEFT_PADDING;
    },
    TOP_PADDING: function() {
        return TOP_PADDING;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getContentPadding: function() {
        return getContentPadding;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
var _define_property = __webpack_require__(21228);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(3009);
var _constants = __webpack_require__(34952);
var _theme = __webpack_require__(51397);
var _sidenavconstants = __webpack_require__(74842);
var _sizes = __webpack_require__(82699);
var _style = __webpack_require__(65082);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var LEFT_PADDING = (_obj = {}, _define_property._(_obj, _constants.HD, 96), _define_property._(_obj, _constants.FULL_HD, 192), _obj);
var _obj1;
var TOP_PADDING = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 160), _define_property._(_obj1, _constants.FULL_HD, 240), _obj1);
var colors = {
    background: (0, _theme.makeThemeColor)(_theme.TERTIARY)
};
var getContentPadding = function() {
    var hasSideNav = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, screenSize = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : undefined;
    var screenDimension = screenSize || (0, _sizes.getScreenSize)();
    return hasSideNav ? _sidenavconstants.WIDTH[screenDimension] + LEFT_PADDING[screenDimension] : LEFT_PADDING[screenDimension];
};
var getInitialStyle = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext, screenSize = _ref.screenSize, colorMode = _ref.colorMode;
    return {
        Background: {
            w: _sizes.SCREEN_WIDTH[screenSize],
            h: _sizes.SCREEN_HEIGHT[screenSize],
            color: colors.background[colorMode]
        },
        Grid: {
            x: getContentPadding(true, screenSize),
            y: TOP_PADDING[screenSize]
        }
    };
};


/***/ }),

/***/ 49914:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    filterNavigationEntries: function() {
        return filterNavigationEntries;
    },
    getImageUrl: function() {
        return getImageUrl;
    }
});
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(88801);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _fidosdk = __webpack_require__(19804);
var _constants = __webpack_require__(34952);
var _ctautils = __webpack_require__(42533);
var _sizes = __webpack_require__(82699);
var _mosaicCardstyle = __webpack_require__(79478);
var getImageUrl = function(item) {
    var screenSize = (0, _sizes.getScreenSize)();
    item.image.src = _fidosdk.imageService.getUrl(item.image.id, _mosaicCardstyle.MOSAIC_CARD_SIZE[screenSize].w, _mosaicCardstyle.MOSAIC_CARD_SIZE[screenSize].h, {
        fit: _constants.IMAGE_FIT_SCALE_CROP,
        quality: _constants.IMAGE_QUALITY,
        format: _constants.DEFAULT_IMAGE_FORMAT
    });
    return item;
};
var filterNavigationEntries = function(value, type) {
    var navigationEntry = (0, _get.default)(value, "entries", []).flatMap(function(entry) {
        return entry;
    }).find(function(item) {
        if ((0, _ctautils.getItemActionType)({
            action: item.entry
        }) === type) {
            var itemImage = (0, _get.default)(item, "subEntries[0].image");
            if (itemImage) {
                item.subEntries = itemImage.src ? item.subEntries : (0, _get.default)(item, "subEntries").map(function(item) {
                    return getImageUrl(item);
                });
            }
            return true;
        }
        return false;
    });
    return (0, _get.default)(navigationEntry, "subEntries", []);
};


/***/ }),

/***/ 92972:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/* eslint-disable no-console */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return App;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _get = __webpack_require__(60528);
var _get_prototype_of = __webpack_require__(35196);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _object_without_properties = __webpack_require__(46537);
var _sliced_to_array = __webpack_require__(28966);
var _create_super = __webpack_require__(6400);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(65759);
var _sdk = __webpack_require__(29956);
var _typography = __webpack_require__(18411);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _iconprovider = __webpack_require__(58449);
var _appsettings = __webpack_require__(20944);
var _routes = /*#__PURE__*/ _interop_require_default._(__webpack_require__(24439));
var _sidenavcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(48966));
var _sidenavconstants = __webpack_require__(74842);
var _appstyle = __webpack_require__(8827);
var _appconnector = /*#__PURE__*/ _interop_require_default._(__webpack_require__(74342));
var _popupContainercomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(30311));
var _popupContainerconstants = __webpack_require__(54258);
var _popupactions = __webpack_require__(47531);
var _popupsconstants = __webpack_require__(60952);
var _cookieConsentcomponent = __webpack_require__(72836);
var _screenSavercomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(19685));
var _screenSaverconstants = __webpack_require__(27009);
var _apputils = __webpack_require__(3613);
var _i18n = __webpack_require__(14910);
var _apputils1 = __webpack_require__(60368);
var _routesutils = __webpack_require__(14948);
var _screenSaveractions = __webpack_require__(90962);
var _analyticsutils = __webpack_require__(2693);
var _layoutactions = __webpack_require__(8424);
var _virtualization = __webpack_require__(11559);
var _newrelicerrorHandler = __webpack_require__(40339);
var _snackBarcomponent = __webpack_require__(20356);
var _default = /*#__PURE__*/ _interop_require_default._(__webpack_require__(38940));
var App = /*#__PURE__*/ function(_Router_App) {
    "use strict";
    _inherits._(App, _Router_App);
    var _super = _create_super._(App);
    function App() {
        _class_call_check._(this, App);
        return _super.apply(this, arguments);
    }
    _create_class._(App, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _appstyle.defaultContext;
            }
        },
        {
            key: "_setup",
            value: function _setup() {
                _sdk.Router.startRouter(_routes.default, this);
            }
        },
        {
            key: "_attach",
            value: function _attach() {
                this._unsubscribe = (0, _appconnector.default)(this);
                this.tag("ScreenSaver").resetTimer();
                (0, _apputils.patchKeyListener)(this);
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                if (this._unsubscribe) {
                    this._unsubscribe();
                    this._unsubscribe = null;
                }
                this._cleanup();
            }
        },
        {
            key: "isAppInitialized",
            set: function set(value) {
                this._isAppInitialized = value;
                if (value && !this._lifecyclesServise) {
                    this._lifecyclesServise = new _default.default();
                }
            }
        },
        {
            key: "isOpenedViaDeeplink",
            set: function set(value) {
                this._shouldNavigateToHomeOnBack = value;
            }
        },
        {
            key: "promptBeforeExitFeature",
            set: function set(value) {
                this._promptBeforeExitFeature = value;
            }
        },
        {
            key: "shouldDisplayCookieConsent",
            set: function set(value) {
                _lightningjsredux.default.dispatch((0, _screenSaveractions.setScreenSaverIsLocked)(value));
                if (value) {
                    this._setState("Widgets.CookieConsent");
                }
            }
        },
        {
            key: "popUp",
            set: function set(value) {
                if (value) {
                    this.tag("Popup").content = value;
                    _sdk.Router.focusWidget("Popup");
                }
            }
        },
        {
            key: "currentRoute",
            set: function set(value) {
                var livePath = "".concat(_routesutils.LIVE_PATH, "/");
                var videoPath = "".concat(_routesutils.VIDEO_PATH, "/");
                this._currentRoute = value;
                if (value.includes(livePath) || value.includes(videoPath)) {
                    this.patch({
                        color: _appstyle.colors.transparent
                    });
                }
            }
        },
        {
            key: "_captureKey",
            value: function _captureKey() {
                this.tag("ScreenSaver").resetTimer();
                return false;
            }
        },
        {
            key: "_handleLeft",
            value: function _handleLeft() {
                var sidenav = this.tag("Sidenav");
                var isNavigationActive = sidenav.visible && sidenav.isActive;
                if (!isNavigationActive) {
                    console.warn("[app] Navigation is not active");
                    return false;
                }
                var activeWidget = _sdk.Router.getActiveWidget();
                if (activeWidget && activeWidget.ref !== "Sidenav") {
                    return false;
                }
                this.tag("Pages").setSmooth("x", _sidenavconstants.EXPANDED_WIDTH[this._style.screenSize] - _sidenavconstants.WIDTH[this._style.screenSize], _sidenavconstants.animationConfig);
                _sdk.Router.focusWidget("Sidenav");
                return true;
            }
        },
        {
            // Should be triggered via fireAncestors by the children components
            key: "$notification",
            value: function $notification(notification) {
                this.tag("SnackBar").push(notification);
            }
        },
        {
            /**
   * Lighting SDK Router hook, will be executed when there is no routing history in stack
   */ key: "_handleAppClose",
            value: function _handleAppClose() {
                if (this._shouldNavigateToHomeOnBack && !_routesutils.DEEP_LINK_EXCLUSIONS.includes(this._currentRoute)) {
                    _sdk.Router.navigate(_routesutils.HOME_PATH);
                    return;
                }
                if (this._isAppInitialized && this._promptBeforeExitFeature) {
                    _lightningjsredux.default.dispatch((0, _popupactions.showPopupAction)(_popupsconstants.EXIT_POPUP_ID));
                } else {
                    this._handleExitApp();
                }
            }
        },
        {
            key: "_handleExitApp",
            value: function _handleExitApp() {
                this._cleanup();
                (0, _apputils.closeApp)(this.application);
            }
        },
        {
            key: "_cleanup",
            value: function _cleanup() {
                if (this._cleanupComplete) {
                    return;
                }
                console.log("[app.component] Shutting down analytics engines");
                (0, _analyticsutils.cleanupEngines)();
                console.log("[app.component] Removing redundant window globals added during the app lifecycle");
                (0, _apputils1.cleanupGlobals)();
                console.log("[app.component] Purging views virtualization cache");
                (0, _virtualization.cleanupVirtualizationCache)();
                (0, _iconprovider.cleanupIconsCache)();
                // TODO: cleanup other reducers if necessary
                console.log("[app.component] Purging layout API cache");
                _lightningjsredux.default.dispatch((0, _layoutactions.clearCache)());
                console.log("[app.component] Removing unsubscribed Redux observers");
                _lightningjsredux.default.cleanup();
                console.log("[app.component] Removing error handling observers");
                (0, _newrelicerrorHandler.unsubscribeThirdPartyErrorHandlers)();
                (0, _i18n.destroy)();
                (0, _apputils1.cleanupConfig)();
                this._cleanupComplete = true;
            }
        },
        {
            key: "_hidePopUp",
            value: function _hidePopUp() {
                this.tag("Popup").reset();
                _sdk.Router.restoreFocus();
            }
        },
        {
            key: "_handleRouteBack",
            value: function _handleRouteBack() {
                _sdk.Router.back();
                this._hidePopUp();
            }
        },
        {
            key: "_showScreensaver",
            value: function _showScreensaver() {
                if (this.tag("ScreenSaver").canBeShown) {
                    _sdk.Router.focusWidget("ScreenSaver");
                }
            }
        }
    ], [
        {
            key: "getFonts",
            value: function getFonts() {
                // FIXME: Ideally, we should support "graceful degradation" approach here: load woff2 and use woff as fallback
                // See https://github.com/rdkcentral/Lightning-SDK/issues/185
                return _typography.descriptors.map(function(_param) {
                    var url = _param.url, rest = _object_without_properties._(_param, [
                        "url"
                    ]);
                    return _object_spread._({
                        url: (0, _appsettings.getFullPath)(url)
                    }, rest);
                });
            }
        },
        {
            key: "_template",
            value: function _template() {
                var _obj, _obj1;
                return (0, _merge.default)(_object_spread_props._(_object_spread._({}, _get._(_get_prototype_of._(App), "_template", this).call(this)), {
                    rect: true,
                    forceZIndexContext: true,
                    Pages: {
                        zIndex: 0
                    },
                    Widgets: {
                        zIndex: 100,
                        forceZIndexContext: true,
                        Sidenav: {
                            type: _sidenavcomponent.default,
                            zIndex: 101
                        },
                        Popup: {
                            type: _popupContainercomponent.default,
                            zIndex: 103,
                            signals: (_obj = {}, _define_property._(_obj, _popupContainerconstants.EXIT_APP_SIGNAL, "_handleExitApp"), _define_property._(_obj, _popupContainerconstants.HIDE_POPUP_SIGNAL, "_hidePopUp"), _define_property._(_obj, _popupContainerconstants.ROUTE_BACK_SIGNAL, "_handleRouteBack"), _obj)
                        },
                        SnackBar: {
                            type: _snackBarcomponent.SnackBar,
                            zIndex: 104
                        },
                        CookieConsent: {
                            type: _cookieConsentcomponent.CookieConsent,
                            zIndex: 105
                        },
                        ScreenSaver: {
                            type: _screenSavercomponent.default,
                            zIndex: 106,
                            signals: (_obj1 = {}, _define_property._(_obj1, _screenSaverconstants.SHOW_SCREENSAVER_SIGNAL, "_showScreensaver"), _define_property._(_obj1, _screenSaverconstants.HIDE_SCREENSAVER_SIGNAL, "_hideScreensaver"), _obj1)
                        }
                    }
                }), (0, _appstyle.getInitialStyle)());
            }
        },
        {
            key: "_states",
            value: function _states() {
                var _get_call = _sliced_to_array._(_get._(_get_prototype_of._(App), "_states", this).call(this), 2), Loading = _get_call[0], WidgetsBaseState = _get_call[1];
                return [
                    Loading,
                    /*#__PURE__*/ function(WidgetsBaseState) {
                        _inherits._(Widgets, WidgetsBaseState);
                        var _super = _create_super._(Widgets);
                        function Widgets() {
                            _class_call_check._(this, Widgets);
                            return _super.apply(this, arguments);
                        }
                        _create_class._(Widgets, [
                            {
                                key: "currentWidgetRef",
                                get: function get() {
                                    return this._widget ? this._widget.ref : "";
                                }
                            },
                            {
                                /**
         * Switches from one widget to another while in the Widgets state
         * @override
         */ key: "reload",
                                value: function reload(widget) {
                                    this._previousWidgetRef = this.currentWidgetRef;
                                    _get._(_get_prototype_of._(Widgets.prototype), "reload", this).call(this, widget);
                                }
                            },
                            {
                                key: "_showScreensaver",
                                value: function _showScreensaver() {
                                    var currentWidgetRef = this.currentWidgetRef;
                                    if (currentWidgetRef === "Popup") {
                                        var popUpContainer = this.tag("Popup");
                                        if (_screenSaverconstants.BANNED_POPUPS.includes(popUpContainer.popupId)) {
                                            return;
                                        }
                                    }
                                    if (!_screenSaverconstants.BANNED_WIDGETS.includes(currentWidgetRef)) {
                                        _get._(_get_prototype_of._(Widgets.prototype), "_showScreensaver", this).call(this);
                                    }
                                }
                            },
                            {
                                key: "_hideScreensaver",
                                value: function _hideScreensaver() {
                                    var previousWidget = this._previousWidgetRef ? this.tag("Widgets.".concat(this._previousWidgetRef)) : null;
                                    if (previousWidget) {
                                        this.reload(previousWidget);
                                    } else {
                                        _sdk.Router.restoreFocus();
                                    }
                                }
                            },
                            {
                                key: "_handleRight",
                                value: function _handleRight() {
                                    _sdk.Router.restoreFocus();
                                }
                            },
                            {
                                key: "_handleKey",
                                value: function _handleKey() {
                                    return false;
                                }
                            },
                            {
                                key: "$exit",
                                value: function $exit() {
                                    // One of the possible reasons to exit the Widgets state is the Sidenav closing
                                    this.tag("Pages").setSmooth("x", 0, _sidenavconstants.animationConfig);
                                    // Since the focus restored on pages, resetting the screensaver as there is a possibility it was blocked by some widget
                                    this.tag("ScreenSaver").resetTimer();
                                    // This property is inherited from the Router's base app
                                    this._widget = null;
                                    this._previousWidgetRef = "";
                                }
                            }
                        ], [
                            {
                                key: "_states",
                                value: function _states() {
                                    return [
                                        /*#__PURE__*/ function(_this) {
                                            _inherits._(CookieConsent, _this);
                                            var _super = _create_super._(CookieConsent);
                                            function CookieConsent() {
                                                _class_call_check._(this, CookieConsent);
                                                return _super.apply(this, arguments);
                                            }
                                            _create_class._(CookieConsent, [
                                                {
                                                    key: "shouldDisplayCookieConsent",
                                                    set: function set(value) {
                                                        _lightningjsredux.default.dispatch((0, _screenSaveractions.setScreenSaverIsLocked)(value));
                                                        if (value) {
                                                            return;
                                                        }
                                                        // Cookie consent is hidden, checking if there is a pop-up on a background
                                                        var popUpContainer = this.tag("Popup");
                                                        if (popUpContainer.popupId) {
                                                            _sdk.Router.focusWidget("Popup");
                                                            // NOTE: this is mandatory when switching state from one Widget to another
                                                            this.reload(popUpContainer);
                                                        } else {
                                                            _sdk.Router.restoreFocus();
                                                        }
                                                    }
                                                },
                                                {
                                                    key: "popUp",
                                                    set: function set(value) {
                                                        if (value) {
                                                            // NOTE: setting the pop-up content only, without focus switching
                                                            this.tag("Popup").content = value;
                                                        }
                                                    }
                                                },
                                                {
                                                    key: "_hidePopUp",
                                                    value: function _hidePopUp() {
                                                        this.tag("Popup").reset();
                                                    }
                                                },
                                                {
                                                    key: "_getFocused",
                                                    value: function _getFocused() {
                                                        return this.tag("CookieConsent");
                                                    }
                                                }
                                            ]);
                                            return CookieConsent;
                                        }(this)
                                    ];
                                }
                            }
                        ]);
                        return Widgets;
                    }(WidgetsBaseState)
                ];
            }
        }
    ]);
    return App;
}(_sdk.Router.App);


/***/ }),

/***/ 74342:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(37815);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _gdprNoticeselectors = __webpack_require__(82369);
var _featuresselectors = __webpack_require__(76109);
var _popupselectors = __webpack_require__(47746);
var _appselectors = __webpack_require__(65910);
var _routingselectors = __webpack_require__(2001);
var mapControllers = function(instance) {
    return {
        promptBeforeExitFeature: {
            selector: _featuresselectors.getPromptBeforeExitFeature,
            callback: function(value) {
                instance.promptBeforeExitFeature = value;
            }
        },
        gdprNoticeVisibility: {
            selector: _gdprNoticeselectors.getGdprNoticeVisibility,
            callback: function(value) {
                instance.shouldDisplayCookieConsent = value;
            }
        },
        showPopup: {
            selector: _popupselectors.getPopupData,
            callback: function(value) {
                instance.popUp = value;
            }
        },
        isAppInitialized: {
            selector: _appselectors.isAppInitialized,
            shouldBeInvokedOnConnect: true,
            callback: function(value) {
                instance.isAppInitialized = value;
            }
        },
        isOpenedViaDeeplink: {
            selector: _routingselectors.isOpenedViaDeeplink,
            shouldBeInvokedOnConnect: true,
            callback: function(value) {
                instance.isOpenedViaDeeplink = value;
            }
        },
        currentRoute: {
            selector: _routingselectors.getCurrentRoute,
            callback: function(value) {
                instance.currentRoute = value;
            }
        }
    };
};
var _default = _lightningjsredux.default.control(mapControllers);


/***/ }),

/***/ 8827:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    HEIGHT: function() {
        return HEIGHT;
    },
    WIDTH: function() {
        return WIDTH;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
var _object_spread = __webpack_require__(76247);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(65759);
var _theme = __webpack_require__(51397);
var _colors = __webpack_require__(8426);
var _style = __webpack_require__(65082);
var _sizes = __webpack_require__(82699);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var WIDTH = _object_spread._({}, _sizes.SCREEN_WIDTH);
var HEIGHT = _object_spread._({}, _sizes.SCREEN_HEIGHT);
var colors = {
    background: (0, _theme.makeThemeColor)(_theme.TERTIARY),
    transparent: _colors.TRANSPARENT
};
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var screenSize = context.screenSize;
    return {
        color: colors.transparent,
        w: WIDTH[screenSize],
        h: HEIGHT[screenSize],
        Widgets: {
            SnackBar: {
                w: WIDTH[screenSize],
                y: HEIGHT[screenSize],
                mountY: 1
            }
        }
    };
};


/***/ }),

/***/ 3613:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    handleInteraction: function() {
        return handleInteraction;
    },
    showSnackbar: function() {
        return showSnackbar;
    }
});
var _export_star = __webpack_require__(37668);
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(45538);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _ctaconstants = /*#__PURE__*/ _interop_require_default._(__webpack_require__(77713));
var _ctaactions = __webpack_require__(32067);
var _ctautils = __webpack_require__(42533);
var _signals = __webpack_require__(2109);
var _virtualization = __webpack_require__(11559);
var _notifications = __webpack_require__(93831);
var _i18n = __webpack_require__(14910);
_export_star._(__webpack_require__(74106), exports);
_export_star._(__webpack_require__(91378), exports);
var showSnackbar = function(root, level, message) {
    root.fireAncestors("$".concat(_signals.NOTIFICATION_SIGNAL), (0, _notifications.makeNotification)(level, message));
};
var handleInteraction = function(item, root) {
    if (item && item.id && item.id !== _virtualization.PLACEHOLDER.id) {
        _lightningjsredux.default.dispatch((0, _ctaactions.createItemAction)({
            item: item
        }));
        var type = (0, _ctautils.getItemActionType)(item);
        if (type === _ctaconstants.default.BOOKMARK) {
            showSnackbar(root, _notifications.NOTIFICATION_LEVEL.SUCCESS, (0, _i18n.t)("bookmarks.added"));
        } else if (type === _ctaconstants.default.UNBOOKMARK) {
            showSnackbar(root, _notifications.NOTIFICATION_LEVEL.SUCCESS, (0, _i18n.t)("bookmarks.removed"));
        }
    }
};


/***/ }),

/***/ 29815:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "handleDeeplink", ({
    enumerable: true,
    get: function() {
        return handleDeeplink;
    }
}));
var _async_to_generator = __webpack_require__(24146);
var _interop_require_default = __webpack_require__(81200);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(88801);
var _config = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67958));
var _superagent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(54247));
var _routesutils = __webpack_require__(14948);
var DEEPLINK_REGEX = /\/((video-tv\/(filme|serien|live-tv|shows|live)\/(\S+)-(\d+))|((podcast|musik)\/(\S+)))/gi;
var DEFAULT_PATH = _routesutils.HOME_PATH;
var VOD_PREFIX = "clip_";
var redirect = function(path) {
    window.history.replaceState(null, document.title, "/".concat(window.location.search, "#").concat(path));
};
var patchPath = function(path) {
    if (!path.startsWith("video/")) {
        return path;
    }
    var id = path.split("/").pop();
    return "video/".concat(id.startsWith(VOD_PREFIX) ? id : "".concat(VOD_PREFIX).concat(id));
};
var handleDeeplink = function() {
    var _ref = _async_to_generator._(function(pathname, callback) {
        var path, result, deeplink, handler, error;
        return _ts_generator._(this, function(_state) {
            switch(_state.label){
                case 0:
                    path = pathname || document.location.pathname || "";
                    if (!(path && path.match(DEEPLINK_REGEX))) return [
                        3,
                        4
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        _superagent.default.get("".concat(_config.default.fido.baseUrlsByAPIType.linkConverter, "/internal-paths")).query({
                            "external-path": path
                        }).then(function(response) {
                            return response.body.internalPaths;
                        })
                    ];
                case 2:
                    result = _state.sent();
                    deeplink = result.find(function(param) {
                        var scopes = param.scopes;
                        return scopes.includes("rdk");
                    });
                    handler = callback || redirect;
                    handler(deeplink.path ? patchPath(deeplink.path) : DEFAULT_PATH);
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    // eslint-disable-next-line no-console
                    console.error("[deeplink] Can not handle deeplink request, rerouting to the home screen");
                    redirect(DEFAULT_PATH);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function handleDeeplink(pathname, callback) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 38093:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _export_star = __webpack_require__(37668);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(45538);
_export_star._(__webpack_require__(29815), exports);


/***/ }),

/***/ 74106:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "closeApp", ({
    enumerable: true,
    get: function() {
        return closeApp;
    }
}));
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(3009);
function closeApp() {
    window.close();
}


/***/ }),

/***/ 91378:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "patchKeyListener", ({
    enumerable: true,
    get: function() {
        return patchKeyListener;
    }
}));
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(65759);
var patchKeyListener = function(app) {
    var platform = app.stage.platform;
    var keyDownListener = platform._keydownListener.bind(platform);
    var keyUpListener = platform._keyupListener.bind(platform);
    platform._removeKeyHandler();
    platform._keydownListener = function(event) {
        event.preventDefault();
        keyDownListener(event);
    };
    platform._keyupListener = function(event) {
        event.preventDefault();
        keyUpListener(event);
    };
    window.addEventListener("keydown", platform._keydownListener);
    window.addEventListener("keyup", platform._keyupListener);
};


/***/ }),

/***/ 68560:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    AudioPlayer: function() {
        return AudioPlayer;
    },
    destroyAudioPlayer: function() {
        return destroyAudioPlayer;
    },
    getAudioPlayerInstance: function() {
        return getAudioPlayerInstance;
    },
    initAudioPlayer: function() {
        return initAudioPlayer;
    }
});
var _class_call_check = __webpack_require__(67818);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(88801);
var _html5engine = __webpack_require__(67681);
var _shakaengine = __webpack_require__(52418);
var _playerdispatcher = __webpack_require__(39020);
var AudioPlayer = /*#__PURE__*/ function(HTML5Engine) {
    "use strict";
    _inherits._(AudioPlayer, HTML5Engine);
    var _super = _create_super._(AudioPlayer);
    function AudioPlayer() {
        _class_call_check._(this, AudioPlayer);
        return _super.apply(this, arguments);
    }
    return AudioPlayer;
}(_html5engine.HTML5Engine);
var audioPlayer;
var currentPlayerId = null;
var getAudioPlayerInstance = function() {
    return audioPlayer;
};
var destroyAudioPlayer = function() {
    var id = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : currentPlayerId;
    var player = getAudioPlayerInstance();
    if (player) {
        player.release();
    }
    if (id) {
        var node = document.getElementById(id);
        try {
            if (node) {
                node.remove();
            }
        } finally{
            currentPlayerId = null;
        }
    }
    return true;
};
var initAudioPlayer = function() {
    var id = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "audio-player";
    if (document.getElementById(id)) {
        // eslint-disable-next-line no-console
        console.log("[AudioAdapter] Audio player node ".concat(id, " already exists, no need to init"));
        return;
    }
    destroyAudioPlayer(currentPlayerId);
    currentPlayerId = id;
    var isRadio = !id.startsWith("audio");
    audioPlayer = isRadio ? new _shakaengine.ShakaEngine() : new AudioPlayer();
    var element = document.createElement("audio");
    element.setAttribute("id", id);
    element.setAttribute("autoplay", true);
    // NOTE: despite it may fix CORS issues in a normal browser, on a contrary, it creates CORS issues on idempotent GET requests on STBs
    // element.setAttribute('crossorigin', 'anonymous');
    document.body.appendChild(element);
    if (isRadio) {
        // eslint-disable-next-line no-console
        console.log("[AudioAdapter] Initializing radio player");
        audioPlayer.init({
            dispatcher: _playerdispatcher.playerDispatcher,
            element: element
        });
    } else {
        audioPlayer.configure({
            dispatcher: _playerdispatcher.playerDispatcher
        });
        audioPlayer.init(element);
        audioPlayer.setEventListeners();
    }
};


/***/ }),

/***/ 64276:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "AudioPlayer", ({
    enumerable: true,
    get: function() {
        return AudioPlayer;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _sliced_to_array = __webpack_require__(28966);
var _create_super = __webpack_require__(6400);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(3009);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _fidosdk = __webpack_require__(19804);
var _constants = __webpack_require__(34952);
var _layoutactions = __webpack_require__(8424);
var _playeractions = __webpack_require__(90120);
var _playerconstants = __webpack_require__(7602);
var _controlsconstants = __webpack_require__(55197);
var _controlscomponent = __webpack_require__(92371);
var _progressBarconstants = __webpack_require__(88227);
var _spinnercomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(76976));
var _autoscrollcomponent = __webpack_require__(72209);
var _ctaactions = __webpack_require__(32067);
var _audioadapter = __webpack_require__(68560);
var _audioconnector = /*#__PURE__*/ _interop_require_default._(__webpack_require__(2875));
var _audiostyle = __webpack_require__(46322);
var _audioutils = __webpack_require__(96784);
var _audioconstants = __webpack_require__(23179);
var AudioPlayer = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(AudioPlayer, _Lightning_Component);
    var _super = _create_super._(AudioPlayer);
    function AudioPlayer() {
        _class_call_check._(this, AudioPlayer);
        return _super.apply(this, arguments);
    }
    _create_class._(AudioPlayer, [
        {
            key: "_build",
            value: function _build() {
                this._style = _audiostyle.defaultContext;
                this._coverOffset = 0;
                this._autoHideTimeout = null;
            }
        },
        {
            key: "_onUrlParams",
            value: function _onUrlParams(param) {
                var audioId = param.audioId;
                this._entityType = window.location.hash.replace("#", "").split("/").shift();
                this._entityId = audioId;
                (0, _audioadapter.initAudioPlayer)("".concat(this._entityType, "-player"));
                this._isResumed = this._clipId === this._entityId;
                this.tag("Controls").progressBarVariant = this._entityType === _fidosdk.LAYOUT_ENTITIES.radio ? _progressBarconstants.TIME_HIDDEN : _progressBarconstants.TIME_BELOW;
                if (this._isResumed) {
                    this.tag("Controls").showControls();
                    this.tag("Spinner").alpha = 0;
                    (0, _audioadapter.getAudioPlayerInstance)().play();
                    // NOTE: this will prevent the _refocus chain from activating in the subsequent components
                    _lightningjsredux.default.dispatch((0, _layoutactions.clearCache)(this._entityType, this._clipId, "main"));
                } else {
                    this.tag("Cover").alpha = _audiostyle.IMAGE_INITIAL_ALPHA;
                    this.tag("Spinner").setSmooth("alpha", 1);
                    this._onControlsHidden();
                    this.metadata = null;
                    _lightningjsredux.default.dispatch((0, _playerconstants.reset)());
                    _lightningjsredux.default.dispatch((0, _layoutactions.fetchLayout)(this._entityType, audioId));
                }
            }
        },
        {
            key: "_attach",
            value: function _attach() {
                this._unsubscribe = (0, _audioconnector.default)(this);
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                if (this._unsubscribe) {
                    this._unsubscribe();
                    this._unsubscribe = null;
                }
                this._playbackState = undefined;
                this._hasRelatedEpisodes = false;
                this.tag("Image").removeAllListeners("txLoaded");
            }
        },
        {
            key: "canPlay",
            set: function set(value) {
                if (value) {
                    this.tag("Controls").showControls();
                    this.tag("Spinner").setSmooth("alpha", 0);
                }
            }
        },
        {
            key: "playbackState",
            set: function set(value) {
                switch(value){
                    case _playerconstants.PLAYBACK_STATE_PLAYING:
                        this._setState("Playing");
                        break;
                    case _playerconstants.PLAYBACK_STATE_PAUSED:
                        this._setState("Paused");
                        break;
                    case _playerconstants.PLAYBACK_STATE_ENDED:
                        if (this._playbackState === _playerconstants.PLAYBACK_STATE_PLAYING || this._playbackState === _playerconstants.PLAYBACK_STATE_PAUSED) {
                            _sdk.Router.back();
                        }
                        break;
                    default:
                        break;
                }
                this._playbackState = value;
            }
        },
        {
            key: "isBuffering",
            set: function set(value) {
                this.tag("Spinner").setSmooth("alpha", value ? 1 : 0, {
                    delay: 1
                });
            }
        },
        {
            key: "metadata",
            set: function set(value) {
                var _this = this;
                this._clipId = (0, _get.default)(value, "video.id");
                var title = (0, _get.default)(value, "title") || "";
                var extraTitle = (0, _get.default)(value, "extraTitle") || "";
                var image = (0, _get.default)(value, "image.idsByRatio.1:1") || (0, _get.default)(value, "image.id") || "";
                var _this__style = this._style, screenSize = _this__style.screenSize, colorMode = _this__style.colorMode;
                var coverSize = _audiostyle.COVER_SIZE[screenSize];
                var imageSource = _fidosdk.imageService.getUrl(image, coverSize, coverSize, {
                    fit: _constants.IMAGE_FIT_SCALE_CROP,
                    quality: _constants.IMAGE_QUALITY,
                    format: _constants.DEFAULT_IMAGE_FORMAT
                });
                var patch = {
                    Content: {
                        Cover: {
                            Image: {
                                src: imageSource
                            }
                        },
                        Title: {
                            caption: title
                        },
                        ExtraTitle: {
                            caption: extraTitle
                        }
                    }
                };
                var offset = _audiostyle.COVER_SIZE[screenSize] + _audiostyle.IMAGE_MARGIN[screenSize];
                if (title) {
                    patch.Content.Title.y = offset;
                    offset += (0, _audiostyle.getTitleFont)(screenSize).lineHeight;
                }
                if (extraTitle) {
                    offset += _audiostyle.TEXT_MARGIN[screenSize];
                    patch.Content.ExtraTitle.y = offset;
                    offset += (0, _audiostyle.getExtraTitleFont)(screenSize).lineHeight;
                }
                this._coverOffset = (offset - _audiostyle.COVER_SIZE[screenSize]) / 2;
                patch.Content.h = offset;
                this.tag("Image").removeAllListeners("txLoaded");
                this.tag("Image").once("txLoaded", function() {
                    _this.tag("Cover").setSmooth("alpha", 1);
                    (0, _audioutils.getColors)(_this.stage, imageSource).catch(function() {
                        return [
                            _audiostyle.colors.background[colorMode],
                            _audiostyle.colors.background[colorMode]
                        ];
                    }).then(function(param) {
                        var _param = _sliced_to_array._(param, 2), bottom = _param[0], top = _param[1];
                        _this.tag("Background").patch({
                            smooth: {
                                colorTop: top,
                                colorBottom: bottom
                            }
                        });
                    });
                });
                this.patch(patch);
            }
        },
        {
            key: "hasRelatedEpisodes",
            set: function set(value) {
                this._hasRelatedEpisodes = value;
                this.tag("Controls").topBarItems = (0, _audioutils.getTopBarItems)({
                    hasRelatedEpisodes: this._hasRelatedEpisodes
                });
            }
        },
        {
            key: "_getFocused",
            value: function _getFocused() {
                return this.tag("Controls");
            }
        },
        {
            key: "_handleTopBarItemSelection",
            value: function _handleTopBarItemSelection(item) {
                var id = item && item.id || "";
                if (id === _audioconstants.TOP_BAR_ITEMS.BACK) {
                    _sdk.Router.back();
                } else if (id === _audioconstants.TOP_BAR_ITEMS.EPISODES) {
                    this.tag("Controls").showSideGlass();
                }
            }
        },
        {
            key: "_handleItemAction",
            value: function _handleItemAction(item) {
                (0, _ctaactions.dispatchItemAction)(item);
            }
        },
        {
            key: "_onControlsShown",
            value: function _onControlsShown() {
                this.patch((0, _audiostyle.getControlsVisibleStyle)(this._style.screenSize));
            }
        },
        {
            key: "_onControlsHidden",
            value: function _onControlsHidden() {
                this.patch((0, _audiostyle.getControlsHiddenStyle)(this._style.screenSize, this._coverOffset));
            }
        },
        {
            key: "_handleSeek",
            value: function _handleSeek(position) {
                (0, _audioadapter.getAudioPlayerInstance)().seek(position);
            }
        },
        {
            key: "start",
            value: function start() {
                _lightningjsredux.default.dispatch((0, _playeractions.fetchPlayerLayout)());
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                var _obj;
                return (0, _merge.default)({
                    Background: {
                        rect: true
                    },
                    Content: {
                        Cover: {
                            Shadow: {
                                type: _sdk.Lightning.components.FastBlurComponent
                            },
                            Image: {
                                shader: {
                                    type: _sdk.Lightning.shaders.RoundedRectangle
                                }
                            }
                        },
                        Title: {
                            type: _autoscrollcomponent.Autoscroll
                        },
                        ExtraTitle: {
                            type: _autoscrollcomponent.Autoscroll
                        }
                    },
                    Controls: {
                        type: _controlscomponent.Controls,
                        displayOverlayBackdrop: false,
                        displayOverlayTop: false,
                        displayMetadata: false,
                        progressBarVariant: _progressBarconstants.TIME_BELOW,
                        signals: (_obj = {}, _define_property._(_obj, _controlsconstants.SEEK_SIGNAL, "_handleSeek"), _define_property._(_obj, _controlsconstants.TOP_BAR_ITEM_SELECTED_SIGNAL, "_handleTopBarItemSelection"), _define_property._(_obj, _controlsconstants.SIDE_GLASS_ITEM_SELECTED_SIGNAL, "_handleItemAction"), _define_property._(_obj, _controlsconstants.CONTROLS_SHOW_SIGNAL, "_onControlsShown"), _define_property._(_obj, _controlsconstants.CONTROLS_HIDE_SIGNAL, "_onControlsHidden"), _obj),
                        topBarItems: (0, _audioutils.getTopBarItems)()
                    },
                    Spinner: {
                        type: _spinnercomponent.default
                    }
                }, (0, _audiostyle.getInitialStyle)());
            }
        },
        {
            key: "_states",
            value: function _states() {
                return [
                    /*#__PURE__*/ function(_this) {
                        _inherits._(Playing, _this);
                        var _super = _create_super._(Playing);
                        function Playing() {
                            _class_call_check._(this, Playing);
                            return _super.apply(this, arguments);
                        }
                        _create_class._(Playing, [
                            {
                                key: "_handlePauseControl",
                                value: function _handlePauseControl() {
                                    (0, _audioadapter.getAudioPlayerInstance)().pause();
                                    this.tag("Controls").show(_controlsconstants.PAUSED_STATE);
                                }
                            },
                            {
                                key: "_handlePlayPause",
                                value: function _handlePlayPause() {
                                    this._handlePauseControl();
                                    return true;
                                }
                            },
                            {
                                key: "_handleEnter",
                                value: function _handleEnter() {
                                    this._handlePauseControl();
                                    return true;
                                }
                            }
                        ]);
                        return Playing;
                    }(this),
                    /*#__PURE__*/ function(_this) {
                        _inherits._(Paused, _this);
                        var _super = _create_super._(Paused);
                        function Paused() {
                            _class_call_check._(this, Paused);
                            return _super.apply(this, arguments);
                        }
                        _create_class._(Paused, [
                            {
                                key: "$enter",
                                value: function $enter(param) {
                                    var prevState = param.prevState;
                                    if (prevState) {
                                        this.tag("Controls").showControls();
                                    }
                                }
                            },
                            {
                                key: "_handlePlayControl",
                                value: function _handlePlayControl() {
                                    (0, _audioadapter.getAudioPlayerInstance)().play();
                                    this.tag("Controls").show(_controlsconstants.PLAYING_STATE);
                                }
                            },
                            {
                                key: "_handlePlayPause",
                                value: function _handlePlayPause() {
                                    this._handlePlayControl();
                                    return true;
                                }
                            },
                            {
                                key: "_handleEnter",
                                value: function _handleEnter() {
                                    this._handlePlayControl();
                                    return true;
                                }
                            },
                            {
                                key: "_handleBack",
                                value: function _handleBack() {
                                    (0, _audioadapter.getAudioPlayerInstance)().pause();
                                    return false;
                                }
                            }
                        ]);
                        return Paused;
                    }(this)
                ];
            }
        }
    ]);
    return AudioPlayer;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 2875:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(52318);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _layoutselectors = __webpack_require__(53368);
var _playerselectors = __webpack_require__(83318);
var mapControllers = function(instance) {
    return [
        {
            selector: _playerselectors.getPlaybackState,
            shouldBeInvokedOnConnect: true,
            callback: function(value) {
                instance.playbackState = value;
            }
        },
        {
            selector: _layoutselectors.getCurrentLayout,
            shouldBeInvokedOnConnect: true,
            callback: function() {
                instance.start();
            }
        },
        {
            selector: _playerselectors.getCanPlay,
            shouldBeInvokedOnConnect: true,
            callback: function(value) {
                instance.canPlay = value;
            }
        },
        {
            selector: _playerselectors.getCurrentMetadataItem,
            shouldBeInvokedOnConnect: true,
            callback: function(value) {
                instance.metadata = value;
            }
        },
        {
            selector: _playerselectors.getSideGlassContent,
            shouldBeInvokedOnConnect: true,
            callback: function(value) {
                instance.hasRelatedEpisodes = Boolean(value);
            }
        },
        {
            selector: _playerselectors.getIsBuffering,
            shouldBeInvokedOnConnect: false,
            callback: function(value) {
                instance.isBuffering = Boolean(value);
            }
        }
    ];
};
var _default = _lightningjsredux.default.control(mapControllers);


/***/ }),

/***/ 23179:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "TOP_BAR_ITEMS", ({
    enumerable: true,
    get: function() {
        return TOP_BAR_ITEMS;
    }
}));
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
var TOP_BAR_ITEMS = {
    BACK: "BACK",
    EPISODES: "EPISODES"
};


/***/ }),

/***/ 46322:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    COVER_SIZE: function() {
        return COVER_SIZE;
    },
    IMAGE_INITIAL_ALPHA: function() {
        return IMAGE_INITIAL_ALPHA;
    },
    IMAGE_MARGIN: function() {
        return IMAGE_MARGIN;
    },
    SPINNER_SIZE: function() {
        return SPINNER_SIZE;
    },
    TEXT_MARGIN: function() {
        return TEXT_MARGIN;
    },
    TEXT_SHADOW_OFFSET_X: function() {
        return TEXT_SHADOW_OFFSET_X;
    },
    TEXT_SHADOW_OFFSET_Y: function() {
        return TEXT_SHADOW_OFFSET_Y;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getControlsHiddenStyle: function() {
        return getControlsHiddenStyle;
    },
    getControlsVisibleStyle: function() {
        return getControlsVisibleStyle;
    },
    getExtraTitleFont: function() {
        return getExtraTitleFont;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    getTitleFont: function() {
        return getTitleFont;
    }
});
var _define_property = __webpack_require__(21228);
var _object_spread = __webpack_require__(76247);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(45538);
var _constants = __webpack_require__(34952);
var _typography = __webpack_require__(18411);
var _theme = __webpack_require__(51397);
var _sdk = __webpack_require__(29956);
var _style = __webpack_require__(65082);
var _sizes = __webpack_require__(82699);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var COVER_SIZE = (_obj = {}, _define_property._(_obj, _constants.HD, 256), _define_property._(_obj, _constants.FULL_HD, 440), _obj);
var _obj1;
var SPINNER_SIZE = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 200), _define_property._(_obj1, _constants.FULL_HD, 200), _obj1);
var colors = {
    text: (0, _theme.makeThemeColor)(_theme.PRIMARY),
    shadow: (0, _theme.makeThemeColor)(_theme.TERTIARY),
    background: (0, _theme.makeThemeColor)(_theme.TERTIARY)
};
var TEXT_SHADOW_OFFSET_X = 0;
var TEXT_SHADOW_OFFSET_Y = 2;
var _obj2;
var IMAGE_MARGIN = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 16), _define_property._(_obj2, _constants.FULL_HD, 24), _obj2);
var _obj3;
var TEXT_MARGIN = (_obj3 = {}, _define_property._(_obj3, _constants.HD, 4), _define_property._(_obj3, _constants.FULL_HD, 4), _obj3);
var IMAGE_INITIAL_ALPHA = 0.0001;
var getTitleFont = function(screenSize) {
    return (0, _typography.getFont)(_typography.FONT.PARIS_3, screenSize);
};
var getExtraTitleFont = function(screenSize) {
    return (0, _typography.getFont)(_typography.FONT.KINSHASA_1, screenSize);
};
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var screenSize = context.screenSize, colorMode = context.colorMode;
    var w = _sizes.SCREEN_WIDTH[screenSize];
    var h = _sizes.SCREEN_HEIGHT[screenSize];
    var coverSize = COVER_SIZE[screenSize];
    var middleX = Math.round(w / 2);
    var middleY = Math.round(h / 2);
    var coverMiddle = Math.round(coverSize / 2);
    var commonTextConfig = {
        textColor: colors.text[colorMode],
        shadow: true,
        shadowColor: colors.shadow[colorMode],
        shadowOffsetX: TEXT_SHADOW_OFFSET_X,
        shadowOffsetY: TEXT_SHADOW_OFFSET_Y,
        textAlign: "center",
        maxLines: 1,
        maxLinesSuffix: "...",
        verticalAlign: "middle"
    };
    return {
        w: w,
        h: h,
        Background: {
            w: w,
            h: h,
            colorTop: colors.background[colorMode],
            colorBottom: colors.background[colorMode]
        },
        Content: {
            w: coverSize,
            h: coverSize,
            x: middleX,
            y: middleY,
            mount: 0.5,
            Cover: {
                alpha: IMAGE_INITIAL_ALPHA,
                w: coverSize,
                h: coverSize,
                Shadow: {
                    amount: 3,
                    mount: 0.5,
                    w: coverSize * 2,
                    h: coverSize * 2,
                    x: coverMiddle,
                    y: coverMiddle,
                    content: {
                        rect: true,
                        color: 0x2f000000,
                        x: coverMiddle,
                        y: coverMiddle + 16,
                        w: coverSize + 8,
                        h: coverSize + 8,
                        shader: {
                            type: _sdk.Lightning.shaders.RoundedRectangle,
                            radius: 8
                        }
                    }
                },
                Image: {
                    w: coverSize,
                    h: coverSize,
                    shader: {
                        radius: 8
                    }
                }
            },
            Title: {
                mountX: 0.5,
                x: _sizes.middle,
                w: w - _constants.safetyMargins.horizontal[screenSize] * 2,
                font: _object_spread._({}, getTitleFont(screenSize), commonTextConfig)
            },
            ExtraTitle: {
                mountX: 0.5,
                x: _sizes.middle,
                w: w - _constants.safetyMargins.horizontal[screenSize] * 2,
                font: _object_spread._({}, getExtraTitleFont(screenSize), commonTextConfig)
            }
        },
        Controls: {},
        Spinner: {
            alpha: 0,
            mount: 0.5,
            w: SPINNER_SIZE[screenSize],
            h: SPINNER_SIZE[screenSize],
            x: _sizes.middle,
            y: _sizes.middle
        }
    };
};
var getControlsVisibleStyle = function(screenSize) {
    return {
        Content: {
            smooth: {
                y: Math.round(_sizes.SCREEN_HEIGHT[screenSize] / 2)
            },
            Title: {
                smooth: {
                    alpha: 1
                }
            },
            ExtraTitle: {
                smooth: {
                    alpha: 1
                }
            }
        }
    };
};
var getControlsHiddenStyle = function(screenSize, coverOffset) {
    return {
        Content: {
            smooth: {
                y: Math.round(_sizes.SCREEN_HEIGHT[screenSize] / 2) + (coverOffset || 0)
            },
            Title: {
                smooth: {
                    alpha: 0
                }
            },
            ExtraTitle: {
                smooth: {
                    alpha: 0
                }
            }
        }
    };
};


/***/ }),

/***/ 96784:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    getColors: function() {
        return getColors;
    },
    getTopBarItems: function() {
        return getTopBarItems;
    }
});
var _sliced_to_array = __webpack_require__(28966);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
var _playerconstants = __webpack_require__(7602);
var _i18n = __webpack_require__(14910);
var _audioconstants = __webpack_require__(23179);
// eslint-disable-next-line no-bitwise
var toHex = function(red, green, blue) {
    return blue | green << 8 | red << 16;
};
var format = function(input, args) {
    var list = input.map(function(colors) {
        var _colors_split_map = _sliced_to_array._(colors.split(",").map(Number), 3), r = _colors_split_map[0], g = _colors_split_map[1], b = _colors_split_map[2];
        return 0xff000000 + toHex(r, g, b);
    });
    return args.amount === 1 || list.length === 1 ? list[0] : list;
};
var group = function(number, grouping) {
    var grouped = Math.round(number / grouping) * grouping;
    return Math.min(grouped, 255);
};
var extractProminentColors = function(data, args) {
    var colors = {};
    for(var i = 0; i < data.length; i += 40){
        var rgb = [
            group(data[i], args.group),
            group(data[i + 1], args.group),
            group(data[i + 2], args.group)
        ].join();
        colors[rgb] = colors[rgb] ? colors[rgb] + 1 : 1;
    }
    return format(Object.entries(colors).sort(function(param, param1) {
        var _param = _sliced_to_array._(param, 2), a = _param[1], _param1 = _sliced_to_array._(param1, 2), b = _param1[1];
        return a > b ? -1 : 1;
    }).slice(0, args.amount).map(function(param) {
        var _param = _sliced_to_array._(param, 1), rgb = _param[0];
        return rgb;
    }), args);
};
var getColors = function(stage, url) {
    return new Promise(function(resolve, reject) {
        var canvas = stage.platform.getDrawingCanvas();
        var context = canvas.getContext("2d");
        context.imageSmoothingEnabled = true;
        var image = new Image();
        image.onload = function() {
            var imageWidth = image.width;
            var imageHeight = image.height;
            canvas.width = Math.round(imageWidth);
            canvas.height = Math.round(imageHeight);
            context.drawImage(image, 0, 0, canvas.width, canvas.height);
            var data = context.getImageData(0, 0, canvas.width, canvas.height).data;
            resolve(extractProminentColors(data, {
                amount: 2,
                group: 15
            }));
        };
        image.onError = function(error) {
            reject(error);
        };
        image.crossOrigin = "Anonymous";
        image.src = url;
    });
};
var defaultTopBarItems = [
    {
        id: _audioconstants.TOP_BAR_ITEMS.BACK,
        icon: "ArrowLeftWithBase",
        text: (0, _i18n.t)("nav.backToNav"),
        action: _playerconstants.TOP_BAR_BACK
    },
    {
        id: _audioconstants.TOP_BAR_ITEMS.EPISODES,
        icon: "Chapter",
        text: (0, _i18n.t)("nav.episodes"),
        action: _playerconstants.TOP_BAR_RELATED_VIDEOS
    }
];
var getTopBarItems = function() {
    var hasRelatedEpisodes = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).hasRelatedEpisodes;
    return defaultTopBarItems.filter(function(param) {
        var id = param.id;
        switch(id){
            case _audioconstants.TOP_BAR_ITEMS.EPISODES:
                return hasRelatedEpisodes;
            default:
                return true;
        }
    });
};


/***/ }),

/***/ 72209:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "Autoscroll", ({
    enumerable: true,
    get: function() {
        return Autoscroll;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _create_super = __webpack_require__(6400);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(65759);
var _sdk = __webpack_require__(29956);
var _autoscrollshader = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34932));
var Autoscroll = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(Autoscroll, _Lightning_Component);
    var _super = _create_super._(Autoscroll);
    function Autoscroll() {
        _class_call_check._(this, Autoscroll);
        return _super.apply(this, arguments);
    }
    _create_class._(Autoscroll, [
        {
            key: "_attach",
            value: function _attach() {
                var _this = this;
                this._direction = -1;
                this.tag("Text").on("txLoaded", function() {
                    _this._updateInitialPosition();
                });
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                this.tag("Text").removeAllListeners("txLoaded");
                this._cleanupTransition();
                this._animation = null;
            }
        },
        {
            key: "font",
            set: function set(value) {
                this.patch({
                    Text: {
                        text: _object_spread._({}, value)
                    },
                    h: value && value.lineHeight || 0
                });
            }
        },
        {
            key: "caption",
            set: function set(value) {
                this.tag("Text").text.text = value;
            }
        },
        {
            key: "_cleanupTransition",
            value: function _cleanupTransition() {
                var transition = this.tag("Text").transition("x");
                if (transition) {
                    transition.stop();
                    transition.removeAllListeners("progress");
                    transition.removeAllListeners("finish");
                }
            }
        },
        {
            key: "_scroll",
            value: function _scroll() {
                var text = this.tag("Text");
                // t = S / v, here v = 16 pixels per second.
                var duration = (text.finalW - this.finalW) / 16;
                text.setSmooth("x", this._direction === -1 ? this.finalW - text.finalW : 0, {
                    timingFunction: "linear",
                    delay: 1,
                    duration: duration
                });
            }
        },
        {
            key: "_updateInitialPosition",
            value: function _updateInitialPosition() {
                var _this = this;
                var text = this.tag("Text");
                if (text.finalW <= this.finalW) {
                    text.x = Math.round((this.finalW - text.finalW) / 2);
                    this._cleanupTransition();
                    return;
                }
                text.x = 0;
                this._cleanupTransition();
                text.transition("x").on("progress", function(v) {
                    var offset = 0.22;
                    if (_this._direction === -1) {
                        _this.shader.bottom = 1 - Math.max(v - 1 + offset, 0) / offset;
                        _this.shader.top = Math.min(1 - offset + v, 1);
                    } else {
                        _this.shader.top = 1 - Math.max(v - 1 + offset, 0) / offset;
                        _this.shader.bottom = Math.min(1 - offset + v, 1);
                    }
                });
                text.transition("x").on("finish", function() {
                    _this._direction = _this._direction === -1 ? 1 : -1;
                    _this._scroll();
                });
                this._scroll();
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return {
                    rtt: true,
                    shader: {
                        type: _autoscrollshader.default,
                        top: 1
                    },
                    Text: {
                        text: {
                            wordWrap: false,
                            textOverflow: false
                        }
                    }
                };
            }
        }
    ]);
    return Autoscroll;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 34932:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return AutoscrollShader;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _get = __webpack_require__(60528);
var _get_prototype_of = __webpack_require__(35196);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(52318);
var _sdk = __webpack_require__(29956);
var AutoscrollShader = /*#__PURE__*/ function(_Lightning_shaders_WebGLDefaultShader) {
    "use strict";
    _inherits._(AutoscrollShader, _Lightning_shaders_WebGLDefaultShader);
    var _super = _create_super._(AutoscrollShader);
    function AutoscrollShader(context) {
        _class_call_check._(this, AutoscrollShader);
        var _this;
        _this = _super.call(this, context);
        _this._top = 1.0;
        _this._bottom = 1.0;
        return _this;
    }
    _create_class._(AutoscrollShader, [
        {
            key: "setupUniforms",
            value: function setupUniforms(operation) {
                _get._(_get_prototype_of._(AutoscrollShader.prototype), "setupUniforms", this).call(this, operation);
                this._setUniform("top", this._top, this.gl.uniform1f);
                this._setUniform("bottom", this._bottom, this.gl.uniform1f);
            }
        },
        {
            key: "top",
            get: function get() {
                return this._top;
            },
            set: function set(value) {
                this._top = value;
                this.redraw();
            }
        },
        {
            key: "bottom",
            get: function get() {
                return this._bottom;
            },
            set: function set(value) {
                this._bottom = value;
                this.redraw();
            }
        }
    ]);
    return AutoscrollShader;
}(_sdk.Lightning.shaders.WebGLDefaultShader);
AutoscrollShader.vertexShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    attribute vec2 aVertexPosition;\n    attribute vec2 aTextureCoord;\n    attribute vec4 aColor;\n\n    uniform vec2 projection;\n\n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n\n    void main(void){\n        gl_Position = vec4(aVertexPosition.x * projection.x - 1.0, aVertexPosition.y * -abs(projection.y) + 1.0, 0.0, 1.0);\n        vTextureCoord = aTextureCoord;\n        vColor = aColor;\n        gl_Position.y = -sign(projection.y) * gl_Position.y;\n    }\n";
AutoscrollShader.fragmentShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n\n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n\n    uniform sampler2D uSampler;\n    uniform float top;\n    uniform float bottom;\n\n    void main(void){\n        vec4 color = texture2D(uSampler, vTextureCoord) * vColor;\n\n        float size = 0.1;\n        float multiplier = 1.0 / size;\n\n        float topMask = 1.0 - max((size * top - vTextureCoord.x) * multiplier, 0.0);\n        float bottomMask = 1.0 - max((vTextureCoord.x - 1.0 + size * bottom) * multiplier, 0.0);\n\n        gl_FragColor = color * topMask * bottomMask;\n    }\n";


/***/ }),

/***/ 58967:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/* eslint-disable no-console */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "Page", ({
    enumerable: true,
    get: function() {
        return Page;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _sliced_to_array = __webpack_require__(28966);
var _create_super = __webpack_require__(6400);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
var _sdk = __webpack_require__(29956);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _layoutactions = __webpack_require__(8424);
var _layoututils = __webpack_require__(13598);
var _routingactions = __webpack_require__(78235);
var _abstractLayoutstyle = __webpack_require__(82357);
var _skeltonprovider = __webpack_require__(1966);
var _pageTransition = __webpack_require__(70813);
var _pageconnector = /*#__PURE__*/ _interop_require_default._(__webpack_require__(51669));
var _pagestyle = __webpack_require__(41352);
var _pageutils = __webpack_require__(8279);
var Page = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(Page, _Lightning_Component);
    var _super = _create_super._(Page);
    function Page() {
        _class_call_check._(this, Page);
        return _super.apply(this, arguments);
    }
    _create_class._(Page, [
        _define_property._({
            key: "_onUrlParams"
        }, "value", function _onUrlParams(params) {
            var entityType = params.entityType, entityId = params.entityId, historyState = params[_sdk.Router.symbols.historyState];
            // NOTE: Ensure history state is provided as early as possible so when a layout is set from a backtrack, it will be shifted to a correct position
            this._history = historyState;
            // NOTE: it will help to ensure that a new layout will not be applied to a previous page on backtrack
            Page.currentTarget = this.id;
            _lightningjsredux.default.dispatch((0, _layoutactions.fetchLayout)(entityType, entityId, historyState && historyState.query ? {
                query: historyState.query
            } : {}));
            _lightningjsredux.default.dispatch((0, _routingactions.setRouteSkeletonByEntity)(entityType, entityId));
        }),
        {
            key: "_construct",
            value: function _construct() {
                this._style = _pagestyle.defaultContext;
                this._entity = "";
                this._reuseRenderer = true;
            }
        },
        {
            key: "_build",
            value: function _build() {
                this._skeletonFadeAnimation = this.tag("Skeleton").animation({
                    duration: 0.5,
                    actions: [
                        {
                            p: "alpha",
                            v: {
                                0: 1,
                                1: 0
                            }
                        }
                    ],
                    stopMethod: "immediate"
                });
            }
        },
        {
            key: "_active",
            value: function _active() {
                var _this = this;
                this._unsubscribe = (0, _pageconnector.default)(this);
                this._skeletonFadeAnimation.on("finish", function() {
                    if (!_this._skeleton) {
                        _this.tag("Skeleton").children = [];
                    }
                });
            }
        },
        {
            key: "_inactive",
            value: function _inactive() {
                this._cleanup();
            }
        },
        {
            key: "historyState",
            value: function historyState(history) {
                if (history) {
                    this._history = history;
                }
                var renderer = this.tag("Renderer").children[0];
                if (renderer && typeof renderer.historyState === "function") {
                    return renderer.historyState(history);
                }
                return undefined;
            }
        },
        {
            key: "layout",
            set: function set(value) {
                var _this = this;
                if (!value) {
                    return;
                }
                // An ugly hack to avoid Lightning bug when a previous page is detached after
                // a new one is attached (and therefore the previous page may render the same layout as a new one)
                clearTimeout(this._layoutTimeout);
                this._layoutTimeout = setTimeout(function() {
                    if (!Page.currentTarget || Page.currentTarget === _this.id) {
                        _this._applyLayout(value);
                    }
                }, 0);
            }
        },
        {
            key: "skeleton",
            set: function set(value) {
                if (value && this._skeleton !== value) {
                    var skeleton = (0, _skeltonprovider.getSkeletonByConfig)(value);
                    this._skeletonFadeAnimation.stop();
                    if (skeleton) {
                        this.tag("Skeleton").patch({
                            alpha: 1,
                            children: [
                                skeleton
                            ]
                        });
                    }
                } else if (!value) {
                    if (this._skeletonFadeAnimation) {
                        this._skeletonFadeAnimation.start();
                    }
                }
                this._skeleton = value;
            }
        },
        {
            key: "hasSideNav",
            set: function set(value) {
                if (this._hasSideNav !== value) {
                    this._hasSideNav = value;
                    this._applyContentPadding();
                }
            }
        },
        {
            key: "pageTransition",
            value: function pageTransition(pageIn, pageOut) {
                return (0, _pageTransition.pageTransition)(pageIn, pageOut);
            }
        },
        {
            key: "_getFocused",
            value: function _getFocused() {
                return this.tag("Renderer").children[0];
            }
        },
        {
            key: "_applyLayout",
            value: function _applyLayout(value) {
                var entity = (0, _layoututils.getLayoutEntityAsString)(value);
                var isDifferentLayout = this._entity !== entity;
                this._entity = entity;
                var type = (0, _pageutils.getRenderer)(value);
                var _this_tag_children = _sliced_to_array._(this.tag("Renderer").children, 1), currentRenderer = _this_tag_children[0];
                if ((this._reuseRenderer || !isDifferentLayout) && currentRenderer instanceof type) {
                    currentRenderer.data = value;
                } else {
                    this.tag("Renderer").children = [
                        {
                            type: type,
                            h: _pagestyle.RENDERER_HEIGHT[this._style.screenSize]
                        }
                    ];
                    var renderer = this.tag("Renderer").children[0];
                    this._restoreHistory(renderer);
                    renderer.data = value;
                    this._refocus();
                }
            }
        },
        {
            key: "_applyContentPadding",
            value: function _applyContentPadding() {
                var value = (0, _abstractLayoutstyle.getContentPadding)(this._hasSideNav);
                this.tag("Skeleton").x = value;
            }
        },
        {
            key: "_restoreHistory",
            value: function _restoreHistory(renderer) {
                if (this._history && typeof renderer.historyState === "function") {
                    renderer.historyState(this._history);
                    this._history = undefined;
                }
            }
        },
        {
            key: "_cleanup",
            value: function _cleanup() {
                if (this._unsubscribe) {
                    this._unsubscribe();
                    this._unsubscribe = null;
                }
                clearTimeout(this._layoutTimeout);
                if (this._skeletonFadeAnimation) {
                    this._skeletonFadeAnimation.removeAllListeners("finish");
                }
                this._skeleton = null;
                this._skeletonFadeAnimation = null;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return {
                    Renderer: {},
                    Skeleton: {}
                };
            }
        }
    ]);
    return Page;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 51669:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(88801);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _layoutselectors = __webpack_require__(53368);
var _routingselectors = __webpack_require__(2001);
var mapControllers = function(instance) {
    return [
        {
            selector: _layoutselectors.getCurrentLayout,
            shouldBeInvokedOnConnect: true,
            callback: function(value) {
                instance.layout = value;
            }
        },
        {
            selector: _routingselectors.isTopLevelRoute,
            shouldBeInvokedOnConnect: true,
            callback: function(value) {
                instance.hasSideNav = value;
            }
        },
        {
            selector: _routingselectors.getRouteSkeleton,
            shouldBeInvokedOnConnect: true,
            callback: function(value) {
                instance.skeleton = value;
            }
        }
    ];
};
var _default = _lightningjsredux.default.control(mapControllers);


/***/ }),

/***/ 41352:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    RENDERER_HEIGHT: function() {
        return RENDERER_HEIGHT;
    },
    defaultContext: function() {
        return defaultContext;
    }
});
var _object_spread = __webpack_require__(76247);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(42578);
var _style = __webpack_require__(65082);
var _sizes = __webpack_require__(82699);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var RENDERER_HEIGHT = _object_spread._({}, _sizes.SCREEN_HEIGHT);


/***/ }),

/***/ 8279:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
// TODO: Adjust routing paths for LNG

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    getRenderer: function() {
        return getRenderer;
    },
    isEPG: function() {
        return isEPG;
    },
    isExploreCatalogue: function() {
        return isExploreCatalogue;
    },
    isProfilesGate: function() {
        return isProfilesGate;
    },
    isSearch: function() {
        return isSearch;
    }
});
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(3009);
var _fidosdk = __webpack_require__(19804);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _constants = __webpack_require__(34952);
var _profilesGatecomponent = __webpack_require__(95045);
var _abstractLayoutcomponent = __webpack_require__(65151);
var _searchcomponent = __webpack_require__(79467);
var _exploreCataloguecomponent = __webpack_require__(76194);
var isEPG = function(entityType, entityId) {
    return entityType === _constants.FRONTSPACE && entityId === _fidosdk.LAYOUT_FRONTSPACES.epggrid;
};
var isSearch = function(entityType, entityId) {
    return entityType === _constants.FRONTSPACE && entityId === _fidosdk.LAYOUT_FRONTSPACES.search;
};
var isProfilesGate = function(entityType, entityId) {
    return entityType === _fidosdk.LAYOUT_ENTITIES.frontspace && entityId === _fidosdk.LAYOUT_FRONTSPACES.profilesgate;
};
var isExploreCatalogue = function(entityType, entityId, areBlocksEmpty) {
    return entityType === _constants.FRONTSPACE && entityId === _fidosdk.LAYOUT_FRONTSPACES.bookmarks && areBlocksEmpty;
};
var getRenderer = function(layout) {
    var _ref = layout.entity || {}, entityType = _ref.type, entityId = _ref.id;
    var areBlocksEmpty = !(0, _get.default)(layout, "blocks.length");
    if (isProfilesGate(entityType, entityId)) {
        return _profilesGatecomponent.ProfilesGate;
    }
    if (isSearch(entityType, entityId)) {
        return _searchcomponent.Search;
    }
    if (isExploreCatalogue(entityType, entityId, areBlocksEmpty)) {
        return _exploreCataloguecomponent.ExploreCatalogue;
    }
    return _abstractLayoutcomponent.AbstractLayout;
};


/***/ }),

/***/ 70813:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "pageTransition", ({
    enumerable: true,
    get: function() {
        return pageTransition;
    }
}));
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(52318);
var pageTransition = function(pageIn, pageOut) {
    return new Promise(function(resolve) {
        pageIn.visible = true;
        if (pageOut) {
            pageOut.visible = false;
        }
        resolve();
    });
};


/***/ }),

/***/ 73731:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "ContextTitle", ({
    enumerable: true,
    get: function() {
        return ContextTitle;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _contextTitlestyle = __webpack_require__(87978);
var ContextTitle = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(ContextTitle, _Lightning_Component);
    var _super = _create_super._(ContextTitle);
    function ContextTitle() {
        _class_call_check._(this, ContextTitle);
        return _super.apply(this, arguments);
    }
    _create_class._(ContextTitle, [
        {
            key: "data",
            set: function set(value) {
                var title = (0, _get.default)(value, "metadata.title", "");
                this.tag("Rectangle").tag("Label").text = title;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Rectangle: {
                        Label: {}
                    }
                }, (0, _contextTitlestyle.getInitialStyle)());
            }
        }
    ]);
    return ContextTitle;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 87978:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    PICTO_HEIGHT: function() {
        return PICTO_HEIGHT;
    },
    RECTANGLE_HEIGHT: function() {
        return RECTANGLE_HEIGHT;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
var _memoize = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34736));
var _constants = __webpack_require__(34952);
var _theme = __webpack_require__(51397);
var _typography = __webpack_require__(18411);
var _style = __webpack_require__(65082);
var _sizes = __webpack_require__(82699);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var RECTANGLE_HEIGHT = (_obj = {}, _define_property._(_obj, _constants.HD, 88), _define_property._(_obj, _constants.FULL_HD, 88), _obj);
var _obj1;
var PICTO_HEIGHT = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 60), _define_property._(_obj1, _constants.FULL_HD, 60), _obj1);
var colors = {
    background: (0, _theme.makeThemeColor)(_theme.TERTIARY)
};
var getInitialStyle = (0, _memoize.default)(function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext, screenSize = _ref.screenSize, colorMode = _ref.colorMode;
    return {
        Rectangle: {
            rect: true,
            zIndex: 2,
            w: _sizes.SCREEN_WIDTH[screenSize],
            h: RECTANGLE_HEIGHT[screenSize],
            color: colors.background[colorMode],
            Label: {
                mount: 0.5,
                x: _sizes.middle,
                y: _sizes.middle,
                text: _object_spread._({}, (0, _typography.getFont)(_typography.FONT.OTTAWA_1, screenSize))
            }
        }
    };
});


/***/ }),

/***/ 56630:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "SHOW_PRIVACY_SETTINGS_SIGNAL", ({
    enumerable: true,
    get: function() {
        return SHOW_PRIVACY_SETTINGS_SIGNAL;
    }
}));
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(45538);
var SHOW_PRIVACY_SETTINGS_SIGNAL = "privacySettingsExit";


/***/ }),

/***/ 72836:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "CookieConsent", ({
    enumerable: true,
    get: function() {
        return CookieConsent;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(52318);
var _sdk = __webpack_require__(29956);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _gdprBannercomponent = __webpack_require__(40089);
var _privacySettingscomponent = __webpack_require__(6085);
var _privacySettingsconstants = __webpack_require__(75813);
var _gdprNoticeactions = __webpack_require__(18012);
var _analyticsutils = __webpack_require__(2693);
var _cookieConcentconstants = __webpack_require__(56630);
var CookieConsent = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(CookieConsent, _Lightning_Component);
    var _super = _create_super._(CookieConsent);
    function CookieConsent() {
        _class_call_check._(this, CookieConsent);
        return _super.apply(this, arguments);
    }
    _create_class._(CookieConsent, [
        {
            key: "_focus",
            value: function _focus() {
                this._setState("GdprBanner");
                this.patch({
                    alpha: 1
                });
            }
        },
        {
            key: "_unfocus",
            value: function _unfocus() {
                this.patch({
                    alpha: 0
                });
            }
        },
        {
            key: "_handleExitPrivacySettings",
            value: function _handleExitPrivacySettings() {
                _lightningjsredux.default.dispatch((0, _gdprNoticeactions.toggleGdprNotice)());
            }
        },
        {
            key: "_handleShowPrivacySettings",
            value: function _handleShowPrivacySettings() {
                (0, _analyticsutils.sendEvent)({
                    key: "pressCookieBannerSetupButton"
                });
                this._setState("Settings");
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return {
                    GdprBanner: {
                        visible: false,
                        type: _gdprBannercomponent.GdprBanner,
                        signals: _define_property._({}, _cookieConcentconstants.SHOW_PRIVACY_SETTINGS_SIGNAL, "_handleShowPrivacySettings")
                    },
                    Settings: {
                        visible: false,
                        type: _privacySettingscomponent.PrivacySettings,
                        signals: _define_property._({}, _privacySettingsconstants.PRIVACY_SETTINGS_EXIT_SIGNAL, "_handleExitPrivacySettings")
                    }
                };
            }
        },
        {
            key: "_states",
            value: function _states() {
                return [
                    /*#__PURE__*/ function(_this) {
                        _inherits._(GdprBanner, _this);
                        var _super = _create_super._(GdprBanner);
                        function GdprBanner() {
                            _class_call_check._(this, GdprBanner);
                            return _super.apply(this, arguments);
                        }
                        _create_class._(GdprBanner, [
                            {
                                key: "$enter",
                                value: function $enter() {
                                    this.tag("GdprBanner").visible = true;
                                    this.tag("Settings").visible = false;
                                }
                            },
                            {
                                key: "_getFocused",
                                value: function _getFocused() {
                                    return this.tag("GdprBanner");
                                }
                            }
                        ]);
                        return GdprBanner;
                    }(this),
                    /*#__PURE__*/ function(_this) {
                        _inherits._(Settings, _this);
                        var _super = _create_super._(Settings);
                        function Settings() {
                            _class_call_check._(this, Settings);
                            return _super.apply(this, arguments);
                        }
                        _create_class._(Settings, [
                            {
                                key: "_handleRight",
                                value: function _handleRight() {
                                    return true;
                                }
                            },
                            {
                                key: "$enter",
                                value: function $enter() {
                                    this.tag("GdprBanner").visible = false;
                                    this.tag("Settings").visible = true;
                                }
                            },
                            {
                                key: "_getFocused",
                                value: function _getFocused() {
                                    return this.tag("Settings");
                                }
                            }
                        ]);
                        return Settings;
                    }(this)
                ];
            }
        }
    ]);
    return CookieConsent;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 32067:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/* eslint-disable no-console */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    PRESS_BOOKMARKS_BUTTON: function() {
        return PRESS_BOOKMARKS_BUTTON;
    },
    PRESS_LOGOUT_BUTTON: function() {
        return PRESS_LOGOUT_BUTTON;
    },
    createItemAction: function() {
        return createItemAction;
    },
    dispatchItemAction: function() {
        return dispatchItemAction;
    }
});
var _async_to_generator = __webpack_require__(24146);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(3009);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _fidosdk = __webpack_require__(19804);
var _layoutselectors = __webpack_require__(53368);
var _pairingactions = __webpack_require__(83887);
var _layoutactions = __webpack_require__(8424);
var _bookmarkactions = __webpack_require__(21890);
var _routesutils = __webpack_require__(14948);
var _featuresselectors = __webpack_require__(76109);
var _analyticsutils = __webpack_require__(2693);
var _lockactions = __webpack_require__(75250);
var _playerconstants = __webpack_require__(7602);
var _tokenactions = __webpack_require__(99619);
var _playerselectors = __webpack_require__(83318);
var _errorconstants = __webpack_require__(22311);
var _erroractions = __webpack_require__(39258);
var _pairingutils = __webpack_require__(54264);
var _ctautils = __webpack_require__(42533);
var _ctaconstants = /*#__PURE__*/ _interop_require_default._(__webpack_require__(77713));
var PRESS_BOOKMARKS_BUTTON = "bookmarks/PRESS_BOOKMARKS_BUTTON";
var PRESS_LOGOUT_BUTTON = "logout/PRESS_LOGOUT_BUTTON";
var createItemAction = function(options) {
    var type = (0, _ctautils.getItemActionType)(options.item);
    var targetData = (0, _ctautils.getTargetData)(options.item);
    var section = (0, _ctautils.getSectionCode)(options.item);
    var event = options.analytics || (0, _ctautils.getItemAnalyticsEvent)(options.item);
    var id = targetData.id;
    var reload = (0, _ctautils.shouldRefreshAliasHome)(section, _lightningjsredux.default.getState());
    console.log("[CTA] Creating action for type: ".concat(type, ", id: ").concat(id, ", section: ").concat(section));
    switch(type){
        case _ctaconstants.default.AUDIO:
            {
                return function() {
                    (0, _analyticsutils.sendEvent)(event);
                    (0, _routesutils.navigateToAudioPage)(id);
                };
            }
        case _ctaconstants.default.RADIO:
            {
                return function() {
                    (0, _analyticsutils.sendEvent)(event);
                    (0, _routesutils.navigateToRadioPage)(id);
                };
            }
        case _ctaconstants.default.BOOKMARKS:
            // eslint-disable-next-line no-unused-vars
            return function(dispatch) {
                dispatch((0, _layoutactions.setCurrentSectionCode)(section));
                dispatch({
                    type: PRESS_BOOKMARKS_BUTTON
                });
                (0, _routesutils.navigateToBookmarksPage)();
            };
        case _ctaconstants.default.BOOKMARK:
            return function(dispatch) {
                return dispatch((0, _bookmarkactions.addBookmark)(options.item));
            };
        case _ctaconstants.default.UNBOOKMARK:
            return function(dispatch) {
                return dispatch((0, _bookmarkactions.removeBookmark)(options.item));
            };
        case _ctaconstants.default.CLOSE:
            return function(dispatch) {
                dispatch((0, _layoutactions.setCurrentSectionCode)(section));
                (0, _analyticsutils.sendEvent)(event);
                // dispatch(navigateToAliasHome());
                console.log("[CTA] Reloading Home on close");
                (0, _routesutils.navigateToAliasHome)({
                    reload: reload
                });
            };
        case _ctaconstants.default.FOLDER:
            return function(dispatch) {
                dispatch((0, _layoutactions.setCurrentSectionCode)(section));
                (0, _analyticsutils.sendEvent)(event);
                // dispatch(navigateToFolderPage(id));
                (0, _routesutils.navigateToFolderPage)(id);
            };
        case _ctaconstants.default.FOLDERS:
            return function(dispatch) {
                dispatch((0, _layoutactions.setCurrentSectionCode)(section));
                (0, _analyticsutils.sendEvent)(event);
                (0, _routesutils.navigateToFoldersPage)();
            };
        case _ctaconstants.default.FRONTSPACE:
            return function(dispatch) {
                // NOTE: The "offers" layout may change a section from "kids" to "main", leading to an unintended content unlocking
                if (id !== _fidosdk.LAYOUT_FRONTSPACES.offers) {
                    dispatch((0, _layoutactions.setCurrentSectionCode)(section));
                }
                (0, _analyticsutils.sendEvent)(event);
                (0, _routesutils.navigateToFrontspace)(id);
            };
        case _ctaconstants.default.PROFILES_GATE:
            return function(dispatch) {
                (0, _analyticsutils.sendEvent)(event);
                dispatch((0, _lockactions.clearAfterProfileChanged)());
                dispatch((0, _layoutactions.setNavigationAllowed)(false));
                console.log("[CTA] Reloading Home to get Profiles Gate");
                (0, _routesutils.navigateToAliasHome)({
                    reload: true
                });
            };
        case _ctaconstants.default.HOME_ALIAS:
            return function(dispatch) {
                dispatch((0, _layoutactions.setCurrentSectionCode)(section));
                (0, _analyticsutils.sendEvent)(event);
                // dispatch(navigateToAliasHome());
                console.log("[CTA] Reloading Home");
                (0, _routesutils.navigateToAliasHome)({
                    reload: reload
                });
            };
        case _ctaconstants.default.INFORMATION:
            return function(dispatch) {
                dispatch((0, _layoutactions.setCurrentSectionCode)(section));
                (0, _analyticsutils.sendEvent)(event);
                (0, _routesutils.navigateToInformationPage)();
            };
        case _ctaconstants.default.USAGE_TERMS:
            return function() {
                (0, _routesutils.navigateToUsageTermsPage)();
            };
        case _ctaconstants.default.SUBSCRIPTION_TERMS:
            return function(dispatch) {
                dispatch((0, _layoutactions.setCurrentSectionCode)(section));
                (0, _analyticsutils.sendEvent)(event);
            // TODO: navigate to Subscription Terms
            // dispatch(navigateToSubscriptionTermsPage());
            };
        case _ctaconstants.default.LEGAL_CONDITIONS:
            return function(dispatch) {
                dispatch((0, _layoutactions.setCurrentSectionCode)(section));
                (0, _analyticsutils.sendEvent)(event);
                (0, _routesutils.navigateToLegalConditionsPage)();
            };
        case _ctaconstants.default.PRIVACY_POLICY:
            return function() {
                (0, _routesutils.navigateToPrivacyPolicyPage)();
            };
        case _ctaconstants.default.LIVE:
            return function() {
                (0, _analyticsutils.sendEvent)(event);
                // TODO: navigate to Live
                (0, _routesutils.navigateToLivePage)(id);
            };
        case _ctaconstants.default.LIVES:
            return function(dispatch) {
                dispatch((0, _layoutactions.setCurrentSectionCode)(section));
                (0, _analyticsutils.sendEvent)(event);
                (0, _routesutils.navigateToLivesPage)();
            };
        case _ctaconstants.default.LOCK:
            (0, _analyticsutils.sendEvent)(event);
            return (0, _lockactions.handleLock)({
                item: options.item
            });
        case _ctaconstants.default.LOGOUT:
            return function() {
                var _ref = _async_to_generator._(function(dispatch, getState) {
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // eslint-disable-next-line no-console
                                console.log("[CTA] Handling logout action");
                                (0, _pairingutils.rememberSSIDeclined)();
                                return [
                                    4,
                                    dispatch((0, _pairingactions.logout)())
                                ];
                            case 1:
                                _state.sent();
                                dispatch({
                                    type: PRESS_LOGOUT_BUTTON
                                });
                                (0, _analyticsutils.sendEvent)({
                                    key: "pressLogoutButton"
                                });
                                dispatch((0, _lockactions.disableProfileAutoSelect)());
                                dispatch((0, _tokenactions.resetJwtProfile)());
                                dispatch((0, _layoutactions.clearCache)());
                                if ((0, _featuresselectors.getOpenCatalogFeature)(getState())) {
                                    dispatch((0, _layoutactions.fetchNavigation)("main"));
                                    (0, _routesutils.navigateToAliasHome)();
                                } else {
                                    (0, _routesutils.navigateToLandingPage)();
                                }
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(dispatch, getState) {
                    return _ref.apply(this, arguments);
                };
            }();
        case _ctaconstants.default.OPTOUT:
            return function() {
                (0, _routesutils.navigateToSettingsPage)();
            };
        case _ctaconstants.default.PROFILE:
            return function(dispatch) {
                dispatch((0, _layoutactions.setCurrentSectionCode)(section));
                (0, _analyticsutils.sendEvent)(event);
                // dispatch(navigateToProfilePage());
                (0, _routesutils.navigateToProfilePage)();
            };
        case _ctaconstants.default.PROGRAM:
            return function(dispatch) {
                dispatch((0, _layoutactions.setCurrentSectionCode)(section));
                (0, _analyticsutils.sendEvent)(event);
                (0, _routesutils.navigateToProgramPage)(id);
            };
        case _ctaconstants.default.SEASON:
            return function(dispatch) {
                dispatch((0, _layoutactions.setCurrentSectionCode)(section));
                (0, _analyticsutils.sendEvent)(event);
                (0, _routesutils.navigateToSeasonPage)(id);
            };
        case _ctaconstants.default.SEARCH:
            return function(dispatch) {
                dispatch((0, _layoutactions.setCurrentSectionCode)(section));
                (0, _analyticsutils.sendEvent)(event);
                (0, _routesutils.navigateToSearchPage)();
            };
        case _ctaconstants.default.SERVICE:
            return function(dispatch) {
                dispatch((0, _layoutactions.setCurrentSectionCode)(section));
                (0, _analyticsutils.sendEvent)(event);
                // dispatch(navigateToServicePage(id));
                (0, _routesutils.navigateToServicePage)(id);
            };
        case _ctaconstants.default.SERVICES:
            return function(dispatch) {
                dispatch((0, _layoutactions.setCurrentSectionCode)(section));
                (0, _analyticsutils.sendEvent)(event);
                (0, _routesutils.navigateToServicesPage)();
            };
        case _ctaconstants.default.VIDEO:
            return function() {
                (0, _analyticsutils.sendEvent)(event);
                (0, _routesutils.navigateToVodPage)(id);
            };
        case _ctaconstants.default.HELP:
            return function(dispatch) {
                dispatch((0, _layoutactions.setCurrentSectionCode)(section));
                (0, _analyticsutils.overrideGAPageName)("main_App_help");
                (0, _analyticsutils.sendEvent)(event);
                (0, _routesutils.navigateToFAQPage)();
            };
        case _ctaconstants.default.FEEDBACK:
            return function(dispatch) {
                dispatch((0, _layoutactions.setCurrentSectionCode)(section));
                (0, _analyticsutils.overrideGAPageName)("main_App_feedback");
                (0, _analyticsutils.sendEvent)(event);
                (0, _routesutils.navigateToFeedbackPage)();
            };
        case _ctaconstants.default.ACCOUNT_SETTINGS:
            return function(dispatch) {
                dispatch((0, _layoutactions.setCurrentSectionCode)(section));
                (0, _analyticsutils.sendEvent)(event);
                (0, _routesutils.navigateToAccountSettingsPage)();
            };
        case _ctaconstants.default.PLAY:
            return function(dispatch, getState) {
                var state = _lightningjsredux.default.getState();
                var layout = (0, _layoutselectors.getCurrentLayout)(state);
                var entityType = (0, _layoutselectors.getRequestedEntityType)(state);
                dispatch((0, _playerconstants.setPlayerInitialized)(_object_spread._({
                    layout: layout,
                    isLive: entityType === _fidosdk.LAYOUT_ENTITIES.live,
                    entityType: entityType
                }, options)));
                var source = (0, _playerselectors.getVideoSource)(getState());
                if (!source) {
                    dispatch((0, _erroractions.errorAction)(_errorconstants.ERROR_LEVELS.FATAL, _errorconstants.ERROR_TYPES.PLAYER, "No sources available"));
                }
            };
        default:
    }
    return null;
};
var dispatchItemAction = function(item) {
    if (!item) {
        return;
    }
    var action = createItemAction({
        item: item
    });
    if (action) {
        _lightningjsredux.default.dispatch(action);
    }
};


/***/ }),

/***/ 77713:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(42578);
var _constants = __webpack_require__(34952);
var _default = {
    AUDIO: _constants.AUDIO,
    ACCOUNT_SETTINGS: _constants.ACCOUNT_SETTINGS,
    BOOKMARK: _constants.BOOKMARK,
    BOOKMARKS: _constants.BOOKMARKS,
    UNBOOKMARK: _constants.UNBOOKMARK,
    LIVE: _constants.LIVE,
    LIVES: _constants.LIVES,
    PROGRAM: _constants.PROGRAM,
    SEASON: _constants.SEASON,
    VIDEO: _constants.VIDEO,
    SERVICE: _constants.SERVICE,
    HOME_ALIAS: _constants.HOME_ALIAS,
    SERVICES: _constants.SERVICES,
    PROFILE: _constants.PROFILE,
    SEARCH: _constants.SEARCH,
    SETTINGS: _constants.SETTINGS,
    USAGE_TERMS: _constants.USAGE_TERMS,
    SUBSCRIPTION_TERMS: _constants.SUBSCRIPTION_TERMS,
    LEGAL_CONDITIONS: _constants.LEGAL_CONDITIONS,
    PRIVACY_POLICY: _constants.PRIVACY_POLICY,
    FOLDERS: _constants.FOLDERS,
    FOLDER: _constants.FOLDER,
    INFORMATION: _constants.INFORMATION,
    CLOSE: _constants.CLOSE,
    OPTOUT: _constants.OPTOUT,
    LOCK: _constants.LOCK,
    LOGOUT: _constants.LOGOUT,
    FRONTSPACE: _constants.FRONTSPACE,
    HELP: _constants.HELP,
    FEEDBACK: _constants.FEEDBACK,
    PROFILES_GATE: _constants.PROFILES_GATE,
    PLAY: _constants.PLAY,
    RADIO: _constants.RADIO
};


/***/ }),

/***/ 42533:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    getItemActionType: function() {
        return getItemActionType;
    },
    getItemAnalyticsEvent: function() {
        return getItemAnalyticsEvent;
    },
    getItemTargetValue: function() {
        return getItemTargetValue;
    },
    getSectionCode: function() {
        return getSectionCode;
    },
    getTargetData: function() {
        return getTargetData;
    },
    shouldRefreshAliasHome: function() {
        return shouldRefreshAliasHome;
    },
    shouldStoreVideoRoute: function() {
        return shouldStoreVideoRoute;
    }
});
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _constants = __webpack_require__(34952);
var _ctaconstants = /*#__PURE__*/ _interop_require_default._(__webpack_require__(77713));
var _layoutselectors = __webpack_require__(53368);
var getItemTargetValue = function(target) {
    return Object.keys(target).filter(function(value) {
        return value.includes("value_");
    })[0];
};
var getItemAnalyticsEvent = function(item) {
    return (0, _get.default)(item, "action.analytics", (0, _get.default)(item, "analytics"));
};
var shouldRefreshAliasHome = function(section, state) {
    var currentSectionCode = (0, _layoutselectors.getCurrentSectionCode)(state);
    return section !== currentSectionCode;
};
var getItemActionType = function(item) {
    if (!item) {
        return null;
    }
    var target = item.action ? item.action.target : item.target;
    if (!target) {
        return item.id;
    }
    var targetValue = getItemTargetValue(target);
    var metadata = target[targetValue];
    var type = metadata.type || metadata.reference || target.type;
    if (type === _constants.FRONTSPACE && metadata.id === _constants.PROFILES_GATE) {
        return _ctaconstants.default.PROFILES_GATE;
    }
    return type;
};
var getTargetData = function(item) {
    var target = (0, _get.default)(item, "action.target");
    if (!target) {
        return {
            id: item.id
        };
    }
    var targetValue = getItemTargetValue(target);
    return target[targetValue];
};
var getSectionCode = function(item) {
    var target = (0, _get.default)(item, "action.target");
    try {
        var targetTypeMap = {
            layout: "value_layout"
        };
        var targetValue = targetTypeMap[target.type] || "value_app";
        var section = target[targetValue].section;
        return section;
    } catch (e) {
        return null;
    }
};
var shouldStoreVideoRoute = function(hash) {
    return !/\/video\/.+/.test(hash);
};


/***/ }),

/***/ 70362:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "DeviceGate", ({
    enumerable: true,
    get: function() {
        return DeviceGate;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _sdk = __webpack_require__(29956);
var _unpairactions = __webpack_require__(21219);
var _apputils = __webpack_require__(60368);
var _layoutactions = __webpack_require__(8424);
var _routesutils = __webpack_require__(14948);
var _brandIconcomponent = __webpack_require__(362);
var _buttoncomponent = __webpack_require__(31464);
var _deviceGatestyle = __webpack_require__(16805);
var _deviceGateconnector = /*#__PURE__*/ _interop_require_default._(__webpack_require__(83729));
var _i18n = __webpack_require__(14910);
var DeviceGate = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(DeviceGate, _Lightning_Component);
    var _super = _create_super._(DeviceGate);
    function DeviceGate() {
        _class_call_check._(this, DeviceGate);
        return _super.apply(this, arguments);
    }
    _create_class._(DeviceGate, [
        {
            key: "_construct",
            value: function _construct() {
                this._index = 0;
            }
        },
        {
            key: "_active",
            value: function _active() {
                (0, _apputils.removeSplashScreen)();
                this._unsubscribe = (0, _deviceGateconnector.default)(this);
            }
        },
        {
            key: "_inactive",
            value: function _inactive() {
                if (this._unsubscribe) {
                    this._unsubscribe();
                    this._unsubscribe = null;
                }
            }
        },
        {
            key: "deeplink",
            set: function set(value) {
                this._deeplink = value;
            }
        },
        {
            key: "_getFocused",
            value: function _getFocused() {
                return this.tag("Buttons").children[this._index];
            }
        },
        {
            key: "_handleLeft",
            value: function _handleLeft() {
                this._index = Math.max(this._index - 1, 0);
                return true;
            }
        },
        {
            key: "_handleRight",
            value: function _handleRight() {
                this._index = Math.min(this._index + 1, 1);
                return true;
            }
        },
        {
            key: "_handleEnter",
            value: function _handleEnter() {
                if (this._index) {
                    _lightningjsredux.default.dispatch((0, _unpairactions.logout)()).finally(function() {
                        _lightningjsredux.default.dispatch((0, _layoutactions.fetchNavigation)("main"));
                        (0, _routesutils.navigateToAliasHome)(false);
                    });
                } else {
                    (0, _routesutils.navigateTo)(this._deeplink || _routesutils.HOME_PATH, false);
                }
                return true;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Background: {},
                    Logo: {
                        type: _brandIconcomponent.BrandIcon
                    },
                    Container: {
                        Title: {
                            text: {
                                text: (0, _i18n.t)("pairing.devicesGate.title")
                            }
                        },
                        Description: {
                            text: {
                                text: (0, _i18n.t)("pairing.devicesGate.description")
                            }
                        },
                        Buttons: {
                            Retry: {
                                type: _buttoncomponent.Button,
                                label: (0, _i18n.t)("error.retry")
                            },
                            Logout: {
                                type: _buttoncomponent.Button,
                                label: (0, _i18n.t)("pairing.welcome.disconnect")
                            }
                        }
                    }
                }, (0, _deviceGatestyle.getInitialStyle)());
            }
        }
    ]);
    return DeviceGate;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 83729:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(88801);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _routingselectors = __webpack_require__(2001);
var mapControllers = function(instance) {
    return [
        {
            selector: _routingselectors.getDeepLink,
            callback: function(value) {
                instance.deeplink = value;
            },
            shouldBeInvokedOnConnect: true
        }
    ];
};
var _default = _lightningjsredux.default.control(mapControllers);


/***/ }),

/***/ 16805:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    GAP: function() {
        return GAP;
    },
    LOGO_HEIGHT: function() {
        return LOGO_HEIGHT;
    },
    TEXT_GAP: function() {
        return TEXT_GAP;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    getWordWrapWidth: function() {
        return getWordWrapWidth;
    }
});
var _define_property = __webpack_require__(21228);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(37815);
var _constants = __webpack_require__(34952);
var _theme = __webpack_require__(51397);
var _typography = __webpack_require__(18411);
var _style = __webpack_require__(65082);
var _sizes = __webpack_require__(82699);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var GAP = (_obj = {}, _define_property._(_obj, _constants.HD, 24), _define_property._(_obj, _constants.FULL_HD, 32), _obj);
var _obj1;
var TEXT_GAP = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 8), _define_property._(_obj1, _constants.FULL_HD, 16), _obj1);
var _obj2;
var LOGO_HEIGHT = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 40), _define_property._(_obj2, _constants.FULL_HD, 56), _obj2);
var getWordWrapWidth = function(screenSize) {
    return Math.round(_sizes.SCREEN_WIDTH[screenSize] * 0.75);
};
var colors = {
    text: (0, _theme.makeThemeColor)(_theme.PRIMARY),
    background: (0, _theme.makeThemeColor)(_theme.TERTIARY)
};
var getInitialStyle = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext, screenSize = _ref.screenSize, colorMode = _ref.colorMode;
    var w = _sizes.SCREEN_WIDTH[screenSize];
    var h = _sizes.SCREEN_HEIGHT[screenSize];
    var textColor = colors.text[colorMode];
    var wordWrapWidth = getWordWrapWidth(screenSize);
    return {
        w: w,
        h: h,
        color: colors.background,
        Background: {
            w: w,
            h: h
        },
        Logo: {
            mountX: 0.5,
            x: _sizes.middle,
            y: _constants.safetyMargins.vertical[screenSize],
            h: LOGO_HEIGHT[screenSize]
        },
        Container: {
            w: w,
            h: h,
            flex: {
                direction: "column",
                alignItems: "center",
                justifyContent: "center"
            },
            Title: {
                text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT.KINSHASA_3)), {
                    textColor: textColor,
                    wordWrapWidth: wordWrapWidth,
                    textAlign: "center",
                    maxLines: 2
                }),
                flexItem: {
                    marginBottom: TEXT_GAP[screenSize]
                }
            },
            Description: {
                text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT.OTTAWA_1)), {
                    textColor: textColor,
                    wordWrapWidth: wordWrapWidth,
                    textAlign: "center",
                    maxLines: 5
                }),
                flexItem: {
                    marginBottom: TEXT_GAP[screenSize]
                }
            },
            Buttons: {
                flex: {
                    direction: "row"
                },
                flexItem: {
                    marginTop: GAP[screenSize],
                    marginBottom: GAP[screenSize]
                },
                Retry: {
                    flexItem: {
                        marginRight: GAP[screenSize]
                    }
                },
                Logout: {}
            }
        }
    };
};


/***/ }),

/***/ 98154:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return DeviceInfoBar;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(45538);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _utils = __webpack_require__(64188);
var _deviceInfoBarstyle = __webpack_require__(80709);
var _deviceInfoBarconnector = /*#__PURE__*/ _interop_require_default._(__webpack_require__(52067));
var DeviceInfoBar = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(DeviceInfoBar, _Lightning_Component);
    var _super = _create_super._(DeviceInfoBar);
    function DeviceInfoBar() {
        _class_call_check._(this, DeviceInfoBar);
        return _super.apply(this, arguments);
    }
    _create_class._(DeviceInfoBar, [
        {
            key: "deviceVersion",
            set: function set(value) {
                this._deviceVersion = value;
                this.setDeviceVersion();
            }
        },
        {
            key: "deviceBrand",
            set: function set(value) {
                this._deviceBrand = value;
                this.setDeviceVersion();
            }
        },
        {
            key: "deviceModel",
            set: function set(value) {
                this._deviceModel = value;
                this.setDeviceVersion();
            }
        },
        {
            key: "setDeviceVersion",
            value: function setDeviceVersion() {
                var view = this.tag("DeviceVersion");
                try {
                    var matches = navigator.userAgent.match(/MN=([a-zA-Z0-9]*);/);
                    var userAgentModel = matches && matches[1] || "";
                    var deviceModel = this._deviceModel || userAgentModel;
                    var deviceVersion = this._deviceVersion || [
                        this._deviceBrand,
                        deviceModel
                    ].filter(Boolean).join(" ");
                    view.text.text = "Device: ".concat(deviceVersion);
                } catch (error) {
                    view.text.text = "";
                }
            }
        },
        {
            key: "_attach",
            value: function _attach() {
                this._unsubscribe = (0, _deviceInfoBarconnector.default)(this);
                this.tag("AppVersion").text.text = "App: ".concat(_utils.appVersion);
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                if (this._unsubscribe) {
                    this._unsubscribe();
                    this._unsubscribe = null;
                }
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    DeviceVersion: {
                        text: {}
                    },
                    AppVersion: {
                        text: {}
                    }
                }, (0, _deviceInfoBarstyle.getInitialStyle)());
            }
        }
    ]);
    return DeviceInfoBar;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 52067:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(3009);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _appselectors = __webpack_require__(65910);
var mapControllers = function(instance) {
    return {
        deviceVersion: {
            selector: _appselectors.getDeviceVersion,
            shouldBeInvokedOnConnect: true,
            callback: function(value) {
                instance.deviceVersion = value;
            }
        },
        deviceBrand: {
            selector: _appselectors.getDeviceBrand,
            shouldBeInvokedOnConnect: true,
            callback: function(value) {
                instance.deviceBrand = value;
            }
        },
        deviceModel: {
            selector: _appselectors.getDeviceModel,
            shouldBeInvokedOnConnect: true,
            callback: function(value) {
                instance.deviceModel = value;
            }
        }
    };
};
var _default = _lightningjsredux.default.control(mapControllers);


/***/ }),

/***/ 80709:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    CONTENT_HEIGHT: function() {
        return CONTENT_HEIGHT;
    },
    CONTENT_WIDTH: function() {
        return CONTENT_WIDTH;
    },
    OFFSET_BOTTOM: function() {
        return OFFSET_BOTTOM;
    },
    OFFSET_RIGHT: function() {
        return OFFSET_RIGHT;
    },
    TEXT_COLOR: function() {
        return TEXT_COLOR;
    },
    getInfoBarOffsetX: function() {
        return getInfoBarOffsetX;
    },
    getInfoBarOffsetY: function() {
        return getInfoBarOffsetY;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(45538);
var _constants = __webpack_require__(34952);
var _theme = __webpack_require__(51397);
var _typography = __webpack_require__(18411);
var _style = __webpack_require__(65082);
var _sizes = __webpack_require__(82699);
var _makeDefaultStylingContext = (0, _style.makeDefaultStylingContext)(), screenSize = _makeDefaultStylingContext.screenSize, colorMode = _makeDefaultStylingContext.colorMode;
var _obj;
var OFFSET_BOTTOM = (_obj = {}, _define_property._(_obj, _constants.HD, 64), _define_property._(_obj, _constants.FULL_HD, 88), _obj);
var _obj1;
var OFFSET_RIGHT = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 64), _define_property._(_obj1, _constants.FULL_HD, 88), _obj1);
var _obj2;
var CONTENT_HEIGHT = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 48), _define_property._(_obj2, _constants.FULL_HD, 56), _obj2);
var TEXT_COLOR = (0, _theme.makeThemeColor)(_theme.PRIMARY)[colorMode];
var CONTENT_WIDTH = (_sizes.SCREEN_WIDTH[screenSize] - OFFSET_RIGHT[screenSize]) / 2;
var getInfoBarOffsetX = function() {
    return _sizes.SCREEN_WIDTH[screenSize] - OFFSET_RIGHT[screenSize];
};
var getInfoBarOffsetY = function() {
    return _sizes.SCREEN_HEIGHT[screenSize] - OFFSET_BOTTOM[screenSize];
};
var getInitialStyle = function() {
    return {
        x: getInfoBarOffsetX(),
        y: getInfoBarOffsetY(),
        w: 200,
        h: 60,
        mount: 1,
        flex: {
            direction: "column",
            wrap: true,
            justifyContent: "flex-end",
            alignContent: "flex-end"
        },
        DeviceVersion: {
            text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT.BERLIN_2, screenSize)), {
                textColor: TEXT_COLOR
            })
        },
        AppVersion: {
            text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT.BERLIN_2, screenSize)), {
                textColor: TEXT_COLOR
            })
        }
    };
};


/***/ }),

/***/ 22311:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/**
 * @typedef {string} ErrorTypes
 */ /**
 * @enum {ErrorTypes}
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ERROR_LEVELS: function() {
        return ERROR_LEVELS;
    },
    ERROR_TYPES: function() {
        return ERROR_TYPES;
    },
    RETRY_ACTIONS: function() {
        return RETRY_ACTIONS;
    }
});
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
var ERROR_TYPES = {
    GENERAL: "general",
    CSL: "csl",
    PAIRING: "pairing",
    PLAYER: "player",
    LAYOUT: "layout",
    STORAGE: "storage"
};
var ERROR_LEVELS = {
    FATAL: "fatal",
    SILENT: "silent"
};
var RETRY_ACTIONS = {
    LAYOUT_FETCH: "layout_fetch"
};


/***/ }),

/***/ 92806:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "colors", ({
    enumerable: true,
    get: function() {
        return colors;
    }
}));
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(45538);
var _theme = __webpack_require__(51397);
var colors = {
    background: (0, _theme.makeThemeColor)(_theme.TERTIARY),
    blocks: [
        (0, _theme.makeThemeColor)(_theme.PRIMARY, 0.2),
        (0, _theme.makeThemeColor)(_theme.PRIMARY, 0.2),
        (0, _theme.makeThemeColor)(_theme.PRIMARY, 0.2),
        (0, _theme.makeThemeColor)(_theme.PRIMARY, 0.2)
    ]
};


/***/ }),

/***/ 76194:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "ExploreCatalogue", ({
    enumerable: true,
    get: function() {
        return ExploreCatalogue;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _constants = __webpack_require__(34952);
var _fidosdk = __webpack_require__(19804);
var _ctaactions = __webpack_require__(32067);
var _abstractLayoututils = __webpack_require__(41533);
var _exploreCataloguestyle = __webpack_require__(92550);
var _buttoncomponent = __webpack_require__(31464);
var _i18n = __webpack_require__(14910);
var ExploreCatalogue = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(ExploreCatalogue, _Lightning_Component);
    var _super = _create_super._(ExploreCatalogue);
    function ExploreCatalogue() {
        _class_call_check._(this, ExploreCatalogue);
        return _super.apply(this, arguments);
    }
    _create_class._(ExploreCatalogue, [
        {
            key: "_getFocused",
            value: function _getFocused() {
                return this.tag("Button");
            }
        },
        {
            key: "_handleEnter",
            value: function _handleEnter() {
                return _lightningjsredux.default.dispatch((0, _ctaactions.createItemAction)((0, _abstractLayoututils.createLayoutAction)(_constants.HOME_ALIAS, _fidosdk.LAYOUT_ALIASES, "pressBookmarksButton")));
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Background: {
                        rect: true
                    },
                    Content: {
                        MainTitle: {
                            text: {
                                text: (0, _i18n.t)("bookmarks.title")
                            }
                        },
                        Blocks: {},
                        Title: {
                            text: {
                                text: (0, _i18n.t)("bookmarks.noContentTitle")
                            }
                        },
                        Description: {
                            text: {
                                text: (0, _i18n.t)("bookmarks.noContentDescription")
                            }
                        },
                        Button: {
                            type: _buttoncomponent.Button,
                            label: (0, _i18n.t)("bookmarks.noContentAction")
                        }
                    }
                }, (0, _exploreCataloguestyle.getInitialStyle)());
            }
        }
    ]);
    return ExploreCatalogue;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 5905:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "BLOCK_GAP", ({
    enumerable: true,
    get: function() {
        return BLOCK_GAP;
    }
}));
var _define_property = __webpack_require__(21228);
var _export_star = __webpack_require__(37668);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
var _constants = __webpack_require__(34952);
_export_star._(__webpack_require__(92806), exports);
var _obj;
var BLOCK_GAP = (_obj = {}, _define_property._(_obj, _constants.HD, 16), _define_property._(_obj, _constants.FULL_HD, 24), _obj);


/***/ }),

/***/ 92550:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/* eslint-disable arrow-body-style */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BLOCK_HEIGHT: function() {
        return BLOCK_HEIGHT;
    },
    BLOCK_WIDTH: function() {
        return BLOCK_WIDTH;
    },
    MARGIN_BLOCKS_TOP: function() {
        return MARGIN_BLOCKS_TOP;
    },
    MARGIN_DESCRIPTION_TOP: function() {
        return MARGIN_DESCRIPTION_TOP;
    },
    MARGIN_SCREEN_TITLE_TOP: function() {
        return MARGIN_SCREEN_TITLE_TOP;
    },
    MARGIN_TITLE_TOP: function() {
        return MARGIN_TITLE_TOP;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _object_spread = __webpack_require__(76247);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(3009);
var _constants = __webpack_require__(34952);
var _typography = __webpack_require__(18411);
var _style = __webpack_require__(65082);
var _sizes = __webpack_require__(82699);
var _abstractLayoutstyle = __webpack_require__(82357);
var _exploreCatalogueutils = __webpack_require__(59319);
var _exploreCatalogueconstants = __webpack_require__(5905);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var MARGIN_BLOCKS_TOP = (_obj = {}, _define_property._(_obj, _constants.HD, 24), _define_property._(_obj, _constants.FULL_HD, 40), _obj);
var _obj1;
var MARGIN_TITLE_TOP = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 40), _define_property._(_obj1, _constants.FULL_HD, 48), _obj1);
var _obj2;
var MARGIN_DESCRIPTION_TOP = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 8), _define_property._(_obj2, _constants.FULL_HD, 8), _obj2);
var _obj3;
var MARGIN_SCREEN_TITLE_TOP = (_obj3 = {}, _define_property._(_obj3, _constants.HD, 168), _define_property._(_obj3, _constants.FULL_HD, 272), _obj3);
var _obj4;
var BLOCK_WIDTH = (_obj4 = {}, _define_property._(_obj4, _constants.HD, 221), _define_property._(_obj4, _constants.FULL_HD, 327), _obj4);
var _obj5;
var BLOCK_HEIGHT = (_obj5 = {}, _define_property._(_obj5, _constants.HD, 124), _define_property._(_obj5, _constants.FULL_HD, 184), _obj5);
var getInitialStyle = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext, screenSize = _ref.screenSize, colorMode = _ref.colorMode;
    return {
        Background: {
            w: _sizes.SCREEN_WIDTH[screenSize],
            h: _sizes.SCREEN_HEIGHT[screenSize],
            color: _exploreCatalogueconstants.colors.background[colorMode]
        },
        Content: {
            x: (0, _abstractLayoutstyle.getContentPadding)(),
            flex: {
                direction: "column"
            },
            MainTitle: {
                flexItem: {
                    marginTop: MARGIN_SCREEN_TITLE_TOP[screenSize]
                },
                text: _object_spread._({}, (0, _typography.getFont)(_typography.FONT.PARIS_3, screenSize))
            },
            Blocks: {
                flexItem: {
                    marginTop: MARGIN_BLOCKS_TOP[screenSize]
                },
                flex: {},
                children: _exploreCatalogueconstants.colors.blocks.map(function(color) {
                    return (0, _exploreCatalogueutils.createBlock)(color, screenSize, colorMode);
                })
            },
            Title: {
                flexItem: {
                    marginTop: MARGIN_TITLE_TOP[screenSize]
                },
                text: _object_spread._({}, (0, _typography.getFont)(_typography.FONT.OTTAWA_3, screenSize))
            },
            Description: {
                flexItem: {
                    marginTop: MARGIN_DESCRIPTION_TOP[screenSize]
                },
                text: _object_spread._({}, (0, _typography.getFont)(_typography.FONT.BERLIN_1, screenSize))
            },
            Button: {
                flexItem: {
                    marginTop: MARGIN_TITLE_TOP[screenSize]
                }
            }
        }
    };
};


/***/ }),

/***/ 59319:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "createBlock", ({
    enumerable: true,
    get: function() {
        return createBlock;
    }
}));
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(52318);
var _posterconstants = __webpack_require__(99246);
var _exploreCatalogueconstants = __webpack_require__(5905);
var createBlock = function(color, screenSize, colorMode) {
    return _object_spread_props._(_object_spread._({
        rect: true,
        flexItem: {
            marginRight: _exploreCatalogueconstants.BLOCK_GAP[screenSize]
        }
    }, _posterconstants.sizes[_posterconstants.templates.PosterS][screenSize]), {
        color: color[colorMode]
    });
};


/***/ }),

/***/ 3289:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "GdprBanner", ({
    enumerable: true,
    get: function() {
        return GdprBanner;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(42578);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _gdprBannerstyle = __webpack_require__(16541);
var _buttoncomponent = __webpack_require__(31464);
var _gdprNoticeactions = __webpack_require__(18012);
var _i18n = __webpack_require__(14910);
var _gdprBannerconstants = __webpack_require__(94081);
var _cookieConcentconstants = __webpack_require__(56630);
var GdprBanner = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(GdprBanner, _Lightning_Component);
    var _super = _create_super._(GdprBanner);
    function GdprBanner() {
        _class_call_check._(this, GdprBanner);
        return _super.apply(this, arguments);
    }
    _create_class._(GdprBanner, [
        {
            key: "_construct",
            value: function _construct() {
                this._index = 0;
            }
        },
        {
            key: "_build",
            value: function _build() {
                this._buttons = this.tag("ButtonsRow").children;
            }
        },
        {
            key: "_setIndex",
            value: function _setIndex() {
                var index = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._index;
                this._index = index;
            }
        },
        {
            key: "_focus",
            value: function _focus() {
                this._setIndex();
            }
        },
        {
            key: "_unfocus",
            value: function _unfocus() {
                this._setIndex(0);
            }
        },
        {
            key: "_getFocused",
            value: function _getFocused() {
                return this._buttons[this._index];
            }
        },
        {
            key: "_handleEnter",
            value: function _handleEnter() {
                switch(this._getFocused().action){
                    case _gdprBannerconstants.PRIVACY_CONSENT_ALL:
                        _lightningjsredux.default.dispatch((0, _gdprNoticeactions.pressGdprNoticeConsentAllButton)());
                        return true;
                    case _gdprBannerconstants.PRIVACY_DECLINE_ALL:
                        _lightningjsredux.default.dispatch((0, _gdprNoticeactions.pressGdprNoticeDeclineAllButton)());
                        return true;
                    case _gdprBannerconstants.PRIVACY_SELECT:
                        this.signal(_cookieConcentconstants.SHOW_PRIVACY_SETTINGS_SIGNAL);
                        return true;
                    default:
                        return false;
                }
            }
        },
        {
            key: "_handleRight",
            value: function _handleRight() {
                if (this._index < this._buttons.length - 1) {
                    this._setIndex(this._index + 1);
                    return true;
                }
                return true;
            }
        },
        {
            key: "_handleBack",
            value: function _handleBack() {
                return true;
            }
        },
        {
            key: "_handleLeft",
            value: function _handleLeft() {
                if (this._index > 0) {
                    this._setIndex(this._index - 1);
                    return true;
                }
                return true;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Description: {
                        text: {
                            text: (0, _i18n.t)("gdprNotice.description")
                        }
                    },
                    ButtonsRow: {
                        AcceptAll: {
                            type: _buttoncomponent.Button,
                            label: (0, _i18n.t)("gdprNotice.ok"),
                            action: _gdprBannerconstants.PRIVACY_CONSENT_ALL
                        },
                        Settings: {
                            type: _buttoncomponent.Button,
                            label: (0, _i18n.t)("gdprNotice.parameters"),
                            action: _gdprBannerconstants.PRIVACY_SELECT
                        },
                        DeclineAll: {
                            type: _buttoncomponent.Button,
                            label: (0, _i18n.t)("gdprNotice.decline"),
                            action: _gdprBannerconstants.PRIVACY_DECLINE_ALL
                        }
                    }
                }, (0, _gdprBannerstyle.getInitialStyle)());
            }
        }
    ]);
    return GdprBanner;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 16541:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BUTTON_MARGIN_RIGHT: function() {
        return BUTTON_MARGIN_RIGHT;
    },
    CONTENT_SIDE_MARGIN: function() {
        return CONTENT_SIDE_MARGIN;
    },
    DESCRIPTION_PADDING_BOTTOM: function() {
        return DESCRIPTION_PADDING_BOTTOM;
    },
    PADDING_BOTTOM: function() {
        return PADDING_BOTTOM;
    },
    PADDING_TOP: function() {
        return PADDING_TOP;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _object_spread = __webpack_require__(76247);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(65759);
var _theme = __webpack_require__(51397);
var _typography = __webpack_require__(18411);
var _constants = __webpack_require__(34952);
var _style = __webpack_require__(65082);
var _sizes = __webpack_require__(82699);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var CONTENT_SIDE_MARGIN = (_obj = {}, _define_property._(_obj, _constants.HD, 152), _define_property._(_obj, _constants.FULL_HD, 232), _obj);
var _obj1;
var BUTTON_MARGIN_RIGHT = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 24), _define_property._(_obj1, _constants.FULL_HD, 24), _obj1);
var _obj2;
var PADDING_BOTTOM = (_obj2 = {}, _define_property._(_obj2, _constants.HD, _constants.safetyMargins.vertical[_constants.HD]), _define_property._(_obj2, _constants.FULL_HD, _constants.safetyMargins.vertical[_constants.FULL_HD]), _obj2);
var _obj3;
var PADDING_TOP = (_obj3 = {}, _define_property._(_obj3, _constants.HD, 32), _define_property._(_obj3, _constants.FULL_HD, 48), _obj3);
var _obj4;
var DESCRIPTION_PADDING_BOTTOM = (_obj4 = {}, _define_property._(_obj4, _constants.HD, 32), _define_property._(_obj4, _constants.FULL_HD, 48), _obj4);
var colors = {
    background: (0, _theme.makeThemeColor)(_theme.TERTIARY)
};
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var screenSize = context.screenSize, colorMode = context.colorMode;
    var descriptionFont = (0, _typography.getFont)(_typography.FONT.OTTAWA_1, screenSize);
    var wordWrapWidth = _sizes.SCREEN_WIDTH[screenSize] - CONTENT_SIDE_MARGIN[screenSize] * 2;
    return {
        rect: true,
        w: _sizes.SCREEN_WIDTH[screenSize],
        mountY: 1,
        y: _sizes.SCREEN_HEIGHT[screenSize],
        x: 0,
        color: colors.background[colorMode],
        flex: {
            direction: "column",
            paddingBottom: PADDING_BOTTOM[screenSize]
        },
        Description: {
            flexItem: {
                marginBottom: DESCRIPTION_PADDING_BOTTOM[screenSize]
            },
            x: CONTENT_SIDE_MARGIN[screenSize],
            y: PADDING_TOP[screenSize],
            text: _object_spread._({
                textAlign: "center",
                wordWrapWidth: wordWrapWidth
            }, descriptionFont)
        },
        ButtonsRow: {
            flex: {
                direction: "row",
                justifyContent: "center"
            },
            flexItem: {
                marginTop: DESCRIPTION_PADDING_BOTTOM[screenSize]
            },
            AcceptAll: {
                flexItem: {
                    marginRight: BUTTON_MARGIN_RIGHT[screenSize]
                }
            },
            Settings: {
                flexItem: {
                    marginRight: BUTTON_MARGIN_RIGHT[screenSize]
                }
            }
        }
    };
};


/***/ }),

/***/ 40089:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "GdprBanner", ({
    enumerable: true,
    get: function() {
        return _gdprBannercomponent.GdprBanner;
    }
}));
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(65759);
var _gdprBannercomponent = __webpack_require__(3289);


/***/ }),

/***/ 94081:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    PRIVACY_CONSENT_ALL: function() {
        return PRIVACY_CONSENT_ALL;
    },
    PRIVACY_DECLINE_ALL: function() {
        return PRIVACY_DECLINE_ALL;
    },
    PRIVACY_SELECT: function() {
        return PRIVACY_SELECT;
    }
});
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(42578);
var PRIVACY_DECLINE_ALL = "declineAll";
var PRIVACY_CONSENT_ALL = "consentAll";
var PRIVACY_SELECT = "selectPrivacy";


/***/ }),

/***/ 86437:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Heartbeat: function() {
        return Heartbeat;
    },
    getSessionInitialProps: function() {
        return _heartbeatutils.getSessionInitialProps;
    }
});
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(37815);
var _heartbeatengine = __webpack_require__(15922);
var _heartbeatutils = __webpack_require__(36614);
var Heartbeat = new _heartbeatengine.HeartbeatEngine();


/***/ }),

/***/ 15922:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    HeartbeatEngine: function() {
        return HeartbeatEngine;
    },
    default: function() {
        return _default;
    }
});
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _object_without_properties = __webpack_require__(46537);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(42578);
var _fidosdk = __webpack_require__(19804);
var _config = __webpack_require__(67958);
var HeartbeatEngine = /*#__PURE__*/ function() {
    "use strict";
    function HeartbeatEngine() {
        _class_call_check._(this, HeartbeatEngine);
        this._reset();
    }
    _create_class._(HeartbeatEngine, [
        {
            key: "_reset",
            value: function _reset() {
                this._sendView = undefined;
                this._viewData = undefined;
                this._ticker = undefined;
                this._currentPlayerTime = 0;
                this._previousPlayerTime = undefined;
                this._previousRelativeTime = undefined;
                this._previousTickTime = this._currentTimeInSeconds();
                this._cslErrorHandler = undefined;
                this._sequenceNumber = 0;
            }
        },
        {
            key: "_currentTimeInSeconds",
            value: function _currentTimeInSeconds() {
                return Math.round(Date.now() / 1000);
            }
        },
        {
            key: "currentPlayerTime",
            get: function get() {
                return this._currentPlayerTime;
            },
            set: function set(value) {
                if (Number.isFinite(value) && value >= 0) {
                    this._currentPlayerTime = Math.floor(value);
                }
            }
        },
        {
            key: "createSession",
            value: function createSession(data) {
                var _this = this;
                return _async_to_generator._(function() {
                    var session, polling, cslErrorHandler, view, startTime, UID, sessionData, playerStartTime, _ref, sessionId, sendView, error;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                session = data.session, polling = data.polling, cslErrorHandler = data.cslErrorHandler, view = data.view, startTime = data.startTime;
                                UID = session.UID, sessionData = _object_without_properties._(session, [
                                    "UID"
                                ]);
                                playerStartTime = Number.isFinite(startTime) ? startTime : 0;
                                _this._reset();
                                if (Number.isFinite(polling)) {
                                    // The "polling" parameter specifies seconds
                                    _this._heartbeatInterval = polling * 1000;
                                } else {
                                    _this._heartbeatInterval = _config.heartbeat.heartbeatInterval || 240000;
                                }
                                _this._currentPlayerTime = Math.floor(playerStartTime);
                                _this._viewData = view;
                                _this._cslErrorHandler = cslErrorHandler;
                                return [
                                    4,
                                    _fidosdk.heartbeatService.createSession(UID ? {
                                        sessionData: sessionData,
                                        user: {
                                            UID: UID
                                        }
                                    } : {
                                        sessionData: sessionData
                                    })
                                ];
                            case 1:
                                _ref = _state.sent(), sessionId = _ref.sessionId, sendView = _ref.sendView;
                                // eslint-disable-next-line no-console
                                console.log("[Heartbeat] Session created successfully:", sessionId);
                                _this._sendView = sendView;
                                _this._previousTickTime = _this._currentTimeInSeconds();
                                return [
                                    2,
                                    sessionId
                                ];
                            case 2:
                                error = _state.sent();
                                // TODO: Figure out what is expected in case of Heartbeat session creation error
                                // eslint-disable-next-line no-console
                                console.error("[Heartbeat] Session creation failed:", error);
                                return [
                                    2,
                                    null
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "resume",
            value: function resume() {
                var _this = this;
                if (!this._ticker) {
                    // Pause time should not be counted as viewed
                    this._previousTickTime = this._currentTimeInSeconds();
                    this._ticker = setInterval(function() {
                        return _this.sendHeartbeat();
                    }, this._heartbeatInterval);
                }
                this.sendHeartbeat();
            }
        },
        {
            key: "pause",
            value: function pause() {
                // In case it was already paused, do not advance the tcRelative
                if (!this._ticker) {
                    this._previousTickTime = this._currentTimeInSeconds();
                }
                clearInterval(this._ticker);
                this._ticker = undefined;
                this.sendHeartbeat();
            }
        },
        {
            key: "sendHeartbeat",
            value: function sendHeartbeat() {
                var _this = this;
                return _async_to_generator._(function() {
                    var currentTime, currentPlayerTime, tcRelative, sequenceNumber, _ref, viewInformation, error;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this._sendView || !_this._viewData) {
                                    return [
                                        2
                                    ];
                                }
                                currentTime = _this._currentTimeInSeconds();
                                currentPlayerTime = _this._currentPlayerTime;
                                tcRelative = currentTime - _this._previousTickTime;
                                sequenceNumber = _this._sequenceNumber;
                                // NOTE: sequency number is increased before sending the event to mitigate long-waiting promise resolution
                                _this._sequenceNumber += 1;
                                _this._previousTickTime = currentTime;
                                _this._previousPlayerTime = currentPlayerTime;
                                _this._previousRelativeTime = tcRelative;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _this._sendView(_object_spread_props._(_object_spread._({}, _this._viewData), {
                                        tc: currentPlayerTime,
                                        tcRelative: tcRelative,
                                        sequenceNumber: sequenceNumber
                                    }))
                                ];
                            case 2:
                                _ref = _state.sent(), viewInformation = _ref.view_information;
                                if (viewInformation && viewInformation.csl && viewInformation.csl.allowed === false) {
                                    if (_this._cslErrorHandler) {
                                        _this._cslErrorHandler();
                                    }
                                    _fidosdk.thirdPartyWithLayoutService.sendErrorEvent(new Error("Heartbeat failed due to CSL error"));
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                error = _state.sent();
                                _fidosdk.thirdPartyWithLayoutService.sendErrorEvent(new Error("Heartbeat tick failed: ".concat(error.message)));
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                clearInterval(this._ticker);
                // Per the spec, heartbeats should be sent when a player is closed
                this.sendHeartbeat();
                this._reset();
            }
        }
    ]);
    return HeartbeatEngine;
}();
var _default = new HeartbeatEngine();


/***/ }),

/***/ 36614:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "getSessionInitialProps", ({
    enumerable: true,
    get: function() {
        return getSessionInitialProps;
    }
}));
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(52318);
var _heartbeatconstants = __webpack_require__(22013);
var _heartbeatselectors = __webpack_require__(99163);
var _playerselectors = __webpack_require__(83318);
var _userselectors = __webpack_require__(41845);
var getSessionInitialProps = function(state) {
    return {
        uidType: (0, _userselectors.getPairingUid)(state) ? _heartbeatconstants.UID_TYPE_GIGYA : _heartbeatconstants.UID_TYPE_DEVICE_ID,
        clipId: (0, _playerselectors.getClipId)(state),
        videoId: (0, _playerselectors.getVideoId)(state),
        clipDuration: (0, _playerselectors.getDurationInSeconds)(state),
        clipType: (0, _heartbeatselectors.getVideoClipType)(state),
        programId: (0, _heartbeatselectors.getProgramId)(state),
        serviceCode: (0, _heartbeatselectors.getServiceCode)(state),
        UID: (0, _userselectors.getUid)(state),
        startTime: (0, _playerselectors.getElapsedTimeInSeconds)(state)
    };
};


/***/ }),

/***/ 18481:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    dictionary: function() {
        return dictionary;
    },
    languages: function() {
        return _dejson1.default;
    }
});
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _enjson = /*#__PURE__*/ _interop_require_default._(__webpack_require__(27259));
var _dejson = /*#__PURE__*/ _interop_require_default._(__webpack_require__(2462));
var _dejson1 = /*#__PURE__*/ _interop_require_default._(__webpack_require__(83635));
var dictionary = (0, _merge.default)(_enjson.default, _dejson.default);


/***/ }),

/***/ 14910:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    destroy: function() {
        return destroy;
    },
    setupI18NOverrides: function() {
        return setupI18NOverrides;
    },
    t: function() {
        return t;
    }
});
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(45538);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _config = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67958));
var _utils = __webpack_require__(7387);
var _defaultlanguages = __webpack_require__(18481);
var bundle = _object_spread_props._(_object_spread._({}, _defaultlanguages.dictionary), {
    languages: _defaultlanguages.languages
});
var setupI18NOverrides = function(overrides) {
    if (overrides) {
        bundle = (0, _merge.default)(bundle, overrides);
    }
};
var destroy = function() {
    bundle = undefined;
};
var t = (0, _utils.translate)(bundle, _config.default.i18nNames);


/***/ }),

/***/ 7387:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    buildList: function() {
        return buildList;
    },
    translate: function() {
        return translate;
    }
});
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(88801);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _sprintfjs = __webpack_require__(24131);
var pluralizeFunctions = {
    en: function(number) {
        return number === 0 || number > 1 ? "other" : "one";
    },
    fr: function(number) {
        return number > 1 ? "other" : "one";
    },
    hu: function(number, general) {
        if (!general) {
            return "one";
        }
        return number > 1 ? "other" : "one";
    },
    // eslint-disable-next-line consistent-return
    hr: function(number, general) {
        // General plural
        if (general) {
            return number > 1 ? "other" : "one";
        }
        var numberInString = number.toString();
        var lastDigit = numberInString.charAt(numberInString.length - 1);
        if (number > 4 && number < 21 || [
            "0",
            "5",
            "6",
            "7",
            "8",
            "9"
        ].includes(lastDigit)) {
            // Third plural form
            return "many";
        }
        if (lastDigit === "1") {
            // First plural form and singular
            return "one";
        }
        if (lastDigit === "2" || lastDigit === "3" || lastDigit === "4") {
            // Second plural form
            return "few";
        }
    }
};
var translate = function(lang) {
    var i18nNames = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var pluralize = pluralizeFunctions[(0, _get.default)(lang, "_i18n.lang")] || pluralizeFunctions.fr;
    return function(key) {
        var data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, number = arguments.length > 2 ? arguments[2] : void 0, general = arguments.length > 3 ? arguments[3] : void 0;
        var combineKey = key;
        // Pluralize
        if (typeof number !== "undefined") {
            combineKey = "".concat(key, ".").concat(pluralize(number, general));
        }
        var translation = (0, _get.default)(lang, combineKey, combineKey);
        return (0, _sprintfjs.sprintf)(translation, _object_spread_props._(_object_spread._({}, data, i18nNames), {
            number: number
        }));
    };
};
var buildList = function(lang) {
    return function(list, maxSize) {
        var separator = (0, _get.default)(lang, "_i18n.separator");
        var lastSeparator = (0, _get.default)(lang, "_i18n.and");
        if (!list || !list.length) {
            return "";
        }
        if (list.length === 1) {
            return list[0];
        }
        var lastIndex = list.length - 1;
        var subList = list.slice(0, lastIndex).join(separator);
        var result = "".concat(subList).concat(lastSeparator).concat(list[lastIndex]);
        return result.length > maxSize ? "".concat(result.substring(0, maxSize), "...") : result;
    };
};


/***/ }),

/***/ 8653:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    CATCH_PHRASE_FONT: function() {
        return CATCH_PHRASE_FONT;
    },
    CATCH_PHRASE_FONT_TYPE: function() {
        return CATCH_PHRASE_FONT_TYPE;
    },
    CATCH_PHRASE_MAX_LINES: function() {
        return CATCH_PHRASE_MAX_LINES;
    },
    JUSTIFY_CONTENT: function() {
        return JUSTIFY_CONTENT;
    },
    LOGO_ICON: function() {
        return LOGO_ICON;
    },
    LOGO_ICON_SCALE: function() {
        return LOGO_ICON_SCALE;
    },
    PADDING_TOP: function() {
        return PADDING_TOP;
    },
    WORD_WRAP_WIDTH: function() {
        return WORD_WRAP_WIDTH;
    }
});
var _define_property = __webpack_require__(21228);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(42578);
var _typography = __webpack_require__(18411);
var _constants = __webpack_require__(34952);
var _iconconstants = __webpack_require__(48112);
var _sizes = __webpack_require__(82699);
var LOGO_ICON = _iconconstants.customerServiceIcon;
var LOGO_ICON_SCALE = 1;
var CATCH_PHRASE_MAX_LINES = 2;
var CATCH_PHRASE_FONT = _typography.FONT.TOKYO_4;
var CATCH_PHRASE_FONT_TYPE = _typography.FONT_TYPE.MAIN;
var _obj;
var WORD_WRAP_WIDTH = (_obj = {}, _define_property._(_obj, _constants.HD, Math.round(_sizes.SCREEN_WIDTH[_constants.HD] * 0.775)), _define_property._(_obj, _constants.FULL_HD, Math.round(_sizes.SCREEN_WIDTH[_constants.FULL_HD] * 0.775)), _obj);
var _obj1;
var PADDING_TOP = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 0), _define_property._(_obj1, _constants.FULL_HD, 0), _obj1);
var JUSTIFY_CONTENT = "center";


/***/ }),

/***/ 1698:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "shouldNavigateToSingleSignIn", ({
    enumerable: true,
    get: function() {
        return shouldNavigateToSingleSignIn;
    }
}));
var _async_to_generator = __webpack_require__(24146);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(42578);
var _pairingutils = __webpack_require__(54264);
var _default = __webpack_require__(46066);
var shouldNavigateToSingleSignIn = function() {
    var _ref = _async_to_generator._(function() {
        var status, error;
        return _ts_generator._(this, function(_state) {
            switch(_state.label){
                case 0:
                    if ((0, _pairingutils.shouldSkipSSI)()) {
                        return [
                            2,
                            false
                        ];
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0, _default.getStatus)()
                    ];
                case 2:
                    status = _state.sent().status;
                    return [
                        2,
                        status.isPartnerLoginAllowed && status.displayTos
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        2,
                        false
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function shouldNavigateToSingleSignIn() {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 36084:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "Landing", ({
    enumerable: true,
    get: function() {
        return Landing;
    }
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(65759);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _landingconnector = /*#__PURE__*/ _interop_require_default._(__webpack_require__(46935));
var _i18n = __webpack_require__(14910);
var _brandIconcomponent = __webpack_require__(362);
var _heroOverlaycomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(10169));
var _landingButtonscomponent = __webpack_require__(22099);
var _landingstyle = __webpack_require__(66690);
var _routingactions = __webpack_require__(78235);
var _apputils = __webpack_require__(60368);
var _routesutils = __webpack_require__(14948);
var _landingutils = __webpack_require__(53358);
var Landing = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(Landing, _Lightning_Component);
    var _super = _create_super._(Landing);
    function Landing() {
        _class_call_check._(this, Landing);
        return _super.apply(this, arguments);
    }
    _create_class._(Landing, [
        {
            key: "_build",
            value: function _build() {
                var background = this.tag("Background");
                background.once("txLoaded", function() {
                    background.setSmooth("alpha", 1);
                    background.setSmooth("scale", 1, {
                        duration: 0.5
                    });
                });
            }
        },
        {
            key: "_attach",
            value: function _attach() {
                _lightningjsredux.default.dispatch((0, _routingactions.landingShown)());
            }
        },
        {
            key: "_active",
            value: function _active() {
                var _this = this;
                return _async_to_generator._(function() {
                    var proceedWithSSI;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, _landingutils.shouldNavigateToSingleSignIn)()
                                ];
                            case 1:
                                proceedWithSSI = _state.sent();
                                (0, _apputils.removeSplashScreen)();
                                if (proceedWithSSI) {
                                    (0, _routesutils.navigateTo)(_routesutils.SSI_PATH);
                                } else {
                                    _this.tag("Root").visible = true;
                                    _this._unsubscribe = (0, _landingconnector.default)(_this);
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_inactive",
            value: function _inactive() {
                if (this._unsubscribe) {
                    this._unsubscribe();
                    this._unsubscribe = null;
                }
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                this.tag("Background").removeAllListeners("txLoaded");
            }
        },
        {
            key: "isUnpairedEntering",
            set: function set(value) {
                var text = value ? (0, _i18n.t)("pairing.landing.connect") : (0, _i18n.t)("pairing.landing.pricing");
                this.tag("Pricing").text.text = text;
            }
        },
        {
            key: "_getFocused",
            value: function _getFocused() {
                return this.tag("Buttons");
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Root: {
                        Background: {},
                        Overlay: {
                            type: _heroOverlaycomponent.default
                        },
                        Content: {
                            Logo: {
                                type: _brandIconcomponent.BrandIcon,
                                testId: "CustomerLogo"
                            },
                            CatchPhrase: {
                                text: {
                                    text: (0, _i18n.t)("pairing.landing.catchPhrase")
                                }
                            },
                            Description: {
                                text: {
                                    text: (0, _i18n.t)("pairing.landing.description")
                                }
                            },
                            Pricing: {
                                text: {
                                    text: (0, _i18n.t)("pairing.landing.pricing")
                                }
                            },
                            Buttons: {
                                type: _landingButtonscomponent.LandingButtons
                            }
                        }
                    },
                    testId: "Landing"
                }, (0, _landingstyle.getInitialStyle)());
            }
        }
    ]);
    return Landing;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 46935:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(3009);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _pairingselectors = __webpack_require__(59739);
var mapControllers = function(instance) {
    return [
        {
            selector: _pairingselectors.getIsUnpairedEntering,
            callback: function(value) {
                instance.isUnpairedEntering = value;
            },
            shouldBeInvokedOnConnect: true
        }
    ];
};
var _default = _lightningjsredux.default.control(mapControllers);


/***/ }),

/***/ 22070:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _export_star = __webpack_require__(37668);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
_export_star._(__webpack_require__(8653), exports);


/***/ }),

/***/ 66690:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BUTTONS_MARGIN_TOP: function() {
        return BUTTONS_MARGIN_TOP;
    },
    LOGO_HEIGHT: function() {
        return LOGO_HEIGHT;
    },
    LOGO_MARGIN_BOTTOM: function() {
        return LOGO_MARGIN_BOTTOM;
    },
    PADDING_LEFT: function() {
        return PADDING_LEFT;
    },
    PADDING_TOP: function() {
        return _landingconstants.PADDING_TOP;
    },
    TEXT_MARGIN_BOTTOM: function() {
        return TEXT_MARGIN_BOTTOM;
    },
    TEXT_MARGIN_TOP: function() {
        return TEXT_MARGIN_TOP;
    },
    WORD_WRAP_WIDTH: function() {
        return _landingconstants.WORD_WRAP_WIDTH;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    getLogoViewBox: function() {
        return getLogoViewBox;
    }
});
var _define_property = __webpack_require__(21228);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(65759);
var _constants = __webpack_require__(34952);
var _typography = __webpack_require__(18411);
var _landingconstants = __webpack_require__(22070);
var _sizes = __webpack_require__(82699);
var _style = __webpack_require__(65082);
var _landingutils = __webpack_require__(53358);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var PADDING_LEFT = (_obj = {}, _define_property._(_obj, _constants.HD, 64), _define_property._(_obj, _constants.FULL_HD, 80), _obj);
var _obj1;
var LOGO_HEIGHT = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 152), _define_property._(_obj1, _constants.FULL_HD, 152), _obj1);
var _obj2;
var LOGO_MARGIN_BOTTOM = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 0), _define_property._(_obj2, _constants.FULL_HD, 0), _obj2);
var _obj3;
var TEXT_MARGIN_BOTTOM = (_obj3 = {}, _define_property._(_obj3, _constants.HD, 16), _define_property._(_obj3, _constants.FULL_HD, 16), _obj3);
var _obj4;
var TEXT_MARGIN_TOP = (_obj4 = {}, _define_property._(_obj4, _constants.HD, 32), _define_property._(_obj4, _constants.FULL_HD, 64), _obj4);
var _obj5;
var BUTTONS_MARGIN_TOP = (_obj5 = {}, _define_property._(_obj5, _constants.HD, 32), _define_property._(_obj5, _constants.FULL_HD, 64), _obj5);
var getLogoViewBox = function(screenSize) {
    return {
        h: LOGO_HEIGHT[screenSize]
    };
};
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var _context_screenSize = context.screenSize, screenSize = _context_screenSize === void 0 ? _constants.FULL_HD : _context_screenSize;
    var wordWrapWidth = _landingconstants.WORD_WRAP_WIDTH[screenSize];
    return {
        Root: {
            visible: false,
            w: _sizes.SCREEN_WIDTH[screenSize],
            h: _sizes.SCREEN_HEIGHT[screenSize],
            Background: {
                w: _sizes.SCREEN_WIDTH[screenSize],
                h: _sizes.SCREEN_HEIGHT[screenSize],
                src: (0, _landingutils.getBackgroundUrl)(screenSize),
                alpha: 0.001,
                scale: 1.05,
                zIndex: 1
            },
            Overlay: {
                w: _sizes.identity,
                h: _sizes.identity,
                zIndex: 2
            },
            Content: {
                x: PADDING_LEFT[screenSize],
                h: _sizes.SCREEN_HEIGHT[screenSize],
                y: _landingconstants.PADDING_TOP[screenSize],
                flex: {
                    justifyContent: _landingconstants.JUSTIFY_CONTENT,
                    direction: "column"
                },
                zIndex: 3,
                Logo: {
                    h: LOGO_HEIGHT[screenSize],
                    textureScale: _landingconstants.LOGO_ICON_SCALE,
                    flexItem: {
                        marginBottom: LOGO_MARGIN_BOTTOM[screenSize]
                    }
                },
                CatchPhrase: {
                    text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_landingconstants.CATCH_PHRASE_FONT, screenSize, _landingconstants.CATCH_PHRASE_FONT_TYPE)), {
                        maxLines: _landingconstants.CATCH_PHRASE_MAX_LINES,
                        textOverflow: "...",
                        wordWrapWidth: wordWrapWidth
                    }),
                    flexItem: {
                        marginTop: TEXT_MARGIN_TOP[screenSize],
                        marginBottom: TEXT_MARGIN_BOTTOM[screenSize]
                    }
                },
                Description: {
                    text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT.KINSHASA_3, screenSize)), {
                        maxLines: 3,
                        wordWrapWidth: wordWrapWidth
                    }),
                    flexItem: {
                        marginBottom: TEXT_MARGIN_BOTTOM[screenSize]
                    }
                },
                Pricing: {
                    text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT.OTTAWA_2, screenSize)), {
                        maxLines: 3,
                        wordWrapWidth: wordWrapWidth
                    })
                },
                Buttons: {
                    flexItem: {
                        marginTop: BUTTONS_MARGIN_TOP[screenSize]
                    }
                }
            }
        }
    };
};


/***/ }),

/***/ 53358:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "getBackgroundUrl", ({
    enumerable: true,
    get: function() {
        return getBackgroundUrl;
    }
}));
var _export_star = __webpack_require__(37668);
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(88801);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _constants = __webpack_require__(34952);
var _config = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67958));
var _fidosdk = __webpack_require__(19804);
var _sizes = __webpack_require__(82699);
var _landingbackgroundHDjpg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(87362));
var _landingbackgroundFULL_HDjpg = /*#__PURE__*/ _interop_require_default._(__webpack_require__(2372));
var _appsettings = __webpack_require__(20944);
_export_star._(__webpack_require__(1698), exports);
var getBackgroundUrl = function(screenSize) {
    var resolution = screenSize || (0, _sizes.getScreenSize)();
    var imageId = (0, _get.default)(_config.default, "customMedia.landingImage");
    if (imageId) {
        return _fidosdk.imageService.getUrl(imageId, _sizes.SCREEN_WIDTH[screenSize], _sizes.SCREEN_HEIGHT[screenSize], {
            fit: _constants.IMAGE_FIT_SCALE_CROP,
            quality: _constants.IMAGE_QUALITY,
            format: _constants.DEFAULT_IMAGE_FORMAT,
            interlace: 1
        });
    }
    return (0, _appsettings.getFullPath)(resolution === _constants.HD ? _landingbackgroundHDjpg.default : _landingbackgroundFULL_HDjpg.default);
};


/***/ }),

/***/ 92135:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "DIRECTION", ({
    enumerable: true,
    get: function() {
        return DIRECTION;
    }
}));
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(65759);
var DIRECTION = "column";


/***/ }),

/***/ 65274:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "buttons", ({
    enumerable: true,
    get: function() {
        return buttons;
    }
}));
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(88801);
var _landingButtonsconstants = __webpack_require__(37122);
var buttons = [
    _landingButtonsconstants.SIGN_IN,
    _landingButtonsconstants.SIGN_ON
];


/***/ }),

/***/ 22099:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "LandingButtons", ({
    enumerable: true,
    get: function() {
        return LandingButtons;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _inherits = __webpack_require__(71648);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _create_super = __webpack_require__(6400);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
var _sdk = __webpack_require__(29956);
var _i18n = __webpack_require__(14910);
var _buttoncomponent = __webpack_require__(31464);
var _buttonstyle = __webpack_require__(3211);
var _sizes = __webpack_require__(82699);
var _landingButtonsstyle = __webpack_require__(41407);
var _landingButtonsprovider = __webpack_require__(65274);
var _landingButtonsconstants = __webpack_require__(37122);
var LandingButtons = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(LandingButtons, _Lightning_Component);
    var _super = _create_super._(LandingButtons);
    function LandingButtons() {
        _class_call_check._(this, LandingButtons);
        return _super.apply(this, arguments);
    }
    _create_class._(LandingButtons, [
        {
            key: "_construct",
            value: function _construct() {
                this._index = 0;
            }
        },
        {
            key: "_build",
            value: function _build() {
                var screenSize = (0, _sizes.getScreenSize)();
                var isRow = _landingButtonsconstants.DIRECTION === "row";
                this.children.forEach(function(child) {
                    child.flexItem = isRow ? {
                        marginRight: _landingButtonsstyle.GAP[screenSize]
                    } : {
                        marginBottom: _landingButtonsstyle.GAP[screenSize]
                    };
                    if (!isRow) {
                        child.minWidth = _landingButtonsstyle.MIN_BUTTON_WIDTH[screenSize];
                    }
                });
                this.h = this.children.length * (_buttonstyle.HEIGHT[screenSize] + _landingButtonsstyle.GAP[screenSize]) - _landingButtonsstyle.GAP[screenSize];
            }
        },
        {
            key: "_getFocused",
            value: function _getFocused() {
                return this.children[this._index];
            }
        },
        {
            key: "_handleLeft",
            value: function _handleLeft() {
                if (_landingButtonsconstants.DIRECTION === "column") {
                    return false;
                }
                if (this._index > 0) {
                    this._index -= 1;
                    return true;
                }
                return false;
            }
        },
        {
            key: "_handleRight",
            value: function _handleRight() {
                if (_landingButtonsconstants.DIRECTION === "column") {
                    return false;
                }
                if (this._index < this.children.length - 1) {
                    this._index = +1;
                    return true;
                }
                return false;
            }
        },
        {
            key: "_handleUp",
            value: function _handleUp() {
                if (_landingButtonsconstants.DIRECTION === "row") {
                    return false;
                }
                if (this._index > 0) {
                    this._index -= 1;
                    return true;
                }
                return false;
            }
        },
        {
            key: "_handleDown",
            value: function _handleDown() {
                if (_landingButtonsconstants.DIRECTION === "row") {
                    return false;
                }
                if (this._index < this.children.length - 1) {
                    this._index = +1;
                    return true;
                }
                return false;
            }
        },
        {
            key: "_handleEnter",
            value: function _handleEnter() {
                _landingButtonsprovider.buttons[this._index].action();
                _landingButtonsprovider.buttons[this._index].event();
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return _object_spread._({
                    flex: {
                        direction: _landingButtonsconstants.DIRECTION
                    }
                }, _landingButtonsprovider.buttons.reduce(function(result, param) {
                    var id = param.id, label = param.label;
                    return _object_spread_props._(_object_spread._({}, result), _define_property._({}, id, {
                        type: _buttoncomponent.Button,
                        label: (0, _i18n.t)(label)
                    }));
                }, {}));
            }
        }
    ]);
    return LandingButtons;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 37122:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ENTER: function() {
        return ENTER;
    },
    SIGN_IN: function() {
        return SIGN_IN;
    },
    SIGN_ON: function() {
        return SIGN_ON;
    }
});
var _export_star = __webpack_require__(37668);
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _routesutils = __webpack_require__(14948);
var _analyticsutils = __webpack_require__(2693);
var _pairingactions = __webpack_require__(83887);
_export_star._(__webpack_require__(92135), exports);
var ENTER = {
    id: "Enter",
    label: "pairing.landing.enter",
    action: function() {
        // eslint-disable-next-line no-console
        console.log("[Landing] Handling ENTER action");
        (0, _routesutils.navigateTo)(_routesutils.HOME_PATH);
        _lightningjsredux.default.dispatch((0, _pairingactions.setUnpairedEntering)());
    },
    event: function() {}
};
var SIGN_ON = {
    id: "SignOnButton",
    label: "pairing.landing.signOn",
    ref: "SignOnButton",
    action: function() {
        return (0, _routesutils.navigateToExpiredSubscriptionPage)();
    },
    event: function() {
        return (0, _analyticsutils.sendEvent)({
            key: "pressSubscribeButton"
        });
    }
};
var SIGN_IN = {
    id: "SignInButton",
    label: "pairing.landing.signIn",
    action: function() {
        return (0, _routesutils.navigateTo)(_routesutils.PAIRING_PATH);
    },
    event: function() {
        return (0, _analyticsutils.sendEvent)({
            key: "pressConnectButton"
        });
    }
};


/***/ }),

/***/ 41407:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    GAP: function() {
        return GAP;
    },
    MIN_BUTTON_WIDTH: function() {
        return MIN_BUTTON_WIDTH;
    }
});
var _define_property = __webpack_require__(21228);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(88801);
var _constants = __webpack_require__(34952);
var _obj;
var GAP = (_obj = {}, _define_property._(_obj, _constants.HD, 16), _define_property._(_obj, _constants.FULL_HD, 16), _obj);
var _obj1;
var MIN_BUTTON_WIDTH = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 175), _define_property._(_obj1, _constants.FULL_HD, 175), _obj1);


/***/ }),

/***/ 65151:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "AbstractLayout", ({
    enumerable: true,
    get: function() {
        return AbstractLayout;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _create_super = __webpack_require__(6400);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(3009);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _constants = __webpack_require__(34952);
var _config = __webpack_require__(67958);
var _theme = __webpack_require__(74314);
var _colors = __webpack_require__(8426);
var _popupsconstants = __webpack_require__(60952);
var _apputils = __webpack_require__(3613);
var _impression = __webpack_require__(62117);
var _templates = __webpack_require__(63555);
var _signals = __webpack_require__(2109);
var _layoutactions = __webpack_require__(8424);
var _popupactions = __webpack_require__(47531);
var _contextTitlecomponent = __webpack_require__(73731);
var _contextTitlestyle = __webpack_require__(87978);
var _rowconstants = __webpack_require__(7395);
var _abstractLayoututils = __webpack_require__(41533);
var _abstractLayoutstyle = __webpack_require__(82357);
var _abstractLayoutconnect = /*#__PURE__*/ _interop_require_default._(__webpack_require__(80761));
var AbstractLayout = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(AbstractLayout, _Lightning_Component);
    var _super = _create_super._(AbstractLayout);
    function AbstractLayout() {
        _class_call_check._(this, AbstractLayout);
        return _super.apply(this, arguments);
    }
    _create_class._(AbstractLayout, [
        {
            key: "_construct",
            value: function _construct() {
                this._positions = [];
                this._heights = [];
                this._indexMap = [];
                this._index = 0;
                this._offset = 0;
                this._hasSideNav = false;
                this._style = _abstractLayoutstyle.defaultContext;
                this._verticalOffset = 0;
                this._viewsCount = 0;
            }
        },
        {
            key: "_attach",
            value: function _attach() {
                this._unsubscribe = (0, _abstractLayoutconnect.default)(this);
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                if (this._unsubscribe) {
                    this._unsubscribe();
                    this._unsubscribe = null;
                }
                this._data = undefined;
            }
        },
        {
            key: "data",
            get: function get() {
                return this._data;
            },
            set: function set(value) {
                var blocks = value.blocks, entity = value.entity, layout = value.layout;
                var currentViews = this.tag("Blocks").children;
                var couldReuse = this._shouldRefreshPlacement(value.blocks);
                var contentPadding = (0, _abstractLayoutstyle.getContentPadding)(this._hasSideNav);
                this._data = value;
                if (couldReuse) {
                    for(var i = 0; i < blocks.length; i += 1){
                        var view = currentViews[i];
                        if (view) {
                            var block = blocks[i];
                            view.patch({
                                data: _object_spread_props._(_object_spread._({}, view.data), {
                                    block: block
                                }),
                                contentPadding: contentPadding
                            });
                        }
                    }
                    // NOTE: refocus is required here since despite the same amount of rows, children count inside those rows may differ from local views states
                    this._refocus();
                    this._restoreFocusedItemIndex();
                    return;
                }
                this._positions = [];
                this._heights = [];
                this._indexMap = [];
                var focusMode = _config.featureFlipping.leftCornerFocus ? _rowconstants.FOCUS_MODE_LEFT : _rowconstants.FOCUS_MODE_CENTER;
                var theme = (0, _theme.getLayoutTheme)((0, _get.default)(layout, "theme"));
                var screenSize = this._style.screenSize;
                var children = [];
                var width = _abstractLayoutstyle.WIDTH[screenSize];
                var halfOfScreenHeight = _abstractLayoutstyle.HEIGHT[screenSize] / 2;
                var displayShowMore = (0, _abstractLayoututils.shouldDisplayShowMoreButtons)(entity);
                var offset = 0;
                for(var i1 = 0; i1 < blocks.length; i1 += 1){
                    var data = blocks[i1];
                    // Define Lightning classes that would be used to instantiate block and item views
                    var blockType = (0, _abstractLayoututils.getBlockTemplateType)(data);
                    var itemType = (0, _templates.getContentTemplateByTemplateId)(data.content.contentTemplateId);
                    // Define block and item sizes
                    var itemSize = (0, _templates.getContentSizeByContentTemplateId)(data.content.contentTemplateId);
                    var blockSize = (0, _abstractLayoututils.calculateBlockHeight)({
                        blockType: blockType,
                        itemType: itemType,
                        data: data,
                        itemSize: itemSize,
                        blockIndex: i1,
                        screenSize: screenSize,
                        displayShowMore: displayShowMore
                    });
                    var _obj;
                    children.push({
                        type: blockType,
                        focusMode: focusMode,
                        data: {
                            block: data,
                            blockIndex: i1,
                            blockTemplate: data.blockTemplateId,
                            itemSize: itemSize,
                            itemType: itemType,
                            itemTemplate: data.content.contentTemplateId,
                            theme: theme,
                            rowSize: {
                                w: width,
                                h: blockSize.h
                            },
                            displayShowMore: displayShowMore
                        },
                        contentPadding: contentPadding,
                        w: width,
                        h: blockSize.h,
                        y: offset,
                        signals: (_obj = {}, _define_property._(_obj, _signals.SELECTED_SIGNAL, "_handleSelected"), _define_property._(_obj, _signals.PORTION_REQUESTED_SIGNAL, "_handlePortionRequest"), _define_property._(_obj, _signals.EPG_SIGNAL, "_handleEpg"), _define_property._(_obj, _signals.HIDE_BACKGROUND_SIGNAL, "_hideBackground"), _define_property._(_obj, _signals.SHOW_BACKGROUND_SIGNAL, "_showBackground"), _define_property._(_obj, _signals.SHOW_GRID_SIGNAL, "_showGrid"), _define_property._(_obj, _signals.IMPRESSION_TRACK_SIGNAL, "_impressionTrack"), _define_property._(_obj, _signals.IMPRESSION_UNTRACK_SIGNAL, "_impressionUnTrack"), _obj)
                    });
                    var rowSize = Math.round(blockSize.h / blockSize.rowCount);
                    var halfOfRowSize = Math.round(rowSize / 2);
                    // For per-block impression tracking
                    this._heights.push({
                        top: offset,
                        bottom: offset + blockSize.h,
                        heightForImpression: Math.round(blockSize.h / 2)
                    });
                    for(var j = 0; j < blockSize.rowCount; j += 1){
                        this._positions.push(Math.min(halfOfScreenHeight - offset - halfOfRowSize, 0));
                        this._indexMap.push(i1);
                        offset += rowSize;
                    }
                }
                this._backgroundColor = theme.backgroundColor || _abstractLayoutstyle.BACKGROUND_COLOR[this._style.colorMode];
                this.patch({
                    Background: {
                        color: this._backgroundHidden ? _colors.TRANSPARENT : this._backgroundColor
                    },
                    Blocks: {
                        children: children
                    }
                });
                if (this._positions.length) {
                    if (offset > _abstractLayoutstyle.HEIGHT[screenSize]) {
                        var minOffset = _abstractLayoutstyle.HEIGHT[screenSize] - offset - _abstractLayoutstyle.BOTTOM_PADDING[this._style.screenSize];
                        this._positions = this._positions.map(function(y) {
                            return Math.max(minOffset, y);
                        });
                    }
                    this._setIndex(Math.min(this._index, this._positions.length - 1));
                }
                var verticalOffset = this._getVerticalOffset();
                if (!verticalOffset) {
                    this.tag("ContextTitle").alpha = 0;
                }
                if (verticalOffset !== this._verticalOffset) {
                    this._verticalOffset = verticalOffset;
                    this._setIndex(this._index);
                }
                this._refocus();
                this._restoreFocusedItemIndex();
            }
        },
        {
            key: "hasSideNav",
            set: function set(value) {
                if (this._hasSideNav !== value) {
                    this._hasSideNav = value;
                    this._applyContentPadding();
                }
            }
        },
        {
            key: "historyState",
            value: function historyState(history) {
                if (history) {
                    var _history_row = history.row, row = _history_row === void 0 ? 0 : _history_row, _history_column = history.column, column = _history_column === void 0 ? 0 : _history_column;
                    var index = Number.isFinite(row) ? row : 0;
                    this._index = Math.max(index, 0);
                    this._column = column;
                    this._setIndex(this._index);
                    this._restoreFocusedItemIndex();
                    return undefined;
                }
                var focusedBlock = this._getFocused();
                return {
                    row: this._index,
                    column: focusedBlock ? focusedBlock.focusedIndex : 0
                };
            }
        },
        {
            key: "_applyContentPadding",
            value: function _applyContentPadding() {
                var value = (0, _abstractLayoutstyle.getContentPadding)(this._hasSideNav);
                this.tag("Blocks").children.forEach(function(child) {
                    child.contentPadding = value;
                });
            }
        },
        {
            key: "_shouldRefreshPlacement",
            value: function _shouldRefreshPlacement(newBlocks) {
                return (0, _abstractLayoututils.couldReuseCurrentViews)(this._data ? this._data.blocks : [], newBlocks);
            }
        },
        {
            key: "_getFocused",
            value: function _getFocused() {
                var views = this.tag("Blocks").children;
                return views && views[this._indexMap[this._index]];
            }
        },
        {
            key: "_handleUp",
            value: function _handleUp() {
                if (this._index > 0) {
                    var previousBlock = this._getFocused();
                    this._setIndex(this._index - 1, true);
                    // In case we are moving focus to grid (which is the only block type exposing maxIndex) after anchoring
                    var block = this._getFocused();
                    if (block && previousBlock !== block && !block.focusedIndex) {
                        block.focusedIndex = block.maxIndex || 0;
                    }
                    return true;
                }
                return false;
            }
        },
        {
            key: "_handleDown",
            value: function _handleDown() {
                if (this._index < this._indexMap.length - 1) {
                    this._setIndex(this._index + 1, true);
                    return true;
                }
                return false;
            }
        },
        {
            key: "_captureKey",
            value: function _captureKey() {
                this._column = undefined;
                return false;
            }
        },
        {
            key: "_restoreFocusedItemIndex",
            value: function _restoreFocusedItemIndex() {
                var focusedBlock = this._getFocused();
                if (focusedBlock && Number.isFinite(this._column) && focusedBlock.focusedIndex !== this._column) {
                    focusedBlock.focusedIndex = this._column;
                }
            }
        },
        {
            key: "_handleSelected",
            value: function _handleSelected(item) {
                (0, _apputils.handleInteraction)(item, this);
            }
        },
        {
            key: "_handlePortionRequest",
            value: function _handlePortionRequest(portion) {
                _lightningjsredux.default.dispatch((0, _layoutactions.fetchBlockPage)(portion));
            }
        },
        {
            key: "_handleEpg",
            value: function _handleEpg(date) {
                _lightningjsredux.default.dispatch((0, _layoutactions.fetchEPGLayout)(date));
            }
        },
        {
            key: "_showGrid",
            value: function _showGrid(block) {
                _lightningjsredux.default.dispatch((0, _popupactions.showPopupAction)(_popupsconstants.GRID_POPUP_ID, {
                    block: block
                }));
            }
        },
        {
            key: "_impressionTrack",
            value: function _impressionTrack(blockIndex, items) {
                if (this._isBlockFullyVisible(blockIndex)) {
                    (0, _impression.track)(blockIndex, items);
                }
            }
        },
        {
            key: "_impressionUnTrack",
            value: function _impressionUnTrack(blockIndex, items) {
                (0, _impression.untrack)(blockIndex, items);
            }
        },
        {
            key: "_isBlockFullyVisible",
            value: function _isBlockFullyVisible(blockIndex) {
                var start = this.finalY - this._offset;
                var end = this.finalH - this._offset;
                if (blockIndex === this._index) {
                    // This is the currently focused block, no extra checks needed
                    return true;
                }
                if (!this._heights[blockIndex]) {
                    return false;
                }
                var _this__heights_blockIndex = this._heights[blockIndex], top = _this__heights_blockIndex.top, bottom = _this__heights_blockIndex.bottom, h = _this__heights_blockIndex.heightForImpression;
                if (top > end || bottom < start) {
                    return false;
                }
                if (end - top < h || bottom - start < h) {
                    return false;
                }
                return true;
            }
        },
        {
            key: "_hideBackground",
            value: function _hideBackground() {
                this._backgroundHidden = true;
                this.tag("Background").setSmooth("color", _colors.TRANSPARENT, {
                    duration: 0.25
                });
            }
        },
        {
            key: "_showBackground",
            value: function _showBackground() {
                this._backgroundHidden = false;
                this.tag("Background").setSmooth("color", this._backgroundColor, {
                    duration: 0.025
                });
            }
        },
        {
            key: "_setIndex",
            value: function _setIndex() {
                var index = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._index, shouldAnimate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var position = this._positions[index];
                if (!Number.isFinite(position)) {
                    return;
                }
                var offset = index === 0 ? this._verticalOffset : 0;
                this._offset = position + offset;
                this._index = index;
                if (shouldAnimate) {
                    this.tag("Blocks").setSmooth("y", this._offset);
                } else {
                    this.tag("Blocks").y = this._offset;
                }
                for(var i = 0; i < this._heights.length; i += 1){
                    if (!this._isBlockFullyVisible(i)) {
                        (0, _impression.untrack)(i);
                    }
                }
            }
        },
        {
            key: "_getVerticalOffset",
            value: function _getVerticalOffset() {
                if (this._data) {
                    var entity = this._data.entity;
                    if ((0, _abstractLayoututils.shouldDisplayContextTitle)(entity, _constants.FOLDER)) {
                        this.tag("ContextTitle").patch({
                            data: entity,
                            alpha: 1
                        });
                        return _contextTitlestyle.RECTANGLE_HEIGHT[this._style.screenSize];
                    }
                }
                return 0;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Background: {
                        rect: true
                    },
                    ContextTitle: {
                        type: _contextTitlecomponent.ContextTitle
                    },
                    Blocks: {}
                }, (0, _abstractLayoutstyle.getInitialStyle)());
            }
        }
    ]);
    return AbstractLayout;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 80761:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(65759);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _routingselectors = __webpack_require__(2001);
var mapControllers = function(instance) {
    return [
        {
            selector: _routingselectors.isTopLevelRoute,
            shouldBeInvokedOnConnect: true,
            callback: function(value) {
                instance.hasSideNav = value;
            }
        }
    ];
};
var _default = _lightningjsredux.default.control(mapControllers);


/***/ }),

/***/ 82357:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BACKGROUND_COLOR: function() {
        return BACKGROUND_COLOR;
    },
    BOTTOM_PADDING: function() {
        return BOTTOM_PADDING;
    },
    HEIGHT: function() {
        return HEIGHT;
    },
    LEFT_PADDING: function() {
        return _constants.LAYOUT_LEFT_PADDING;
    },
    WIDTH: function() {
        return WIDTH;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getContentPadding: function() {
        return getContentPadding;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _object_spread = __webpack_require__(76247);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(88801);
var _constants = __webpack_require__(34952);
var _theme = __webpack_require__(51397);
var _style = __webpack_require__(65082);
var _sizes = __webpack_require__(82699);
var _sidenavconstants = __webpack_require__(74842);
var _colors = __webpack_require__(8426);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var BOTTOM_PADDING = (_obj = {}, _define_property._(_obj, _constants.HD, _constants.safetyMargins.vertical.HD), _define_property._(_obj, _constants.FULL_HD, _constants.safetyMargins.vertical.FULL_HD), _obj);
var getContentPadding = function() {
    var hasSideNav = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, screenSize = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : undefined;
    var screenDimension = screenSize || defaultContext.screenSize;
    return hasSideNav ? _sidenavconstants.WIDTH[screenDimension] + _constants.LAYOUT_LEFT_PADDING[screenDimension] : _constants.safetyMargins.horizontal[screenDimension];
};
var WIDTH = _object_spread._({}, _sizes.SCREEN_WIDTH);
var HEIGHT = _object_spread._({}, _sizes.SCREEN_HEIGHT);
var BACKGROUND_COLOR = (0, _theme.makeThemeColor)(_theme.TERTIARY);
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var screenSize = context.screenSize;
    return {
        w: WIDTH[screenSize],
        Background: {
            w: WIDTH[screenSize],
            h: HEIGHT[screenSize],
            color: _colors.TRANSPARENT
        },
        ContextTitle: {
            alpha: 0
        },
        Blocks: {
            w: WIDTH[screenSize]
        },
        Notifications: {}
    };
};


/***/ }),

/***/ 41533:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    calculateBlockHeight: function() {
        return calculateBlockHeight;
    },
    couldReuseCurrentViews: function() {
        return couldReuseCurrentViews;
    },
    createLayoutAction: function() {
        return createLayoutAction;
    },
    getBlockTemplateType: function() {
        return getBlockTemplateType;
    },
    shouldDisplayContextTitle: function() {
        return shouldDisplayContextTitle;
    },
    shouldDisplayShowMoreButtons: function() {
        return shouldDisplayShowMoreButtons;
    }
});
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(52318);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _gridcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(36997));
var _templates = __webpack_require__(63555);
var _abstractLayoutconstants = __webpack_require__(18143);
var getBlockTemplateType = function(block) {
    return (0, _templates.getSelectorTemplateById)((0, _get.default)(block, "alternativeContent.selectorTemplateId")) || (0, _templates.getBlockTemplateById)(block.blockTemplateId);
};
var calculateBlockHeight = function(layoutData) {
    var blockType = layoutData.blockType, data = layoutData.data, itemSize = layoutData.itemSize, screenSize = layoutData.screenSize, displayShowMore = layoutData.displayShowMore;
    var rowCounter = blockType.getRowCount;
    var getGap = blockType.getContentGap;
    var rowCount = rowCounter ? rowCounter({
        content: data.content,
        displayShowMore: displayShowMore
    }, screenSize) : 1;
    var itemGap = getGap ? getGap(screenSize) : 0;
    var result = {
        h: (itemSize.h + itemGap) * rowCount,
        top: 0,
        bottom: 0,
        rowCount: rowCount
    };
    var handler = blockType.getOffsetsByBlockData;
    if (handler) {
        var _handler = handler(layoutData), top = _handler.top, bottom = _handler.bottom, h = _handler.h;
        result.top += top;
        result.bottom += bottom;
        result.h = (Number.isFinite(h) ? h : result.h) + top + bottom;
    }
    return result;
};
var couldReuseCurrentViews = function(currentBlocks, newBlocks) {
    var checkVerticalBlocksLength = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (!currentBlocks.length || currentBlocks.length !== newBlocks.length) {
        return false;
    }
    for(var i = 0; i < newBlocks.length; i += 1){
        var newBlock = newBlocks[i];
        var currentBlock = currentBlocks[i];
        if (!currentBlock || !newBlock) {
            return false;
        }
        var blockTemplateId = newBlock.blockTemplateId, contentTemplateId = newBlock.content.contentTemplateId;
        if (blockTemplateId !== currentBlock.blockTemplateId || contentTemplateId !== currentBlock.content.contentTemplateId) {
            return false;
        }
        // Grid template affects overall layout height, therefore we'll need to-calculate it's rows positions
        if (checkVerticalBlocksLength && blockTemplateId === _gridcomponent.default.Templates.Grid) {
            var currentItemsCount = (0, _get.default)(currentBlock, "content.items.length", 0);
            var newItemsCount = (0, _get.default)(newBlock, "content.items.length", 0);
            if (currentItemsCount !== newItemsCount) {
                return false;
            }
        }
    }
    return true;
};
var shouldDisplayContextTitle = function(entity, type) {
    return _abstractLayoutconstants.SHOULD_DISPLAY_CONTEXT_TITLE && (0, _get.default)(entity, "type") === type;
};
var shouldDisplayShowMoreButtons = function(entity) {
    return _abstractLayoutconstants.DISPLAY_SHOW_MORE_ON_GRIDS && entity && (entity.type === "program" || entity.type === "season");
};
var createLayoutAction = function(entityType, entityId, analyticsKey) {
    return {
        item: {
            action: {
                target: {
                    type: "layout",
                    value_layout: {
                        type: entityType,
                        id: entityId
                    }
                },
                analytics: {
                    key: analyticsKey
                }
            }
        }
    };
};


/***/ }),

/***/ 18143:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DISPLAY_SHOW_MORE_ON_GRIDS: function() {
        return DISPLAY_SHOW_MORE_ON_GRIDS;
    },
    SHOULD_DISPLAY_CONTEXT_TITLE: function() {
        return SHOULD_DISPLAY_CONTEXT_TITLE;
    }
});
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
var SHOULD_DISPLAY_CONTEXT_TITLE = false;
var DISPLAY_SHOW_MORE_ON_GRIDS = true;


/***/ }),

/***/ 73382:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "Live", ({
    enumerable: true,
    get: function() {
        return Live;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _get = __webpack_require__(60528);
var _get_prototype_of = __webpack_require__(35196);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(52318);
var _get1 = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _fidosdk = __webpack_require__(19804);
var _ctaactions = __webpack_require__(32067);
var _videoLoadercomponent = __webpack_require__(46647);
var _playercomponent = __webpack_require__(52811);
var _controlscomponent = __webpack_require__(92371);
var _videoLoaderconstants = __webpack_require__(90616);
var _controlsconstants = __webpack_require__(55197);
var _tracksconstants = __webpack_require__(75702);
var _liveconnector = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81390));
var _livestyle = __webpack_require__(82034);
var _liveutils = __webpack_require__(9624);
var _liveconstants = __webpack_require__(73386);
var _contentAdvisorycomponent = __webpack_require__(22122);
var _playerconstants = __webpack_require__(7602);
var _layoutactions = __webpack_require__(8424);
var _playeractions = __webpack_require__(90120);
var _analyticsutils = __webpack_require__(2693);
var _tracksutils = __webpack_require__(76793);
var _screenSaveractions = __webpack_require__(90962);
var Live = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(Live, _Lightning_Component);
    var _super = _create_super._(Live);
    function Live() {
        _class_call_check._(this, Live);
        return _super.apply(this, arguments);
    }
    _create_class._(Live, [
        {
            key: "_active",
            value: function _active() {
                this._canPlay = false;
                this._hasRelatedVideos = false;
                this._hasTracks = false;
                this._hasProgramInformation = false;
                this._isShowingControls = false;
                this._isVideoEnding = false;
                this._isOnLive = true;
                this._startTimeInSeconds = 0;
                this._startOverFeature = false;
                this._setState("Loading");
                this._unsubscribe = (0, _liveconnector.default)(this);
            }
        },
        {
            key: "_onUrlParams",
            value: function _onUrlParams(param) {
                var videoId = param.videoId;
                _lightningjsredux.default.dispatch((0, _playerconstants.reset)());
                _lightningjsredux.default.dispatch((0, _layoutactions.fetchLayout)(_fidosdk.LAYOUT_ENTITIES.live, videoId));
            }
        },
        {
            key: "_inactive",
            value: function _inactive() {
                if (this._unsubscribe) {
                    this._unsubscribe();
                    this._unsubscribe = null;
                }
            }
        },
        {
            key: "isLoadingContent",
            set: function set(value) {
                if (value) {
                    this._setState("Loading");
                }
            }
        },
        {
            key: "canPlay",
            set: function set(value) {
                this._canPlay = value;
                if (this._canPlay) {
                    this.tag("Player").play();
                }
            }
        },
        {
            key: "playbackState",
            set: function set(value) {
                if (value === _playerconstants.PLAYBACK_STATE_PLAYING) {
                    this._setState("Playback.Playing");
                }
            }
        },
        {
            key: "shouldHideVideoLoader",
            set: function set(value) {
                if (value) {
                    this.tag("Loader").hide();
                }
            }
        },
        {
            key: "hasRelatedVideos",
            set: function set(value) {
                this._hasRelatedVideos = value;
                this._updateTopBarItems();
            }
        },
        {
            key: "audioTracks",
            set: function set(value) {
                this._hasTracks = this._hasTracks || value && value.length > 1;
                this._updateTopBarItems(value);
            }
        },
        {
            key: "subtitleTracks",
            set: function set(value) {
                this._hasTracks = this._hasTracks || value && value.length > 0 && !(0, _tracksutils.areForcedSubtitlesOnly)(value);
                this._updateTopBarItems(value);
            }
        },
        {
            key: "programInformation",
            set: function set(value) {
                this._hasProgramInformation = Boolean(value && (value.description || value.title));
                this._updateTopBarItems();
            }
        },
        {
            key: "startOverFeature",
            set: function set(value) {
                this._startOverFeature = value;
                this._updateTopBarItems();
            }
        },
        {
            key: "startTimeInSeconds",
            set: function set(value) {
                this._startTimeInSeconds = value;
            }
        },
        {
            key: "isOnLive",
            set: function set(value) {
                this._isOnLive = value;
                this._updateTopBarItems();
            }
        },
        {
            key: "isAdBreakDisplayed",
            set: function set(value) {
                if (value) {
                    this._setState("Ads");
                }
            }
        },
        {
            key: "shouldSwitchToNextProgram",
            set: function set(value) {
                if (value) {
                    _lightningjsredux.default.dispatch((0, _playeractions.switchToNextProgram)());
                }
            }
        },
        {
            key: "shouldLoadNewMetadataItems",
            set: function set(value) {
                if (value) {
                    _lightningjsredux.default.dispatch((0, _playeractions.getNewMetadataItems)());
                }
            }
        },
        {
            key: "start",
            value: function start() {
                _lightningjsredux.default.dispatch((0, _playeractions.fetchPlayerLayout)());
            }
        },
        {
            key: "_handleBack",
            value: function _handleBack() {
                (0, _analyticsutils.sendEvent)({
                    key: "pressBackButtonDuringVideo"
                });
                return false;
            }
        },
        {
            key: "_pause",
            value: function _pause() {
                if (!this._startOverFeature) {
                    return;
                }
                this.tag("Player").pause();
                this.tag("Controls").show(_controlsconstants.PAUSED_STATE);
            }
        },
        {
            key: "_play",
            value: function _play() {
                this.tag("Player").play();
                this.tag("Controls").show(_controlsconstants.PLAYING_STATE);
            }
        },
        {
            key: "_updateTopBarItems",
            value: function _updateTopBarItems() {
                this.tag("Controls").topBarItems = (0, _liveutils.getTopBarItems)({
                    isOnLive: this._isOnLive,
                    hasTracks: this._hasTracks,
                    hasRelatedVideos: this._hasRelatedVideos,
                    hasProgramInformation: this._hasProgramInformation,
                    startOverFeature: this._startOverFeature
                });
            }
        },
        {
            key: "_handleLoaderSequenceComplete",
            value: function _handleLoaderSequenceComplete() {
                this._isLoadingSequenceComplete = true;
                // NOTE: handling a case of a fail-safe timeout
                this.tag("Loader").hide();
                this._playVideoIfReady();
            }
        },
        {
            key: "_handleSeek",
            value: function _handleSeek(position) {
                this.tag("Player").seek(this._startTimeInSeconds + position);
            }
        },
        {
            key: "_handleTopBarItemSelection",
            value: function _handleTopBarItemSelection(item) {
                var id = (0, _get1.default)(item, "id", "");
                if (id === _liveconstants.TOP_BAR_ITEMS.BACK) {
                    _sdk.Router.back();
                } else if (id === _liveconstants.TOP_BAR_ITEMS.START_OVER) {
                    this._handleStartOver();
                } else if (id === _liveconstants.TOP_BAR_ITEMS.BACK_TO_LIVE) {
                    this._handleBackToLive();
                } else if (id === _liveconstants.TOP_BAR_ITEMS.TRACKS) {
                    this.tag("Controls").showTracks();
                } else if (id === _liveconstants.TOP_BAR_ITEMS.RELATED_VIDEOS) {
                    this.tag("Controls").showSideGlass();
                } else if (id === _liveconstants.TOP_BAR_ITEMS.INFO_PAGE) {
                    this.tag("Controls").showProgramInformation();
                }
            }
        },
        {
            key: "_handleStartOver",
            value: function _handleStartOver() {
                this._handleSeek(0);
                this._play();
                this.isOnLive = false;
            }
        },
        {
            key: "_handleBackToLive",
            value: function _handleBackToLive() {
                _lightningjsredux.default.dispatch((0, _playeractions.switchToNextProgram)());
                this.tag("Player").backToLive();
                this.isOnLive = true;
            }
        },
        {
            key: "_handleItemAction",
            value: function _handleItemAction(item) {
                (0, _ctaactions.dispatchItemAction)(item);
            }
        },
        {
            key: "_handleAudioTrackSelection",
            value: function _handleAudioTrackSelection(track) {
                if (track) {
                    _lightningjsredux.default.dispatch((0, _playeractions.selectAudioTrack)(track));
                }
            }
        },
        {
            key: "_handleSubtitlesTrackSelection",
            value: function _handleSubtitlesTrackSelection(track) {
                _lightningjsredux.default.dispatch((0, _playeractions.selectSubtitlesTrack)(track));
            }
        },
        {
            key: "_handleNextVideoClose",
            value: function _handleNextVideoClose() {
                _sdk.Router.back();
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                var _obj;
                return (0, _merge.default)({
                    Player: {
                        type: _playercomponent.Player
                    },
                    Controls: {
                        type: _controlscomponent.Controls,
                        topBarItems: [],
                        signals: (_obj = {}, _define_property._(_obj, _controlsconstants.SEEK_SIGNAL, "_handleSeek"), _define_property._(_obj, _controlsconstants.PAUSE_SIGNAL, "_handleProgressBarLongSeek"), _define_property._(_obj, _controlsconstants.TOP_BAR_ITEM_SELECTED_SIGNAL, "_handleTopBarItemSelection"), _define_property._(_obj, _controlsconstants.SIDE_GLASS_ITEM_SELECTED_SIGNAL, "_handleItemAction"), _define_property._(_obj, _tracksconstants.AUDIO_TRACK_SELECTED_SIGNAL, "_handleAudioTrackSelection"), _define_property._(_obj, _tracksconstants.SUBTITLES_TRACK_SELECTED_SIGNAL, "_handleSubtitlesTrackSelection"), _define_property._(_obj, _controlsconstants.CONTROLS_SHOW_SIGNAL, "_onControlsShown"), _define_property._(_obj, _controlsconstants.CONTROLS_HIDE_SIGNAL, "_onControlsHidden"), _obj)
                    },
                    ContentAdvisory: {
                        type: _contentAdvisorycomponent.ContentAdvisory
                    },
                    Loader: {
                        type: _videoLoadercomponent.VideoLoader,
                        signals: _define_property._({}, _videoLoaderconstants.COMPLETE_SIGNAL, "_handleLoaderSequenceComplete")
                    }
                }, (0, _livestyle.getInitialStyle)());
            }
        },
        {
            key: "_states",
            value: function _states() {
                return [
                    /*#__PURE__*/ function(_this) {
                        _inherits._(Loading, _this);
                        var _super = _create_super._(Loading);
                        function Loading() {
                            _class_call_check._(this, Loading);
                            return _super.apply(this, arguments);
                        }
                        _create_class._(Loading, [
                            {
                                key: "$enter",
                                value: function $enter() {
                                    this._isLoadingSequenceComplete = false;
                                    this.tag("Loader").show();
                                }
                            }
                        ]);
                        return Loading;
                    }(this),
                    /*#__PURE__*/ function(_this) {
                        _inherits._(Playback, _this);
                        var _super = _create_super._(Playback);
                        function Playback() {
                            _class_call_check._(this, Playback);
                            return _super.apply(this, arguments);
                        }
                        _create_class._(Playback, [
                            {
                                key: "isVideoEnding",
                                set: function set(value) {
                                    this._isVideoEnding = value;
                                    this._displayContentAdvisoryIfRequired();
                                }
                            },
                            {
                                key: "_getFocused",
                                value: function _getFocused() {
                                    return this.tag("Controls");
                                }
                            },
                            {
                                key: "_onControlsShown",
                                value: function _onControlsShown() {
                                    this.tag("ContentAdvisory").pause();
                                    this._isShowingControls = true;
                                }
                            },
                            {
                                key: "_onControlsHidden",
                                value: function _onControlsHidden() {
                                    this.tag("ContentAdvisory").resume();
                                    this._isShowingControls = false;
                                }
                            },
                            {
                                key: "_displayContentAdvisoryIfRequired",
                                value: function _displayContentAdvisoryIfRequired() {
                                    if (this._isVideoEnding && !this._isShowingControls) {
                                        this.tag("ContentAdvisory").start();
                                    }
                                }
                            }
                        ], [
                            {
                                key: "_states",
                                value: function _states() {
                                    return [
                                        /*#__PURE__*/ function(_this) {
                                            _inherits._(Playing, _this);
                                            var _super = _create_super._(Playing);
                                            function Playing() {
                                                _class_call_check._(this, Playing);
                                                return _super.apply(this, arguments);
                                            }
                                            _create_class._(Playing, [
                                                {
                                                    key: "$enter",
                                                    value: function $enter(states) {
                                                        var previousState = (0, _get1.default)(states, "prevState", "");
                                                        // According to requirements, the Content Advisory component should be displayed "after each break"
                                                        this.tag("ContentAdvisory").start();
                                                        if (previousState === "Loading") {
                                                            // Once video is started, controls should be shown
                                                            this.tag("Controls").showControls();
                                                        } else if (previousState === "Playback.Paused") {
                                                            // When player is switching to Playing state from Paused it means, a Play button was triggered and controls were shown
                                                            // According to the requirements, Content Advisory should be hidden when controls are visible
                                                            this.tag("ContentAdvisory").pause();
                                                        }
                                                        _lightningjsredux.default.dispatch((0, _screenSaveractions.setScreenSaverIsLocked)(true));
                                                    }
                                                },
                                                {
                                                    key: "$exit",
                                                    value: function $exit() {
                                                        this.tag("ContentAdvisory").pause();
                                                    }
                                                },
                                                {
                                                    key: "_handleEnter",
                                                    value: function _handleEnter() {
                                                        this._pause();
                                                        return true;
                                                    }
                                                },
                                                {
                                                    key: "_handlePause",
                                                    value: function _handlePause() {
                                                        this._pause();
                                                        return true;
                                                    }
                                                },
                                                {
                                                    key: "_handlePlayPause",
                                                    value: function _handlePlayPause() {
                                                        this._pause();
                                                        return true;
                                                    }
                                                },
                                                {
                                                    key: "_handleProgressBarLongSeek",
                                                    value: function _handleProgressBarLongSeek() {
                                                        this._pause();
                                                    }
                                                },
                                                {
                                                    key: "_handleLoaderSequenceComplete",
                                                    value: function _handleLoaderSequenceComplete() {
                                                        _get._(_get_prototype_of._(Playing.prototype), "_handleLoaderSequenceComplete", this).call(this);
                                                        this.tag("Controls").showControls();
                                                    }
                                                },
                                                {
                                                    key: "playbackState",
                                                    set: function set(value) {
                                                        if (value === _playerconstants.PLAYBACK_STATE_PAUSED) {
                                                            this._setState("Playback.Paused");
                                                        }
                                                    }
                                                }
                                            ]);
                                            return Playing;
                                        }(this),
                                        /*#__PURE__*/ function(_this) {
                                            _inherits._(Paused, _this);
                                            var _super = _create_super._(Paused);
                                            function Paused() {
                                                _class_call_check._(this, Paused);
                                                return _super.apply(this, arguments);
                                            }
                                            _create_class._(Paused, [
                                                {
                                                    key: "_handleEnter",
                                                    value: function _handleEnter() {
                                                        this._play();
                                                        return true;
                                                    }
                                                },
                                                {
                                                    key: "_handlePlay",
                                                    value: function _handlePlay() {
                                                        this._play();
                                                        return true;
                                                    }
                                                },
                                                {
                                                    key: "_handlePlayPause",
                                                    value: function _handlePlayPause() {
                                                        this._play();
                                                        return true;
                                                    }
                                                }
                                            ]);
                                            return Paused;
                                        }(this)
                                    ];
                                }
                            }
                        ]);
                        return Playback;
                    }(this),
                    /*#__PURE__*/ function(_this) {
                        _inherits._(Ads, _this);
                        var _super = _create_super._(Ads);
                        function Ads() {
                            _class_call_check._(this, Ads);
                            return _super.apply(this, arguments);
                        }
                        _create_class._(Ads, [
                            {
                                key: "$enter",
                                value: function $enter() {
                                    this.tag("Loader").hide();
                                }
                            },
                            {
                                key: "_getFocused",
                                value: function _getFocused() {
                                    return this.tag("Player");
                                }
                            }
                        ]);
                        return Ads;
                    }(this)
                ];
            }
        }
    ]);
    return Live;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 81390:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(37815);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _layoutselectors = __webpack_require__(53368);
var _playerselectors = __webpack_require__(83318);
var _videoselectors = __webpack_require__(23035);
var _liveselectors = __webpack_require__(81586);
var mapControllers = function(instance) {
    return {
        shouldSwitchToNextProgram: {
            selector: _playerselectors.shouldSwitchToNextProgram,
            callback: function(value) {
                instance.shouldSwitchToNextProgram = value;
            }
        },
        shouldLoadNewMetadataItems: {
            selector: _playerselectors.shouldLoadNewMetadataItems,
            callback: function(value) {
                instance.shouldLoadNewMetadataItems = value;
            }
        },
        layout: {
            selector: _layoutselectors.getCurrentLayout,
            shouldBeInvokedOnConnect: true,
            callback: function() {
                instance.start();
            }
        },
        canPlay: {
            selector: _playerselectors.getCanPlay,
            callback: function(value) {
                instance.canPlay = value;
            }
        },
        playbackState: {
            selector: _playerselectors.getPlaybackState,
            callback: function(value) {
                instance.playbackState = value;
            }
        },
        shouldHideVideoLoader: {
            selector: _playerselectors.shouldHideVideoLoader,
            shouldBeInvokedOnConnect: true,
            callback: function(value) {
                instance.shouldHideVideoLoader = value;
            }
        },
        isLoadingContent: {
            selector: _playerselectors.getIsLoadingContent,
            shouldBeInvokedOnConnect: true,
            callback: function(value) {
                instance.isLoadingContent = value;
            }
        },
        isAdBreakDisplayed: {
            selector: _playerselectors.isPlayingAds,
            callback: function(value) {
                instance.isAdBreakDisplayed = value;
            },
            shouldBeInvokedOnConnect: true
        },
        sideGlass: {
            selector: _playerselectors.getSideGlassContent,
            callback: function(value) {
                instance.hasRelatedVideos = value;
            }
        },
        audioTracks: {
            selector: _playerselectors.getAudioTracks,
            callback: function(value) {
                instance.audioTracks = value;
            }
        },
        subtitleTracks: {
            selector: _playerselectors.getSubtitleTracks,
            callback: function(value) {
                instance.subtitleTracks = value;
            }
        },
        programInformation: {
            selector: _videoselectors.getCurrentVideoItem,
            callback: function(value) {
                instance.programInformation = value;
            }
        },
        isVideoEnding: {
            selector: _videoselectors.isVideoEnding,
            callback: function(value) {
                instance.isVideoEnding = value;
            }
        },
        startTimeInSeconds: {
            selector: _playerselectors.getStartTimeInSeconds,
            callback: function(value) {
                instance.startTimeInSeconds = value;
            }
        },
        startOverFeature: {
            selector: _playerselectors.isLiveStartOverEnabled,
            shouldBeInvokedOnConnect: true,
            callback: function(value) {
                instance.startOverFeature = value;
            }
        },
        isOnLive: {
            selector: _liveselectors.isOnLive,
            callback: function(value) {
                instance.isOnLive = value;
            }
        }
    };
};
var _default = _lightningjsredux.default.control(mapControllers);


/***/ }),

/***/ 73386:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    TOP_BAR_ITEMS: function() {
        return TOP_BAR_ITEMS;
    },
    TRACK_KEYS: function() {
        return TRACK_KEYS;
    }
});
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(3009);
var TOP_BAR_ITEMS = {
    BACK: "BACK",
    START_OVER: "START_OVER",
    BACK_TO_LIVE: "BACK_TO_LIVE",
    TRACKS: "TRACKS",
    RELATED_VIDEOS: "RELATED_VIDEOS",
    INFO_PAGE: "INFO_PAGE"
};
var TRACK_KEYS = {
    PREFERRED_AUDIO_TRACK_LANGUAGE: "preferredAudioTrackLanguage",
    PREFERRED_SUBTITLE_TRACK_LANGUAGE: "preferredSubtitleTrackLanguage"
};


/***/ }),

/***/ 82034:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(42578);
var _style = __webpack_require__(65082);
var _sizes = __webpack_require__(82699);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var screenSize = context.screenSize;
    return {
        w: _sizes.SCREEN_WIDTH[screenSize],
        h: _sizes.SCREEN_HEIGHT[screenSize]
    };
};


/***/ }),

/***/ 9624:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "getTopBarItems", ({
    enumerable: true,
    get: function() {
        return getTopBarItems;
    }
}));
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(88801);
var _config = __webpack_require__(67958);
var _playerconstants = __webpack_require__(7602);
var _i18n = __webpack_require__(14910);
var _liveconstants = __webpack_require__(73386);
var defaultTopBarItems = [
    {
        id: _liveconstants.TOP_BAR_ITEMS.BACK,
        icon: "ArrowLeftWithBase",
        text: (0, _i18n.t)("nav.backToNav"),
        action: _playerconstants.TOP_BAR_BACK
    },
    {
        id: _liveconstants.TOP_BAR_ITEMS.START_OVER,
        icon: "StartOver",
        text: (0, _i18n.t)("player.replay"),
        action: _playerconstants.TOP_BAR_START_OVER
    },
    {
        id: _liveconstants.TOP_BAR_ITEMS.BACK_TO_LIVE,
        icon: "BackToLive",
        text: (0, _i18n.t)("nav.backToLive"),
        action: _playerconstants.TOP_BAR_BACK_TO_LIVE
    },
    {
        id: _liveconstants.TOP_BAR_ITEMS.TRACKS,
        icon: "Tracks",
        text: (0, _i18n.t)("nav.subtitles"),
        action: _playerconstants.TOP_BAR_TRACKS
    },
    {
        id: _liveconstants.TOP_BAR_ITEMS.RELATED_VIDEOS,
        icon: "RelatedVideos",
        text: (0, _i18n.t)("nav.channelSelector"),
        action: _playerconstants.TOP_BAR_RELATED_VIDEOS
    },
    {
        id: _liveconstants.TOP_BAR_ITEMS.INFO_PAGE,
        icon: "Info",
        text: (0, _i18n.t)("nav.synopsis"),
        action: _playerconstants.TOP_BAR_INFO_PAGE
    }
];
var getTopBarItems = function(param) {
    var isOnLive = param.isOnLive, hasTracks = param.hasTracks, hasRelatedVideos = param.hasRelatedVideos, hasProgramInformation = param.hasProgramInformation, startOverFeature = param.startOverFeature;
    return defaultTopBarItems.filter(function(param) {
        var id = param.id;
        switch(id){
            case _liveconstants.TOP_BAR_ITEMS.START_OVER:
                return isOnLive && startOverFeature;
            case _liveconstants.TOP_BAR_ITEMS.BACK_TO_LIVE:
                return !isOnLive && startOverFeature;
            case _liveconstants.TOP_BAR_ITEMS.TRACKS:
                return hasTracks;
            case _liveconstants.TOP_BAR_ITEMS.RELATED_VIDEOS:
                return !_config.featureFlipping.player_liveHideRelatedChannels && hasRelatedVideos;
            case _liveconstants.TOP_BAR_ITEMS.INFO_PAGE:
                return hasProgramInformation;
            default:
                return true;
        }
    });
};


/***/ }),

/***/ 789:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _export_star = __webpack_require__(37668);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(65759);
_export_star._(__webpack_require__(2646), exports);


/***/ }),

/***/ 2646:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "Pairing", ({
    enumerable: true,
    get: function() {
        return Pairing;
    }
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(37815);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _config = __webpack_require__(67958);
var _pairingactions = __webpack_require__(83887);
var _lockactions = __webpack_require__(75250);
var _pairingconstants = __webpack_require__(25994);
var _analyticsutils = __webpack_require__(2693);
var _apputils = __webpack_require__(60368);
var _pairingProvideractions = __webpack_require__(35350);
var _layoutactions = __webpack_require__(8424);
var _popupactions = __webpack_require__(47531);
var _popupsconstants = __webpack_require__(60952);
var _routesutils = __webpack_require__(14948);
var _signals = __webpack_require__(2109);
var _spinnercomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(76976));
var _pairingSelectorcomponent = __webpack_require__(62531);
var _brandIconcomponent = __webpack_require__(362);
var _desktopPairingcomponent = __webpack_require__(50206);
var _mobilePairingcomponent = __webpack_require__(90838);
var _i18n = __webpack_require__(14910);
var _ssicomponent = __webpack_require__(73152);
var _pairingutils = __webpack_require__(54264);
var _pairingconstants1 = __webpack_require__(41367);
var _pairingstyle = __webpack_require__(60143);
var _pairingconnector = /*#__PURE__*/ _interop_require_default._(__webpack_require__(99049));
var Pairing = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(Pairing, _Lightning_Component);
    var _super = _create_super._(Pairing);
    function Pairing() {
        _class_call_check._(this, Pairing);
        return _super.apply(this, arguments);
    }
    _create_class._(Pairing, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _pairingstyle.defaultContext;
                this._focusedButton = 0;
                this._pairingIntervalId = null;
                this._tokenTimeout = null;
                this._pollingInterval = 10000;
                this._ssiCompletion = false;
            }
        },
        {
            key: "_build",
            value: function _build() {
                this.tag("Left").visible = false;
                this.tag("Right").visible = false;
                this.tag("Spinner").visible = false;
            }
        },
        {
            key: "_active",
            value: function _active() {
                var _this = this;
                return _async_to_generator._(function() {
                    var _ref, status, token, error, shouldDisplaySSI;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                (0, _apputils.removeSplashScreen)();
                                _this._ssiCompletion = false;
                                _this._unsubscribe = (0, _pairingconnector.default)(_this);
                                _this.tag("Spinner").visible = true;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    (0, _pairingProvideractions.getStatus)()
                                ];
                            case 2:
                                _ref = _state.sent(), status = _ref.status, token = _ref.token;
                                if (status.isPartnerLoginAllowed) {
                                    _this._ssiToken = token;
                                    _this._ssiAcceptanceRequired = status.displayTos;
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                error = _state.sent();
                                _this._ssiToken = null;
                                _this._ssiAcceptanceRequired = false;
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                _this.tag("Left").visible = true;
                                _this.tag("Right").visible = true;
                                _this.tag("Spinner").visible = false;
                                shouldDisplaySSI = Boolean(_this._ssiToken);
                                _this._views = [
                                    shouldDisplaySSI ? "SSI" : "",
                                    "Mobile",
                                    "Desktop"
                                ].filter(Boolean);
                                _this.tag("Left").buttons = [
                                    shouldDisplaySSI && {
                                        label: (0, _i18n.t)("pairing.token.magenta.button"),
                                        iconLeft: "Television",
                                        iconRight: "ArrowRight"
                                    },
                                    {
                                        label: (0, _i18n.t)("pairing.token.mobile.button"),
                                        iconLeft: "QRCode",
                                        iconRight: "ArrowRight"
                                    },
                                    {
                                        label: (0, _i18n.t)("pairing.token.computer.button"),
                                        iconLeft: "Laptop",
                                        iconRight: "ArrowRight"
                                    }
                                ].filter(Boolean);
                                _this.tag(_this._views[0]).visible = true;
                                // OTP pairing
                                _this._requestNewPairingCode();
                                _this._pairingIntervalId = setInterval(function() {
                                    return _lightningjsredux.default.dispatch((0, _pairingactions.getStatus)());
                                }, _this._pollingInterval);
                                _this._setState("Left");
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_inactive",
            value: function _inactive() {
                this._clearTokenTimeout();
                this._clearPairingInterval();
                if (this._unsubscribe) {
                    this._unsubscribe();
                    this._unsubscribe = null;
                }
                _lightningjsredux.default.dispatch((0, _pairingactions.clearPairingToken)());
            }
        },
        {
            key: "_switchViews",
            value: function _switchViews(index) {
                var _this = this;
                this._views.forEach(function(view, i) {
                    _this.tag(view).visible = i === index;
                });
            }
        },
        {
            key: "_handleAccept",
            value: function _handleAccept() {
                var _this = this;
                return _async_to_generator._(function() {
                    var error;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this._ssiCompletion = true;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    ,
                                    7
                                ]);
                                if (!_this._ssiAcceptanceRequired) return [
                                    3,
                                    2
                                ];
                                (0, _routesutils.navigateTo)("ssi");
                                return [
                                    3,
                                    5
                                ];
                            case 2:
                                return [
                                    4,
                                    (0, _pairingProvideractions.exchangePlatformToken)(_this._ssiToken)
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    4,
                                    _lightningjsredux.default.dispatch((0, _pairingactions.getCurrentPairedUser)(true))
                                ];
                            case 4:
                                _state.sent();
                                _this._completePairing();
                                _state.label = 5;
                            case 5:
                                return [
                                    3,
                                    7
                                ];
                            case 6:
                                error = _state.sent();
                                _lightningjsredux.default.dispatch((0, _popupactions.showPopupAction)(_popupsconstants.FATAL_ERROR_POPUP_ID, {
                                    routeBackOnClose: false,
                                    exitAppOnClose: false
                                }));
                                _this.tag("SSI").reset();
                                return [
                                    3,
                                    7
                                ];
                            case 7:
                                _this._ssiCompletion = false;
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_requestNewPairingCode",
            value: function _requestNewPairingCode() {
                _lightningjsredux.default.dispatch((0, _pairingactions.fetchToken)());
                _lightningjsredux.default.dispatch((0, _lockactions.disableProfileAutoSelect)());
            }
        },
        {
            key: "_clearTokenTimeout",
            value: function _clearTokenTimeout() {
                if (this._tokenTimeout) {
                    clearTimeout(this._tokenTimeout);
                }
            }
        },
        {
            key: "_clearPairingInterval",
            value: function _clearPairingInterval() {
                if (this._pairingIntervalId) {
                    clearInterval(this._pairingIntervalId);
                }
                this._pairingIntervalId = null;
            }
        },
        {
            key: "_completePairing",
            value: function _completePairing() {
                _lightningjsredux.default.dispatch((0, _layoutactions.clearCache)());
                // as we just cleared the cache, requesting new navigation layout
                _lightningjsredux.default.dispatch((0, _layoutactions.fetchNavigation)());
                // eslint-disable-next-line no-console
                console.log("[Pairing] Moving to deeplink: ".concat(this._deeplink));
                (0, _routesutils.navigateTo)(this._deeplink || _routesutils.HOME_PATH, false);
            }
        },
        {
            key: "pollingInterval",
            set: function set(value) {
                this._pollingInterval = value;
                if (this._pairingIntervalId) {
                    this._clearPairingInterval();
                    this._pairingIntervalId = setInterval(function() {
                        return _lightningjsredux.default.dispatch((0, _pairingactions.getStatus)());
                    }, this._pollingInterval);
                }
            }
        },
        {
            key: "deeplink",
            set: function set(value) {
                this._deeplink = value;
                // eslint-disable-next-line no-console
                console.log("[Pairing] Deeplink set: ".concat(this._deeplink));
            }
        },
        {
            key: "token",
            set: function set(value) {
                if (!value) return;
                this._clearTokenTimeout();
                this._tokenTimeout = setTimeout(function() {
                    return _sdk.Router.back();
                }, _config.pairing.pairingTimeout);
                this.tag("Desktop").token = value;
            }
        },
        {
            key: "url",
            set: function set(value) {
                this.tag("Mobile").url = value;
            }
        },
        {
            key: "pairingStatus",
            set: function set(status) {
                // preventing race condition when both auth methods where triggered
                if (this._ssiCompletion) {
                    return;
                }
                if (status === _pairingconstants.PAIRING_STATUS_PAIRED) {
                    (0, _pairingutils.setPairingMethod)(_pairingconstants1.PAIRING_METHOD.PAIRING);
                    this._completePairing();
                }
            }
        },
        {
            key: "_handleBack",
            value: function _handleBack() {
                (0, _analyticsutils.sendEvent)({
                    key: "pressTokenBackButton"
                });
                return false;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Background: {
                        rect: true
                    },
                    CustomerIcon: {
                        type: _brandIconcomponent.BrandIcon
                    },
                    Left: {
                        type: _pairingSelectorcomponent.PairingSelector,
                        labels: {
                            title: (0, _i18n.t)("pairing.token.connect")
                        },
                        signals: _define_property._({}, _signals.SELECTED_SIGNAL, "_switchViews")
                    },
                    Right: {
                        SSI: {
                            type: _ssicomponent.SSIPairing,
                            signals: {
                                accept: "_handleAccept"
                            }
                        },
                        Mobile: {
                            type: _mobilePairingcomponent.MobilePairing,
                            labels: {
                                title: (0, _i18n.t)("pairing.token.synchRedirection"),
                                steps: "pairing.token.mobile.steps.step",
                                stepsCount: 2
                            }
                        },
                        Desktop: {
                            type: _desktopPairingcomponent.DesktopPairing,
                            labels: {
                                title: (0, _i18n.t)("pairing.token.synchRedirection"),
                                steps: "pairing.token.computer.steps.step",
                                stepsCount: 3
                            }
                        }
                    },
                    Spinner: {
                        type: _spinnercomponent.default
                    }
                }, (0, _pairingstyle.getInitialStyle)());
            }
        },
        {
            key: "_states",
            value: function _states() {
                return [
                    /*#__PURE__*/ function(_this) {
                        _inherits._(Left, _this);
                        var _super = _create_super._(Left);
                        function Left() {
                            _class_call_check._(this, Left);
                            return _super.apply(this, arguments);
                        }
                        _create_class._(Left, [
                            {
                                key: "_getFocused",
                                value: function _getFocused() {
                                    return this.tag("Left");
                                }
                            },
                            {
                                key: "_handleRight",
                                value: function _handleRight() {
                                    if ((0, _pairingutils.hasSSISupport)() && this.tag("SSI").visible) {
                                        this._setState("Right");
                                        return true;
                                    }
                                    return false;
                                }
                            }
                        ]);
                        return Left;
                    }(this),
                    /*#__PURE__*/ function(_this) {
                        _inherits._(Right, _this);
                        var _super = _create_super._(Right);
                        function Right() {
                            _class_call_check._(this, Right);
                            return _super.apply(this, arguments);
                        }
                        _create_class._(Right, [
                            {
                                key: "_getFocused",
                                value: function _getFocused() {
                                    var _$_this = this;
                                    return this._views.map(function(id) {
                                        return _$_this.tag(id);
                                    }).find(function(view) {
                                        return view.visible;
                                    });
                                }
                            },
                            {
                                key: "_handleLeft",
                                value: function _handleLeft() {
                                    if (this._ssiCompletion) {
                                        return false;
                                    }
                                    this._setState("Left");
                                    return true;
                                }
                            }
                        ]);
                        return Right;
                    }(this)
                ];
            }
        }
    ]);
    return Pairing;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 99049:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(3009);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _pairingselectors = __webpack_require__(59739);
var _routingselectors = __webpack_require__(2001);
var mapControllers = function(instance) {
    return [
        {
            selector: _pairingselectors.getPollingInterval,
            callback: function(value) {
                instance.pollingInterval = value;
            }
        },
        {
            selector: _routingselectors.getDeepLink,
            callback: function(value) {
                instance.deeplink = value;
            }
        },
        {
            selector: _pairingselectors.getPairingStatus,
            callback: function(value) {
                instance.pairingStatus = value;
            }
        },
        {
            selector: _pairingselectors.getPairingToken,
            callback: function(value) {
                instance.token = value;
            }
        },
        {
            selector: _pairingselectors.getPairingURI,
            callback: function(value) {
                instance.url = value;
            }
        }
    ];
};
var _default = _lightningjsredux.default.control(mapControllers);


/***/ }),

/***/ 60143:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ICON_MARGIN_BOTTOM: function() {
        return ICON_MARGIN_BOTTOM;
    },
    ICON_MARGIN_TOP: function() {
        return ICON_MARGIN_TOP;
    },
    LEFT_WIDTH: function() {
        return _pairingSelectorstyle.WIDTH;
    },
    LOGO_HEIGHT: function() {
        return LOGO_HEIGHT;
    },
    SPACER: function() {
        return _pairingSelectorstyle.SPACER;
    },
    SPINNER_SIZE: function() {
        return SPINNER_SIZE;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _object_spread = __webpack_require__(76247);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(37815);
var _theme = __webpack_require__(51397);
var _constants = __webpack_require__(34952);
var _style = __webpack_require__(65082);
var _sizes = __webpack_require__(82699);
var _pairingSelectorstyle = __webpack_require__(13106);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var colors = {
    background: (0, _theme.makeThemeColor)(_theme.TERTIARY),
    separator: (0, _theme.makeThemeColor)(_theme.PRIMARY, 0.3)
};
var _obj;
var LOGO_HEIGHT = (_obj = {}, _define_property._(_obj, _constants.HD, 96), _define_property._(_obj, _constants.FULL_HD, 152), _obj);
var ICON_MARGIN_TOP = _object_spread._({}, _constants.safetyMargins.vertical);
var _obj1;
var ICON_MARGIN_BOTTOM = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 24), _define_property._(_obj1, _constants.FULL_HD, 24), _obj1);
var _obj2;
var SPINNER_SIZE = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 100), _define_property._(_obj2, _constants.FULL_HD, 100), _obj2);
var getInitialStyle = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext, _ref_screenSize = _ref.screenSize, screenSize = _ref_screenSize === void 0 ? _constants.FULL_HD : _ref_screenSize, _ref_colorMode = _ref.colorMode, colorMode = _ref_colorMode === void 0 ? _theme.DEFAULT_MODE : _ref_colorMode;
    var top = ICON_MARGIN_TOP[screenSize] + LOGO_HEIGHT[screenSize] + ICON_MARGIN_BOTTOM[screenSize];
    var containerHeight = _sizes.SCREEN_HEIGHT[screenSize] - top - _constants.safetyMargins.vertical[screenSize];
    var rightWidth = _sizes.SCREEN_WIDTH[screenSize] - _constants.safetyMargins.horizontal[screenSize] * 2 - _pairingSelectorstyle.WIDTH[screenSize] - _pairingSelectorstyle.SPACER[screenSize];
    return {
        w: _sizes.SCREEN_WIDTH[screenSize],
        h: _sizes.SCREEN_HEIGHT[screenSize],
        Background: {
            w: _sizes.SCREEN_WIDTH[screenSize],
            h: _sizes.SCREEN_HEIGHT[screenSize],
            color: colors.background[colorMode]
        },
        CustomerIcon: {
            y: ICON_MARGIN_TOP[screenSize],
            mountX: 0.5,
            x: _sizes.middle,
            h: LOGO_HEIGHT[screenSize]
        },
        Left: {
            y: top,
            h: containerHeight
        },
        Right: {
            x: _constants.safetyMargins.horizontal[screenSize] + _pairingSelectorstyle.WIDTH[screenSize] + _pairingSelectorstyle.SPACER[screenSize],
            y: top,
            h: containerHeight,
            w: rightWidth,
            Mobile: {
                visible: false,
                h: containerHeight,
                w: rightWidth
            },
            Desktop: {
                visible: false,
                h: containerHeight,
                w: rightWidth
            },
            SSI: {
                visible: false,
                w: rightWidth
            }
        },
        Spinner: {
            visible: false,
            w: SPINNER_SIZE[screenSize],
            h: SPINNER_SIZE[screenSize],
            x: _sizes.middle,
            y: _sizes.middle,
            mountX: 0.5
        }
    };
};


/***/ }),

/***/ 73152:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "SSIPairing", ({
    enumerable: true,
    get: function() {
        return SSIPairing;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _get = __webpack_require__(60528);
var _get_prototype_of = __webpack_require__(35196);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _set = __webpack_require__(81364);
var _create_super = __webpack_require__(6400);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _i18n = __webpack_require__(14910);
var _buttoncomponent = __webpack_require__(31464);
var _spinnercomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(76976));
var _ssistyle = __webpack_require__(82145);
var SSIPairing = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(SSIPairing, _Lightning_Component);
    var _super = _create_super._(SSIPairing);
    function SSIPairing() {
        _class_call_check._(this, SSIPairing);
        return _super.apply(this, arguments);
    }
    _create_class._(SSIPairing, [
        {
            key: "_construct",
            value: function _construct() {
                this._index = 0;
            }
        },
        {
            key: "w",
            get: function get() {
                return _get._(_get_prototype_of._(SSIPairing.prototype), "w", this);
            },
            set: function set(value) {
                _set._(_get_prototype_of._(SSIPairing.prototype), "w", value, this, true);
                // WARN: only static values are supported
                this.patch({
                    Title: {
                        text: {
                            wordWrapWidth: value
                        }
                    },
                    Description: {
                        text: {
                            wordWrapWidth: value
                        }
                    },
                    Buttons: {
                        w: value
                    }
                });
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.patch({
                    Buttons: {
                        visible: true
                    },
                    Spinner: {
                        visible: false
                    }
                });
            }
        },
        {
            key: "_focus",
            value: function _focus() {
                this._index = 0;
            }
        },
        {
            key: "_getFocused",
            value: function _getFocused() {
                return this.tag("Buttons").children[this._index];
            }
        },
        {
            key: "_handleEnter",
            value: function _handleEnter() {
                var buttons = this.tag("Buttons");
                if (buttons.visible) {
                    buttons.visible = false;
                    this.tag("Spinner").visible = true;
                    this.signal("accept");
                }
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Title: {
                        text: {
                            text: (0, _i18n.t)("pairing.token.magenta.title")
                        }
                    },
                    Buttons: {
                        Accept: {
                            type: _buttoncomponent.Button,
                            label: (0, _i18n.t)("pairing.token.magenta.accept")
                        },
                        Decline: {
                            type: _buttoncomponent.Button
                        }
                    },
                    Spinner: {
                        type: _spinnercomponent.default
                    }
                }, (0, _ssistyle.getInitialStyle)());
            }
        }
    ]);
    return SSIPairing;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 82145:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BUTTONS_MARGIN: function() {
        return BUTTONS_MARGIN;
    },
    SPINNER_SIZE: function() {
        return SPINNER_SIZE;
    },
    TEXT_MARGIN: function() {
        return TEXT_MARGIN;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(42578);
var _theme = __webpack_require__(51397);
var _constants = __webpack_require__(34952);
var _typography = __webpack_require__(18411);
var _style = __webpack_require__(65082);
var _sizes = __webpack_require__(82699);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var colors = {
    text: (0, _theme.makeThemeColor)(_theme.PRIMARY)
};
var _obj;
var TEXT_MARGIN = (_obj = {}, _define_property._(_obj, _constants.HD, 8), _define_property._(_obj, _constants.FULL_HD, 8), _obj);
var _obj1;
var BUTTONS_MARGIN = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 24), _define_property._(_obj1, _constants.FULL_HD, 32), _obj1);
var _obj2;
var SPINNER_SIZE = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 32), _define_property._(_obj2, _constants.FULL_HD, 32), _obj2);
var getInitialStyle = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext, _ref_screenSize = _ref.screenSize, screenSize = _ref_screenSize === void 0 ? _constants.FULL_HD : _ref_screenSize, _ref_colorMode = _ref.colorMode, colorMode = _ref_colorMode === void 0 ? _theme.DEFAULT_MODE : _ref_colorMode;
    return {
        flex: {
            direction: "column"
        },
        Title: {
            text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT.PARIS_2, screenSize)), {
                textColor: colors.text[colorMode]
            }),
            flexItem: {
                marginBottom: TEXT_MARGIN[screenSize]
            }
        },
        Description: {
            text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT.OTTAWA_1, screenSize)), {
                textColor: colors.text[colorMode]
            })
        },
        Buttons: {
            flexItem: {
                marginTop: BUTTONS_MARGIN[screenSize]
            },
            flex: {
                alignItems: "center",
                justifyContent: "center",
                direction: "row"
            },
            Accept: {
                flexItem: {
                    marginRight: BUTTONS_MARGIN[screenSize]
                }
            },
            Decline: {}
        },
        Spinner: {
            visible: false,
            w: SPINNER_SIZE[screenSize],
            h: SPINNER_SIZE[screenSize],
            x: _sizes.middle,
            mountX: 0.5,
            flexItem: {
                marginTop: BUTTONS_MARGIN[screenSize]
            }
        }
    };
};


/***/ }),

/***/ 64331:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _export_star = __webpack_require__(37668);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(52318);
_export_star._(__webpack_require__(789), exports);


/***/ }),

/***/ 41367:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    PAIRING_METHOD: function() {
        return PAIRING_METHOD;
    },
    SKIP_SSI_KEY: function() {
        return SKIP_SSI_KEY;
    }
});
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(3009);
var PAIRING_METHOD = {
    NONE: "none",
    PAIRING: "pairing",
    SSI: "ssi"
};
var SKIP_SSI_KEY = "skip_SSI";


/***/ }),

/***/ 54264:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    getPairingMethod: function() {
        return getPairingMethod;
    },
    setPairingMethod: function() {
        return setPairingMethod;
    }
});
var _export_star = __webpack_require__(37668);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(65759);
_export_star._(__webpack_require__(6499), exports);
var PAIRING_METHOD_KEY = "pairing_method";
var getPairingMethod = function() {
    return localStorage.getItem(PAIRING_METHOD_KEY);
};
var setPairingMethod = function(value) {
    return localStorage.setItem(PAIRING_METHOD_KEY, value);
};


/***/ }),

/***/ 6499:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    hasSSISupport: function() {
        return hasSSISupport;
    },
    rememberSSIDeclined: function() {
        return rememberSSIDeclined;
    },
    shouldSkipSSI: function() {
        return shouldSkipSSI;
    }
});
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(65759);
var _pairingconstants = __webpack_require__(41367);
var hasSSISupport = function() {
    try {
        var params = new URLSearchParams(window.location.search);
        return params.has("token");
    } catch (error) {
        return false;
    }
};
var rememberSSIDeclined = function() {
    localStorage.setItem(_pairingconstants.SKIP_SSI_KEY, true);
};
var shouldSkipSSI = function() {
    return localStorage.getItem(_pairingconstants.SKIP_SSI_KEY) === "true";
};


/***/ }),

/***/ 97140:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "TermsOfService", ({
    enumerable: true,
    get: function() {
        return TermsOfService;
    }
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(3009);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _routesutils = __webpack_require__(14948);
var _apputils = __webpack_require__(60368);
var _default = __webpack_require__(46066);
var _pairingactions = __webpack_require__(83887);
var _layoutactions = __webpack_require__(8424);
var _popupactions = __webpack_require__(47531);
var _lifecyclesutils = __webpack_require__(10126);
var _popupsconstants = __webpack_require__(60952);
var _i18n = __webpack_require__(14910);
var _buttoncomponent = __webpack_require__(31464);
var _spinnercomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(76976));
var _pairingutils = __webpack_require__(54264);
var _tosstyle = __webpack_require__(84382);
var _tosconnector = /*#__PURE__*/ _interop_require_default._(__webpack_require__(62352));
var TermsOfService = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(TermsOfService, _Lightning_Component);
    var _super = _create_super._(TermsOfService);
    function TermsOfService() {
        _class_call_check._(this, TermsOfService);
        return _super.apply(this, arguments);
    }
    _create_class._(TermsOfService, [
        {
            key: "_construct",
            value: function _construct() {
                this._index = 0;
                this._style = _tosstyle.defaultContext;
            }
        },
        {
            key: "_active",
            value: function _active() {
                (0, _apputils.removeSplashScreen)();
                this._unsubscribe = (0, _tosconnector.default)(this);
            }
        },
        {
            key: "_inactive",
            value: function _inactive() {
                if (this._unsubscribe) {
                    this._unsubscribe();
                    this._unsubscribe = null;
                }
            }
        },
        {
            key: "deeplink",
            set: function set(value) {
                this._deeplink = value;
            }
        },
        {
            key: "_focus",
            value: function _focus() {
                this._index = 0;
            }
        },
        {
            key: "_handleLeft",
            value: function _handleLeft() {
                this._index = 0;
                return true;
            }
        },
        {
            key: "_handleRight",
            value: function _handleRight() {
                this._index = 1;
                return true;
            }
        },
        {
            key: "_getFocused",
            value: function _getFocused() {
                return this.tag("Buttons").children[this._index];
            }
        },
        {
            key: "_handleEnter",
            value: function _handleEnter() {
                if (!this.tag("Buttons").visible) {
                    return false;
                }
                if (this._index) {
                    this._handleDecline();
                } else {
                    this._handleAccept();
                }
                return true;
            }
        },
        {
            key: "_handleAccept",
            value: function _handleAccept() {
                var _this = this;
                return _async_to_generator._(function() {
                    var isPaired;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.patch({
                                    Buttons: {
                                        visible: false
                                    },
                                    Spinner: {
                                        visible: true
                                    }
                                });
                                return [
                                    4,
                                    (0, _default.singleSignIn)(true)
                                ];
                            case 1:
                                isPaired = _state.sent();
                                if (!isPaired) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    _lightningjsredux.default.dispatch((0, _pairingactions.getCurrentPairedUser)(true))
                                ];
                            case 2:
                                _state.sent();
                                _lightningjsredux.default.dispatch((0, _layoutactions.clearCache)());
                                // as we just cleared the cache, requesting new navigation layout
                                _lightningjsredux.default.dispatch((0, _layoutactions.fetchNavigation)());
                                (0, _routesutils.navigateTo)(_this._deeplink || _routesutils.HOME_PATH, false);
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                (0, _lifecyclesutils.setCloseReason)("error");
                                _lightningjsredux.default.dispatch((0, _popupactions.showPopupAction)(_popupsconstants.FATAL_ERROR_POPUP_ID, {}));
                                _state.label = 4;
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_handleDecline",
            value: function _handleDecline() {
                (0, _pairingutils.rememberSSIDeclined)();
                (0, _routesutils.navigateTo)(_routesutils.HOME_PATH);
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Title: {
                        text: {
                            text: (0, _i18n.t)("pairing.ssi.title")
                        }
                    },
                    Description: {
                        text: {
                            text: (0, _i18n.t)("pairing.ssi.description")
                        }
                    },
                    Buttons: {
                        Accept: {
                            type: _buttoncomponent.Button,
                            label: (0, _i18n.t)("pairing.ssi.accept")
                        },
                        Decline: {
                            type: _buttoncomponent.Button,
                            label: (0, _i18n.t)("pairing.ssi.decline")
                        }
                    },
                    Spinner: {
                        type: _spinnercomponent.default
                    }
                }, (0, _tosstyle.getInitialStyle)());
            }
        }
    ]);
    return TermsOfService;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 62352:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(45538);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _routingselectors = __webpack_require__(2001);
var mapControllers = function(instance) {
    return [
        {
            selector: _routingselectors.getDeepLink,
            callback: function(value) {
                instance.deeplink = value;
            },
            shouldBeInvokedOnConnect: true
        }
    ];
};
var _default = _lightningjsredux.default.control(mapControllers);


/***/ }),

/***/ 84382:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BUTTONS_MARGIN: function() {
        return BUTTONS_MARGIN;
    },
    SPINNER_SIZE: function() {
        return SPINNER_SIZE;
    },
    TEXT_MARGIN: function() {
        return TEXT_MARGIN;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(42578);
var _theme = __webpack_require__(51397);
var _constants = __webpack_require__(34952);
var _typography = __webpack_require__(18411);
var _sizes = __webpack_require__(82699);
var _style = __webpack_require__(65082);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var colors = {
    text: (0, _theme.makeThemeColor)(_theme.PRIMARY)
};
var _obj;
var TEXT_MARGIN = (_obj = {}, _define_property._(_obj, _constants.HD, 24), _define_property._(_obj, _constants.FULL_HD, 32), _obj);
var _obj1;
var BUTTONS_MARGIN = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 24), _define_property._(_obj1, _constants.FULL_HD, 32), _obj1);
var _obj2;
var SPINNER_SIZE = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 32), _define_property._(_obj2, _constants.FULL_HD, 32), _obj2);
var getInitialStyle = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext, _ref_screenSize = _ref.screenSize, screenSize = _ref_screenSize === void 0 ? _constants.FULL_HD : _ref_screenSize, _ref_colorMode = _ref.colorMode, colorMode = _ref_colorMode === void 0 ? _theme.DEFAULT_MODE : _ref_colorMode;
    var w = _sizes.SCREEN_WIDTH[screenSize] * 0.7;
    return {
        w: _sizes.SCREEN_WIDTH[screenSize],
        h: _sizes.SCREEN_HEIGHT[screenSize],
        flex: {
            direction: "column",
            alignItems: "center",
            justifyContent: "center"
        },
        Title: {
            text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT.PARIS_2, screenSize)), {
                textAlign: "center",
                wordWrapWidth: w,
                textColor: colors.text[colorMode]
            }),
            flexItem: {
                marginBottom: TEXT_MARGIN[screenSize]
            }
        },
        Description: {
            text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT.OTTAWA_1, screenSize)), {
                textAlign: "center",
                wordWrapWidth: w,
                textColor: colors.text[colorMode]
            })
        },
        Buttons: {
            w: w,
            flexItem: {
                marginTop: BUTTONS_MARGIN[screenSize]
            },
            flex: {
                alignItems: "center",
                justifyContent: "center",
                direction: "row"
            },
            Accept: {
                flexItem: {
                    marginRight: BUTTONS_MARGIN[screenSize]
                }
            },
            Decline: {}
        },
        Spinner: {
            visible: false,
            w: SPINNER_SIZE[screenSize],
            h: SPINNER_SIZE[screenSize],
            flexItem: {
                marginTop: BUTTONS_MARGIN[screenSize]
            }
        }
    };
};


/***/ }),

/***/ 78036:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/* eslint-disable no-console */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "AdsAdapter", ({
    enumerable: true,
    get: function() {
        return AdsAdapter;
    }
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(3009);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _config = __webpack_require__(67958);
var _utils = __webpack_require__(64188);
var _mediaengine = __webpack_require__(88918);
var _playerconstants = __webpack_require__(7602);
var _erroractions = __webpack_require__(39258);
var _errorconstants = __webpack_require__(16186);
var _adsutils = __webpack_require__(48691);
var _analyticsutils = __webpack_require__(2693);
var _adsconstants = __webpack_require__(61726);
var _playerselectors = __webpack_require__(83318);
var AdsAdapter = /*#__PURE__*/ function() {
    "use strict";
    function AdsAdapter() {
        _class_call_check._(this, AdsAdapter);
    }
    _create_class._(AdsAdapter, [
        {
            key: "init",
            value: /**
   * Creates ad bridge instance correspondent to provided settings
   *
   * @param {Object} settings
   * @param {Object} settings.contentHandlers key-value map containing ad bridge callback handlers
   * @param {Number} settings.contentDuration duration of a video
   * @param {string} settings.providerId ads provider id, as given by the Layout API
   * @param {Object} settings.providerConfig advertising data defined for a specific provider, as given by the Layout API
   * @returns {Object}
   */ function init(param) {
                var contentHandlers = param.contentHandlers, contentDuration = param.contentDuration, providerId = param.providerId, providerConfig = param.providerConfig;
                var _this = this;
                return _async_to_generator._(function() {
                    var Bridge, _ref, engine, eventHandlers, _this__renderers, videoRef, containerRef, companionRef, adBridge;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!providerId || !providerConfig) {
                                    return [
                                        2,
                                        null
                                    ];
                                }
                                providerConfig.capping = providerConfig.brParams && providerConfig.brParams.capping || providerConfig.capping;
                                providerConfig.queryParams = (0, _adsutils.updateQueryParams)(providerConfig);
                                Bridge = (0, _adsutils.bridgeClassByProviderId)(providerId);
                                if (!Bridge) {
                                    return [
                                        2,
                                        null
                                    ];
                                }
                                return [
                                    4,
                                    (0, _mediaengine.getAdPlayerInstance)()
                                ];
                            case 1:
                                _ref = _state.sent(), engine = _ref.Engine;
                                eventHandlers = {
                                    onBreakStarted: function(event) {
                                        var _ref = event || {}, type = _ref.type, silent = _ref.silent;
                                        if (!silent) {
                                            var adBreak = (0, _get.default)(_this._adBridge, "engine.currentSlot");
                                            _lightningjsredux.default.dispatch((0, _playerconstants.adBreakStarted)(type, _this._adBridge.getSlotsDuration() || (0, _adsutils.getAdsDurationInSeconds)(adBreak)));
                                        }
                                        var analyticsKey = (0, _get.default)(_adsconstants.AD_ANALYTICS_TYPES.begin, type, null);
                                        if (analyticsKey) {
                                            (0, _analyticsutils.setAttributes)({
                                                adBreakId: event.reference
                                            });
                                            _this._currentAdBreakEvent = analyticsKey;
                                        }
                                    },
                                    onBreakEnded: function() {
                                        // NOTE: for some reason the onSlotEnded callback in the ad engine is not always working
                                        if (_this._adBridge) {
                                            _this._adBridge.endedAdsDuration = 0;
                                        }
                                        var type = (0, _playerselectors.getDisplayedAdBreakType)(_lightningjsredux.default.getState());
                                        _lightningjsredux.default.dispatch((0, _playerconstants.adBreakEnded)());
                                        var analyticsKey = (0, _get.default)(_adsconstants.AD_ANALYTICS_TYPES.post, type, null);
                                        if (analyticsKey) {
                                            (0, _analyticsutils.sendEvent)({
                                                key: analyticsKey
                                            });
                                        }
                                    },
                                    onEnded: function() {
                                        console.log("[ads.adapter] Ad ended");
                                        _lightningjsredux.default.dispatch((0, _playerconstants.adEnded)());
                                        (0, _analyticsutils.sendEvent)({
                                            key: "adComplete"
                                        });
                                    },
                                    onError: function(error) {
                                        console.log("[ads.adapter] Ad error:", error);
                                        _this.notifyAdBreakStarted();
                                        if (error) {
                                            _lightningjsredux.default.dispatch((0, _playerconstants.adError)(error));
                                        }
                                    },
                                    onPlaying: function() {
                                        console.log("[ads.adapter] Ad playing");
                                        _lightningjsredux.default.dispatch((0, _playerconstants.adPlaying)());
                                    },
                                    onPaused: function() {
                                        console.log("[ads.adapter] Ad paused");
                                        _lightningjsredux.default.dispatch((0, _playerconstants.adPaused)());
                                    },
                                    onProviderLoaded: function() {
                                        console.log("[ads.adapter] Ads provider loaded");
                                        _lightningjsredux.default.dispatch((0, _playerconstants.adProviderLoaded)());
                                    },
                                    onAdBreakListUpdate: function(cuePoints) {
                                        console.log("[ads.adapter] Ads breaks list updated:", cuePoints);
                                        _lightningjsredux.default.dispatch((0, _playerconstants.adMarkers)(cuePoints));
                                    },
                                    onAdLoaded: function() {
                                        console.log("[ads.adapter] Ad loaded");
                                    },
                                    onProviderLoading: function() {
                                        console.log("[ads.adapter] Ad provider loading");
                                    },
                                    onStarted: function(event) {
                                        _this.notifyAdBreakStarted();
                                        var adId = event.adId, duration = event.duration, skipOffset = event.skipOffset;
                                        console.log("[ads.adapter] Ad ".concat(adId, " started with duration of ").concat(duration, " seconds"));
                                        // Sending analytics
                                        (0, _analyticsutils.setAttributes)({
                                            adId: adId,
                                            adDuration: duration
                                        });
                                        (0, _analyticsutils.sendEvent)({
                                            key: "adStarted"
                                        });
                                        _lightningjsredux.default.dispatch((0, _playerconstants.adStarted)(skipOffset));
                                        // NOTE: first "playing" event is interpreted as ad start by the ad-engine
                                        _lightningjsredux.default.dispatch((0, _playerconstants.adPlaying)());
                                    },
                                    onAdStopped: function() {
                                        console.log("[ads.adapter] Ad stopped");
                                    },
                                    onAdPaused: function() {
                                        console.log("[ads.adapter] Ad paused");
                                    },
                                    onFirstQuartile: function() {
                                        (0, _analyticsutils.sendEvent)({
                                            key: "adFirstQuartile"
                                        });
                                    },
                                    onMidPoint: function() {
                                        (0, _analyticsutils.sendEvent)({
                                            key: "adMidPoint"
                                        });
                                    },
                                    onThirdQuartile: function() {
                                        (0, _analyticsutils.sendEvent)({
                                            key: "adThirdQuartile"
                                        });
                                    },
                                    onBreakCapping: function() {
                                        console.log("[ads.adapter] Ad break capping, skipping this one");
                                    }
                                };
                                _this._renderers = (0, _adsutils.createRenderers)("ads");
                                _this__renderers = _this._renderers, videoRef = _this__renderers.video, containerRef = _this__renderers.container, companionRef = _this__renderers.companion;
                                videoRef.autoplay = true;
                                adBridge = new Bridge(_object_spread_props._(_object_spread._({}, providerConfig), {
                                    contentDuration: contentDuration,
                                    features: {
                                        lazy: Boolean(_config.featureFlipping.player_adLazyVmap),
                                        triggerSlotOnSeek: {
                                            enabled: Boolean(_config.featureFlipping.player_antiFF),
                                            preventDelayWhenFutureBreak: 10
                                        }
                                    },
                                    volume: providerConfig.volume || _adsconstants.DEFAULT_VOLUME_LEVEL
                                }), eventHandlers, contentHandlers, {
                                    VideoEngine: engine,
                                    storage: _utils.storage,
                                    adEventError: {
                                        adUnknownError: "AD_UNKNOWN_ERROR",
                                        adError: "AD_ERROR"
                                    }
                                });
                                adBridge.setContainerRef(containerRef);
                                adBridge.setCompanionRef(companionRef);
                                adBridge.setVideoRef(videoRef);
                                adBridge.contentHasStarted();
                                _this._adTimeUpdateHandler = _this.onAdTimeUpdate.bind(_this);
                                _this._renderers.video.addEventListener("timeupdate", _this._adTimeUpdateHandler);
                                _this._adBridge = adBridge;
                                return [
                                    2,
                                    {
                                        bridge: adBridge
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "notifyAdBreakStarted",
            value: function notifyAdBreakStarted() {
                if (this._currentAdBreakEvent) {
                    (0, _analyticsutils.sendEvent)({
                        key: this._currentAdBreakEvent
                    });
                    this._currentAdBreakEvent = undefined;
                }
            }
        },
        {
            key: "onAdTimeUpdate",
            value: function onAdTimeUpdate(event) {
                if (!this._adBridge || !event.target || !Number.isFinite(event.target.currentTime)) {
                    return;
                }
                _lightningjsredux.default.dispatch((0, _playerconstants.adTimeUpdate)(event.target.currentTime));
                _lightningjsredux.default.dispatch((0, _playerconstants.adBreakTimeUpdate)(event.target.currentTime + this._adBridge.getEndedAdsDuration()));
            }
        },
        {
            key: "reset",
            value: function reset() {
                if (this._adBridge) {
                    try {
                        this._adBridge.release();
                    } catch (error) {
                        _lightningjsredux.default.dispatch((0, _erroractions.errorAction)(_errorconstants.ERROR_LEVELS.SILENT, _errorconstants.ERROR_TYPES.GENERAL, error.message));
                    }
                }
                this._adBridge = null;
                this._currentAdBreakEvent = undefined;
                if (this._renderers) {
                    Object.values(this._renderers).forEach(function(renderer) {
                        if (renderer && renderer.parentNode) {
                            renderer.parentNode.removeChild(renderer);
                        }
                    });
                    if (this._renderers.video) {
                        this._renderers.video.removeEventListener("timeupdate", this._adTimeUpdateHandler);
                    }
                }
                this._renderers = null;
                this._adTimeUpdateHandler = null;
            }
        }
    ]);
    return AdsAdapter;
}();


/***/ }),

/***/ 73262:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _export_star = __webpack_require__(37668);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(42578);
_export_star._(__webpack_require__(86377), exports);


/***/ }),

/***/ 47473:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _playerselectors = __webpack_require__(83318);
var _featuresselectors = __webpack_require__(76109);
var mapControllers = function(instance) {
    return [
        {
            selector: _playerselectors.getVideoAds,
            callback: function(value) {
                instance.advertisement = value;
            },
            shouldBeInvokedOnConnect: true
        },
        {
            selector: _playerselectors.getAdBreakDuration,
            callback: function(value) {
                instance.adBreakDuration = value;
            },
            shouldBeInvokedOnConnect: true
        },
        {
            selector: _playerselectors.getAdSkipOffset,
            callback: function(value) {
                instance.adSkipOffset = value;
            },
            shouldBeInvokedOnConnect: true
        },
        {
            selector: _playerselectors.getAdElapsedTime,
            callback: function(value) {
                instance.adElapsedTime = value;
            },
            shouldBeInvokedOnConnect: true
        },
        {
            selector: _playerselectors.getAdBreakElapsedTime,
            callback: function(value) {
                instance.adBreakElapsedTime = value;
            },
            shouldBeInvokedOnConnect: true
        },
        {
            selector: _featuresselectors.getPlayerAdsCountFeature,
            callback: function(value) {
                instance.displayAdsCountdown = value;
            },
            shouldBeInvokedOnConnect: true
        },
        {
            selector: _playerselectors.getAdJingleImageId,
            callback: function(value) {
                instance.adJingleImageId = value;
            },
            shouldBeInvokedOnConnect: true
        },
        {
            selector: _playerselectors.isAdJingleDisplayed,
            callback: function(value) {
                instance.isAdJingleDisplayed = value;
            },
            shouldBeInvokedOnConnect: true
        },
        {
            selector: _playerselectors.getTitle,
            callback: function(value) {
                instance.contentTitle = value;
            },
            shouldBeInvokedOnConnect: true
        },
        {
            selector: _playerselectors.getAdPlaybackState,
            callback: function(value) {
                instance.playbackState = value;
            },
            shouldBeInvokedOnConnect: true
        },
        {
            selector: _playerselectors.getDisplayedAdBreakType,
            callback: function(value) {
                instance.displayedAdBreakType = value;
            },
            shouldBeInvokedOnConnect: true
        },
        {
            selector: _playerselectors.getLBannerState,
            callback: function(value) {
                instance.shouldDisplayLBanner = value;
            }
        }
    ];
};
var _default = _lightningjsredux.default.control(mapControllers);


/***/ }),

/***/ 61726:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ADS_COUNTDOWN_DEFAULT_TOTAL_DURATION: function() {
        return ADS_COUNTDOWN_DEFAULT_TOTAL_DURATION;
    },
    AD_ANALYTICS_TYPES: function() {
        return AD_ANALYTICS_TYPES;
    },
    BRIDGE_AD_OCEAN: function() {
        return BRIDGE_AD_OCEAN;
    },
    PAUSE_SIGNAL: function() {
        return PAUSE_SIGNAL;
    },
    PLAY_SIGNAL: function() {
        return PLAY_SIGNAL;
    },
    SKIP_SIGNAL: function() {
        return SKIP_SIGNAL;
    },
    TOP_BAR_ITEMS: function() {
        return TOP_BAR_ITEMS;
    }
});
var _export_star = __webpack_require__(37668);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(37815);
_export_star._(__webpack_require__(66719), exports);
var PAUSE_SIGNAL = "pause";
var PLAY_SIGNAL = "play";
var SKIP_SIGNAL = "skip";
var AD_ANALYTICS_TYPES = {
    begin: {
        preroll: "prerollBegins",
        midroll: "midrollBegins"
    },
    back: {
        preroll: "pressBackButtonDuringPreroll",
        midroll: "pressBackButtonDuringMidroll"
    },
    post: {
        preroll: "postPreroll",
        midroll: "postMidroll"
    }
};
var TOP_BAR_ITEMS = {
    BACK: "BACK"
};
var BRIDGE_AD_OCEAN = "adOcean";
var ADS_COUNTDOWN_DEFAULT_TOTAL_DURATION = 20;


/***/ }),

/***/ 48691:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BRIDGES: function() {
        return BRIDGES;
    },
    adExitAnalyticsEvent: function() {
        return adExitAnalyticsEvent;
    },
    bridgeClassByProviderId: function() {
        return bridgeClassByProviderId;
    },
    createRenderers: function() {
        return createRenderers;
    },
    getAdsDurationInSeconds: function() {
        return getAdsDurationInSeconds;
    },
    updateCountdown: function() {
        return updateCountdown;
    },
    updateQueryParams: function() {
        return updateQueryParams;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(37815);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _utils = __webpack_require__(64188);
var _commonBridge = __webpack_require__(9743);
var _playerutils = __webpack_require__(92628);
var _adsconstants = __webpack_require__(61726);
var _analyticsutils = __webpack_require__(2693);
var BRIDGES = _define_property._({}, _adsconstants.BRIDGE_AD_OCEAN, _commonBridge.CommonBridge);
var bridgeClassByProviderId = function(adsProviderId) {
    return BRIDGES[adsProviderId] || _commonBridge.CommonBridge;
};
var createRenderers = function(prefix) {
    var _createAdRenderers = (0, _playerutils.createAdRenderers)(prefix), container = _createAdRenderers.container, video = _createAdRenderers.video;
    container.className = "ads-container";
    var companion = document.createElement("div");
    // TODO: clarify companion container styling
    companion.style.cssText = "position: fixed; top: 32px; right: 32px; width: 300px; height: 250px; overflow: hidden;";
    container.appendChild(companion);
    return {
        companion: companion,
        container: container,
        video: video
    };
};
var adExitAnalyticsEvent = function(type) {
    var analyticsKey = (0, _get.default)(_adsconstants.AD_ANALYTICS_TYPES.back, type, null);
    if (analyticsKey) (0, _analyticsutils.sendEvent)({
        key: analyticsKey
    });
};
var getAdsDurationInSeconds = function(adBreak) {
    if (!adBreak || !Array.isArray(adBreak.ads)) {
        return 0;
    }
    return adBreak.ads.map(function(ad) {
        var playableAds = (ad.creatives || []).filter(function(param) {
            var assets = param.assets;
            return assets.length > 0;
        });
        if (!playableAds.length) {
            return 0;
        }
        var adDuration = playableAds[0].duration;
        return adDuration || _adsconstants.ADS_COUNTDOWN_DEFAULT_TOTAL_DURATION;
    }).reduce(function(result, duration) {
        return result + duration;
    }, 0);
};
var updateCountdown = function(view, elapsed, total) {
    var skipAnimation = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    view.body = (0, _utils.getTimeFormat)(Math.floor(total - elapsed));
    var value = 1.0 - Math.min(Math.max(total ? elapsed / total : 0, 0), 1);
    if (skipAnimation || !view.progress && value) {
        view.progress = value;
    } else {
        view.setSmooth("progress", value, {
            duration: 0.35
        });
    }
};
var updateQueryParams = function(config) {
    var queryParams = config.queryParams || {};
    var apiframeworks = (0, _get.default)(config, "brParams.vastmacro.APIFRAMEWORKS", "");
    return _object_spread_props._(_object_spread._({}, queryParams), {
        apiframeworks: apiframeworks
    });
};


/***/ }),

/***/ 9743:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    CommonBridge: function() {
        return CommonBridge;
    },
    default: function() {
        return _default;
    }
});
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(52318);
var _adengine = __webpack_require__(25854);
var CommonBridge = /*#__PURE__*/ function(AbstractAdExtendedBridge) {
    "use strict";
    _inherits._(CommonBridge, AbstractAdExtendedBridge);
    var _super = _create_super._(CommonBridge);
    function CommonBridge() {
        _class_call_check._(this, CommonBridge);
        return _super.apply(this, arguments);
    }
    _create_class._(CommonBridge, [
        {
            key: "pause",
            value: function pause() {
                if (this.engine && this.engine.getCurrentAd()) {
                    this.engine.pause();
                } else {
                    this.contentHandlers.playerPause();
                }
            }
        },
        {
            key: "buildTargeting",
            value: function buildTargeting(targeting) {
                return Object.keys(targeting).map(function(key) {
                    return "".concat(key, "=").concat(encodeURIComponent(targeting[key]));
                }).join(this.config.targetingKeysSeparator);
            }
        }
    ]);
    return CommonBridge;
}(_adengine.AbstractAdExtendedBridge);
var _default = CommonBridge;


/***/ }),

/***/ 86377:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "Ads", ({
    enumerable: true,
    get: function() {
        return Ads;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(37815);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _fidosdk = __webpack_require__(19804);
var _constants = __webpack_require__(34952);
var _config = __webpack_require__(67958);
var _adsstyle = __webpack_require__(95375);
var _overlaycomponent = __webpack_require__(6859);
var _i18n = __webpack_require__(14910);
var _adsconnector = /*#__PURE__*/ _interop_require_default._(__webpack_require__(47473));
var _metadatacomponent = __webpack_require__(70057);
var _playbackStateIndicatorcomponent = __webpack_require__(84268);
var _playerconstants = __webpack_require__(7602);
var _adsconstants = __webpack_require__(61726);
var _callToActioncomponent = __webpack_require__(91743);
var _topBarcomponent = __webpack_require__(5947);
var _pillcomponent = __webpack_require__(70452);
var _signals = __webpack_require__(2109);
var _textures = __webpack_require__(67179);
var _adsutils = __webpack_require__(48691);
var _lBannerutils = __webpack_require__(59285);
var Ads = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(Ads, _Lightning_Component);
    var _super = _create_super._(Ads);
    function Ads() {
        _class_call_check._(this, Ads);
        return _super.apply(this, arguments);
    }
    _create_class._(Ads, [
        {
            key: "_construct",
            value: function _construct() {
                this._shouldDisplayAdJingle = false;
                this._displayedAdBreakType = null;
                this._skippableAdsProgressTime = undefined;
                this._canSkipAd = false;
                this._canSkipAdBreak = false;
                this._skipButtonPressLocked = false;
            }
        },
        {
            key: "_attach",
            value: function _attach() {
                this._unsubscribe = (0, _adsconnector.default)(this);
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                if (this._unsubscribe) {
                    this._unsubscribe();
                    this._unsubscribe = null;
                }
                this._focused = undefined;
            }
        },
        {
            key: "advertisement",
            set: function set(value) {
                if (!value || !value.brParams || !_config.featureFlipping.player_skippableAd) {
                    this._skippableAdsProgressTime = undefined;
                    this._canSkipAd = false;
                    this._canSkipAdBreak = false;
                    return;
                }
                this._canSkipAd = Boolean(value.brParams.skippableAdsActivation);
                this._canSkipAdBreak = Boolean(value.brParams.skippableAdsSkipAll);
                this._skippableAdsProgressTime = Math.round((value.brParams.skippableAdsProgressTime || 0) / 1000);
                this._refocus();
            }
        },
        {
            key: "adSkipOffset",
            set: function set(value) {
                this._adSkipOffset = value;
                this._updateSkipAdButtonState();
            }
        },
        {
            key: "adElapsedTime",
            set: function set(value) {
                this._adElapsedTime = value;
                this._updateSkipAdButtonState();
            }
        },
        {
            key: "isAdJingleDisplayed",
            set: function set(value) {
                if (value) {
                    this._setState("AdJingle");
                }
            }
        },
        {
            key: "adJingleImageId",
            set: function set(value) {
                var adJingleView = this.tag("AdJingle");
                if (!value) {
                    adJingleView.texture = null;
                    return;
                }
                var finalW = adJingleView.finalW, finalH = adJingleView.finalH;
                adJingleView.texture = (0, _textures.cover)(_fidosdk.imageService.getUrl(value, finalW, finalH, {
                    fit: _constants.IMAGE_FIT_SCALE_CROP,
                    quality: _constants.IMAGE_QUALITY,
                    format: _constants.DEFAULT_IMAGE_FORMAT
                }), finalW, finalH);
                // NOTE: forcing to load a texture since the Ad Jingle alpha is equal to 0 at this moment
                // If this call is omitted, there will be a flush of paused content before Ad Jingle appears
                adJingleView.loadTexture();
            }
        },
        {
            key: "contentTitle",
            set: function set(value) {
                this.tag("Metadata").extraTitle = (0, _i18n.t)("player.adExtraTitle", {
                    contentTitle: value || ""
                });
            }
        },
        {
            key: "shouldDisplayLBanner",
            set: function set(value) {
                (0, _lBannerutils.handleAdPlayerScale)(value);
            }
        },
        {
            key: "playbackState",
            set: function set(value) {
                if (value === _playerconstants.PLAYBACK_STATE_PLAYING) {
                    this._setState("Playing");
                } else if (value === _playerconstants.PLAYBACK_STATE_PAUSED) {
                    this._setState("Paused");
                } else if (value === _playerconstants.PLAYBACK_STATE_ENDED) {
                    this._dropFocus();
                }
            }
        },
        {
            key: "displayedAdBreakType",
            set: function set(value) {
                this._displayedAdBreakType = value;
            }
        },
        {
            key: "adBreakElapsedTime",
            set: function set(value) {
                this._adBreakElapsedTime = value;
                // normally elapsed time should increase, otherwise it means the countdown was reset, no need to animate
                this._updateCountdown(value < this._adBreakElapsedTime);
            }
        },
        {
            key: "adBreakDuration",
            set: function set(value) {
                this._adBreakDuration = value;
                this._updateCountdown();
            }
        },
        {
            key: "displayAdsCountdown",
            set: function set(value) {
                this.tag("Countdown").visible = Boolean(value);
            }
        },
        {
            key: "_updateCountdown",
            value: function _updateCountdown() {
                var skipAnimation = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                var view = this.tag("Countdown");
                view.alpha = this._adBreakDuration ? 1 : 0;
                (0, _adsutils.updateCountdown)(view, this._adBreakElapsedTime, this._adBreakDuration, skipAnimation);
            }
        },
        {
            key: "_dropFocus",
            value: function _dropFocus() {
                if (this._focused !== this.tag("Skip")) {
                    this._focused = undefined;
                }
            }
        },
        {
            key: "_handleSkipButtonPress",
            value: function _handleSkipButtonPress() {
                if (this._skipButtonPressLocked) {
                    return false;
                }
                if (this._focused === this.tag("Skip")) {
                    this._skipButtonPressLocked = true;
                    this.signal(_adsconstants.SKIP_SIGNAL, this._canSkipAdBreak);
                    return true;
                }
                return false;
            }
        },
        {
            key: "_updateSkipAdButtonState",
            value: function _updateSkipAdButtonState() {
                var button = this.tag("Skip");
                this._skipButtonPressLocked = false;
                if (!(this._canSkipAd || this._canSkipAdBreak) || !Number.isFinite(this._skippableAdsProgressTime) || !Number.isFinite(this._adElapsedTime) || !Number.isFinite(this._adSkipOffset)) {
                    button.visible = false;
                    this._focused = undefined;
                    this._refocus();
                    return;
                }
                button.visible = this._canSkipAdBreak && button.visible || this._adElapsedTime >= this._skippableAdsProgressTime;
                if (!button.visible) {
                    if (!this._canSkipAdBreak && this._focused === button) {
                        this._focused = undefined;
                        this._refocus();
                    }
                    return;
                }
                if (this._focused === button) {
                    return;
                }
                if (this._adElapsedTime >= this._adSkipOffset) {
                    button.label = (0, _i18n.t)("player.skipAd");
                    button.progress = undefined;
                    this._focused = button;
                    this._refocus();
                } else {
                    var countdown = Math.round(this._adSkipOffset - this._adElapsedTime);
                    button.label = "".concat((0, _i18n.t)("player.skipIn"), " ").concat(countdown);
                    if (!Number.isFinite(button.progress)) {
                        button.progress = this._adElapsedTime / this._adSkipOffset;
                    }
                    button.setSmooth("progress", Math.min(1, this._adElapsedTime / this._adSkipOffset), {
                        duration: 0.3,
                        timingFunction: "linear"
                    });
                }
            }
        },
        {
            key: "_pause",
            value: function _pause() {
                this.signal(_adsconstants.PAUSE_SIGNAL);
            }
        },
        {
            key: "_play",
            value: function _play() {
                this.signal(_adsconstants.PLAY_SIGNAL);
            }
        },
        {
            key: "_handleBack",
            value: function _handleBack() {
                (0, _adsutils.adExitAnalyticsEvent)(this._displayedAdBreakType);
                return false;
            }
        },
        {
            key: "_handleUp",
            value: function _handleUp() {
                if (!_adsconstants.DISPLAY_AD_METADATA) {
                    return false;
                }
                if (!this._focused) {
                    this._focused = this.tag("TopBar");
                    return true;
                }
                return false;
            }
        },
        {
            key: "_handleDown",
            value: function _handleDown() {
                if (!_adsconstants.DISPLAY_AD_METADATA) {
                    return false;
                }
                if (this._focused) {
                    this._focused = undefined;
                    return true;
                }
                return false;
            }
        },
        {
            key: "_handleLeft",
            value: function _handleLeft() {
                return true;
            }
        },
        {
            key: "_handleRight",
            value: function _handleRight() {
                return true;
            }
        },
        {
            key: "_getFocused",
            value: function _getFocused() {
                return this._focused;
            }
        },
        {
            key: "_handleTopBarItemSelected",
            value: function _handleTopBarItemSelected() {
                _sdk.Router.back();
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Overlay: {
                        type: _overlaycomponent.Overlay
                    },
                    TopBar: {
                        type: _topBarcomponent.TopBar,
                        items: [
                            {
                                id: _adsconstants.TOP_BAR_ITEMS.BACK,
                                icon: "ArrowLeftWithBase",
                                text: (0, _i18n.t)("nav.backToNav"),
                                action: _playerconstants.TOP_BAR_BACK
                            }
                        ],
                        signals: _define_property._({}, _signals.SELECTED_SIGNAL, "_handleTopBarItemSelected")
                    },
                    Metadata: {
                        type: _metadatacomponent.Metadata,
                        title: (0, _i18n.t)("player.adMessage"),
                        extraTitle: (0, _i18n.t)("player.adExtraTitle")
                    },
                    PlaybackStateIndicator: {
                        type: _playbackStateIndicatorcomponent.PlaybackStateIndicator
                    },
                    Countdown: {
                        type: _pillcomponent.Pill,
                        title: (0, _i18n.t)("player.adMessage")
                    },
                    Skip: {
                        type: _callToActioncomponent.CallToAction,
                        label: (0, _i18n.t)("player.adMessage"),
                        picto: {
                            type: "icon",
                            name: "SkipNext"
                        }
                    },
                    AdJingle: {}
                }, (0, _adsstyle.getInitialStyle)());
            }
        },
        {
            key: "_states",
            value: function _states() {
                return [
                    /*#__PURE__*/ function(_this) {
                        _inherits._(Playing, _this);
                        var _super = _create_super._(Playing);
                        function Playing() {
                            _class_call_check._(this, Playing);
                            return _super.apply(this, arguments);
                        }
                        _create_class._(Playing, [
                            {
                                key: "$enter",
                                value: function $enter() {
                                    this.tag("PlaybackStateIndicator").show("Paused");
                                    this._dropFocus();
                                }
                            },
                            {
                                key: "_handleEnter",
                                value: function _handleEnter() {
                                    if (this._handleSkipButtonPress()) {
                                        return true;
                                    }
                                    this._pause();
                                    return true;
                                }
                            },
                            {
                                key: "_handlePause",
                                value: function _handlePause() {
                                    this._pause();
                                    return true;
                                }
                            },
                            {
                                key: "_handlePlayPause",
                                value: function _handlePlayPause() {
                                    this._pause();
                                    return true;
                                }
                            }
                        ]);
                        return Playing;
                    }(this),
                    /*#__PURE__*/ function(_this) {
                        _inherits._(Paused, _this);
                        var _super = _create_super._(Paused);
                        function Paused() {
                            _class_call_check._(this, Paused);
                            return _super.apply(this, arguments);
                        }
                        _create_class._(Paused, [
                            {
                                key: "$enter",
                                value: function $enter() {
                                    this.tag("PlaybackStateIndicator").show("Playing");
                                }
                            },
                            {
                                key: "_handleEnter",
                                value: function _handleEnter() {
                                    if (this._handleSkipButtonPress()) {
                                        return true;
                                    }
                                    this._play();
                                    return true;
                                }
                            },
                            {
                                key: "_handlePlay",
                                value: function _handlePlay() {
                                    this._play();
                                    return true;
                                }
                            },
                            {
                                key: "_handlePlayPause",
                                value: function _handlePlayPause() {
                                    this._play();
                                    return true;
                                }
                            }
                        ]);
                        return Paused;
                    }(this),
                    /*#__PURE__*/ function(_this) {
                        _inherits._(AdJingle, _this);
                        var _super = _create_super._(AdJingle);
                        function AdJingle() {
                            _class_call_check._(this, AdJingle);
                            return _super.apply(this, arguments);
                        }
                        _create_class._(AdJingle, [
                            {
                                key: "$enter",
                                value: function $enter() {
                                    this.tag("AdJingle").setSmooth("alpha", 1);
                                }
                            },
                            {
                                key: "$exit",
                                value: function $exit() {
                                    this.tag("AdJingle").setSmooth("alpha", 0);
                                }
                            },
                            {
                                key: "_getFocused",
                                value: function _getFocused() {
                                    return this;
                                }
                            },
                            {
                                key: "_handleUp",
                                value: function _handleUp() {
                                    return true;
                                }
                            },
                            {
                                key: "_handleDown",
                                value: function _handleDown() {
                                    return true;
                                }
                            }
                        ]);
                        return AdJingle;
                    }(this)
                ];
            }
        }
    ]);
    return Ads;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 66719:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DEFAULT_VOLUME_LEVEL: function() {
        return DEFAULT_VOLUME_LEVEL;
    },
    DISPLAY_AD_METADATA: function() {
        return DISPLAY_AD_METADATA;
    },
    DISPLAY_SHADOW_OVERLAY: function() {
        return DISPLAY_SHADOW_OVERLAY;
    }
});
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(88801);
var DEFAULT_VOLUME_LEVEL = 0.5;
var DISPLAY_SHADOW_OVERLAY = false;
var DISPLAY_AD_METADATA = false;


/***/ }),

/***/ 95375:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    METADATA_MARGIN_BOTTOM: function() {
        return METADATA_MARGIN_BOTTOM;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _object_spread = __webpack_require__(76247);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(37815);
var _constants = __webpack_require__(34952);
var _theme = __webpack_require__(51397);
var _style = __webpack_require__(65082);
var _sizes = __webpack_require__(82699);
var _playbackStateIndicatorstyle = __webpack_require__(65207);
var _adsconstants = __webpack_require__(61726);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var colors = {
    text: (0, _theme.makeThemeColor)(_theme.PRIMARY)
};
var _obj;
var METADATA_MARGIN_BOTTOM = (_obj = {}, _define_property._(_obj, _constants.HD, 8), _define_property._(_obj, _constants.FULL_HD, 16), _obj);
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var screenSize = context.screenSize;
    var margin = {
        x: _constants.safetyMargins.horizontal[screenSize],
        y: _constants.safetyMargins.vertical[screenSize]
    };
    var playbackStateIndicatorY = _sizes.SCREEN_HEIGHT[screenSize] - margin.y;
    return {
        w: _sizes.SCREEN_WIDTH[screenSize],
        h: _sizes.SCREEN_HEIGHT[screenSize],
        Overlay: {
            visible: _adsconstants.DISPLAY_SHADOW_OVERLAY
        },
        TopBar: _object_spread._({
            visible: _adsconstants.DISPLAY_AD_METADATA
        }, margin),
        Metadata: {
            visible: _adsconstants.DISPLAY_AD_METADATA,
            x: margin.x,
            y: playbackStateIndicatorY - _playbackStateIndicatorstyle.ICON_HEIGHT[screenSize] - METADATA_MARGIN_BOTTOM[screenSize],
            mountY: 1
        },
        PlaybackStateIndicator: {
            visible: _adsconstants.DISPLAY_AD_METADATA,
            x: margin.x,
            y: playbackStateIndicatorY,
            mountY: 1
        },
        Countdown: {
            mountX: 1,
            x: function(v) {
                return v - _constants.safetyMargins.horizontal[screenSize];
            },
            y: _constants.safetyMargins.vertical[screenSize],
            displayIcon: false
        },
        Skip: {
            visible: false,
            mount: 1,
            x: function(v) {
                return v - _constants.safetyMargins.horizontal[screenSize];
            },
            y: function(v) {
                return v - _constants.safetyMargins.vertical[screenSize];
            }
        },
        AdJingle: {
            w: _sizes.SCREEN_WIDTH[screenSize],
            h: _sizes.SCREEN_HEIGHT[screenSize]
        }
    };
};


/***/ }),

/***/ 59285:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "handleAdPlayerScale", ({
    enumerable: true,
    get: function() {
        return handleAdPlayerScale;
    }
}));
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(42578);
var _lBannerutils = __webpack_require__(14625);
var _sizes = __webpack_require__(82699);
var handleAdPlayerScale = function(enable) {
    var videoEl = document.querySelector(".ads-container>video");
    if (!videoEl) return;
    var fullWidth = _sizes.SCREEN_WIDTH[(0, _sizes.getScreenSize)()];
    var fullHeight = _sizes.SCREEN_HEIGHT[(0, _sizes.getScreenSize)()];
    if (enable) {
        var width = Math.floor(fullWidth * (1 - (0, _lBannerutils.getLBannerWidthScale)()));
        var height = Math.floor(fullHeight * (1 - (0, _lBannerutils.getLBannerHeightScale)()));
        videoEl.style.width = "".concat(width, "px");
        videoEl.style.height = "".concat(height, "px");
    } else {
        videoEl.style.width = "".concat(fullWidth, "px");
        videoEl.style.height = "".concat(fullHeight, "px");
    }
};


/***/ }),

/***/ 84268:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "PlaybackStateIndicator", ({
    enumerable: true,
    get: function() {
        return PlaybackStateIndicator;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(3009);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _playbackStateIndicatorutils = __webpack_require__(81791);
var _playbackStateIndicatorstyle = __webpack_require__(65207);
var PlaybackStateIndicator = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(PlaybackStateIndicator, _Lightning_Component);
    var _super = _create_super._(PlaybackStateIndicator);
    function PlaybackStateIndicator() {
        _class_call_check._(this, PlaybackStateIndicator);
        return _super.apply(this, arguments);
    }
    _create_class._(PlaybackStateIndicator, [
        {
            key: "_attach",
            value: function _attach() {
                this._setState("Playing");
            }
        },
        {
            key: "show",
            value: function show(state) {
                this._setState(state);
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    PlayIcon: (0, _playbackStateIndicatorutils.makeIcon)("Play"),
                    PauseIcon: (0, _playbackStateIndicatorutils.makeIcon)("Pause")
                }, (0, _playbackStateIndicatorstyle.getInitialStyle)());
            }
        },
        {
            key: "_states",
            value: function _states() {
                return [
                    /*#__PURE__*/ function(_this) {
                        _inherits._(Playing, _this);
                        var _super = _create_super._(Playing);
                        function Playing() {
                            _class_call_check._(this, Playing);
                            return _super.apply(this, arguments);
                        }
                        _create_class._(Playing, [
                            {
                                key: "$enter",
                                value: function $enter() {
                                    this.tag("PlayIcon").visible = true;
                                    this.tag("PauseIcon").visible = false;
                                }
                            }
                        ]);
                        return Playing;
                    }(this),
                    /*#__PURE__*/ function(_this) {
                        _inherits._(Paused, _this);
                        var _super = _create_super._(Paused);
                        function Paused() {
                            _class_call_check._(this, Paused);
                            return _super.apply(this, arguments);
                        }
                        _create_class._(Paused, [
                            {
                                key: "$enter",
                                value: function $enter() {
                                    this.tag("PlayIcon").visible = false;
                                    this.tag("PauseIcon").visible = true;
                                }
                            }
                        ]);
                        return Paused;
                    }(this)
                ];
            }
        }
    ]);
    return PlaybackStateIndicator;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 65207:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ICON_HEIGHT: function() {
        return ICON_HEIGHT;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
var _define_property = __webpack_require__(21228);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
var _constants = __webpack_require__(34952);
var _style = __webpack_require__(65082);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var ICON_HEIGHT = (_obj = {}, _define_property._(_obj, _constants.HD, 24), _define_property._(_obj, _constants.FULL_HD, 32), _obj);
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var screenSize = context.screenSize;
    return {
        h: ICON_HEIGHT[screenSize]
    };
};


/***/ }),

/***/ 81791:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "makeIcon", ({
    enumerable: true,
    get: function() {
        return makeIcon;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(52318);
var _icons = __webpack_require__(20360);
var _iconcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(70160));
var _playbackStateIndicatorstyle = __webpack_require__(65207);
var makeIcon = function(name) {
    return {
        type: _iconcomponent.default,
        iconData: {
            picto: {
                name: name,
                collection: _icons.ICON_COLLECTION.CONTROLS
            },
            viewBox: {
                h: _playbackStateIndicatorstyle.ICON_HEIGHT[_playbackStateIndicatorstyle.defaultContext.screenSize]
            }
        }
    };
};


/***/ }),

/***/ 24740:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "DEVICE_CODE", ({
    enumerable: true,
    get: function() {
        return DEVICE_CODE;
    }
}));
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(52318);
var DEVICE_CODE = "web";


/***/ }),

/***/ 55104:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "YouboraAdsAdapter", ({
    enumerable: true,
    get: function() {
        return YouboraAdsAdapter;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _get = __webpack_require__(60528);
var _get_prototype_of = __webpack_require__(35196);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
var _get1 = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _legacyAdapter = __webpack_require__(2161);
var YouboraAdsAdapter = /*#__PURE__*/ function(BaseYouboraAdsAdapter) {
    "use strict";
    _inherits._(YouboraAdsAdapter, BaseYouboraAdsAdapter);
    var _super = _create_super._(YouboraAdsAdapter);
    function YouboraAdsAdapter() {
        _class_call_check._(this, YouboraAdsAdapter);
        return _super.apply(this, arguments);
    }
    _create_class._(YouboraAdsAdapter, [
        {
            key: "initListener",
            value: function initListener() {
                var _this = this;
                // NOTE: an ugly hack to reorder calls in the ad-engine in order to ensure
                // there will be adResource set on the adStart event
                setTimeout(function() {
                    return _get._(_get_prototype_of._(YouboraAdsAdapter.prototype), "initListener", _this).call(_this);
                }, 0);
            }
        },
        {
            key: "getResource",
            value: function getResource() {
                return (0, _get1.default)(this.player, "display.video.src");
            }
        },
        {
            key: "getPlayrate",
            value: function getPlayrate() {
                return 1;
            }
        }
    ]);
    return YouboraAdsAdapter;
}(_legacyAdapter.YouboraLegacyAdsAdapter);


/***/ }),

/***/ 64018:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DEEPLINK_ORIGIN: function() {
        return DEEPLINK_ORIGIN;
    },
    KEY: function() {
        return KEY;
    },
    fetchYouboraData: function() {
        return fetchYouboraData;
    },
    getCatalogCallerOrigin: function() {
        return getCatalogCallerOrigin;
    },
    getPlayerCallerOrigin: function() {
        return getPlayerCallerOrigin;
    },
    getRealReferrer: function() {
        return getRealReferrer;
    },
    getVideoCallerEntity: function() {
        return getVideoCallerEntity;
    },
    getYouboraDataFromLayout: function() {
        return getYouboraDataFromLayout;
    }
});
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(88801);
var _config = __webpack_require__(67958);
var _utils = __webpack_require__(64188);
var _sdk = __webpack_require__(29956);
var _fidosdk = __webpack_require__(19804);
var _playerselectors = __webpack_require__(83318);
var _appselectors = __webpack_require__(65910);
var _userselectors = __webpack_require__(41845);
var _youboraconstants = __webpack_require__(24740);
var KEY = "youbora";
var DEEPLINK_ORIGIN = "deeplink";
var getRealReferrer = function() {
    if (window.location !== window.parent.location && document.referrer) {
        return new URL(document.referrer);
    }
    return new URL(window.location.href);
};
var getYouboraDataFromLayout = (0, _playerselectors.getAnalyticsById)(KEY);
var getCatalogCallerOrigin = function(url) {
    var pageData = url.match(/^app\/(\w+)(\/(\w+))?$/);
    if (!pageData) {
        return null;
    }
    var entityType = pageData[1];
    if (entityType === _fidosdk.LAYOUT_ENTITIES.alias || entityType === _fidosdk.LAYOUT_ENTITIES.frontspace) {
        // Entity ID should be returned for cases like alias/home, frontspace/bookmarks, etc.
        return pageData[3];
    }
    return entityType;
};
var getPlayerCallerOrigin = function(url) {
    var pageData = url.match(/^(video|live)\/(\w+)$/);
    return pageData ? pageData[1] : null;
};
var getVideoCallerEntity = function() {
    var history = _sdk.Router.getHistory();
    var lastHistoryItem = history.pop();
    if (!lastHistoryItem) {
        return DEEPLINK_ORIGIN;
    }
    var hash = lastHistoryItem.hash;
    var matchers = [
        getPlayerCallerOrigin,
        getCatalogCallerOrigin
    ];
    for(var i = 0; i < matchers.length; i += 1){
        var origin = matchers[i](hash);
        if (origin) {
            return origin;
        }
    }
    return DEEPLINK_ORIGIN;
};
var fetchYouboraData = function(state) {
    var result = _object_spread_props._(_object_spread._({
        "user.name": (0, _userselectors.getUid)(state),
        referer: getRealReferrer().origin,
        accountCode: _config.youbora.accountCode,
        "device.name": _utils.appPlatform,
        "device.code": _youboraconstants.DEVICE_CODE,
        "device.brand": (0, _appselectors.getDeviceBrand)(state),
        "device.model": (0, _appselectors.getDeviceModel)(state),
        "device.type": _utils.appPlatform === "web" ? "web" : "stb",
        "device.osVersion": (0, _appselectors.getDeviceVersion)(state),
        "content.customDimension.7": (0, _playerselectors.getCurrentAssetType)(state) || "unref",
        "app.name": _config.i18nNames.appDisplayName,
        "app.releaseVersion": _utils.appVersion,
        "content.customDimension.10": _utils.appCustomer,
        "content.customDimension.14": getVideoCallerEntity()
    }, getYouboraDataFromLayout(state)), {
        "content.customDimension.9": "rdk",
        /**
     * Parse manifest allows to detect the real CDN behind our own applicative load
     * balancer. The LBCDN isn't activated on all the customers yet, so the Youbora
     * QA could tell you that this isn't necessary and could be safely de-activated,
     * where it should stay on !
     */ "parse.manifest": true
    });
    return result;
};


/***/ }),

/***/ 72415:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "GooglePauseAds", ({
    enumerable: true,
    get: function() {
        return GooglePauseAds;
    }
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _playerconstants = __webpack_require__(7602);
var _i18n = __webpack_require__(14910);
var _pillcomponent = __webpack_require__(70452);
var _googlePauseAdsconnector = /*#__PURE__*/ _interop_require_default._(__webpack_require__(90262));
var _googlePauseAdsutils = __webpack_require__(18546);
var _googlePauseAdsstyle = __webpack_require__(76799);
var GooglePauseAds = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(GooglePauseAds, _Lightning_Component);
    var _super = _create_super._(GooglePauseAds);
    function GooglePauseAds() {
        _class_call_check._(this, GooglePauseAds);
        return _super.apply(this, arguments);
    }
    _create_class._(GooglePauseAds, [
        {
            key: "_construct",
            value: function _construct() {
                this._adAvailable = false;
                this._imageAvailable = false;
            }
        },
        {
            key: "_attach",
            value: function _attach() {
                var _this = this;
                return _async_to_generator._(function() {
                    var image;
                    return _ts_generator._(this, function(_state) {
                        _this._unsubscribe = (0, _googlePauseAdsconnector.default)(_this);
                        image = _this.tag("Image");
                        image.on("txLoaded", function() {
                            _this._imageAvailable = true;
                            _this.tag("Pill").visible = true;
                            _lightningjsredux.default.dispatch((0, _playerconstants.pauseAdsDisplaying)());
                            (0, _googlePauseAdsutils.track)(_this._trackers);
                        });
                        image.on("txError", function() {
                            _this._imageAvailable = false;
                            _this.tag("Pill").visible = false;
                            _lightningjsredux.default.dispatch((0, _playerconstants.pauseAdsError)());
                        });
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                if (this._unsubscribe) {
                    this._unsubscribe();
                    this._unsubscribe = null;
                }
                this._trackers = null;
                this.tag("Image").removeAllListeners("txLoaded");
                this.tag("Image").removeAllListeners("txError");
            }
        },
        {
            key: "isAvailable",
            get: function get() {
                return this._adAvailable;
            }
        },
        {
            key: "adRequestData",
            set: function set(value) {
                this._adAvailable = Boolean(value);
            }
        },
        {
            key: "ad",
            set: function set(value) {
                var image = this.tag("Image");
                this.tag("Pill").visible = false;
                this._imageAvailable = false;
                if (!value) {
                    image.src = null;
                    return;
                }
                this._trackers = [];
                if (value.tracking_url) {
                    if (value.tracking_url.view) {
                        this._trackers.push(value.tracking_url.view);
                    }
                    if (Array.isArray(value.tracking_url.views)) {
                        this._trackers = this._trackers.concat(value.tracking_url.views);
                    }
                }
                image.src = value.file_url;
                // force the ads image to be loaded in order to know in advance if the image is available
                image.loadTexture();
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Image: {},
                    Pill: {
                        type: _pillcomponent.Pill,
                        title: (0, _i18n.t)("player.advertisement"),
                        body: (0, _i18n.t)("player.pauseAdMessage")
                    }
                }, (0, _googlePauseAdsstyle.getInitialStyle)());
            }
        }
    ]);
    return GooglePauseAds;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 90262:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _playerselectors = __webpack_require__(83318);
var mapControllers = function(instance) {
    return [
        {
            selector: _playerselectors.getPauseAdRequestData,
            callback: function(value) {
                instance.adRequestData = value;
            },
            shouldBeInvokedOnConnect: true
        },
        {
            selector: _playerselectors.getCurrentPauseAd,
            callback: function(value) {
                instance.ad = value;
            },
            shouldBeInvokedOnConnect: true
        }
    ];
};
var _default = _lightningjsredux.default.control(mapControllers);


/***/ }),

/***/ 76799:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
var _constants = __webpack_require__(34952);
var _theme = __webpack_require__(51397);
var _style = __webpack_require__(65082);
var _sizes = __webpack_require__(82699);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var colors = {
    background: (0, _theme.makeThemeColor)(_theme.PRIMARY),
    text: (0, _theme.makeThemeColor)(_theme.TERTIARY)
};
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var screenSize = context.screenSize, colorMode = context.colorMode;
    return {
        w: _sizes.SCREEN_WIDTH[screenSize],
        h: _sizes.SCREEN_HEIGHT[screenSize],
        Image: {
            w: _sizes.SCREEN_WIDTH[screenSize],
            h: _sizes.SCREEN_HEIGHT[screenSize]
        },
        Pill: {
            x: _constants.safetyMargins.horizontal[screenSize],
            y: _constants.safetyMargins.vertical[screenSize],
            backgroundColor: colors.background[colorMode],
            textColor: colors.text[colorMode]
        }
    };
};


/***/ }),

/***/ 18546:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "track", ({
    enumerable: true,
    get: function() {
        return track;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
var _superagent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(54247));
var track = function(urls) {
    return urls ? urls.map(function(url) {
        return _superagent.default.get(url).catch(function() {});
    }) : [];
};


/***/ }),

/***/ 22122:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "ContentAdvisory", ({
    enumerable: true,
    get: function() {
        return ContentAdvisory;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _videoconstants = __webpack_require__(1628);
var _contentAdvisorystyle = __webpack_require__(85828);
var _contentAdvisoryconstants = __webpack_require__(8561);
var _iconcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(70160));
var _contentAdvisoryconnector = /*#__PURE__*/ _interop_require_default._(__webpack_require__(83302));
var ContentAdvisory = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(ContentAdvisory, _Lightning_Component);
    var _super = _create_super._(ContentAdvisory);
    function ContentAdvisory() {
        _class_call_check._(this, ContentAdvisory);
        return _super.apply(this, arguments);
    }
    _create_class._(ContentAdvisory, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _contentAdvisorystyle.defaultContext;
                this._hasData = false;
                this._displayDuration = _videoconstants.ADVISORY_DISPLAY_DURATION_IN_SECONDS * 1000;
                this._inProgress = false;
                this._timerId = null;
            }
        },
        {
            key: "_build",
            value: function _build() {
                this._hide();
            }
        },
        {
            key: "_attach",
            value: function _attach() {
                this._unsubscribe = (0, _contentAdvisoryconnector.default)(this);
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                if (this._unsubscribe) {
                    this._unsubscribe();
                    this._unsubscribe = null;
                }
                this._destroyTimer();
            }
        },
        {
            key: "contentAdvisory",
            set: function set(value) {
                if (value) {
                    this._setText(value.title, "Title");
                    this._setText(value.description, "Description");
                    this.pictos = value.pictos;
                    this.tag("Treatment").visible = this._hasData;
                } else {
                    this._hasData = false;
                }
            }
        },
        {
            key: "pictos",
            set: function set(value) {
                var _this = this;
                if (!value) {
                    return;
                }
                var iconViewBox = (0, _contentAdvisorystyle.getIconViewBox)(this._style.screenSize);
                var element = this.tag("Icons");
                element.children = value.filter(Boolean).map(function(picto) {
                    return {
                        type: _iconcomponent.default,
                        iconData: {
                            picto: picto,
                            viewBox: iconViewBox
                        },
                        flexItem: {
                            marginRight: _contentAdvisoryconstants.PICTO_MARGIN[_this._style.screenSize]
                        }
                    };
                });
                this._hasData = this._hasData || Boolean(element.children.length);
            }
        },
        {
            key: "_setText",
            value: function _setText(value, tag) {
                var element = this.tag(tag);
                element.text.text = value;
                element.visible = Boolean(value);
                this._hasData = this._hasData || element.visible;
            }
        },
        {
            key: "_show",
            value: function _show() {
                this.alpha = 1;
            }
        },
        {
            key: "_hide",
            value: function _hide() {
                this.alpha = 0;
            }
        },
        {
            key: "_complete",
            value: function _complete() {
                this._hide();
                this._inProgress = false;
            }
        },
        {
            key: "_startTimer",
            value: function _startTimer() {
                this._timerId = setTimeout(this._complete.bind(this), this._displayDuration);
            }
        },
        {
            key: "_destroyTimer",
            value: function _destroyTimer() {
                if (this._timerId) {
                    clearTimeout(this._timerId);
                    this._timerId = null;
                }
            }
        },
        {
            key: "start",
            value: function start() {
                this._show();
                this._startTimer();
                this._inProgress = true;
            }
        },
        {
            key: "pause",
            value: function pause() {
                this._hide();
                if (this._inProgress) {
                    this._destroyTimer();
                }
            }
        },
        {
            key: "resume",
            value: function resume() {
                if (!this._inProgress) {
                    this._hide();
                    return;
                }
                this._show();
                this._startTimer();
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Treatment: {},
                    Content: _contentAdvisoryconstants.TEMPLATE
                }, (0, _contentAdvisorystyle.getInitialStyle)());
            }
        }
    ]);
    return ContentAdvisory;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 83302:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(45538);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _playerselectors = __webpack_require__(83318);
var mapControllers = function(instance) {
    return {
        contentAdvisory: {
            selector: _playerselectors.getContentAdvisory,
            callback: function(value) {
                instance.contentAdvisory = value;
            }
        }
    };
};
var _default = _lightningjsredux.default.control(mapControllers);


/***/ }),

/***/ 8561:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "ADVISORY_BEFORE_VIDEO_END_DELAY", ({
    enumerable: true,
    get: function() {
        return ADVISORY_BEFORE_VIDEO_END_DELAY;
    }
}));
var _export_star = __webpack_require__(37668);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(65759);
_export_star._(__webpack_require__(82008), exports);
var ADVISORY_BEFORE_VIDEO_END_DELAY = 5;


/***/ }),

/***/ 85828:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DESCRIPTION_MARGIN_BOTTOM: function() {
        return DESCRIPTION_MARGIN_BOTTOM;
    },
    ICONS_MARGIN_BOTTOM: function() {
        return ICONS_MARGIN_BOTTOM;
    },
    ICON_SIZE: function() {
        return ICON_SIZE;
    },
    MAX_TEXT_WIDTH: function() {
        return MAX_TEXT_WIDTH;
    },
    PADDING_LEFT: function() {
        return PADDING_LEFT;
    },
    PADDING_TOP: function() {
        return PADDING_TOP;
    },
    TITLE_MARGIN_BOTTOM: function() {
        return TITLE_MARGIN_BOTTOM;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getIconViewBox: function() {
        return getIconViewBox;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
var _memoize = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34736));
var _constants = __webpack_require__(34952);
var _typography = __webpack_require__(18411);
var _theme = __webpack_require__(51397);
var _style = __webpack_require__(65082);
var _colors = __webpack_require__(8426);
var _contentAdvisoryconstants = __webpack_require__(8561);
var _sizes = __webpack_require__(82699);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var MAX_TEXT_WIDTH = (_obj = {}, _define_property._(_obj, _constants.HD, 640), _define_property._(_obj, _constants.FULL_HD, 960), _obj);
var _obj1;
var PADDING_LEFT = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 64), _define_property._(_obj1, _constants.FULL_HD, 96), _obj1);
var _obj2;
var PADDING_TOP = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 40), _define_property._(_obj2, _constants.FULL_HD, 56), _obj2);
var _obj3;
var TITLE_MARGIN_BOTTOM = (_obj3 = {}, _define_property._(_obj3, _constants.HD, 8), _define_property._(_obj3, _constants.FULL_HD, 8), _obj3);
var _obj4;
var DESCRIPTION_MARGIN_BOTTOM = (_obj4 = {}, _define_property._(_obj4, _constants.HD, 16), _define_property._(_obj4, _constants.FULL_HD, 16), _obj4);
var _obj5;
var ICONS_MARGIN_BOTTOM = (_obj5 = {}, _define_property._(_obj5, _constants.HD, 16), _define_property._(_obj5, _constants.FULL_HD, 16), _obj5);
var _obj6, _obj7;
var ICON_SIZE = {
    WIDTH: (_obj6 = {}, _define_property._(_obj6, _constants.HD, 32), _define_property._(_obj6, _constants.FULL_HD, 40), _obj6),
    HEIGHT: (_obj7 = {}, _define_property._(_obj7, _constants.HD, 32), _define_property._(_obj7, _constants.FULL_HD, 40), _obj7)
};
var getIconViewBox = (0, _memoize.default)(function(screenSize) {
    return {
        w: ICON_SIZE.WIDTH[screenSize],
        h: ICON_SIZE.HEIGHT[screenSize]
    };
});
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var screenSize = context.screenSize, colorMode = context.colorMode;
    var titleFont = (0, _typography.getFont)(_typography.FONT.OTTAWA_2, screenSize);
    var descriptionFont = (0, _typography.getFont)(_typography.FONT.OTTAWA_1, screenSize);
    var wordWrapWidth = MAX_TEXT_WIDTH[screenSize];
    return {
        visible: _contentAdvisoryconstants.SHOULD_DISPLAY,
        Treatment: {
            visible: false,
            rect: true,
            w: _sizes.SCREEN_WIDTH[screenSize],
            h: _sizes.SCREEN_HEIGHT[screenSize],
            colorUl: (0, _theme.makeThemeColor)(_theme.TERTIARY, 0.8)[colorMode],
            colorUr: _colors.TRANSPARENT,
            colorBr: _colors.TRANSPARENT,
            colorBl: _colors.TRANSPARENT
        },
        Content: {
            flex: {
                direction: "column",
                justifyContent: "flex-start",
                paddingLeft: PADDING_LEFT[screenSize],
                paddingTop: PADDING_TOP[screenSize]
            },
            zIndex: 2,
            Icons: {
                flex: {
                    direction: "row",
                    justifyContent: "flex-start"
                },
                flexItem: {
                    marginBottom: ICONS_MARGIN_BOTTOM[screenSize]
                }
            },
            Title: {
                flexItem: {
                    marginBottom: TITLE_MARGIN_BOTTOM[screenSize]
                },
                text: _object_spread_props._(_object_spread._({}, titleFont), {
                    wordWrapWidth: wordWrapWidth,
                    maxLines: 1,
                    maxLinesSuffix: "...",
                    verticalAlign: "middle"
                })
            },
            Description: {
                flexItem: {
                    marginBottom: DESCRIPTION_MARGIN_BOTTOM[screenSize]
                },
                text: _object_spread_props._(_object_spread._({}, descriptionFont), {
                    wordWrapWidth: wordWrapWidth,
                    maxLines: 2,
                    maxLinesSuffix: "...",
                    verticalAlign: "middle"
                })
            }
        }
    };
};


/***/ }),

/***/ 82008:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    PICTO_MARGIN: function() {
        return PICTO_MARGIN;
    },
    SHOULD_DISPLAY: function() {
        return SHOULD_DISPLAY;
    },
    TEMPLATE: function() {
        return TEMPLATE;
    }
});
var _define_property = __webpack_require__(21228);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(42578);
var _constants = __webpack_require__(34952);
var _obj;
var PICTO_MARGIN = (_obj = {}, _define_property._(_obj, _constants.HD, 8), _define_property._(_obj, _constants.FULL_HD, 16), _obj);
var SHOULD_DISPLAY = true;
var TEMPLATE = {
    Title: {},
    Description: {},
    Icons: {}
};


/***/ }),

/***/ 92371:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "Controls", ({
    enumerable: true,
    get: function() {
        return Controls;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _to_consumable_array = __webpack_require__(30005);
var _create_super = __webpack_require__(6400);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(52318);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _debounce = /*#__PURE__*/ _interop_require_default._(__webpack_require__(66292));
var _sdk = __webpack_require__(29956);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _analyticsutils = __webpack_require__(2693);
var _playerconstants = __webpack_require__(7602);
var _signals = __webpack_require__(2109);
var _overlaycomponent = __webpack_require__(6859);
var _topBarcomponent = __webpack_require__(5947);
var _eventMarkercomponent = __webpack_require__(77671);
var _metadatacomponent = __webpack_require__(70057);
var _sideGlasscomponent = __webpack_require__(23069);
var _sideGlassconstants = __webpack_require__(6728);
var _trackscomponent = __webpack_require__(92091);
var _tracksconstants = __webpack_require__(75702);
var _progressBarcomponent = __webpack_require__(17351);
var _progressBarconstants = __webpack_require__(88227);
var _playerconstants1 = __webpack_require__(28824);
var _programInformationcomponent = __webpack_require__(33006);
var _programInformationconstants = __webpack_require__(57953);
var _controlsconnector = /*#__PURE__*/ _interop_require_default._(__webpack_require__(92181));
var _controlsstyle = __webpack_require__(21950);
var _controlsconstants = __webpack_require__(55197);
var Controls = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(Controls, _Lightning_Component);
    var _super = _create_super._(Controls);
    function Controls() {
        _class_call_check._(this, Controls);
        return _super.apply(this, arguments);
    }
    _create_class._(Controls, [
        {
            key: "_construct",
            value: function _construct() {
                var _this = this;
                this._startAutoHide = (0, _debounce.default)(function() {
                    _this.hide();
                    _this.signal(_controlsconstants.CONTROLS_HIDE_SIGNAL);
                }, _playerconstants1.INTERFACE_DISPLAY_DURATION);
                this._index = 0;
            }
        },
        {
            key: "_build",
            value: function _build() {
                var _this = this;
                // When fade in animation is finished, put Progress Bar in focus in order to properly handle Left and Right buttons
                this.tag("Main").transition("alpha").on("finish", function() {
                    if (_this.alpha < 1) {
                        _this.focusOnAuxiliaryControls();
                    }
                });
                this._focusableItems = [
                    this.tag("TopBar")
                ].concat(_to_consumable_array._(this.tag("AuxiliaryButtons").children), [
                    this.tag("Progress")
                ]);
                this._autoHideDisablingViews = [
                    this.tag("SideGlass"),
                    this.tag("Tracks"),
                    this.tag("ProgramInformation")
                ];
                this._visibleFocusableItems = [];
                this._checkFocusableItems();
                this._focusTag("Progress");
            }
        },
        {
            key: "_attach",
            value: function _attach() {
                this._unsubscribe = (0, _controlsconnector.default)(this);
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                if (this._unsubscribe) {
                    this._unsubscribe();
                    this._unsubscribe = null;
                }
                this._focused = undefined;
                this._focusableItems = [];
                this._visibleFocusableItems = [];
                this._autoHideDisablingViews = [];
                this.tag("Main").transition("alpha").removeAllListeners();
                this._startAutoHide.cancel();
            }
        },
        {
            key: "isLive",
            set: function set(value) {
                this._isLive = value;
                this.tag("SideGlass").isLiveSideGlass = value;
                this._updateSeekAvailability();
            }
        },
        {
            key: "isLiveSeekEnabled",
            set: function set(value) {
                this._liveSeekEnabled = value;
                this._updateSeekAvailability();
            }
        },
        {
            key: "topBarItems",
            set: /**
   * Sets an array of items visually represented by icons with textual label that allows user to interact with playback process
   */ function set(value) {
                this.tag("TopBar").items = value;
            }
        },
        {
            key: "title",
            set: /**
   * Sets metadata title as the first line over a Progress Bar
   */ function set(value) {
                this.tag("Metadata").title = value;
            }
        },
        {
            key: "extraTitle",
            set: /**
   * Sets metadata extra title as the second line over a Progress Bar
   */ function set(value) {
                this.tag("Metadata").extraTitle = value;
            }
        },
        {
            key: "programInformation",
            set: /**
   * Sets info page data
   */ function set(value) {
                this.tag("Progress").storyboardId = (0, _get.default)(value, "video.images.storyboard.id", null);
            }
        },
        {
            key: "isHidden",
            get: function get() {
                return this.tag("Main").alpha === 0;
            }
        },
        {
            key: "displayOverlayBackdrop",
            set: function set(value) {
                this.tag("Overlay").displayBackdrop = value;
            }
        },
        {
            key: "displayOverlayTop",
            set: function set(value) {
                this.tag("Overlay").displayTop = value;
            }
        },
        {
            key: "displayOverlayBottom",
            set: function set(value) {
                this.tag("Overlay").displayBottom = value;
            }
        },
        {
            key: "displayMetadata",
            set: function set(value) {
                this.tag("Metadata").visible = value;
            }
        },
        {
            key: "progressBarVariant",
            set: function set(value) {
                this.tag("Progress").variant = value;
            }
        },
        {
            key: "lBannerState",
            set: function set(value) {
                this._lBannerState = value;
                this._updateSeekAvailability();
            }
        },
        {
            /**
   * Displays the controls simultaneously displaying EventMarker in a specified state
   *
   * @param {('Playing'|'Paused')} state current playback state
   */ key: "show",
            value: function show(state) {
                this.tag("Toggle").show(state);
            }
        },
        {
            key: "hide",
            value: function hide() {
                this.tag("Main").setSmooth("alpha", 0);
                this.focusOnAuxiliaryControls();
            }
        },
        {
            key: "focusOnAuxiliaryControls",
            value: function focusOnAuxiliaryControls() {
                var auxiliaryButton = this.tag("AuxiliaryButtons").children.find(function(child) {
                    return child.visible;
                });
                if (auxiliaryButton) {
                    this._setIndex(this._visibleFocusableItems.indexOf(auxiliaryButton));
                } else {
                    this._focusTag("Progress");
                }
                this._refocus();
            }
        },
        {
            key: "showSideGlass",
            value: function showSideGlass() {
                this._focused = this.tag("SideGlass");
                this._refocus();
                (0, _analyticsutils.sendEvent)({
                    key: "openSideGlass"
                });
            }
        },
        {
            key: "showTracks",
            value: function showTracks() {
                this._focused = this.tag("Tracks");
                this._refocus();
                (0, _analyticsutils.sendEvent)({
                    key: "playerTracksPanelOpen"
                });
            }
        },
        {
            key: "showProgramInformation",
            value: function showProgramInformation() {
                this._focused = this.tag("ProgramInformation");
                this._refocus();
                (0, _analyticsutils.sendEvent)({
                    key: "pressSynopsis"
                });
            }
        },
        {
            key: "_getFocused",
            value: function _getFocused() {
                return this._focused;
            }
        },
        {
            key: "_unfocus",
            value: function _unfocus() {
                this.tag("Main").alpha = 0;
                this._focusTag("Progress");
            }
        },
        {
            key: "_captureKey",
            value: function _captureKey() {
                this.showControls();
                return false;
            }
        },
        {
            key: "_handleLeft",
            value: function _handleLeft() {
                return true;
            }
        },
        {
            key: "_handleUp",
            value: function _handleUp() {
                if (this._index > 0) {
                    this._setIndex(this._index - 1);
                    var topBar = this.tag("TopBar");
                    if (this._focused === topBar) {
                        topBar.index = topBar.maxIndex;
                    }
                    return true;
                }
                return false;
            }
        },
        {
            key: "_handleDown",
            value: function _handleDown() {
                if (this._index < this._visibleFocusableItems.length - 1) {
                    this._setIndex(this._index + 1);
                    return true;
                }
                return false;
            }
        },
        {
            key: "_setIndex",
            value: function _setIndex() {
                var index = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._index, restartTimer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                this._index = index;
                this._focused = this._visibleFocusableItems[this._index];
                if (restartTimer) {
                    this._startAutoHide();
                }
            }
        },
        {
            key: "_focusTag",
            value: function _focusTag(tagName) {
                var index = this._visibleFocusableItems.indexOf(this.tag(tagName));
                if (index === -1) {
                    return;
                }
                this._setIndex(index);
            }
        },
        {
            key: "_checkFocusableItems",
            value: function _checkFocusableItems() {
                var restartTimer = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
                this._visibleFocusableItems = this._focusableItems.filter(function(item) {
                    return item.visible;
                });
                if (this._focused && !this._focused.visible) {
                    this._setIndex(0, restartTimer);
                } else if (this._focused) {
                    this._setIndex(this._visibleFocusableItems.indexOf(this._focused), restartTimer);
                }
            }
        },
        {
            key: "_handleSidePanelClose",
            value: function _handleSidePanelClose() {
                this._focusTag("TopBar");
                this._refocus();
                this._startAutoHide();
            }
        },
        {
            key: "_handleSideGlassClose",
            value: function _handleSideGlassClose() {
                this._handleSidePanelClose();
                (0, _analyticsutils.sendEvent)({
                    key: "closeSideGlass"
                });
            }
        },
        {
            key: "_handleTracksPanelClose",
            value: function _handleTracksPanelClose() {
                this._handleSidePanelClose();
                (0, _analyticsutils.sendEvent)({
                    key: "playerTracksPanelClose"
                });
            }
        },
        {
            key: "_handleTopBarItemSelected",
            value: function _handleTopBarItemSelected(item) {
                this.signal(_controlsconstants.TOP_BAR_ITEM_SELECTED_SIGNAL, item);
                if (item && item.action) {
                    switch(item.action){
                        case _playerconstants.TOP_BAR_INFO_PAGE:
                        case _playerconstants.TOP_BAR_RELATED_VIDEOS:
                        case _playerconstants.TOP_BAR_TRACKS:
                            this._startAutoHide.cancel();
                            break;
                        default:
                            break;
                    }
                    _lightningjsredux.default.dispatch({
                        type: item.action
                    });
                }
            }
        },
        {
            key: "_updateSeekAvailability",
            value: function _updateSeekAvailability() {
                var canSeek = !this._lBannerState;
                this.tag("Progress").seekEnable = this._isLive ? this._liveSeekEnabled : canSeek;
            }
        },
        {
            key: "showControls",
            value: function showControls() {
                this.tag("Main").setSmooth("alpha", 1);
                if (!this._autoHideDisablingViews.includes(this._focused)) {
                    this._startAutoHide();
                }
                this.signal(_controlsconstants.CONTROLS_SHOW_SIGNAL);
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                var _obj, _obj1;
                return (0, _merge.default)({
                    Main: {
                        Overlay: {
                            type: _overlaycomponent.Overlay
                        },
                        TopBar: {
                            type: _topBarcomponent.TopBar,
                            signals: _define_property._({}, _signals.SELECTED_SIGNAL, "_handleTopBarItemSelected")
                        },
                        Toggle: {
                            type: _eventMarkercomponent.Toggle
                        },
                        Metadata: {
                            type: _metadatacomponent.Metadata
                        },
                        Progress: {
                            type: _progressBarcomponent.ProgressBar,
                            passSignals: (_obj = {}, _define_property._(_obj, _progressBarconstants.SEEK_SIGNAL, true), _define_property._(_obj, _progressBarconstants.PAUSE_SIGNAL, true), _obj)
                        },
                        SideGlass: {
                            type: _sideGlasscomponent.SideGlass,
                            passSignals: _define_property._({}, _signals.SELECTED_SIGNAL, _controlsconstants.SIDE_GLASS_ITEM_SELECTED_SIGNAL),
                            signals: _define_property._({}, _sideGlassconstants.CLOSE_SIGNAL, "_handleSideGlassClose")
                        },
                        Tracks: {
                            type: _trackscomponent.Tracks,
                            signals: _define_property._({}, _tracksconstants.CLOSE_SIGNAL, "_handleTracksPanelClose"),
                            passSignals: (_obj1 = {}, _define_property._(_obj1, _tracksconstants.AUDIO_TRACK_SELECTED_SIGNAL, true), _define_property._(_obj1, _tracksconstants.SUBTITLES_TRACK_SELECTED_SIGNAL, true), _obj1)
                        },
                        ProgramInformation: {
                            type: _programInformationcomponent.ProgramInformation,
                            signals: _define_property._({}, _programInformationconstants.PROGRAM_INFORMATION_CLOSED_SIGNAL, "_handleSidePanelClose")
                        }
                    },
                    AuxiliaryButtons: {}
                }, (0, _controlsstyle.getInitialStyle)());
            }
        }
    ]);
    return Controls;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 92181:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(42578);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _playerselectors = __webpack_require__(83318);
var _videoselectors = __webpack_require__(23035);
var mapControllers = function(instance) {
    return [
        {
            selector: _playerselectors.getIsLive,
            callback: function(value) {
                instance.isLive = value;
            }
        },
        {
            selector: _playerselectors.isLiveSeekEnabled,
            callback: function(value) {
                instance.isLiveSeekEnabled = value;
            }
        },
        {
            selector: _playerselectors.getTitle,
            callback: function(value) {
                instance.title = value;
            }
        },
        {
            selector: _playerselectors.getExtraTitle,
            callback: function(value) {
                instance.extraTitle = value;
            }
        },
        {
            selector: _videoselectors.getCurrentVideoItem,
            callback: function(value) {
                instance.programInformation = value;
            }
        },
        {
            selector: _videoselectors.getCurrentChapter,
            callback: function(value) {
                instance.chapter = value;
            }
        },
        {
            selector: _playerselectors.getLBannerState,
            callback: function(value) {
                instance.lBannerState = value;
            }
        }
    ];
};
var _default = _lightningjsredux.default.control(mapControllers);


/***/ }),

/***/ 55197:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    CONTROLS_HIDE_SIGNAL: function() {
        return CONTROLS_HIDE_SIGNAL;
    },
    CONTROLS_SHOW_SIGNAL: function() {
        return CONTROLS_SHOW_SIGNAL;
    },
    PAUSED_STATE: function() {
        return PAUSED_STATE;
    },
    PAUSE_SIGNAL: function() {
        return _progressBarconstants.PAUSE_SIGNAL;
    },
    PLAYING_STATE: function() {
        return PLAYING_STATE;
    },
    SEEK_SIGNAL: function() {
        return _progressBarconstants.SEEK_SIGNAL;
    },
    SIDE_GLASS_ITEM_SELECTED_SIGNAL: function() {
        return SIDE_GLASS_ITEM_SELECTED_SIGNAL;
    },
    TOP_BAR_ITEM_SELECTED_SIGNAL: function() {
        return TOP_BAR_ITEM_SELECTED_SIGNAL;
    }
});
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(3009);
var _progressBarconstants = __webpack_require__(88227);
var TOP_BAR_ITEM_SELECTED_SIGNAL = "topBarItemSelected";
var SIDE_GLASS_ITEM_SELECTED_SIGNAL = "sideGlassItemSelected";
var PLAYING_STATE = "Playing";
var PAUSED_STATE = "Paused";
var CONTROLS_SHOW_SIGNAL = "onControlsShow";
var CONTROLS_HIDE_SIGNAL = "onControlsHide";


/***/ }),

/***/ 21950:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    METADATA_Y: function() {
        return METADATA_Y;
    },
    PROGRESS_HEIGHT: function() {
        return PROGRESS_HEIGHT;
    },
    PROGRESS_MARGIN_TOP: function() {
        return PROGRESS_MARGIN_TOP;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _object_spread = __webpack_require__(76247);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(88801);
var _constants = __webpack_require__(34952);
var _theme = __webpack_require__(51397);
var _style = __webpack_require__(65082);
var _sizes = __webpack_require__(82699);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var METADATA_Y = (_obj = {}, _define_property._(_obj, _constants.HD, 566), _define_property._(_obj, _constants.FULL_HD, 880), _obj);
var _obj1;
var PROGRESS_HEIGHT = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 30), _define_property._(_obj1, _constants.FULL_HD, 36), _obj1);
var _obj2;
var PROGRESS_MARGIN_TOP = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 16), _define_property._(_obj2, _constants.FULL_HD, 16), _obj2);
var colors = {
    text: (0, _theme.makeThemeColor)(_theme.PRIMARY)
};
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var screenSize = context.screenSize;
    var margin = {
        x: _constants.safetyMargins.horizontal[screenSize],
        y: _constants.safetyMargins.vertical[screenSize]
    };
    return {
        w: _sizes.SCREEN_WIDTH[screenSize],
        h: _sizes.SCREEN_HEIGHT[screenSize],
        Main: {
            w: _sizes.SCREEN_WIDTH[screenSize],
            h: _sizes.SCREEN_HEIGHT[screenSize],
            alpha: 0,
            transitions: {
                alpha: {
                    duration: 0.3
                }
            },
            TopBar: _object_spread._({}, margin),
            Toggle: {
                mount: 0.5,
                x: _sizes.middle,
                y: _sizes.middle
            },
            Metadata: {
                x: margin.x,
                y: METADATA_Y[screenSize]
            },
            SideGlass: {
                zIndex: 2
            },
            Tracks: {
                zIndex: 2
            },
            ProgramInformation: {
                zIndex: 2
            },
            Progress: {
                mountY: 1,
                x: margin.x,
                y: _sizes.SCREEN_HEIGHT[screenSize] - margin.y,
                w: _sizes.SCREEN_WIDTH[screenSize] - margin.x * 2
            }
        },
        AuxiliaryButtons: {
            mount: 1,
            x: _sizes.SCREEN_WIDTH[screenSize] - margin.x,
            y: _sizes.SCREEN_HEIGHT[screenSize] - margin.y - PROGRESS_HEIGHT[screenSize] - PROGRESS_MARGIN_TOP[screenSize]
        }
    };
};


/***/ }),

/***/ 69295:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "CsaIcon", ({
    enumerable: true,
    get: function() {
        return _csaIconcomponent.CsaIcon;
    }
}));
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(37815);
var _csaIconcomponent = __webpack_require__(30278);


/***/ }),

/***/ 30278:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "CsaIcon", ({
    enumerable: true,
    get: function() {
        return CsaIcon;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(3009);
var _sdk = __webpack_require__(29956);
var CsaIcon = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(CsaIcon, _Lightning_Component);
    var _super = _create_super._(CsaIcon);
    function CsaIcon() {
        _class_call_check._(this, CsaIcon);
        return _super.apply(this, arguments);
    }
    _create_class._(CsaIcon, [
        {
            key: "handleIcon",
            value: function handleIcon() {}
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return {};
            }
        }
    ]);
    return CsaIcon;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 45049:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "makeIcon", ({
    enumerable: true,
    get: function() {
        return makeIcon;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(42578);
var _icons = __webpack_require__(20360);
var _iconcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(70160));
var _eventMarkerstyle = __webpack_require__(49958);
var makeIcon = function(name) {
    return {
        type: _iconcomponent.default,
        iconData: {
            picto: {
                name: name,
                collection: _icons.ICON_COLLECTION.CONTROLS
            },
            viewBox: {
                h: _eventMarkerstyle.ICON_HEIGHT[_eventMarkerstyle.defaultContext.screenSize]
            }
        }
    };
};


/***/ }),

/***/ 77671:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "Toggle", ({
    enumerable: true,
    get: function() {
        return Toggle;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _get = __webpack_require__(60528);
var _get_prototype_of = __webpack_require__(35196);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _envetMarkerutils = __webpack_require__(45049);
var _eventMarkerstyle = __webpack_require__(49958);
var Toggle = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(Toggle, _Lightning_Component);
    var _super = _create_super._(Toggle);
    function Toggle() {
        _class_call_check._(this, Toggle);
        return _super.apply(this, arguments);
    }
    _create_class._(Toggle, [
        {
            key: "$enter",
            value: function $enter() {
                if (!this.transitionAnimation) {
                    this.transitionAnimation = this.animation({
                        duration: 1,
                        stopMethod: "immediate",
                        actions: [
                            {
                                p: "scale",
                                v: {
                                    0: {
                                        v: 1
                                    },
                                    1: {
                                        v: 1.5
                                    }
                                }
                            },
                            {
                                p: "alpha",
                                v: {
                                    0: {
                                        v: 0
                                    },
                                    0.3: {
                                        v: 0.3
                                    },
                                    0.4: {
                                        v: 0.4
                                    },
                                    0.5: {
                                        v: 0.5
                                    },
                                    0.6: {
                                        v: 0.5
                                    },
                                    0.8: {
                                        v: 0.3
                                    },
                                    1: {
                                        v: 0
                                    }
                                }
                            }
                        ]
                    });
                }
                this.transitionAnimation.start();
            }
        },
        {
            key: "show",
            value: function show(state) {
                this._setState(state);
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Background: {},
                    PlayIcon: (0, _envetMarkerutils.makeIcon)("Play"),
                    PauseIcon: (0, _envetMarkerutils.makeIcon)("Pause")
                }, (0, _eventMarkerstyle.getInitialStyle)());
            }
        },
        {
            key: "_states",
            value: function _states() {
                return [
                    /*#__PURE__*/ function(_this) {
                        _inherits._(Playing, _this);
                        var _super = _create_super._(Playing);
                        function Playing() {
                            _class_call_check._(this, Playing);
                            return _super.apply(this, arguments);
                        }
                        _create_class._(Playing, [
                            {
                                key: "$enter",
                                value: function $enter() {
                                    this.tag("PlayIcon").visible = true;
                                    this.tag("PauseIcon").visible = false;
                                    _get._(_get_prototype_of._(Playing.prototype), "$enter", this).call(this);
                                }
                            }
                        ]);
                        return Playing;
                    }(this),
                    /*#__PURE__*/ function(_this) {
                        _inherits._(Paused, _this);
                        var _super = _create_super._(Paused);
                        function Paused() {
                            _class_call_check._(this, Paused);
                            return _super.apply(this, arguments);
                        }
                        _create_class._(Paused, [
                            {
                                key: "$enter",
                                value: function $enter() {
                                    this.tag("PlayIcon").visible = false;
                                    this.tag("PauseIcon").visible = true;
                                    _get._(_get_prototype_of._(Paused.prototype), "$enter", this).call(this);
                                }
                            }
                        ]);
                        return Paused;
                    }(this)
                ];
            }
        }
    ]);
    return Toggle;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 49958:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DIAMETER: function() {
        return DIAMETER;
    },
    ICON_HEIGHT: function() {
        return ICON_HEIGHT;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    getTexture: function() {
        return getTexture;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
var _memoize = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34736));
var _sdk = __webpack_require__(29956);
var _constants = __webpack_require__(34952);
var _theme = __webpack_require__(51397);
var _style = __webpack_require__(65082);
var _sizes = __webpack_require__(82699);
var _colors = __webpack_require__(8426);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var colors = {
    background: (0, _theme.makeThemeColor)(_theme.SECONDARY)
};
var _obj;
var DIAMETER = (_obj = {}, _define_property._(_obj, _constants.HD, 168), _define_property._(_obj, _constants.FULL_HD, 168), _obj);
var _obj1;
var ICON_HEIGHT = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 72), _define_property._(_obj1, _constants.FULL_HD, 72), _obj1);
var getTexture = function(context) {
    var screenSize = context.screenSize;
    var size = DIAMETER[screenSize];
    return _sdk.Lightning.Tools.getRoundRect(size, size, Math.round(size / 2), 0, _colors.TRANSPARENT, true, _colors.WHITE);
};
var getInitialStyle = (0, _memoize.default)(function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var screenSize = context.screenSize, colorMode = context.colorMode;
    var size = DIAMETER[screenSize];
    var iconStyle = {
        mount: 0.5,
        x: _sizes.middle,
        y: _sizes.middle
    };
    return {
        alpha: 0,
        w: size,
        h: size,
        Background: {
            color: colors.background[colorMode],
            texture: getTexture(context),
            w: size,
            h: size
        },
        PlayIcon: iconStyle,
        PauseIcon: iconStyle
    };
}, _style.cacheResolver);


/***/ }),

/***/ 14705:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "MetadataTitle", ({
    enumerable: true,
    get: function() {
        return MetadataTitle;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(65759);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _iconcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(70160));
var _metadataTitlestyle = __webpack_require__(87276);
var _metadataTitleconnector = /*#__PURE__*/ _interop_require_default._(__webpack_require__(23819));
var MetadataTitle = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(MetadataTitle, _Lightning_Component);
    var _super = _create_super._(MetadataTitle);
    function MetadataTitle() {
        _class_call_check._(this, MetadataTitle);
        return _super.apply(this, arguments);
    }
    _create_class._(MetadataTitle, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _metadataTitlestyle.defaultContext;
                this._csaPicto = null;
                this._hasAgeGate = false;
            }
        },
        {
            key: "_attach",
            value: function _attach() {
                this._unsubscribe = (0, _metadataTitleconnector.default)(this);
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                if (this._unsubscribe) {
                    this._unsubscribe();
                    this._unsubscribe = null;
                }
            }
        },
        {
            key: "title",
            get: function get() {
                return this.tag("Title").text;
            },
            set: function set(value) {
                this.tag("Title").text = value;
            }
        },
        {
            key: "csaPicto",
            set: function set(value) {
                this._csaPicto = value;
                this.tag("CsaIcon").visible = Boolean(this._csaPicto);
                this.patch({
                    FlexContainer: {
                        CsaIcon: {
                            visible: true,
                            iconData: {
                                picto: this._csaPicto,
                                viewBox: (0, _metadataTitlestyle.getCSAIconViewBox)(this._style.screenSize)
                            }
                        }
                    }
                });
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    FlexContainer: {
                        Title: {},
                        CsaIcon: {
                            type: _iconcomponent.default
                        }
                    }
                }, (0, _metadataTitlestyle.getInitialStyle)());
            }
        }
    ]);
    return MetadataTitle;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 23819:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(3009);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _playerselectors = __webpack_require__(83318);
var mapControllers = function(instance) {
    return [
        {
            selector: _playerselectors.getCSAPicto,
            callback: function(value) {
                instance.csaPicto = value;
            },
            shouldBeInvokedOnConnect: true
        }
    ];
};
var _default = _lightningjsredux.default.control(mapControllers);


/***/ }),

/***/ 83081:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "MetadataTitle", ({
    enumerable: true,
    get: function() {
        return _metadataTitlecomponent.MetadataTitle;
    }
}));
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
var _metadataTitlecomponent = __webpack_require__(14705);


/***/ }),

/***/ 14128:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    CSA_ICON_MARGIN: function() {
        return CSA_ICON_MARGIN;
    },
    CSA_ICON_SIZE: function() {
        return CSA_ICON_SIZE;
    }
});
var _define_property = __webpack_require__(21228);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(45538);
var _constants = __webpack_require__(34952);
var _obj;
var CSA_ICON_SIZE = (_obj = {}, _define_property._(_obj, _constants.HD, 24), _define_property._(_obj, _constants.FULL_HD, 32), _obj);
var _obj1;
var CSA_ICON_MARGIN = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 8), _define_property._(_obj1, _constants.FULL_HD, 8), _obj1);


/***/ }),

/***/ 87276:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    defaultContext: function() {
        return defaultContext;
    },
    getCSAIconViewBox: function() {
        return getCSAIconViewBox;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
var _memoize = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34736));
var _typography = __webpack_require__(18411);
var _style = __webpack_require__(65082);
var _metadataconstants = __webpack_require__(97854);
var _metadatastyle = __webpack_require__(8338);
var _metadataTitleconstants = __webpack_require__(14128);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var getCSAIconViewBox = (0, _memoize.default)(function(screenSize) {
    return {
        h: _metadataTitleconstants.CSA_ICON_SIZE[screenSize],
        w: _metadataTitleconstants.CSA_ICON_SIZE[screenSize]
    };
});
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var screenSize = context.screenSize;
    var wordWrapWidth = _metadataconstants.MAX_TEXT_WIDTH[screenSize];
    var titleFont = (0, _typography.getFont)(_typography.FONT.KINSHASA_1, screenSize);
    return {
        FlexContainer: {
            flex: {
                direction: "row",
                alignItems: "center"
            },
            Title: {
                text: _object_spread._({
                    wordWrapWidth: wordWrapWidth
                }, _metadatastyle.genericTextStyle, titleFont)
            },
            CsaIcon: {
                visible: false,
                flexItem: {
                    marginLeft: _metadataTitleconstants.CSA_ICON_MARGIN[screenSize]
                }
            }
        }
    };
};


/***/ }),

/***/ 70057:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "Metadata", ({
    enumerable: true,
    get: function() {
        return Metadata;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(3009);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _metadataTitlecomponent = __webpack_require__(83081);
var _metadatastyle = __webpack_require__(8338);
var Metadata = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(Metadata, _Lightning_Component);
    var _super = _create_super._(Metadata);
    function Metadata() {
        _class_call_check._(this, Metadata);
        return _super.apply(this, arguments);
    }
    _create_class._(Metadata, [
        {
            key: "_build",
            value: function _build() {
                this._style = _metadatastyle.defaultContext;
            }
        },
        {
            key: "_updatePositions",
            value: function _updatePositions() {
                var extraTitle = this.tag("ExtraTitle");
                var offset = this.finalH;
                if (extraTitle.visible) {
                    extraTitle.y = offset;
                }
            }
        },
        {
            key: "title",
            get: function get() {
                return this.tag("Title").title;
            },
            set: function set(value) {
                var element = this.tag("Title");
                element.title = value;
                element.visible = Boolean(value);
                this._updatePositions();
            }
        },
        {
            key: "extraTitle",
            get: function get() {
                return this.tag("ExtraTitle").text.text;
            },
            set: function set(value) {
                var element = this.tag("ExtraTitle");
                element.text.text = value;
                element.visible = Boolean(value);
                this._updatePositions();
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Title: {
                        type: _metadataTitlecomponent.MetadataTitle
                    },
                    ExtraTitle: {}
                }, (0, _metadatastyle.getInitialStyle)());
            }
        }
    ]);
    return Metadata;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 97854:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    MAX_TEXT_WIDTH: function() {
        return MAX_TEXT_WIDTH;
    },
    TITLE_MARGIN_BOTTOM: function() {
        return TITLE_MARGIN_BOTTOM;
    }
});
var _define_property = __webpack_require__(21228);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(88801);
var _constants = __webpack_require__(34952);
var _obj;
var MAX_TEXT_WIDTH = (_obj = {}, _define_property._(_obj, _constants.HD, 1000), _define_property._(_obj, _constants.FULL_HD, 1000), _obj);
var _obj1;
var TITLE_MARGIN_BOTTOM = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 4), _define_property._(_obj1, _constants.FULL_HD, 8), _obj1);


/***/ }),

/***/ 8338:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    defaultContext: function() {
        return defaultContext;
    },
    genericTextStyle: function() {
        return genericTextStyle;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
var _object_spread = __webpack_require__(76247);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(52318);
var _typography = __webpack_require__(18411);
var _style = __webpack_require__(65082);
var _metadataconstants = __webpack_require__(97854);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var genericTextStyle = {
    maxLines: 1,
    textBaseline: "bottom",
    verticalAlign: "middle"
};
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var screenSize = context.screenSize;
    var titleFont = (0, _typography.getFont)(_typography.FONT.KINSHASA_1, screenSize);
    var extraTitleFont = (0, _typography.getFont)(_typography.FONT.OTTAWA_1, screenSize);
    var wordWrapWidth = _metadataconstants.MAX_TEXT_WIDTH[screenSize];
    return {
        w: wordWrapWidth,
        h: titleFont.lineHeight + _metadataconstants.TITLE_MARGIN_BOTTOM[screenSize] + extraTitleFont.lineHeight,
        ExtraTitle: {
            mountY: 1,
            text: _object_spread._({
                wordWrapWidth: wordWrapWidth
            }, genericTextStyle, extraTitleFont)
        }
    };
};


/***/ }),

/***/ 6859:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "Overlay", ({
    enumerable: true,
    get: function() {
        return Overlay;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(3009);
var _sdk = __webpack_require__(29956);
var _overlaystyle = __webpack_require__(229);
var _colors = __webpack_require__(8426);
var Overlay = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(Overlay, _Lightning_Component);
    var _super = _create_super._(Overlay);
    function Overlay() {
        _class_call_check._(this, Overlay);
        return _super.apply(this, arguments);
    }
    _create_class._(Overlay, [
        {
            key: "colorMode",
            get: function get() {
                return this._colorMode;
            },
            set: function set(value) {
                this._colorMode = value;
                this.patch({
                    color: _overlaystyle.colors.background[this._colorMode]
                });
            }
        },
        {
            key: "displayBackdrop",
            set: function set(value) {
                this.color = value ? _overlaystyle.colors.background[this._colorMode] : _colors.TRANSPARENT;
            }
        },
        {
            key: "displayTop",
            set: function set(value) {
                this.tag("Top").visible = value;
            }
        },
        {
            key: "displayBottom",
            set: function set(value) {
                this.tag("Bottom").visible = value;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _overlaystyle.getInitialStyle)();
            }
        }
    ]);
    return Overlay;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 229:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    background: function() {
        return background;
    },
    colors: function() {
        return colors;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    gradient: function() {
        return gradient;
    }
});
var _define_property = __webpack_require__(21228);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(42578);
var _theme = __webpack_require__(51397);
var _constants = __webpack_require__(34952);
var _style = __webpack_require__(65082);
var _sizes = __webpack_require__(82699);
var _colors = __webpack_require__(8426);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var colors = {
    background: (0, _theme.makeThemeColor)(_theme.TERTIARY)
};
var _obj;
var background = (_obj = {}, _define_property._(_obj, _constants.HD, {
    w: _sizes.SCREEN_WIDTH[_constants.HD],
    h: _sizes.SCREEN_HEIGHT[_constants.HD]
}), _define_property._(_obj, _constants.FULL_HD, {
    w: _sizes.SCREEN_WIDTH[_constants.FULL_HD],
    h: _sizes.SCREEN_HEIGHT[_constants.FULL_HD]
}), _obj);
var _obj1;
var gradient = (_obj1 = {}, _define_property._(_obj1, _constants.HD, {
    w: _sizes.SCREEN_WIDTH[_constants.HD],
    h: Math.round(_sizes.SCREEN_HEIGHT[_constants.HD] * 0.25)
}), _define_property._(_obj1, _constants.FULL_HD, {
    w: _sizes.SCREEN_WIDTH[_constants.FULL_HD],
    h: Math.round(_sizes.SCREEN_HEIGHT[_constants.FULL_HD] * 0.25)
}), _obj1);
var getInitialStyle = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext, screenSize = _ref.screenSize, colorMode = _ref.colorMode;
    return _object_spread_props._(_object_spread._({}, background[screenSize]), {
        rect: true,
        color: (0, _theme.getDarkColor)(_theme.TERTIARY, 0.6),
        Top: _object_spread_props._(_object_spread._({}, gradient[screenSize]), {
            rect: true,
            colorTop: colors.background[colorMode],
            colorBottom: _colors.TRANSPARENT
        }),
        Bottom: _object_spread_props._(_object_spread._({}, gradient[screenSize]), {
            rect: true,
            y: background[screenSize].h - gradient[screenSize].h,
            colorTop: _colors.TRANSPARENT,
            colorBottom: colors.background[colorMode]
        })
    });
};


/***/ }),

/***/ 70452:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "Pill", ({
    enumerable: true,
    get: function() {
        return Pill;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(3009);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _iconcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(70160));
var _pillshader = /*#__PURE__*/ _interop_require_default._(__webpack_require__(40521));
var _pillstyle = __webpack_require__(87872);
var Pill = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(Pill, _Lightning_Component);
    var _super = _create_super._(Pill);
    function Pill() {
        _class_call_check._(this, Pill);
        return _super.apply(this, arguments);
    }
    _create_class._(Pill, [
        {
            key: "_init",
            value: function _init() {
                var _this = this;
                this._style = _pillstyle.defaultContext;
                this._maxWidth = 0;
                var icon = this.tag("Icon");
                var primary = this.tag("Primary");
                var secondary = this.tag("Secondary");
                var handleUpdate = function() {
                    var paddingX = _pillstyle.HORIZONTAL_PADDING[_this._style.screenSize];
                    var gap = _pillstyle.GAP[_this._style.screenSize];
                    var patch = {
                        Background: {},
                        Icon: {},
                        Primary: {},
                        Secondary: {}
                    };
                    patch.Icon.x = paddingX;
                    patch.Primary.x = icon.visible ? Math.round(patch.Icon.x + (icon.finalW ? icon.finalW + gap : 0)) : paddingX;
                    patch.Secondary.x = Math.round(patch.Primary.x + (primary.finalW ? primary.finalW + gap : 0));
                    patch.w = patch.Secondary.x + secondary.finalW + paddingX;
                    _this._maxWidth = Math.max(_this._maxWidth, patch.w);
                    var minWidth = Math.max(_this._maxWidth, _this._minWidth || 0);
                    if (minWidth && patch.w < minWidth) {
                        var offset = Math.round((minWidth - patch.w) / 2);
                        patch.Icon.x += offset;
                        patch.Primary.x += offset;
                        patch.Secondary.x += offset;
                        patch.w = minWidth;
                    }
                    patch.Background.w = patch.w;
                    _this.patch(patch);
                };
                icon.on("txLoaded", handleUpdate);
                secondary.on("txLoaded", handleUpdate);
                primary.on("txLoaded", handleUpdate);
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                this._progress = 0;
                this.tag("Primary").removeAllListeners("txLoaded");
                this.tag("Secondary").removeAllListeners("txLoaded");
                this.tag("Icon").removeAllListeners("txLoaded");
            }
        },
        {
            key: "minWidth",
            get: function get() {
                return this._minWidth;
            },
            set: function set(value) {
                this._minWidth = value;
            }
        },
        {
            key: "progress",
            get: function get() {
                return this._progress;
            },
            set: function set(value) {
                this._progress = value;
                this.tag("Background").shader.progress = Math.max(0, 1 - value);
            }
        },
        {
            key: "title",
            set: function set(value) {
                this.tag("Primary").text.text = value;
            }
        },
        {
            key: "body",
            set: function set(value) {
                this.tag("Secondary").text.text = value;
            }
        },
        {
            key: "backgroundColor",
            set: function set(value) {
                this.patch({
                    Background: {
                        shader: {
                            fillColor: value
                        }
                    }
                });
            }
        },
        {
            key: "textColor",
            set: function set(value) {
                this.patch({
                    Icon: {
                        color: value
                    },
                    Primary: {
                        color: value
                    },
                    Secondary: {
                        color: value
                    }
                });
            }
        },
        {
            key: "displayIcon",
            get: function get() {
                return this.tag("Icon").visible;
            },
            set: function set(value) {
                this.tag("Icon").visible = value;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Background: {
                        rect: true,
                        shader: {
                            type: _pillshader.default
                        },
                        flexItem: false
                    },
                    Icon: {
                        type: _iconcomponent.default
                    },
                    Primary: {
                        text: {}
                    },
                    Secondary: {
                        text: {}
                    }
                }, (0, _pillstyle.getInitialStyle)());
            }
        }
    ]);
    return Pill;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 87872:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    GAP: function() {
        return GAP;
    },
    HEIGHT: function() {
        return HEIGHT;
    },
    HORIZONTAL_PADDING: function() {
        return HORIZONTAL_PADDING;
    },
    ICON_HEIGHT: function() {
        return ICON_HEIGHT;
    },
    VERTICAL_PADDING: function() {
        return VERTICAL_PADDING;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(3009);
var _constants = __webpack_require__(34952);
var _theme = __webpack_require__(51397);
var _typography = __webpack_require__(18411);
var _style = __webpack_require__(65082);
var _sizes = __webpack_require__(82699);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var colors = {
    background: (0, _theme.makeThemeColor)(_theme.TERTIARY),
    bar: (0, _theme.makeThemeColor)(_theme.PRIMARY, 0.3),
    text: (0, _theme.makeThemeColor)(_theme.PRIMARY)
};
var _obj;
var HEIGHT = (_obj = {}, _define_property._(_obj, _constants.HD, 48), _define_property._(_obj, _constants.FULL_HD, 56), _obj);
var _obj1;
var ICON_HEIGHT = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 24), _define_property._(_obj1, _constants.FULL_HD, 32), _obj1);
var _obj2;
var HORIZONTAL_PADDING = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 24), _define_property._(_obj2, _constants.FULL_HD, 32), _obj2);
var _obj3;
var VERTICAL_PADDING = (_obj3 = {}, _define_property._(_obj3, _constants.HD, 12), _define_property._(_obj3, _constants.FULL_HD, 12), _obj3);
var _obj4;
var GAP = (_obj4 = {}, _define_property._(_obj4, _constants.HD, 8), _define_property._(_obj4, _constants.FULL_HD, 8), _obj4);
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var screenSize = context.screenSize, colorMode = context.colorMode;
    var primaryFont = (0, _typography.getFont)(_typography.FONT.BERLIN_3, screenSize);
    var secondaryFont = (0, _typography.getFont)(_typography.FONT.BERLIN_1, screenSize);
    return {
        h: HEIGHT[screenSize],
        Background: {
            w: _sizes.identity,
            h: HEIGHT[screenSize],
            shader: {
                fillColor: colors.background[colorMode],
                progressColor: colors.bar[colorMode],
                radius: Math.round(HEIGHT[screenSize] / 2)
            }
        },
        Icon: {
            iconData: {
                picto: {
                    name: "Play",
                    type: "icon"
                },
                viewBox: {
                    h: ICON_HEIGHT[screenSize]
                }
            },
            y: Math.round((HEIGHT[screenSize] - ICON_HEIGHT[screenSize]) / 2)
        },
        Primary: {
            color: colors.text[colorMode],
            y: Math.round((HEIGHT[screenSize] - primaryFont.lineHeight) / 2),
            text: _object_spread_props._(_object_spread._({}, primaryFont), {
                verticalAlign: "middle",
                wordWrap: false
            })
        },
        Secondary: {
            color: colors.text[colorMode],
            y: Math.round((HEIGHT[screenSize] - secondaryFont.lineHeight) / 2),
            text: _object_spread_props._(_object_spread._({}, secondaryFont), {
                verticalAlign: "middle",
                wordWrap: false
            })
        }
    };
};


/***/ }),

/***/ 33006:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "ProgramInformation", ({
    enumerable: true,
    get: function() {
        return ProgramInformation;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(3009);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _constants = __webpack_require__(34952);
var _scrollcomponent = __webpack_require__(31418);
var _programDescriptioncomponent = __webpack_require__(68091);
var _sizes = __webpack_require__(82699);
var _programInformationstyle = __webpack_require__(3966);
var _programInformationconstants = __webpack_require__(57953);
var _programInformationconnector = /*#__PURE__*/ _interop_require_default._(__webpack_require__(33900));
var ProgramInformation = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(ProgramInformation, _Lightning_Component);
    var _super = _create_super._(ProgramInformation);
    function ProgramInformation() {
        _class_call_check._(this, ProgramInformation);
        return _super.apply(this, arguments);
    }
    _create_class._(ProgramInformation, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _programInformationstyle.defaultContext;
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                this.tag("Title").removeAllListeners("txLoaded");
                if (this._unsubscribe) {
                    this._unsubscribe();
                }
            }
        },
        {
            key: "_active",
            value: function _active() {
                if (!this._unsubscribe) {
                    this._unsubscribe = (0, _programInformationconnector.default)(this);
                }
            }
        },
        {
            key: "data",
            set: function set(content) {
                var _this = this;
                if (!content) {
                    return;
                }
                this.tag("Title").once("txLoaded", function() {
                    var scroll = _this.tag("Scroll");
                    var scrollableView = scroll.content;
                    if (scrollableView) {
                        var titleHeight = _this.tag("Title").finalH;
                        var screenSize = _this._style.screenSize;
                        scroll.visible = true;
                        scroll.y = titleHeight + _programInformationstyle.PADDING_TOP[screenSize] + _programInformationstyle.GAP[screenSize];
                        scroll.h = _sizes.SCREEN_HEIGHT[screenSize] - scroll.y - _constants.safetyMargins.vertical[screenSize];
                        scrollableView.data = {
                            description: content.description
                        };
                    }
                });
                this.tag("Title").text.text = content.title;
            }
        },
        {
            key: "_getFocused",
            value: function _getFocused() {
                return this.tag("Scroll");
            }
        },
        {
            key: "_unfocus",
            value: function _unfocus() {
                this.patch((0, _programInformationstyle.getUnFocusedStyle)(this._style.screenSize));
            }
        },
        {
            key: "_focus",
            value: function _focus() {
                this.patch((0, _programInformationstyle.getFocusedStyle)(this._style.screenSize));
            }
        },
        {
            key: "_handleBack",
            value: function _handleBack() {
                this.signal(_programInformationconstants.PROGRAM_INFORMATION_CLOSED_SIGNAL);
            }
        },
        {
            key: "_handleLeft",
            value: function _handleLeft() {
                this.signal(_programInformationconstants.PROGRAM_INFORMATION_CLOSED_SIGNAL);
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    rect: true,
                    BackgroundOverlay: {
                        rect: true
                    },
                    Title: {},
                    Scroll: {
                        type: _scrollcomponent.Scroll,
                        content: {
                            type: _programDescriptioncomponent.ProgramDescription,
                            w: _programInformationstyle.TEXT_WIDTH[_programInformationstyle.defaultContext.screenSize]
                        }
                    }
                }, (0, _programInformationstyle.getInitialStyle)());
            }
        }
    ]);
    return ProgramInformation;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 33900:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(65759);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _videoselectors = __webpack_require__(23035);
var mapControllers = function(instance) {
    return [
        {
            shouldBeInvokedOnConnect: true,
            selector: _videoselectors.getCurrentVideoItem,
            callback: function(value) {
                instance.data = value;
            }
        }
    ];
};
var _default = _lightningjsredux.default.control(mapControllers);


/***/ }),

/***/ 57953:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "PROGRAM_INFORMATION_CLOSED_SIGNAL", ({
    enumerable: true,
    get: function() {
        return PROGRAM_INFORMATION_CLOSED_SIGNAL;
    }
}));
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(45538);
var PROGRAM_INFORMATION_CLOSED_SIGNAL = "programInformationClosed";


/***/ }),

/***/ 3966:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    GAP: function() {
        return GAP;
    },
    PADDING_LEFT: function() {
        return PADDING_LEFT;
    },
    PADDING_RIGHT: function() {
        return PADDING_RIGHT;
    },
    PADDING_TOP: function() {
        return PADDING_TOP;
    },
    TEXT_WIDTH: function() {
        return TEXT_WIDTH;
    },
    WIDTH: function() {
        return WIDTH;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getFocusedStyle: function() {
        return getFocusedStyle;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    getUnFocusedStyle: function() {
        return getUnFocusedStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(52318);
var _memoize = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34736));
var _constants = __webpack_require__(34952);
var _theme = __webpack_require__(51397);
var _typography = __webpack_require__(18411);
var _sizes = __webpack_require__(82699);
var _style = __webpack_require__(65082);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var PADDING_TOP = (_obj = {}, _define_property._(_obj, _constants.HD, 40), _define_property._(_obj, _constants.FULL_HD, 56), _obj);
var _obj1;
var GAP = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 40), _define_property._(_obj1, _constants.FULL_HD, 40), _obj1);
var _obj2;
var PADDING_RIGHT = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 80), _define_property._(_obj2, _constants.FULL_HD, 104), _obj2);
var _obj3;
var PADDING_LEFT = (_obj3 = {}, _define_property._(_obj3, _constants.HD, 80), _define_property._(_obj3, _constants.FULL_HD, 104), _obj3);
var _obj4;
var WIDTH = (_obj4 = {}, _define_property._(_obj4, _constants.HD, 640), _define_property._(_obj4, _constants.FULL_HD, 960), _obj4);
var _obj5;
var TEXT_WIDTH = (_obj5 = {}, _define_property._(_obj5, _constants.HD, WIDTH[_constants.HD] - PADDING_RIGHT[_constants.HD] - PADDING_LEFT[_constants.HD]), _define_property._(_obj5, _constants.FULL_HD, WIDTH[_constants.FULL_HD] - PADDING_RIGHT[_constants.FULL_HD] - PADDING_LEFT[_constants.FULL_HD]), _obj5);
var colors = {
    text: (0, _theme.makeThemeColor)(_theme.PRIMARY),
    backgroundOverlay: (0, _theme.makeThemeColor)(_theme.PRIMARY, 0.1),
    background: (0, _theme.makeThemeColor)(_theme.TERTIARY)
};
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var screenSize = context.screenSize, colorMode = context.colorMode;
    var offsetX = _sizes.SCREEN_WIDTH[screenSize] + WIDTH[screenSize];
    var color = colors.text[colorMode];
    var titleFont = (0, _typography.getFont)(_typography.FONT.TOKYO_4, screenSize);
    var textWidth = TEXT_WIDTH[screenSize];
    return {
        visible: false,
        x: offsetX,
        w: WIDTH[screenSize],
        h: _sizes.SCREEN_HEIGHT[screenSize],
        color: colors.background[colorMode],
        BackgroundOverlay: {
            w: WIDTH[screenSize],
            h: _sizes.SCREEN_HEIGHT[screenSize],
            color: colors.backgroundOverlay[colorMode]
        },
        Title: {
            x: PADDING_LEFT[screenSize],
            y: PADDING_TOP[screenSize],
            text: _object_spread_props._(_object_spread._({}, titleFont), {
                wordWrapWidth: textWidth,
                textColor: color,
                verticalAlign: "bottom",
                maxLinesSuffix: "...",
                maxLines: 2
            })
        },
        Scroll: {
            visible: false,
            x: PADDING_LEFT[screenSize],
            w: textWidth
        }
    };
};
var getFocusedStyle = (0, _memoize.default)(function(screenSize) {
    return {
        visible: true,
        smooth: {
            x: _sizes.SCREEN_WIDTH[screenSize] - WIDTH[screenSize]
        }
    };
});
var getUnFocusedStyle = (0, _memoize.default)(function(screenSize) {
    return {
        smooth: {
            x: _sizes.SCREEN_WIDTH[screenSize]
        }
    };
});


/***/ }),

/***/ 17351:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "ProgressBar", ({
    enumerable: true,
    get: function() {
        return ProgressBar;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _get = __webpack_require__(60528);
var _get_prototype_of = __webpack_require__(35196);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _set = __webpack_require__(81364);
var _create_super = __webpack_require__(6400);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(88801);
var _clamp = /*#__PURE__*/ _interop_require_default._(__webpack_require__(35636));
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _debounce = /*#__PURE__*/ _interop_require_default._(__webpack_require__(66292));
var _throttle = /*#__PURE__*/ _interop_require_default._(__webpack_require__(38209));
var _sdk = __webpack_require__(29956);
var _utils = __webpack_require__(64188);
var _config = __webpack_require__(67958);
var _playerconstants = __webpack_require__(28824);
var _progressutils = __webpack_require__(40779);
var _sizes = __webpack_require__(82699);
var _sliderThumbcomponent = __webpack_require__(5370);
var _sliderThumbstyle = __webpack_require__(44299);
var _storyboardcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(74290));
var _storyboardstyle = __webpack_require__(7847);
var _storyboardconstants = __webpack_require__(24773);
var _storyboardutils = __webpack_require__(49429);
var _seekBarcomponent = __webpack_require__(12315);
var _progressBarstyle = __webpack_require__(95361);
var _progressBarconstants = __webpack_require__(88227);
var _progressBarconnector = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65163));
var ProgressBar = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(ProgressBar, _Lightning_Component);
    var _super = _create_super._(ProgressBar);
    function ProgressBar() {
        _class_call_check._(this, ProgressBar);
        return _super.apply(this, arguments);
    }
    _create_class._(ProgressBar, [
        {
            key: "_construct",
            value: function _construct() {
                var _this = this;
                this._duration = 0;
                this._elapsed = 0;
                this._progress = 0;
                this._seekEnable = true;
                this._seekDirection = 0;
                this._playHead = 0;
                this._seekTime = 0;
                this._barWidth = 0;
                this._barOffset = 0;
                this._style = _progressBarstyle.defaultContext;
                this._isLive = false;
                this._isActive = false;
                // Indicates if all the text labels widths are detected and the bar is placed accurately in a middle
                this._isBuiltCompletely = false;
                this._withStoryboard = false;
                this._variant = _progressBarconstants.TIME_ASIDE;
                this._longSeekEnabled = false;
                this._ticks = 0;
                this._debounceDigitSeek = (0, _debounce.default)(function(seekTime) {
                    _this.signal(_progressBarconstants.SEEK_SIGNAL, seekTime);
                }, _playerconstants.SEEK_DEBOUNCE_MS);
                this._debounceSeek = (0, _debounce.default)(function() {
                    _this._seekDirection = 0;
                    _this._elapsed = _this._seekTime;
                    _this.signal(_progressBarconstants.SEEK_SIGNAL, _this._seekTime);
                }, _playerconstants.SEEK_DEBOUNCE_MS);
                this._throttleSeek = (0, _throttle.default)(function() {
                    var step = _playerconstants.SEEK_STEP_SECONDS;
                    if (_this._longSeekEnabled) {
                        if (_this._ticks > 20) {
                            step = 120;
                        } else if (_this._ticks > 15) {
                            step = 60;
                        } else if (_this._ticks > 10) {
                            step = 30;
                        }
                        if (_this._ticks > 1 && _progressBarconstants.PAUSE_ON_LONG_SEEK) {
                            _this.signal(_progressBarconstants.PAUSE_SIGNAL);
                        }
                    }
                    _this._seekTime = (0, _clamp.default)(_this._seekTime + step * _this._seekDirection, 0, _this._duration);
                    if (_this._isLive && _this._playHead) {
                        _this._seekTime = _this._seekTime > _this._playHead ? _this._playHead : _this._seekTime;
                    }
                    // Don't play seek animation if children sizes are not determined yet
                    if (_this._isBuiltCompletely) {
                        _this._setSeekTime(_this._seekTime);
                    }
                    _this._ticks += 1;
                    _this._debounceSeek();
                }, _playerconstants.SEEK_THROTTLE_MS);
            }
        },
        {
            key: "_build",
            value: function _build() {
                this.elapsed = 0;
                this._playHead = 0;
            }
        },
        {
            key: "_attach",
            value: function _attach() {
                this._unsubscribe = (0, _progressBarconnector.default)(this);
            }
        },
        {
            key: "_active",
            value: function _active() {
                this._isActive = true;
                this._handleProgressUpdate();
            }
        },
        {
            key: "_inactive",
            value: function _inactive() {
                this._isActive = false;
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                if (this._unsubscribe) {
                    this._unsubscribe();
                    this._unsubscribe = null;
                }
                this.tag("Duration").removeAllListeners("txLoaded");
                this._isBuiltCompletely = false;
                this._stopSeeking();
            }
        },
        {
            key: "seekEnable",
            get: function get() {
                return this._seekEnable;
            },
            set: function set(value) {
                this._seekEnable = value;
            }
        },
        {
            key: "longSeekEnabled",
            get: function get() {
                return this._longSeekEnabled;
            },
            set: function set(value) {
                this._longSeekEnabled = value;
            }
        },
        {
            key: "canSeek",
            get: function get() {
                return this._seekEnable && this._duration > 0;
            }
        },
        {
            key: "withStoryboard",
            get: function get() {
                return this._withStoryboard && !this._isLive;
            }
        },
        {
            key: "elapsed",
            set: function set(value) {
                this._elapsed = value;
                this._updateTime();
            }
        },
        {
            key: "playHead",
            set: function set(value) {
                this._playHead = value;
                this.tag("Bar").playHead = (0, _progressutils.safeProgressValue)(this._duration > 0 ? value / this._duration : 0);
            }
        },
        {
            key: "duration",
            set: function set(value) {
                // Place dynamic controls on start position
                var duration = this.tag("Duration");
                if (this._duration !== value) {
                    duration.text.text = (0, _utils.getTimeFormat)(value).replace(/\d/g, "0");
                    // NOTE: force text texture to be loaded synchronously in order to measure as wide text as possible
                    duration.loadTexture();
                    var w = duration.finalW;
                    this._barOffset = this._variant === _progressBarconstants.TIME_ASIDE ? w + _progressBarstyle.LABEL_OFFSET[this._style.screenSize] : 0;
                }
                this._duration = value;
                this._handleProgressUpdate();
                // Play seek animation if it was requested before Duration label texture was loaded
                this._isBuiltCompletely = true;
                if (this._seekDirection !== 0) {
                    this._setSeekTime(this._seekTime);
                }
                // rolling back true duration value
                duration.text.text = (0, _utils.getTimeFormat)(value);
                this._placeAdMarkers();
            }
        },
        {
            key: "storyboard",
            set: function set(value) {
                this._withStoryboard = value;
            }
        },
        {
            key: "storyboardId",
            set: function set(id) {
                if (this.withStoryboard) {
                    this.tag("Storyboard").imageId = id;
                }
            }
        },
        {
            key: "isLive",
            set: function set(value) {
                this._isLive = value;
                this.tag("Bar").isLive = value;
            }
        },
        {
            key: "w",
            get: function get() {
                return _get._(_get_prototype_of._(ProgressBar.prototype), "w", this);
            },
            set: function set(value) {
                _set._(_get_prototype_of._(ProgressBar.prototype), "w", value, this, true);
                this._handleProgressUpdate();
            }
        },
        {
            key: "variant",
            get: function get() {
                return this._variant;
            },
            set: function set(value) {
                this._variant = value;
                var showProgress = this._variant !== _progressBarconstants.TIME_HIDDEN;
                this.patch({
                    Elapsed: {
                        visible: showProgress
                    },
                    Duration: {
                        visible: showProgress
                    }
                });
                this._handleProgressUpdate();
            }
        },
        {
            key: "adMarkers",
            set: function set(value) {
                this._adMarkers = value;
                this._placeAdMarkers();
            }
        },
        {
            key: "_placeAdMarkers",
            value: function _placeAdMarkers() {
                var _this = this;
                if (!this._adMarkers || !this._duration || !this._barWidth || !_config.featureFlipping.player_midrollMarkers) {
                    return;
                }
                this.tag("Ads").children = this._adMarkers.filter(function(cue) {
                    return cue <= _this._duration;
                }).map(function(cue) {
                    var offset = cue / _this._duration;
                    var x = Math.round(offset * _this._barWidth);
                    return _object_spread_props._(_object_spread._({}, (0, _progressBarstyle.makeAdMarkerStyle)(_this._style)), {
                        x: x
                    });
                });
            }
        },
        {
            key: "_focus",
            value: function _focus() {
                this.patch((0, _progressBarstyle.getFocusedStyle)(this._style.screenSize));
            }
        },
        {
            key: "_unfocus",
            value: function _unfocus() {
                if (this._seekDirection !== 0) {
                    this._seekDirection = 0;
                    this._elapsed = this._seekTime;
                    this.signal(_progressBarconstants.SEEK_SIGNAL, this._seekTime);
                }
                this._stopSeeking();
                this.patch((0, _progressBarstyle.getUnFocusedStyle)(this._style.screenSize));
            }
        },
        {
            key: "_handleKeyRelease",
            value: function _handleKeyRelease() {
                this._ticks = 0;
            }
        },
        {
            key: "_handleLeft",
            value: function _handleLeft() {
                return this._handleRewind();
            }
        },
        {
            key: "_handleRight",
            value: function _handleRight() {
                return this._handleFastForward();
            }
        },
        {
            key: "_handleSkipFastForward",
            value: function _handleSkipFastForward() {
                return this._handleFastForward();
            }
        },
        {
            key: "_handleSkipRewind",
            value: function _handleSkipRewind() {
                return this._handleRewind();
            }
        },
        {
            key: "_handleRewind",
            value: function _handleRewind() {
                return this._startSeeking(-1);
            }
        },
        {
            key: "_handleFastForward",
            value: function _handleFastForward() {
                return this._startSeeking(1);
            }
        },
        {
            // NOTE: this one should be kept as Metrological app store may use both FastForward and Forward for key definition
            key: "_handleForward",
            value: function _handleForward() {
                return this._handleFastForward();
            }
        },
        {
            key: "_handleKey",
            value: function _handleKey(event) {
                if (this._seekDirection === 0 && this._duration && /^[0-9]$/.test(event.key)) {
                    var seekTime = Math.round(this._duration * (parseInt(event.key, 10) / 10));
                    this._debounceDigitSeek(seekTime);
                    return true;
                }
                return false;
            }
        },
        {
            key: "_startSeeking",
            value: function _startSeeking(direction) {
                if (!this.canSeek) {
                    return false;
                }
                this._updateTime();
                this._seekDirection = direction;
                this._throttleSeek();
                return true;
            }
        },
        {
            key: "_stopSeeking",
            value: function _stopSeeking() {
                this._ticks = 0;
                this._seekDirection = 0;
                this._debounceSeek.cancel();
                this._throttleSeek.cancel();
                this._debounceDigitSeek.cancel();
            }
        },
        {
            key: "_handleProgressUpdate",
            value: function _handleProgressUpdate() {
                if (!this._isActive) {
                    return;
                }
                this._barWidth = this.finalW - this._barOffset * 2;
                var screenSize = this._style.screenSize;
                var isAside = this._variant === _progressBarconstants.TIME_ASIDE;
                var h = isAside ? _progressBarstyle.HEIGHT[screenSize] : _sliderThumbstyle.DIAMETER[screenSize] + _progressBarstyle.LABEL_OFFSET[screenSize] + (0, _progressBarstyle.getTimeLabelsFont)(screenSize).lineHeight;
                var y = isAside ? Math.round(h / 2) : h;
                var mountY = isAside ? 0.5 : 1;
                var barY = isAside ? _sizes.middle : Math.round((_sliderThumbstyle.DIAMETER[screenSize] - _progressBarstyle.BAR_HEIGHT_UNFOCUSED[screenSize]) / 2);
                this.patch({
                    h: h,
                    Elapsed: {
                        y: y,
                        mountY: mountY
                    },
                    Bar: {
                        x: this._barOffset,
                        w: this._barWidth,
                        mountY: isAside ? 0.5 : 0,
                        y: barY
                    },
                    Ads: {
                        x: this._barOffset,
                        mountY: isAside ? 0.5 : 0,
                        y: barY,
                        w: this._barWidth
                    },
                    SliderThumb: {
                        visible: this.canSeek,
                        mountY: isAside ? 0.5 : 0,
                        y: isAside ? _sizes.middle : 0
                    },
                    Duration: {
                        x: this.finalW,
                        y: y,
                        mountY: mountY,
                        mountX: 1
                    }
                });
                this._placeAdMarkers();
                this._updateTime();
            }
        },
        {
            key: "_updateTime",
            value: function _updateTime() {
                this._progress = this._variant === _progressBarconstants.TIME_HIDDEN ? 1 : (0, _progressutils.safeProgressValue)(this._duration > 0 ? this._elapsed / this._duration : 0);
                if (this._seekDirection === 0) {
                    this._seekTime = this._elapsed;
                    this.tag("Elapsed").text.text = (0, _utils.getTimeFormat)(this._elapsed);
                    this.tag("Bar").progress = this._progress;
                    this.tag("SliderThumb").x = this._getSliderPosition(this._progress);
                }
            }
        },
        {
            key: "_getSliderPosition",
            value: function _getSliderPosition(progress) {
                return this._barOffset + progress * this._barWidth;
            }
        },
        {
            key: "_setSeekTime",
            value: function _setSeekTime(time) {
                var shouldAnimate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                var progress = Math.min(time / this._duration, 1);
                var sliderThumbPosition = this._getSliderPosition(progress);
                this._updateStoryboard(progress, shouldAnimate);
                if (shouldAnimate) {
                    this.tag("SliderThumb").setSmooth("x", sliderThumbPosition, _progressBarstyle.SLIDER_THUMB_TRANSITION);
                    this.tag("Bar").setSmooth("progress", progress, _progressBarstyle.SLIDER_THUMB_TRANSITION);
                } else {
                    this.tag("SliderThumb").x = sliderThumbPosition;
                    this.tag("Bar").progress = progress;
                }
                this.tag("Elapsed").text.text = (0, _utils.getTimeFormat)(time);
            }
        },
        {
            key: "_updateStoryboard",
            value: function _updateStoryboard(progress, shouldAnimate) {
                if (this.withStoryboard) {
                    var storyboard = this.tag("Storyboard");
                    var storyboardPosition = this._getStoryboardPosition(progress);
                    var framePosition = (0, _storyboardutils.safeStoryboardValue)(Math.max(1, Math.floor(_storyboardconstants.FRAMES_COUNT * progress) * _storyboardconstants.FRAME_W));
                    storyboard.updateView(framePosition);
                    if (shouldAnimate && storyboard.isVisible) {
                        storyboard.setSmooth("x", storyboardPosition, _progressBarstyle.SLIDER_THUMB_TRANSITION);
                        return;
                    }
                    storyboard.x = storyboardPosition;
                }
            }
        },
        {
            key: "_getStoryboardPosition",
            value: function _getStoryboardPosition(progress) {
                var sliderThumbPosition = this._getSliderPosition(progress);
                var storyboardCenter = Math.round(_storyboardstyle.STORYBOARD_WIDTH / 2);
                var endPoint = this._barWidth + this._barOffset;
                if (endPoint < sliderThumbPosition + storyboardCenter) {
                    return endPoint - _storyboardstyle.STORYBOARD_WIDTH;
                }
                if (sliderThumbPosition > storyboardCenter + this._barOffset) {
                    return sliderThumbPosition - storyboardCenter;
                }
                return this._barOffset;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                // TODO: move all the constants into the progressBar.style.js file
                return (0, _merge.default)({
                    Elapsed: {},
                    Bar: {
                        type: _seekBarcomponent.SeekBar
                    },
                    Ads: {},
                    SliderThumb: {
                        type: _sliderThumbcomponent.SliderThumb
                    },
                    Duration: {},
                    Storyboard: {
                        type: _storyboardcomponent.default
                    }
                }, (0, _progressBarstyle.getInitialStyle)());
            }
        }
    ]);
    return ProgressBar;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 65163:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(88801);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _featuresselectors = __webpack_require__(76109);
var _liveselectors = __webpack_require__(81586);
var _playerselectors = __webpack_require__(83318);
var mapControllers = function(instance) {
    return [
        {
            selector: _playerselectors.getIsLive,
            shouldBeInvokedOnConnect: true,
            callback: function(value) {
                instance.isLive = value;
            }
        },
        {
            selector: _playerselectors.getDurationInSeconds,
            shouldBeInvokedOnConnect: true,
            callback: function(value) {
                instance.duration = value;
            }
        },
        {
            selector: _playerselectors.getElapsedTimeInSeconds,
            shouldBeInvokedOnConnect: true,
            callback: function(value) {
                instance.elapsed = value;
            }
        },
        {
            selector: _liveselectors.getLiveEdgeInSeconds,
            shouldBeInvokedOnConnect: true,
            callback: function(value) {
                instance.playHead = value;
            }
        },
        {
            selector: _featuresselectors.getStoryboardFeature,
            shouldBeInvokedOnConnect: true,
            callback: function(value) {
                instance.storyboard = value;
            }
        },
        {
            selector: _featuresselectors.getPlayerLongSeekFeature,
            shouldBeInvokedOnConnect: true,
            callback: function(value) {
                instance.longSeekEnabled = value;
            }
        },
        {
            selector: _playerselectors.getAdMarkers,
            shouldBeInvokedOnConnect: true,
            callback: function(value) {
                instance.adMarkers = value;
            }
        }
    ];
};
var _default = _lightningjsredux.default.control(mapControllers);


/***/ }),

/***/ 88227:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    PAUSE_ON_LONG_SEEK: function() {
        return PAUSE_ON_LONG_SEEK;
    },
    PAUSE_SIGNAL: function() {
        return PAUSE_SIGNAL;
    },
    SEEK_SIGNAL: function() {
        return SEEK_SIGNAL;
    },
    TIME_ASIDE: function() {
        return TIME_ASIDE;
    },
    TIME_BELOW: function() {
        return TIME_BELOW;
    },
    TIME_HIDDEN: function() {
        return TIME_HIDDEN;
    }
});
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(65759);
var SEEK_SIGNAL = "seek";
var PAUSE_SIGNAL = "pause";
var TIME_ASIDE = "aside";
var TIME_BELOW = "below";
var TIME_HIDDEN = "hidden";
var PAUSE_ON_LONG_SEEK = false;


/***/ }),

/***/ 95361:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    AD_MARKER_BORDER_RADIUS: function() {
        return AD_MARKER_BORDER_RADIUS;
    },
    AD_MARKER_HEIGHT: function() {
        return AD_MARKER_HEIGHT;
    },
    AD_MARKER_WIDTH: function() {
        return AD_MARKER_WIDTH;
    },
    BAR_HEIGHT_FOCUSED: function() {
        return BAR_HEIGHT_FOCUSED;
    },
    BAR_HEIGHT_UNFOCUSED: function() {
        return BAR_HEIGHT_UNFOCUSED;
    },
    HEIGHT: function() {
        return HEIGHT;
    },
    LABEL_OFFSET: function() {
        return LABEL_OFFSET;
    },
    SLIDER_THUMB_TRANSITION: function() {
        return SLIDER_THUMB_TRANSITION;
    },
    STORYBOARD_OFFSET_BOTTOM: function() {
        return STORYBOARD_OFFSET_BOTTOM;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getFocusedStyle: function() {
        return getFocusedStyle;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    getTimeLabelsFont: function() {
        return getTimeLabelsFont;
    },
    getUnFocusedStyle: function() {
        return getUnFocusedStyle;
    },
    makeAdMarkerStyle: function() {
        return makeAdMarkerStyle;
    },
    makeTextStyle: function() {
        return makeTextStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
var _memoize = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34736));
var _sdk = __webpack_require__(29956);
var _constants = __webpack_require__(34952);
var _typography = __webpack_require__(18411);
var _theme = __webpack_require__(51397);
var _sizes = __webpack_require__(82699);
var _style = __webpack_require__(65082);
var _storyboardstyle = __webpack_require__(7847);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var HEIGHT = (_obj = {}, _define_property._(_obj, _constants.HD, 30), _define_property._(_obj, _constants.FULL_HD, 36), _obj);
var _obj1;
var LABEL_OFFSET = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 16), _define_property._(_obj1, _constants.FULL_HD, 24), _obj1);
var _obj2;
var BAR_HEIGHT_UNFOCUSED = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 8), _define_property._(_obj2, _constants.FULL_HD, 8), _obj2);
var _obj3;
var BAR_HEIGHT_FOCUSED = (_obj3 = {}, _define_property._(_obj3, _constants.HD, 12), _define_property._(_obj3, _constants.FULL_HD, 12), _obj3);
var _obj4;
var STORYBOARD_OFFSET_BOTTOM = (_obj4 = {}, _define_property._(_obj4, _constants.HD, 32), _define_property._(_obj4, _constants.FULL_HD, 40), _obj4);
var colors = {
    text: (0, _theme.makeThemeColor)(_theme.PRIMARY),
    adMarker: (0, _theme.makeThemeColor)(_theme.PRIMARY)
};
var AD_MARKER_HEIGHT = 12;
var AD_MARKER_WIDTH = 6;
var AD_MARKER_BORDER_RADIUS = 2;
var SLIDER_THUMB_TRANSITION = {
    duration: 0.3,
    timingFunction: "linear"
};
var getTimeLabelsFont = function(screenSize) {
    return (0, _typography.getFont)(_typography.FONT.BERLIN_1, screenSize);
};
var makeTextStyle = function(param) {
    var screenSize = param.screenSize, colorMode = param.colorMode;
    return {
        color: colors.text[colorMode],
        mountY: 0.5,
        y: _sizes.middle,
        text: _object_spread_props._(_object_spread._({}, getTimeLabelsFont(screenSize)), {
            verticalAlign: "middle"
        })
    };
};
var makeAdMarkerStyle = function(param) {
    var colorMode = param.colorMode;
    return {
        rect: true,
        w: AD_MARKER_WIDTH,
        h: AD_MARKER_HEIGHT,
        color: colors.adMarker[colorMode],
        shader: {
            type: _sdk.Lightning.shaders.RoundedRectangle,
            radius: AD_MARKER_BORDER_RADIUS
        }
    };
};
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var screenSize = context.screenSize;
    var elapsedStyle = makeTextStyle(context);
    elapsedStyle.text.textAlign = "right";
    return {
        Elapsed: elapsedStyle,
        Bar: {
            mountY: 0.5,
            x: LABEL_OFFSET[screenSize],
            y: _sizes.middle,
            h: BAR_HEIGHT_UNFOCUSED[screenSize]
        },
        Ads: {
            h: AD_MARKER_HEIGHT
        },
        Duration: _object_spread_props._(_object_spread._({}, makeTextStyle(context)), {
            x: _sizes.identity,
            mountX: 1
        }),
        SliderThumb: {
            y: _sizes.middle,
            mount: 0.5,
            scale: 0
        },
        Storyboard: {
            y: -_storyboardstyle.STORYBOARD_HEIGHT - STORYBOARD_OFFSET_BOTTOM[screenSize]
        }
    };
};
var getUnFocusedStyle = (0, _memoize.default)(function(screenSize) {
    return {
        Bar: {
            smooth: {
                h: BAR_HEIGHT_UNFOCUSED[screenSize]
            }
        },
        SliderThumb: {
            smooth: {
                scale: 0
            }
        }
    };
});
var getFocusedStyle = (0, _memoize.default)(function(screenSize) {
    return {
        Bar: {
            smooth: {
                h: BAR_HEIGHT_FOCUSED[screenSize]
            }
        },
        SliderThumb: {
            smooth: {
                scale: 1
            }
        }
    };
});


/***/ }),

/***/ 12315:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "SeekBar", ({
    enumerable: true,
    get: function() {
        return SeekBar;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _seekBarstyle = __webpack_require__(16846);
var SeekBar = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(SeekBar, _Lightning_Component);
    var _super = _create_super._(SeekBar);
    function SeekBar() {
        _class_call_check._(this, SeekBar);
        return _super.apply(this, arguments);
    }
    _create_class._(SeekBar, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _seekBarstyle.defaultContext;
            }
        },
        {
            key: "_build",
            value: function _build() {
                this.progress = 0;
                this.playHead = 0;
            }
        },
        {
            key: "playHead",
            get: function get() {
                return this._playHead;
            },
            set: function set(value) {
                this._playHead = value;
                this.tag("PlayHeadBar").scaleX = value;
                this.tag("PlayHeadBarOverlay").scaleX = value;
            }
        },
        {
            key: "isLive",
            set: function set(value) {
                this.tag("ProgressBar").color = value ? _seekBarstyle.colors.live[this._style.colorMode] : _seekBarstyle.colors.progress[this._style.colorMode];
            }
        },
        {
            key: "progress",
            get: function get() {
                return this._progress;
            },
            set: function set(value) {
                this._progress = value;
                this.tag("ProgressBar").scaleX = value;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    rect: true,
                    PlayHeadBar: {
                        rect: true
                    },
                    PlayHeadBarOverlay: {
                        rect: true
                    },
                    ProgressBar: {
                        rect: true
                    }
                }, (0, _seekBarstyle.getInitialStyle)());
            }
        }
    ]);
    return SeekBar;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 16846:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(88801);
var _theme = __webpack_require__(51397);
var _sizes = __webpack_require__(82699);
var _style = __webpack_require__(65082);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var colors = {
    background: (0, _theme.makeThemeColor)(_theme.PRIMARY, 0.3),
    progress: (0, _theme.makeThemeColor)(_theme.SECONDARY),
    live: (0, _theme.makeThemeColor)(_theme.LIVE),
    darkLive: (0, _theme.makeThemeColor)(_theme.TERTIARY, 0.6)
};
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    return {
        color: colors.background[context.colorMode],
        PlayHeadBar: {
            h: _sizes.identity,
            w: _sizes.identity,
            pivotX: 0,
            color: colors.live[context.colorMode]
        },
        PlayHeadBarOverlay: {
            h: _sizes.identity,
            w: _sizes.identity,
            pivotX: 0,
            color: colors.darkLive[context.colorMode]
        },
        ProgressBar: {
            h: _sizes.identity,
            w: _sizes.identity,
            pivotX: 0
        }
    };
};


/***/ }),

/***/ 38487:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "BIG_FRAME_W", ({
    enumerable: true,
    get: function() {
        return BIG_FRAME_W;
    }
}));
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(45538);
var BIG_FRAME_W = 4000;


/***/ }),

/***/ 74290:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return Storyboard;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(37815);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _debounce = /*#__PURE__*/ _interop_require_default._(__webpack_require__(66292));
var _sdk = __webpack_require__(29956);
var _storyboardstyle = __webpack_require__(7847);
var _storyboardconstants = __webpack_require__(24773);
var _storyboardutils = __webpack_require__(49429);
var Storyboard = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(Storyboard, _Lightning_Component);
    var _super = _create_super._(Storyboard);
    function Storyboard() {
        _class_call_check._(this, Storyboard);
        return _super.apply(this, arguments);
    }
    _create_class._(Storyboard, [
        {
            key: "_construct",
            value: function _construct() {
                var _this = this;
                this._frames = null;
                this._image = null;
                this._currentImage = null;
                this._style = _storyboardstyle.defaultContext;
                this._innerFramePosition = 0;
                this._startAutoHide = (0, _debounce.default)(function() {
                    _this.setSmooth("alpha", 0, _storyboardstyle.VISIBILITY_TRANSITION);
                }, _storyboardconstants.STORYBOARD_DISPLAY_DURATION);
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                this._startAutoHide.cancel();
                this._frames = null;
                this._image = null;
                this._currentImage = null;
            }
        },
        {
            key: "_setVisible",
            value: function _setVisible() {
                this._startAutoHide();
                this.setSmooth("alpha", 1, _storyboardstyle.VISIBILITY_TRANSITION);
            }
        },
        {
            key: "_moveTexture",
            value: function _moveTexture(shift) {
                this.texture.enableClipping(shift, _storyboardconstants.FRAME_Y, _storyboardconstants.FRAME_W, _storyboardconstants.FRAME_H);
                this._setVisible();
            }
        },
        {
            key: "_findFrameAndPosition",
            value: function _findFrameAndPosition(position) {
                this._image = this._frames[Math.floor(position / _storyboardconstants.BIG_FRAME_W)];
                this._innerFramePosition = position % _storyboardconstants.BIG_FRAME_W;
            }
        },
        {
            key: "imageId",
            set: function set(id) {
                if (id) {
                    this._frames = (0, _storyboardutils.getStoryboardGroupedFrames)(id);
                }
            }
        },
        {
            key: "isVisible",
            get: function get() {
                return this.alpha === 1;
            }
        },
        {
            key: "updateView",
            value: function updateView(seekPosition) {
                if (this._frames && this._frames.length > 0) {
                    this._findFrameAndPosition(seekPosition);
                    if (!this._currentImage || this._currentImage !== this._image) {
                        this._currentImage = this._image;
                        this.patch({
                            src: this._image
                        });
                        this._moveTexture(this._innerFramePosition);
                        return;
                    }
                    this._moveTexture(this._innerFramePosition);
                }
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Border: {
                        type: _sdk.Lightning.components.BorderComponent
                    }
                }, (0, _storyboardstyle.getInitialStyle)());
            }
        }
    ]);
    return Storyboard;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 24773:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    FRAMES_COUNT: function() {
        return FRAMES_COUNT;
    },
    FRAME_H: function() {
        return FRAME_H;
    },
    FRAME_W: function() {
        return FRAME_W;
    },
    FRAME_Y: function() {
        return FRAME_Y;
    },
    ORIGIN_IMAGE_W: function() {
        return ORIGIN_IMAGE_W;
    },
    STORYBOARD_DISPLAY_DURATION: function() {
        return STORYBOARD_DISPLAY_DURATION;
    }
});
var _export_star = __webpack_require__(37668);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(45538);
_export_star._(__webpack_require__(38487), exports);
var STORYBOARD_DISPLAY_DURATION = 3000;
var ORIGIN_IMAGE_W = 60000;
var FRAME_Y = 0;
var FRAME_W = 200;
var FRAME_H = 112;
var FRAMES_COUNT = 300;


/***/ }),

/***/ 7847:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BORDER_COLOR: function() {
        return BORDER_COLOR;
    },
    BORDER_WIDTH: function() {
        return BORDER_WIDTH;
    },
    STORYBOARD_HEIGHT: function() {
        return STORYBOARD_HEIGHT;
    },
    STORYBOARD_WIDTH: function() {
        return STORYBOARD_WIDTH;
    },
    VISIBILITY_TRANSITION: function() {
        return VISIBILITY_TRANSITION;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
var _define_property = __webpack_require__(21228);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(52318);
var _theme = __webpack_require__(51397);
var _sizes = __webpack_require__(82699);
var _style = __webpack_require__(65082);
var _obj;
var BORDER_COLOR = (_obj = {}, _define_property._(_obj, _theme.DARK_MODE, (0, _theme.getDarkColor)(_theme.PRIMARY)), _define_property._(_obj, _theme.LIGHT_MODE, (0, _theme.getLightColor)(_theme.SECONDARY)), _obj);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var VISIBILITY_TRANSITION = {
    duration: 0.3
};
var STORYBOARD_WIDTH = 200;
var STORYBOARD_HEIGHT = 112;
var BORDER_WIDTH = 2;
var colors = {
    border: BORDER_COLOR
};
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var colorMode = context.colorMode;
    return {
        alpha: 0,
        w: STORYBOARD_WIDTH,
        h: STORYBOARD_HEIGHT,
        Border: {
            borderWidth: BORDER_WIDTH,
            colorBorder: colors.border[colorMode],
            w: _sizes.identity,
            h: _sizes.identity
        }
    };
};


/***/ }),

/***/ 49429:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    getStoryboardGroupedFrames: function() {
        return getStoryboardGroupedFrames;
    },
    getStoryboardUrl: function() {
        return getStoryboardUrl;
    },
    safeStoryboardValue: function() {
        return safeStoryboardValue;
    }
});
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(88801);
var _clamp = /*#__PURE__*/ _interop_require_default._(__webpack_require__(35636));
var _constants = __webpack_require__(34952);
var _fidosdk = __webpack_require__(19804);
var _storyboardconstants = __webpack_require__(24773);
var safeStoryboardValue = function(value) {
    return (0, _clamp.default)(value, 0, _storyboardconstants.ORIGIN_IMAGE_W - _storyboardconstants.FRAME_W);
};
var getStoryboardUrl = function(imageId, shift, width) {
    var params = {
        fit: _constants.IMAGE_FIT_CROP,
        quality: _constants.IMAGE_QUALITY,
        format: _constants.DEFAULT_IMAGE_FORMAT,
        crop: "".concat(shift, ",1")
    };
    var url = _fidosdk.imageService.getUrl(imageId, width, _storyboardconstants.FRAME_H, params);
    return url;
};
var getStoryboardGroupedFrames = function(imageId) {
    var framesList = [];
    var steps = _storyboardconstants.ORIGIN_IMAGE_W / _storyboardconstants.BIG_FRAME_W;
    for(var i = 0; i < steps; i += 1){
        var shift = i * _storyboardconstants.BIG_FRAME_W || 1;
        var image = getStoryboardUrl(imageId, shift, _storyboardconstants.BIG_FRAME_W);
        framesList.push(image);
    }
    return framesList;
};


/***/ }),

/***/ 23069:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "SideGlass", ({
    enumerable: true,
    get: function() {
        return SideGlass;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _create_super = __webpack_require__(6400);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(88801);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _sdk = __webpack_require__(29956);
var _theme = __webpack_require__(74314);
var _signals = __webpack_require__(2109);
var _analyticsutils = __webpack_require__(2693);
var _ctautils = __webpack_require__(42533);
var _sideGlassstyle = __webpack_require__(9781);
var _sideGlassconstants = __webpack_require__(6728);
var _sideGlassconnector = /*#__PURE__*/ _interop_require_default._(__webpack_require__(83453));
var SideGlass = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(SideGlass, _Lightning_Component);
    var _super = _create_super._(SideGlass);
    function SideGlass() {
        _class_call_check._(this, SideGlass);
        return _super.apply(this, arguments);
    }
    _create_class._(SideGlass, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _sideGlassstyle.defaultContext;
                this._index = 0;
                this._maxIndex = 0;
                this._focused = null;
                this._isLiveSideGlass = false;
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                this._focused = null;
                if (this._unsubscribe) {
                    this._unsubscribe();
                }
            }
        },
        {
            key: "_active",
            value: function _active() {
                if (!this._unsubscribe) {
                    this._unsubscribe = (0, _sideGlassconnector.default)(this);
                }
            }
        },
        {
            key: "data",
            set: function set(value) {
                var _this = this;
                if (!value) {
                    return;
                }
                var itemTemplate = (0, _get.default)(value, "content.contentTemplateId");
                var template = _sideGlassconstants.TEMPLATES[itemTemplate];
                if (!template) {
                    itemTemplate = Object.keys(_sideGlassconstants.TEMPLATES)[0];
                    template = _sideGlassconstants.TEMPLATES[itemTemplate];
                }
                var screenSize = this._style.screenSize;
                var block = (0, _get.default)(value, "content.items", []);
                var itemSize = _object_spread_props._(_object_spread._({}, template.Sizes[itemTemplate][this._style.screenSize]), {
                    w: (0, _sideGlassstyle.getContentWidth)(itemTemplate, screenSize)
                });
                var blockTheme = (0, _theme.getLayoutTheme)((0, _get.default)(value, "theme"));
                var paddingTop = _sideGlassstyle.PADDING_TOP[screenSize];
                var paddingBottom = _sideGlassstyle.PADDING_BOTTOM[screenSize];
                var contentGap = _sideGlassstyle.CONTENT_GAP[screenSize];
                var panelHeight = _sideGlassstyle.HEIGHT[screenSize];
                var halfOfScreenHeight = Math.round(panelHeight / 2);
                var halfOfItemHeight = Math.round(itemSize.h / 2);
                var children = [];
                this._positions = [];
                this._maxIndex = block.length - 1;
                var offset = 0;
                var topOffset = paddingTop;
                var bottomOffset = panelHeight - block.length * itemSize.h - this._maxIndex * contentGap - paddingBottom;
                block.forEach(function(content, index) {
                    var y = index * (itemSize.h + contentGap);
                    children.push(_object_spread_props._(_object_spread._({}, itemSize), {
                        type: template,
                        y: y,
                        item: {
                            content: content,
                            config: itemSize,
                            template: itemTemplate,
                            colorScheme: blockTheme.colorScheme,
                            sideGlass: true
                        },
                        signals: _define_property._({}, _signals.SELECTED_SIGNAL, "_handleSelected")
                    }));
                    _this._positions.push(Math.min(Math.max(halfOfScreenHeight - offset - halfOfItemHeight, bottomOffset), topOffset));
                    offset += itemSize.h + contentGap;
                });
                this.tag("Container").children = children;
                this.index = 0;
                this._refocus();
            }
        },
        {
            key: "index",
            get: function get() {
                return this._index;
            },
            set: function set(value) {
                this._index = value;
                var container = this.tag("Container");
                var child = container.children[this._index];
                // NOTE: in case if items could overlap, it's necessary to raise a focused item's z-index so it will be render "on top"
                if (_sideGlassstyle.Z_INDEX_FOCUSED !== _sideGlassstyle.Z_INDEX_UNFOCUSED) {
                    if (this._focused) {
                        this._focused.zIndex = _sideGlassstyle.Z_INDEX_UNFOCUSED;
                    }
                    child.zIndex = _sideGlassstyle.Z_INDEX_FOCUSED;
                }
                container.setSmooth("y", this._positions[this._index]);
                this._focused = child;
            }
        },
        {
            key: "isLiveSideGlass",
            get: function get() {
                return this._isLiveSideGlass;
            },
            set: function set(sideGlassFlag) {
                this._isLiveSideGlass = sideGlassFlag;
            }
        },
        {
            key: "_handleSelected",
            value: function _handleSelected(item) {
                var id = (0, _ctautils.getTargetData)(item).id;
                (0, _analyticsutils.sendEvent)({
                    key: "navigationPanelReplay",
                    clipId: id
                });
                this.signal(_signals.SELECTED_SIGNAL, item);
            }
        },
        {
            key: "_unfocus",
            value: function _unfocus() {
                this.patch((0, _sideGlassstyle.getUnFocusedStyle)(this._style.screenSize));
            }
        },
        {
            key: "_focus",
            value: function _focus() {
                this.patch((0, _sideGlassstyle.getFocusedStyle)(this._style.screenSize));
            }
        },
        {
            key: "_getFocused",
            value: function _getFocused() {
                return this.tag("Container").children[this._index];
            }
        },
        {
            key: "_handleUp",
            value: function _handleUp() {
                if (this._index > 0) {
                    this.index -= 1;
                }
                return true;
            }
        },
        {
            key: "_handleDown",
            value: function _handleDown() {
                if (this._index < this._maxIndex) {
                    this.index += 1;
                }
                return true;
            }
        },
        {
            key: "_fireCloseSignal",
            value: function _fireCloseSignal() {
                this.signal(_sideGlassconstants.CLOSE_SIGNAL);
                return true;
            }
        },
        {
            key: "_handleBack",
            value: function _handleBack() {
                return this._fireCloseSignal();
            }
        },
        {
            key: "_handleLeft",
            value: function _handleLeft() {
                return this._fireCloseSignal();
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    rect: true,
                    BackgroundOverlay: {
                        rect: true
                    },
                    Container: {}
                }, (0, _sideGlassstyle.getInitialStyle)());
            }
        }
    ]);
    return SideGlass;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 83453:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(65759);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _playerselectors = __webpack_require__(83318);
var mapControllers = function(instance) {
    return [
        {
            shouldBeInvokedOnConnect: true,
            selector: _playerselectors.getSideGlassContent,
            callback: function(value) {
                instance.data = value;
            }
        }
    ];
};
var _default = _lightningjsredux.default.control(mapControllers);


/***/ }),

/***/ 6728:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    CLOSE_SIGNAL: function() {
        return CLOSE_SIGNAL;
    },
    TEMPLATES: function() {
        return TEMPLATES;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(65759);
var _horizontalCardcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(16348));
var _horizontalSquarecomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(73876));
var CLOSE_SIGNAL = "close";
var _obj;
var TEMPLATES = (_obj = {}, _define_property._(_obj, _horizontalCardcomponent.default.Templates.HorizontalCard, _horizontalCardcomponent.default), _define_property._(_obj, _horizontalSquarecomponent.default.Templates.HorizontalSquare, _horizontalSquarecomponent.default), _obj);


/***/ }),

/***/ 9781:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    CONTENT_GAP: function() {
        return CONTENT_GAP;
    },
    HEIGHT: function() {
        return HEIGHT;
    },
    PADDINGS: function() {
        return PADDINGS;
    },
    PADDING_BOTTOM: function() {
        return PADDING_BOTTOM;
    },
    PADDING_LEFT: function() {
        return PADDING_LEFT;
    },
    PADDING_TOP: function() {
        return PADDING_TOP;
    },
    WIDTH: function() {
        return WIDTH;
    },
    Z_INDEX_FOCUSED: function() {
        return Z_INDEX_FOCUSED;
    },
    Z_INDEX_UNFOCUSED: function() {
        return Z_INDEX_UNFOCUSED;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getContentWidth: function() {
        return getContentWidth;
    },
    getFocusedStyle: function() {
        return getFocusedStyle;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    getUnFocusedStyle: function() {
        return getUnFocusedStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(3009);
var _memoize = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34736));
var _constants = __webpack_require__(34952);
var _theme = __webpack_require__(51397);
var _style = __webpack_require__(65082);
var _sizes = __webpack_require__(82699);
var _horizontalCardcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(16348));
var _horizontalSquarecomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(73876));
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var WIDTH = (_obj = {}, _define_property._(_obj, _constants.HD, 640), _define_property._(_obj, _constants.FULL_HD, 960), _obj);
var HEIGHT = _object_spread._({}, _sizes.SCREEN_HEIGHT);
var _obj1;
var PADDING_LEFT = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 40), _define_property._(_obj1, _constants.FULL_HD, 40), _obj1);
var _obj2;
var PADDING_TOP = (_obj2 = {}, _define_property._(_obj2, _constants.HD, _constants.safetyMargins.vertical[_constants.HD]), _define_property._(_obj2, _constants.FULL_HD, _constants.safetyMargins.vertical[_constants.FULL_HD]), _obj2);
var _obj3;
var PADDING_BOTTOM = (_obj3 = {}, _define_property._(_obj3, _constants.HD, _constants.safetyMargins.vertical[_constants.HD]), _define_property._(_obj3, _constants.FULL_HD, _constants.safetyMargins.vertical[_constants.FULL_HD]), _obj3);
var _obj4;
var CONTENT_GAP = (_obj4 = {}, _define_property._(_obj4, _constants.HD, 16), _define_property._(_obj4, _constants.FULL_HD, 16), _obj4);
var _obj5, _obj6;
var PADDINGS = (_obj6 = {}, _define_property._(_obj6, _horizontalCardcomponent.default.Templates.HorizontalCard, (_obj5 = {}, _define_property._(_obj5, _constants.HD, 0), _define_property._(_obj5, _constants.FULL_HD, 0), _obj5)), _define_property._(_obj6, _horizontalSquarecomponent.default.Templates.HorizontalSquare, PADDING_LEFT), _obj6);
var Z_INDEX_FOCUSED = 1;
var Z_INDEX_UNFOCUSED = 1;
var colors = {
    background: (0, _theme.makeThemeColor)(_theme.TERTIARY),
    backgroundOverlay: (0, _theme.makeThemeColor)(_theme.PRIMARY, 0.1)
};
var getContentWidth = function(itemTemplate, screenSize) {
    return WIDTH[screenSize] - PADDING_LEFT[screenSize] - (PADDINGS[itemTemplate] ? PADDINGS[itemTemplate][screenSize] : 0);
};
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var screenSize = context.screenSize, colorMode = context.colorMode;
    return {
        visible: false,
        x: _sizes.SCREEN_WIDTH[screenSize],
        w: WIDTH[screenSize],
        h: HEIGHT[screenSize],
        color: colors.background[colorMode],
        BackgroundOverlay: {
            color: colors.backgroundOverlay[colorMode],
            w: WIDTH[screenSize],
            h: HEIGHT[screenSize]
        },
        Container: {
            x: PADDING_LEFT[screenSize],
            y: PADDING_TOP[screenSize]
        }
    };
};
var getFocusedStyle = (0, _memoize.default)(function(screenSize) {
    return {
        visible: true,
        smooth: {
            x: _sizes.SCREEN_WIDTH[screenSize] - WIDTH[screenSize]
        }
    };
});
var getUnFocusedStyle = (0, _memoize.default)(function(screenSize) {
    return {
        smooth: {
            x: _sizes.SCREEN_WIDTH[screenSize]
        }
    };
});


/***/ }),

/***/ 5370:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "SliderThumb", ({
    enumerable: true,
    get: function() {
        return SliderThumb;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _create_super = __webpack_require__(6400);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(52318);
var _sdk = __webpack_require__(29956);
var _sliderThumbstyle = __webpack_require__(44299);
var SliderThumb = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(SliderThumb, _Lightning_Component);
    var _super = _create_super._(SliderThumb);
    function SliderThumb() {
        _class_call_check._(this, SliderThumb);
        return _super.apply(this, arguments);
    }
    _create_class._(SliderThumb, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _sliderThumbstyle.defaultContext;
            }
        },
        {
            key: "colorMode",
            get: function get() {
                return this._style.colorMode;
            },
            set: function set(value) {
                this._style = _object_spread_props._(_object_spread._({}, this._style), {
                    colorMode: value
                });
                this.patch((0, _sliderThumbstyle.getInitialStyle)(this._style));
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return _object_spread._({
                    rect: true
                }, (0, _sliderThumbstyle.getInitialStyle)());
            }
        }
    ]);
    return SliderThumb;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 44299:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DIAMETER: function() {
        return DIAMETER;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
var _define_property = __webpack_require__(21228);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(52318);
var _sdk = __webpack_require__(29956);
var _constants = __webpack_require__(34952);
var _theme = __webpack_require__(51397);
var _style = __webpack_require__(65082);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var colors = {
    handle: (0, _theme.makeThemeColor)(_theme.PRIMARY)
};
var _obj;
var DIAMETER = (_obj = {}, _define_property._(_obj, _constants.HD, 22), _define_property._(_obj, _constants.FULL_HD, 30), _obj);
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var screenSize = context.screenSize, colorMode = context.colorMode;
    var size = DIAMETER[screenSize];
    return {
        color: colors.handle[colorMode],
        texture: _sdk.Lightning.Tools.getRoundRect(size, size, Math.round(size / 2), 0, 0x00000000, true, colors.handle[colorMode])
    };
};


/***/ }),

/***/ 13563:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "TopBarItem", ({
    enumerable: true,
    get: function() {
        return TopBarItem;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(37815);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _icons = __webpack_require__(20360);
var _iconcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(70160));
var _topBarItemstyle = __webpack_require__(42859);
var TopBarItem = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(TopBarItem, _Lightning_Component);
    var _super = _create_super._(TopBarItem);
    function TopBarItem() {
        _class_call_check._(this, TopBarItem);
        return _super.apply(this, arguments);
    }
    _create_class._(TopBarItem, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _topBarItemstyle.defaultContext;
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                this.tag("Label").removeAllListeners("txLoaded");
            }
        },
        {
            key: "data",
            set: function set(value) {
                var _this = this;
                var text = value.text, icon = value.icon;
                var screenSize = this._style.screenSize;
                this.tag("Label").once("txLoaded", function() {
                    _this.tag("Background").w = _topBarItemstyle.HEIGHT[screenSize] + _topBarItemstyle.ICON_MARGIN_RIGHT[screenSize] + _this.tag("Label").finalW + _topBarItemstyle.SPACER_END[screenSize];
                });
                this.patch({
                    IconWrapper: {
                        Icon: {
                            iconData: {
                                viewBox: {
                                    h: _topBarItemstyle.ICON_SIZE[this._style.screenSize]
                                },
                                picto: {
                                    name: icon,
                                    collection: _icons.ICON_COLLECTION.SPECIAL
                                }
                            }
                        }
                    },
                    Label: {
                        text: {
                            text: text
                        }
                    }
                });
            }
        },
        {
            key: "_focus",
            value: function _focus() {
                this.patch((0, _topBarItemstyle.getFocusedStyle)(this._style));
            }
        },
        {
            key: "_unfocus",
            value: function _unfocus() {
                this.patch((0, _topBarItemstyle.getUnFocusedStyle)(this._style));
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Background: {
                        shader: {
                            type: _sdk.Lightning.shaders.RoundedRectangle
                        }
                    },
                    IconWrapper: {
                        IconBackground: {
                            shader: {
                                type: _sdk.Lightning.shaders.RoundedRectangle
                            }
                        },
                        Icon: {
                            type: _iconcomponent.default
                        }
                    },
                    Label: {}
                }, (0, _topBarItemstyle.getInitialStyle)());
            }
        }
    ]);
    return TopBarItem;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 42859:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    FOCUSED_ALPHA: function() {
        return FOCUSED_ALPHA;
    },
    HEIGHT: function() {
        return HEIGHT;
    },
    ICON_MARGIN_RIGHT: function() {
        return ICON_MARGIN_RIGHT;
    },
    ICON_SIZE: function() {
        return ICON_SIZE;
    },
    LABEL_UNFOCUSED_ALPHA: function() {
        return LABEL_UNFOCUSED_ALPHA;
    },
    SPACER_END: function() {
        return SPACER_END;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getFocusedStyle: function() {
        return getFocusedStyle;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    getUnFocusedStyle: function() {
        return getUnFocusedStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(37815);
var _memoize = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34736));
var _constants = __webpack_require__(34952);
var _theme = __webpack_require__(51397);
var _typography = __webpack_require__(18411);
var _style = __webpack_require__(65082);
var _sizes = __webpack_require__(82699);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var HEIGHT = (_obj = {}, _define_property._(_obj, _constants.HD, 48), _define_property._(_obj, _constants.FULL_HD, 72), _obj);
var _obj1;
var ICON_SIZE = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 32), _define_property._(_obj1, _constants.FULL_HD, 40), _obj1);
var _obj2;
var ICON_MARGIN_RIGHT = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 8), _define_property._(_obj2, _constants.FULL_HD, 16), _obj2);
var _obj3;
var SPACER_END = (_obj3 = {}, _define_property._(_obj3, _constants.HD, 32), _define_property._(_obj3, _constants.FULL_HD, 32), _obj3);
var LABEL_UNFOCUSED_ALPHA = 0;
var FOCUSED_ALPHA = 1;
var colors = {
    icon: (0, _theme.makeThemeColor)(_theme.PRIMARY),
    iconFocused: (0, _theme.makeThemeColor)(_theme.TERTIARY),
    iconBackground: (0, _theme.makeThemeColor)(_theme.TERTIARY, 0.3),
    iconBackgroundFocused: (0, _theme.makeThemeColor)(_theme.PRIMARY),
    text: (0, _theme.makeThemeColor)(_theme.PRIMARY),
    background: (0, _theme.makeThemeColor)(_theme.TERTIARY, 0.3),
    border: (0, _theme.makeThemeColor)(_theme.PRIMARY, 0.1)
};
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var screenSize = context.screenSize, colorMode = context.colorMode;
    var font = (0, _typography.getFont)(_typography.FONT.OTTAWA_2, screenSize);
    return {
        h: HEIGHT[screenSize],
        Background: {
            alpha: 0,
            rect: true,
            h: HEIGHT[screenSize],
            shader: {
                radius: Math.round(HEIGHT[screenSize] / 2),
                fillColor: colors.background[colorMode],
                strokeColor: colors.border[colorMode],
                stroke: 1.25
            }
        },
        IconWrapper: {
            w: HEIGHT[screenSize],
            h: HEIGHT[screenSize],
            IconBackground: {
                rect: true,
                w: HEIGHT[screenSize],
                h: HEIGHT[screenSize],
                shader: {
                    fillColor: colors.iconBackground[colorMode],
                    radius: Math.round(HEIGHT[screenSize] / 2)
                }
            },
            Icon: {
                color: colors.icon[colorMode],
                mount: 0.5,
                x: _sizes.middle,
                y: _sizes.middle
            }
        },
        Label: {
            x: HEIGHT[screenSize] + ICON_MARGIN_RIGHT[screenSize],
            alpha: LABEL_UNFOCUSED_ALPHA,
            mountY: 0.5,
            y: _sizes.middle,
            color: colors.text[colorMode],
            text: _object_spread_props._(_object_spread._({}, font), {
                verticalAlign: "middle"
            })
        }
    };
};
var getFocusedStyle = (0, _memoize.default)(function(param) {
    var colorMode = param.colorMode;
    return {
        Background: {
            smooth: {
                alpha: 1
            }
        },
        IconWrapper: {
            IconBackground: {
                smooth: {
                    "shader.fillColor": colors.iconBackgroundFocused[colorMode]
                }
            },
            Icon: {
                smooth: {
                    color: colors.iconFocused[colorMode]
                }
            }
        },
        Label: {
            smooth: {
                alpha: FOCUSED_ALPHA
            }
        }
    };
}, _style.cacheResolver);
var getUnFocusedStyle = (0, _memoize.default)(function(param) {
    var colorMode = param.colorMode;
    return {
        Background: {
            smooth: {
                alpha: 0
            }
        },
        IconWrapper: {
            IconBackground: {
                smooth: {
                    "shader.fillColor": colors.iconBackground[colorMode]
                }
            },
            Icon: {
                smooth: {
                    color: colors.icon[colorMode]
                }
            }
        },
        Label: {
            smooth: {
                alpha: LABEL_UNFOCUSED_ALPHA
            }
        }
    };
}, _style.cacheResolver);


/***/ }),

/***/ 5947:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "TopBar", ({
    enumerable: true,
    get: function() {
        return TopBar;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(45538);
var _sdk = __webpack_require__(29956);
var _signals = __webpack_require__(2109);
var _topBarItemcomponent = __webpack_require__(13563);
var _topBarstyle = __webpack_require__(99210);
var _topBarItemstyle = __webpack_require__(42859);
var TopBar = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(TopBar, _Lightning_Component);
    var _super = _create_super._(TopBar);
    function TopBar() {
        _class_call_check._(this, TopBar);
        return _super.apply(this, arguments);
    }
    _create_class._(TopBar, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _topBarstyle.defaultContext;
                this._index = 0;
                this._items = [];
            }
        },
        {
            key: "items",
            set: function set(value) {
                var _this = this;
                this._items = value;
                this._maxIndex = Math.max(this._items.length - 1, 0);
                var topBarItemHeight = _topBarItemstyle.HEIGHT[this._style.screenSize];
                var container = this.tag("Items");
                if (container.children.length === this._items.length) {
                    container.children.forEach(function(view, index) {
                        view.data = _this._items[index];
                    });
                    return;
                }
                container.children = this._items.map(function(data, index) {
                    return {
                        type: _topBarItemcomponent.TopBarItem,
                        data: data,
                        y: (topBarItemHeight + _topBarstyle.GAP[_this._style.screenSize]) * index
                    };
                });
                this._index = this._maxIndex;
                this._refocus();
            }
        },
        {
            key: "maxIndex",
            get: function get() {
                return this._maxIndex;
            }
        },
        {
            key: "index",
            get: function get() {
                return this._index;
            },
            set: function set(value) {
                this._index = value;
            }
        },
        {
            key: "_getFocused",
            value: function _getFocused() {
                return this.tag("Items").children[this._index];
            }
        },
        {
            key: "_handleEnter",
            value: function _handleEnter() {
                var item = this._items[this._index];
                if (item) {
                    this.signal(_signals.SELECTED_SIGNAL, item);
                    return true;
                }
                return false;
            }
        },
        {
            key: "_handleUp",
            value: function _handleUp() {
                if (this.index > 0) {
                    this.index -= 1;
                    return true;
                }
                return false;
            }
        },
        {
            key: "_handleDown",
            value: function _handleDown() {
                if (this.index < this._maxIndex) {
                    this.index += 1;
                    return true;
                }
                return false;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return {
                    Items: {}
                };
            }
        }
    ]);
    return TopBar;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 99210:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    GAP: function() {
        return GAP;
    },
    defaultContext: function() {
        return defaultContext;
    }
});
var _define_property = __webpack_require__(21228);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
var _constants = __webpack_require__(34952);
var _style = __webpack_require__(65082);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var GAP = (_obj = {}, _define_property._(_obj, _constants.HD, 8), _define_property._(_obj, _constants.FULL_HD, 16), _obj);


/***/ }),

/***/ 24779:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "getClosedCaptionsLabel", ({
    enumerable: true,
    get: function() {
        return getClosedCaptionsLabel;
    }
}));
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
var _i18n = __webpack_require__(14910);
var getClosedCaptionsLabel = function(label) {
    return "".concat(label, " (").concat((0, _i18n.t)("player.closedCaption"), ")");
};


/***/ }),

/***/ 5208:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "TrackItem", ({
    enumerable: true,
    get: function() {
        return TrackItem;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(37815);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _radiocomponent = __webpack_require__(25648);
var _trackItemstyle = __webpack_require__(53426);
var _radiostyle = __webpack_require__(27819);
var TrackItem = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(TrackItem, _Lightning_Component);
    var _super = _create_super._(TrackItem);
    function TrackItem() {
        _class_call_check._(this, TrackItem);
        return _super.apply(this, arguments);
    }
    _create_class._(TrackItem, [
        {
            key: "label",
            get: function get() {
                return this.tag("Radio").label;
            },
            set: function set(value) {
                var _this = this;
                var labelRect = this.tag("Radio").tag("Label");
                labelRect.on("txLoaded", function() {
                    _this.h = (0, _radiostyle.getFinalHeight)(labelRect.finalH);
                });
                this.tag("Radio").label = value;
            }
        },
        {
            key: "isSelected",
            get: function get() {
                return this.tag("Radio").isSelected;
            },
            set: function set(value) {
                this.tag("Radio").isSelected = value;
            }
        },
        {
            key: "_focus",
            value: function _focus() {
                this.patch(_trackItemstyle.focusedStyle);
            }
        },
        {
            key: "_unfocus",
            value: function _unfocus() {
                this.patch(_trackItemstyle.unFocusedStyle);
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Background: {
                        rect: true
                    },
                    Radio: {
                        type: _radiocomponent.Radio
                    }
                }, (0, _trackItemstyle.getInitialStyle)());
            }
        }
    ]);
    return TrackItem;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 53426:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    PADDING_LEFT: function() {
        return PADDING_LEFT;
    },
    TITLE_MARGIN_BOTTOM: function() {
        return TITLE_MARGIN_BOTTOM;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    focusedStyle: function() {
        return focusedStyle;
    },
    getInitialHeight: function() {
        return _radiostyle.getInitialHeight;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    unFocusedStyle: function() {
        return unFocusedStyle;
    }
});
var _define_property = __webpack_require__(21228);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(45538);
var _constants = __webpack_require__(34952);
var _theme = __webpack_require__(51397);
var _sizes = __webpack_require__(82699);
var _style = __webpack_require__(65082);
var _radiostyle = __webpack_require__(27819);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var TITLE_MARGIN_BOTTOM = (_obj = {}, _define_property._(_obj, _constants.HD, 12), _define_property._(_obj, _constants.FULL_HD, 16), _obj);
var _obj1;
var PADDING_LEFT = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 80), _define_property._(_obj1, _constants.FULL_HD, 104), _obj1);
var colors = {
    background: (0, _theme.makeThemeColor)(_theme.PRIMARY, 0.3)
};
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var screenSize = context.screenSize, colorMode = context.colorMode;
    return {
        h: (0, _radiostyle.getInitialHeight)(screenSize),
        Background: {
            w: _sizes.identity,
            h: _sizes.identity,
            color: colors.background[colorMode],
            alpha: 0
        },
        Radio: {
            x: PADDING_LEFT[screenSize]
        }
    };
};
var unFocusedStyle = {
    Background: {
        smooth: {
            alpha: 0
        }
    }
};
var focusedStyle = {
    Background: {
        smooth: {
            alpha: 1
        }
    }
};


/***/ }),

/***/ 92091:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "Tracks", ({
    enumerable: true,
    get: function() {
        return Tracks;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _mediaengine = __webpack_require__(88918);
var _i18n = __webpack_require__(14910);
var _signals = __webpack_require__(2109);
var _tracksPanelcomponent = __webpack_require__(77464);
var _tracksconnector = /*#__PURE__*/ _interop_require_default._(__webpack_require__(6468));
var _tracksconstants = __webpack_require__(75702);
var _tracksstyle = __webpack_require__(92592);
var _tracksutils = __webpack_require__(76793);
var _playerutils = __webpack_require__(41230);
var Tracks = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(Tracks, _Lightning_Component);
    var _super = _create_super._(Tracks);
    function Tracks() {
        _class_call_check._(this, Tracks);
        return _super.apply(this, arguments);
    }
    _create_class._(Tracks, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _tracksstyle.defaultContext;
                this._reset();
            }
        },
        {
            key: "_attach",
            value: function _attach() {
                this._unsubscribe = (0, _tracksconnector.default)(this);
                this._panels = [
                    this.tag("AudioTracks"),
                    this.tag("SubtitleTracks")
                ];
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                if (this._unsubscribe) {
                    this._unsubscribe();
                    this._unsubscribe = null;
                }
                this._reset();
            }
        },
        {
            key: "audioTracks",
            set: function set(value) {
                this._setPanelTracks(this.tag("AudioTracks"), (0, _tracksutils.formatAudioTracks)(value));
                this.tag("AudioTracks").setFocusToSelectedItem();
            }
        },
        {
            key: "subtitleTracks",
            set: function set(value) {
                var selectableSubtitles = (value || []).filter(function(track) {
                    return !(0, _playerutils.isForcedSubtitlesTrack)(track);
                });
                this._subtitles = (0, _tracksutils.formatSubtitlesTracks)(selectableSubtitles);
                this._setPanelTracks(this.tag("SubtitleTracks"), this._subtitles);
            }
        },
        {
            key: "selectedAudioTrack",
            set: function set(value) {
                this.tag("AudioTracks").highlightPreferredTrack(value);
            }
        },
        {
            key: "selectedSubtitlesTrack",
            set: function set(value) {
                var id = value || Number.isFinite(value) ? value : _mediaengine.DISABLED_SUBTITLES_ID;
                var track = this._subtitles && this._subtitles.find(function(param) {
                    var id = param.id;
                    return id;
                });
                this.tag("SubtitleTracks").highlightPreferredTrack(track ? id : null);
            }
        },
        {
            key: "_setPanelTracks",
            value: function _setPanelTracks(panel, tracks) {
                panel.visible = Boolean(tracks.length);
                panel.items = tracks;
                this._focused = this._panels.find(function(panel) {
                    return panel.visible;
                });
                this._refocus();
            }
        },
        {
            key: "_unfocus",
            value: function _unfocus() {
                this.patch((0, _tracksstyle.getUnFocusedStyle)(this._style.screenSize));
                // Ensure last selected audio track will be in focus by default
                this.tag("AudioTracks").setFocusToSelectedItem();
                // Ensure focus will move seamlessly to the Subtitles panel
                this.tag("SubtitleTracks").index = 0;
                // Drop focus to the top-most visible panel(usually it's Audio)
                this._focused = this._panels.find(function(panel) {
                    return panel.visible;
                });
            }
        },
        {
            key: "_focus",
            value: function _focus() {
                this.patch((0, _tracksstyle.getFocusedStyle)(this._style.screenSize));
            }
        },
        {
            key: "_fireCloseSignal",
            value: function _fireCloseSignal() {
                this.signal(_tracksconstants.CLOSE_SIGNAL);
                return true;
            }
        },
        {
            key: "_getFocused",
            value: function _getFocused() {
                return this._focused;
            }
        },
        {
            key: "_handleBack",
            value: function _handleBack() {
                return this._fireCloseSignal();
            }
        },
        {
            key: "_handleLeft",
            value: function _handleLeft() {
                return this._fireCloseSignal();
            }
        },
        {
            key: "_handleUp",
            value: function _handleUp() {
                var panel = this.tag("AudioTracks");
                if (panel.visible) {
                    this._focused = panel;
                }
                return true;
            }
        },
        {
            key: "_handleDown",
            value: function _handleDown() {
                var panel = this.tag("SubtitleTracks");
                if (panel.visible) {
                    this._focused = panel;
                }
                return true;
            }
        },
        {
            key: "_handleAudioTrackSelection",
            value: function _handleAudioTrackSelection(track) {
                this.signal(_tracksconstants.AUDIO_TRACK_SELECTED_SIGNAL, track && track.id || null);
            }
        },
        {
            key: "_handleSubtitlesTrackSelection",
            value: function _handleSubtitlesTrackSelection(track) {
                var id = track && track.id || null;
                this.signal(_tracksconstants.SUBTITLES_TRACK_SELECTED_SIGNAL, id === _mediaengine.DISABLED_SUBTITLES_ID ? null : id);
            }
        },
        {
            key: "_reset",
            value: function _reset() {
                this._focused = null;
                this._selectedProfile = null;
                this._subtitles = undefined;
                this._panels = [];
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    rect: true,
                    BackgroundOverlay: {
                        rect: true
                    },
                    Panels: {
                        AudioTracks: {
                            type: _tracksPanelcomponent.TracksPanel,
                            title: (0, _i18n.t)("player.audio"),
                            signals: _define_property._({}, _signals.SELECTED_SIGNAL, "_handleAudioTrackSelection")
                        },
                        SubtitleTracks: {
                            type: _tracksPanelcomponent.TracksPanel,
                            title: (0, _i18n.t)("player.subtitles"),
                            signals: _define_property._({}, _signals.SELECTED_SIGNAL, "_handleSubtitlesTrackSelection")
                        }
                    }
                }, (0, _tracksstyle.getInitialStyle)());
            }
        }
    ]);
    return Tracks;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 6468:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _playerselectors = __webpack_require__(83318);
var mapControllers = function(instance) {
    return [
        {
            selector: _playerselectors.getAudioTracks,
            shouldBeInvokedOnConnect: true,
            callback: function(value) {
                instance.audioTracks = value;
            }
        },
        {
            selector: _playerselectors.getSubtitleTracks,
            shouldBeInvokedOnConnect: true,
            callback: function(value) {
                instance.subtitleTracks = value;
            }
        },
        {
            selector: _playerselectors.getSelectedAudioTrack,
            shouldBeInvokedOnConnect: true,
            callback: function(value) {
                instance.selectedAudioTrack = value;
            }
        },
        {
            selector: _playerselectors.getSelectedSubtitlesTrack,
            shouldBeInvokedOnConnect: true,
            callback: function(value) {
                instance.selectedSubtitlesTrack = value;
            }
        }
    ];
};
var _default = _lightningjsredux.default.control(mapControllers);


/***/ }),

/***/ 75702:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    AUDIO_TRACK_SELECTED_SIGNAL: function() {
        return AUDIO_TRACK_SELECTED_SIGNAL;
    },
    CLOSE_SIGNAL: function() {
        return CLOSE_SIGNAL;
    },
    SUBTITLES_TRACK_SELECTED_SIGNAL: function() {
        return SUBTITLES_TRACK_SELECTED_SIGNAL;
    }
});
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(3009);
var CLOSE_SIGNAL = "close";
var AUDIO_TRACK_SELECTED_SIGNAL = "audioTrackSelected";
var SUBTITLES_TRACK_SELECTED_SIGNAL = "subtitlesTrackSelected";


/***/ }),

/***/ 92592:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    AUDIO_MARGIN_BOTTOM: function() {
        return AUDIO_MARGIN_BOTTOM;
    },
    WIDTH: function() {
        return WIDTH;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getFocusedStyle: function() {
        return getFocusedStyle;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    getUnFocusedStyle: function() {
        return getUnFocusedStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(37815);
var _memoize = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34736));
var _constants = __webpack_require__(34952);
var _theme = __webpack_require__(51397);
var _style = __webpack_require__(65082);
var _sizes = __webpack_require__(82699);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var WIDTH = (_obj = {}, _define_property._(_obj, _constants.HD, 640), _define_property._(_obj, _constants.FULL_HD, 960), _obj);
var _obj1;
var AUDIO_MARGIN_BOTTOM = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 8), _define_property._(_obj1, _constants.FULL_HD, 16), _obj1);
var colors = {
    background: (0, _theme.makeThemeColor)(_theme.TERTIARY),
    backgroundOverlay: (0, _theme.makeThemeColor)(_theme.PRIMARY, 0.1)
};
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var screenSize = context.screenSize, colorMode = context.colorMode;
    var contentViewportHeight = _sizes.SCREEN_HEIGHT[screenSize] - _constants.safetyMargins.vertical[screenSize];
    var tracksPanelHeight = Math.round(contentViewportHeight / 2);
    return {
        x: _sizes.SCREEN_WIDTH[screenSize],
        w: WIDTH[screenSize],
        h: _sizes.SCREEN_HEIGHT[screenSize],
        color: colors.background[colorMode],
        BackgroundOverlay: {
            color: colors.backgroundOverlay[colorMode],
            w: WIDTH[screenSize],
            h: _sizes.SCREEN_HEIGHT[screenSize]
        },
        Panels: {
            y: _constants.safetyMargins.vertical[screenSize],
            h: contentViewportHeight,
            w: WIDTH[screenSize],
            AudioTracks: {
                visible: false,
                w: WIDTH[screenSize],
                flexItem: {
                    marginBottom: AUDIO_MARGIN_BOTTOM[screenSize],
                    minHeight: tracksPanelHeight,
                    grow: 1
                }
            },
            SubtitleTracks: {
                visible: false,
                w: WIDTH[screenSize],
                flexItem: {
                    minHeight: tracksPanelHeight,
                    grow: 1
                }
            },
            flex: {
                direction: "column",
                justifyContent: "flex-start"
            }
        }
    };
};
var getFocusedStyle = (0, _memoize.default)(function(screenSize) {
    return {
        smooth: {
            x: _sizes.SCREEN_WIDTH[screenSize] - WIDTH[screenSize]
        }
    };
});
var getUnFocusedStyle = (0, _memoize.default)(function(screenSize) {
    return {
        smooth: {
            x: _sizes.SCREEN_WIDTH[screenSize]
        }
    };
});


/***/ }),

/***/ 76793:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    areForcedSubtitlesOnly: function() {
        return areForcedSubtitlesOnly;
    },
    formatAudioTracks: function() {
        return formatAudioTracks;
    },
    formatSubtitlesTracks: function() {
        return formatSubtitlesTracks;
    },
    getAudioTrackLabelByLanguageCode: function() {
        return getAudioTrackLabelByLanguageCode;
    },
    getLabelByLanguageCode: function() {
        return getLabelByLanguageCode;
    },
    getSubtitleTrackLabel: function() {
        return getSubtitleTrackLabel;
    },
    getTracksWithCorrectLabel: function() {
        return getTracksWithCorrectLabel;
    }
});
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _object_without_properties = __webpack_require__(46537);
var _to_consumable_array = __webpack_require__(30005);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(37815);
var _startCase = /*#__PURE__*/ _interop_require_default._(__webpack_require__(47889));
var _mediaengine = __webpack_require__(88918);
var _i18n = __webpack_require__(14910);
var _ISO6933to1constants = __webpack_require__(13831);
var _tracksutils = __webpack_require__(24779);
var getLabelByLanguageCode = function(code) {
    return (0, _startCase.default)((0, _i18n.t)("languages.".concat(_ISO6933to1constants.ISO693_TO_1[code] || code)));
};
var getAudioTrackLabelByLanguageCode = function(code) {
    switch(code){
        case _mediaengine.AUDIO_TRACK.AD:
            return (0, _i18n.t)("player.audioDescription");
        case _mediaengine.AUDIO_TRACK.OV:
            return (0, _i18n.t)("player.originalSoundtrack");
        default:
            return getLabelByLanguageCode(code);
    }
};
var getSubtitleTrackLabel = function(track) {
    if (!track) {
        return track.label;
    }
    if (track.language === _mediaengine.DISABLED_SUBTITLES) {
        return (0, _i18n.t)("player.subDisable");
    }
    var language = getLabelByLanguageCode(track.language);
    if (track.roles && track.roles.includes("caption")) {
        return (0, _tracksutils.getClosedCaptionsLabel)(language);
    }
    return language;
};
var getTracksWithCorrectLabel = function(tracks) {
    if (!tracks || !tracks.length) {
        return [];
    }
    return tracks.map(function(_param) {
        var language = _param.language, track = _object_without_properties._(_param, [
            "language"
        ]);
        return _object_spread_props._(_object_spread._({}, track), {
            language: language,
            label: (0, _mediaengine.getCorrectAudioTrackLabel)(language)
        });
    });
};
var formatAudioTracks = function(tracks) {
    return getTracksWithCorrectLabel(tracks).map(function(_param) {
        var label = _param.label, track = _object_without_properties._(_param, [
            "label"
        ]);
        return _object_spread_props._(_object_spread._({}, track), {
            label: getAudioTrackLabelByLanguageCode(label)
        });
    });
};
var formatSubtitlesTracks = function(tracks) {
    var tracksWithLabels = getTracksWithCorrectLabel(tracks);
    return _to_consumable_array._(tracksWithLabels).concat([
        {
            id: _mediaengine.DISABLED_SUBTITLES_ID,
            active: !tracksWithLabels.some(function(param) {
                var active = param.active;
                return active;
            }),
            language: _mediaengine.DISABLED_SUBTITLES
        }
    ]).map(function(track) {
        return _object_spread_props._(_object_spread._({}, track), {
            label: getSubtitleTrackLabel(track)
        });
    });
};
var areForcedSubtitlesOnly = function(tracks) {
    return tracks.filter(function(param) {
        var id = param.id;
        return id !== _mediaengine.DISABLED_SUBTITLES_ID;
    }).every(function(param) {
        var roles = param.roles;
        return roles && roles.includes("forced_subtitle");
    });
};


/***/ }),

/***/ 77464:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "TracksPanel", ({
    enumerable: true,
    get: function() {
        return TracksPanel;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _get = __webpack_require__(60528);
var _get_prototype_of = __webpack_require__(35196);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _set = __webpack_require__(81364);
var _create_super = __webpack_require__(6400);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(37815);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _tracksPanelstyle = __webpack_require__(63228);
var _signals = __webpack_require__(2109);
var _trackItemcomponent = __webpack_require__(5208);
var TracksPanel = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(TracksPanel, _Lightning_Component);
    var _super = _create_super._(TracksPanel);
    function TracksPanel() {
        _class_call_check._(this, TracksPanel);
        return _super.apply(this, arguments);
    }
    _create_class._(TracksPanel, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _tracksPanelstyle.defaultContext;
                this._items = [];
                this._index = 0;
            }
        },
        {
            key: "title",
            get: function get() {
                return this.tag("Title").text.text;
            },
            set: function set(value) {
                this.tag("Title").text.text = value;
            }
        },
        {
            key: "items",
            get: function get() {
                return this._items;
            },
            set: function set(value) {
                var _this = this;
                this._items = value || [];
                this.patch({
                    Items: {
                        children: this._items.map(function(track) {
                            return {
                                type: _trackItemcomponent.TrackItem,
                                label: track.label,
                                w: _this.finalW,
                                isSelected: Boolean(track.active)
                            };
                        })
                    }
                });
                this._refocus();
            }
        },
        {
            key: "w",
            get: function get() {
                return _get._(_get_prototype_of._(TracksPanel.prototype), "w", this);
            },
            set: function set(value) {
                _set._(_get_prototype_of._(TracksPanel.prototype), "w", value, this, true);
                this.tag("Items").children.forEach(function(child) {
                    child.w = value;
                });
            }
        },
        {
            key: "index",
            get: function get() {
                return this._index;
            },
            set: function set(value) {
                this._index = value;
            }
        },
        {
            key: "setFocusToSelectedItem",
            value: function setFocusToSelectedItem() {
                var selectedItemIndex = this.tag("Items").children.findIndex(function(param) {
                    var isSelected = param.isSelected;
                    return isSelected;
                });
                this.index = selectedItemIndex >= 0 ? selectedItemIndex : 0;
                this._refocus();
            }
        },
        {
            key: "highlightPreferredTrack",
            value: function highlightPreferredTrack(trackId) {
                var trackToHighLight = this._items.findIndex(function(param) {
                    var id = param.id;
                    return id === trackId;
                });
                if (trackToHighLight >= 0) {
                    var items = this.tag("Items").children;
                    for(var i = 0; i < items.length; i += 1){
                        items[i].isSelected = false;
                    }
                    items[trackToHighLight].isSelected = true;
                }
                this.index = trackToHighLight >= 0 ? trackToHighLight : 0;
                this._refocus();
            }
        },
        {
            key: "_getFocused",
            value: function _getFocused() {
                return this.tag("Items").children[this.index];
            }
        },
        {
            key: "_handleUp",
            value: function _handleUp() {
                if (this.index > 0) {
                    this.index -= 1;
                    return true;
                }
                return false;
            }
        },
        {
            key: "_handleDown",
            value: function _handleDown() {
                if (this.index < this.items.length - 1) {
                    this.index += 1;
                    return true;
                }
                return false;
            }
        },
        {
            key: "_handleEnter",
            value: function _handleEnter() {
                var selectedView = this.tag("Items").children[this._index];
                if (selectedView) {
                    this.tag("Items").children.forEach(function(child) {
                        child.isSelected = child === selectedView;
                    });
                    this.signal(_signals.SELECTED_SIGNAL, this.items[this._index]);
                }
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Title: {},
                    Items: {}
                }, (0, _tracksPanelstyle.getInitialStyle)());
            }
        }
    ]);
    return TracksPanel;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 63228:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    PADDING_LEFT: function() {
        return PADDING_LEFT;
    },
    TITLE_MARGIN_BOTTOM: function() {
        return TITLE_MARGIN_BOTTOM;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _object_spread = __webpack_require__(76247);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);
var _constants = __webpack_require__(34952);
var _theme = __webpack_require__(51397);
var _typography = __webpack_require__(18411);
var _style = __webpack_require__(65082);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var TITLE_MARGIN_BOTTOM = (_obj = {}, _define_property._(_obj, _constants.HD, 12), _define_property._(_obj, _constants.FULL_HD, 16), _obj);
var _obj1;
var PADDING_LEFT = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 80), _define_property._(_obj1, _constants.FULL_HD, 104), _obj1);
var colors = {
    title: (0, _theme.makeThemeColor)(_theme.PRIMARY)
};
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var screenSize = context.screenSize, colorMode = context.colorMode;
    var font = (0, _typography.getFont)(_typography.FONT.PARIS_2, screenSize);
    return {
        flex: {
            direction: "column"
        },
        Title: {
            x: PADDING_LEFT[screenSize],
            color: colors.title[colorMode],
            text: _object_spread._({}, font),
            flexItem: {
                marginBottom: TITLE_MARGIN_BOTTOM[screenSize]
            }
        },
        Items: {
            flex: {
                direction: "column"
            }
        }
    };
};


/***/ }),

/***/ 43710:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "lifecycleHandler", ({
    enumerable: true,
    get: function() {
        return lifecycleHandler;
    }
}));
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
var lifecycleHandler = function() {};


/***/ }),

/***/ 1814:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    createAdRenderers: function() {
        return createAdRenderers;
    },
    createRenderers: function() {
        return createRenderers;
    },
    switchLBannerState: function() {
        return switchLBannerState;
    }
});
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(37815);
var _sizes = __webpack_require__(82699);
var _lBannerutils = __webpack_require__(14625);
var getOrCreate = function(id, tag) {
    var existing = document.getElementById(id);
    if (existing) {
        return existing;
    }
    var result = document.createElement(tag);
    result.setAttribute("id", id);
    return result;
};
var createRenderers = function(prefix) {
    var container = getOrCreate("".concat(prefix, "-container"), "div");
    container.style.cssText = "position: fixed; top: 0; left: 0; width: 100%; height: 100%; overflow: hidden;";
    var video = getOrCreate("".concat(prefix, "-video"), "video");
    // video.setAttribute('crossorigin', 'anonymous');
    video.style.cssText = "width: 100%; height: 100%; object-fit: contain; object-position: center; top: 0; right: 0; position: absolute;";
    container.className = "video-container";
    // const subtitles = document.createElement('div');
    container.appendChild(video);
    // container.appendChild(subtitles);
    document.body.appendChild(container);
    return {
        container: container,
        video: video
    };
};
var createAdRenderers = function(prefix) {
    return createRenderers(prefix);
};
var switchLBannerState = function(videoEl, enable) {
    if (!videoEl) return;
    var fullWidth = _sizes.SCREEN_WIDTH[(0, _sizes.getScreenSize)()];
    var fullHeight = _sizes.SCREEN_HEIGHT[(0, _sizes.getScreenSize)()];
    if (enable) {
        var width = Math.floor(fullWidth * (1 - (0, _lBannerutils.getLBannerWidthScale)()));
        var height = Math.floor(fullHeight * (1 - (0, _lBannerutils.getLBannerHeightScale)()));
        videoEl.style.width = "".concat(width, "px");
        videoEl.style.height = "".concat(height, "px");
    } else {
        videoEl.style.width = "".concat(fullWidth, "px");
        videoEl.style.height = "".concat(fullHeight, "px");
    }
};


/***/ }),

/***/ 55138:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/**
 * Defines how long a video loader (i.e. Jingle) should be displayed over a video when playback is started.
 * The value should be specified in seconds.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    LOADER_DELAY: function() {
        return LOADER_DELAY;
    },
    POST_AD_JINGLE_DELAY: function() {
        return POST_AD_JINGLE_DELAY;
    },
    REUSE_VIDEO_NODE: function() {
        return REUSE_VIDEO_NODE;
    }
});
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(42578);
var LOADER_DELAY = 0;
var POST_AD_JINGLE_DELAY = 0.1;
var REUSE_VIDEO_NODE = false;


/***/ }),

/***/ 65498:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "enhancePlayerConfig", ({
    enumerable: true,
    get: function() {
        return enhancePlayerConfig;
    }
}));
var _async_to_generator = __webpack_require__(24146);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(42578);
var _mediaengine = __webpack_require__(88918);
var _device = __webpack_require__(34670);
var enhancePlayerConfig = function() {
    var _ref = _async_to_generator._(function(config) {
        var model, base;
        return _ts_generator._(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _device.deviceInfo.getModel()
                    ];
                case 1:
                    model = _state.sent();
                    base = model.startsWith("MR601") ? _object_spread_props._(_object_spread._({}, config), {
                        manifestPreprocessor: _mediaengine.removeNonPlayReadyDRM
                    }) : _object_spread_props._(_object_spread._({}, config), {
                        manifestPreprocessor: _mediaengine.removeNonWidevineDRM
                    });
                    return [
                        2,
                        _object_spread_props._(_object_spread._({}, base), {
                            restartOnSeekStall: 5000,
                            restartOnSeekStallLive: 15000
                        })
                    ];
            }
        });
    });
    return function enhancePlayerConfig(config) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 44935:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "PlayerAdapter", ({
    enumerable: true,
    get: function() {
        return PlayerAdapter;
    }
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _interop_require_default = __webpack_require__(81200);
var _sliced_to_array = __webpack_require__(28966);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(3009);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _mediaengine = __webpack_require__(88918);
var _config = __webpack_require__(67958);
var _playeractions = __webpack_require__(90120);
var _playerutils = __webpack_require__(41230);
var _youboraadsadapter = __webpack_require__(55104);
var _adsadapter = __webpack_require__(78036);
var _playerutils1 = __webpack_require__(92628);
var _playerdispatcher = __webpack_require__(39020);
var _playerconstants = __webpack_require__(28824);
var PlayerAdapter = /*#__PURE__*/ function() {
    "use strict";
    function PlayerAdapter() {
        _class_call_check._(this, PlayerAdapter);
    }
    _create_class._(PlayerAdapter, [
        {
            key: "init",
            value: function init(settings) {
                var _this = this;
                return _async_to_generator._(function() {
                    var _ref, content, ads, state;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    Promise.all([
                                        _this.makeContentPlayer(),
                                        _this.makeAdsPlayer(settings.ads)
                                    ])
                                ];
                            case 1:
                                _ref = _sliced_to_array._.apply(void 0, [
                                    _state.sent(),
                                    2
                                ]), content = _ref[0], ads = _ref[1];
                                state = _lightningjsredux.default.getState();
                                _this._plugins = (Array.isArray(content.plugins) ? content.plugins : []).map(function(Plugin) {
                                    return new Plugin();
                                });
                                _this._plugins.forEach(function(plugin) {
                                    plugin.init({
                                        engine: content.player,
                                        options: (0, _playerutils1.fetchPlayerPluginDataById)(plugin.id, state),
                                        // NOTE: If there is no ad adapter connected to Youbora plugin, ads playback time will be included into video join time
                                        sendInitEvent: Boolean(_config.featureFlipping.youboraAdsAdapter)
                                    });
                                });
                                return [
                                    2,
                                    {
                                        content: content,
                                        ads: ads
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "makeContentPlayer",
            value: function makeContentPlayer() {
                var _this = this;
                return _async_to_generator._(function() {
                    var _ref, player, plugins;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.initVideo()
                                ];
                            case 1:
                                _ref = _sliced_to_array._.apply(void 0, [
                                    _state.sent(),
                                    2
                                ]), player = _ref[0], plugins = _ref[1];
                                return [
                                    2,
                                    {
                                        player: player,
                                        plugins: plugins
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "initVideo",
            value: function initVideo() {
                var _this = this;
                return _async_to_generator._(function() {
                    var _ref, Engine, plugins, player, _createRenderers, videoRef, containerRef, subtitlesContainer, state, _ref1, audioTrack, textTrack, userPreferences, config;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, _mediaengine.getPlayerInstance)()
                                ];
                            case 1:
                                _ref = _state.sent(), Engine = _ref.Engine, plugins = _ref.plugins;
                                _this.resetVideo();
                                player = new Engine();
                                _createRenderers = (0, _playerutils1.createRenderers)("main-player"), videoRef = _createRenderers.video, containerRef = _createRenderers.container, subtitlesContainer = _createRenderers.subtitles;
                                _this._video = videoRef;
                                _this._container = containerRef;
                                state = _lightningjsredux.default.getState();
                                _ref1 = state.player.preferences || {}, audioTrack = _ref1.audioTrack, textTrack = _ref1.textTrack;
                                userPreferences = {
                                    audio: (0, _playerutils.audioPreferenceToManifestTrack)(audioTrack),
                                    text: (0, _playerutils.textPreferenceToManifestTrack)(textTrack)
                                };
                                return [
                                    4,
                                    (0, _playerutils1.enhancePlayerConfig)({
                                        dispatcher: _playerdispatcher.playerDispatcher,
                                        drm: {
                                            settings: _config.video.drm,
                                            token: {
                                                handler: function() {
                                                    return _lightningjsredux.default.dispatch((0, _playeractions.fetchUpfrontToken)(_config.defaultService));
                                                }
                                            }
                                        },
                                        element: videoRef,
                                        subtitlesContainer: subtitlesContainer,
                                        userPreferences: userPreferences
                                    })
                                ];
                            case 2:
                                config = _state.sent();
                                player.init(config);
                                if (_this._plugins) {
                                    _this._plugins.forEach(function(plugin) {
                                        plugin.connect(player);
                                    });
                                }
                                return [
                                    2,
                                    [
                                        player,
                                        plugins
                                    ]
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "makeAdsPlayer",
            value: function makeAdsPlayer(settings) {
                if (!this._adsAdapter) {
                    this._adsAdapter = new _adsadapter.AdsAdapter();
                }
                return this._adsAdapter.init(settings);
            }
        },
        {
            key: "notifyAdBridgeInit",
            value: function notifyAdBridgeInit(bridge) {
                if (_config.featureFlipping.youboraAdsAdapter && this._plugins && bridge) {
                    this._plugins.forEach(function(plugin) {
                        if (plugin.setAdsAdapter) {
                            plugin.setAdsAdapter(new _youboraadsadapter.YouboraAdsAdapter(bridge.engine));
                        }
                    });
                }
            }
        },
        {
            key: "resetVideo",
            value: function resetVideo() {
                if (this._plugins) {
                    this._plugins.forEach(function(plugin) {
                        plugin.disconnect();
                    });
                }
                if (this._container && !_playerconstants.REUSE_VIDEO_NODE) {
                    while(this._container.firstChild){
                        this._container.removeChild(this._container.lastChild);
                    }
                    if (this._container.parentNode) {
                        this._container.parentNode.removeChild(this._container);
                    }
                }
                this._container = null;
                this._video = null;
            }
        },
        {
            key: "reset",
            value: function reset() {
                if (this._plugins) {
                    this._plugins.forEach(function(plugin) {
                        plugin.release();
                    });
                }
                this._plugins = [];
                this.resetVideo();
                if (this._adsAdapter) {
                    this._adsAdapter.reset();
                }
                this._adsAdapter = null;
            }
        },
        {
            key: "firePluginEvent",
            value: function firePluginEvent(eventName) {
                this._plugins.forEach(function(plugin) {
                    var adapter = plugin.getAdapter();
                    if (adapter && adapter[eventName] && typeof adapter[eventName] === "function") {
                        adapter[eventName]();
                    }
                });
            }
        },
        {
            key: "firePluginEndedEvent",
            value: function firePluginEndedEvent() {
                this.firePluginEvent("endedListener");
            }
        },
        {
            key: "firePluginPauseEvent",
            value: function firePluginPauseEvent() {
                this.firePluginEvent("pauseListener");
            }
        }
    ]);
    return PlayerAdapter;
}();


/***/ }),

/***/ 52811:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/* eslint-disable no-console */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "Player", ({
    enumerable: true,
    get: function() {
        return Player;
    }
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _sliced_to_array = __webpack_require__(28966);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(42578);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _sdk = __webpack_require__(29956);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _fidosdk = __webpack_require__(19804);
var _constants = __webpack_require__(34952);
var _playerconstants = __webpack_require__(7602);
var _playeractions = __webpack_require__(90120);
var _screenSaveractions = __webpack_require__(90962);
var _analyticsutils = __webpack_require__(2693);
var _spinnercomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(76976));
var _subtitlescomponent = __webpack_require__(58415);
var _textures = __webpack_require__(67179);
var _adscomponent = __webpack_require__(73262);
var _adsconstants = __webpack_require__(61726);
var _playerconstants1 = __webpack_require__(28824);
var _playerconnector = /*#__PURE__*/ _interop_require_default._(__webpack_require__(45557));
var _playeradapter = __webpack_require__(44935);
var _playerutils = __webpack_require__(92628);
var _playerstyle = __webpack_require__(16147);
var _lifecyclehandler = __webpack_require__(43710);
var Player = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(Player, _Lightning_Component);
    var _super = _create_super._(Player);
    function Player() {
        _class_call_check._(this, Player);
        return _super.apply(this, arguments);
    }
    _create_class._(Player, [
        {
            key: "_construct",
            value: function _construct() {
                this._durationInSeconds = 0;
                this._isAdError = false;
                this._isContentLoadingStarted = false;
                this._containsAds = false;
                this._quartiles = [
                    0,
                    0,
                    0,
                    0
                ];
            }
        },
        {
            key: "_attach",
            value: function _attach() {
                this.stage.gc();
            }
        },
        {
            key: "_active",
            value: function _active() {
                this._adapter = new _playeradapter.PlayerAdapter();
                this._unsubscribe = (0, _playerconnector.default)(this);
                this.stage.gc();
                this._quartilesTracked = [
                    false,
                    false,
                    false,
                    false
                ];
                this._playing = null;
            }
        },
        {
            key: "_inactive",
            value: function _inactive() {
                if (this._unsubscribe) {
                    this._unsubscribe();
                    this._unsubscribe = null;
                }
                // NOTE: we need to check if the store was not cleaned up (required to avoid so-called "memory leaks" on Ziggo)
                if (_lightningjsredux.default.dispatch) {
                    // Ensure no player-related data left in Redux store
                    _lightningjsredux.default.dispatch((0, _playerconstants.reset)());
                }
                // TODO: handle case when player's load was called and there is a big delay between load's finish and play start
                this._stop();
                this._adapter = null;
                this._playing = null;
            }
        },
        {
            key: "source",
            set: function set(value) {
                if (this._source !== value) {
                    this._source = value;
                    if (this._source) {
                        console.log("[player.component] Source set, starting");
                        this._start();
                    } else {
                        console.log("[player.component] Source removed, stopping");
                        // NOTE: should be kept to handle player lock during playback (in case of switching of live programs)
                        this._stop();
                    }
                }
            }
        },
        {
            key: "isBuffering",
            set: function set(value) {
                this.tag("Spinner").setSmooth("alpha", value ? 1 : 0);
            }
        },
        {
            key: "shouldHideVideoLoader",
            set: function set(value) {
                if (value) {
                    this.tag("PostAdJingle").setSmooth("alpha", 0, _playerstyle.POST_AD_JINGLE_OUT_TRANSITION);
                }
            }
        },
        {
            key: "elapsedTimeInSeconds",
            set: function set(value) {
                if (this._player) {
                    this._elapsedTimeInSeconds = value;
                    if (!this._position) {
                        this._position = value;
                    }
                    (0, _playerutils.trackQuartiles)(value, this._quartiles, this._quartilesTracked);
                }
                if (this._adBridge) {
                    this._adBridge.contentHasProgressed(value);
                }
            }
        },
        {
            key: "durationInSeconds",
            set: function set(value) {
                this._durationInSeconds = value;
                this._quartiles = [
                    value,
                    value,
                    value,
                    value
                ].map(function(value, index) {
                    return value * (index + 1) * _playerconstants1.PERCENTAGE_EVENT_DURATION * 0.01;
                });
                this._quartiles[this._quartiles.length - 1] -= 5;
            }
        },
        {
            key: "advertising",
            set: function set(value) {
                this._advertising = value;
            }
        },
        {
            key: "postAdJingleImageId",
            set: function set(value) {
                var adJingleView = this.tag("PostAdJingle");
                var finalW = adJingleView.finalW, finalH = adJingleView.finalH;
                adJingleView.texture = (0, _textures.cover)(_fidosdk.imageService.getUrl(value, finalW, finalH, {
                    fit: _constants.IMAGE_FIT_SCALE_CROP,
                    quality: _constants.IMAGE_QUALITY,
                    format: _constants.DEFAULT_IMAGE_FORMAT
                }), finalW, finalH);
                // NOTE: forcing to load a texture since the Ad Jingle alpha is equal to 0 at this moment
                // If this call is omitted, there will be a flush of paused content before Ad Jingle appears
                adJingleView.loadTexture();
            }
        },
        {
            key: "adsProvider",
            set: function set(value) {
                this._adsProvider = value;
            }
        },
        {
            key: "isAdError",
            set: function set(value) {
                this._isAdError = value;
            }
        },
        {
            key: "lifecycleState",
            set: function set(value) {
                (0, _lifecyclehandler.lifecycleHandler)(value, this);
            }
        },
        {
            key: "isPlayingAds",
            set: function set(value) {
                var _this = this;
                this._isPlayingAds = value;
                if (value) {
                    this._containsAds = true;
                    if (this._player) {
                        this._player.reset();
                        this.isBuffering = false;
                        if (this._playing) {
                            _lightningjsredux.default.dispatch((0, _playerconstants.paused)());
                        }
                        this._player = null;
                    }
                    if (this._adapter) {
                        this._adapter.resetVideo();
                        _lightningjsredux.default.dispatch((0, _screenSaveractions.setScreenSaverIsLocked)(true));
                    }
                } else if (!this._player && this._source) {
                    if (_playerconstants1.POST_AD_JINGLE_DELAY && this._adBreakType && this._adBreakType.startsWith(_playerconstants1.AD_BREAK_MID_ROLL)) {
                        var jingle = this.tag("PostAdJingle");
                        jingle.alpha = 1.0;
                    }
                    this._adapter.initVideo().then(function(param) {
                        var _param = _sliced_to_array._(param, 1), player = _param[0];
                        _this._player = player;
                        _this._startContent();
                        _lightningjsredux.default.dispatch((0, _screenSaveractions.setScreenSaverIsLocked)(true));
                    });
                }
                this.tag("Ads").visible = value;
                this._refocus();
            }
        },
        {
            key: "adBreakType",
            set: function set(value) {
                this._adBreakType = value;
            }
        },
        {
            key: "isEnded",
            set: function set(value) {
                console.log("[player.component] content duration on the end event ", this._durationInSeconds);
                if (value) {
                    this._adapter.firePluginEndedEvent();
                }
            }
        },
        {
            key: "shouldUseAdBridge",
            get: function get() {
                return this._isPlayingAds && this._adBridge && !this._isAdError;
            }
        },
        {
            key: "play",
            value: function play() {
                if (this.shouldUseAdBridge) {
                    try {
                        this._adBridge.play();
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.error("[Player.component] Could not play", error);
                    }
                } else if (this._player) {
                    this._player.play();
                    this.stage.gc();
                }
                this._playing = true;
                _lightningjsredux.default.dispatch((0, _screenSaveractions.setScreenSaverIsLocked)(true));
            }
        },
        {
            key: "pause",
            value: function pause() {
                if (this.shouldUseAdBridge) {
                    this._adBridge.pause();
                } else if (this._player) {
                    this._player.pause();
                }
                this._playing = false;
                _lightningjsredux.default.dispatch((0, _screenSaveractions.setScreenSaverIsLocked)(false));
            }
        },
        {
            key: "skipAd",
            value: function skipAd(skipEntireAdBreak) {
                if (!this._adBridge) {
                    return;
                }
                if (skipEntireAdBreak) {
                    this._adBridge.skipBreak();
                } else {
                    this._adBridge.skipAd();
                }
            }
        },
        {
            key: "seek",
            value: function seek(position) {
                var forceRestart = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                if (!this._player) {
                    return;
                }
                this._player.seek(position, forceRestart);
                var method = this._position - position < 0 ? "forward" : "backward";
                this._position = position;
                (0, _playerutils.trackQuartiles)(position, this._quartiles, this._quartilesTracked);
                (0, _analyticsutils.sendEvent)({
                    key: method
                });
                if (this._source && !this._source.isLive && this._adBridge) {
                    this._adBridge.triggerSlotOnSeek(position);
                }
            }
        },
        {
            key: "backToLive",
            value: function backToLive() {
                if (this._player) {
                    this._player.backToLive();
                }
            }
        },
        {
            key: "setAudioTrackById",
            value: function setAudioTrackById(id) {
                if (this._player) {
                    this._player.setAudioTrackById(id);
                }
            }
        },
        {
            key: "setSubtitlesTrackById",
            value: function setSubtitlesTrackById(id) {
                if (this._player) {
                    this._player.setSubtitlesTrackById(id);
                }
            }
        },
        {
            key: "_start",
            value: function _start() {
                var _this = this;
                return _async_to_generator._(function() {
                    var _ref, content, ads;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._adapter.init({
                                        ads: {
                                            providerId: _this._adsProvider,
                                            providerConfig: _this._advertising,
                                            contentDuration: _this._durationInSeconds,
                                            contentHandlers: {
                                                playerPlay: function() {
                                                    if (!_this._isContentLoadingStarted) {
                                                        _this._startContent();
                                                    }
                                                },
                                                jingleDisplay: function(type) {
                                                    return _lightningjsredux.default.dispatch((0, _playeractions.showAdJingle)(type));
                                                },
                                                playerPause: function() {
                                                    _this._adapter.firePluginPauseEvent();
                                                }
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _ref = _state.sent(), content = _ref.content, ads = _ref.ads;
                                _this._player = content.player;
                                _this._adBridge = ads ? ads.bridge : null;
                                if (_this._adBridge) {
                                    console.log("[player.component] Requesting ads from Ad Bridge");
                                    // Once ad bridge is initialized, it should fire an event that will be caught by event-to-Redux dispatcher
                                    _this._adBridge.init().then(function() {
                                        // Since it's an asynchronous process, player could be stopped while it's running, so checking for a null reference
                                        if (_this._adBridge) {
                                            _this._adapter.notifyAdBridgeInit(_this._adBridge);
                                            _this._adBridge.requestAds({}, {
                                                start: 0,
                                                duration: _this._durationInSeconds
                                            });
                                        }
                                    });
                                } else {
                                    console.log("[player.component] Starting content playback");
                                    // In case if there are no ads to play, switch to direct content playback, wait for pre-roll complete otherwise
                                    _this._startContent();
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_startContent",
            value: function _startContent() {
                var _this = this;
                return _async_to_generator._(function() {
                    var shouldAutoPlay, reference, error, startTime;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this._source) {
                                    console.log("[player.component] No source, can not start content playback");
                                    return [
                                        2
                                    ];
                                }
                                _this._playing = true;
                                // Either it's a first player's loading and we need to dispatch an appropriate action
                                // or it's a "resume" after an ad break, and we need to continue "linear" playback
                                shouldAutoPlay = _this._isContentLoadingStarted ? true : _this._source.shouldAutoPlay;
                                if (!_this._isContentLoadingStarted) {
                                    _lightningjsredux.default.dispatch((0, _playerconstants.loadStart)());
                                }
                                _this._isContentLoadingStarted = true;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    (0, _playerutils.getOriginalUrlFromReference)(_this._source.reference)
                                ];
                            case 2:
                                reference = _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                error = _state.sent();
                                throw new Error("Failed to fetch manifest redirect");
                            case 4:
                                // NOTE: a situation is possible when a player is closed (i.e. all references are cleaned) in a process of an original URL request
                                if (_this._player) {
                                    startTime = Number.isFinite(_this._elapsedTimeInSeconds) ? _this._elapsedTimeInSeconds : (0, _get.default)(_this._source, "startTime");
                                    // When there is a content to play the player should fire a CAN_PLAY event, and the app will know it's OK to start playback
                                    _this._player.start(_object_spread_props._(_object_spread._({}, _this._source), {
                                        startTime: startTime,
                                        shouldAutoPlay: shouldAutoPlay,
                                        reference: reference
                                    }));
                                } else {
                                    console.log("[player.component] No player instance, can not start content playback");
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_stop",
            value: function _stop() {
                if (this._player) {
                    this._player.reset();
                    this._player = null;
                }
                if (this._adapter) {
                    this._adapter.reset();
                }
                if (this._adBridge) {
                    this._adBridge.release();
                }
                this._containsAds = false;
                this._isContentLoadingStarted = false;
                if (_lightningjsredux.default.dispatch) {
                    _lightningjsredux.default.dispatch((0, _screenSaveractions.setScreenSaverIsLocked)(false));
                }
                this._playing = false;
                (0, _analyticsutils.sendEvent)({
                    key: "playbackStopped"
                });
            }
        },
        {
            key: "_getFocused",
            value: function _getFocused() {
                return this.tag("Ads").visible ? this.tag("Ads") : undefined;
            }
        },
        {
            key: "setlBannerState",
            value: function setlBannerState(enable) {
                (0, _playerutils.switchLBannerState)(this._adapter._video, enable);
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                var _obj;
                return (0, _merge.default)({
                    Ads: {
                        type: _adscomponent.Ads,
                        signals: (_obj = {}, _define_property._(_obj, _adsconstants.PAUSE_SIGNAL, "pause"), _define_property._(_obj, _adsconstants.PLAY_SIGNAL, "play"), _define_property._(_obj, _adsconstants.SKIP_SIGNAL, "skipAd"), _obj)
                    },
                    Spinner: {
                        type: _spinnercomponent.default
                    },
                    Subtitles: {
                        type: _subtitlescomponent.Subtitles
                    },
                    PostAdJingle: {}
                }, (0, _playerstyle.getInitialStyle)());
            }
        }
    ]);
    return Player;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 45557:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _playerselectors = __webpack_require__(83318);
var _lifecyclesselectors = __webpack_require__(32749);
var mapControllers = function(instance) {
    return [
        {
            selector: _playerselectors.getAdsProvider,
            callback: function(value) {
                instance.adsProvider = value;
            },
            shouldBeInvokedOnConnect: true
        },
        {
            selector: _playerselectors.getVideoAds,
            callback: function(value) {
                instance.advertising = value;
            },
            shouldBeInvokedOnConnect: true
        },
        {
            selector: _playerselectors.getJingleImageId,
            callback: function(value) {
                instance.postAdJingleImageId = value;
            },
            shouldBeInvokedOnConnect: true
        },
        {
            selector: _playerselectors.getIsAdError,
            callback: function(value) {
                instance.isAdError = value;
            },
            shouldBeInvokedOnConnect: true
        },
        {
            selector: _playerselectors.isPlayingAds,
            callback: function(value) {
                instance.isPlayingAds = value;
            },
            shouldBeInvokedOnConnect: true
        },
        {
            selector: _playerselectors.getDisplayedAdBreakType,
            callback: function(value) {
                instance.adBreakType = value;
            },
            shouldBeInvokedOnConnect: true
        },
        {
            selector: _playerselectors.getDurationInSeconds,
            callback: function(value) {
                instance.durationInSeconds = value;
            },
            shouldBeInvokedOnConnect: true
        },
        {
            selector: _lifecyclesselectors.getLifecycleState,
            callback: function(value) {
                instance.lifecycleState = value;
            },
            shouldBeInvokedOnConnect: true
        },
        {
            selector: _playerselectors.getVideoSource,
            callback: function(value) {
                instance.source = value;
            },
            shouldBeInvokedOnConnect: true
        },
        {
            selector: _playerselectors.getIsBuffering,
            callback: function(value) {
                instance.isBuffering = value;
            },
            shouldBeInvokedOnConnect: true
        },
        {
            selector: _playerselectors.shouldHideVideoLoader,
            shouldBeInvokedOnConnect: true,
            callback: function(value) {
                instance.shouldHideVideoLoader = value;
            }
        },
        {
            selector: _playerselectors.getElapsedTimeInSeconds,
            callback: function(value) {
                instance.elapsedTimeInSeconds = value;
            }
        },
        {
            selector: _playerselectors.getIsEnded,
            shouldBeInvokedOnConnect: true,
            callback: function(value) {
                instance.isEnded = value;
            }
        },
        {
            selector: _playerselectors.getSelectedAudioTrack,
            shouldBeInvokedOnConnect: false,
            callback: function(value) {
                instance.setAudioTrackById(value);
            }
        },
        {
            selector: _playerselectors.getSelectedSubtitlesTrack,
            shouldBeInvokedOnConnect: false,
            callback: function(value) {
                instance.setSubtitlesTrackById(value);
            }
        }
    ];
};
var _default = _lightningjsredux.default.control(mapControllers);


/***/ }),

/***/ 28824:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    AD_BREAK_MID_ROLL: function() {
        return AD_BREAK_MID_ROLL;
    },
    AD_BREAK_PRE_ROLL: function() {
        return AD_BREAK_PRE_ROLL;
    },
    AD_JINGLE_DURATION: function() {
        return _playerconstants.AD_JINGLE_DURATION;
    },
    INTERFACE_DISPLAY_DURATION: function() {
        return _playerconstants.INTERFACE_DISPLAY_DURATION;
    },
    JINGLE_DURATION: function() {
        return _playerconstants.JINGLE_DURATION;
    },
    LIVE_DURATION: function() {
        return _playerconstants.LIVE_DURATION;
    },
    PERCENTAGE_EVENT_DURATION: function() {
        return PERCENTAGE_EVENT_DURATION;
    },
    SEEK_DEBOUNCE_MS: function() {
        return _playerconstants.SEEK_DEBOUNCE_MS;
    },
    SEEK_STEP_SECONDS: function() {
        return _playerconstants.SEEK_STEP_SECONDS;
    },
    SEEK_THROTTLE_MS: function() {
        return _playerconstants.SEEK_THROTTLE_MS;
    }
});
var _export_star = __webpack_require__(37668);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(3009);
var _playerconstants = __webpack_require__(7602);
_export_star._(__webpack_require__(55138), exports);
var PERCENTAGE_EVENT_DURATION = 25;
var AD_BREAK_PRE_ROLL = "preroll";
var AD_BREAK_MID_ROLL = "midroll";


/***/ }),

/***/ 39020:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "playerDispatcher", ({
    enumerable: true,
    get: function() {
        return playerDispatcher;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(52318);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _mediaengine = __webpack_require__(62221);
var _playerconstants = __webpack_require__(7602);
var _playeractions = __webpack_require__(90120);
var playerDispatcher = function(event, payload) {
    if (event === _mediaengine.VIDEO_EVENTS.ERROR) {
        var error = (0, _get.default)(payload, "error.error", payload.error);
        _lightningjsredux.default.dispatch((0, _playeractions.playbackError)(error));
        return;
    }
    if (event) {
        _lightningjsredux.default.dispatch({
            type: (0, _playerconstants.withPlayerPrefix)(event.toUpperCase()),
            payload: payload
        });
    }
};


/***/ }),

/***/ 16147:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    POST_AD_JINGLE_OUT_TRANSITION: function() {
        return POST_AD_JINGLE_OUT_TRANSITION;
    },
    SPINNER_SIZE: function() {
        return SPINNER_SIZE;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
var _define_property = __webpack_require__(21228);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(52318);
var _constants = __webpack_require__(34952);
var _style = __webpack_require__(65082);
var _sizes = __webpack_require__(82699);
var _playerconstants = __webpack_require__(28824);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var SPINNER_SIZE = (_obj = {}, _define_property._(_obj, _constants.HD, 200), _define_property._(_obj, _constants.FULL_HD, 200), _obj);
var POST_AD_JINGLE_OUT_TRANSITION = {
    duration: 0.3,
    delay: _playerconstants.POST_AD_JINGLE_DELAY
};
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var screenSize = context.screenSize;
    var spinnerSize = SPINNER_SIZE[screenSize];
    return {
        w: _sizes.SCREEN_WIDTH[screenSize],
        h: _sizes.SCREEN_HEIGHT[screenSize],
        Ads: {},
        PostAdJingle: {
            alpha: 0,
            w: _sizes.SCREEN_WIDTH[screenSize],
            h: _sizes.SCREEN_HEIGHT[screenSize]
        },
        Spinner: {
            alpha: 0,
            mount: 0.5,
            w: spinnerSize,
            h: spinnerSize,
            x: _sizes.middle,
            y: _sizes.middle
        },
        Subtitles: {}
    };
};


/***/ }),

/***/ 92628:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    calculatePartOfDuration: function() {
        return calculatePartOfDuration;
    },
    fetchPlayerPluginDataById: function() {
        return fetchPlayerPluginDataById;
    },
    getOriginUrl: function() {
        return getOriginUrl;
    },
    getOriginalUrlFromReference: function() {
        return getOriginalUrlFromReference;
    },
    getUserPreference: function() {
        return getUserPreference;
    },
    trackQuartiles: function() {
        return trackQuartiles;
    }
});
var _export_star = __webpack_require__(37668);
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
var _superagent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(54247));
var _config = __webpack_require__(67958);
var _utils = __webpack_require__(64188);
var _analyticsutils = __webpack_require__(2693);
var _youborautils = __webpack_require__(64018);
var _playerconstants = __webpack_require__(28824);
_export_star._(__webpack_require__(1814), exports);
_export_star._(__webpack_require__(65498), exports);
var getOriginUrl = function(lbCdnUrl) {
    return new Promise(function(resolve, reject) {
        _superagent.default.get(lbCdnUrl).then(function(response) {
            resolve(response.text);
        }).catch(function(error) {
            return reject(error);
        });
    });
};
var getOriginalUrlFromReference = function(reference) {
    if (reference && reference.includes("no-redirect")) {
        return getOriginUrl(reference);
    }
    return Promise.resolve(reference);
};
var fetchPlayerPluginDataById = function(id, state) {
    switch(id){
        case _youborautils.KEY:
            return {
                data: (0, _youborautils.fetchYouboraData)(state),
                settings: _config.youbora
            };
        default:
            return {};
    }
};
var getUserPreference = function(key) {
    var profileUid = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    return _utils.storage.getItem([
        profileUid,
        key
    ].filter(Boolean).join(".") || _utils.storage.getItem(key)) || "";
};
var calculatePartOfDuration = function(value, duration) {
    return Math.floor(value / duration * 100 / _playerconstants.PERCENTAGE_EVENT_DURATION);
};
var trackQuartiles = function(value, quartiles, trackedQuartiles) {
    for(var i = 0; i < quartiles.length; i += 1){
        if (!trackedQuartiles[i] && value >= quartiles[i]) {
            (0, _analyticsutils.sendEvent)({
                key: "completion".concat((i + 1) * _playerconstants.PERCENTAGE_EVENT_DURATION)
            });
            trackedQuartiles[i] = true;
        }
    }
};


/***/ }),

/***/ 78941:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "setup", ({
    enumerable: true,
    get: function() {
        return _default.setup;
    }
}));
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(45538);
var _default = __webpack_require__(99189);


/***/ }),

/***/ 89342:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "setupPerformancePolyfill", ({
    enumerable: true,
    get: function() {
        return setupPerformancePolyfill;
    }
}));
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(42578);
var setupPerformancePolyfill = function(window) {
    var startOffset = Date.now ? Date.now() : +new Date();
    var performance = window.performance || {};
    if (!performance.now) {
        var polyfill = function() {
            return (Date.now ? Date.now() : +new Date()) - startOffset;
        };
        performance.now = performance.webkitNow || performance.mozNow || performance.msNow || polyfill;
    }
    if (!performance.mark) {
        performance.mark = function() {};
    }
    if (!performance.measure) {
        performance.measure = function() {};
    }
    window.performance = performance;
};


/***/ }),

/***/ 99189:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "setup", ({
    enumerable: true,
    get: function() {
        return setup;
    }
}));
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(37815);
var _performancepolyfill = __webpack_require__(89342);
var setup = function(window) {
    (0, _performancepolyfill.setupPerformancePolyfill)(window);
};


/***/ }),

/***/ 30311:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return PopupContainer;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _create_super = __webpack_require__(6400);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(3009);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _popupContainerconstants = __webpack_require__(54258);
var _popupContainerstyle = __webpack_require__(76480);
var _popups = __webpack_require__(91322);
var PopupContainer = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(PopupContainer, _Lightning_Component);
    var _super = _create_super._(PopupContainer);
    function PopupContainer() {
        _class_call_check._(this, PopupContainer);
        return _super.apply(this, arguments);
    }
    _create_class._(PopupContainer, [
        {
            key: "content",
            set: function set(value) {
                var data = (0, _merge.default)((0, _popups.getPopupByID)(value.id), value.options);
                this._popupId = data.popupId;
                this.children = [
                    this.stage.c(_object_spread_props._(_object_spread._({}, data), {
                        ref: "Content"
                    }))
                ];
            }
        },
        {
            key: "popupId",
            get: function get() {
                return this._popupId;
            }
        },
        {
            key: "_focus",
            value: function _focus() {
                this.alpha = 1;
            }
        },
        {
            key: "_handleLeft",
            value: function _handleLeft() {
                return true;
            }
        },
        {
            key: "_handleRight",
            value: function _handleRight() {
                return true;
            }
        },
        {
            key: "_handleBack",
            value: function _handleBack() {
                this.signal(_popupContainerconstants.HIDE_POPUP_SIGNAL);
                return true;
            }
        },
        {
            key: "_getFocused",
            value: function _getFocused() {
                return this.tag("Content");
            }
        },
        {
            key: "reset",
            value: function reset() {
                this._popupId = null;
                this.alpha = 0;
                this.children = [];
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _popupContainerstyle.getInitialStyle)();
            }
        }
    ]);
    return PopupContainer;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 54258:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    EXIT_APP_SIGNAL: function() {
        return EXIT_APP_SIGNAL;
    },
    HIDE_POPUP_SIGNAL: function() {
        return HIDE_POPUP_SIGNAL;
    },
    ROUTE_BACK_SIGNAL: function() {
        return ROUTE_BACK_SIGNAL;
    }
});
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(88801);
var HIDE_POPUP_SIGNAL = "hideFullscreenPopup";
var EXIT_APP_SIGNAL = "exitApp";
var ROUTE_BACK_SIGNAL = "routeBack";


/***/ }),

/***/ 76480:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
var _sizes = __webpack_require__(82699);
var _style = __webpack_require__(65082);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var screenSize = context.screenSize;
    return {
        alpha: 0,
        w: _sizes.SCREEN_WIDTH[screenSize],
        h: _sizes.SCREEN_HEIGHT[screenSize]
    };
};


/***/ }),

/***/ 77472:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "AbstractPopup", ({
    enumerable: true,
    get: function() {
        return AbstractPopup;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(37815);
var _sdk = __webpack_require__(29956);
var _popupContainerconstants = __webpack_require__(54258);
var AbstractPopup = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(AbstractPopup, _Lightning_Component);
    var _super = _create_super._(AbstractPopup);
    function AbstractPopup() {
        _class_call_check._(this, AbstractPopup);
        return _super.apply(this, arguments);
    }
    _create_class._(AbstractPopup, [
        {
            key: "_handleBack",
            value: function _handleBack() {
                this.signal(this._getCloseActionSignal());
                return true;
            }
        },
        {
            key: "_getCloseActionSignal",
            value: function _getCloseActionSignal() {
                if (this._checkHistoryAvailable()) {
                    return _popupContainerconstants.ROUTE_BACK_SIGNAL;
                }
                if (this._exitAppOnClose) {
                    return _popupContainerconstants.EXIT_APP_SIGNAL;
                }
                return _popupContainerconstants.HIDE_POPUP_SIGNAL;
            }
        },
        {
            key: "_checkHistoryAvailable",
            value: function _checkHistoryAvailable() {
                return this._routeBackOnClose && _sdk.Router.getHistory().length > 0;
            }
        },
        {
            key: "routeBackOnClose",
            get: function get() {
                return this._routeBackOnClose;
            },
            set: function set(value) {
                this._routeBackOnClose = value;
            }
        },
        {
            key: "exitAppOnClose",
            set: function set(value) {
                this._exitAppOnClose = value;
            }
        }
    ]);
    return AbstractPopup;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 10879:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "AccountCompletionPopup", ({
    enumerable: true,
    get: function() {
        return AccountCompletionPopup;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(37815);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _i18n = __webpack_require__(14910);
var _popupContainerconstants = __webpack_require__(54258);
var _buttoncomponent = __webpack_require__(31464);
var _brandIconcomponent = __webpack_require__(362);
var _abstractPopupcomponent = __webpack_require__(77472);
var _accountCompletionPopupstyle = __webpack_require__(25662);
var AccountCompletionPopup = /*#__PURE__*/ function(AbstractPopup) {
    "use strict";
    _inherits._(AccountCompletionPopup, AbstractPopup);
    var _super = _create_super._(AccountCompletionPopup);
    function AccountCompletionPopup() {
        _class_call_check._(this, AccountCompletionPopup);
        return _super.apply(this, arguments);
    }
    _create_class._(AccountCompletionPopup, [
        {
            key: "_active",
            value: function _active() {
                this.tag("OkButton").label = this._getCloseButtonCaption();
            }
        },
        {
            key: "_getFocused",
            value: function _getFocused() {
                return this.tag("OkButton");
            }
        },
        {
            key: "_handleEnter",
            value: function _handleEnter() {
                this.signal(this._getCloseActionSignal());
                return true;
            }
        },
        {
            key: "_getCloseButtonCaption",
            value: function _getCloseButtonCaption() {
                switch(this._getCloseActionSignal()){
                    case _popupContainerconstants.EXIT_APP_SIGNAL:
                        return (0, _i18n.t)("global.quit");
                    case _popupContainerconstants.ROUTE_BACK_SIGNAL:
                    default:
                        return (0, _i18n.t)("global.back");
                }
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                var _obj;
                return (0, _merge.default)((0, _accountCompletionPopupstyle.getInitialStyle)(), {
                    Icon: {
                        type: _brandIconcomponent.BrandIcon
                    },
                    FlexContainer: {
                        Title: {
                            text: {
                                text: (0, _i18n.t)("pairing.completion.title")
                            }
                        },
                        Description: {
                            text: {
                                text: (0, _i18n.t)("pairing.completion.description")
                            }
                        },
                        OkButton: {
                            type: _buttoncomponent.Button,
                            label: (0, _i18n.t)("global.close")
                        }
                    },
                    passSignals: (_obj = {}, _define_property._(_obj, _popupContainerconstants.HIDE_POPUP_SIGNAL, true), _define_property._(_obj, _popupContainerconstants.ROUTE_BACK_SIGNAL, true), _define_property._(_obj, _popupContainerconstants.EXIT_APP_SIGNAL, true), _obj)
                });
            }
        }
    ]);
    return AccountCompletionPopup;
}(_abstractPopupcomponent.AbstractPopup);


/***/ }),

/***/ 25662:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BUTTONS_TOP_MARGIN: function() {
        return BUTTONS_TOP_MARGIN;
    },
    CONTENT_SIDE_MARGIN: function() {
        return CONTENT_SIDE_MARGIN;
    },
    DESCRIPTION_TOP_MARGIN: function() {
        return DESCRIPTION_TOP_MARGIN;
    },
    LOGO_HEIGHT: function() {
        return LOGO_HEIGHT;
    },
    LOGO_OFFSET_TOP: function() {
        return LOGO_OFFSET_TOP;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
var _memoize = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34736));
var _theme = __webpack_require__(51397);
var _typography = __webpack_require__(18411);
var _constants = __webpack_require__(34952);
var _style = __webpack_require__(65082);
var _sizes = __webpack_require__(82699);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var CONTENT_SIDE_MARGIN = (_obj = {}, _define_property._(_obj, _constants.HD, 320), _define_property._(_obj, _constants.FULL_HD, 480), _obj);
var _obj1;
var DESCRIPTION_TOP_MARGIN = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 8), _define_property._(_obj1, _constants.FULL_HD, 16), _obj1);
var _obj2;
var BUTTONS_TOP_MARGIN = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 24), _define_property._(_obj2, _constants.FULL_HD, 32), _obj2);
var _obj3;
var LOGO_HEIGHT = (_obj3 = {}, _define_property._(_obj3, _constants.HD, 40), _define_property._(_obj3, _constants.FULL_HD, 56), _obj3);
var _obj4;
var LOGO_OFFSET_TOP = (_obj4 = {}, _define_property._(_obj4, _constants.HD, 40), _define_property._(_obj4, _constants.FULL_HD, 56), _obj4);
var colors = {
    background: (0, _theme.makeThemeColor)(_theme.TERTIARY)
};
var getInitialStyle = (0, _memoize.default)(function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var screenSize = context.screenSize, colorMode = context.colorMode;
    var titleFont = (0, _typography.getFont)(_typography.FONT.KINSHASA_3, screenSize);
    var descriptionFont = (0, _typography.getFont)(_typography.FONT.OTTAWA_2, screenSize);
    var wordWrapWidth = _sizes.SCREEN_WIDTH[screenSize] - CONTENT_SIDE_MARGIN[screenSize] * 2;
    return {
        rect: true,
        color: colors.background[colorMode],
        h: _sizes.SCREEN_HEIGHT[screenSize],
        w: _sizes.SCREEN_WIDTH[screenSize],
        Icon: {
            x: _sizes.middle,
            y: LOGO_OFFSET_TOP[screenSize],
            mountX: 0.5,
            textureScale: 1.5,
            h: LOGO_HEIGHT[screenSize]
        },
        FlexContainer: {
            x: _sizes.middle,
            y: _sizes.middle,
            mountY: 0.5,
            flex: {
                direction: "column",
                justifyContent: "center"
            },
            Title: {
                mountX: 0.5,
                text: _object_spread._({
                    textAlign: "center",
                    wordWrapWidth: wordWrapWidth,
                    maxLines: 2,
                    maxLinesSuffix: "..."
                }, titleFont)
            },
            Description: {
                flexItem: {
                    marginTop: DESCRIPTION_TOP_MARGIN[screenSize]
                },
                mountX: 0.5,
                text: _object_spread._({
                    textAlign: "center",
                    wordWrapWidth: wordWrapWidth
                }, descriptionFont)
            },
            OkButton: {
                flexItem: {
                    marginTop: BUTTONS_TOP_MARGIN[screenSize]
                },
                mountX: 0.5,
                colorMode: colorMode
            }
        }
    };
});


/***/ }),

/***/ 57414:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "AgeGatePopup", ({
    enumerable: true,
    get: function() {
        return AgeGatePopup;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _sdk = __webpack_require__(29956);
var _fidosdk = __webpack_require__(19804);
var _constants = __webpack_require__(34952);
var _ageGatePopupstyle = __webpack_require__(1591);
var _i18n = __webpack_require__(14910);
var _buttoncomponent = __webpack_require__(31464);
var _popupContainerconstants = __webpack_require__(54258);
var _iconcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(70160));
var _ctaactions = __webpack_require__(32067);
var _textures = __webpack_require__(67179);
var _playerutils = __webpack_require__(41230);
var AgeGatePopup = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(AgeGatePopup, _Lightning_Component);
    var _super = _create_super._(AgeGatePopup);
    function AgeGatePopup() {
        _class_call_check._(this, AgeGatePopup);
        return _super.apply(this, arguments);
    }
    _create_class._(AgeGatePopup, [
        {
            key: "routeBackOnClose",
            set: function set(value) {
                this._routeBackOnClose = value;
            }
        },
        {
            key: "payload",
            set: function set(value) {
                this._payload = value;
                var _this = this, finalW = _this.finalW, finalH = _this.finalH;
                var item = value.item;
                this.tag("BackgroundPoster").texture = (0, _textures.cover)(_fidosdk.imageService.getUrl((0, _playerutils.getVideoItemProgramImageId)(item), finalW, finalH, {
                    fit: _constants.IMAGE_FIT_SCALE_CROP,
                    quality: _constants.IMAGE_QUALITY,
                    format: _constants.DEFAULT_IMAGE_FORMAT
                }), finalW, finalH);
            }
        },
        {
            key: "_build",
            value: function _build() {
                this._index = 0;
                this._buttons = this.tag("ButtonsSection").children;
            }
        },
        {
            key: "_getFocused",
            value: function _getFocused() {
                return this._buttons[this._index];
            }
        },
        {
            key: "_handleRight",
            value: function _handleRight() {
                if (this._index < this._buttons.length - 1) {
                    this._setIndex(this._index + 1);
                    return true;
                }
                return false;
            }
        },
        {
            key: "_handleLeft",
            value: function _handleLeft() {
                if (this._index > 0) {
                    this._setIndex(this._index - 1);
                    return true;
                }
                return true;
            }
        },
        {
            key: "_handleEnter",
            value: function _handleEnter() {
                if (this._index === 1 && this._payload) {
                    this.signal(_popupContainerconstants.HIDE_POPUP_SIGNAL);
                    _lightningjsredux.default.dispatch((0, _ctaactions.createItemAction)(this._payload));
                } else {
                    this.signal(this._routeBackOnClose ? _popupContainerconstants.ROUTE_BACK_SIGNAL : _popupContainerconstants.HIDE_POPUP_SIGNAL);
                }
                return true;
            }
        },
        {
            key: "_handleBack",
            value: function _handleBack() {
                this.signal(this._routeBackOnClose ? _popupContainerconstants.ROUTE_BACK_SIGNAL : _popupContainerconstants.HIDE_POPUP_SIGNAL);
                return true;
            }
        },
        {
            key: "_setIndex",
            value: function _setIndex(value) {
                this._index = value;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                var _obj;
                return (0, _merge.default)((0, _ageGatePopupstyle.getInitialStyle)(), {
                    FlexContainer: {
                        IconWrapper: {
                            Icon: {
                                type: _iconcomponent.default
                            }
                        },
                        Title: {
                            text: {
                                text: (0, _i18n.t)("popups.ageGate.heading")
                            }
                        },
                        Description: {
                            text: {
                                text: (0, _i18n.t)("popups.ageGate.body")
                            }
                        },
                        ButtonsSection: {
                            CancelButton: {
                                type: _buttoncomponent.Button,
                                label: (0, _i18n.t)("global.cancel")
                            },
                            OkButton: {
                                type: _buttoncomponent.Button,
                                label: (0, _i18n.t)("global.continue")
                            }
                        }
                    },
                    passSignals: (_obj = {}, _define_property._(_obj, _popupContainerconstants.HIDE_POPUP_SIGNAL, true), _define_property._(_obj, _popupContainerconstants.ROUTE_BACK_SIGNAL, true), _obj)
                });
            }
        }
    ]);
    return AgeGatePopup;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 1591:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BUTTONS_MARGIN: function() {
        return BUTTONS_MARGIN;
    },
    BUTTONS_TOP_MARGIN: function() {
        return BUTTONS_TOP_MARGIN;
    },
    CONTENT_SIDE_MARGIN: function() {
        return CONTENT_SIDE_MARGIN;
    },
    CSA18_ICON: function() {
        return CSA18_ICON;
    },
    DESCRIPTION_TOP_MARGIN: function() {
        return DESCRIPTION_TOP_MARGIN;
    },
    ICON_SIZE: function() {
        return ICON_SIZE;
    },
    TITLE_TOP_MARGIN: function() {
        return TITLE_TOP_MARGIN;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getIconViewBox: function() {
        return getIconViewBox;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(3009);
var _memoize = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34736));
var _theme = __webpack_require__(51397);
var _typography = __webpack_require__(18411);
var _constants = __webpack_require__(34952);
var _style = __webpack_require__(65082);
var _sizes = __webpack_require__(82699);
var _colors = __webpack_require__(8426);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var CONTENT_SIDE_MARGIN = (_obj = {}, _define_property._(_obj, _constants.HD, 320), _define_property._(_obj, _constants.FULL_HD, 480), _obj);
var _obj1;
var TITLE_TOP_MARGIN = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 16), _define_property._(_obj1, _constants.FULL_HD, 24), _obj1);
var _obj2;
var DESCRIPTION_TOP_MARGIN = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 8), _define_property._(_obj2, _constants.FULL_HD, 16), _obj2);
var _obj3;
var BUTTONS_MARGIN = (_obj3 = {}, _define_property._(_obj3, _constants.HD, 8), _define_property._(_obj3, _constants.FULL_HD, 12), _obj3);
var _obj4;
var BUTTONS_TOP_MARGIN = (_obj4 = {}, _define_property._(_obj4, _constants.HD, 24), _define_property._(_obj4, _constants.FULL_HD, 32), _obj4);
var _obj5, _obj6;
var ICON_SIZE = {
    WIDTH: (_obj5 = {}, _define_property._(_obj5, _constants.HD, 60), _define_property._(_obj5, _constants.FULL_HD, 72), _obj5),
    HEIGHT: (_obj6 = {}, _define_property._(_obj6, _constants.HD, 60), _define_property._(_obj6, _constants.FULL_HD, 72), _obj6)
};
var CSA18_ICON = {
    name: "Csa18",
    type: "icon"
};
var getIconViewBox = (0, _memoize.default)(function(screenSize) {
    return {
        w: ICON_SIZE.WIDTH[screenSize],
        h: ICON_SIZE.HEIGHT[screenSize]
    };
});
var colors = {
    background: (0, _theme.makeThemeColor)(_theme.TERTIARY),
    darkering: (0, _theme.makeThemeColor)(_theme.TERTIARY, 0.8)
};
var getInitialStyle = (0, _memoize.default)(function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var screenSize = context.screenSize, colorMode = context.colorMode;
    var titleFont = (0, _typography.getFont)(_typography.FONT.KINSHASA_3, screenSize);
    var descriptionFont = (0, _typography.getFont)(_typography.FONT.OTTAWA_2, screenSize);
    var wordWrapWidth = _sizes.SCREEN_WIDTH[screenSize] - CONTENT_SIDE_MARGIN[screenSize] * 2;
    return {
        rect: true,
        color: colors.background[colorMode],
        h: _sizes.SCREEN_HEIGHT[screenSize],
        w: _sizes.SCREEN_WIDTH[screenSize],
        BackgroundPoster: {
            w: _sizes.identity,
            h: _sizes.identity
        },
        Darkering: {
            w: _sizes.identity,
            h: _sizes.identity,
            rect: true,
            color: colors.darkering[colorMode]
        },
        FlexContainer: {
            x: _sizes.middle,
            y: _sizes.middle,
            mountY: 0.5,
            flex: {
                direction: "column",
                justifyContent: "center"
            },
            IconWrapper: {
                rect: true,
                color: _colors.TRANSPARENT,
                mountX: 0.5,
                w: getIconViewBox(screenSize).w,
                h: getIconViewBox(screenSize).h,
                Icon: {
                    iconData: {
                        picto: CSA18_ICON,
                        viewBox: getIconViewBox(screenSize)
                    }
                }
            },
            Title: {
                flexItem: {
                    marginTop: TITLE_TOP_MARGIN[screenSize]
                },
                mountX: 0.5,
                text: _object_spread._({
                    textAlign: "center",
                    wordWrapWidth: wordWrapWidth,
                    maxLines: 2,
                    maxLinesSuffix: "..."
                }, titleFont)
            },
            Description: {
                flexItem: {
                    marginTop: DESCRIPTION_TOP_MARGIN[screenSize]
                },
                mountX: 0.5,
                text: _object_spread._({
                    textAlign: "center",
                    wordWrapWidth: wordWrapWidth
                }, descriptionFont)
            },
            ButtonsSection: {
                flexItem: {
                    marginTop: BUTTONS_TOP_MARGIN[screenSize]
                },
                flex: {
                    direction: "row",
                    justifyContent: "center"
                },
                mountX: 0.5,
                CancelButton: {
                    flexItem: {
                        marginRight: BUTTONS_MARGIN[screenSize]
                    },
                    colorMode: colorMode
                },
                OkButton: {
                    flexItem: {
                        marginLeft: BUTTONS_MARGIN[screenSize]
                    },
                    colorMode: colorMode
                }
            }
        }
    };
});


/***/ }),

/***/ 50572:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "BroadcastingLockPopup", ({
    enumerable: true,
    get: function() {
        return BroadcastingLockPopup;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _get = __webpack_require__(60528);
var _get_prototype_of = __webpack_require__(35196);
var _inherits = __webpack_require__(71648);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _create_super = __webpack_require__(6400);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
var _commonPopupcomponent = __webpack_require__(13883);
var BroadcastingLockPopup = /*#__PURE__*/ function(CommonPopup) {
    "use strict";
    _inherits._(BroadcastingLockPopup, CommonPopup);
    var _super = _create_super._(BroadcastingLockPopup);
    function BroadcastingLockPopup() {
        _class_call_check._(this, BroadcastingLockPopup);
        return _super.apply(this, arguments);
    }
    _create_class._(BroadcastingLockPopup, null, [
        {
            key: "_template",
            value: function _template() {
                return _object_spread_props._(_object_spread._({}, _get._(_get_prototype_of._(BroadcastingLockPopup), "_template", this).call(this)), {
                    title: "layout.locks.live.unavailableNotAiring"
                });
            }
        }
    ]);
    return BroadcastingLockPopup;
}(_commonPopupcomponent.CommonPopup);


/***/ }),

/***/ 13883:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "CommonPopup", ({
    enumerable: true,
    get: function() {
        return CommonPopup;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(88801);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _i18n = __webpack_require__(14910);
var _popupContainerconstants = __webpack_require__(54258);
var _commonPopupstyle = __webpack_require__(46963);
var _buttoncomponent = __webpack_require__(31464);
var _brandIconcomponent = __webpack_require__(362);
var _abstractPopupcomponent = __webpack_require__(77472);
var CommonPopup = /*#__PURE__*/ function(AbstractPopup) {
    "use strict";
    _inherits._(CommonPopup, AbstractPopup);
    var _super = _create_super._(CommonPopup);
    function CommonPopup() {
        _class_call_check._(this, CommonPopup);
        return _super.apply(this, arguments);
    }
    _create_class._(CommonPopup, [
        {
            key: "_active",
            value: function _active() {
                this.tag("OkButton").label = this._getCloseButtonCaption();
            }
        },
        {
            key: "_getFocused",
            value: function _getFocused() {
                return this.tag("OkButton");
            }
        },
        {
            key: "_handleEnter",
            value: function _handleEnter() {
                this.signal(this._getCloseActionSignal());
                return true;
            }
        },
        {
            key: "_getCloseButtonCaption",
            value: function _getCloseButtonCaption() {
                switch(this._getCloseActionSignal()){
                    case _popupContainerconstants.EXIT_APP_SIGNAL:
                        return (0, _i18n.t)("global.quit");
                    case _popupContainerconstants.ROUTE_BACK_SIGNAL:
                    default:
                        return (0, _i18n.t)("global.back");
                }
            }
        },
        {
            key: "title",
            set: function set(value) {
                this.tag("Title").text.text = (0, _i18n.t)(value);
            }
        },
        {
            key: "message",
            set: function set(value) {
                this.tag("Description").text.text = value;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                var _obj;
                return (0, _merge.default)((0, _commonPopupstyle.getInitialStyle)(), {
                    Icon: {
                        type: _brandIconcomponent.BrandIcon
                    },
                    FlexContainer: {
                        Title: {
                            text: {
                                text: (0, _i18n.t)("error.general")
                            }
                        },
                        OkButton: {
                            type: _buttoncomponent.Button,
                            label: (0, _i18n.t)("global.ok")
                        }
                    },
                    passSignals: (_obj = {}, _define_property._(_obj, _popupContainerconstants.HIDE_POPUP_SIGNAL, true), _define_property._(_obj, _popupContainerconstants.ROUTE_BACK_SIGNAL, true), _define_property._(_obj, _popupContainerconstants.EXIT_APP_SIGNAL, true), _obj)
                });
            }
        }
    ]);
    return CommonPopup;
}(_abstractPopupcomponent.AbstractPopup);


/***/ }),

/***/ 46963:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BUTTONS_TOP_MARGIN: function() {
        return BUTTONS_TOP_MARGIN;
    },
    CONTENT_SIDE_MARGIN: function() {
        return CONTENT_SIDE_MARGIN;
    },
    DESCRIPTION_TOP_MARGIN: function() {
        return DESCRIPTION_TOP_MARGIN;
    },
    LOGO_HEIGHT: function() {
        return LOGO_HEIGHT;
    },
    LOGO_OFFSET_TOP: function() {
        return LOGO_OFFSET_TOP;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(65759);
var _memoize = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34736));
var _theme = __webpack_require__(51397);
var _typography = __webpack_require__(18411);
var _constants = __webpack_require__(34952);
var _style = __webpack_require__(65082);
var _sizes = __webpack_require__(82699);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var CONTENT_SIDE_MARGIN = (_obj = {}, _define_property._(_obj, _constants.HD, 320), _define_property._(_obj, _constants.FULL_HD, 480), _obj);
var _obj1;
var DESCRIPTION_TOP_MARGIN = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 8), _define_property._(_obj1, _constants.FULL_HD, 16), _obj1);
var _obj2;
var BUTTONS_TOP_MARGIN = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 24), _define_property._(_obj2, _constants.FULL_HD, 32), _obj2);
var _obj3;
var LOGO_HEIGHT = (_obj3 = {}, _define_property._(_obj3, _constants.HD, 40), _define_property._(_obj3, _constants.FULL_HD, 56), _obj3);
var _obj4;
var LOGO_OFFSET_TOP = (_obj4 = {}, _define_property._(_obj4, _constants.HD, 40), _define_property._(_obj4, _constants.FULL_HD, 56), _obj4);
var colors = {
    background: (0, _theme.makeThemeColor)(_theme.TERTIARY)
};
var getInitialStyle = (0, _memoize.default)(function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var screenSize = context.screenSize, colorMode = context.colorMode;
    var titleFont = (0, _typography.getFont)(_typography.FONT.KINSHASA_3, screenSize);
    var descriptionFont = (0, _typography.getFont)(_typography.FONT.OTTAWA_2, screenSize);
    var wordWrapWidth = _sizes.SCREEN_WIDTH[screenSize] - CONTENT_SIDE_MARGIN[screenSize] * 2;
    return {
        rect: true,
        color: colors.background[colorMode],
        h: _sizes.SCREEN_HEIGHT[screenSize],
        w: _sizes.SCREEN_WIDTH[screenSize],
        Icon: {
            x: _sizes.middle,
            y: LOGO_OFFSET_TOP[screenSize],
            mountX: 0.5,
            textureScale: 1.5,
            h: LOGO_HEIGHT[screenSize]
        },
        FlexContainer: {
            x: _sizes.middle,
            y: _sizes.middle,
            mountY: 0.5,
            flex: {
                direction: "column",
                justifyContent: "center"
            },
            Title: {
                mountX: 0.5,
                text: _object_spread._({
                    textAlign: "center",
                    wordWrapWidth: wordWrapWidth,
                    maxLines: 5,
                    maxLinesSuffix: "..."
                }, titleFont)
            },
            Description: {
                flexItem: {
                    marginTop: DESCRIPTION_TOP_MARGIN[screenSize]
                },
                mountX: 0.5,
                text: _object_spread._({
                    textAlign: "center",
                    wordWrapWidth: wordWrapWidth
                }, descriptionFont)
            },
            OkButton: {
                flexItem: {
                    marginTop: BUTTONS_TOP_MARGIN[screenSize]
                },
                mountX: 0.5,
                colorMode: colorMode
            }
        }
    };
});


/***/ }),

/***/ 68521:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "ContentRatingLockPopup", ({
    enumerable: true,
    get: function() {
        return ContentRatingLockPopup;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _get = __webpack_require__(60528);
var _get_prototype_of = __webpack_require__(35196);
var _inherits = __webpack_require__(71648);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _create_super = __webpack_require__(6400);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(65759);
var _commonPopupcomponent = __webpack_require__(13883);
var ContentRatingLockPopup = /*#__PURE__*/ function(CommonPopup) {
    "use strict";
    _inherits._(ContentRatingLockPopup, CommonPopup);
    var _super = _create_super._(ContentRatingLockPopup);
    function ContentRatingLockPopup() {
        _class_call_check._(this, ContentRatingLockPopup);
        return _super.apply(this, arguments);
    }
    _create_class._(ContentRatingLockPopup, null, [
        {
            key: "_template",
            value: function _template() {
                return _object_spread_props._(_object_spread._({}, _get._(_get_prototype_of._(ContentRatingLockPopup), "_template", this).call(this)), {
                    title: "layout.locks.contentRating.message"
                });
            }
        }
    ]);
    return ContentRatingLockPopup;
}(_commonPopupcomponent.CommonPopup);


/***/ }),

/***/ 73545:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "CSLLockPopup", ({
    enumerable: true,
    get: function() {
        return CSLLockPopup;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _get = __webpack_require__(60528);
var _get_prototype_of = __webpack_require__(35196);
var _inherits = __webpack_require__(71648);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _create_super = __webpack_require__(6400);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(3009);
var _commonPopupcomponent = __webpack_require__(13883);
var _i18n = __webpack_require__(14910);
var CSLLockPopup = /*#__PURE__*/ function(CommonPopup) {
    "use strict";
    _inherits._(CSLLockPopup, CommonPopup);
    var _super = _create_super._(CSLLockPopup);
    function CSLLockPopup() {
        _class_call_check._(this, CSLLockPopup);
        return _super.apply(this, arguments);
    }
    _create_class._(CSLLockPopup, null, [
        {
            key: "_template",
            value: function _template() {
                return _object_spread_props._(_object_spread._({}, _get._(_get_prototype_of._(CSLLockPopup), "_template", this).call(this)), {
                    title: (0, _i18n.t)("error.csl")
                });
            }
        }
    ]);
    return CSLLockPopup;
}(_commonPopupcomponent.CommonPopup);


/***/ }),

/***/ 89480:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "ExitPopup", ({
    enumerable: true,
    get: function() {
        return ExitPopup;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _create_super = __webpack_require__(6400);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(52318);
var _sdk = __webpack_require__(29956);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _theme = __webpack_require__(51397);
var _sizes = __webpack_require__(82699);
var _buttoncomponent = __webpack_require__(31464);
var _i18n = __webpack_require__(14910);
var _exitPopupstyle = __webpack_require__(87630);
var _popupContainerconstants = __webpack_require__(54258);
var _iconcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(70160));
var _buttonRectanglecomponent = __webpack_require__(89813);
var ExitPopup = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(ExitPopup, _Lightning_Component);
    var _super = _create_super._(ExitPopup);
    function ExitPopup() {
        _class_call_check._(this, ExitPopup);
        return _super.apply(this, arguments);
    }
    _create_class._(ExitPopup, [
        {
            key: "_attach",
            value: function _attach() {
                var _this = this;
                var icon = this.tag("Popup").tag("Icon");
                var handleUpdate = function() {
                    _this.patch(_object_spread._({}, (0, _exitPopupstyle.getFinalStyle)()));
                };
                icon.on("txLoaded", handleUpdate);
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                this.tag("Popup").tag("Icon").removeAllListeners("txLoaded");
            }
        },
        {
            key: "_build",
            value: function _build() {
                this._index = 0;
                this._actionTypes = [
                    _popupContainerconstants.EXIT_APP_SIGNAL,
                    _popupContainerconstants.HIDE_POPUP_SIGNAL
                ];
                this._buttons = this.tag("Popup").tag("ButtonsFlexContainer").children;
            }
        },
        {
            key: "_getFocused",
            value: function _getFocused() {
                return this._buttons[this._index];
            }
        },
        {
            key: "_handleRight",
            value: function _handleRight() {
                if (this._index < this._buttons.length - 1) {
                    this._setIndex(this._index + 1);
                    return true;
                }
                return false;
            }
        },
        {
            key: "_handleLeft",
            value: function _handleLeft() {
                if (this._index > 0) {
                    this._setIndex(this._index - 1);
                    return true;
                }
                return true;
            }
        },
        {
            key: "_handleEnter",
            value: function _handleEnter() {
                this.signal(this._actionTypes[this._index]);
            }
        },
        {
            key: "_setIndex",
            value: function _setIndex() {
                var index = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._index;
                this._index = index;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                var _obj;
                return (0, _merge.default)({
                    w: _sizes.identity,
                    h: _sizes.identity,
                    Overlay: {},
                    Popup: {
                        type: _buttonRectanglecomponent.ButtonRectangle,
                        Icon: {
                            type: _iconcomponent.default
                        },
                        Title: {
                            text: {
                                text: (0, _i18n.t)("global.confirmExit")
                            }
                        },
                        ButtonsFlexContainer: {
                            ExitButton: {
                                type: _buttoncomponent.Button,
                                label: (0, _i18n.t)("global.ok"),
                                colorMode: _theme.DARK_MODE
                            },
                            CancelButton: {
                                type: _buttoncomponent.Button,
                                label: (0, _i18n.t)("global.cancel"),
                                colorMode: _theme.DARK_MODE
                            }
                        }
                    },
                    passSignals: (_obj = {}, _define_property._(_obj, _popupContainerconstants.EXIT_APP_SIGNAL, true), _define_property._(_obj, _popupContainerconstants.HIDE_POPUP_SIGNAL, true), _obj)
                }, (0, _exitPopupstyle.getInitialStyle)());
            }
        }
    ]);
    return ExitPopup;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 87630:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BORDER_RADIUS: function() {
        return BORDER_RADIUS;
    },
    BUTTONS_OFFSET: function() {
        return BUTTONS_OFFSET;
    },
    FLEX_CONTAINER_HEIGHT: function() {
        return FLEX_CONTAINER_HEIGHT;
    },
    ICON_HEIGHT: function() {
        return ICON_HEIGHT;
    },
    ICON_OFFSET: function() {
        return ICON_OFFSET;
    },
    INFO_ICON: function() {
        return INFO_ICON;
    },
    POPUP_HEIGHT: function() {
        return POPUP_HEIGHT;
    },
    POPUP_WIDTH: function() {
        return POPUP_WIDTH;
    },
    TEXT_OFFSET: function() {
        return TEXT_OFFSET;
    },
    TITLE_HEIGHT: function() {
        return TITLE_HEIGHT;
    },
    TITLE_WIDTH: function() {
        return TITLE_WIDTH;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getFinalStyle: function() {
        return getFinalStyle;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    titleFont: function() {
        return titleFont;
    }
});
var _define_property = __webpack_require__(21228);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(3009);
var _constants = __webpack_require__(34952);
var _theme = __webpack_require__(51397);
var _typography = __webpack_require__(18411);
var _style = __webpack_require__(65082);
var _sizes = __webpack_require__(82699);
var _colors = __webpack_require__(8426);
var titleFont = (0, _typography.getFont)(_typography.FONT.OTTAWA_1);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var colors = {
    popup: (0, _theme.makeThemeColor)(_theme.TERTIARY),
    popupOverlay: (0, _theme.makeThemeColor)(_theme.TERTIARY, 0.8),
    text: (0, _theme.makeThemeColor)(_theme.PRIMARY)
};
var _obj;
var POPUP_WIDTH = (_obj = {}, _define_property._(_obj, _constants.HD, 672), _define_property._(_obj, _constants.FULL_HD, 960), _obj);
var _obj1;
var POPUP_HEIGHT = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 196), _define_property._(_obj1, _constants.FULL_HD, 232), _obj1);
var _obj2;
var TITLE_WIDTH = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 512), _define_property._(_obj2, _constants.FULL_HD, 776), _obj2);
var _obj3;
var TITLE_HEIGHT = (_obj3 = {}, _define_property._(_obj3, _constants.HD, 30), _define_property._(_obj3, _constants.FULL_HD, 36), _obj3);
var _obj4;
var FLEX_CONTAINER_HEIGHT = (_obj4 = {}, _define_property._(_obj4, _constants.HD, 41), _define_property._(_obj4, _constants.FULL_HD, 56), _obj4);
var _obj5;
var ICON_OFFSET = (_obj5 = {}, _define_property._(_obj5, _constants.HD, 24), _define_property._(_obj5, _constants.FULL_HD, 24), _obj5);
var _obj6;
var TEXT_OFFSET = (_obj6 = {}, _define_property._(_obj6, _constants.HD, 8), _define_property._(_obj6, _constants.FULL_HD, 8), _obj6);
var _obj7;
var BUTTONS_OFFSET = (_obj7 = {}, _define_property._(_obj7, _constants.HD, 16), _define_property._(_obj7, _constants.FULL_HD, 24), _obj7);
var _obj8;
var ICON_HEIGHT = (_obj8 = {}, _define_property._(_obj8, _constants.HD, 40), _define_property._(_obj8, _constants.FULL_HD, 48), _obj8);
var _obj9;
var BORDER_RADIUS = (_obj9 = {}, _define_property._(_obj9, _constants.HD, 24), _define_property._(_obj9, _constants.FULL_HD, 40), _obj9);
var INFO_ICON = {
    name: "Warning",
    type: "icon"
};
var getInitialStyle = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext, screenSize = _ref.screenSize, colorMode = _ref.colorMode;
    return {
        Overlay: {
            rect: true,
            w: _sizes.SCREEN_WIDTH[screenSize],
            h: _sizes.SCREEN_HEIGHT[screenSize],
            color: _colors.TRANSPARENT
        },
        Popup: {
            rect: true,
            x: _sizes.SCREEN_WIDTH[screenSize] / 2 - POPUP_WIDTH[screenSize] / 2,
            y: _sizes.SCREEN_HEIGHT[screenSize] / 2 - POPUP_HEIGHT[screenSize] / 2,
            w: POPUP_WIDTH[screenSize],
            h: POPUP_HEIGHT[screenSize],
            borderRadius: BORDER_RADIUS[screenSize],
            flex: {
                direction: "column"
            },
            color: _colors.TRANSPARENT,
            Icon: {
                flexItem: {
                    marginTop: ICON_OFFSET[screenSize]
                },
                mountX: 0.5,
                x: _sizes.middle,
                color: colors.text[colorMode],
                iconData: {
                    picto: INFO_ICON,
                    viewBox: {
                        h: ICON_HEIGHT[screenSize]
                    }
                }
            },
            Title: {
                visible: false,
                flexItem: {
                    marginTop: TEXT_OFFSET[screenSize]
                },
                mountX: 0.5,
                x: _sizes.middle,
                text: _object_spread_props._(_object_spread._({
                    textColor: colors.text[colorMode]
                }, titleFont), {
                    verticalAlign: "middle",
                    maxLines: 1
                })
            },
            ButtonsFlexContainer: {
                rect: true,
                visible: false,
                h: FLEX_CONTAINER_HEIGHT[screenSize],
                w: _sizes.identity,
                flexItem: {
                    marginTop: BUTTONS_OFFSET[screenSize]
                },
                color: _colors.TRANSPARENT,
                flex: {
                    direction: "row",
                    justifyContent: "center"
                },
                ExitButton: {
                    flexItem: {
                        marginRight: BUTTONS_OFFSET[screenSize]
                    }
                }
            }
        }
    };
};
var getFinalStyle = function() {
    var colorMode = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext).colorMode;
    return {
        Overlay: {
            color: colors.popupOverlay[colorMode]
        },
        Popup: {
            color: colors.popup[colorMode],
            Title: {
                visible: true
            },
            ButtonsFlexContainer: {
                visible: true
            }
        }
    };
};


/***/ }),

/***/ 37964:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "FreemiumLockPopup", ({
    enumerable: true,
    get: function() {
        return FreemiumLockPopup;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _get = __webpack_require__(60528);
var _get_prototype_of = __webpack_require__(35196);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(45538);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _i18n = __webpack_require__(14910);
var _popupContainerconstants = __webpack_require__(54258);
var _subscriptionExpiredcomponent = __webpack_require__(7394);
var FreemiumLockPopup = /*#__PURE__*/ function(SubscriptionExpired) {
    "use strict";
    _inherits._(FreemiumLockPopup, SubscriptionExpired);
    var _super = _create_super._(FreemiumLockPopup);
    function FreemiumLockPopup() {
        _class_call_check._(this, FreemiumLockPopup);
        return _super.apply(this, arguments);
    }
    _create_class._(FreemiumLockPopup, [
        {
            key: "routeBackOnClose",
            set: function set(value) {
                this._routeBackOnClose = value;
            }
        },
        {
            key: "_handleEnter",
            value: function _handleEnter() {
                this.signal(this._getCloseActionSignal());
                return true;
            }
        },
        {
            key: "_getCloseActionSignal",
            value: function _getCloseActionSignal() {
                if (this._checkHistoryAvailable()) {
                    return _popupContainerconstants.ROUTE_BACK_SIGNAL;
                }
                return _popupContainerconstants.HIDE_POPUP_SIGNAL;
            }
        },
        {
            key: "_checkHistoryAvailable",
            value: function _checkHistoryAvailable() {
                return this._routeBackOnClose && _sdk.Router.getHistory().length > 0;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                var _obj;
                return (0, _merge.default)(_get._(_get_prototype_of._(FreemiumLockPopup), "_template", this).call(this), {
                    Content: {
                        ChangeButton: {
                            label: (0, _i18n.t)("global.close")
                        }
                    },
                    passSignals: (_obj = {}, _define_property._(_obj, _popupContainerconstants.HIDE_POPUP_SIGNAL, true), _define_property._(_obj, _popupContainerconstants.ROUTE_BACK_SIGNAL, true), _obj)
                });
            }
        }
    ]);
    return FreemiumLockPopup;
}(_subscriptionExpiredcomponent.SubscriptionExpired);


/***/ }),

/***/ 32642:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "GeoBlockPopup", ({
    enumerable: true,
    get: function() {
        return GeoBlockPopup;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(88801);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _geoBlockPopupstyle = __webpack_require__(94845);
var _i18n = __webpack_require__(14910);
var _buttoncomponent = __webpack_require__(31464);
var _popupContainerconstants = __webpack_require__(54258);
var _brandIconcomponent = __webpack_require__(362);
var GeoBlockPopup = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(GeoBlockPopup, _Lightning_Component);
    var _super = _create_super._(GeoBlockPopup);
    function GeoBlockPopup() {
        _class_call_check._(this, GeoBlockPopup);
        return _super.apply(this, arguments);
    }
    _create_class._(GeoBlockPopup, [
        {
            key: "_getFocused",
            value: function _getFocused() {
                return this.tag("OkButton");
            }
        },
        {
            key: "_handleEnter",
            value: function _handleEnter() {
                return this._handleExitPopup();
            }
        },
        {
            key: "_handleBack",
            value: function _handleBack() {
                return this._handleExitPopup();
            }
        },
        {
            key: "_handleExitPopup",
            value: function _handleExitPopup() {
                // TODO check app exit or route back in case if deeplinking will be added
                this.signal(_popupContainerconstants.ROUTE_BACK_SIGNAL);
                return true;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)((0, _geoBlockPopupstyle.getInitialStyle)(), {
                    FlexContainer: {
                        Icon: {
                            type: _brandIconcomponent.BrandIcon
                        },
                        Description: {
                            text: {
                                text: (0, _i18n.t)("layout.locks.geoBlocked.message")
                            }
                        },
                        OkButton: {
                            type: _buttoncomponent.Button,
                            label: (0, _i18n.t)("global.close")
                        }
                    },
                    passSignals: _define_property._({}, _popupContainerconstants.ROUTE_BACK_SIGNAL, true)
                });
            }
        }
    ]);
    return GeoBlockPopup;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 94845:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BUTTONS_TOP_MARGIN: function() {
        return BUTTONS_TOP_MARGIN;
    },
    CONTENT_SIDE_MARGIN: function() {
        return CONTENT_SIDE_MARGIN;
    },
    DESCRIPTION_TOP_MARGIN: function() {
        return DESCRIPTION_TOP_MARGIN;
    },
    LOGO_HEIGHT: function() {
        return LOGO_HEIGHT;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(42578);
var _memoize = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34736));
var _theme = __webpack_require__(51397);
var _typography = __webpack_require__(18411);
var _constants = __webpack_require__(34952);
var _style = __webpack_require__(65082);
var _sizes = __webpack_require__(82699);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var CONTENT_SIDE_MARGIN = (_obj = {}, _define_property._(_obj, _constants.HD, 320), _define_property._(_obj, _constants.FULL_HD, 480), _obj);
var _obj1;
var DESCRIPTION_TOP_MARGIN = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 8), _define_property._(_obj1, _constants.FULL_HD, 16), _obj1);
var _obj2;
var BUTTONS_TOP_MARGIN = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 40), _define_property._(_obj2, _constants.FULL_HD, 40), _obj2);
var _obj3;
var LOGO_HEIGHT = (_obj3 = {}, _define_property._(_obj3, _constants.HD, 56), _define_property._(_obj3, _constants.FULL_HD, 96), _obj3);
var colors = {
    background: (0, _theme.makeThemeColor)(_theme.TERTIARY)
};
var getInitialStyle = (0, _memoize.default)(function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var screenSize = context.screenSize, colorMode = context.colorMode;
    var descriptionFont = (0, _typography.getFont)(_typography.FONT.OTTAWA_2, screenSize);
    var wordWrapWidth = _sizes.SCREEN_WIDTH[screenSize] - CONTENT_SIDE_MARGIN[screenSize] * 2;
    return {
        rect: true,
        color: colors.background[colorMode],
        h: _sizes.SCREEN_HEIGHT[screenSize],
        w: _sizes.SCREEN_WIDTH[screenSize],
        FlexContainer: {
            x: _sizes.middle,
            y: _sizes.middle,
            mountY: 0.5,
            flex: {
                direction: "column",
                justifyContent: "center"
            },
            Icon: {
                mountX: 0.5,
                textureScale: 1.5,
                h: LOGO_HEIGHT[screenSize]
            },
            Description: {
                flexItem: {
                    marginTop: DESCRIPTION_TOP_MARGIN[screenSize]
                },
                mountX: 0.5,
                text: _object_spread._({
                    textAlign: "center",
                    wordWrapWidth: wordWrapWidth
                }, descriptionFont)
            },
            OkButton: {
                flexItem: {
                    marginTop: BUTTONS_TOP_MARGIN[screenSize]
                },
                mountX: 0.5,
                colorMode: colorMode
            }
        }
    };
});


/***/ }),

/***/ 81103:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "GridPopup", ({
    enumerable: true,
    get: function() {
        return GridPopup;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _create_super = __webpack_require__(6400);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(42578);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _constants = __webpack_require__(34952);
var _gridcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(36997));
var _sizes = __webpack_require__(82699);
var _signals = __webpack_require__(2109);
var _virtualization = __webpack_require__(11559);
var _layoutactions = __webpack_require__(8424);
var _popupContainerconstants = __webpack_require__(54258);
var _ctaactions = __webpack_require__(32067);
var _gridPopupstyle = __webpack_require__(69699);
var _gridPopupconnect = /*#__PURE__*/ _interop_require_default._(__webpack_require__(89776));
var GridPopup = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(GridPopup, _Lightning_Component);
    var _super = _create_super._(GridPopup);
    function GridPopup() {
        _class_call_check._(this, GridPopup);
        return _super.apply(this, arguments);
    }
    _create_class._(GridPopup, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _gridPopupstyle.defaultContext;
                this._blockIndex = undefined;
            }
        },
        {
            key: "_active",
            value: function _active() {
                this._unsubscribe = (0, _gridPopupconnect.default)(this);
            }
        },
        {
            key: "_inactive",
            value: function _inactive() {
                if (this._unsubscribe) {
                    this._unsubscribe();
                }
                this._layout = undefined;
                this._block = undefined;
            }
        },
        {
            key: "layout",
            set: function set(value) {
                if (!value) {
                    return;
                }
                this._layout = value;
                this._renderGrid();
            }
        },
        {
            key: "block",
            set: function set(value) {
                if (!value) {
                    return;
                }
                this._block = value;
                this._renderGrid();
            }
        },
        {
            key: "_renderGrid",
            value: function _renderGrid() {
                if (!this._layout || !this._block || !Number.isFinite(this._block.blockIndex)) {
                    return;
                }
                var screenSize = this._style.screenSize;
                var view = this.tag("Grid");
                var block = this._layout.blocks[this._block.blockIndex];
                var w = _sizes.SCREEN_WIDTH[screenSize] - _constants.safetyMargins.horizontal[screenSize];
                var h = _sizes.SCREEN_HEIGHT[screenSize];
                if (view.data) {
                    view.data = _object_spread_props._(_object_spread._({}, this._block), {
                        rowSize: {
                            w: w,
                            h: h
                        },
                        blockIndex: 0,
                        block: block,
                        showAllItems: true
                    });
                    return;
                }
                var itemSize = this._block.itemSize;
                var blockSize = _gridcomponent.default.getOffsetsByBlockData({
                    data: block,
                    blockIndex: 0,
                    showAllItems: true
                });
                var rowsCount = _gridcomponent.default.getRowCount({
                    content: block.content,
                    showAllItems: true
                }, screenSize);
                var gap = _gridcomponent.default.getContentGap(screenSize);
                var rowSize = itemSize.h + gap;
                var halfOfScreenHeight = Math.round(h / 2);
                var halfOfRowSize = Math.round(rowSize / 2);
                var offset = 0;
                this._positions = [];
                this._index = 0;
                for(var i = 0; i < rowsCount; i += 1){
                    this._positions.push(Math.min(halfOfScreenHeight - halfOfRowSize - blockSize.top - offset, 0));
                    offset += rowSize;
                }
                if (this._positions.length && offset > h) {
                    var minOffset = h - offset - _constants.safetyMargins.vertical[screenSize] - blockSize.top - gap;
                    this._positions = this._positions.map(function(y) {
                        return Math.max(minOffset, y);
                    });
                }
                view.data = _object_spread_props._(_object_spread._({}, this._block), {
                    rowSize: {
                        w: w,
                        h: h
                    },
                    block: block,
                    blockIndex: 0,
                    showAllItems: true
                });
            }
        },
        {
            key: "_handlePortionRequest",
            value: function _handlePortionRequest(portion) {
                _lightningjsredux.default.dispatch((0, _layoutactions.fetchBlockPage)(portion));
            }
        },
        {
            key: "_handleSelected",
            value: function _handleSelected(item) {
                if (item && item.id && item.id !== _virtualization.PLACEHOLDER.id) {
                    this.signal(_popupContainerconstants.HIDE_POPUP_SIGNAL);
                    _lightningjsredux.default.dispatch((0, _ctaactions.createItemAction)({
                        item: item
                    }));
                }
            }
        },
        {
            key: "_setIndex",
            value: function _setIndex() {
                var index = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._index;
                var position = this._positions[index];
                if (!Number.isFinite(position)) {
                    return;
                }
                this._index = index;
                this.tag("Grid").setSmooth("y", position);
            }
        },
        {
            key: "_getFocused",
            value: function _getFocused() {
                return this.tag("Grid");
            }
        },
        {
            key: "_handleUp",
            value: function _handleUp() {
                if (this._index > 0) {
                    this._setIndex(this._index - 1);
                }
                return true;
            }
        },
        {
            key: "_handleDown",
            value: function _handleDown() {
                if (this._index < this._positions.length - 1) {
                    this._setIndex(this._index + 1);
                }
                return true;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                var _obj;
                return (0, _merge.default)({
                    rect: true,
                    passSignals: _define_property._({}, _popupContainerconstants.HIDE_POPUP_SIGNAL, true),
                    Grid: {
                        type: _gridcomponent.default,
                        signals: (_obj = {}, _define_property._(_obj, _signals.PORTION_REQUESTED_SIGNAL, "_handlePortionRequest"), _define_property._(_obj, _signals.SELECTED_SIGNAL, "_handleSelected"), _obj)
                    }
                }, (0, _gridPopupstyle.getInitialStyle)());
            }
        }
    ]);
    return GridPopup;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 89776:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(37815);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _layoutselectors = __webpack_require__(53368);
var mapControllers = function(instance) {
    return [
        {
            selector: _layoutselectors.getCurrentLayout,
            shouldBeInvokedOnConnect: true,
            callback: function(value) {
                instance.layout = value;
            }
        }
    ];
};
var _default = _lightningjsredux.default.control(mapControllers);


/***/ }),

/***/ 69699:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(42578);
var _constants = __webpack_require__(34952);
var _theme = __webpack_require__(51397);
var _style = __webpack_require__(65082);
var _sizes = __webpack_require__(82699);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var colors = {
    background: (0, _theme.makeThemeColor)(_theme.TERTIARY)
};
var getInitialStyle = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext, screenSize = _ref.screenSize, colorMode = _ref.colorMode;
    var w = _sizes.SCREEN_WIDTH[screenSize];
    var h = _sizes.SCREEN_HEIGHT[screenSize];
    return {
        w: w,
        h: h,
        color: colors.background[colorMode],
        Grid: {
            // w,
            // h,
            x: _constants.safetyMargins.horizontal[screenSize]
        }
    };
};


/***/ }),

/***/ 91322:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "getPopupByID", ({
    enumerable: true,
    get: function() {
        return getPopupByID;
    }
}));
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
var _exitPopupcomponent = __webpack_require__(89480);
var _commonPopupcomponent = __webpack_require__(13883);
var _ageGatePopupcomponent = __webpack_require__(57414);
var _geoBlockPopupcomponent = __webpack_require__(32642);
var _profilesGatePopupcomponent = __webpack_require__(54340);
var _kidsLeavePopupcomponent = __webpack_require__(40261);
var _parentalCodecomponent = __webpack_require__(60458);
var _cslLockPopupcomponent = __webpack_require__(73545);
var _gridPopupcomponent = __webpack_require__(81103);
var _contentRatingLockPopupcomponent = __webpack_require__(68521);
var _parentalFilterPopupLockcomponent = __webpack_require__(29339);
var _maxParentalCodePopupcomponent = __webpack_require__(7918);
var _popupsconstants = __webpack_require__(60952);
var _broadcastingLockPopupcomponent = __webpack_require__(50572);
var _freemiumLockPopupcomponent = __webpack_require__(37964);
var _epgPopupcomponent = __webpack_require__(70059);
var _subscriptionPopupcomponent = __webpack_require__(46954);
var _programCardcomponent = __webpack_require__(79961);
var _accountCompletionPopupcomponent = __webpack_require__(10879);
var getPopupByID = function(id) {
    var popup = {};
    switch(id){
        case _popupsconstants.GEO_BLOCK_POPUP_ID:
            popup = {
                type: _geoBlockPopupcomponent.GeoBlockPopup
            };
            break;
        case _popupsconstants.AGE_GATE_POPUP_ID:
            popup = {
                type: _ageGatePopupcomponent.AgeGatePopup,
                routeBackOnClose: true
            };
            break;
        case _popupsconstants.PROFILES_GATE_POPUP_ID:
            popup = {
                type: _profilesGatePopupcomponent.ProfilesGatePopup
            };
            break;
        case _popupsconstants.KIDS_LEAVE_POPUP_ID:
            popup = {
                type: _kidsLeavePopupcomponent.KidsLeave
            };
            break;
        case _popupsconstants.EXIT_POPUP_ID:
            popup = {
                type: _exitPopupcomponent.ExitPopup
            };
            break;
        case _popupsconstants.FATAL_ERROR_POPUP_ID:
            popup = {
                type: _commonPopupcomponent.CommonPopup,
                routeBackOnClose: true,
                exitAppOnClose: true
            };
            break;
        case _popupsconstants.BROADCASTING_LOCK_POPUP_ID:
            popup = {
                type: _broadcastingLockPopupcomponent.BroadcastingLockPopup
            };
            break;
        case _popupsconstants.FREEMIUM_LOCK_POPUP_ID:
            popup = {
                type: _freemiumLockPopupcomponent.FreemiumLockPopup
            };
            break;
        case _popupsconstants.PARENTAL_CODE_POPUP_ID:
            popup = {
                type: _parentalCodecomponent.ParentalCode
            };
            break;
        case _popupsconstants.CSL_BLOCK_POPUP_ID:
            popup = {
                type: _cslLockPopupcomponent.CSLLockPopup,
                routeBackOnClose: true
            };
            break;
        case _popupsconstants.EPG_POPUP_ID:
            popup = {
                type: _epgPopupcomponent.EpgPopup
            };
            break;
        case _popupsconstants.EPG_LAYOUT_POPUP_ID:
            popup = {
                type: _programCardcomponent.ProgramCard
            };
            break;
        case _popupsconstants.GRID_POPUP_ID:
            popup = {
                type: _gridPopupcomponent.GridPopup
            };
            break;
        case _popupsconstants.SUBSCRIPTION_POPUP_ID:
            popup = {
                type: _subscriptionPopupcomponent.SubscriptionPopup
            };
            break;
        case _popupsconstants.ACCOUNT_COMPLETION_POPUP_ID:
            popup = {
                type: _accountCompletionPopupcomponent.AccountCompletionPopup
            };
            break;
        case _popupsconstants.CONTENT_RATING_POPUP_ID:
            popup = {
                type: _contentRatingLockPopupcomponent.ContentRatingLockPopup
            };
            break;
        case _popupsconstants.PARENTAL_FILTER_POPUP_ID:
            popup = {
                type: _parentalFilterPopupLockcomponent.ParentalFilterPopupLock
            };
            break;
        case _popupsconstants.MAX_PARENTAL_CODE_POPUP_ID:
            popup = {
                type: _maxParentalCodePopupcomponent.MaxParentalCodePopup
            };
            break;
        case _popupsconstants.COMMON_POPUP_ID:
        default:
            popup = {
                type: _commonPopupcomponent.CommonPopup
            };
            break;
    }
    popup.popupId = id;
    return popup;
};


/***/ }),

/***/ 40261:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "KidsLeave", ({
    enumerable: true,
    get: function() {
        return KidsLeave;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(45538);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _set = /*#__PURE__*/ _interop_require_default._(__webpack_require__(35609));
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _sdk = __webpack_require__(29956);
var _kidsLeavePopupstyle = __webpack_require__(36940);
var _buttoncomponent = __webpack_require__(31464);
var _i18n = __webpack_require__(14910);
var _passwordcomponent = __webpack_require__(94017);
var _kidsLeavePopuputils = __webpack_require__(14349);
var _keyboardNumberscomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(21498));
var _keyboardconstants = __webpack_require__(20190);
var _kidsLeavePopupconstant = __webpack_require__(4607);
var _popupContainerconstants = __webpack_require__(54258);
var _ctaactions = __webpack_require__(32067);
var KidsLeave = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(KidsLeave, _Lightning_Component);
    var _super = _create_super._(KidsLeave);
    function KidsLeave() {
        _class_call_check._(this, KidsLeave);
        return _super.apply(this, arguments);
    }
    _create_class._(KidsLeave, [
        {
            key: "payload",
            set: function set(value) {
                this._payload = value;
            }
        },
        {
            key: "isEmptyPassword",
            get: function get() {
                return this.password === "";
            }
        },
        {
            key: "isAllPassword",
            get: function get() {
                return this.password.length === _kidsLeavePopupconstant.PASSWORD_LENGTH;
            }
        },
        {
            key: "_init",
            value: function _init() {
                this.generatedPassword = (0, _kidsLeavePopuputils.generatePassword)(_kidsLeavePopupconstant.PASSWORD_LENGTH);
                this.password = "";
                this.tag("Keyboard").renderKeyboard(_kidsLeavePopupconstant.passwordCharacters);
                this.tag("PasswordBlock").setPasswordText(this.generatedPassword);
                this._setState("Keyboard");
            }
        },
        {
            key: "_handleSelectedLetter",
            value: function _handleSelectedLetter(letter) {
                if (this.isEmptyPassword) this._resetPasswordView();
                this._updatePassword(letter);
                if (this.isAllPassword) this._validatePassword();
            }
        },
        {
            key: "_updatePassword",
            value: function _updatePassword(value) {
                this.tag("PasswordBlock").push(value);
                this.password += value;
            }
        },
        {
            key: "_validatePassword",
            value: function _validatePassword() {
                if (this.generatedPassword === this.password) {
                    (0, _set.default)(this._payload, "item.action.target.value_layout.type", "profilesgate");
                    this.signal(_popupContainerconstants.HIDE_POPUP_SIGNAL);
                    _lightningjsredux.default.dispatch((0, _ctaactions.createItemAction)(this._payload));
                    return;
                }
                this.password = "";
                this._showException();
            }
        },
        {
            key: "_resetPasswordView",
            value: function _resetPasswordView() {
                this.tag("PasswordBlock").clearPasswordInput();
                this._hideException();
            }
        },
        {
            key: "_handleEnter",
            value: function _handleEnter() {
                this.signal(_popupContainerconstants.HIDE_POPUP_SIGNAL);
                return true;
            }
        },
        {
            key: "_showException",
            value: function _showException() {
                this.tag("Exception").alpha = 1;
            }
        },
        {
            key: "_hideException",
            value: function _hideException() {
                this.tag("Exception").alpha = 0;
            }
        },
        {
            key: "_handleDown",
            value: function _handleDown() {
                this._setState("Keyboard");
                return false;
            }
        },
        {
            key: "_handleUp",
            value: function _handleUp() {
                this._setState("Button");
                return false;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Background: {
                        rect: true
                    },
                    Button: {
                        type: _buttoncomponent.Button,
                        label: (0, _i18n.t)("global.back")
                    },
                    Content: {
                        Title: {
                            text: {
                                text: (0, _i18n.t)("leavingKidsSection.title")
                            }
                        },
                        PasswordBlock: {
                            type: _passwordcomponent.Password
                        },
                        Exception: {
                            text: {
                                text: (0, _i18n.t)("leavingKidsSection.wrongCode")
                            }
                        },
                        Keyboard: {
                            type: _keyboardNumberscomponent.default,
                            signals: _define_property._({}, _keyboardconstants.LETTER_SELECTED_SIGNAL, "_handleSelectedLetter")
                        }
                    },
                    passSignals: _define_property._({}, _popupContainerconstants.HIDE_POPUP_SIGNAL, true)
                }, (0, _kidsLeavePopupstyle.getInitialStyle)());
            }
        },
        {
            key: "_states",
            value: function _states() {
                return [
                    /*#__PURE__*/ function(_this) {
                        _inherits._(Keyboard, _this);
                        var _super = _create_super._(Keyboard);
                        function Keyboard() {
                            _class_call_check._(this, Keyboard);
                            return _super.apply(this, arguments);
                        }
                        _create_class._(Keyboard, [
                            {
                                key: "_getFocused",
                                value: function _getFocused() {
                                    return this.tag("Keyboard");
                                }
                            }
                        ]);
                        return Keyboard;
                    }(this),
                    /*#__PURE__*/ function(_this) {
                        _inherits._(Button, _this);
                        var _super = _create_super._(Button);
                        function Button() {
                            _class_call_check._(this, Button);
                            return _super.apply(this, arguments);
                        }
                        _create_class._(Button, [
                            {
                                key: "_getFocused",
                                value: function _getFocused() {
                                    return this.tag("Button");
                                }
                            }
                        ]);
                        return Button;
                    }(this)
                ];
            }
        }
    ]);
    return KidsLeave;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 4607:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    PASSWORD_LENGTH: function() {
        return PASSWORD_LENGTH;
    },
    numbersKeys: function() {
        return numbersKeys;
    },
    passwordCharacters: function() {
        return passwordCharacters;
    }
});
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(52318);
var numbersKeys = [
    "number_zero",
    "number_one",
    "number_two",
    "number_three",
    "number_four",
    "number_five",
    "number_six",
    "number_seven",
    "number_eight",
    "number_nine"
];
var passwordCharacters = [
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "0"
];
var PASSWORD_LENGTH = 3;


/***/ }),

/***/ 36940:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BUTTON_OFFSET_LEFT: function() {
        return BUTTON_OFFSET_LEFT;
    },
    CONTENT_HEIGHT: function() {
        return CONTENT_HEIGHT;
    },
    CONTENT_MARGIN_LEFT: function() {
        return CONTENT_MARGIN_LEFT;
    },
    CONTENT_MARGIN_TOP: function() {
        return CONTENT_MARGIN_TOP;
    },
    CONTENT_WIDTH: function() {
        return CONTENT_WIDTH;
    },
    EXCEPTION_HEIGHT: function() {
        return EXCEPTION_HEIGHT;
    },
    EXCEPTION_OFFSET: function() {
        return EXCEPTION_OFFSET;
    },
    PASSWORD_OFFSET_TOP: function() {
        return PASSWORD_OFFSET_TOP;
    },
    TITLE_HEIGHT: function() {
        return TITLE_HEIGHT;
    },
    TITLE_WIDTH: function() {
        return TITLE_WIDTH;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getContentSettings: function() {
        return getContentSettings;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    getTitleSettings: function() {
        return getTitleSettings;
    }
});
var _define_property = __webpack_require__(21228);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
var _theme = __webpack_require__(51397);
var _constants = __webpack_require__(34952);
var _typography = __webpack_require__(18411);
var _style = __webpack_require__(65082);
var _sizes = __webpack_require__(82699);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var colors = {
    background: (0, _theme.makeThemeColor)(_theme.TERTIARY),
    title: (0, _theme.makeThemeColor)(_theme.PRIMARY),
    exception: (0, _theme.makeThemeColor)(_theme.UTILITY1)
};
var _obj;
var CONTENT_MARGIN_TOP = (_obj = {}, _define_property._(_obj, _constants.HD, 144), _define_property._(_obj, _constants.FULL_HD, 264), _obj);
var _obj1;
var CONTENT_MARGIN_LEFT = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 422), _define_property._(_obj1, _constants.FULL_HD, 715), _obj1);
var _obj2;
var CONTENT_WIDTH = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 436), _define_property._(_obj2, _constants.FULL_HD, 491), _obj2);
var _obj3;
var CONTENT_HEIGHT = (_obj3 = {}, _define_property._(_obj3, _constants.HD, 451), _define_property._(_obj3, _constants.FULL_HD, 549), _obj3);
var getContentSettings = function(screenSize) {
    return {
        w: CONTENT_WIDTH[screenSize],
        h: CONTENT_HEIGHT[screenSize],
        y: CONTENT_MARGIN_TOP[screenSize],
        x: CONTENT_MARGIN_LEFT[screenSize],
        flex: {
            direction: "column",
            alignItems: "center"
        }
    };
};
var _obj4;
var TITLE_HEIGHT = (_obj4 = {}, _define_property._(_obj4, _constants.HD, 72), _define_property._(_obj4, _constants.FULL_HD, 96), _obj4);
var _obj5;
var TITLE_WIDTH = (_obj5 = {}, _define_property._(_obj5, _constants.HD, 436), _define_property._(_obj5, _constants.FULL_HD, 491), _obj5);
var _obj6;
var BUTTON_OFFSET_LEFT = (_obj6 = {}, _define_property._(_obj6, _constants.HD, 20), _define_property._(_obj6, _constants.FULL_HD, 70), _obj6);
var _obj7;
var EXCEPTION_HEIGHT = (_obj7 = {}, _define_property._(_obj7, _constants.HD, 24), _define_property._(_obj7, _constants.FULL_HD, 30), _obj7);
var getTitleSettings = function(screenSize, colorMode) {
    return {
        text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT.KINSHASA_2, screenSize)), {
            maxLines: 2,
            maxLinesSuffix: "...",
            wordWrapWidth: TITLE_WIDTH[screenSize],
            textAlign: "center",
            textColor: colors.title[colorMode]
        })
    };
};
var PASSWORD_OFFSET_TOP = 32;
var EXCEPTION_OFFSET = 12;
var getInitialStyle = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext, screenSize = _ref.screenSize, colorMode = _ref.colorMode;
    return {
        zIndex: 1,
        Background: {
            w: _sizes.SCREEN_WIDTH[screenSize],
            h: _sizes.SCREEN_HEIGHT[screenSize],
            color: colors.background[colorMode],
            alpha: 0.9
        },
        Button: {
            x: _constants.safetyMargins.horizontal[screenSize],
            y: _constants.safetyMargins.vertical[screenSize]
        },
        Content: _object_spread_props._(_object_spread._({}, getContentSettings(screenSize)), {
            Title: _object_spread._({}, getTitleSettings(screenSize, colorMode)),
            PasswordBlock: {
                flexItem: {
                    marginTop: PASSWORD_OFFSET_TOP
                }
            },
            Exception: {
                flexItem: {
                    marginTop: EXCEPTION_OFFSET
                },
                h: EXCEPTION_HEIGHT[screenSize],
                alpha: 0,
                text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT.BERLIN_1, screenSize)), {
                    textColor: colors.exception[colorMode],
                    verticalAlign: "middle"
                })
            },
            Keyboard: {
                flexItem: {
                    marginTop: EXCEPTION_OFFSET
                }
            }
        })
    };
};


/***/ }),

/***/ 14349:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "generatePassword", ({
    enumerable: true,
    get: function() {
        return generatePassword;
    }
}));
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(42578);
var _kidsLeavePopupconstant = __webpack_require__(4607);
var generatePassword = function(length) {
    var result = "";
    for(var i = 0; i < length; i += 1){
        result += _kidsLeavePopupconstant.passwordCharacters[Math.floor(Math.random() * _kidsLeavePopupconstant.passwordCharacters.length)];
    }
    return result;
};


/***/ }),

/***/ 94017:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "Password", ({
    enumerable: true,
    get: function() {
        return Password;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _passwordstyle = __webpack_require__(43354);
var _passwordutils = __webpack_require__(48977);
var _restrictedInputcomponent = __webpack_require__(48592);
var _kidsLeavePopupconstant = __webpack_require__(4607);
var Password = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(Password, _Lightning_Component);
    var _super = _create_super._(Password);
    function Password() {
        _class_call_check._(this, Password);
        return _super.apply(this, arguments);
    }
    _create_class._(Password, [
        {
            key: "_init",
            value: function _init() {
                this.tag("InputPassword").length = _kidsLeavePopupconstant.PASSWORD_LENGTH;
            }
        },
        {
            key: "push",
            value: function push(digit) {
                this.tag("InputPassword").push(digit);
            }
        },
        {
            key: "pop",
            value: function pop() {
                this.tag("InputPassword").pop();
            }
        },
        {
            key: "clearPasswordInput",
            value: function clearPasswordInput() {
                this.tag("InputPassword").clearInput();
            }
        },
        {
            key: "borderCellColor",
            set: function set(color) {
                this.tag("InputPassword").borderCellColor = color;
            }
        },
        {
            key: "cells",
            set: function set(length) {
                this.tag("InputPassword").length = length;
            }
        },
        {
            key: "setPasswordText",
            value: function setPasswordText(value) {
                var text = (0, _passwordutils.getPasswordString)(value);
                this.tag("TextPassword").visible = Boolean(text);
                this.tag("TextPassword").text.text = text;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    TextPassword: {
                        text: {
                            text: ""
                        }
                    },
                    InputPassword: {
                        type: _restrictedInputcomponent.RestrictedInput
                    }
                }, (0, _passwordstyle.getInitialStyle)());
            }
        }
    ]);
    return Password;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 43354:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    PASSWORD_WIDTH: function() {
        return PASSWORD_WIDTH;
    },
    TEXT_PASSWORD_HEIGHT: function() {
        return TEXT_PASSWORD_HEIGHT;
    },
    TEXT_PASSWORD_MARGIN_BOTTOM: function() {
        return TEXT_PASSWORD_MARGIN_BOTTOM;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(3009);
var _theme = __webpack_require__(51397);
var _constants = __webpack_require__(34952);
var _typography = __webpack_require__(18411);
var _style = __webpack_require__(65082);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var colors = {
    title: (0, _theme.makeThemeColor)(_theme.PRIMARY)
};
var _obj;
var PASSWORD_WIDTH = (_obj = {}, _define_property._(_obj, _constants.HD, 436), _define_property._(_obj, _constants.FULL_HD, 491), _obj);
var _obj1;
var TEXT_PASSWORD_HEIGHT = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 36), _define_property._(_obj1, _constants.FULL_HD, 48), _obj1);
var TEXT_PASSWORD_MARGIN_BOTTOM = 24;
var getInitialStyle = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext, screenSize = _ref.screenSize, colorMode = _ref.colorMode;
    return {
        flex: {
            direction: "column",
            alignItems: "center"
        },
        TextPassword: {
            flexItem: {
                marginBottom: TEXT_PASSWORD_MARGIN_BOTTOM
            },
            h: TEXT_PASSWORD_HEIGHT[screenSize],
            visible: false,
            text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT.KINSHASA_1, screenSize)), {
                maxLines: 1,
                maxLinesSuffix: "...",
                wordWrapWidth: PASSWORD_WIDTH[screenSize],
                textAlign: "center",
                textColor: colors.title[colorMode],
                verticalAlign: "middle"
            })
        }
    };
};


/***/ }),

/***/ 48977:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "getPasswordString", ({
    enumerable: true,
    get: function() {
        return getPasswordString;
    }
}));
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(3009);
var _kidsLeavePopupconstant = __webpack_require__(4607);
var _i18n = __webpack_require__(14910);
var getPasswordString = function(password) {
    if (!password || password.split("").length !== _kidsLeavePopupconstant.PASSWORD_LENGTH) return "";
    var passwordParts = password.split("").map(function(key) {
        return (0, _i18n.t)("global.numbers.".concat(_kidsLeavePopupconstant.numbersKeys[+key])).toUpperCase();
    });
    return passwordParts.join(" - ");
};


/***/ }),

/***/ 7918:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "MaxParentalCodePopup", ({
    enumerable: true,
    get: function() {
        return MaxParentalCodePopup;
    }
}));
var _assert_this_initialized = __webpack_require__(99561);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _get = __webpack_require__(60528);
var _get_prototype_of = __webpack_require__(35196);
var _inherits = __webpack_require__(71648);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _create_super = __webpack_require__(6400);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(88801);
var _commonPopupcomponent = __webpack_require__(13883);
var _popupContainerconstants = __webpack_require__(54258);
var _routesutils = __webpack_require__(14948);
var _i18n = __webpack_require__(14910);
var MaxParentalCodePopup = /*#__PURE__*/ function(CommonPopup) {
    "use strict";
    _inherits._(MaxParentalCodePopup, CommonPopup);
    var _super = _create_super._(MaxParentalCodePopup);
    function MaxParentalCodePopup() {
        _class_call_check._(this, MaxParentalCodePopup);
        var _this;
        _this = _super.apply(this, arguments);
        _define_property._(_assert_this_initialized._(_this), "_getCloseButtonCaption", function() {
            return (0, _i18n.t)("global.returnHome");
        });
        return _this;
    }
    _create_class._(MaxParentalCodePopup, [
        {
            key: "_close",
            value: function _close() {
                (0, _routesutils.navigateToAliasHome)();
                this.signal(_popupContainerconstants.HIDE_POPUP_SIGNAL);
            }
        },
        {
            key: "_handleBack",
            value: function _handleBack() {
                this._close();
            }
        },
        {
            key: "_handleEnter",
            value: function _handleEnter() {
                this._close();
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return _object_spread_props._(_object_spread._({}, _get._(_get_prototype_of._(MaxParentalCodePopup), "_template", this).call(this)), {
                    title: "error.maxParentalCode"
                });
            }
        }
    ]);
    return MaxParentalCodePopup;
}(_commonPopupcomponent.CommonPopup);


/***/ }),

/***/ 85277:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "KEYBOARD_VISIBLE", ({
    enumerable: true,
    get: function() {
        return KEYBOARD_VISIBLE;
    }
}));
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
var KEYBOARD_VISIBLE = true;


/***/ }),

/***/ 73448:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "ForgotCodeHint", ({
    enumerable: true,
    get: function() {
        return ForgotCodeHint;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(37815);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _buttoncomponent = __webpack_require__(31464);
var _i18n = __webpack_require__(14910);
var _forgotCodeHintstyle = __webpack_require__(74046);
var _forgotCodeHintconstants = __webpack_require__(33802);
var ForgotCodeHint = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(ForgotCodeHint, _Lightning_Component);
    var _super = _create_super._(ForgotCodeHint);
    function ForgotCodeHint() {
        _class_call_check._(this, ForgotCodeHint);
        return _super.apply(this, arguments);
    }
    _create_class._(ForgotCodeHint, [
        {
            key: "_init",
            value: function _init() {
                this._style = _forgotCodeHintstyle.defaultContext;
                this.password = "";
                this._exceptionInterval = null;
            }
        },
        {
            key: "_active",
            value: function _active() {
                this._setState("HomeButton");
            }
        },
        {
            key: "_handleUp",
            value: function _handleUp() {
                return true;
            }
        },
        {
            key: "_handleDown",
            value: function _handleDown() {
                return true;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Background: {
                        rect: true
                    },
                    BackButton: {
                        type: _buttoncomponent.Button,
                        label: (0, _i18n.t)("global.back")
                    },
                    Content: {
                        Title: {
                            text: {
                                text: (0, _i18n.t)("parentalCode.forgottenCode")
                            }
                        },
                        Body: {
                            text: {
                                text: (0, _i18n.t)("parentalCode.lost.instruction")
                            }
                        },
                        HomeButton: {
                            type: _buttoncomponent.Button,
                            label: (0, _i18n.t)("parentalCode.lost.catalogReturn")
                        }
                    }
                }, (0, _forgotCodeHintstyle.getInitialStyle)(), {});
            }
        },
        {
            key: "_states",
            value: function _states() {
                return [
                    /*#__PURE__*/ function(_this) {
                        _inherits._(BackButton, _this);
                        var _super = _create_super._(BackButton);
                        function BackButton() {
                            _class_call_check._(this, BackButton);
                            return _super.apply(this, arguments);
                        }
                        _create_class._(BackButton, [
                            {
                                key: "_getFocused",
                                value: function _getFocused() {
                                    return this.tag("BackButton");
                                }
                            },
                            {
                                key: "_handleDown",
                                value: function _handleDown() {
                                    this._setState("HomeButton");
                                    return true;
                                }
                            },
                            {
                                key: "_handleEnter",
                                value: function _handleEnter() {
                                    this.signal(_forgotCodeHintconstants.HIDE_SIGNAL);
                                    return true;
                                }
                            }
                        ]);
                        return BackButton;
                    }(this),
                    /*#__PURE__*/ function(_this) {
                        _inherits._(HomeButton, _this);
                        var _super = _create_super._(HomeButton);
                        function HomeButton() {
                            _class_call_check._(this, HomeButton);
                            return _super.apply(this, arguments);
                        }
                        _create_class._(HomeButton, [
                            {
                                key: "_getFocused",
                                value: function _getFocused() {
                                    return this.tag("HomeButton");
                                }
                            },
                            {
                                key: "_handleUp",
                                value: function _handleUp() {
                                    this._setState("BackButton");
                                    return true;
                                }
                            },
                            {
                                key: "_handleEnter",
                                value: function _handleEnter() {
                                    this.signal(_forgotCodeHintconstants.HOME_SIGNAL);
                                    return true;
                                }
                            }
                        ]);
                        return HomeButton;
                    }(this)
                ];
            }
        }
    ]);
    return ForgotCodeHint;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 33802:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    HIDE_SIGNAL: function() {
        return HIDE_SIGNAL;
    },
    HOME_SIGNAL: function() {
        return HOME_SIGNAL;
    }
});
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
var HIDE_SIGNAL = "hide";
var HOME_SIGNAL = "home";


/***/ }),

/***/ 74046:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    CONTENT_HEIGHT: function() {
        return CONTENT_HEIGHT;
    },
    CONTENT_WIDTH: function() {
        return CONTENT_WIDTH;
    },
    TEXT_OFFSET: function() {
        return TEXT_OFFSET;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(65759);
var _theme = __webpack_require__(51397);
var _constants = __webpack_require__(34952);
var _typography = __webpack_require__(18411);
var _style = __webpack_require__(65082);
var _sizes = __webpack_require__(82699);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var colors = {
    background: (0, _theme.makeThemeColor)(_theme.TERTIARY),
    title: (0, _theme.makeThemeColor)(_theme.PRIMARY)
};
var _obj;
var CONTENT_WIDTH = (_obj = {}, _define_property._(_obj, _constants.HD, _sizes.SCREEN_WIDTH[_constants.HD] - _constants.safetyMargins.horizontal[_constants.HD] * 2), _define_property._(_obj, _constants.FULL_HD, _sizes.SCREEN_WIDTH[_constants.FULL_HD] - _constants.safetyMargins.horizontal[_constants.FULL_HD] * 2), _obj);
var _obj1;
var CONTENT_HEIGHT = (_obj1 = {}, _define_property._(_obj1, _constants.HD, _sizes.SCREEN_HEIGHT[_constants.HD] - _constants.safetyMargins.vertical[_constants.HD] * 2), _define_property._(_obj1, _constants.FULL_HD, _sizes.SCREEN_HEIGHT[_constants.FULL_HD] - _constants.safetyMargins.vertical[_constants.FULL_HD] * 2), _obj1);
var TEXT_OFFSET = 40;
var getInitialStyle = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext, screenSize = _ref.screenSize, colorMode = _ref.colorMode;
    return {
        zIndex: 1,
        Background: {
            w: _sizes.SCREEN_WIDTH[screenSize],
            h: _sizes.SCREEN_HEIGHT[screenSize],
            color: colors.background[colorMode]
        },
        BackButton: {
            x: _constants.safetyMargins.horizontal[screenSize],
            y: _constants.safetyMargins.vertical[screenSize]
        },
        Content: {
            w: CONTENT_WIDTH[screenSize],
            h: CONTENT_HEIGHT[screenSize],
            x: _constants.safetyMargins.horizontal[screenSize],
            y: _constants.safetyMargins.vertical[screenSize],
            flex: {
                direction: "column",
                alignItems: "center",
                justifyContent: "center"
            },
            Title: {
                text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT.PARIS_3, screenSize)), {
                    maxLines: 2,
                    maxLinesSuffix: "...",
                    wordWrapWidth: CONTENT_WIDTH[screenSize],
                    textAlign: "center",
                    textColor: colors.title[colorMode]
                })
            },
            Body: {
                flexItem: {
                    marginTop: TEXT_OFFSET
                },
                text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT.OTTAWA_1, screenSize)), {
                    maxLines: 2,
                    maxLinesSuffix: "...",
                    wordWrapWidth: CONTENT_WIDTH[screenSize],
                    textAlign: "center",
                    textColor: colors.title[colorMode]
                })
            },
            HomeButton: {
                flexItem: {
                    marginTop: TEXT_OFFSET
                }
            }
        }
    };
};


/***/ }),

/***/ 60458:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "ParentalCode", ({
    enumerable: true,
    get: function() {
        return ParentalCode;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(3009);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _sdk = __webpack_require__(29956);
var _parentalCodestyle = __webpack_require__(77355);
var _buttoncomponent = __webpack_require__(31464);
var _i18n = __webpack_require__(14910);
var _passwordcomponent = __webpack_require__(94017);
var _brandIconcomponent = __webpack_require__(362);
var _keyboardNumberscomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(21498));
var _keyboardconstants = __webpack_require__(20190);
var _parentalCodeconstants = __webpack_require__(37758);
var _popupContainerconstants = __webpack_require__(54258);
var _ctaactions = __webpack_require__(32067);
var _useractions = __webpack_require__(79489);
var _forgotCodeHintcomponent = __webpack_require__(73448);
var _parentalCodeconnector = /*#__PURE__*/ _interop_require_default._(__webpack_require__(79312));
var _forgotCodeHintconstants = __webpack_require__(33802);
var _routesutils = __webpack_require__(14948);
var ParentalCode = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(ParentalCode, _Lightning_Component);
    var _super = _create_super._(ParentalCode);
    function ParentalCode() {
        _class_call_check._(this, ParentalCode);
        return _super.apply(this, arguments);
    }
    _create_class._(ParentalCode, [
        {
            key: "routeBackOnClose",
            set: function set(value) {
                this._routeBackOnClose = value;
            }
        },
        {
            key: "_init",
            value: function _init() {
                this._style = _parentalCodestyle.defaultContext;
                this.password = "";
                this._exceptionInterval = null;
                this._isUnlocked = false;
                var keyboard = this.tag("Keyboard");
                keyboard.itemsPerRow = _parentalCodeconstants.passwordCharacters.length;
                keyboard.renderKeyboard(_parentalCodeconstants.passwordCharacters);
                this.tag("PasswordBlock").cells = _parentalCodeconstants.PASSWORD_LENGTH;
                this._setState("Keyboard");
            }
        },
        {
            key: "_attach",
            value: function _attach() {
                this._unsubscribe = (0, _parentalCodeconnector.default)(this);
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                this._clearExceptionInterval();
                this._cleanup();
            }
        },
        {
            key: "_cleanup",
            value: function _cleanup() {
                if (this._unsubscribe) {
                    this._unsubscribe();
                    this._unsubscribe = null;
                }
                _lightningjsredux.default.dispatch((0, _useractions.closeParentalLock)());
            }
        },
        {
            key: "payload",
            set: function set(value) {
                this._payload = value;
            }
        },
        {
            key: "isEmptyPassword",
            get: function get() {
                return this.password === "";
            }
        },
        {
            key: "isAllPassword",
            get: function get() {
                return this.password.length === _parentalCodeconstants.PASSWORD_LENGTH;
            }
        },
        {
            key: "handlePopup",
            value: function handlePopup(value) {
                var _this = this;
                if (value) {
                    this.signal(_popupContainerconstants.HIDE_POPUP_SIGNAL);
                    _lightningjsredux.default.dispatch((0, _ctaactions.createItemAction)(this._payload));
                    return;
                }
                // NOTE: don't show the exception message for the first time this pop-up is opened
                if (this._isUnlocked !== value) {
                    this._showException();
                    this._clearExceptionInterval();
                    this._exceptionInterval = setTimeout(function() {
                        return _this._hideException();
                    }, _parentalCodeconstants.EXCEPTION_INTERVAL);
                }
                this._isUnlocked = value;
            }
        },
        {
            key: "_handleSelectedLetter",
            value: function _handleSelectedLetter(letter) {
                if (this.isAllPassword) {
                    return;
                }
                if (this.isEmptyPassword) {
                    this._resetPasswordView();
                }
                this._updatePassword(letter);
            }
        },
        {
            key: "_updatePassword",
            value: function _updatePassword(value) {
                switch(value){
                    case _keyboardconstants.BACKSPACE:
                        {
                            this.password = this.password.slice(0, this.password.length ? this.password.length - 1 : 0);
                            this.tag("PasswordBlock").pop();
                            break;
                        }
                    default:
                        {
                            this.password += value;
                            this.tag("PasswordBlock").push(value);
                            if (this.isAllPassword) {
                                this._validatePassword();
                            }
                        }
                }
            }
        },
        {
            key: "_validatePassword",
            value: function _validatePassword() {
                if (this.password.length === _parentalCodeconstants.PASSWORD_LENGTH) {
                    this._isUnlocked = undefined;
                    _lightningjsredux.default.dispatch((0, _useractions.checkParentalRestrictionCode)(this.password));
                }
            }
        },
        {
            key: "_clearExceptionInterval",
            value: function _clearExceptionInterval() {
                if (this._exceptionInterval) {
                    clearTimeout(this._exceptionInterval);
                }
            }
        },
        {
            key: "_resetPasswordView",
            value: function _resetPasswordView() {
                this._hideException();
            }
        },
        {
            key: "_handleBack",
            value: function _handleBack() {
                this.signal(this._routeBackOnClose ? _popupContainerconstants.ROUTE_BACK_SIGNAL : _popupContainerconstants.HIDE_POPUP_SIGNAL);
                return true;
            }
        },
        {
            key: "_showException",
            value: function _showException() {
                this.patch({
                    Input: {
                        Content: {
                            PasswordBlock: {
                                borderCellColor: {
                                    color: _parentalCodestyle.colors.exception[this._style.colorMode],
                                    opacity: 1
                                }
                            }
                        }
                    }
                });
                this.tag("Exception").alpha = 1;
            }
        },
        {
            key: "_hideException",
            value: function _hideException() {
                this.patch({
                    Input: {
                        Content: {
                            PasswordBlock: {
                                borderCellColor: {
                                    color: _parentalCodestyle.colors.border[this._style.colorMode],
                                    opacity: 0.3
                                }
                            }
                        }
                    }
                });
                this.tag("PasswordBlock").clearPasswordInput();
                this.tag("Exception").alpha = 0;
                this.password = "";
                this._clearExceptionInterval();
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                var _obj, _obj1;
                return (0, _merge.default)({
                    Background: {
                        rect: true
                    },
                    Input: {
                        Button: {
                            type: _buttoncomponent.Button,
                            label: (0, _i18n.t)("global.back")
                        },
                        Content: {
                            CustomerIcon: {
                                type: _brandIconcomponent.BrandIcon
                            },
                            Title: {
                                text: {
                                    text: (0, _i18n.t)("parentalCode.instruction")
                                }
                            },
                            PasswordBlock: {
                                type: _passwordcomponent.Password
                            },
                            ExceptionWrapper: {
                                Exception: {
                                    text: {
                                        text: (0, _i18n.t)("parentalCode.incorrectCode")
                                    }
                                }
                            },
                            Keyboard: {
                                type: _keyboardNumberscomponent.default,
                                signals: _define_property._({}, _keyboardconstants.LETTER_SELECTED_SIGNAL, "_handleSelectedLetter")
                            },
                            ForgotCodeButton: {
                                type: _buttoncomponent.Button,
                                label: (0, _i18n.t)("parentalCode.forgottenCode")
                            }
                        }
                    },
                    ForgotCodeHint: {
                        type: _forgotCodeHintcomponent.ForgotCodeHint,
                        signals: (_obj = {}, _define_property._(_obj, _forgotCodeHintconstants.HOME_SIGNAL, "_handleHomeSignal"), _define_property._(_obj, _forgotCodeHintconstants.HIDE_SIGNAL, "_handleHideSignal"), _obj)
                    },
                    passSignals: (_obj1 = {}, _define_property._(_obj1, _popupContainerconstants.ROUTE_BACK_SIGNAL, true), _define_property._(_obj1, _popupContainerconstants.HIDE_POPUP_SIGNAL, true), _obj1)
                }, (0, _parentalCodestyle.getInitialStyle)());
            }
        },
        {
            key: "_states",
            value: function _states() {
                return [
                    /*#__PURE__*/ function(_this) {
                        _inherits._(Button, _this);
                        var _super = _create_super._(Button);
                        function Button() {
                            _class_call_check._(this, Button);
                            return _super.apply(this, arguments);
                        }
                        _create_class._(Button, [
                            {
                                key: "_getFocused",
                                value: function _getFocused() {
                                    return this.tag("Button");
                                }
                            },
                            {
                                key: "_handleEnter",
                                value: function _handleEnter() {
                                    this.signal(this._routeBackOnClose ? _popupContainerconstants.ROUTE_BACK_SIGNAL : _popupContainerconstants.HIDE_POPUP_SIGNAL);
                                    return true;
                                }
                            },
                            {
                                key: "_handleDown",
                                value: function _handleDown() {
                                    this._setState("Keyboard");
                                    return true;
                                }
                            }
                        ]);
                        return Button;
                    }(this),
                    /*#__PURE__*/ function(_this) {
                        _inherits._(Keyboard, _this);
                        var _super = _create_super._(Keyboard);
                        function Keyboard() {
                            _class_call_check._(this, Keyboard);
                            return _super.apply(this, arguments);
                        }
                        _create_class._(Keyboard, [
                            {
                                key: "_getFocused",
                                value: function _getFocused() {
                                    return this.tag("Keyboard");
                                }
                            },
                            {
                                key: "_handleUp",
                                value: function _handleUp() {
                                    this._setState("Button");
                                    return true;
                                }
                            },
                            {
                                key: "_handleDown",
                                value: function _handleDown() {
                                    this._setState("ForgotCode");
                                    return true;
                                }
                            }
                        ]);
                        return Keyboard;
                    }(this),
                    /*#__PURE__*/ function(_this) {
                        _inherits._(ForgotCode, _this);
                        var _super = _create_super._(ForgotCode);
                        function ForgotCode() {
                            _class_call_check._(this, ForgotCode);
                            return _super.apply(this, arguments);
                        }
                        _create_class._(ForgotCode, [
                            {
                                key: "_getFocused",
                                value: function _getFocused() {
                                    return this.tag("ForgotCodeButton");
                                }
                            },
                            {
                                key: "_handleEnter",
                                value: function _handleEnter() {
                                    this._setState("ForgotCode.Open");
                                    return true;
                                }
                            },
                            {
                                key: "_handleUp",
                                value: function _handleUp() {
                                    this._setState("Keyboard");
                                    return true;
                                }
                            }
                        ], [
                            {
                                key: "_states",
                                value: function _states() {
                                    return [
                                        /*#__PURE__*/ function(_this) {
                                            _inherits._(Open, _this);
                                            var _super = _create_super._(Open);
                                            function Open() {
                                                _class_call_check._(this, Open);
                                                return _super.apply(this, arguments);
                                            }
                                            _create_class._(Open, [
                                                {
                                                    key: "$enter",
                                                    value: function $enter() {
                                                        this.tag("ForgotCodeHint").visible = true;
                                                    }
                                                },
                                                {
                                                    key: "$exit",
                                                    value: function $exit() {
                                                        this.tag("ForgotCodeHint").visible = false;
                                                    }
                                                },
                                                {
                                                    key: "_getFocused",
                                                    value: function _getFocused() {
                                                        return this.tag("ForgotCodeHint");
                                                    }
                                                },
                                                {
                                                    key: "_handleBack",
                                                    value: function _handleBack() {
                                                        this._handleHideSignal();
                                                        return true;
                                                    }
                                                },
                                                {
                                                    key: "_handleHomeSignal",
                                                    value: function _handleHomeSignal() {
                                                        (0, _routesutils.navigateToAliasHome)();
                                                        this.signal(_popupContainerconstants.HIDE_POPUP_SIGNAL);
                                                    }
                                                },
                                                {
                                                    key: "_handleHideSignal",
                                                    value: function _handleHideSignal() {
                                                        this._setState("ForgotCode");
                                                    }
                                                }
                                            ]);
                                            return Open;
                                        }(this)
                                    ];
                                }
                            }
                        ]);
                        return ForgotCode;
                    }(this)
                ];
            }
        }
    ]);
    return ParentalCode;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 79312:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _userselectors = __webpack_require__(41845);
var mapControllers = function(instance) {
    return [
        {
            selector: _userselectors.getParentalLockStatus,
            condition: function() {
                return true;
            },
            callback: function(value) {
                instance.handlePopup(value);
            }
        }
    ];
};
var _default = _lightningjsredux.default.control(mapControllers);


/***/ }),

/***/ 37758:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    EXCEPTION_INTERVAL: function() {
        return EXCEPTION_INTERVAL;
    },
    PASSWORD_LENGTH: function() {
        return PASSWORD_LENGTH;
    },
    passwordCharacters: function() {
        return passwordCharacters;
    }
});
var _export_star = __webpack_require__(37668);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(3009);
_export_star._(__webpack_require__(85277), exports);
var passwordCharacters = [
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "0",
    "<"
];
var PASSWORD_LENGTH = 4;
var EXCEPTION_INTERVAL = 2000;


/***/ }),

/***/ 77355:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    EXCEPTION_HEIGHT: function() {
        return EXCEPTION_HEIGHT;
    },
    EXCEPTION_OFFSET: function() {
        return EXCEPTION_OFFSET;
    },
    FORGOT_CODE_BUTTON_OFFSET: function() {
        return FORGOT_CODE_BUTTON_OFFSET;
    },
    LOGO_HEIGHT: function() {
        return LOGO_HEIGHT;
    },
    PASSWORD_OFFSET_TOP: function() {
        return PASSWORD_OFFSET_TOP;
    },
    TITLE_WIDTH: function() {
        return TITLE_WIDTH;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(37815);
var _theme = __webpack_require__(51397);
var _constants = __webpack_require__(34952);
var _typography = __webpack_require__(18411);
var _style = __webpack_require__(65082);
var _sizes = __webpack_require__(82699);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var colors = {
    background: (0, _theme.makeThemeColor)(_theme.TERTIARY),
    title: (0, _theme.makeThemeColor)(_theme.PRIMARY),
    exception: (0, _theme.makeThemeColor)(_theme.UTILITY1),
    border: (0, _theme.makeThemeColor)(_theme.PRIMARY)
};
var _obj;
var LOGO_HEIGHT = (_obj = {}, _define_property._(_obj, _constants.HD, 96), _define_property._(_obj, _constants.FULL_HD, 152), _obj);
var _obj1;
var TITLE_WIDTH = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 900), _define_property._(_obj1, _constants.FULL_HD, 955), _obj1);
var _obj2;
var EXCEPTION_HEIGHT = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 56), _define_property._(_obj2, _constants.FULL_HD, 64), _obj2);
var _obj3;
var PASSWORD_OFFSET_TOP = (_obj3 = {}, _define_property._(_obj3, _constants.HD, 56), _define_property._(_obj3, _constants.FULL_HD, 64), _obj3);
var EXCEPTION_OFFSET = 12;
var FORGOT_CODE_BUTTON_OFFSET = 40;
var getInitialStyle = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext, screenSize = _ref.screenSize, colorMode = _ref.colorMode;
    return {
        zIndex: 1,
        Background: {
            w: _sizes.SCREEN_WIDTH[screenSize],
            h: _sizes.SCREEN_HEIGHT[screenSize],
            color: colors.background[colorMode]
        },
        Input: {
            Button: {
                x: _constants.safetyMargins.horizontal[screenSize],
                y: _constants.safetyMargins.vertical[screenSize]
            },
            Content: {
                w: _sizes.SCREEN_WIDTH[screenSize] - _constants.safetyMargins.horizontal[screenSize] * 2,
                h: _sizes.SCREEN_HEIGHT[screenSize] - _constants.safetyMargins.vertical[screenSize] * 2,
                x: _constants.safetyMargins.horizontal[screenSize],
                y: _constants.safetyMargins.vertical[screenSize],
                flex: {
                    direction: "column",
                    alignItems: "center",
                    justifyContent: "center"
                },
                CustomerIcon: {
                    h: LOGO_HEIGHT[screenSize]
                },
                Title: {
                    text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT.PARIS_3, screenSize)), {
                        maxLines: 2,
                        maxLinesSuffix: "...",
                        wordWrapWidth: TITLE_WIDTH[screenSize],
                        textAlign: "center",
                        textColor: colors.title[colorMode]
                    })
                },
                PasswordBlock: {
                    flexItem: {
                        marginTop: PASSWORD_OFFSET_TOP[screenSize]
                    }
                },
                ExceptionWrapper: {
                    h: EXCEPTION_HEIGHT[screenSize],
                    Exception: {
                        alpha: 0,
                        x: _sizes.middle,
                        y: _sizes.middle,
                        mount: 0.5,
                        text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT.OTTAWA_2, screenSize)), {
                            textColor: colors.exception[colorMode],
                            verticalAlign: "middle"
                        })
                    }
                },
                Keyboard: {
                    flexItem: {
                        marginTop: EXCEPTION_OFFSET
                    }
                },
                ForgotCodeButton: {
                    flexItem: {
                        marginTop: FORGOT_CODE_BUTTON_OFFSET
                    }
                }
            }
        },
        ForgotCodeHint: {
            visible: false
        }
    };
};


/***/ }),

/***/ 29339:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "ParentalFilterPopupLock", ({
    enumerable: true,
    get: function() {
        return ParentalFilterPopupLock;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _get = __webpack_require__(60528);
var _get_prototype_of = __webpack_require__(35196);
var _inherits = __webpack_require__(71648);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _create_super = __webpack_require__(6400);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(52318);
var _commonPopupcomponent = __webpack_require__(13883);
var ParentalFilterPopupLock = /*#__PURE__*/ function(CommonPopup) {
    "use strict";
    _inherits._(ParentalFilterPopupLock, CommonPopup);
    var _super = _create_super._(ParentalFilterPopupLock);
    function ParentalFilterPopupLock() {
        _class_call_check._(this, ParentalFilterPopupLock);
        return _super.apply(this, arguments);
    }
    _create_class._(ParentalFilterPopupLock, null, [
        {
            key: "_template",
            value: function _template() {
                return _object_spread_props._(_object_spread._({}, _get._(_get_prototype_of._(ParentalFilterPopupLock), "_template", this).call(this)), {
                    title: "layout.locks.parentalFilter.message"
                });
            }
        }
    ]);
    return ParentalFilterPopupLock;
}(_commonPopupcomponent.CommonPopup);


/***/ }),

/***/ 60952:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ACCOUNT_COMPLETION_POPUP_ID: function() {
        return ACCOUNT_COMPLETION_POPUP_ID;
    },
    AGE_GATE_POPUP_ID: function() {
        return AGE_GATE_POPUP_ID;
    },
    BROADCASTING_LOCK_POPUP_ID: function() {
        return BROADCASTING_LOCK_POPUP_ID;
    },
    COMMON_POPUP_ID: function() {
        return COMMON_POPUP_ID;
    },
    CONTENT_RATING_POPUP_ID: function() {
        return CONTENT_RATING_POPUP_ID;
    },
    CSL_BLOCK_POPUP_ID: function() {
        return CSL_BLOCK_POPUP_ID;
    },
    EPG_LAYOUT_POPUP_ID: function() {
        return EPG_LAYOUT_POPUP_ID;
    },
    EPG_POPUP_ID: function() {
        return EPG_POPUP_ID;
    },
    EXIT_POPUP_ID: function() {
        return EXIT_POPUP_ID;
    },
    FATAL_ERROR_POPUP_ID: function() {
        return FATAL_ERROR_POPUP_ID;
    },
    FREEMIUM_LOCK_POPUP_ID: function() {
        return FREEMIUM_LOCK_POPUP_ID;
    },
    GEO_BLOCK_POPUP_ID: function() {
        return GEO_BLOCK_POPUP_ID;
    },
    GRID_POPUP_ID: function() {
        return GRID_POPUP_ID;
    },
    KIDS_LEAVE_POPUP_ID: function() {
        return KIDS_LEAVE_POPUP_ID;
    },
    MAX_PARENTAL_CODE_POPUP_ID: function() {
        return MAX_PARENTAL_CODE_POPUP_ID;
    },
    PARENTAL_CODE_POPUP_ID: function() {
        return PARENTAL_CODE_POPUP_ID;
    },
    PARENTAL_FILTER_POPUP_ID: function() {
        return PARENTAL_FILTER_POPUP_ID;
    },
    PROFILES_GATE_POPUP_ID: function() {
        return PROFILES_GATE_POPUP_ID;
    },
    SUBSCRIPTION_POPUP_ID: function() {
        return SUBSCRIPTION_POPUP_ID;
    }
});
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(37815);
var EXIT_POPUP_ID = "exitPopup";
var COMMON_POPUP_ID = "commonPopup";
var FATAL_ERROR_POPUP_ID = "fatalErrorPopup";
var AGE_GATE_POPUP_ID = "contentRatingAdvisoryPopup";
var GEO_BLOCK_POPUP_ID = "geoBlockedPopup";
var CSL_BLOCK_POPUP_ID = "CSLBlockedPopup";
var PROFILES_GATE_POPUP_ID = "profilesGatePopup";
var KIDS_LEAVE_POPUP_ID = "kidsLeavePopup";
var BROADCASTING_LOCK_POPUP_ID = "liveBroadcastingLockPopup";
var FREEMIUM_LOCK_POPUP_ID = "freemiumLockPopup";
var PARENTAL_CODE_POPUP_ID = "parentalCodePopup";
var EPG_POPUP_ID = "epgPopup";
var EPG_LAYOUT_POPUP_ID = "epgLayoutPopup";
var GRID_POPUP_ID = "gridPopup";
var SUBSCRIPTION_POPUP_ID = "subscriptionPopup";
var ACCOUNT_COMPLETION_POPUP_ID = "accountCompletionPopup";
var CONTENT_RATING_POPUP_ID = "contentRating";
var PARENTAL_FILTER_POPUP_ID = "parentalFilter";
var MAX_PARENTAL_CODE_POPUP_ID = "maxParentalCodePopup";


/***/ }),

/***/ 54340:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "ProfilesGatePopup", ({
    enumerable: true,
    get: function() {
        return ProfilesGatePopup;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _get = __webpack_require__(60528);
var _get_prototype_of = __webpack_require__(35196);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _create_super = __webpack_require__(6400);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _ctaactions = __webpack_require__(32067);
var _profilesGatecomponent = __webpack_require__(95045);
var _lockactions = __webpack_require__(75250);
var _popupContainerconstants = __webpack_require__(54258);
var ProfilesGatePopup = /*#__PURE__*/ function(ProfilesGate) {
    "use strict";
    _inherits._(ProfilesGatePopup, ProfilesGate);
    var _super = _create_super._(ProfilesGatePopup);
    function ProfilesGatePopup() {
        _class_call_check._(this, ProfilesGatePopup);
        return _super.apply(this, arguments);
    }
    _create_class._(ProfilesGatePopup, [
        {
            key: "payload",
            set: function set(value) {
                _lightningjsredux.default.dispatch((0, _lockactions.checkProfileAutoSelect)(value));
                this.data = value;
            }
        },
        {
            key: "_handleSelected",
            value: function _handleSelected(item) {
                this.signal(_popupContainerconstants.HIDE_POPUP_SIGNAL);
                return _lightningjsredux.default.dispatch((0, _ctaactions.createItemAction)({
                    item: item
                }));
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                var _obj;
                return _object_spread_props._(_object_spread._({}, _get._(_get_prototype_of._(ProfilesGatePopup), "_template", this).call(this)), {
                    passSignals: (_obj = {}, _define_property._(_obj, _popupContainerconstants.HIDE_POPUP_SIGNAL, true), _define_property._(_obj, _popupContainerconstants.EXIT_APP_SIGNAL, true), _obj)
                });
            }
        }
    ]);
    return ProfilesGatePopup;
}(_profilesGatecomponent.ProfilesGate);


/***/ }),

/***/ 46954:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "SubscriptionPopup", ({
    enumerable: true,
    get: function() {
        return SubscriptionPopup;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(52318);
var _lockutils = __webpack_require__(78414);
var _popupContainerconstants = __webpack_require__(54258);
var _subscriptionExpiredcomponent = __webpack_require__(7394);
var _upsellcomponent = __webpack_require__(52262);
var _abstractPopupcomponent = __webpack_require__(77472);
var _subscriptionPopuputils = __webpack_require__(21643);
var _subscriptionPopupconnector = /*#__PURE__*/ _interop_require_default._(__webpack_require__(26306));
var SubscriptionPopup = /*#__PURE__*/ function(AbstractPopup) {
    "use strict";
    _inherits._(SubscriptionPopup, AbstractPopup);
    var _super = _create_super._(SubscriptionPopup);
    function SubscriptionPopup() {
        _class_call_check._(this, SubscriptionPopup);
        return _super.apply(this, arguments);
    }
    _create_class._(SubscriptionPopup, [
        {
            key: "_active",
            value: function _active() {
                this._unsubscribe = (0, _subscriptionPopupconnector.default)(this);
            }
        },
        {
            key: "_inactive",
            value: function _inactive() {
                if (this._unsubscribe) {
                    this._unsubscribe();
                    this._unsubscribe = null;
                }
            }
        },
        {
            key: "entityType",
            set: function set(value) {
                this.routeBackOnClose = this.routeBackOnClose || (0, _lockutils.isPlayerLocked)(value);
            }
        },
        {
            key: "payload",
            set: function set(value) {
                this.tag("Regular").payload = value;
                this.tag("Upsell").payload = value;
            }
        },
        {
            key: "lock",
            set: function set(value) {
                var upsell = (0, _subscriptionPopuputils.getUpsell)(value);
                this.tag("Regular").visible = !upsell;
                this.tag("Upsell").visible = !!upsell;
                var tag = upsell ? "Upsell" : "Regular";
                this.tag(tag).requiredFeatures = upsell.details ? upsell.details.products : [];
                this.tag(tag).lock = value;
            }
        },
        {
            key: "_getFocused",
            value: function _getFocused() {
                var regular = this.tag("Regular");
                var upsell = this.tag("Upsell");
                if (regular.visible) {
                    return regular;
                }
                if (upsell.visible) {
                    return upsell;
                }
                return undefined;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                var _obj, _obj1, _obj2;
                return {
                    Regular: {
                        type: _subscriptionExpiredcomponent.SubscriptionExpired,
                        passSignals: (_obj = {}, _define_property._(_obj, _popupContainerconstants.HIDE_POPUP_SIGNAL, true), _define_property._(_obj, _popupContainerconstants.ROUTE_BACK_SIGNAL, true), _obj)
                    },
                    Upsell: {
                        type: _upsellcomponent.Upsell,
                        passSignals: (_obj1 = {}, _define_property._(_obj1, _popupContainerconstants.HIDE_POPUP_SIGNAL, true), _define_property._(_obj1, _popupContainerconstants.ROUTE_BACK_SIGNAL, true), _obj1)
                    },
                    passSignals: (_obj2 = {}, _define_property._(_obj2, _popupContainerconstants.HIDE_POPUP_SIGNAL, true), _define_property._(_obj2, _popupContainerconstants.ROUTE_BACK_SIGNAL, true), _define_property._(_obj2, _popupContainerconstants.EXIT_APP_SIGNAL, true), _obj2)
                };
            }
        }
    ]);
    return SubscriptionPopup;
}(_abstractPopupcomponent.AbstractPopup);


/***/ }),

/***/ 26306:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(37815);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _layoutselectors = __webpack_require__(53368);
var mapControllers = function(instance) {
    return [
        {
            shouldBeInvokedOnConnect: true,
            selector: _layoutselectors.getRequestedEntityType,
            callback: function(value) {
                instance.entityType = value;
            }
        }
    ];
};
var _default = _lightningjsredux.default.control(mapControllers);


/***/ }),

/***/ 21643:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "getUpsell", ({
    enumerable: true,
    get: function() {
        return getUpsell;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(88801);
var _config = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67958));
var getUpsell = function(lock) {
    if (!_config.default.featureFlipping.upsellFlow) {
        return null;
    }
    if (!lock) {
        return null;
    }
    var unlockTarget = lock.reasonAttributes ? lock.reasonAttributes.unlockTarget : null;
    if (!unlockTarget) {
        return null;
    }
    var upsell = unlockTarget["value_".concat(unlockTarget.type)];
    return upsell && upsell.reference === "upsell" ? upsell : null;
};


/***/ }),

/***/ 95045:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "ProfilesGate", ({
    enumerable: true,
    get: function() {
        return ProfilesGate;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(45538);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _ctaactions = __webpack_require__(32067);
var _theme = __webpack_require__(74314);
var _brandIconcomponent = __webpack_require__(362);
var _templates = __webpack_require__(63555);
var _abstractLayoututils = __webpack_require__(41533);
var _block = __webpack_require__(3777);
var _impression = __webpack_require__(62117);
var _signals = __webpack_require__(2109);
var _popupContainerconstants = __webpack_require__(54258);
var _exitPopupcomponent = __webpack_require__(89480);
var _profilesGatestyle = __webpack_require__(50479);
var ProfilesGate = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(ProfilesGate, _Lightning_Component);
    var _super = _create_super._(ProfilesGate);
    function ProfilesGate() {
        _class_call_check._(this, ProfilesGate);
        return _super.apply(this, arguments);
    }
    _create_class._(ProfilesGate, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _profilesGatestyle.defaultContext;
            }
        },
        {
            key: "_inactive",
            value: function _inactive() {
                // TODO: figure out if we actually want to track profiles
                (0, _impression.trackImpressions)(this._data);
            }
        },
        {
            key: "data",
            set: function set(value) {
                this._data = value;
                var _this__data = this._data, blocks = _this__data.blocks, layout = _this__data.layout;
                if (!blocks || !blocks.length) {
                    return;
                }
                var children = [];
                var theme = (0, _theme.getLayoutTheme)((0, _get.default)(layout, "theme"));
                var data = blocks[0];
                var title = (0, _block.getTitle)(data.title);
                // The title comes from Phrase
                data.title = {};
                // Define Lightning classes that would be used to instantiate block and item views
                var blockType = (0, _templates.getBlockTemplateById)(data.blockTemplateId);
                var itemType = (0, _templates.getContentTemplateByTemplateId)(data.content.contentTemplateId);
                var itemSize = (0, _templates.getContentSizeByContentTemplateId)(data.content.contentTemplateId);
                var blockSize = (0, _abstractLayoututils.calculateBlockHeight)({
                    blockType: blockType,
                    data: data,
                    itemSize: itemSize
                });
                var w = _profilesGatestyle.WIDTH[this._style.screenSize];
                var _obj;
                children.push({
                    type: blockType,
                    data: {
                        block: data,
                        itemSize: itemSize,
                        itemType: itemType,
                        theme: theme,
                        rowSize: {
                            w: w,
                            h: blockSize.h
                        }
                    },
                    contentGap: _profilesGatestyle.CONTENT_GAP[this._style.screenSize],
                    contentPadding: (0, _profilesGatestyle.getContentPadding)(),
                    w: w,
                    h: blockSize.h,
                    signals: (_obj = {}, _define_property._(_obj, _signals.SELECTED_SIGNAL, "_handleSelected"), _define_property._(_obj, _signals.IMPRESSION_TRACK_SIGNAL, "_impressionTrack"), _define_property._(_obj, _signals.IMPRESSION_UNTRACK_SIGNAL, "_impressionUnTrack"), _obj)
                });
                this.patch({
                    alpha: 1,
                    Background: {
                        color: theme.backgroundColor || _profilesGatestyle.colors.background[this._style.colorMode]
                    },
                    Title: {
                        text: {
                            text: title
                        }
                    },
                    Blocks: {
                        children: children
                    }
                });
                this._refocus();
            }
        },
        {
            key: "_getFocused",
            value: function _getFocused() {
                return this.tag("ExitPopup").visible ? this.tag("ExitPopup") : this.tag("Blocks").children[0];
            }
        },
        {
            key: "_handleSelected",
            value: function _handleSelected(item) {
                this.visible = false;
                return _lightningjsredux.default.dispatch((0, _ctaactions.createItemAction)({
                    item: item
                }));
            }
        },
        {
            key: "_handleBack",
            value: function _handleBack() {
                var exitPopup = this.tag("ExitPopup");
                exitPopup.visible = !exitPopup.visible;
                return true;
            }
        },
        {
            key: "_handleExitAppSignal",
            value: function _handleExitAppSignal() {
                this.signal(_popupContainerconstants.EXIT_APP_SIGNAL);
            }
        },
        {
            key: "_handleHidePopupSignal",
            value: function _handleHidePopupSignal() {
                this.tag("ExitPopup").visible = false;
                this._refocus();
            }
        },
        {
            key: "_impressionTrack",
            value: function _impressionTrack(_, items) {
                (0, _impression.track)(0, items);
            }
        },
        {
            key: "_impressionUnTrack",
            value: function _impressionUnTrack(_, items) {
                (0, _impression.untrack)(0, items);
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                var _obj, _obj1;
                return (0, _merge.default)({
                    Background: {
                        rect: true
                    },
                    CustomerLogo: {
                        type: _brandIconcomponent.BrandIcon
                    },
                    Title: {},
                    Blocks: {},
                    ExitPopup: {
                        visible: false,
                        type: _exitPopupcomponent.ExitPopup,
                        signals: (_obj = {}, _define_property._(_obj, _popupContainerconstants.EXIT_APP_SIGNAL, "_handleExitAppSignal"), _define_property._(_obj, _popupContainerconstants.HIDE_POPUP_SIGNAL, "_handleHidePopupSignal"), _obj),
                        passSignals: (_obj1 = {}, _define_property._(_obj1, _popupContainerconstants.EXIT_APP_SIGNAL, false), _define_property._(_obj1, _popupContainerconstants.HIDE_POPUP_SIGNAL, false), _obj1)
                    },
                    testId: "ProfilesGate"
                }, (0, _profilesGatestyle.getInitialStyle)());
            }
        }
    ]);
    return ProfilesGate;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 50479:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    CONTENT_GAP: function() {
        return CONTENT_GAP;
    },
    LOGO_HEIGHT: function() {
        return LOGO_HEIGHT;
    },
    LOGO_Y: function() {
        return LOGO_Y;
    },
    TITLE_MARGIN_BOTTOM: function() {
        return TITLE_MARGIN_BOTTOM;
    },
    WIDTH: function() {
        return WIDTH;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getContentPadding: function() {
        return getContentPadding;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _object_spread = __webpack_require__(76247);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
var _theme = __webpack_require__(51397);
var _constants = __webpack_require__(34952);
var _typography = __webpack_require__(18411);
var _style = __webpack_require__(65082);
var _sizes = __webpack_require__(82699);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var getContentPadding = function() {
    var screenSize = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : undefined;
    var screenDimension = screenSize || defaultContext.screenSize;
    return _constants.safetyMargins.horizontal[screenDimension];
};
var _obj;
var CONTENT_GAP = (_obj = {}, _define_property._(_obj, _constants.HD, 40), _define_property._(_obj, _constants.FULL_HD, 40), _obj);
var WIDTH = _object_spread._({}, _sizes.SCREEN_WIDTH);
var _obj1;
var LOGO_HEIGHT = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 128), _define_property._(_obj1, _constants.FULL_HD, 152), _obj1);
var _obj2;
var LOGO_Y = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 88), _define_property._(_obj2, _constants.FULL_HD, 104), _obj2);
var _obj3;
var TITLE_MARGIN_BOTTOM = (_obj3 = {}, _define_property._(_obj3, _constants.HD, 40), _define_property._(_obj3, _constants.FULL_HD, 96), _obj3);
var colors = {
    background: (0, _theme.makeThemeColor)(_theme.TERTIARY)
};
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var screenSize = context.screenSize, colorMode = context.colorMode;
    var w = WIDTH[screenSize];
    var h = _sizes.SCREEN_HEIGHT[screenSize];
    var titleY = LOGO_Y[screenSize] + LOGO_HEIGHT[screenSize];
    var titleFont = (0, _typography.getFont)(_typography.FONT.PARIS_3, screenSize);
    return {
        w: w,
        h: h,
        alpha: 0,
        Background: {
            w: w,
            h: h,
            color: colors.background[colorMode]
        },
        CustomerLogo: {
            mountX: 0.5,
            x: _sizes.middle,
            y: LOGO_Y[screenSize],
            h: LOGO_HEIGHT[screenSize]
        },
        Title: {
            mountX: 0.5,
            x: Math.round(w / 2),
            y: titleY,
            text: titleFont
        },
        Blocks: {
            y: titleY + titleFont.lineHeight + TITLE_MARGIN_BOTTOM[screenSize],
            w: w
        }
    };
};


/***/ }),

/***/ 37276:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "QRCodePage", ({
    enumerable: true,
    get: function() {
        return QRCodePage;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(37815);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _qrcode = /*#__PURE__*/ _interop_require_default._(__webpack_require__(20061));
var _sdk = __webpack_require__(29956);
var _config = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67958));
var _icons = __webpack_require__(20360);
var _i18n = __webpack_require__(14910);
var _apputils = __webpack_require__(60368);
var _qrCodestyle = __webpack_require__(14666);
var _qrCodeutils = __webpack_require__(75554);
var _sizes = __webpack_require__(82699);
var _routesutils = __webpack_require__(14948);
var QRCodePage = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(QRCodePage, _Lightning_Component);
    var _super = _create_super._(QRCodePage);
    function QRCodePage() {
        _class_call_check._(this, QRCodePage);
        return _super.apply(this, arguments);
    }
    _create_class._(QRCodePage, [
        {
            key: "_active",
            value: function _active() {
                var _this = this;
                (0, _apputils.removeSplashScreen)();
                var pageName = _sdk.Router.getActiveRoute().replace("".concat(_routesutils.CORE_PATH, "/"), "");
                var codeUrl = (0, _get.default)(_config.default, "qrCode.links.".concat(pageName, ".long"));
                var shortUrl = (0, _get.default)(_config.default, "qrCode.links.".concat(pageName, ".short"));
                var translationKey = (0, _qrCodeutils.getPageTranslationKey)(pageName);
                var screenSize = (0, _sizes.getScreenSize)();
                _qrcode.default.toDataURL(codeUrl, {
                    margin: 2,
                    width: _qrCodestyle.QR_CODE_IMAGE_SIZE[screenSize].w
                }).then(function(dataUrl) {
                    var texture = (0, _icons.getSvgTexture)(dataUrl, _qrCodestyle.QR_CODE_IMAGE_SIZE[screenSize].w, _qrCodestyle.QR_CODE_IMAGE_SIZE[screenSize].h);
                    _this.tag("Code").texture = texture;
                });
                this.patch({
                    Content: {
                        PageTitle: {
                            text: {
                                text: (0, _i18n.t)("".concat(translationKey, ".title"))
                            }
                        },
                        QRCodeWrapper: {
                            Title: {
                                text: {
                                    text: (0, _i18n.t)("".concat(translationKey, ".qrcode.title"))
                                }
                            },
                            Info: {
                                text: {
                                    text: "".concat((0, _i18n.t)("".concat(translationKey, ".qrcode.infos")), " <b>").concat(shortUrl, "</b>")
                                }
                            }
                        }
                    }
                });
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({}, (0, _qrCodestyle.getInitialStyle)());
            }
        }
    ]);
    return QRCodePage;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 14666:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    INFO_WRAP_WIDTH: function() {
        return INFO_WRAP_WIDTH;
    },
    PAGE_TITLE_FONT: function() {
        return PAGE_TITLE_FONT;
    },
    QR_CODE_IMAGE_SIZE: function() {
        return QR_CODE_IMAGE_SIZE;
    },
    QR_TITLE_FONT: function() {
        return QR_TITLE_FONT;
    },
    _defaultContext_screenSize: function() {
        return _defaultContext_screenSize;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    screenSize: function() {
        return screenSize;
    }
});
var _define_property = __webpack_require__(21228);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(52318);
var _sdk = __webpack_require__(29956);
var _theme = __webpack_require__(51397);
var _constants = __webpack_require__(34952);
var _typography = __webpack_require__(18411);
var _sizes = __webpack_require__(82699);
var defaultContext = {
    screenSize: (0, _sizes.getScreenSize)(),
    colorMode: _theme.DEFAULT_MODE
};
var _defaultContext_screenSize = defaultContext.screenSize, screenSize = _defaultContext_screenSize === void 0 ? _constants.FULL_HD : _defaultContext_screenSize;
var colors = {
    background: (0, _theme.makeThemeColor)(_theme.TERTIARY),
    text: (0, _theme.makeThemeColor)(_theme.PRIMARY),
    border: (0, _theme.makeThemeColor)(_theme.PRIMARY, 0.3)
};
var _obj;
var CONTENT_PADDING_TOP = (_obj = {}, _define_property._(_obj, _constants.HD, 24), _define_property._(_obj, _constants.FULL_HD, 36), _obj);
var _obj1;
var CONTENT_PADDING_LEFT = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 372), _define_property._(_obj1, _constants.FULL_HD, 698), _obj1);
var _obj2;
var QR_CODE_WRAPPER_PADDING_TOP = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 120), _define_property._(_obj2, _constants.FULL_HD, 202), _obj2);
var _obj3;
var QR_CODE_WRAPPER_SIZE = (_obj3 = {}, _define_property._(_obj3, _constants.HD, {
    w: 452,
    h: 422
}), _define_property._(_obj3, _constants.FULL_HD, {
    w: 580,
    h: 598
}), _obj3);
var _obj4;
var QR_CODE_TITLE_PADDING_TOP = (_obj4 = {}, _define_property._(_obj4, _constants.HD, 48), _define_property._(_obj4, _constants.FULL_HD, 64), _obj4);
var _obj5;
var QR_CODE_IMAGE_PADDING_TOP = (_obj5 = {}, _define_property._(_obj5, _constants.HD, 40), _define_property._(_obj5, _constants.FULL_HD, 64), _obj5);
var _obj6;
var QR_CODE_IMAGE_SIZE = (_obj6 = {}, _define_property._(_obj6, _constants.HD, {
    w: 162,
    h: 162
}), _define_property._(_obj6, _constants.FULL_HD, {
    w: 250,
    h: 250
}), _obj6);
var _obj7;
var QR_CODE_INFO_PADDING_TOP = (_obj7 = {}, _define_property._(_obj7, _constants.HD, 40), _define_property._(_obj7, _constants.FULL_HD, 56), _obj7);
var _obj8;
var PAGE_TITLE_FONT = (_obj8 = {}, _define_property._(_obj8, _constants.HD, _typography.FONT.OTTAWA_3), _define_property._(_obj8, _constants.FULL_HD, _typography.FONT.PARIS_3), _obj8);
var _obj9;
var QR_TITLE_FONT = (_obj9 = {}, _define_property._(_obj9, _constants.HD, _typography.FONT.KINSHASA_3), _define_property._(_obj9, _constants.FULL_HD, _typography.FONT.KINSHASA_3), _obj9);
var _obj10;
var INFO_WRAP_WIDTH = (_obj10 = {}, _define_property._(_obj10, _constants.HD, 388), _define_property._(_obj10, _constants.FULL_HD, 485), _obj10);
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var _context_screenSize = context.screenSize, screenSize = _context_screenSize === void 0 ? _constants.FULL_HD : _context_screenSize, _context_colorMode = context.colorMode, colorMode = _context_colorMode === void 0 ? _theme.DEFAULT_MODE : _context_colorMode;
    return {
        w: _sizes.SCREEN_WIDTH[screenSize],
        h: _sizes.SCREEN_HEIGHT[screenSize],
        Background: {
            rect: true,
            h: _sizes.identity,
            w: _sizes.identity,
            color: colors.background[colorMode]
        },
        Content: {
            x: CONTENT_PADDING_LEFT[screenSize],
            y: CONTENT_PADDING_TOP[screenSize],
            flex: {
                direction: "column",
                alignItems: "center"
            },
            PageTitle: {
                text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(PAGE_TITLE_FONT[screenSize], screenSize)), {
                    verticalAlign: "middle",
                    textColor: colors.text[colorMode]
                })
            },
            QRCodeWrapper: {
                flex: {
                    direction: "column",
                    alignItems: "center"
                },
                y: QR_CODE_WRAPPER_PADDING_TOP[screenSize],
                texture: _sdk.Lightning.Tools.getRoundRect(QR_CODE_WRAPPER_SIZE[screenSize].w, QR_CODE_WRAPPER_SIZE[screenSize].h, 8, colors.border[colorMode] ? 1 : 0, colors.border[colorMode], true, colors.background[colorMode]),
                Title: {
                    flexItem: {
                        marginTop: QR_CODE_TITLE_PADDING_TOP[screenSize]
                    },
                    text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(QR_TITLE_FONT[screenSize], screenSize)), {
                        verticalAlign: "middle",
                        textColor: colors.text[colorMode]
                    })
                },
                Code: {
                    flexItem: {
                        marginTop: QR_CODE_IMAGE_PADDING_TOP[screenSize]
                    },
                    rect: true,
                    h: QR_CODE_IMAGE_SIZE[screenSize].h,
                    w: QR_CODE_IMAGE_SIZE[screenSize].w,
                    color: colors.text[colorMode],
                    shader: {
                        type: _sdk.Lightning.shaders.RoundedRectangle,
                        radius: 8,
                        strokeColor: colors.text[colorMode]
                    }
                },
                Info: {
                    flexItem: {
                        marginTop: QR_CODE_INFO_PADDING_TOP[screenSize]
                    },
                    text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT.BERLIN_1, screenSize)), {
                        maxLines: 3,
                        verticalAlign: "middle",
                        wordBreak: true,
                        advancedRenderer: true,
                        wordWrapWidth: INFO_WRAP_WIDTH[screenSize],
                        textAlign: "center",
                        textColor: colors.text[colorMode]
                    })
                }
            }
        }
    };
};


/***/ }),

/***/ 75554:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    getPageTranslationKey: function() {
        return getPageTranslationKey;
    },
    pageToTranslationMap: function() {
        return pageToTranslationMap;
    }
});
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(65759);
var pageToTranslationMap = {
    information: "accountInformation",
    account_settings: "accountSettings"
};
var getPageTranslationKey = function(key) {
    return pageToTranslationMap[key] ? pageToTranslationMap[key] : key;
};


/***/ }),

/***/ 74538:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "routes", ({
    enumerable: true,
    get: function() {
        return routes;
    }
}));
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(37815);
var _toscomponent = __webpack_require__(97140);
var _audiocomponent = __webpack_require__(64276);
var routes = [
    {
        path: "audio/:audioId",
        component: _audiocomponent.AudioPlayer,
        widgets: [
            "CookieConsent",
            "SnackBar",
            "Popup"
        ],
        options: {
            preventStorage: true,
            reuseInstance: false
        }
    },
    {
        path: "radio/:audioId",
        component: _audiocomponent.AudioPlayer,
        widgets: [
            "CookieConsent",
            "SnackBar",
            "Popup"
        ],
        options: {
            preventStorage: true,
            reuseInstance: false
        }
    },
    {
        path: "ssi",
        component: _toscomponent.TermsOfService,
        widgets: [
            "CookieConsent",
            "Popup"
        ]
    }
];


/***/ }),

/***/ 19464:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "afterEachRoute", ({
    enumerable: true,
    get: function() {
        return afterEachRoute;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
var _sdk = __webpack_require__(29956);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _routesutils = __webpack_require__(14948);
var _analyticsutils = __webpack_require__(2693);
var afterEachRoute = function(destination) {
    var url = (0, _get.default)(destination, "url", "");
    if (url && _routesutils.HISTORY_CLEANUP_PAGES.includes(url)) {
        _sdk.Router.setHistory([]);
    }
    (0, _analyticsutils.sendPageView)(destination.url);
    (0, _analyticsutils.sendPrintEvent)("ViewContent");
};


/***/ }),

/***/ 77424:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _export_star = __webpack_require__(37668);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(65759);
_export_star._(__webpack_require__(41397), exports);


/***/ }),

/***/ 52850:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "boot", ({
    enumerable: true,
    get: function() {
        return boot;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(3009);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _config = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67958));
var _appactions = __webpack_require__(20386);
var _routingactions = __webpack_require__(78235);
var _layoutactions = __webpack_require__(8424);
var _templates = __webpack_require__(63555);
var boot = function() {
    _lightningjsredux.default.dispatch((0, _routingactions.setDeeplinkLocation)(window.location.hash.replace(/^#/, "")));
    _lightningjsredux.default.dispatch((0, _layoutactions.setContentTemplateOptions)((0, _templates.getContentTemplateOptions)()));
    return _lightningjsredux.default.dispatch((0, _appactions.initializeApp)(_config.default));
};


/***/ }),

/***/ 41397:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "beforeEachRoute", ({
    enumerable: true,
    get: function() {
        return beforeEachRoute;
    }
}));
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
var beforeEachRoute = function() {
    return Promise.resolve(true);
};


/***/ }),

/***/ 63487:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "routerConfig", ({
    enumerable: true,
    get: function() {
        return routerConfig;
    }
}));
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(52318);
var _boothook = __webpack_require__(52850);
var routerConfig = {
    boot: _boothook.boot
};


/***/ }),

/***/ 24439:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default1;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _to_consumable_array = __webpack_require__(30005);
var _create_super = __webpack_require__(6400);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(65759);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _sdk = __webpack_require__(29956);
var _routingactions = __webpack_require__(78235);
var _pagecomponent = __webpack_require__(58967);
var _pairingcomponent = __webpack_require__(64331);
var _landingcomponent = __webpack_require__(36084);
var _beforeEachRoutehook = __webpack_require__(77424);
var _afterEachRoutehook = __webpack_require__(19464);
var _routesutils = __webpack_require__(14948);
var _accountcomponent = __webpack_require__(62959);
var _settingscomponent = __webpack_require__(90912);
var _staticPagecomponent = __webpack_require__(50844);
var _subscriptionExpiredcomponent = __webpack_require__(7394);
var _qrCodecomponent = __webpack_require__(37276);
var _userInformationcomponent = __webpack_require__(34783);
var _abstractMosaiccomponent = __webpack_require__(20533);
var _videocomponent = __webpack_require__(78926);
var _livecomponent = __webpack_require__(73382);
var _default = __webpack_require__(63487);
var _routes = __webpack_require__(74538);
var _deviceGatecomponent = __webpack_require__(70362);
var ErrorHandler = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(ErrorHandler, _Lightning_Component);
    var _super = _create_super._(ErrorHandler);
    function ErrorHandler() {
        _class_call_check._(this, ErrorHandler);
        return _super.apply(this, arguments);
    }
    _create_class._(ErrorHandler, [
        {
            key: "_active",
            value: function _active() {
                _sdk.Router.navigate("app/alias/home", false);
            }
        }
    ]);
    return ErrorHandler;
}(_sdk.Lightning.Component);
var _default1 = _object_spread_props._(_object_spread._({}, _default.routerConfig), {
    root: _routesutils.HOME_PATH,
    beforeEachRoute: function(from, to) {
        _lightningjsredux.default.dispatch((0, _routingactions.setCurrentLocation)(to.url, to.route.path));
        // eslint-disable-next-line no-console
        console.log("[routes] Navigating to: ".concat(to.url));
        return (0, _beforeEachRoutehook.beforeEachRoute)(from, to);
    },
    afterEachRoute: function(destination) {
        return (0, _afterEachRoutehook.afterEachRoute)(destination);
    },
    routes: _to_consumable_array._(_routes.routes).concat([
        {
            path: "video/:videoId",
            component: _videocomponent.Video,
            widgets: [
                "CookieConsent",
                "SnackBar",
                "Popup",
                "ScreenSaver"
            ],
            options: {
                preventStorage: true,
                reuseInstance: false
            }
        },
        {
            path: "live/:videoId",
            component: _livecomponent.Live,
            widgets: [
                "CookieConsent",
                "SnackBar",
                "Popup",
                "ScreenSaver"
            ],
            options: {
                preventStorage: true,
                reuseInstance: false
            }
        },
        {
            path: "app/:entityType/:entityId",
            component: _pagecomponent.Page,
            widgets: [
                "Sidenav",
                "SnackBar",
                "CookieConsent",
                "Popup",
                "ScreenSaver"
            ],
            options: {
                reuseInstance: false
            }
        },
        {
            path: "app/frontspace/offers",
            component: _subscriptionExpiredcomponent.SubscriptionExpired,
            widgets: [
                "CookieConsent",
                "Popup",
                "ScreenSaver"
            ]
        },
        {
            path: _routesutils.PAIRING_PATH,
            component: _pairingcomponent.Pairing,
            widgets: [
                "CookieConsent",
                "Popup"
            ]
        },
        {
            path: _routesutils.LANDING_PATH,
            component: _landingcomponent.Landing,
            widgets: [
                "CookieConsent",
                "Popup"
            ],
            options: {
                clearHistory: true
            }
        },
        {
            path: _routesutils.DEVICE_GATE_PATH,
            component: _deviceGatecomponent.DeviceGate,
            widgets: [
                "CookieConsent",
                "Popup",
                "ScreenSaver"
            ],
            options: {
                clearHistory: true
            }
        },
        {
            path: _routesutils.EXPIRED_SUBSCRIPTION_PATH,
            component: _subscriptionExpiredcomponent.SubscriptionExpired,
            widgets: [
                "CookieConsent",
                "SnackBar",
                "Popup"
            ]
        },
        {
            path: _routesutils.PROFILE_PATH,
            component: _accountcomponent.Account,
            widgets: [
                "Sidenav",
                "CookieConsent",
                "Popup",
                "ScreenSaver"
            ]
        },
        {
            path: _routesutils.SETTINGS_PATH,
            component: _settingscomponent.Settings,
            widgets: [
                "Sidenav",
                "CookieConsent",
                "Popup"
            ]
        },
        {
            path: _routesutils.INFORMATION_PATH,
            component: _userInformationcomponent.UserInformation,
            widgets: [
                "Sidenav",
                "CookieConsent",
                "Popup"
            ]
        },
        {
            path: _routesutils.FOLDERS_PATH,
            component: _abstractMosaiccomponent.AbstractMosaic,
            widgets: [
                "Sidenav",
                "CookieConsent",
                "Popup",
                "ScreenSaver"
            ]
        },
        {
            path: _routesutils.SERVICES_PATH,
            component: _abstractMosaiccomponent.AbstractMosaic,
            widgets: [
                "Sidenav",
                "CookieConsent",
                "Popup",
                "ScreenSaver"
            ]
        },
        {
            path: _routesutils.LIVES_PATH,
            component: _abstractMosaiccomponent.AbstractMosaic,
            widgets: [
                "Sidenav",
                "CookieConsent",
                "Popup"
            ]
        },
        {
            path: _routesutils.USAGE_TERMS_PATH,
            before: function(page) {
                page.target = "termsOfUsage";
                return Promise.resolve();
            },
            component: _staticPagecomponent.StaticPage,
            widgets: [
                "CookieConsent",
                "Popup"
            ]
        },
        {
            path: _routesutils.LEGAL_CONDITIONS_PATH,
            before: function(page) {
                page.target = "legalConditions";
                return Promise.resolve();
            },
            component: _staticPagecomponent.StaticPage,
            widgets: [
                "CookieConsent",
                "Popup"
            ]
        },
        {
            path: _routesutils.PRIVACY_POLICY_PATH,
            before: function(page) {
                page.target = "privacyPolicy";
                return Promise.resolve();
            },
            component: _staticPagecomponent.StaticPage,
            widgets: [
                "CookieConsent",
                "Popup"
            ]
        },
        {
            path: _routesutils.FAQ_PATH,
            component: _qrCodecomponent.QRCodePage,
            widgets: [
                "Sidenav",
                "Popup",
                "ScreenSaver"
            ]
        },
        {
            path: _routesutils.ACCOUNT_SETTINGS_PATH,
            component: _qrCodecomponent.QRCodePage,
            widgets: [
                "Sidenav",
                "Popup",
                "ScreenSaver"
            ]
        },
        {
            path: _routesutils.FEEDBACK_PATH,
            component: _qrCodecomponent.QRCodePage,
            widgets: [
                "Sidenav",
                "Popup",
                "ScreenSaver"
            ]
        },
        {
            path: "*",
            component: _pagecomponent.Page,
            widgets: [
                "CookieConsent",
                "Popup"
            ]
        },
        {
            path: "!",
            component: ErrorHandler
        }
    ])
});


/***/ }),

/***/ 14948:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ACCOUNT_SETTINGS_PATH: function() {
        return ACCOUNT_SETTINGS_PATH;
    },
    APP_PATH: function() {
        return APP_PATH;
    },
    AUDIO_PATH: function() {
        return AUDIO_PATH;
    },
    BOOKMARKS_ENTITY: function() {
        return BOOKMARKS_ENTITY;
    },
    BOOKMARKS_PATH: function() {
        return BOOKMARKS_PATH;
    },
    CORE_PATH: function() {
        return CORE_PATH;
    },
    DEEP_LINK_EXCLUSIONS: function() {
        return DEEP_LINK_EXCLUSIONS;
    },
    DEVICE_GATE_PATH: function() {
        return DEVICE_GATE_PATH;
    },
    EXPIRED_SUBSCRIPTION_PATH: function() {
        return EXPIRED_SUBSCRIPTION_PATH;
    },
    FAQ_PATH: function() {
        return FAQ_PATH;
    },
    FEEDBACK_PATH: function() {
        return FEEDBACK_PATH;
    },
    FOLDERS_ENTITY: function() {
        return FOLDERS_ENTITY;
    },
    FOLDERS_PATH: function() {
        return FOLDERS_PATH;
    },
    FOLDER_ENTITY: function() {
        return FOLDER_ENTITY;
    },
    FOLDER_PATH: function() {
        return FOLDER_PATH;
    },
    FRONTSPACE_PATH: function() {
        return FRONTSPACE_PATH;
    },
    HISTORY_CLEANUP_PAGES: function() {
        return HISTORY_CLEANUP_PAGES;
    },
    HOME_PATH: function() {
        return HOME_PATH;
    },
    INFORMATION_PATH: function() {
        return INFORMATION_PATH;
    },
    LANDING_PATH: function() {
        return LANDING_PATH;
    },
    LEGAL_CONDITIONS_PATH: function() {
        return LEGAL_CONDITIONS_PATH;
    },
    LIVES_ENTITY: function() {
        return LIVES_ENTITY;
    },
    LIVES_PATH: function() {
        return LIVES_PATH;
    },
    LIVE_PATH: function() {
        return LIVE_PATH;
    },
    PAIRING_PATH: function() {
        return PAIRING_PATH;
    },
    PRIVACY_POLICY_PATH: function() {
        return PRIVACY_POLICY_PATH;
    },
    PROFILE_ENTITY: function() {
        return PROFILE_ENTITY;
    },
    PROFILE_PATH: function() {
        return PROFILE_PATH;
    },
    PROGRAM_ENTITY: function() {
        return PROGRAM_ENTITY;
    },
    PROGRAM_PATH: function() {
        return PROGRAM_PATH;
    },
    RADIO_PATH: function() {
        return RADIO_PATH;
    },
    SEARCH_ENTITY: function() {
        return SEARCH_ENTITY;
    },
    SEARCH_PATH: function() {
        return SEARCH_PATH;
    },
    SEASON_ENTITY: function() {
        return SEASON_ENTITY;
    },
    SEASON_PATH: function() {
        return SEASON_PATH;
    },
    SERVICES_ENTITY: function() {
        return SERVICES_ENTITY;
    },
    SERVICES_PATH: function() {
        return SERVICES_PATH;
    },
    SERVICE_ENTITY: function() {
        return SERVICE_ENTITY;
    },
    SERVICE_PATH: function() {
        return SERVICE_PATH;
    },
    SETTINGS_PATH: function() {
        return SETTINGS_PATH;
    },
    SSI_PATH: function() {
        return SSI_PATH;
    },
    SUBSCRIPTION_TERMS_PATH: function() {
        return SUBSCRIPTION_TERMS_PATH;
    },
    USAGE_TERMS_PATH: function() {
        return USAGE_TERMS_PATH;
    },
    VIDEO_PATH: function() {
        return VIDEO_PATH;
    },
    navigateTo: function() {
        return navigateTo;
    },
    navigateToAccountSettingsPage: function() {
        return navigateToAccountSettingsPage;
    },
    navigateToAliasHome: function() {
        return navigateToAliasHome;
    },
    navigateToAudioPage: function() {
        return navigateToAudioPage;
    },
    navigateToBookmarksPage: function() {
        return navigateToBookmarksPage;
    },
    navigateToExpiredSubscriptionPage: function() {
        return navigateToExpiredSubscriptionPage;
    },
    navigateToFAQPage: function() {
        return navigateToFAQPage;
    },
    navigateToFeedbackPage: function() {
        return navigateToFeedbackPage;
    },
    navigateToFolderPage: function() {
        return navigateToFolderPage;
    },
    navigateToFoldersPage: function() {
        return navigateToFoldersPage;
    },
    navigateToFrontspace: function() {
        return navigateToFrontspace;
    },
    navigateToInformationPage: function() {
        return navigateToInformationPage;
    },
    navigateToLandingPage: function() {
        return navigateToLandingPage;
    },
    navigateToLegalConditionsPage: function() {
        return navigateToLegalConditionsPage;
    },
    navigateToLivePage: function() {
        return navigateToLivePage;
    },
    navigateToLivesPage: function() {
        return navigateToLivesPage;
    },
    navigateToPairingPage: function() {
        return navigateToPairingPage;
    },
    navigateToPrivacyPolicyPage: function() {
        return navigateToPrivacyPolicyPage;
    },
    navigateToProfilePage: function() {
        return navigateToProfilePage;
    },
    navigateToProgramPage: function() {
        return navigateToProgramPage;
    },
    navigateToRadioPage: function() {
        return navigateToRadioPage;
    },
    navigateToSearchPage: function() {
        return navigateToSearchPage;
    },
    navigateToSeasonPage: function() {
        return navigateToSeasonPage;
    },
    navigateToServicePage: function() {
        return navigateToServicePage;
    },
    navigateToServicesPage: function() {
        return navigateToServicesPage;
    },
    navigateToSettingsPage: function() {
        return navigateToSettingsPage;
    },
    navigateToUsageTermsPage: function() {
        return navigateToUsageTermsPage;
    },
    navigateToVodPage: function() {
        return navigateToVodPage;
    }
});
var _to_consumable_array = __webpack_require__(30005);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(3009);
var _sdk = __webpack_require__(29956);
var _fidosdk = __webpack_require__(19804);
var _Router;
var APP_PATH = "app";
var SERVICES_ENTITY = "services";
var FOLDERS_ENTITY = "folders";
var PROFILE_ENTITY = "profile";
var LIVES_ENTITY = "lives";
var FOLDER_ENTITY = _fidosdk.LAYOUT_ENTITIES.folder;
var PROGRAM_ENTITY = _fidosdk.LAYOUT_ENTITIES.program;
var SEASON_ENTITY = _fidosdk.LAYOUT_ENTITIES.season;
var SEARCH_ENTITY = "".concat(_fidosdk.LAYOUT_ENTITIES.frontspace, "/").concat(_fidosdk.LAYOUT_FRONTSPACES.search);
var SERVICE_ENTITY = _fidosdk.LAYOUT_ENTITIES.service;
var BOOKMARKS_ENTITY = "".concat(_fidosdk.LAYOUT_ENTITIES.frontspace, "/").concat(_fidosdk.LAYOUT_FRONTSPACES.bookmarks);
var BOOKMARKS_PATH = "".concat(APP_PATH, "/").concat(BOOKMARKS_ENTITY);
var FOLDER_PATH = "".concat(APP_PATH, "/").concat(FOLDER_ENTITY);
var SERVICES_PATH = "".concat(APP_PATH, "/").concat(SERVICES_ENTITY);
var PROFILE_PATH = "".concat(APP_PATH, "/").concat(PROFILE_ENTITY);
var PROGRAM_PATH = "".concat(APP_PATH, "/").concat(PROGRAM_ENTITY);
var SEASON_PATH = "".concat(APP_PATH, "/").concat(SEASON_ENTITY);
var SEARCH_PATH = "".concat(APP_PATH, "/").concat(SEARCH_ENTITY);
var SERVICE_PATH = "".concat(APP_PATH, "/").concat(SERVICE_ENTITY);
var HOME_PATH = "".concat(APP_PATH, "/").concat(_fidosdk.LAYOUT_ENTITIES.alias, "/").concat(_fidosdk.LAYOUT_ALIASES.home);
var FRONTSPACE_PATH = "".concat(APP_PATH, "/").concat(_fidosdk.LAYOUT_ENTITIES.frontspace);
var FOLDERS_PATH = "".concat(APP_PATH, "/").concat(FOLDERS_ENTITY);
var LIVES_PATH = "".concat(APP_PATH, "/").concat(LIVES_ENTITY);
var AUDIO_PATH = _fidosdk.LAYOUT_ENTITIES.audio;
var RADIO_PATH = _fidosdk.LAYOUT_ENTITIES.radio;
var VIDEO_PATH = _fidosdk.LAYOUT_ENTITIES.video;
var LIVE_PATH = _fidosdk.LAYOUT_ENTITIES.live;
var CORE_PATH = "core";
var PAIRING_PATH = "".concat(CORE_PATH, "/pairing");
var LANDING_PATH = "landing";
var SSI_PATH = "ssi";
var DEVICE_GATE_PATH = "device-gate";
var USAGE_TERMS_PATH = "/terms-of-usage";
var PRIVACY_POLICY_PATH = "/privacy-policy";
var SUBSCRIPTION_TERMS_PATH = "/terms-of-subscription";
var LEGAL_CONDITIONS_PATH = "/legal-conditions";
var SETTINGS_PATH = "/settings";
var INFORMATION_PATH = "".concat(CORE_PATH, "/information");
var FAQ_PATH = "".concat(CORE_PATH, "/faq");
var FEEDBACK_PATH = "".concat(CORE_PATH, "/feedback");
var ACCOUNT_SETTINGS_PATH = "".concat(CORE_PATH, "/account_settings");
var EXPIRED_SUBSCRIPTION_PATH = "".concat(CORE_PATH, "/expired-subscription");
var HISTORY_CLEANUP_PAGES = [
    HOME_PATH,
    LANDING_PATH
];
var DEEP_LINK_EXCLUSIONS = [
    HOME_PATH,
    LANDING_PATH,
    PAIRING_PATH,
    SSI_PATH,
    INFORMATION_PATH,
    USAGE_TERMS_PATH,
    PRIVACY_POLICY_PATH,
    SUBSCRIPTION_TERMS_PATH,
    LEGAL_CONDITIONS_PATH,
    SETTINGS_PATH,
    FAQ_PATH,
    FEEDBACK_PATH,
    ACCOUNT_SETTINGS_PATH,
    EXPIRED_SUBSCRIPTION_PATH,
    DEVICE_GATE_PATH
];
var navigateTo = function() {
    for(var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++){
        params[_key] = arguments[_key];
    }
    return (_Router = _sdk.Router).navigate.apply(_Router, _to_consumable_array._(params));
};
var navigateToAliasHome = function() {
    for(var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++){
        params[_key] = arguments[_key];
    }
    return navigateTo.apply(void 0, [
        HOME_PATH
    ].concat(_to_consumable_array._(params)));
};
var navigateToFrontspace = function(entityId) {
    for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        params[_key - 1] = arguments[_key];
    }
    return navigateTo.apply(void 0, [
        "".concat(FRONTSPACE_PATH, "/").concat(entityId)
    ].concat(_to_consumable_array._(params)));
};
var navigateToBookmarksPage = function() {
    for(var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++){
        params[_key] = arguments[_key];
    }
    return navigateTo.apply(void 0, [
        BOOKMARKS_PATH
    ].concat(_to_consumable_array._(params)));
};
var navigateToFolderPage = function(entityId) {
    for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        params[_key - 1] = arguments[_key];
    }
    return navigateTo.apply(void 0, [
        "".concat(FOLDER_PATH, "/").concat(entityId)
    ].concat(_to_consumable_array._(params)));
};
var navigateToServicesPage = function() {
    for(var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++){
        params[_key] = arguments[_key];
    }
    return navigateTo.apply(void 0, [
        SERVICES_PATH
    ].concat(_to_consumable_array._(params)));
};
var navigateToProfilePage = function() {
    for(var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++){
        params[_key] = arguments[_key];
    }
    return navigateTo.apply(void 0, [
        PROFILE_PATH
    ].concat(_to_consumable_array._(params)));
};
var navigateToProgramPage = function(entityId) {
    for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        params[_key - 1] = arguments[_key];
    }
    return navigateTo.apply(void 0, [
        "".concat(PROGRAM_PATH, "/").concat(entityId)
    ].concat(_to_consumable_array._(params)));
};
var navigateToSeasonPage = function(entityId) {
    for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        params[_key - 1] = arguments[_key];
    }
    return navigateTo.apply(void 0, [
        "".concat(SEASON_PATH, "/").concat(entityId)
    ].concat(_to_consumable_array._(params)));
};
var navigateToSearchPage = function() {
    for(var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++){
        params[_key] = arguments[_key];
    }
    return navigateTo.apply(void 0, [
        SEARCH_PATH
    ].concat(_to_consumable_array._(params)));
};
var navigateToServicePage = function(entityId) {
    for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        params[_key - 1] = arguments[_key];
    }
    return navigateTo.apply(void 0, [
        "".concat(SERVICE_PATH, "/").concat(entityId)
    ].concat(_to_consumable_array._(params)));
};
var navigateToFoldersPage = function() {
    for(var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++){
        params[_key] = arguments[_key];
    }
    return navigateTo.apply(void 0, [
        FOLDERS_PATH
    ].concat(_to_consumable_array._(params)));
};
var navigateToLivesPage = function() {
    for(var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++){
        params[_key] = arguments[_key];
    }
    return navigateTo.apply(void 0, [
        LIVES_PATH
    ].concat(_to_consumable_array._(params)));
};
var navigateToPairingPage = function() {
    for(var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++){
        params[_key] = arguments[_key];
    }
    return navigateTo.apply(void 0, [
        PAIRING_PATH
    ].concat(_to_consumable_array._(params)));
};
var navigateToAudioPage = function(entityId) {
    for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        params[_key - 1] = arguments[_key];
    }
    return navigateTo.apply(void 0, [
        "".concat(AUDIO_PATH, "/").concat(entityId)
    ].concat(_to_consumable_array._(params)));
};
var navigateToRadioPage = function(entityId) {
    for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        params[_key - 1] = arguments[_key];
    }
    return navigateTo.apply(void 0, [
        "".concat(RADIO_PATH, "/").concat(entityId)
    ].concat(_to_consumable_array._(params)));
};
var navigateToVodPage = function(entityId) {
    for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        params[_key - 1] = arguments[_key];
    }
    return navigateTo.apply(void 0, [
        "".concat(VIDEO_PATH, "/").concat(entityId)
    ].concat(_to_consumable_array._(params)));
};
var navigateToLivePage = function(entityId) {
    for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        params[_key - 1] = arguments[_key];
    }
    return navigateTo.apply(void 0, [
        "".concat(LIVE_PATH, "/").concat(entityId)
    ].concat(_to_consumable_array._(params)));
};
var navigateToLandingPage = function() {
    for(var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++){
        params[_key] = arguments[_key];
    }
    return navigateTo.apply(void 0, [
        LANDING_PATH
    ].concat(_to_consumable_array._(params)));
};
var navigateToExpiredSubscriptionPage = function() {
    for(var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++){
        params[_key] = arguments[_key];
    }
    return navigateTo.apply(void 0, [
        EXPIRED_SUBSCRIPTION_PATH
    ].concat(_to_consumable_array._(params)));
};
var navigateToSettingsPage = function() {
    for(var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++){
        params[_key] = arguments[_key];
    }
    return navigateTo.apply(void 0, [
        SETTINGS_PATH
    ].concat(_to_consumable_array._(params)));
};
var navigateToInformationPage = function() {
    for(var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++){
        params[_key] = arguments[_key];
    }
    return navigateTo.apply(void 0, [
        INFORMATION_PATH
    ].concat(_to_consumable_array._(params)));
};
var navigateToUsageTermsPage = function() {
    for(var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++){
        params[_key] = arguments[_key];
    }
    return navigateTo.apply(void 0, [
        USAGE_TERMS_PATH
    ].concat(_to_consumable_array._(params)));
};
var navigateToLegalConditionsPage = function() {
    for(var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++){
        params[_key] = arguments[_key];
    }
    return navigateTo.apply(void 0, [
        LEGAL_CONDITIONS_PATH
    ].concat(_to_consumable_array._(params)));
};
var navigateToPrivacyPolicyPage = function() {
    for(var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++){
        params[_key] = arguments[_key];
    }
    return navigateTo.apply(void 0, [
        PRIVACY_POLICY_PATH
    ].concat(_to_consumable_array._(params)));
};
var navigateToFAQPage = function() {
    for(var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++){
        params[_key] = arguments[_key];
    }
    return navigateTo.apply(void 0, [
        FAQ_PATH
    ].concat(_to_consumable_array._(params)));
};
var navigateToFeedbackPage = function() {
    for(var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++){
        params[_key] = arguments[_key];
    }
    return navigateTo.apply(void 0, [
        FEEDBACK_PATH
    ].concat(_to_consumable_array._(params)));
};
var navigateToAccountSettingsPage = function() {
    for(var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++){
        params[_key] = arguments[_key];
    }
    return navigateTo.apply(void 0, [
        ACCOUNT_SETTINGS_PATH
    ].concat(_to_consumable_array._(params)));
};


/***/ }),

/***/ 19685:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return ScreenSaver;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _create_super = __webpack_require__(6400);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(3009);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _fidosdk = __webpack_require__(19804);
var _constants = __webpack_require__(34952);
var _screenSaverutils = __webpack_require__(34849);
var _brandIconcomponent = __webpack_require__(362);
var _textures = __webpack_require__(67179);
var _screenSaverconnector = /*#__PURE__*/ _interop_require_default._(__webpack_require__(10013));
var _screenSaverstyle = __webpack_require__(41331);
var _screenSaverconstants = __webpack_require__(27009);
var ScreenSaver = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(ScreenSaver, _Lightning_Component);
    var _super = _create_super._(ScreenSaver);
    function ScreenSaver() {
        _class_call_check._(this, ScreenSaver);
        return _super.apply(this, arguments);
    }
    _create_class._(ScreenSaver, [
        {
            key: "_build",
            value: function _build() {
                var _this = this;
                this._index = 0;
                this._container = this.tag("BackgroundContainer");
                this._logoContainer = this.tag("LogoContainer");
                this._label = this.tag("Label");
                this._label.patch({
                    appear: this._label.animation((0, _screenSaverstyle.getDescriptionAppearAnimStyle)()),
                    fadeIn: this._label.animation((0, _screenSaverstyle.getFadeAnimStyle)(_screenSaverconstants.FADE_IN, _screenSaverconstants.LABEL_FADE_IN_DURATION, _screenSaverconstants.LABEL_APPEAR_DELAY)),
                    fadeOut: this._label.animation((0, _screenSaverstyle.getFadeAnimStyle)(_screenSaverconstants.FADE_OUT, _screenSaverconstants.LABEL_FADE_OUT_DURATION))
                });
                this._appearAnimation = this.animation((0, _screenSaverstyle.getFadeAnimStyle)(_screenSaverconstants.FADE_IN, _screenSaverconstants.SCREEN_APPEAR_DURATION));
                this._logoAppearAnimation = this.tag("Logo").animation((0, _screenSaverstyle.getFadeAnimStyle)(_screenSaverconstants.FADE_IN, _screenSaverconstants.LOGO_APPEAR_DURATION));
                this._labelSwapTimer = this.animation((0, _screenSaverstyle.getDummyAnimStyle)(_screenSaverconstants.LABEL_SWAP_DURATION_OFFSET));
                this._backgroundSwapTimer = this.animation((0, _screenSaverstyle.getDummyAnimStyle)(_screenSaverconstants.BACKGROUND_DURATION));
                this._logoSwapTimer = this.animation((0, _screenSaverstyle.getDummyAnimStyle)(_screenSaverconstants.BACKGROUND_DURATION));
                this._iterationTimer = this.animation((0, _screenSaverstyle.getDummyAnimStyle)(_screenSaverconstants.ITERATION_TOTAL_DURATION));
                this._labelSwapTimer.on("finish", function() {
                    return _this._onLabelSwapTimerFinished();
                });
                this._backgroundSwapTimer.on("finish", function() {
                    return _this._onBackgroundSwapTimerFinished();
                });
                this._logoSwapTimer.on("finish", function() {
                    return _this._onLogoSwapTimerFinished();
                });
                this._iterationTimer.on("finish", function() {
                    return _this._onIterationTimerFinished();
                });
                this._label.fadeOut.on("finish", function() {
                    return _this._onLabelFadeOutFinished();
                });
                this._isLocked = false;
            }
        },
        {
            key: "_attach",
            value: function _attach() {
                this._unsubscribe = (0, _screenSaverconnector.default)(this);
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                if (this._unsubscribe) {
                    this._unsubscribe();
                    this._unsubscribe = null;
                }
                this._reset();
            }
        },
        {
            key: "items",
            set: function set(value) {
                var _this = this;
                var _this1 = this, finalW = _this1.finalW, finalH = _this1.finalH;
                this._items = value;
                if (this._items.length === 1) {
                    for(var i = 0; i < _screenSaverstyle.BACKGROUND_STYLES.length - 1; i += 1){
                        this._items.push(this._items[0]);
                    }
                }
                var backgroundStyleIndex = -1;
                this._container.children = this._items.map(function() {
                    backgroundStyleIndex = (0, _screenSaverutils.getNextIndex)(backgroundStyleIndex, _screenSaverstyle.BACKGROUND_STYLES);
                    return _screenSaverstyle.BACKGROUND_STYLES[backgroundStyleIndex];
                });
                var _getProgramLogoStyle = (0, _screenSaverstyle.getProgramLogoStyle)(this._style), logoWidth = _getProgramLogoStyle.w, logoHeight = _getProgramLogoStyle.h;
                this._logoContainer.children = this._items.map(function() {
                    return {};
                });
                this._logoContainer.children.forEach(function(item, index) {
                    item.patch({
                        alpha: 0,
                        fadeIn: item.animation((0, _screenSaverstyle.getFadeAnimStyle)(_screenSaverconstants.FADE_IN, _screenSaverconstants.BACKGROUND_FADE_IN_DURATION, _screenSaverconstants.BACKGROUND_FADE_DELAY)),
                        fadeOut: item.animation((0, _screenSaverstyle.getFadeAnimStyle)(_screenSaverconstants.FADE_OUT, _screenSaverconstants.BACKGROUND_FADE_OUT_FAST)),
                        texture: _object_spread_props._(_object_spread._({}, (0, _textures.contain)(_fidosdk.imageService.getUrl(_this._items[index].logoId, logoWidth, logoHeight, {
                            fit: _constants.IMAGE_FIT_CROP,
                            quality: _constants.IMAGE_QUALITY,
                            format: _constants.TRANSPARENT_IMAGE_FORMAT
                        }))), {
                            hasAlpha: true
                        })
                    });
                    item.texture.load();
                });
                this._container.children.forEach(function(item, index) {
                    item.patch({
                        alpha: 0,
                        fadeIn: item.animation((0, _screenSaverstyle.getFadeAnimStyle)(_screenSaverconstants.FADE_IN, _screenSaverconstants.BACKGROUND_FADE_IN_DURATION, _screenSaverconstants.BACKGROUND_FADE_DELAY)),
                        fadeOut: item.animation((0, _screenSaverstyle.getFadeAnimStyle)(_screenSaverconstants.FADE_OUT, _screenSaverconstants.BACKGROUND_FADE_OUT_FAST)),
                        idle: item.animation((0, _screenSaverstyle.getBackgroundIdleAnimStyle)(item.zoom)),
                        texture: (0, _textures.cover)(_fidosdk.imageService.getUrl(_this._items[index].imageId, finalW, finalH, {
                            fit: _constants.IMAGE_FIT_SCALE_CROP,
                            quality: _constants.IMAGE_QUALITY,
                            format: _constants.DEFAULT_IMAGE_FORMAT
                        }), finalW, finalH)
                    });
                    item.texture.load();
                });
                if (this.canBeShown) {
                    this.resetTimer();
                }
            }
        },
        {
            key: "canBeShown",
            get: function get() {
                // NOTE: the "visible" flag could be set to false by Router in case if ScreenSaver is not presented in a "widgets" list for a current route
                return this.visible && !this._isLocked && Boolean(this._items && this._items.length);
            }
        },
        {
            key: "isShown",
            get: function get() {
                return this.alpha > 0;
            }
        },
        {
            key: "isLocked",
            set: function set(value) {
                this._isLocked = value;
            }
        },
        {
            key: "resetTimer",
            value: function resetTimer() {
                var _this = this;
                if (this._screenSaverTimeout) {
                    clearTimeout(this._screenSaverTimeout);
                }
                if (this.isShown) {
                    return;
                }
                this._screenSaverTimeout = setTimeout(function() {
                    _this.signal(_screenSaverconstants.SHOW_SCREENSAVER_SIGNAL);
                }, _screenSaverconstants.SCREEN_SAVER_COUNTDOWN);
            }
        },
        {
            key: "_handleKey",
            value: function _handleKey() {
                this.signal(_screenSaverconstants.HIDE_SCREENSAVER_SIGNAL);
                this.resetTimer();
            }
        },
        {
            key: "_focus",
            value: function _focus() {
                this._appearAnimation.start();
                this._startSequence();
            }
        },
        {
            key: "_unfocus",
            value: function _unfocus() {
                this._reset();
            }
        },
        {
            key: "_startSequence",
            value: function _startSequence() {
                this._container.children.forEach(function(item) {
                    item.alpha = 0;
                });
                this._logoAppearAnimation.start();
                this._startBackgroundAnimation(0, true);
                this._startLogoAnimation(0, true);
                this._startLabelAnimation(0, true);
                this._processSequence();
            }
        },
        {
            key: "_processSequence",
            value: function _processSequence() {
                this._labelSwapTimer.start();
                this._backgroundSwapTimer.start();
                this._logoSwapTimer.start();
                this._iterationTimer.start();
            }
        },
        {
            key: "_onLabelSwapTimerFinished",
            value: function _onLabelSwapTimerFinished() {
                if (this.isShown) {
                    this._label.fadeOut.start();
                }
            }
        },
        {
            key: "_onBackgroundSwapTimerFinished",
            value: function _onBackgroundSwapTimerFinished() {
                if (this.isShown) {
                    this._container.children[this._index].fadeOut.start();
                    this._startBackgroundAnimation((0, _screenSaverutils.getNextIndex)(this._index, this._items));
                }
            }
        },
        {
            key: "_onLogoSwapTimerFinished",
            value: function _onLogoSwapTimerFinished() {
                if (this.isShown) {
                    this._logoContainer.children[this._index].fadeOut.start();
                    this._startLogoAnimation((0, _screenSaverutils.getNextIndex)(this._index, this._items));
                }
            }
        },
        {
            key: "_onIterationTimerFinished",
            value: function _onIterationTimerFinished() {
                if (this.isShown) {
                    this._index = (0, _screenSaverutils.getNextIndex)(this._index, this._items);
                    this._processSequence();
                }
            }
        },
        {
            key: "_onLabelFadeOutFinished",
            value: function _onLabelFadeOutFinished() {
                if (this.isShown) {
                    this._startLabelAnimation((0, _screenSaverutils.getNextIndex)(this._index, this._items));
                }
            }
        },
        {
            key: "_startLabelAnimation",
            value: function _startLabelAnimation(index) {
                var skipDelay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var currentItem = this._items[index];
                this.tag("Label").patch({
                    Title: {
                        text: {
                            text: currentItem.title
                        }
                    },
                    Details: {
                        text: {
                            text: currentItem.details
                        }
                    }
                });
                this._label.appear.start();
                this._label.fadeIn.start();
                if (skipDelay) {
                    this._label.appear.skipDelay();
                    this._label.fadeIn.skipDelay();
                }
            }
        },
        {
            key: "_startBackgroundAnimation",
            value: function _startBackgroundAnimation(index) {
                var skipDelay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                this._container.children[index].fadeIn.start();
                if (skipDelay) {
                    this._container.children[index].fadeIn.skipDelay();
                }
                this._container.children[index].idle.start();
            }
        },
        {
            key: "_startLogoAnimation",
            value: function _startLogoAnimation(index) {
                var skipDelay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                this._logoContainer.children[index].fadeIn.start();
                if (skipDelay) {
                    this._logoContainer.children[index].fadeIn.skipDelay();
                }
            }
        },
        {
            key: "_reset",
            value: function _reset() {
                if (this._screenSaverTimeout) {
                    clearTimeout(this._screenSaverTimeout);
                }
                this._container.children.forEach(function(item) {
                    item.fadeIn.stopNow();
                    item.fadeOut.stopNow();
                    item.idle.stopNow();
                });
                this._label.appear.stopNow();
                this._label.fadeIn.stopNow();
                this._label.fadeOut.stopNow();
                this._appearAnimation.stopNow();
                this._logoAppearAnimation.stopNow();
                this._labelSwapTimer.stopNow();
                this._backgroundSwapTimer.stopNow();
                this._iterationTimer.stopNow();
                this._index = 0;
                this.alpha = 0;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)((0, _screenSaverstyle.getInitialStyle)(), {
                    rect: true,
                    Logo: {
                        type: _brandIconcomponent.BrandIcon
                    }
                });
            }
        }
    ]);
    return ScreenSaver;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 10013:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(45538);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _screenSaverselectors = __webpack_require__(57677);
var _screenSaverutils = __webpack_require__(34849);
var mapControllers = function(instance) {
    return {
        screenSaverData: {
            selector: _screenSaverselectors.getScreenSaverData,
            condition: function(param) {
                var previousProp = param.previousProp, currentProp = param.currentProp;
                return (0, _screenSaverutils.checkLayoutsNotEqual)(previousProp, currentProp);
            },
            callback: function(value) {
                instance.items = value.items;
            }
        },
        isLocked: {
            selector: _screenSaverselectors.getScreenSaverIsLocked,
            callback: function(isLocked) {
                instance.isLocked = isLocked;
            }
        }
    };
};
var _default = _lightningjsredux.default.control(mapControllers);


/***/ }),

/***/ 27009:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BACKGROUND_DURATION: function() {
        return BACKGROUND_DURATION;
    },
    BACKGROUND_FADE_DELAY: function() {
        return BACKGROUND_FADE_DELAY;
    },
    BACKGROUND_FADE_IN_DURATION: function() {
        return BACKGROUND_FADE_IN_DURATION;
    },
    BACKGROUND_FADE_OUT_FAST: function() {
        return BACKGROUND_FADE_OUT_FAST;
    },
    BACKGROUND_FADE_OUT_SLOW: function() {
        return BACKGROUND_FADE_OUT_SLOW;
    },
    BACKGROUND_IDLE_SUSTAIN: function() {
        return BACKGROUND_IDLE_SUSTAIN;
    },
    BANNED_POPUPS: function() {
        return BANNED_POPUPS;
    },
    BANNED_WIDGETS: function() {
        return BANNED_WIDGETS;
    },
    FADE_IN: function() {
        return FADE_IN;
    },
    FADE_OUT: function() {
        return FADE_OUT;
    },
    HIDE_SCREENSAVER_SIGNAL: function() {
        return HIDE_SCREENSAVER_SIGNAL;
    },
    ITERATION_TOTAL_DURATION: function() {
        return ITERATION_TOTAL_DURATION;
    },
    LABEL_APPEAR_DELAY: function() {
        return LABEL_APPEAR_DELAY;
    },
    LABEL_APPEAR_DURATION: function() {
        return LABEL_APPEAR_DURATION;
    },
    LABEL_FADE_IN_DURATION: function() {
        return LABEL_FADE_IN_DURATION;
    },
    LABEL_FADE_OUT_DURATION: function() {
        return LABEL_FADE_OUT_DURATION;
    },
    LABEL_SWAP_DURATION_OFFSET: function() {
        return LABEL_SWAP_DURATION_OFFSET;
    },
    LOGO_APPEAR_DURATION: function() {
        return LOGO_APPEAR_DURATION;
    },
    SCREEN_APPEAR_DURATION: function() {
        return SCREEN_APPEAR_DURATION;
    },
    SCREEN_SAVER_COUNTDOWN: function() {
        return SCREEN_SAVER_COUNTDOWN;
    },
    SHOW_SCREENSAVER_SIGNAL: function() {
        return SHOW_SCREENSAVER_SIGNAL;
    }
});
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(52318);
var _popupsconstants = __webpack_require__(60952);
var SHOW_SCREENSAVER_SIGNAL = "show";
var HIDE_SCREENSAVER_SIGNAL = "hide";
var SCREEN_SAVER_COUNTDOWN = 120000;
var ITERATION_TOTAL_DURATION = 8;
var SCREEN_APPEAR_DURATION = 0.15;
var LOGO_APPEAR_DURATION = 1;
var LABEL_SWAP_DURATION_OFFSET = 6.5;
var LABEL_APPEAR_DURATION = 3;
var LABEL_APPEAR_DELAY = 0.5;
var LABEL_FADE_IN_DURATION = 3.5;
var LABEL_FADE_OUT_DURATION = 1;
var BACKGROUND_DURATION = 6.9;
var BACKGROUND_FADE_IN_DURATION = 2;
var BACKGROUND_FADE_OUT_FAST = 1;
var BACKGROUND_FADE_OUT_SLOW = 2;
var BACKGROUND_FADE_DELAY = 0.5;
var BACKGROUND_IDLE_SUSTAIN = 2;
var FADE_IN = 0;
var FADE_OUT = 1;
var BANNED_POPUPS = [
    _popupsconstants.PROFILES_GATE_POPUP_ID
];
var BANNED_WIDGETS = [
    "CookieConsent"
];


/***/ }),

/***/ 41331:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BACKGROUND_STYLES: function() {
        return BACKGROUND_STYLES;
    },
    DESCRIPTION_BOTTOM_MARGIN: function() {
        return DESCRIPTION_BOTTOM_MARGIN;
    },
    DESCRIPTION_START_X_OFFSET: function() {
        return DESCRIPTION_START_X_OFFSET;
    },
    DESCRIPTION_X_OFFSET: function() {
        return DESCRIPTION_X_OFFSET;
    },
    LOGO_HEIGHT: function() {
        return LOGO_HEIGHT;
    },
    LOGO_X_OFFSET: function() {
        return LOGO_X_OFFSET;
    },
    LOGO_Y_OFFSET: function() {
        return LOGO_Y_OFFSET;
    },
    PROGRAM_LOGO_OFFSET: function() {
        return PROGRAM_LOGO_OFFSET;
    },
    PROGRAM_LOGO_SIZE: function() {
        return PROGRAM_LOGO_SIZE;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getBackgroundIdleAnimStyle: function() {
        return getBackgroundIdleAnimStyle;
    },
    getDescriptionAppearAnimStyle: function() {
        return getDescriptionAppearAnimStyle;
    },
    getDummyAnimStyle: function() {
        return getDummyAnimStyle;
    },
    getFadeAnimStyle: function() {
        return getFadeAnimStyle;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    getProgramLogoStyle: function() {
        return getProgramLogoStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(45538);
var _memoize = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34736));
var _theme = __webpack_require__(51397);
var _constants = __webpack_require__(34952);
var _typography = __webpack_require__(18411);
var _style = __webpack_require__(65082);
var _sizes = __webpack_require__(82699);
var _screenSaverconstants = __webpack_require__(27009);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var colors = {
    background: (0, _theme.makeThemeColor)(_theme.TERTIARY),
    title: (0, _theme.makeThemeColor)(_theme.PRIMARY),
    details: (0, _theme.makeThemeColor)(_theme.PRIMARY, 0.5),
    gradientFill: (0, _theme.makeThemeColor)(_theme.TERTIARY),
    transparent: (0, _theme.makeThemeColor)(_theme.TERTIARY, 0)
};
var BACKGROUND_STYLES = [
    // Animation zoomIn from right top corner
    {
        pivot: 0,
        zoom: {
            zoomStart: 1,
            zoomEnd: 1.11
        }
    },
    // Animation zoomIn from left bottom corner
    {
        pivot: 1,
        zoom: {
            zoomStart: 1,
            zoomEnd: 1.06
        }
    },
    // Animation zoomOut from center
    {
        zoom: {
            zoomStart: 1.25,
            zoomEnd: 1
        }
    },
    // Animation zoomIn from left bottom corner
    {
        pivot: 1,
        zoom: {
            zoomStart: 1,
            zoomEnd: 1.18
        }
    },
    // Animation zoomIn from center
    {
        zoom: {
            zoomStart: 1,
            zoomEnd: 1.12
        }
    }
];
var _obj;
var PROGRAM_LOGO_SIZE = (_obj = {}, _define_property._(_obj, _constants.HD, {
    w: 251,
    h: 157
}), _define_property._(_obj, _constants.FULL_HD, {
    w: 382,
    h: 215
}), _obj);
var _obj1;
var PROGRAM_LOGO_OFFSET = (_obj1 = {}, _define_property._(_obj1, _constants.HD, {
    x: 64,
    y: 332
}), _define_property._(_obj1, _constants.FULL_HD, {
    x: 64,
    y: 432
}), _obj1);
var _obj2;
var LOGO_HEIGHT = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 92), _define_property._(_obj2, _constants.FULL_HD, 104), _obj2);
var _obj3;
var LOGO_X_OFFSET = (_obj3 = {}, _define_property._(_obj3, _constants.HD, 64), _define_property._(_obj3, _constants.FULL_HD, 64), _obj3);
var _obj4;
var LOGO_Y_OFFSET = (_obj4 = {}, _define_property._(_obj4, _constants.HD, 32), _define_property._(_obj4, _constants.FULL_HD, 32), _obj4);
var _obj5;
var DESCRIPTION_START_X_OFFSET = (_obj5 = {}, _define_property._(_obj5, _constants.HD, 28), _define_property._(_obj5, _constants.FULL_HD, 28), _obj5);
var _obj6;
var DESCRIPTION_X_OFFSET = (_obj6 = {}, _define_property._(_obj6, _constants.HD, 64), _define_property._(_obj6, _constants.FULL_HD, 64), _obj6);
var _obj7;
var DESCRIPTION_BOTTOM_MARGIN = (_obj7 = {}, _define_property._(_obj7, _constants.HD, 58), _define_property._(_obj7, _constants.FULL_HD, 58), _obj7);
var getInitialStyle = (0, _memoize.default)(function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext, screenSize = _ref.screenSize, colorMode = _ref.colorMode;
    var titleFont = (0, _typography.getFont)(_typography.FONT.OSLO_3, screenSize);
    var detailsFont = (0, _typography.getFont)(_typography.FONT.KINSHASA_2, screenSize);
    return {
        alpha: 0,
        color: colors.background[colorMode],
        h: _sizes.SCREEN_HEIGHT[screenSize],
        w: _sizes.SCREEN_WIDTH[screenSize],
        BackgroundContainer: {
            w: _sizes.identity,
            h: _sizes.identity
        },
        Gradient: {
            rect: true,
            w: _sizes.identity,
            h: _sizes.identity,
            colorBl: colors.gradientFill[colorMode],
            colorUl: colors.gradientFill[colorMode],
            colorUr: colors.transparent[colorMode],
            colorBr: colors.transparent[colorMode]
        },
        Logo: {
            x: LOGO_X_OFFSET[screenSize],
            y: LOGO_Y_OFFSET[screenSize],
            textureScale: 1.5,
            h: LOGO_HEIGHT[screenSize]
        },
        LogoContainer: {
            x: PROGRAM_LOGO_OFFSET[screenSize].x,
            y: _sizes.SCREEN_HEIGHT[screenSize] - PROGRAM_LOGO_OFFSET[screenSize].y
        },
        Label: {
            x: DESCRIPTION_START_X_OFFSET[screenSize],
            y: _sizes.SCREEN_HEIGHT[screenSize] - DESCRIPTION_BOTTOM_MARGIN[screenSize],
            mountY: 1,
            flex: {
                direction: "column"
            },
            Title: {
                text: _object_spread._({
                    textColor: colors.title[colorMode]
                }, titleFont)
            },
            Details: {
                text: _object_spread._({
                    textColor: colors.details[colorMode]
                }, detailsFont)
            }
        }
    };
}, _style.cacheResolver);
var getDescriptionAppearAnimStyle = (0, _memoize.default)(function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var screenSize = context.screenSize;
    return {
        duration: _screenSaverconstants.LABEL_APPEAR_DURATION,
        repeat: 0,
        stopMethod: "immediate",
        delay: _screenSaverconstants.LABEL_APPEAR_DELAY,
        actions: [
            {
                p: "x",
                v: {
                    0: {
                        v: DESCRIPTION_START_X_OFFSET[screenSize],
                        s: 0.1
                    },
                    1: {
                        v: DESCRIPTION_X_OFFSET[screenSize],
                        sm: 1
                    }
                }
            }
        ]
    };
}, _style.cacheResolver);
var getProgramLogoStyle = (0, _memoize.default)(function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var screenSize = context.screenSize;
    var _PROGRAM_LOGO_SIZE_screenSize = PROGRAM_LOGO_SIZE[screenSize], w = _PROGRAM_LOGO_SIZE_screenSize.w, h = _PROGRAM_LOGO_SIZE_screenSize.h;
    return {
        w: w,
        h: h
    };
}, _style.cacheResolver);
var getDummyAnimStyle = function(duration) {
    return {
        duration: duration,
        repeat: 0,
        stopMethod: "immediate"
    };
};
var getFadeAnimStyle = function(direction, duration) {
    var delay = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    return {
        duration: duration,
        repeat: 0,
        delay: delay,
        stopMethod: "immediate",
        actions: [
            {
                p: "alpha",
                v: {
                    0: Number(direction !== 0),
                    1: Number(direction === 0)
                }
            }
        ]
    };
};
var getBackgroundIdleAnimStyle = (0, _memoize.default)(function(param) {
    var zoomStart = param.zoomStart, zoomEnd = param.zoomEnd;
    return {
        duration: _screenSaverconstants.ITERATION_TOTAL_DURATION + _screenSaverconstants.BACKGROUND_IDLE_SUSTAIN,
        repeat: 0,
        stopMethod: "immediate",
        actions: [
            {
                p: "scale",
                v: {
                    0: {
                        v: zoomStart,
                        sm: 0
                    },
                    1: {
                        v: zoomEnd,
                        sm: 0
                    }
                }
            }
        ]
    };
}, _style.cacheResolver);


/***/ }),

/***/ 89859:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return SearchResultBlock;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(65759);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _ctaactions = __webpack_require__(32067);
var _searchactions = __webpack_require__(75986);
var _abstractLayoutcomponent = __webpack_require__(65151);
var _abstractLayoututils = __webpack_require__(41533);
var _blocksstyle = __webpack_require__(15155);
var SearchResultBlock = /*#__PURE__*/ function(AbstractLayout) {
    "use strict";
    _inherits._(SearchResultBlock, AbstractLayout);
    var _super = _create_super._(SearchResultBlock);
    function SearchResultBlock() {
        _class_call_check._(this, SearchResultBlock);
        return _super.apply(this, arguments);
    }
    _create_class._(SearchResultBlock, [
        {
            key: "hasResults",
            get: function get() {
                return this.tag("Blocks").children.length !== 0;
            }
        },
        {
            key: "_handleSelected",
            value: function _handleSelected(item) {
                _lightningjsredux.default.dispatch((0, _searchactions.saveSearchedItem)(item));
                _lightningjsredux.default.dispatch((0, _ctaactions.createItemAction)({
                    item: item
                }));
            }
        },
        {
            key: "_setIndex",
            value: function _setIndex() {
                var index = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._index, shouldAnimate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var position = this._positions[index];
                if (!Number.isFinite(position)) {
                    return;
                }
                var offset = index === 0 ? 0 : -(0, _blocksstyle.getBlockOffset)(this._style.screenSize);
                this._offset = position + offset;
                this._index = index;
                if (shouldAnimate) {
                    this.tag("Blocks").setSmooth("y", this._offset);
                } else {
                    this.tag("Blocks").y = this._offset;
                }
            }
        },
        {
            key: "_shouldRefreshPlacement",
            value: function _shouldRefreshPlacement(newBlocks) {
                return (0, _abstractLayoututils.couldReuseCurrentViews)(this._data ? this._data.blocks : [], newBlocks, true);
            }
        }
    ]);
    return SearchResultBlock;
}(_abstractLayoutcomponent.AbstractLayout);


/***/ }),

/***/ 15155:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    defaultContext: function() {
        return defaultContext;
    },
    getBlockOffset: function() {
        return getBlockOffset;
    }
});
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(45538);
var _style = __webpack_require__(65082);
var _keyboardstyle = __webpack_require__(51836);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var getBlockOffset = function(screenSize) {
    return _keyboardstyle.KEYBOARD_HEIGHT[screenSize];
};


/***/ }),

/***/ 78884:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    facets: function() {
        return facets;
    },
    facetsOrder: function() {
        return facetsOrder;
    },
    templateIdForFacets: function() {
        return templateIdForFacets;
    }
});
var _define_property = __webpack_require__(21228);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
var _templateTypes = __webpack_require__(43581);
var facets = {
    PLAYLIST: "playlist",
    PROGRAM: "program",
    VC: "vc",
    VI: "vi",
    PODCAST: "podcast"
};
var facetsOrder = [
    facets.PLAYLIST,
    facets.PROGRAM,
    facets.VC,
    facets.VI,
    facets.PODCAST
];
var _obj;
var templateIdForFacets = (_obj = {}, _define_property._(_obj, facets.PLAYLIST, _templateTypes.templateTypes.PosterM), _define_property._(_obj, facets.PROGRAM, _templateTypes.templateTypes.PosterM), _define_property._(_obj, facets.VI, _templateTypes.templateTypes.PosterM), _define_property._(_obj, facets.VC, _templateTypes.templateTypes.PosterM), _define_property._(_obj, facets.PODCAST, _templateTypes.templateTypes.HorizontalSquare), _obj);


/***/ }),

/***/ 79467:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/* eslint-disable no-console */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "Search", ({
    enumerable: true,
    get: function() {
        return Search;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
var _sdk = __webpack_require__(29956);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _keyboardstyle = __webpack_require__(51836);
var _searchHistorystyle = __webpack_require__(75516);
var _theme = __webpack_require__(74314);
var _keyboardconstants = __webpack_require__(20190);
var _signals = __webpack_require__(2109);
var _searchactions = __webpack_require__(75986);
var _keyboardcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(15939));
var _searchFieldcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(84433));
var _blockscomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(89859));
var _searchHistorycomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(60955));
var _searchstyle = __webpack_require__(91379);
var _searchconnect = /*#__PURE__*/ _interop_require_default._(__webpack_require__(62080));
var Search = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(Search, _Lightning_Component);
    var _super = _create_super._(Search);
    function Search() {
        _class_call_check._(this, Search);
        return _super.apply(this, arguments);
    }
    _create_class._(Search, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _searchstyle.defaultContext;
                this._query = "";
            }
        },
        {
            key: "_attach",
            value: function _attach() {
                this._unsubscribe = (0, _searchconnect.default)(this);
                this._fallbackRequestAllowed = true;
                this._setState("Keyboard");
                _lightningjsredux.default.dispatch((0, _searchactions.getSearchedItems)());
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                if (this._unsubscribe) {
                    this._unsubscribe();
                    this._unsubscribe = null;
                }
                this._data = null;
                this._defaults = null;
                this._query = "";
                _lightningjsredux.default.dispatch((0, _searchactions.stopSearch)());
            }
        },
        {
            key: "historyState",
            value: function historyState(history) {
                var renderer = this.tag("SearchResultBlock");
                // Restoring on backward navigation
                if (history) {
                    if (Number.isFinite(history.column)) {
                        this._setState("Content", [
                            true
                        ]);
                    }
                    this._query = history.query || "";
                    this.tag("SearchField").searchQuery = this._query;
                }
                // Returning current state for history storage
                var result = renderer.historyState(history);
                if (result && this._query) {
                    result.query = this._query;
                }
                return result;
            }
        },
        {
            key: "data",
            get: function get() {
                return this._data;
            },
            set: function set(value) {
                if (!value) {
                    return;
                }
                if (!value.queryParameters) {
                    this._defaults = value;
                }
                var query = (0, _get.default)(value, "queryParameters.query") || "";
                // For a case when BFF returns empty layout for a new query (i.e. no results found) and that query
                // was restored upon entering the Search screen without that screen in navigation history stack
                if (query !== (this._query || "") && !(this._query && !value.queryParameters)) {
                    return;
                }
                this._data = (0, _get.default)(value, "blocks.length") ? value : this._defaults || value;
                // Fallback for a fallback: an empty result arrived
                if (this._fallbackRequestAllowed && !(0, _get.default)(this._data, "blocks.length")) {
                    console.log("[search] Requesting on fallback");
                    _lightningjsredux.default.dispatch((0, _searchactions.searchAll)());
                    return;
                }
                var theme = (0, _theme.getLayoutTheme)((0, _get.default)(value, "layout.theme"));
                var color = theme.backgroundColor || _searchstyle.BACKGROUND_COLOR[this._style.colorMode];
                this.patch({
                    Background: {
                        color: color
                    },
                    Strip: {
                        color: color
                    },
                    Overlay: {
                        colorTop: color
                    }
                });
                this.tag("SearchResultBlock").data = this._data;
                this._refocus();
            }
        },
        {
            key: "query",
            get: function get() {
                return this._query;
            },
            set: function set(value) {
                if (this._query === value) {
                    return;
                }
                this._query = value;
                // Query was changed, allowing to request a default layout again in case of failure
                this._fallbackRequestAllowed = true;
                this.tag("SearchField").searchQuery = this._query;
            }
        },
        {
            key: "searchHistory",
            set: function set(value) {
                this.tag("SearchHistory").searchedItems = value;
            }
        },
        {
            key: "_handleKeyPress",
            value: function _handleKeyPress(symbol) {
                _lightningjsredux.default.dispatch((0, _searchactions.searchKeyInput)(symbol));
            }
        },
        {
            key: "_handleSearchFromHistory",
            value: function _handleSearchFromHistory(item) {
                this.query = item;
                // NOTE: we are not calling the debounced search here to avoid delay
                _lightningjsredux.default.dispatch((0, _searchactions.searchAll)(this._query, true));
            }
        },
        {
            key: "_hideKeyboard",
            value: function _hideKeyboard() {
                var skipAnimation = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                var offset = _keyboardstyle.KEYBOARD_OFFSET_Y[this._style.screenSize];
                var animation = {
                    duration: skipAnimation ? 0 : 0.2
                };
                this.patch({
                    Keyboard: {
                        smooth: {
                            y: [
                                -offset,
                                animation
                            ],
                            alpha: [
                                0,
                                animation
                            ]
                        }
                    },
                    SearchHistory: {
                        smooth: {
                            y: [
                                -offset,
                                animation
                            ],
                            alpha: [
                                0,
                                animation
                            ]
                        }
                    },
                    SearchResultBlock: {
                        smooth: {
                            y: [
                                offset,
                                animation
                            ]
                        },
                        h: this.finalH - offset
                    }
                });
            }
        },
        {
            key: "_showKeyboard",
            value: function _showKeyboard() {
                var screenSize = this._style.screenSize;
                var offset = _keyboardstyle.KEYBOARD_OFFSET_Y[screenSize];
                var animation = {
                    duration: 0.2
                };
                this.patch({
                    Keyboard: {
                        smooth: {
                            alpha: [
                                1,
                                animation
                            ],
                            y: [
                                offset,
                                animation
                            ]
                        }
                    },
                    SearchHistory: {
                        smooth: {
                            alpha: [
                                1,
                                animation
                            ],
                            y: [
                                _searchHistorystyle.HISTORY_POSITION_Y[screenSize],
                                animation
                            ]
                        }
                    },
                    SearchResultBlock: {
                        smooth: {
                            y: [
                                (0, _searchstyle.getBlockOffset)(screenSize),
                                animation
                            ]
                        },
                        h: this.finalH - (0, _searchstyle.getBlockOffset)(screenSize)
                    }
                });
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Background: {
                        rect: true
                    },
                    SearchField: {
                        type: _searchFieldcomponent.default,
                        searchQuery: ""
                    },
                    Keyboard: {
                        type: _keyboardcomponent.default,
                        signals: _define_property._({}, _keyboardconstants.LETTER_SELECTED_SIGNAL, "_handleKeyPress")
                    },
                    SearchHistory: {
                        type: _searchHistorycomponent.default,
                        signals: _define_property._({}, _signals.SELECTED_SIGNAL, "_handleSearchFromHistory")
                    },
                    Strip: {
                        rect: true
                    },
                    Overlay: {
                        rect: true
                    },
                    SearchResultBlock: {
                        type: _blockscomponent.default
                    }
                }, (0, _searchstyle.getInitialStyle)());
            }
        },
        {
            key: "_states",
            value: function _states() {
                return [
                    /*#__PURE__*/ function(_this) {
                        _inherits._(Keyboard, _this);
                        var _super = _create_super._(Keyboard);
                        function Keyboard() {
                            _class_call_check._(this, Keyboard);
                            return _super.apply(this, arguments);
                        }
                        _create_class._(Keyboard, [
                            {
                                key: "$enter",
                                value: function $enter() {
                                    this._showKeyboard();
                                    if (!this._focused) {
                                        this._focused = this.tag("Keyboard");
                                    }
                                }
                            },
                            {
                                key: "_getFocused",
                                value: function _getFocused() {
                                    return this._focused;
                                }
                            },
                            {
                                key: "_handleDown",
                                value: function _handleDown() {
                                    this._setState("Content");
                                    return true;
                                }
                            },
                            {
                                key: "_handleLeft",
                                value: function _handleLeft() {
                                    if (this._focused === this.tag("Keyboard")) {
                                        return false;
                                    }
                                    this._focused = this.tag("Keyboard");
                                    return true;
                                }
                            },
                            {
                                key: "_handleRight",
                                value: function _handleRight() {
                                    if (this._focused === this.tag("Keyboard") && this.tag("SearchHistory").isVisibleHistory) {
                                        this._focused = this.tag("SearchHistory");
                                        return true;
                                    }
                                    return false;
                                }
                            }
                        ]);
                        return Keyboard;
                    }(this),
                    /*#__PURE__*/ function(_this) {
                        _inherits._(Content, _this);
                        var _super = _create_super._(Content);
                        function Content() {
                            _class_call_check._(this, Content);
                            return _super.apply(this, arguments);
                        }
                        _create_class._(Content, [
                            {
                                key: "$enter",
                                value: function $enter(_) {
                                    var skipAnimation = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                                    this._hideKeyboard(skipAnimation);
                                }
                            },
                            {
                                key: "_getFocused",
                                value: function _getFocused() {
                                    return this.tag("SearchResultBlock");
                                }
                            },
                            {
                                key: "_handleUp",
                                value: function _handleUp() {
                                    this._setState("Keyboard");
                                    return true;
                                }
                            }
                        ]);
                        return Content;
                    }(this)
                ];
            }
        }
    ]);
    return Search;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 62080:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(3009);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _searchselectors = __webpack_require__(72321);
var mapControllers = function(instance) {
    return [
        {
            shouldBeInvokedOnConnect: true,
            selector: _searchselectors.getSearchedHistory,
            callback: function(value) {
                instance.searchHistory = value;
            }
        },
        {
            shouldBeInvokedOnConnect: true,
            selector: _searchselectors.getSearchQuery,
            callback: function(value) {
                instance.query = value;
            }
        }
    ];
};
var _default = _lightningjsredux.default.control(mapControllers);


/***/ }),

/***/ 91379:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BACKGROUND_COLOR: function() {
        return BACKGROUND_COLOR;
    },
    OVERLAY_HEIGHT: function() {
        return OVERLAY_HEIGHT;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getBlockOffset: function() {
        return getBlockOffset;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
var _define_property = __webpack_require__(21228);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(42578);
var _theme = __webpack_require__(51397);
var _constants = __webpack_require__(34952);
var _style = __webpack_require__(65082);
var _sizes = __webpack_require__(82699);
var _keyboardstyle = __webpack_require__(51836);
var _searchFieldstyle = __webpack_require__(49822);
var _colors = __webpack_require__(8426);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var BACKGROUND_COLOR = (0, _theme.makeThemeColor)(_theme.TERTIARY);
var getBlockOffset = function(screenSize) {
    return _keyboardstyle.KEYBOARD_OFFSET_Y[screenSize] + _keyboardstyle.KEYBOARD_HEIGHT[screenSize];
};
var _obj;
var OVERLAY_HEIGHT = (_obj = {}, _define_property._(_obj, _constants.HD, 80), _define_property._(_obj, _constants.FULL_HD, 80), _obj);
var getInitialStyle = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext, screenSize = _ref.screenSize, colorMode = _ref.colorMode;
    var overlayOffset = _keyboardstyle.KEYBOARD_OFFSET_Y[screenSize] - _searchFieldstyle.OFFSET[screenSize];
    var resultsOffset = getBlockOffset(screenSize);
    var w = _sizes.SCREEN_WIDTH[screenSize];
    var h = _sizes.SCREEN_HEIGHT[screenSize];
    return {
        forceZIndexContext: true,
        w: w,
        h: h,
        Background: {
            w: w,
            h: h,
            color: BACKGROUND_COLOR[colorMode]
        },
        SearchField: {
            zIndex: 4
        },
        Keyboard: {
            zIndex: 3
        },
        SearchHistory: {
            zIndex: 3
        },
        Strip: {
            zIndex: 2,
            w: w,
            h: overlayOffset,
            color: BACKGROUND_COLOR[colorMode]
        },
        Overlay: {
            zIndex: 2,
            w: w,
            h: OVERLAY_HEIGHT[screenSize],
            y: overlayOffset,
            colorTop: BACKGROUND_COLOR[colorMode],
            colorBottom: _colors.TRANSPARENT
        },
        SearchResultBlock: {
            zIndex: 1,
            y: resultsOffset,
            h: h - resultsOffset
        }
    };
};


/***/ }),

/***/ 41963:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BACKGROUND_RADIUS: function() {
        return BACKGROUND_RADIUS;
    },
    BAR_OFFSET_LEFT: function() {
        return BAR_OFFSET_LEFT;
    },
    BAR_OPACITY: function() {
        return BAR_OPACITY;
    },
    HEIGHT: function() {
        return HEIGHT;
    },
    TEXT_FONT: function() {
        return TEXT_FONT;
    }
});
var _define_property = __webpack_require__(21228);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(42578);
var _constants = __webpack_require__(34952);
var _obj;
var HEIGHT = (_obj = {}, _define_property._(_obj, _constants.HD, 40), _define_property._(_obj, _constants.FULL_HD, 56), _obj);
var BACKGROUND_RADIUS = 0;
var BAR_OFFSET_LEFT = 8;
var BAR_OPACITY = 0.3;
var TEXT_FONT = "KINSHASA_2";


/***/ }),

/***/ 84433:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return SearchField;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
var _sdk = __webpack_require__(29956);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _searchFieldstyle = __webpack_require__(49822);
var _i18n = __webpack_require__(14910);
var _searchFieldconstants = __webpack_require__(2100);
var SearchField = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(SearchField, _Lightning_Component);
    var _super = _create_super._(SearchField);
    function SearchField() {
        _class_call_check._(this, SearchField);
        return _super.apply(this, arguments);
    }
    _create_class._(SearchField, [
        {
            key: "_init",
            value: function _init() {
                this._style = _searchFieldstyle.defaultContext;
            }
        },
        {
            key: "_build",
            value: function _build() {
                var _this = this;
                var label = this.tag("Label");
                label.on("txLoaded", function() {
                    var labelInnerWidth = (0, _searchFieldstyle.getInnerWidth)(_searchFieldstyle.WIDTH[_this._style.screenSize], _searchFieldstyle.BAR_PADDING_LEFT);
                    var textWidth = label.finalW;
                    if (textWidth > labelInnerWidth) {
                        var diff = (textWidth - labelInnerWidth) * -1;
                        label.x = diff;
                    } else {
                        label.x = _searchFieldstyle.BAR_PADDING_LEFT;
                    }
                });
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                this.tag("Label").removeAllListeners("txLoaded");
            }
        },
        {
            key: "searchQuery",
            set: function set(value) {
                if (!value) {
                    this.tag("Label").text.text = (0, _i18n.t)("search.placeholder");
                    return;
                }
                this.tag("Label").text.text = value.length > _searchFieldconstants.MAX_TEXT_LENGTH_TO_SHOW ? value.slice(-_searchFieldconstants.MAX_TEXT_LENGTH_TO_SHOW) : value;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Background: {
                        shader: {
                            type: _sdk.Lightning.shaders.RoundedRectangle
                        }
                    },
                    Bar: {
                        shader: {
                            type: _sdk.Lightning.shaders.RoundedRectangle
                        }
                    },
                    Label: {}
                }, (0, _searchFieldstyle.getInitialStyle)());
            }
        }
    ]);
    return SearchField;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 2100:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    MAX_TEXT_LENGTH_TO_SHOW: function() {
        return MAX_TEXT_LENGTH_TO_SHOW;
    },
    START_SEARCH: function() {
        return START_SEARCH;
    }
});
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(37815);
var MAX_TEXT_LENGTH_TO_SHOW = 80;
var START_SEARCH = "handleStartSearch";


/***/ }),

/***/ 49822:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BAR_PADDING_LEFT: function() {
        return BAR_PADDING_LEFT;
    },
    OFFSET: function() {
        return OFFSET;
    },
    WIDTH: function() {
        return WIDTH;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    getInnerWidth: function() {
        return getInnerWidth;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(65759);
var _theme = __webpack_require__(51397);
var _memoize = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34736));
var _constants = __webpack_require__(34952);
var _typography = __webpack_require__(18411);
var _style = __webpack_require__(65082);
var _keyboardstyle = __webpack_require__(51836);
var _sizes = __webpack_require__(82699);
var _searchFieldconstants = __webpack_require__(41963);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var WIDTH = (_obj = {}, _define_property._(_obj, _constants.HD, 489), _define_property._(_obj, _constants.FULL_HD, 729), _obj);
var _obj1;
var OFFSET = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 8), _define_property._(_obj1, _constants.FULL_HD, 16), _obj1);
var BAR_PADDING_LEFT = _searchFieldconstants.BAR_OFFSET_LEFT;
var colors = {
    bar: (0, _theme.makeThemeColor)(_theme.PRIMARY, _searchFieldconstants.BAR_OPACITY),
    background: (0, _theme.makeThemeColor)(_theme.TERTIARY),
    text: (0, _theme.makeThemeColor)(_theme.PRIMARY)
};
var getInnerWidth = (0, _memoize.default)(function(width, padding) {
    return width - padding * 2;
});
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var screenSize = context.screenSize, colorMode = context.colorMode;
    return {
        x: _keyboardstyle.KEYBOARD_OFFSET_X[screenSize],
        y: _keyboardstyle.KEYBOARD_OFFSET_Y[screenSize] - _searchFieldconstants.HEIGHT[screenSize] - OFFSET[screenSize],
        h: _searchFieldconstants.HEIGHT[screenSize],
        w: WIDTH[screenSize],
        clipping: true,
        Background: {
            rect: true,
            h: _sizes.identity,
            w: _sizes.identity,
            color: colors.background[colorMode],
            shader: {
                radius: _searchFieldconstants.BACKGROUND_RADIUS
            }
        },
        Bar: {
            rect: true,
            h: _sizes.identity,
            w: _sizes.identity,
            color: colors.bar[colorMode],
            shader: {
                radius: _searchFieldconstants.BACKGROUND_RADIUS
            }
        },
        Label: {
            x: BAR_PADDING_LEFT,
            mountY: 0.5,
            y: _sizes.middle,
            text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT[_searchFieldconstants.TEXT_FONT], screenSize)), {
                wordWrap: false,
                textColor: colors.text[colorMode],
                verticalAlign: "middle"
            })
        }
    };
};


/***/ }),

/***/ 60955:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return SearchedItems;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(42578);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _i18n = __webpack_require__(14910);
var _searchHistorystyle = __webpack_require__(75516);
var _searchedItemcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(93980));
var _signals = __webpack_require__(2109);
var SearchedItems = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(SearchedItems, _Lightning_Component);
    var _super = _create_super._(SearchedItems);
    function SearchedItems() {
        _class_call_check._(this, SearchedItems);
        return _super.apply(this, arguments);
    }
    _create_class._(SearchedItems, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _searchHistorystyle.defaultContext;
                this._buttons = [];
                this._searchedItems = [];
                this._index = 0;
            }
        },
        {
            key: "searchedItems",
            set: function set(searchedItems) {
                var isHistoryVisible = searchedItems && searchedItems.length > 0;
                this.patch({
                    Title: {
                        visible: isHistoryVisible,
                        text: {
                            text: (0, _i18n.t)("search.history")
                        }
                    },
                    EmptyHistoryLabel: {
                        visible: !isHistoryVisible,
                        text: {
                            text: (0, _i18n.t)("search.empty")
                        }
                    }
                });
                if (isHistoryVisible) {
                    this._searchedItems = searchedItems;
                    this.tag("Items").children = searchedItems.map(function(item) {
                        return {
                            type: _searchedItemcomponent.default,
                            data: item
                        };
                    });
                }
                var items = this.tag("Items").children;
                this._buttons = items.filter(function(item) {
                    return item;
                });
            }
        },
        {
            key: "isVisibleHistory",
            get: function get() {
                return this.tag("Items").children.length > 0;
            }
        },
        {
            key: "_focus",
            value: function _focus() {
                this._setIndex();
            }
        },
        {
            key: "_getFocused",
            value: function _getFocused() {
                return this._focused;
            }
        },
        {
            key: "_setIndex",
            value: function _setIndex() {
                var index = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._index;
                this._index = index;
                this._focused = this._buttons[this._index];
                this._refocus();
            }
        },
        {
            key: "_handleUp",
            value: function _handleUp() {
                if (this._index > 0) {
                    this._setIndex(this._index - 1);
                    return true;
                }
                return false;
            }
        },
        {
            key: "_handleDown",
            value: function _handleDown() {
                if (this._index < this._buttons.length - 1) {
                    this._setIndex(this._index + 1);
                    return true;
                }
                return false;
            }
        },
        {
            key: "_handleEnter",
            value: function _handleEnter() {
                this.signal(_signals.SELECTED_SIGNAL, this._searchedItems[this._index]);
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Title: {},
                    EmptyHistoryLabel: {},
                    Items: {}
                }, (0, _searchHistorystyle.getInitialStyle)());
            }
        }
    ]);
    return SearchedItems;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 75516:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    CONTAINER_HEIGHT: function() {
        return CONTAINER_HEIGHT;
    },
    CONTAINER_WIDTH: function() {
        return CONTAINER_WIDTH;
    },
    EMPTY_HISTORY_FONT: function() {
        return EMPTY_HISTORY_FONT;
    },
    EMPTY_HISTORY_FONT_TYPE: function() {
        return EMPTY_HISTORY_FONT_TYPE;
    },
    EMPTY_HISTORY_LABEL_POSITION: function() {
        return EMPTY_HISTORY_LABEL_POSITION;
    },
    HISTORY_POSITION_X: function() {
        return HISTORY_POSITION_X;
    },
    HISTORY_POSITION_Y: function() {
        return HISTORY_POSITION_Y;
    },
    SEARCHED_ITEM_POSITION_Y: function() {
        return SEARCHED_ITEM_POSITION_Y;
    },
    TITLE_FONT: function() {
        return TITLE_FONT;
    },
    TITLE_FONT_TYPE: function() {
        return TITLE_FONT_TYPE;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(42578);
var _constants = __webpack_require__(34952);
var _typography = __webpack_require__(18411);
var _style = __webpack_require__(65082);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var CONTAINER_WIDTH = (_obj = {}, _define_property._(_obj, _constants.HD, 483), _define_property._(_obj, _constants.FULL_HD, 732), _obj);
var _obj1;
var CONTAINER_HEIGHT = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 219), _define_property._(_obj1, _constants.FULL_HD, 299), _obj1);
var _obj2;
var HISTORY_POSITION_X = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 738), _define_property._(_obj2, _constants.FULL_HD, 1090), _obj2);
var _obj3;
var SEARCHED_ITEM_POSITION_Y = (_obj3 = {}, _define_property._(_obj3, _constants.HD, 44), _define_property._(_obj3, _constants.FULL_HD, 72), _obj3);
var _obj4;
var HISTORY_POSITION_Y = (_obj4 = {}, _define_property._(_obj4, _constants.HD, 64), _define_property._(_obj4, _constants.FULL_HD, 133), _obj4);
var _obj5;
var EMPTY_HISTORY_LABEL_POSITION = {
    vertical: (_obj5 = {}, _define_property._(_obj5, _constants.HD, 96), _define_property._(_obj5, _constants.FULL_HD, 136), _obj5)
};
var TITLE_FONT = _typography.FONT.KINSHASA_3;
var TITLE_FONT_TYPE = _typography.FONT_TYPE.MAIN;
var EMPTY_HISTORY_FONT = _typography.FONT.KINSHASA_3;
var EMPTY_HISTORY_FONT_TYPE = _typography.FONT_TYPE.MAIN;
var getInitialStyle = function() {
    var screenSize = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext).screenSize;
    return {
        x: HISTORY_POSITION_X[screenSize],
        y: HISTORY_POSITION_Y[screenSize],
        w: CONTAINER_WIDTH[screenSize],
        h: CONTAINER_HEIGHT[screenSize],
        Title: {
            w: CONTAINER_WIDTH[screenSize],
            text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(TITLE_FONT, screenSize, TITLE_FONT_TYPE)), {
                maxLines: 1,
                verticalAlign: "middle",
                textAlign: "center"
            })
        },
        EmptyHistoryLabel: {
            w: CONTAINER_WIDTH[screenSize],
            y: EMPTY_HISTORY_LABEL_POSITION.vertical[screenSize],
            text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(EMPTY_HISTORY_FONT, screenSize, EMPTY_HISTORY_FONT_TYPE)), {
                maxLines: 1,
                verticalAlign: "middle",
                textAlign: "center"
            })
        },
        Items: {
            y: SEARCHED_ITEM_POSITION_Y[screenSize],
            flex: {
                direction: "column",
                justifyContent: "center"
            }
        },
        cacheResolver: _style.cacheResolver
    };
};


/***/ }),

/***/ 93980:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return SearchedItem;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(3009);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _searchedItemstyle = __webpack_require__(65356);
var _iconcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(70160));
var SearchedItem = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(SearchedItem, _Lightning_Component);
    var _super = _create_super._(SearchedItem);
    function SearchedItem() {
        _class_call_check._(this, SearchedItem);
        return _super.apply(this, arguments);
    }
    _create_class._(SearchedItem, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _searchedItemstyle.defaultContext;
            }
        },
        {
            key: "data",
            set: function set(item) {
                this.patch({
                    Icon: {
                        iconData: {
                            picto: _searchedItemstyle.HISTORY_ICON,
                            viewBox: {
                                w: _searchedItemstyle.ICON_DIMENSION[this._style.screenSize].w,
                                h: _searchedItemstyle.ICON_DIMENSION[this._style.screenSize].h
                            }
                        }
                    },
                    Title: {
                        text: {
                            text: item
                        }
                    }
                });
            }
        },
        {
            key: "_focus",
            value: function _focus() {
                this.patch((0, _searchedItemstyle.getFocusedStyle)(this._style));
            }
        },
        {
            key: "_unfocus",
            value: function _unfocus() {
                this.patch((0, _searchedItemstyle.getUnFocusedStyle)(this._style));
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Icon: {
                        type: _iconcomponent.default
                    },
                    Title: {}
                }, (0, _searchedItemstyle.getInitialStyle)());
            }
        }
    ]);
    return SearchedItem;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 65356:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BACKGROUND_FOCUSED_COLOR: function() {
        return BACKGROUND_FOCUSED_COLOR;
    },
    BACKGROUND_UNFOCUSED_COLOR: function() {
        return BACKGROUND_UNFOCUSED_COLOR;
    },
    HISTORY_ICON: function() {
        return HISTORY_ICON;
    },
    ICON_DIMENSION: function() {
        return ICON_DIMENSION;
    },
    ICON_MARGIN_BOTTOM: function() {
        return ICON_MARGIN_BOTTOM;
    },
    ICON_MARGIN_LEFT: function() {
        return ICON_MARGIN_LEFT;
    },
    ICON_MARGIN_RIGHT: function() {
        return ICON_MARGIN_RIGHT;
    },
    ICON_MARGIN_TOP: function() {
        return ICON_MARGIN_TOP;
    },
    ITEM_HEIGHT: function() {
        return ITEM_HEIGHT;
    },
    ITEM_MARGIN_BOTTOM: function() {
        return ITEM_MARGIN_BOTTOM;
    },
    ITEM_WIDTH: function() {
        return ITEM_WIDTH;
    },
    TEXT_FOCUSED_COLOR: function() {
        return TEXT_FOCUSED_COLOR;
    },
    TEXT_UNFOCUSED_COLOR: function() {
        return TEXT_UNFOCUSED_COLOR;
    },
    TITLE_FONT: function() {
        return TITLE_FONT;
    },
    TITLE_FONT_TYPE: function() {
        return TITLE_FONT_TYPE;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getFocusedStyle: function() {
        return getFocusedStyle;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    getUnFocusedStyle: function() {
        return getUnFocusedStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(42578);
var _constants = __webpack_require__(34952);
var _typography = __webpack_require__(18411);
var _theme = __webpack_require__(51397);
var _style = __webpack_require__(65082);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var ITEM_WIDTH = (_obj = {}, _define_property._(_obj, _constants.HD, 487), _define_property._(_obj, _constants.FULL_HD, 732), _obj);
var _obj1;
var ITEM_HEIGHT = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 40), _define_property._(_obj1, _constants.FULL_HD, 56), _obj1);
var _obj2;
var ITEM_MARGIN_BOTTOM = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 4), _define_property._(_obj2, _constants.FULL_HD, 1), _obj2);
var _obj3;
var ICON_MARGIN_TOP = (_obj3 = {}, _define_property._(_obj3, _constants.HD, 8), _define_property._(_obj3, _constants.FULL_HD, 16), _obj3);
var _obj4;
var ICON_MARGIN_BOTTOM = (_obj4 = {}, _define_property._(_obj4, _constants.HD, 8), _define_property._(_obj4, _constants.FULL_HD, 16), _obj4);
var _obj5;
var ICON_MARGIN_LEFT = (_obj5 = {}, _define_property._(_obj5, _constants.HD, 62), _define_property._(_obj5, _constants.FULL_HD, 55), _obj5);
var _obj6;
var ICON_MARGIN_RIGHT = (_obj6 = {}, _define_property._(_obj6, _constants.HD, 24), _define_property._(_obj6, _constants.FULL_HD, 24), _obj6);
var _obj7;
var ICON_DIMENSION = (_obj7 = {}, _define_property._(_obj7, _constants.HD, {
    w: 24,
    h: 24
}), _define_property._(_obj7, _constants.FULL_HD, {
    w: 24,
    h: 24
}), _obj7);
var colors = {
    background: (0, _theme.makeThemeColor)(_theme.CLOUD_NORMAL)[defaultContext.colorMode]
};
var TITLE_FONT = _typography.FONT.BERLIN_1;
var TITLE_FONT_TYPE = _typography.FONT_TYPE.MAIN;
var BACKGROUND_FOCUSED_COLOR = (0, _theme.makeThemeColor)(_theme.PRIMARY);
var BACKGROUND_UNFOCUSED_COLOR = (0, _theme.makeThemeColor)(_theme.CLOUD_NORMAL);
var TEXT_UNFOCUSED_COLOR = (0, _theme.makeThemeColor)(_theme.PRIMARY);
var TEXT_FOCUSED_COLOR = (0, _theme.makeThemeColor)(_theme.TERTIARY);
var HISTORY_ICON = {
    name: "History",
    type: "icon"
};
var getUnFocusedStyle = function(param) {
    var colorMode = param.colorMode;
    return {
        color: BACKGROUND_UNFOCUSED_COLOR[colorMode],
        Icon: {
            color: TEXT_UNFOCUSED_COLOR[colorMode]
        },
        Title: {
            color: TEXT_UNFOCUSED_COLOR[colorMode]
        }
    };
};
var getFocusedStyle = function(param) {
    var colorMode = param.colorMode;
    return {
        color: BACKGROUND_FOCUSED_COLOR[colorMode],
        Icon: {
            color: TEXT_FOCUSED_COLOR[colorMode]
        },
        Title: {
            color: TEXT_FOCUSED_COLOR[colorMode]
        }
    };
};
var getInitialStyle = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext, screenSize = _ref.screenSize, colorMode = _ref.colorMode;
    return {
        rect: true,
        color: BACKGROUND_UNFOCUSED_COLOR[colorMode],
        w: ITEM_WIDTH[screenSize],
        h: ITEM_HEIGHT[screenSize],
        flex: {
            direction: "row",
            alignItems: "center"
        },
        flexItem: {
            marginBottom: ITEM_MARGIN_BOTTOM[screenSize]
        },
        Icon: {
            flexItem: {
                marginTop: ICON_MARGIN_TOP[screenSize],
                marginBottom: ICON_MARGIN_BOTTOM[screenSize],
                marginLeft: ICON_MARGIN_LEFT[screenSize],
                marginRight: ICON_MARGIN_RIGHT[screenSize]
            }
        },
        Title: {
            text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(TITLE_FONT, screenSize, TITLE_FONT_TYPE)), {
                maxLines: 1,
                verticalAlign: "middle",
                textAlign: "center",
                maxLinesSuffix: "...",
                wrap: true,
                wordWrapWidth: ITEM_WIDTH[screenSize] - ICON_MARGIN_LEFT[screenSize] - ICON_DIMENSION[screenSize].w - ICON_MARGIN_RIGHT[screenSize]
            })
        },
        cacheResolver: _style.cacheResolver
    };
};


/***/ }),

/***/ 20944:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    STATIC_DIRECTORY: function() {
        return STATIC_DIRECTORY;
    },
    capitalizeKeyActions: function() {
        return capitalizeKeyActions;
    },
    getFullPath: function() {
        return getFullPath;
    },
    getSettings: function() {
        return getSettings;
    }
});
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _memoize = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34736));
var _sdk = __webpack_require__(29956);
var _default = __webpack_require__(95652);
var STATIC_DIRECTORY = "static";
var capitalizeKeyActions = (0, _memoize.default)(function(codes) {
    return Object.keys(codes).reduce(function(previous, key) {
        var value = codes[key];
        previous[key] = value.charAt(0).toUpperCase() + value.slice(1);
        return previous;
    }, {});
});
var getSettings = function() {
    var appSettings = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : undefined, platformSettings = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : undefined;
    var sizes = window.innerHeight <= 720 ? {
        w: 1280,
        h: 720
    } : {
        w: 1920,
        h: 1080
    };
    var forcedStageSettings = {
        // Disable UI auto-scaling
        precision: 1,
        // Ensure video will be visible behind an app
        clearColor: 0x00000000
    };
    var canvas2d;
    var inspector;
    try {
        var query = new URL(document.location).searchParams;
        canvas2d = query.get("canvas2d") === "true";
        inspector = query.get("inspector") === "true";
    } catch (error) {
        canvas2d = false;
        inspector = false;
    }
    var commonSettings = {
        appSettings: {
            keys: capitalizeKeyActions((0, _default.getKeyCodes)()),
            stage: _object_spread._({
                useImageWorker: true,
                canvas2d: canvas2d
            }, sizes),
            debug: false
        },
        platformSettings: {
            inspector: inspector,
            path: "./".concat(STATIC_DIRECTORY),
            log: true,
            showVersion: false,
            router: {
                disableTransitions: false,
                lazyCreate: true,
                lazyDestroy: true,
                destroyOnHistoryBack: true,
                reuseInstance: false
            }
        }
    };
    // Gracefully apply any overrides except sizes: we need to keep our own resolution handling in order to follow the Studio design
    var overrides = (0, _merge.default)({
        appSettings: appSettings,
        platformSettings: platformSettings
    }, {
        appSettings: {
            stage: _object_spread._({}, forcedStageSettings)
        }
    });
    commonSettings.platformSettings.fontLoader = function(fonts, store) {
        return Promise.allSettled(fonts.map(function(param) {
            var family = param.family, url = param.url, urls = param.urls, descriptors = param.descriptors;
            var src = urls ? urls.map(function(url) {
                return "url(".concat(url, ")");
            }) : "url(".concat(url, ")");
            var fontFace = new FontFace(family, src, descriptors || {});
            store.push(fontFace);
            document.fonts.add(fontFace);
            return fontFace.load();
        }));
    };
    return (0, _merge.default)(commonSettings, (0, _default.getSettings)(), overrides);
};
var STATIC_DIRECTORY_REG_EXP = new RegExp("^/".concat(STATIC_DIRECTORY, "/"));
var getFullPath = function(url) {
    if (!url) {
        return "";
    }
    var hostedUrlPublicPath = "./public" || 0;
    var base = _sdk.Utils.asset(url.replace(hostedUrlPublicPath, "/").replace(STATIC_DIRECTORY_REG_EXP, ""));
    // Handling deeplink scenarios which are not working on previews (AWS limitation)
    var pathname = window.location.pathname;
    if (!pathname || pathname === "/") {
        return base;
    }
    return  false ? 0 : base.replace(pathname, "");
};


/***/ }),

/***/ 95652:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    getKeyCodes: function() {
        return getKeyCodes;
    },
    getSettings: function() {
        return getSettings;
    }
});
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(3009);
var _keys = __webpack_require__(3043);
var getKeyCodes = function() {
    return _keys.keyCodes;
};
var getSettings = function() {
    return {
        appSettings: {
            stage: {
                forceTxCanvasSource: true
            }
        }
    };
};


/***/ }),

/***/ 6085:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "PrivacySettings", ({
    enumerable: true,
    get: function() {
        return PrivacySettings;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _sliced_to_array = __webpack_require__(28966);
var _to_consumable_array = __webpack_require__(30005);
var _create_super = __webpack_require__(6400);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
var _sdk = __webpack_require__(29956);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _privacySettingsstyle = __webpack_require__(12703);
var _privacySettingsutils = __webpack_require__(71105);
var _privacySettingsconnector = /*#__PURE__*/ _interop_require_default._(__webpack_require__(2480));
var _checkBoxBlockcomponent = __webpack_require__(43474);
var _buttoncomponent = __webpack_require__(31464);
var _iconcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(70160));
var _brandIconcomponent = __webpack_require__(362);
var _i18n = __webpack_require__(14910);
var _useractions = __webpack_require__(79489);
var _analyticsutils = __webpack_require__(2693);
var _privacySettingsconstants = __webpack_require__(75813);
var PrivacySettings = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(PrivacySettings, _Lightning_Component);
    var _super = _create_super._(PrivacySettings);
    function PrivacySettings() {
        _class_call_check._(this, PrivacySettings);
        return _super.apply(this, arguments);
    }
    _create_class._(PrivacySettings, [
        {
            key: "_construct",
            value: function _construct() {
                this._index = 0;
                this._focusable = [];
                this._visibility = [];
                this._positions = [
                    0
                ];
                this._savedCookies = {};
            }
        },
        {
            key: "_attach",
            value: function _attach() {
                this._unsubscribe = (0, _privacySettingsconnector.default)(this);
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                if (this._unsubscribe) {
                    this._unsubscribe();
                    this._unsubscribe = null;
                }
            }
        },
        {
            key: "_getFocused",
            value: function _getFocused() {
                // FIXME: hacky way to get actual finalH of CookieGroups
                this.setPositions();
                return this.focused;
            }
        },
        {
            key: "focused",
            get: function get() {
                return this._focusable[this._index];
            }
        },
        {
            key: "setPositions",
            value: function setPositions() {
                var _this = this;
                // do nothing if positions are already set
                if (this._positions.length > 1) {
                    return;
                }
                this.stage.update();
                this._positions = [
                    0
                ];
                var offset = this.tag("CookieGroups").finalY;
                this._visibility = [
                    {
                        BrandIcon: true,
                        ArrowUp: false,
                        ArrowDown: this.tag("ScrollContent").finalH > this.tag("ScrollWrapper").finalH
                    }
                ];
                var bottomOffset = this.tag("ScrollWrapper").finalH - this.tag("ScrollContent").finalH;
                var halfOfScreenHeight = this.tag("ScrollWrapper").finalH / 2;
                this.tag("CookieGroups").children.forEach(function(block) {
                    var position = Math.min(Math.max(halfOfScreenHeight - offset - Math.round(block.finalH / 2), bottomOffset), 0);
                    _this._positions.push(position);
                    offset += block.finalH;
                    var isBrandIconVisible = position === 0;
                    _this._visibility.push({
                        BrandIcon: isBrandIconVisible,
                        ArrowUp: !isBrandIconVisible,
                        ArrowDown: position !== bottomOffset
                    });
                });
                // update visibility for items
                this.setIndex();
            }
        },
        {
            key: "setIndex",
            value: function setIndex() {
                var index = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._index;
                this._index = index;
                var itemsVisibility = this._visibility[index];
                this.patch({
                    ArrowUp: {
                        visible: itemsVisibility.ArrowUp
                    },
                    BrandIcon: {
                        visible: itemsVisibility.BrandIcon
                    },
                    ScrollWrapper: {
                        ScrollContent: {
                            smooth: {
                                y: index ? this._positions[index] : 0
                            }
                        }
                    },
                    ArrowDown: {
                        visible: itemsVisibility.ArrowDown
                    }
                });
            }
        },
        {
            key: "selectedCookies",
            get: function get() {
                return this.tag("CookieGroups").children.reduce(function(memo, item) {
                    return _object_spread_props._(_object_spread._({}, memo), _define_property._({}, item.category, item.checked));
                }, {});
            }
        },
        {
            key: "_dispatchSelectedCategories",
            value: function _dispatchSelectedCategories() {
                var shouldSendEvent = !this._areGdprCookiesSet || (0, _privacySettingsutils.isUpdated)(this.savedCookies, this.selectedCookies);
                var consent = this.selectedCookies;
                _lightningjsredux.default.dispatch((0, _useractions.setUserConsents)(consent));
                if (shouldSendEvent) {
                    (0, _analyticsutils.sendEvent)({
                        key: "gdprChangeConsents",
                        consentNames: Object.keys(consent).filter(function(key) {
                            return consent[key];
                        }).join(",")
                    });
                }
            }
        },
        {
            key: "_handleUp",
            value: function _handleUp() {
                if (this._index > 0) {
                    this.setIndex(this._index - 1);
                    return true;
                }
                return false;
            }
        },
        {
            key: "_handleDown",
            value: function _handleDown() {
                if (this._index < this._focusable.length - 1) {
                    this.setIndex(this._index + 1);
                    return true;
                }
                return false;
            }
        },
        {
            key: "_handleEnter",
            value: function _handleEnter() {
                if (this.focused === this.tag("BackButton")) {
                    this._dispatchSelectedCategories();
                    this.signal(_privacySettingsconstants.PRIVACY_SETTINGS_EXIT_SIGNAL);
                }
                this.tag("BackButton").label = (0, _privacySettingsutils.getBackButtonLabel)(this.savedCookies, this.selectedCookies, this._areGdprCookiesSet);
                return true;
            }
        },
        {
            key: "_handleBack",
            value: function _handleBack() {
                this._dispatchSelectedCategories();
                this.signal(_privacySettingsconstants.PRIVACY_SETTINGS_EXIT_SIGNAL);
                return true;
            }
        },
        {
            key: "_setCheckbox",
            value: function _setCheckbox(category, value) {
                var checkbox = this.tag("CookieGroups").children.find(function(cookieCategory) {
                    return cookieCategory.category === category;
                });
                if (checkbox) {
                    checkbox.checked = value;
                }
            }
        },
        {
            key: "cookies",
            set: function set(value) {
                var _this = this;
                this._savedCookies = value;
                this.tag("CookieGroups").children = Object.keys(value).map(function(cookieCategory) {
                    return {
                        type: _checkBoxBlockcomponent.CheckBoxBlock,
                        data: {
                            title: (0, _i18n.t)("privacySettings.cookie.".concat(cookieCategory, ".title")),
                            description: (0, _i18n.t)("privacySettings.cookie.".concat(cookieCategory, ".content"))
                        },
                        category: cookieCategory
                    };
                });
                this._focusable = [
                    this.tag("BackButton")
                ].concat(_to_consumable_array._(this.tag("CookieGroups").children));
                Object.entries(value).forEach(function(param) {
                    var _param = _sliced_to_array._(param, 2), category = _param[0], _$value = _param[1];
                    var checkbox = _this.tag("CookieGroups").children.find(function(cookieCategory) {
                        return cookieCategory.category === category;
                    });
                    if (checkbox) {
                        checkbox.checked = typeof _$value === "boolean" ? _$value : false;
                    }
                });
            }
        },
        {
            key: "areGdprCookiesSet",
            set: function set(value) {
                this._areGdprCookiesSet = value;
            }
        },
        {
            key: "savedCookies",
            get: function get() {
                return this._savedCookies;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Background: {},
                    BackButton: {
                        type: _buttoncomponent.Button,
                        label: (0, _i18n.t)("global.back")
                    },
                    ArrowUp: {
                        type: _iconcomponent.default
                    },
                    BrandIcon: {
                        type: _brandIconcomponent.BrandIcon
                    },
                    ScrollWrapper: {
                        ScrollContent: {
                            Title: {
                                text: {
                                    text: (0, _i18n.t)("privacySettings.title")
                                }
                            },
                            Description: {
                                visible: (0, _i18n.t)("privacySettings.cookie.text"),
                                text: {
                                    text: (0, _i18n.t)("privacySettings.cookie.text")
                                }
                            },
                            CookieGroups: {}
                        }
                    },
                    ArrowDown: {
                        type: _iconcomponent.default
                    }
                }, (0, _privacySettingsstyle.getInitialStyle)());
            }
        }
    ]);
    return PrivacySettings;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 2480:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(3009);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _userselectors = __webpack_require__(41845);
var mapControllers = function(instance) {
    return {
        cookies: {
            selector: _userselectors.getCookies,
            shouldBeInvokedOnConnect: true,
            callback: function(value) {
                instance.cookies = value;
            }
        },
        areUserPreferencesSet: {
            selector: _userselectors.areGdprCookiesSet,
            shouldBeInvokedOnConnect: true,
            callback: function(value) {
                instance.areGdprCookiesSet = value;
            }
        }
    };
};
var _default = _lightningjsredux.default.control(mapControllers);


/***/ }),

/***/ 75813:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "PRIVACY_SETTINGS_EXIT_SIGNAL", ({
    enumerable: true,
    get: function() {
        return PRIVACY_SETTINGS_EXIT_SIGNAL;
    }
}));
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(3009);
var PRIVACY_SETTINGS_EXIT_SIGNAL = "privacySettingsExit";


/***/ }),

/***/ 12703:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BRAND_ICON_SIZE: function() {
        return BRAND_ICON_SIZE;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    gridPadding: function() {
        return gridPadding;
    }
});
var _define_property = __webpack_require__(21228);
var _object_spread = __webpack_require__(76247);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(45538);
var _constants = __webpack_require__(34952);
var _typography = __webpack_require__(18411);
var _theme = __webpack_require__(51397);
var _style = __webpack_require__(65082);
var _sizes = __webpack_require__(82699);
var _iconconstants = __webpack_require__(48112);
var _obj;
var BRAND_ICON_SIZE = (_obj = {}, _define_property._(_obj, _constants.HD, 64), _define_property._(_obj, _constants.FULL_HD, 72), _obj);
var _obj1;
var ARROW_PADDING_BOTTOM = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 24), _define_property._(_obj1, _constants.FULL_HD, 32), _obj1);
var _obj2;
var ARROW_SIZE = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 96), _define_property._(_obj2, _constants.FULL_HD, 128), _obj2);
var _obj3;
var CONTENT_SIDE_MARGIN = (_obj3 = {}, _define_property._(_obj3, _constants.HD, 300), _define_property._(_obj3, _constants.FULL_HD, 460), _obj3);
var _obj4;
var TITLE_PADDING_BOTTOM = (_obj4 = {}, _define_property._(_obj4, _constants.HD, 24), _define_property._(_obj4, _constants.FULL_HD, 56), _obj4);
var _obj5;
var DESCRIPTION_PADDING_BOTTOM = (_obj5 = {}, _define_property._(_obj5, _constants.HD, 24), _define_property._(_obj5, _constants.FULL_HD, 25), _obj5);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var screenSize = context.screenSize, colorMode = context.colorMode;
    var topY = _constants.safetyMargins.vertical[screenSize];
    var scrollWrapperY = topY + ARROW_SIZE[screenSize] + ARROW_PADDING_BOTTOM[screenSize];
    var scrollWrapperWidth = _sizes.SCREEN_WIDTH[screenSize] - CONTENT_SIDE_MARGIN[screenSize] * 2;
    var scrollWrapperHeight = _sizes.SCREEN_HEIGHT[screenSize] - _constants.safetyMargins.vertical[screenSize] - scrollWrapperY - ARROW_SIZE[screenSize];
    var titleFont = (0, _typography.getFont)(_typography.FONT.KINSHASA_3, screenSize);
    var descriptionFont = (0, _typography.getFont)(_typography.FONT.MADRID_1, screenSize);
    var backgroundColor = (0, _theme.makeThemeColor)(_theme.TERTIARY);
    return {
        w: _sizes.SCREEN_WIDTH[screenSize],
        h: _sizes.SCREEN_HEIGHT[screenSize],
        Background: {
            rect: true,
            w: _sizes.SCREEN_WIDTH[screenSize],
            h: _sizes.SCREEN_HEIGHT[screenSize],
            color: backgroundColor[colorMode]
        },
        BackButton: {
            x: _constants.safetyMargins.horizontal[screenSize],
            y: topY
        },
        ArrowUp: {
            y: topY,
            mountX: 0.5,
            x: _sizes.middle,
            visible: false,
            iconData: {
                picto: {
                    name: "ArrowUp",
                    type: _iconconstants.ICON_TYPE.SIMPLE_ICON
                },
                viewBox: {
                    h: ARROW_SIZE[screenSize]
                }
            }
        },
        BrandIcon: {
            h: BRAND_ICON_SIZE[screenSize],
            y: topY,
            mountX: 0.5,
            x: _sizes.middle
        },
        ScrollWrapper: {
            mountX: 0.5,
            x: _sizes.middle,
            y: scrollWrapperY,
            w: scrollWrapperWidth,
            h: scrollWrapperHeight,
            clipping: true,
            ScrollContent: {
                flex: {
                    direction: "column"
                },
                Title: {
                    mountX: 0.5,
                    flexItem: {
                        marginBottom: TITLE_PADDING_BOTTOM[screenSize]
                    },
                    x: _sizes.middle,
                    text: _object_spread._({}, titleFont)
                },
                Description: {
                    mountX: 0.5,
                    x: _sizes.middle,
                    flexItem: {
                        marginBottom: DESCRIPTION_PADDING_BOTTOM[screenSize]
                    },
                    text: _object_spread._({
                        wordWrapWidth: scrollWrapperWidth
                    }, descriptionFont)
                },
                CookieGroups: {
                    flex: {
                        direction: "column"
                    }
                }
            }
        },
        ArrowDown: {
            mountY: 1,
            y: _sizes.SCREEN_HEIGHT[screenSize] - _constants.safetyMargins.vertical[screenSize],
            mountX: 0.5,
            x: _sizes.middle,
            visible: false,
            iconData: {
                picto: {
                    name: "ArrowDown",
                    type: _iconconstants.ICON_TYPE.SIMPLE_ICON
                },
                viewBox: {
                    h: ARROW_SIZE[screenSize]
                }
            }
        }
    };
};
var gridPadding = {
    left: 224
};


/***/ }),

/***/ 71105:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    getBackButtonLabel: function() {
        return getBackButtonLabel;
    },
    isUpdated: function() {
        return isUpdated;
    }
});
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(88801);
var _config = __webpack_require__(67958);
var _i18n = __webpack_require__(14910);
var _gdprNoticeutils = __webpack_require__(28865);
var isUpdated = function(savedCookies, selectedCookies) {
    return _config.gdprCookies.some(function(category) {
        return savedCookies[category] !== selectedCookies[category];
    }) && !((0, _gdprNoticeutils.areCookiesEmpty)(savedCookies) && _config.gdprCookies.every(function(category) {
        return selectedCookies[category] === false;
    }));
};
var getBackButtonLabel = function(savedCookies, selectedCookies) {
    return isUpdated(savedCookies, selectedCookies) ? (0, _i18n.t)("global.backSave") : (0, _i18n.t)("global.back");
};


/***/ }),

/***/ 90912:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "Settings", ({
    enumerable: true,
    get: function() {
        return Settings;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(37815);
var _sdk = __webpack_require__(29956);
var _apputils = __webpack_require__(60368);
var _privacySettingscomponent = __webpack_require__(6085);
var _privacySettingsconstants = __webpack_require__(75813);
var Settings = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(Settings, _Lightning_Component);
    var _super = _create_super._(Settings);
    function Settings() {
        _class_call_check._(this, Settings);
        return _super.apply(this, arguments);
    }
    _create_class._(Settings, [
        {
            key: "_active",
            value: function _active() {
                (0, _apputils.removeSplashScreen)();
            }
        },
        {
            key: "_handleExitPrivacySettings",
            value: function _handleExitPrivacySettings() {
                _sdk.Router.back();
            }
        },
        {
            key: "_getFocused",
            value: function _getFocused() {
                return this.tag("Settings");
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return {
                    Settings: {
                        type: _privacySettingscomponent.PrivacySettings,
                        signals: _define_property._({}, _privacySettingsconstants.PRIVACY_SETTINGS_EXIT_SIGNAL, "_handleExitPrivacySettings")
                    }
                };
            }
        }
    ]);
    return Settings;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 15703:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return SidenavIcon;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(3009);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _fidosdk = __webpack_require__(19804);
var _constants = __webpack_require__(34952);
var _iconcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(70160));
var _sidenavIconstyle = __webpack_require__(11155);
var SidenavIcon = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(SidenavIcon, _Lightning_Component);
    var _super = _create_super._(SidenavIcon);
    function SidenavIcon() {
        _class_call_check._(this, SidenavIcon);
        return _super.apply(this, arguments);
    }
    _create_class._(SidenavIcon, [
        {
            key: "_detach",
            value: function _detach() {
                this.tag("Image").removeAllListeners("txLoaded");
                this.tag("Icon").removeAllListeners("txLoaded");
            }
        },
        {
            key: "_construct",
            value: function _construct() {
                this._style = _sidenavIconstyle.defaultContext;
            }
        },
        {
            key: "content",
            set: function set(value) {
                var _ref = value || {}, picto = _ref.picto, image = _ref.image;
                var _getImageSize = (0, _sidenavIconstyle.getImageSize)(this._style.screenSize), w = _getImageSize.w, h = _getImageSize.h;
                var src = image && image.id ? _fidosdk.imageService.getUrl(image.id, w, h, {
                    fit: _constants.IMAGE_FIT_SCALE_CROP,
                    quality: _constants.IMAGE_QUALITY,
                    format: _constants.TRANSPARENT_IMAGE_FORMAT
                }) : "";
                var view = this.tag(src ? "Image" : "Icon");
                view.on("txLoaded", function() {
                    view.setSmooth("alpha", 1);
                });
                this.patch({
                    Icon: {
                        alpha: 0.0001,
                        visible: !src,
                        iconData: {
                            picto: picto,
                            viewBox: (0, _sidenavIconstyle.getIconViewBox)(this._style.screenSize)
                        }
                    },
                    Image: {
                        alpha: 0.0001,
                        w: w,
                        h: h,
                        visible: Boolean(src),
                        src: src
                    }
                });
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Icon: {
                        type: _iconcomponent.default
                    },
                    Image: {
                        shader: {
                            type: _sdk.Lightning.shaders.RoundedRectangle
                        }
                    }
                }, (0, _sidenavIconstyle.getInitialStyle)());
            }
        }
    ]);
    return SidenavIcon;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 11155:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    HEIGHT: function() {
        return HEIGHT;
    },
    ICON_PADDING: function() {
        return ICON_PADDING;
    },
    ICON_SIZE: function() {
        return ICON_SIZE;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getIconViewBox: function() {
        return getIconViewBox;
    },
    getImageSize: function() {
        return getImageSize;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(37815);
var _memoize = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34736));
var _constants = __webpack_require__(34952);
var _theme = __webpack_require__(51397);
var _style = __webpack_require__(65082);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var colors = {
    icon: (0, _theme.makeThemeColor)(_theme.PRIMARY),
    focusedIcon: (0, _theme.makeThemeColor)(_theme.TERTIARY)
};
var _obj;
var HEIGHT = (_obj = {}, _define_property._(_obj, _constants.HD, 48), _define_property._(_obj, _constants.FULL_HD, 72), _obj);
var _obj1, _obj2;
var ICON_SIZE = {
    WIDTH: (_obj1 = {}, _define_property._(_obj1, _constants.HD, 24), _define_property._(_obj1, _constants.FULL_HD, 32), _obj1),
    HEIGHT: (_obj2 = {}, _define_property._(_obj2, _constants.HD, 24), _define_property._(_obj2, _constants.FULL_HD, 32), _obj2)
};
var _obj3;
var ICON_PADDING = (_obj3 = {}, _define_property._(_obj3, _constants.HD, 16), _define_property._(_obj3, _constants.FULL_HD, 16), _obj3);
var getImageSize = function(screenSize) {
    return {
        w: ICON_SIZE.WIDTH[screenSize],
        h: ICON_SIZE.WIDTH[screenSize]
    };
};
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var screenSize = context.screenSize, colorMode = context.colorMode;
    var x = _constants.safetyMargins.horizontal[screenSize];
    var y = Math.round((HEIGHT[screenSize] - ICON_SIZE.HEIGHT[screenSize]) / 2);
    return {
        Icon: {
            x: x,
            y: y,
            color: colors.icon[colorMode]
        },
        Image: {
            x: x,
            y: y,
            shader: {
                radius: ICON_SIZE.HEIGHT[screenSize] / 2
            }
        }
    };
};
var getIconViewBox = (0, _memoize.default)(function(screenSize) {
    return {
        w: ICON_SIZE.WIDTH[screenSize],
        h: ICON_SIZE.HEIGHT[screenSize]
    };
});


/***/ }),

/***/ 35085:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "SHOW_INDICATOR", ({
    enumerable: true,
    get: function() {
        return SHOW_INDICATOR;
    }
}));
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(3009);
var SHOW_INDICATOR = true;


/***/ }),

/***/ 44762:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    CONTENT_GAP: function() {
        return CONTENT_GAP;
    },
    RESTRICTED_PATHS: function() {
        return RESTRICTED_PATHS;
    }
});
var _define_property = __webpack_require__(21228);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(37815);
var _constants = __webpack_require__(34952);
var _routesutils = __webpack_require__(14948);
var _obj;
var CONTENT_GAP = (_obj = {}, _define_property._(_obj, _constants.HD, 16), _define_property._(_obj, _constants.FULL_HD, 24), _obj);
var RESTRICTED_PATHS = [
    _routesutils.USAGE_TERMS_PATH,
    _routesutils.PRIVACY_POLICY_PATH,
    _routesutils.SUBSCRIPTION_TERMS_PATH,
    _routesutils.LEGAL_CONDITIONS_PATH,
    _routesutils.SETTINGS_PATH,
    _routesutils.EXPIRED_SUBSCRIPTION_PATH,
    _routesutils.VIDEO_PATH,
    _routesutils.LIVE_PATH
];


/***/ }),

/***/ 92882:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "DEFAULT_SERVICE", ({
    enumerable: true,
    get: function() {
        return DEFAULT_SERVICE;
    }
}));
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(65759);
var DEFAULT_SERVICE = "rtlplus_root";


/***/ }),

/***/ 19707:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/* eslint-disable no-console */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "MiniPlayer", ({
    enumerable: true,
    get: function() {
        return MiniPlayer;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(45538);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _sdk = __webpack_require__(29956);
var _fidosdk = __webpack_require__(19804);
var _constants = __webpack_require__(34952);
var _playerconstants = __webpack_require__(7602);
var _apputils = __webpack_require__(3613);
var _notifications = __webpack_require__(93831);
var _routesutils = __webpack_require__(14948);
var _audioadapter = __webpack_require__(68560);
var _autoscrollcomponent = __webpack_require__(72209);
var _barscomponent = __webpack_require__(75116);
var _miniPlayerconnect = /*#__PURE__*/ _interop_require_default._(__webpack_require__(93221));
var _miniPlayerstyle = __webpack_require__(84168);
var _miniPlayerconstants = __webpack_require__(47666);
var MiniPlayer = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(MiniPlayer, _Lightning_Component);
    var _super = _create_super._(MiniPlayer);
    function MiniPlayer() {
        _class_call_check._(this, MiniPlayer);
        return _super.apply(this, arguments);
    }
    _create_class._(MiniPlayer, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _miniPlayerstyle.defaultContext;
                this._isRadio = false;
            }
        },
        {
            key: "_attach",
            value: function _attach() {
                this._unsubscribe = (0, _miniPlayerconnect.default)(this);
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                if (this._unsubscribe) {
                    this._unsubscribe();
                    this._unsubscribe = null;
                }
            }
        },
        {
            key: "isActive",
            get: function get() {
                return this._playbackState === _playerconstants.PLAYBACK_STATE_PLAYING || this._playbackState === _playerconstants.PLAYBACK_STATE_PAUSED;
            }
        },
        {
            key: "metadata",
            set: function set(value) {
                this._clipId = (0, _get.default)(value, "video.id");
                var extraTitle = (0, _get.default)(value, "extraTitle") || "";
                var title = (0, _get.default)(value, "title") || "";
                var image = (0, _get.default)(value, "image.idsByRatio.1:1") || (0, _get.default)(value, "image.id") || "";
                var screenSize = this._style.screenSize;
                var coverSize = _miniPlayerstyle.COVER_SIZE[screenSize];
                this.patch({
                    Cover: {
                        src: _fidosdk.imageService.getUrl(image, coverSize, coverSize, {
                            fit: _constants.IMAGE_FIT_SCALE_CROP,
                            quality: _constants.IMAGE_QUALITY,
                            format: _constants.DEFAULT_IMAGE_FORMAT
                        })
                    },
                    ExtraTitle: {
                        caption: extraTitle
                    },
                    Title: {
                        caption: title
                    }
                });
                if (image) {
                    this.tag("Cover").loadTexture();
                }
            }
        },
        {
            key: "source",
            set: function set(value) {
                var audioPlayer = (0, _audioadapter.getAudioPlayerInstance)();
                if (!audioPlayer) {
                    return;
                }
                if (!value) {
                    audioPlayer.pause();
                    this.tag("Spectrum").stop();
                    return;
                }
                this._isRadio = value.provider === "radio";
                if (audioPlayer.source && audioPlayer.source.reference === value.reference) {
                    console.log("[MiniPlayer] Current source is the same: ".concat(value.reference));
                    audioPlayer.play();
                    return;
                }
                audioPlayer.pause();
                if (value.format === "mp3" || value.format === "hls") {
                    console.log("[MiniPlayer] Requesting a new playback of: ".concat(value.reference));
                    audioPlayer.setSource(value);
                    audioPlayer.play();
                } else {
                    console.log("[MiniPlayer] Destroying audio player");
                    // video playback was requested, stopping audio player and forgetting what it was playing
                    this._destroyAudioPlayer();
                }
            }
        },
        {
            key: "playbackError",
            set: function set(value) {
                var audioPlayer = (0, _audioadapter.getAudioPlayerInstance)();
                if (!value || !audioPlayer) {
                    return;
                }
                if (!this.isOnAudioPlayerScreen) {
                    (0, _apputils.showSnackbar)(this, _notifications.NOTIFICATION_LEVEL.ERROR, value.message);
                }
                this.tag("Spectrum").stop();
                this._destroyAudioPlayer();
                _lightningjsredux.default.dispatch((0, _playerconstants.reset)());
            }
        },
        {
            key: "playbackState",
            set: function set(value) {
                // The source was removed (i.e. player was reset) however a play or pause event was dispatched after that
                if (!this._clipId && (value === _playerconstants.PLAYBACK_STATE_PLAYING || value === _playerconstants.PLAYBACK_STATE_PAUSED)) {
                    this.tag("Spectrum").stop();
                    return;
                }
                this._playbackState = value;
                switch(value){
                    case _playerconstants.PLAYBACK_STATE_PLAYING:
                        {
                            this.tag("Spectrum").start();
                            break;
                        }
                    case _playerconstants.PLAYBACK_STATE_PAUSED:
                        {
                            this.tag("Spectrum").stop(true);
                            break;
                        }
                    case _playerconstants.PLAYBACK_STATE_ENDED:
                        {
                            this.tag("Spectrum").stop();
                            if (this.isOnAudioPlayerScreen) {
                                _sdk.Router.back();
                                this._destroyAudioPlayer();
                                _lightningjsredux.default.dispatch((0, _playerconstants.reset)());
                            }
                            break;
                        }
                    default:
                        {
                            this.tag("Spectrum").stop();
                            break;
                        }
                }
                var isVisible = this._playbackState === _playerconstants.PLAYBACK_STATE_PLAYING || this._playbackState === _playerconstants.PLAYBACK_STATE_PAUSED;
                if (!isVisible) {
                    this.signal(_miniPlayerconstants.HIDE_SIGNAL);
                }
                this.visible = isVisible;
            }
        },
        {
            key: "isOnAudioPlayerScreen",
            get: function get() {
                var route = _sdk.Router.getActiveRoute();
                return route.startsWith(_fidosdk.LAYOUT_ENTITIES.audio) || route.startsWith(_fidosdk.LAYOUT_ENTITIES.live);
            }
        },
        {
            key: "_focus",
            value: function _focus() {
                this.patch((0, _miniPlayerstyle.getFocusedStyle)(this._style));
            }
        },
        {
            key: "_unfocus",
            value: function _unfocus() {
                this.patch((0, _miniPlayerstyle.getUnFocusedStyle)(this._style));
            }
        },
        {
            key: "_handleEnter",
            value: function _handleEnter() {
                if (!this._clipId) {
                    return false;
                }
                if (this._isRadio) {
                    (0, _routesutils.navigateToRadioPage)(this._clipId);
                } else {
                    (0, _routesutils.navigateToAudioPage)(this._clipId);
                }
                return true;
            }
        },
        {
            key: "_handlePlay",
            value: function _handlePlay() {
                if (this._playbackState === _playerconstants.PLAYBACK_STATE_PLAYING) {
                    (0, _audioadapter.getAudioPlayerInstance)().pause();
                    return true;
                }
                return false;
            }
        },
        {
            key: "_handlePause",
            value: function _handlePause() {
                if (this._playbackState === _playerconstants.PLAYBACK_STATE_PAUSED) {
                    (0, _audioadapter.getAudioPlayerInstance)().play();
                    return true;
                }
                return false;
            }
        },
        {
            key: "_handlePlayPause",
            value: function _handlePlayPause() {
                return this._handlePlay() || this._handlePause();
            }
        },
        {
            key: "_destroyAudioPlayer",
            value: function _destroyAudioPlayer() {
                (0, _audioadapter.destroyAudioPlayer)();
            }
        },
        {
            key: "open",
            value: function open(width) {
                var screenSize = this._style.screenSize;
                var barsWidth = this.tag("Spectrum").w;
                var textWidth = width - _miniPlayerstyle.COVER_SIZE[screenSize] - _miniPlayerstyle.PADDING[screenSize] * 3 - _miniPlayerstyle.GAP[screenSize] - barsWidth;
                this.patch({
                    Background: {
                        smooth: {
                            alpha: [
                                this._playbackState === _playerconstants.PLAYBACK_STATE_PLAYING || this._playbackState === _playerconstants.PLAYBACK_STATE_PAUSED ? 1 : 0,
                                _miniPlayerstyle.TRANSITION_CONFIG
                            ]
                        }
                    },
                    Spectrum: {
                        smooth: {
                            x: [
                                width - _miniPlayerstyle.PADDING[screenSize] - barsWidth,
                                _miniPlayerstyle.TRANSITION_CONFIG
                            ]
                        }
                    },
                    Cover: {
                        smooth: {
                            alpha: [
                                1,
                                _miniPlayerstyle.TRANSITION_CONFIG
                            ]
                        }
                    },
                    ExtraTitle: {
                        w: textWidth,
                        smooth: {
                            alpha: 1
                        }
                    },
                    Title: {
                        w: textWidth,
                        smooth: {
                            alpha: 1
                        }
                    }
                });
            }
        },
        {
            key: "close",
            value: function close(width) {
                this.patch({
                    Background: {
                        smooth: {
                            alpha: [
                                0,
                                _miniPlayerstyle.TRANSITION_CONFIG
                            ]
                        }
                    },
                    Spectrum: {
                        smooth: {
                            x: [
                                Math.round((width - this.tag("Spectrum").w) / 2),
                                _miniPlayerstyle.TRANSITION_CONFIG
                            ]
                        }
                    },
                    Cover: {
                        smooth: {
                            alpha: [
                                0,
                                _miniPlayerstyle.TRANSITION_CONFIG
                            ]
                        }
                    },
                    ExtraTitle: {
                        smooth: {
                            alpha: 0
                        }
                    },
                    Title: {
                        smooth: {
                            alpha: 0
                        }
                    }
                });
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Background: {
                        rect: true
                    },
                    Spectrum: {
                        type: _barscomponent.Bars
                    },
                    Cover: {},
                    ExtraTitle: {
                        type: _autoscrollcomponent.Autoscroll
                    },
                    Title: {
                        type: _autoscrollcomponent.Autoscroll
                    }
                }, (0, _miniPlayerstyle.getInitialStyle)());
            }
        }
    ]);
    return MiniPlayer;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 98724:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _export_star = __webpack_require__(37668);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(88801);
_export_star._(__webpack_require__(19707), exports);


/***/ }),

/***/ 93221:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(3009);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _playerselectors = __webpack_require__(83318);
var mapControllers = function(instance) {
    return [
        {
            selector: _playerselectors.getPlaybackState,
            callback: function(value) {
                instance.playbackState = value;
            }
        },
        {
            selector: _playerselectors.getVideoSource,
            callback: function(value) {
                instance.source = value;
            }
        },
        {
            selector: _playerselectors.getCurrentMetadataItem,
            callback: function(value) {
                instance.metadata = value;
            }
        },
        {
            selector: _playerselectors.getLastPlaybackError,
            callback: function(value) {
                instance.playbackError = value;
            }
        }
    ];
};
var _default = _lightningjsredux.default.control(mapControllers);


/***/ }),

/***/ 47666:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "HIDE_SIGNAL", ({
    enumerable: true,
    get: function() {
        return HIDE_SIGNAL;
    }
}));
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(65759);
var HIDE_SIGNAL = "hide";


/***/ }),

/***/ 84168:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BORDER: function() {
        return BORDER;
    },
    COVER_SIZE: function() {
        return COVER_SIZE;
    },
    GAP: function() {
        return GAP;
    },
    HEIGHT: function() {
        return HEIGHT;
    },
    PADDING: function() {
        return PADDING;
    },
    TRANSITION_CONFIG: function() {
        return TRANSITION_CONFIG;
    },
    WIDTH: function() {
        return WIDTH;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getExtraTitleFont: function() {
        return getExtraTitleFont;
    },
    getFocusedStyle: function() {
        return getFocusedStyle;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    getTitleFont: function() {
        return getTitleFont;
    },
    getUnFocusedStyle: function() {
        return getUnFocusedStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _object_spread = __webpack_require__(76247);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(65759);
var _theme = __webpack_require__(51397);
var _constants = __webpack_require__(34952);
var _sdk = __webpack_require__(29956);
var _typography = __webpack_require__(18411);
var _style = __webpack_require__(65082);
var _colors = __webpack_require__(8426);
var _barsstyle = __webpack_require__(94186);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var colors = {
    background: (0, _theme.makeThemeColor)(_theme.PRIMARY, 0.1),
    text: (0, _theme.makeThemeColor)(_theme.PRIMARY),
    border: (0, _theme.makeThemeColor)(_theme.PRIMARY)
};
var _obj;
var WIDTH = (_obj = {}, _define_property._(_obj, _constants.HD, 152), _define_property._(_obj, _constants.FULL_HD, 224), _obj);
var _obj1;
var HEIGHT = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 72), _define_property._(_obj1, _constants.FULL_HD, 88), _obj1);
var _obj2;
var PADDING = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 12), _define_property._(_obj2, _constants.FULL_HD, 16), _obj2);
var _obj3;
var GAP = (_obj3 = {}, _define_property._(_obj3, _constants.HD, 24), _define_property._(_obj3, _constants.FULL_HD, 24), _obj3);
var _obj4;
var COVER_SIZE = (_obj4 = {}, _define_property._(_obj4, _constants.HD, 48), _define_property._(_obj4, _constants.FULL_HD, 56), _obj4);
var _obj5;
var BORDER = (_obj5 = {}, _define_property._(_obj5, _constants.HD, 2), _define_property._(_obj5, _constants.FULL_HD, 4), _obj5);
var _obj6;
var DEFAULT_WIDTH = (_obj6 = {}, _define_property._(_obj6, _constants.HD, 304), _define_property._(_obj6, _constants.FULL_HD, 416), _obj6);
var TRANSITION_CONFIG = {
    duration: 0.3
};
var getExtraTitleFont = function(screenSize) {
    return (0, _typography.getFont)(_typography.FONT.BERLIN_1, screenSize);
};
var getTitleFont = function(screenSize) {
    return (0, _typography.getFont)(_typography.FONT.MADRID_3, screenSize);
};
var getInitialStyle = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext, screenSize = _ref.screenSize, colorMode = _ref.colorMode;
    var commonTextConfig = {
        textColor: colors.text[colorMode],
        textAlign: "center",
        maxLines: 1,
        maxLinesSuffix: "...",
        verticalAlign: "middle"
    };
    var extraTitleFont = getExtraTitleFont(screenSize);
    var titleFont = getTitleFont(screenSize);
    var textX = PADDING[screenSize] * 2 + COVER_SIZE[screenSize];
    var textWidth = DEFAULT_WIDTH[screenSize] - COVER_SIZE[screenSize] - PADDING[screenSize] * 3 - GAP[screenSize] - _barsstyle.WIDTH[screenSize];
    return {
        h: HEIGHT[screenSize],
        Background: {
            w: function(value) {
                return value;
            },
            h: HEIGHT[screenSize],
            color: colors.background[colorMode],
            alpha: 0,
            shader: {
                type: _sdk.Lightning.shaders.RoundedRectangle,
                stroke: 0,
                strokeColor: _colors.TRANSPARENT,
                radius: 4
            }
        },
        Spectrum: {
            y: Math.round((HEIGHT[screenSize] - _barsstyle.HEIGHT[screenSize]) / 2)
        },
        Cover: {
            alpha: 0,
            w: COVER_SIZE[screenSize],
            h: COVER_SIZE[screenSize],
            x: PADDING[screenSize],
            y: Math.round((HEIGHT[screenSize] - COVER_SIZE[screenSize]) / 2),
            shader: {
                type: _sdk.Lightning.shaders.RoundedRectangle,
                radius: 4
            }
        },
        ExtraTitle: {
            x: textX,
            y: PADDING[screenSize],
            w: textWidth,
            font: _object_spread._({}, extraTitleFont, commonTextConfig)
        },
        Title: {
            x: textX,
            y: PADDING[screenSize] + extraTitleFont.lineHeight,
            w: textWidth,
            font: _object_spread._({}, titleFont, commonTextConfig)
        }
    };
};
var getFocusedStyle = function(param) {
    var colorMode = param.colorMode, screenSize = param.screenSize;
    return {
        Background: {
            smooth: {
                "shader.strokeColor": colors.border[colorMode],
                "shader.stroke": BORDER[screenSize],
                radius: 4 + BORDER[screenSize]
            }
        }
    };
};
var getUnFocusedStyle = function() {
    return {
        Background: {
            smooth: {
                "shader.strokeColor": _colors.TRANSPARENT,
                "shader.stroke": 0,
                radius: 4
            }
        }
    };
};


/***/ }),

/***/ 75116:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "Bars", ({
    enumerable: true,
    get: function() {
        return Bars;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(42578);
var _sdk = __webpack_require__(29956);
var _barsstyle = __webpack_require__(94186);
var Bars = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(Bars, _Lightning_Component);
    var _super = _create_super._(Bars);
    function Bars() {
        _class_call_check._(this, Bars);
        return _super.apply(this, arguments);
    }
    _create_class._(Bars, [
        {
            key: "_attach",
            value: function _attach() {
                this._style = _barsstyle.defaultContext;
                var _this__style = this._style, screenSize = _this__style.screenSize, colorMode = _this__style.colorMode;
                var h = _barsstyle.HEIGHT[screenSize];
                var w = _barsstyle.BAR_WIDTH[screenSize];
                var gap = _barsstyle.GAP[screenSize];
                var children = [];
                for(var i = 0; i < 4; i += 1){
                    children.push({
                        ref: "Bar".concat(i),
                        rect: true,
                        w: w,
                        h: h,
                        x: i * (w + gap),
                        y: h,
                        mountY: 1,
                        color: _barsstyle.colors.bar[colorMode]
                    });
                }
                this.patch({
                    children: children,
                    w: _barsstyle.WIDTH[screenSize]
                });
                this._timeouts = {};
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                this.stop();
                this._timeouts = null;
                this._style = null;
            }
        },
        {
            key: "start",
            value: function start() {
                var _this = this;
                this.children.forEach(function(child) {
                    _this._startBarAnimation(child);
                });
            }
        },
        {
            key: "stop",
            value: function stop() {
                var displayMinimalLevel = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                var _this = this;
                this.children.forEach(function(child) {
                    _this._stopBarAnimation(child);
                    child.setSmooth("h", displayMinimalLevel ? 1 : 0);
                });
                if (this._timeouts) {
                    Object.keys(this._timeouts).forEach(function(key) {
                        clearTimeout(_this._timeouts[key]);
                        _this._timeouts[key] = null;
                    });
                }
            }
        },
        {
            key: "_startBarAnimation",
            value: function _startBarAnimation(bar) {
                var _this = this;
                var height = _barsstyle.HEIGHT[this._style.screenSize];
                bar.transition("h").on("finish", function() {
                    var timeout = setTimeout(function() {
                        return bar.setSmooth("h", Math.round(Math.random() * height));
                    }, 16);
                    _this._timeouts[bar.ref] = timeout;
                });
                bar.setSmooth("h", Math.round(Math.random() * height));
            }
        },
        {
            key: "_stopBarAnimation",
            value: function _stopBarAnimation(bar) {
                var transition = bar.transition("h");
                if (transition) {
                    transition.stop();
                    transition.removeAllListeners("finish");
                }
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _barsstyle.getInitialStyle)();
            }
        }
    ]);
    return Bars;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 94186:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BAR_WIDTH: function() {
        return BAR_WIDTH;
    },
    GAP: function() {
        return GAP;
    },
    HEIGHT: function() {
        return HEIGHT;
    },
    WIDTH: function() {
        return WIDTH;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
var _define_property = __webpack_require__(21228);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(52318);
var _theme = __webpack_require__(51397);
var _constants = __webpack_require__(34952);
var _style = __webpack_require__(65082);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var colors = {
    background: (0, _theme.makeThemeColor)(_theme.PRIMARY, 0.1),
    bar: (0, _theme.makeThemeColor)(_theme.SECONDARY)
};
var _obj;
var HEIGHT = (_obj = {}, _define_property._(_obj, _constants.HD, 24), _define_property._(_obj, _constants.FULL_HD, 32), _obj);
var _obj1;
var BAR_WIDTH = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 3), _define_property._(_obj1, _constants.FULL_HD, 4), _obj1);
var _obj2;
var GAP = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 1), _define_property._(_obj2, _constants.FULL_HD, 2), _obj2);
var getWidth = function(screenSize) {
    return 4 * (BAR_WIDTH[screenSize] + GAP[screenSize]) - GAP[screenSize];
};
var _obj3;
var WIDTH = (_obj3 = {}, _define_property._(_obj3, _constants.HD, getWidth(_constants.HD)), _define_property._(_obj3, _constants.FULL_HD, getWidth(_constants.FULL_HD)), _obj3);
var getInitialStyle = function() {
    var screenSize = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext).screenSize;
    return {
        h: HEIGHT[screenSize]
    };
};


/***/ }),

/***/ 48966:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return Sidenav;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _create_super = __webpack_require__(6400);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(52318);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _sdk = __webpack_require__(29956);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _ctaactions = __webpack_require__(32067);
var _ctautils = __webpack_require__(42533);
var _miniPlayercomponent = __webpack_require__(98724);
var _miniPlayerconstants = __webpack_require__(47666);
var _sidenavItemcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(11570));
var _sidenavItemstyle = __webpack_require__(39524);
var _sidenavLogocomponent = __webpack_require__(40258);
var _sidenavstyle = __webpack_require__(53659);
var _sidenavconnect = /*#__PURE__*/ _interop_require_default._(__webpack_require__(53489));
var _sidenavutils = __webpack_require__(54463);
var _sidenavconstants = __webpack_require__(74842);
var _routesutils = __webpack_require__(14948);
var Sidenav = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(Sidenav, _Lightning_Component);
    var _super = _create_super._(Sidenav);
    function Sidenav() {
        _class_call_check._(this, Sidenav);
        return _super.apply(this, arguments);
    }
    _create_class._(Sidenav, [
        {
            key: "_construct",
            value: function _construct() {
                this._isActive = false;
                this._section = null;
                this._navigation = null;
                this._isMiniPlayerFocused = false;
                this._index = 0;
                this._itemsCount = 0;
                this._currentRoute = "";
                this._currentPaths = [];
                this._currentSections = [];
                this._style = _sidenavstyle.defaultContext;
            }
        },
        {
            key: "_attach",
            value: function _attach() {
                this._unsubscribe = (0, _sidenavconnect.default)(this);
            }
        },
        {
            key: "_active",
            value: function _active() {
                var screenSize = this._style.screenSize;
                var w = _sidenavconstants.WIDTH[screenSize];
                this.tag("MiniPlayer").close(w - _sidenavstyle.MINI_PLAYER_MARGIN[screenSize] * 2);
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                if (this._unsubscribe) {
                    this._unsubscribe();
                    this._unsubscribe = null;
                }
                this._isMiniPlayerFocused = false;
            }
        },
        {
            key: "isActive",
            get: function get() {
                return this._isActive;
            },
            set: function set(value) {
                if (this._isActive !== value) {
                    this.alpha = value ? 1 : 0;
                    this._isActive = value;
                }
            }
        },
        {
            key: "couldRequestNavigationLayout",
            set: function set(value) {
                this._couldRequestNavigationLayout = value;
                if (this._couldRequestNavigationLayout && this._section) {
                    this.logoSection = this._section;
                }
            }
        },
        {
            key: "section",
            set: function set(value) {
                if (this._section !== value) {
                    this._navigation = null;
                    this._doTheThing();
                    this.logoSection = value;
                    this._section = value;
                }
            }
        },
        {
            key: "logoSection",
            set: function set(value) {
                this.tag("Logo").section = value;
            }
        },
        {
            key: "colorMode",
            get: function get() {
                return this._style.colorMode;
            },
            set: function set(value) {
                this._style = _object_spread_props._(_object_spread._({}, this._style), {
                    colorMode: value
                });
                this.patch({
                    color: _sidenavstyle.colors.background[this._style.colorMode]
                });
            }
        },
        {
            key: "navigation",
            get: function get() {
                return this._navigation;
            },
            set: function set(value) {
                if (!(0, _sidenavutils.isSameNavigation)(this._navigation, value)) {
                    this._navigation = value;
                    this._doTheThing();
                }
            }
        },
        {
            key: "_doTheThing",
            value: function _doTheThing() {
                var _this = this;
                if (this._navigation && this._navigation.entries) {
                    var screenSize = this._style.screenSize;
                    var entries = this._navigation.entries;
                    var itemHeight = _sidenavItemstyle.HEIGHT[screenSize];
                    var contentGap = _sidenavstyle.CONTENT_GAP[screenSize];
                    var itemGap = _sidenavstyle.ITEM_GAP[screenSize];
                    this._itemsCount = entries.map(function(entry) {
                        return entry.length;
                    }).reduce(function(a, b) {
                        return a + b;
                    }, 0);
                    var groupCount = 0;
                    var gap = 0;
                    this.tag("Items").children = entries.flatMap(function(group) {
                        _this._setIndex(Math.min(Math.max(_this._index, 0), _this._itemsCount - 1));
                        _this._currentPaths = group.map(function(param) {
                            var entry = param.entry;
                            return (0, _sidenavutils.actionToPath)({
                                action: entry
                            });
                        });
                        _this._currentSections = group.map(function(param) {
                            var entry = param.entry;
                            return (0, _ctautils.getSectionCode)({
                                action: entry
                            });
                        });
                        var itemOffset = itemHeight + contentGap;
                        var itemsSize = itemOffset * _this._itemsCount - contentGap;
                        var offset = Math.round((_this.finalH - itemsSize) / 2);
                        var children = group.map(function(param, index) {
                            var entry = param.entry;
                            return {
                                type: _sidenavItemcomponent.default,
                                w: _sidenavconstants.WIDTH[screenSize],
                                y: offset + (index + groupCount) * itemOffset + gap,
                                ref: "SidenavItem".concat(index),
                                item: {
                                    label: entry.label,
                                    content: entry
                                },
                                actionPath: _this._currentPaths[index],
                                actionSection: _this._currentSections[index],
                                expanded: Boolean(_this._isFocused)
                            };
                        });
                        groupCount += group.length;
                        gap += itemGap;
                        return children;
                    });
                } else {
                    this.tag("Items").children = [];
                }
                this._updateSideNav();
            }
        },
        {
            key: "currentRoute",
            set: function set(value) {
                this._currentRoute = value;
                this._updateSideNav();
            }
        },
        {
            key: "isItemSelected",
            value: function isItemSelected(item) {
                if (item.actionSection !== this._section) {
                    return false;
                }
                if (item.actionPath === this._currentRoute) {
                    return true;
                }
                if (_sidenavconstants.DEFAULT_SERVICE && this._currentRoute === "app/service/".concat(_sidenavconstants.DEFAULT_SERVICE)) {
                    return item.actionPath === _routesutils.HOME_PATH;
                }
                return false;
            }
        },
        {
            key: "_updateSideNav",
            value: function _updateSideNav() {
                var _this = this;
                this.tag("Items").children.forEach(function(item, index) {
                    var isSelected = _this.isItemSelected(item);
                    item.isSelected = isSelected;
                    _this._index = isSelected ? index : _this._index;
                });
            }
        },
        {
            key: "_setIndex",
            value: function _setIndex() {
                var index = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._index;
                this._index = index;
            }
        },
        {
            key: "_focus",
            value: function _focus() {
                var screenSize = this._style.screenSize;
                var w = _sidenavconstants.EXPANDED_WIDTH[screenSize];
                this.setSmooth("w", w, _sidenavconstants.animationConfig);
                this._setIndex();
                this.tag("Items").children.forEach(function(child) {
                    child.expanded = true;
                });
                this.tag("Logo").setSmooth("alpha", 1);
                this.tag("Border").setSmooth("alpha", 1, {
                    delay: 0.15,
                    duration: 0.2
                });
                this.tag("Gradient").setSmooth("alpha", 1, _sidenavconstants.animationConfig);
                this.tag("MiniPlayer").open(w - _sidenavstyle.MINI_PLAYER_MARGIN[screenSize] * 2);
                this._isFocused = true;
            }
        },
        {
            key: "_unfocus",
            value: function _unfocus() {
                var _this = this;
                var screenSize = this._style.screenSize;
                var w = _sidenavconstants.WIDTH[screenSize];
                this.setSmooth("w", w, _sidenavconstants.animationConfig);
                this.tag("Items").children.forEach(function(child, index) {
                    child.expanded = false;
                    if (_this.isItemSelected(child)) {
                        _this._index = index;
                    }
                });
                this.tag("Logo").setSmooth("alpha", 0);
                this.tag("Border").setSmooth("alpha", 0, {
                    duration: 0.2
                });
                this.tag("Gradient").setSmooth("alpha", 0, _sidenavconstants.animationConfig);
                this.tag("MiniPlayer").close(w - _sidenavstyle.MINI_PLAYER_MARGIN[screenSize] * 2);
                this._isMiniPlayerFocused = false;
                this._isFocused = false;
            }
        },
        {
            key: "_getFocused",
            value: function _getFocused() {
                return this._isMiniPlayerFocused ? this.tag("MiniPlayer") : this.tag("Items").children[this._index];
            }
        },
        {
            key: "_handleEnter",
            value: function _handleEnter() {
                if (!this._navigation || !this._navigation.entries) {
                    return false;
                }
                var itemToAction = this._navigation.entries.flatMap(function(entry) {
                    return entry;
                })[this._index].entry;
                var itemType = (0, _get.default)(itemToAction, "target.type", "");
                _lightningjsredux.default.dispatch((0, _ctaactions.createItemAction)({
                    item: {
                        action: itemToAction
                    }
                }));
                if (itemType !== "lock") {
                    this._returnToPage();
                }
                return true;
            }
        },
        {
            key: "_handleUp",
            value: function _handleUp() {
                if (this._isMiniPlayerFocused) {
                    this._isMiniPlayerFocused = false;
                    return true;
                }
                if (this._index > 0) {
                    this._setIndex(this._index - 1);
                    return true;
                }
                return false;
            }
        },
        {
            key: "_handleDown",
            value: function _handleDown() {
                if (this._index < this._itemsCount - 1) {
                    this._setIndex(this._index + 1);
                    return true;
                }
                if (!this._isMiniPlayerFocused && this.tag("MiniPlayer").isActive) {
                    this._isMiniPlayerFocused = true;
                }
                return false;
            }
        },
        {
            key: "_hideMiniPlayer",
            value: function _hideMiniPlayer() {
                this._isMiniPlayerFocused = false;
                this._refocus();
            }
        },
        {
            key: "_handleRight",
            value: function _handleRight() {
                return false;
            }
        },
        {
            key: "_handleBack",
            value: function _handleBack() {
                this._returnToPage();
                return true;
            }
        },
        {
            key: "_returnToPage",
            value: function _returnToPage() {
                _sdk.Router.focusPage();
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    rect: true,
                    Gradient: {},
                    Items: {},
                    Border: {
                        rect: true
                    },
                    Logo: {
                        type: _sidenavLogocomponent.SidenavLogo
                    },
                    MiniPlayerWrapper: {
                        MiniPlayer: {
                            type: _miniPlayercomponent.MiniPlayer,
                            signals: _define_property._({}, _miniPlayerconstants.HIDE_SIGNAL, "_hideMiniPlayer")
                        }
                    }
                }, (0, _sidenavstyle.getInitialStyle)());
            }
        }
    ]);
    return Sidenav;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 53489:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(88801);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _routingselectors = __webpack_require__(2001);
var _layoutselectors = __webpack_require__(53368);
var _appselectors = __webpack_require__(65910);
var mapControllers = function(instance) {
    return [
        {
            selector: _layoutselectors.getNavigationSection,
            callback: function(value) {
                instance.section = value;
            }
        },
        {
            selector: _routingselectors.isNavigationAllowed,
            callback: function(value) {
                instance.isActive = value;
            }
        },
        {
            selector: _appselectors.isAppInitialized,
            callback: function(value) {
                instance.couldRequestNavigationLayout = value;
            }
        },
        {
            selector: _layoutselectors.getLayoutNavigation,
            callback: function(value) {
                instance.navigation = value;
            }
        },
        {
            selector: _routingselectors.getCurrentRoute,
            callback: function(value) {
                instance.currentRoute = value;
            }
        }
    ];
};
var _default = _lightningjsredux.default.control(mapControllers);


/***/ }),

/***/ 74842:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    EXPANDED_WIDTH: function() {
        return _constants.SIDENAV_EXPANDED_WIDTH;
    },
    WIDTH: function() {
        return _constants.SIDENAV_WIDTH;
    },
    animationConfig: function() {
        return animationConfig;
    },
    animationDurationInSeconds: function() {
        return animationDurationInSeconds;
    },
    default: function() {
        return _default;
    }
});
var _export_star = __webpack_require__(37668);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
_export_star._(__webpack_require__(44762), exports);
_export_star._(__webpack_require__(92882), exports);
var _constants = __webpack_require__(34952);
var animationDurationInSeconds = 0.3;
var animationConfig = {
    duration: 0.3
};
var _default = {
    animationDurationInSeconds: animationDurationInSeconds,
    animationConfig: animationConfig
};


/***/ }),

/***/ 53659:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    CONTENT_GAP: function() {
        return _sidenavconstants.CONTENT_GAP;
    },
    ITEM_GAP: function() {
        return ITEM_GAP;
    },
    KIDS_LOGO_WIDTH: function() {
        return KIDS_LOGO_WIDTH;
    },
    LOGO_MARGIN_BOTTOM: function() {
        return LOGO_MARGIN_BOTTOM;
    },
    MAIN_LOGO_HEIGHT: function() {
        return MAIN_LOGO_HEIGHT;
    },
    MINI_PLAYER_MARGIN: function() {
        return MINI_PLAYER_MARGIN;
    },
    PADDING_BOTTOM: function() {
        return PADDING_BOTTOM;
    },
    PADDING_LEFT: function() {
        return PADDING_LEFT;
    },
    PADDING_TOP: function() {
        return PADDING_TOP;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    getKidsIconViewBox: function() {
        return getKidsIconViewBox;
    },
    getMainIconViewBox: function() {
        return getMainIconViewBox;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(3009);
var _memoize = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34736));
var _theme = __webpack_require__(51397);
var _constants = __webpack_require__(34952);
var _sidenavconstants = __webpack_require__(74842);
var _style = __webpack_require__(65082);
var _sizes = __webpack_require__(82699);
var _brandIconconstants = __webpack_require__(17009);
var _miniPlayerstyle = __webpack_require__(84168);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var colors = {
    background: (0, _theme.makeThemeColor)(_theme.TERTIARY),
    border: (0, _theme.makeThemeColor)(_theme.PRIMARY, 0.3),
    overlay: (0, _theme.makeThemeColor)(_theme.TERTIARY),
    empty: (0, _theme.makeThemeColor)(_theme.TERTIARY, 0)
};
var _obj;
var MAIN_LOGO_HEIGHT = (_obj = {}, _define_property._(_obj, _constants.HD, 72), _define_property._(_obj, _constants.FULL_HD, 96), _obj);
var _obj1;
var KIDS_LOGO_WIDTH = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 216), _define_property._(_obj1, _constants.FULL_HD, 280), _obj1);
var getKidsIconViewBox = (0, _memoize.default)(function(screenSize) {
    return {
        w: KIDS_LOGO_WIDTH[screenSize],
        h: MAIN_LOGO_HEIGHT[screenSize]
    };
});
var getMainIconViewBox = (0, _memoize.default)(function(screenSize) {
    return {
        h: MAIN_LOGO_HEIGHT[screenSize],
        w: MAIN_LOGO_HEIGHT[screenSize] * _brandIconconstants.BRAND_ICON_WIDTH_RATIO
    };
});
var _obj2;
var LOGO_MARGIN_BOTTOM = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 56), _define_property._(_obj2, _constants.FULL_HD, 96), _obj2);
var _obj3;
var PADDING_TOP = (_obj3 = {}, _define_property._(_obj3, _constants.HD, 40), _define_property._(_obj3, _constants.FULL_HD, 56), _obj3);
var _obj4;
var ITEM_GAP = (_obj4 = {}, _define_property._(_obj4, _constants.HD, 24), _define_property._(_obj4, _constants.FULL_HD, 36), _obj4);
var _obj5;
var PADDING_BOTTOM = (_obj5 = {}, _define_property._(_obj5, _constants.HD, _constants.safetyMargins.vertical[_constants.HD]), _define_property._(_obj5, _constants.FULL_HD, _constants.safetyMargins.vertical[_constants.FULL_HD]), _obj5);
var _obj6;
var PADDING_LEFT = (_obj6 = {}, _define_property._(_obj6, _constants.HD, _constants.safetyMargins.horizontal[_constants.HD]), _define_property._(_obj6, _constants.FULL_HD, _constants.safetyMargins.horizontal[_constants.FULL_HD]), _obj6);
var _obj7;
var MINI_PLAYER_MARGIN = (_obj7 = {}, _define_property._(_obj7, _constants.HD, 16), _define_property._(_obj7, _constants.FULL_HD, 24), _obj7);
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var screenSize = context.screenSize, colorMode = context.colorMode;
    return {
        alpha: 0,
        color: colors.background[colorMode],
        w: _sidenavconstants.WIDTH[screenSize],
        h: _sizes.SCREEN_HEIGHT[screenSize],
        Gradient: {
            alpha: 0,
            x: _sidenavconstants.EXPANDED_WIDTH[screenSize] / 2,
            rect: true,
            w: _sizes.SCREEN_WIDTH[screenSize] - _sidenavconstants.EXPANDED_WIDTH[screenSize],
            h: _sizes.SCREEN_HEIGHT[screenSize],
            colorLeft: colors.overlay[colorMode],
            colorRight: colors.empty[colorMode]
        },
        Items: {
            w: _sidenavconstants.WIDTH[screenSize],
            h: _sizes.SCREEN_HEIGHT[screenSize]
        },
        Border: {
            x: _sidenavconstants.EXPANDED_WIDTH[screenSize] - 1,
            alpha: 0,
            w: 1,
            h: _sizes.SCREEN_HEIGHT[screenSize],
            color: colors.border[colorMode]
        },
        Logo: {
            alpha: 0,
            x: PADDING_LEFT[screenSize],
            y: PADDING_TOP[screenSize]
        },
        MiniPlayerWrapper: {
            mountY: 1,
            y: _sizes.SCREEN_HEIGHT[screenSize] - _constants.safetyMargins.vertical[screenSize],
            w: function(value) {
                return value - MINI_PLAYER_MARGIN[screenSize] * 2;
            },
            h: _miniPlayerstyle.HEIGHT[screenSize],
            MiniPlayer: {
                x: MINI_PLAYER_MARGIN[screenSize],
                w: _sizes.identity
            }
        }
    };
};


/***/ }),

/***/ 54463:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    actionToPath: function() {
        return actionToPath;
    },
    isSameNavigation: function() {
        return isSameNavigation;
    },
    isSameNavigationItem: function() {
        return isSameNavigationItem;
    }
});
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(88801);
var _ctautils = __webpack_require__(42533);
var _ctaconstants = /*#__PURE__*/ _interop_require_default._(__webpack_require__(77713));
var _routesutils = __webpack_require__(14948);
var actionToPath = function(item) {
    var type = (0, _ctautils.getItemActionType)(item);
    var targetData = (0, _ctautils.getTargetData)(item);
    var id = targetData.id;
    switch(type){
        case _ctaconstants.default.BOOKMARKS:
            return _routesutils.BOOKMARKS_PATH;
        case _ctaconstants.default.BOOKMARK:
            return "";
        case _ctaconstants.default.UNBOOKMARK:
            return "";
        case _ctaconstants.default.CLOSE:
            return _routesutils.HOME_PATH;
        case _ctaconstants.default.FOLDER:
            return "".concat(_routesutils.FOLDER_PATH, "/").concat(id);
        case _ctaconstants.default.FOLDERS:
            return _routesutils.FOLDERS_PATH;
        case _ctaconstants.default.FRONTSPACE:
            return "".concat(_routesutils.FRONTSPACE_PATH, "/").concat(id);
        case _ctaconstants.default.HOME_ALIAS:
            return _routesutils.HOME_PATH;
        case _ctaconstants.default.INFORMATION:
            return _routesutils.INFORMATION_PATH;
        case _ctaconstants.default.USAGE_TERMS:
            return _routesutils.USAGE_TERMS_PATH;
        case _ctaconstants.default.SUBSCRIPTION_TERMS:
            return _routesutils.SUBSCRIPTION_TERMS_PATH;
        case _ctaconstants.default.LEGAL_CONDITIONS:
            return _routesutils.LEGAL_CONDITIONS_PATH;
        case _ctaconstants.default.LIVE:
            return "";
        case _ctaconstants.default.LIVES:
            return _routesutils.LIVES_PATH;
        case _ctaconstants.default.LOCK:
            return "";
        case _ctaconstants.default.LOGOUT:
            return "";
        case _ctaconstants.default.OPTOUT:
            return _routesutils.SETTINGS_PATH;
        case _ctaconstants.default.PROFILE:
            return _routesutils.PROFILE_PATH;
        case _ctaconstants.default.PROGRAM:
            return _routesutils.PROGRAM_PATH;
        case _ctaconstants.default.SEARCH:
            return _routesutils.SEARCH_PATH;
        case _ctaconstants.default.SERVICE:
            return "".concat(_routesutils.SERVICE_PATH, "/").concat(id);
        case _ctaconstants.default.SERVICES:
            return _routesutils.SERVICES_PATH;
        case _ctaconstants.default.VIDEO:
            return _routesutils.VIDEO_PATH;
        case _ctaconstants.default.HELP:
            return "";
        default:
            break;
    }
    return "";
};
var isSameNavigationItem = function(a, b) {
    if (!a || !b || !a.entry || !b.entry) {
        return false;
    }
    if (a.entry.id !== b.entry.id) {
        return false;
    }
    if (a.entry.image) {
        if (!b.entry.image) {
            return false;
        }
        if (a.image.id !== b.image.id) {
            return false;
        }
    } else if (b.entry.image) {
        return false;
    }
    if (a.subentries) {
        if (!b.subentries) {
            return false;
        }
        if (a.subentries.length !== b.subentries.length) {
            return false;
        }
        for(var i = 0; i < a.subentries.length; i += 1){
            if (a.subentries[i].id !== b.subentries[i].id) {
                return false;
            }
        }
    } else if (b.subentries) {
        return false;
    }
    return true;
};
var isSameNavigation = function(a, b) {
    if (!a || !b || !a.entries || !b.entries) {
        return false;
    }
    if (a.entries.length !== b.entries.length) {
        return false;
    }
    for(var i = 0; i < a.entries.length; i += 1){
        if (!isSameNavigationItem(a.entries[i], b.entries[i])) {
            return false;
        }
    }
    return true;
};


/***/ }),

/***/ 11570:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return SidenavItem;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _create_super = __webpack_require__(6400);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(65759);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _sidenavconstants = __webpack_require__(74842);
var _sidenavIconcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(15703));
var _sidenavItemstyle = __webpack_require__(39524);
var _sidenavItemconstants = __webpack_require__(35085);
var SidenavItem = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(SidenavItem, _Lightning_Component);
    var _super = _create_super._(SidenavItem);
    function SidenavItem() {
        _class_call_check._(this, SidenavItem);
        return _super.apply(this, arguments);
    }
    _create_class._(SidenavItem, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _sidenavItemstyle.defaultContext;
                this._isSelected = false;
                this._actionPath = "";
            }
        },
        {
            key: "item",
            get: function get() {
                return this._item;
            },
            set: function set(value) {
                this._item = value;
                this.patch({
                    Label: {
                        text: {
                            text: value.content.label
                        }
                    },
                    SidenavIcon: {
                        content: value.content
                    }
                });
            }
        },
        {
            key: "actionPath",
            get: function get() {
                return this._actionPath;
            },
            set: function set(value) {
                this._actionPath = value;
            }
        },
        {
            key: "expanded",
            set: function set(value) {
                this.tag("Label").setSmooth("alpha", value ? 1 : 0, _sidenavconstants.animationConfig);
                this.tag("Indicator").x = (0, _sidenavItemstyle.getIndicatorPosition)(value, this._style.screenSize);
            }
        },
        {
            key: "colorMode",
            get: function get() {
                return this._style.colorMode;
            },
            set: function set(value) {
                this._style = _object_spread_props._(_object_spread._({}, this._style), {
                    colorMode: value
                });
                this._updateColorMode();
            }
        },
        {
            key: "isSelected",
            get: function get() {
                return this._isSelected;
            },
            set: function set(value) {
                if (this._isSelected === value) {
                    return;
                }
                this._isSelected = value;
                this._updateAlpha();
                this.tag("Indicator").alpha = _sidenavItemconstants.SHOW_INDICATOR ? value : 0;
            }
        },
        {
            key: "_updateColorMode",
            value: function _updateColorMode() {
                this.patch({
                    color: _sidenavItemstyle.colors.background[this.colorMode]
                });
                this.$enter();
            }
        },
        {
            key: "_updateAlpha",
            value: function _updateAlpha() {
                this.alpha = this.isSelected ? _sidenavItemstyle.ALPHA_ACTIVE : _sidenavItemstyle.ALPHA_INACTIVE;
                this.tag("SidenavIcon").isSelected = this.isSelected;
            }
        },
        {
            key: "_focus",
            value: function _focus() {
                this._setState("Focused");
                this.alpha = _sidenavItemstyle.ALPHA_ACTIVE;
            }
        },
        {
            key: "_unfocus",
            value: function _unfocus() {
                this._setState("Unfocused");
                this._updateAlpha();
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Background: {
                        rect: true
                    },
                    SidenavIcon: {
                        type: _sidenavIconcomponent.default
                    },
                    Indicator: {},
                    Label: {}
                }, (0, _sidenavItemstyle.getInitialStyle)());
            }
        },
        {
            key: "_states",
            value: function _states() {
                return [
                    /*#__PURE__*/ function(_this) {
                        _inherits._(Unfocused, _this);
                        var _super = _create_super._(Unfocused);
                        function Unfocused() {
                            _class_call_check._(this, Unfocused);
                            return _super.apply(this, arguments);
                        }
                        _create_class._(Unfocused, [
                            {
                                key: "$enter",
                                value: function $enter() {
                                    this.patch((0, _sidenavItemstyle.getStateStyles)(this._style).unfocused);
                                }
                            }
                        ]);
                        return Unfocused;
                    }(this),
                    /*#__PURE__*/ function(_this) {
                        _inherits._(Focused, _this);
                        var _super = _create_super._(Focused);
                        function Focused() {
                            _class_call_check._(this, Focused);
                            return _super.apply(this, arguments);
                        }
                        _create_class._(Focused, [
                            {
                                key: "$enter",
                                value: function $enter() {
                                    this.patch((0, _sidenavItemstyle.getStateStyles)(this._style).focused);
                                }
                            }
                        ]);
                        return Focused;
                    }(this)
                ];
            }
        }
    ]);
    return SidenavItem;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 39524:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ALPHA_ACTIVE: function() {
        return ALPHA_ACTIVE;
    },
    ALPHA_INACTIVE: function() {
        return ALPHA_INACTIVE;
    },
    HEIGHT: function() {
        return HEIGHT;
    },
    ICON_PADDING: function() {
        return ICON_PADDING;
    },
    INDICATOR_WIDTH: function() {
        return INDICATOR_WIDTH;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getIndicatorPosition: function() {
        return getIndicatorPosition;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    getStateStyles: function() {
        return getStateStyles;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(65759);
var _memoize = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34736));
var _constants = __webpack_require__(34952);
var _theme = __webpack_require__(51397);
var _typography = __webpack_require__(18411);
var _sidenavconstants = __webpack_require__(74842);
var _sizes = __webpack_require__(82699);
var _style = __webpack_require__(65082);
var _sidenavIconstyle = __webpack_require__(11155);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var colors = {
    background: (0, _theme.makeThemeColor)(_theme.PRIMARY),
    label: (0, _theme.makeThemeColor)(_theme.PRIMARY),
    focusedLabel: (0, _theme.makeThemeColor)(_theme.TERTIARY),
    indicator: (0, _theme.makeThemeColor)(_theme.SECONDARY)
};
var ALPHA_INACTIVE = 0.3;
var ALPHA_ACTIVE = 1;
var _obj;
var HEIGHT = (_obj = {}, _define_property._(_obj, _constants.HD, 48), _define_property._(_obj, _constants.FULL_HD, 72), _obj);
var _obj1;
var ICON_PADDING = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 16), _define_property._(_obj1, _constants.FULL_HD, 16), _obj1);
var _obj2;
var INDICATOR_WIDTH = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 4), _define_property._(_obj2, _constants.FULL_HD, 8), _obj2);
var getIndicatorPosition = function(value, screenSize) {
    return (value ? _sidenavconstants.EXPANDED_WIDTH[screenSize] : _sidenavconstants.WIDTH[screenSize]) - INDICATOR_WIDTH[screenSize];
};
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var screenSize = context.screenSize, colorMode = context.colorMode;
    var offset = _constants.safetyMargins.horizontal[screenSize];
    var font = (0, _typography.getFont)(_typography.FONT.OTTAWA_2, screenSize);
    return {
        h: HEIGHT[screenSize],
        alpha: ALPHA_INACTIVE,
        Background: {
            w: _sizes.identity,
            h: HEIGHT[screenSize],
            alpha: 0,
            color: colors.background[colorMode]
        },
        Indicator: {
            alpha: 0,
            rect: true,
            h: HEIGHT[screenSize],
            w: INDICATOR_WIDTH[screenSize],
            x: getIndicatorPosition(false, screenSize),
            color: colors.indicator[colorMode]
        },
        Label: {
            text: _object_spread_props._(_object_spread._({}, font), {
                verticalAlign: "middle"
            }),
            alpha: 0,
            x: offset + _sidenavIconstyle.ICON_SIZE.WIDTH[screenSize] + ICON_PADDING[screenSize],
            y: Math.round((HEIGHT[screenSize] - font.lineHeight) / 2)
        }
    };
};
var getStateStyles = (0, _memoize.default)(function(param) {
    var colorMode = param.colorMode, screenSize = param.screenSize;
    return {
        unfocused: {
            w: _sidenavconstants.WIDTH[screenSize],
            Background: {
                w: _sidenavconstants.WIDTH[screenSize],
                alpha: 0
            },
            SidenavIcon: {
                Icon: {
                    color: _sidenavIconstyle.colors.icon[colorMode]
                }
            },
            Label: {
                color: colors.label[colorMode]
            }
        },
        focused: {
            alpha: ALPHA_ACTIVE,
            w: _sidenavconstants.EXPANDED_WIDTH[screenSize],
            Background: {
                w: _sidenavconstants.EXPANDED_WIDTH[screenSize],
                alpha: 1
            },
            SidenavIcon: {
                Icon: {
                    color: _sidenavIconstyle.colors.focusedIcon[colorMode]
                }
            },
            Label: {
                color: colors.focusedLabel[colorMode]
            }
        }
    };
}, _style.cacheResolver);


/***/ }),

/***/ 61900:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "SidenavLogo", ({
    enumerable: true,
    get: function() {
        return SidenavLogo;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
var _sdk = __webpack_require__(29956);
var _iconcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(70160));
var _iconconstants = __webpack_require__(48112);
var _sizes = __webpack_require__(82699);
var _sidenavLogoconnect = /*#__PURE__*/ _interop_require_default._(__webpack_require__(57540));
var _sidenavLogoutils = __webpack_require__(39111);
var _sidenavLogoconstants = __webpack_require__(95241);
var SidenavLogo = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(SidenavLogo, _Lightning_Component);
    var _super = _create_super._(SidenavLogo);
    function SidenavLogo() {
        _class_call_check._(this, SidenavLogo);
        return _super.apply(this, arguments);
    }
    _create_class._(SidenavLogo, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = {
                    screenSize: (0, _sizes.getScreenSize)()
                };
            }
        },
        {
            key: "_attach",
            value: function _attach() {
                var _this = this;
                this._unsubscribe = (0, _sidenavLogoconnect.default)(this);
                this.tag("Icon").on("txLoaded", function() {
                    var icon = _this.tag("Icon");
                    _this.patch({
                        w: icon.finalW,
                        h: icon.finalH
                    });
                });
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                if (this._unsubscribe) {
                    this._unsubscribe();
                    this._unsubscribe = null;
                }
                clearTimeout(this._logoUpdateTimeout);
                this.tag("Icon").removeAllListeners("txLoaded");
            }
        },
        {
            key: "updateLogo",
            value: function updateLogo() {
                var _this = this;
                this._logoUpdateTimeout = setTimeout(function() {
                    _this.tag("Icon").iconData = {
                        picto: {
                            type: _iconconstants.ICON_TYPE.SERVICE_ICON,
                            name: "rtlplus_root_alternate_".concat(_sidenavLogoconstants.MIN_INDEX + Math.floor(Math.random() * _sidenavLogoconstants.MAX_INDEX))
                        },
                        scale: _sidenavLogoconstants.LOGO_ICON_SCALE,
                        viewBox: (0, _sidenavLogoutils.getLogoViewBox)(_this._style.screenSize)
                    };
                }, _sidenavLogoconstants.UPDATE_TIMEOUT_MS);
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return {
                    Icon: {
                        type: _iconcomponent.default
                    }
                };
            }
        }
    ]);
    return SidenavLogo;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 57540:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _routingselectors = __webpack_require__(2001);
var mapControllers = function(instance) {
    return [
        {
            selector: _routingselectors.getCurrentRoute,
            callback: function() {
                instance.updateLogo();
            }
        }
    ];
};
var _default = _lightningjsredux.default.control(mapControllers);


/***/ }),

/***/ 95241:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    MAX_INDEX: function() {
        return MAX_INDEX;
    },
    MIN_INDEX: function() {
        return MIN_INDEX;
    },
    UPDATE_TIMEOUT_MS: function() {
        return UPDATE_TIMEOUT_MS;
    }
});
var _export_star = __webpack_require__(37668);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
_export_star._(__webpack_require__(29178), exports);
var MIN_INDEX = 1;
var MAX_INDEX = 12;
var UPDATE_TIMEOUT_MS = 300;


/***/ }),

/***/ 40258:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _export_star = __webpack_require__(37668);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(42578);
_export_star._(__webpack_require__(61900), exports);


/***/ }),

/***/ 29178:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _export_star = __webpack_require__(37668);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(37815);
_export_star._(__webpack_require__(27314), exports);


/***/ }),

/***/ 39111:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "getLogoViewBox", ({
    enumerable: true,
    get: function() {
        return getLogoViewBox;
    }
}));
var _export_star = __webpack_require__(37668);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(3009);
var _sidenavstyle = __webpack_require__(53659);
_export_star._(__webpack_require__(31280), exports);
var getLogoViewBox = function(screenSize) {
    return (0, _sidenavstyle.getMainIconViewBox)(screenSize);
};


/***/ }),

/***/ 83347:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/* eslint-disable no-console */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "StaticPage", ({
    enumerable: true,
    get: function() {
        return StaticPage;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _create_super = __webpack_require__(6400);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(37815);
var _throttle = /*#__PURE__*/ _interop_require_default._(__webpack_require__(38209));
var _sdk = __webpack_require__(29956);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _config = __webpack_require__(67958);
var _staticPagestyle = __webpack_require__(37361);
var _apputils = __webpack_require__(60368);
var _staticFilesutils = __webpack_require__(23269);
var _staticFilesrenders = __webpack_require__(94947);
var _buttoncomponent = __webpack_require__(31464);
var _iconcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(70160));
var _brandIconcomponent = __webpack_require__(362);
var _i18n = __webpack_require__(14910);
var THROTTLE_MS = 100;
var StaticPage = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(StaticPage, _Lightning_Component);
    var _super = _create_super._(StaticPage);
    function StaticPage() {
        _class_call_check._(this, StaticPage);
        return _super.apply(this, arguments);
    }
    _create_class._(StaticPage, [
        {
            key: "_construct",
            value: function _construct() {
                this._index = 0;
                this._containerH = 0;
                this._focusedContent = false;
                this._lastElementTxLoaded = false;
                this._throttleUp = (0, _throttle.default)(this._navigateUp, THROTTLE_MS);
                this._throttleDown = (0, _throttle.default)(this._navigateDown, THROTTLE_MS);
            }
        },
        {
            key: "_active",
            value: function _active() {
                (0, _apputils.removeSplashScreen)();
            }
        },
        {
            key: "_inactive",
            value: function _inactive() {
                this._throttleUp.cancel();
                this._throttleDown.cancel();
            }
        },
        {
            key: "target",
            set: function set(pageName) {
                var _this = this;
                var content = this.tag("ScrollContent");
                var fileURL = [
                    _config.staticFiles.base,
                    _config.customerCode,
                    _config.staticFiles.files[pageName]
                ].join("/");
                (0, _staticFilesutils.parseFile)(fileURL).then(function(data) {
                    var textItems = (0, _staticFilesrenders.renderFile)((0, _staticFilesutils.filterNodes)(data), _object_spread_props._(_object_spread._({}, _this._config), {
                        wordWrap: _this.tag("ScrollWrapper").w
                    }));
                    content.children = textItems;
                    var lastElement = content.children[content.children.length - 1];
                    if (lastElement) {
                        lastElement.once("txLoaded", function() {
                            _this._lastElementTxLoaded = true;
                        });
                    }
                }, // eslint-disable-next-line no-unused-vars
                function(err) {
                // TODO Error handling here
                });
                this._updateFocus(true);
            }
        },
        {
            key: "viewPortHeight",
            get: function get() {
                return Math.round(this.tag("ScrollWrapper").finalH * _staticPagestyle.VIEWPORT_OFFSET_PERCENTAGE);
            }
        },
        {
            key: "_positions",
            get: function get() {
                if (this._isSinglePage()) return 1;
                return Math.ceil(this.tag("ScrollContent").finalH / this.viewPortHeight);
            }
        },
        {
            key: "_build",
            value: function _build() {
                var _this = this;
                this._config = _staticPagestyle.defaultContext;
                var content = this.tag("ScrollContent");
                content.onUpdate = function() {
                    var finalH = content.finalH;
                    if (finalH > 0) {
                        _this.setPositions();
                        _this._updateFocus(!_this._isSinglePage());
                    }
                };
            }
        },
        {
            key: "_updateFocus",
            value: function _updateFocus(value) {
                if (this._focusedContent !== value) {
                    this._focusedContent = value;
                    this._refocus();
                }
            }
        },
        {
            key: "_isSinglePage",
            value: function _isSinglePage() {
                var wrapperH = this.tag("ScrollWrapper").finalH;
                return wrapperH > this._containerH;
            }
        },
        {
            key: "_getFocused",
            value: function _getFocused() {
                if (this._focusedContent) {
                    return undefined;
                }
                var button = this.tag("BackButton");
                if (button && button.visible) {
                    return button;
                }
                return undefined;
            }
        },
        {
            key: "setPositions",
            value: function setPositions() {
                var contentH = this.tag("ScrollContent").finalH;
                if (this._positions > 0 && this._containerH === contentH) {
                    return;
                }
                this._containerH = contentH;
                this.setIndex();
            }
        },
        {
            key: "setIndex",
            value: function setIndex() {
                var index = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._index;
                this._index = index;
                var isLastPage = this.tag("ScrollContent").finalH - (this._index + 1) * this.viewPortHeight < this.viewPortHeight;
                var smooth = 0;
                if (isLastPage && this._lastElementTxLoaded) {
                    smooth = this.tag("ScrollContent").finalH - this.viewPortHeight;
                } else {
                    smooth = index ? this._index * this.viewPortHeight : 0;
                }
                this.patch({
                    ArrowUp: {
                        visible: this._index > 0
                    },
                    BrandIcon: {
                        visible: this._index === 0
                    },
                    ScrollWrapper: {
                        GradientTop: {
                            visible: this._index > 0
                        },
                        ScrollContent: {
                            smooth: {
                                y: -smooth
                            }
                        }
                    },
                    ArrowDown: {
                        visible: this._index < this._positions - 1 && !(isLastPage && this._lastElementTxLoaded)
                    }
                });
                this.stage.textureManager.gc();
            }
        },
        {
            key: "_navigateUp",
            value: function _navigateUp() {
                if (this._index > 0) {
                    this.setIndex(this._index - 1);
                    return true;
                }
                if (this._index === 0 && this._focusedContent) {
                    this._updateFocus(false);
                    return true;
                }
                return false;
            }
        },
        {
            key: "_handleUp",
            value: function _handleUp() {
                this._throttleUp();
            }
        },
        {
            key: "_navigateDown",
            value: function _navigateDown() {
                if (!this._focusedContent && !this._isSinglePage()) {
                    this._updateFocus(true);
                    return true;
                }
                if (this._index < this._positions - 1 && !this._isSinglePage()) {
                    this.setIndex(this._index + 1);
                    return true;
                }
                return false;
            }
        },
        {
            key: "_handleDown",
            value: function _handleDown() {
                this._throttleDown();
            }
        },
        {
            key: "_handleBack",
            value: function _handleBack() {
                _sdk.Router.back();
                return true;
            }
        },
        {
            key: "_handleEnter",
            value: function _handleEnter() {
                if (this._getFocused() === this.tag("BackButton")) {
                    _sdk.Router.back();
                    return true;
                }
                return false;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Background: {},
                    BackButton: {
                        type: _buttoncomponent.Button,
                        label: (0, _i18n.t)("global.back"),
                        visible: false
                    },
                    ArrowUp: {
                        type: _iconcomponent.default
                    },
                    BrandIcon: {
                        type: _brandIconcomponent.BrandIcon
                    },
                    ScrollWrapper: {
                        GradientTop: {},
                        ScrollContent: {},
                        GradientBottom: {}
                    },
                    ArrowDown: {
                        type: _iconcomponent.default
                    }
                }, (0, _staticPagestyle.getInitialStyle)());
            }
        }
    ]);
    return StaticPage;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 37361:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BRAND_ICON_SIZE: function() {
        return BRAND_ICON_SIZE;
    },
    VIEWPORT_OFFSET_PERCENTAGE: function() {
        return VIEWPORT_OFFSET_PERCENTAGE;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    gridPadding: function() {
        return gridPadding;
    }
});
var _define_property = __webpack_require__(21228);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(88801);
var _constants = __webpack_require__(34952);
var _theme = __webpack_require__(51397);
var _style = __webpack_require__(65082);
var _sizes = __webpack_require__(82699);
var _iconconstants = __webpack_require__(48112);
var _obj;
var BRAND_ICON_SIZE = (_obj = {}, _define_property._(_obj, _constants.HD, 64), _define_property._(_obj, _constants.FULL_HD, 72), _obj);
var _obj1;
var ARROW_PADDING_BOTTOM = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 24), _define_property._(_obj1, _constants.FULL_HD, 32), _obj1);
var _obj2;
var ARROW_SIZE = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 96), _define_property._(_obj2, _constants.FULL_HD, 128), _obj2);
var _obj3;
var CONTENT_SIDE_MARGIN = (_obj3 = {}, _define_property._(_obj3, _constants.HD, 300), _define_property._(_obj3, _constants.FULL_HD, 460), _obj3);
var _obj4;
var GRADIENT_HEIGHT = (_obj4 = {}, _define_property._(_obj4, _constants.HD, 20), _define_property._(_obj4, _constants.FULL_HD, 40), _obj4);
var VIEWPORT_OFFSET_PERCENTAGE = 0.95;
var defaultContext = (0, _style.makeDefaultStylingContext)();
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var screenSize = context.screenSize, colorMode = context.colorMode;
    var topY = _constants.safetyMargins.vertical[screenSize];
    var scrollWrapperY = topY + ARROW_SIZE[screenSize] + ARROW_PADDING_BOTTOM[screenSize];
    var scrollWrapperWidth = _sizes.SCREEN_WIDTH[screenSize] - CONTENT_SIDE_MARGIN[screenSize] * 2;
    var scrollWrapperHeight = _sizes.SCREEN_HEIGHT[screenSize] - _constants.safetyMargins.vertical[screenSize] - scrollWrapperY - ARROW_SIZE[screenSize];
    var colors = {
        background: (0, _theme.makeThemeColor)(_theme.TERTIARY),
        gradientFill: (0, _theme.makeThemeColor)(_theme.TERTIARY),
        transparent: (0, _theme.makeThemeColor)(_theme.TERTIARY, 0)
    };
    return {
        w: _sizes.SCREEN_WIDTH[screenSize],
        h: _sizes.SCREEN_HEIGHT[screenSize],
        Background: {
            rect: true,
            w: _sizes.SCREEN_WIDTH[screenSize],
            h: _sizes.SCREEN_HEIGHT[screenSize],
            color: colors.background[colorMode]
        },
        BackButton: {
            x: _constants.safetyMargins.horizontal[screenSize],
            y: topY
        },
        ArrowUp: {
            y: topY,
            mountX: 0.5,
            x: _sizes.middle,
            visible: false,
            iconData: {
                picto: {
                    name: "ArrowUp",
                    type: _iconconstants.ICON_TYPE.SIMPLE_ICON
                },
                viewBox: {
                    h: ARROW_SIZE[screenSize]
                }
            }
        },
        BrandIcon: {
            h: BRAND_ICON_SIZE[screenSize],
            y: topY,
            mountX: 0.5,
            x: _sizes.middle
        },
        ScrollWrapper: {
            zIndex: 1,
            mountX: 0.5,
            x: _sizes.middle,
            y: scrollWrapperY,
            w: scrollWrapperWidth,
            h: scrollWrapperHeight,
            color: colors.background[colorMode],
            rect: true,
            clipping: true,
            GradientTop: {
                w: scrollWrapperWidth,
                h: GRADIENT_HEIGHT[screenSize],
                zIndex: 2,
                rect: true,
                mountX: 0.5,
                x: _sizes.middle,
                colorUl: colors.gradientFill[colorMode],
                colorUr: colors.gradientFill[colorMode],
                colorBr: colors.transparent[colorMode],
                colorBl: colors.transparent[colorMode]
            },
            ScrollContent: {
                zIndex: 1,
                w: scrollWrapperWidth,
                flex: {
                    direction: "column"
                }
            },
            GradientBottom: {
                w: scrollWrapperWidth,
                h: GRADIENT_HEIGHT[screenSize],
                zIndex: 2,
                rect: true,
                mountX: 0.5,
                x: _sizes.middle,
                y: scrollWrapperHeight - GRADIENT_HEIGHT[screenSize],
                colorUr: colors.transparent[colorMode],
                colorUl: colors.transparent[colorMode],
                colorBl: colors.gradientFill[colorMode],
                colorBr: colors.gradientFill[colorMode]
            }
        },
        ArrowDown: {
            mountY: 1,
            y: _sizes.SCREEN_HEIGHT[screenSize] - _constants.safetyMargins.vertical[screenSize],
            mountX: 0.5,
            x: _sizes.middle,
            visible: false,
            iconData: {
                picto: {
                    name: "ArrowDown",
                    type: _iconconstants.ICON_TYPE.SIMPLE_ICON
                },
                viewBox: {
                    h: ARROW_SIZE[screenSize]
                }
            }
        }
    };
};
var gridPadding = {
    left: 224
};


/***/ }),

/***/ 50844:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "StaticPage", ({
    enumerable: true,
    get: function() {
        return _staticPagecomponent.StaticPage;
    }
}));
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(88801);
var _staticPagecomponent = __webpack_require__(83347);


/***/ }),

/***/ 99592:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "SubscriptionExpired", ({
    enumerable: true,
    get: function() {
        return _subscriptionExpiredcomponent.SubscriptionExpired;
    }
}));
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(37815);
var _subscriptionExpiredcomponent = __webpack_require__(514);


/***/ }),

/***/ 1540:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/* eslint-disable no-console */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "SubscriptionExpiredBase", ({
    enumerable: true,
    get: function() {
        return SubscriptionExpiredBase;
    }
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(65759);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _config = __webpack_require__(67958);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _i18n = __webpack_require__(14910);
var _pairingSelectorcomponent = __webpack_require__(62531);
var _desktopPairingcomponent = __webpack_require__(50206);
var _mobilePairingcomponent = __webpack_require__(90838);
var _popupContainerconstants = __webpack_require__(54258);
var _pairingactions = __webpack_require__(83887);
var _signals = __webpack_require__(2109);
var _routingactions = __webpack_require__(78235);
var _lockutils = __webpack_require__(78414);
var _brandIconcomponent = __webpack_require__(362);
var _routesutils = __webpack_require__(14948);
var _analyticsutils = __webpack_require__(2693);
var _layoutactions = __webpack_require__(8424);
var _apputils = __webpack_require__(60368);
var _ctaactions = __webpack_require__(32067);
var _subscriptionExpiredBasestyle = __webpack_require__(86361);
var _subscriptionExpiredBaseconnector = /*#__PURE__*/ _interop_require_default._(__webpack_require__(6659));
var SubscriptionExpiredBase = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(SubscriptionExpiredBase, _Lightning_Component);
    var _super = _create_super._(SubscriptionExpiredBase);
    function SubscriptionExpiredBase() {
        _class_call_check._(this, SubscriptionExpiredBase);
        return _super.apply(this, arguments);
    }
    _create_class._(SubscriptionExpiredBase, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _subscriptionExpiredBasestyle.defaultContext;
                this._focusedButton = 0;
                this._lock = null;
                this._views = [
                    "Mobile",
                    "Desktop"
                ];
            }
        },
        {
            key: "_build",
            value: function _build() {
                this.tag(this._views[0]).visible = true;
            }
        },
        {
            key: "_active",
            value: function _active() {
                this._unsubscribe = (0, _subscriptionExpiredBaseconnector.default)(this);
                this._isLoading = true;
                (0, _apputils.removeSplashScreen)();
                this._setState("Left");
            }
        },
        {
            key: "_inactive",
            value: function _inactive() {
                this._isLoading = false;
                this._lock = null;
                if (this._unsubscribe) {
                    this._unsubscribe();
                    this._unsubscribe = null;
                }
                if (this._popupHidingTimeout) {
                    clearTimeout(this._popupHidingTimeout);
                }
            }
        },
        {
            key: "_switchViews",
            value: function _switchViews(index) {
                var _this = this;
                if (index >= this._views.length) {
                    this._hideScreen();
                    return;
                }
                this._views.forEach(function(view, i) {
                    _this.tag(view).visible = i === index;
                });
            }
        },
        {
            key: "isPaired",
            set: function set(value) {
                this._isPaired = value;
            }
        },
        {
            key: "lock",
            set: function set(value) {
                this._lock = value;
            }
        },
        {
            key: "payload",
            set: function set(value) {
                this._payload = value;
            }
        },
        {
            key: "services",
            set: function set(value) {
                this._services = value;
            }
        },
        {
            key: "requiredFeatures",
            set: function set(value) {
                this._requiredFeatures = value;
            }
        },
        {
            key: "entityType",
            set: function set(value) {
                this._entityType = value;
            }
        },
        {
            key: "entityId",
            set: function set(value) {
                this._entityId = value;
            }
        },
        {
            key: "deviceBrand",
            set: function set(value) {
                this._deviceBrand = value;
            }
        },
        {
            key: "_getOriginalTarget",
            value: function _getOriginalTarget() {
                if (this._lock) {
                    var target = (0, _lockutils.getNestedOriginalTarget)(this._lock.originalTarget);
                    if (target) {
                        console.log("[Upsell] Setting deeplink location basing on lock: ".concat(target), this._lock);
                        return target;
                    }
                }
                if (this._entityType && this._entityId) {
                    var prefix = (0, _lockutils.getUnlockPathPrefix)(this._entityType);
                    var target1 = "".concat(prefix).concat(this._entityType, "/").concat(this._entityId);
                    console.log("[Upsell] Setting deeplink location basing on entity: ".concat(target1));
                    return target1;
                }
                return null;
            }
        },
        {
            key: "_handleUnlockAttempt",
            value: function _handleUnlockAttempt() {
                var _this = this;
                return _async_to_generator._(function() {
                    var target;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this._isPaired) {
                                    target = _this._getOriginalTarget();
                                    if (target) {
                                        _lightningjsredux.default.dispatch((0, _routingactions.setDeeplinkLocation)(target));
                                    }
                                    (0, _routesutils.navigateTo)(_routesutils.PAIRING_PATH);
                                    // The navigation is async though there is no promise, awaiting for a few milliseconds to be sure there will be
                                    // no flash of the content page behind the modal
                                    _this._popupHidingTimeout = setTimeout(function() {
                                        _this.signal(_popupContainerconstants.HIDE_POPUP_SIGNAL);
                                    }, 100);
                                    return [
                                        2
                                    ];
                                }
                                if (!(_this._payload || _this._entityType)) return [
                                    3,
                                    4
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    ,
                                    3,
                                    4
                                ]);
                                return [
                                    4,
                                    _lightningjsredux.default.dispatch((0, _pairingactions.fetchUserSubscription)())
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                // NOTE: in case the component became inactive, there is no reason to enter this phase
                                if (_this._isLoading) {
                                    _this._resolveLock();
                                }
                                return [
                                    7
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_resolveLock",
            value: function _resolveLock() {
                if (this._payload) {
                    _lightningjsredux.default.dispatch((0, _ctaactions.createItemAction)(this._payload));
                } else if (this._entityType && this._entityId) {
                    _lightningjsredux.default.dispatch((0, _layoutactions.fetchLayout)(this._entityType, this._entityId));
                }
                this.signal(_popupContainerconstants.HIDE_POPUP_SIGNAL);
            }
        },
        {
            key: "_hideScreen",
            value: function _hideScreen() {
                if (this._lock) {
                    this.signal(_popupContainerconstants.HIDE_POPUP_SIGNAL);
                    if ((0, _lockutils.isPlayerLocked)(this._entityType)) {
                        _sdk.Router.back();
                    }
                } else {
                    _sdk.Router.back();
                }
            }
        },
        {
            key: "_handleBack",
            value: function _handleBack() {
                (0, _analyticsutils.sendEvent)({
                    key: "pressTokenBackButton"
                });
                return false;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Background: {
                        rect: true
                    },
                    CustomerIcon: {
                        type: _brandIconcomponent.BrandIcon
                    },
                    Left: {
                        type: _pairingSelectorcomponent.PairingSelector,
                        buttons: [
                            {
                                label: (0, _i18n.t)("pairing.token.mobile.button"),
                                iconLeft: "QRCode",
                                iconRight: "ArrowRight"
                            },
                            {
                                label: (0, _i18n.t)("pairing.token.computer.button"),
                                iconLeft: "Laptop",
                                iconRight: "ArrowRight"
                            },
                            {
                                label: (0, _i18n.t)("pairing.subscribe.offer.back")
                            }
                        ],
                        labels: {
                            features: [
                                (0, _i18n.t)("pairing.subscribe.offers.offer1"),
                                (0, _i18n.t)("pairing.subscribe.offers.offer2"),
                                (0, _i18n.t)("pairing.subscribe.offers.offer3")
                            ],
                            title: (0, _i18n.t)("pairing.subscribe.offers.title")
                        },
                        signals: _define_property._({}, _signals.SELECTED_SIGNAL, "_switchViews")
                    },
                    Right: {
                        Mobile: {
                            type: _mobilePairingcomponent.MobilePairing,
                            labels: {
                                title: (0, _i18n.t)("pairing.subscribe.how"),
                                steps: "pairing.subscribe.mobile.steps.step",
                                stepsCount: 3
                            },
                            button: (0, _i18n.t)("pairing.subscribe.button"),
                            url: _config.pairing.subscriptionURL,
                            signals: _define_property._({}, _signals.SELECTED_SIGNAL, "_handleUnlockAttempt")
                        },
                        Desktop: {
                            type: _desktopPairingcomponent.DesktopPairing,
                            labels: {
                                title: (0, _i18n.t)("pairing.subscribe.how"),
                                steps: "pairing.subscribe.computer.steps.step",
                                stepsCount: 3
                            },
                            button: (0, _i18n.t)("pairing.subscribe.button"),
                            signals: _define_property._({}, _signals.SELECTED_SIGNAL, "_handleUnlockAttempt")
                        }
                    }
                }, (0, _subscriptionExpiredBasestyle.getInitialStyle)());
            }
        },
        {
            key: "_states",
            value: function _states() {
                return [
                    /*#__PURE__*/ function(_this) {
                        _inherits._(Left, _this);
                        var _super = _create_super._(Left);
                        function Left() {
                            _class_call_check._(this, Left);
                            return _super.apply(this, arguments);
                        }
                        _create_class._(Left, [
                            {
                                key: "_getFocused",
                                value: function _getFocused() {
                                    return this.tag("Left");
                                }
                            },
                            {
                                key: "_handleRight",
                                value: function _handleRight() {
                                    this._setState("Right");
                                    return true;
                                }
                            }
                        ]);
                        return Left;
                    }(this),
                    /*#__PURE__*/ function(_this) {
                        _inherits._(Right, _this);
                        var _super = _create_super._(Right);
                        function Right() {
                            _class_call_check._(this, Right);
                            return _super.apply(this, arguments);
                        }
                        _create_class._(Right, [
                            {
                                key: "_getFocused",
                                value: function _getFocused() {
                                    var _$_this = this;
                                    return this._views.map(function(id) {
                                        return _$_this.tag(id);
                                    }).find(function(view) {
                                        return view.visible;
                                    });
                                }
                            },
                            {
                                key: "_handleLeft",
                                value: function _handleLeft() {
                                    this._setState("Left");
                                    return true;
                                }
                            }
                        ]);
                        return Right;
                    }(this)
                ];
            }
        }
    ]);
    return SubscriptionExpiredBase;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 6659:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _userselectors = __webpack_require__(41845);
var _pairingselectors = __webpack_require__(59739);
var _layoutselectors = __webpack_require__(53368);
var _appselectors = __webpack_require__(65910);
var mapControllers = function(instance) {
    return [
        {
            shouldBeInvokedOnConnect: true,
            selector: _userselectors.getPairingUid,
            callback: function(value) {
                instance.isPaired = Boolean(value);
            }
        },
        {
            shouldBeInvokedOnConnect: true,
            selector: _pairingselectors.getPremiumServices,
            callback: function(value) {
                instance.services = value;
            }
        },
        {
            shouldBeInvokedOnConnect: true,
            selector: _layoutselectors.getRequestedEntityType,
            callback: function(value) {
                instance.entityType = value;
            }
        },
        {
            shouldBeInvokedOnConnect: true,
            selector: _layoutselectors.getRequestedEntityId,
            callback: function(value) {
                instance.entityId = value;
            }
        },
        {
            shouldBeInvokedOnConnect: true,
            selector: _appselectors.getDeviceBrand,
            callback: function(value) {
                instance.deviceBrand = value;
            }
        }
    ];
};
var _default = _lightningjsredux.default.control(mapControllers);


/***/ }),

/***/ 86361:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ICON_MARGIN_BOTTOM: function() {
        return ICON_MARGIN_BOTTOM;
    },
    ICON_MARGIN_TOP: function() {
        return ICON_MARGIN_TOP;
    },
    LEFT_WIDTH: function() {
        return _pairingSelectorstyle.WIDTH;
    },
    LOGO_HEIGHT: function() {
        return LOGO_HEIGHT;
    },
    SPACER: function() {
        return _pairingSelectorstyle.SPACER;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _object_spread = __webpack_require__(76247);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
var _theme = __webpack_require__(51397);
var _constants = __webpack_require__(34952);
var _style = __webpack_require__(65082);
var _sizes = __webpack_require__(82699);
var _pairingSelectorstyle = __webpack_require__(13106);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var colors = {
    background: (0, _theme.makeThemeColor)(_theme.TERTIARY),
    separator: (0, _theme.makeThemeColor)(_theme.PRIMARY, 0.3)
};
var _obj;
var LOGO_HEIGHT = (_obj = {}, _define_property._(_obj, _constants.HD, 96), _define_property._(_obj, _constants.FULL_HD, 152), _obj);
var ICON_MARGIN_TOP = _object_spread._({}, _constants.safetyMargins.vertical);
var _obj1;
var ICON_MARGIN_BOTTOM = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 24), _define_property._(_obj1, _constants.FULL_HD, 24), _obj1);
var getInitialStyle = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext, _ref_screenSize = _ref.screenSize, screenSize = _ref_screenSize === void 0 ? _constants.FULL_HD : _ref_screenSize, _ref_colorMode = _ref.colorMode, colorMode = _ref_colorMode === void 0 ? _theme.DEFAULT_MODE : _ref_colorMode;
    var top = ICON_MARGIN_TOP[screenSize] + LOGO_HEIGHT[screenSize] + ICON_MARGIN_BOTTOM[screenSize];
    var containerHeight = _sizes.SCREEN_HEIGHT[screenSize] - top - _constants.safetyMargins.vertical[screenSize];
    var rightWidth = _sizes.SCREEN_WIDTH[screenSize] - _constants.safetyMargins.horizontal[screenSize] * 2 - _pairingSelectorstyle.WIDTH[screenSize] - _pairingSelectorstyle.SPACER[screenSize];
    return {
        w: _sizes.SCREEN_WIDTH[screenSize],
        h: _sizes.SCREEN_HEIGHT[screenSize],
        Background: {
            w: _sizes.SCREEN_WIDTH[screenSize],
            h: _sizes.SCREEN_HEIGHT[screenSize],
            color: colors.background[colorMode]
        },
        CustomerIcon: {
            y: ICON_MARGIN_TOP[screenSize],
            mountX: 0.5,
            x: _sizes.middle,
            h: LOGO_HEIGHT[screenSize]
        },
        Left: {
            y: top,
            h: containerHeight
        },
        Right: {
            x: _constants.safetyMargins.horizontal[screenSize] + _pairingSelectorstyle.WIDTH[screenSize] + _pairingSelectorstyle.SPACER[screenSize],
            y: top,
            h: containerHeight,
            w: rightWidth,
            Mobile: {
                visible: false,
                h: containerHeight,
                w: rightWidth
            },
            Desktop: {
                visible: false,
                h: containerHeight,
                w: rightWidth
            }
        }
    };
};


/***/ }),

/***/ 514:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "SubscriptionExpired", ({
    enumerable: true,
    get: function() {
        return SubscriptionExpired;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(3009);
var _subscriptionExpiredBasecomponent = __webpack_require__(1540);
var SubscriptionExpired = /*#__PURE__*/ function(SubscriptionExpiredBase) {
    "use strict";
    _inherits._(SubscriptionExpired, SubscriptionExpiredBase);
    var _super = _create_super._(SubscriptionExpired);
    function SubscriptionExpired() {
        _class_call_check._(this, SubscriptionExpired);
        return _super.apply(this, arguments);
    }
    return SubscriptionExpired;
}(_subscriptionExpiredBasecomponent.SubscriptionExpiredBase);


/***/ }),

/***/ 52262:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "Upsell", ({
    enumerable: true,
    get: function() {
        return Upsell;
    }
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _get = __webpack_require__(60528);
var _get_prototype_of = __webpack_require__(35196);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _sliced_to_array = __webpack_require__(28966);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(42578);
var _get1 = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _config = __webpack_require__(67958);
var _analyticsutils = __webpack_require__(2693);
var _subscriptionExpiredBasecomponent = __webpack_require__(1540);
var _i18n = __webpack_require__(14910);
var _pairingutils = __webpack_require__(41765);
var _popupContainerconstants = __webpack_require__(54258);
var _notifications = __webpack_require__(93831);
var _signals = __webpack_require__(2109);
var _ctaactions = __webpack_require__(32067);
var _pairingSelectorcomponent = __webpack_require__(62531);
var _brandIconcomponent = __webpack_require__(362);
var _desktopPairingcomponent = __webpack_require__(50206);
var _mobilePairingcomponent = __webpack_require__(90838);
var _subscriptionExpiredBasestyle = __webpack_require__(86361);
var _pairingconstants = __webpack_require__(41367);
var _pairingutils1 = __webpack_require__(54264);
var Upsell = /*#__PURE__*/ function(SubscriptionExpiredBase) {
    "use strict";
    _inherits._(Upsell, SubscriptionExpiredBase);
    var _super = _create_super._(Upsell);
    function Upsell() {
        _class_call_check._(this, Upsell);
        return _super.apply(this, arguments);
    }
    _create_class._(Upsell, [
        {
            key: "_active",
            value: function _active() {
                _get._(_get_prototype_of._(Upsell.prototype), "_active", this).call(this);
                var url = (0, _pairingutils1.getPairingMethod)() === _pairingconstants.PAIRING_METHOD.SSI ? _config.pairing.ssiURL : _config.pairing.upsellURL;
                var QRCodeUrl = this._getUrlWithParams(url);
                (0, _analyticsutils.sendEvent)({
                    key: "upsellMessageViewed"
                });
                this.patch({
                    Right: {
                        Mobile: {
                            url: QRCodeUrl
                        },
                        Desktop: {
                            steps: [
                                (0, _i18n.t)("upsell.computer.step1", {
                                    url: url
                                }),
                                (0, _i18n.t)("upsell.computer.step2"),
                                (0, _i18n.t)("upsell.computer.step3")
                            ]
                        }
                    }
                });
            }
        },
        {
            key: "isPaired",
            set: function set(value) {
                this._isPaired = value;
                var key = value ? "pairedButton" : "unpairedButton";
                this.tag("Desktop").button = (0, _pairingutils.translate)("upsell.computer.".concat(key));
                this.tag("Mobile").button = (0, _pairingutils.translate)("upsell.mobile.".concat(key));
            }
        },
        {
            key: "_resolveLock",
            value: function _resolveLock() {
                var required = this._requiredFeatures && this._requiredFeatures.length ? this._requiredFeatures : [];
                var available = this._services && this._services.length ? this._services : [];
                var offersMatching = !required.length || (available.length ? this._services.some(function(service) {
                    return required.every(function(product) {
                        return service.products.includes(product);
                    });
                }) : false);
                if (offersMatching) {
                    _lightningjsredux.default.dispatch((0, _ctaactions.createItemAction)(this._payload));
                    this.signal(_popupContainerconstants.HIDE_POPUP_SIGNAL);
                } else {
                    this.fireAncestors("$".concat(_signals.NOTIFICATION_SIGNAL), (0, _notifications.makeNotification)(_notifications.NOTIFICATION_LEVEL.ERROR, (0, _i18n.t)("upsell.error")));
                }
            }
        },
        {
            key: "_getUrlWithParams",
            value: function _getUrlWithParams(url) {
                var unlockTarget = (0, _get1.default)(this._lock, "reasonAttributes.unlockTarget", {});
                if (!unlockTarget) return url;
                var additionalParams = (0, _get1.default)(unlockTarget, "value_".concat(unlockTarget.type, ".details.additionalParams"), {});
                if (!additionalParams || Object.keys(additionalParams).length === 0) return url;
                additionalParams.platformCode = _config.platformCode;
                additionalParams.PartnerContext = this._deviceBrand;
                var urlObj = new URL(url);
                Object.entries(additionalParams).forEach(function(param) {
                    var _param = _sliced_to_array._(param, 2), key = _param[0], value = _param[1];
                    urlObj.searchParams.append(key, value);
                });
                url = urlObj.toString();
                return url;
            }
        },
        {
            key: "_handleUnlockAttempt",
            value: function _handleUnlockAttempt() {
                var _this = this;
                var _this1 = this, _superprop_get__handleUnlockAttempt = function() {
                    return _get._(_get_prototype_of._(Upsell.prototype), "_handleUnlockAttempt", _this);
                };
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        (0, _analyticsutils.sendEvent)({
                            key: "upsellRegisterClick"
                        });
                        _superprop_get__handleUnlockAttempt().call(_this1);
                        return [
                            2
                        ];
                    });
                })();
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Background: {
                        rect: true
                    },
                    CustomerIcon: {
                        type: _brandIconcomponent.BrandIcon
                    },
                    Left: {
                        type: _pairingSelectorcomponent.PairingSelector,
                        buttons: [
                            {
                                label: (0, _i18n.t)("upsell.mobile.button"),
                                iconLeft: "QRCode",
                                iconRight: "ArrowRight"
                            },
                            {
                                label: (0, _i18n.t)("upsell.computer.button"),
                                iconLeft: "Laptop",
                                iconRight: "ArrowRight"
                            },
                            {
                                label: (0, _i18n.t)("global.back")
                            }
                        ],
                        labels: {
                            title: (0, _i18n.t)("upsell.title")
                        },
                        signals: _define_property._({}, _signals.SELECTED_SIGNAL, "_switchViews")
                    },
                    Right: {
                        Mobile: {
                            type: _mobilePairingcomponent.MobilePairing,
                            labels: {
                                title: (0, _i18n.t)("upsell.mobile.title"),
                                steps: "upsell.mobile.step",
                                stepsCount: 3
                            },
                            url: _config.pairing.upsellURL,
                            signals: _define_property._({}, _signals.SELECTED_SIGNAL, "_handleUnlockAttempt")
                        },
                        Desktop: {
                            type: _desktopPairingcomponent.DesktopPairing,
                            labels: {
                                title: (0, _i18n.t)("upsell.computer.title")
                            },
                            steps: [
                                (0, _i18n.t)("upsell.computer.step1", {
                                    url: _config.pairing.upsellURL
                                }),
                                (0, _i18n.t)("upsell.computer.step2"),
                                (0, _i18n.t)("upsell.computer.step3")
                            ],
                            signals: _define_property._({}, _signals.SELECTED_SIGNAL, "_handleUnlockAttempt")
                        }
                    }
                }, (0, _subscriptionExpiredBasestyle.getInitialStyle)());
            }
        }
    ]);
    return Upsell;
}(_subscriptionExpiredBasecomponent.SubscriptionExpiredBase);


/***/ }),

/***/ 7394:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "SubscriptionExpired", ({
    enumerable: true,
    get: function() {
        return _subscriptionExpiredcomponent.SubscriptionExpired;
    }
}));
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(52318);
var _subscriptionExpiredcomponent = __webpack_require__(99592);


/***/ }),

/***/ 58415:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "Subtitles", ({
    enumerable: true,
    get: function() {
        return Subtitles;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _object_without_properties = __webpack_require__(46537);
var _to_consumable_array = __webpack_require__(30005);
var _create_super = __webpack_require__(6400);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(65759);
var _sdk = __webpack_require__(29956);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _isEmpty = /*#__PURE__*/ _interop_require_default._(__webpack_require__(82691));
var _textDisplayerutils = __webpack_require__(57259);
var _textDisplayerconstants = __webpack_require__(77773);
var _subtitlesstyle = __webpack_require__(42148);
var _subtitlesconstants = __webpack_require__(10615);
var _subtitlesutils = __webpack_require__(54744);
var _subtitlesconnect = /*#__PURE__*/ _interop_require_default._(__webpack_require__(54851));
var Subtitles = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(Subtitles, _Lightning_Component);
    var _super = _create_super._(Subtitles);
    function Subtitles() {
        _class_call_check._(this, Subtitles);
        return _super.apply(this, arguments);
    }
    _create_class._(Subtitles, [
        {
            key: "_construct",
            value: function _construct() {
                this._screenSize = _subtitlesstyle.defaultContext.screenSize;
            }
        },
        {
            key: "_attach",
            value: function _attach() {
                this._unsubscribe = (0, _subtitlesconnect.default)(this);
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                if (this._unsubscribe) {
                    this._unsubscribe();
                    this._unsubscribe = null;
                }
            }
        },
        {
            key: "updateSubtitles",
            value: function updateSubtitles(payload) {
                var _this = this;
                if (!payload) {
                    return;
                }
                var action = payload.cuePointState, parent = _object_without_properties._(payload, [
                    "cuePointState"
                ]);
                if (action === _textDisplayerconstants.CUE_ACTION.REMOVED) {
                    if ((0, _isEmpty.default)(parent)) {
                        this._clearAllRegions();
                    } else {
                        this._removeItem(parent);
                    }
                    return;
                }
                // parse container cue
                this._parseCue(parent);
                // parse nested cues
                if (parent.version === _textDisplayerconstants.TEXT_RENDERER_V4) {
                    var parentBackgroundColor = (0, _subtitlesutils.parseColor)(parent.backgroundColor);
                    (parent.nestedCues || []).filter(function(cue) {
                        return Boolean(cue.payload);
                    }).forEach(function(child) {
                        _this._parseCue(_object_spread_props._(_object_spread._({}, child), {
                            backgroundColor: (0, _subtitlesutils.parseColor)(child.backgroundColor) || parentBackgroundColor || _subtitlesconstants.DEFAULT_BACKGROUND_COLOR,
                            region: parent.region
                        }));
                    });
                } else {
                    parent.nestedCues.forEach(function(nestedCue) {
                        _this._parseCue(nestedCue, true);
                    });
                }
            }
        },
        {
            // eslint-disable-next-line no-unused-vars
            key: "_parseCue",
            value: function _parseCue(cue) {
                // skip line break;
                if (this._isLineBreak(cue) || !(cue.payload && cue.payload.length)) {
                    return;
                }
                // display container cue
                var regionId = this._getRegionId(cue);
                // container dimensions support by region data
                if (cue.region && cue.region.id) {
                    this._applyRegionStyle(regionId, (0, _subtitlesutils.getDimensionsByRegion)(cue, this._screenSize));
                }
                // container dimensions support by size data
                if (cue.size) {
                    this._applyRegionStyle(regionId, (0, _subtitlesutils.getDimensionsBySize)(cue.size, cue.writingMode, this._screenSize));
                }
                this._addItem(cue);
            }
        },
        {
            key: "_getRegionById",
            value: function _getRegionById(regionId) {
                return this.tag("Regions.".concat(regionId));
            }
        },
        {
            key: "_applyRegionStyle",
            value: function _applyRegionStyle(regionId, style) {
                if (!this._getRegionById(regionId)) {
                    this.tag("Regions").patch(_define_property._({}, regionId, (0, _subtitlesstyle.getDefaultRegionStyle)(this._screenSize)));
                }
                this.tag("Regions").patch(_define_property._({}, regionId, style));
            }
        },
        {
            key: "_addItem",
            value: function _addItem(cue) {
                var regionId = this._getRegionId(cue);
                var region = this._getRegionById(regionId);
                var currentCues = region.children;
                var styledItem = (0, _merge.default)((0, _subtitlesstyle.getItemStyle)(), this._parseCueStyle(cue, region));
                region.children = _to_consumable_array._(currentCues).concat([
                    styledItem
                ]);
            }
        },
        {
            key: "_removeItem",
            value: function _removeItem(cue, regionId) {
                var _this = this;
                var parentRegionId = regionId || this._getRegionId(cue);
                var region = this._getRegionById(parentRegionId);
                if (cue.nestedCues) {
                    cue.nestedCues.forEach(function(nestedCue) {
                        return _this._removeItem(nestedCue, parentRegionId);
                    });
                }
                if (region) {
                    region.children = region.children.filter(function(child) {
                        return !(0, _textDisplayerutils.isEqualCuePoint)(child.metadata, cue);
                    });
                }
            }
        },
        {
            key: "_clearAllRegions",
            value: function _clearAllRegions() {
                this.tag("Regions").children = [];
            }
        },
        {
            key: "_isLineBreak",
            value: function _isLineBreak(cue) {
                return Boolean(cue.lineBreak || cue.spacer);
            }
        },
        {
            key: "_getRegionId",
            value: function _getRegionId(cue) {
                if (cue.region && cue.region.id) {
                    return "Region_".concat(cue.region.id);
                }
                return "Region_".concat(_subtitlesconstants.DEFAULT_REGION);
            }
        },
        {
            key: "_parseCueStyle",
            value: function _parseCueStyle(cue, region) {
                var text = {
                    text: cue.payload,
                    wordWrapWidth: region.finalW
                };
                var result = {
                    text: text,
                    metadata: cue,
                    flexItem: {
                        alignSelf: "center"
                    }
                };
                if (cue.backgroundColor) {
                    text.highlight = true;
                    text.highlightColor = Number.isFinite(cue.backgroundColor) ? cue.backgroundColor : (0, _subtitlesutils.parseColor)(cue.backgroundColor);
                }
                if (cue.color) {
                    text.textColor = (0, _subtitlesutils.parseColor)(cue.color);
                }
                if (cue.fontFamily) {
                    text.fontFace = cue.fontFamily;
                }
                if (cue.fontSize) {
                    // TODO: clarify how this value will look like to check if we parse it properly
                    text.fontSize = (0, _subtitlesutils.convertLengthValue)(text.fontSize, cue, this._screenSize);
                }
                if (cue.fontStyle) {
                    text.fontStyle = cue.fontStyle;
                }
                if (cue.lineHeight) {
                    text.lineHeight = cue.lineHeight;
                }
                // The position defines the indent of the text in the direction defined by the writing direction
                if (cue.position) {
                    if (cue.writingMode === _subtitlesconstants.writingMode.HORIZONTAL_TOP_TO_BOTTOM) {
                        text.paddingLeft = cue.position;
                    }
                }
                return result;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _subtitlesstyle.getInitialStyle)();
            }
        }
    ]);
    return Subtitles;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 54851:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(52318);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _playerselectors = __webpack_require__(83318);
var mapControllers = function(instance) {
    return {
        subtitleCuePoint: {
            selector: _playerselectors.getSubtitleCuePoint,
            shouldBeInvokedOnConnect: true,
            callback: function(value) {
                instance.updateSubtitles(value);
            }
        }
    };
};
var _default = _lightningjsredux.default.control(mapControllers);


/***/ }),

/***/ 10615:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DEFAULT_BACKGROUND_COLOR: function() {
        return DEFAULT_BACKGROUND_COLOR;
    },
    DEFAULT_CONTAINER_SCALE: function() {
        return DEFAULT_CONTAINER_SCALE;
    },
    DEFAULT_REGION: function() {
        return DEFAULT_REGION;
    },
    units: function() {
        return units;
    },
    writingMode: function() {
        return writingMode;
    }
});
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(65759);
var _theme = __webpack_require__(51397);
var DEFAULT_CONTAINER_SCALE = 0.8;
var units = {
    PX: 0,
    PERCENTAGE: 1,
    LINES: 2
};
var writingMode = {
    HORIZONTAL_TOP_TO_BOTTOM: "horizontal-tb",
    VERTICAL_LEFT_TO_RIGHT: "vertical-lr",
    VERTICAL_RIGHT_TO_LEFT: "vertical-rl"
};
var DEFAULT_REGION = "default";
var DEFAULT_BACKGROUND_COLOR = (0, _theme.hexToARGB)("#000000", 0);


/***/ }),

/***/ 42148:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    INNER_PADDING: function() {
        return INNER_PADDING;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getDefaultRegionStyle: function() {
        return getDefaultRegionStyle;
    },
    getFullContainerHeight: function() {
        return getFullContainerHeight;
    },
    getFullContainerWidth: function() {
        return getFullContainerWidth;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    getItemStyle: function() {
        return getItemStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(42578);
var _memoize = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34736));
var _typography = __webpack_require__(18411);
var _theme = __webpack_require__(51397);
var _constants = __webpack_require__(34952);
var _style = __webpack_require__(65082);
var _sizes = __webpack_require__(82699);
var _subtitlesconstants = __webpack_require__(10615);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var colors = {
    text: (0, _theme.makeThemeColor)(_theme.PRIMARY)
};
var getFullContainerWidth = function(screenSize) {
    return _sizes.SCREEN_WIDTH[screenSize];
};
var getFullContainerHeight = function(screenSize) {
    return _sizes.SCREEN_HEIGHT[screenSize];
};
var getInitialStyle = (0, _memoize.default)(function() {
    return {
        Regions: {}
    };
});
var _obj;
var INNER_PADDING = (_obj = {}, _define_property._(_obj, _constants.HD, 6), _define_property._(_obj, _constants.FULL_HD, 8), _obj);
var getDefaultRegionStyle = (0, _memoize.default)(function(screenSize) {
    var containerWidth = getFullContainerWidth(screenSize);
    var containerHeight = getFullContainerHeight(screenSize);
    return {
        w: containerWidth * _subtitlesconstants.DEFAULT_CONTAINER_SCALE,
        h: containerHeight * _subtitlesconstants.DEFAULT_CONTAINER_SCALE,
        x: (0, _sizes.getCenter)(containerWidth, containerWidth * _subtitlesconstants.DEFAULT_CONTAINER_SCALE),
        y: (0, _sizes.getCenter)(containerHeight, containerHeight * _subtitlesconstants.DEFAULT_CONTAINER_SCALE),
        flex: {
            direction: "column",
            // alignItems: 'center',
            justifyContent: "flex-end"
        }
    };
});
var getItemStyle = (0, _memoize.default)(function() {
    var screenSize = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext).screenSize;
    var font = (0, _typography.getFont)(_typography.FONT.OSLO_2, screenSize);
    var color = colors.text[_theme.DARK_MODE];
    var containerWidth = getFullContainerWidth(screenSize);
    var padding = INNER_PADDING[screenSize];
    return {
        text: _object_spread_props._(_object_spread._({}, font), {
            textColor: color,
            highlightPaddingLeft: padding,
            paddingLeft: padding,
            highlightPaddingRight: padding,
            paddingRight: padding,
            wordWrapWidth: containerWidth,
            textBaseline: "alphabetic",
            verticalAlign: "middle"
        })
    };
});


/***/ }),

/***/ 54744:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    convertLengthValue: function() {
        return convertLengthValue;
    },
    displayAlignToFlex: function() {
        return displayAlignToFlex;
    },
    getAbsoluteLengthInPixels: function() {
        return getAbsoluteLengthInPixels;
    },
    getDimensionsByRegion: function() {
        return getDimensionsByRegion;
    },
    getDimensionsBySize: function() {
        return getDimensionsBySize;
    },
    getLengthValueInfo: function() {
        return getLengthValueInfo;
    },
    parseColor: function() {
        return parseColor;
    },
    textAlignToFlex: function() {
        return textAlignToFlex;
    }
});
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
var _subtitlesconstants = __webpack_require__(10615);
var _subtitlesstyle = __webpack_require__(42148);
var displayAlignToFlex = function(displayAlign) {
    switch(displayAlign){
        case "before":
            return "flex-start";
        case "center":
            return "center";
        case "after":
            return "flex-end";
        default:
            return "flex-end";
    }
};
var textAlignToFlex = function(textAlign) {
    switch(textAlign){
        case "left":
        case "start":
            return "flex-start";
        case "right":
        case "end":
            return "flex-end";
        case "center":
            return "center";
        default:
            return "flex-start";
    }
};
var getDimensionsByRegion = function(cue, screenSize) {
    var region = cue.region;
    var supportableUnits = [
        _subtitlesconstants.units.PX,
        _subtitlesconstants.units.PERCENTAGE
    ];
    var containerWidth = (0, _subtitlesstyle.getFullContainerWidth)(screenSize);
    var containerHeight = (0, _subtitlesstyle.getFullContainerHeight)(screenSize);
    var usePercentage = region.widthUnits === _subtitlesconstants.units.PERCENTAGE;
    if (supportableUnits.includes(region.widthUnits) && supportableUnits.includes(region.heightUnits)) {
        return {
            w: usePercentage ? containerWidth * (region.width / 100) : region.width,
            h: usePercentage ? containerHeight * (region.height / 100) : region.height,
            x: Math.round(containerWidth * (region.viewportAnchorX / 100)),
            y: Math.round(containerHeight * (region.viewportAnchorY / 100)),
            flex: {
                justifyContent: displayAlignToFlex(cue.displayAlign)
            }
        };
    }
    return {};
};
var getDimensionsBySize = function(size, cueWritingMode, screenSize) {
    var containerWidth = (0, _subtitlesstyle.getFullContainerWidth)(screenSize);
    var containerHeight = (0, _subtitlesstyle.getFullContainerHeight)(screenSize);
    if (cueWritingMode === _subtitlesconstants.writingMode.HORIZONTAL_TOP_TO_BOTTOM) {
        return {
            w: containerWidth * (size / 100)
        };
    }
    return {
        h: containerHeight * (size / 100)
    };
};
var getLengthValueInfo = function(lengthValue) {
    // eslint-disable-next-line prefer-regex-literals
    var matches = new RegExp(/(\d*\.?\d+)([a-z]+|%+)/).exec(lengthValue);
    if (!matches) {
        return null;
    }
    return {
        value: Number(matches[1]),
        unit: matches[2]
    };
};
var getAbsoluteLengthInPixels = function(value, cue, containerHeight) {
    return containerHeight * value / cue.cellResolution.rows;
};
var convertLengthValue = function(lengthValue, cue, screenSize) {
    var lengthValueInfo = getLengthValueInfo(lengthValue);
    if (!lengthValueInfo) {
        return lengthValue;
    }
    var fullContainerHeight = (0, _subtitlesstyle.getFullContainerHeight)(screenSize);
    var unit = lengthValueInfo.unit, value = lengthValueInfo.value;
    switch(unit){
        case "%":
            return getAbsoluteLengthInPixels(value / 100, cue, fullContainerHeight);
        case "c":
            return getAbsoluteLengthInPixels(value, cue, fullContainerHeight);
        default:
            return lengthValue;
    }
};
var parseColor = function(hex) {
    var fallback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0x00000000;
    var result = parseInt(hex.length === 9 ? "0x".concat(hex.substring(7)).concat(hex.substring(1, 7)) : hex.replace("#", "0x"), 16);
    return Number.isFinite(result) ? result : fallback;
};


/***/ }),

/***/ 92561:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _create_super = __webpack_require__(6400);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(3009);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _AlertViewconstants = __webpack_require__(98585);
var _brandIconcomponent = __webpack_require__(362);
var _AlertViewstyle = __webpack_require__(22272);
var _buttoncomponent = __webpack_require__(31464);
var _signals = __webpack_require__(2109);
var _templates = __webpack_require__(88229);
/**
 * This Organism displays event, alert, or error messages.
 *
 * @version 1.7.1
 * @see https://zeroheight.com/726d5c282/v/latest/p/26a7c3-alertview--v171
 */ var AlertView = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(AlertView, _Lightning_Component);
    var _super = _create_super._(AlertView);
    function AlertView() {
        _class_call_check._(this, AlertView);
        return _super.apply(this, arguments);
    }
    _create_class._(AlertView, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _AlertViewstyle.defaultContext;
                this._contentPadding = 0;
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                this.tag("Background").removeAllListeners("txLoaded");
                this._item = undefined;
            }
        },
        {
            key: "item",
            set: function set(param) {
                var content = param.content, config = param.config;
                var _this = this;
                this.tag("Background").once("txLoaded", function() {
                    _this.tag("Background").setSmooth("alpha", 1);
                });
                this._item = content;
                var wordWrapWidth = (0, _AlertViewstyle.getWordWrapWidth)(this._style.screenSize);
                var textColor = _AlertViewstyle.colors.text[this._style.colorMode];
                this.patch(_object_spread_props._(_object_spread._({}, config), {
                    Background: {
                        alpha: 0.0001,
                        src: content.image ? content.image.src : ""
                    },
                    Container: {
                        Title: (0, _templates.makeTextPatch)(content.title || "", wordWrapWidth, textColor),
                        Description: (0, _templates.makeTextPatch)(content.description || "", wordWrapWidth, textColor),
                        Button: {
                            label: content.action && content.action.label || ""
                        },
                        ExtraDetails: (0, _templates.makeTextPatch)(content.extraDetails || "", wordWrapWidth, textColor)
                    }
                }));
                this.contentPadding = this._contentPadding;
            }
        },
        {
            key: "contentPadding",
            set: function set(value) {
                var offset = Number.isFinite(value) ? value : 0;
                this.patch({
                    Logo: {
                        x: function(v) {
                            return Math.round((v + offset) / 2);
                        }
                    },
                    Container: {
                        x: offset,
                        w: _AlertViewconstants.sizes[_AlertViewconstants.templates.AlertView][this._style.screenSize].w - offset
                    }
                });
                this._contentPadding = value;
            }
        },
        {
            key: "_handleEnter",
            value: function _handleEnter() {
                this.signal(_signals.SELECTED_SIGNAL, this._item);
                return true;
            }
        },
        {
            key: "_getFocused",
            value: function _getFocused() {
                return this.tag("Button");
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    rect: true,
                    Background: {},
                    Logo: {
                        type: _brandIconcomponent.BrandIcon
                    },
                    Container: {
                        Title: {},
                        Description: {},
                        Button: {
                            type: _buttoncomponent.Button
                        },
                        ExtraDetails: {}
                    }
                }, (0, _AlertViewstyle.getInitialStyle)());
            }
        }
    ]);
    return AlertView;
}(_sdk.Lightning.Component);
AlertView.Templates = _AlertViewconstants.templates;
AlertView.Sizes = _AlertViewconstants.sizes;
AlertView.ImageOptions = _AlertViewconstants.imageOptions;
var _default = AlertView;


/***/ }),

/***/ 98585:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    imageOptions: function() {
        return imageOptions;
    },
    sizes: function() {
        return sizes;
    },
    templates: function() {
        return templates;
    }
});
var _define_property = __webpack_require__(21228);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
var _constants = __webpack_require__(34952);
var templates = {
    AlertView: "AlertView"
};
var _obj;
var sizes = _define_property._({}, templates.AlertView, (_obj = {}, _define_property._(_obj, _constants.HD, {
    w: 1280,
    h: 720
}), _define_property._(_obj, _constants.FULL_HD, {
    w: 1920,
    h: 1080
}), _obj));
var _obj1;
var imageOptions = _define_property._({}, templates.AlertView, (_obj1 = {}, _define_property._(_obj1, _constants.HD, {
    width: 1280,
    height: 720
}), _define_property._(_obj1, _constants.FULL_HD, {
    width: 1920,
    height: 1080
}), _obj1));


/***/ }),

/***/ 22272:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    GAP: function() {
        return GAP;
    },
    LOGO_HEIGHT: function() {
        return LOGO_HEIGHT;
    },
    TEXT_GAP: function() {
        return TEXT_GAP;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    getWordWrapWidth: function() {
        return getWordWrapWidth;
    }
});
var _define_property = __webpack_require__(21228);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(65759);
var _constants = __webpack_require__(34952);
var _theme = __webpack_require__(51397);
var _typography = __webpack_require__(18411);
var _style = __webpack_require__(65082);
var _AlertViewconstants = __webpack_require__(98585);
var _sizes = __webpack_require__(82699);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var GAP = (_obj = {}, _define_property._(_obj, _constants.HD, 24), _define_property._(_obj, _constants.FULL_HD, 32), _obj);
var _obj1;
var TEXT_GAP = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 8), _define_property._(_obj1, _constants.FULL_HD, 16), _obj1);
var _obj2;
var LOGO_HEIGHT = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 40), _define_property._(_obj2, _constants.FULL_HD, 56), _obj2);
var getWordWrapWidth = function(screenSize) {
    return Math.round(_AlertViewconstants.sizes[_AlertViewconstants.templates.AlertView][screenSize].w * 0.75);
};
var colors = {
    text: (0, _theme.makeThemeColor)(_theme.PRIMARY),
    background: (0, _theme.makeThemeColor)(_theme.TERTIARY)
};
var getInitialStyle = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext, screenSize = _ref.screenSize, colorMode = _ref.colorMode;
    var _sizes_templates_AlertView_screenSize = _AlertViewconstants.sizes[_AlertViewconstants.templates.AlertView][screenSize], w = _sizes_templates_AlertView_screenSize.w, h = _sizes_templates_AlertView_screenSize.h;
    var textColor = colors.text[colorMode];
    var wordWrapWidth = getWordWrapWidth(screenSize);
    return {
        w: w,
        h: h,
        color: colors.background,
        Background: {
            w: w,
            h: h
        },
        Logo: {
            mountX: 0.5,
            x: _sizes.middle,
            y: _constants.safetyMargins.vertical[screenSize],
            h: LOGO_HEIGHT[screenSize]
        },
        Container: {
            w: w,
            h: h,
            flex: {
                direction: "column",
                alignItems: "center",
                justifyContent: "center"
            },
            Title: {
                text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT.KINSHASA_3)), {
                    textColor: textColor,
                    wordWrapWidth: wordWrapWidth,
                    textAlign: "center",
                    maxLines: 2
                }),
                flexItem: {
                    marginBottom: TEXT_GAP[screenSize]
                }
            },
            Description: {
                text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT.OTTAWA_1)), {
                    textColor: textColor,
                    wordWrapWidth: wordWrapWidth,
                    textAlign: "center",
                    maxLines: 5
                }),
                flexItem: {
                    marginBottom: TEXT_GAP[screenSize]
                }
            },
            Button: {
                flexItem: {
                    marginTop: GAP[screenSize],
                    marginBottom: GAP[screenSize]
                }
            },
            ExtraDetails: {
                text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT.OTTAWA_1)), {
                    textColor: textColor,
                    wordWrapWidth: wordWrapWidth,
                    textAlign: "center",
                    maxLines: 3
                })
            }
        }
    };
};


/***/ }),

/***/ 47094:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return Avatar;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _create_super = __webpack_require__(6400);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(52318);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _avatarstyle = __webpack_require__(98697);
var _avatarutils = __webpack_require__(93406);
var Avatar = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(Avatar, _Lightning_Component);
    var _super = _create_super._(Avatar);
    function Avatar() {
        _class_call_check._(this, Avatar);
        return _super.apply(this, arguments);
    }
    _create_class._(Avatar, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _avatarstyle.defaultContext;
            }
        },
        {
            key: "photoId",
            set: function set(imageId) {
                if (!imageId) {
                    return;
                }
                this.patch({
                    src: (0, _avatarutils.getProfilePhotoUrl)(_object_spread._({
                        imageId: imageId
                    }, (0, _avatarstyle.getImageSize)(this._style.screenSize)))
                });
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    rtt: true,
                    shader: {
                        type: _sdk.Lightning.shaders.RoundedRectangle
                    }
                }, (0, _avatarstyle.getInitialStyle)());
            }
        }
    ]);
    return Avatar;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 98697:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    defaultContext: function() {
        return defaultContext;
    },
    getImageRadius: function() {
        return getImageRadius;
    },
    getImageSize: function() {
        return getImageSize;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    imageSizes: function() {
        return imageSizes;
    }
});
var _define_property = __webpack_require__(21228);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(3009);
var _constants = __webpack_require__(34952);
var _style = __webpack_require__(65082);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var imageSizes = (_obj = {}, _define_property._(_obj, _constants.HD, {
    width: 48,
    height: 48
}), _define_property._(_obj, _constants.FULL_HD, {
    width: 56,
    height: 56
}), _obj);
var getImageRadius = function(screenSize) {
    return Math.round(imageSizes[screenSize].width / 2);
};
var getImageSize = function(screenSize) {
    return imageSizes[screenSize];
};
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    return {
        w: imageSizes[context.screenSize].width,
        h: imageSizes[context.screenSize].height,
        shader: {
            radius: getImageRadius(context.screenSize)
        }
    };
};


/***/ }),

/***/ 93406:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "getProfilePhotoUrl", ({
    enumerable: true,
    get: function() {
        return getProfilePhotoUrl;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(88801);
var _memoize = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34736));
var _constants = __webpack_require__(34952);
var _fidosdk = __webpack_require__(19804);
var _style = __webpack_require__(65082);
var getProfilePhotoUrl = (0, _memoize.default)(function(param) {
    var imageId = param.imageId, width = param.width, height = param.height;
    return _fidosdk.imageService.getUrl(imageId, width, height, {
        format: _constants.TRANSPARENT_IMAGE_FORMAT,
        fit: _constants.IMAGE_FIT_SCALE_CROP,
        quality: _constants.IMAGE_QUALITY
    });
}, _style.cacheResolver);


/***/ }),

/***/ 69289:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "Badge", ({
    enumerable: true,
    get: function() {
        return Badge;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(88801);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _iconcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(70160));
var _badgestyle = __webpack_require__(40228);
var Badge = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(Badge, _Lightning_Component);
    var _super = _create_super._(Badge);
    function Badge() {
        _class_call_check._(this, Badge);
        return _super.apply(this, arguments);
    }
    _create_class._(Badge, [
        {
            key: "_attach",
            value: function _attach() {
                var _this = this;
                this.tag("Icon").on("txLoaded", function() {
                    var icon = _this.tag("Icon");
                    _this.patch({
                        w: icon.finalW,
                        h: icon.finalH
                    });
                });
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                this.tag("Icon").removeAllListeners("txLoaded");
            }
        },
        {
            key: "iconData",
            set: function set(value) {
                this.tag("Icon").iconData = value;
                this.alpha = value ? 1 : 0;
            }
        },
        {
            key: "iconColor",
            get: function get() {
                return this.tag("Icon").color;
            },
            set: function set(value) {
                this.tag("Icon").color = value;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    rect: true,
                    shader: {
                        type: _sdk.Lightning.shaders.RoundedRectangle
                    },
                    Icon: {
                        type: _iconcomponent.default
                    }
                }, (0, _badgestyle.getInitialStyle)());
            }
        }
    ]);
    return Badge;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 40228:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BORDER_RADIUS: function() {
        return BORDER_RADIUS;
    },
    COLOR: function() {
        return COLOR;
    },
    ICON_COLOR: function() {
        return ICON_COLOR;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(3009);
var _theme = __webpack_require__(51397);
var _style = __webpack_require__(65082);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var COLOR = (0, _theme.makeThemeColor)(_theme.SECONDARY);
var ICON_COLOR = (0, _theme.makeThemeColor)(_theme.TERTIARY);
var BORDER_RADIUS = 4;
var getInitialStyle = function() {
    var colorMode = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext).colorMode;
    return {
        color: COLOR[colorMode],
        iconColor: ICON_COLOR[colorMode],
        shader: {
            radius: BORDER_RADIUS
        }
    };
};


/***/ }),

/***/ 4441:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return Banner;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(37815);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _sdk = __webpack_require__(29956);
var _focusshader = /*#__PURE__*/ _interop_require_default._(__webpack_require__(25906));
var _imageshader = /*#__PURE__*/ _interop_require_default._(__webpack_require__(17154));
var _signals = __webpack_require__(2109);
var _bannerstyle = __webpack_require__(84164);
var _bannerconstants = __webpack_require__(36631);
var Banner = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(Banner, _Lightning_Component);
    var _super = _create_super._(Banner);
    function Banner() {
        _class_call_check._(this, Banner);
        return _super.apply(this, arguments);
    }
    _create_class._(Banner, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _bannerstyle.defaultContext;
            }
        },
        {
            key: "_inactive",
            value: function _inactive() {
                this.signal(_signals.INACTIVE_SIGNAL, this);
            }
        },
        {
            key: "_attach",
            value: function _attach() {
                var _this = this;
                this.tag("Image").on("txLoaded", function() {
                    _this.tag("Image").setSmooth("alpha", 1);
                });
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                this.tag("Image").removeAllListeners("txLoaded");
                this._item = undefined;
                this.signal(_signals.DETACHED_SIGNAL, this);
            }
        },
        {
            key: "item",
            get: function get() {
                return this._item;
            },
            set: function set(param) {
                var content = param.content, config = param.config, template = param.template, colorScheme = param.colorScheme;
                var screenSize = this._style.screenSize;
                var templateDataAccessPath = [
                    template,
                    this._style.screenSize
                ];
                if (this._item && this._item.id === content.id) {
                    this._item = content;
                    return;
                }
                this._item = content;
                this._config = config || (0, _get.default)(_bannerconstants.sizes, templateDataAccessPath, {});
                this._style = {
                    screenSize: screenSize,
                    colorMode: colorScheme
                };
                var _this__item = this._item, description = _this__item.description, title = _this__item.title, image = _this__item.image, logo = _this__item.logo;
                var imageUrl = image && image.src || "";
                var logoUrl = logo && logo.src || "";
                var wordWrapWidth = this._config.w - _bannerstyle.PADDING * 2;
                this.patch({
                    w: this._config.w,
                    h: this._config.h,
                    Image: {
                        src: imageUrl,
                        alpha: 0.0001
                    },
                    Content: {
                        Description: {
                            text: {
                                text: description || "",
                                visible: Boolean(description),
                                wordWrapWidth: wordWrapWidth
                            }
                        },
                        Title: {
                            text: {
                                text: title || "",
                                visible: Boolean(title),
                                wordWrapWidth: wordWrapWidth
                            }
                        },
                        Logo: {
                            src: logoUrl,
                            visible: Boolean(logoUrl)
                        }
                    }
                });
            }
        },
        {
            key: "_focus",
            value: function _focus() {
                this.patch((0, _bannerstyle.getFocusedStyle)(this._style));
            }
        },
        {
            key: "_unfocus",
            value: function _unfocus() {
                this.patch(_bannerstyle.unFocusedStyle);
            }
        },
        {
            key: "_handleEnter",
            value: function _handleEnter() {
                this.signal(_signals.SELECTED_SIGNAL, this._item);
                return true;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Border: {
                        rect: true,
                        shader: {
                            type: _focusshader.default
                        }
                    },
                    Image: {
                        shader: {
                            type: _imageshader.default
                        }
                    },
                    Content: {
                        Description: {
                            text: {}
                        },
                        Title: {
                            text: {}
                        },
                        Logo: {}
                    }
                }, (0, _bannerstyle.getInitialStyle)());
            }
        }
    ]);
    return Banner;
}(_sdk.Lightning.Component);
Banner.Templates = _bannerconstants.templates;
Banner.Sizes = _bannerconstants.sizes;
Banner.ImageOptions = _bannerconstants.imageOptions;


/***/ }),

/***/ 36631:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    imageOptions: function() {
        return imageOptions;
    },
    sizes: function() {
        return sizes;
    },
    templates: function() {
        return templates;
    }
});
var _define_property = __webpack_require__(21228);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(37815);
var _constants = __webpack_require__(34952);
var templates = {
    Banner: "Banner"
};
var _obj;
var sizes = _define_property._({}, templates.Banner, (_obj = {}, _define_property._(_obj, _constants.HD, {
    w: 1024,
    h: 341
}), _define_property._(_obj, _constants.FULL_HD, {
    w: 1560,
    h: 520
}), _obj));
var _obj1;
var imageOptions = _define_property._({}, templates.Banner, (_obj1 = {}, _define_property._(_obj1, _constants.HD, {
    PRIMARY: {
        width: 1024,
        height: 341
    },
    LOGO: {
        width: 123,
        height: 69,
        fit: _constants.IMAGE_FIT_MAX
    }
}), _define_property._(_obj1, _constants.FULL_HD, {
    PRIMARY: {
        width: 1560,
        height: 520
    },
    LOGO: {
        width: 176,
        height: 99,
        fit: _constants.IMAGE_FIT_MAX
    }
}), _obj1));


/***/ }),

/***/ 84164:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ICON_HEIGHT: function() {
        return ICON_HEIGHT;
    },
    LOCK_ICON_HEIGHT: function() {
        return LOCK_ICON_HEIGHT;
    },
    LOGO_MARGIN_BOTTOM: function() {
        return LOGO_MARGIN_BOTTOM;
    },
    PADDING: function() {
        return PADDING;
    },
    SCALE_FOCUSED: function() {
        return SCALE_FOCUSED;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getFocusedStyle: function() {
        return getFocusedStyle;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    unFocusedStyle: function() {
        return unFocusedStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(37815);
var _constants = __webpack_require__(34952);
var _memoize = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34736));
var _theme = __webpack_require__(51397);
var _typography = __webpack_require__(18411);
var _colors = __webpack_require__(8426);
var _style = __webpack_require__(65082);
var _bannerconstants = __webpack_require__(36631);
var _focus = __webpack_require__(78506);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var SCALE_FOCUSED = 1.02;
var PADDING = 24;
var LOGO_MARGIN_BOTTOM = 8;
var _obj;
var ICON_HEIGHT = (_obj = {}, _define_property._(_obj, _constants.HD, 24), _define_property._(_obj, _constants.FULL_HD, 32), _obj);
var _obj1;
var LOCK_ICON_HEIGHT = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 32), _define_property._(_obj1, _constants.FULL_HD, 40), _obj1);
var colors = {
    border: (0, _theme.makeThemeColor)(_theme.PRIMARY),
    overlay: (0, _theme.makeThemeColor)(_theme.TERTIARY)
};
var getInitialStyle = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext, screenSize = _ref.screenSize, colorMode = _ref.colorMode;
    var _sizes_templates_Banner_screenSize = _bannerconstants.sizes[_bannerconstants.templates.Banner][screenSize], w = _sizes_templates_Banner_screenSize.w, h = _sizes_templates_Banner_screenSize.h;
    var borderSize = _focus.BORDER_WIDTH[screenSize];
    var borderOffset = borderSize * 2;
    return {
        zIndex: _style.UNFOCUSED_Z_INDEX,
        w: w,
        h: h,
        Border: {
            w: w + borderOffset,
            h: h + borderOffset,
            x: -borderSize,
            y: -borderSize,
            color: _colors.TRANSPARENT,
            shader: {
                radius: _focus.BORDER_RADIUS[screenSize],
                outline: _focus.BORDER_WIDTH[screenSize],
                strokeColor: _colors.TRANSPARENT,
                innerColor: _colors.TRANSPARENT
            }
        },
        Image: {
            w: w,
            h: h,
            shader: {
                radius: _focus.BORDER_RADIUS[screenSize],
                overlayColor: colors.overlay[colorMode]
            }
        },
        Content: {
            flex: {
                direction: "column-reverse"
            },
            w: w - PADDING * 2,
            h: h - PADDING * 2,
            x: PADDING,
            y: PADDING,
            Description: {
                text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT.OTTAWA_1)), {
                    maxLines: 3,
                    textOverflow: "..."
                })
            },
            Title: {
                text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT.KINSHASA_3)), {
                    maxLines: 2,
                    textOverflow: "..."
                })
            },
            Logo: {
                flexItem: {
                    marginBottom: LOGO_MARGIN_BOTTOM
                }
            }
        }
    };
};
var getFocusedStyle = (0, _memoize.default)(function(param) {
    var colorMode = param.colorMode;
    return {
        zIndex: _style.FOCUSED_Z_INDEX,
        Border: {
            smooth: {
                scale: SCALE_FOCUSED,
                "shader.strokeColor": _focus.BORDER_COLOR[colorMode],
                "shader.innerColor": _focus.INNER_BORDER_COLOR[colorMode],
                "shader.scale": SCALE_FOCUSED
            }
        },
        Image: {
            smooth: {
                scale: SCALE_FOCUSED,
                "shader.scale": SCALE_FOCUSED
            }
        }
    };
}, _style.cacheResolver);
var unFocusedStyle = {
    zIndex: _style.UNFOCUSED_Z_INDEX,
    Border: {
        smooth: {
            scale: 1,
            "shader.strokeColor": _colors.TRANSPARENT,
            "shader.innerColor": _colors.TRANSPARENT,
            "shader.scale": 1.0
        }
    },
    Image: {
        smooth: {
            scale: 1,
            "shader.scale": 1.0
        }
    }
};


/***/ }),

/***/ 65167:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "BigButton", ({
    enumerable: true,
    get: function() {
        return BigButton;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _create_super = __webpack_require__(6400);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(45538);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _iconcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(70160));
var _sizes = __webpack_require__(82699);
var _bigButtonstyle = __webpack_require__(47516);
var _buttonBackgroundcomponent = __webpack_require__(32866);
var BigButton = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(BigButton, _Lightning_Component);
    var _super = _create_super._(BigButton);
    function BigButton() {
        _class_call_check._(this, BigButton);
        return _super.apply(this, arguments);
    }
    _create_class._(BigButton, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _bigButtonstyle.defaultContext;
                this._isLeftIconTxLoading = false;
                this._isRightIconTxLoading = false;
                this._isLabelTxLoading = false;
                this._minWidth = 0;
                this._isFocused = false;
                this._isSelected = false;
            }
        },
        {
            key: "_init",
            value: function _init() {
                var _this = this;
                var label = this.tag("Label");
                var leftIcon = this.tag("IconLeft");
                var rightIcon = this.tag("IconRight");
                var screenSize = (0, _sizes.getScreenSize)();
                var iconWidth = _bigButtonstyle.ICON_WIDTH[screenSize];
                var gap = _bigButtonstyle.GAP[screenSize];
                var padding = _bigButtonstyle.PADDING[screenSize];
                var handleUpdate = function() {
                    if (_this._isLeftIconTxLoading || _this._isLabelTxLoading || _this._isRightIconTxLoading) {
                        return;
                    }
                    var leftIconWidth = leftIcon.finalW ? gap + iconWidth : 0;
                    var rightIconWidth = rightIcon.finalW ? gap + iconWidth : 0;
                    var textWidth = _this.finalW - (padding * 2 + leftIconWidth + rightIconWidth);
                    _this.patch({
                        IconLeft: {
                            x: padding
                        },
                        IconRight: {
                            x: _this.finalW - padding
                        },
                        Label: {
                            text: {
                                wordWrapWidth: textWidth
                            }
                        }
                    });
                };
                leftIcon.on("txLoaded", function() {
                    _this._isLeftIconTxLoading = false;
                    handleUpdate();
                });
                rightIcon.on("txLoaded", function() {
                    _this._isRightIconTxLoading = false;
                    handleUpdate();
                });
                label.on("txLoaded", function() {
                    _this._isLabelTxLoading = false;
                    handleUpdate();
                });
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                this.tag("Label").removeAllListeners("txLoaded");
                this.tag("IconLeft").removeAllListeners("txLoaded");
                this.tag("IconRight").removeAllListeners("txLoaded");
            }
        },
        {
            key: "label",
            set: function set(value) {
                this.tag("Label").text.text = value;
                this._isLabelTxLoading = true;
            }
        },
        {
            key: "pictoLeft",
            set: function set(value) {
                this._isLeftIconTxLoading = true;
                var screenSize = (0, _sizes.getScreenSize)();
                this.tag("IconLeft").iconData = {
                    picto: value,
                    viewBox: {
                        w: _bigButtonstyle.ICON_WIDTH[screenSize],
                        h: _bigButtonstyle.ICON_HEIGHT[screenSize]
                    }
                };
            }
        },
        {
            key: "pictoRight",
            set: function set(value) {
                this._isRightIconTxLoading = true;
                var screenSize = (0, _sizes.getScreenSize)();
                this.tag("IconRight").iconData = {
                    picto: value,
                    viewBox: {
                        w: _bigButtonstyle.ICON_WIDTH[screenSize],
                        h: _bigButtonstyle.ICON_HEIGHT[screenSize]
                    }
                };
            }
        },
        {
            key: "colorMode",
            get: function get() {
                return this._style.colorMode;
            },
            set: function set(value) {
                this._style = _object_spread_props._(_object_spread._({}, this._style), {
                    colorMode: value
                });
                this.patch((0, _bigButtonstyle.getInitialStyle)(this._style));
            }
        },
        {
            key: "isSelected",
            get: function get() {
                return this._isSelected;
            },
            set: function set(value) {
                this._isSelected = value;
                this._updateStyle();
            }
        },
        {
            key: "_updateStyle",
            value: function _updateStyle() {
                this.patch(this._isFocused ? (0, _bigButtonstyle.getFocusedStyle)(_object_spread_props._(_object_spread._({}, this._style), {
                    selected: this._isSelected
                })) : (0, _bigButtonstyle.getUnFocusedStyle)(_object_spread_props._(_object_spread._({}, this._style), {
                    selected: this._isSelected
                })));
            }
        },
        {
            key: "_focus",
            value: function _focus() {
                this._isFocused = true;
                this._updateStyle();
            }
        },
        {
            key: "_unfocus",
            value: function _unfocus() {
                this._isFocused = false;
                this._updateStyle();
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Background: {
                        type: _buttonBackgroundcomponent.ButtonBackground,
                        w: _sizes.identity
                    },
                    Fill: {},
                    IconLeft: {
                        type: _iconcomponent.default
                    },
                    IconRight: {
                        type: _iconcomponent.default
                    },
                    Label: {}
                }, (0, _bigButtonstyle.getInitialStyle)());
            }
        }
    ]);
    return BigButton;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 47516:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _export_star = __webpack_require__(37668);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(52318);
_export_star._(__webpack_require__(98958), exports);


/***/ }),

/***/ 81857:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BORDER_RADIUS: function() {
        return BORDER_RADIUS;
    },
    FILL_FOCUSED_COLOR: function() {
        return FILL_FOCUSED_COLOR;
    },
    FILL_SELECTED_COLOR: function() {
        return FILL_SELECTED_COLOR;
    },
    FILL_UNFOCUSED_COLOR: function() {
        return FILL_UNFOCUSED_COLOR;
    },
    SCALE_FOCUSED: function() {
        return SCALE_FOCUSED;
    },
    STROKE_FOCUSED: function() {
        return STROKE_FOCUSED;
    },
    STROKE_FOCUSED_COLOR: function() {
        return STROKE_FOCUSED_COLOR;
    },
    STROKE_UNFOCUSED: function() {
        return STROKE_UNFOCUSED;
    },
    STROKE_UNFOCUSED_COLOR: function() {
        return STROKE_UNFOCUSED_COLOR;
    },
    TEXT_FOCUSED_COLOR: function() {
        return TEXT_FOCUSED_COLOR;
    },
    TEXT_SELECTED_COLOR: function() {
        return TEXT_SELECTED_COLOR;
    },
    TEXT_UNFOCUSED_COLOR: function() {
        return TEXT_UNFOCUSED_COLOR;
    }
});
var _define_property = __webpack_require__(21228);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(45538);
var _constants = __webpack_require__(34952);
var _theme = __webpack_require__(51397);
var _obj;
var BORDER_RADIUS = (_obj = {}, _define_property._(_obj, _constants.HD, 4), _define_property._(_obj, _constants.FULL_HD, 4), _obj);
var _obj1;
var STROKE_UNFOCUSED = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 2), _define_property._(_obj1, _constants.FULL_HD, 3), _obj1);
var _obj2;
var STROKE_FOCUSED = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 2), _define_property._(_obj2, _constants.FULL_HD, 3), _obj2);
var STROKE_UNFOCUSED_COLOR = (0, _theme.makeThemeColor)(_theme.PRIMARY, 1.0);
var STROKE_FOCUSED_COLOR = (0, _theme.makeThemeColor)(_theme.PRIMARY, 1.0);
var FILL_UNFOCUSED_COLOR = (0, _theme.makeThemeColor)(_theme.TERTIARY);
var FILL_SELECTED_COLOR = (0, _theme.makeThemeColor)(_theme.PRIMARY, 0.6);
var FILL_FOCUSED_COLOR = (0, _theme.makeThemeColor)(_theme.PRIMARY);
var TEXT_UNFOCUSED_COLOR = (0, _theme.makeThemeColor)(_theme.PRIMARY);
var TEXT_SELECTED_COLOR = (0, _theme.makeThemeColor)(_theme.TERTIARY);
var TEXT_FOCUSED_COLOR = (0, _theme.makeThemeColor)(_theme.TERTIARY);
var SCALE_FOCUSED = 1.05;


/***/ }),

/***/ 98958:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    GAP: function() {
        return GAP;
    },
    HEIGHT: function() {
        return HEIGHT;
    },
    ICON_HEIGHT: function() {
        return ICON_HEIGHT;
    },
    ICON_WIDTH: function() {
        return ICON_WIDTH;
    },
    PADDING: function() {
        return PADDING;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getFocusedStyle: function() {
        return getFocusedStyle;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    getUnFocusedStyle: function() {
        return getUnFocusedStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(65759);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _constants = __webpack_require__(34952);
var _typography = __webpack_require__(18411);
var _colors = __webpack_require__(8426);
var _style = __webpack_require__(65082);
var _sizes = __webpack_require__(82699);
var _buttonconstants = __webpack_require__(81857);
var _buttonutils = __webpack_require__(84065);
var _buttonTexturecomponent = __webpack_require__(9978);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var HEIGHT = (_obj = {}, _define_property._(_obj, _constants.HD, 72), _define_property._(_obj, _constants.FULL_HD, 96), _obj);
var _obj1;
var PADDING = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 40), _define_property._(_obj1, _constants.FULL_HD, 48), _obj1);
var _obj2;
var ICON_WIDTH = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 24), _define_property._(_obj2, _constants.FULL_HD, 40), _obj2);
var _obj3;
var ICON_HEIGHT = (_obj3 = {}, _define_property._(_obj3, _constants.HD, 24), _define_property._(_obj3, _constants.FULL_HD, 40), _obj3);
var _obj4;
var GAP = (_obj4 = {}, _define_property._(_obj4, _constants.HD, 8), _define_property._(_obj4, _constants.FULL_HD, 16), _obj4);
var getUnFocusedStyle = function(param) {
    var screenSize = param.screenSize, colorMode = param.colorMode, selected = param.selected;
    return {
        Background: {
            borderWidth: (0, _buttonutils.getStrokeWidth)(_buttonconstants.STROKE_UNFOCUSED[screenSize]),
            type: _buttonTexturecomponent.ButtonTexture,
            smooth: {
                color: selected ? _buttonconstants.FILL_SELECTED_COLOR[colorMode] : _buttonconstants.FILL_UNFOCUSED_COLOR[colorMode],
                borderColor: selected ? _colors.TRANSPARENT : _buttonconstants.STROKE_UNFOCUSED_COLOR[colorMode],
                scale: 1.0
            }
        },
        IconLeft: {
            smooth: {
                color: selected ? _buttonconstants.TEXT_SELECTED_COLOR[colorMode] : _buttonconstants.TEXT_UNFOCUSED_COLOR[colorMode]
            }
        },
        IconRight: {
            smooth: {
                color: selected ? _buttonconstants.TEXT_SELECTED_COLOR[colorMode] : _buttonconstants.TEXT_UNFOCUSED_COLOR[colorMode]
            }
        },
        Label: {
            smooth: {
                color: selected ? _buttonconstants.TEXT_SELECTED_COLOR[colorMode] : _buttonconstants.TEXT_UNFOCUSED_COLOR[colorMode]
            }
        }
    };
};
var getFocusedStyle = function(param) {
    var screenSize = param.screenSize, colorMode = param.colorMode;
    return {
        Background: {
            borderWidth: (0, _buttonutils.getStrokeWidth)(_buttonconstants.STROKE_FOCUSED[screenSize]),
            smooth: {
                borderColor: _buttonconstants.STROKE_FOCUSED_COLOR[colorMode],
                color: _buttonconstants.FILL_FOCUSED_COLOR[colorMode],
                scale: _buttonconstants.SCALE_FOCUSED
            }
        },
        IconLeft: {
            smooth: {
                color: _buttonconstants.TEXT_FOCUSED_COLOR[colorMode]
            }
        },
        IconRight: {
            smooth: {
                color: _buttonconstants.TEXT_FOCUSED_COLOR[colorMode]
            }
        },
        Label: {
            smooth: {
                color: _buttonconstants.TEXT_FOCUSED_COLOR[colorMode]
            }
        }
    };
};
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var screenSize = context.screenSize, colorMode = context.colorMode;
    var h = HEIGHT[screenSize];
    var font = (0, _typography.getFont)(_typography.FONT.OTTAWA_3, screenSize);
    return (0, _merge.default)({
        h: h,
        Background: {
            h: h,
            color: _buttonconstants.FILL_UNFOCUSED_COLOR[colorMode],
            borderRadius: _buttonconstants.BORDER_RADIUS[screenSize]
        },
        IconLeft: {
            y: Math.round((h - ICON_HEIGHT[screenSize]) / 2)
        },
        IconRight: {
            mountX: 1,
            y: Math.round((h - ICON_HEIGHT[screenSize]) / 2)
        },
        Label: {
            mountX: 0.5,
            x: _sizes.middle,
            y: Math.round((h - font.lineHeight) / 2),
            text: _object_spread_props._(_object_spread._({}, font), {
                maxLines: 1,
                verticalAlign: "middle",
                textAlign: "center"
            })
        }
    }, getUnFocusedStyle(context));
};


/***/ }),

/***/ 84931:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return BigSquare;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(65759);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _bigSquareconstants = __webpack_require__(83278);
var _progresscomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(45926));
var _progressutils = __webpack_require__(40779);
var _textures = __webpack_require__(67179);
var _signals = __webpack_require__(2109);
var _bigSquarestyle = __webpack_require__(2448);
var _iconcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(70160));
var _focusshader = /*#__PURE__*/ _interop_require_default._(__webpack_require__(25906));
var _templates = __webpack_require__(88229);
var BigSquare = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(BigSquare, _Lightning_Component);
    var _super = _create_super._(BigSquare);
    function BigSquare() {
        _class_call_check._(this, BigSquare);
        return _super.apply(this, arguments);
    }
    _create_class._(BigSquare, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _bigSquarestyle.defaultContext;
            }
        },
        {
            key: "_inactive",
            value: function _inactive() {
                this.signal(_signals.INACTIVE_SIGNAL, this);
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                this.signal(_signals.DETACHED_SIGNAL, this);
            }
        },
        {
            key: "item",
            get: function get() {
                return this._item;
            },
            set: function set(param) {
                var content = param.content, colorScheme = param.colorScheme;
                var progress = (0, _progressutils.getProgress)(content.progress);
                if ((0, _templates.areContentItemsEqual)(this._item, content)) {
                    this._item = content;
                    this.patch({
                        ContentContainer: {
                            Progress: {
                                progress: progress
                            }
                        }
                    });
                    return;
                }
                this._item = content;
                var screenSize = this._style.screenSize;
                var _this__item = this._item, image = _this__item.image, title = _this__item.title, extraTitle = _this__item.extraTitle, csaPicto = _this__item.csaPicto;
                var imageUrl = image && image.src || "";
                if (colorScheme && colorScheme !== this._style.colorMode) {
                    this._style = {
                        screenSize: screenSize,
                        colorMode: colorScheme
                    };
                }
                this.patch({
                    ContentContainer: {
                        Logo: {
                            visible: true,
                            texture: (0, _textures.contain)(imageUrl, _bigSquarestyle.IMAGE_SIZE, _bigSquarestyle.IMAGE_SIZE)
                        },
                        Progress: {
                            progress: progress,
                            colorMode: this._style.colorMode
                        },
                        TitleIconBox: {
                            Icon: {
                                visible: Boolean(csaPicto),
                                iconData: {
                                    picto: csaPicto,
                                    viewBox: (0, _bigSquarestyle.getIconViewBox)(screenSize)
                                }
                            },
                            Title: {
                                visible: Boolean(title),
                                text: {
                                    text: title
                                },
                                x: (0, _bigSquarestyle.getActualTitleLeftOffset)(Boolean(csaPicto)),
                                color: _bigSquarestyle.colors.text[this._style.colorMode]
                            }
                        },
                        ExtraTitle: {
                            visible: Boolean(extraTitle),
                            text: {
                                text: extraTitle
                            },
                            color: _bigSquarestyle.colors.text[this._style.colorMode]
                        }
                    }
                });
            }
        },
        {
            key: "_focus",
            value: function _focus() {
                this.patch((0, _bigSquarestyle.getFocusedStyle)(this._style));
            }
        },
        {
            key: "_unfocus",
            value: function _unfocus() {
                this.patch(_bigSquarestyle.unFocusedStyle);
            }
        },
        {
            key: "_handleEnter",
            value: function _handleEnter() {
                this.signal(_signals.SELECTED_SIGNAL, this._item);
                return true;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Border: {
                        rect: true,
                        shader: {
                            type: _focusshader.default,
                            useImageMask: true
                        }
                    },
                    Background: {
                        rect: true,
                        shader: {
                            type: _sdk.Lightning.shaders.RoundedRectangle
                        }
                    },
                    ContentContainer: {
                        Logo: {},
                        Progress: {
                            type: _progresscomponent.default
                        },
                        TitleIconBox: {
                            Icon: {
                                type: _iconcomponent.default
                            },
                            Title: {}
                        },
                        ExtraTitle: {}
                    }
                }, (0, _bigSquarestyle.getInitialStyle)());
            }
        }
    ]);
    return BigSquare;
}(_sdk.Lightning.Component);
BigSquare.Templates = _bigSquareconstants.templates;
BigSquare.Sizes = _bigSquareconstants.sizes;
BigSquare.ImageOptions = _bigSquareconstants.imageOptions;


/***/ }),

/***/ 83278:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ITEMS_BY_BREAKPOINTS: function() {
        return _bigSquareconstants.ITEMS_BY_BREAKPOINTS;
    },
    imageOptions: function() {
        return imageOptions;
    },
    sizes: function() {
        return sizes;
    },
    templates: function() {
        return templates;
    }
});
var _define_property = __webpack_require__(21228);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(37815);
var _constants = __webpack_require__(34952);
var _sizes = __webpack_require__(82699);
var _bigSquareconstants = __webpack_require__(81468);
var templates = {
    BigSquare: "BigSquare"
};
var _obj;
var imageOptions = _define_property._({}, templates.BigSquare, (_obj = {}, _define_property._(_obj, _constants.HD, {
    PRIMARY: {
        width: 80,
        height: 80
    }
}), _define_property._(_obj, _constants.FULL_HD, {
    PRIMARY: {
        width: 96,
        height: 96
    }
}), _obj));
var _obj1;
var heights = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 189), _define_property._(_obj1, _constants.FULL_HD, 224), _obj1);
var _getElementSize = (0, _sizes.getElementSize)(_bigSquareconstants.ITEMS_BY_BREAKPOINTS, 1.0, templates.BigSquare), _sizes1 = _getElementSize.sizes;
var sizes = [
    _constants.FULL_HD,
    _constants.HD
].reduce(function(acc, size) {
    acc[templates.BigSquare][size] = {
        w: _sizes1[templates.BigSquare][size].w,
        h: heights[size]
    };
    return acc;
}, _define_property._({}, templates.BigSquare, {}));


/***/ }),

/***/ 2448:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    CONTENT_PADDING: function() {
        return CONTENT_PADDING;
    },
    EXTRA_TITLE_MARGIN_TOP: function() {
        return EXTRA_TITLE_MARGIN_TOP;
    },
    ICON_SIZE: function() {
        return ICON_SIZE;
    },
    IMAGE_SIZE: function() {
        return IMAGE_SIZE;
    },
    PROGRESS_HEIGHT: function() {
        return PROGRESS_HEIGHT;
    },
    PROGRESS_MARGIN_VERTICAL: function() {
        return PROGRESS_MARGIN_VERTICAL;
    },
    TITLE_ICON_BOX_HEIGHT: function() {
        return TITLE_ICON_BOX_HEIGHT;
    },
    TITLE_MARGIN_LEFT: function() {
        return TITLE_MARGIN_LEFT;
    },
    borderWidth: function() {
        return borderWidth;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getActualTitleLeftOffset: function() {
        return getActualTitleLeftOffset;
    },
    getContainerSize: function() {
        return getContainerSize;
    },
    getExtraTitleTopOffset: function() {
        return getExtraTitleTopOffset;
    },
    getFocusedStyle: function() {
        return getFocusedStyle;
    },
    getIconViewBox: function() {
        return getIconViewBox;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    getProgressTopOffset: function() {
        return getProgressTopOffset;
    },
    getTitleIconBoxTopOffset: function() {
        return getTitleIconBoxTopOffset;
    },
    getTitleWrapWidth: function() {
        return getTitleWrapWidth;
    },
    screenSize: function() {
        return screenSize;
    },
    unFocusedStyle: function() {
        return unFocusedStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(52318);
var _constants = __webpack_require__(34952);
var _theme = __webpack_require__(51397);
var _memoize = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34736));
var _typography = __webpack_require__(18411);
var _sizes = __webpack_require__(82699);
var _style = __webpack_require__(65082);
var _focus = __webpack_require__(78506);
var _colors = __webpack_require__(8426);
var _bigSquareconstants = __webpack_require__(83278);
var screenSize = (0, _sizes.getScreenSize)();
var defaultContext = (0, _style.makeDefaultStylingContext)();
var colors = {
    background: (0, _theme.makeThemeColor)(_theme.PRIMARY, 0.1),
    text: (0, _theme.makeThemeColor)(_theme.PRIMARY)
};
var _obj;
var borderWidth = (_obj = {}, _define_property._(_obj, _constants.HD, 2), _define_property._(_obj, _constants.FULL_HD, 4), _obj);
var _obj1;
var ICON_SIZE = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 16), _define_property._(_obj1, _constants.FULL_HD, 24), _obj1);
var _obj2;
var CONTENT_PADDING = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 12), _define_property._(_obj2, _constants.FULL_HD, 16), _obj2);
var _obj3;
var IMAGE_SIZE = (_obj3 = {}, _define_property._(_obj3, _constants.HD, 80), _define_property._(_obj3, _constants.FULL_HD, 96), _obj3);
var _obj4;
var TITLE_ICON_BOX_HEIGHT = (_obj4 = {}, _define_property._(_obj4, _constants.HD, 24), _define_property._(_obj4, _constants.FULL_HD, 30), _obj4);
var PROGRESS_MARGIN_VERTICAL = 16;
var TITLE_MARGIN_LEFT = 4;
var EXTRA_TITLE_MARGIN_TOP = 4;
var PROGRESS_HEIGHT = 4;
var getIconViewBox = (0, _memoize.default)(function(screenSize) {
    return {
        w: ICON_SIZE[screenSize],
        h: ICON_SIZE[screenSize]
    };
});
var getContainerSize = (0, _memoize.default)(function(screenSize) {
    return {
        w: _bigSquareconstants.sizes[_bigSquareconstants.templates.BigSquare][screenSize].w - CONTENT_PADDING[screenSize] * 2,
        h: _bigSquareconstants.sizes[_bigSquareconstants.templates.BigSquare][screenSize].h - CONTENT_PADDING[screenSize] * 2
    };
});
var getActualTitleLeftOffset = function(isIconVisible) {
    return isIconVisible ? TITLE_MARGIN_LEFT + ICON_SIZE[screenSize] : 0;
};
var getTitleWrapWidth = (0, _memoize.default)(function(screenSize) {
    return getContainerSize(screenSize).w - getIconViewBox(screenSize).w - TITLE_MARGIN_LEFT;
});
var getProgressTopOffset = (0, _memoize.default)(function(screenSize) {
    return IMAGE_SIZE[screenSize] + PROGRESS_MARGIN_VERTICAL;
});
var getTitleIconBoxTopOffset = (0, _memoize.default)(function(screenSize) {
    return IMAGE_SIZE[screenSize] + PROGRESS_HEIGHT + PROGRESS_MARGIN_VERTICAL * 2;
});
var getExtraTitleTopOffset = (0, _memoize.default)(function(screenSize) {
    return IMAGE_SIZE[screenSize] + PROGRESS_HEIGHT + TITLE_ICON_BOX_HEIGHT[screenSize] + EXTRA_TITLE_MARGIN_TOP + PROGRESS_MARGIN_VERTICAL * 2;
});
var getInitialStyle = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext, screenSize = _ref.screenSize, colorMode = _ref.colorMode;
    var _sizes_templates_BigSquare_screenSize = _bigSquareconstants.sizes[_bigSquareconstants.templates.BigSquare][screenSize], w = _sizes_templates_BigSquare_screenSize.w, h = _sizes_templates_BigSquare_screenSize.h;
    var borderSize = _focus.BORDER_WIDTH[screenSize];
    var borderOffset = borderSize * 2;
    var containerSize = getContainerSize(screenSize);
    return {
        Border: {
            w: w + borderOffset,
            h: h + borderOffset,
            x: -borderSize,
            y: -borderSize,
            color: _colors.TRANSPARENT,
            shader: {
                radius: _focus.BORDER_RADIUS[screenSize],
                outline: _focus.BORDER_WIDTH[screenSize],
                strokeColor: _colors.TRANSPARENT,
                innerColor: _colors.TRANSPARENT
            }
        },
        Background: {
            w: w,
            h: h,
            color: _colors.TRANSPARENT,
            shader: {
                radius: _focus.BORDER_RADIUS[screenSize]
            }
        },
        ContentContainer: {
            w: containerSize.w,
            h: containerSize.h,
            x: CONTENT_PADDING[screenSize],
            y: CONTENT_PADDING[screenSize],
            Logo: {
                w: IMAGE_SIZE[screenSize],
                h: IMAGE_SIZE[screenSize]
            },
            Progress: {
                w: getContainerSize(screenSize).w,
                y: getProgressTopOffset(screenSize)
            },
            TitleIconBox: {
                w: _sizes.identity,
                h: TITLE_ICON_BOX_HEIGHT[screenSize],
                y: getTitleIconBoxTopOffset(screenSize),
                Icon: {
                    mountY: 0.5,
                    y: _sizes.middle,
                    alpha: 0.8
                },
                Title: {
                    color: colors.text[colorMode],
                    text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT.BERLIN_3, screenSize)), {
                        maxLines: 1,
                        verticalAlign: "middle",
                        wordWrapWidth: getTitleWrapWidth(screenSize)
                    })
                }
            },
            ExtraTitle: {
                y: getExtraTitleTopOffset(screenSize),
                color: colors.text[colorMode],
                text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT.MADRID_1, screenSize)), {
                    maxLines: 1,
                    verticalAlign: "middle",
                    wordWrapWidth: getContainerSize(screenSize).w
                }),
                alpha: 0.8
            }
        }
    };
};
var getFocusedStyle = (0, _memoize.default)(function(param) {
    var colorMode = param.colorMode;
    return {
        Border: {
            smooth: {
                scale: _focus.SCALE_FOCUSED,
                "shader.strokeColor": _focus.BORDER_COLOR[colorMode],
                "shader.innerColor": _focus.INNER_BORDER_COLOR[colorMode],
                "shader.scale": _focus.SCALE_FOCUSED
            }
        },
        Background: {
            smooth: {
                color: colors.background[colorMode],
                scale: _focus.SCALE_FOCUSED
            }
        }
    };
}, _style.cacheResolver);
var unFocusedStyle = {
    Border: {
        smooth: {
            scale: 1,
            "shader.strokeColor": _colors.TRANSPARENT,
            "shader.innerColor": _colors.TRANSPARENT,
            "shader.scale": 1.0
        }
    },
    Background: {
        smooth: {
            color: _colors.TRANSPARENT,
            scale: 1,
            "shader.scale": 1.0
        }
    }
};


/***/ }),

/***/ 81468:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "ITEMS_BY_BREAKPOINTS", ({
    enumerable: true,
    get: function() {
        return ITEMS_BY_BREAKPOINTS;
    }
}));
var _define_property = __webpack_require__(21228);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(45538);
var _constants = __webpack_require__(34952);
var _obj;
var ITEMS_BY_BREAKPOINTS = (_obj = {}, _define_property._(_obj, _constants.HD, 6), _define_property._(_obj, _constants.FULL_HD, 6), _obj);


/***/ }),

/***/ 89464:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "Block", ({
    enumerable: true,
    get: function() {
        return Block;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _create_super = __webpack_require__(6400);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(52318);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _fidosdk = __webpack_require__(19804);
var _constants = __webpack_require__(34952);
var _rowcomponent = __webpack_require__(53565);
var _block = __webpack_require__(3777);
var _theme = __webpack_require__(74314);
var _signals = __webpack_require__(2109);
var _blockstyle = __webpack_require__(39623);
var Block = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(Block, _Lightning_Component);
    var _super = _create_super._(Block);
    function Block() {
        _class_call_check._(this, Block);
        return _super.apply(this, arguments);
    }
    _create_class._(Block, [
        {
            key: "_construct",
            value: function _construct() {
                this._contentPadding = 0;
                this._style = _object_spread._({}, _blockstyle.defaultContext);
            }
        },
        {
            key: "_build",
            value: function _build() {
                this.patch((0, _blockstyle.getInitialStyle)(this._style));
            }
        },
        {
            key: "_attach",
            value: function _attach() {
                var background = this.tag("Background");
                background.alpha = _blockstyle.BACKGROUND_INITIAL_ALPHA;
                background.on("txLoaded", function() {
                    background.setSmooth("alpha", _blockstyle.BACKGROUND_LOADED_ALPHA);
                });
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                this._data = undefined;
                this.tag("Background").removeAllListeners("txLoaded");
            }
        },
        {
            key: "data",
            get: function get() {
                return this._data;
            },
            set: function set(value) {
                this._data = value;
                var _this__data = this._data, block = _this__data.block, blockIndex = _this__data.blockIndex, theme = _this__data.theme, rowSize = _this__data.rowSize;
                var _getLayoutTheme = (0, _theme.getLayoutTheme)(block.theme, theme), colorScheme = _getLayoutTheme.colorScheme, backgroundColor = _getLayoutTheme.backgroundColor, backgroundImage = _getLayoutTheme.backgroundImage;
                var backgroundImageURL = backgroundImage ? _fidosdk.imageService.getUrl(backgroundImage, rowSize.w, rowSize.h, {
                    fit: _constants.IMAGE_FIT_SCALE_CROP,
                    quality: _constants.IMAGE_QUALITY,
                    format: _constants.DEFAULT_IMAGE_FORMAT
                }) : null;
                var titleText = (0, _block.getTitle)(block.title);
                var hasTitle = Boolean(titleText);
                var blockStyle = Number.isFinite(blockIndex) ? (0, _blockstyle.getBlockStyle)({
                    hasTitle: hasTitle,
                    isFirstBlock: blockIndex === 0,
                    screenSize: this._style.screenSize
                }) : _blockstyle.EMPTY_BLOCK_STYLE;
                this._style.colorMode = colorScheme;
                this.patch(_object_spread_props._(_object_spread._({}, rowSize), {
                    color: backgroundColor,
                    Background: {
                        src: backgroundImageURL
                    },
                    Title: _object_spread._({
                        visible: hasTitle,
                        color: _blockstyle.colors.title[colorScheme],
                        text: {
                            text: titleText
                        }
                    }, blockStyle.title),
                    Row: _object_spread._({}, blockStyle.items)
                }));
                this.tag("Row").data = value;
            }
        },
        {
            key: "contentPadding",
            get: function get() {
                return this._contentPadding;
            },
            set: function set(value) {
                if (Number.isFinite(value) && this._contentPadding !== value) {
                    this.tag("Title").x = value;
                    this.tag("Row").patch({
                        x: value,
                        leftPadding: value
                    });
                    this._contentPadding = value;
                }
            }
        },
        {
            key: "contentGap",
            get: function get() {
                return this.tag("Row").contentGap;
            },
            set: function set(value) {
                this.tag("Row").contentGap = value;
            }
        },
        {
            key: "startPointMode",
            get: function get() {
                return this.tag("Row").startPointMode;
            },
            set: function set(value) {
                this.tag("Row").startPointMode = value;
            }
        },
        {
            key: "focusMode",
            set: function set(value) {
                this.tag("Row").focusMode = value;
            }
        },
        {
            key: "focusedIndex",
            get: function get() {
                return this.tag("Row").focusedIndex;
            },
            set: function set(value) {
                this.tag("Row").focusedIndex = value;
            }
        },
        {
            key: "_getFocused",
            value: function _getFocused() {
                return this.tag("Row");
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                var _obj;
                return (0, _merge.default)({
                    rect: true,
                    Background: {},
                    Title: {},
                    Row: {
                        type: _rowcomponent.Row
                    },
                    passSignals: (_obj = {}, _define_property._(_obj, _signals.SELECTED_SIGNAL, true), _define_property._(_obj, _signals.SHOW_GRID_SIGNAL, true), _define_property._(_obj, _signals.PORTION_REQUESTED_SIGNAL, true), _define_property._(_obj, _signals.IMPRESSION_TRACK_SIGNAL, true), _define_property._(_obj, _signals.IMPRESSION_UNTRACK_SIGNAL, true), _obj)
                }, (0, _blockstyle.getInitialStyle)());
            }
        },
        {
            key: "getOffsetsByBlockData",
            value: function getOffsetsByBlockData(param) {
                var title = param.data.title, screenSize = param.screenSize, blockIndex = param.blockIndex;
                var hasTitle = Boolean((0, _block.getTitle)(title));
                var _getBlockStyle = (0, _blockstyle.getBlockStyle)({
                    hasTitle: hasTitle,
                    isFirstBlock: blockIndex === 0,
                    screenSize: screenSize
                }), items = _getBlockStyle.items, bottom = _getBlockStyle.padding.bottom;
                return {
                    top: Number.isFinite(blockIndex) ? items.y : 0,
                    bottom: bottom
                };
            }
        }
    ]);
    return Block;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 48954:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _export_star = __webpack_require__(37668);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(65759);
_export_star._(__webpack_require__(43915), exports);


/***/ }),

/***/ 39623:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BACKGROUND_INITIAL_ALPHA: function() {
        return BACKGROUND_INITIAL_ALPHA;
    },
    BACKGROUND_LOADED_ALPHA: function() {
        return BACKGROUND_LOADED_ALPHA;
    },
    EMPTY_BLOCK_STYLE: function() {
        return EMPTY_BLOCK_STYLE;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getBlockStyle: function() {
        return getBlockStyle;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    getTitleStyle: function() {
        return getTitleStyle;
    }
});
var _export_star = __webpack_require__(37668);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(3009);
var _memoize = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34736));
var _theme = __webpack_require__(51397);
var _typography = __webpack_require__(18411);
var _sizes = __webpack_require__(82699);
var _style = __webpack_require__(65082);
var _blockconstants = _export_star._(__webpack_require__(48954), exports);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var EMPTY_BLOCK_STYLE = {
    title: {},
    items: {}
};
var BACKGROUND_INITIAL_ALPHA = 0.001;
var BACKGROUND_LOADED_ALPHA = 1;
var colors = {
    title: (0, _theme.makeThemeColor)(_theme.PRIMARY)
};
var getTitleStyle = (0, _memoize.default)(function(param) {
    var screenSize = param.screenSize, colorMode = param.colorMode;
    return {
        y: _blockconstants.TITLE_PADDING.TOP[screenSize],
        color: colors.title[colorMode],
        text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT.KINSHASA_3, screenSize)), {
            verticalAlign: "middle"
        })
    };
}, _style.cacheResolver);
var getBlockStyle = (0, _memoize.default)(function(context) {
    var hasTitle = context.hasTitle, isFirstBlock = context.isFirstBlock, screenSize = context.screenSize;
    var padding = {
        top: _blockconstants.PADDING.TOP[screenSize],
        bottom: _blockconstants.PADDING.BOTTOM[screenSize],
        left: _blockconstants.PADDING.LEFT[screenSize]
    };
    var firstBlockPadding = _blockconstants.FIRST_BLOCK_PADDING[screenSize];
    var titleStyle = getTitleStyle(context);
    var items = {
        y: padding.top
    };
    var title = {
        y: titleStyle.y
    };
    if (hasTitle) {
        items.y = titleStyle.text.lineHeight + _blockconstants.TITLE_PADDING.BOTTOM[screenSize];
        if (isFirstBlock) {
            items.y += firstBlockPadding;
            title.y = firstBlockPadding;
        } else {
            items.y += titleStyle.y;
        }
    } else if (isFirstBlock) {
        items.y = firstBlockPadding;
    }
    return {
        title: title,
        items: items,
        padding: padding
    };
}, _style.cacheResolver);
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    return {
        Background: {
            w: _sizes.identity,
            h: _sizes.identity
        },
        Row: {
            rightPadding: _blockconstants.PADDING.RIGHT[context.screenSize]
        },
        Title: getTitleStyle(context)
    };
};


/***/ }),

/***/ 43915:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    CONTENT_GAP: function() {
        return _constants.CONTENT_GAP;
    },
    FIRST_BLOCK_PADDING: function() {
        return FIRST_BLOCK_PADDING;
    },
    PADDING: function() {
        return PADDING;
    },
    TITLE_PADDING: function() {
        return TITLE_PADDING;
    }
});
var _define_property = __webpack_require__(21228);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(3009);
var _constants = __webpack_require__(34952);
var _obj, _obj1, _obj2, _obj3;
var PADDING = {
    // This padding will be applied if there is no title specified for a List
    TOP: (_obj = {}, _define_property._(_obj, _constants.HD, 32), _define_property._(_obj, _constants.FULL_HD, 32), _obj),
    BOTTOM: (_obj1 = {}, _define_property._(_obj1, _constants.HD, 16), _define_property._(_obj1, _constants.FULL_HD, 32), _obj1),
    LEFT: (_obj2 = {}, _define_property._(_obj2, _constants.HD, 40), _define_property._(_obj2, _constants.FULL_HD, 40), _obj2),
    RIGHT: (_obj3 = {}, _define_property._(_obj3, _constants.HD, _constants.safetyMargins.horizontal.HD), _define_property._(_obj3, _constants.FULL_HD, _constants.safetyMargins.horizontal.FULL_HD), _obj3)
};
var _obj4, _obj5;
var TITLE_PADDING = {
    TOP: (_obj4 = {}, _define_property._(_obj4, _constants.HD, 16), _define_property._(_obj4, _constants.FULL_HD, 32), _obj4),
    BOTTOM: (_obj5 = {}, _define_property._(_obj5, _constants.HD, 12), _define_property._(_obj5, _constants.FULL_HD, 24), _obj5)
};
var _obj6;
var FIRST_BLOCK_PADDING = (_obj6 = {}, _define_property._(_obj6, _constants.HD, 80), _define_property._(_obj6, _constants.FULL_HD, 80), _obj6);


/***/ }),

/***/ 362:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "BrandIcon", ({
    enumerable: true,
    get: function() {
        return BrandIcon;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _get = __webpack_require__(60528);
var _get_prototype_of = __webpack_require__(35196);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _set = __webpack_require__(81364);
var _create_super = __webpack_require__(6400);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(37815);
var _sdk = __webpack_require__(29956);
var _iconcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(70160));
var _sizes = __webpack_require__(82699);
var _brandIconconstants = __webpack_require__(17009);
var _brandIconutils = __webpack_require__(53880);
var BrandIcon = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(BrandIcon, _Lightning_Component);
    var _super = _create_super._(BrandIcon);
    function BrandIcon() {
        _class_call_check._(this, BrandIcon);
        return _super.apply(this, arguments);
    }
    _create_class._(BrandIcon, [
        {
            key: "_construct",
            value: function _construct() {
                this._textureScale = _brandIconconstants.LOGO_ICON_SCALE;
                this._textureWidth = 0;
                this._textureHeight = 0;
            }
        },
        {
            key: "_attach",
            value: function _attach() {
                var _this = this;
                var icon = this.tag("Icon");
                this._updateWidth = function() {
                    _this.tag("Icon").setSmooth("alpha", 1);
                    _this.w = _this._textureScale ? Math.round(icon.finalW / _this._textureScale) : icon.finalW;
                };
                icon.on("txLoaded", this._updateWidth);
            }
        },
        {
            key: "_active",
            value: function _active() {
                this._isIconActive = true;
                this._updateIconTexture();
            }
        },
        {
            key: "_inactive",
            value: function _inactive() {
                this._isIconActive = false;
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                this.tag("Icon").removeAllListeners("txLoaded");
            }
        },
        {
            key: "textureScale",
            get: function get() {
                return this._textureScale;
            },
            set: function set(value) {
                this._textureScale = value;
                this._updateIconTexture();
            }
        },
        {
            key: "w",
            get: function get() {
                return _get._(_get_prototype_of._(BrandIcon.prototype), "w", this);
            },
            set: function set(value) {
                this.tag("Icon").removeListener("txLoaded", this._updateWidth);
                _set._(_get_prototype_of._(BrandIcon.prototype), "w", value, this, true);
                this._textureWidth = value;
                this._updateIconTexture();
            }
        },
        {
            key: "h",
            get: function get() {
                return _get._(_get_prototype_of._(BrandIcon.prototype), "h", this);
            },
            set: function set(value) {
                _set._(_get_prototype_of._(BrandIcon.prototype), "h", value, this, true);
                if (_brandIconconstants.BRAND_ICON_WIDTH_RATIO) {
                    _set._(_get_prototype_of._(BrandIcon.prototype), "w", value * _brandIconconstants.BRAND_ICON_WIDTH_RATIO, this, true);
                    this._textureWidth = value * _brandIconconstants.BRAND_ICON_WIDTH_RATIO;
                }
                this._textureHeight = value;
                this._updateIconTexture();
            }
        },
        {
            key: "_updateIconTexture",
            value: function _updateIconTexture() {
                if (!this._isIconActive) {
                    return;
                }
                this.tag("Icon").iconData = {
                    picto: (0, _brandIconutils.getLogoIcon)(),
                    scale: this._textureScale,
                    viewBox: {
                        w: this._textureWidth,
                        h: this._textureHeight
                    }
                };
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return {
                    Icon: {
                        type: _iconcomponent.default,
                        mountY: 0.5,
                        alpha: _brandIconconstants.DEFAULT_ALPHA,
                        y: _sizes.middle
                    }
                };
            }
        }
    ]);
    return BrandIcon;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 17009:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "DEFAULT_ALPHA", ({
    enumerable: true,
    get: function() {
        return DEFAULT_ALPHA;
    }
}));
var _export_star = __webpack_require__(37668);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(45538);
_export_star._(__webpack_require__(27314), exports);
var DEFAULT_ALPHA = 0.001;


/***/ }),

/***/ 53880:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _export_star = __webpack_require__(37668);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(65759);
_export_star._(__webpack_require__(31280), exports);


/***/ }),

/***/ 27314:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BRAND_ICON_WIDTH_RATIO: function() {
        return BRAND_ICON_WIDTH_RATIO;
    },
    LOGO_ICON: function() {
        return LOGO_ICON;
    },
    LOGO_ICON_SCALE: function() {
        return LOGO_ICON_SCALE;
    }
});
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(37815);
var _iconconstants = __webpack_require__(48112);
var LOGO_ICON = {
    type: _iconconstants.ICON_TYPE.SERVICE_ICON,
    name: "rtlplus_root"
};
var LOGO_ICON_SCALE = 1.0;
var BRAND_ICON_WIDTH_RATIO = 1.6;


/***/ }),

/***/ 31280:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "getLogoIcon", ({
    enumerable: true,
    get: function() {
        return getLogoIcon;
    }
}));
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(45538);
var _brandIconconstants = __webpack_require__(27314);
var getLogoIcon = function() {
    return _brandIconconstants.LOGO_ICON;
};


/***/ }),

/***/ 31464:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "Button", ({
    enumerable: true,
    get: function() {
        return Button;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _create_super = __webpack_require__(6400);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(52318);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _iconcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(70160));
var _sizes = __webpack_require__(82699);
var _buttonstyle = __webpack_require__(3211);
var _buttonBackgroundcomponent = __webpack_require__(32866);
var Button = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(Button, _Lightning_Component);
    var _super = _create_super._(Button);
    function Button() {
        _class_call_check._(this, Button);
        return _super.apply(this, arguments);
    }
    _create_class._(Button, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _buttonstyle.defaultContext;
                this._isIconTxLoading = false;
                this._isLabelTxLoading = false;
                this._minWidth = 0;
            }
        },
        {
            key: "_init",
            value: function _init() {
                var _this = this;
                var label = this.tag("Label");
                var icon = this.tag("Icon");
                var screenSize = (0, _sizes.getScreenSize)();
                var iconWidth = _buttonstyle.ICON_WIDTH[screenSize];
                var iconPaddingLeft = _buttonstyle.ICON_PADDING_LEFT[screenSize];
                var padding = _buttonstyle.PADDING[screenSize];
                var handleUpdate = function() {
                    if (_this._isIconTxLoading || _this._isLabelTxLoading) {
                        return;
                    }
                    var size = padding * 2 + label.finalW;
                    var offset = icon.finalW ? iconPaddingLeft + iconWidth : 0;
                    var w = Math.max(size + offset, _this._minWidth);
                    _this.patch({
                        w: w,
                        Icon: {
                            x: padding
                        },
                        Label: {
                            x: Math.max(padding + offset, Math.round((w - label.finalW) / 2))
                        }
                    });
                };
                icon.on("txLoaded", function() {
                    _this._isIconTxLoading = false;
                    handleUpdate();
                });
                label.on("txLoaded", function() {
                    _this._isLabelTxLoading = false;
                    handleUpdate();
                });
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                this.tag("Label").removeAllListeners("txLoaded");
                this.tag("Icon").removeAllListeners("txLoaded");
            }
        },
        {
            key: "label",
            set: function set(value) {
                this.tag("Label").text.text = value;
                this._isLabelTxLoading = true;
            }
        },
        {
            key: "picto",
            set: function set(value) {
                this._isIconTxLoading = true;
                var screenSize = (0, _sizes.getScreenSize)();
                this.tag("Icon").iconData = {
                    picto: value,
                    viewBox: {
                        w: _buttonstyle.ICON_WIDTH[screenSize],
                        h: _buttonstyle.ICON_HEIGHT[screenSize]
                    }
                };
            }
        },
        {
            key: "colorMode",
            get: function get() {
                return this._style.colorMode;
            },
            set: function set(value) {
                this._style = _object_spread_props._(_object_spread._({}, this._style), {
                    colorMode: value
                });
                this.patch((0, _buttonstyle.getInitialStyle)(this._style));
            }
        },
        {
            key: "minWidth",
            get: function get() {
                return this._minWidth;
            },
            set: function set(value) {
                this._minWidth = value;
            }
        },
        {
            key: "_focus",
            value: function _focus() {
                this.patch((0, _buttonstyle.getFocusedStyle)(this._style));
            }
        },
        {
            key: "_unfocus",
            value: function _unfocus() {
                this.patch((0, _buttonstyle.getUnFocusedStyle)(this._style));
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Background: {
                        type: _buttonBackgroundcomponent.ButtonBackground,
                        w: _sizes.identity
                    },
                    Fill: {},
                    Icon: {
                        type: _iconcomponent.default
                    },
                    Label: {}
                }, (0, _buttonstyle.getInitialStyle)());
            }
        }
    ]);
    return Button;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 3211:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _export_star = __webpack_require__(37668);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(45538);
_export_star._(__webpack_require__(66417), exports);


/***/ }),

/***/ 84065:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
// Adding extra 1.5 pixels to a minimal border size to reduce GPU aliasing artifacts

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "getStrokeWidth", ({
    enumerable: true,
    get: function() {
        return getStrokeWidth;
    }
}));
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(3009);
var getStrokeWidth = function(stroke) {
    return stroke >= 1.5 ? stroke : 1.5;
};


/***/ }),

/***/ 3857:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BORDER_RADIUS: function() {
        return BORDER_RADIUS;
    },
    FILL_FOCUSED_COLOR: function() {
        return FILL_FOCUSED_COLOR;
    },
    FILL_UNFOCUSED_COLOR: function() {
        return FILL_UNFOCUSED_COLOR;
    },
    SCALE_FOCUSED: function() {
        return SCALE_FOCUSED;
    },
    STROKE_FOCUSED: function() {
        return STROKE_FOCUSED;
    },
    STROKE_FOCUSED_COLOR: function() {
        return STROKE_FOCUSED_COLOR;
    },
    STROKE_UNFOCUSED: function() {
        return STROKE_UNFOCUSED;
    },
    STROKE_UNFOCUSED_COLOR: function() {
        return STROKE_UNFOCUSED_COLOR;
    },
    TEXT_FOCUSED_COLOR: function() {
        return TEXT_FOCUSED_COLOR;
    },
    TEXT_UNFOCUSED_COLOR: function() {
        return TEXT_UNFOCUSED_COLOR;
    }
});
var _define_property = __webpack_require__(21228);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
var _constants = __webpack_require__(34952);
var _theme = __webpack_require__(51397);
var _obj;
var BORDER_RADIUS = (_obj = {}, _define_property._(_obj, _constants.HD, 8), _define_property._(_obj, _constants.FULL_HD, 8), _obj);
var _obj1;
var STROKE_UNFOCUSED = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 2), _define_property._(_obj1, _constants.FULL_HD, 3), _obj1);
var _obj2;
var STROKE_FOCUSED = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 2), _define_property._(_obj2, _constants.FULL_HD, 3), _obj2);
var STROKE_UNFOCUSED_COLOR = (0, _theme.makeThemeColor)(_theme.PRIMARY, 1.0);
var STROKE_FOCUSED_COLOR = (0, _theme.makeThemeColor)(_theme.PRIMARY, 1.0);
var FILL_UNFOCUSED_COLOR = (0, _theme.makeThemeColor)(_theme.TERTIARY);
var FILL_FOCUSED_COLOR = (0, _theme.makeThemeColor)(_theme.PRIMARY);
var TEXT_UNFOCUSED_COLOR = (0, _theme.makeThemeColor)(_theme.PRIMARY);
var TEXT_FOCUSED_COLOR = (0, _theme.makeThemeColor)(_theme.TERTIARY);
var SCALE_FOCUSED = 1.05;


/***/ }),

/***/ 66417:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    HEIGHT: function() {
        return HEIGHT;
    },
    ICON_HEIGHT: function() {
        return ICON_HEIGHT;
    },
    ICON_PADDING_LEFT: function() {
        return ICON_PADDING_LEFT;
    },
    ICON_WIDTH: function() {
        return ICON_WIDTH;
    },
    PADDING: function() {
        return PADDING;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getFocusedStyle: function() {
        return getFocusedStyle;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    getUnFocusedStyle: function() {
        return getUnFocusedStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(45538);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _constants = __webpack_require__(34952);
var _typography = __webpack_require__(18411);
var _style = __webpack_require__(65082);
var _buttonconstants = __webpack_require__(3857);
var _buttonutils = __webpack_require__(84065);
var _buttonTexturecomponent = __webpack_require__(9978);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var HEIGHT = (_obj = {}, _define_property._(_obj, _constants.HD, 40), _define_property._(_obj, _constants.FULL_HD, 56), _obj);
var _obj1;
var PADDING = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 16), _define_property._(_obj1, _constants.FULL_HD, 24), _obj1);
var _obj2;
var ICON_WIDTH = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 24), _define_property._(_obj2, _constants.FULL_HD, 32), _obj2);
var _obj3;
var ICON_HEIGHT = (_obj3 = {}, _define_property._(_obj3, _constants.HD, 24), _define_property._(_obj3, _constants.FULL_HD, 32), _obj3);
var _obj4;
var ICON_PADDING_LEFT = (_obj4 = {}, _define_property._(_obj4, _constants.HD, 4), _define_property._(_obj4, _constants.FULL_HD, 8), _obj4);
var getUnFocusedStyle = function(param) {
    var screenSize = param.screenSize, colorMode = param.colorMode;
    return {
        Background: {
            color: _buttonconstants.FILL_UNFOCUSED_COLOR[colorMode],
            borderColor: _buttonconstants.STROKE_UNFOCUSED_COLOR[colorMode],
            borderWidth: (0, _buttonutils.getStrokeWidth)(_buttonconstants.STROKE_UNFOCUSED[screenSize]),
            type: _buttonTexturecomponent.ButtonTexture,
            smooth: {
                scale: 1.0
            }
        },
        Icon: {
            color: _buttonconstants.TEXT_UNFOCUSED_COLOR[colorMode]
        },
        Label: {
            color: _buttonconstants.TEXT_UNFOCUSED_COLOR[colorMode]
        }
    };
};
var getFocusedStyle = function(param) {
    var screenSize = param.screenSize, colorMode = param.colorMode;
    return {
        Background: {
            color: _buttonconstants.FILL_FOCUSED_COLOR[colorMode],
            borderColor: _buttonconstants.STROKE_FOCUSED_COLOR[colorMode],
            borderWidth: (0, _buttonutils.getStrokeWidth)(_buttonconstants.STROKE_FOCUSED[screenSize]),
            smooth: {
                scale: _buttonconstants.SCALE_FOCUSED
            }
        },
        Icon: {
            color: _buttonconstants.TEXT_FOCUSED_COLOR[colorMode]
        },
        Label: {
            color: _buttonconstants.TEXT_FOCUSED_COLOR[colorMode]
        }
    };
};
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var screenSize = context.screenSize, colorMode = context.colorMode;
    var h = HEIGHT[screenSize];
    var font = (0, _typography.getFont)(_typography.FONT.OTTAWA_2, screenSize);
    return (0, _merge.default)({
        h: h,
        Background: {
            h: h,
            color: _buttonconstants.FILL_UNFOCUSED_COLOR[colorMode],
            borderRadius: _buttonconstants.BORDER_RADIUS[screenSize]
        },
        Icon: {
            y: Math.round((h - ICON_HEIGHT[screenSize]) / 2)
        },
        Label: {
            y: Math.round((h - font.lineHeight) / 2),
            text: _object_spread_props._(_object_spread._({}, font), {
                verticalAlign: "middle"
            })
        }
    }, getUnFocusedStyle(context));
};


/***/ }),

/***/ 32866:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "ButtonBackground", ({
    enumerable: true,
    get: function() {
        return _buttonBackgroundcomponent.ButtonBackground;
    }
}));
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(88801);
var _buttonBackgroundcomponent = __webpack_require__(22348);


/***/ }),

/***/ 89813:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "ButtonRectangle", ({
    enumerable: true,
    get: function() {
        return ButtonRectangle;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
var _sdk = __webpack_require__(29956);
var ButtonRectangle = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(ButtonRectangle, _Lightning_Component);
    var _super = _create_super._(ButtonRectangle);
    function ButtonRectangle() {
        _class_call_check._(this, ButtonRectangle);
        return _super.apply(this, arguments);
    }
    _create_class._(ButtonRectangle, [
        {
            key: "_construct",
            value: function _construct() {
                this._borderColor = 0;
                this._borderWidth = 0;
                this._borderRadius = 0;
            }
        },
        {
            key: "borderColor",
            get: function get() {
                return this._borderColor;
            },
            set: function set(value) {
                this._borderColor = value;
                this.patch({
                    shader: {
                        strokeColor: value
                    }
                });
            }
        },
        {
            key: "borderWidth",
            get: function get() {
                return this._borderWidth;
            },
            set: function set(value) {
                this._borderWidth = value;
                this.patch({
                    shader: {
                        stroke: value
                    }
                });
            }
        },
        {
            key: "borderRadius",
            get: function get() {
                return this._borderRadius;
            },
            set: function set(value) {
                this._borderRadius = value;
                this.patch({
                    shader: {
                        radius: value
                    }
                });
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return {
                    rect: true,
                    shader: {
                        type: _sdk.Lightning.shaders.RoundedRectangle
                    }
                };
            }
        }
    ]);
    return ButtonRectangle;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 9978:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "ButtonTexture", ({
    enumerable: true,
    get: function() {
        return ButtonTexture;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(42578);
var _sdk = __webpack_require__(29956);
var _buttonTextureutils = __webpack_require__(5619);
var ButtonTexture = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(ButtonTexture, _Lightning_Component);
    var _super = _create_super._(ButtonTexture);
    function ButtonTexture() {
        _class_call_check._(this, ButtonTexture);
        return _super.apply(this, arguments);
    }
    _create_class._(ButtonTexture, [
        {
            key: "_construct",
            value: function _construct() {
                this._generatedTextureWidth = 0;
                this._generatedTextureHeight = 0;
                this._fillColor = 0;
                this._borderColor = 0;
                this._borderWidth = 0;
                this._borderRadius = 0;
                this._fillColor = 0;
                this._shouldUpdateTexture = false;
            }
        },
        {
            key: "_attach",
            value: function _attach() {
                var _this = this;
                this._shouldUpdateTexture = true;
                this.onUpdate = function(param) {
                    var finalW = param.finalW, finalH = param.finalH;
                    if (finalW !== _this._generatedTextureWidth || finalH !== _this._generatedTextureHeight) {
                        _this._generatedTextureWidth = finalW;
                        _this._generatedTextureHeight = finalH;
                        _this._updateButtonTexture();
                    }
                };
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                this._shouldUpdateTexture = false;
                this.onUpdate = undefined;
            }
        },
        {
            key: "borderColor",
            get: function get() {
                return this._borderColor;
            },
            set: function set(value) {
                this._borderColor = value;
                this._updateButtonTexture();
            }
        },
        {
            key: "borderWidth",
            get: function get() {
                return this._borderWidth;
            },
            set: function set(value) {
                this._borderWidth = value;
            }
        },
        {
            key: "borderRadius",
            get: function get() {
                return this._borderRadius;
            },
            set: function set(value) {
                this._borderRadius = value;
            }
        },
        {
            key: "color",
            get: function get() {
                return this._fillColor;
            },
            set: function set(value) {
                this._fillColor = value;
                this._updateButtonTexture();
            }
        },
        {
            key: "_updateButtonTexture",
            value: function _updateButtonTexture() {
                if (!this._shouldUpdateTexture || !this._generatedTextureWidth || !this._generatedTextureHeight) {
                    return;
                }
                this.texture = (0, _buttonTextureutils.makeButtonTexture)(this._generatedTextureWidth, this._generatedTextureHeight, this._borderRadius, this._borderWidth, this._borderColor, this._fillColor);
            }
        }
    ]);
    return ButtonTexture;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 5619:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "makeButtonTexture", ({
    enumerable: true,
    get: function() {
        return makeButtonTexture;
    }
}));
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(45538);
var _sdk = __webpack_require__(29956);
var _colors = __webpack_require__(8426);
var makeButtonTexture = function(w, h) {
    var borderRadius = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, borderWidth = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, borderColor = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0, fillColor = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : _colors.WHITE;
    return _sdk.Lightning.Tools.getRoundRect(w, h, borderRadius, borderWidth, borderColor, true, fillColor);
};


/***/ }),

/***/ 22348:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "ButtonBackground", ({
    enumerable: true,
    get: function() {
        return ButtonBackground;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _get = __webpack_require__(60528);
var _get_prototype_of = __webpack_require__(35196);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _set = __webpack_require__(81364);
var _create_super = __webpack_require__(6400);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(88801);
var _sdk = __webpack_require__(29956);
var _focusshader = /*#__PURE__*/ _interop_require_default._(__webpack_require__(25906));
var ButtonBackground = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(ButtonBackground, _Lightning_Component);
    var _super = _create_super._(ButtonBackground);
    function ButtonBackground() {
        _class_call_check._(this, ButtonBackground);
        return _super.apply(this, arguments);
    }
    _create_class._(ButtonBackground, [
        {
            key: "scale",
            get: function get() {
                return _get._(_get_prototype_of._(ButtonBackground.prototype), "scale", this);
            },
            set: function set(value) {
                _set._(_get_prototype_of._(ButtonBackground.prototype), "scale", value, this, true);
                this.shader.scale = value;
            }
        },
        {
            key: "borderColor",
            get: function get() {
                return this.shader.strokeColor;
            },
            set: function set(value) {
                this.shader.strokeColor = value;
            }
        },
        {
            key: "innerColor",
            get: function get() {
                return this.shader.innerColor;
            },
            set: function set(value) {
                this.shader.innerColor = value;
            }
        },
        {
            key: "borderWidth",
            get: function get() {
                return this.shader.outline;
            },
            set: function set(value) {
                this.shader.outline = value;
            }
        },
        {
            key: "borderRadius",
            get: function get() {
                return this.shader.radius;
            },
            set: function set(value) {
                this.shader.radius = value;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return {
                    rect: true,
                    shader: {
                        type: _focusshader.default
                    }
                };
            }
        }
    ]);
    return ButtonBackground;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 91743:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "CallToAction", ({
    enumerable: true,
    get: function() {
        return CallToAction;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(52318);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _iconcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(70160));
var _sizes = __webpack_require__(82699);
var _ctashader = /*#__PURE__*/ _interop_require_default._(__webpack_require__(86390));
var _callToActionstyle = __webpack_require__(6073);
var _callToActionconstants = __webpack_require__(13458);
var CallToAction = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(CallToAction, _Lightning_Component);
    var _super = _create_super._(CallToAction);
    function CallToAction() {
        _class_call_check._(this, CallToAction);
        return _super.apply(this, arguments);
    }
    _create_class._(CallToAction, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _callToActionstyle.defaultContext;
                this._hasIcon = false;
                this._isFocused = false;
            }
        },
        {
            key: "_attach",
            value: function _attach() {
                var _this = this;
                var label = this.tag("Label");
                var icon = this.tag("Icon");
                var handleUpdate = function() {
                    var screenSize = _this._style.screenSize;
                    var iconWidth = _this._hasIcon ? _callToActionconstants.ICON_WIDTH[screenSize] : 0;
                    var iconPaddingLeft = _callToActionconstants.ICON_PADDING_LEFT[screenSize];
                    var padding = _callToActionconstants.PADDING[screenSize];
                    var size = padding * 2 + label.finalW;
                    var offset = iconWidth ? iconPaddingLeft + iconWidth : 0;
                    var offsetX = padding + offset;
                    if (label.finalW === 0) {
                        size = _callToActionconstants.DEFAULT_BUTTON_WIDTH[screenSize];
                        padding = (0, _sizes.getCenter)(_callToActionconstants.DEFAULT_BUTTON_WIDTH[screenSize], iconWidth);
                        offset = 0;
                        offsetX = 0;
                    }
                    var w = size + offset;
                    _this.patch({
                        w: w,
                        Icon: {
                            x: padding
                        },
                        Label: {
                            x: offsetX
                        }
                    });
                };
                icon.on("txLoaded", handleUpdate);
                label.on("txLoaded", handleUpdate);
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                this.tag("Label").removeAllListeners("txLoaded");
                this.tag("Icon").removeAllListeners("txLoaded");
            }
        },
        {
            key: "label",
            set: function set(value) {
                this.tag("Label").text.text = value;
            }
        },
        {
            key: "picto",
            set: function set(value) {
                var screenSize = (0, _sizes.getScreenSize)();
                this._hasIcon = Boolean(value);
                this.tag("Icon").iconData = {
                    picto: value,
                    viewBox: {
                        w: _callToActionconstants.ICON_WIDTH[screenSize],
                        h: _callToActionconstants.ICON_HEIGHT[screenSize]
                    }
                };
            }
        },
        {
            key: "progress",
            get: function get() {
                return this._progress;
            },
            set: function set(value) {
                if (this._progress === value) {
                    return;
                }
                if (Number.isFinite(value)) {
                    if (!Number.isFinite(this._progress)) {
                        this.patch((0, _callToActionstyle.getProgressStyle)(this._style));
                    }
                    this.tag("Background").shader.progress = value;
                } else {
                    if (Number.isFinite(this._progress)) {
                        this.patch((0, _callToActionstyle.getInitialStyle)(this._style));
                    }
                    this.patch(this._isFocused ? (0, _callToActionstyle.getFocusedStyle)(this._style) : (0, _callToActionstyle.getUnFocusedStyle)(this._style));
                }
                this._progress = value;
            }
        },
        {
            key: "_focus",
            value: function _focus() {
                this._isFocused = true;
                this.patch((0, _callToActionstyle.getFocusedStyle)(this._style));
            }
        },
        {
            key: "_unfocus",
            value: function _unfocus() {
                this._isFocused = false;
                this.patch((0, _callToActionstyle.getUnFocusedStyle)(this._style));
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Background: {
                        shader: {
                            type: _ctashader.default
                        }
                    },
                    Icon: {
                        type: _iconcomponent.default
                    },
                    Label: {}
                }, (0, _callToActionstyle.getInitialStyle)());
            }
        }
    ]);
    return CallToAction;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 13458:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _export_star = __webpack_require__(37668);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(52318);
_export_star._(__webpack_require__(17710), exports);


/***/ }),

/***/ 6073:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    defaultContext: function() {
        return defaultContext;
    },
    getFocusedStyle: function() {
        return getFocusedStyle;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    getProgressStyle: function() {
        return getProgressStyle;
    },
    getUnFocusedStyle: function() {
        return getUnFocusedStyle;
    }
});
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(37815);
var _typography = __webpack_require__(18411);
var _style = __webpack_require__(65082);
var _sizes = __webpack_require__(82699);
var _callToActionconstants = __webpack_require__(13458);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var screenSize = context.screenSize, colorMode = context.colorMode;
    var h = _callToActionconstants.HEIGHT[screenSize];
    var font = (0, _typography.getFont)(_callToActionconstants.LABEL_FONT, screenSize);
    var borderWidth = _callToActionconstants.BORDER_WIDTH[screenSize];
    return {
        h: h,
        Background: {
            x: -borderWidth,
            y: -borderWidth,
            h: h + borderWidth * 2,
            w: function(v) {
                return v + borderWidth * 2;
            },
            rect: true,
            shader: {
                borderWidth: borderWidth,
                fillColor: _callToActionconstants.UNFOCUSED_BACKGROUND_COLOR[colorMode],
                innerBorderColor: _callToActionconstants.UNFOCUSED_INNER_BORDER_COLOR[colorMode],
                outerBorderColor: _callToActionconstants.UNFOCUSED_OUTER_BORDER_COLOR[colorMode],
                radius: _callToActionconstants.BORDER_RADIUS[screenSize],
                progressColor: _callToActionconstants.LOADING_BAR_COLOR[colorMode],
                scale: 1
            }
        },
        Icon: {
            color: _callToActionconstants.UNFOCUSED_CONTENT_COLOR[colorMode],
            y: (0, _sizes.getCenter)(h, _callToActionconstants.ICON_HEIGHT[screenSize])
        },
        Label: {
            color: _callToActionconstants.UNFOCUSED_CONTENT_COLOR[colorMode],
            y: (0, _sizes.getCenter)(h, font.lineHeight),
            text: _object_spread_props._(_object_spread._({}, font), {
                verticalAlign: "middle"
            })
        }
    };
};
var getProgressStyle = function(param) {
    var colorMode = param.colorMode;
    return {
        Background: {
            shader: {
                fillColor: _callToActionconstants.LOADING_BACKGROUND_COLOR[colorMode],
                innerBorderColor: _callToActionconstants.LOADING_INNER_BORDER_COLOR[colorMode],
                outerBorderColor: _callToActionconstants.LOADING_OUTER_BORDER_COLOR[colorMode],
                scale: 1
            },
            scale: 1
        },
        Icon: {
            color: _callToActionconstants.LOADING_CONTENT_COLOR[colorMode]
        },
        Label: {
            color: _callToActionconstants.LOADING_CONTENT_COLOR[colorMode]
        }
    };
};
var getUnFocusedStyle = function(param) {
    var colorMode = param.colorMode;
    return {
        Background: {
            smooth: {
                "shader.fillColor": _callToActionconstants.UNFOCUSED_BACKGROUND_COLOR[colorMode],
                "shader.innerBorderColor": _callToActionconstants.UNFOCUSED_INNER_BORDER_COLOR[colorMode],
                "shader.outerBorderColor": _callToActionconstants.UNFOCUSED_OUTER_BORDER_COLOR[colorMode],
                "scale.scale": 1,
                scale: 1
            }
        },
        Icon: {
            color: _callToActionconstants.UNFOCUSED_CONTENT_COLOR[colorMode]
        },
        Label: {
            color: _callToActionconstants.UNFOCUSED_CONTENT_COLOR[colorMode]
        }
    };
};
var getFocusedStyle = function(param) {
    var colorMode = param.colorMode;
    return {
        Background: {
            smooth: {
                "shader.fillColor": _callToActionconstants.FOCUSED_BACKGROUND_COLOR[colorMode],
                "shader.innerBorderColor": _callToActionconstants.FOCUSED_INNER_BORDER_COLOR[colorMode],
                "shader.outerBorderColor": _callToActionconstants.FOCUSED_OUTER_BORDER_COLOR[colorMode],
                "scale.scale": 1.05,
                scale: 1.05
            }
        },
        Icon: {
            color: _callToActionconstants.FOCUSED_CONTENT_COLOR[colorMode]
        },
        Label: {
            color: _callToActionconstants.FOCUSED_CONTENT_COLOR[colorMode]
        }
    };
};


/***/ }),

/***/ 17710:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BORDER_RADIUS: function() {
        return BORDER_RADIUS;
    },
    BORDER_WIDTH: function() {
        return BORDER_WIDTH;
    },
    DEFAULT_BUTTON_WIDTH: function() {
        return DEFAULT_BUTTON_WIDTH;
    },
    FOCUSED_BACKGROUND_COLOR: function() {
        return FOCUSED_BACKGROUND_COLOR;
    },
    FOCUSED_CONTENT_COLOR: function() {
        return FOCUSED_CONTENT_COLOR;
    },
    FOCUSED_INNER_BORDER_COLOR: function() {
        return FOCUSED_INNER_BORDER_COLOR;
    },
    FOCUSED_OUTER_BORDER_COLOR: function() {
        return FOCUSED_OUTER_BORDER_COLOR;
    },
    HEIGHT: function() {
        return HEIGHT;
    },
    ICON_HEIGHT: function() {
        return ICON_HEIGHT;
    },
    ICON_PADDING_LEFT: function() {
        return ICON_PADDING_LEFT;
    },
    ICON_WIDTH: function() {
        return ICON_WIDTH;
    },
    LABEL_FONT: function() {
        return LABEL_FONT;
    },
    LOADING_BACKGROUND_COLOR: function() {
        return LOADING_BACKGROUND_COLOR;
    },
    LOADING_BAR_COLOR: function() {
        return LOADING_BAR_COLOR;
    },
    LOADING_CONTENT_COLOR: function() {
        return LOADING_CONTENT_COLOR;
    },
    LOADING_INNER_BORDER_COLOR: function() {
        return LOADING_INNER_BORDER_COLOR;
    },
    LOADING_OUTER_BORDER_COLOR: function() {
        return LOADING_OUTER_BORDER_COLOR;
    },
    PADDING: function() {
        return PADDING;
    },
    UNFOCUSED_BACKGROUND_COLOR: function() {
        return UNFOCUSED_BACKGROUND_COLOR;
    },
    UNFOCUSED_CONTENT_COLOR: function() {
        return UNFOCUSED_CONTENT_COLOR;
    },
    UNFOCUSED_INNER_BORDER_COLOR: function() {
        return UNFOCUSED_INNER_BORDER_COLOR;
    },
    UNFOCUSED_OUTER_BORDER_COLOR: function() {
        return UNFOCUSED_OUTER_BORDER_COLOR;
    }
});
var _define_property = __webpack_require__(21228);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(88801);
var _theme = __webpack_require__(51397);
var _constants = __webpack_require__(34952);
var _typography = __webpack_require__(18411);
var _obj;
var BORDER_RADIUS = (_obj = {}, _define_property._(_obj, _constants.HD, 8), _define_property._(_obj, _constants.FULL_HD, 8), _obj);
var _obj1;
var BORDER_WIDTH = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 4), _define_property._(_obj1, _constants.FULL_HD, 6), _obj1);
var _obj2;
var HEIGHT = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 56), _define_property._(_obj2, _constants.FULL_HD, 64), _obj2);
var _obj3;
var PADDING = (_obj3 = {}, _define_property._(_obj3, _constants.HD, 24), _define_property._(_obj3, _constants.FULL_HD, 24), _obj3);
var _obj4;
var ICON_WIDTH = (_obj4 = {}, _define_property._(_obj4, _constants.HD, 32), _define_property._(_obj4, _constants.FULL_HD, 40), _obj4);
var _obj5;
var ICON_HEIGHT = (_obj5 = {}, _define_property._(_obj5, _constants.HD, 32), _define_property._(_obj5, _constants.FULL_HD, 40), _obj5);
var _obj6;
var ICON_PADDING_LEFT = (_obj6 = {}, _define_property._(_obj6, _constants.HD, 8), _define_property._(_obj6, _constants.FULL_HD, 8), _obj6);
var _obj7;
var DEFAULT_BUTTON_WIDTH = (_obj7 = {}, _define_property._(_obj7, _constants.HD, 56), _define_property._(_obj7, _constants.FULL_HD, 64), _obj7);
var LABEL_FONT = _typography.FONT.OTTAWA_2;
var UNFOCUSED_BACKGROUND_COLOR = (0, _theme.makeThemeColor)(_theme.TERTIARY, 0.6);
var UNFOCUSED_CONTENT_COLOR = (0, _theme.makeThemeColor)(_theme.PRIMARY);
var UNFOCUSED_INNER_BORDER_COLOR = (0, _theme.makeThemeColor)(_theme.PRIMARY, 0.3);
var UNFOCUSED_OUTER_BORDER_COLOR = (0, _theme.makeThemeColor)(_theme.PRIMARY, 0);
var FOCUSED_BACKGROUND_COLOR = (0, _theme.makeThemeColor)(_theme.PRIMARY);
var FOCUSED_CONTENT_COLOR = (0, _theme.makeThemeColor)(_theme.TERTIARY);
var FOCUSED_INNER_BORDER_COLOR = (0, _theme.makeThemeColor)(_theme.TERTIARY);
var FOCUSED_OUTER_BORDER_COLOR = (0, _theme.makeThemeColor)(_theme.PRIMARY);
var LOADING_BACKGROUND_COLOR = (0, _theme.makeThemeColor)(_theme.TERTIARY, 0.3);
var LOADING_BAR_COLOR = (0, _theme.makeThemeColor)(_theme.PRIMARY);
var LOADING_CONTENT_COLOR = (0, _theme.makeThemeColor)(_theme.TERTIARY);
var LOADING_INNER_BORDER_COLOR = (0, _theme.makeThemeColor)(_theme.TERTIARY);
var LOADING_OUTER_BORDER_COLOR = (0, _theme.makeThemeColor)(_theme.PRIMARY, 0);


/***/ }),

/***/ 28518:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "CallToAction", ({
    enumerable: true,
    get: function() {
        return _callToActioncomponent.CallToAction;
    }
}));
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(42578);
var _callToActioncomponent = __webpack_require__(89081);


/***/ }),

/***/ 89081:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _export_star = __webpack_require__(37668);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(3009);
_export_star._(__webpack_require__(91743), exports);


/***/ }),

/***/ 87487:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return Card;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _sliced_to_array = __webpack_require__(28966);
var _create_super = __webpack_require__(6400);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _signals = __webpack_require__(2109);
var _progressutils = __webpack_require__(40779);
var _templates = __webpack_require__(88229);
var _incentivecomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(9077));
var _incentivestyle = __webpack_require__(64443);
var _focusshader = /*#__PURE__*/ _interop_require_default._(__webpack_require__(25906));
var _imageshader = /*#__PURE__*/ _interop_require_default._(__webpack_require__(17154));
var _cardstyle = __webpack_require__(84013);
var _cardconstants = __webpack_require__(20910);
var _incentiveutils = __webpack_require__(72823);
var Card = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(Card, _Lightning_Component);
    var _super = _create_super._(Card);
    function Card() {
        _class_call_check._(this, Card);
        return _super.apply(this, arguments);
    }
    _create_class._(Card, [
        {
            key: "_construct",
            value: function _construct() {
                this._index = 0;
                this._style = _object_spread._({}, _cardstyle.defaultContext);
            }
        },
        {
            key: "_inactive",
            value: function _inactive() {
                this.signal(_signals.INACTIVE_SIGNAL, this);
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                var _this = this;
                _cardstyle.TITLES_ORDER.forEach(function(id) {
                    var view = _this.tag(id);
                    if (view) {
                        view.removeAllListeners("txLoaded");
                    }
                });
                this._item = undefined;
                this.signal(_signals.DETACHED_SIGNAL, this);
            }
        },
        {
            key: "index",
            get: function get() {
                return this._index;
            },
            set: function set(value) {
                this._index = value;
            }
        },
        {
            key: "item",
            get: function get() {
                return this._item;
            },
            set: function set(param) {
                var content = param.content, config = param.config, template = param.template, _param_colorScheme = param.colorScheme, colorScheme = _param_colorScheme === void 0 ? _cardstyle.defaultContext.colorMode : _param_colorScheme;
                var _this = this;
                var templateDataAccessPath = [
                    template,
                    this._style.screenSize
                ];
                var progress = (0, _progressutils.getProgress)(content.progress);
                if ((0, _templates.areContentItemsEqual)(this._item, content)) {
                    this._item = content;
                    this.patch({
                        Image: {
                            shader: {
                                progress: progress
                            }
                        }
                    });
                    return;
                }
                this._item = content;
                this._config = config || _object_spread._({}, (0, _get.default)(_cardconstants.sizes, templateDataAccessPath, {}));
                if (colorScheme && colorScheme !== this._style.colorMode) {
                    this._style = {
                        screenSize: this._style.screenSize,
                        colorMode: colorScheme
                    };
                }
                var _this__item = this._item, title = _this__item.title, extraTitle = _this__item.extraTitle, pictos = _this__item.pictos;
                var wordWrapWidth = this.wordWrapWidth;
                var wordWrapWidthHalf = Math.round(wordWrapWidth / 2);
                var cardImageOptions = (0, _get.default)(_cardconstants.imageOptions, templateDataAccessPath, {});
                var textColor = _cardstyle.colors.text[this._style.colorMode];
                var imageUrl = (0, _get.default)(this._item, "image.src", "");
                var offset = _cardstyle.IMAGE_OFFSET[this._style.screenSize];
                var topLeftIcon = (0, _cardstyle.getIcon)(pictos, _templates.ICON_POSITION.TOP_LEFT);
                var topRightIcon = (0, _cardstyle.getIcon)(pictos, _templates.ICON_POSITION.TOP_RIGHT);
                var bottomRightIcon = (0, _cardstyle.getIcon)(pictos, _templates.ICON_POSITION.BOTTOM_RIGHT);
                var details = _cardconstants.DISPLAY_DETAILS && this._item.details ? this._item.details : "";
                var highlight = this._item.highlight || "";
                var minTextOffset = cardImageOptions.PRIMARY.height + _cardstyle.IMAGE_MARGIN_BOTTOM;
                var highlightPatch = (0, _templates.makeTextPatch)(highlight, details ? wordWrapWidthHalf : wordWrapWidth, textColor);
                var detailsPatch = (0, _templates.makeTextPatch)(details, highlight ? wordWrapWidthHalf : wordWrapWidth, textColor);
                highlightPatch.y = minTextOffset;
                detailsPatch.y = minTextOffset;
                var incentiveLines = (0, _incentiveutils.getLinesCount)(this._item.incentives);
                this._hasIncentives = incentiveLines > 0;
                var incentiveHeight = this._hasIncentives ? _incentivestyle.HEIGHT[this._style.screenSize] : 0;
                this._metadataOffset = cardImageOptions.PRIMARY.height + _cardstyle.IMAGE_MARGIN_BOTTOM + incentiveHeight;
                this.patch({
                    w: this._config.w,
                    h: this._config.h,
                    Border: {
                        w: cardImageOptions.PRIMARY.width + offset,
                        h: cardImageOptions.PRIMARY.height + offset
                    },
                    Image: {
                        w: cardImageOptions.PRIMARY.width,
                        h: cardImageOptions.PRIMARY.height,
                        src: imageUrl,
                        shader: {
                            progress: progress
                        }
                    },
                    TopLeftIcon: {
                        visible: Boolean(topLeftIcon),
                        iconData: {
                            picto: topLeftIcon,
                            viewBox: (0, _cardstyle.getIconViewBox)(this._style.screenSize)
                        }
                    },
                    TopRightIcon: {
                        visible: Boolean(topRightIcon),
                        iconData: {
                            picto: topRightIcon,
                            viewBox: (0, _cardstyle.getIconViewBox)(this._style.screenSize)
                        }
                    },
                    BottomRightIcon: {
                        visible: Boolean(bottomRightIcon),
                        y: cardImageOptions.PRIMARY.height - _cardstyle.ICON_PADDING_VERTICAL - _cardstyle.PROGRESS_HEIGHT,
                        iconData: {
                            picto: bottomRightIcon,
                            viewBox: (0, _cardstyle.getIconViewBox)(this._style.screenSize)
                        }
                    },
                    Incentive: {
                        visible: this._hasIncentives,
                        y: cardImageOptions.PRIMARY.height + _cardstyle.IMAGE_MARGIN_BOTTOM,
                        data: {
                            w: cardImageOptions.PRIMARY.width,
                            linesCount: incentiveLines,
                            incentives: this._item.incentives,
                            colorMode: this._style.colorMode
                        }
                    },
                    ExtraTitle: (0, _templates.makeTextPatch)(_cardconstants.DISPLAY_EXTRA_TITLE ? extraTitle : "", wordWrapWidth, textColor),
                    Title: (0, _templates.makeTextPatch)(_cardconstants.DISPLAY_TITLE ? title : "", wordWrapWidth, textColor),
                    Highlight: highlightPatch,
                    Details: detailsPatch
                });
                // In case if ID was changed (i.e. full refresh is required) but the content is the same
                this._updateMetadataPosition();
                _cardstyle.TITLES_ORDER.forEach(function(id) {
                    var view = _this.tag(id);
                    if (view) {
                        view.on("txLoaded", _this._updateMetadataPosition.bind(_this));
                    }
                });
            }
        },
        {
            key: "wordWrapWidth",
            get: function get() {
                return this._config ? this._config.w : 0;
            }
        },
        {
            key: "_updateMetadataPosition",
            value: function _updateMetadataPosition() {
                // NOTE: we are using manual calculation instead of the "flex" layout in order to speed up tile creation
                var _TITLES_ORDER = _sliced_to_array._(_cardstyle.TITLES_ORDER, 2), firstLineTag = _TITLES_ORDER[0], secondLineTag = _TITLES_ORDER[1];
                var firstLine = this.tag(firstLineTag);
                var secondLine = this.tag(secondLineTag);
                var highlights = this.tag("Highlight");
                var details = this.tag("Details");
                var offset = this._metadataOffset;
                if (firstLine.visible) {
                    firstLine.y = offset;
                    offset += firstLine.finalH;
                }
                if (secondLine.visible) {
                    secondLine.y = offset;
                    offset += secondLine.finalH;
                }
                if (details.visible || highlights.visible) {
                    details.patch((0, _cardstyle.getDetailsPosition)(highlights.visible));
                    details.y = offset;
                    highlights.y = offset;
                }
            }
        },
        {
            key: "_focus",
            value: function _focus() {
                this.patch((0, _cardstyle.getFocusedStyle)(this._style));
            }
        },
        {
            key: "_unfocus",
            value: function _unfocus() {
                this.patch(_cardstyle.unFocusedStyle);
            }
        },
        {
            key: "_handleEnter",
            value: function _handleEnter() {
                this.signal(_signals.SELECTED_SIGNAL, this._item);
                return true;
            }
        }
    ], [
        {
            key: "_template",
            value: /* istanbul ignore next */ function _template() {
                return (0, _merge.default)({
                    Border: {
                        rect: true,
                        shader: {
                            type: _focusshader.default
                        }
                    },
                    Image: {
                        shader: {
                            type: _imageshader.default
                        }
                    },
                    TopLeftIcon: {
                        type: _cardconstants.ICONS_TYPES[_templates.ICON_POSITION.TOP_LEFT]
                    },
                    TopRightIcon: {
                        type: _cardconstants.ICONS_TYPES[_templates.ICON_POSITION.TOP_RIGHT]
                    },
                    BottomRightIcon: {
                        type: _cardconstants.ICONS_TYPES[_templates.ICON_POSITION.BOTTOM_RIGHT]
                    },
                    Incentive: {
                        type: _incentivecomponent.default
                    },
                    ExtraTitle: {},
                    Title: {},
                    Highlight: {},
                    Details: {}
                }, (0, _cardstyle.getInitialStyle)());
            }
        }
    ]);
    return Card;
}(_sdk.Lightning.Component);
Card.Templates = _cardconstants.templates;
Card.Sizes = _cardconstants.sizes;
Card.ImageOptions = _cardconstants.imageOptions;


/***/ }),

/***/ 20910:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ICON_HEIGHT: function() {
        return ICON_HEIGHT;
    },
    ICON_PADDING_HORIZONTAL: function() {
        return ICON_PADDING_HORIZONTAL;
    },
    ICON_PADDING_VERTICAL: function() {
        return ICON_PADDING_VERTICAL;
    },
    imageOptions: function() {
        return imageOptions;
    },
    sizes: function() {
        return sizes;
    }
});
var _define_property = __webpack_require__(21228);
var _export_star = __webpack_require__(37668);
var _interop_require_wildcard = __webpack_require__(95316);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(52318);
var _constants = __webpack_require__(34952);
var _typography = __webpack_require__(18411);
var _theme = __webpack_require__(51397);
var _sizes = __webpack_require__(82699);
var _cardconstants = /*#__PURE__*/ _interop_require_wildcard._(_export_star._(__webpack_require__(67453), exports));
var ICON_PADDING_VERTICAL = 4;
var ICON_PADDING_HORIZONTAL = 8;
var _obj;
var ICON_HEIGHT = (_obj = {}, _define_property._(_obj, _constants.HD, 24), _define_property._(_obj, _constants.FULL_HD, 32), _obj);
var RATIO = 9 / 16;
var _obj1;
var metadataHeight = (_obj1 = {}, _define_property._(_obj1, _constants.HD, _cardconstants.INCENTIVE_HEIGHT[_constants.HD] + (0, _typography.getFont)(_cardconstants.EXTRA_TITLE_FONT_NAME, _constants.HD, _cardconstants.EXTRA_TITLE_FONT_TYPE).lineHeight * _cardconstants.EXTRA_TITLE_LINES + (0, _typography.getFont)(_cardconstants.TITLE_FONT_NAME, _constants.HD, _cardconstants.TITLE_FONT_TYPE).lineHeight + (0, _typography.getFont)(_typography.FONT.BERLIN_1, _constants.HD).lineHeight + _cardconstants.IMAGE_MARGIN_BOTTOM), _define_property._(_obj1, _constants.FULL_HD, _cardconstants.INCENTIVE_HEIGHT[_constants.FULL_HD] + (0, _typography.getFont)(_cardconstants.EXTRA_TITLE_FONT_NAME, _constants.FULL_HD, _cardconstants.EXTRA_TITLE_FONT_TYPE).lineHeight * _cardconstants.EXTRA_TITLE_LINES + (0, _typography.getFont)(_cardconstants.TITLE_FONT_NAME, _constants.FULL_HD, _cardconstants.TITLE_FONT_TYPE).lineHeight + (0, _typography.getFont)(_typography.FONT.BERLIN_1, _constants.FULL_HD).lineHeight + _cardconstants.IMAGE_MARGIN_BOTTOM), _obj1);
var imageOptions = [
    _cardconstants.templates.CardS,
    _cardconstants.templates.CardM,
    _cardconstants.templates.CardL
].reduce(function(result, template) {
    var _getElementSize = (0, _sizes.getElementSize)(_cardconstants.ITEMS_BY_BREAKPOINTS[template], RATIO, template), templateImageOptions = _getElementSize.imageOptions;
    return _object_spread._({}, result, templateImageOptions);
}, {});
var sizes = [
    _cardconstants.templates.CardS,
    _cardconstants.templates.CardM,
    _cardconstants.templates.CardL
].reduce(function(result, template) {
    var _obj;
    return _object_spread_props._(_object_spread._({}, result), _define_property._({}, template, (_obj = {}, _define_property._(_obj, _constants.HD, {
        w: imageOptions[template][_constants.HD][_theme.PRIMARY].width,
        h: imageOptions[template][_constants.HD][_theme.PRIMARY].height + metadataHeight[_constants.HD]
    }), _define_property._(_obj, _constants.FULL_HD, {
        w: imageOptions[template][_constants.FULL_HD][_theme.PRIMARY].width,
        h: imageOptions[template][_constants.FULL_HD][_theme.PRIMARY].height + metadataHeight[_constants.HD]
    }), _obj)));
}, {});


/***/ }),

/***/ 84013:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ICON_HEIGHT: function() {
        return _cardconstants.ICON_HEIGHT;
    },
    ICON_PADDING_VERTICAL: function() {
        return _cardconstants.ICON_PADDING_VERTICAL;
    },
    IMAGE_MARGIN_BOTTOM: function() {
        return _cardconstants.IMAGE_MARGIN_BOTTOM;
    },
    IMAGE_OFFSET: function() {
        return IMAGE_OFFSET;
    },
    PROGRESS_HEIGHT: function() {
        return _progressstyle.HEIGHT;
    },
    TITLES_ORDER: function() {
        return _cardconstants.TITLES_ORDER;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getDetailsPosition: function() {
        return getDetailsPosition;
    },
    getFocusedStyle: function() {
        return getFocusedStyle;
    },
    getIcon: function() {
        return getIcon;
    },
    getIconViewBox: function() {
        return getIconViewBox;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    makeBasicIconStyle: function() {
        return makeBasicIconStyle;
    },
    makeBasicTextStyle: function() {
        return makeBasicTextStyle;
    },
    unFocusedStyle: function() {
        return unFocusedStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(52318);
var _memoize = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34736));
var _typography = __webpack_require__(18411);
var _theme = __webpack_require__(51397);
var _constants = __webpack_require__(34952);
var _progressstyle = __webpack_require__(67614);
var _sizes = __webpack_require__(82699);
var _style = __webpack_require__(65082);
var _focus = __webpack_require__(78506);
var _cardconstants = __webpack_require__(20910);
var _colors = __webpack_require__(8426);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var getIconViewBox = (0, _memoize.default)(function(screenSize) {
    return {
        h: _cardconstants.ICON_HEIGHT[screenSize]
    };
});
var colors = {
    text: (0, _theme.makeThemeColor)(_theme.PRIMARY),
    border: _cardconstants.BORDER_COLOR,
    innerBorder: _cardconstants.INNER_BORDER_COLOR,
    overlayTop: (0, _theme.makeThemeColor)(_theme.TERTIARY, 0),
    overlayBottom: (0, _theme.makeThemeColor)(_theme.TERTIARY),
    highlight: _cardconstants.HIGHLIGHT_COLOR
};
var _obj;
var IMAGE_OFFSET = (_obj = {}, _define_property._(_obj, _constants.HD, _focus.BORDER_WIDTH[_constants.HD] * 2), _define_property._(_obj, _constants.FULL_HD, _focus.BORDER_WIDTH[_constants.FULL_HD] * 2), _obj);
var getIcon = function(icons, position) {
    return icons ? icons[_cardconstants.ICONS[position]] : null;
};
var makeBasicTextStyle = function(param) {
    var font = param.font, _param_colorMode = param.colorMode, colorMode = _param_colorMode === void 0 ? _theme.DEFAULT_MODE : _param_colorMode;
    return {
        color: colors.text[colorMode],
        text: _object_spread_props._(_object_spread._({}, font), {
            verticalAlign: "middle",
            wordWrap: false,
            textOverflow: "..."
        })
    };
};
var makeBasicIconStyle = function() {
    return {
        alpha: 0.8,
        y: _cardconstants.ICON_PADDING_VERTICAL
    };
};
var getDetailsPosition = (0, _memoize.default)(function() {
    var hasHighlightText = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
    return hasHighlightText ? {
        mountX: 1,
        x: _sizes.identity
    } : {
        mountX: 0,
        x: 0
    };
});
var getInitialStyle = (0, _memoize.default)(function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext, _ref_screenSize = _ref.screenSize, screenSize = _ref_screenSize === void 0 ? _constants.FULL_HD : _ref_screenSize, _ref_colorMode = _ref.colorMode, colorMode = _ref_colorMode === void 0 ? _theme.DEFAULT_MODE : _ref_colorMode;
    return {
        zIndex: _style.UNFOCUSED_Z_INDEX,
        Border: {
            zIndex: 1,
            x: -_focus.BORDER_WIDTH[screenSize],
            y: -_focus.BORDER_WIDTH[screenSize],
            shader: {
                outline: _focus.BORDER_WIDTH[screenSize],
                radius: _focus.BORDER_RADIUS[screenSize],
                strokeColor: _colors.TRANSPARENT
            }
        },
        Image: {
            zIndex: 2,
            shader: {
                radius: _focus.BORDER_RADIUS[screenSize],
                progressHeight: _progressstyle.HEIGHT,
                progressBackgroundColor: _progressstyle.colors.background[colorMode],
                progressBarColor: _progressstyle.colors.bar[colorMode]
            }
        },
        TopLeftIcon: {
            zIndex: 3,
            x: _cardconstants.ICON_PADDING_HORIZONTAL,
            y: _cardconstants.ICON_PADDING_VERTICAL
        },
        TopRightIcon: _object_spread_props._(_object_spread._({
            zIndex: 3
        }, makeBasicIconStyle()), {
            visible: _cardconstants.DISPLAY_ICONS,
            mountX: 1,
            x: function(width) {
                return width - _cardconstants.ICON_PADDING_HORIZONTAL;
            },
            y: _cardconstants.ICON_PADDING_VERTICAL
        }),
        BottomRightIcon: {
            zIndex: 3,
            mount: 1,
            x: function(w) {
                return w - _cardconstants.ICON_PADDING_HORIZONTAL;
            },
            visible: _cardconstants.DISPLAY_ICONS,
            alpha: 0.8
        },
        Incentive: {
            zIndex: 0
        },
        ExtraTitle: {
            color: colors.text[colorMode],
            text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_cardconstants.EXTRA_TITLE_FONT_NAME, screenSize, _cardconstants.EXTRA_TITLE_FONT_TYPE)), {
                verticalAlign: "middle",
                wordWrap: true,
                maxLines: _cardconstants.EXTRA_TITLE_LINES,
                maxLinesSuffix: "..."
            }),
            colorMode: colorMode
        },
        Title: makeBasicTextStyle({
            font: (0, _typography.getFont)(_cardconstants.TITLE_FONT_NAME, screenSize, _cardconstants.TITLE_FONT_TYPE),
            colorMode: colorMode
        }),
        Highlight: {
            text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT.BERLIN_1, screenSize)), {
                verticalAlign: "middle",
                wordWrap: false,
                textOverflow: "...",
                textColor: colors.highlight[colorMode]
            })
        },
        Details: _object_spread_props._(_object_spread._({}, makeBasicTextStyle({
            font: (0, _typography.getFont)(_typography.FONT.BERLIN_1, screenSize),
            colorMode: colorMode
        }), getDetailsPosition()), {
            alpha: 0.6
        }),
        ProgressBar: {
            mountY: 1
        }
    };
}, _style.cacheResolver);
var getFocusedStyle = (0, _memoize.default)(function(param) {
    var colorMode = param.colorMode;
    return {
        zIndex: _style.FOCUSED_Z_INDEX,
        Border: {
            smooth: {
                scale: _focus.SCALE_FOCUSED,
                "shader.strokeColor": colors.border[colorMode],
                "shader.innerColor": colors.innerBorder[colorMode],
                "shader.scale": _focus.SCALE_FOCUSED
            }
        },
        Image: {
            smooth: {
                scale: _focus.SCALE_FOCUSED,
                "shader.scale": _focus.SCALE_FOCUSED
            }
        }
    };
}, _style.cacheResolver);
var unFocusedStyle = {
    zIndex: _style.UNFOCUSED_Z_INDEX,
    Border: {
        smooth: {
            scale: 1,
            "shader.strokeColor": _colors.TRANSPARENT,
            "shader.innerColor": _colors.TRANSPARENT,
            "shader.scale": 1.0
        }
    },
    Image: {
        smooth: {
            scale: 1,
            "shader.scale": 1.0
        }
    }
};


/***/ }),

/***/ 67453:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BORDER_COLOR: function() {
        return BORDER_COLOR;
    },
    DISPLAY_DETAILS: function() {
        return DISPLAY_DETAILS;
    },
    DISPLAY_EXTRA_TITLE: function() {
        return DISPLAY_EXTRA_TITLE;
    },
    DISPLAY_ICONS: function() {
        return DISPLAY_ICONS;
    },
    DISPLAY_TITLE: function() {
        return DISPLAY_TITLE;
    },
    EXTRA_TITLE_FONT_NAME: function() {
        return EXTRA_TITLE_FONT_NAME;
    },
    EXTRA_TITLE_FONT_TYPE: function() {
        return EXTRA_TITLE_FONT_TYPE;
    },
    EXTRA_TITLE_LINES: function() {
        return EXTRA_TITLE_LINES;
    },
    HIGHLIGHT_COLOR: function() {
        return HIGHLIGHT_COLOR;
    },
    ICONS: function() {
        return ICONS;
    },
    ICONS_TYPES: function() {
        return ICONS_TYPES;
    },
    IMAGE_MARGIN_BOTTOM: function() {
        return IMAGE_MARGIN_BOTTOM;
    },
    INCENTIVE_HEIGHT: function() {
        return _incentivestyle.HEIGHT;
    },
    INNER_BORDER_COLOR: function() {
        return INNER_BORDER_COLOR;
    },
    ITEMS_BY_BREAKPOINTS: function() {
        return ITEMS_BY_BREAKPOINTS;
    },
    TITLES_ORDER: function() {
        return TITLES_ORDER;
    },
    TITLE_FONT_NAME: function() {
        return TITLE_FONT_NAME;
    },
    TITLE_FONT_TYPE: function() {
        return TITLE_FONT_TYPE;
    },
    templates: function() {
        return templates;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(88801);
var _constants = __webpack_require__(34952);
var _typography = __webpack_require__(18411);
var _theme = __webpack_require__(51397);
var _templates = __webpack_require__(88229);
var _iconcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(70160));
var _badgecomponent = __webpack_require__(69289);
var _incentivestyle = __webpack_require__(64443);
var DISPLAY_ICONS = true;
var DISPLAY_TITLE = true;
var DISPLAY_EXTRA_TITLE = true;
var DISPLAY_DETAILS = false;
var IMAGE_MARGIN_BOTTOM = 8;
var EXTRA_TITLE_FONT_NAME = _typography.FONT.OTTAWA_3;
var EXTRA_TITLE_FONT_TYPE = _typography.FONT_TYPE.MAIN;
var TITLE_FONT_NAME = _typography.FONT.MADRID_3;
var TITLE_FONT_TYPE = _typography.FONT_TYPE.MAIN;
var TITLES_ORDER = [
    "ExtraTitle",
    "Title"
];
var EXTRA_TITLE_LINES = 2;
var BORDER_COLOR = (0, _theme.makeThemeColor)(_theme.PRIMARY);
var INNER_BORDER_COLOR = (0, _theme.makeThemeColor)(_theme.TERTIARY);
var HIGHLIGHT_COLOR = (0, _theme.makeThemeColor)(_theme.QUATERNARY);
var _obj;
var ICONS = (_obj = {}, _define_property._(_obj, _templates.ICON_POSITION.TOP_LEFT, 2), _define_property._(_obj, _templates.ICON_POSITION.TOP_RIGHT, 4), _define_property._(_obj, _templates.ICON_POSITION.BOTTOM_RIGHT, 1), _obj);
var _obj1;
var ICONS_TYPES = (_obj1 = {}, _define_property._(_obj1, _templates.ICON_POSITION.TOP_LEFT, _iconcomponent.default), _define_property._(_obj1, _templates.ICON_POSITION.TOP_RIGHT, _badgecomponent.Badge), _define_property._(_obj1, _templates.ICON_POSITION.BOTTOM_RIGHT, _iconcomponent.default), _obj1);
var templates = {
    CardS: "CardS",
    CardM: "CardM",
    CardL: "CardL"
};
var _obj2, _obj3, _obj4, _obj5;
var ITEMS_BY_BREAKPOINTS = (_obj5 = {}, _define_property._(_obj5, templates.CardS, (_obj2 = {}, _define_property._(_obj2, _constants.HD, 6), _define_property._(_obj2, _constants.FULL_HD, 8), _obj2)), _define_property._(_obj5, templates.CardM, (_obj3 = {}, _define_property._(_obj3, _constants.HD, 6), _define_property._(_obj3, _constants.FULL_HD, 6), _obj3)), _define_property._(_obj5, templates.CardL, (_obj4 = {}, _define_property._(_obj4, _constants.HD, 5), _define_property._(_obj4, _constants.FULL_HD, 5), _obj4)), _obj5);


/***/ }),

/***/ 14530:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return Cover;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(88801);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _textures = __webpack_require__(67179);
var _signals = __webpack_require__(2109);
var _focuscomponent = __webpack_require__(4069);
var _coverstyle = __webpack_require__(24259);
var _coverconstants = __webpack_require__(78286);
var Cover = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(Cover, _Lightning_Component);
    var _super = _create_super._(Cover);
    function Cover() {
        _class_call_check._(this, Cover);
        return _super.apply(this, arguments);
    }
    _create_class._(Cover, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _coverstyle.defaultContext;
            }
        },
        {
            key: "_inactive",
            value: function _inactive() {
                this.signal(_signals.INACTIVE_SIGNAL, this);
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                this.tag("Image").removeAllListeners("txLoaded");
                this._item = undefined;
                this.signal(_signals.DETACHED_SIGNAL, this);
            }
        },
        {
            key: "item",
            get: function get() {
                return this._item;
            },
            set: function set(param) {
                var content = param.content, colorMode = param.colorScheme;
                var _this = this;
                if (this._item && this._item.id === content.id) {
                    this._item = content;
                    return;
                }
                this._item = content;
                if (this._style.colorMode !== colorMode) {
                    this._style = {
                        screenSize: this._style.screenSize,
                        colorMode: colorMode
                    };
                }
                var _this__item = this._item, image = _this__item.image, title = _this__item.title;
                this.tag("Image").once("txLoaded", function() {
                    _this.tag("Image").setSmooth("alpha", 1);
                });
                this.patch({
                    Border: {
                        colorMode: colorMode
                    },
                    Image: {
                        alpha: _textures.UNLOADED_TEXTURE_ALPHA,
                        src: image.src
                    },
                    Label: {
                        visible: Boolean(title),
                        color: _coverstyle.colors.text[colorMode],
                        text: {
                            text: title
                        }
                    }
                });
            }
        },
        {
            key: "_focus",
            value: function _focus() {
                this.patch(_coverstyle.focusedStyle);
            }
        },
        {
            key: "_unfocus",
            value: function _unfocus() {
                this.patch(_coverstyle.unFocusedStyle);
            }
        },
        {
            key: "_handleEnter",
            value: function _handleEnter() {
                this.signal(_signals.SELECTED_SIGNAL, this._item);
                return true;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Border: {
                        type: _focuscomponent.CoverFocus
                    },
                    Image: {
                        rtt: true,
                        shader: {
                            type: _sdk.Lightning.shaders.RoundedRectangle
                        }
                    },
                    Label: {}
                }, (0, _coverstyle.getInitialStyle)());
            }
        }
    ]);
    return Cover;
}(_sdk.Lightning.Component);
Cover.Templates = _coverconstants.templates;
Cover.Sizes = _coverconstants.sizes;
Cover.ImageOptions = _coverconstants.imageOptions;


/***/ }),

/***/ 78286:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    imageOptions: function() {
        return imageOptions;
    },
    sizes: function() {
        return sizes;
    },
    templates: function() {
        return templates;
    }
});
var _define_property = __webpack_require__(21228);
var _export_star = __webpack_require__(37668);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(45538);
var _constants = __webpack_require__(34952);
_export_star._(__webpack_require__(87878), exports);
var templates = {
    Cover: "Cover"
};
var _obj;
var sizes = _define_property._({}, templates.Cover, (_obj = {}, _define_property._(_obj, _constants.HD, {
    w: 136,
    h: 232
}), _define_property._(_obj, _constants.FULL_HD, {
    w: 208,
    h: 336
}), _obj));
var commonImageOptions = {
    format: _constants.TRANSPARENT_IMAGE_FORMAT,
    fit: "scale_crop"
};
var _obj1;
var imageOptions = _define_property._({}, templates.Cover, (_obj1 = {}, _define_property._(_obj1, _constants.HD, {
    PRIMARY: _object_spread_props._(_object_spread._({}, commonImageOptions), {
        width: 128,
        height: 128
    })
}), _define_property._(_obj1, _constants.FULL_HD, {
    PRIMARY: _object_spread_props._(_object_spread._({}, commonImageOptions), {
        width: 192,
        height: 192
    })
}), _obj1));


/***/ }),

/***/ 24259:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ALPHA_FOCUSED: function() {
        return ALPHA_FOCUSED;
    },
    ALPHA_UNFOCUSED: function() {
        return ALPHA_UNFOCUSED;
    },
    IMAGE_PADDING_BOTTOM: function() {
        return IMAGE_PADDING_BOTTOM;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    focusedStyle: function() {
        return focusedStyle;
    },
    getBorderDiameter: function() {
        return getBorderDiameter;
    },
    getBorderTexture: function() {
        return getBorderTexture;
    },
    getImageRadius: function() {
        return getImageRadius;
    },
    getImageSize: function() {
        return getImageSize;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    unFocusedStyle: function() {
        return unFocusedStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(42578);
var _constants = __webpack_require__(34952);
var _sdk = __webpack_require__(29956);
var _theme = __webpack_require__(51397);
var _typography = __webpack_require__(18411);
var _coverconstants = __webpack_require__(78286);
var _colors = __webpack_require__(8426);
var _sizes = __webpack_require__(82699);
var _focus = __webpack_require__(78506);
var defaultContext = {
    screenSize: (0, _sizes.getScreenSize)(),
    colorMode: _theme.DEFAULT_MODE
};
var _obj;
var IMAGE_PADDING_BOTTOM = (_obj = {}, _define_property._(_obj, _constants.HD, 16), _define_property._(_obj, _constants.FULL_HD, 24), _obj);
var ALPHA_FOCUSED = 1;
var ALPHA_UNFOCUSED = 0.6;
var colors = {
    text: (0, _theme.makeThemeColor)(_theme.PRIMARY)
};
var getImageSize = function(screenSize) {
    return _coverconstants.imageOptions[_coverconstants.templates.Cover][screenSize].PRIMARY;
};
var getImageRadius = function(screenSize) {
    return Math.round(getImageSize(screenSize).width / 2);
};
var getBorderDiameter = function(screenSize) {
    return getImageSize(screenSize).width + _focus.BORDER_WIDTH[screenSize] * 2;
};
var getBorderTexture = function(context) {
    var screenSize = context.screenSize;
    var diameter = getBorderDiameter(screenSize);
    return _sdk.Lightning.Tools.getRoundRect(diameter, diameter, getImageRadius(screenSize) + _focus.BORDER_WIDTH[screenSize], // NOTE: while border width should be equal to 3px, we adding an extra pixel to ensure there will be no gap between image and border
    _focus.BORDER_WIDTH[screenSize] + 1, _colors.WHITE, true, _colors.TRANSPARENT);
};
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var _context_screenSize = context.screenSize, screenSize = _context_screenSize === void 0 ? _constants.FULL_HD : _context_screenSize;
    var w = _coverconstants.sizes[_coverconstants.templates.Cover][screenSize].w;
    var imageSize = getImageSize(screenSize);
    var borderOffset = -_focus.BORDER_WIDTH[screenSize];
    return {
        alpha: ALPHA_UNFOCUSED,
        Border: {
            alpha: 0,
            radius: getImageRadius(screenSize),
            x: borderOffset,
            y: borderOffset
        },
        Image: {
            w: imageSize.width,
            h: imageSize.height,
            shader: {
                radius: getImageRadius(screenSize)
            }
        },
        Label: {
            y: imageSize.height + IMAGE_PADDING_BOTTOM[screenSize],
            w: w,
            text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT.KINSHASA_3, screenSize, _coverconstants.LABEL_TEXT_TYPE)), {
                verticalAlign: "middle",
                textAlign: "center",
                wordBreak: true,
                advancedRenderer: true,
                maxLinesSuffix: "...",
                maxLines: 2,
                textOverflow: "ellipsis"
            })
        }
    };
};
var focusedStyle = {
    alpha: ALPHA_FOCUSED,
    Border: {
        smooth: {
            alpha: 1,
            scale: 1.05
        }
    },
    Image: {
        smooth: {
            scale: 1.05
        }
    }
};
var unFocusedStyle = {
    alpha: ALPHA_UNFOCUSED,
    Border: {
        smooth: {
            alpha: 0,
            scale: 1
        }
    },
    Image: {
        smooth: {
            scale: 1
        }
    }
};


/***/ }),

/***/ 87878:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "LABEL_TEXT_TYPE", ({
    enumerable: true,
    get: function() {
        return LABEL_TEXT_TYPE;
    }
}));
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(45538);
var _typography = __webpack_require__(18411);
var LABEL_TEXT_TYPE = _typography.FONT_TYPE.MAIN;


/***/ }),

/***/ 66174:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BORDER_COLOR: function() {
        return BORDER_COLOR;
    },
    BORDER_WIDTH: function() {
        return _focus.BORDER_WIDTH;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getBorderTexture: function() {
        return getBorderTexture;
    }
});
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
var _memoize = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34736));
var _theme = __webpack_require__(51397);
var _sdk = __webpack_require__(29956);
var _sizes = __webpack_require__(82699);
var _focus = __webpack_require__(78506);
var _colors = __webpack_require__(8426);
var defaultContext = {
    screenSize: (0, _sizes.getScreenSize)(),
    colorMode: _theme.DEFAULT_MODE
};
var BORDER_COLOR = (0, _theme.makeThemeColor)(_theme.PRIMARY);
var getBorderTexture = (0, _memoize.default)(function(param, radius) {
    var screenSize = param.screenSize, colorMode = param.colorMode;
    var diameter = radius * 2 + _focus.BORDER_WIDTH[screenSize] * 2;
    return _sdk.Lightning.Tools.getRoundRect(diameter, diameter, radius + _focus.BORDER_WIDTH[screenSize], // NOTE: while border width should be equal to 3px, we adding an extra pixel to ensure there will be no gap between image and border
    _focus.BORDER_WIDTH[screenSize] + 1, BORDER_COLOR[colorMode], true, _colors.TRANSPARENT);
}, function(param, radius) {
    var screenSize = param.screenSize, colorMode = param.colorMode;
    return "".concat(screenSize, "_").concat(colorMode, "_").concat(radius);
});


/***/ }),

/***/ 83236:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "CoverFocus", ({
    enumerable: true,
    get: function() {
        return CoverFocus;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _focusstyle = __webpack_require__(75740);
var CoverFocus = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(CoverFocus, _Lightning_Component);
    var _super = _create_super._(CoverFocus);
    function CoverFocus() {
        _class_call_check._(this, CoverFocus);
        return _super.apply(this, arguments);
    }
    _create_class._(CoverFocus, [
        {
            key: "_construct",
            value: function _construct() {
                this._radius = 0;
                this._style = _focusstyle.defaultContext;
            }
        },
        {
            key: "radius",
            get: function get() {
                return this._radius;
            },
            set: function set(value) {
                if (value !== this._radius) {
                    this._radius = value;
                    var borderWidth = _focusstyle.BORDER_WIDTH[this._style.screenSize];
                    var size = this._radius * 2 + borderWidth * 2;
                    this.patch({
                        w: size,
                        h: size,
                        texture: (0, _focusstyle.getOuterBorderTexture)(this._style, this._radius),
                        Inner: {
                            w: size - borderWidth,
                            h: size - borderWidth,
                            texture: (0, _focusstyle.getInnerBorderTexture)(this._style, this._radius)
                        }
                    });
                }
            }
        },
        {
            key: "colorMode",
            get: function get() {
                return this._colorMode;
            },
            set: function set(value) {
                if (value !== this._style.colorMode) {
                    this._style = {
                        screenSize: this._style.screenSize,
                        colorMode: value
                    };
                    this.patch({
                        texture: (0, _focusstyle.getOuterBorderTexture)(this._style, this._radius),
                        Inner: {
                            texture: (0, _focusstyle.getInnerBorderTexture)(this._style, this._radius)
                        }
                    });
                }
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Inner: {}
                }, (0, _focusstyle.getInitialStyle)());
            }
        }
    ]);
    return CoverFocus;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 75740:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BORDER_WIDTH: function() {
        return _focus.BORDER_WIDTH;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    getInnerBorderTexture: function() {
        return getInnerBorderTexture;
    },
    getOuterBorderTexture: function() {
        return getOuterBorderTexture;
    }
});
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
var _memoize = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34736));
var _theme = __webpack_require__(51397);
var _sdk = __webpack_require__(29956);
var _sizes = __webpack_require__(82699);
var _focus = __webpack_require__(78506);
var _colors = __webpack_require__(8426);
var _focusstyle = __webpack_require__(66174);
var defaultContext = {
    screenSize: (0, _sizes.getScreenSize)(),
    colorMode: _theme.DEFAULT_MODE
};
var getOuterBorderTexture = (0, _memoize.default)(function(param, radius) {
    var screenSize = param.screenSize, colorMode = param.colorMode;
    var diameter = radius * 2;
    return _sdk.Lightning.Tools.getRoundRect(diameter, diameter, radius, _focus.BORDER_WIDTH[screenSize] / 2, _focusstyle.BORDER_COLOR[colorMode], true, _colors.TRANSPARENT);
}, function(param, radius) {
    var screenSize = param.screenSize, colorMode = param.colorMode;
    return "".concat(screenSize, "_").concat(colorMode, "_").concat(radius);
});
var getInnerBorderTexture = (0, _memoize.default)(function(param, radius) {
    var screenSize = param.screenSize, colorMode = param.colorMode;
    var diameter = radius * 2;
    var borderWidth = _focus.BORDER_WIDTH[screenSize] / 2;
    return _sdk.Lightning.Tools.getRoundRect(diameter, diameter, radius, // NOTE: while border width should be equal to 2px, we adding an extra pixel to ensure there will be no gap between image and border
    borderWidth + 1, _focus.INNER_BORDER_COLOR[colorMode], true, _colors.TRANSPARENT);
}, function(param, radius) {
    var screenSize = param.screenSize, colorMode = param.colorMode;
    return "".concat(screenSize, "_").concat(colorMode, "_").concat(radius);
});
var getInitialStyle = function() {
    var screenSize = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext).screenSize;
    var borderWidth = _focus.BORDER_WIDTH[screenSize] / 2;
    return {
        Inner: {
            x: borderWidth,
            y: borderWidth
        }
    };
};


/***/ }),

/***/ 4069:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _export_star = __webpack_require__(37668);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(52318);
_export_star._(__webpack_require__(83236), exports);


/***/ }),

/***/ 18216:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    INNER_BORDER_COLOR: function() {
        return INNER_BORDER_COLOR;
    },
    ITEMS_BY_BREAKPOINTS: function() {
        return ITEMS_BY_BREAKPOINTS;
    }
});
var _define_property = __webpack_require__(21228);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(42578);
var _constants = __webpack_require__(34952);
var _theme = __webpack_require__(51397);
var INNER_BORDER_COLOR = (0, _theme.makeThemeColor)(_theme.TERTIARY);
var _obj;
var ITEMS_BY_BREAKPOINTS = (_obj = {}, _define_property._(_obj, _constants.HD, 6), _define_property._(_obj, _constants.FULL_HD, 6), _obj);


/***/ }),

/***/ 65602:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return FlatRectangle;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _create_super = __webpack_require__(6400);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(52318);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _flatRectangleconstants = __webpack_require__(29687);
var _templates = __webpack_require__(88229);
var _focusshader = /*#__PURE__*/ _interop_require_default._(__webpack_require__(25906));
var _imageshader = /*#__PURE__*/ _interop_require_default._(__webpack_require__(17154));
var _signals = __webpack_require__(2109);
var _flatRectanglestyle = __webpack_require__(44790);
var FlatRectangle = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(FlatRectangle, _Lightning_Component);
    var _super = _create_super._(FlatRectangle);
    function FlatRectangle() {
        _class_call_check._(this, FlatRectangle);
        return _super.apply(this, arguments);
    }
    _create_class._(FlatRectangle, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _object_spread._({}, _flatRectanglestyle.defaultContext);
            }
        },
        {
            key: "_inactive",
            value: function _inactive() {
                this.signal(_signals.INACTIVE_SIGNAL, this);
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                this._item = undefined;
                this.signal(_signals.DETACHED_SIGNAL, this);
            }
        },
        {
            key: "item",
            get: function get() {
                return this._item;
            },
            set: function set(param) {
                var content = param.content, _param_colorScheme = param.colorScheme, colorScheme = _param_colorScheme === void 0 ? this._style.colorMode : _param_colorScheme;
                if ((0, _templates.areContentItemsEqual)(this._item, content)) {
                    this._item = content;
                    return;
                }
                this._item = content;
                if (colorScheme && colorScheme !== this._style.colorMode) {
                    this._style = {
                        screenSize: this._style.screenSize,
                        colorMode: colorScheme
                    };
                }
                var _this__item = this._item, image = _this__item.image, title = _this__item.title;
                var src = image ? image.src : "";
                this.patch({
                    Image: {
                        src: src
                    },
                    Title: {
                        text: {
                            text: title || ""
                        }
                    }
                });
            }
        },
        {
            key: "_focus",
            value: function _focus() {
                this.patch((0, _flatRectanglestyle.getFocusedStyle)(this._style));
            }
        },
        {
            key: "_unfocus",
            value: function _unfocus() {
                this.patch(_flatRectanglestyle.unFocusedStyle);
            }
        },
        {
            key: "_handleEnter",
            value: function _handleEnter() {
                this.signal(_signals.SELECTED_SIGNAL, this._item);
                return true;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Border: {
                        rect: true,
                        shader: {
                            type: _focusshader.default
                        }
                    },
                    Image: {
                        shader: {
                            type: _imageshader.default
                        }
                    },
                    Title: {}
                }, (0, _flatRectanglestyle.getInitialStyle)());
            }
        }
    ]);
    return FlatRectangle;
}(_sdk.Lightning.Component);
FlatRectangle.Templates = _flatRectangleconstants.templates;
FlatRectangle.Sizes = _flatRectangleconstants.sizes;
FlatRectangle.ImageOptions = _flatRectangleconstants.imageOptions;


/***/ }),

/***/ 29687:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    imageOptions: function() {
        return imageOptions;
    },
    sizes: function() {
        return sizes;
    },
    templates: function() {
        return templates;
    }
});
var _define_property = __webpack_require__(21228);
var _export_star = __webpack_require__(37668);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(37815);
var _constants = __webpack_require__(34952);
var _theme = __webpack_require__(51397);
var _sizes = __webpack_require__(82699);
var _flatRectangleconstants = _export_star._(__webpack_require__(18216), exports);
var templates = {
    FlatRectangle: "FlatRectangle"
};
var RATIO = 4 / 15;
var sizes = (0, _sizes.getElementSize)(_flatRectangleconstants.ITEMS_BY_BREAKPOINTS, RATIO, templates.FlatRectangle).sizes;
var imageOptions = [
    _constants.HD,
    _constants.FULL_HD
].reduce(function(result, breakpoint) {
    result[templates.FlatRectangle][breakpoint] = _define_property._({}, _theme.PRIMARY, {
        width: sizes[templates.FlatRectangle][breakpoint].w * 2,
        height: sizes[templates.FlatRectangle][breakpoint].h * 2
    });
    return result;
}, _define_property._({}, templates.FlatRectangle, {}));


/***/ }),

/***/ 44790:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    SHADOW_OFFSET_X: function() {
        return SHADOW_OFFSET_X;
    },
    SHADOW_OFFSET_Y: function() {
        return SHADOW_OFFSET_Y;
    },
    TITLE_HEIGHT: function() {
        return TITLE_HEIGHT;
    },
    TITLE_MARGIN: function() {
        return TITLE_MARGIN;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getFocusedStyle: function() {
        return getFocusedStyle;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    unFocusedStyle: function() {
        return unFocusedStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(52318);
var _memoize = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34736));
var _theme = __webpack_require__(51397);
var _typography = __webpack_require__(18411);
var _constants = __webpack_require__(34952);
var _focus = __webpack_require__(78506);
var _style = __webpack_require__(65082);
var _colors = __webpack_require__(8426);
var _flatRectangleconstants = __webpack_require__(29687);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var colors = {
    title: (0, _theme.makeThemeColor)(_theme.PRIMARY),
    shadowColor: (0, _theme.makeThemeColor)(_theme.TERTIARY),
    border: (0, _theme.makeThemeColor)(_theme.PRIMARY),
    innerBorder: _flatRectangleconstants.INNER_BORDER_COLOR
};
var _obj;
var TITLE_MARGIN = (_obj = {}, _define_property._(_obj, _constants.HD, 12), _define_property._(_obj, _constants.FULL_HD, 16), _obj);
var _obj1;
var TITLE_HEIGHT = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 30), _define_property._(_obj1, _constants.FULL_HD, 36), _obj1);
var SHADOW_OFFSET_X = 2;
var SHADOW_OFFSET_Y = 2;
var getInitialStyle = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext, screenSize = _ref.screenSize, colorMode = _ref.colorMode;
    var width = _flatRectangleconstants.sizes[_flatRectangleconstants.templates.FlatRectangle][screenSize].w;
    var height = _flatRectangleconstants.sizes[_flatRectangleconstants.templates.FlatRectangle][screenSize].h;
    var titleWidth = Math.floor(width - TITLE_MARGIN[screenSize] * 2);
    var titleMarginTop = Math.floor(height / 2 - TITLE_HEIGHT[screenSize] / 2);
    var offset = _focus.BORDER_WIDTH[screenSize] * 2;
    return {
        zIndex: _style.UNFOCUSED_Z_INDEX,
        w: width,
        h: height,
        Border: {
            x: -_focus.BORDER_WIDTH[screenSize],
            y: -_focus.BORDER_WIDTH[screenSize],
            w: width + offset,
            h: height + offset,
            shader: {
                outline: _focus.BORDER_WIDTH[screenSize],
                radius: _focus.BORDER_RADIUS[screenSize],
                strokeColor: _colors.TRANSPARENT
            }
        },
        Image: {
            w: width,
            h: height,
            shader: {
                radius: _focus.BORDER_RADIUS[screenSize]
            }
        },
        Title: {
            w: titleWidth,
            x: TITLE_MARGIN[screenSize],
            y: titleMarginTop,
            text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT.OTTAWA_2, screenSize)), {
                textColor: colors.title[colorMode],
                textAlign: "center",
                maxLines: 1,
                maxLinesSuffix: "...",
                verticalAlign: "middle",
                shadow: true,
                shadowColor: colors.shadowColor[colorMode],
                shadowOffsetX: SHADOW_OFFSET_X,
                shadowOffsetY: SHADOW_OFFSET_Y
            })
        }
    };
};
var getFocusedStyle = (0, _memoize.default)(function(param) {
    var colorMode = param.colorMode;
    return {
        zIndex: _style.FOCUSED_Z_INDEX,
        Border: {
            smooth: {
                scale: _focus.SCALE_FOCUSED,
                "shader.strokeColor": colors.border[colorMode],
                "shader.innerColor": colors.innerBorder[colorMode],
                "shader.scale": _focus.SCALE_FOCUSED
            }
        },
        Image: {
            smooth: {
                scale: _focus.SCALE_FOCUSED,
                "shader.scale": _focus.SCALE_FOCUSED
            }
        }
    };
}, _style.cacheResolver);
var unFocusedStyle = {
    zIndex: _style.UNFOCUSED_Z_INDEX,
    Border: {
        smooth: {
            scale: 1,
            "shader.strokeColor": _colors.TRANSPARENT,
            "shader.innerColor": _colors.TRANSPARENT,
            "shader.scale": 1.0
        }
    },
    Image: {
        smooth: {
            scale: 1,
            "shader.scale": 1.0
        }
    }
};


/***/ }),

/***/ 26908:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return Hero;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _create_super = __webpack_require__(6400);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(65759);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _herostyle = __webpack_require__(56339);
var _heroconstants = __webpack_require__(65517);
var _heroOverlaycomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(10169));
var _heroMetadatacomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(19225));
var _heroNavcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(50209));
var _heroNavstyle = __webpack_require__(45055);
var _signals = __webpack_require__(2109);
var _rowcomponent = __webpack_require__(53565);
var Hero = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(Hero, _Lightning_Component);
    var _super = _create_super._(Hero);
    function Hero() {
        _class_call_check._(this, Hero);
        return _super.apply(this, arguments);
    }
    _create_class._(Hero, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _herostyle.defaultContext;
                this._contentPadding = 0;
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                this._items = undefined;
                this._style = undefined;
                this._index = undefined;
                this._contentPadding = 0;
            }
        },
        {
            key: "id",
            get: function get() {
                return this._id;
            }
        },
        {
            key: "data",
            get: function get() {
                return this._data;
            },
            set: function set(value) {
                var block = value.block;
                this._id = block.id;
                this._items = block.content.items;
                // NOTE: in order to follow Bedrock Design System language, Hero is an item and SlideShow is a block, so placing actual item here
                this.tag("Items").data = _object_spread_props._(_object_spread._({}, value), {
                    itemType: _heroNavcomponent.default,
                    itemTemplate: "HeroPoster",
                    itemSize: _heroNavstyle.sizes[this._style.screenSize]
                });
                this._setIndex(this.focusedIndex);
            }
        },
        {
            key: "contentPadding",
            get: function get() {
                return this._contentPadding;
            },
            set: function set(value) {
                if (value === this._contentPadding) {
                    return;
                }
                this._contentPadding = Number.isFinite(value) ? value : 0;
                var screenSize = this._style.screenSize;
                var x = this._contentPadding;
                var backgroundOffset = _herostyle.BACKGROUND_CONTENT_OFFSET[screenSize];
                var backgroundSize = _heroconstants.imageOptions[_heroconstants.templates.Hero][screenSize].PRIMARY;
                var w = backgroundSize.width - x + backgroundOffset;
                var h = Math.round(backgroundSize.height * (w / backgroundSize.width));
                this.patch({
                    Background: {
                        w: w,
                        h: h
                    },
                    Gradient: {
                        w: w,
                        h: h
                    },
                    Metadata: {
                        x: x
                    },
                    Items: {
                        x: x,
                        leftPadding: value
                    }
                });
            }
        },
        {
            key: "background",
            set: function set(value) {
                this.tag("Background").src = value;
            }
        },
        {
            key: "focusMode",
            get: function get() {
                return this.tag("Items").focusMode;
            },
            set: function set(value) {
                this.tag("Items").focusMode = value;
            }
        },
        {
            key: "focusedIndex",
            get: function get() {
                return this.tag("Items").focusedIndex;
            },
            set: function set(value) {
                this.tag("Items").focusedIndex = value;
                this._setIndex(value);
            }
        },
        {
            key: "_getFocused",
            value: function _getFocused() {
                return this.tag("Items");
            }
        },
        {
            key: "_setIndex",
            value: function _setIndex(index) {
                if (!this._items || !this._items.length || index === this._index) {
                    return;
                }
                this._index = Number.isFinite(index) ? index : 0;
                var currentItem = this._items[this._index];
                if (currentItem) {
                    this.tag("Metadata").item = currentItem;
                }
                this.background = (0, _get.default)(this._items, "[".concat(this._index, "].image.src"), "");
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                var _obj;
                return (0, _merge.default)({
                    Background: {},
                    Gradient: {
                        type: _heroOverlaycomponent.default
                    },
                    Metadata: {
                        type: _heroMetadatacomponent.default
                    },
                    Items: {
                        type: _rowcomponent.Row,
                        signals: _define_property._({}, _signals.FOCUSED_SIGNAL, "_setIndex")
                    },
                    passSignals: (_obj = {}, _define_property._(_obj, _signals.SELECTED_SIGNAL, true), _define_property._(_obj, _signals.PORTION_REQUESTED_SIGNAL, true), _obj)
                }, (0, _herostyle.getInitialStyle)());
            }
        }
    ]);
    return Hero;
}(_sdk.Lightning.Component);
Hero.Templates = _heroconstants.templates;
Hero.Sizes = _heroconstants.sizes;
Hero.ImageOptions = _heroconstants.imageOptions;


/***/ }),

/***/ 65517:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    heroNavSizes: function() {
        return _heroNavstyle.sizes;
    },
    imageOptions: function() {
        return imageOptions;
    },
    sizes: function() {
        return sizes;
    },
    templates: function() {
        return templates;
    }
});
var _define_property = __webpack_require__(21228);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(88801);
var _constants = __webpack_require__(34952);
var _sizes = __webpack_require__(82699);
var _heroNavstyle = __webpack_require__(45055);
var _heroMetadataconstants = __webpack_require__(73344);
var templates = {
    Hero: "Hero"
};
var _obj;
var sizes = _define_property._({}, templates.Hero, (_obj = {}, _define_property._(_obj, _constants.HD, {
    w: _sizes.SCREEN_WIDTH[_constants.HD],
    h: Math.round(_sizes.SCREEN_HEIGHT[_constants.HD] * 0.85)
}), _define_property._(_obj, _constants.FULL_HD, {
    w: _sizes.SCREEN_WIDTH[_constants.FULL_HD],
    h: Math.round(_sizes.SCREEN_HEIGHT[_constants.FULL_HD] * 0.85)
}), _obj));
var _obj1;
var imageOptions = _define_property._({}, templates.Hero, (_obj1 = {}, _define_property._(_obj1, _constants.HD, {
    PRIMARY: {
        width: sizes[templates.Hero][_constants.HD].w,
        height: sizes[templates.Hero][_constants.HD].h
    },
    SECONDARY: {
        width: _heroNavstyle.sizes[_constants.HD].w,
        height: _heroNavstyle.sizes[_constants.HD].h
    },
    LOGO: {
        width: _heroMetadataconstants.logoSize[_constants.HD].w,
        height: _heroMetadataconstants.logoSize[_constants.HD].h,
        fit: _constants.IMAGE_FIT_MAX
    }
}), _define_property._(_obj1, _constants.FULL_HD, {
    PRIMARY: {
        width: sizes[templates.Hero][_constants.FULL_HD].w,
        height: sizes[templates.Hero][_constants.FULL_HD].h
    },
    SECONDARY: {
        width: _heroNavstyle.sizes[_constants.FULL_HD].w,
        height: _heroNavstyle.sizes[_constants.FULL_HD].h
    },
    LOGO: {
        width: _heroMetadataconstants.logoSize[_constants.FULL_HD].w,
        height: _heroMetadataconstants.logoSize[_constants.FULL_HD].h,
        fit: _constants.IMAGE_FIT_MAX
    }
}), _obj1));


/***/ }),

/***/ 56339:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BACKGROUND_CONTENT_OFFSET: function() {
        return BACKGROUND_CONTENT_OFFSET;
    },
    CONTENT_GAP: function() {
        return CONTENT_GAP;
    },
    HEIGHT: function() {
        return HEIGHT;
    },
    METADATA_PADDING_BOTTOM: function() {
        return METADATA_PADDING_BOTTOM;
    },
    PADDING_BOTTOM: function() {
        return PADDING_BOTTOM;
    },
    PADDING_LEFT: function() {
        return PADDING_LEFT;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    getItemsTop: function() {
        return getItemsTop;
    },
    getMetadataBottom: function() {
        return getMetadataBottom;
    },
    sizes: function() {
        return _heroconstants.sizes;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(45538);
var _memoize = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34736));
var _constants = __webpack_require__(34952);
var _style = __webpack_require__(65082);
var _heroNavstyle = __webpack_require__(45055);
var _heroconstants = __webpack_require__(65517);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var CONTENT_GAP = (_obj = {}, _define_property._(_obj, _constants.HD, 12), _define_property._(_obj, _constants.FULL_HD, 12), _obj);
var _obj1;
var HEIGHT = (_obj1 = {}, _define_property._(_obj1, _constants.HD, _heroconstants.sizes[_heroconstants.templates.Hero][_constants.HD].h), _define_property._(_obj1, _constants.FULL_HD, _heroconstants.sizes[_heroconstants.templates.Hero][_constants.FULL_HD].h), _obj1);
var _obj2;
var PADDING_BOTTOM = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 24), _define_property._(_obj2, _constants.FULL_HD, 32), _obj2);
var _obj3;
var PADDING_LEFT = (_obj3 = {}, _define_property._(_obj3, _constants.HD, 32), _define_property._(_obj3, _constants.FULL_HD, 40), _obj3);
var _obj4;
var METADATA_PADDING_BOTTOM = (_obj4 = {}, _define_property._(_obj4, _constants.HD, 24), _define_property._(_obj4, _constants.FULL_HD, 32), _obj4);
var _obj5;
var BACKGROUND_CONTENT_OFFSET = (_obj5 = {}, _define_property._(_obj5, _constants.HD, 40), _define_property._(_obj5, _constants.FULL_HD, 40), _obj5);
var getItemsTop = (0, _memoize.default)(function(screenSize) {
    return HEIGHT[screenSize] - PADDING_BOTTOM[screenSize] - _heroNavstyle.sizes[screenSize].h;
});
var getMetadataBottom = (0, _memoize.default)(function(screenSize) {
    return getItemsTop(screenSize) - METADATA_PADDING_BOTTOM[screenSize];
});
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var screenSize = context.screenSize;
    var itemsTop = getItemsTop(screenSize);
    var metadataBottom = getMetadataBottom(screenSize);
    var size = _heroconstants.sizes[_heroconstants.templates.Hero][screenSize];
    var backgroundSize = _heroconstants.imageOptions[_heroconstants.templates.Hero][screenSize].PRIMARY;
    var background = {
        w: backgroundSize.width,
        h: backgroundSize.height,
        x: size.w,
        mountX: 1
    };
    return _object_spread_props._(_object_spread._({}, size), {
        Background: _object_spread._({}, background),
        Gradient: _object_spread._({}, background),
        Metadata: {
            mountY: 1,
            h: metadataBottom,
            y: metadataBottom
        },
        Items: {
            y: itemsTop,
            rightPadding: _constants.safetyMargins.horizontal[screenSize]
        }
    });
};


/***/ }),

/***/ 73344:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "logoSize", ({
    enumerable: true,
    get: function() {
        return logoSize;
    }
}));
var _define_property = __webpack_require__(21228);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(88801);
var _constants = __webpack_require__(34952);
var _obj;
var logoSize = (_obj = {}, _define_property._(_obj, _constants.HD, {
    w: 251,
    h: 157
}), _define_property._(_obj, _constants.FULL_HD, {
    w: 382,
    h: 215
}), _obj);


/***/ }),

/***/ 45130:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return HeroMetadata;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _create_super = __webpack_require__(6400);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(37815);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _textures = __webpack_require__(67179);
var _iconcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(70160));
var _incentivecomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(9077));
var _incentiveutils = __webpack_require__(72823);
var _heroMetadatastyle = __webpack_require__(56700);
var HeroMetadata = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(HeroMetadata, _Lightning_Component);
    var _super = _create_super._(HeroMetadata);
    function HeroMetadata() {
        _class_call_check._(this, HeroMetadata);
        return _super.apply(this, arguments);
    }
    _create_class._(HeroMetadata, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _heroMetadatastyle.defaultContext;
            }
        },
        {
            key: "item",
            set: function set(value) {
                var title = value.title, extraDetails = value.extraDetails, csaPicto = value.csaPicto, incentives = value.incentives;
                var logo = (0, _get.default)(value, "logo.src", "");
                var sizes = (0, _heroMetadatastyle.getSizes)(this._style.screenSize);
                var isExtraDetailsVisible = Boolean(extraDetails);
                var isCsaIconVisible = Boolean(csaPicto);
                var isIconsRowVisible = isExtraDetailsVisible || isCsaIconVisible;
                var incentiveLines = (0, _incentiveutils.getLinesCount)(incentives);
                this.patch({
                    ProgramLogo: {
                        visible: Boolean(logo),
                        Logo: {
                            texture: _object_spread_props._(_object_spread._({}, (0, _textures.contain)(logo, sizes.programLogo.w, sizes.programLogo.h)), {
                                hasAlpha: true
                            })
                        }
                    },
                    Incentive: {
                        visible: incentiveLines > 0,
                        data: {
                            linesCount: incentiveLines,
                            w: sizes.iconsRow.w,
                            incentives: incentives,
                            colorMode: this._style.colorMode
                        }
                    },
                    Title: {
                        visible: Boolean(title),
                        text: {
                            text: title
                        }
                    },
                    IconsRow: {
                        visible: isIconsRowVisible,
                        ExtraDetails: {
                            visible: isExtraDetailsVisible,
                            text: {
                                text: extraDetails
                            }
                        },
                        CsaIcon: {
                            visible: isCsaIconVisible,
                            iconData: {
                                picto: csaPicto,
                                viewBox: sizes.icon
                            }
                        }
                    }
                });
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    ProgramLogo: {
                        Logo: {}
                    },
                    Incentive: {
                        type: _incentivecomponent.default
                    },
                    Title: {},
                    IconsRow: {
                        ServiceIcon: {
                            type: _iconcomponent.default
                        },
                        ExtraDetails: {},
                        CsaIcon: {
                            type: _iconcomponent.default
                        }
                    }
                }, (0, _heroMetadatastyle.getInitialStyle)(this._style));
            }
        }
    ]);
    return HeroMetadata;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 56700:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    defaultContext: function() {
        return defaultContext;
    },
    getExtraDetailsFont: function() {
        return getExtraDetailsFont;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    getMargins: function() {
        return getMargins;
    },
    getPaddings: function() {
        return getPaddings;
    },
    getSizes: function() {
        return getSizes;
    },
    getTitleFont: function() {
        return getTitleFont;
    },
    margins: function() {
        return margins;
    },
    paddings: function() {
        return paddings;
    },
    sizes: function() {
        return sizes;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(42578);
var _constants = __webpack_require__(34952);
var _typography = __webpack_require__(18411);
var _memoize = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34736));
var _style = __webpack_require__(65082);
var _sizes = __webpack_require__(82699);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var sizes = (_obj = {}, _define_property._(_obj, _constants.HD, {
    iconsRow: {
        w: 1000,
        h: 32
    },
    icon: {
        h: 32
    },
    programLogo: {
        w: 251,
        h: 157
    },
    extraDetails: {
        w: 460
    },
    title: {
        w: 460
    }
}), _define_property._(_obj, _constants.FULL_HD, {
    iconsRow: {
        w: 1000,
        h: 40
    },
    icon: {
        h: 40
    },
    programLogo: {
        w: 382,
        h: 215
    },
    extraDetails: {
        w: 688
    },
    title: {
        w: 688
    }
}), _obj);
var _obj1;
var margins = (_obj1 = {}, _define_property._(_obj1, _constants.HD, {
    serviceIcon: {
        marginRight: 8
    },
    extraDetails: {
        marginRight: 12
    }
}), _define_property._(_obj1, _constants.FULL_HD, {
    serviceIcon: {
        marginRight: 12
    },
    extraDetails: {
        marginRight: 16
    }
}), _obj1);
var _obj2;
var paddings = (_obj2 = {}, _define_property._(_obj2, _constants.HD, {
    title: {
        paddingTop: 16
    },
    iconsRow: {
        paddingTop: 16
    }
}), _define_property._(_obj2, _constants.FULL_HD, {
    title: {
        paddingTop: 16
    },
    iconsRow: {
        paddingTop: 24
    }
}), _obj2);
var getSizes = function() {
    var screenSize = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _constants.FULL_HD;
    return sizes[screenSize];
};
var getMargins = function() {
    var screenSize = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _constants.FULL_HD;
    return margins[screenSize];
};
var getPaddings = function() {
    var screenSize = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _constants.FULL_HD;
    return paddings[screenSize];
};
var getTitleFont = (0, _memoize.default)(function(screenSize) {
    return (0, _typography.getFont)(_typography.FONT.PARIS_3, screenSize);
});
var getExtraDetailsFont = (0, _memoize.default)(function(screenSize) {
    return (0, _typography.getFont)(_typography.FONT.BERLIN_1, screenSize);
});
var getInitialStyle = function() {
    var screenSize = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext).screenSize;
    var sizes = getSizes(screenSize);
    var margins = getMargins(screenSize);
    var paddings = getPaddings(screenSize);
    return {
        flex: {
            direction: "column",
            justifyContent: "flex-end"
        },
        ProgramLogo: {
            w: sizes.programLogo.w,
            h: sizes.programLogo.h,
            Logo: {
                mountY: 0.5,
                y: _sizes.middle
            }
        },
        Incentive: {},
        Title: {
            flexItem: {
                marginTop: paddings.title.paddingTop
            },
            text: _object_spread_props._(_object_spread._({}, getTitleFont(screenSize)), {
                verticalAlign: "middle",
                wordWrapWidth: sizes.title.w,
                maxLines: 2,
                maxLinesSuffix: "..."
            })
        },
        IconsRow: {
            h: sizes.iconsRow.h,
            flexItem: {
                marginTop: paddings.iconsRow.paddingTop
            },
            flex: {
                direction: "row",
                alignItems: "center"
            },
            ExtraDetails: {
                text: _object_spread_props._(_object_spread._({}, getExtraDetailsFont(screenSize)), {
                    verticalAlign: "middle",
                    wordWrapWidth: sizes.extraDetails.w,
                    maxLines: 1,
                    maxLinesSuffix: "..."
                }),
                flexItem: {
                    marginRight: margins.extraDetails.marginRight
                }
            },
            CsaIcon: {}
        }
    };
};


/***/ }),

/***/ 19225:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(88801);
var _heroMetadatacomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(45130));
var _default = _heroMetadatacomponent.default;


/***/ }),

/***/ 50209:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return HeroPoster;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _create_super = __webpack_require__(6400);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(42578);
var _sdk = __webpack_require__(29956);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _iconcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(70160));
var _signals = __webpack_require__(2109);
var _templates = __webpack_require__(88229);
var _imageshader = /*#__PURE__*/ _interop_require_default._(__webpack_require__(17154));
var _focusshader = /*#__PURE__*/ _interop_require_default._(__webpack_require__(25906));
var _heroNavstyle = __webpack_require__(45055);
var HeroPoster = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(HeroPoster, _Lightning_Component);
    var _super = _create_super._(HeroPoster);
    function HeroPoster() {
        _class_call_check._(this, HeroPoster);
        return _super.apply(this, arguments);
    }
    _create_class._(HeroPoster, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _heroNavstyle.defaultContext;
            }
        },
        {
            key: "_inactive",
            value: function _inactive() {
                this.signal(_signals.INACTIVE_SIGNAL, this);
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                this._item = undefined;
                this.signal(_signals.DETACHED_SIGNAL, this);
            }
        },
        {
            key: "item",
            get: function get() {
                return this._item;
            },
            set: function set(param) {
                var content = param.content, config = param.config, template = param.template, _param_colorScheme = param.colorScheme, colorScheme = _param_colorScheme === void 0 ? this._style.colorMode : _param_colorScheme;
                var screenSize = this._style.screenSize;
                var templateDataAccessPath = [
                    template,
                    screenSize
                ];
                if ((0, _templates.areContentItemsEqual)(this._item, content)) {
                    this._item = content;
                    return;
                }
                this._item = content;
                this._config = config || _object_spread._({}, (0, _get.default)(_heroNavstyle.sizes, templateDataAccessPath, {}));
                this._style.colorMode = colorScheme;
                var _this__item = this._item, secondaryImage = _this__item.secondaryImage, lockPicto = _this__item.lockPicto;
                this.patch({
                    Image: {
                        src: secondaryImage && secondaryImage.src
                    },
                    LockIcon: {
                        iconData: {
                            picto: lockPicto,
                            viewBox: (0, _heroNavstyle.getLockIconViewBox)(this._style.screenSize)
                        }
                    }
                });
            }
        },
        {
            key: "_focus",
            value: function _focus() {
                this.patch((0, _heroNavstyle.getFocusedStyle)(this._style));
            }
        },
        {
            key: "_unfocus",
            value: function _unfocus() {
                this.patch(_heroNavstyle.unFocusedStyle);
            }
        },
        {
            key: "_handleEnter",
            value: function _handleEnter() {
                this.signal(_signals.SELECTED_SIGNAL, this._item);
                return true;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Border: {
                        rect: true,
                        shader: {
                            type: _focusshader.default
                        }
                    },
                    Image: {
                        shader: {
                            type: _imageshader.default
                        }
                    },
                    LockIcon: {
                        type: _iconcomponent.default
                    }
                }, (0, _heroNavstyle.getInitialStyle)(this._style));
            }
        }
    ]);
    return HeroPoster;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 45055:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ICON_HEIGHT: function() {
        return ICON_HEIGHT;
    },
    ICON_PADDING_HORIZONTAL: function() {
        return ICON_PADDING_HORIZONTAL;
    },
    ICON_PADDING_VERTICAL: function() {
        return ICON_PADDING_VERTICAL;
    },
    LOCK_ICON_HEIGHT: function() {
        return LOCK_ICON_HEIGHT;
    },
    PADDING_BOTTOM: function() {
        return PADDING_BOTTOM;
    },
    PADDING_LEFT: function() {
        return PADDING_LEFT;
    },
    PADDING_RIGHT: function() {
        return PADDING_RIGHT;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getFocusedStyle: function() {
        return getFocusedStyle;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    getLockIconViewBox: function() {
        return getLockIconViewBox;
    },
    sizes: function() {
        return sizes;
    },
    unFocusedStyle: function() {
        return unFocusedStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(52318);
var _memoize = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34736));
var _constants = __webpack_require__(34952);
var _style = __webpack_require__(65082);
var _focus = __webpack_require__(78506);
var _colors = __webpack_require__(8426);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var LOCK_ICON_HEIGHT = (_obj = {}, _define_property._(_obj, _constants.HD, 32), _define_property._(_obj, _constants.FULL_HD, 40), _obj);
var _obj1;
var ICON_HEIGHT = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 24), _define_property._(_obj1, _constants.FULL_HD, 32), _obj1);
var _obj2;
var sizes = (_obj2 = {}, _define_property._(_obj2, _constants.HD, {
    w: 247,
    h: 139
}), _define_property._(_obj2, _constants.FULL_HD, {
    w: 302,
    h: 170
}), _obj2);
var _obj3;
var PADDING_LEFT = (_obj3 = {}, _define_property._(_obj3, _constants.HD, 12), _define_property._(_obj3, _constants.FULL_HD, 16), _obj3);
var _obj4;
var PADDING_RIGHT = (_obj4 = {}, _define_property._(_obj4, _constants.HD, 12), _define_property._(_obj4, _constants.FULL_HD, 16), _obj4);
var _obj5;
var PADDING_BOTTOM = (_obj5 = {}, _define_property._(_obj5, _constants.HD, 8), _define_property._(_obj5, _constants.FULL_HD, 12), _obj5);
var ICON_PADDING_VERTICAL = 4;
var ICON_PADDING_HORIZONTAL = 8;
var getLockIconViewBox = (0, _memoize.default)(function(screenSize) {
    return {
        h: LOCK_ICON_HEIGHT[screenSize]
    };
});
var colors = {
    border: _focus.BORDER_COLOR,
    innerBorder: _focus.INNER_BORDER_COLOR
};
var getInitialStyle = function() {
    var screenSize = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext).screenSize;
    var borderSize = _focus.BORDER_WIDTH[screenSize];
    var borderOffset = borderSize * 2;
    return {
        zIndex: _style.UNFOCUSED_Z_INDEX,
        Border: {
            w: sizes[screenSize].w + borderOffset,
            h: sizes[screenSize].h + borderOffset,
            x: -borderSize,
            y: -borderSize,
            color: _colors.TRANSPARENT,
            shader: {
                radius: _focus.BORDER_RADIUS[screenSize],
                outline: _focus.BORDER_WIDTH[screenSize],
                strokeColor: _colors.TRANSPARENT,
                innerColor: _colors.TRANSPARENT
            }
        },
        Image: _object_spread_props._(_object_spread._({}, sizes[screenSize]), {
            shader: {
                radius: _focus.BORDER_RADIUS[screenSize]
            }
        }),
        LockIcon: {
            x: ICON_PADDING_HORIZONTAL,
            y: ICON_PADDING_VERTICAL
        }
    };
};
var getFocusedStyle = (0, _memoize.default)(function(param) {
    var colorMode = param.colorMode;
    return {
        zIndex: _style.FOCUSED_Z_INDEX,
        Border: {
            smooth: {
                scale: _focus.SCALE_FOCUSED,
                "shader.strokeColor": colors.border[colorMode],
                "shader.innerColor": colors.innerBorder[colorMode],
                "shader.scale": _focus.SCALE_FOCUSED
            }
        },
        Image: {
            smooth: {
                scale: _focus.SCALE_FOCUSED,
                "shader.scale": _focus.SCALE_FOCUSED
            }
        }
    };
}, _style.cacheResolver);
var unFocusedStyle = {
    zIndex: _style.UNFOCUSED_Z_INDEX,
    Border: {
        smooth: {
            scale: 1,
            "shader.strokeColor": _colors.TRANSPARENT,
            "shader.innerColor": _colors.TRANSPARENT,
            "shader.scale": 1.0
        }
    },
    Image: {
        smooth: {
            scale: 1,
            "shader.scale": 1.0
        }
    }
};


/***/ }),

/***/ 10169:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return HeroOverlay;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(88801);
var _sdk = __webpack_require__(29956);
var _theme = __webpack_require__(51397);
var _heroOverlaystyle = __webpack_require__(4695);
var _sizes = __webpack_require__(82699);
var HeroOverlay = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(HeroOverlay, _Lightning_Component);
    var _super = _create_super._(HeroOverlay);
    function HeroOverlay() {
        _class_call_check._(this, HeroOverlay);
        return _super.apply(this, arguments);
    }
    _create_class._(HeroOverlay, null, [
        {
            key: "_template",
            value: function _template() {
                return {
                    Left: {
                        rect: true,
                        w: function(v) {
                            return v * 0.75;
                        },
                        h: _sizes.identity,
                        colorBl: _heroOverlaystyle.filledColor[_theme.DEFAULT_MODE],
                        colorUl: _heroOverlaystyle.filledColor[_theme.DEFAULT_MODE],
                        colorUr: _heroOverlaystyle.emptyColor[_theme.DEFAULT_MODE],
                        colorBr: _heroOverlaystyle.emptyColor[_theme.DEFAULT_MODE]
                    },
                    Bottom: {
                        rect: true,
                        w: _sizes.identity,
                        h: _sizes.middle,
                        mountY: 1,
                        y: _sizes.identity,
                        colorBl: _heroOverlaystyle.filledColor[_theme.DEFAULT_MODE],
                        colorUl: _heroOverlaystyle.emptyColor[_theme.DEFAULT_MODE],
                        colorUr: _heroOverlaystyle.emptyColor[_theme.DEFAULT_MODE],
                        colorBr: _heroOverlaystyle.filledColor[_theme.DEFAULT_MODE]
                    }
                };
            }
        }
    ]);
    return HeroOverlay;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 4695:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    emptyColor: function() {
        return emptyColor;
    },
    filledColor: function() {
        return filledColor;
    }
});
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);
var _theme = __webpack_require__(51397);
var filledColor = (0, _theme.makeThemeColor)(_theme.TERTIARY);
var emptyColor = (0, _theme.makeThemeColor)(_theme.TERTIARY, 0);


/***/ }),

/***/ 78647:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "HeroSkeleton", ({
    enumerable: true,
    get: function() {
        return HeroSkeleton;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
var _sdk = __webpack_require__(29956);
var _slideShowcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(28844));
var _herostyle = __webpack_require__(56339);
var _heroskeletonstyle = __webpack_require__(3612);
var HeroSkeleton = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(HeroSkeleton, _Lightning_Component);
    var _super = _create_super._(HeroSkeleton);
    function HeroSkeleton() {
        _class_call_check._(this, HeroSkeleton);
        return _super.apply(this, arguments);
    }
    _create_class._(HeroSkeleton, null, [
        {
            key: "_template",
            value: function _template() {
                return (0, _heroskeletonstyle.getInitialStyle)();
            }
        },
        {
            key: "getHeight",
            value: function getHeight(data) {
                var bottom = _slideShowcomponent.default.getOffsetsByBlockData(data).bottom;
                return _herostyle.HEIGHT[data.screenSize] + bottom;
            }
        }
    ]);
    return HeroSkeleton;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 3612:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _to_consumable_array = __webpack_require__(30005);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(88801);
var _skeletonrectanglecomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(82149));
var _style = __webpack_require__(65082);
var _herostyle = __webpack_require__(56339);
var _heroMetadatastyle = __webpack_require__(56700);
var _heroNavstyle = __webpack_require__(45055);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var getInitialStyle = function() {
    var screenSize = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext).screenSize;
    var sizes = (0, _heroMetadatastyle.getSizes)(screenSize);
    var paddings = (0, _heroMetadatastyle.getPaddings)(screenSize);
    var metadataBottom = (0, _herostyle.getMetadataBottom)(screenSize);
    var itemsTop = (0, _herostyle.getItemsTop)(screenSize);
    var itemSize = _heroNavstyle.sizes[screenSize];
    var gap = _herostyle.CONTENT_GAP[screenSize];
    return {
        Metadata: {
            mountY: 1,
            h: metadataBottom,
            y: metadataBottom,
            flex: {
                direction: "column",
                justifyContent: "flex-end"
            },
            ProgramLogo: {
                type: _skeletonrectanglecomponent.default,
                w: sizes.programLogo.w,
                h: sizes.programLogo.h
            },
            IconsRow: {
                type: _skeletonrectanglecomponent.default,
                w: 500,
                h: sizes.iconsRow.h,
                flexItem: {
                    marginTop: paddings.iconsRow.paddingTop
                }
            },
            Title: {
                flexItem: {
                    marginTop: paddings.title.paddingTop
                },
                h: (0, _heroMetadatastyle.getTitleFont)().lineHeight * 2,
                flex: {
                    direction: "column"
                },
                FirstLine: {
                    type: _skeletonrectanglecomponent.default,
                    w: 700,
                    h: (0, _heroMetadatastyle.getTitleFont)().lineHeight
                },
                SecondLine: {
                    type: _skeletonrectanglecomponent.default,
                    w: 500,
                    h: (0, _heroMetadatastyle.getTitleFont)().lineHeight
                }
            }
        },
        Items: {
            y: itemsTop,
            children: _to_consumable_array._(Array(6)).map(function(_, index) {
                return _object_spread._({
                    type: _skeletonrectanglecomponent.default,
                    x: index * (itemSize.w + gap)
                }, itemSize);
            })
        }
    };
};


/***/ }),

/***/ 34552:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "HeroSkeleton", ({
    enumerable: true,
    get: function() {
        return _heroskeletoncomponent.HeroSkeleton;
    }
}));
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(65759);
var _heroskeletoncomponent = __webpack_require__(78647);


/***/ }),

/***/ 37614:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DISPLAY_DETAILS: function() {
        return DISPLAY_DETAILS;
    },
    DISPLAY_EXTRA_TITLE: function() {
        return DISPLAY_EXTRA_TITLE;
    },
    DISPLAY_ICONS: function() {
        return DISPLAY_ICONS;
    },
    EXTRA_HIGHLIGHT_FONT_NAME: function() {
        return EXTRA_HIGHLIGHT_FONT_NAME;
    },
    EXTRA_HIGHLIGHT_FONT_TYPE: function() {
        return EXTRA_HIGHLIGHT_FONT_TYPE;
    },
    ICONS: function() {
        return ICONS;
    },
    ICONS_TYPES: function() {
        return ICONS_TYPES;
    },
    ITEMS_BY_BREAKPOINTS: function() {
        return ITEMS_BY_BREAKPOINTS;
    },
    SIDE_GLASS_ICONS: function() {
        return SIDE_GLASS_ICONS;
    },
    TITLE_FONT_NAME: function() {
        return TITLE_FONT_NAME;
    },
    TITLE_FONT_TYPE: function() {
        return TITLE_FONT_TYPE;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(52318);
var _constants = __webpack_require__(34952);
var _typography = __webpack_require__(18411);
var _templates = __webpack_require__(88229);
var _iconcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(70160));
var _badgecomponent = __webpack_require__(69289);
var DISPLAY_ICONS = true;
var DISPLAY_EXTRA_TITLE = true;
var DISPLAY_DETAILS = false;
var TITLE_FONT_TYPE = _typography.FONT_TYPE.MAIN;
var TITLE_FONT_NAME = _typography.FONT.OTTAWA_3;
var EXTRA_HIGHLIGHT_FONT_NAME = _typography.FONT.BERLIN_1;
var EXTRA_HIGHLIGHT_FONT_TYPE = _typography.FONT_TYPE.MAIN;
var _obj;
var ICONS = (_obj = {}, _define_property._(_obj, _templates.ICON_POSITION.TOP_RIGHT, 4), _define_property._(_obj, _templates.ICON_POSITION.BOTTOM_RIGHT, 1), _define_property._(_obj, _templates.ICON_POSITION.CENTER, 3), _obj);
var _obj1;
var SIDE_GLASS_ICONS = (_obj1 = {}, _define_property._(_obj1, _templates.ICON_POSITION.TOP_LEFT, 3), _define_property._(_obj1, _templates.ICON_POSITION.TOP_RIGHT, 4), _define_property._(_obj1, _templates.ICON_POSITION.BOTTOM_RIGHT, 1), _define_property._(_obj1, _templates.ICON_POSITION.CENTER, 3), _obj1);
var _obj2;
var ICONS_TYPES = (_obj2 = {}, _define_property._(_obj2, _templates.ICON_POSITION.TOP_LEFT, _iconcomponent.default), _define_property._(_obj2, _templates.ICON_POSITION.TOP_RIGHT, _badgecomponent.Badge), _define_property._(_obj2, _templates.ICON_POSITION.BOTTOM_RIGHT, _iconcomponent.default), _define_property._(_obj2, _templates.ICON_POSITION.CENTER, _iconcomponent.default), _obj2);
var _obj3;
var ITEMS_BY_BREAKPOINTS = (_obj3 = {}, _define_property._(_obj3, _constants.HD, 2), _define_property._(_obj3, _constants.FULL_HD, 2), _obj3);


/***/ }),

/***/ 16348:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return HorizontalCard;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(45538);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _constants = __webpack_require__(34952);
var _progressutils = __webpack_require__(40779);
var _templates = __webpack_require__(88229);
var _colors = __webpack_require__(8426);
var _imageshader = /*#__PURE__*/ _interop_require_default._(__webpack_require__(17154));
var _focusshader = /*#__PURE__*/ _interop_require_default._(__webpack_require__(25906));
var _signals = __webpack_require__(2109);
var _horizontalCardstyle = __webpack_require__(88636);
var _horizontalCardconstants = __webpack_require__(75827);
var HorizontalCard = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(HorizontalCard, _Lightning_Component);
    var _super = _create_super._(HorizontalCard);
    function HorizontalCard() {
        _class_call_check._(this, HorizontalCard);
        return _super.apply(this, arguments);
    }
    _create_class._(HorizontalCard, [
        {
            key: "_construct",
            value: function _construct() {
                this._index = 0;
                this._style = _horizontalCardstyle.defaultContext;
            }
        },
        {
            key: "_inactive",
            value: function _inactive() {
                this.signal(_signals.INACTIVE_SIGNAL, this);
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                this.tag("Image").removeAllListeners("txLoaded");
                this._item = undefined;
                this.signal(_signals.DETACHED_SIGNAL, this);
            }
        },
        {
            key: "item",
            get: function get() {
                return this._item;
            },
            set: function set(param) {
                var content = param.content, config = param.config, template = param.template, sideGlass = param.sideGlass, _param_colorScheme = param.colorScheme, colorScheme = _param_colorScheme === void 0 ? _horizontalCardstyle.defaultContext.colorMode : _param_colorScheme;
                var _this = this;
                var templateDataAccessPath = [
                    template,
                    this._style.screenSize
                ];
                var progress = (0, _progressutils.getProgress)(content.progress);
                if ((0, _templates.areContentItemsEqual)(this._item, content)) {
                    this._item = content;
                    this.patch({
                        Image: {
                            shader: {
                                progress: progress
                            }
                        }
                    });
                    return;
                }
                this._item = content;
                this._config = config || (0, _get.default)(_horizontalCardconstants.sizes, templateDataAccessPath, {});
                this._itemTemplate = template;
                var _this__item = this._item, title = _this__item.title, extraTitle = _this__item.extraTitle, details = _this__item.details, highlight = _this__item.highlight, description = _this__item.description, extraHighlight = _this__item.extraHighlight, pictos = _this__item.pictos;
                var wordWrapWidth = this.wordWrapWidth;
                var textColor = _horizontalCardstyle.colors.text[colorScheme];
                var imageUrl = (0, _get.default)(this._item, "image.src", "");
                this.tag("Image").once("txLoaded", function() {
                    _this.tag("Image").setSmooth("alpha", 1);
                });
                this.patch({
                    w: this._config.w,
                    h: this._config.h,
                    Image: {
                        alpha: 0.0001,
                        src: imageUrl,
                        shader: {
                            progress: progress
                        }
                    },
                    ExtraFlexContainer: {
                        visible: sideGlass,
                        CentralIcon: {
                            iconData: {
                                picto: (0, _horizontalCardstyle.getIcon)(pictos, _templates.ICON_POSITION.CENTER, sideGlass),
                                viewBox: (0, _horizontalCardstyle.getCentralIconViewBox)(this._style.screenSize)
                            }
                        },
                        ExtraHighlight: (0, _templates.makeTextPatch)(extraHighlight, wordWrapWidth, textColor)
                    },
                    TopLeftIcon: {
                        iconData: {
                            picto: (0, _horizontalCardstyle.getIcon)(pictos, _templates.ICON_POSITION.TOP_LEFT, sideGlass),
                            viewBox: (0, _horizontalCardstyle.getIconViewBox)(this._style.screenSize)
                        }
                    },
                    TopRightIcon: {
                        iconData: {
                            picto: (0, _horizontalCardstyle.getIcon)(pictos, _templates.ICON_POSITION.TOP_RIGHT, sideGlass),
                            viewBox: (0, _horizontalCardstyle.getIconViewBox)(this._style.screenSize)
                        }
                    },
                    BottomRightIcon: {
                        y: this._config.h - _horizontalCardstyle.ICON_PADDING_VERTICAL - _horizontalCardstyle.PROGRESS_HEIGHT,
                        iconData: {
                            picto: (0, _horizontalCardstyle.getIcon)(pictos, _templates.ICON_POSITION.BOTTOM_RIGHT, sideGlass),
                            viewBox: (0, _horizontalCardstyle.getIconViewBox)(this._style.screenSize)
                        }
                    },
                    FlexContainer: {
                        // NOTE: needs to use rect property to justifying flex items in flex container
                        rect: true,
                        color: _colors.TRANSPARENT,
                        flex: {
                            direction: "column",
                            justifyContent: "center"
                        },
                        Title: (0, _templates.makeTextPatch)(title, wordWrapWidth, textColor),
                        ExtraTitle: (0, _templates.makeTextPatch)(_horizontalCardconstants.DISPLAY_EXTRA_TITLE ? extraTitle : "", wordWrapWidth, textColor),
                        Highlight: (0, _templates.makeTextPatch)(highlight, wordWrapWidth, textColor),
                        Description: (0, _templates.makeTextPatch)(description, wordWrapWidth, textColor),
                        Details: (0, _templates.makeTextPatch)(_horizontalCardconstants.DISPLAY_DETAILS ? details : "", wordWrapWidth, textColor)
                    }
                });
            }
        },
        {
            key: "wordWrapWidth",
            get: function get() {
                var _$_get = (0, _get.default)(_horizontalCardconstants.imageOptions, [
                    this._itemTemplate,
                    this._style.screenSize
                ], {}), _get_PRIMARY = _$_get.PRIMARY, imageWidth = _get_PRIMARY.width;
                var padding = _horizontalCardstyle.TEXT_LEFT_PADDING[this._style.screenSize];
                var width = (0, _get.default)(this, "_config.w", this.finalW);
                var safetyMargin = _constants.safetyMargins.vertical[this._style.screenSize];
                return width - imageWidth - padding - safetyMargin;
            }
        },
        {
            key: "_focus",
            value: function _focus() {
                this.patch((0, _horizontalCardstyle.getFocusedStyle)(this._style));
            }
        },
        {
            key: "_unfocus",
            value: function _unfocus() {
                this.patch(_horizontalCardstyle.unFocusedStyle);
            }
        },
        {
            key: "_handleEnter",
            value: function _handleEnter() {
                this.signal(_signals.SELECTED_SIGNAL, this._item);
                return true;
            }
        }
    ], [
        {
            key: "_template",
            value: /* istanbul ignore next */ function _template() {
                return (0, _merge.default)({
                    Border: {
                        rect: true,
                        shader: {
                            type: _focusshader.default
                        }
                    },
                    Image: {
                        shader: {
                            type: _imageshader.default
                        }
                    },
                    Gradient: {
                        shader: {
                            type: _sdk.Lightning.shaders.RoundedRectangle
                        }
                    },
                    ExtraFlexContainer: {
                        CentralIcon: {
                            type: _horizontalCardconstants.ICONS_TYPES[_templates.ICON_POSITION.CENTER]
                        },
                        ExtraHighlight: {}
                    },
                    TopLeftIcon: {
                        type: _horizontalCardconstants.ICONS_TYPES[_templates.ICON_POSITION.TOP_LEFT]
                    },
                    TopRightIcon: {
                        type: _horizontalCardconstants.ICONS_TYPES[_templates.ICON_POSITION.TOP_RIGHT]
                    },
                    BottomRightIcon: {
                        type: _horizontalCardconstants.ICONS_TYPES[_templates.ICON_POSITION.BOTTOM_RIGHT]
                    },
                    FlexContainer: {
                        Title: {},
                        ExtraTitle: {},
                        Highlight: {},
                        Description: {},
                        Details: {}
                    }
                }, (0, _horizontalCardstyle.getInitialStyle)());
            }
        }
    ]);
    return HorizontalCard;
}(_sdk.Lightning.Component);
HorizontalCard.Templates = _horizontalCardconstants.templates;
HorizontalCard.Sizes = _horizontalCardconstants.sizes;
HorizontalCard.ImageOptions = _horizontalCardconstants.imageOptions;


/***/ }),

/***/ 75827:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    heights: function() {
        return heights;
    },
    imageOptions: function() {
        return imageOptions;
    },
    sizes: function() {
        return sizes;
    },
    templates: function() {
        return templates;
    }
});
var _define_property = __webpack_require__(21228);
var _export_star = __webpack_require__(37668);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(3009);
var _constants = __webpack_require__(34952);
var _sizes = __webpack_require__(82699);
var _horizontalCardconstants = _export_star._(__webpack_require__(37614), exports);
var templates = {
    HorizontalCard: "HorizontalCard"
};
var _obj;
var heights = (_obj = {}, _define_property._(_obj, _constants.HD, 158), _define_property._(_obj, _constants.FULL_HD, 198), _obj);
var _obj1;
var imageOptions = _define_property._({}, templates.HorizontalCard, (_obj1 = {}, _define_property._(_obj1, _constants.HD, {
    PRIMARY: {
        width: 281,
        height: 158
    }
}), _define_property._(_obj1, _constants.FULL_HD, {
    PRIMARY: {
        width: 353,
        height: 198
    }
}), _obj1));
var _getElementSize = (0, _sizes.getElementSize)(_horizontalCardconstants.ITEMS_BY_BREAKPOINTS, 1.0, templates.HorizontalCard), _sizes1 = _getElementSize.sizes;
var sizes = [
    _constants.FULL_HD,
    _constants.HD
].reduce(function(acc, size) {
    acc[templates.HorizontalCard][size] = {
        w: _sizes1[templates.HorizontalCard][size].w,
        h: heights[size]
    };
    return acc;
}, _define_property._({}, templates.HorizontalCard, {}));


/***/ }),

/***/ 88636:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ICON_HEIGHT: function() {
        return ICON_HEIGHT;
    },
    ICON_PADDING_HORIZONTAL: function() {
        return ICON_PADDING_HORIZONTAL;
    },
    ICON_PADDING_VERTICAL: function() {
        return ICON_PADDING_VERTICAL;
    },
    IMAGE_OFFSET: function() {
        return IMAGE_OFFSET;
    },
    LOCK_ICON_HEIGHT: function() {
        return LOCK_ICON_HEIGHT;
    },
    PROGRESS_HEIGHT: function() {
        return _progressstyle.HEIGHT;
    },
    TEXT_LEFT_PADDING: function() {
        return TEXT_LEFT_PADDING;
    },
    TEXT_TOP_PADDING: function() {
        return TEXT_TOP_PADDING;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getCentralIconHeight: function() {
        return getCentralIconHeight;
    },
    getCentralIconViewBox: function() {
        return getCentralIconViewBox;
    },
    getFocusedStyle: function() {
        return getFocusedStyle;
    },
    getIcon: function() {
        return getIcon;
    },
    getIconViewBox: function() {
        return getIconViewBox;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    getLockIconViewBox: function() {
        return getLockIconViewBox;
    },
    makeBasicIconStyle: function() {
        return makeBasicIconStyle;
    },
    makeBasicTextStyle: function() {
        return makeBasicTextStyle;
    },
    unFocusedStyle: function() {
        return unFocusedStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(3009);
var _memoize = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34736));
var _typography = __webpack_require__(18411);
var _theme = __webpack_require__(51397);
var _constants = __webpack_require__(34952);
var _style = __webpack_require__(65082);
var _progressstyle = __webpack_require__(67614);
var _horizontalCardconstants = __webpack_require__(75827);
var _focus = __webpack_require__(78506);
var _colors = __webpack_require__(8426);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var IMAGE_OFFSET = (_obj = {}, _define_property._(_obj, _constants.HD, _focus.BORDER_WIDTH[_constants.HD] * 2), _define_property._(_obj, _constants.FULL_HD, _focus.BORDER_WIDTH[_constants.FULL_HD] * 2), _obj);
var _obj1;
var TEXT_TOP_PADDING = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 16), _define_property._(_obj1, _constants.FULL_HD, 16), _obj1);
var _obj2;
var TEXT_LEFT_PADDING = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 24), _define_property._(_obj2, _constants.FULL_HD, 24), _obj2);
var _obj3;
var ICON_HEIGHT = (_obj3 = {}, _define_property._(_obj3, _constants.HD, 24), _define_property._(_obj3, _constants.FULL_HD, 32), _obj3);
var _obj4;
var LOCK_ICON_HEIGHT = (_obj4 = {}, _define_property._(_obj4, _constants.HD, 32), _define_property._(_obj4, _constants.FULL_HD, 40), _obj4);
var ICON_PADDING_VERTICAL = 4;
var ICON_PADDING_HORIZONTAL = 8;
var getIconViewBox = (0, _memoize.default)(function(screenSize) {
    return {
        h: ICON_HEIGHT[screenSize]
    };
});
var getLockIconViewBox = (0, _memoize.default)(function(screenSize) {
    return {
        h: LOCK_ICON_HEIGHT[screenSize]
    };
});
var getCentralIconHeight = function(screenSize) {
    return _horizontalCardconstants.imageOptions[_horizontalCardconstants.templates.HorizontalCard][screenSize];
};
var getCentralIconViewBox = (0, _memoize.default)(function(screenSize) {
    return {
        h: getCentralIconHeight(screenSize).PRIMARY.height * 0.5,
        w: getCentralIconHeight(screenSize).PRIMARY.height * 0.5
    };
});
var colors = {
    text: (0, _theme.makeThemeColor)(_theme.PRIMARY),
    border: (0, _theme.makeThemeColor)(_theme.PRIMARY),
    innerBorder: _focus.INNER_BORDER_COLOR,
    overlayTop: (0, _theme.makeThemeColor)(_theme.TERTIARY, 0),
    overlayBottom: (0, _theme.makeThemeColor)(_theme.TERTIARY),
    gradient: (0, _theme.makeThemeColor)(_theme.TERTIARY)
};
var makeBasicTextStyle = function(param) {
    var font = param.font, _param_colorMode = param.colorMode, colorMode = _param_colorMode === void 0 ? _theme.DEFAULT_MODE : _param_colorMode;
    return {
        color: colors.text[colorMode],
        text: _object_spread_props._(_object_spread._({}, font), {
            verticalAlign: "middle",
            wordWrap: false,
            textOverflow: "..."
        })
    };
};
var makeBasicIconStyle = function() {
    return {
        alpha: 0.8
    };
};
var getIcon = function(icons, position) {
    var sideGlass = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var map = sideGlass ? _horizontalCardconstants.SIDE_GLASS_ICONS : _horizontalCardconstants.ICONS;
    return icons ? icons[map[position]] : null;
};
var getInitialStyle = (0, _memoize.default)(function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext, _ref_screenSize = _ref.screenSize, screenSize = _ref_screenSize === void 0 ? _constants.FULL_HD : _ref_screenSize, _ref_colorMode = _ref.colorMode, colorMode = _ref_colorMode === void 0 ? _theme.DEFAULT_MODE : _ref_colorMode;
    var imageSize = _horizontalCardconstants.imageOptions[_horizontalCardconstants.templates.HorizontalCard][screenSize].PRIMARY;
    var offset = IMAGE_OFFSET[screenSize];
    return {
        Border: {
            w: imageSize.width + offset,
            h: imageSize.height + offset,
            x: -_focus.BORDER_WIDTH[screenSize],
            y: -_focus.BORDER_WIDTH[screenSize],
            shader: {
                outline: _focus.BORDER_WIDTH[screenSize],
                radius: _focus.BORDER_RADIUS[screenSize],
                strokeColor: _colors.TRANSPARENT
            }
        },
        Image: {
            w: imageSize.width,
            h: imageSize.height,
            shader: {
                radius: _focus.BORDER_RADIUS[screenSize],
                progressHeight: _progressstyle.HEIGHT,
                progressBackgroundColor: _progressstyle.colors.background[colorMode],
                progressBarColor: _progressstyle.colors.bar[colorMode]
            }
        },
        Gradient: {
            visible: false,
            // NOTE: compensating possible border erosion by the Lightning's Rounded Rectangle shader
            x: -1,
            y: -1,
            w: imageSize.width + 2,
            h: imageSize.height + 2,
            rect: true,
            color: colors.gradient[colorMode],
            alpha: 0.6,
            shader: {
                radius: _focus.BORDER_RADIUS[screenSize]
            }
        },
        ExtraFlexContainer: {
            visible: false,
            alpha: 1,
            w: imageSize.width,
            h: imageSize.height,
            flex: {
                direction: "column",
                alignItems: "center",
                justifyContent: "center"
            },
            ExtraHighlight: makeBasicTextStyle({
                font: (0, _typography.getFont)(_horizontalCardconstants.EXTRA_HIGHLIGHT_FONT_NAME, screenSize, _horizontalCardconstants.EXTRA_HIGHLIGHT_FONT_TYPE),
                colorMode: colorMode
            })
        },
        TopLeftIcon: {
            x: ICON_PADDING_HORIZONTAL,
            y: ICON_PADDING_VERTICAL
        },
        TopRightIcon: _object_spread_props._(_object_spread._({}, makeBasicIconStyle()), {
            visible: _horizontalCardconstants.DISPLAY_ICONS,
            mountX: 1,
            x: imageSize.width - ICON_PADDING_HORIZONTAL,
            y: ICON_PADDING_VERTICAL
        }),
        BottomRightIcon: {
            mount: 1,
            x: imageSize.width - ICON_PADDING_HORIZONTAL,
            visible: _horizontalCardconstants.DISPLAY_ICONS,
            alpha: 0.8
        },
        FlexContainer: {
            x: imageSize.width + TEXT_LEFT_PADDING[screenSize],
            h: imageSize.height,
            Title: makeBasicTextStyle({
                font: (0, _typography.getFont)(_horizontalCardconstants.TITLE_FONT_NAME, screenSize, _horizontalCardconstants.TITLE_FONT_TYPE),
                colorMode: colorMode
            }),
            ExtraTitle: makeBasicTextStyle({
                font: (0, _typography.getFont)(_typography.FONT.BERLIN_1, screenSize),
                colorMode: colorMode
            }),
            Highlight: _object_spread_props._(_object_spread._({}, makeBasicTextStyle({
                font: (0, _typography.getFont)(_typography.FONT.BERLIN_1, screenSize),
                colorMode: colorMode
            })), {
                alpha: 0.6
            }),
            Description: {
                text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT.BERLIN_1, screenSize)), {
                    maxLines: 3,
                    verticalAlign: "middle",
                    wordWrap: true,
                    maxLinesSuffix: "..."
                })
            },
            Details: _object_spread_props._(_object_spread._({}, makeBasicTextStyle({
                font: (0, _typography.getFont)(_typography.FONT.BERLIN_1, screenSize),
                colorMode: colorMode
            })), {
                alpha: 0.6
            })
        }
    };
}, _style.cacheResolver);
var getFocusedStyle = (0, _memoize.default)(function(param) {
    var colorMode = param.colorMode;
    return {
        Border: {
            smooth: {
                scale: _focus.SCALE_FOCUSED,
                "shader.strokeColor": colors.border[colorMode],
                "shader.innerColor": colors.innerBorder[colorMode],
                "shader.scale": _focus.SCALE_FOCUSED
            }
        },
        Image: {
            smooth: {
                scale: _focus.SCALE_FOCUSED,
                "shader.scale": _focus.SCALE_FOCUSED
            }
        },
        Gradient: {
            smooth: {
                scale: _focus.SCALE_FOCUSED
            }
        },
        ExtraFlexContainer: {
            smooth: {
                alpha: 0
            }
        }
    };
}, _style.cacheResolver);
var unFocusedStyle = {
    Border: {
        smooth: {
            scale: 1,
            "shader.strokeColor": _colors.TRANSPARENT,
            "shader.innerColor": _colors.TRANSPARENT,
            "shader.scale": 1.0
        }
    },
    Image: {
        smooth: {
            scale: 1,
            "shader.scale": 1.0
        }
    },
    Gradient: {
        smooth: {
            scale: 1
        }
    },
    ExtraFlexContainer: {
        smooth: {
            alpha: 1
        }
    }
};


/***/ }),

/***/ 42685:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BORDER_COLOR: function() {
        return BORDER_COLOR;
    },
    EXTRA_HIGHLIGHT_FONT_NAME: function() {
        return EXTRA_HIGHLIGHT_FONT_NAME;
    },
    EXTRA_HIGHLIGHT_FONT_TYPE: function() {
        return EXTRA_HIGHLIGHT_FONT_TYPE;
    },
    INNER_BORDER_COLOR: function() {
        return INNER_BORDER_COLOR;
    },
    ITEMS_BY_BREAKPOINTS: function() {
        return ITEMS_BY_BREAKPOINTS;
    },
    LINE1_COLOR: function() {
        return LINE1_COLOR;
    },
    LINE2_COLOR: function() {
        return LINE2_COLOR;
    },
    LINE3_COLOR: function() {
        return LINE3_COLOR;
    },
    TITLE_FONT_NAME: function() {
        return TITLE_FONT_NAME;
    },
    TITLE_FONT_TYPE: function() {
        return TITLE_FONT_TYPE;
    }
});
var _define_property = __webpack_require__(21228);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(88801);
var _constants = __webpack_require__(34952);
var _typography = __webpack_require__(18411);
var _theme = __webpack_require__(51397);
var TITLE_FONT_TYPE = _typography.FONT_TYPE.MAIN;
var TITLE_FONT_NAME = _typography.FONT.OTTAWA_3;
var EXTRA_HIGHLIGHT_FONT_NAME = _typography.FONT.BERLIN_1;
var EXTRA_HIGHLIGHT_FONT_TYPE = _typography.FONT_TYPE.MAIN;
var BORDER_COLOR = (0, _theme.makeThemeColor)(_theme.PRIMARY);
var INNER_BORDER_COLOR = (0, _theme.makeThemeColor)(_theme.TERTIARY);
var LINE1_COLOR = (0, _theme.makeThemeColor)(_theme.PRIMARY);
var LINE2_COLOR = (0, _theme.makeThemeColor)(_theme.QUATERNARY);
var LINE3_COLOR = (0, _theme.makeThemeColor)(_theme.QUATERNARY);
var _obj;
var ITEMS_BY_BREAKPOINTS = (_obj = {}, _define_property._(_obj, _constants.HD, 2), _define_property._(_obj, _constants.FULL_HD, 2), _obj);


/***/ }),

/***/ 5746:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "getLines", ({
    enumerable: true,
    get: function() {
        return getLines;
    }
}));
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(3009);
var getLines = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, extraTitle = _ref.extraTitle, details = _ref.details, highlight = _ref.highlight, description = _ref.description;
    return [
        extraTitle || "",
        [
            details,
            highlight
        ].filter(Boolean).join(" | "),
        description || ""
    ];
};


/***/ }),

/***/ 73876:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return HorizontalSquare;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _sliced_to_array = __webpack_require__(28966);
var _create_super = __webpack_require__(6400);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(65759);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _constants = __webpack_require__(34952);
var _progresscomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(45926));
var _progressutils = __webpack_require__(40779);
var _focusshader = /*#__PURE__*/ _interop_require_default._(__webpack_require__(25906));
var _templates = __webpack_require__(88229);
var _signals = __webpack_require__(2109);
var _horizontalSquarestyle = __webpack_require__(72042);
var _horizontalSquareutils = __webpack_require__(90093);
var _horizontalSquareconstants = __webpack_require__(13448);
var HorizontalSquare = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(HorizontalSquare, _Lightning_Component);
    var _super = _create_super._(HorizontalSquare);
    function HorizontalSquare() {
        _class_call_check._(this, HorizontalSquare);
        return _super.apply(this, arguments);
    }
    _create_class._(HorizontalSquare, [
        {
            key: "_construct",
            value: function _construct() {
                this._index = 0;
                this._style = _horizontalSquarestyle.defaultContext;
            }
        },
        {
            key: "_inactive",
            value: function _inactive() {
                this.signal(_signals.INACTIVE_SIGNAL, this);
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                this._item = undefined;
                this.signal(_signals.DETACHED_SIGNAL, this);
            }
        },
        {
            key: "item",
            get: function get() {
                return this._item;
            },
            set: function set(param) {
                var content = param.content, config = param.config, template = param.template, _param_colorScheme = param.colorScheme, colorScheme = _param_colorScheme === void 0 ? _horizontalSquarestyle.defaultContext.colorMode : _param_colorScheme;
                var templateDataAccessPath = [
                    template,
                    this._style.screenSize
                ];
                var progress = (0, _progressutils.makeProgressBarProperties)(content.progress);
                if ((0, _templates.areContentItemsEqual)(this._item, content)) {
                    this._item = content;
                    this.patch({
                        FlexContainer: {
                            Line3: {
                                visible: !progress.visible
                            },
                            ProgressBar: progress
                        }
                    });
                    return;
                }
                this._item = content;
                this._config = config || (0, _get.default)(_horizontalSquareconstants.sizes, templateDataAccessPath, {});
                this._itemTemplate = template;
                var wordWrapWidth = this.wordWrapWidth;
                var imageUrl = (0, _get.default)(this._item, "image.src", "");
                var _getLines = _sliced_to_array._((0, _horizontalSquareutils.getLines)(this._item), 3), line1 = _getLines[0], line2 = _getLines[1], line3 = _getLines[2];
                var screenSize = this._style.screenSize;
                this.patch({
                    Background: {
                        w: this._config.w,
                        h: this._config.h
                    },
                    ScalableContent: {
                        src: imageUrl,
                        shader: {
                            strokeColor: _horizontalSquarestyle.colors.border[colorScheme]
                        }
                    },
                    FlexContainer: {
                        Line1: (0, _templates.makeTextPatch)(line1, wordWrapWidth, _horizontalSquareconstants.LINE1_COLOR[colorScheme]),
                        Line2: (0, _templates.makeTextPatch)(line2, wordWrapWidth, _horizontalSquareconstants.LINE2_COLOR[colorScheme]),
                        Line3: _object_spread_props._(_object_spread._({}, (0, _templates.makeTextPatch)(line3, wordWrapWidth, _horizontalSquareconstants.LINE3_COLOR[colorScheme])), {
                            visible: !progress.visible
                        }),
                        ProgressBar: _object_spread._({
                            w: this._config.w - ((0, _horizontalSquarestyle.getImageSize)(screenSize) + _horizontalSquarestyle.TEXT_LEFT_PADDING[screenSize] + _horizontalSquarestyle.PADDING[screenSize] * 2)
                        }, progress)
                    }
                });
            }
        },
        {
            key: "wordWrapWidth",
            get: function get() {
                var _$_get = (0, _get.default)(_horizontalSquareconstants.imageOptions, [
                    this._itemTemplate,
                    this._style.screenSize
                ], {}), _get_PRIMARY = _$_get.PRIMARY, imageWidth = _get_PRIMARY.width;
                var padding = _horizontalSquarestyle.TEXT_LEFT_PADDING[this._style.screenSize];
                var width = this._config.w || this.finalW;
                var safetyMargin = _constants.safetyMargins.vertical[this._style.screenSize];
                return width - imageWidth - padding - safetyMargin;
            }
        },
        {
            key: "_focus",
            value: function _focus() {
                this.patch((0, _horizontalSquarestyle.getFocusedStyle)(this._style));
            }
        },
        {
            key: "_unfocus",
            value: function _unfocus() {
                this.patch(_horizontalSquarestyle.unFocusedStyle);
            }
        },
        {
            key: "_handleEnter",
            value: function _handleEnter() {
                this.signal(_signals.SELECTED_SIGNAL, this._item);
                return true;
            }
        }
    ], [
        {
            key: "_template",
            value: /* istanbul ignore next */ function _template() {
                return (0, _merge.default)({
                    Background: {
                        rect: true,
                        shader: {
                            type: _sdk.Lightning.shaders.RoundedRectangle
                        }
                    },
                    Border: {
                        rect: true,
                        shader: {
                            type: _focusshader.default
                        }
                    },
                    ScalableContent: {
                        shader: {
                            type: _sdk.Lightning.shaders.RoundedRectangle
                        }
                    },
                    FlexContainer: {
                        Line1: {},
                        Line2: {},
                        Line3: {},
                        ProgressBar: {
                            type: _progresscomponent.default,
                            visible: false
                        }
                    }
                }, (0, _horizontalSquarestyle.getInitialStyle)());
            }
        }
    ]);
    return HorizontalSquare;
}(_sdk.Lightning.Component);
HorizontalSquare.Templates = _horizontalSquareconstants.templates;
HorizontalSquare.Sizes = _horizontalSquareconstants.sizes;
HorizontalSquare.ImageOptions = _horizontalSquareconstants.imageOptions;


/***/ }),

/***/ 13448:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    heights: function() {
        return heights;
    },
    imageOptions: function() {
        return imageOptions;
    },
    sizes: function() {
        return sizes;
    },
    templates: function() {
        return templates;
    }
});
var _define_property = __webpack_require__(21228);
var _export_star = __webpack_require__(37668);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
var _constants = __webpack_require__(34952);
var _sizes = __webpack_require__(82699);
var _horizontalSquareconstants = _export_star._(__webpack_require__(42685), exports);
var templates = {
    HorizontalSquare: "HorizontalSquare"
};
var _obj;
var heights = (_obj = {}, _define_property._(_obj, _constants.HD, 164), _define_property._(_obj, _constants.FULL_HD, 200), _obj);
var _obj1;
var imageOptions = _define_property._({}, templates.HorizontalSquare, (_obj1 = {}, _define_property._(_obj1, _constants.HD, {
    PRIMARY: {
        width: 120,
        height: 120
    }
}), _define_property._(_obj1, _constants.FULL_HD, {
    PRIMARY: {
        width: 144,
        height: 144
    }
}), _obj1));
var _getElementSize = (0, _sizes.getElementSize)(_horizontalSquareconstants.ITEMS_BY_BREAKPOINTS, 1.0, templates.HorizontalSquare), _sizes1 = _getElementSize.sizes;
var sizes = [
    _constants.FULL_HD,
    _constants.HD
].reduce(function(acc, size) {
    acc[templates.HorizontalSquare][size] = {
        w: _sizes1[templates.HorizontalSquare][size].w,
        h: heights[size]
    };
    return acc;
}, _define_property._({}, templates.HorizontalSquare, {}));


/***/ }),

/***/ 72042:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    IMAGE_OFFSET: function() {
        return IMAGE_OFFSET;
    },
    PADDING: function() {
        return PADDING;
    },
    TEXT_GAP: function() {
        return TEXT_GAP;
    },
    TEXT_LEFT_PADDING: function() {
        return TEXT_LEFT_PADDING;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getFocusedStyle: function() {
        return getFocusedStyle;
    },
    getImageSize: function() {
        return getImageSize;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    makeBasicIconStyle: function() {
        return makeBasicIconStyle;
    },
    makeBasicTextStyle: function() {
        return makeBasicTextStyle;
    },
    unFocusedStyle: function() {
        return unFocusedStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(3009);
var _memoize = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34736));
var _typography = __webpack_require__(18411);
var _theme = __webpack_require__(51397);
var _constants = __webpack_require__(34952);
var _style = __webpack_require__(65082);
var _focus = __webpack_require__(78506);
var _horizontalSquareconstants = __webpack_require__(13448);
var _colors = __webpack_require__(8426);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var PADDING = (_obj = {}, _define_property._(_obj, _constants.HD, 16), _define_property._(_obj, _constants.FULL_HD, 24), _obj);
var _obj1;
var TEXT_GAP = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 4), _define_property._(_obj1, _constants.FULL_HD, 4), _obj1);
var _obj2;
var TEXT_LEFT_PADDING = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 24), _define_property._(_obj2, _constants.FULL_HD, 24), _obj2);
var _obj3;
var IMAGE_OFFSET = (_obj3 = {}, _define_property._(_obj3, _constants.HD, _focus.BORDER_WIDTH[_constants.HD] * 2), _define_property._(_obj3, _constants.FULL_HD, _focus.BORDER_WIDTH[_constants.FULL_HD] * 2), _obj3);
var getImageSize = function(screenSize) {
    return _horizontalSquareconstants.imageOptions[_horizontalSquareconstants.templates.HorizontalSquare][screenSize].PRIMARY.height;
};
var colors = {
    background: (0, _theme.makeThemeColor)(_theme.PRIMARY, 0.1),
    border: _horizontalSquareconstants.BORDER_COLOR,
    innerBorder: _horizontalSquareconstants.INNER_BORDER_COLOR,
    text: (0, _theme.makeThemeColor)(_theme.PRIMARY)
};
var makeBasicTextStyle = function(param) {
    var font = param.font, _param_colorMode = param.colorMode, colorMode = _param_colorMode === void 0 ? _theme.DEFAULT_MODE : _param_colorMode;
    return {
        color: colors.text[colorMode],
        text: _object_spread_props._(_object_spread._({}, font), {
            verticalAlign: "middle",
            wordWrap: false,
            textOverflow: "..."
        })
    };
};
var makeBasicIconStyle = function() {
    return {
        alpha: 0.8
    };
};
var getInitialStyle = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext, _ref_screenSize = _ref.screenSize, screenSize = _ref_screenSize === void 0 ? _constants.FULL_HD : _ref_screenSize, _ref_colorMode = _ref.colorMode, colorMode = _ref_colorMode === void 0 ? _theme.DEFAULT_MODE : _ref_colorMode;
    var _sizes_templates_HorizontalSquare_screenSize = _horizontalSquareconstants.sizes[_horizontalSquareconstants.templates.HorizontalSquare][screenSize], w = _sizes_templates_HorizontalSquare_screenSize.w, h = _sizes_templates_HorizontalSquare_screenSize.h;
    var gap = TEXT_GAP[screenSize];
    var imageSize = getImageSize(screenSize);
    var verticalOffset = Math.round((h - imageSize) / 2);
    return {
        Background: {
            alpha: 0,
            w: w,
            h: h,
            color: colors.background[colorMode],
            shader: {
                radius: 8
            }
        },
        Border: {
            x: PADDING[screenSize] - _focus.BORDER_WIDTH[screenSize],
            y: verticalOffset - _focus.BORDER_WIDTH[screenSize],
            w: imageSize + IMAGE_OFFSET[screenSize],
            h: imageSize + IMAGE_OFFSET[screenSize],
            shader: {
                outline: _focus.BORDER_WIDTH[screenSize],
                radius: _focus.BORDER_RADIUS[screenSize],
                strokeColor: _colors.TRANSPARENT
            }
        },
        ScalableContent: {
            x: PADDING[screenSize],
            y: verticalOffset,
            w: imageSize,
            h: imageSize,
            shader: {
                stroke: 0,
                strokeColor: colors.border[colorMode],
                radius: _focus.BORDER_RADIUS[screenSize]
            }
        },
        FlexContainer: {
            flex: {
                direction: "column",
                justifyContent: "center"
            },
            x: PADDING[screenSize] + imageSize + TEXT_LEFT_PADDING[screenSize],
            y: verticalOffset,
            h: h - verticalOffset * 2,
            Line1: _object_spread_props._(_object_spread._({}, makeBasicTextStyle({
                font: (0, _typography.getFont)(_horizontalSquareconstants.TITLE_FONT_NAME, screenSize, _horizontalSquareconstants.TITLE_FONT_TYPE),
                colorMode: colorMode
            })), {
                flexItem: {
                    marginBottom: gap
                }
            }),
            Line2: _object_spread_props._(_object_spread._({}, makeBasicTextStyle({
                font: (0, _typography.getFont)(_typography.FONT.BERLIN_1, screenSize),
                colorMode: colorMode
            })), {
                flexItem: {
                    marginBottom: gap
                }
            }),
            Line3: {
                text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT.BERLIN_1, screenSize)), {
                    maxLines: 2,
                    verticalAlign: "middle",
                    wordWrap: true,
                    maxLinesSuffix: "..."
                }),
                flexItem: {
                    marginBottom: gap
                }
            },
            ProgressBar: {
                flexItem: {
                    marginTop: 16
                }
            }
        }
    };
};
var getFocusedStyle = (0, _memoize.default)(function(param) {
    var colorMode = param.colorMode;
    return {
        Background: {
            smooth: {
                alpha: 1
            }
        },
        Border: {
            smooth: {
                scale: _focus.SCALE_FOCUSED,
                "shader.strokeColor": colors.border[colorMode],
                "shader.innerColor": colors.innerBorder[colorMode],
                "shader.scale": _focus.SCALE_FOCUSED
            }
        },
        ScalableContent: {
            smooth: {
                scale: 1.05
            }
        }
    };
}, _style.cacheResolver);
var unFocusedStyle = {
    Background: {
        smooth: {
            alpha: 0
        }
    },
    Border: {
        smooth: {
            scale: 1,
            "shader.strokeColor": _colors.TRANSPARENT,
            "shader.innerColor": _colors.TRANSPARENT,
            "shader.scale": 1.0
        }
    },
    ScalableContent: {
        smooth: {
            scale: 1
        }
    }
};


/***/ }),

/***/ 90093:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _export_star = __webpack_require__(37668);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(37815);
_export_star._(__webpack_require__(5746), exports);


/***/ }),

/***/ 7048:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "appCustomer", ({
    enumerable: true,
    get: function() {
        return _utils.appCustomer;
    }
}));
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(37815);
var _utils = __webpack_require__(64188);


/***/ }),

/***/ 70160:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return Icon;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _get = __webpack_require__(60528);
var _get_prototype_of = __webpack_require__(35196);
var _inherits = __webpack_require__(71648);
var _set = __webpack_require__(81364);
var _create_super = __webpack_require__(6400);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(37815);
var _sdk = __webpack_require__(29956);
var _iconprovider = __webpack_require__(58449);
var _iconutils = __webpack_require__(48246);
var _iconconstants = __webpack_require__(48112);
var _colors = __webpack_require__(8426);
var Icon = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(Icon, _Lightning_Component);
    var _super = _create_super._(Icon);
    function Icon() {
        _class_call_check._(this, Icon);
        return _super.apply(this, arguments);
    }
    _create_class._(Icon, [
        {
            key: "_construct",
            value: function _construct() {
                this._textureScale = 1;
                this._textureLoadedHandler = this._onTextureLoaded.bind(this);
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                this.removeAllListeners("txLoaded");
                this._name = undefined;
            }
        },
        {
            key: "name",
            get: function get() {
                return this._name;
            }
        },
        {
            key: "color",
            get: function get() {
                return _get._(_get_prototype_of._(Icon.prototype), "color", this);
            },
            set: function set(value) {
                _set._(_get_prototype_of._(Icon.prototype), "color", _iconconstants.COLOR_LOCKED.includes(this._name) ? _colors.WHITE : value, this, true);
            }
        },
        {
            key: "iconData",
            set: /**
   * @param {IconData} value icon data to render
   */ function set(value) {
                this._textureScale = value.scale || 1;
                if (value.picto && value.picto.name) {
                    this._name = value.picto.name;
                }
                this.iconTexture = typeof value.picto === "string" ? (0, _iconprovider.getTextureByUrl)(value.picto, value.viewBox, this._textureScale) : (0, _iconprovider.getTextureByIconData)(value);
            }
        },
        {
            key: "iconTexture",
            set: function set(value) {
                this.texture = null;
                this.removeListener("txLoaded", this._textureLoadedHandler);
                if (this._textureScale !== 1) {
                    this.on("txLoaded", this._textureLoadedHandler);
                }
                this.texture = value;
            }
        },
        {
            key: "_onTextureLoaded",
            value: function _onTextureLoaded(texture) {
                var sizes = (0, _iconutils.getScaledTextureSize)(texture, this._textureScale);
                if (sizes) {
                    this.patch(sizes);
                }
            }
        }
    ]);
    return Icon;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 48112:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    COLOR_LOCKED: function() {
        return COLOR_LOCKED;
    },
    ICON_COLOR_SUFFIX: function() {
        return ICON_COLOR_SUFFIX;
    },
    ICON_TYPE: function() {
        return ICON_TYPE;
    },
    customerServiceIcon: function() {
        return customerServiceIcon;
    }
});
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(88801);
var _appCustomerconstants = __webpack_require__(7048);
var ICON_TYPE = {
    SERVICE_ICON: "service-icon",
    SIMPLE_ICON: "icon"
};
var customerServiceIcon = {
    type: ICON_TYPE.SERVICE_ICON,
    name: _appCustomerconstants.appCustomer
};
var ICON_COLOR_SUFFIX = {
    dark: "_dark",
    default: "",
    light: "_ghost"
};
var COLOR_LOCKED = [
    "Live",
    "BackToLive",
    "Csa6",
    "Csa12",
    "Csa16",
    "Csa18"
];


/***/ }),

/***/ 58449:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    cleanupIconsCache: function() {
        return cleanupIconsCache;
    },
    getIconUrl: function() {
        return getIconUrl;
    },
    getTextureByIconData: function() {
        return getTextureByIconData;
    },
    getTextureByName: function() {
        return getTextureByName;
    },
    getTextureByUrl: function() {
        return getTextureByUrl;
    }
});
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(88801);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _config = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67958));
var _icons = __webpack_require__(20360);
var _appsettings = __webpack_require__(20944);
var _iconconstants = __webpack_require__(48112);
var textureCache = {};
var getServiceIconFromBundle = function(name) {
    var colorMode = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "default";
    var baseUrl = (0, _get.default)(_config.default, "assetsBundle.manifest.baseUrl");
    var icon = (0, _get.default)(_config.default, "assetsBundle.manifest.urls.viewbox.".concat(name).concat(_iconconstants.ICON_COLOR_SUFFIX[colorMode]));
    if (!baseUrl) {
        return null;
    }
    if (!icon) {
        return null;
    }
    return "".concat(baseUrl, "/").concat(icon);
};
var getServiceIcon = function(name) {
    var colorMode = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "default";
    var fullCode = getServiceIconFromBundle(name, colorMode);
    return fullCode;
};
var getIconUrl = function(type, name, collection, colorMode) {
    switch(type){
        case _iconconstants.ICON_TYPE.SERVICE_ICON:
            return getServiceIcon(name, colorMode);
        default:
            return (0, _appsettings.getFullPath)((0, _icons.iconByName)(name.toLowerCase(), collection));
    }
};
var getTextureByUrl = function(url, viewBox, scale) {
    var useCache = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
    var width = viewBox.w, height = viewBox.h;
    var id = [
        url,
        width,
        height,
        scale
    ].join("_");
    if (useCache && textureCache[id]) {
        return textureCache[id];
    }
    var result = (0, _icons.getSvgTexture)(url, width, height, scale);
    if (useCache) {
        textureCache[id] = result;
    }
    return result;
};
var getTextureByName = function(picto, viewBox) {
    var scale = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, colorMode = arguments.length > 3 ? arguments[3] : void 0, useCache = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : true;
    if (!picto || !picto.name || !viewBox) {
        return null;
    }
    var name = picto.name, type = picto.type, collection = picto.collection;
    var url = getIconUrl(type, name, collection, colorMode);
    return getTextureByUrl(url, viewBox, scale, useCache);
};
var getTextureByIconData = function(iconData) {
    if (iconData) {
        var picto = iconData.picto, viewBox = iconData.viewBox, colorMode = iconData.colorMode;
        if (picto && viewBox) {
            return getTextureByName(picto, viewBox, iconData.scale || 1, colorMode);
        }
    }
    return null;
};
var cleanupIconsCache = function() {
    Object.keys(textureCache).forEach(function(key) {
        delete textureCache[key];
    });
};


/***/ }),

/***/ 48246:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/**
 * Calculates image size for previously up-scaled or down-scaled texture
 *
 * @param {number} scale when scale is equal to 1 it will not be applied and this function will return null
 * @param {Object} texture Lightning texture
 * @returns {?Object} size containing "w" and "h" properties, or null if scale is equal to 1
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "getScaledTextureSize", ({
    enumerable: true,
    get: function() {
        return getScaledTextureSize;
    }
}));
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(45538);
var getScaledTextureSize = function(texture) {
    var scale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    if (scale !== 1 && texture._source) {
        var _texture__source = texture._source, w = _texture__source.w, h = _texture__source.h;
        return {
            w: Math.round(w / scale),
            h: Math.round(h / scale)
        };
    }
    return null;
};


/***/ }),

/***/ 9077:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/* eslint-disable no-console */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return Incentive;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _create_super = __webpack_require__(6400);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(37815);
var _flatMap = /*#__PURE__*/ _interop_require_default._(__webpack_require__(47812));
var _sdk = __webpack_require__(29956);
var _stampcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(56117));
var _stampstyle = __webpack_require__(76103);
var _stampconstants = __webpack_require__(97147);
var _incentivestyle = __webpack_require__(64443);
var _incentiveconstants = __webpack_require__(37212);
var _incentiveutils = __webpack_require__(72823);
var Incentive = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(Incentive, _Lightning_Component);
    var _super = _create_super._(Incentive);
    function Incentive() {
        _class_call_check._(this, Incentive);
        return _super.apply(this, arguments);
    }
    _create_class._(Incentive, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _incentivestyle.defaultContext;
                this._childrenLoaded = 0;
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                this.children.forEach(function(child) {
                    child.removeAllListeners("txLoaded");
                });
            }
        },
        {
            key: "data",
            set: function set(param) {
                var colorMode = param.colorMode, incentives = param.incentives, w = param.w, linesCount = param.linesCount, _param_alignment = param.alignment, alignment = _param_alignment === void 0 ? _incentiveconstants.ALIGNMENT_HORIZONTAL : _param_alignment;
                var _this = this;
                if (!incentives || !incentives.length || !linesCount) {
                    if (this.children.length) {
                        this.children = [];
                    }
                    return;
                }
                if (colorMode && colorMode !== this._style.colorMode) {
                    this._style = {
                        screenSize: this._style.screenSize,
                        colorMode: colorMode
                    };
                }
                var wordWrapWidth = w && alignment === _incentiveconstants.ALIGNMENT_HORIZONTAL ? Math.round(w / linesCount) : w;
                this.children = (0, _flatMap.default)(incentives.filter(_incentiveutils.hasValidDisplayVariant), function(incentive) {
                    var displayVariant = (0, _incentiveutils.getDisplayVariant)(incentive);
                    return (incentive.lines || []).map(function(param) {
                        var theme = param.theme, text = param.text;
                        if (!text) {
                            return null;
                        }
                        switch(theme){
                            case _incentiveconstants.THEME_STAMP:
                                return {
                                    type: _stampcomponent.default,
                                    label: text,
                                    labelColor: _stampstyle.colors.text[_this._style.colorMode],
                                    wordWrapWidth: wordWrapWidth - _stampstyle.PADDING[_this._style.screenSize] * 2,
                                    backgroundColor: displayVariant === _stampconstants.DISPLAY_VARIANT_PRIMARY ? _stampstyle.colors.primary[_this._style.colorMode] : _stampstyle.colors.secondary[_this._style.colorMode]
                                };
                            case _incentiveconstants.THEME_TEXT:
                                {
                                    return {
                                        y: _stampstyle.PADDING[_this._style.screenSize],
                                        color: _incentivestyle.colors.text[_this._style.colorMode],
                                        text: _object_spread_props._(_object_spread._({}, (0, _incentivestyle.getTextTemplate)(_this._style.screenSize)), {
                                            wordWrapWidth: wordWrapWidth,
                                            text: text
                                        })
                                    };
                                }
                            default:
                                return null;
                        }
                    }).filter(Boolean);
                });
                this._childrenLoaded = 0;
                this.children.forEach(function(child) {
                    child.once("txLoaded", function() {
                        _this._childrenLoaded += 1;
                        if (_this._childrenLoaded >= _this.children.length) {
                            _this._placeChildren(alignment);
                        }
                    });
                });
            }
        },
        {
            key: "_placeChildren",
            value: function _placeChildren() {
                var alignment = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _incentiveconstants.ALIGNMENT_HORIZONTAL;
                var _this = this;
                var offset = 0;
                if (alignment === _incentiveconstants.ALIGNMENT_VERTICAL) {
                    var w = 0;
                    this.children.forEach(function(child) {
                        child.y = offset;
                        offset += child.finalH + _incentivestyle.GAP[_this._style.screenSize];
                        w = Math.max(w, child.finalW);
                    });
                    this.children.forEach(function(child) {
                        child.x = Math.round((w - child.finalW) / 2);
                    });
                    this.patch({
                        w: w,
                        h: offset
                    });
                } else {
                    this.children.forEach(function(child) {
                        child.x = offset;
                        offset += child.finalW + _incentivestyle.GAP[_this._style.screenSize];
                    });
                    this.w = offset;
                }
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _incentivestyle.getInitialStyle)();
            }
        }
    ]);
    return Incentive;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 37212:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ALIGNMENT_HORIZONTAL: function() {
        return ALIGNMENT_HORIZONTAL;
    },
    ALIGNMENT_VERTICAL: function() {
        return ALIGNMENT_VERTICAL;
    },
    MULTI_LINE_CHAR_LIMIT: function() {
        return MULTI_LINE_CHAR_LIMIT;
    },
    SINGLE_LINE_CHAR_LIMIT: function() {
        return SINGLE_LINE_CHAR_LIMIT;
    },
    THEME_STAMP: function() {
        return THEME_STAMP;
    },
    THEME_TEXT: function() {
        return THEME_TEXT;
    }
});
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(65759);
var THEME_STAMP = "stamp";
var THEME_TEXT = "text";
var ALIGNMENT_HORIZONTAL = "horizontal";
var ALIGNMENT_VERTICAL = "vertical";
var SINGLE_LINE_CHAR_LIMIT = 18;
var MULTI_LINE_CHAR_LIMIT = 18;


/***/ }),

/***/ 64443:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    GAP: function() {
        return GAP;
    },
    HEIGHT: function() {
        return HEIGHT;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    getTextTemplate: function() {
        return getTextTemplate;
    }
});
var _define_property = __webpack_require__(21228);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
var _typography = __webpack_require__(18411);
var _constants = __webpack_require__(34952);
var _theme = __webpack_require__(51397);
var _style = __webpack_require__(65082);
var _stampstyle = __webpack_require__(76103);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var GAP = (_obj = {}, _define_property._(_obj, _constants.HD, 4), _define_property._(_obj, _constants.FULL_HD, 4), _obj);
var _obj1;
var HEIGHT = (_obj1 = {}, _define_property._(_obj1, _constants.HD, (0, _stampstyle.getLabelFont)(_constants.HD).lineHeight + _stampstyle.PADDING[_constants.HD] * 2), _define_property._(_obj1, _constants.FULL_HD, (0, _stampstyle.getLabelFont)(_constants.FULL_HD).lineHeight + _stampstyle.PADDING[_constants.FULL_HD] * 2), _obj1);
var colors = {
    text: (0, _theme.makeThemeColor)(_theme.PRIMARY)
};
var getTextTemplate = function(screenSize) {
    return _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT.BOSTON_2, screenSize)), {
        verticalAlign: "middle",
        wordWrap: false,
        textOverflow: "..."
    });
};
var getInitialStyle = function() {
    var screenSize = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext).screenSize;
    return {
        h: HEIGHT[screenSize]
    };
};


/***/ }),

/***/ 72823:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    getDisplayVariant: function() {
        return getDisplayVariant;
    },
    getLinesCount: function() {
        return getLinesCount;
    },
    hasValidDisplayVariant: function() {
        return hasValidDisplayVariant;
    }
});
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(3009);
var _stampconstants = __webpack_require__(97147);
var getDisplayVariant = function(incentive) {
    try {
        return incentive.display.variant.toLowerCase();
    } catch (error) {
        return "";
    }
};
var hasValidDisplayVariant = function(incentive) {
    var variant = getDisplayVariant(incentive);
    return variant === _stampconstants.DISPLAY_VARIANT_PRIMARY || variant === _stampconstants.DISPLAY_VARIANT_SECONDARY;
};
var getLinesCount = function(incentives) {
    if (!incentives || !incentives.length) {
        return false;
    }
    return incentives.filter(hasValidDisplayVariant).reduce(function(result, incentive) {
        return result + (incentive.lines ? incentive.lines.filter(function(line) {
            return line.text;
        }).length : 0);
    }, 0);
};


/***/ }),

/***/ 78026:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DISPLAY_PROGRESS: function() {
        return DISPLAY_PROGRESS;
    },
    ICONS: function() {
        return ICONS;
    },
    ICONS_TYPES: function() {
        return ICONS_TYPES;
    },
    ITEMS_BY_BREAKPOINTS: function() {
        return ITEMS_BY_BREAKPOINTS;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(37815);
var _constants = __webpack_require__(34952);
var _iconcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(70160));
var _badgecomponent = __webpack_require__(69289);
var _templates = __webpack_require__(88229);
var _obj;
var ICONS = (_obj = {}, _define_property._(_obj, _templates.ICON_POSITION.TOP_LEFT, 2), _define_property._(_obj, _templates.ICON_POSITION.TOP_RIGHT, 4), _obj);
var _obj1;
var ICONS_TYPES = (_obj1 = {}, _define_property._(_obj1, _templates.ICON_POSITION.TOP_LEFT, _iconcomponent.default), _define_property._(_obj1, _templates.ICON_POSITION.TOP_RIGHT, _badgecomponent.Badge), _define_property._(_obj1, _templates.ICON_POSITION.BOTTOM_RIGHT, _iconcomponent.default), _obj1);
var DISPLAY_PROGRESS = true;
var _obj2;
var ITEMS_BY_BREAKPOINTS = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 7), _define_property._(_obj2, _constants.FULL_HD, 7), _obj2);


/***/ }),

/***/ 54656:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return Jacket;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(65759);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _sdk = __webpack_require__(29956);
var _focusshader = /*#__PURE__*/ _interop_require_default._(__webpack_require__(25906));
var _imageshader = /*#__PURE__*/ _interop_require_default._(__webpack_require__(17154));
var _templates = __webpack_require__(88229);
var _signals = __webpack_require__(2109);
var _incentivecomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(9077));
var _incentiveutils = __webpack_require__(72823);
var _incentiveconstants = __webpack_require__(37212);
var _jacketconstants = __webpack_require__(29946);
var _jacketstyle = __webpack_require__(99760);
var Jacket = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(Jacket, _Lightning_Component);
    var _super = _create_super._(Jacket);
    function Jacket() {
        _class_call_check._(this, Jacket);
        return _super.apply(this, arguments);
    }
    _create_class._(Jacket, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _jacketstyle.defaultContext;
            }
        },
        {
            key: "_inactive",
            value: function _inactive() {
                this.signal(_signals.INACTIVE_SIGNAL, this);
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                this._item = undefined;
                this.signal(_signals.DETACHED_SIGNAL, this);
            }
        },
        {
            key: "item",
            get: function get() {
                return this._item;
            },
            set: function set(param) {
                var content = param.content, config = param.config, template = param.template, colorScheme = param.colorScheme;
                var templateDataAccessPath = [
                    template,
                    this._style.screenSize
                ];
                if (this._item && this._item.id === content.id) {
                    this._item = content;
                    return;
                }
                this._item = content;
                this._config = config || (0, _get.default)(_jacketconstants.sizes, templateDataAccessPath, {});
                var _this__item = this._item, pictos = _this__item.pictos, image = _this__item.image, incentives = _this__item.incentives;
                var imageUrl = image && image.src || "";
                var screenSize = this._style.screenSize;
                var viewBox = (0, _jacketstyle.getIconViewBox)(screenSize);
                var incentiveLines = (0, _incentiveutils.getLinesCount)(incentives);
                this._style = {
                    screenSize: screenSize,
                    colorMode: colorScheme
                };
                this.patch({
                    Image: {
                        src: imageUrl
                    },
                    TopLeftIcon: {
                        iconData: {
                            picto: (0, _jacketstyle.getIcon)(pictos, _templates.ICON_POSITION.TOP_LEFT),
                            viewBox: viewBox
                        }
                    },
                    TopRightIcon: {
                        iconData: {
                            picto: (0, _jacketstyle.getIcon)(pictos, _templates.ICON_POSITION.TOP_RIGHT),
                            viewBox: viewBox
                        }
                    },
                    BottomRightIcon: {
                        iconData: {
                            picto: (0, _jacketstyle.getIcon)(pictos, _templates.ICON_POSITION.BOTTOM_RIGHT),
                            viewBox: viewBox
                        }
                    },
                    Incentive: {
                        visible: incentiveLines > 0,
                        data: {
                            linesCount: incentiveLines,
                            w: this._config.w,
                            incentives: incentives,
                            colorMode: this._style.colorMOde,
                            alignment: _incentiveconstants.ALIGNMENT_VERTICAL
                        }
                    }
                });
            }
        },
        {
            key: "_focus",
            value: function _focus() {
                this.patch((0, _jacketstyle.getFocusedStyle)(this._style));
            }
        },
        {
            key: "_unfocus",
            value: function _unfocus() {
                this.patch(_jacketstyle.unFocusedStyle);
            }
        },
        {
            key: "_handleEnter",
            value: function _handleEnter() {
                this.signal(_signals.SELECTED_SIGNAL, this._item);
                return true;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Border: {
                        rect: true,
                        shader: {
                            type: _focusshader.default
                        }
                    },
                    Image: {
                        shader: {
                            type: _imageshader.default
                        }
                    },
                    TopLeftIcon: {
                        type: _jacketconstants.ICONS_TYPES[_templates.ICON_POSITION.TOP_LEFT]
                    },
                    TopRightIcon: {
                        type: _jacketconstants.ICONS_TYPES[_templates.ICON_POSITION.TOP_RIGHT]
                    },
                    BottomRightIcon: {
                        type: _jacketconstants.ICONS_TYPES[_templates.ICON_POSITION.BOTTOM_RIGHT]
                    },
                    Incentive: {
                        type: _incentivecomponent.default
                    }
                }, (0, _jacketstyle.getInitialStyle)());
            }
        }
    ]);
    return Jacket;
}(_sdk.Lightning.Component);
Jacket.Templates = _jacketconstants.templates;
Jacket.Sizes = _jacketconstants.sizes;
Jacket.ImageOptions = _jacketconstants.imageOptions;


/***/ }),

/***/ 29946:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    imageOptions: function() {
        return imageOptions;
    },
    sizes: function() {
        return sizes;
    },
    templates: function() {
        return templates;
    }
});
var _export_star = __webpack_require__(37668);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(52318);
var _sizes = __webpack_require__(82699);
var _jacketconstants = _export_star._(__webpack_require__(78026), exports);
var templates = {
    Jacket: "Jacket"
};
var RATIO = 4 / 3;
var _getElementSize = (0, _sizes.getElementSize)(_jacketconstants.ITEMS_BY_BREAKPOINTS, RATIO, templates.Jacket), sizes = _getElementSize.sizes, imageOptions = _getElementSize.imageOptions;


/***/ }),

/***/ 99760:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ICON_HEIGHT: function() {
        return ICON_HEIGHT;
    },
    ICON_PADDING_HORIZONTAL: function() {
        return ICON_PADDING_HORIZONTAL;
    },
    ICON_PADDING_VERTICAL: function() {
        return ICON_PADDING_VERTICAL;
    },
    LOCK_ICON_HEIGHT: function() {
        return LOCK_ICON_HEIGHT;
    },
    PADDING_HORIZONTAL: function() {
        return PADDING_HORIZONTAL;
    },
    PADDING_VERTICAL: function() {
        return PADDING_VERTICAL;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getFocusedStyle: function() {
        return getFocusedStyle;
    },
    getIcon: function() {
        return getIcon;
    },
    getIconViewBox: function() {
        return getIconViewBox;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    unFocusedStyle: function() {
        return unFocusedStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(52318);
var _constants = __webpack_require__(34952);
var _memoize = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34736));
var _style = __webpack_require__(65082);
var _colors = __webpack_require__(8426);
var _focus = __webpack_require__(78506);
var _jacketconstants = __webpack_require__(29946);
var _sizes = __webpack_require__(82699);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var ICON_PADDING_VERTICAL = 4;
var ICON_PADDING_HORIZONTAL = 8;
var _obj;
var ICON_HEIGHT = (_obj = {}, _define_property._(_obj, _constants.HD, 24), _define_property._(_obj, _constants.FULL_HD, 32), _obj);
var _obj1;
var LOCK_ICON_HEIGHT = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 32), _define_property._(_obj1, _constants.FULL_HD, 40), _obj1);
var PADDING_VERTICAL = 4;
var PADDING_HORIZONTAL = 8;
var getIconViewBox = (0, _memoize.default)(function(screenSize) {
    return {
        h: ICON_HEIGHT[screenSize]
    };
});
var getIcon = function(icons, position) {
    return icons ? icons[_jacketconstants.ICONS[position]] : null;
};
var getInitialStyle = function() {
    var screenSize = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext).screenSize;
    var _sizes_templates_Jacket_screenSize = _jacketconstants.sizes[_jacketconstants.templates.Jacket][screenSize], w = _sizes_templates_Jacket_screenSize.w, h = _sizes_templates_Jacket_screenSize.h;
    var borderSize = _focus.BORDER_WIDTH[screenSize];
    var borderOffset = borderSize * 2;
    return {
        Border: {
            w: w + borderOffset,
            h: h + borderOffset,
            x: -borderSize,
            y: -borderSize,
            color: _colors.TRANSPARENT,
            shader: {
                radius: _focus.BORDER_RADIUS[screenSize],
                outline: _focus.BORDER_WIDTH[screenSize],
                strokeColor: _colors.TRANSPARENT,
                innerColor: _colors.TRANSPARENT
            }
        },
        Image: _object_spread_props._(_object_spread._({}, _jacketconstants.sizes[screenSize]), {
            shader: {
                radius: _focus.BORDER_RADIUS[screenSize]
            }
        }),
        TopLeftIcon: {
            x: PADDING_HORIZONTAL,
            y: PADDING_VERTICAL
        },
        TopRightIcon: {
            alpha: 0.8,
            x: w - PADDING_HORIZONTAL - ICON_HEIGHT[screenSize],
            y: h - PADDING_VERTICAL - ICON_HEIGHT[screenSize]
        },
        BottomRightIcon: {
            mountX: 1,
            x: w - PADDING_HORIZONTAL,
            y: PADDING_VERTICAL
        },
        Incentive: {
            x: _sizes.middle,
            y: _sizes.middle,
            mount: 0.5
        }
    };
};
var getFocusedStyle = (0, _memoize.default)(function(param) {
    var colorMode = param.colorMode;
    return {
        Border: {
            smooth: {
                scale: _focus.SCALE_FOCUSED,
                "shader.strokeColor": _focus.BORDER_COLOR[colorMode],
                "shader.innerColor": _focus.INNER_BORDER_COLOR[colorMode],
                "shader.scale": _focus.SCALE_FOCUSED
            }
        },
        Image: {
            smooth: {
                scale: _focus.SCALE_FOCUSED,
                "shader.scale": _focus.SCALE_FOCUSED
            }
        }
    };
}, _style.cacheResolver);
var unFocusedStyle = {
    Border: {
        smooth: {
            scale: 1,
            "shader.strokeColor": _colors.TRANSPARENT,
            "shader.innerColor": _colors.TRANSPARENT,
            "shader.scale": 1.0
        }
    },
    Image: {
        smooth: {
            scale: 1,
            "shader.scale": 1.0
        }
    }
};


/***/ }),

/***/ 10050:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return JumbotronSquare;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _create_super = __webpack_require__(6400);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _analyticsutils = __webpack_require__(2693);
var _incentivecomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(9077));
var _progresscomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(45926));
var _callToActioncomponent = __webpack_require__(91743);
var _callToActioncomponent1 = __webpack_require__(28518);
var _myListCallToActioncomponent = __webpack_require__(5805);
var _podcastInformationcomponent = __webpack_require__(49360);
var _podcastInformationconstants = __webpack_require__(98050);
var _signals = __webpack_require__(2109);
var _incentiveutils = __webpack_require__(72823);
var _templates = __webpack_require__(88229);
var _soloutils = __webpack_require__(50088);
var _progressutils = __webpack_require__(40779);
var _jumbotronutils = __webpack_require__(68141);
var _podcastInformationstyle = __webpack_require__(99024);
var _jumbotronSquarestyle = __webpack_require__(70382);
var _jumbotronSquareconstants = __webpack_require__(6983);
var JumbotronSquare = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(JumbotronSquare, _Lightning_Component);
    var _super = _create_super._(JumbotronSquare);
    function JumbotronSquare() {
        _class_call_check._(this, JumbotronSquare);
        return _super.apply(this, arguments);
    }
    _create_class._(JumbotronSquare, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _jumbotronSquarestyle.defaultContext;
                this._buttons = [];
                this._index = 0;
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                this._buttons = null;
                this._focused = null;
            }
        },
        {
            key: "item",
            get: function get() {
                return this._item;
            },
            set: function set(param) {
                var content = param.content, blockIndex = param.blockIndex, itemIndex = param.itemIndex, config = param.config, _param_colorScheme = param.colorScheme, colorScheme = _param_colorScheme === void 0 ? _jumbotronSquarestyle.defaultContext.colorMode : _param_colorScheme;
                this._item = content;
                var _this__item = this._item, action = _this__item.action, author = _this__item.author, bookmark = _this__item.bookmark, description = _this__item.description, extraDetails = _this__item.extraDetails, image = _this__item.image, incentives = _this__item.incentives, progress = _this__item.progress, title = _this__item.title;
                // const incentives = [
                //   {
                //     display: {
                //       variant: 'primary',
                //     },
                //     lines: [
                //       {
                //         theme: 'text',
                //         text: 'Text',
                //       },
                //       {
                //         theme: 'stamp',
                //         text: 'Primary',
                //       },
                //     ],
                //   },
                //   {
                //     display: {
                //       variant: 'secondary',
                //     },
                //     lines: [
                //       {
                //         theme: 'stamp',
                //         text: 'Secondary',
                //       },
                //     ],
                //   },
                // ];
                var incentiveLines = (0, _incentiveutils.getLinesCount)(incentives);
                var leftWidth = (0, _jumbotronSquarestyle.getLeftContainerWidth)(this._style.screenSize, this.tag("FlexContainer").x);
                var textColor = _jumbotronSquarestyle.colors.text[this._style.colorMode];
                this.patch({
                    FlexContainer: {
                        Image: {
                            src: image.src
                        },
                        ContainerD: {
                            w: leftWidth,
                            ContainerE: {
                                w: leftWidth,
                                visible: incentiveLines > 0 || title || author,
                                Incentive: {
                                    visible: incentiveLines > 0,
                                    data: {
                                        linesCount: incentiveLines,
                                        w: leftWidth,
                                        incentives: incentives,
                                        colorMode: this._style.colorMode
                                    }
                                },
                                Title: (0, _templates.makeTextPatch)(title, leftWidth, textColor),
                                Author: (0, _templates.makeTextPatch)(author, leftWidth, textColor)
                            },
                            ContainerH: {
                                ProgressBar: _object_spread._({
                                    w: Math.round(leftWidth * 0.33)
                                }, (0, _progressutils.makeProgressBarProperties)(progress)),
                                ButtonsContainer: {
                                    PlayButton: {
                                        visible: (0, _soloutils.isVisibleCTA)(action),
                                        label: (0, _get.default)(action, "label", ""),
                                        picto: (0, _get.default)(action, "picto", "")
                                    },
                                    MyListButton: {
                                        visible: Boolean(bookmark),
                                        item: bookmark,
                                        blockIndex: blockIndex,
                                        itemIndex: itemIndex
                                    },
                                    InfoButton: {
                                        visible: (0, _jumbotronutils.isVisibleInformationButton)(this._item)
                                    }
                                }
                            },
                            Separator: {
                                w: leftWidth,
                                visible: extraDetails || description
                            },
                            ContainerI: {
                                ExtraDetails: (0, _templates.makeTextPatch)(extraDetails, leftWidth, textColor),
                                Description: (0, _templates.makeTextPatch)(description, leftWidth, textColor)
                            }
                        }
                    },
                    ProgramInformation: {
                        data: this._item
                    }
                });
                this._buttons = this.tag("ButtonsContainer").children.filter(function(item) {
                    return item.visible;
                });
                this._setIndex();
            }
        },
        {
            key: "contentPadding",
            set: function set(value) {
                this.tag("FlexContainer").x = Number.isFinite(value) ? value : 0;
            }
        },
        {
            key: "_setIndex",
            value: function _setIndex() {
                var index = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._index;
                this._index = index;
                this._focused = this._buttons && this._buttons[this._index];
            }
        },
        {
            key: "_showProgramInformation",
            value: function _showProgramInformation() {
                this.zIndex = _jumbotronSquareconstants.Z_INDEX_WITH_PROGRAM_INFO;
                this.tag("ProgramInformation").patch((0, _podcastInformationstyle.getProgramInformationFocusedStyle)());
                this._focused = this.tag("ProgramInformation");
            }
        },
        {
            key: "_handleProgramInformationClose",
            value: function _handleProgramInformationClose() {
                this.zIndex = _jumbotronSquareconstants.Z_INDEX_NORMAL;
                this.tag("ProgramInformation").patch((0, _podcastInformationstyle.getProgramInformationUnFocusedStyle)());
                this._setIndex();
                (0, _analyticsutils.sendEvent)({
                    key: "closeMoreInfo"
                });
            }
        },
        {
            key: "_getFocused",
            value: function _getFocused() {
                return this._focused;
            }
        },
        {
            key: "_handleRight",
            value: function _handleRight() {
                if (!this._buttons) {
                    return false;
                }
                if (this._index < this._buttons.length - 1) {
                    this._setIndex(this._index + 1);
                    return true;
                }
                return false;
            }
        },
        {
            key: "_handleLeft",
            value: function _handleLeft() {
                if (this._index > 0) {
                    this._setIndex(this._index - 1);
                    return true;
                }
                return false;
            }
        },
        {
            key: "_handleEnter",
            value: function _handleEnter() {
                if (this._focused === this.tag("InfoButton")) {
                    this._showProgramInformation();
                    (0, _analyticsutils.sendEvent)({
                        key: "pressMoreInfo"
                    });
                } else {
                    this.signal(_signals.SELECTED_SIGNAL, this._item);
                }
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    FlexContainer: {
                        Image: {
                            shader: {
                                type: _sdk.Lightning.shaders.RoundedRectangle
                            }
                        },
                        ContainerD: {
                            ContainerE: {
                                Incentive: {
                                    type: _incentivecomponent.default
                                },
                                Title: {},
                                Author: {}
                            },
                            ContainerH: {
                                ProgressBar: {
                                    type: _progresscomponent.default
                                },
                                ButtonsContainer: {
                                    PlayButton: {
                                        type: _callToActioncomponent.CallToAction
                                    },
                                    MyListButton: {
                                        type: _myListCallToActioncomponent.MyListButtonSecondary,
                                        passSignals: _define_property._({}, _signals.SELECTED_SIGNAL, true)
                                    },
                                    InfoButton: {
                                        type: _callToActioncomponent1.CallToAction
                                    }
                                }
                            },
                            Separator: {
                                rect: true
                            },
                            ContainerI: {
                                ExtraDetails: {},
                                Description: {}
                            }
                        }
                    },
                    ProgramInformation: {
                        type: _podcastInformationcomponent.PodcastInformation,
                        signals: _define_property._({}, _podcastInformationconstants.PROGRAM_INFORMATION_CLOSED_SIGNAL, "_handleProgramInformationClose")
                    }
                }, (0, _jumbotronSquarestyle.getInitialStyle)());
            }
        },
        {
            key: "getBottomMargin",
            value: function getBottomMargin(param) {
                var screenSize = param.screenSize;
                return _jumbotronSquareconstants.VERTICAL_PADDING[screenSize];
            }
        }
    ]);
    return JumbotronSquare;
}(_sdk.Lightning.Component);
JumbotronSquare.Templates = _jumbotronSquareconstants.templates;
JumbotronSquare.Sizes = _jumbotronSquareconstants.sizes;
JumbotronSquare.ImageOptions = _jumbotronSquareconstants.imageOptions;


/***/ }),

/***/ 6983:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    VERTICAL_PADDING: function() {
        return VERTICAL_PADDING;
    },
    Z_INDEX_NORMAL: function() {
        return Z_INDEX_NORMAL;
    },
    Z_INDEX_WITH_PROGRAM_INFO: function() {
        return Z_INDEX_WITH_PROGRAM_INFO;
    },
    imageOptions: function() {
        return imageOptions;
    },
    sizes: function() {
        return sizes;
    },
    templates: function() {
        return templates;
    }
});
var _define_property = __webpack_require__(21228);
var _object_spread = __webpack_require__(76247);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
var _constants = __webpack_require__(34952);
var _sizes = __webpack_require__(82699);
var _podcastInformationTopstyle = __webpack_require__(11944);
var templates = {
    JumbotronSquare: "JumbotronSquare"
};
var _obj;
var VERTICAL_PADDING = (_obj = {}, _define_property._(_obj, _constants.HD, 56), _define_property._(_obj, _constants.FULL_HD, 56), _obj);
var _obj1;
var IMAGE_SIZE = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 448), _define_property._(_obj1, _constants.FULL_HD, 448), _obj1);
var Z_INDEX_NORMAL = 0;
var Z_INDEX_WITH_PROGRAM_INFO = 1000;
var _obj2;
var sizes = _define_property._({}, templates.JumbotronSquare, (_obj2 = {}, _define_property._(_obj2, _constants.HD, {
    w: _sizes.SCREEN_WIDTH[_constants.HD],
    h: IMAGE_SIZE[_constants.HD] + VERTICAL_PADDING[_constants.HD]
}), _define_property._(_obj2, _constants.FULL_HD, {
    w: _sizes.SCREEN_WIDTH[_constants.FULL_HD],
    h: IMAGE_SIZE[_constants.FULL_HD] + VERTICAL_PADDING[_constants.FULL_HD]
}), _obj2));
var _obj3;
var imageOptions = _define_property._({}, templates.JumbotronSquare, (_obj3 = {}, _define_property._(_obj3, _constants.HD, {
    PRIMARY: {
        width: IMAGE_SIZE[_constants.HD],
        height: IMAGE_SIZE[_constants.HD]
    },
    LOGO: _object_spread._({}, _podcastInformationTopstyle.LOGO_DIMENSIONS[_constants.HD])
}), _define_property._(_obj3, _constants.FULL_HD, {
    PRIMARY: {
        width: IMAGE_SIZE[_constants.FULL_HD],
        height: IMAGE_SIZE[_constants.FULL_HD]
    },
    LOGO: _object_spread._({}, _podcastInformationTopstyle.LOGO_DIMENSIONS[_constants.FULL_HD])
}), _obj3));


/***/ }),

/***/ 70382:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BUTTONS_CONTAINER_GAP: function() {
        return BUTTONS_CONTAINER_GAP;
    },
    CONTAINER_A_GAP: function() {
        return CONTAINER_A_GAP;
    },
    CONTAINER_D_GAP: function() {
        return CONTAINER_D_GAP;
    },
    CONTAINER_E_GAP: function() {
        return CONTAINER_E_GAP;
    },
    CONTAINER_H_GAP: function() {
        return CONTAINER_H_GAP;
    },
    CONTAINER_I_GAP: function() {
        return CONTAINER_I_GAP;
    },
    IMAGE_RADIUS: function() {
        return IMAGE_RADIUS;
    },
    INFO_ICON: function() {
        return INFO_ICON;
    },
    SEPARATOR_HEIGHT: function() {
        return SEPARATOR_HEIGHT;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    getLeftContainerWidth: function() {
        return getLeftContainerWidth;
    },
    makeBasicTextStyle: function() {
        return makeBasicTextStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(65759);
var _constants = __webpack_require__(34952);
var _theme = __webpack_require__(51397);
var _typography = __webpack_require__(18411);
var _style = __webpack_require__(65082);
var _sizes = __webpack_require__(82699);
var _sidenavconstants = __webpack_require__(74842);
var _jumbotronSquareconstants = __webpack_require__(6983);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var colors = {
    text: (0, _theme.makeThemeColor)(_theme.PRIMARY),
    separator: (0, _theme.makeThemeColor)(_theme.PRIMARY, 0.3)
};
var _obj;
var IMAGE_RADIUS = (_obj = {}, _define_property._(_obj, _constants.HD, 4), _define_property._(_obj, _constants.FULL_HD, 8), _obj);
var _obj1;
var SEPARATOR_HEIGHT = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 2), _define_property._(_obj1, _constants.FULL_HD, 4), _obj1);
var _obj2;
var CONTAINER_A_GAP = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 48), _define_property._(_obj2, _constants.FULL_HD, 48), _obj2);
var _obj3;
var CONTAINER_D_GAP = (_obj3 = {}, _define_property._(_obj3, _constants.HD, 32), _define_property._(_obj3, _constants.FULL_HD, 32), _obj3);
var _obj4;
var CONTAINER_E_GAP = (_obj4 = {}, _define_property._(_obj4, _constants.HD, 8), _define_property._(_obj4, _constants.FULL_HD, 8), _obj4);
var _obj5;
var CONTAINER_H_GAP = (_obj5 = {}, _define_property._(_obj5, _constants.HD, 24), _define_property._(_obj5, _constants.FULL_HD, 24), _obj5);
var _obj6;
var CONTAINER_I_GAP = (_obj6 = {}, _define_property._(_obj6, _constants.HD, 8), _define_property._(_obj6, _constants.FULL_HD, 8), _obj6);
var _obj7;
var BUTTONS_CONTAINER_GAP = (_obj7 = {}, _define_property._(_obj7, _constants.HD, 16), _define_property._(_obj7, _constants.FULL_HD, 24), _obj7);
var INFO_ICON = {
    name: "InfoLight",
    type: "icon"
};
var getLeftContainerWidth = function(screenSize, offset) {
    return _sizes.SCREEN_WIDTH[screenSize] - (offset || _constants.safetyMargins.horizontal[screenSize]) - _jumbotronSquareconstants.imageOptions[_jumbotronSquareconstants.templates.JumbotronSquare][screenSize].PRIMARY.width - CONTAINER_A_GAP[screenSize] - _constants.safetyMargins.horizontal[screenSize];
};
var makeBasicTextStyle = function(param) {
    var font = param.font, _param_colorMode = param.colorMode, colorMode = _param_colorMode === void 0 ? _theme.DEFAULT_MODE : _param_colorMode, _param_maxLines = param.maxLines, maxLines = _param_maxLines === void 0 ? 2 : _param_maxLines;
    return {
        color: colors.text[colorMode],
        text: _object_spread_props._(_object_spread._({}, font), {
            verticalAlign: "middle",
            wordWrap: true,
            maxLines: maxLines,
            maxLinesSuffix: "..."
        })
    };
};
var getInitialStyle = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext, _ref_screenSize = _ref.screenSize, screenSize = _ref_screenSize === void 0 ? _constants.FULL_HD : _ref_screenSize, _ref_colorMode = _ref.colorMode, colorMode = _ref_colorMode === void 0 ? _theme.DEFAULT_MODE : _ref_colorMode;
    var imageSize = _jumbotronSquareconstants.imageOptions[_jumbotronSquareconstants.templates.JumbotronSquare][screenSize].PRIMARY.width;
    return {
        FlexContainer: {
            // NOTE: same as in the AbstractLayout
            x: _sidenavconstants.WIDTH[screenSize] + 40,
            flex: {
                direction: "row",
                paddingTop: _jumbotronSquareconstants.VERTICAL_PADDING[screenSize]
            },
            Image: {
                w: imageSize,
                h: imageSize,
                shader: {
                    radius: IMAGE_RADIUS[screenSize]
                },
                flexItem: {
                    marginRight: CONTAINER_A_GAP[screenSize]
                }
            },
            ContainerD: {
                flex: {
                    direction: "column"
                },
                ContainerE: {
                    flex: {
                        direction: "column"
                    },
                    flexItem: {
                        marginBottom: CONTAINER_D_GAP[screenSize]
                    },
                    Incentive: {
                        flexItem: {
                            marginBottom: CONTAINER_E_GAP[screenSize]
                        }
                    },
                    Title: _object_spread._({
                        flexItem: {
                            marginBottom: CONTAINER_E_GAP[screenSize]
                        }
                    }, makeBasicTextStyle({
                        font: (0, _typography.getFont)(_typography.FONT.PARIS_3, screenSize),
                        colorMode: colorMode
                    })),
                    Author: _object_spread._({
                        flexItem: {
                            marginBottom: CONTAINER_E_GAP[screenSize]
                        },
                        alpha: 0.6
                    }, makeBasicTextStyle({
                        font: (0, _typography.getFont)(_typography.FONT.OTTAWA_1, screenSize),
                        colorMode: colorMode
                    }))
                },
                ContainerH: {
                    flex: {
                        direction: "column"
                    },
                    flexItem: {
                        marginBottom: CONTAINER_D_GAP[screenSize]
                    },
                    ProgressBar: {
                        flexItem: {
                            marginBottom: CONTAINER_H_GAP[screenSize]
                        }
                    },
                    ButtonsContainer: {
                        flex: {
                            direction: "row"
                        },
                        PlayButton: {
                            flexItem: {
                                marginRight: BUTTONS_CONTAINER_GAP[screenSize]
                            }
                        },
                        MyListButton: {
                            flexItem: {
                                marginRight: BUTTONS_CONTAINER_GAP[screenSize]
                            }
                        },
                        InfoButton: {
                            picto: INFO_ICON
                        }
                    }
                },
                Separator: {
                    flexItem: {
                        marginBottom: CONTAINER_D_GAP[screenSize]
                    },
                    rect: true,
                    color: colors.separator[colorMode],
                    h: SEPARATOR_HEIGHT[screenSize]
                },
                ContainerI: {
                    flex: {
                        direction: "column"
                    },
                    ExtraDetails: _object_spread._({
                        flexItem: {
                            marginBottom: CONTAINER_I_GAP[screenSize]
                        },
                        alpha: 0.6
                    }, makeBasicTextStyle({
                        font: (0, _typography.getFont)(_typography.FONT.MADRID_3, screenSize),
                        colorMode: colorMode
                    })),
                    Description: _object_spread._({}, makeBasicTextStyle({
                        font: (0, _typography.getFont)(_typography.FONT.OTTAWA_1, screenSize),
                        colorMode: colorMode,
                        maxLines: 3
                    }))
                }
            }
        }
    };
};


/***/ }),

/***/ 78176:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BUTTON_TYPES: function() {
        return BUTTON_TYPES;
    },
    CTA_BUTTON_MARGIN_RIGHT: function() {
        return CTA_BUTTON_MARGIN_RIGHT;
    },
    CTA_MARGIN_BOTTOM: function() {
        return CTA_MARGIN_BOTTOM;
    },
    DESCRIPTION_FONT: function() {
        return DESCRIPTION_FONT;
    },
    EXTRA_TITLE_FONT: function() {
        return EXTRA_TITLE_FONT;
    },
    EXTRA_TITLE_FONT_TYPE: function() {
        return EXTRA_TITLE_FONT_TYPE;
    },
    INFO_ICON: function() {
        return INFO_ICON;
    },
    SHOW_BOTTOM_ROW: function() {
        return SHOW_BOTTOM_ROW;
    },
    SHOW_CONTENT_ADVISORY: function() {
        return SHOW_CONTENT_ADVISORY;
    },
    SHOW_DETAILS: function() {
        return SHOW_DETAILS;
    },
    SHOW_EXTRA_HIGHLIGHT: function() {
        return SHOW_EXTRA_HIGHLIGHT;
    },
    SHOW_HIGHLIGHT: function() {
        return SHOW_HIGHLIGHT;
    },
    SHOW_SERVICE_ICON: function() {
        return SHOW_SERVICE_ICON;
    },
    TRAILER_ICON: function() {
        return TRAILER_ICON;
    }
});
var _define_property = __webpack_require__(21228);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(3009);
var _typography = __webpack_require__(18411);
var _constants = __webpack_require__(34952);
var _callToActioncomponent = __webpack_require__(91743);
var _callToActioncomponent1 = __webpack_require__(28518);
var _myListCallToActioncomponent = __webpack_require__(5805);
var _focus = __webpack_require__(78506);
var SHOW_SERVICE_ICON = false;
var SHOW_HIGHLIGHT = true;
var SHOW_EXTRA_HIGHLIGHT = true;
var SHOW_DETAILS = false;
var SHOW_CONTENT_ADVISORY = false;
var SHOW_BOTTOM_ROW = false;
var EXTRA_TITLE_FONT = _typography.FONT.PARIS_3;
var EXTRA_TITLE_FONT_TYPE = _typography.FONT_TYPE.MAIN;
var DESCRIPTION_FONT = _typography.FONT.OTTAWA_2;
var _obj;
var CTA_MARGIN_BOTTOM = (_obj = {}, _define_property._(_obj, _constants.HD, 32), _define_property._(_obj, _constants.FULL_HD, 40), _obj);
var _obj1;
var CTA_BUTTON_MARGIN_RIGHT = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 12 + _focus.BORDER_WIDTH[_constants.HD]), _define_property._(_obj1, _constants.FULL_HD, 16 + _focus.BORDER_WIDTH[_constants.FULL_HD]), _obj1);
var BUTTON_TYPES = {
    PLAY_BUTTON: _callToActioncomponent.CallToAction,
    MY_LIST_BUTTON: _myListCallToActioncomponent.MyListButtonSecondary,
    INFO_BUTTON: _callToActioncomponent1.CallToAction,
    TRAILER_BUTTON: _callToActioncomponent1.CallToAction
};
var INFO_ICON = {
    name: "InfoLight",
    type: "icon"
};
var TRAILER_ICON = {
    name: "Trailer",
    type: "icon"
};


/***/ }),

/***/ 71665:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return Jumbotron;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _create_super = __webpack_require__(6400);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(52318);
var _sdk = __webpack_require__(29956);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _constants = __webpack_require__(34952);
var _i18n = __webpack_require__(14910);
var _heroOverlaycomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(10169));
var _progresscomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(45926));
var _iconcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(70160));
var _textures = __webpack_require__(67179);
var _signals = __webpack_require__(2109);
var _jumbotronconstants = __webpack_require__(21049);
var _jumbotronstyle = __webpack_require__(16019);
var _jumbotronutils = __webpack_require__(68141);
var _templates = __webpack_require__(88229);
var _progressutils = __webpack_require__(40779);
var _soloutils = __webpack_require__(50088);
var _podcastInformationcomponent = __webpack_require__(49360);
var _programInformationconstants = __webpack_require__(21248);
var _incentivecomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(9077));
var _incentiveutils = __webpack_require__(72823);
var _analyticsutils = __webpack_require__(2693);
var _podcastInformationstyle = __webpack_require__(99024);
var _trailercomponent = __webpack_require__(44029);
var _trailerconstants = __webpack_require__(25981);
var Jumbotron = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(Jumbotron, _Lightning_Component);
    var _super = _create_super._(Jumbotron);
    function Jumbotron() {
        _class_call_check._(this, Jumbotron);
        return _super.apply(this, arguments);
    }
    _create_class._(Jumbotron, [
        {
            key: "_construct",
            value: function _construct() {
                this._buttons = [];
                this._index = 0;
                this._style = _jumbotronstyle.defaultContext;
                this._showingTrailer = false;
            }
        },
        {
            key: "_attach",
            value: function _attach() {
                this._trailerStarted = false;
                this._trailerComplete = false;
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                this.tag("Background").removeAllListeners("txLoaded");
                if (this._hideBackgroundTimeout) {
                    clearTimeout(this._hideBackgroundTimeout);
                }
                this._showingTrailer = false;
                this._focused = null;
            }
        },
        {
            key: "item",
            get: function get() {
                return this._item;
            },
            set: function set(param) {
                var content = param.content, blockIndex = param.blockIndex, itemIndex = param.itemIndex, config = param.config, _param_colorScheme = param.colorScheme, colorScheme = _param_colorScheme === void 0 ? _jumbotronstyle.defaultContext.colorMode : _param_colorScheme;
                var _this = this;
                var currentImage = (0, _get.default)(this._item, "image.src");
                this._item = content;
                var screenSize = this._style.screenSize;
                var textColor = _jumbotronstyle.colors.text[colorScheme];
                var _this__item = this._item, image = _this__item.image, logo = _this__item.logo, description = _this__item.description, details = _this__item.details, highlight = _this__item.highlight, extraTitle = _this__item.extraTitle, extraHighlight = _this__item.extraHighlight, extraDetails = _this__item.extraDetails, progress = _this__item.progress, action = _this__item.action, servicePicto = _this__item.servicePicto, csaPicto = _this__item.csaPicto, bookmark = _this__item.bookmark, secondaryActions = _this__item.secondaryActions, incentives = _this__item.incentives;
                var contentAdvisoryPictos = (0, _get.default)(this._item, "contentAdvisory.pictos", []);
                var isContentAdvisoryVisible = _jumbotronconstants.SHOW_CONTENT_ADVISORY && contentAdvisoryPictos.some(function(value) {
                    return Boolean(value);
                });
                var isContentRatingIconVisible = !_jumbotronconstants.SHOW_CONTENT_ADVISORY && !_jumbotronconstants.SHOW_BOTTOM_ROW;
                var isExtraHighlightRowVisible = _jumbotronconstants.SHOW_EXTRA_HIGHLIGHT && extraHighlight || isContentAdvisoryVisible || isContentRatingIconVisible;
                var logoSrc = logo && logo.src || "";
                var isLogoVisible = Boolean(logoSrc);
                var serviceIconVisible = (0, _soloutils.isVisibleIcon)(servicePicto);
                var incentiveLines = (0, _incentiveutils.getLinesCount)(incentives);
                var highlightText = [
                    highlight,
                    extraDetails
                ].filter(Boolean).join(_jumbotronconstants.HIGHLIGHT_SEPARATOR);
                var textWidth = _jumbotronstyle.FLEX_CONTAINER_WIDTH[screenSize];
                this._trailer = secondaryActions[1];
                var trailerPicto = (0, _get.default)(this._trailer, "picto", _jumbotronstyle.TRAILER_ICON);
                var trailerLabel = (0, _get.default)(this._trailer, "label", (0, _i18n.t)("trailer.actionLabel"));
                var trailerId = (0, _get.default)(this._trailer, "target.value_layout.id");
                var patch = {
                    Trailer: {
                        asset: trailerId
                    },
                    FlexContainer: {
                        Logo: {
                            visible: isLogoVisible,
                            texture: _object_spread_props._(_object_spread._({}, (0, _textures.contain)(logoSrc, _jumbotronstyle.LOGO_DIMENSIONS[screenSize].width, _jumbotronstyle.LOGO_DIMENSIONS[screenSize].height)), {
                                hasAlpha: true
                            })
                        },
                        Incentive: {
                            visible: incentiveLines > 0,
                            data: {
                                linesCount: incentiveLines,
                                w: _jumbotronstyle.FLEX_CONTAINER_WIDTH[screenSize],
                                incentives: incentives,
                                colorMode: this._style.colorMode
                            }
                        },
                        ServiceIcon: {
                            visible: _jumbotronconstants.SHOW_SERVICE_ICON && serviceIconVisible,
                            iconData: {
                                picto: servicePicto,
                                viewBox: (0, _jumbotronstyle.getServiceIconViewBox)(screenSize)
                            }
                        },
                        MetadataRow: {
                            Highlight: (0, _templates.makeTextPatch)(_jumbotronconstants.SHOW_HIGHLIGHT ? highlightText : "", textWidth, textColor),
                            ExtraTitle: (0, _templates.makeTextPatch)(extraTitle, textWidth, textColor),
                            ExtraHighlightRow: {
                                visible: isExtraHighlightRowVisible,
                                ExtraHighlight: (0, _templates.makeTextPatch)(_jumbotronconstants.SHOW_EXTRA_HIGHLIGHT ? extraHighlight : "", textWidth, textColor),
                                ContentAdvisory: {
                                    IconsRow: {
                                        visible: isContentAdvisoryVisible
                                    },
                                    ContentRatingIcon: {
                                        visible: isContentRatingIconVisible,
                                        iconData: {
                                            picto: csaPicto,
                                            viewBox: (0, _jumbotronstyle.getBasicIconViewBox)(screenSize)
                                        }
                                    }
                                }
                            },
                            Description: (0, _templates.makeTextPatch)(description, textWidth, textColor),
                            Details: (0, _templates.makeTextPatch)(_jumbotronconstants.SHOW_DETAILS ? details : "", textWidth, textColor)
                        },
                        ProgressBar: (0, _progressutils.makeProgressBarProperties)(progress),
                        ButtonsRow: {
                            PlayButton: {
                                visible: (0, _soloutils.isVisibleCTA)(action),
                                label: (0, _get.default)(action, "label", ""),
                                picto: (0, _get.default)(action, "picto", "")
                            },
                            MyListButton: {
                                visible: Boolean(bookmark),
                                label: (0, _i18n.t)("bookmarks.actionLabel"),
                                item: bookmark,
                                blockIndex: blockIndex,
                                itemIndex: itemIndex
                            },
                            InfoButton: {
                                visible: (0, _jumbotronutils.isVisibleInformationButton)(this._item),
                                label: (0, _i18n.t)("contentInfo.actionLabel")
                            },
                            TrailerButton: {
                                visible: this.tag("Trailer").enabled ? Boolean(this._trailer && this._trailerComplete) : Boolean(this._trailer),
                                picto: trailerPicto,
                                label: trailerLabel
                            }
                        },
                        BottomRow: {
                            visible: _jumbotronconstants.SHOW_BOTTOM_ROW,
                            ExtraDetails: (0, _templates.makeTextPatch)(extraDetails, _jumbotronstyle.FLEX_CONTAINER_WIDTH[screenSize], textColor),
                            ContentRatingIcon: {
                                iconData: {
                                    picto: csaPicto,
                                    viewBox: (0, _jumbotronstyle.getBasicIconViewBox)(screenSize)
                                }
                            }
                        }
                    },
                    ProgramInformation: {
                        data: this._item
                    }
                };
                if (currentImage !== image.src) {
                    this.tag("Background").once("txLoaded", function() {
                        _this.tag("Background").setSmooth("alpha", 1);
                    });
                    patch.Background = {
                        texture: (0, _textures.cover)(image.src, config.w, config.h),
                        alpha: this.stage.textureManager.textureSourceHashmap.has(image.src) ? 1 : 0.0001
                    };
                }
                this.patch(patch);
                if (isContentAdvisoryVisible) {
                    this.tag("IconsRow").children = contentAdvisoryPictos.map(function(picto) {
                        return _object_spread._({
                            type: _iconcomponent.default
                        }, (0, _jumbotronstyle.getContentAdvisoryIconStyle)(picto, _this._style.screenSize));
                    });
                }
                var items = this.tag("ButtonsRow").children;
                this._buttons = items.filter(function(item) {
                    return item.visible;
                });
                this._setIndex();
            }
        },
        {
            key: "contentPadding",
            set: function set(value) {
                var screenSize = this._style.screenSize;
                var x = Number.isFinite(value) ? value : 0;
                var backgroundOffset = _jumbotronstyle.BACKGROUND_CONTENT_OFFSET[screenSize];
                var backgroundSize = _jumbotronconstants.imageOptions[_jumbotronconstants.templates.Jumbotron][screenSize].PRIMARY;
                var w = backgroundSize.width - x + backgroundOffset;
                var h = Math.round(backgroundSize.height * (w / backgroundSize.width));
                this.patch({
                    Background: {
                        w: w,
                        h: h
                    },
                    Gradient: {
                        w: w,
                        h: h
                    },
                    Trailer: {
                        w: w,
                        h: h
                    },
                    FlexContainer: {
                        x: x,
                        ProgressBar: {
                            w: w - _constants.safetyMargins.horizontal[screenSize] * 2
                        }
                    }
                });
            }
        },
        {
            key: "_getFocused",
            value: function _getFocused() {
                return this._focused;
            }
        },
        {
            key: "_focus",
            value: function _focus() {
                this._isFocused = true;
                this._playTrailer();
            }
        },
        {
            key: "_unfocus",
            value: function _unfocus() {
                this._isFocused = false;
                this.tag("Trailer").pause();
                this._hideTrailer();
            }
        },
        {
            key: "_playTrailer",
            value: function _playTrailer() {
                var _this = this;
                // NOTE: auto-play is disabled after a trailer is complete and should be re-enabled via a corresponding button
                if (this._trailerComplete) {
                    return;
                }
                this._hideBackgroundTimeout = setTimeout(function() {
                    _this.tag("Trailer").play();
                }, 150);
            }
        },
        {
            key: "_showTrailer",
            value: function _showTrailer() {
                if (!this._isFocused) {
                    return;
                }
                this._showingTrailer = true;
                this.tag("Background").setSmooth("alpha", 0.0001);
                this.signal(_signals.HIDE_BACKGROUND_SIGNAL);
            }
        },
        {
            key: "_hideTrailer",
            value: function _hideTrailer() {
                this._showingTrailer = false;
                this.tag("Background").setSmooth("alpha", 1);
                this.signal(_signals.SHOW_BACKGROUND_SIGNAL);
            }
        },
        {
            key: "_handleRight",
            value: function _handleRight() {
                if (this._index < this._buttons.length - 1) {
                    this._setIndex(this._index + 1);
                    return true;
                }
                return false;
            }
        },
        {
            key: "_handleLeft",
            value: function _handleLeft() {
                if (this._index > 0) {
                    this._setIndex(this._index - 1);
                    return true;
                }
                return false;
            }
        },
        {
            key: "_setIndex",
            value: function _setIndex() {
                var index = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._index;
                this._index = index;
                this._focused = this._buttons[this._index];
            }
        },
        {
            key: "_handleEnter",
            value: function _handleEnter() {
                if (this._focused === this.tag("InfoButton")) {
                    this._showProgramInformation();
                    (0, _analyticsutils.sendEvent)({
                        key: "pressMoreInfo"
                    });
                } else if (this._focused === this.tag("TrailerButton")) {
                    this.signal(_signals.SELECTED_SIGNAL, {
                        id: "trailer",
                        action: this._trailer
                    });
                } else {
                    this.signal(_signals.SELECTED_SIGNAL, this._item);
                }
            }
        },
        {
            key: "_showProgramInformation",
            value: function _showProgramInformation() {
                this.zIndex = _jumbotronconstants.Z_INDEX_WITH_PROGRAM_INFO;
                this.tag("ProgramInformation").patch((0, _podcastInformationstyle.getProgramInformationFocusedStyle)());
                this._focused = this.tag("ProgramInformation");
            }
        },
        {
            key: "_handleProgramInformationClose",
            value: function _handleProgramInformationClose() {
                this.zIndex = _jumbotronconstants.Z_INDEX_NORMAL;
                this.tag("ProgramInformation").patch((0, _podcastInformationstyle.getProgramInformationUnFocusedStyle)());
                this._setIndex();
                (0, _analyticsutils.sendEvent)({
                    key: "closeMoreInfo"
                });
            }
        },
        {
            key: "_handleVideoCanPlay",
            value: function _handleVideoCanPlay() {
                if (this._isFocused) {
                    this._playTrailer();
                }
            }
        },
        {
            key: "_handleVideoPlaying",
            value: function _handleVideoPlaying() {
                this._trailerStarted = true;
                this._trailerComplete = false;
                this._showTrailer();
            }
        },
        {
            key: "_handleVideoEnded",
            value: function _handleVideoEnded() {
                this._trailerComplete = true;
                this._trailerStarted = false;
                this._hideTrailer();
                this.tag("TrailerButton").visible = true;
                this._buttons = this.tag("ButtonsRow").children.filter(function(item) {
                    return item.visible;
                });
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                var _obj;
                return (0, _merge.default)({
                    Background: {},
                    Gradient: {
                        type: _heroOverlaycomponent.default
                    },
                    Trailer: {
                        type: _trailercomponent.TrailerPlayer,
                        signals: (_obj = {}, _define_property._(_obj, _trailerconstants.VIDEO_CAN_PLAY_SIGNAL, "_handleVideoCanPlay"), _define_property._(_obj, _trailerconstants.VIDEO_PLAYING_SIGNAL, "_handleVideoPlaying"), _define_property._(_obj, _trailerconstants.VIDEO_ENDED_SIGNAL, "_handleVideoEnded"), _obj)
                    },
                    FlexContainer: {
                        Logo: {},
                        Incentive: {
                            type: _incentivecomponent.default
                        },
                        ServiceIcon: {
                            type: _iconcomponent.default
                        },
                        MetadataRow: {
                            Highlight: {},
                            ExtraTitle: {},
                            ExtraHighlightRow: {
                                ExtraHighlight: {},
                                ContentAdvisory: {
                                    IconsRow: {},
                                    ContentRatingIcon: {
                                        type: _iconcomponent.default
                                    }
                                }
                            },
                            Description: {},
                            Details: {}
                        },
                        ProgressBar: {
                            type: _progresscomponent.default
                        },
                        ButtonsRow: {
                            PlayButton: {
                                type: _jumbotronconstants.BUTTON_TYPES.PLAY_BUTTON
                            },
                            MyListButton: {
                                type: _jumbotronconstants.BUTTON_TYPES.MY_LIST_BUTTON,
                                passSignals: _define_property._({}, _signals.SELECTED_SIGNAL, true)
                            },
                            InfoButton: {
                                type: _jumbotronconstants.BUTTON_TYPES.INFO_BUTTON
                            },
                            TrailerButton: {
                                type: _jumbotronconstants.BUTTON_TYPES.TRAILER_BUTTON
                            }
                        },
                        BottomRow: {
                            ExtraDetails: {},
                            ContentRatingIcon: {
                                type: _iconcomponent.default
                            }
                        }
                    },
                    ProgramInformation: {
                        type: _podcastInformationcomponent.PodcastInformation,
                        signals: _define_property._({}, _programInformationconstants.PROGRAM_INFORMATION_CLOSED_SIGNAL, "_handleProgramInformationClose")
                    }
                }, (0, _jumbotronstyle.getInitialStyle)());
            }
        },
        {
            key: "getBottomMargin",
            value: function getBottomMargin(param) {
                var screenSize = param.screenSize;
                return _jumbotronstyle.LAYOUT_BOTTOM_MARGIN[screenSize];
            }
        }
    ]);
    return Jumbotron;
}(_sdk.Lightning.Component);
Jumbotron.Templates = _jumbotronconstants.templates;
Jumbotron.Sizes = _jumbotronconstants.sizes;
Jumbotron.ImageOptions = _jumbotronconstants.imageOptions;


/***/ }),

/***/ 21049:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    HIGHLIGHT_SEPARATOR: function() {
        return HIGHLIGHT_SEPARATOR;
    },
    LOGO_DIMENSIONS: function() {
        return LOGO_DIMENSIONS;
    },
    Z_INDEX_NORMAL: function() {
        return Z_INDEX_NORMAL;
    },
    Z_INDEX_WITH_PROGRAM_INFO: function() {
        return Z_INDEX_WITH_PROGRAM_INFO;
    },
    imageOptions: function() {
        return imageOptions;
    },
    sizes: function() {
        return sizes;
    },
    templates: function() {
        return templates;
    }
});
var _define_property = __webpack_require__(21228);
var _export_star = __webpack_require__(37668);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(52318);
var _constants = __webpack_require__(34952);
var _sizes = __webpack_require__(82699);
_export_star._(__webpack_require__(78176), exports);
var Z_INDEX_NORMAL = 0;
var Z_INDEX_WITH_PROGRAM_INFO = 1000;
var templates = {
    Jumbotron: "Jumbotron"
};
var HIGHLIGHT_SEPARATOR = " | ";
var _obj;
var sizes = _define_property._({}, templates.Jumbotron, (_obj = {}, _define_property._(_obj, _constants.HD, {
    w: _sizes.SCREEN_WIDTH[_constants.HD],
    h: _sizes.SCREEN_HEIGHT[_constants.HD]
}), _define_property._(_obj, _constants.FULL_HD, {
    w: _sizes.SCREEN_WIDTH[_constants.FULL_HD],
    h: _sizes.SCREEN_HEIGHT[_constants.FULL_HD]
}), _obj));
var _obj1;
var LOGO_DIMENSIONS = (_obj1 = {}, _define_property._(_obj1, _constants.HD, {
    width: 299,
    height: 168
}), _define_property._(_obj1, _constants.FULL_HD, {
    width: 597,
    height: 336
}), _obj1);
var _obj2;
var imageOptions = _define_property._({}, templates.Jumbotron, (_obj2 = {}, _define_property._(_obj2, _constants.HD, {
    PRIMARY: {
        width: sizes[templates.Jumbotron][_constants.HD].w,
        height: sizes[templates.Jumbotron][_constants.HD].h
    },
    SECONDARY: {
        width: _sizes.SCREEN_WIDTH[_constants.HD],
        height: _sizes.SCREEN_HEIGHT[_constants.HD]
    },
    LOGO: _object_spread_props._(_object_spread._({}, LOGO_DIMENSIONS[_constants.HD]), {
        fit: _constants.IMAGE_FIT_MAX
    })
}), _define_property._(_obj2, _constants.FULL_HD, {
    PRIMARY: {
        width: sizes[templates.Jumbotron][_constants.FULL_HD].w,
        height: sizes[templates.Jumbotron][_constants.FULL_HD].h
    },
    SECONDARY: {
        width: _sizes.SCREEN_WIDTH[_constants.FULL_HD],
        height: _sizes.SCREEN_HEIGHT[_constants.FULL_HD]
    },
    LOGO: _object_spread_props._(_object_spread._({}, LOGO_DIMENSIONS[_constants.FULL_HD]), {
        fit: _constants.IMAGE_FIT_MAX
    })
}), _obj2));


/***/ }),

/***/ 16019:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BACKGROUND_CONTENT_OFFSET: function() {
        return BACKGROUND_CONTENT_OFFSET;
    },
    BASIC_PICTO_DIMENSION: function() {
        return BASIC_PICTO_DIMENSION;
    },
    BOTTOM_ROW_GAP: function() {
        return BOTTOM_ROW_GAP;
    },
    CONTENT_ADVISORY_ICON_DIMENSION: function() {
        return CONTENT_ADVISORY_ICON_DIMENSION;
    },
    CONTENT_ADVISORY_ICON_MARGIN: function() {
        return CONTENT_ADVISORY_ICON_MARGIN;
    },
    DESCRIPTION_MARGIN_BOTTOM: function() {
        return DESCRIPTION_MARGIN_BOTTOM;
    },
    DETAILS_MARGIN_BOTTOM: function() {
        return DETAILS_MARGIN_BOTTOM;
    },
    EXTRA_HIGHLIGHT_MARGIN_BOTTOM: function() {
        return EXTRA_HIGHLIGHT_MARGIN_BOTTOM;
    },
    EXTRA_HIGHLIGHT_MARGIN_RIGHT: function() {
        return EXTRA_HIGHLIGHT_MARGIN_RIGHT;
    },
    EXTRA_TITLE_MARGIN_BOTTOM: function() {
        return EXTRA_TITLE_MARGIN_BOTTOM;
    },
    FLEX_CONTAINER_MARGIN_BOTTOM: function() {
        return FLEX_CONTAINER_MARGIN_BOTTOM;
    },
    FLEX_CONTAINER_WIDTH: function() {
        return FLEX_CONTAINER_WIDTH;
    },
    HIGHLIGHT_MARGIN_BOTTOM: function() {
        return HIGHLIGHT_MARGIN_BOTTOM;
    },
    INCENTIVE_MARGIN_BOTTOM: function() {
        return INCENTIVE_MARGIN_BOTTOM;
    },
    INFO_ICON: function() {
        return _jumbotronconstants.INFO_ICON;
    },
    LAYOUT_BOTTOM_MARGIN: function() {
        return LAYOUT_BOTTOM_MARGIN;
    },
    LOGO_DIMENSIONS: function() {
        return _jumbotronconstants.LOGO_DIMENSIONS;
    },
    LOGO_MARGIN_BOTTOM: function() {
        return LOGO_MARGIN_BOTTOM;
    },
    PROGRESS_MARGIN_BOTTOM: function() {
        return PROGRESS_MARGIN_BOTTOM;
    },
    SERVICE_PICTO_DIMENSIONS: function() {
        return SERVICE_PICTO_DIMENSIONS;
    },
    SERVICE_PICTO_MARGIN_BOTTOM: function() {
        return SERVICE_PICTO_MARGIN_BOTTOM;
    },
    TRAILER_ICON: function() {
        return _jumbotronconstants.TRAILER_ICON;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getBasicIconViewBox: function() {
        return getBasicIconViewBox;
    },
    getContentAdvisoryIconStyle: function() {
        return getContentAdvisoryIconStyle;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    getServiceIconViewBox: function() {
        return getServiceIconViewBox;
    },
    makeBasicTextStyle: function() {
        return makeBasicTextStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(52318);
var _memoize = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34736));
var _typography = __webpack_require__(18411);
var _theme = __webpack_require__(51397);
var _constants = __webpack_require__(34952);
var _sizes = __webpack_require__(82699);
var _style = __webpack_require__(65082);
var _jumbotronconstants = __webpack_require__(21049);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var FLEX_CONTAINER_WIDTH = (_obj = {}, _define_property._(_obj, _constants.HD, Math.round(_sizes.SCREEN_WIDTH[_constants.HD] * 0.5)), _define_property._(_obj, _constants.FULL_HD, Math.round(_sizes.SCREEN_WIDTH[_constants.FULL_HD] * 0.45)), _obj);
var _obj1;
var LAYOUT_BOTTOM_MARGIN = (_obj1 = {}, _define_property._(_obj1, _constants.HD, -64), _define_property._(_obj1, _constants.FULL_HD, -112), _obj1);
var _obj2;
var BACKGROUND_CONTENT_OFFSET = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 40), _define_property._(_obj2, _constants.FULL_HD, 40), _obj2);
var _obj3;
var FLEX_CONTAINER_MARGIN_BOTTOM = (_obj3 = {}, _define_property._(_obj3, _constants.HD, 104), _define_property._(_obj3, _constants.FULL_HD, 168), _obj3);
var _obj4;
var LOGO_MARGIN_BOTTOM = (_obj4 = {}, _define_property._(_obj4, _constants.HD, 8), _define_property._(_obj4, _constants.FULL_HD, 16), _obj4);
var _obj5;
var INCENTIVE_MARGIN_BOTTOM = (_obj5 = {}, _define_property._(_obj5, _constants.HD, 8), _define_property._(_obj5, _constants.FULL_HD, 16), _obj5);
var _obj6;
var SERVICE_PICTO_DIMENSIONS = (_obj6 = {}, _define_property._(_obj6, _constants.HD, {
    width: 40,
    height: 40
}), _define_property._(_obj6, _constants.FULL_HD, {
    width: 56,
    height: 56
}), _obj6);
var _obj7;
var SERVICE_PICTO_MARGIN_BOTTOM = (_obj7 = {}, _define_property._(_obj7, _constants.HD, 24), _define_property._(_obj7, _constants.FULL_HD, 24), _obj7);
var _obj8;
var HIGHLIGHT_MARGIN_BOTTOM = (_obj8 = {}, _define_property._(_obj8, _constants.HD, 8), _define_property._(_obj8, _constants.FULL_HD, 16), _obj8);
var _obj9;
var EXTRA_TITLE_MARGIN_BOTTOM = (_obj9 = {}, _define_property._(_obj9, _constants.HD, 16), _define_property._(_obj9, _constants.FULL_HD, 24), _obj9);
var _obj10;
var EXTRA_HIGHLIGHT_MARGIN_BOTTOM = (_obj10 = {}, _define_property._(_obj10, _constants.HD, 8), _define_property._(_obj10, _constants.FULL_HD, 16), _obj10);
var _obj11;
var EXTRA_HIGHLIGHT_MARGIN_RIGHT = (_obj11 = {}, _define_property._(_obj11, _constants.HD, 8), _define_property._(_obj11, _constants.FULL_HD, 16), _obj11);
var _obj12;
var DESCRIPTION_MARGIN_BOTTOM = (_obj12 = {}, _define_property._(_obj12, _constants.HD, 32), _define_property._(_obj12, _constants.FULL_HD, 40), _obj12);
var _obj13;
var PROGRESS_MARGIN_BOTTOM = (_obj13 = {}, _define_property._(_obj13, _constants.HD, 32), _define_property._(_obj13, _constants.FULL_HD, 32), _obj13);
var _obj14;
var DETAILS_MARGIN_BOTTOM = (_obj14 = {}, _define_property._(_obj14, _constants.HD, 32), _define_property._(_obj14, _constants.FULL_HD, 32), _obj14);
var _obj15;
var CONTENT_ADVISORY_ICON_DIMENSION = (_obj15 = {}, _define_property._(_obj15, _constants.HD, {
    h: 24
}), _define_property._(_obj15, _constants.FULL_HD, {
    h: 32
}), _obj15);
var _obj16;
var CONTENT_ADVISORY_ICON_MARGIN = (_obj16 = {}, _define_property._(_obj16, _constants.HD, -1), _define_property._(_obj16, _constants.FULL_HD, -1), _obj16);
var _obj17;
var BASIC_PICTO_DIMENSION = (_obj17 = {}, _define_property._(_obj17, _constants.HD, 32), _define_property._(_obj17, _constants.FULL_HD, 40), _obj17);
var _obj18;
var BOTTOM_ROW_GAP = (_obj18 = {}, _define_property._(_obj18, _constants.HD, 8), _define_property._(_obj18, _constants.FULL_HD, 8), _obj18);
var getServiceIconViewBox = (0, _memoize.default)(function(screenSize) {
    return {
        h: SERVICE_PICTO_DIMENSIONS[screenSize].height
    };
});
var getBasicIconViewBox = (0, _memoize.default)(function(screenSize) {
    return {
        h: BASIC_PICTO_DIMENSION[screenSize]
    };
});
var colors = {
    text: (0, _theme.makeThemeColor)(_theme.PRIMARY)
};
var makeBasicTextStyle = function(param) {
    var font = param.font, _param_colorMode = param.colorMode, colorMode = _param_colorMode === void 0 ? _theme.DEFAULT_MODE : _param_colorMode;
    return {
        color: colors.text[colorMode],
        text: _object_spread_props._(_object_spread._({}, font), {
            verticalAlign: "middle",
            wordWrap: true,
            maxLines: 2,
            maxLinesSuffix: "..."
        })
    };
};
var getContentAdvisoryIconStyle = (0, _memoize.default)(function(picto, screenSize) {
    return {
        visible: Boolean(picto),
        flexItem: {
            marginRight: CONTENT_ADVISORY_ICON_MARGIN[screenSize]
        },
        iconData: {
            picto: picto,
            viewBox: CONTENT_ADVISORY_ICON_DIMENSION[screenSize]
        }
    };
}, _style.cacheResolver);
var getInitialStyle = (0, _memoize.default)(function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext, _ref_screenSize = _ref.screenSize, screenSize = _ref_screenSize === void 0 ? _constants.FULL_HD : _ref_screenSize, _ref_colorMode = _ref.colorMode, colorMode = _ref_colorMode === void 0 ? _theme.DEFAULT_MODE : _ref_colorMode;
    var backgroundSize = _jumbotronconstants.imageOptions[_jumbotronconstants.templates.Jumbotron][screenSize].PRIMARY;
    var background = {
        w: backgroundSize.width,
        h: backgroundSize.height,
        x: _jumbotronconstants.sizes[_jumbotronconstants.templates.Jumbotron][screenSize].w,
        mountX: 1
    };
    var _sizes_templates_Jumbotron_screenSize = _jumbotronconstants.sizes[_jumbotronconstants.templates.Jumbotron][screenSize], w = _sizes_templates_Jumbotron_screenSize.w, h = _sizes_templates_Jumbotron_screenSize.h;
    return {
        Background: _object_spread._({}, background),
        Gradient: _object_spread._({}, background),
        Trailer: _object_spread._({}, background),
        FlexContainer: {
            w: w,
            h: h - FLEX_CONTAINER_MARGIN_BOTTOM[screenSize],
            flex: {
                direction: "column",
                justifyContent: "flex-end"
            },
            Logo: {
                flexItem: {
                    marginBottom: LOGO_MARGIN_BOTTOM[screenSize]
                }
            },
            Incentive: {
                flexItem: {
                    marginBottom: INCENTIVE_MARGIN_BOTTOM[screenSize]
                }
            },
            ServiceIcon: {
                flexItem: {
                    marginBottom: SERVICE_PICTO_MARGIN_BOTTOM[screenSize]
                }
            },
            MetadataRow: {
                flex: {
                    direction: "column"
                },
                Highlight: {
                    text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT.BERLIN_1, screenSize)), {
                        maxLines: 1,
                        verticalAlign: "middle"
                    }),
                    alpha: 0.8,
                    flexItem: {
                        marginBottom: HIGHLIGHT_MARGIN_BOTTOM[screenSize]
                    }
                },
                ExtraTitle: {
                    flexItem: {
                        marginBottom: EXTRA_TITLE_MARGIN_BOTTOM[screenSize]
                    },
                    text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_jumbotronconstants.EXTRA_TITLE_FONT, screenSize, _jumbotronconstants.EXTRA_TITLE_FONT_TYPE)), {
                        maxLines: 2,
                        verticalAlign: "middle"
                    })
                },
                ExtraHighlightRow: {
                    flex: {
                        direction: "row",
                        alignItems: "center"
                    },
                    flexItem: {
                        marginBottom: EXTRA_HIGHLIGHT_MARGIN_BOTTOM[screenSize]
                    },
                    ExtraHighlight: {
                        flexItem: {
                            marginRight: EXTRA_HIGHLIGHT_MARGIN_RIGHT[screenSize]
                        },
                        h: (0, _typography.getFont)(_typography.FONT.BERLIN_1, screenSize).lineHeight,
                        text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT.BERLIN_1, screenSize)), {
                            maxLines: 1,
                            verticalAlign: "middle"
                        }),
                        alpha: 0.8
                    },
                    ContentAdvisory: {
                        flex: {
                            direction: "row"
                        },
                        IconsRow: {
                            h: CONTENT_ADVISORY_ICON_DIMENSION[screenSize].h,
                            flex: {
                                direction: "row"
                            }
                        },
                        ContentRatingIcon: {}
                    }
                },
                Description: _object_spread_props._(_object_spread._({}, makeBasicTextStyle({
                    font: (0, _typography.getFont)(_jumbotronconstants.DESCRIPTION_FONT, screenSize),
                    colorMode: colorMode
                })), {
                    alpha: 0.8,
                    flexItem: {
                        marginBottom: DESCRIPTION_MARGIN_BOTTOM[screenSize]
                    }
                }),
                Details: {
                    text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT.BERLIN_2, screenSize)), {
                        maxLines: 1,
                        verticalAlign: "middle"
                    }),
                    flexItem: {
                        marginBottom: DETAILS_MARGIN_BOTTOM[screenSize]
                    }
                }
            },
            ProgressBar: {
                w: w - _constants.safetyMargins.horizontal[screenSize] * 2,
                mountY: 1,
                flexItem: {
                    marginBottom: PROGRESS_MARGIN_BOTTOM[screenSize]
                }
            },
            ButtonsRow: {
                flex: {
                    direction: "row"
                },
                flexItem: {
                    marginBottom: _jumbotronconstants.CTA_MARGIN_BOTTOM[screenSize]
                },
                PlayButton: {
                    flexItem: {
                        marginRight: _jumbotronconstants.CTA_BUTTON_MARGIN_RIGHT[screenSize]
                    }
                },
                MyListButton: {
                    flexItem: {
                        marginRight: _jumbotronconstants.CTA_BUTTON_MARGIN_RIGHT[screenSize]
                    }
                },
                InfoButton: {
                    picto: _jumbotronconstants.INFO_ICON,
                    flexItem: {
                        marginRight: _jumbotronconstants.CTA_BUTTON_MARGIN_RIGHT[screenSize]
                    }
                },
                TrailerButton: {}
            },
            BottomRow: {
                flex: {
                    direction: "row",
                    alignItems: "center"
                },
                ExtraDetails: {
                    text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT.OTTAWA_2, screenSize)), {
                        maxLines: 1,
                        verticalAlign: "middle"
                    }),
                    flexItem: {
                        marginRight: BOTTOM_ROW_GAP[screenSize]
                    }
                },
                ContentRatingIcon: {
                    mountY: 0.5,
                    y: _sizes.middle
                }
            }
        }
    };
}, _style.cacheResolver);


/***/ }),

/***/ 68141:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "isVisibleInformationButton", ({
    enumerable: true,
    get: function() {
        return isVisibleInformationButton;
    }
}));
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(37815);
var isVisibleInformationButton = function(param) {
    var title = param.title, description = param.description;
    return Boolean(title) || Boolean(description);
};


/***/ }),

/***/ 44029:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/* eslint-disable no-console */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "TrailerPlayer", ({
    enumerable: true,
    get: function() {
        return TrailerPlayer;
    }
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _sliced_to_array = __webpack_require__(28966);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(3009);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _sdk = __webpack_require__(29956);
var _fidosdk = __webpack_require__(19804);
var _mediaengine = __webpack_require__(88918);
var _config = __webpack_require__(67958);
var _playerutils = __webpack_require__(92628);
var _screenSaveractions = __webpack_require__(90962);
var _playerutils1 = __webpack_require__(41230);
var _trailerconstants = __webpack_require__(25981);
var TrailerPlayer = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(TrailerPlayer, _Lightning_Component);
    var _super = _create_super._(TrailerPlayer);
    function TrailerPlayer() {
        _class_call_check._(this, TrailerPlayer);
        return _super.apply(this, arguments);
    }
    _create_class._(TrailerPlayer, [
        {
            key: "_construct",
            value: function _construct() {
                this._readyToPlay = false;
                this._videoId = null;
            }
        },
        {
            key: "_attach",
            value: function _attach() {
                this._readyToPlay = true;
                if (this._videoId) {
                    this._loadVideo(this._videoId);
                }
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                this._readyToPlay = false;
                this._destroyPlayer();
                this._videoId = null;
            }
        },
        {
            key: "enabled",
            get: function get() {
                return _config.featureFlipping.player_trailer;
            }
        },
        {
            key: "asset",
            set: function set(value) {
                if (this._videoId !== value) {
                    if (this._videoId) {
                        this._destroyPlayer();
                    }
                    if (this._readyToPlay) {
                        this._loadVideo(value);
                    }
                    this._videoId = value;
                }
            }
        },
        {
            key: "_loadVideo",
            value: function _loadVideo(videoId) {
                var _this = this;
                return _async_to_generator._(function() {
                    var _ref, layout, Engine, sources, index, _createRenderers, videoRef, containerRef, subtitlesContainer, config;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!videoId || !_config.featureFlipping.player_trailer) {
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    4,
                                    Promise.all([
                                        _fidosdk.layoutService.fetchByEntity({
                                            entityType: "video",
                                            entityId: videoId,
                                            sectionCode: "main"
                                        }),
                                        (0, _mediaengine.getPlayerInstance)()
                                    ])
                                ];
                            case 1:
                                _ref = _sliced_to_array._.apply(void 0, [
                                    _state.sent(),
                                    2
                                ]), layout = _ref[0], Engine = _ref[1].Engine;
                                if (!_this._readyToPlay) {
                                    return [
                                        2
                                    ];
                                }
                                sources = (0, _get.default)(layout, "blocks[0].content.items[0].itemContent.video.assets");
                                index = (0, _playerutils1.selectNextPlayableSource)({
                                    sources: sources
                                });
                                _createRenderers = (0, _playerutils.createRenderers)(), videoRef = _createRenderers.video, containerRef = _createRenderers.container, subtitlesContainer = _createRenderers.subtitles;
                                console.log("[Trailer] Loading video");
                                if (!sources[index] || !sources[index].reference) {
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    4,
                                    (0, _playerutils.enhancePlayerConfig)({
                                        dispatcher: _this.playerDispatcher.bind(_this),
                                        drm: {
                                            settings: _config.video.drm,
                                            token: {
                                                handler: function() {
                                                    return _fidosdk.upFrontTokenService.getVideoToken({
                                                        videoId: videoId,
                                                        service: _config.defaultService
                                                    }).then(function(value) {
                                                        return {
                                                            value: value
                                                        };
                                                    });
                                                }
                                            }
                                        },
                                        element: videoRef,
                                        size: {
                                            width: "".concat(_this.finalW, "px"),
                                            height: "".concat(_this.finalH, "px")
                                        },
                                        mute: !_config.featureFlipping.player_trailer_sound,
                                        subtitlesContainer: subtitlesContainer
                                    })
                                ];
                            case 2:
                                config = _state.sent();
                                _this._player = new Engine();
                                _this._player.init(config);
                                _this._player.start(_object_spread_props._(_object_spread._({}, sources[index]), {
                                    shouldAutoPlay: false
                                }));
                                _this._container = containerRef;
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_destroyPlayer",
            value: function _destroyPlayer() {
                if (this._player) {
                    this._player.reset();
                    this._player = null;
                }
                if (this._container) {
                    while(this._container.firstChild){
                        this._container.removeChild(this._container.lastChild);
                    }
                    if (this._container.parentNode) {
                        this._container.parentNode.removeChild(this._container);
                    }
                }
                if (_lightningjsredux.default.dispatch) {
                    _lightningjsredux.default.dispatch((0, _screenSaveractions.setScreenSaverIsLocked)(false));
                }
                this._container = null;
            }
        },
        {
            key: "play",
            value: function play(startTime) {
                if (!this._player) {
                    return;
                }
                if (Number.isFinite(startTime)) {
                    this._player.seek(startTime);
                }
                this._player.play();
            }
        },
        {
            key: "pause",
            value: function pause() {
                if (!this._player) {
                    return;
                }
                if (_lightningjsredux.default.dispatch) {
                    _lightningjsredux.default.dispatch((0, _screenSaveractions.setScreenSaverIsLocked)(false));
                }
                this._player.pause();
            }
        },
        {
            // eslint-disable-next-line no-unused-vars
            key: "playerDispatcher",
            value: function playerDispatcher(event, payload) {
                if (event === _trailerconstants.VIDEO_CAN_PLAY_SIGNAL) {
                    this.signal(_trailerconstants.VIDEO_CAN_PLAY_SIGNAL);
                } else if (event === _trailerconstants.VIDEO_PLAYING_SIGNAL) {
                    if (_lightningjsredux.default.dispatch) {
                        _lightningjsredux.default.dispatch((0, _screenSaveractions.setScreenSaverIsLocked)(true));
                    }
                    this.signal(_trailerconstants.VIDEO_PLAYING_SIGNAL);
                } else if (event === _trailerconstants.VIDEO_ENDED_SIGNAL) {
                    this.signal(_trailerconstants.VIDEO_ENDED_SIGNAL);
                }
            }
        }
    ]);
    return TrailerPlayer;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 25981:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    VIDEO_CAN_PLAY_SIGNAL: function() {
        return VIDEO_CAN_PLAY_SIGNAL;
    },
    VIDEO_ENDED_SIGNAL: function() {
        return VIDEO_ENDED_SIGNAL;
    },
    VIDEO_PLAYING_SIGNAL: function() {
        return VIDEO_PLAYING_SIGNAL;
    }
});
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(37815);
var VIDEO_PLAYING_SIGNAL = "playing";
var VIDEO_ENDED_SIGNAL = "ended";
var VIDEO_CAN_PLAY_SIGNAL = "canplay";


/***/ }),

/***/ 68779:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BACKSPACE: function() {
        return BACKSPACE;
    },
    BUTTON_LENGTH: function() {
        return BUTTON_LENGTH;
    },
    DEFAULT_KEYBOARD: function() {
        return DEFAULT_KEYBOARD;
    },
    ITEMS_PER_ROW: function() {
        return ITEMS_PER_ROW;
    },
    LETTER_REMOVED_SIGNAL: function() {
        return LETTER_REMOVED_SIGNAL;
    },
    LETTER_SELECTED_SIGNAL: function() {
        return LETTER_SELECTED_SIGNAL;
    },
    SPACE: function() {
        return SPACE;
    },
    SPECIAL_KEYS: function() {
        return SPECIAL_KEYS;
    }
});
var _define_property = __webpack_require__(21228);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(42578);
var LETTER_SELECTED_SIGNAL = "letterSelected";
var LETTER_REMOVED_SIGNAL = "letterRemoved";
var ITEMS_PER_ROW = 10;
var SPACE = "_";
var BACKSPACE = "<";
var BUTTON_LENGTH = 2;
var _obj;
var SPECIAL_KEYS = (_obj = {}, _define_property._(_obj, SPACE, {
    icon: {
        name: "Space",
        type: "icon"
    },
    keyLength: BUTTON_LENGTH
}), _define_property._(_obj, BACKSPACE, {
    icon: {
        name: "BackSpace",
        type: "icon"
    },
    keyLength: BUTTON_LENGTH
}), _obj);
var DEFAULT_KEYBOARD = [
    [
        "a",
        "\xe4"
    ],
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    [
        "o",
        "\xf6"
    ],
    "p",
    "q",
    "r",
    [
        "s",
        "\xdf"
    ],
    "t",
    [
        "u",
        "\xfc"
    ],
    "v",
    "w",
    "x",
    "y",
    "z",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "0",
    SPACE,
    BACKSPACE
];


/***/ }),

/***/ 50176:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BACKGROUND_UNFOCUSED_OPACITY: function() {
        return BACKGROUND_UNFOCUSED_OPACITY;
    },
    FOCUSED_FONT: function() {
        return FOCUSED_FONT;
    },
    ICON_BACKGROUND_UNFOCUSED_OPACITY: function() {
        return ICON_BACKGROUND_UNFOCUSED_OPACITY;
    },
    RADIUS: function() {
        return RADIUS;
    },
    UNFOCUSED_FONT: function() {
        return UNFOCUSED_FONT;
    }
});
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(88801);
var RADIUS = 4;
var BACKGROUND_UNFOCUSED_OPACITY = 0;
var ICON_BACKGROUND_UNFOCUSED_OPACITY = 0.2;
var FOCUSED_FONT = "KINSHASA_1";
var UNFOCUSED_FONT = "KINSHASA_1";


/***/ }),

/***/ 7657:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "KeyboardItem", ({
    enumerable: true,
    get: function() {
        return KeyboardItem;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(42578);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _keyItemstyle = __webpack_require__(95552);
var KeyboardItem = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(KeyboardItem, _Lightning_Component);
    var _super = _create_super._(KeyboardItem);
    function KeyboardItem() {
        _class_call_check._(this, KeyboardItem);
        return _super.apply(this, arguments);
    }
    _create_class._(KeyboardItem, [
        {
            key: "_setup",
            value: function _setup() {
                this._style = _keyItemstyle.defaultContext;
            }
        },
        {
            key: "_focus",
            value: function _focus() {
                this._setState("Focused");
            }
        },
        {
            key: "_unfocus",
            value: function _unfocus() {
                this._setState("Unfocused");
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Button: {
                        shader: {
                            type: _sdk.Lightning.shaders.RoundedRectangle
                        },
                        SpecialIndicator: {
                            visible: false,
                            shader: {
                                type: _sdk.Lightning.shaders.RoundedRectangle
                            }
                        }
                    }
                }, (0, _keyItemstyle.getInitialStyle)());
            }
        },
        {
            key: "_states",
            value: function _states() {
                return [
                    /*#__PURE__*/ function(_this) {
                        _inherits._(Unfocused, _this);
                        var _super = _create_super._(Unfocused);
                        function Unfocused() {
                            _class_call_check._(this, Unfocused);
                            return _super.apply(this, arguments);
                        }
                        _create_class._(Unfocused, [
                            {
                                key: "$enter",
                                value: function $enter() {
                                    if (this.tag("Icon")) {
                                        this.tag("Button").color = _keyItemstyle.buttonColor.iconBackgroundUnFocused[this._style.colorMode];
                                        this.tag("Icon").color = _keyItemstyle.buttonColor.innerElementUnFocused[this._style.colorMode];
                                        return;
                                    }
                                    this.tag("Button").color = _keyItemstyle.buttonColor.backgroundUnFocused[this._style.colorMode];
                                    this.tag("Letter").text = (0, _keyItemstyle.getStateLetterStyles)(this._style).unfocused;
                                }
                            }
                        ]);
                        return Unfocused;
                    }(this),
                    /*#__PURE__*/ function(_this) {
                        _inherits._(Focused, _this);
                        var _super = _create_super._(Focused);
                        function Focused() {
                            _class_call_check._(this, Focused);
                            return _super.apply(this, arguments);
                        }
                        _create_class._(Focused, [
                            {
                                key: "$enter",
                                value: function $enter() {
                                    this.tag("Button").color = _keyItemstyle.buttonColor.backgroundFocused[this._style.colorMode];
                                    if (this.tag("Letter")) this.tag("Letter").text = (0, _keyItemstyle.getStateLetterStyles)(this._style).focused;
                                    if (this.tag("Icon")) this.tag("Icon").color = _keyItemstyle.buttonColor.innerElementFocused[this._style.colorMode];
                                }
                            }
                        ]);
                        return Focused;
                    }(this)
                ];
            }
        }
    ]);
    return KeyboardItem;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 95552:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    KEYS_GAP: function() {
        return KEYS_GAP;
    },
    KEY_HEIGHT: function() {
        return KEY_HEIGHT;
    },
    KEY_WIDTH: function() {
        return KEY_WIDTH;
    },
    PICTO_DIMENSIONS: function() {
        return PICTO_DIMENSIONS;
    },
    SPECIAL_INDICATOR_OFFSET_BOTTOM: function() {
        return SPECIAL_INDICATOR_OFFSET_BOTTOM;
    },
    SPECIAL_INDICATOR_RADIUS: function() {
        return SPECIAL_INDICATOR_RADIUS;
    },
    SPECIAL_INDICATOR_SIZE: function() {
        return SPECIAL_INDICATOR_SIZE;
    },
    buttonColor: function() {
        return buttonColor;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getBasicIconViewBox: function() {
        return getBasicIconViewBox;
    },
    getBasicLetter: function() {
        return getBasicLetter;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    getStateLetterStyles: function() {
        return getStateLetterStyles;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
var _memoize = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34736));
var _constants = __webpack_require__(34952);
var _theme = __webpack_require__(51397);
var _typography = __webpack_require__(18411);
var _style = __webpack_require__(65082);
var _keyItemconstants = __webpack_require__(50176);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var BORDER_RADIUS = _keyItemconstants.RADIUS;
var _obj;
var KEY_HEIGHT = (_obj = {}, _define_property._(_obj, _constants.HD, 40), _define_property._(_obj, _constants.FULL_HD, 56), _obj);
var _obj1;
var KEY_WIDTH = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 48), _define_property._(_obj1, _constants.FULL_HD, 72), _obj1);
var _obj2;
var PICTO_DIMENSIONS = (_obj2 = {}, _define_property._(_obj2, _constants.HD, {
    width: 24,
    height: 24
}), _define_property._(_obj2, _constants.FULL_HD, {
    width: 36,
    height: 36
}), _obj2);
var KEYS_GAP = 1;
var SPECIAL_INDICATOR_RADIUS = 3;
var _obj3;
var SPECIAL_INDICATOR_OFFSET_BOTTOM = (_obj3 = {}, _define_property._(_obj3, _constants.HD, 2), _define_property._(_obj3, _constants.FULL_HD, 4), _obj3);
var _obj4;
var SPECIAL_INDICATOR_SIZE = (_obj4 = {}, _define_property._(_obj4, _constants.HD, 4), _define_property._(_obj4, _constants.FULL_HD, 6), _obj4);
var buttonColor = {
    backgroundFocused: (0, _theme.makeThemeColor)(_theme.PRIMARY),
    innerElementUnFocused: (0, _theme.makeThemeColor)(_theme.PRIMARY),
    innerElementFocused: (0, _theme.makeThemeColor)(_theme.TERTIARY),
    specialIndicator: (0, _theme.makeThemeColor)(_theme.CLOUD_NORMAL),
    backgroundUnFocused: (0, _theme.makeThemeColor)(_theme.PRIMARY, _keyItemconstants.BACKGROUND_UNFOCUSED_OPACITY),
    iconBackgroundUnFocused: (0, _theme.makeThemeColor)(_theme.PRIMARY, _keyItemconstants.ICON_BACKGROUND_UNFOCUSED_OPACITY)
};
var getBasicIconViewBox = (0, _memoize.default)(function(screenSize) {
    return {
        h: PICTO_DIMENSIONS[screenSize].height,
        w: PICTO_DIMENSIONS[screenSize].width
    };
});
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var screenSize = context.screenSize, colorMode = context.colorMode;
    return {
        Button: {
            rect: true,
            w: KEY_WIDTH[screenSize],
            h: KEY_HEIGHT[screenSize],
            color: buttonColor.backgroundUnFocused[colorMode],
            shader: {
                radius: BORDER_RADIUS
            },
            SpecialIndicator: {
                rect: true,
                w: SPECIAL_INDICATOR_SIZE[screenSize],
                h: SPECIAL_INDICATOR_SIZE[screenSize],
                x: KEY_WIDTH[screenSize] / 2 - SPECIAL_INDICATOR_SIZE[screenSize] / 2,
                y: KEY_HEIGHT[screenSize] - SPECIAL_INDICATOR_SIZE[screenSize] * 2,
                color: buttonColor.specialIndicator[colorMode],
                shader: {
                    radius: SPECIAL_INDICATOR_RADIUS
                }
            }
        }
    };
};
var getStateLetterStyles = (0, _memoize.default)(function(param) {
    var screenSize = param.screenSize, colorMode = param.colorMode;
    return {
        unfocused: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT[_keyItemconstants.FOCUSED_FONT], screenSize)), {
            lineHeight: KEY_HEIGHT[screenSize],
            textColor: buttonColor.innerElementUnFocused[colorMode]
        }),
        focused: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT[_keyItemconstants.UNFOCUSED_FONT], screenSize)), {
            lineHeight: KEY_HEIGHT[screenSize],
            textColor: buttonColor.innerElementFocused[colorMode]
        })
    };
}, _style.cacheResolver);
var getBasicLetter = function(param) {
    var symbol = param.symbol, screenSize = param.screenSize, colorMode = param.colorMode;
    return {
        Letter: {
            w: KEY_WIDTH[screenSize],
            h: KEY_HEIGHT[screenSize],
            text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT.KINSHASA_1, screenSize)), {
                lineHeight: KEY_HEIGHT[screenSize],
                textColor: buttonColor.innerElementUnFocused[colorMode],
                textAlign: "center",
                text: symbol,
                verticalAlign: "middle"
            })
        }
    };
};


/***/ }),

/***/ 15939:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return Keyboard;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _create_super = __webpack_require__(6400);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(65759);
var _sdk = __webpack_require__(29956);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _keyboardstyle = __webpack_require__(51836);
var _keyItemcomponent = __webpack_require__(7657);
var _keyItemstyle = __webpack_require__(95552);
var _keyboardconstants = __webpack_require__(20190);
var _iconcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(70160));
var _subKeyboardcomponent = __webpack_require__(4552);
var _subKeyboardconstants = __webpack_require__(91592);
var Keyboard = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(Keyboard, _Lightning_Component);
    var _super = _create_super._(Keyboard);
    function Keyboard() {
        _class_call_check._(this, Keyboard);
        return _super.apply(this, arguments);
    }
    _create_class._(Keyboard, [
        {
            key: "_init",
            value: function _init() {
                this._index = 0;
                this._style = _keyboardstyle.defaultContext;
                this._keyBoardLayout = [
                    0
                ];
                this.numberOfSpecialButtons = 0;
                this.initialize = _keyboardconstants.DEFAULT_KEYBOARD;
            }
        },
        {
            key: "initialize",
            set: function set(letterRow) {
                var _this = this;
                var numberOfButtons = 0;
                this.tag("Keys").children = letterRow.map(function(symbol, index) {
                    if (Object.keys(_keyboardconstants.SPECIAL_KEYS).includes(symbol)) {
                        var _SPECIAL_KEYS_symbol = _keyboardconstants.SPECIAL_KEYS[symbol], keyLength = _SPECIAL_KEYS_symbol.keyLength, icon = _SPECIAL_KEYS_symbol.icon;
                        for(var i = 0; i < keyLength; i += 1){
                            _this._keyBoardLayout[numberOfButtons] = index;
                            numberOfButtons += 1;
                        }
                        _this.numberOfSpecialButtons += keyLength - 1;
                        var width = _keyItemstyle.KEY_WIDTH[_this._style.screenSize] + _keyItemstyle.KEYS_GAP;
                        var height = _keyItemstyle.KEY_HEIGHT[_this._style.screenSize] + _keyItemstyle.KEYS_GAP;
                        var iconViewBox = (0, _keyItemstyle.getBasicIconViewBox)(_this._style.screenSize);
                        return {
                            type: _keyItemcomponent.KeyboardItem,
                            x: Math.round(width * ((numberOfButtons - keyLength) % _keyboardconstants.ITEMS_PER_ROW)),
                            y: Math.round(height * Math.floor((numberOfButtons - keyLength) / _keyboardconstants.ITEMS_PER_ROW)),
                            Button: {
                                color: _keyItemstyle.buttonColor.iconBackgroundUnFocused[_this._style.colorMode],
                                w: keyLength * _keyItemstyle.KEY_WIDTH[_this._style.screenSize] + _keyItemstyle.KEYS_GAP
                            },
                            Icon: {
                                type: _iconcomponent.default,
                                x: Math.round((keyLength * width - iconViewBox.w) / 2),
                                y: Math.round((height - iconViewBox.h) / 2),
                                iconData: {
                                    picto: icon,
                                    viewBox: iconViewBox
                                }
                            }
                        };
                    }
                    _this._keyBoardLayout[numberOfButtons] = index;
                    numberOfButtons += 1;
                    var isMultiple = Array.isArray(symbol);
                    var viewSymbol = isMultiple ? symbol[0] : symbol;
                    return _object_spread._({
                        type: _keyItemcomponent.KeyboardItem,
                        x: (_keyItemstyle.KEY_WIDTH[_this._style.screenSize] + _keyItemstyle.KEYS_GAP) * ((numberOfButtons - 1) % _keyboardconstants.ITEMS_PER_ROW),
                        y: (_keyItemstyle.KEY_HEIGHT[_this._style.screenSize] + _keyItemstyle.KEYS_GAP) * Math.floor((numberOfButtons - 1) / _keyboardconstants.ITEMS_PER_ROW),
                        Button: {
                            SpecialIndicator: {
                                visible: isMultiple
                            }
                        }
                    }, (0, _keyItemstyle.getBasicLetter)(_object_spread._({
                        symbol: viewSymbol
                    }, _this._style)));
                });
                this._setIndex();
            }
        },
        {
            key: "_handleCloseSubKeyboard",
            value: function _handleCloseSubKeyboard() {
                this._focused = this.tag("Keys").children[this._index];
            }
        },
        {
            key: "_handleUp",
            value: function _handleUp() {
                var isBelowFirstRow = this._index + this.numberOfSpecialButtons >= _keyboardconstants.ITEMS_PER_ROW;
                if (isBelowFirstRow) {
                    this._setIndex(this._keyBoardLayout[this._keyBoardLayout.indexOf(this._index) - _keyboardconstants.ITEMS_PER_ROW]);
                }
                return false;
            }
        },
        {
            key: "_handleDown",
            value: function _handleDown() {
                var lastRowStartIndex = Math.ceil(this._keyBoardLayout.length / _keyboardconstants.ITEMS_PER_ROW - 1) * _keyboardconstants.ITEMS_PER_ROW;
                var hasNoItemBellow = this._index + _keyboardconstants.ITEMS_PER_ROW >= this._keyBoardLayout.length;
                var isLastRow = this._keyBoardLayout.indexOf(this._index) >= lastRowStartIndex;
                if (isLastRow || hasNoItemBellow) return false;
                this._setIndex(this._keyBoardLayout[this._keyBoardLayout.indexOf(this._index) + _keyboardconstants.ITEMS_PER_ROW]);
                return true;
            }
        },
        {
            key: "_handleLeft",
            value: function _handleLeft() {
                var isBeginningOfRow = this._keyBoardLayout.indexOf(this._index) % _keyboardconstants.ITEMS_PER_ROW === 0;
                if (isBeginningOfRow) {
                    return false;
                }
                if (this._index > 0) {
                    this._setIndex(this._index - 1);
                    return true;
                }
                return false;
            }
        },
        {
            key: "_handleRight",
            value: function _handleRight() {
                var isEndOfRow = this._keyBoardLayout.lastIndexOf(this._index) % _keyboardconstants.ITEMS_PER_ROW < _keyboardconstants.ITEMS_PER_ROW - 1;
                if (isEndOfRow) {
                    this._setIndex(this._index + 1);
                    return true;
                }
                return false;
            }
        },
        {
            key: "_handleEnter",
            value: function _handleEnter() {
                var selectedItem = _keyboardconstants.DEFAULT_KEYBOARD[this._index];
                if (!Array.isArray(selectedItem)) {
                    this.signal(_keyboardconstants.LETTER_SELECTED_SIGNAL, selectedItem);
                    return;
                }
                var _this__focused = this._focused, x = _this__focused.x, y = _this__focused.y;
                this.tag("SubKeys").initialize = {
                    x: x,
                    y: y,
                    items: selectedItem
                };
                this._focused = this.tag("SubKeys");
            }
        },
        {
            key: "_setIndex",
            value: function _setIndex() {
                var index = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._index;
                this._index = index;
                this._focused = this.tag("Keys").children[this._index];
            }
        },
        {
            key: "_getFocused",
            value: function _getFocused() {
                return this._focused;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Background: {},
                    Keys: {},
                    SubKeys: {
                        type: _subKeyboardcomponent.SubKeyboard,
                        signals: _define_property._({}, _subKeyboardconstants.CLOSE_SUB_KEYBOARD_SIGNAL, "_handleCloseSubKeyboard"),
                        passSignals: _define_property._({}, _keyboardconstants.LETTER_SELECTED_SIGNAL, true)
                    }
                }, (0, _keyboardstyle.getInitialStyle)());
            }
        }
    ]);
    return Keyboard;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 20190:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _export_star = __webpack_require__(37668);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(45538);
_export_star._(__webpack_require__(68779), exports);


/***/ }),

/***/ 51836:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    KEYBOARD_HEIGHT: function() {
        return KEYBOARD_HEIGHT;
    },
    KEYBOARD_OFFSET_X: function() {
        return KEYBOARD_OFFSET_X;
    },
    KEYBOARD_OFFSET_Y: function() {
        return KEYBOARD_OFFSET_Y;
    },
    KEYBOARD_WIDTH: function() {
        return KEYBOARD_WIDTH;
    },
    colorMode: function() {
        return colorMode;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    screenSize: function() {
        return screenSize;
    }
});
var _define_property = __webpack_require__(21228);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(52318);
var _theme = __webpack_require__(51397);
var _constants = __webpack_require__(34952);
var _style = __webpack_require__(65082);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var KEYBOARD_HEIGHT = (_obj = {}, _define_property._(_obj, _constants.HD, 163), _define_property._(_obj, _constants.FULL_HD, 227), _obj);
var _obj1;
var KEYBOARD_WIDTH = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 489), _define_property._(_obj1, _constants.FULL_HD, 729), _obj1);
var _obj2;
var KEYBOARD_OFFSET_X = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 192), _define_property._(_obj2, _constants.FULL_HD, 264), _obj2);
var _obj3;
var KEYBOARD_OFFSET_Y = (_obj3 = {}, _define_property._(_obj3, _constants.HD, 120), _define_property._(_obj3, _constants.FULL_HD, 205), _obj3);
var colors = {
    background: (0, _theme.makeThemeColor)(_theme.TERTIARY)
};
var screenSize = defaultContext.screenSize, colorMode = defaultContext.colorMode;
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var screenSize = context.screenSize, colorMode = context.colorMode;
    return {
        x: KEYBOARD_OFFSET_X[screenSize],
        y: KEYBOARD_OFFSET_Y[screenSize],
        Background: {
            rect: true,
            h: KEYBOARD_HEIGHT[screenSize],
            w: KEYBOARD_WIDTH[screenSize],
            color: colors.background[colorMode]
        }
    };
};


/***/ }),

/***/ 72742:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return KeyboardNumbers;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _create_super = __webpack_require__(6400);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(88801);
var _sdk = __webpack_require__(29956);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _keys = __webpack_require__(3043);
var _iconcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(70160));
var _keyItemcomponent = __webpack_require__(7657);
var _keyboardconstants = __webpack_require__(20190);
var _keyItemstyle = __webpack_require__(95552);
var _keyboardNumbersstyle = __webpack_require__(90491);
var _keyboardNumbersconstants = __webpack_require__(41482);
var KeyboardNumbers = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(KeyboardNumbers, _Lightning_Component);
    var _super = _create_super._(KeyboardNumbers);
    function KeyboardNumbers() {
        _class_call_check._(this, KeyboardNumbers);
        return _super.apply(this, arguments);
    }
    _create_class._(KeyboardNumbers, [
        {
            key: "_init",
            value: function _init() {
                this._index = 0;
                this._itemsPerRow = _keyboardNumbersconstants.ITEMS_PER_ROW;
                this._style = _keyboardNumbersstyle.defaultContext;
                this.keys = [];
                this.renderKeyboard();
            }
        },
        {
            key: "itemsPerRow",
            get: function get() {
                return this._itemsPerRow;
            },
            set: function set(value) {
                this._itemsPerRow = value || _keyboardNumbersconstants.ITEMS_PER_ROW;
            }
        },
        {
            key: "renderKeyboard",
            value: function renderKeyboard() {
                var value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
                this._keys = value || _keyboardNumbersconstants.DEFAULT_KEYBOARD;
                this._renderKeys(this._keys);
                this.visible = true;
                this._setIndex(0);
                this._refocus();
            }
        },
        {
            key: "_renderKeys",
            value: function _renderKeys(characters) {
                var _this = this;
                var iconViewBox = (0, _keyboardNumbersstyle.getBasicIconViewBox)(this._style.screenSize);
                this.patch({
                    Keys: {
                        children: characters.map(function(symbol, index) {
                            var icon = _keyboardconstants.SPECIAL_KEYS[symbol] ? _keyboardconstants.SPECIAL_KEYS[symbol].icon : null;
                            var result = _object_spread._({
                                type: _keyItemcomponent.KeyboardItem,
                                x: (_keyItemstyle.KEY_WIDTH[_this._style.screenSize] + _keyItemstyle.KEYS_GAP) * (index % _this._itemsPerRow),
                                y: (_keyItemstyle.KEY_HEIGHT[_this._style.screenSize] + _keyItemstyle.KEYS_GAP) * Math.floor(index / _this._itemsPerRow)
                            }, icon ? undefined : (0, _keyItemstyle.getBasicLetter)(_object_spread._({
                                symbol: symbol
                            }, _this._style)));
                            if (icon) {
                                result.Icon = {
                                    type: _iconcomponent.default,
                                    x: Math.round((_keyItemstyle.KEY_WIDTH[_this._style.screenSize] - iconViewBox.w) / 2),
                                    y: Math.round((_keyItemstyle.KEY_HEIGHT[_this._style.screenSize] - iconViewBox.h) / 2),
                                    color: _keyItemstyle.buttonColor.innerElementUnFocused[_this._style.colorMode],
                                    iconData: {
                                        picto: icon,
                                        viewBox: iconViewBox
                                    }
                                };
                                result.Button = {
                                    color: _keyItemstyle.buttonColor.iconBackgroundUnFocused[_this._style.colorMode]
                                };
                            }
                            return result;
                        })
                    },
                    w: (_keyItemstyle.KEY_WIDTH[this._style.screenSize] + _keyItemstyle.KEYS_GAP) * this._itemsPerRow,
                    h: (_keyItemstyle.KEY_HEIGHT[this._style.screenSize] + _keyItemstyle.KEYS_GAP) * Math.ceil(characters.length / this._itemsPerRow)
                });
            }
        },
        {
            key: "_handleUp",
            value: function _handleUp() {
                if (this._index >= this._itemsPerRow) {
                    this._setIndex(this._index - this._itemsPerRow);
                    return true;
                }
                return false;
            }
        },
        {
            key: "_handleDown",
            value: function _handleDown() {
                var isNotLastRow = this._index + this._itemsPerRow < this._keys.length;
                if (isNotLastRow) {
                    this._setIndex(this._index + this._itemsPerRow);
                }
                return false;
            }
        },
        {
            key: "_handleLeft",
            value: function _handleLeft() {
                if (this._index > 0) {
                    this._setIndex(this._index - 1);
                }
                return false;
            }
        },
        {
            key: "_handleRight",
            value: function _handleRight() {
                if (this._index < this._keys.length - 1) {
                    this._setIndex(this._index + 1);
                }
                return false;
            }
        },
        {
            key: "_handleEnter",
            value: function _handleEnter() {
                this.signal(_keyboardconstants.LETTER_SELECTED_SIGNAL, this._keys[this._index]);
                return true;
            }
        },
        {
            key: "_handleKey",
            value: function _handleKey(event) {
                // eslint-disable-next-line prefer-const
                var key = event.key, keyCode = event.keyCode;
                if (!key) {
                    key = (0, _keys.keyCodeToNumber)(keyCode);
                }
                if (/^[0-9]$/.test(key)) {
                    // eslint-disable-next-line eqeqeq
                    var index = this._keys.findIndex(function(value) {
                        return value == key;
                    });
                    if (index > -1) {
                        this._setIndex(index);
                        return this._handleEnter();
                    }
                }
                return false;
            }
        },
        {
            key: "_setIndex",
            value: function _setIndex() {
                var index = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._index;
                this._index = index;
            }
        },
        {
            key: "_focus",
            value: function _focus() {
                this._setIndex();
            }
        },
        {
            key: "_getFocused",
            value: function _getFocused() {
                return this.tag("Keys").children[this._index];
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    visible: false,
                    Background: {},
                    Keys: {}
                }, (0, _keyboardNumbersstyle.getInitialStyle)());
            }
        }
    ]);
    return KeyboardNumbers;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 41482:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DEFAULT_KEYBOARD: function() {
        return DEFAULT_KEYBOARD;
    },
    ITEMS_PER_ROW: function() {
        return ITEMS_PER_ROW;
    }
});
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(45538);
var ITEMS_PER_ROW = 10;
var DEFAULT_KEYBOARD = [
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "0"
];


/***/ }),

/***/ 90491:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ICON_SIZE: function() {
        return ICON_SIZE;
    },
    KEYBOARD_HEIGHT: function() {
        return KEYBOARD_HEIGHT;
    },
    KEYBOARD_WIDTH: function() {
        return KEYBOARD_WIDTH;
    },
    colorMode: function() {
        return colorMode;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getBasicIconViewBox: function() {
        return getBasicIconViewBox;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    screenSize: function() {
        return screenSize;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
var _memoize = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34736));
var _theme = __webpack_require__(51397);
var _constants = __webpack_require__(34952);
var _style = __webpack_require__(65082);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var KEYBOARD_HEIGHT = (_obj = {}, _define_property._(_obj, _constants.HD, 81), _define_property._(_obj, _constants.FULL_HD, 113), _obj);
var _obj1;
var KEYBOARD_WIDTH = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 244), _define_property._(_obj1, _constants.FULL_HD, 364), _obj1);
var colors = {
    background: (0, _theme.makeThemeColor)(_theme.TERTIARY)
};
var _obj2;
var ICON_SIZE = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 24), _define_property._(_obj2, _constants.FULL_HD, 36), _obj2);
var screenSize = defaultContext.screenSize, colorMode = defaultContext.colorMode;
var getBasicIconViewBox = (0, _memoize.default)(function(screenSize) {
    return {
        h: ICON_SIZE[screenSize],
        w: ICON_SIZE[screenSize]
    };
});
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var screenSize = context.screenSize, colorMode = context.colorMode;
    return {
        h: KEYBOARD_HEIGHT[screenSize],
        w: KEYBOARD_WIDTH[screenSize],
        Background: {
            rect: true,
            h: KEYBOARD_HEIGHT[screenSize],
            w: KEYBOARD_WIDTH[screenSize],
            color: colors.background[colorMode]
        }
    };
};


/***/ }),

/***/ 21498:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(52318);
var _keyboardNumberscomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(72742));
var _default = _keyboardNumberscomponent.default;


/***/ }),

/***/ 4552:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "SubKeyboard", ({
    enumerable: true,
    get: function() {
        return SubKeyboard;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _create_super = __webpack_require__(6400);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(52318);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _subKeyboardstyle = __webpack_require__(72327);
var _keyItemcomponent = __webpack_require__(7657);
var _keyItemstyle = __webpack_require__(95552);
var _keyboardconstants = __webpack_require__(20190);
var _subKeyboardconstants = __webpack_require__(91592);
var SubKeyboard = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(SubKeyboard, _Lightning_Component);
    var _super = _create_super._(SubKeyboard);
    function SubKeyboard() {
        _class_call_check._(this, SubKeyboard);
        return _super.apply(this, arguments);
    }
    _create_class._(SubKeyboard, [
        {
            key: "_init",
            value: function _init() {
                this._index = 0;
                this._items = [];
                this._style = _subKeyboardstyle.defaultContext;
            }
        },
        {
            key: "initialize",
            set: function set(data) {
                var _this = this;
                var items = data.items, x = data.x, y = data.y;
                this._items = items;
                var numberOfButtons = 0;
                var width;
                var height;
                if (items.length >= _subKeyboardstyle.MAX_ITEMS_PER_ROW) {
                    width = (_keyItemstyle.KEY_WIDTH[this._style.screenSize] + _keyItemstyle.KEYS_GAP) * _subKeyboardstyle.MAX_ITEMS_PER_ROW;
                    height = (_keyItemstyle.KEY_HEIGHT[this._style.screenSize] + _keyItemstyle.KEYS_GAP) * Math.floor(items.length / _subKeyboardstyle.MAX_ITEMS_PER_ROW);
                } else {
                    width = (_keyItemstyle.KEY_WIDTH[this._style.screenSize] + _keyItemstyle.KEYS_GAP) * items.length;
                    height = _keyItemstyle.KEY_HEIGHT[this._style.screenSize] + _keyItemstyle.KEYS_GAP;
                }
                this.tag("Keys").children = items.map(function(symbol, index) {
                    numberOfButtons += 1;
                    return _object_spread._({
                        type: _keyItemcomponent.KeyboardItem,
                        x: (_keyItemstyle.KEY_WIDTH[_this._style.screenSize] + _keyItemstyle.KEYS_GAP) * ((numberOfButtons - 1) % _subKeyboardstyle.MAX_ITEMS_PER_ROW),
                        y: (_keyItemstyle.KEY_HEIGHT[_this._style.screenSize] + _keyItemstyle.KEYS_GAP) * Math.floor((numberOfButtons - 1) / _subKeyboardstyle.MAX_ITEMS_PER_ROW),
                        Button: {
                            SpecialIndicator: {
                                visible: index === 0
                            }
                        }
                    }, (0, _keyItemstyle.getBasicLetter)(_object_spread._({
                        symbol: symbol
                    }, _this._style)));
                });
                this.patch({
                    x: x,
                    y: y,
                    visible: true,
                    ScalableContent: {
                        w: width + _subKeyboardstyle.KEY_PADDING * 2,
                        h: height + _subKeyboardstyle.KEY_PADDING * 2
                    }
                });
            }
        },
        {
            key: "_reset",
            value: function _reset() {
                this._index = 0;
                this._items = [];
                this.patch({
                    visible: false,
                    x: 0,
                    y: 0,
                    ScalableContent: {
                        w: 0,
                        h: 0
                    }
                });
                this.tag("Keys").children = undefined;
            }
        },
        {
            key: "_close",
            value: function _close() {
                this.signal(_subKeyboardconstants.CLOSE_SUB_KEYBOARD_SIGNAL);
                this._reset();
            }
        },
        {
            key: "_handleUp",
            value: function _handleUp() {
                var isNotFirstRow = this._index > _subKeyboardstyle.MAX_ITEMS_PER_ROW - 1;
                if (isNotFirstRow) {
                    this._setIndex(this._index - _subKeyboardstyle.MAX_ITEMS_PER_ROW);
                    return true;
                }
                this._close();
                return false;
            }
        },
        {
            key: "_handleDown",
            value: function _handleDown() {
                var isNotLastRow = this._index + _subKeyboardstyle.MAX_ITEMS_PER_ROW < this._items.length;
                if (isNotLastRow) {
                    this._setIndex(this._index + _subKeyboardstyle.MAX_ITEMS_PER_ROW);
                    return true;
                }
                this._close();
                return false;
            }
        },
        {
            key: "_handleLeft",
            value: function _handleLeft() {
                var itemsCount = this._items.length;
                var isNotBeginningOfRow = itemsCount > _subKeyboardstyle.MAX_ITEMS_PER_ROW ? this._index % _subKeyboardstyle.MAX_ITEMS_PER_ROW !== 0 : this._index > 0;
                if (isNotBeginningOfRow) {
                    this._setIndex(this._index - 1);
                    return true;
                }
                this._close();
                return false;
            }
        },
        {
            key: "_handleRight",
            value: function _handleRight() {
                var itemsCount = this._items.length;
                var isNotEndOfRow = itemsCount > _subKeyboardstyle.MAX_ITEMS_PER_ROW ? (this._index + 1) % _subKeyboardstyle.MAX_ITEMS_PER_ROW !== 0 : this._index + 1 < itemsCount;
                if (isNotEndOfRow) {
                    this._setIndex(this._index + 1);
                    return true;
                }
                this._close();
                return false;
            }
        },
        {
            key: "_handleEnter",
            value: function _handleEnter() {
                this.signal(_keyboardconstants.LETTER_SELECTED_SIGNAL, this._items[this._index]);
            }
        },
        {
            key: "_handleBack",
            value: function _handleBack() {
                this._close();
            }
        },
        {
            key: "_setIndex",
            value: function _setIndex() {
                var index = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._index;
                this._index = index;
            }
        },
        {
            key: "_getFocused",
            value: function _getFocused() {
                return this.tag("Keys").children[this._index];
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    ScalableContent: {
                        Background: {
                            shader: {
                                type: _sdk.Lightning.shaders.RoundedRectangle
                            }
                        },
                        Keys: {}
                    }
                }, (0, _subKeyboardstyle.getInitialStyle)());
            }
        }
    ]);
    return SubKeyboard;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 91592:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "CLOSE_SUB_KEYBOARD_SIGNAL", ({
    enumerable: true,
    get: function() {
        return CLOSE_SUB_KEYBOARD_SIGNAL;
    }
}));
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(3009);
var CLOSE_SUB_KEYBOARD_SIGNAL = "closeSubKeyboard";


/***/ }),

/***/ 72327:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    KEY_PADDING: function() {
        return KEY_PADDING;
    },
    MAX_ITEMS_PER_ROW: function() {
        return MAX_ITEMS_PER_ROW;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(65759);
var _theme = __webpack_require__(51397);
var _style = __webpack_require__(65082);
var _sizes = __webpack_require__(82699);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var KEY_PADDING = 4;
var BORDER_RADIUS = 4;
var BORDER_WIDTH = 3;
var MAX_ITEMS_PER_ROW = 4;
var colors = {
    scalableContent: (0, _theme.makeThemeColor)(_theme.TERTIARY),
    background: (0, _theme.makeThemeColor)(_theme.PRIMARY, 0.1),
    border: (0, _theme.makeThemeColor)(_theme.PRIMARY)
};
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var colorMode = context.colorMode;
    return {
        visible: false,
        ScalableContent: {
            rect: true,
            w: 0,
            h: 0,
            color: colors.scalableContent[colorMode],
            Background: {
                rect: true,
                w: _sizes.identity,
                h: _sizes.identity,
                color: colors.background[colorMode],
                shader: {
                    strokeColor: colors.border[colorMode],
                    stroke: BORDER_WIDTH,
                    radius: BORDER_RADIUS
                }
            },
            Keys: {
                x: KEY_PADDING,
                y: KEY_PADDING
            }
        }
    };
};


/***/ }),

/***/ 22772:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "MosaicCard", ({
    enumerable: true,
    get: function() {
        return MosaicCard;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _sdk = __webpack_require__(29956);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _iconcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(70160));
var _mosaicCardstyle = __webpack_require__(79478);
var _signals = __webpack_require__(2109);
var _focusshader = /*#__PURE__*/ _interop_require_default._(__webpack_require__(25906));
var _textures = __webpack_require__(67179);
var MosaicCard = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(MosaicCard, _Lightning_Component);
    var _super = _create_super._(MosaicCard);
    function MosaicCard() {
        _class_call_check._(this, MosaicCard);
        return _super.apply(this, arguments);
    }
    _create_class._(MosaicCard, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _mosaicCardstyle.defaultContext;
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                this.tag("Icon").removeAllListeners("txLoaded");
            }
        },
        {
            key: "item",
            set: function set(value) {
                var _this = this;
                this._item = value;
                var imageUrl = (0, _get.default)(this._item, "image.src", "");
                this.tag("Icon").once("txLoaded", function() {
                    _this.tag("Icon").setSmooth("alpha", 1);
                });
                this.patch({
                    Image: {
                        texture: imageUrl && imageUrl.length ? (0, _textures.cover)(imageUrl, _mosaicCardstyle.MOSAIC_CARD_SIZE[this._style.screenSize].w, _mosaicCardstyle.MOSAIC_CARD_SIZE[this._style.screenSize].h) : null
                    },
                    Content: {
                        Label: {
                            text: {
                                text: value.label || ""
                            }
                        },
                        IconWrapper: {
                            Icon: {
                                alpha: 0.0001,
                                iconData: {
                                    picto: value.picto,
                                    viewBox: (0, _mosaicCardstyle.getIconViewBox)(this._style.screenSize)
                                }
                            }
                        }
                    }
                });
            }
        },
        {
            key: "_focus",
            value: function _focus() {
                this.patch((0, _mosaicCardstyle.getFocusedStyle)(this._style));
            }
        },
        {
            key: "_unfocus",
            value: function _unfocus() {
                this.patch(_mosaicCardstyle.unFocusedStyle);
            }
        },
        {
            key: "_handleEnter",
            value: function _handleEnter() {
                this.signal(_signals.SELECTED_SIGNAL, this._item);
                return true;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Border: {
                        rect: true,
                        shader: {
                            type: _focusshader.default
                        }
                    },
                    Background: {
                        rect: true,
                        shader: {
                            type: _sdk.Lightning.shaders.RoundedRectangle
                        }
                    },
                    Image: {
                        shader: {
                            type: _sdk.Lightning.shaders.RoundedRectangle
                        }
                    },
                    Content: {
                        IconWrapper: {
                            Icon: {
                                type: _iconcomponent.default
                            }
                        },
                        Label: {}
                    }
                }, (0, _mosaicCardstyle.getInitialStyle)());
            }
        }
    ]);
    return MosaicCard;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 79478:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BORDER_RADIUS: function() {
        return BORDER_RADIUS;
    },
    ICON_SIZES: function() {
        return ICON_SIZES;
    },
    MOSAIC_CARD_SIZE: function() {
        return MOSAIC_CARD_SIZE;
    },
    PADDING: function() {
        return PADDING;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getFocusedStyle: function() {
        return getFocusedStyle;
    },
    getIconViewBox: function() {
        return getIconViewBox;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    unFocusedStyle: function() {
        return unFocusedStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(52318);
var _memoize = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34736));
var _theme = __webpack_require__(51397);
var _constants = __webpack_require__(34952);
var _typography = __webpack_require__(18411);
var _sizes = __webpack_require__(82699);
var _style = __webpack_require__(65082);
var _focus = __webpack_require__(78506);
var _colors = __webpack_require__(8426);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var MOSAIC_CARD_SIZE = (_obj = {}, _define_property._(_obj, _constants.HD, {
    w: 199,
    h: 112
}), _define_property._(_obj, _constants.FULL_HD, {
    w: 300,
    h: 169
}), _obj);
var PADDING = 8;
var colors = {
    background: (0, _theme.makeThemeColor)(_theme.TERTIARY, 0.3),
    icon: (0, _theme.makeThemeColor)(_theme.PRIMARY),
    label: (0, _theme.makeThemeColor)(_theme.PRIMARY)
};
var _obj1;
var ICON_SIZES = (_obj1 = {}, _define_property._(_obj1, _constants.HD, Math.round(MOSAIC_CARD_SIZE[_constants.HD].h / 2)), _define_property._(_obj1, _constants.FULL_HD, Math.round(MOSAIC_CARD_SIZE[_constants.FULL_HD].h / 2)), _obj1);
var _obj2;
var BORDER_RADIUS = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 4), _define_property._(_obj2, _constants.FULL_HD, 4), _obj2);
var getIconViewBox = (0, _memoize.default)(function(screenSize) {
    return {
        h: ICON_SIZES[screenSize]
    };
});
var getInitialStyle = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext, screenSize = _ref.screenSize, colorMode = _ref.colorMode;
    var _MOSAIC_CARD_SIZE_screenSize = MOSAIC_CARD_SIZE[screenSize], w = _MOSAIC_CARD_SIZE_screenSize.w, h = _MOSAIC_CARD_SIZE_screenSize.h;
    var borderSize = _focus.BORDER_WIDTH[screenSize];
    var borderOffset = borderSize * 2;
    return {
        Border: {
            w: w + borderOffset,
            h: h + borderOffset,
            x: -borderSize,
            y: -borderSize,
            color: _colors.TRANSPARENT,
            shader: {
                radius: BORDER_RADIUS[screenSize],
                outline: _focus.BORDER_WIDTH[screenSize],
                strokeColor: _colors.TRANSPARENT,
                innerColor: _colors.TRANSPARENT
            }
        },
        Background: {
            w: w,
            h: h,
            shader: {
                fillColor: colors.background[colorMode],
                radius: BORDER_RADIUS[screenSize]
            }
        },
        Image: {
            w: w,
            h: h,
            shader: {
                radius: BORDER_RADIUS[screenSize]
            }
        },
        Content: {
            w: w,
            h: h,
            flex: {
                direction: "column",
                alignItems: "center",
                justifyContent: "center"
            },
            IconWrapper: {
                w: w,
                h: ICON_SIZES[screenSize],
                Icon: {
                    mountX: 0.5,
                    x: _sizes.middle,
                    color: colors.icon[colorMode]
                }
            },
            Label: {
                color: colors.label[colorMode],
                text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT.BERLIN_2, screenSize)), {
                    wordWrapWidth: w - PADDING * 2,
                    wordWrap: true,
                    wordBreak: true,
                    advancedRenderer: true,
                    textAlign: "center",
                    verticalAlign: "bottom",
                    maxLines: 2,
                    maxLinesSuffix: "..."
                })
            }
        }
    };
};
var getFocusedStyle = function(param) {
    var colorMode = param.colorMode;
    return {
        Border: {
            smooth: {
                scale: _focus.SCALE_FOCUSED,
                "shader.strokeColor": _focus.BORDER_COLOR[colorMode],
                "shader.innerColor": _focus.INNER_BORDER_COLOR[colorMode],
                "shader.scale": _focus.SCALE_FOCUSED
            }
        },
        Background: {
            smooth: {
                scale: _focus.SCALE_FOCUSED,
                "shader.scale": _focus.SCALE_FOCUSED
            }
        },
        Image: {
            smooth: {
                scale: _focus.SCALE_FOCUSED,
                "shader.scale": _focus.SCALE_FOCUSED
            }
        }
    };
};
var unFocusedStyle = {
    Border: {
        smooth: {
            scale: 1,
            "shader.strokeColor": _colors.TRANSPARENT,
            "shader.innerColor": _colors.TRANSPARENT,
            "shader.scale": 1.0
        }
    },
    Background: {
        smooth: {
            scale: 1,
            "shader.scale": 1.0
        }
    },
    Image: {
        smooth: {
            scale: 1,
            "shader.scale": 1.0
        }
    }
};


/***/ }),

/***/ 38943:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "MY_LIST_ICONS", ({
    enumerable: true,
    get: function() {
        return MY_LIST_ICONS;
    }
}));
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(45538);
var MY_LIST_ICONS = {
    MY_LIST_ICON_BOOKED: {
        name: "ListAdded",
        type: " icon"
    },
    MY_LIST_ICON_UNBOOKED: {
        name: "ListAdd",
        type: "icon"
    }
};


/***/ }),

/***/ 5805:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    MyListButtonPrimary: function() {
        return MyListButtonPrimary;
    },
    MyListButtonSecondary: function() {
        return MyListButtonSecondary;
    },
    WithBookmarkToggle: function() {
        return WithBookmarkToggle;
    }
});
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _create_super = __webpack_require__(6400);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(52318);
var _ctaconstants = /*#__PURE__*/ _interop_require_default._(__webpack_require__(77713));
var _myListCallToActionconstants = /*#__PURE__*/ _interop_require_default._(__webpack_require__(83949));
var _signals = __webpack_require__(2109);
var _callToActioncomponent = __webpack_require__(91743);
var _callToActioncomponent1 = __webpack_require__(28518);
var _myListCallToActionutils = __webpack_require__(50650);
var WithBookmarkToggle = function(base) {
    var BookmarkToggle = /*#__PURE__*/ function(base) {
        "use strict";
        _inherits._(BookmarkToggle, base);
        var _super = _create_super._(BookmarkToggle);
        function BookmarkToggle() {
            _class_call_check._(this, BookmarkToggle);
            return _super.apply(this, arguments);
        }
        _create_class._(BookmarkToggle, [
            {
                key: "isBookmarked",
                set: function set(value) {
                    this._isBookmarked = value;
                    this.picto = value ? _myListCallToActionconstants.default.MY_LIST_ICON_BOOKED : _myListCallToActionconstants.default.MY_LIST_ICON_UNBOOKED;
                    if (this._item) {
                        this._item.state = this._isBookmarked;
                        this._item.action = (0, _myListCallToActionutils.makeBookmarkAction)(this._item.id, this._isBookmarked ? _ctaconstants.default.UNBOOKMARK : _ctaconstants.default.BOOKMARK);
                    }
                }
            },
            {
                key: "item",
                set: function set(value) {
                    if (!value) {
                        return;
                    }
                    this._item = _object_spread._({}, value);
                    this.isBookmarked = this._item.state;
                }
            },
            {
                key: "blockIndex",
                set: function set(value) {
                    this._blockIndex = value;
                }
            },
            {
                key: "itemIndex",
                set: function set(value) {
                    this._itemIndex = value;
                }
            },
            {
                key: "_handleEnter",
                value: function _handleEnter() {
                    if (!this._item) {
                        return;
                    }
                    this.signal(_signals.SELECTED_SIGNAL, _object_spread_props._(_object_spread._({}, this._item), {
                        blockIndex: this._blockIndex,
                        itemIndex: this._itemIndex
                    }));
                }
            }
        ]);
        return BookmarkToggle;
    }(base);
    return BookmarkToggle;
};
var MyListButtonPrimary = WithBookmarkToggle(_callToActioncomponent.CallToAction);
var MyListButtonSecondary = WithBookmarkToggle(_callToActioncomponent1.CallToAction);


/***/ }),

/***/ 83949:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(37815);
var _myListCallToActionconstants = __webpack_require__(38943);
var _default = _myListCallToActionconstants.MY_LIST_ICONS;


/***/ }),

/***/ 50650:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/**
 * Creates layout system compatible action object for bookmark toggle
 *
 * @param {string} id Bookmark entity id
 * @param {('bookmark'|'unbookmark')} type
 * @returns {Object}
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "makeBookmarkAction", ({
    enumerable: true,
    get: function() {
        return makeBookmarkAction;
    }
}));
var _define_property = __webpack_require__(21228);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(37815);
var makeBookmarkAction = function(id, type) {
    return {
        target: _define_property._({}, "value_".concat(type), {
            id: id,
            type: type
        })
    };
};


/***/ }),

/***/ 197:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "NavigationArrow", ({
    enumerable: true,
    get: function() {
        return NavigationArrow;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(37815);
var _sdk = __webpack_require__(29956);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _icons = __webpack_require__(20360);
var _iconcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(70160));
var _navigationArrowstyle = __webpack_require__(8692);
var _navigationArrowconstants = __webpack_require__(61273);
var NavigationArrow = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(NavigationArrow, _Lightning_Component);
    var _super = _create_super._(NavigationArrow);
    function NavigationArrow() {
        _class_call_check._(this, NavigationArrow);
        return _super.apply(this, arguments);
    }
    _create_class._(NavigationArrow, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _navigationArrowstyle.defaultContext;
                this._disabled = false;
                this._focused = false;
            }
        },
        {
            key: "disabled",
            get: function get() {
                return this._disabled;
            },
            set: function set(value) {
                if (value === this._disabled) {
                    return;
                }
                this._disabled = value;
                if (this._disabled) {
                    this.patch((0, _navigationArrowstyle.getDisabledStyle)(this._style));
                } else if (this._focused) {
                    this.patch((0, _navigationArrowstyle.getFocusedStyle)(this._style));
                } else {
                    this.patch((0, _navigationArrowstyle.getUnFocusedStyle)(this._style));
                }
            }
        },
        {
            key: "variant",
            set: function set(value) {
                if (value !== _navigationArrowconstants.ARROW_LEFT && value !== _navigationArrowconstants.ARROW_RIGHT) {
                    return;
                }
                var size = Math.round(_navigationArrowstyle.SIZE[this._style.screenSize] / 2);
                this.tag("Icon").iconData = {
                    picto: {
                        name: value,
                        collection: _icons.ICON_COLLECTION.BASIC
                    },
                    viewBox: {
                        w: size,
                        h: size
                    }
                };
            }
        },
        {
            key: "_focus",
            value: function _focus() {
                if (this._disabled) {
                    this.patch((0, _navigationArrowstyle.getDisabledStyle)(this._style));
                    return;
                }
                this.patch((0, _navigationArrowstyle.getFocusedStyle)(this._style));
                this._focused = true;
            }
        },
        {
            key: "_unfocus",
            value: function _unfocus() {
                if (this._disabled) {
                    this.patch((0, _navigationArrowstyle.getDisabledStyle)(this._style));
                } else {
                    this.patch((0, _navigationArrowstyle.getUnFocusedStyle)(this._style));
                }
                this._focused = false;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Background: {
                        rect: true,
                        shader: {
                            type: _sdk.Lightning.shaders.RoundedRectangle
                        }
                    },
                    Icon: {
                        type: _iconcomponent.default
                    }
                }, (0, _navigationArrowstyle.getInitialStyle)());
            }
        }
    ]);
    return NavigationArrow;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 61273:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ARROW_LEFT: function() {
        return ARROW_LEFT;
    },
    ARROW_RIGHT: function() {
        return ARROW_RIGHT;
    }
});
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
var ARROW_LEFT = "ArrowLeft";
var ARROW_RIGHT = "ArrowRight";


/***/ }),

/***/ 8692:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BORDER_RADIUS: function() {
        return BORDER_RADIUS;
    },
    SIZE: function() {
        return SIZE;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getDisabledStyle: function() {
        return getDisabledStyle;
    },
    getFocusedStyle: function() {
        return getFocusedStyle;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    getUnFocusedStyle: function() {
        return getUnFocusedStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(45538);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _constants = __webpack_require__(34952);
var _theme = __webpack_require__(51397);
var _style = __webpack_require__(65082);
var _focus = __webpack_require__(78506);
var _sizes = __webpack_require__(82699);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var SIZE = (_obj = {}, _define_property._(_obj, _constants.HD, 56), _define_property._(_obj, _constants.FULL_HD, 64), _obj);
var _obj1;
var BORDER_RADIUS = (_obj1 = {}, _define_property._(_obj1, _constants.HD, SIZE[_constants.HD] / 2), _define_property._(_obj1, _constants.FULL_HD, SIZE[_constants.FULL_HD] / 2), _obj1);
var colors = {
    background: (0, _theme.makeThemeColor)(_theme.QUATERNARY, 0.3),
    icon: (0, _theme.makeThemeColor)(_theme.PRIMARY),
    backgroundFocused: (0, _theme.makeThemeColor)(_theme.QUATERNARY),
    iconFocused: (0, _theme.makeThemeColor)(_theme.TERTIARY),
    backgroundDisabled: (0, _theme.makeThemeColor)(_theme.QUATERNARY, 0.1),
    iconDisabled: (0, _theme.makeThemeColor)(_theme.PRIMARY, 0.1)
};
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var screenSize = context.screenSize, colorMode = context.colorMode;
    var size = SIZE[screenSize];
    return (0, _merge.default)({
        w: size,
        h: size,
        Background: {
            w: size,
            h: size,
            color: colors.background[colorMode],
            shader: {
                radius: BORDER_RADIUS[screenSize]
            }
        },
        Icon: {
            color: colors.icon[colorMode],
            mount: 0.5,
            x: _sizes.middle,
            y: _sizes.middle
        }
    });
};
var getFocusedStyle = function(param) {
    var colorMode = param.colorMode;
    return {
        Background: {
            smooth: {
                scale: _focus.SCALE_FOCUSED,
                color: colors.backgroundFocused[colorMode]
            }
        },
        Icon: {
            smooth: {
                scale: _focus.SCALE_FOCUSED,
                color: colors.iconFocused[colorMode]
            }
        }
    };
};
var getUnFocusedStyle = function(param) {
    var colorMode = param.colorMode;
    return {
        Background: {
            smooth: {
                scale: 1.0,
                color: colors.background[colorMode]
            }
        },
        Icon: {
            smooth: {
                scale: 1.0,
                color: colors.icon[colorMode]
            }
        }
    };
};
var getDisabledStyle = function(param) {
    var colorMode = param.colorMode;
    return {
        Background: {
            smooth: {
                scale: 1.0,
                color: colors.backgroundDisabled[colorMode]
            }
        },
        Icon: {
            smooth: {
                scale: 1.0,
                color: colors.iconDisabled[colorMode]
            }
        }
    };
};


/***/ }),

/***/ 93831:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    NOTIFICATION_LEVEL: function() {
        return NOTIFICATION_LEVEL;
    },
    makeNotification: function() {
        return makeNotification;
    }
});
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(45538);
var NOTIFICATION_LEVEL = {
    SYSTEM: "SYSTEM",
    SUCCESS: "SUCCESS",
    WARNING: "WARNING",
    ERROR: "ERROR"
};
var makeNotification = function(level, text, icon) {
    return {
        level: level,
        text: text,
        icon: icon
    };
};


/***/ }),

/***/ 50206:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "DesktopPairing", ({
    enumerable: true,
    get: function() {
        return DesktopPairing;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _get = __webpack_require__(60528);
var _get_prototype_of = __webpack_require__(35196);
var _inherits = __webpack_require__(71648);
var _object_spread = __webpack_require__(76247);
var _set = __webpack_require__(81364);
var _create_super = __webpack_require__(6400);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
var _sdk = __webpack_require__(29956);
var _desktopPairingstyle = __webpack_require__(81441);
var _pairingutils = __webpack_require__(41765);
var _signals = __webpack_require__(2109);
var DesktopPairing = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(DesktopPairing, _Lightning_Component);
    var _super = _create_super._(DesktopPairing);
    function DesktopPairing() {
        _class_call_check._(this, DesktopPairing);
        return _super.apply(this, arguments);
    }
    _create_class._(DesktopPairing, [
        {
            key: "_inactive",
            value: function _inactive() {
                this.tag("Code").removeAllListeners("txLoaded");
                this._token = null;
            }
        },
        {
            key: "labels",
            set: function set(value) {
                this.tag("Title").text.text = value.title;
                if (value.stepsCount && value.steps) {
                    (0, _pairingutils.displaySteps)((0, _pairingutils.getSteps)(this, 5), (0, _pairingutils.makeKeys)(value.steps, value.stepsCount));
                }
            }
        },
        {
            key: "steps",
            set: function set(value) {
                if (!value) {
                    return;
                }
                (0, _pairingutils.displaySteps)((0, _pairingutils.getSteps)(this, 5), value);
            }
        },
        {
            key: "button",
            set: function set(value) {
                this.tag("Button").patch({
                    label: value,
                    visible: Boolean(value)
                });
                this._refocus();
            }
        },
        {
            key: "w",
            get: function get() {
                return _get._(_get_prototype_of._(DesktopPairing.prototype), "w", this);
            },
            set: function set(value) {
                _set._(_get_prototype_of._(DesktopPairing.prototype), "w", value, this, true);
                // WARN: only static values are supported
                this.patch(_object_spread._({
                    Title: {
                        text: {
                            wordWrapWidth: value
                        }
                    }
                }, (0, _pairingutils.makePatch)(5, {
                    w: value
                })));
            }
        },
        {
            key: "token",
            set: function set(value) {
                if (value === this._token) {
                    return;
                }
                this.tag("Code").text.text = value ? value.split("").join("  ") : "";
            }
        },
        {
            key: "_handleEnter",
            value: function _handleEnter() {
                if (!this.tag("Button").visible) {
                    return false;
                }
                this.signal(_signals.SELECTED_SIGNAL);
                return true;
            }
        },
        {
            key: "_getFocused",
            value: function _getFocused() {
                var button = this.tag("Button");
                return button.visible ? button : undefined;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _desktopPairingstyle.getInitialStyle)();
            }
        }
    ]);
    return DesktopPairing;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 81441:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    STEPS_GAP: function() {
        return STEPS_GAP;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(42578);
var _theme = __webpack_require__(51397);
var _constants = __webpack_require__(34952);
var _typography = __webpack_require__(18411);
var _style = __webpack_require__(65082);
var _pairingStepstyle = __webpack_require__(99895);
var _pairingutils = __webpack_require__(41765);
var _buttoncomponent = __webpack_require__(31464);
var _sizes = __webpack_require__(82699);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var colors = {
    text: (0, _theme.makeThemeColor)(_theme.PRIMARY)
};
var _obj;
var STEPS_GAP = (_obj = {}, _define_property._(_obj, _constants.HD, 24), _define_property._(_obj, _constants.FULL_HD, 32), _obj);
var getInitialStyle = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext, _ref_screenSize = _ref.screenSize, screenSize = _ref_screenSize === void 0 ? _constants.FULL_HD : _ref_screenSize, _ref_colorMode = _ref.colorMode, colorMode = _ref_colorMode === void 0 ? _theme.DEFAULT_MODE : _ref_colorMode;
    var titleFont = (0, _typography.getFont)(_typography.FONT.PARIS_2, screenSize);
    var codeFont = (0, _typography.getFont)(_typography.FONT.TOKYO_4, screenSize);
    return _object_spread_props._(_object_spread._({
        flex: {
            direction: "column"
        },
        Title: {
            text: _object_spread_props._(_object_spread._({}, titleFont), {
                textColor: colors.text[colorMode],
                maxLines: 2,
                maxLinesSuffix: "...",
                verticalAlign: "middle"
            }),
            flexItem: {
                marginBottom: 24
            }
        }
    }, (0, _pairingutils.makeStepsTemplate)(5, {
        flexItem: {
            marginBottom: STEPS_GAP[screenSize]
        }
    })), {
        Code: {
            x: _pairingStepstyle.CIRCLE_SIZE[screenSize] + _pairingStepstyle.CIRCLE_MARGIN_RIGHT[screenSize],
            text: _object_spread._({}, codeFont)
        },
        Button: {
            flexItem: {
                marginTop: STEPS_GAP[screenSize]
            },
            visible: false,
            type: _buttoncomponent.Button,
            label: "",
            mountX: 0.5,
            x: _sizes.middle
        }
    });
};


/***/ }),

/***/ 15797:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "Feature", ({
    enumerable: true,
    get: function() {
        return Feature;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _get = __webpack_require__(60528);
var _get_prototype_of = __webpack_require__(35196);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _set = __webpack_require__(81364);
var _create_super = __webpack_require__(6400);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(65759);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _featurestyle = __webpack_require__(4050);
var _iconcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(70160));
var Feature = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(Feature, _Lightning_Component);
    var _super = _create_super._(Feature);
    function Feature() {
        _class_call_check._(this, Feature);
        return _super.apply(this, arguments);
    }
    _create_class._(Feature, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _featurestyle.defaultContext;
            }
        },
        {
            key: "title",
            set: function set(value) {
                this.tag("Text").text.text = value;
            }
        },
        {
            key: "w",
            get: function get() {
                return _get._(_get_prototype_of._(Feature.prototype), "w", this);
            },
            set: function set(value) {
                _set._(_get_prototype_of._(Feature.prototype), "w", value, this, true);
                var screenSize = this._style.screenSize;
                this.tag("Text").patch({
                    text: {
                        wordWrapWidth: value - _featurestyle.ICON_SIZE.WIDTH[screenSize] - _featurestyle.MARGIN[screenSize]
                    }
                });
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Icon: {
                        type: _iconcomponent.default
                    },
                    Text: {}
                }, (0, _featurestyle.getInitialStyle)());
            }
        }
    ]);
    return Feature;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 4050:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ICON_SIZE: function() {
        return ICON_SIZE;
    },
    MARGIN: function() {
        return MARGIN;
    },
    _defaultContext_screenSize: function() {
        return _defaultContext_screenSize;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    screenSize: function() {
        return screenSize;
    }
});
var _define_property = __webpack_require__(21228);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(42578);
var _theme = __webpack_require__(51397);
var _constants = __webpack_require__(34952);
var _icons = __webpack_require__(20360);
var _typography = __webpack_require__(18411);
var _sizes = __webpack_require__(82699);
var defaultContext = {
    screenSize: (0, _sizes.getScreenSize)(),
    colorMode: _theme.DEFAULT_MODE
};
var _defaultContext_screenSize = defaultContext.screenSize, screenSize = _defaultContext_screenSize === void 0 ? _constants.FULL_HD : _defaultContext_screenSize;
var colors = {
    text: (0, _theme.makeThemeColor)(_theme.PRIMARY),
    icon: (0, _theme.makeThemeColor)(_theme.UTILITY2)
};
var _obj, _obj1;
var ICON_SIZE = {
    WIDTH: (_obj = {}, _define_property._(_obj, _constants.HD, 16), _define_property._(_obj, _constants.FULL_HD, 24), _obj),
    HEIGHT: (_obj1 = {}, _define_property._(_obj1, _constants.HD, 16), _define_property._(_obj1, _constants.FULL_HD, 24), _obj1)
};
var _obj2;
var MARGIN = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 8), _define_property._(_obj2, _constants.FULL_HD, 12), _obj2);
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var _context_screenSize = context.screenSize, screenSize = _context_screenSize === void 0 ? _constants.FULL_HD : _context_screenSize, _context_colorMode = context.colorMode, colorMode = _context_colorMode === void 0 ? _theme.DEFAULT_MODE : _context_colorMode;
    var font = (0, _typography.getFont)(_typography.FONT.MADRID_1, screenSize);
    return {
        h: Math.max(ICON_SIZE.HEIGHT[screenSize], font.lineHeight),
        flex: {
            direction: "row"
        },
        Icon: {
            iconData: {
                picto: {
                    name: "Check",
                    collection: _icons.ICON_COLLECTION.BASIC
                },
                viewBox: {
                    w: ICON_SIZE.WIDTH[screenSize],
                    h: ICON_SIZE.HEIGHT[screenSize]
                }
            },
            color: colors.icon[colorMode]
        },
        Text: {
            text: _object_spread_props._(_object_spread._({}, font), {
                verticalAlign: "middle",
                textColor: colors.text[colorMode]
            }),
            flexItem: {
                marginLeft: MARGIN[screenSize]
            }
        }
    };
};


/***/ }),

/***/ 90838:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "MobilePairing", ({
    enumerable: true,
    get: function() {
        return MobilePairing;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _get = __webpack_require__(60528);
var _get_prototype_of = __webpack_require__(35196);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _set = __webpack_require__(81364);
var _create_super = __webpack_require__(6400);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(65759);
var _qrcode = /*#__PURE__*/ _interop_require_default._(__webpack_require__(20061));
var _sdk = __webpack_require__(29956);
var _icons = __webpack_require__(20360);
var _mobilePairingstyle = __webpack_require__(35626);
var _pairingutils = __webpack_require__(41765);
var _signals = __webpack_require__(2109);
var MobilePairing = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(MobilePairing, _Lightning_Component);
    var _super = _create_super._(MobilePairing);
    function MobilePairing() {
        _class_call_check._(this, MobilePairing);
        return _super.apply(this, arguments);
    }
    _create_class._(MobilePairing, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _mobilePairingstyle.defaultContext;
            }
        },
        {
            key: "_inactive",
            value: function _inactive() {
                this.tag("Code").removeAllListeners("txLoaded");
                this._token = null;
            }
        },
        {
            key: "labels",
            set: function set(value) {
                this.tag("Title").text.text = value.title;
                (0, _pairingutils.displaySteps)((0, _pairingutils.getSteps)(this, 5), (0, _pairingutils.makeKeys)(value.steps, value.stepsCount));
            }
        },
        {
            key: "button",
            set: function set(value) {
                this.tag("Button").patch({
                    label: value,
                    visible: Boolean(value)
                });
                this._refocus();
            }
        },
        {
            key: "w",
            get: function get() {
                return _get._(_get_prototype_of._(MobilePairing.prototype), "w", this);
            },
            set: function set(value) {
                _set._(_get_prototype_of._(MobilePairing.prototype), "w", value, this, true);
                var screenSize = this._style.screenSize;
                var stepsWidth = value - _mobilePairingstyle.CODE_SIZE[screenSize] - _mobilePairingstyle.STEPS_MARGIN_LEFT[screenSize];
                // WARN: only static values are supported
                this.patch({
                    Title: {
                        text: {
                            wordWrapWidth: value
                        }
                    },
                    Content: {
                        CodeContainer: {
                            w: value,
                            Steps: _object_spread._({
                                w: stepsWidth
                            }, (0, _pairingutils.makePatch)(5, {
                                w: stepsWidth
                            }))
                        }
                    }
                });
            }
        },
        {
            key: "url",
            set: function set(value) {
                var _this = this;
                if (value === this._token) {
                    return;
                }
                this._token = value;
                var code = this.tag("Code");
                code.alpha = 0.0001;
                if (!value) {
                    return;
                }
                code.once("txLoaded", function() {
                    code.setSmooth("alpha", 1);
                });
                // Using high-resolution QR codes triggers an issue on Magenta devices in FHD mode
                // possible solution: https://www.npmjs.com/package/qrcode-generator
                _qrcode.default.toDataURL(value, {
                    margin: 4,
                    width: _mobilePairingstyle.CODE_SIZE.HD
                }).then(function(dataUrl) {
                    var texture = (0, _icons.getSvgTexture)(dataUrl, _mobilePairingstyle.CODE_SIZE[_this._style.screenSize], _mobilePairingstyle.CODE_SIZE[_this._style.screenSize]);
                    code.texture = texture;
                });
            }
        },
        {
            key: "_handleEnter",
            value: function _handleEnter() {
                if (!this.tag("Button").visible) {
                    return false;
                }
                this.signal(_signals.SELECTED_SIGNAL);
                return true;
            }
        },
        {
            key: "_getFocused",
            value: function _getFocused() {
                var button = this.tag("Button");
                return button.visible ? button : undefined;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _mobilePairingstyle.getInitialStyle)();
            }
        }
    ]);
    return MobilePairing;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 35626:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    CODE_SIZE: function() {
        return CODE_SIZE;
    },
    STEPS_GAP: function() {
        return STEPS_GAP;
    },
    STEPS_MARGIN_LEFT: function() {
        return STEPS_MARGIN_LEFT;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(42578);
var _theme = __webpack_require__(51397);
var _constants = __webpack_require__(34952);
var _typography = __webpack_require__(18411);
var _style = __webpack_require__(65082);
var _pairingutils = __webpack_require__(41765);
var _buttoncomponent = __webpack_require__(31464);
var _sizes = __webpack_require__(82699);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var colors = {
    text: (0, _theme.makeThemeColor)(_theme.PRIMARY)
};
var _obj;
var CODE_SIZE = (_obj = {}, _define_property._(_obj, _constants.HD, 208), _define_property._(_obj, _constants.FULL_HD, 274), _obj);
var _obj1;
var STEPS_MARGIN_LEFT = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 32), _define_property._(_obj1, _constants.FULL_HD, 40), _obj1);
var _obj2;
var STEPS_GAP = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 24), _define_property._(_obj2, _constants.FULL_HD, 32), _obj2);
var getInitialStyle = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext, _ref_screenSize = _ref.screenSize, screenSize = _ref_screenSize === void 0 ? _constants.FULL_HD : _ref_screenSize, _ref_colorMode = _ref.colorMode, colorMode = _ref_colorMode === void 0 ? _theme.DEFAULT_MODE : _ref_colorMode;
    var titleFont = (0, _typography.getFont)(_typography.FONT.PARIS_2, screenSize);
    return {
        flex: {
            direction: "column"
        },
        Title: {
            text: _object_spread_props._(_object_spread._({}, titleFont), {
                textColor: colors.text[colorMode],
                maxLines: 2,
                maxLinesSuffix: "...",
                verticalAlign: "middle"
            }),
            flexItem: {
                marginBottom: 24
            }
        },
        Content: {
            flex: {
                direction: "column"
            },
            CodeContainer: {
                flex: {
                    direction: "row"
                },
                Code: {
                    w: CODE_SIZE[screenSize],
                    h: CODE_SIZE[screenSize]
                },
                Steps: _object_spread._({
                    flex: {
                        direction: "column"
                    },
                    flexItem: {
                        marginLeft: STEPS_MARGIN_LEFT[screenSize]
                    }
                }, (0, _pairingutils.makeStepsTemplate)(5, {
                    flexItem: {
                        marginBottom: STEPS_GAP[screenSize]
                    }
                }))
            },
            Button: {
                flexItem: {
                    marginTop: STEPS_GAP[screenSize]
                },
                visible: false,
                type: _buttoncomponent.Button,
                label: "",
                mountX: 0.5,
                x: _sizes.middle
            }
        }
    };
};


/***/ }),

/***/ 41765:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    displaySteps: function() {
        return displaySteps;
    },
    getSteps: function() {
        return getSteps;
    },
    makeKeys: function() {
        return makeKeys;
    },
    makePatch: function() {
        return makePatch;
    },
    makeStepsTemplate: function() {
        return makeStepsTemplate;
    },
    translate: function() {
        return translate;
    }
});
var _define_property = __webpack_require__(21228);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _to_consumable_array = __webpack_require__(30005);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(42578);
var _i18n = __webpack_require__(14910);
var _pairingStepcomponent = __webpack_require__(84751);
var makePatch = function(count, patch) {
    return _to_consumable_array._(Array(count)).map(function(_, i) {
        return i;
    }).reduce(function(result, current) {
        return _object_spread_props._(_object_spread._({}, result), _define_property._({}, "Step".concat(current), patch));
    }, {});
};
var makeStepsTemplate = function(count, style) {
    return makePatch(count, _object_spread._({
        type: _pairingStepcomponent.PairingStep,
        visible: false
    }, style));
};
var translate = function(key, data) {
    var result = (0, _i18n.t)(key, data);
    return result === key ? null : result;
};
var makeKeys = function(base, count) {
    var result = [];
    for(var i = 0; i < count; i += 1){
        result.push(translate("".concat(base).concat(i + 1)));
    }
    return result;
};
var displaySteps = function(steps, values) {
    var digit = 0;
    steps.forEach(function(view, index) {
        var text = values[index];
        view.title = text;
        view.digit = "0".concat(digit + 1);
        view.visible = Boolean(text);
        if (view.visible) {
            digit += 1;
        }
    });
};
var getSteps = function(view, count) {
    var base = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "Step";
    return _to_consumable_array._(Array(count)).map(function(_, index) {
        return view.tag("".concat(base).concat(index));
    }).filter(Boolean);
};


/***/ }),

/***/ 62531:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "PairingSelector", ({
    enumerable: true,
    get: function() {
        return PairingSelector;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _get = __webpack_require__(60528);
var _get_prototype_of = __webpack_require__(35196);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _set = __webpack_require__(81364);
var _create_super = __webpack_require__(6400);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(65759);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _signals = __webpack_require__(2109);
var _bigButtoncomponent = __webpack_require__(65167);
var _featurecomponent = __webpack_require__(15797);
var _pairingSelectorstyle = __webpack_require__(13106);
var PairingSelector = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(PairingSelector, _Lightning_Component);
    var _super = _create_super._(PairingSelector);
    function PairingSelector() {
        _class_call_check._(this, PairingSelector);
        return _super.apply(this, arguments);
    }
    _create_class._(PairingSelector, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _pairingSelectorstyle.defaultContext;
                this._focusedButton = 0;
            }
        },
        {
            key: "h",
            get: function get() {
                return _get._(_get_prototype_of._(PairingSelector.prototype), "h", this);
            },
            set: function set(value) {
                _set._(_get_prototype_of._(PairingSelector.prototype), "h", value, this, true);
                this.patch({
                    Static: {
                        h: value
                    },
                    Buttons: {
                        h: value
                    },
                    Separator: {
                        h: value
                    }
                });
            }
        },
        {
            key: "labels",
            set: function set(value) {
                this.patch({
                    Static: {
                        Title: {
                            text: {
                                text: value.title
                            }
                        }
                    }
                });
                for(var i = 0; i < 3; i += 1){
                    var text = value.features ? value.features[i] : "";
                    this.tag("Feature".concat(i)).patch({
                        title: text || "",
                        visible: Boolean(text)
                    });
                }
            }
        },
        {
            key: "buttons",
            set: function set(value) {
                var screenSize = this._style.screenSize;
                var w = _pairingSelectorstyle.WIDTH[screenSize] - _pairingSelectorstyle.SPACER[screenSize];
                var marginBottom = _pairingSelectorstyle.BUTTONS_GAP[this._style.screenSize];
                this.tag("Buttons").children = value.map(function(param, index) {
                    var label = param.label, iconLeft = param.iconLeft, iconRight = param.iconRight;
                    return {
                        type: _bigButtoncomponent.BigButton,
                        w: w,
                        ref: "Button".concat(index),
                        label: label,
                        pictoLeft: {
                            type: "icon",
                            name: iconLeft
                        },
                        pictoRight: {
                            type: "icon",
                            name: iconRight
                        },
                        flexItem: {
                            marginBottom: marginBottom
                        }
                    };
                });
                if (value.length) {
                    this.tag("Buttons").children[this._focusedButton].isSelected = true;
                }
            }
        },
        {
            key: "selectedButton",
            get: function get() {
                return this.tag("Buttons").children.findIndex(function(button) {
                    return button.isSelected;
                });
            },
            set: function set(value) {
                var _this = this;
                this._focusedButton = value;
                this.tag("Buttons").children.forEach(function(button, index) {
                    button.isSelected = index === _this._focusedButton;
                });
            }
        },
        {
            key: "_getFocused",
            value: function _getFocused() {
                return this.tag("Buttons").children[this._focusedButton];
            }
        },
        {
            key: "_handleUp",
            value: function _handleUp() {
                if (this._focusedButton > 0) {
                    this._focusedButton -= 1;
                    return true;
                }
                return false;
            }
        },
        {
            key: "_handleDown",
            value: function _handleDown() {
                if (this._focusedButton < this.tag("Buttons").children.length - 1) {
                    this._focusedButton += 1;
                    return true;
                }
                return false;
            }
        },
        {
            key: "_handleLeft",
            value: function _handleLeft() {
                return true;
            }
        },
        {
            key: "_handleEnter",
            value: function _handleEnter() {
                var _this = this;
                this.tag("Buttons").children.forEach(function(button, index) {
                    button.isSelected = index === _this._focusedButton;
                });
                this.signal(_signals.SELECTED_SIGNAL, this._focusedButton);
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Static: {
                        Title: {
                            text: {
                                text: ""
                            }
                        },
                        Feature0: {
                            type: _featurecomponent.Feature
                        },
                        Feature1: {
                            type: _featurecomponent.Feature
                        },
                        Feature2: {
                            type: _featurecomponent.Feature
                        }
                    },
                    Buttons: {},
                    Separator: {}
                }, (0, _pairingSelectorstyle.getInitialStyle)());
            }
        }
    ]);
    return PairingSelector;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 13106:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BUTTONS_GAP: function() {
        return BUTTONS_GAP;
    },
    SEPARATOR: function() {
        return SEPARATOR;
    },
    SPACER: function() {
        return SPACER;
    },
    STEPS_GAP: function() {
        return STEPS_GAP;
    },
    WIDTH: function() {
        return WIDTH;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    titleFont: function() {
        return titleFont;
    }
});
var _define_property = __webpack_require__(21228);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(42578);
var _theme = __webpack_require__(51397);
var _constants = __webpack_require__(34952);
var _typography = __webpack_require__(18411);
var _style = __webpack_require__(65082);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var titleFont = (0, _typography.getFont)(_typography.FONT.PARIS_3);
var colors = {
    separator: (0, _theme.makeThemeColor)(_theme.PRIMARY, 0.3)
};
var _obj;
var SPACER = (_obj = {}, _define_property._(_obj, _constants.HD, 32), _define_property._(_obj, _constants.FULL_HD, 40), _obj);
var _obj1;
var WIDTH = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 412 + SPACER[_constants.HD]), _define_property._(_obj1, _constants.FULL_HD, 588 + SPACER[_constants.FULL_HD]), _obj1);
var _obj2;
var SEPARATOR = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 2), _define_property._(_obj2, _constants.FULL_HD, 4), _obj2);
var _obj3;
var STEPS_GAP = (_obj3 = {}, _define_property._(_obj3, _constants.HD, 16), _define_property._(_obj3, _constants.FULL_HD, 24), _obj3);
var _obj4;
var BUTTONS_GAP = (_obj4 = {}, _define_property._(_obj4, _constants.HD, 16), _define_property._(_obj4, _constants.FULL_HD, 16), _obj4);
var getInitialStyle = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext, _ref_screenSize = _ref.screenSize, screenSize = _ref_screenSize === void 0 ? _constants.FULL_HD : _ref_screenSize, _ref_colorMode = _ref.colorMode, colorMode = _ref_colorMode === void 0 ? _theme.DEFAULT_MODE : _ref_colorMode;
    var leftWidth = WIDTH[screenSize] - SPACER[screenSize];
    return {
        w: WIDTH[screenSize],
        Static: {
            x: _constants.safetyMargins.horizontal[screenSize],
            w: leftWidth,
            flex: {
                direction: "column"
            },
            Title: {
                text: {
                    wordWrapWidth: leftWidth,
                    maxLines: 2
                },
                flexItem: {
                    marginBottom: STEPS_GAP[screenSize]
                }
            },
            Feature0: {
                w: leftWidth,
                flexItem: {
                    marginBottom: STEPS_GAP[screenSize]
                }
            },
            Feature1: {
                w: leftWidth,
                flexItem: {
                    marginBottom: STEPS_GAP[screenSize]
                }
            },
            Feature2: {
                w: leftWidth,
                flexItem: {
                    marginBottom: STEPS_GAP[screenSize]
                }
            }
        },
        Buttons: {
            x: _constants.safetyMargins.horizontal[screenSize],
            w: leftWidth,
            flex: {
                direction: "column",
                justifyContent: "flex-end",
                alignItems: "stretch"
            }
        },
        Separator: {
            rect: true,
            x: _constants.safetyMargins.horizontal[screenSize] + WIDTH[screenSize],
            w: SEPARATOR[screenSize],
            color: colors.separator[colorMode]
        }
    };
};


/***/ }),

/***/ 84751:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "PairingStep", ({
    enumerable: true,
    get: function() {
        return PairingStep;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _get = __webpack_require__(60528);
var _get_prototype_of = __webpack_require__(35196);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _set = __webpack_require__(81364);
var _create_super = __webpack_require__(6400);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(3009);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _pairingStepstyle = __webpack_require__(99895);
var PairingStep = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(PairingStep, _Lightning_Component);
    var _super = _create_super._(PairingStep);
    function PairingStep() {
        _class_call_check._(this, PairingStep);
        return _super.apply(this, arguments);
    }
    _create_class._(PairingStep, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _pairingStepstyle.defaultContext;
            }
        },
        {
            key: "_active",
            value: function _active() {
                var _this = this;
                var screenSize = this._style.screenSize;
                var circleSize = _pairingStepstyle.CIRCLE_SIZE[screenSize];
                var title = this.tag("Title");
                title.on("txLoaded", function() {
                    var textHeight = title.finalH;
                    _this.patch({
                        h: Math.max(textHeight, circleSize)
                    });
                });
            }
        },
        {
            key: "_inactive",
            value: function _inactive() {
                this.tag("Title").removeAllListeners("txLoaded");
            }
        },
        {
            key: "digit",
            get: function get() {
                return this.tag("Digit").text.text;
            },
            set: function set(value) {
                this.tag("Digit").text.text = value;
            }
        },
        {
            key: "title",
            get: function get() {
                return this.tag("Title").text.text;
            },
            set: function set(value) {
                this.tag("Title").text.text = value;
            }
        },
        {
            key: "w",
            get: function get() {
                return _get._(_get_prototype_of._(PairingStep.prototype), "w", this);
            },
            set: function set(value) {
                _set._(_get_prototype_of._(PairingStep.prototype), "w", value, this, true);
                var screenSize = this._style.screenSize;
                // WARN: only static values are supported
                this.patch({
                    Title: {
                        text: {
                            wordWrapWidth: value - _pairingStepstyle.CIRCLE_SIZE[screenSize] - _pairingStepstyle.CIRCLE_MARGIN_RIGHT[screenSize]
                        }
                    }
                });
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Circle: {
                        shader: {
                            type: _sdk.Lightning.shaders.RoundedRectangle
                        }
                    },
                    DigitContainer: {
                        Digit: {}
                    },
                    Title: {}
                }, (0, _pairingStepstyle.getInitialStyle)());
            }
        }
    ]);
    return PairingStep;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 99895:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    CIRCLE_MARGIN_RIGHT: function() {
        return CIRCLE_MARGIN_RIGHT;
    },
    CIRCLE_SIZE: function() {
        return CIRCLE_SIZE;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(3009);
var _theme = __webpack_require__(51397);
var _constants = __webpack_require__(34952);
var _typography = __webpack_require__(18411);
var _style = __webpack_require__(65082);
var _colors = __webpack_require__(8426);
var _sizes = __webpack_require__(82699);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var colors = {
    text: (0, _theme.makeThemeColor)(_theme.PRIMARY),
    circle: (0, _theme.makeThemeColor)(_theme.SECONDARY)
};
var _obj;
var CIRCLE_SIZE = (_obj = {}, _define_property._(_obj, _constants.HD, 48), _define_property._(_obj, _constants.FULL_HD, 56), _obj);
var _obj1;
var CIRCLE_MARGIN_RIGHT = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 24), _define_property._(_obj1, _constants.FULL_HD, 40), _obj1);
var getInitialStyle = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext, _ref_screenSize = _ref.screenSize, screenSize = _ref_screenSize === void 0 ? _constants.FULL_HD : _ref_screenSize, _ref_colorMode = _ref.colorMode, colorMode = _ref_colorMode === void 0 ? _theme.DEFAULT_MODE : _ref_colorMode;
    var numberFont = (0, _typography.getFont)(_typography.FONT.OTTAWA_3, screenSize);
    var textFont = (0, _typography.getFont)(_typography.FONT.OTTAWA_1, screenSize);
    var circleSize = CIRCLE_SIZE[screenSize];
    return {
        h: circleSize,
        Circle: {
            w: circleSize,
            h: circleSize,
            y: _sizes.middle,
            mountY: 0.5,
            rect: true,
            shader: {
                fillColor: _colors.TRANSPARENT,
                strokeColor: colors.circle[colorMode],
                stroke: 4,
                radius: Math.round(circleSize / 2)
            }
        },
        DigitContainer: {
            w: circleSize,
            h: circleSize,
            y: _sizes.middle,
            mountY: 0.5,
            Digit: {
                x: _sizes.middle,
                y: _sizes.middle,
                mount: 0.5,
                text: _object_spread_props._(_object_spread._({}, numberFont), {
                    textColor: colors.text[colorMode],
                    verticalAlign: "middle",
                    textAlign: "center"
                })
            }
        },
        Title: {
            x: circleSize + CIRCLE_MARGIN_RIGHT[screenSize],
            y: _sizes.middle,
            mountY: 0.5,
            text: _object_spread_props._(_object_spread._({}, textFont), {
                textColor: colors.text[colorMode],
                maxLines: 3,
                maxLinesSuffix: "...",
                verticalAlign: "middle"
            })
        }
    };
};


/***/ }),

/***/ 79704:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "PodcastDescription", ({
    enumerable: true,
    get: function() {
        return PodcastDescription;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _create_super = __webpack_require__(6400);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(52318);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _chunk = /*#__PURE__*/ _interop_require_default._(__webpack_require__(41255));
var _sdk = __webpack_require__(29956);
var _templates = __webpack_require__(88229);
var _podcastInformationEntrycomponent = __webpack_require__(16891);
var _podcastDescriptionstyle = __webpack_require__(43137);
var PodcastDescription = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(PodcastDescription, _Lightning_Component);
    var _super = _create_super._(PodcastDescription);
    function PodcastDescription() {
        _class_call_check._(this, PodcastDescription);
        return _super.apply(this, arguments);
    }
    _create_class._(PodcastDescription, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _podcastDescriptionstyle.defaultContext;
            }
        },
        {
            key: "_attach",
            value: function _attach() {
                var _this = this;
                this.onUpdate = function() {
                    if (_this._emittedHeight !== _this.finalH) {
                        _this._emittedHeight = _this.finalH;
                        _this.emit("txLoaded");
                    }
                };
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                this.onUpdate = undefined;
                this._emittedHeight = 0;
            }
        },
        {
            key: "data",
            set: function set(value) {
                var description = value.description;
                var _this__style = this._style, colorMode = _this__style.colorMode, screenSize = _this__style.screenSize;
                var w = this.w;
                var additionalMetadata = (value.additionalMetadata || []).filter(function(item) {
                    return Boolean(item.details);
                });
                var gap = _podcastDescriptionstyle.ENTRIES_GAP[screenSize];
                var columnWidth = Math.round(w / 2) - gap;
                var rows = (0, _chunk.default)(additionalMetadata, 2).map(function(chunk, index) {
                    return {
                        ref: "Row".concat(index),
                        flex: {
                            direction: "row"
                        },
                        flexItem: {
                            marginBottom: gap
                        },
                        w: w,
                        children: chunk.map(function(param) {
                            var title = param.title, details = param.details;
                            return {
                                type: _podcastInformationEntrycomponent.PodcastInformationEntry,
                                data: {
                                    title: title,
                                    details: details,
                                    w: columnWidth
                                },
                                w: columnWidth,
                                flexItem: {
                                    marginRight: gap
                                }
                            };
                        })
                    };
                });
                this.patch(_object_spread._({
                    Description: (0, _templates.makeTextPatch)(description, w, _podcastDescriptionstyle.colors.description[colorMode]),
                    Separator: {
                        w: w,
                        visible: Boolean(additionalMetadata.length)
                    }
                }, rows.reduce(function(result, item) {
                    return _object_spread_props._(_object_spread._({}, result), _define_property._({}, item.ref, item));
                }, {})));
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Description: {},
                    Separator: {}
                }, (0, _podcastDescriptionstyle.getInitialStyle)());
            }
        }
    ]);
    return PodcastDescription;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 43137:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ENTRIES_GAP: function() {
        return ENTRIES_GAP;
    },
    GAP: function() {
        return GAP;
    },
    SEPARATOR_HEIGHT: function() {
        return SEPARATOR_HEIGHT;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(37815);
var _constants = __webpack_require__(34952);
var _typography = __webpack_require__(18411);
var _theme = __webpack_require__(51397);
var _style = __webpack_require__(65082);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var GAP = (_obj = {}, _define_property._(_obj, _constants.HD, 24), _define_property._(_obj, _constants.FULL_HD, 40), _obj);
var _obj1;
var ENTRIES_GAP = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 24), _define_property._(_obj1, _constants.FULL_HD, 24), _obj1);
var _obj2;
var SEPARATOR_HEIGHT = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 2), _define_property._(_obj2, _constants.FULL_HD, 4), _obj2);
var colors = {
    description: (0, _theme.makeThemeColor)(_theme.PRIMARY),
    separator: (0, _theme.makeThemeColor)(_theme.PRIMARY, 0.3)
};
var getInitialStyle = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext, screenSize = _ref.screenSize, colorMode = _ref.colorMode;
    var descriptionFont = (0, _typography.getFont)(_typography.FONT.OTTAWA_1, screenSize);
    return {
        flex: {
            direction: "column"
        },
        Description: {
            flexItem: {
                marginBottom: GAP[screenSize]
            },
            text: _object_spread_props._(_object_spread._({}, descriptionFont), {
                maxLinesSuffix: "..."
            })
        },
        Separator: {
            flexItem: {
                marginBottom: GAP[screenSize]
            },
            rect: true,
            color: colors.separator[colorMode],
            h: SEPARATOR_HEIGHT[screenSize]
        }
    };
};


/***/ }),

/***/ 16891:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "PodcastInformationEntry", ({
    enumerable: true,
    get: function() {
        return PodcastInformationEntry;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(88801);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _podcastInformationEntrystyle = __webpack_require__(78993);
var PodcastInformationEntry = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(PodcastInformationEntry, _Lightning_Component);
    var _super = _create_super._(PodcastInformationEntry);
    function PodcastInformationEntry() {
        _class_call_check._(this, PodcastInformationEntry);
        return _super.apply(this, arguments);
    }
    _create_class._(PodcastInformationEntry, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _podcastInformationEntrystyle.defaultContext;
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                this.tag("Title").removeAllListeners("txLoaded");
                this.tag("Details").removeAllListeners("txLoaded");
            }
        },
        {
            key: "data",
            set: function set(content) {
                if (!content) {
                    return;
                }
                this.patch({
                    Title: {
                        visible: Boolean(content.title),
                        text: {
                            text: content.title,
                            wordWrapWidth: content.w
                        }
                    },
                    Details: {
                        visible: Boolean(content.details),
                        text: {
                            text: content.details,
                            wordWrapWidth: content.w
                        }
                    }
                });
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Title: {},
                    Details: {}
                }, (0, _podcastInformationEntrystyle.getInitialStyle)());
            }
        }
    ]);
    return PodcastInformationEntry;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 78993:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(3009);
var _theme = __webpack_require__(51397);
var _typography = __webpack_require__(18411);
var _style = __webpack_require__(65082);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var colors = {
    text: (0, _theme.makeThemeColor)(_theme.PRIMARY)
};
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var screenSize = context.screenSize, colorMode = context.colorMode;
    return {
        Title: {
            alpha: 0.8,
            color: colors.text[colorMode],
            text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT.BERLIN_1, screenSize)), {
                maxLinesSuffix: "...",
                maxLines: 1
            })
        },
        Details: {
            color: colors.text[colorMode],
            text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT.OTTAWA_1, screenSize)), {
                maxLinesSuffix: "...",
                maxLines: 3
            })
        },
        flex: {
            direction: "column"
        }
    };
};


/***/ }),

/***/ 49360:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "PodcastInformation", ({
    enumerable: true,
    get: function() {
        return PodcastInformation;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(88801);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _scrollcomponent = __webpack_require__(31418);
var _podcastInformationTopcomponent = __webpack_require__(21434);
var _podcastDescriptioncomponent = __webpack_require__(79704);
var _podcastInformationstyle = __webpack_require__(99024);
var _podcastInformationconstants = __webpack_require__(98050);
var PodcastInformation = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(PodcastInformation, _Lightning_Component);
    var _super = _create_super._(PodcastInformation);
    function PodcastInformation() {
        _class_call_check._(this, PodcastInformation);
        return _super.apply(this, arguments);
    }
    _create_class._(PodcastInformation, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _podcastInformationstyle.defaultContext;
            }
        },
        {
            key: "data",
            set: function set(content) {
                if (!content) {
                    return;
                }
                var top = this.tag("Top");
                var scroll = this.tag("Scroll");
                var screenSize = this._style.screenSize;
                var scrollableView = scroll.content;
                if (scrollableView) {
                    top.once("txLoaded", function() {
                        scroll.y = top.h;
                        scroll.h = (0, _podcastInformationstyle.getContainerHeight)(screenSize) - scroll.y;
                        scrollableView.data = content;
                    });
                }
                top.data = content;
            }
        },
        {
            key: "_getFocused",
            value: function _getFocused() {
                return this.tag("Scroll");
            }
        },
        {
            key: "_handleKey",
            value: function _handleKey() {
                return true;
            }
        },
        {
            key: "_handleBack",
            value: function _handleBack() {
                this.signal(_podcastInformationconstants.PROGRAM_INFORMATION_CLOSED_SIGNAL);
                return true;
            }
        },
        {
            key: "_handleEnter",
            value: function _handleEnter() {
                if (this.tag("ExitButton").visible) {
                    this.signal(_podcastInformationconstants.PROGRAM_INFORMATION_CLOSED_SIGNAL);
                }
                return true;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Overlay: {
                        rect: true
                    },
                    ContentContainer: {
                        Top: {
                            type: _podcastInformationTopcomponent.PodcastInformationTop
                        },
                        Scroll: {
                            type: _scrollcomponent.Scroll,
                            content: {
                                type: _podcastDescriptioncomponent.PodcastDescription,
                                w: _podcastInformationstyle.TEXT_WIDTH[_podcastInformationstyle.defaultContext.screenSize]
                            }
                        }
                    }
                }, (0, _podcastInformationstyle.getInitialStyle)());
            }
        }
    ]);
    return PodcastInformation;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 98050:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "PROGRAM_INFORMATION_CLOSED_SIGNAL", ({
    enumerable: true,
    get: function() {
        return PROGRAM_INFORMATION_CLOSED_SIGNAL;
    }
}));
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(3009);
var PROGRAM_INFORMATION_CLOSED_SIGNAL = "programInformationClosed";


/***/ }),

/***/ 99024:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    TEXT_WIDTH: function() {
        return TEXT_WIDTH;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getContainerHeight: function() {
        return getContainerHeight;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    getProgramInformationFocusedStyle: function() {
        return getProgramInformationFocusedStyle;
    },
    getProgramInformationUnFocusedStyle: function() {
        return getProgramInformationUnFocusedStyle;
    }
});
var _define_property = __webpack_require__(21228);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(45538);
var _constants = __webpack_require__(34952);
var _theme = __webpack_require__(51397);
var _sizes = __webpack_require__(82699);
var _style = __webpack_require__(65082);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var TEXT_WIDTH = (_obj = {}, _define_property._(_obj, _constants.HD, _sizes.SCREEN_WIDTH[_constants.HD] - _constants.safetyMargins.horizontal[_constants.HD] * 2), _define_property._(_obj, _constants.FULL_HD, _sizes.SCREEN_WIDTH[_constants.FULL_HD] - _constants.safetyMargins.horizontal[_constants.FULL_HD] * 2), _obj);
var colors = {
    background: (0, _theme.makeThemeColor)(_theme.TERTIARY)
};
var getContainerHeight = function(screenSize) {
    return _sizes.SCREEN_HEIGHT[screenSize] - _constants.safetyMargins.vertical[screenSize] * 2;
};
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var screenSize = context.screenSize, colorMode = context.colorMode;
    var containerHeight = getContainerHeight(screenSize);
    return {
        alpha: 0,
        w: _sizes.SCREEN_WIDTH[screenSize],
        h: _sizes.SCREEN_HEIGHT[screenSize],
        Overlay: {
            w: _sizes.SCREEN_WIDTH[screenSize],
            h: _sizes.SCREEN_HEIGHT[screenSize],
            color: colors.background[colorMode]
        },
        ContentContainer: {
            h: containerHeight,
            x: _constants.safetyMargins.horizontal[screenSize],
            y: _constants.safetyMargins.vertical[screenSize],
            Top: {},
            Scroll: {
                w: TEXT_WIDTH[screenSize],
                h: containerHeight,
                y: 0
            }
        }
    };
};
var getProgramInformationFocusedStyle = function() {
    return {
        smooth: {
            alpha: 1
        }
    };
};
var getProgramInformationUnFocusedStyle = function() {
    return {
        smooth: {
            alpha: 0
        }
    };
};


/***/ }),

/***/ 21434:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "PodcastInformationTop", ({
    enumerable: true,
    get: function() {
        return PodcastInformationTop;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(45538);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _textures = __webpack_require__(67179);
var _podcastInformationTopstyle = __webpack_require__(11944);
var PodcastInformationTop = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(PodcastInformationTop, _Lightning_Component);
    var _super = _create_super._(PodcastInformationTop);
    function PodcastInformationTop() {
        _class_call_check._(this, PodcastInformationTop);
        return _super.apply(this, arguments);
    }
    _create_class._(PodcastInformationTop, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _podcastInformationTopstyle.defaultContext;
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                this.tag("Title").removeAllListeners("txLoaded");
            }
        },
        {
            key: "data",
            set: function set(content) {
                var _this = this;
                if (!content) {
                    return;
                }
                var screenSize = this._style.screenSize;
                var logo = content.logo;
                var logoSrc = logo && logo.src || "";
                var height = _podcastInformationTopstyle.GAP[screenSize] + (logoSrc ? _podcastInformationTopstyle.LOGO_DIMENSIONS[screenSize].height : 0) + (content.title ? _podcastInformationTopstyle.GAP[screenSize] : 0);
                if (content.title) {
                    this.tag("Title").once("txLoaded", function(texture) {
                        _this.h = height + texture.source.h;
                        _this.emit("txLoaded");
                    });
                } else {
                    this.h = height;
                    this.emit("txLoaded");
                }
                this.patch({
                    Logo: {
                        visible: Boolean(logoSrc),
                        texture: (0, _textures.contain)(logoSrc, _podcastInformationTopstyle.LOGO_DIMENSIONS[screenSize].width, _podcastInformationTopstyle.LOGO_DIMENSIONS[screenSize].height)
                    },
                    Title: {
                        visible: Boolean(content.title),
                        text: {
                            text: content.title
                        }
                    }
                });
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Logo: {},
                    Title: {}
                }, (0, _podcastInformationTopstyle.getInitialStyle)());
            }
        }
    ]);
    return PodcastInformationTop;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 11944:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    GAP: function() {
        return GAP;
    },
    LOGO_DIMENSIONS: function() {
        return LOGO_DIMENSIONS;
    },
    TEXT_WIDTH: function() {
        return TEXT_WIDTH;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    getTitleFont: function() {
        return getTitleFont;
    }
});
var _define_property = __webpack_require__(21228);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(42578);
var _constants = __webpack_require__(34952);
var _theme = __webpack_require__(51397);
var _typography = __webpack_require__(18411);
var _sizes = __webpack_require__(82699);
var _style = __webpack_require__(65082);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var LOGO_DIMENSIONS = (_obj = {}, _define_property._(_obj, _constants.HD, {
    width: _sizes.SCREEN_WIDTH[_constants.HD] - _constants.safetyMargins.horizontal[_constants.HD] * 2,
    height: 150
}), _define_property._(_obj, _constants.FULL_HD, {
    width: _sizes.SCREEN_WIDTH[_constants.FULL_HD] - _constants.safetyMargins.horizontal[_constants.FULL_HD] * 2,
    height: 214
}), _obj);
var _obj1;
var TEXT_WIDTH = (_obj1 = {}, _define_property._(_obj1, _constants.HD, _sizes.SCREEN_WIDTH[_constants.HD] - _constants.safetyMargins.horizontal[_constants.HD] * 2), _define_property._(_obj1, _constants.FULL_HD, _sizes.SCREEN_WIDTH[_constants.FULL_HD] - _constants.safetyMargins.horizontal[_constants.FULL_HD] * 2), _obj1);
var _obj2;
var GAP = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 40), _define_property._(_obj2, _constants.FULL_HD, 40), _obj2);
var colors = {
    text: (0, _theme.makeThemeColor)(_theme.PRIMARY)
};
var getTitleFont = function(screenSize) {
    return (0, _typography.getFont)(_typography.FONT.PARIS_3, screenSize);
};
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var screenSize = context.screenSize, colorMode = context.colorMode;
    return {
        Logo: {
            flexItem: {
                marginBottom: GAP[screenSize]
            }
        },
        Title: {
            color: colors.text[colorMode],
            text: _object_spread_props._(_object_spread._({}, getTitleFont(screenSize)), {
                maxLinesSuffix: "...",
                wordWrapWidth: TEXT_WIDTH[screenSize],
                maxLines: 2
            })
        },
        flex: {
            direction: "column"
        }
    };
};


/***/ }),

/***/ 80510:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DISPLAY_PROGRESS: function() {
        return DISPLAY_PROGRESS;
    },
    DISPLAY_TEXT: function() {
        return DISPLAY_TEXT;
    },
    ICONS: function() {
        return ICONS;
    },
    ICONS_TYPES: function() {
        return ICONS_TYPES;
    },
    ITEMS_BY_BREAKPOINTS: function() {
        return ITEMS_BY_BREAKPOINTS;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(42578);
var _constants = __webpack_require__(34952);
var _iconcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(70160));
var _badgecomponent = __webpack_require__(69289);
var _templates = __webpack_require__(88229);
var _obj;
var ICONS = (_obj = {}, _define_property._(_obj, _templates.ICON_POSITION.TOP_RIGHT, 4), _define_property._(_obj, _templates.ICON_POSITION.BOTTOM_RIGHT, 1), _obj);
var _obj1;
var ICONS_TYPES = (_obj1 = {}, _define_property._(_obj1, _templates.ICON_POSITION.TOP_LEFT, _iconcomponent.default), _define_property._(_obj1, _templates.ICON_POSITION.TOP_RIGHT, _badgecomponent.Badge), _define_property._(_obj1, _templates.ICON_POSITION.BOTTOM_RIGHT, _iconcomponent.default), _obj1);
var DISPLAY_PROGRESS = true;
var DISPLAY_TEXT = true;
var _obj2;
var ITEMS_BY_BREAKPOINTS = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 8), _define_property._(_obj2, _constants.FULL_HD, 8), _obj2);


/***/ }),

/***/ 8289:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return Portrait;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _sdk = __webpack_require__(29956);
var _focusshader = /*#__PURE__*/ _interop_require_default._(__webpack_require__(25906));
var _imageshader = /*#__PURE__*/ _interop_require_default._(__webpack_require__(17154));
var _signals = __webpack_require__(2109);
var _templates = __webpack_require__(88229);
var _progressutils = __webpack_require__(40779);
var _incentivecomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(9077));
var _incentiveutils = __webpack_require__(72823);
var _incentiveconstants = __webpack_require__(37212);
var _portraitconstants = __webpack_require__(45338);
var _portraitstyle = __webpack_require__(9505);
var Portrait = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(Portrait, _Lightning_Component);
    var _super = _create_super._(Portrait);
    function Portrait() {
        _class_call_check._(this, Portrait);
        return _super.apply(this, arguments);
    }
    _create_class._(Portrait, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _portraitstyle.defaultContext;
            }
        },
        {
            key: "_inactive",
            value: function _inactive() {
                this.signal(_signals.INACTIVE_SIGNAL, this);
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                this._item = undefined;
                this.signal(_signals.DETACHED_SIGNAL, this);
            }
        },
        {
            key: "item",
            get: function get() {
                return this._item;
            },
            set: function set(param) {
                var content = param.content, config = param.config, template = param.template, colorScheme = param.colorScheme;
                var templateDataAccessPath = [
                    template,
                    this._style.screenSize
                ];
                var progress = _portraitconstants.DISPLAY_PROGRESS ? (0, _progressutils.getProgress)(content.progress) : 0;
                if ((0, _templates.areContentItemsEqual)(this._item, content)) {
                    this._item = content;
                    this.patch({
                        Image: {
                            shader: {
                                progress: progress
                            }
                        }
                    });
                    return;
                }
                this._item = content;
                this._config = config || (0, _get.default)(_portraitconstants.sizes, templateDataAccessPath, {});
                var h = this._config.h;
                var _this__item = this._item, pictos = _this__item.pictos, incentives = _this__item.incentives;
                var screenSize = this._style.screenSize;
                var extraTitle = _portraitconstants.DISPLAY_TEXT ? this._item.extraTitle : "";
                var imageUrl = (0, _get.default)(this._item, "image.src", "");
                var viewBox = (0, _portraitstyle.getIconViewBox)(screenSize);
                var incentiveLines = (0, _incentiveutils.getLinesCount)(this._item.incentives);
                if (colorScheme && colorScheme !== this._style.colorMode) {
                    this._style = {
                        screenSize: screenSize,
                        colorMode: colorScheme
                    };
                }
                this.patch({
                    Image: {
                        src: imageUrl,
                        shader: {
                            progress: progress
                        }
                    },
                    Text: {
                        y: h - (progress ? _portraitstyle.PROGRESS_HEIGHT : 0) - _portraitstyle.TEXT_MARGIN_BOTTOM,
                        text: {
                            text: extraTitle || ""
                        }
                    },
                    TopLeftIcon: {
                        iconData: {
                            picto: (0, _portraitstyle.getIcon)(pictos, _templates.ICON_POSITION.TOP_LEFT),
                            viewBox: viewBox
                        }
                    },
                    TopRightIcon: {
                        iconData: {
                            picto: (0, _portraitstyle.getIcon)(pictos, _templates.ICON_POSITION.TOP_RIGHT),
                            viewBox: viewBox
                        }
                    },
                    BottomRightIcon: {
                        iconData: {
                            picto: (0, _portraitstyle.getIcon)(pictos, _templates.ICON_POSITION.BOTTOM_RIGHT),
                            viewBox: viewBox
                        }
                    },
                    Incentive: {
                        visible: incentiveLines > 0,
                        data: {
                            w: this._config.w,
                            linesCount: incentiveLines,
                            incentives: incentives,
                            colorMode: this._style.colorMOde,
                            alignment: _incentiveconstants.ALIGNMENT_VERTICAL
                        }
                    }
                });
            }
        },
        {
            key: "_focus",
            value: function _focus() {
                this.patch((0, _portraitstyle.getFocusedStyle)(this._style));
            }
        },
        {
            key: "_unfocus",
            value: function _unfocus() {
                this.patch(_portraitstyle.unFocusedStyle);
            }
        },
        {
            key: "_handleEnter",
            value: function _handleEnter() {
                this.signal(_signals.SELECTED_SIGNAL, this._item);
                return true;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Border: {
                        rect: true,
                        shader: {
                            type: _focusshader.default
                        }
                    },
                    Image: {
                        shader: {
                            type: _imageshader.default
                        }
                    },
                    TopLeftIcon: {
                        type: _portraitconstants.ICONS_TYPES[_templates.ICON_POSITION.TOP_LEFT]
                    },
                    TopRightIcon: {
                        type: _portraitconstants.ICONS_TYPES[_templates.ICON_POSITION.TOP_RIGHT]
                    },
                    BottomRightIcon: {
                        type: _portraitconstants.ICONS_TYPES[_templates.ICON_POSITION.BOTTOM_RIGHT]
                    },
                    Incentive: {
                        type: _incentivecomponent.default
                    }
                }, (0, _portraitstyle.getInitialStyle)());
            }
        }
    ]);
    return Portrait;
}(_sdk.Lightning.Component);
Portrait.Templates = _portraitconstants.templates;
Portrait.Sizes = _portraitconstants.sizes;
Portrait.ImageOptions = _portraitconstants.imageOptions;


/***/ }),

/***/ 45338:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    imageOptions: function() {
        return imageOptions;
    },
    sizes: function() {
        return sizes;
    },
    templates: function() {
        return templates;
    }
});
var _export_star = __webpack_require__(37668);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
var _sizes = __webpack_require__(82699);
var _portraitconstants = _export_star._(__webpack_require__(80510), exports);
var templates = {
    Portrait: "Portrait"
};
var RATIO = 3 / 2;
var _getElementSize = (0, _sizes.getElementSize)(_portraitconstants.ITEMS_BY_BREAKPOINTS, RATIO, templates.Portrait), sizes = _getElementSize.sizes, imageOptions = _getElementSize.imageOptions;


/***/ }),

/***/ 9505:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ICON_HEIGHT: function() {
        return ICON_HEIGHT;
    },
    PADDING_HORIZONTAL: function() {
        return PADDING_HORIZONTAL;
    },
    PADDING_VERTICAL: function() {
        return PADDING_VERTICAL;
    },
    PROGRESS_HEIGHT: function() {
        return _progressstyle.HEIGHT;
    },
    TEXT_MARGIN_BOTTOM: function() {
        return TEXT_MARGIN_BOTTOM;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getFocusedStyle: function() {
        return getFocusedStyle;
    },
    getIcon: function() {
        return getIcon;
    },
    getIconViewBox: function() {
        return getIconViewBox;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    unFocusedStyle: function() {
        return unFocusedStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
var _constants = __webpack_require__(34952);
var _memoize = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34736));
var _theme = __webpack_require__(51397);
var _typography = __webpack_require__(18411);
var _progressstyle = __webpack_require__(67614);
var _style = __webpack_require__(65082);
var _colors = __webpack_require__(8426);
var _focus = __webpack_require__(78506);
var _portraitconstants = __webpack_require__(45338);
var _sizes = __webpack_require__(82699);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var ICON_HEIGHT = (_obj = {}, _define_property._(_obj, _constants.HD, 24), _define_property._(_obj, _constants.FULL_HD, 32), _obj);
var PADDING_VERTICAL = 4;
var PADDING_HORIZONTAL = 8;
var TEXT_MARGIN_BOTTOM = 8;
var colors = {
    text: (0, _theme.makeThemeColor)(_theme.PRIMARY),
    overlay: (0, _theme.makeThemeColor)(_theme.TERTIARY)
};
var getIconViewBox = (0, _memoize.default)(function(screenSize) {
    return {
        h: ICON_HEIGHT[screenSize]
    };
});
var getIcon = function(icons, position) {
    return icons ? icons[_portraitconstants.ICONS[position]] : null;
};
var getInitialStyle = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext, screenSize = _ref.screenSize, colorMode = _ref.colorMode;
    var _sizes_templates_Portrait_screenSize = _portraitconstants.sizes[_portraitconstants.templates.Portrait][screenSize], w = _sizes_templates_Portrait_screenSize.w, h = _sizes_templates_Portrait_screenSize.h;
    var borderSize = _focus.BORDER_WIDTH[screenSize];
    var borderOffset = borderSize * 2;
    return {
        w: w,
        h: h,
        Border: {
            w: w + borderOffset,
            h: h + borderOffset,
            x: -borderSize,
            y: -borderSize,
            color: _colors.TRANSPARENT,
            shader: {
                radius: _focus.BORDER_RADIUS[screenSize],
                outline: _focus.BORDER_WIDTH[screenSize],
                strokeColor: _colors.TRANSPARENT,
                innerColor: _colors.TRANSPARENT
            }
        },
        Image: {
            w: w,
            h: h,
            shader: {
                radius: _focus.BORDER_RADIUS[screenSize],
                progressHeight: _progressstyle.HEIGHT,
                progressBackgroundColor: _progressstyle.colors.background[colorMode],
                progressBarColor: _progressstyle.colors.bar[colorMode],
                overlayColor: colors.overlay[colorMode]
            }
        },
        Text: {
            x: Math.round(w / 2),
            y: h - _progressstyle.HEIGHT - TEXT_MARGIN_BOTTOM,
            mountX: 0.5,
            mountY: 1,
            color: colors.text[colorMode],
            text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT.BOSTON_1, screenSize)), {
                verticalAlign: "middle",
                wordWrapWidth: w - PADDING_HORIZONTAL * 2
            })
        },
        TopLeftIcon: {
            x: PADDING_HORIZONTAL,
            y: PADDING_VERTICAL
        },
        TopRightIcon: {
            alpha: 0.8,
            mountX: 1,
            x: w,
            y: PADDING_VERTICAL
        },
        BottomRightIcon: {
            mount: 1,
            x: w,
            y: h - _progressstyle.HEIGHT - PADDING_VERTICAL
        },
        Incentive: {
            x: _sizes.middle,
            y: _sizes.middle,
            mount: 0.5
        }
    };
};
var getFocusedStyle = (0, _memoize.default)(function(param) {
    var colorMode = param.colorMode;
    return {
        Border: {
            smooth: {
                scale: _focus.SCALE_FOCUSED,
                "shader.strokeColor": _focus.BORDER_COLOR[colorMode],
                "shader.innerColor": _focus.INNER_BORDER_COLOR[colorMode],
                "shader.scale": _focus.SCALE_FOCUSED
            }
        },
        Image: {
            smooth: {
                scale: _focus.SCALE_FOCUSED,
                "shader.scale": _focus.SCALE_FOCUSED
            }
        }
    };
}, _style.cacheResolver);
var unFocusedStyle = {
    Border: {
        smooth: {
            scale: 1,
            "shader.strokeColor": _colors.TRANSPARENT,
            "shader.innerColor": _colors.TRANSPARENT,
            "shader.scale": 1.0
        }
    },
    Image: {
        smooth: {
            scale: 1,
            "shader.scale": 1.0
        }
    }
};


/***/ }),

/***/ 32668:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BORDER_COLOR: function() {
        return BORDER_COLOR;
    },
    DISPLAY_DETAILS: function() {
        return DISPLAY_DETAILS;
    },
    DISPLAY_EXTRA_TITLE: function() {
        return DISPLAY_EXTRA_TITLE;
    },
    DISPLAY_ICONS: function() {
        return DISPLAY_ICONS;
    },
    DISPLAY_TITLE: function() {
        return DISPLAY_TITLE;
    },
    EXTRA_TITLE_FONT_NAME: function() {
        return EXTRA_TITLE_FONT_NAME;
    },
    HIGHLIGHT_COLOR: function() {
        return HIGHLIGHT_COLOR;
    },
    ICONS: function() {
        return ICONS;
    },
    ICONS_TYPES: function() {
        return ICONS_TYPES;
    },
    INNER_BORDER_COLOR: function() {
        return INNER_BORDER_COLOR;
    },
    ITEMS_BY_BREAKPOINTS: function() {
        return ITEMS_BY_BREAKPOINTS;
    },
    POSTER_OVERLAY: function() {
        return POSTER_OVERLAY;
    },
    TITLES_ORDER: function() {
        return TITLES_ORDER;
    },
    TITLE_FONT_NAME: function() {
        return TITLE_FONT_NAME;
    },
    TITLE_FONT_TYPE: function() {
        return TITLE_FONT_TYPE;
    },
    templates: function() {
        return templates;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
var _constants = __webpack_require__(34952);
var _typography = __webpack_require__(18411);
var _theme = __webpack_require__(51397);
var _templates = __webpack_require__(88229);
var _iconcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(70160));
var _badgecomponent = __webpack_require__(69289);
var TITLES_ORDER = [
    "ExtraTitle",
    "Title"
];
var TITLE_FONT_NAME = _typography.FONT.BERLIN_1;
var EXTRA_TITLE_FONT_NAME = _typography.FONT.OTTAWA_3;
var TITLE_FONT_TYPE = _typography.FONT_TYPE.MAIN;
var DISPLAY_ICONS = true;
var DISPLAY_TITLE = true;
var DISPLAY_EXTRA_TITLE = false;
var DISPLAY_DETAILS = false;
var BORDER_COLOR = (0, _theme.makeThemeColor)(_theme.PRIMARY);
var INNER_BORDER_COLOR = (0, _theme.makeThemeColor)(_theme.TERTIARY);
var POSTER_OVERLAY = (0, _theme.makeThemeColor)(_theme.TERTIARY);
var HIGHLIGHT_COLOR = (0, _theme.makeThemeColor)(_theme.QUATERNARY);
var _obj;
var ICONS = (_obj = {}, _define_property._(_obj, _templates.ICON_POSITION.TOP_LEFT, 2), _define_property._(_obj, _templates.ICON_POSITION.TOP_RIGHT, 4), _define_property._(_obj, _templates.ICON_POSITION.BOTTOM_RIGHT, 1), _obj);
var _obj1;
var ICONS_TYPES = (_obj1 = {}, _define_property._(_obj1, _templates.ICON_POSITION.TOP_LEFT, _iconcomponent.default), _define_property._(_obj1, _templates.ICON_POSITION.TOP_RIGHT, _badgecomponent.Badge), _define_property._(_obj1, _templates.ICON_POSITION.BOTTOM_RIGHT, _iconcomponent.default), _obj1);
var templates = {
    PosterS: "PosterS",
    PosterM: "PosterM",
    PosterL: "PosterL"
};
var _obj2, _obj3, _obj4, _obj5;
var ITEMS_BY_BREAKPOINTS = (_obj5 = {}, _define_property._(_obj5, templates.PosterS, (_obj2 = {}, _define_property._(_obj2, _constants.HD, 3), _define_property._(_obj2, _constants.FULL_HD, 5), _obj2)), _define_property._(_obj5, templates.PosterM, (_obj3 = {}, _define_property._(_obj3, _constants.HD, 2), _define_property._(_obj3, _constants.FULL_HD, 4), _obj3)), _define_property._(_obj5, templates.PosterL, (_obj4 = {}, _define_property._(_obj4, _constants.HD, 2), _define_property._(_obj4, _constants.FULL_HD, 3), _obj4)), _obj5);


/***/ }),

/***/ 3033:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "shouldDisplayTreatment", ({
    enumerable: true,
    get: function() {
        return shouldDisplayTreatment;
    }
}));
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(3009);
var shouldDisplayTreatment = function(item) {
    if (!item) {
        return false;
    }
    var title = item.title, extraTitle = item.extraTitle, details = item.details, highlight = item.highlight;
    return Boolean(title || extraTitle || details || highlight);
};


/***/ }),

/***/ 63205:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return Poster;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _sliced_to_array = __webpack_require__(28966);
var _create_super = __webpack_require__(6400);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(65759);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _sdk = __webpack_require__(29956);
var _progressutils = __webpack_require__(40779);
var _templates = __webpack_require__(88229);
var _colors = __webpack_require__(8426);
var _incentivecomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(9077));
var _incentiveutils = __webpack_require__(72823);
var _incentiveconstants = __webpack_require__(37212);
var _imageshader = /*#__PURE__*/ _interop_require_default._(__webpack_require__(17154));
var _focusshader = /*#__PURE__*/ _interop_require_default._(__webpack_require__(25906));
var _signals = __webpack_require__(2109);
var _posterutils = __webpack_require__(48743);
var _posterstyle = __webpack_require__(77254);
var _posterconstants = __webpack_require__(99246);
var Poster = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(Poster, _Lightning_Component);
    var _super = _create_super._(Poster);
    function Poster() {
        _class_call_check._(this, Poster);
        return _super.apply(this, arguments);
    }
    _create_class._(Poster, [
        {
            key: "_construct",
            value: function _construct() {
                this._index = 0;
                this._style = _object_spread._({}, _posterstyle.defaultContext);
            }
        },
        {
            key: "_inactive",
            value: function _inactive() {
                this.signal(_signals.INACTIVE_SIGNAL, this);
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                this._item = undefined;
                this.signal(_signals.DETACHED_SIGNAL, this);
            }
        },
        {
            key: "index",
            get: function get() {
                return this._index;
            },
            set: function set(value) {
                this._index = value;
            }
        },
        {
            key: "item",
            get: function get() {
                return this._item;
            },
            set: function set(param) {
                var content = param.content, config = param.config, template = param.template, _param_colorScheme = param.colorScheme, colorScheme = _param_colorScheme === void 0 ? this._style.colorMode : _param_colorScheme;
                var templateDataAccessPath = [
                    template,
                    this._style.screenSize
                ];
                var progress = (0, _progressutils.getProgress)(content.progress);
                if ((0, _templates.areContentItemsEqual)(this._item, content)) {
                    this._item = content;
                    this.patch({
                        Image: {
                            shader: {
                                progress: progress
                            }
                        }
                    });
                    return;
                }
                this._item = content;
                this._config = config || (0, _get.default)(_posterconstants.sizes, templateDataAccessPath, {});
                if (colorScheme && colorScheme !== this._style.colorMode) {
                    this._style = {
                        screenSize: this._style.screenSize,
                        colorMode: colorScheme
                    };
                }
                var screenSize = this._style.screenSize;
                var _this__item = this._item, title = _this__item.title, extraTitle = _this__item.extraTitle, highlight = _this__item.highlight, pictos = _this__item.pictos, incentives = _this__item.incentives;
                var topLeftIcon = (0, _posterstyle.getIcon)(pictos, _templates.ICON_POSITION.TOP_LEFT);
                var topRightIcon = (0, _posterstyle.getIcon)(pictos, _templates.ICON_POSITION.TOP_RIGHT);
                var bottomRightIcon = (0, _posterstyle.getIcon)(pictos, _templates.ICON_POSITION.BOTTOM_RIGHT);
                var details = _posterconstants.DISPLAY_DETAILS ? this._item.details : "";
                var wordWrapWidth = this._config.w - _posterstyle.PADDING_LEFT[screenSize] - (bottomRightIcon ? _posterstyle.ICON_HEIGHT[screenSize] + _posterstyle.ICON_PADDING_HORIZONTAL * 2 : _posterstyle.PADDING_LEFT[screenSize]);
                var wordWrapWidthFlexible = details ? Math.round(wordWrapWidth / 2) : wordWrapWidth;
                var imageUrl = (0, _get.default)(this._item, "image.src", "");
                var textColor = _posterstyle.colors.text[colorScheme];
                var borderOffset = _posterstyle.IMAGE_OFFSET[screenSize];
                var incentiveLines = (0, _incentiveutils.getLinesCount)(this._item.incentives);
                this.patch({
                    Border: {
                        w: this._config.w + borderOffset,
                        h: this._config.h + borderOffset
                    },
                    Image: {
                        w: this._config.w,
                        h: this._config.h,
                        src: imageUrl,
                        shader: {
                            progress: progress,
                            overlayColor: (0, _posterutils.shouldDisplayTreatment)(this._item) ? _posterconstants.POSTER_OVERLAY[this._style.colorMode] : _colors.TRANSPARENT
                        }
                    },
                    ExtraTitle: (0, _templates.makeTextPatch)(_posterconstants.DISPLAY_EXTRA_TITLE ? extraTitle : "", wordWrapWidth, textColor),
                    Title: (0, _templates.makeTextPatch)(_posterconstants.DISPLAY_TITLE ? title : "", wordWrapWidth, textColor),
                    Details: (0, _templates.makeTextPatch)(details, wordWrapWidthFlexible, _posterstyle.colors.details[colorScheme]),
                    Highlights: (0, _templates.makeTextPatch)(highlight, wordWrapWidthFlexible, _posterstyle.colors.highlight[colorScheme]),
                    TopLeftIcon: {
                        visible: _posterconstants.DISPLAY_ICONS && topLeftIcon,
                        iconData: {
                            picto: topLeftIcon,
                            viewBox: (0, _posterstyle.getIconViewBox)(this._style.screenSize)
                        }
                    },
                    TopRightIcon: {
                        visible: _posterconstants.DISPLAY_ICONS && topRightIcon,
                        iconData: {
                            picto: topRightIcon,
                            viewBox: (0, _posterstyle.getIconViewBox)(this._style.screenSize)
                        }
                    },
                    BottomRightIcon: {
                        visible: _posterconstants.DISPLAY_ICONS && bottomRightIcon,
                        iconData: {
                            picto: bottomRightIcon,
                            viewBox: (0, _posterstyle.getIconViewBox)(this._style.screenSize)
                        }
                    },
                    Incentive: {
                        visible: incentiveLines > 0,
                        data: {
                            w: this._config.w,
                            linesCount: incentiveLines,
                            incentives: incentives,
                            colorMode: this._style.colorMOde,
                            alignment: _incentiveconstants.ALIGNMENT_VERTICAL
                        }
                    }
                });
                this._updateMetadataPosition();
            }
        },
        {
            key: "_updateMetadataPosition",
            value: function _updateMetadataPosition() {
                // NOTE: we are using manual calculation instead of the "flex" layout in order to speed up tile creation
                var paddingBottom = _posterstyle.PADDING_BOTTOM[this._style.screenSize];
                var paddingLeft = _posterstyle.PADDING_LEFT[this._style.screenSize];
                var offset = this._config.h - paddingBottom;
                var _TITLES_ORDER = _sliced_to_array._(_posterconstants.TITLES_ORDER, 2), firstLineTag = _TITLES_ORDER[0], secondLineTag = _TITLES_ORDER[1];
                var firstLine = this.tag(firstLineTag);
                var secondLine = this.tag(secondLineTag);
                var details = this.tag("Details");
                var highlights = this.tag("Highlights");
                var bottomRightIcon = this.tag("BottomRightIcon");
                if (details.visible || highlights.visible) {
                    offset -= details.text.lineHeight;
                    details.patch((0, _posterstyle.getDetailsPosition)(this._style.screenSize, highlights.visible, Boolean(bottomRightIcon.name)));
                    details.y = offset;
                    highlights.x = paddingLeft;
                    highlights.y = offset;
                }
                if (secondLine.visible) {
                    offset -= secondLine.text.lineHeight;
                    secondLine.x = paddingLeft;
                    secondLine.y = offset;
                }
                if (firstLine.visible) {
                    offset -= firstLine.text.lineHeight;
                    firstLine.x = paddingLeft;
                    firstLine.y = offset;
                }
            }
        },
        {
            key: "_focus",
            value: function _focus() {
                this.patch((0, _posterstyle.getFocusedStyle)(this._style));
            }
        },
        {
            key: "_unfocus",
            value: function _unfocus() {
                this.patch(_posterstyle.unFocusedStyle);
            }
        },
        {
            key: "_handleEnter",
            value: function _handleEnter() {
                this.signal(_signals.SELECTED_SIGNAL, this._item);
                return true;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Border: {
                        rect: true,
                        shader: {
                            type: _focusshader.default
                        }
                    },
                    Image: {
                        shader: {
                            type: _imageshader.default
                        }
                    },
                    TopLeftIcon: {
                        type: _posterconstants.ICONS_TYPES[_templates.ICON_POSITION.TOP_LEFT]
                    },
                    TopRightIcon: {
                        type: _posterconstants.ICONS_TYPES[_templates.ICON_POSITION.TOP_RIGHT]
                    },
                    BottomRightIcon: {
                        type: _posterconstants.ICONS_TYPES[_templates.ICON_POSITION.BOTTOM_RIGHT]
                    },
                    ExtraTitle: {},
                    Title: {},
                    Details: {},
                    Highlights: {},
                    Incentive: {
                        type: _incentivecomponent.default
                    }
                }, (0, _posterstyle.getInitialStyle)());
            }
        }
    ]);
    return Poster;
}(_sdk.Lightning.Component);
Poster.Templates = _posterconstants.templates;
Poster.Sizes = _posterconstants.sizes;
Poster.ImageOptions = _posterconstants.imageOptions;


/***/ }),

/***/ 99246:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    imageOptions: function() {
        return imageOptions;
    },
    sizes: function() {
        return sizes;
    }
});
var _export_star = __webpack_require__(37668);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(52318);
var _sizes = __webpack_require__(82699);
var _posterconstants = _export_star._(__webpack_require__(32668), exports);
var RATIO = 9 / 16;
var _reduce = [
    _posterconstants.templates.PosterS,
    _posterconstants.templates.PosterM,
    _posterconstants.templates.PosterL
].reduce(function(acc, template) {
    var _getElementSize = (0, _sizes.getElementSize)(_posterconstants.ITEMS_BY_BREAKPOINTS[template], RATIO, template), templateSizes = _getElementSize.sizes, templateImageOptions = _getElementSize.imageOptions;
    acc.sizes[template] = templateSizes[template];
    acc.imageOptions[template] = templateImageOptions[template];
    return acc;
}, {
    sizes: {},
    imageOptions: {}
}), sizes = _reduce.sizes, imageOptions = _reduce.imageOptions;


/***/ }),

/***/ 77254:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ICON_HEIGHT: function() {
        return ICON_HEIGHT;
    },
    ICON_PADDING_HORIZONTAL: function() {
        return ICON_PADDING_HORIZONTAL;
    },
    ICON_PADDING_VERTICAL: function() {
        return ICON_PADDING_VERTICAL;
    },
    IMAGE_OFFSET: function() {
        return IMAGE_OFFSET;
    },
    PADDING_BOTTOM: function() {
        return PADDING_BOTTOM;
    },
    PADDING_LEFT: function() {
        return PADDING_LEFT;
    },
    PADDING_RIGHT: function() {
        return PADDING_RIGHT;
    },
    PADDING_TOP: function() {
        return PADDING_TOP;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getDetailsPosition: function() {
        return getDetailsPosition;
    },
    getFocusedStyle: function() {
        return getFocusedStyle;
    },
    getIcon: function() {
        return getIcon;
    },
    getIconViewBox: function() {
        return getIconViewBox;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    unFocusedStyle: function() {
        return unFocusedStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(42578);
var _memoize = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34736));
var _typography = __webpack_require__(18411);
var _constants = __webpack_require__(34952);
var _theme = __webpack_require__(51397);
var _progressstyle = __webpack_require__(67614);
var _style = __webpack_require__(65082);
var _focus = __webpack_require__(78506);
var _colors = __webpack_require__(8426);
var _sizes = __webpack_require__(82699);
var _posterconstants = __webpack_require__(99246);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var PADDING_TOP = (_obj = {}, _define_property._(_obj, _constants.HD, 4), _define_property._(_obj, _constants.FULL_HD, 4), _obj);
var _obj1;
var PADDING_RIGHT = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 12), _define_property._(_obj1, _constants.FULL_HD, 16), _obj1);
var _obj2;
var PADDING_LEFT = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 12), _define_property._(_obj2, _constants.FULL_HD, 16), _obj2);
var _obj3;
var PADDING_BOTTOM = (_obj3 = {}, _define_property._(_obj3, _constants.HD, 8), _define_property._(_obj3, _constants.FULL_HD, 12), _obj3);
var ICON_PADDING_VERTICAL = 4;
var ICON_PADDING_HORIZONTAL = 8;
var _obj4;
var ICON_HEIGHT = (_obj4 = {}, _define_property._(_obj4, _constants.HD, 24), _define_property._(_obj4, _constants.FULL_HD, 32), _obj4);
var _obj5;
var IMAGE_OFFSET = (_obj5 = {}, _define_property._(_obj5, _constants.HD, _focus.BORDER_WIDTH[_constants.HD] * 2), _define_property._(_obj5, _constants.FULL_HD, _focus.BORDER_WIDTH[_constants.FULL_HD] * 2), _obj5);
var getDetailsPosition = (0, _memoize.default)(function(screenSize) {
    var hasHighlightText = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, hasCsa = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    return hasHighlightText ? {
        mountX: 1,
        x: function(x) {
            return x - PADDING_RIGHT[screenSize] - (hasCsa ? ICON_HEIGHT[screenSize] + ICON_PADDING_HORIZONTAL : 0);
        }
    } : {
        mountX: 0,
        x: PADDING_LEFT[screenSize]
    };
}, function(screenSize, hasHighlightText, hasCsa) {
    return "".concat(screenSize, "_").concat(hasHighlightText, "_").concat(hasCsa);
});
var getIcon = function(icons, position) {
    return icons ? icons[_posterconstants.ICONS[position]] : null;
};
var colors = {
    border: _posterconstants.BORDER_COLOR,
    innerBorder: _posterconstants.INNER_BORDER_COLOR,
    text: (0, _theme.makeThemeColor)(_theme.PRIMARY),
    details: (0, _theme.makeThemeColor)(_theme.PRIMARY, 0.6),
    highlight: _posterconstants.HIGHLIGHT_COLOR
};
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var screenSize = context.screenSize, colorMode = context.colorMode;
    var titleFont = (0, _typography.getFont)(_posterconstants.TITLE_FONT_NAME, screenSize, _posterconstants.TITLE_FONT_TYPE);
    var extraTitleFont = (0, _typography.getFont)(_posterconstants.EXTRA_TITLE_FONT_NAME, screenSize);
    var commonFont = (0, _typography.getFont)(_typography.FONT.BERLIN_1, screenSize);
    var commonTextStyle = {
        verticalAlign: "middle",
        maxLines: 1,
        textOverflow: "ellipsis",
        maxLinesSuffix: "...",
        wordWrap: false
    };
    return {
        zIndex: _style.UNFOCUSED_Z_INDEX,
        Border: {
            x: -_focus.BORDER_WIDTH[screenSize],
            y: -_focus.BORDER_WIDTH[screenSize],
            color: _colors.TRANSPARENT,
            shader: {
                radius: _focus.BORDER_RADIUS[screenSize],
                outline: _focus.BORDER_WIDTH[screenSize],
                strokeColor: _colors.TRANSPARENT,
                innerColor: _colors.TRANSPARENT
            }
        },
        Image: {
            shader: {
                radius: _focus.BORDER_RADIUS[screenSize],
                progressHeight: _progressstyle.HEIGHT,
                progressBackgroundColor: _progressstyle.colors.background[colorMode],
                progressBarColor: _progressstyle.colors.bar[colorMode],
                overlayColor: _posterconstants.POSTER_OVERLAY[colorMode]
            }
        },
        ExtraTitle: {
            text: _object_spread._({}, extraTitleFont, commonTextStyle),
            color: colors.text[colorMode]
        },
        Title: {
            text: _object_spread._({}, titleFont, commonTextStyle),
            color: colors.text[colorMode]
        },
        Details: _object_spread_props._(_object_spread._({}, getDetailsPosition(screenSize)), {
            text: _object_spread._({}, commonFont, commonTextStyle),
            alpha: 0.6,
            color: colors.details[colorMode]
        }),
        Highlights: {
            text: _object_spread._({}, commonFont, commonTextStyle),
            alpha: 0.6,
            color: colors.highlight[colorMode]
        },
        TopLeftIcon: {
            visible: _posterconstants.DISPLAY_ICONS,
            x: ICON_PADDING_HORIZONTAL,
            y: ICON_PADDING_VERTICAL
        },
        TopRightIcon: {
            visible: _posterconstants.DISPLAY_ICONS,
            mountX: 1,
            x: function(w) {
                return w - ICON_PADDING_HORIZONTAL;
            },
            y: ICON_PADDING_VERTICAL
        },
        BottomRightIcon: {
            visible: _posterconstants.DISPLAY_ICONS,
            mountX: 1,
            x: function(w) {
                return w - ICON_PADDING_HORIZONTAL;
            },
            y: function(h) {
                return h - PADDING_BOTTOM[screenSize] - ICON_HEIGHT[screenSize];
            },
            alpha: 0.8
        },
        Incentive: {
            x: _sizes.middle,
            y: _sizes.middle,
            mount: 0.5
        }
    };
};
var getIconViewBox = (0, _memoize.default)(function(screenSize) {
    return {
        h: ICON_HEIGHT[screenSize]
    };
});
var getFocusedStyle = (0, _memoize.default)(function(param) {
    var colorMode = param.colorMode;
    return {
        zIndex: _style.FOCUSED_Z_INDEX,
        Border: {
            smooth: {
                scale: _focus.SCALE_FOCUSED,
                "shader.strokeColor": colors.border[colorMode],
                "shader.innerColor": colors.innerBorder[colorMode],
                "shader.scale": _focus.SCALE_FOCUSED
            }
        },
        Image: {
            smooth: {
                scale: _focus.SCALE_FOCUSED,
                "shader.scale": _focus.SCALE_FOCUSED
            }
        }
    };
}, _style.cacheResolver);
var unFocusedStyle = {
    zIndex: _style.UNFOCUSED_Z_INDEX,
    Border: {
        smooth: {
            scale: 1,
            "shader.strokeColor": _colors.TRANSPARENT,
            "shader.innerColor": _colors.TRANSPARENT,
            "shader.scale": 1.0
        }
    },
    Image: {
        smooth: {
            scale: 1,
            "shader.scale": 1.0
        }
    }
};


/***/ }),

/***/ 48743:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _export_star = __webpack_require__(37668);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(37815);
_export_star._(__webpack_require__(3033), exports);


/***/ }),

/***/ 68091:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "ProgramDescription", ({
    enumerable: true,
    get: function() {
        return ProgramDescription;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(88801);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _templates = __webpack_require__(88229);
var _contentAdvisorycomponent = __webpack_require__(23341);
var _programDescriptionstyle = __webpack_require__(87993);
var ProgramDescription = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(ProgramDescription, _Lightning_Component);
    var _super = _create_super._(ProgramDescription);
    function ProgramDescription() {
        _class_call_check._(this, ProgramDescription);
        return _super.apply(this, arguments);
    }
    _create_class._(ProgramDescription, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _programDescriptionstyle.defaultContext;
            }
        },
        {
            key: "_attach",
            value: function _attach() {
                var _this = this;
                [
                    this.tag("Description"),
                    this.tag("Details")
                ].forEach(function(child) {
                    child.onUpdate = function() {
                        if (_this._emittedHeight !== _this.finalH) {
                            _this._emittedHeight = _this.finalH;
                            _this.emit("txLoaded");
                        }
                    };
                });
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                this.tag("Description").onUpdate = undefined;
                this.tag("Details").onUpdate = undefined;
                this._emittedHeight = 0;
            }
        },
        {
            key: "data",
            set: function set(value) {
                var description = value.description, details = value.details, highlight = value.highlight, extraHighlight = value.extraHighlight, contentAdvisory = value.contentAdvisory;
                var colorMode = this._style.colorMode;
                var icons = (contentAdvisory ? contentAdvisory.pictos : []).filter(Boolean);
                this.patch({
                    Highlight: (0, _templates.makeTextPatch)(highlight, this.w, _programDescriptionstyle.colors.highlight[colorMode]),
                    ContentAdvisory: {
                        visible: Boolean(extraHighlight || icons.length),
                        data: {
                            icons: icons,
                            label: extraHighlight
                        }
                    },
                    Description: (0, _templates.makeTextPatch)(description, this.w, _programDescriptionstyle.colors.description[colorMode]),
                    Details: (0, _templates.makeTextPatch)(details, this.w, _programDescriptionstyle.colors.details[colorMode])
                });
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Highlight: {},
                    ContentAdvisory: {
                        type: _contentAdvisorycomponent.ContentAdvisory
                    },
                    Description: {},
                    Details: {}
                }, (0, _programDescriptionstyle.getInitialStyle)());
            }
        }
    ]);
    return ProgramDescription;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 87993:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    CONTENT_ADVISORY_MARGIN: function() {
        return CONTENT_ADVISORY_MARGIN;
    },
    ICON_MARGINS: function() {
        return ICON_MARGINS;
    },
    ICON_SIZE: function() {
        return ICON_SIZE;
    },
    TEXT_MARGIN: function() {
        return TEXT_MARGIN;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(37815);
var _constants = __webpack_require__(34952);
var _typography = __webpack_require__(18411);
var _theme = __webpack_require__(51397);
var _style = __webpack_require__(65082);
var _obj;
var TEXT_MARGIN = (_obj = {}, _define_property._(_obj, _constants.HD, 8), _define_property._(_obj, _constants.FULL_HD, 16), _obj);
var _obj1;
var CONTENT_ADVISORY_MARGIN = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 40), _define_property._(_obj1, _constants.FULL_HD, 40), _obj1);
var _obj2;
var ICON_SIZE = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 24), _define_property._(_obj2, _constants.FULL_HD, 32), _obj2);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj3;
var ICON_MARGINS = (_obj3 = {}, _define_property._(_obj3, _constants.HD, {
    marginRight: -1
}), _define_property._(_obj3, _constants.FULL_HD, {
    marginRight: -1
}), _obj3);
var colors = {
    details: (0, _theme.makeThemeColor)(_theme.PRIMARY, 0.8),
    description: (0, _theme.makeThemeColor)(_theme.PRIMARY),
    highlight: (0, _theme.makeThemeColor)(_theme.PRIMARY, 0.8)
};
var getInitialStyle = function() {
    var screenSize = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext).screenSize;
    var detailsFont = (0, _typography.getFont)(_typography.FONT.BERLIN_1, screenSize);
    var descriptionFont = (0, _typography.getFont)(_typography.FONT.OTTAWA_1, screenSize);
    return {
        flex: {
            direction: "column"
        },
        Highlight: {
            text: _object_spread_props._(_object_spread._({}, detailsFont), {
                maxLinesSuffix: "...",
                maxLines: 1
            }),
            flexItem: {
                marginBottom: TEXT_MARGIN[screenSize]
            }
        },
        ContentAdvisory: {
            flexItem: {
                marginBottom: CONTENT_ADVISORY_MARGIN[screenSize]
            }
        },
        Description: {
            text: _object_spread_props._(_object_spread._({}, descriptionFont), {
                maxLinesSuffix: "..."
            })
        },
        Details: {
            text: _object_spread_props._(_object_spread._({}, detailsFont), {
                maxLinesSuffix: "...",
                maxLines: 1
            })
        }
    };
};


/***/ }),

/***/ 63902:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "ProgramInformation", ({
    enumerable: true,
    get: function() {
        return ProgramInformation;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(65759);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _i18n = __webpack_require__(14910);
var _textures = __webpack_require__(67179);
var _sizes = __webpack_require__(82699);
var _buttoncomponent = __webpack_require__(31464);
var _iconcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(70160));
var _scrollcomponent = __webpack_require__(31418);
var _programDescriptioncomponent = __webpack_require__(68091);
var _programInformationstyle = __webpack_require__(89187);
var _programInformationconstants = __webpack_require__(21248);
var ProgramInformation = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(ProgramInformation, _Lightning_Component);
    var _super = _create_super._(ProgramInformation);
    function ProgramInformation() {
        _class_call_check._(this, ProgramInformation);
        return _super.apply(this, arguments);
    }
    _create_class._(ProgramInformation, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _programInformationstyle.defaultContext;
            }
        },
        {
            key: "data",
            set: function set(content) {
                if (!content) {
                    return;
                }
                var screenSize = this._style.screenSize;
                var image = content.image, logo = content.logo;
                var logoSrc = logo && logo.src || "";
                var isLogoVisible = Boolean(logoSrc);
                var isServiceIconVisible = Boolean(content.servicePicto);
                this.patch({
                    texture: (0, _textures.cover)(image.src, _sizes.SCREEN_WIDTH[this._style.screenSize], _sizes.SCREEN_HEIGHT[this._style.screenSize]),
                    ContentContainer: {
                        Top: {
                            Title: {
                                visible: !isLogoVisible,
                                text: {
                                    text: content.title
                                }
                            },
                            Logo: {
                                visible: isLogoVisible,
                                texture: (0, _textures.contain)(logoSrc, _programInformationstyle.LOGO_DIMENSIONS[screenSize].width, _programInformationstyle.LOGO_DIMENSIONS[screenSize].height)
                            },
                            ServiceIcon: {
                                visible: isServiceIconVisible,
                                iconData: {
                                    picto: content.servicePicto,
                                    viewBox: (0, _programInformationstyle.getServiceIconViewBox)(screenSize)
                                }
                            }
                        }
                    }
                });
                var scroll = this.tag("Scroll");
                var scrollableView = scroll.content;
                if (scrollableView) {
                    scroll.y = (0, _programInformationstyle.getScrollTop)({
                        isLogoVisible: isLogoVisible,
                        isServiceIconVisible: isServiceIconVisible,
                        isTitleVisible: Boolean(content.title),
                        screenSize: screenSize
                    });
                    scroll.h = (0, _programInformationstyle.getContainerHeight)(screenSize) - scroll.y;
                    scrollableView.data = content;
                }
            }
        },
        {
            key: "_getFocused",
            value: function _getFocused() {
                return this.tag("Scroll");
            }
        },
        {
            key: "_handleKey",
            value: function _handleKey() {
                return true;
            }
        },
        {
            key: "_handleBack",
            value: function _handleBack() {
                this.signal(_programInformationconstants.PROGRAM_INFORMATION_CLOSED_SIGNAL);
                return true;
            }
        },
        {
            key: "_handleEnter",
            value: function _handleEnter() {
                if (this.tag("ExitButton").visible) {
                    this.signal(_programInformationconstants.PROGRAM_INFORMATION_CLOSED_SIGNAL);
                }
                return true;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    rect: true,
                    Overlay: {
                        rect: true
                    },
                    ContentContainer: {
                        Top: {
                            Title: {},
                            Logo: {},
                            ServiceIcon: {
                                type: _iconcomponent.default
                            }
                        },
                        Scroll: {
                            type: _scrollcomponent.Scroll,
                            content: {
                                type: _programDescriptioncomponent.ProgramDescription,
                                w: _programInformationstyle.TEXT_WIDTH[_programInformationstyle.defaultContext.screenSize]
                            }
                        }
                    },
                    ExitButton: {
                        type: _buttoncomponent.Button,
                        visible: false,
                        picto: {
                            name: "Cross"
                        },
                        label: (0, _i18n.t)("global.close")
                    }
                }, (0, _programInformationstyle.getInitialStyle)());
            }
        }
    ]);
    return ProgramInformation;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 21248:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "PROGRAM_INFORMATION_CLOSED_SIGNAL", ({
    enumerable: true,
    get: function() {
        return PROGRAM_INFORMATION_CLOSED_SIGNAL;
    }
}));
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
var PROGRAM_INFORMATION_CLOSED_SIGNAL = "programInformationClosed";


/***/ }),

/***/ 89187:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    LOGO_DIMENSIONS: function() {
        return LOGO_DIMENSIONS;
    },
    LOGO_MARGIN_BOTTOM: function() {
        return LOGO_MARGIN_BOTTOM;
    },
    SERVICE_ICON_HEIGHT: function() {
        return SERVICE_ICON_HEIGHT;
    },
    TEXT_WIDTH: function() {
        return TEXT_WIDTH;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getContainerHeight: function() {
        return getContainerHeight;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    getProgramInformationFocusedStyle: function() {
        return getProgramInformationFocusedStyle;
    },
    getProgramInformationUnFocusedStyle: function() {
        return getProgramInformationUnFocusedStyle;
    },
    getScrollTop: function() {
        return getScrollTop;
    },
    getServiceIconViewBox: function() {
        return getServiceIconViewBox;
    },
    getTitleFont: function() {
        return getTitleFont;
    }
});
var _define_property = __webpack_require__(21228);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(42578);
var _constants = __webpack_require__(34952);
var _theme = __webpack_require__(51397);
var _typography = __webpack_require__(18411);
var _sizes = __webpack_require__(82699);
var _style = __webpack_require__(65082);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var LOGO_DIMENSIONS = (_obj = {}, _define_property._(_obj, _constants.HD, {
    width: _sizes.SCREEN_HEIGHT[_constants.HD] - _constants.safetyMargins.horizontal[_constants.HD] * 2,
    height: 136
}), _define_property._(_obj, _constants.FULL_HD, {
    width: _sizes.SCREEN_HEIGHT[_constants.FULL_HD] - _constants.safetyMargins.horizontal[_constants.FULL_HD] * 2,
    height: 200
}), _obj);
var _obj1;
var LOGO_MARGIN_BOTTOM = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 16), _define_property._(_obj1, _constants.FULL_HD, 24), _obj1);
var _obj2;
var TEXT_WIDTH = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 640), _define_property._(_obj2, _constants.FULL_HD, 980), _obj2);
var _obj3;
var SERVICE_ICON_HEIGHT = (_obj3 = {}, _define_property._(_obj3, _constants.HD, 40), _define_property._(_obj3, _constants.FULL_HD, 56), _obj3);
var colors = {
    background: (0, _theme.makeThemeColor)(_theme.TERTIARY, 0.8)
};
var getTitleFont = function(screenSize) {
    return (0, _typography.getFont)(_typography.FONT.TOKYO_4, screenSize);
};
var getScrollTop = function(param) {
    var isLogoVisible = param.isLogoVisible, isTitleVisible = param.isTitleVisible, isServiceIconVisible = param.isServiceIconVisible, screenSize = param.screenSize;
    var result = 0;
    if (isLogoVisible) {
        result += LOGO_DIMENSIONS[screenSize].height + LOGO_MARGIN_BOTTOM[screenSize];
    } else if (isTitleVisible) {
        result += getTitleFont(screenSize).lineHeight;
    }
    if (isServiceIconVisible) {
        result += SERVICE_ICON_HEIGHT[screenSize];
    }
    return result;
};
var getServiceIconViewBox = function(screenSize) {
    return {
        h: SERVICE_ICON_HEIGHT[screenSize]
    };
};
var getContainerHeight = function(screenSize) {
    return _sizes.SCREEN_HEIGHT[screenSize] - _constants.safetyMargins.vertical[screenSize] * 2;
};
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var screenSize = context.screenSize, colorMode = context.colorMode;
    var containerHeight = getContainerHeight(screenSize);
    return {
        alpha: 0,
        w: _sizes.SCREEN_WIDTH[screenSize],
        h: _sizes.SCREEN_HEIGHT[screenSize],
        Overlay: {
            w: _sizes.SCREEN_WIDTH[screenSize],
            h: _sizes.SCREEN_HEIGHT[screenSize],
            color: colors.background[colorMode]
        },
        ContentContainer: {
            h: containerHeight,
            x: _constants.safetyMargins.horizontal[screenSize],
            y: _constants.safetyMargins.vertical[screenSize],
            Top: {
                Title: {
                    text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT.TOKYO_4, screenSize)), {
                        maxLinesSuffix: "...",
                        wordWrapWidth: TEXT_WIDTH[screenSize],
                        maxLines: 1
                    })
                },
                Logo: {
                    flexItem: {
                        marginBottom: LOGO_MARGIN_BOTTOM[screenSize]
                    }
                },
                ServiceIcon: {},
                flex: {
                    direction: "column"
                }
            },
            Scroll: {
                w: TEXT_WIDTH[screenSize],
                h: containerHeight,
                y: 0
            }
        },
        ExitButton: {
            mountX: 1,
            x: _sizes.SCREEN_WIDTH[screenSize] - _constants.safetyMargins.horizontal[screenSize],
            y: _constants.safetyMargins.vertical[screenSize]
        }
    };
};
var getProgramInformationFocusedStyle = function() {
    return {
        smooth: {
            alpha: 1
        }
    };
};
var getProgramInformationUnFocusedStyle = function() {
    return {
        smooth: {
            alpha: 0
        }
    };
};


/***/ }),

/***/ 23341:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "ContentAdvisory", ({
    enumerable: true,
    get: function() {
        return ContentAdvisory;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _create_super = __webpack_require__(6400);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(42578);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _iconcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(70160));
var _contentAdvisorystyle = __webpack_require__(61542);
var ContentAdvisory = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(ContentAdvisory, _Lightning_Component);
    var _super = _create_super._(ContentAdvisory);
    function ContentAdvisory() {
        _class_call_check._(this, ContentAdvisory);
        return _super.apply(this, arguments);
    }
    _create_class._(ContentAdvisory, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _contentAdvisorystyle.defaultContext;
            }
        },
        {
            key: "data",
            set: function set(param) {
                var icons = param.icons, label = param.label;
                var screenSize = this._style.screenSize;
                this.patch({
                    Label: {
                        visible: Boolean(label),
                        text: {
                            text: label
                        }
                    },
                    Icons: {
                        visible: Boolean(icons.length),
                        children: icons.map(function(icon) {
                            return _object_spread._({
                                type: _iconcomponent.default
                            }, (0, _contentAdvisorystyle.getContentAdvisoryIconStyle)(icon, screenSize));
                        })
                    }
                });
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Label: {},
                    Icons: {}
                }, (0, _contentAdvisorystyle.getInitialStyle)());
            }
        }
    ]);
    return ContentAdvisory;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 61542:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    COLOR: function() {
        return COLOR;
    },
    ICON_MARGIN: function() {
        return ICON_MARGIN;
    },
    ICON_SIZE: function() {
        return ICON_SIZE;
    },
    MARGIN: function() {
        return MARGIN;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getContentAdvisoryIconStyle: function() {
        return getContentAdvisoryIconStyle;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(42578);
var _constants = __webpack_require__(34952);
var _typography = __webpack_require__(18411);
var _theme = __webpack_require__(51397);
var _style = __webpack_require__(65082);
var _obj;
var MARGIN = (_obj = {}, _define_property._(_obj, _constants.HD, 16), _define_property._(_obj, _constants.FULL_HD, 16), _obj);
var _obj1;
var ICON_SIZE = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 24), _define_property._(_obj1, _constants.FULL_HD, 32), _obj1);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var COLOR = (0, _theme.makeThemeColor)(_theme.PRIMARY, 0.8);
var ICON_MARGIN = -1;
var getContentAdvisoryIconStyle = function(picto, screenSize) {
    return {
        visible: Boolean(picto),
        flexItem: {
            marginRight: ICON_MARGIN
        },
        iconData: {
            picto: picto,
            viewBox: {
                w: ICON_SIZE[screenSize],
                h: ICON_SIZE[screenSize]
            }
        }
    };
};
var getInitialStyle = function() {
    var screenSize = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext).screenSize;
    return {
        h: ICON_SIZE[screenSize],
        flex: {
            direction: "row",
            alignItems: "center"
        },
        Label: {
            text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT.BERLIN_1, screenSize)), {
                maxLines: 1,
                verticalAlign: "middle",
                maxLinesSuffix: "...",
                wordWrap: false
            }),
            flexItem: {
                marginRight: MARGIN[screenSize]
            }
        },
        Icons: {
            h: ICON_SIZE[screenSize],
            flex: {
                direction: "row",
                alignItems: "center"
            }
        }
    };
};


/***/ }),

/***/ 31418:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "Scroll", ({
    enumerable: true,
    get: function() {
        return Scroll;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(37815);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _iconcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(70160));
var _scrollstyle = __webpack_require__(11012);
var _scrollshader = /*#__PURE__*/ _interop_require_default._(__webpack_require__(91505));
var Scroll = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(Scroll, _Lightning_Component);
    var _super = _create_super._(Scroll);
    function Scroll() {
        _class_call_check._(this, Scroll);
        return _super.apply(this, arguments);
    }
    _create_class._(Scroll, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _scrollstyle.defaultContext;
                this._offset = 0;
                this._contentHeight = 0;
                this._minOffset = 0;
                this._shouldScroll = false;
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                this._style = undefined;
                this._offset = 0;
                this._contentHeight = 0;
                this._minOffset = 0;
                this._shouldScroll = false;
            }
        },
        {
            key: "content",
            get: function get() {
                return this.tag("Pane").childList.getByRef("Wrapper");
            },
            set: function set(value) {
                var _this = this;
                var pane = this.tag("Pane");
                var current = pane.childList.getByRef("Wrapper");
                if (current) {
                    current.removeAllListeners("txLoaded");
                    pane.childList.remove(current);
                }
                var child = this.stage.c(value);
                child.on("txLoaded", function() {
                    _this._shouldScroll = child.finalH > _this.h;
                    var offset = _this._shouldScroll ? _scrollstyle.ARROW_SIZE[_this._style.screenSize] : 0;
                    _this._minOffset = _this.h - child.finalH - _scrollstyle.ARROW_SIZE[_this._style.screenSize] * 2;
                    pane.patch({
                        w: _this.w,
                        h: _this.h - offset * 2,
                        y: offset
                    });
                    _this.tag("Up").visible = _this._shouldScroll;
                    _this.tag("Down").patch({
                        visible: _this._shouldScroll,
                        y: _this.h
                    });
                    _this._updateOffset(0);
                });
                child.ref = "Wrapper";
                pane.childList.add(child);
            }
        },
        {
            key: "_updateOffset",
            value: function _updateOffset(direction) {
                var content = this.content;
                if (!content) {
                    return;
                }
                var pane = this.tag("Pane");
                content.setSmooth("y", this._offset);
                this.tag("Up").setSmooth("alpha", this._offset >= 0 ? 0 : 1);
                this.tag("Down").setSmooth("alpha", this._offset <= this._minOffset ? 0 : 1);
                pane.setSmooth("shader.top", this._offset >= 0 ? 0 : 1, {
                    delay: direction > 0 ? 0.11 : 0
                });
                pane.setSmooth("shader.bottom", this._offset <= this._minOffset ? 0 : 1, {
                    delay: direction < 0 ? 0.11 : 0
                });
            }
        },
        {
            key: "_handleUp",
            value: function _handleUp() {
                if (!this._shouldScroll) {
                    return true;
                }
                this._offset = Math.min(this._offset + 100, 0);
                this._updateOffset(1);
                return true;
            }
        },
        {
            key: "_handleDown",
            value: function _handleDown() {
                if (!this._shouldScroll) {
                    return true;
                }
                this._offset = Math.max(this._offset - 100, this._minOffset);
                this._updateOffset(-1);
                return true;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Up: {
                        type: _iconcomponent.default
                    },
                    Pane: {
                        rtt: true,
                        shader: {
                            type: _scrollshader.default
                        }
                    },
                    Down: {
                        type: _iconcomponent.default
                    }
                }, (0, _scrollstyle.getInitialStyle)());
            }
        }
    ]);
    return Scroll;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 91505:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return ScrollShader;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _get = __webpack_require__(60528);
var _get_prototype_of = __webpack_require__(35196);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(88801);
var _sdk = __webpack_require__(29956);
var ScrollShader = /*#__PURE__*/ function(_Lightning_shaders_WebGLDefaultShader) {
    "use strict";
    _inherits._(ScrollShader, _Lightning_shaders_WebGLDefaultShader);
    var _super = _create_super._(ScrollShader);
    function ScrollShader(context) {
        _class_call_check._(this, ScrollShader);
        var _this;
        _this = _super.call(this, context);
        _this._top = 1.0;
        _this._bottom = 0;
        return _this;
    }
    _create_class._(ScrollShader, [
        {
            key: "setupUniforms",
            value: function setupUniforms(operation) {
                _get._(_get_prototype_of._(ScrollShader.prototype), "setupUniforms", this).call(this, operation);
                var owner = operation.shaderOwner;
                var renderPrecision = this.ctx.stage.getRenderPrecision();
                this._setUniform("top", this._top, this.gl.uniform1f);
                this._setUniform("bottom", this._bottom, this.gl.uniform1f);
                this._setUniform("resolution", new Float32Array([
                    owner._w * renderPrecision,
                    owner._h * renderPrecision
                ]), this.gl.uniform2fv);
            }
        },
        {
            key: "top",
            get: function get() {
                return this._top;
            },
            set: function set(value) {
                this._top = value;
                this.redraw();
            }
        },
        {
            key: "bottom",
            get: function get() {
                return this._bottom;
            },
            set: function set(value) {
                this._bottom = value;
                this.redraw();
            }
        }
    ]);
    return ScrollShader;
}(_sdk.Lightning.shaders.WebGLDefaultShader);
ScrollShader.vertexShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    attribute vec2 aVertexPosition;\n    attribute vec2 aTextureCoord;\n    attribute vec4 aColor;\n\n    uniform vec2 projection;\n\n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n\n    void main(void){\n        gl_Position = vec4(aVertexPosition.x * projection.x - 1.0, aVertexPosition.y * -abs(projection.y) + 1.0, 0.0, 1.0);\n        vTextureCoord = aTextureCoord;\n        vColor = aColor;\n        gl_Position.y = -sign(projection.y) * gl_Position.y;\n    }\n";
ScrollShader.fragmentShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n\n    varying vec2 vTextureCoord;\n    varying vec2 vProjection;\n    varying vec4 vColor;\n\n    uniform sampler2D uSampler;\n    uniform float top;\n    uniform float bottom;\n\n    void main(void){\n        vec4 color = texture2D(uSampler, vTextureCoord) * vColor;\n\n        float size = 0.1;\n        float multiplier = 1.0 / size;\n\n        float topMask = 1.0 - max((size * top - vTextureCoord.y) * multiplier, 0.0);\n        float bottomMask = 1.0 - max((vTextureCoord.y - 1.0 + size * bottom) * multiplier, 0.0);\n\n        gl_FragColor = color * topMask * bottomMask;\n    }\n";


/***/ }),

/***/ 11012:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ARROW_SIZE: function() {
        return ARROW_SIZE;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
var _define_property = __webpack_require__(21228);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(42578);
var _constants = __webpack_require__(34952);
var _iconconstants = __webpack_require__(48112);
var _sizes = __webpack_require__(82699);
var _style = __webpack_require__(65082);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var ARROW_SIZE = (_obj = {}, _define_property._(_obj, _constants.HD, 56), _define_property._(_obj, _constants.FULL_HD, 80), _obj);
var getInitialStyle = function() {
    var screenSize = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext).screenSize;
    return {
        Up: {
            mountX: 0.5,
            x: _sizes.middle,
            y: 0,
            iconData: {
                picto: {
                    name: "ArrowUp",
                    type: _iconconstants.ICON_TYPE.SIMPLE_ICON
                },
                viewBox: {
                    h: ARROW_SIZE[screenSize]
                }
            }
        },
        Pane: {},
        Down: {
            mountX: 0.5,
            mountY: 1,
            x: _sizes.middle,
            iconData: {
                picto: {
                    name: "ArrowDown",
                    type: _iconconstants.ICON_TYPE.SIMPLE_ICON
                },
                viewBox: {
                    h: ARROW_SIZE[screenSize]
                }
            }
        }
    };
};


/***/ }),

/***/ 45926:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return Progress;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _get = __webpack_require__(60528);
var _get_prototype_of = __webpack_require__(35196);
var _inherits = __webpack_require__(71648);
var _set = __webpack_require__(81364);
var _create_super = __webpack_require__(6400);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(37815);
var _sdk = __webpack_require__(29956);
var _theme = __webpack_require__(51397);
var _sizes = __webpack_require__(82699);
var _progressstyle = __webpack_require__(67614);
var _progressutils = __webpack_require__(40779);
var _progressconstants = __webpack_require__(12305);
var Progress = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(Progress, _Lightning_Component);
    var _super = _create_super._(Progress);
    function Progress() {
        _class_call_check._(this, Progress);
        return _super.apply(this, arguments);
    }
    _create_class._(Progress, [
        {
            key: "_construct",
            value: function _construct() {
                this._progress = 0;
            }
        },
        {
            key: "_handleProgressUpdate",
            value: function _handleProgressUpdate() {
                var width = this.finalW || this.w;
                var progressWidth = this._progress > _progressconstants.FULLY_SHOWN_PERCENTAGE ? width : width * this._progress;
                this.tag("Bar").w = progressWidth;
            }
        },
        {
            key: "w",
            get: function get() {
                return _get._(_get_prototype_of._(Progress.prototype), "w", this);
            },
            set: function set(value) {
                _set._(_get_prototype_of._(Progress.prototype), "w", value, this, true);
                this._handleProgressUpdate();
            }
        },
        {
            key: "progress",
            get: function get() {
                return this._progress;
            },
            set: function set(value) {
                this._progress = (0, _progressutils.safeProgressValue)(value);
                this._handleProgressUpdate();
            }
        },
        {
            key: "colorMode",
            get: function get() {
                return this._colorMode;
            },
            set: function set(value) {
                this._colorMode = value;
                this.patch({
                    color: _progressstyle.colors.background[this._colorMode],
                    Bar: {
                        color: _progressstyle.colors.bar[this._colorMode]
                    }
                });
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return {
                    rect: true,
                    color: _progressstyle.colors.background[_theme.DEFAULT_MODE],
                    h: _progressstyle.HEIGHT,
                    Bar: {
                        rect: true,
                        color: _progressstyle.colors.bar[_theme.DEFAULT_MODE],
                        h: _sizes.identity
                    }
                };
            }
        }
    ]);
    return Progress;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 12305:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "FULLY_SHOWN_PERCENTAGE", ({
    enumerable: true,
    get: function() {
        return FULLY_SHOWN_PERCENTAGE;
    }
}));
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(37815);
var FULLY_SHOWN_PERCENTAGE = 0.95;


/***/ }),

/***/ 67614:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    HEIGHT: function() {
        return HEIGHT;
    },
    colors: function() {
        return colors;
    }
});
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(37815);
var _theme = __webpack_require__(51397);
var HEIGHT = 4;
var colors = {
    background: (0, _theme.makeThemeColor)(_theme.PRIMARY, 0.3),
    bar: (0, _theme.makeThemeColor)(_theme.SECONDARY)
};


/***/ }),

/***/ 40779:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    getPercentage: function() {
        return getPercentage;
    },
    getProgress: function() {
        return getProgress;
    },
    makeProgressBarProperties: function() {
        return makeProgressBarProperties;
    },
    safeProgressValue: function() {
        return safeProgressValue;
    }
});
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(88801);
var _clamp = /*#__PURE__*/ _interop_require_default._(__webpack_require__(35636));
var safeProgressValue = function(value) {
    return (0, _clamp.default)(value, 0, 1);
};
var getProgress = function(percentage) {
    return Number.isFinite(percentage) ? percentage / 100 : 0;
};
var getPercentage = function(currentTime, clipDuration) {
    return clipDuration && currentTime ? Math.ceil(currentTime * 100 / clipDuration) : 0;
};
var makeProgressBarProperties = function(percentage) {
    var progress = getProgress(percentage);
    return {
        visible: Boolean(progress),
        progress: progress
    };
};


/***/ }),

/***/ 25648:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "Radio", ({
    enumerable: true,
    get: function() {
        return Radio;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(65759);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _radiostyle = __webpack_require__(27819);
var Radio = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(Radio, _Lightning_Component);
    var _super = _create_super._(Radio);
    function Radio() {
        _class_call_check._(this, Radio);
        return _super.apply(this, arguments);
    }
    _create_class._(Radio, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _radiostyle.defaultContext;
                this._isSelected = false;
            }
        },
        {
            key: "label",
            get: function get() {
                return this.tag("Label").text.text;
            },
            set: function set(value) {
                this.tag("Label").text.text = value;
            }
        },
        {
            key: "isSelected",
            get: function get() {
                return this._isSelected;
            },
            set: function set(value) {
                var newValue = Boolean(value);
                if (this._isSelected !== newValue) {
                    this._isSelected = newValue;
                    this.patch(this._isSelected ? (0, _radiostyle.getSelectedStyle)(this._style) : (0, _radiostyle.getBaseStyle)(this._style));
                }
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Border: {},
                    Dot: {},
                    Label: {}
                }, (0, _radiostyle.getInitialStyle)());
            }
        }
    ]);
    return Radio;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 27819:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BORDER_DIAMETER: function() {
        return BORDER_DIAMETER;
    },
    BORDER_RIGHT_MARGIN: function() {
        return BORDER_RIGHT_MARGIN;
    },
    DOT_DIAMETER: function() {
        return DOT_DIAMETER;
    },
    TEXT_LABEL_WRAP_WIDTH: function() {
        return TEXT_LABEL_WRAP_WIDTH;
    },
    VERTICAL_PADDING: function() {
        return VERTICAL_PADDING;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getBaseFont: function() {
        return getBaseFont;
    },
    getBaseStyle: function() {
        return getBaseStyle;
    },
    getBorderTexture: function() {
        return getBorderTexture;
    },
    getDotTexture: function() {
        return getDotTexture;
    },
    getFinalHeight: function() {
        return getFinalHeight;
    },
    getInitialHeight: function() {
        return getInitialHeight;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    getRoundedTexture: function() {
        return getRoundedTexture;
    },
    getSelectedStyle: function() {
        return getSelectedStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(3009);
var _memoize = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34736));
var _sdk = __webpack_require__(29956);
var _constants = __webpack_require__(34952);
var _theme = __webpack_require__(51397);
var _typography = __webpack_require__(18411);
var _colors = __webpack_require__(8426);
var _style = __webpack_require__(65082);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var BORDER_DIAMETER = (_obj = {}, _define_property._(_obj, _constants.HD, 24), _define_property._(_obj, _constants.FULL_HD, 32), _obj);
var _obj1;
var DOT_DIAMETER = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 12), _define_property._(_obj1, _constants.FULL_HD, 16), _obj1);
var _obj2;
var VERTICAL_PADDING = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 12), _define_property._(_obj2, _constants.FULL_HD, 16), _obj2);
var _obj3;
var BORDER_RIGHT_MARGIN = (_obj3 = {}, _define_property._(_obj3, _constants.HD, 16), _define_property._(_obj3, _constants.FULL_HD, 24), _obj3);
var _obj4;
var TEXT_LABEL_WRAP_WIDTH = (_obj4 = {}, _define_property._(_obj4, _constants.HD, 500), _define_property._(_obj4, _constants.FULL_HD, 770), _obj4);
var _obj5;
var colors = {
    base: (_obj5 = {}, _define_property._(_obj5, _theme.LIGHT_MODE, (0, _theme.getLightColor)(_theme.TERTIARY)), _define_property._(_obj5, _theme.DARK_MODE, (0, _theme.getDarkColor)(_theme.PRIMARY)), _obj5),
    selected: (0, _theme.makeThemeColor)(_theme.SECONDARY)
};
var getBaseFont = (0, _memoize.default)(function(screenSize) {
    return (0, _typography.getFont)(_typography.FONT.KINSHASA_1, screenSize);
});
var getInitialHeight = (0, _memoize.default)(function(screenSize) {
    return getBaseFont(screenSize).lineHeight + VERTICAL_PADDING[screenSize] * 2;
});
var getFinalHeight = (0, _memoize.default)(function(finalH) {
    return finalH + VERTICAL_PADDING[defaultContext.screenSize] * 2;
});
var getRoundedTexture = function(diameter, strokeColor, fillColor) {
    return _sdk.Lightning.Tools.getRoundRect(diameter, diameter, Math.round(diameter / 2), strokeColor ? 1 : 0, strokeColor, true, fillColor);
};
var getBorderTexture = function(diameter) {
    return getRoundedTexture(diameter, _colors.WHITE, _colors.TRANSPARENT);
};
var getDotTexture = function(diameter) {
    return getRoundedTexture(diameter, _colors.TRANSPARENT, _colors.WHITE);
};
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var screenSize = context.screenSize, colorMode = context.colorMode;
    var borderDiameter = BORDER_DIAMETER[screenSize];
    var dotDiameter = DOT_DIAMETER[screenSize];
    var center = Math.round((borderDiameter - dotDiameter) / 2);
    var font = getBaseFont(screenSize);
    var h = getInitialHeight(screenSize);
    return {
        h: h,
        Border: {
            w: borderDiameter,
            h: borderDiameter,
            y: Math.round((h - borderDiameter) / 2),
            texture: getBorderTexture(borderDiameter),
            color: colors.base[colorMode]
        },
        Dot: {
            w: dotDiameter,
            h: dotDiameter,
            x: center,
            y: Math.round((h - dotDiameter) / 2),
            texture: getDotTexture(dotDiameter),
            color: colors.base[colorMode],
            scale: 0
        },
        Label: {
            x: borderDiameter + BORDER_RIGHT_MARGIN[screenSize],
            y: VERTICAL_PADDING[screenSize],
            text: _object_spread_props._(_object_spread._({}, font), {
                maxLines: 3,
                wordWrapWidth: TEXT_LABEL_WRAP_WIDTH[screenSize],
                verticalAlign: "middle"
            })
        }
    };
};
var getBaseStyle = (0, _memoize.default)(function(param) {
    var screenSize = param.screenSize, colorMode = param.colorMode;
    return {
        Border: {
            smooth: {
                color: colors.base[colorMode]
            }
        },
        Dot: {
            smooth: {
                scale: 0,
                color: colors.base[colorMode]
            }
        },
        Label: {
            text: _object_spread._({}, getBaseFont(screenSize))
        }
    };
}, _style.cacheResolver);
var getSelectedStyle = (0, _memoize.default)(function(param) {
    var screenSize = param.screenSize, colorMode = param.colorMode;
    return {
        Border: {
            smooth: {
                color: colors.selected[colorMode]
            }
        },
        Dot: {
            smooth: {
                scale: 1,
                color: colors.selected[colorMode]
            }
        },
        Label: {
            text: _object_spread._({}, (0, _typography.getFont)(_typography.FONT.KINSHASA_2, screenSize))
        }
    };
}, _style.cacheResolver);


/***/ }),

/***/ 48592:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "RestrictedInput", ({
    enumerable: true,
    get: function() {
        return RestrictedInput;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(45538);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _restrictedInputstyle = __webpack_require__(54120);
var _restrictedInputItemcomponent = __webpack_require__(36254);
var RestrictedInput = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(RestrictedInput, _Lightning_Component);
    var _super = _create_super._(RestrictedInput);
    function RestrictedInput() {
        _class_call_check._(this, RestrictedInput);
        return _super.apply(this, arguments);
    }
    _create_class._(RestrictedInput, [
        {
            key: "_init",
            value: function _init() {
                this._length = 0;
                this._currentItem = 0;
            }
        },
        {
            key: "length",
            set: function set(value) {
                this._length = value;
                this._initializeInput();
            }
        },
        {
            key: "borderCellColor",
            set: function set(color) {
                this.children.forEach(function(child) {
                    child.borderColor = color;
                });
            }
        },
        {
            key: "_initializeInput",
            value: function _initializeInput() {
                var items = [];
                for(var i = 0; i < this._length; i += 1){
                    items.push({
                        type: _restrictedInputItemcomponent.RestrictedInputItem
                    });
                }
                this.children = items;
                this.children[this._currentItem].borderAlpha = _restrictedInputstyle.FOCUSED_ITEM_ALPHA;
            }
        },
        {
            key: "updateBorder",
            value: function updateBorder() {
                var _this = this;
                this.children.forEach(function(child, index) {
                    child.borderAlpha = index === _this._currentItem ? _restrictedInputstyle.FOCUSED_ITEM_ALPHA : _restrictedInputstyle.UNFOCUSED_ITEM_ALPHA;
                });
            }
        },
        {
            key: "push",
            value: function push(value) {
                if (this._currentItem === this._length || !value) return;
                this.children[this._currentItem].itemContent = value;
                this._currentItem += 1;
                this.updateBorder();
            }
        },
        {
            key: "pop",
            value: function pop() {
                this._currentItem = Math.max(this._currentItem - 1, 0);
                this.children[this._currentItem].clearItemContent();
                this.updateBorder();
            }
        },
        {
            key: "clearInput",
            value: function clearInput() {
                this._currentItem = 0;
                this.children.forEach(function(inputItem) {
                    inputItem.clearItemContent();
                });
                this.children[this._currentItem].borderAlpha = _restrictedInputstyle.FOCUSED_ITEM_ALPHA;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({}, (0, _restrictedInputstyle.getInitialStyle)());
            }
        }
    ]);
    return RestrictedInput;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 54120:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    FOCUSED_ITEM_ALPHA: function() {
        return FOCUSED_ITEM_ALPHA;
    },
    UNFOCUSED_ITEM_ALPHA: function() {
        return UNFOCUSED_ITEM_ALPHA;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(3009);
var FOCUSED_ITEM_ALPHA = 1;
var UNFOCUSED_ITEM_ALPHA = 0.3;
var getInitialStyle = function() {
    return {
        flex: {
            direction: "row",
            alignItems: "center"
        }
    };
};


/***/ }),

/***/ 36254:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "RestrictedInputItem", ({
    enumerable: true,
    get: function() {
        return RestrictedInputItem;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(88801);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _restrictedInputItemstyle = __webpack_require__(76384);
var RestrictedInputItem = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(RestrictedInputItem, _Lightning_Component);
    var _super = _create_super._(RestrictedInputItem);
    function RestrictedInputItem() {
        _class_call_check._(this, RestrictedInputItem);
        return _super.apply(this, arguments);
    }
    _create_class._(RestrictedInputItem, [
        {
            key: "borderColor",
            set: function set(color) {
                this.tag("Border").colorBorder = color.color;
                this.borderAlpha = color.opacity;
            }
        },
        {
            key: "borderAlpha",
            set: function set(value) {
                this.tag("Border").alpha = value;
            }
        },
        {
            key: "itemContent",
            set: function set(value) {
                if (!value) return;
                this.tag("Number").text.text = value;
            }
        },
        {
            key: "clearItemContent",
            value: function clearItemContent() {
                this.tag("Number").text.text = "";
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Border: {
                        type: _sdk.Lightning.components.BorderComponent
                    },
                    Number: {
                        text: {
                            text: ""
                        }
                    }
                }, (0, _restrictedInputItemstyle.getInitialStyle)());
            }
        }
    ]);
    return RestrictedInputItem;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 76384:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BORDER_WIDTH: function() {
        return BORDER_WIDTH;
    },
    PASSWORD_ITEM_HEIGHT: function() {
        return PASSWORD_ITEM_HEIGHT;
    },
    PASSWORD_ITEM_OFFSET: function() {
        return PASSWORD_ITEM_OFFSET;
    },
    PASSWORD_ITEM_WIDTH: function() {
        return PASSWORD_ITEM_WIDTH;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(42578);
var _theme = __webpack_require__(51397);
var _constants = __webpack_require__(34952);
var _typography = __webpack_require__(18411);
var _style = __webpack_require__(65082);
var _sizes = __webpack_require__(82699);
var _restrictedInputstyle = __webpack_require__(54120);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var colors = {
    border: (0, _theme.makeThemeColor)(_theme.PRIMARY)
};
var _obj;
var BORDER_WIDTH = (_obj = {}, _define_property._(_obj, _constants.HD, 2), _define_property._(_obj, _constants.FULL_HD, 4), _obj);
var _obj1;
var PASSWORD_ITEM_WIDTH = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 74), _define_property._(_obj1, _constants.FULL_HD, 99), _obj1);
var _obj2;
var PASSWORD_ITEM_HEIGHT = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 158), _define_property._(_obj2, _constants.FULL_HD, 195), _obj2);
var _obj3;
var PASSWORD_ITEM_OFFSET = (_obj3 = {}, _define_property._(_obj3, _constants.HD, 6), _define_property._(_obj3, _constants.FULL_HD, 8), _obj3);
var getInitialStyle = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext, screenSize = _ref.screenSize, colorMode = _ref.colorMode;
    return {
        w: PASSWORD_ITEM_WIDTH[screenSize],
        h: PASSWORD_ITEM_HEIGHT[screenSize],
        flexItem: {
            marginRight: PASSWORD_ITEM_OFFSET[screenSize],
            marginLeft: PASSWORD_ITEM_OFFSET[screenSize]
        },
        Border: {
            alpha: _restrictedInputstyle.UNFOCUSED_ITEM_ALPHA,
            borderWidth: BORDER_WIDTH[screenSize],
            colorBorder: colors.border[colorMode],
            w: PASSWORD_ITEM_WIDTH[screenSize],
            h: PASSWORD_ITEM_HEIGHT[screenSize]
        },
        Number: {
            mountX: 0.5,
            mountY: 0.5,
            x: _sizes.middle,
            y: _sizes.middle,
            text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT.TOKYO_4, screenSize)), {
                verticalAlign: "middle"
            })
        }
    };
};


/***/ }),

/***/ 53565:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "Row", ({
    enumerable: true,
    get: function() {
        return Row;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(65759);
var _sdk = __webpack_require__(29956);
var _theme = __webpack_require__(74314);
var _virtualization = __webpack_require__(11559);
var _signals = __webpack_require__(2109);
var _rowconstants = __webpack_require__(7395);
var _rowstyle = __webpack_require__(23593);
var Row = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(Row, _Lightning_Component);
    var _super = _create_super._(Row);
    function Row() {
        _class_call_check._(this, Row);
        return _super.apply(this, arguments);
    }
    _create_class._(Row, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _rowstyle.defaultContext;
                this._contentGap = _rowstyle.CONTENT_GAP[this._style.screenSize];
                this._isRowActive = false;
                this._isRowAttached = false;
                this._resetVirtualization();
                this._leftPadding = 0;
                this._rightPadding = 0;
            }
        },
        {
            key: "_active",
            value: function _active() {
                var _this = this;
                this._isRowActive = true;
                if (this._data) {
                    if (this._isDataApplied) {
                        this._placeItems();
                    } else {
                        // NOTE: an ugly hack allowing quick vertical scroll
                        this._timeout = setTimeout(function() {
                            _this.data = _this._data;
                        }, _rowconstants.ITEMS_PLACEMENT_TIMEOUT);
                    }
                }
            }
        },
        {
            key: "_inactive",
            value: function _inactive() {
                this._isRowActive = false;
                clearTimeout(this._timeout);
            }
        },
        {
            key: "_attach",
            value: function _attach() {
                this._isRowAttached = true;
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                this._isRowAttached = false;
                this._resetVirtualization();
            }
        },
        {
            key: "data",
            set: function set(value) {
                var _this = this;
                if (!value) {
                    return;
                }
                this.patch({
                    w: value.rowSize.w,
                    h: value.itemSize.h
                });
                this._data = value;
                if (!this._isRowActive) {
                    return;
                }
                var _this__data = this._data, block = _this__data.block, blockIndex = _this__data.blockIndex, itemSize = _this__data.itemSize, itemTemplate = _this__data.itemTemplate, theme = _this__data.theme;
                var _block_content = block.content, items = _block_content.items, pagination = _block_content.pagination;
                var colorScheme = (0, _theme.getLayoutTheme)(block.theme, theme).colorScheme;
                var isUpdating = this._isDataApplied;
                this._blockIndex = blockIndex;
                this._isDataApplied = true;
                this._colorScheme = colorScheme;
                this._id = block.id;
                this._itemSize = itemSize;
                this._items = items.map(function(item, index) {
                    var existingItem = _this._items[index];
                    // NOTE: It's faster than creation of a new object
                    if (existingItem) {
                        existingItem.content = item;
                        existingItem.config = itemSize;
                        existingItem.template = itemTemplate;
                        existingItem.colorScheme = _this._colorScheme;
                        return existingItem;
                    }
                    return _this._makeItemData(item, index);
                });
                var totalItems = pagination.totalItems, itemsPerPage = pagination.itemsPerPage;
                this._totalItems = totalItems;
                this._itemsPerPage = itemsPerPage;
                this._pages = block.pages;
                this._updateContentPlacementStartPoint();
                this._setIndex(Math.min(this._focusedItemIndex, Math.max(this._totalItems - 1, 0)));
                // Remove extra items in case of a row data update
                if (isUpdating) {
                    var views = Object.keys(this._views);
                    for(var i = 0; i < views.length; i += 1){
                        var viewIndex = views[i];
                        if (viewIndex >= this._totalItems) {
                            this._backToBuffer(this._views[viewIndex]);
                        }
                    }
                }
                this._refocus();
            }
        },
        {
            key: "id",
            get: function get() {
                return this._id;
            }
        },
        {
            key: "focusMode",
            set: function set(value) {
                if (_rowconstants.FOCUS_MODES.includes(value) && this._focusMode !== value) {
                    this._focusMode = value;
                    this.goTo(this._focusedItemIndex);
                }
            }
        },
        {
            key: "startPointMode",
            get: function get() {
                return this._startPointMode;
            },
            set: function set(value) {
                if (_rowconstants.START_POINT_MODES.includes(value) && this._startPointMode !== value) {
                    this._startPointMode = value;
                    this._updateContentPlacementStartPoint();
                    this.goTo(this._focusedItemIndex);
                }
            }
        },
        {
            key: "contentGap",
            get: function get() {
                return this._contentGap;
            },
            set: function set(value) {
                this._contentGap = value;
                this._updateContentPlacementStartPoint();
                this.goTo(this._focusedItemIndex);
            }
        },
        {
            key: "leftPadding",
            get: function get() {
                return this._leftPadding;
            },
            set: function set(value) {
                this._leftPadding = value;
                this._updateContentPlacementStartPoint();
                this.goTo(this._focusedItemIndex);
            }
        },
        {
            key: "rightPadding",
            get: function get() {
                return this._rightPadding;
            },
            set: function set(value) {
                this._rightPadding = value;
                this._updateContentPlacementStartPoint();
                this.goTo(this._focusedItemIndex);
            }
        },
        {
            key: "focusedIndex",
            get: function get() {
                return this._focusedItemIndex;
            },
            set: function set(value) {
                this._focusedItemIndex = value;
            }
        },
        {
            key: "goTo",
            value: function goTo(index) {
                this._setIndex(index);
            }
        },
        {
            key: "_setIndex",
            value: function _setIndex(index) {
                var shouldAnimate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                this._focusedItemIndex = index;
                if (!this._totalItems) {
                    return;
                }
                if (shouldAnimate) {
                    this._animateTo(this._focusedItemIndex);
                } else {
                    this._moveTo(this._focusedItemIndex);
                }
                if (this._isRowActive) {
                    this._placeItems();
                }
                this.signal(_signals.FOCUSED_SIGNAL, index);
                if (this._itemsPerPage > 0 && this._pages) {
                    var currentPage = Math.floor(this._focusedItemIndex / this._itemsPerPage);
                    // NOTE: the first page will be empty in case if the Row is used within a Selector block
                    var nextPage = this._pages[0] === _virtualization.PAGE_STATE.LOADED ? currentPage + 1 : 0;
                    if (currentPage !== nextPage) {
                        this._requestPage(currentPage);
                        // In case the row was restored with anchoring from a backward navigation
                        if (currentPage - 1 >= 0) {
                            this._requestPage(currentPage - 1);
                        }
                    }
                    this._requestPage(nextPage);
                }
            }
        },
        {
            /**
   * Sends a signal requesting a specific page of items
   *
   * @param {Number} page zero-based page index
   */ key: "_requestPage",
            value: function _requestPage(page) {
                if (this._pages[page] !== _virtualization.PAGE_STATE.MISSING) {
                    return;
                }
                this.signal(_signals.PORTION_REQUESTED_SIGNAL, {
                    // NOTE: BFF API requires the pages to be 1-based
                    page: page + 1,
                    start: page * this._itemsPerPage,
                    id: this.id
                });
            }
        },
        {
            key: "_focus",
            value: function _focus() {
                // Handle a case when some items disappearing on a far row edge upon sidenav opening
                this._placeItems();
            }
        },
        {
            key: "_getFocused",
            value: function _getFocused() {
                return this._views[this._focusedItemIndex];
            }
        },
        {
            key: "_makeItemData",
            value: function _makeItemData(content, index) {
                var _this__data = this._data, itemSize = _this__data.itemSize, itemTemplate = _this__data.itemTemplate;
                return {
                    content: content,
                    index: index,
                    config: itemSize,
                    template: itemTemplate,
                    colorScheme: this._colorScheme
                };
            }
        },
        {
            key: "_getMaxOffset",
            value: function _getMaxOffset() {
                if (!this._data || !this._totalItems) {
                    return 0;
                }
                var itemWidthWithGap = this._data.itemSize.w + this._contentGap;
                var allItemsSize = this._totalItems * itemWidthWithGap - this._contentGap;
                return this.finalW - this._leftPadding - this._rightPadding - allItemsSize;
            }
        },
        {
            key: "_updateContentPlacementStartPoint",
            value: function _updateContentPlacementStartPoint() {
                if (!this._data || this._startPointMode === _rowconstants.START_POINT_MODE_LEFT) {
                    this._startPoint = 0;
                    return;
                }
                this._startPoint = Math.max(Math.round(this._getMaxOffset() / 2), 0);
            }
        },
        {
            key: "_offsetByIndex",
            value: function _offsetByIndex(index) {
                if (!this._data || !this._totalItems) {
                    return 0;
                }
                var itemWidthWithGap = this._data.itemSize.w + this._contentGap;
                var maxOffset = Math.min(this._getMaxOffset(), 0);
                var offset = -index * itemWidthWithGap;
                if (this._focusMode === _rowconstants.FOCUS_MODE_CENTER) {
                    return Math.max(Math.min(0, offset + Math.round(this.finalW - this._data.itemSize.w) / 2 - this._leftPadding), maxOffset);
                }
                return Math.max(Math.min(0, offset), maxOffset);
            }
        },
        {
            key: "_animateTo",
            value: function _animateTo(index) {
                this._offset = this._offsetByIndex(index);
                this.tag("Container").setSmooth("x", this._offset);
            }
        },
        {
            key: "_moveTo",
            value: function _moveTo(index) {
                this._offset = this._offsetByIndex(index);
                this.tag("Container").x = this._offset;
            }
        },
        {
            key: "_handleLeft",
            value: function _handleLeft() {
                if (this._focusedItemIndex > 0) {
                    this._setIndex(this._focusedItemIndex - 1, true);
                    return true;
                }
                return false;
            }
        },
        {
            key: "_handleRight",
            value: function _handleRight() {
                if (this._focusedItemIndex < this._totalItems - 1) {
                    this._setIndex(this._focusedItemIndex + 1, true);
                    return true;
                }
                return false;
            }
        },
        {
            key: "_getFromBufferOrCreate",
            value: function _getFromBufferOrCreate() {
                var _this__data = this._data, itemType = _this__data.itemType, itemSize = _this__data.itemSize, itemTemplate = _this__data.itemTemplate;
                var existingView = (0, _virtualization.getFromBuffer)(itemTemplate);
                if (existingView) {
                    return existingView;
                }
                var _obj;
                return this.stage.c({
                    type: itemType,
                    w: itemSize.w,
                    h: itemSize.h,
                    template: itemTemplate,
                    passSignals: _define_property._({}, _signals.SELECTED_SIGNAL, true),
                    signals: (_obj = {}, _define_property._(_obj, _signals.INACTIVE_SIGNAL, "_onViewBecomeInactive"), _define_property._(_obj, _signals.DETACHED_SIGNAL, "_onViewBecomeDetached"), _obj)
                });
            }
        },
        {
            key: "_onViewBecomeInactive",
            value: function _onViewBecomeInactive(view) {
                if (view.item) {
                // this.signal(IMPRESSION_UNTRACK_SIGNAL, this._blockIndex, [view.item.index]);
                }
                if (this._isRowAttached) {
                    this._backToBuffer(view);
                }
            }
        },
        {
            key: "_onViewBecomeDetached",
            value: function _onViewBecomeDetached(view) {
                (0, _virtualization.cleanupBuffer)(view);
            }
        },
        {
            key: "_backToBuffer",
            value: function _backToBuffer(view) {
                var _this = this;
                Object.keys(this._views).filter(function(key) {
                    return _this._views[key].id === view.id;
                }).forEach(function(key) {
                    delete _this._views[key];
                });
                (0, _virtualization.backToBuffer)(view);
                view.visible = false;
            }
        },
        {
            key: "_getItemX",
            value: function _getItemX(index) {
                return this._startPoint + (this._data.itemSize.w + this._contentGap) * index;
            }
        },
        {
            key: "_placeItems",
            value: function _placeItems() {
                if (!this._data) {
                    return;
                }
                var container = this.tag("Container");
                var viewportWidth = this.finalW;
                var itemWidthWithGap = this._data.itemSize.w + this._contentGap;
                var maximalOffset = this._focusedItemIndex * itemWidthWithGap;
                var left = maximalOffset + this._offset + this._leftPadding;
                var right = viewportWidth - left;
                var itemsLeft = Math.ceil(left / itemWidthWithGap);
                var itemsRight = Math.ceil(right / itemWidthWithGap);
                var toRender = [];
                var startIndex = Math.max(this._focusedItemIndex - itemsLeft, 0);
                var endIndex = Math.min(this._focusedItemIndex + itemsRight, this._totalItems - 1);
                var impressionLeft = -this._offset;
                var impressionRight = impressionLeft + viewportWidth - this._leftPadding - this._contentGap;
                // console.log(`[Row] Impression bounds: ${impressionLeft} to ${impressionRight}, offset: ${this._offset}`);
                for(var i = startIndex; i <= endIndex; i += 1){
                    toRender.push(i);
                }
                var tracked = [];
                for(var i1 = 0; i1 < toRender.length; i1 += 1){
                    var index = toRender[i1];
                    var x = this._getItemX(index);
                    var view = this._views[index];
                    if (!view) {
                        view = this._getFromBufferOrCreate();
                    }
                    view.index = index;
                    if (this._items[index]) {
                        view.item = this._items[index];
                        if (x >= impressionLeft && x + this._data.itemSize.w <= impressionRight) {
                            // eslint-disable-next-line no-console
                            // console.log(`[Row] Row ${this._blockIndex} item ${view.item.title} is on screen`);
                            tracked.push(index);
                        }
                    } else {
                        view.item = this._makeItemData(_virtualization.PLACEHOLDER, index);
                    }
                    view.x = x;
                    view.visible = true;
                    if (view.parent !== container) {
                        container.childList.add(view);
                    }
                    this._views[index] = view;
                }
                var untracked = toRender.filter(function(index) {
                    return !tracked.includes(index);
                });
                if (tracked.length) {
                    this.signal(_signals.IMPRESSION_TRACK_SIGNAL, this._blockIndex, tracked);
                }
                if (untracked.length) {
                    this.signal(_signals.IMPRESSION_UNTRACK_SIGNAL, this._blockIndex, untracked);
                }
            }
        },
        {
            key: "_resetVirtualization",
            value: function _resetVirtualization() {
                this._itemBlueprint = {};
                this._data = undefined;
                this._isDataApplied = false;
                this._focusedItemIndex = 0;
                this._offset = 0;
                this._itemsPerPage = 0;
                this._startPoint = 0;
                this._items = [];
                this._views = {};
                this._pages = {};
                this._focusMode = _rowconstants.FOCUS_MODE_CENTER;
                this._startPointMode = _rowconstants.START_POINT_MODE_LEFT;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                var _obj;
                return {
                    Container: {},
                    passSignals: (_obj = {}, _define_property._(_obj, _signals.SELECTED_SIGNAL, true), _define_property._(_obj, _signals.SHOW_GRID_SIGNAL, true), _define_property._(_obj, _signals.PORTION_REQUESTED_SIGNAL, true), _define_property._(_obj, _signals.IMPRESSION_TRACK_SIGNAL, true), _define_property._(_obj, _signals.IMPRESSION_UNTRACK_SIGNAL, true), _obj)
                };
            }
        }
    ]);
    return Row;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 7395:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    FOCUS_MODES: function() {
        return FOCUS_MODES;
    },
    FOCUS_MODE_CENTER: function() {
        return FOCUS_MODE_CENTER;
    },
    FOCUS_MODE_LEFT: function() {
        return FOCUS_MODE_LEFT;
    },
    ITEMS_PLACEMENT_TIMEOUT: function() {
        return ITEMS_PLACEMENT_TIMEOUT;
    },
    START_POINT_MODES: function() {
        return START_POINT_MODES;
    },
    START_POINT_MODE_CENTER: function() {
        return START_POINT_MODE_CENTER;
    },
    START_POINT_MODE_LEFT: function() {
        return START_POINT_MODE_LEFT;
    }
});
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(37815);
var ITEMS_PLACEMENT_TIMEOUT = 100;
var FOCUS_MODE_CENTER = "center";
var FOCUS_MODE_LEFT = "left";
var FOCUS_MODES = [
    FOCUS_MODE_CENTER,
    FOCUS_MODE_LEFT
];
var START_POINT_MODE_CENTER = "center";
var START_POINT_MODE_LEFT = "left";
var START_POINT_MODES = [
    START_POINT_MODE_CENTER,
    START_POINT_MODE_LEFT
];


/***/ }),

/***/ 23593:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    CONTENT_GAP: function() {
        return _constants.CONTENT_GAP;
    },
    defaultContext: function() {
        return defaultContext;
    }
});
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(52318);
var _style = __webpack_require__(65082);
var _constants = __webpack_require__(34952);
var defaultContext = (0, _style.makeDefaultStylingContext)();


/***/ }),

/***/ 86390:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return CTAShader;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _get = __webpack_require__(60528);
var _get_prototype_of = __webpack_require__(35196);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(3009);
var _sdk = __webpack_require__(29956);
var CTAShader = /*#__PURE__*/ function(_Lightning_shaders_WebGLDefaultShader) {
    "use strict";
    _inherits._(CTAShader, _Lightning_shaders_WebGLDefaultShader);
    var _super = _create_super._(CTAShader);
    function CTAShader(context) {
        _class_call_check._(this, CTAShader);
        var _this;
        _this = _super.call(this, context);
        _this._radius = 0;
        _this._borderWidth = 0;
        _this._progress = 0;
        _this._fc = 0x00ffffff;
        _this._pc = 0x00ffffff;
        _this._ibc = 0x00ffffff;
        _this._obc = 0x00ffffff;
        _this._fillColor = _this._getNormalizedColor(_this._fc);
        _this._progressColor = _this._getNormalizedColor(_this._pc);
        _this._outerBorderColor = _this._getNormalizedColor(_this._ibc);
        _this._outerBorderColor = _this._getNormalizedColor(_this._obc);
        return _this;
    }
    _create_class._(CTAShader, [
        {
            key: "radius",
            get: function get() {
                return this._radius;
            },
            set: function set(v) {
                this._radius = v;
                this.redraw();
            }
        },
        {
            key: "progress",
            get: function get() {
                return this._progress;
            },
            set: function set(value) {
                this._progress = value;
                this.redraw();
            }
        },
        {
            key: "topLeft",
            get: function get() {
                return this._radius[0];
            },
            set: function set(num) {
                this._radius[0] = num;
                this.redraw();
            }
        },
        {
            key: "topRight",
            get: function get() {
                return this._radius[1];
            },
            set: function set(num) {
                this._radius[1] = num;
                this.redraw();
            }
        },
        {
            key: "bottomRight",
            get: function get() {
                return this._radius[2];
            },
            set: function set(num) {
                this._radius[2] = num;
                this.redraw();
            }
        },
        {
            key: "bottomLeft",
            get: function get() {
                return this._radius[4];
            },
            set: function set(num) {
                this._radius[3] = num;
                this.redraw();
            }
        },
        {
            key: "outerBorderColor",
            get: function get() {
                return this._obc;
            },
            set: function set(argb) {
                this._obc = argb;
                this._outerBorderColor = this._getNormalizedColor(argb);
                this.redraw();
            }
        },
        {
            key: "innerBorderColor",
            get: function get() {
                return this._ibc;
            },
            set: function set(argb) {
                this._ibc = argb;
                this._innerBorderColor = this._getNormalizedColor(argb);
                this.redraw();
            }
        },
        {
            key: "fillColor",
            get: function get() {
                return this._fc;
            },
            set: function set(argb) {
                this._fc = argb;
                this._fillColor = this._getNormalizedColor(argb);
                this.redraw();
            }
        },
        {
            key: "progressColor",
            get: function get() {
                return this._pc;
            },
            set: function set(argb) {
                this._pc = argb;
                this._progressColor = this._getNormalizedColor(argb);
                this.redraw();
            }
        },
        {
            key: "borderWidth",
            get: function get() {
                return this._borderWidth;
            },
            set: function set(num) {
                this._borderWidth = num;
                this.redraw();
            }
        },
        {
            key: "_getNormalizedColor",
            value: function _getNormalizedColor(color) {
                var col = _sdk.Lightning.StageUtils.getRgbaComponentsNormalized(color);
                col[0] *= col[3];
                col[1] *= col[3];
                col[2] *= col[3];
                return new Float32Array(col);
            }
        },
        {
            key: "setupUniforms",
            value: function setupUniforms(operation) {
                _get._(_get_prototype_of._(CTAShader.prototype), "setupUniforms", this).call(this, operation);
                var owner = operation.shaderOwner;
                var renderPrecision = this.ctx.stage.getRenderPrecision();
                this._setUniform("radius", this._radius * renderPrecision, this.gl.uniform1f);
                this._setUniform("scale", 1, this.gl.uniform1f);
                this._setUniform("progress", this._progress, this.gl.uniform1f);
                this._setUniform("borderWidth", this._borderWidth * renderPrecision, this.gl.uniform1f);
                this._setUniform("fillColor", this._fillColor, this.gl.uniform4fv);
                this._setUniform("progressColor", this._progressColor, this.gl.uniform4fv);
                this._setUniform("innerBorderColor", this._innerBorderColor, this.gl.uniform4fv);
                this._setUniform("outerBorderColor", this._outerBorderColor, this.gl.uniform4fv);
                this._setUniform("resolution", new Float32Array([
                    owner._w * renderPrecision,
                    owner._h * renderPrecision
                ]), this.gl.uniform2fv);
            }
        }
    ]);
    return CTAShader;
}(_sdk.Lightning.shaders.WebGLDefaultShader);
CTAShader.vertexShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    attribute vec2 aVertexPosition;\n    attribute vec2 aTextureCoord;\n\n    uniform vec2 projection;\n    varying vec2 vTextureCoord;\n\n    void main(void){\n        gl_Position = vec4(aVertexPosition.x * projection.x - 1.0, aVertexPosition.y * -abs(projection.y) + 1.0, 0.0, 1.0);\n        vTextureCoord = aTextureCoord;\n        gl_Position.y = -sign(projection.y) * gl_Position.y;\n    }\n";
CTAShader.fragmentShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n\n    varying vec2 vTextureCoord;\n\n    uniform float radius;\n    uniform float borderWidth;\n    uniform float scale;\n    uniform float progress;\n    uniform float imageMaskFactor;\n    uniform vec2 resolution;\n    uniform vec4 fillColor;\n    uniform vec4 progressColor;\n    uniform vec4 innerBorderColor;\n    uniform vec4 outerBorderColor;\n\n    float boxDist(vec2 p, vec2 size, float radius) {\n      size -= vec2(radius);\n      vec2 d = abs(p) - size;\n\n      return min(max(d.x, d.y), 0.0) + length(max(d, 0.0)) - radius;\n    }\n\n    float fillMask(float dist) {\n        return clamp(-dist, 0.0, 1.0);\n    }\n\n    vec2 texCoordsWithOffset(float offset) {\n        vec2 texCoordsMultiplier = (1.0 + (offset * 2.0) / resolution);\n        vec2 texCoordsOffset = offset / resolution;\n\n        return vTextureCoord * texCoordsMultiplier - texCoordsOffset;\n    }\n\n    void main() {\n      vec2 halfRes = resolution * 0.5;\n      vec2 halfResOffset = halfRes + 0.5;\n      vec2 texCoords = texCoordsWithOffset(borderWidth / scale);\n\n      float imageDistance = boxDist(texCoords * resolution - halfRes, halfResOffset, radius / scale);\n      float imageMask = fillMask(imageDistance);\n      vec4 backgroundColor = fillColor;\n\n      if (texCoords.x < progress) {\n        backgroundColor.rgb = progressColor.rgb;\n      }\n\n      float outerRadius = (radius + borderWidth * 0.375) / scale;\n      // NOTE: it should be exactly half of the border, but 0.45 simply looks better\n      float borderInnerDistance = boxDist(texCoordsWithOffset((borderWidth * 0.45) / scale) * resolution - halfRes, halfResOffset, outerRadius);\n      float borderOuterDistance = boxDist(vTextureCoord * resolution - halfRes, halfRes, outerRadius + borderWidth * 0.125);\n      vec4 border = mix(outerBorderColor, innerBorderColor, fillMask(borderInnerDistance));\n      border = mix(backgroundColor * imageMask, border, fillMask(borderOuterDistance) - imageMask);\n\n      gl_FragColor = border;\n    }\n";


/***/ }),

/***/ 67579:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return FocusShader;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _get = __webpack_require__(60528);
var _get_prototype_of = __webpack_require__(35196);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(52318);
var _sdk = __webpack_require__(29956);
var _colors = __webpack_require__(8426);
var FocusShader = /*#__PURE__*/ function(_Lightning_shaders_WebGLDefaultShader) {
    "use strict";
    _inherits._(FocusShader, _Lightning_shaders_WebGLDefaultShader);
    var _super = _create_super._(FocusShader);
    function FocusShader(context) {
        _class_call_check._(this, FocusShader);
        var _this;
        _this = _super.call(this, context);
        _this._radius = 0;
        _this._outline = 0;
        _this._scale = 1.0;
        _this._imageMaskFactor = 0.0;
        _this._strokeColorRaw = _colors.TRANSPARENT;
        _this._innerColorRaw = _colors.TRANSPARENT;
        _this._strokeColor = _this._getNormalizedColor(_this._strokeColorRaw);
        _this._innerColor = _this._getNormalizedColor(_this._innerColorRaw);
        return _this;
    }
    _create_class._(FocusShader, [
        {
            key: "scale",
            get: function get() {
                return this._scale;
            },
            set: function set(v) {
                this._scale = Math.max(v, 0);
                this.redraw();
            }
        },
        {
            key: "radius",
            get: function get() {
                return this._radius;
            },
            set: function set(v) {
                this._radius = v;
                this.redraw();
            }
        },
        {
            key: "strokeColor",
            get: function get() {
                return this._strokeColorRaw;
            },
            set: function set(color) {
                this._strokeColorRaw = color;
                this._strokeColor = this._getNormalizedColor(color);
                this.redraw();
            }
        },
        {
            key: "innerColor",
            get: function get() {
                return this._innerColorRaw;
            },
            set: function set(color) {
                this._innerColorRaw = color;
                this._innerColor = this._getNormalizedColor(color);
                this.redraw();
            }
        },
        {
            key: "outline",
            get: function get() {
                return this._outline;
            },
            set: /**
   * Maximal possible stroke thickness
   */ function set(v) {
                this._outline = v;
                this.redraw();
            }
        },
        {
            key: "useImageMask",
            get: function get() {
                return Boolean(this._imageMaskFactor);
            },
            set: function set(v) {
                this._imageMaskFactor = v ? 1 : 0;
                this.redraw();
            }
        },
        {
            key: "_getNormalizedColor",
            value: function _getNormalizedColor(color) {
                var useAlphaChannel = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                var col = _sdk.Lightning.StageUtils.getRgbaComponentsNormalized(color);
                if (useAlphaChannel) {
                    col[0] *= col[3];
                    col[1] *= col[3];
                    col[2] *= col[3];
                }
                return new Float32Array(col);
            }
        },
        {
            key: "setupUniforms",
            value: function setupUniforms(operation) {
                _get._(_get_prototype_of._(FocusShader.prototype), "setupUniforms", this).call(this, operation);
                var owner = operation.shaderOwner;
                var renderPrecision = this.ctx.stage.getRenderPrecision();
                this._setUniform("radius", this._radius, this.gl.uniform1f);
                this._setUniform("strokeColor", this._strokeColor, this.gl.uniform4fv);
                this._setUniform("innerColor", this._innerColor, this.gl.uniform4fv);
                this._setUniform("outline", this._outline * renderPrecision, this.gl.uniform1f);
                this._setUniform("imageMaskFactor", this._imageMaskFactor, this.gl.uniform1f);
                this._setUniform("scale", this._scale, this.gl.uniform1f);
                this._setUniform("resolution", new Float32Array([
                    owner._w * renderPrecision,
                    owner._h * renderPrecision
                ]), this.gl.uniform2fv);
            }
        }
    ]);
    return FocusShader;
}(_sdk.Lightning.shaders.WebGLDefaultShader);
FocusShader.vertexShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    attribute vec2 aVertexPosition;\n    attribute vec2 aTextureCoord;\n\n    uniform vec2 projection;\n    varying vec2 vTextureCoord;\n\n    void main(void){\n        gl_Position = vec4(aVertexPosition.x * projection.x - 1.0, aVertexPosition.y * -abs(projection.y) + 1.0, 0.0, 1.0);\n        vTextureCoord = aTextureCoord;\n        gl_Position.y = -sign(projection.y) * gl_Position.y;\n    }\n";
FocusShader.fragmentShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n\n    varying vec2 vTextureCoord;\n\n    uniform vec2 resolution;\n    uniform float radius;\n    uniform float outline;\n    uniform float scale;\n    uniform float imageMaskFactor;\n    uniform vec4 strokeColor;\n    uniform vec4 innerColor;\n\n    float boxDist(vec2 p, vec2 size, float radius) {\n      size -= vec2(radius);\n      vec2 d = abs(p) - size;\n\n      return min(max(d.x, d.y), 0.0) + length(max(d, 0.0)) - radius;\n    }\n\n    float fillMask(float dist) {\n        return clamp(-dist, 0.0, 1.0);\n    }\n\n    vec2 texCoordsWithOffset(float offset) {\n        vec2 texCoordsMultiplier = (1.0 + (offset * 2.0) / resolution);\n        vec2 texCoordsOffset = offset / resolution;\n\n        return vTextureCoord * texCoordsMultiplier - texCoordsOffset;\n    }\n\n    void main() {\n      vec2 halfRes = resolution * 0.5;\n      vec2 halfResOffset = halfRes + 0.5;\n      vec2 texCoords = texCoordsWithOffset(outline / scale);\n\n      float imageMask = 0.0;\n      if (imageMaskFactor > 0.0) {\n        float imageDistance = boxDist(texCoords * resolution - halfRes, halfResOffset, radius / scale);\n        imageMask = fillMask(imageDistance) * imageMaskFactor;\n      }\n\n      float outerRadius = (radius + outline * 0.375) / scale;\n      float borderInnerDistance = boxDist(texCoordsWithOffset((outline * 0.5) / scale) * resolution - halfRes, halfResOffset, outerRadius);\n      float borderOuterDistance = boxDist(vTextureCoord * resolution - halfRes, halfRes, outerRadius + outline * 0.125);\n      vec4 border = mix(strokeColor, innerColor, fillMask(borderInnerDistance));\n      border = mix(vec4(0.0), border, fillMask(borderOuterDistance) - imageMask);\n\n      gl_FragColor = border;\n    }\n";


/***/ }),

/***/ 28604:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return FlareShader;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _get = __webpack_require__(60528);
var _get_prototype_of = __webpack_require__(35196);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(37815);
var _sdk = __webpack_require__(29956);
var FlareShader = /*#__PURE__*/ function(_Lightning_shaders_WebGLDefaultShader) {
    "use strict";
    _inherits._(FlareShader, _Lightning_shaders_WebGLDefaultShader);
    var _super = _create_super._(FlareShader);
    function FlareShader(ctx) {
        _class_call_check._(this, FlareShader);
        var _this;
        _this = _super.call(this, ctx);
        _this._lineX = 0.0;
        _this._radius = 0.0;
        _this._rotation = 0.0;
        return _this;
    }
    _create_class._(FlareShader, [
        {
            key: "lineX",
            get: function get() {
                return this._lineX;
            },
            set: function set(value) {
                this._lineX = value;
                this.redraw();
            }
        },
        {
            key: "radius",
            get: function get() {
                return this._radius;
            },
            set: function set(value) {
                this._radius = value;
                this.redraw();
            }
        },
        {
            key: "rotation",
            get: function get() {
                return this._rotation;
            },
            set: function set(value) {
                this._rotation = value;
                this.redraw();
            }
        },
        {
            key: "setupUniforms",
            value: function setupUniforms(operation) {
                _get._(_get_prototype_of._(FlareShader.prototype), "setupUniforms", this).call(this, operation);
                var _this = this, ctx = _this.ctx, gl = _this.gl;
                var _ctx_stage = ctx.stage, w = _ctx_stage.w, h = _ctx_stage.h;
                var _operation_shaderOwner = operation.shaderOwner, _w = _operation_shaderOwner._w, _h = _operation_shaderOwner._h;
                var renderPrecision = this.ctx.stage.getRenderPrecision();
                this._setUniform("uLineX", this._lineX, gl.uniform1f);
                this._setUniform("uRadius", this._radius, gl.uniform1f);
                this._setUniform("uRotation", this._rotation, gl.uniform1f);
                this._setUniform("uResolution", [
                    w,
                    h
                ], gl.uniform2fv);
                this._setUniform("projection", this._getProjection(operation), gl.uniform2fv, false);
                this._setUniform("uSize", new Float32Array([
                    _w * renderPrecision,
                    _h * renderPrecision
                ]), this.gl.uniform2fv);
            }
        }
    ]);
    return FlareShader;
}(_sdk.Lightning.shaders.WebGLDefaultShader);
FlareShader.vertexShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n\n    attribute vec2 aVertexPosition;\n    attribute vec2 aTextureCoord;\n    attribute vec2 aVertex;\n    attribute vec4 aColor;\n\n    varying vec4 vColor;\n    varying vec2 vTextureCoord;\n\n    uniform vec2 projection;\n\n    void main(void) {\n        gl_Position = vec4(aVertexPosition.x * projection.x - 1.0, aVertexPosition.y * -abs(projection.y) + 1.0, 0.0, 1.0);\n        gl_Position.y = -sign(projection.y) * gl_Position.y;\n\n        vTextureCoord = aTextureCoord;\n        vColor = aColor;\n    }\n";
FlareShader.fragmentShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n\n    #define PI 3.14159\n\n    varying vec4 vColor;\n    varying vec2 vTextureCoord;\n\n    uniform vec2 uResolution;\n    uniform vec2 uSize;\n    uniform float uLineX;\n    uniform float uRadius;\n    uniform float uRotation;\n\n    float boxDist(vec2 p, vec2 size, float radius) {\n      size -= vec2(radius);\n      vec2 d = abs(p) - size;\n      return min(max(d.x, d.y), 0.0) + length(max(d, 0.0)) - radius;\n    }\n\n    void main() {\n      float angle = radians(uRotation);\n      float cosA = cos(angle);\n      float sinA = sin(angle);\n      mat2 rotation = mat2(cosA, -sinA, sinA, cosA);\n\n      vec2 uv = ((gl_FragCoord.xy / uResolution.xy) - vec2(0.5)) * rotation + vec2(0.5);\n\n      vec2 halfRes = 0.5 * uSize.xy;\n      float mask = boxDist(vTextureCoord.xy * uSize - halfRes, halfRes - 0.005, uRadius);\n\n      float line = uLineX / uResolution.x;\n      float distanceToLine = uv.x - line;\n      float absoluteDistance = pow(pow(distanceToLine, 2.0), 0.5);\n\n      gl_FragColor = mix(vec4(0.0), vec4(vec3(max(1.0 - absoluteDistance, 0.75)), 1.0) * vColor, clamp(-mask, 0.0, 1.0));\n    }\n";


/***/ }),

/***/ 25906:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(42578);
var _focusshader = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67579));
var _default = _focusshader.default;


/***/ }),

/***/ 17154:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return ImageShader;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _get = __webpack_require__(60528);
var _get_prototype_of = __webpack_require__(35196);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(42578);
var _sdk = __webpack_require__(29956);
var _colors = __webpack_require__(8426);
var ImageShader = /*#__PURE__*/ function(_Lightning_shaders_WebGLDefaultShader) {
    "use strict";
    _inherits._(ImageShader, _Lightning_shaders_WebGLDefaultShader);
    var _super = _create_super._(ImageShader);
    function ImageShader(context) {
        _class_call_check._(this, ImageShader);
        var _this;
        _this = _super.call(this, context);
        _this._radius = 0;
        _this._scale = 1.0;
        _this._progress = 0.0;
        _this._progressBarColorRaw = _colors.TRANSPARENT;
        _this._progressBackgroundColorRaw = _colors.TRANSPARENT;
        _this._overlayColorRaw = _colors.TRANSPARENT;
        _this._progressBarColor = _this._getNormalizedColor(_this._progressBarColorRaw);
        _this._progressBackgroundColor = _this._getNormalizedColor(_this._progressBackgroundColorRaw);
        _this._overlayColor = _this._getNormalizedColor(_this._overlayColorRaw);
        _this._progressHeight = 0;
        return _this;
    }
    _create_class._(ImageShader, [
        {
            key: "scale",
            get: function get() {
                return this._scale;
            },
            set: function set(v) {
                this._scale = Math.max(v, 0);
                this.redraw();
            }
        },
        {
            key: "radius",
            get: function get() {
                return this._radius;
            },
            set: function set(v) {
                this._radius = v;
                this.redraw();
            }
        },
        {
            key: "progressBarColor",
            get: function get() {
                return this._progressBarColorRaw;
            },
            set: function set(color) {
                this._progressBarColorRaw = color;
                this._progressBarColor = this._getNormalizedColor(color);
                this.redraw();
            }
        },
        {
            key: "progressBackgroundColor",
            get: function get() {
                return this._progressBackgroundColorRaw;
            },
            set: function set(color) {
                this._progressBackgroundColorRaw = color;
                this._progressBackgroundColor = this._getNormalizedColor(color, false);
                this.redraw();
            }
        },
        {
            key: "overlayColor",
            get: function get() {
                return this._overlayColorRaw;
            },
            set: function set(color) {
                this._overlayColorRaw = color;
                this._overlayColor = this._getNormalizedColor(color, false);
                this.redraw();
            }
        },
        {
            key: "progressHeight",
            get: function get() {
                return this._progressHeight;
            },
            set: function set(value) {
                this._progressHeight = value;
                this.redraw();
            }
        },
        {
            key: "progress",
            get: function get() {
                return this._progress;
            },
            set: function set(num) {
                this._progress = num;
                this.redraw();
            }
        },
        {
            key: "_getNormalizedColor",
            value: function _getNormalizedColor(color) {
                var useAlphaChannel = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                var col = _sdk.Lightning.StageUtils.getRgbaComponentsNormalized(color);
                if (useAlphaChannel) {
                    col[0] *= col[3];
                    col[1] *= col[3];
                    col[2] *= col[3];
                }
                return new Float32Array(col);
            }
        },
        {
            key: "setupUniforms",
            value: function setupUniforms(operation) {
                _get._(_get_prototype_of._(ImageShader.prototype), "setupUniforms", this).call(this, operation);
                var owner = operation.shaderOwner;
                var renderPrecision = this.ctx.stage.getRenderPrecision();
                this._setUniform("radius", this._radius, this.gl.uniform1f);
                this._setUniform("progressColor", this._progressBackgroundColor, this.gl.uniform4fv);
                this._setUniform("progressBarColor", this._progressBarColor, this.gl.uniform4fv);
                this._setUniform("overlayColor", this._overlayColor, this.gl.uniform4fv);
                this._setUniform("scale", this._scale, this.gl.uniform1f);
                this._setUniform("progress", this._progress, this.gl.uniform1f);
                this._setUniform("progressHeight", this._progressHeight, this.gl.uniform1f);
                this._setUniform("resolution", new Float32Array([
                    owner._w * renderPrecision,
                    owner._h * renderPrecision
                ]), this.gl.uniform2fv);
            }
        }
    ]);
    return ImageShader;
}(_sdk.Lightning.shaders.WebGLDefaultShader);
ImageShader.vertexShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    attribute vec2 aVertexPosition;\n    attribute vec2 aTextureCoord;\n\n    attribute vec4 aColor;\n    uniform vec2 projection;\n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n\n    void main(void){\n        gl_Position = vec4(aVertexPosition.x * projection.x - 1.0, aVertexPosition.y * -abs(projection.y) + 1.0, 0.0, 1.0);\n        vTextureCoord = aTextureCoord;\n        vColor = aColor;\n        gl_Position.y = -sign(projection.y) * gl_Position.y;\n    }\n";
ImageShader.fragmentShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n\n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n\n    uniform sampler2D uSampler;\n    uniform vec2 resolution;\n    uniform float radius;\n    uniform float scale;\n    uniform float progress;\n    uniform float progressHeight;\n    uniform vec4 progressBarColor;\n    uniform vec4 progressColor;\n    uniform vec4 overlayColor;\n\n    vec3 blendNormal(vec3 base, vec3 blend, float opacity) {\n      return (blend * opacity + base * (1.0 - opacity));\n    }\n\n    float boxDist(vec2 p, vec2 size, float radius) {\n      size -= vec2(radius);\n      vec2 d = abs(p) - size;\n\n      return min(max(d.x, d.y), 0.0) + length(max(d, 0.0)) - radius;\n    }\n\n    float fillMask(float dist) {\n        return clamp(-dist, 0.0, 1.0);\n    }\n\n    vec2 texCoordsWithOffset(float offset) {\n        vec2 texCoordsMultiplier = (1.0 + (offset * 2.0) / resolution);\n        vec2 texCoordsOffset = offset / resolution;\n\n        return vTextureCoord * texCoordsMultiplier - texCoordsOffset;\n    }\n\n    void main() {\n        vec2 halfRes = resolution * 0.5;\n        vec2 halfResOffset = halfRes + 0.5;\n        vec4 texture = texture2D(uSampler, vTextureCoord) * vColor;\n\n        if (overlayColor.a > 0.0) {\n          float topAlpha = 0.3;\n          float bottomAlpha = 0.6;\n          float globalAlpha = 0.1;\n          float topOverlay = clamp(1.0 - (vTextureCoord.y / 0.25), 0.0, 1.0) * topAlpha;\n          float bottomOverlay = clamp((vTextureCoord.y / 0.5 - 1.0), 0.0, 1.0) * bottomAlpha;\n          float overlay = bottomOverlay + topOverlay + globalAlpha;\n          texture = vec4(blendNormal(texture.rgb, overlayColor.rgb, overlay), 1.0);\n        }\n\n        float imageDistance = boxDist(vTextureCoord * resolution - halfRes, halfResOffset, radius / scale);\n        float imageMask = fillMask(imageDistance);\n\n        vec4 image = mix(vec4(0.0), texture, imageMask);\n\n        if (progress > 0.0) {\n          float offset = scale - 1.0;\n          float halfOffset = offset / 2.0;\n          vec2 texCoordsScaled = vTextureCoord * scale;\n\n          float barHeight = progressHeight / resolution.y;\n          float progressXStart = step(halfOffset, texCoordsScaled.x);\n          float progressXEnd = 1.0 - step(progress + halfOffset, texCoordsScaled.x);\n          float progressYStart = step(1.0 - barHeight + halfOffset, texCoordsScaled.y);\n          float progressBgXEnd = 1.0 - step(1.0 + halfOffset, texCoordsScaled.x);\n          float progressBgYEnd = 1.0 - step(1.0 + halfOffset, texCoordsScaled.y);\n          float progressEndMask = progressBgXEnd * progressBgYEnd;\n\n          float progressMask = progressYStart * progressXStart * progressEndMask * imageMask;\n          float progressBarMask = progressMask * progressXEnd;\n\n          image = vec4(blendNormal(image.rgb, progressColor.rgb, progressColor.a * progressMask), 1.0);\n          image = mix(image, progressBarColor, progressBarMask);\n        }\n\n        gl_FragColor = vec4(image.rgb, imageMask);\n    }\n";


/***/ }),

/***/ 40521:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return PillShader;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _get = __webpack_require__(60528);
var _get_prototype_of = __webpack_require__(35196);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(42578);
var _sdk = __webpack_require__(29956);
var PillShader = /*#__PURE__*/ function(_Lightning_shaders_WebGLDefaultShader) {
    "use strict";
    _inherits._(PillShader, _Lightning_shaders_WebGLDefaultShader);
    var _super = _create_super._(PillShader);
    function PillShader(context) {
        _class_call_check._(this, PillShader);
        var _this;
        _this = _super.call(this, context);
        _this._blend = 0;
        _this._radius = [
            1,
            1,
            1,
            1
        ];
        _this._stroke = 0;
        _this._progress = 0;
        _this._fc = 0x00ffffff;
        _this._pc = 0x00ffffff;
        _this._fillColor = _this._getNormalizedColor(_this._fc);
        _this._progressColor = _this._getNormalizedColor(_this._pc);
        _this._strokeColor = _this._getNormalizedColor(0x00ffffff);
        return _this;
    }
    _create_class._(PillShader, [
        {
            key: "blend",
            set: function set(p) {
                this._blend = Math.min(Math.max(p, 0), 1);
            }
        },
        {
            key: "radius",
            get: function get() {
                return this._radius;
            },
            set: function set(v) {
                if (Array.isArray(v)) {
                    if (v.length === 2) {
                        this._radius = [
                            v[0],
                            v[1],
                            v[0],
                            v[1]
                        ];
                    } else if (v.length === 3) {
                        this._radius = [
                            v[0],
                            v[1],
                            v[2],
                            this._radius[3]
                        ];
                    } else if (v.length === 4) {
                        this._radius = v;
                    } else {
                        this._radius = [
                            v[0],
                            v[0],
                            v[0],
                            v[0]
                        ];
                    }
                } else {
                    this._radius = [
                        v,
                        v,
                        v,
                        v
                    ];
                }
                this.redraw();
            }
        },
        {
            key: "progress",
            get: function get() {
                return this._progress;
            },
            set: function set(value) {
                this._progress = value;
                this.redraw();
            }
        },
        {
            key: "topLeft",
            get: function get() {
                return this._radius[0];
            },
            set: function set(num) {
                this._radius[0] = num;
                this.redraw();
            }
        },
        {
            key: "topRight",
            get: function get() {
                return this._radius[1];
            },
            set: function set(num) {
                this._radius[1] = num;
                this.redraw();
            }
        },
        {
            key: "bottomRight",
            get: function get() {
                return this._radius[2];
            },
            set: function set(num) {
                this._radius[2] = num;
                this.redraw();
            }
        },
        {
            key: "bottomLeft",
            get: function get() {
                return this._radius[4];
            },
            set: function set(num) {
                this._radius[3] = num;
                this.redraw();
            }
        },
        {
            key: "strokeColor",
            get: function get() {
                return this._sc;
            },
            set: function set(argb) {
                this._sc = argb;
                this._strokeColor = this._getNormalizedColor(argb);
                this.redraw();
            }
        },
        {
            key: "fillColor",
            get: function get() {
                return this._fc;
            },
            set: function set(argb) {
                this._fc = argb;
                this._fillColor = this._getNormalizedColor(argb);
                this.redraw();
            }
        },
        {
            key: "progressColor",
            get: function get() {
                return this._pc;
            },
            set: function set(argb) {
                this._pc = argb;
                this._progressColor = this._getNormalizedColor(argb);
                this.redraw();
            }
        },
        {
            key: "stroke",
            get: function get() {
                return this._stroke;
            },
            set: function set(num) {
                this._stroke = num;
                this.redraw();
            }
        },
        {
            key: "_getNormalizedColor",
            value: function _getNormalizedColor(color) {
                var col = _sdk.Lightning.StageUtils.getRgbaComponentsNormalized(color);
                col[0] *= col[3];
                col[1] *= col[3];
                col[2] *= col[3];
                return new Float32Array(col);
            }
        },
        {
            key: "setupUniforms",
            value: function setupUniforms(operation) {
                _get._(_get_prototype_of._(PillShader.prototype), "setupUniforms", this).call(this, operation);
                var owner = operation.shaderOwner;
                var renderPrecision = this.ctx.stage.getRenderPrecision();
                var _radius = this._radius.map(function(r) {
                    return (r + 0.5) * renderPrecision;
                });
                this._setUniform("radius", new Float32Array(_radius), this.gl.uniform4fv);
                this._setUniform("alpha", operation.getElementCore(0).renderContext.alpha, this.gl.uniform1f);
                this._setUniform("blend", this._blend, this.gl.uniform1f);
                this._setUniform("strokeColor", this._strokeColor, this.gl.uniform4fv);
                this._setUniform("fillColor", this._fillColor, this.gl.uniform4fv);
                this._setUniform("progressColor", this._progressColor, this.gl.uniform4fv);
                this._setUniform("progress", this._progress, this.gl.uniform1f);
                this._setUniform("stroke", this._stroke * renderPrecision, this.gl.uniform1f);
                this._setUniform("resolution", new Float32Array([
                    owner._w * renderPrecision,
                    owner._h * renderPrecision
                ]), this.gl.uniform2fv);
            }
        }
    ]);
    return PillShader;
}(_sdk.Lightning.shaders.WebGLDefaultShader);
PillShader.vertexShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    attribute vec2 aVertexPosition;\n    attribute vec2 aTextureCoord;\n\n    attribute vec4 aColor;\n    uniform vec2 projection;\n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n\n    void main(void){\n        gl_Position = vec4(aVertexPosition.x * projection.x - 1.0, aVertexPosition.y * -abs(projection.y) + 1.0, 0.0, 1.0);\n        vTextureCoord = aTextureCoord;\n        vColor = aColor;\n        gl_Position.y = -sign(projection.y) * gl_Position.y;\n    }\n";
PillShader.fragmentShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n\n    #define PI 3.14159265359\n\n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n\n    uniform sampler2D uSampler;\n    uniform vec2 resolution;\n    uniform vec4 radius;\n    uniform float stroke;\n    uniform vec4 strokeColor;\n    uniform vec4 fillColor;\n    uniform vec4 progressColor;\n    uniform float progress;\n    uniform float alpha;\n    uniform float fill;\n    uniform float blend;\n\n    float boxDist(vec2 p, vec2 size, float radius){\n        size -= vec2(radius);\n        vec2 d = abs(p) - size;\n        return min(max(d.x, d.y), 0.0) + length(max(d, 0.0)) - radius;\n    }\n\n    float fillMask(float dist){\n        return clamp(-dist, 0.0, 1.0);\n    }\n\n    float innerBorderMask(float dist, float width){\n        float alpha1 = clamp(dist + width, 0.0, 1.0);\n        float alpha2 = clamp(dist, 0.0, 1.0);\n        return alpha1 - alpha2;\n    }\n\n    void main() {\n        vec2 halfRes = 0.5 * resolution.xy;\n        float r = 0.0;\n        if (vTextureCoord.x < 0.5 && vTextureCoord.y < 0.5) {\n            r = radius[0];\n        } else if (vTextureCoord.x >= 0.5 && vTextureCoord.y < 0.5) {\n            r = radius[1];\n        } else if (vTextureCoord.x >= 0.5 && vTextureCoord.y >= 0.5) {\n            r = radius[2];\n        } else {\n            r = radius[3];\n        }\n\n        vec4 pillColor = fillColor;\n        if (vTextureCoord.x < progress) {\n          pillColor.rgb = progressColor.rgb;\n        }\n\n        float b = boxDist(vTextureCoord.xy * resolution - halfRes, halfRes - 0.005, r);\n        vec4 layer1 = mix(vec4(0.0), pillColor, fillMask(b));\n        vec4 result = mix(layer1, strokeColor, innerBorderMask(b, stroke));\n        gl_FragColor = result;\n    }\n";


/***/ }),

/***/ 2109:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/**
 * Should be used when an item is manually selected by user's input (i.e. via RC button)
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DETACHED_SIGNAL: function() {
        return DETACHED_SIGNAL;
    },
    EPG_SIGNAL: function() {
        return EPG_SIGNAL;
    },
    FOCUSED_SIGNAL: function() {
        return FOCUSED_SIGNAL;
    },
    HIDE_BACKGROUND_SIGNAL: function() {
        return HIDE_BACKGROUND_SIGNAL;
    },
    IMPRESSION_TRACK_SIGNAL: function() {
        return IMPRESSION_TRACK_SIGNAL;
    },
    IMPRESSION_UNTRACK_SIGNAL: function() {
        return IMPRESSION_UNTRACK_SIGNAL;
    },
    INACTIVE_SIGNAL: function() {
        return INACTIVE_SIGNAL;
    },
    NOTIFICATION_SIGNAL: function() {
        return NOTIFICATION_SIGNAL;
    },
    PORTION_REQUESTED_SIGNAL: function() {
        return PORTION_REQUESTED_SIGNAL;
    },
    SELECTED_SIGNAL: function() {
        return SELECTED_SIGNAL;
    },
    SHOW_BACKGROUND_SIGNAL: function() {
        return SHOW_BACKGROUND_SIGNAL;
    },
    SHOW_GRID_SIGNAL: function() {
        return SHOW_GRID_SIGNAL;
    },
    TEXTURE_LOADED_SIGNAL: function() {
        return TEXTURE_LOADED_SIGNAL;
    }
});
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(88801);
var SELECTED_SIGNAL = "selected";
var FOCUSED_SIGNAL = "focused";
var PORTION_REQUESTED_SIGNAL = "portionRequested";
var INACTIVE_SIGNAL = "inactive";
var DETACHED_SIGNAL = "detached";
var NOTIFICATION_SIGNAL = "notification";
var EPG_SIGNAL = "epg";
var TEXTURE_LOADED_SIGNAL = "tx_loaded";
var HIDE_BACKGROUND_SIGNAL = "hide_background";
var SHOW_BACKGROUND_SIGNAL = "show_background";
var SHOW_GRID_SIGNAL = "show_grid";
var IMPRESSION_TRACK_SIGNAL = "impression_track";
var IMPRESSION_UNTRACK_SIGNAL = "impression_untrack";


/***/ }),

/***/ 82149:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return SkeletonRectangle;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(52318);
var _sdk = __webpack_require__(29956);
var _flareshader = /*#__PURE__*/ _interop_require_default._(__webpack_require__(28604));
var _colors = __webpack_require__(8426);
var SkeletonRectangle = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(SkeletonRectangle, _Lightning_Component);
    var _super = _create_super._(SkeletonRectangle);
    function SkeletonRectangle() {
        _class_call_check._(this, SkeletonRectangle);
        return _super.apply(this, arguments);
    }
    _create_class._(SkeletonRectangle, [
        {
            key: "_attach",
            value: function _attach() {
                var flareWidth = window.innerWidth * 1.4;
                this.animation({
                    duration: 2,
                    repeat: -1,
                    stopMethod: "immediate",
                    actions: [
                        {
                            p: "shader.lineX",
                            v: {
                                0: -flareWidth,
                                1: flareWidth
                            }
                        }
                    ]
                }).start();
            }
        },
        {
            key: "radius",
            set: function set(value) {
                this.shader.radius = value;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return {
                    rect: true,
                    color: _colors.WHITE,
                    shader: {
                        type: _flareshader.default,
                        radius: 0
                    }
                };
            }
        }
    ]);
    return SkeletonRectangle;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 26849:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "Skeleton", ({
    enumerable: true,
    get: function() {
        return Skeleton;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(52318);
var _sdk = __webpack_require__(29956);
var _skeltonstyle = __webpack_require__(38931);
var _skeltonconstants = __webpack_require__(477);
var _templates = __webpack_require__(63555);
var Skeleton = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(Skeleton, _Lightning_Component);
    var _super = _create_super._(Skeleton);
    function Skeleton() {
        _class_call_check._(this, Skeleton);
        return _super.apply(this, arguments);
    }
    _create_class._(Skeleton, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _skeltonstyle.defaultContext;
            }
        },
        {
            key: "rows",
            set: function set(value) {
                var offset = 0;
                var children = [];
                for(var i = 0; i < value.length; i += 1){
                    var entry = value[i];
                    var hasProps = Boolean(entry.blockTemplate);
                    var data = {
                        screenSize: this._style.screenSize,
                        blockIndex: i,
                        itemTemplate: entry.itemTemplate
                    };
                    var blockSkeletonTemplateId = hasProps ? entry.blockTemplate : entry;
                    var block = (0, _skeltonconstants.getBlockSkeleton)(blockSkeletonTemplateId);
                    var h = block.getHeight(data);
                    children.push({
                        type: block,
                        y: offset,
                        h: h,
                        items: {
                            count: entry.count || 5,
                            itemTemplate: entry.itemTemplate,
                            itemType: (0, _templates.getContentTemplateByTemplateId)(entry.itemTemplate),
                            itemSize: (0, _templates.getContentSizeByContentTemplateId)(entry.itemTemplate),
                            blockIndex: i
                        }
                    });
                    offset += h;
                }
                this.children = children;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return {
                    alpha: 0.25
                };
            }
        }
    ]);
    return Skeleton;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 477:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BLOCKS: function() {
        return BLOCKS;
    },
    DEFAULT_BLOCK_SKELETON: function() {
        return DEFAULT_BLOCK_SKELETON;
    },
    getBlockSkeleton: function() {
        return getBlockSkeleton;
    }
});
var _define_property = __webpack_require__(21228);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(52318);
var _templateTypes = __webpack_require__(43581);
var _heroskeletoncomponent = __webpack_require__(34552);
var _listskeletoncomponent = __webpack_require__(18793);
var _obj;
var BLOCKS = (_obj = {}, _define_property._(_obj, _templateTypes.templateTypes.Hero, _heroskeletoncomponent.HeroSkeleton), _define_property._(_obj, _templateTypes.blockTemplateTypes.List, _listskeletoncomponent.ListSkeleton), _obj);
var DEFAULT_BLOCK_SKELETON = BLOCKS[_templateTypes.blockTemplateTypes.List];
var getBlockSkeleton = function(id) {
    return BLOCKS[id] || DEFAULT_BLOCK_SKELETON;
};


/***/ }),

/***/ 1966:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "getSkeletonByConfig", ({
    enumerable: true,
    get: function() {
        return getSkeletonByConfig;
    }
}));
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
var _skeltoncomponent = __webpack_require__(26849);
var _templateTypes = __webpack_require__(43581);
var _skeltonconstants = __webpack_require__(477);
var SKELETONS = {
    generic: {
        type: _skeltoncomponent.Skeleton,
        rows: [
            _templateTypes.templateTypes.Hero,
            {
                blockTemplate: _templateTypes.blockTemplateTypes.List,
                itemTemplate: _templateTypes.templateTypes.CardM
            }
        ]
    },
    // TODO: add Jumbotron for programs
    program: {
        type: _skeltoncomponent.Skeleton,
        rows: [
            _templateTypes.templateTypes.Hero,
            {
                blockTemplate: _templateTypes.blockTemplateTypes.List,
                itemTemplate: _templateTypes.templateTypes.CardM
            }
        ]
    }
};
var getSkeletonByConfig = function(config) {
    if (!config) {
        return null;
    }
    if (Array.isArray(config.skeleton)) {
        return {
            type: _skeltoncomponent.Skeleton,
            rows: config.skeleton.map(function(name) {
                return _skeltonconstants.BLOCKS[name] ? name : {
                    blockTemplate: _templateTypes.blockTemplateTypes.List,
                    itemTemplate: name
                };
            })
        };
    }
    return config.preset && SKELETONS[config.preset] || null;
};


/***/ }),

/***/ 38931:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "defaultContext", ({
    enumerable: true,
    get: function() {
        return defaultContext;
    }
}));
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
var _style = __webpack_require__(65082);
var defaultContext = (0, _style.makeDefaultStylingContext)();


/***/ }),

/***/ 20356:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "SnackBar", ({
    enumerable: true,
    get: function() {
        return SnackBar;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(37815);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _snackBarstyle = __webpack_require__(11204);
var _snackBarconstants = __webpack_require__(47591);
var _iconcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(70160));
var _notifications = __webpack_require__(93831);
var SnackBar = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(SnackBar, _Lightning_Component);
    var _super = _create_super._(SnackBar);
    function SnackBar() {
        _class_call_check._(this, SnackBar);
        return _super.apply(this, arguments);
    }
    _create_class._(SnackBar, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _snackBarstyle.defaultContext;
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                if (this._hideTimeout) {
                    clearTimeout(this._hideTimeout);
                    this._hideTimeout = undefined;
                }
            }
        },
        {
            key: "push",
            value: function push(notification) {
                var _this = this;
                if (!notification) {
                    return;
                }
                var contentColor = (0, _get.default)(_snackBarstyle.colors.text, [
                    notification.level,
                    this._style.colorMode
                ]);
                var icon = notification.icon || {
                    name: notification.level === _notifications.NOTIFICATION_LEVEL.SUCCESS ? "CheckFocused" : "Info"
                };
                this.tag("Content").patch({
                    smooth: {
                        color: (0, _get.default)(_snackBarstyle.colors.background, [
                            notification.level,
                            this._style.colorMode
                        ]),
                        y: 0
                    },
                    Inner: {
                        Icon: {
                            color: contentColor,
                            iconData: {
                                picto: icon,
                                viewBox: {
                                    h: _snackBarstyle.ICON_SIZE[this._style.screenSize]
                                }
                            }
                        },
                        Caption: {
                            text: {
                                text: notification.text,
                                textColor: contentColor
                            }
                        }
                    }
                });
                if (this._hideTimeout) {
                    clearTimeout(this._hideTimeout);
                }
                this._hideTimeout = setTimeout(function() {
                    _this.tag("Content").setSmooth("y", _snackBarstyle.HEIGHT[_this._style.screenSize]);
                }, _snackBarconstants.HIDE_TIMEOUT);
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Content: {
                        rect: true,
                        Inner: {
                            Icon: {
                                type: _iconcomponent.default
                            },
                            Caption: {
                                text: {}
                            }
                        }
                    }
                }, (0, _snackBarstyle.getInitialStyle)());
            }
        }
    ]);
    return SnackBar;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 47591:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "HIDE_TIMEOUT", ({
    enumerable: true,
    get: function() {
        return HIDE_TIMEOUT;
    }
}));
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(42578);
var HIDE_TIMEOUT = 2500;


/***/ }),

/***/ 11204:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    HEIGHT: function() {
        return HEIGHT;
    },
    ICON_MARGIN_RIGHT: function() {
        return ICON_MARGIN_RIGHT;
    },
    ICON_SIZE: function() {
        return ICON_SIZE;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(52318);
var _constants = __webpack_require__(34952);
var _theme = __webpack_require__(51397);
var _typography = __webpack_require__(18411);
var _icons = __webpack_require__(20360);
var _style = __webpack_require__(65082);
var _sizes = __webpack_require__(82699);
var _notifications = __webpack_require__(93831);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var tertiary = (0, _theme.makeThemeColor)(_theme.TERTIARY);
var _obj, _obj1;
var colors = {
    text: (_obj = {}, _define_property._(_obj, _notifications.NOTIFICATION_LEVEL.SYSTEM, tertiary), _define_property._(_obj, _notifications.NOTIFICATION_LEVEL.SUCCESS, tertiary), _define_property._(_obj, _notifications.NOTIFICATION_LEVEL.WARNING, tertiary), _define_property._(_obj, _notifications.NOTIFICATION_LEVEL.ERROR, (0, _theme.makeThemeColor)(_theme.PRIMARY)), _obj),
    background: (_obj1 = {}, _define_property._(_obj1, _notifications.NOTIFICATION_LEVEL.SYSTEM, (0, _theme.makeThemeColor)(_theme.UTILITY4)), _define_property._(_obj1, _notifications.NOTIFICATION_LEVEL.SUCCESS, (0, _theme.makeThemeColor)(_theme.UTILITY2)), _define_property._(_obj1, _notifications.NOTIFICATION_LEVEL.WARNING, (0, _theme.makeThemeColor)(_theme.UTILITY3)), _define_property._(_obj1, _notifications.NOTIFICATION_LEVEL.ERROR, (0, _theme.makeThemeColor)(_theme.UTILITY1)), _obj1)
};
var _obj2;
var HEIGHT = (_obj2 = {}, _define_property._(_obj2, _constants.FULL_HD, 68 + _constants.safetyMargins.vertical[_constants.FULL_HD]), _define_property._(_obj2, _constants.HD, 64 + _constants.safetyMargins.vertical[_constants.HD]), _obj2);
var _obj3;
var ICON_SIZE = (_obj3 = {}, _define_property._(_obj3, _constants.FULL_HD, 32), _define_property._(_obj3, _constants.HD, 32), _obj3);
var _obj4;
var ICON_MARGIN_RIGHT = (_obj4 = {}, _define_property._(_obj4, _constants.FULL_HD, 16), _define_property._(_obj4, _constants.HD, 16), _obj4);
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var screenSize = context.screenSize, colorMode = context.colorMode;
    var h = HEIGHT[screenSize];
    return {
        h: h,
        Content: {
            w: _sizes.identity,
            h: h,
            y: h,
            color: colors.background[_notifications.NOTIFICATION_LEVEL.SYSTEM][colorMode],
            Inner: {
                w: _sizes.identity,
                h: h - _constants.safetyMargins.vertical[screenSize],
                Icon: {
                    iconData: {
                        picto: {
                            name: "CheckFocused",
                            collection: _icons.ICON_COLLECTION.BASIC
                        },
                        viewBox: {
                            h: ICON_SIZE[screenSize]
                        }
                    },
                    color: colors.text[_notifications.NOTIFICATION_LEVEL.SYSTEM][colorMode],
                    flexItem: {
                        marginRight: ICON_MARGIN_RIGHT[screenSize]
                    }
                },
                Caption: {
                    text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT.OTTAWA_2)), {
                        verticalAlign: "middle",
                        textColor: colors.text[_notifications.NOTIFICATION_LEVEL.SYSTEM][colorMode]
                    })
                },
                flex: {
                    direction: "row",
                    justifyContent: "center",
                    alignItems: "center"
                }
            }
        }
    };
};


/***/ }),

/***/ 7346:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return Solo;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _create_super = __webpack_require__(6400);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(88801);
var _sdk = __webpack_require__(29956);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _i18n = __webpack_require__(14910);
var _heroOverlaycomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(10169));
var _progresscomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(45926));
var _iconcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(70160));
var _callToActioncomponent = __webpack_require__(91743);
var _sizes = __webpack_require__(82699);
var _textures = __webpack_require__(67179);
var _soloconstants = __webpack_require__(9999);
var _templates = __webpack_require__(88229);
var _soloutils = __webpack_require__(50088);
var _progressutils = __webpack_require__(40779);
var _programInformationcomponent = __webpack_require__(63902);
var _programInformationconstants = __webpack_require__(21248);
var _signals = __webpack_require__(2109);
var _myListCallToActioncomponent = __webpack_require__(5805);
var _analyticsutils = __webpack_require__(2693);
var _programInformationstyle = __webpack_require__(89187);
var _solostyle = __webpack_require__(83303);
var Solo = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(Solo, _Lightning_Component);
    var _super = _create_super._(Solo);
    function Solo() {
        _class_call_check._(this, Solo);
        return _super.apply(this, arguments);
    }
    _create_class._(Solo, [
        {
            key: "_construct",
            value: function _construct() {
                this._buttons = [];
                this._index = 0;
                this._style = _solostyle.defaultContext;
            }
        },
        {
            key: "_init",
            value: function _init() {
                var _this = this;
                // NOTE: needs to use txLoaded event to add margin
                var serviceIcon = this.tag("ServiceIcon");
                serviceIcon.on("txLoaded", function() {
                    serviceIcon.patch({
                        flexItem: {
                            marginRight: _solostyle.SERVICE_ICON_MARGIN_RIGHT[_this._style.screenSize]
                        }
                    });
                });
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                this.tag("ServiceIcon").removeAllListeners("txLoaded");
            }
        },
        {
            key: "item",
            get: function get() {
                return this._item;
            },
            set: function set(param) {
                var content = param.content, blockIndex = param.blockIndex, itemIndex = param.itemIndex, config = param.config, _param_colorScheme = param.colorScheme, colorScheme = _param_colorScheme === void 0 ? _solostyle.defaultContext.colorMode : _param_colorScheme;
                this._item = content;
                var _this__item = this._item, image = _this__item.image, title = _this__item.title, logo = _this__item.logo, progress = _this__item.progress, action = _this__item.action, csaPicto = _this__item.csaPicto, servicePicto = _this__item.servicePicto, extraDetails = _this__item.extraDetails, bookmark = _this__item.bookmark, description = _this__item.description;
                var textColor = _solostyle.colors.text[colorScheme];
                var screenSize = this._style.screenSize;
                var logoSrc = logo && logo.src || "";
                var titleWidth = (0, _solostyle.getTitleWordWrapWidth)(screenSize);
                this.patch({
                    texture: (0, _textures.cover)(image.src, config.w, config.h),
                    FlexContainer: {
                        Logo: {
                            visible: Boolean(logoSrc),
                            texture: _object_spread_props._(_object_spread._({}, (0, _textures.contain)(logoSrc, _soloconstants.logoOptions[screenSize].width, _soloconstants.logoOptions[screenSize].height)), {
                                hasAlpha: true
                            })
                        },
                        DetailsFlexContainer: {
                            visible: (0, _soloutils.isVisibleDetails)(servicePicto, csaPicto, extraDetails),
                            ServiceIcon: {
                                visible: (0, _soloutils.isVisibleIcon)(servicePicto),
                                type: _iconcomponent.default,
                                iconData: {
                                    picto: servicePicto,
                                    viewBox: (0, _solostyle.getServiceIconViewBox)(screenSize)
                                }
                            },
                            Description: {
                                visible: Boolean(extraDetails),
                                text: {
                                    text: extraDetails
                                }
                            },
                            BasicIcon: {
                                visible: (0, _soloutils.isVisibleIcon)(csaPicto),
                                type: _iconcomponent.default,
                                iconData: {
                                    picto: csaPicto,
                                    viewBox: (0, _solostyle.getBasicIconViewBox)(screenSize)
                                }
                            }
                        },
                        Title: _object_spread._({}, (0, _templates.makeTextPatch)(title, titleWidth, textColor)),
                        ProgressBar: _object_spread._({}, (0, _progressutils.makeProgressBarProperties)(progress)),
                        CTAFlexContainer: {
                            PlayButton: {
                                type: _callToActioncomponent.CallToAction,
                                visible: (0, _soloutils.isVisibleCTA)(action),
                                label: (0, _get.default)(action, "label", ""),
                                picto: (0, _get.default)(action, "picto", "")
                            },
                            MyListButton: {
                                type: _callToActioncomponent.CallToAction,
                                visible: Boolean(bookmark),
                                label: (0, _i18n.t)("bookmarks.actionLabel"),
                                item: bookmark,
                                blockIndex: blockIndex,
                                itemIndex: itemIndex
                            },
                            InfoButton: {
                                visible: Boolean(title) || Boolean(description),
                                type: _callToActioncomponent.CallToAction
                            }
                        }
                    },
                    ProgramInformation: {
                        data: this._item
                    }
                });
                var items = this.tag("CTAFlexContainer").children;
                this._buttons = items.filter(function(item) {
                    return item.visible;
                });
            }
        },
        {
            key: "contentPadding",
            set: function set(value) {
                this.tag("FlexContainer").x = Number.isFinite(value) ? value : 0;
            }
        },
        {
            key: "_focus",
            value: function _focus() {
                this._setIndex();
            }
        },
        {
            key: "_getFocused",
            value: function _getFocused() {
                return this._focused;
            }
        },
        {
            key: "_handleRight",
            value: function _handleRight() {
                if (this._index < this._buttons.length - 1) {
                    this._setIndex(this._index + 1);
                    return true;
                }
                return false;
            }
        },
        {
            key: "_handleLeft",
            value: function _handleLeft() {
                if (this._index > 0) {
                    this._setIndex(this._index - 1);
                    return true;
                }
                return false;
            }
        },
        {
            key: "_setIndex",
            value: function _setIndex() {
                var index = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._index;
                this._index = index;
                this._focused = this._buttons[this._index];
                this._refocus();
            }
        },
        {
            key: "_handleEnter",
            value: function _handleEnter() {
                if (this._focused === this.tag("InfoButton")) {
                    this._showProgramInformation();
                    (0, _analyticsutils.sendEvent)({
                        key: "pressMoreInfo"
                    });
                } else {
                    this.signal(_signals.SELECTED_SIGNAL, this._item);
                }
            }
        },
        {
            key: "_showProgramInformation",
            value: function _showProgramInformation() {
                this.zIndex = _soloconstants.Z_INDEX_WITH_PROGRAM_INFO;
                this.tag("ProgramInformation").patch((0, _programInformationstyle.getProgramInformationFocusedStyle)());
                this._focused = this.tag("ProgramInformation");
            }
        },
        {
            key: "_handleProgramInformationClose",
            value: function _handleProgramInformationClose() {
                this.zIndex = _soloconstants.Z_INDEX_NORMAL;
                this.tag("ProgramInformation").patch((0, _programInformationstyle.getProgramInformationUnFocusedStyle)());
                this._setIndex(this._buttons.indexOf(this.tag("InfoButton")));
                (0, _analyticsutils.sendEvent)({
                    key: "closeMoreInfo"
                });
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Gradient: {
                        type: _heroOverlaycomponent.default,
                        w: _sizes.identity,
                        h: _sizes.identity
                    },
                    FlexContainer: {
                        Logo: {},
                        DetailsFlexContainer: {
                            ServiceIcon: {
                                type: _iconcomponent.default
                            },
                            Description: {},
                            BasicIcon: {
                                type: _iconcomponent.default
                            }
                        },
                        Title: {},
                        ProgressBar: {
                            type: _progresscomponent.default,
                            visible: false
                        },
                        CTAFlexContainer: {
                            PlayButton: {
                                type: _callToActioncomponent.CallToAction
                            },
                            MyListButton: {
                                type: _myListCallToActioncomponent.MyListButtonPrimary,
                                passSignals: _define_property._({}, _signals.SELECTED_SIGNAL, true)
                            },
                            InfoButton: {
                                type: _callToActioncomponent.CallToAction
                            }
                        }
                    },
                    ProgramInformation: {
                        type: _programInformationcomponent.ProgramInformation,
                        signals: _define_property._({}, _programInformationconstants.PROGRAM_INFORMATION_CLOSED_SIGNAL, "_handleProgramInformationClose")
                    }
                }, (0, _solostyle.getInitialStyle)());
            }
        }
    ]);
    return Solo;
}(_sdk.Lightning.Component);
Solo.Templates = _soloconstants.templates;
Solo.Sizes = _soloconstants.sizes;
Solo.ImageOptions = _soloconstants.imageOptions;


/***/ }),

/***/ 21195:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "logoOptions", ({
    enumerable: true,
    get: function() {
        return logoOptions;
    }
}));
var _define_property = __webpack_require__(21228);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(65759);
var _constants = __webpack_require__(34952);
var _obj;
var logoOptions = (_obj = {}, _define_property._(_obj, _constants.HD, {
    width: 251,
    height: 141
}), _define_property._(_obj, _constants.FULL_HD, {
    width: 382,
    height: 215
}), _obj);


/***/ }),

/***/ 83303:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BASIC_ICON_HEIGHT: function() {
        return BASIC_ICON_HEIGHT;
    },
    CTA_BUTTON_MARGIN_RIGHT: function() {
        return CTA_BUTTON_MARGIN_RIGHT;
    },
    CTA_HEIGHT: function() {
        return CTA_HEIGHT;
    },
    CTA_ROW_MARGIN_TOP: function() {
        return CTA_ROW_MARGIN_TOP;
    },
    DESCRIPTION_MARGIN_LEFT: function() {
        return DESCRIPTION_MARGIN_LEFT;
    },
    DESCRIPTION_MARGIN_RIGHT: function() {
        return DESCRIPTION_MARGIN_RIGHT;
    },
    DETAILS_ROW_HEIGHT: function() {
        return DETAILS_ROW_HEIGHT;
    },
    DETAILS_ROW_PADDING_BOTTOM: function() {
        return DETAILS_ROW_PADDING_BOTTOM;
    },
    FLEX_CONTAINER_HEIGHT: function() {
        return FLEX_CONTAINER_HEIGHT;
    },
    FLEX_CONTAINER_PADDING_BOTTOM: function() {
        return FLEX_CONTAINER_PADDING_BOTTOM;
    },
    FLEX_CONTAINER_WIDTH: function() {
        return FLEX_CONTAINER_WIDTH;
    },
    INFO_ICON: function() {
        return INFO_ICON;
    },
    LOGO_PADDING_BOTTOM: function() {
        return LOGO_PADDING_BOTTOM;
    },
    PROGRESS_BAR_MARGIN_TOP: function() {
        return PROGRESS_BAR_MARGIN_TOP;
    },
    PROGRESS_BAR_WIDTH: function() {
        return PROGRESS_BAR_WIDTH;
    },
    SERVICE_ICON_HEIGHT: function() {
        return SERVICE_ICON_HEIGHT;
    },
    SERVICE_ICON_MARGIN_RIGHT: function() {
        return SERVICE_ICON_MARGIN_RIGHT;
    },
    TITLE_MARGIN_TOP: function() {
        return TITLE_MARGIN_TOP;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getBasicIconViewBox: function() {
        return getBasicIconViewBox;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    getServiceIconViewBox: function() {
        return getServiceIconViewBox;
    },
    getTitleWordWrapWidth: function() {
        return getTitleWordWrapWidth;
    },
    makeBasicTextStyle: function() {
        return makeBasicTextStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(52318);
var _memoize = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34736));
var _typography = __webpack_require__(18411);
var _theme = __webpack_require__(51397);
var _constants = __webpack_require__(34952);
var _sizes = __webpack_require__(82699);
var _style = __webpack_require__(65082);
var _colors = __webpack_require__(8426);
var _soloconstants = __webpack_require__(9999);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var FLEX_CONTAINER_WIDTH = (_obj = {}, _define_property._(_obj, _constants.HD, 460), _define_property._(_obj, _constants.FULL_HD, 688), _obj);
var _obj1;
var FLEX_CONTAINER_HEIGHT = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 400), _define_property._(_obj1, _constants.FULL_HD, 466), _obj1);
var _obj2;
var FLEX_CONTAINER_PADDING_BOTTOM = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 81), _define_property._(_obj2, _constants.FULL_HD, 174), _obj2);
var _obj3;
var LOGO_PADDING_BOTTOM = (_obj3 = {}, _define_property._(_obj3, _constants.HD, 16), _define_property._(_obj3, _constants.FULL_HD, 24), _obj3);
var DETAILS_ROW_PADDING_BOTTOM = 16;
var _obj4;
var DETAILS_ROW_HEIGHT = (_obj4 = {}, _define_property._(_obj4, _constants.HD, 32), _define_property._(_obj4, _constants.FULL_HD, 40), _obj4);
var _obj5;
var SERVICE_ICON_MARGIN_RIGHT = (_obj5 = {}, _define_property._(_obj5, _constants.HD, 8), _define_property._(_obj5, _constants.FULL_HD, 12), _obj5);
var _obj6;
var DESCRIPTION_MARGIN_RIGHT = (_obj6 = {}, _define_property._(_obj6, _constants.HD, 12), _define_property._(_obj6, _constants.FULL_HD, 16), _obj6);
var _obj7;
var DESCRIPTION_MARGIN_LEFT = (_obj7 = {}, _define_property._(_obj7, _constants.HD, 8), _define_property._(_obj7, _constants.FULL_HD, 12), _obj7);
var TITLE_MARGIN_TOP = 16;
var PROGRESS_BAR_WIDTH = 356;
var TITLE_WORD_PERCENTAGE = 0.4;
var _obj8;
var PROGRESS_BAR_MARGIN_TOP = (_obj8 = {}, _define_property._(_obj8, _constants.HD, 24), _define_property._(_obj8, _constants.FULL_HD, 32), _obj8);
var INFO_ICON = {
    name: "InfoLight",
    type: "icon"
};
var _obj9;
var CTA_ROW_MARGIN_TOP = (_obj9 = {}, _define_property._(_obj9, _constants.HD, 24), _define_property._(_obj9, _constants.FULL_HD, 32), _obj9);
var _obj10;
var SERVICE_ICON_HEIGHT = (_obj10 = {}, _define_property._(_obj10, _constants.HD, 32), _define_property._(_obj10, _constants.FULL_HD, 40), _obj10);
var _obj11;
var BASIC_ICON_HEIGHT = (_obj11 = {}, _define_property._(_obj11, _constants.HD, 24), _define_property._(_obj11, _constants.FULL_HD, 32), _obj11);
var _obj12;
var CTA_HEIGHT = (_obj12 = {}, _define_property._(_obj12, _constants.HD, 56), _define_property._(_obj12, _constants.FULL_HD, 64), _obj12);
var _obj13;
var CTA_BUTTON_MARGIN_RIGHT = (_obj13 = {}, _define_property._(_obj13, _constants.HD, 24), _define_property._(_obj13, _constants.FULL_HD, 32), _obj13);
var getServiceIconViewBox = (0, _memoize.default)(function(screenSize) {
    return {
        h: SERVICE_ICON_HEIGHT[screenSize]
    };
});
var getBasicIconViewBox = (0, _memoize.default)(function(screenSize) {
    return {
        h: BASIC_ICON_HEIGHT[screenSize]
    };
});
var colors = {
    text: (0, _theme.makeThemeColor)(_theme.PRIMARY)
};
var getTitleWordWrapWidth = function(screenSize) {
    return Math.round(_sizes.SCREEN_WIDTH[screenSize] * TITLE_WORD_PERCENTAGE);
};
var makeBasicTextStyle = function(param) {
    var font = param.font, colorMode = param.colorMode;
    return {
        color: colors.text[colorMode],
        text: _object_spread_props._(_object_spread._({}, font), {
            verticalAlign: "middle",
            wordWrap: true,
            maxLines: 2,
            maxLinesSuffix: "..."
        })
    };
};
var getInitialStyle = (0, _memoize.default)(function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext, _ref_screenSize = _ref.screenSize, screenSize = _ref_screenSize === void 0 ? _constants.FULL_HD : _ref_screenSize, _ref_colorMode = _ref.colorMode, colorMode = _ref_colorMode === void 0 ? _theme.DEFAULT_MODE : _ref_colorMode;
    return {
        Gradient: {
            w: _sizes.identity,
            h: _sizes.identity
        },
        FlexContainer: {
            rect: true,
            color: _colors.TRANSPARENT,
            w: FLEX_CONTAINER_WIDTH[screenSize],
            h: FLEX_CONTAINER_HEIGHT[screenSize],
            y: _soloconstants.imageOptions[_soloconstants.templates.Solo][screenSize].PRIMARY.height - FLEX_CONTAINER_HEIGHT[screenSize] - FLEX_CONTAINER_PADDING_BOTTOM[screenSize],
            flex: {
                direction: "column",
                justifyContent: "flex-end"
            },
            Logo: {
                flexItem: {
                    marginBottom: LOGO_PADDING_BOTTOM[screenSize]
                }
            },
            DetailsFlexContainer: {
                rect: true,
                h: DETAILS_ROW_HEIGHT[screenSize],
                color: _colors.TRANSPARENT,
                flex: {
                    direction: "row"
                },
                flexItem: {
                    paddingBottom: DETAILS_ROW_PADDING_BOTTOM
                },
                ServiceIcon: {},
                Description: {
                    mountY: 0.5,
                    y: _sizes.middle,
                    text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT.BERLIN_1, screenSize)), {
                        maxLines: 1,
                        verticalAlign: "middle"
                    }),
                    alpha: 0.8,
                    flexItem: {
                        marginLeft: DESCRIPTION_MARGIN_LEFT[screenSize],
                        marginRight: DESCRIPTION_MARGIN_RIGHT[screenSize]
                    }
                },
                BasicIcon: {
                    flexItem: {
                        marginTop: (DETAILS_ROW_HEIGHT[screenSize] - BASIC_ICON_HEIGHT[screenSize]) / 2
                    },
                    alpha: 0.8
                }
            },
            Title: _object_spread_props._(_object_spread._({}, makeBasicTextStyle({
                font: (0, _typography.getFont)(_typography.FONT.PARIS_3, screenSize),
                colorMode: colorMode
            })), {
                flexItem: {
                    marginTop: TITLE_MARGIN_TOP
                }
            }),
            ProgressBar: {
                w: PROGRESS_BAR_WIDTH,
                mountY: 1,
                flexItem: {
                    marginTop: PROGRESS_BAR_MARGIN_TOP[screenSize]
                }
            },
            CTAFlexContainer: {
                rect: true,
                h: CTA_HEIGHT[screenSize],
                w: FLEX_CONTAINER_WIDTH[screenSize],
                color: _colors.TRANSPARENT,
                flex: {
                    direction: "row"
                },
                flexItem: {
                    marginTop: CTA_ROW_MARGIN_TOP[screenSize]
                },
                PlayButton: {
                    flexItem: {
                        marginRight: CTA_BUTTON_MARGIN_RIGHT[screenSize]
                    }
                },
                MyListButton: {
                    flexItem: {
                        marginRight: CTA_BUTTON_MARGIN_RIGHT[screenSize]
                    }
                },
                InfoButton: {
                    picto: INFO_ICON
                }
            }
        }
    };
}, _style.cacheResolver);


/***/ }),

/***/ 3843:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(88801);
var _solocomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(7346));
var _default = _solocomponent.default;


/***/ }),

/***/ 9999:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Z_INDEX_NORMAL: function() {
        return Z_INDEX_NORMAL;
    },
    Z_INDEX_WITH_PROGRAM_INFO: function() {
        return Z_INDEX_WITH_PROGRAM_INFO;
    },
    imageOptions: function() {
        return imageOptions;
    },
    sizes: function() {
        return sizes;
    },
    templates: function() {
        return templates;
    }
});
var _define_property = __webpack_require__(21228);
var _export_star = __webpack_require__(37668);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
var _constants = __webpack_require__(34952);
var _sizes = __webpack_require__(82699);
_export_star._(__webpack_require__(21195), exports);
var Z_INDEX_NORMAL = 0;
var Z_INDEX_WITH_PROGRAM_INFO = 1000;
var templates = {
    Solo: "Solo"
};
var _obj;
var sizes = _define_property._({}, templates.Solo, (_obj = {}, _define_property._(_obj, _constants.HD, {
    w: _sizes.SCREEN_WIDTH[_constants.HD],
    h: Math.round(_sizes.SCREEN_HEIGHT[_constants.HD] * 0.85)
}), _define_property._(_obj, _constants.FULL_HD, {
    w: _sizes.SCREEN_WIDTH[_constants.FULL_HD],
    h: Math.round(_sizes.SCREEN_HEIGHT[_constants.FULL_HD] * 0.85)
}), _obj));
var _obj1;
var imageOptions = _define_property._({}, templates.Solo, (_obj1 = {}, _define_property._(_obj1, _constants.HD, {
    PRIMARY: {
        width: sizes[templates.Solo][_constants.HD].w,
        height: sizes[templates.Solo][_constants.HD].h
    }
}), _define_property._(_obj1, _constants.FULL_HD, {
    PRIMARY: {
        width: sizes[templates.Solo][_constants.FULL_HD].w,
        height: sizes[templates.Solo][_constants.FULL_HD].h
    }
}), _obj1));


/***/ }),

/***/ 50088:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    isVisibleCTA: function() {
        return isVisibleCTA;
    },
    isVisibleDetails: function() {
        return isVisibleDetails;
    },
    isVisibleIcon: function() {
        return isVisibleIcon;
    }
});
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(42578);
var isVisibleCTA = function(ctaData) {
    return Boolean(ctaData) && (Boolean(ctaData.label) || Boolean(ctaData.picto));
};
var isVisibleIcon = function(iconData) {
    return Boolean(iconData) && Boolean(iconData.name);
};
var isVisibleDetails = function(serviceIcon, csaIcon, extraDetails) {
    return isVisibleIcon(serviceIcon) || isVisibleIcon(csaIcon) || Boolean(extraDetails);
};


/***/ }),

/***/ 74015:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return Spinner;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(37815);
var _sdk = __webpack_require__(29956);
var _theme = __webpack_require__(51397);
var _spinnershader = __webpack_require__(48886);
var _spinnerstyle = __webpack_require__(79796);
var _sizes = __webpack_require__(82699);
var MAX_PROGRESS = 0.45;
var MIN_PROGRESS = 0.1;
var Spinner = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(Spinner, _Lightning_Component);
    var _super = _create_super._(Spinner);
    function Spinner() {
        _class_call_check._(this, Spinner);
        return _super.apply(this, arguments);
    }
    _create_class._(Spinner, [
        {
            key: "_active",
            value: function _active() {
                this._rotationAnimation = this.animation((0, _spinnerstyle.getSpinnerContainerAnimation)());
                this._progressAnimation = this.tag("Inner").animation({
                    duration: 1.2,
                    repeat: -1,
                    stopMethod: "immediate",
                    actions: [
                        {
                            p: "shader.progress",
                            v: {
                                0: {
                                    v: MIN_PROGRESS
                                },
                                0.38: {
                                    v: MAX_PROGRESS
                                },
                                1: {
                                    v: MIN_PROGRESS
                                }
                            }
                        },
                        {
                            p: "rotation",
                            v: {
                                0: {
                                    v: 0
                                },
                                1: {
                                    v: Math.PI * 2
                                }
                            }
                        }
                    ]
                });
                this._rotationAnimation.start();
                this._progressAnimation.start();
            }
        },
        {
            key: "_inactive",
            value: function _inactive() {
                if (this._rotationAnimation) {
                    this._rotationAnimation.stop();
                }
                if (this._progressAnimation) {
                    this._progressAnimation.stop();
                }
                this._rotationAnimation = null;
                this._progressAnimation = null;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return {
                    Inner: {
                        w: _sizes.identity,
                        h: _sizes.identity,
                        color: _spinnerstyle.color[_theme.DEFAULT_MODE],
                        rect: true,
                        shader: {
                            type: _spinnershader.SpinnerShader,
                            progress: MIN_PROGRESS
                        }
                    }
                };
            }
        }
    ]);
    return Spinner;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 48886:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "SpinnerShader", ({
    enumerable: true,
    get: function() {
        return SpinnerShader;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _get = __webpack_require__(60528);
var _get_prototype_of = __webpack_require__(35196);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(88801);
var _sdk = __webpack_require__(29956);
var SpinnerShader = /*#__PURE__*/ function(_Lightning_shaders_WebGLDefaultShader) {
    "use strict";
    _inherits._(SpinnerShader, _Lightning_shaders_WebGLDefaultShader);
    var _super = _create_super._(SpinnerShader);
    function SpinnerShader(ctx) {
        _class_call_check._(this, SpinnerShader);
        var _this;
        _this = _super.call(this, ctx);
        _this._progress = 0.0;
        return _this;
    }
    _create_class._(SpinnerShader, [
        {
            key: "progress",
            get: function get() {
                return this._progress;
            },
            set: function set(value) {
                this._progress = value;
                this.redraw();
            }
        },
        {
            key: "useDefault",
            value: function useDefault() {
                return _get._(_get_prototype_of._(SpinnerShader.prototype), "useDefault", this).call(this) && this._progress === 0.0;
            }
        },
        {
            key: "setupUniforms",
            value: function setupUniforms(operation) {
                _get._(_get_prototype_of._(SpinnerShader.prototype), "setupUniforms", this).call(this, operation);
                var gl = this.gl;
                this._setUniform("projection", this._getProjection(operation), gl.uniform2fv, false);
                this._setUniform("progress", this._progress, gl.uniform1f);
            }
        },
        {
            key: "getExtraAttribBytesPerVertex",
            value: function getExtraAttribBytesPerVertex() {
                return 8;
            }
        },
        {
            key: "enableAttribs",
            value: function enableAttribs() {
                _get._(_get_prototype_of._(SpinnerShader.prototype), "enableAttribs", this).call(this);
                this.gl.enableVertexAttribArray(this._attrib("aVertex"));
            }
        },
        {
            key: "disableAttribs",
            value: function disableAttribs() {
                _get._(_get_prototype_of._(SpinnerShader.prototype), "disableAttribs", this).call(this);
                this.gl.disableVertexAttribArray(this._attrib("aVertex"));
            }
        },
        {
            key: "setExtraAttribsInBuffer",
            value: function setExtraAttribsInBuffer(operation) {
                var offset = operation.extraAttribsDataByteOffset / 4;
                var floats = operation.quads.floats;
                var length = operation.length;
                for(var i = 0; i < length; i += 1){
                    /**
        1.0, -1.0,
        1.0,  1.0,
       -1.0,  1.0,
       -1.0, -1.0,
      */ floats[offset + 0] = 1;
                    floats[offset + 1] = -1;
                    floats[offset + 2] = 1;
                    floats[offset + 3] = 1;
                    floats[offset + 4] = -1;
                    floats[offset + 5] = 1;
                    floats[offset + 6] = -1;
                    floats[offset + 7] = -1;
                    offset += 8;
                }
            }
        },
        {
            key: "beforeDraw",
            value: function beforeDraw(operation) {
                var gl = this.gl;
                gl.vertexAttribPointer(this._attrib("aVertex"), 2, gl.FLOAT, false, this.getExtraAttribBytesPerVertex(), this.getVertexAttribPointerOffset(operation));
            }
        }
    ]);
    return SpinnerShader;
}(_sdk.Lightning.shaders.WebGLDefaultShader);
SpinnerShader.vertexShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n\n    attribute vec2 aVertexPosition;\n    attribute vec2 aVertex;\n    attribute vec4 aColor;\n\n    varying vec4 vColor;\n    varying vec2 vPosition;\n\n    uniform vec2 projection;\n\n    void main(void) {\n        gl_Position = vec4(aVertexPosition.x * projection.x - 1.0, aVertexPosition.y * -abs(projection.y) + 1.0, 0.0, 1.0);\n        gl_Position.y = -sign(projection.y) * gl_Position.y;\n\n        vPosition = aVertex;\n        vColor = aColor;\n    }\n";
SpinnerShader.fragmentShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n\n    #define PIx2 6.28318530718\n\n    varying vec4 vColor;\n    varying vec2 vPosition;\n\n    uniform float progress;\n\n    void main () {\n      float distance = sqrt(dot(vPosition, vPosition));\n      float externalRadius = 1.0;\n      float internalRadius = 0.86;\n\n      if (distance >= externalRadius || distance <= internalRadius) {\n        discard;\n      }\n\n      float angle = atan(vPosition.x, vPosition.y) / PIx2;\n      if (angle < 0.0) {\n        angle = 1.0 + angle;\n      }\n      angle = 1.0 - angle;\n      if (angle > progress) {\n        discard;\n      }\n\n      gl_FragColor = vColor;\n    }\n";


/***/ }),

/***/ 79796:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    color: function() {
        return color;
    },
    getSpinnerContainerAnimation: function() {
        return getSpinnerContainerAnimation;
    }
});
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(52318);
var _theme = __webpack_require__(51397);
var color = (0, _theme.makeThemeColor)(_theme.SECONDARY);
var getSpinnerContainerAnimation = function() {
    return {
        duration: 15,
        repeat: -1,
        stopMethod: "immediate",
        actions: [
            {
                p: "rotation",
                v: {
                    0: {
                        v: 0,
                        sm: 0
                    },
                    1: {
                        v: Math.PI * 2,
                        sm: 0
                    }
                }
            }
        ]
    };
};


/***/ }),

/***/ 76976:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(52318);
var _spinnercomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(74015));
var _default = _spinnercomponent.default;


/***/ }),

/***/ 37488:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BORDER_COLOR: function() {
        return BORDER_COLOR;
    },
    DESCRIPTION_FONT_NAME: function() {
        return DESCRIPTION_FONT_NAME;
    },
    DESCRIPTION_FONT_TYPE: function() {
        return DESCRIPTION_FONT_TYPE;
    },
    ICONS: function() {
        return ICONS;
    },
    ICONS_TYPES: function() {
        return ICONS_TYPES;
    },
    INNER_BORDER_COLOR: function() {
        return INNER_BORDER_COLOR;
    },
    ITEMS_BY_BREAKPOINTS: function() {
        return ITEMS_BY_BREAKPOINTS;
    },
    TITLE_FONT_NAME: function() {
        return TITLE_FONT_NAME;
    },
    TITLE_FONT_TYPE: function() {
        return TITLE_FONT_TYPE;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(65759);
var _constants = __webpack_require__(34952);
var _typography = __webpack_require__(18411);
var _theme = __webpack_require__(51397);
var _templates = __webpack_require__(88229);
var _iconcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(70160));
var _badgecomponent = __webpack_require__(69289);
var TITLE_FONT_NAME = _typography.FONT.BERLIN_3;
var TITLE_FONT_TYPE = _typography.FONT_TYPE.MAIN;
var DESCRIPTION_FONT_NAME = _typography.FONT.MADRID_1;
var DESCRIPTION_FONT_TYPE = _typography.FONT_TYPE.MAIN;
var BORDER_COLOR = (0, _theme.makeThemeColor)(_theme.PRIMARY);
var INNER_BORDER_COLOR = (0, _theme.makeThemeColor)(_theme.TERTIARY);
var ICONS = _define_property._({}, _templates.ICON_POSITION.TOP_RIGHT, 4);
var _obj;
var ICONS_TYPES = (_obj = {}, _define_property._(_obj, _templates.ICON_POSITION.TOP_LEFT, _iconcomponent.default), _define_property._(_obj, _templates.ICON_POSITION.TOP_RIGHT, _badgecomponent.Badge), _define_property._(_obj, _templates.ICON_POSITION.BOTTOM_RIGHT, _iconcomponent.default), _obj);
var _obj1;
var ITEMS_BY_BREAKPOINTS = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 8), _define_property._(_obj1, _constants.FULL_HD, 8), _obj1);


/***/ }),

/***/ 57286:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return SquareMeta;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _sliced_to_array = __webpack_require__(28966);
var _create_super = __webpack_require__(6400);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(45538);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _signals = __webpack_require__(2109);
var _progressutils = __webpack_require__(40779);
var _templates = __webpack_require__(88229);
var _incentivecomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(9077));
var _incentivestyle = __webpack_require__(64443);
var _focusshader = /*#__PURE__*/ _interop_require_default._(__webpack_require__(25906));
var _imageshader = /*#__PURE__*/ _interop_require_default._(__webpack_require__(17154));
var _squareMetastyle = __webpack_require__(60527);
var _squareMetaconstants = __webpack_require__(15634);
var _incentiveutils = __webpack_require__(72823);
var SquareMeta = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(SquareMeta, _Lightning_Component);
    var _super = _create_super._(SquareMeta);
    function SquareMeta() {
        _class_call_check._(this, SquareMeta);
        return _super.apply(this, arguments);
    }
    _create_class._(SquareMeta, [
        {
            key: "_construct",
            value: function _construct() {
                this._index = 0;
                this._style = _object_spread._({}, _squareMetastyle.defaultContext);
            }
        },
        {
            key: "_inactive",
            value: function _inactive() {
                this.signal(_signals.INACTIVE_SIGNAL, this);
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                var _this = this;
                _squareMetastyle.TITLES_ORDER.forEach(function(id) {
                    var view = _this.tag(id);
                    if (view) {
                        view.removeAllListeners("txLoaded");
                    }
                });
                this._item = undefined;
                this.signal(_signals.DETACHED_SIGNAL, this);
            }
        },
        {
            key: "index",
            get: function get() {
                return this._index;
            },
            set: function set(value) {
                this._index = value;
            }
        },
        {
            key: "item",
            get: function get() {
                return this._item;
            },
            set: function set(param) {
                var content = param.content, config = param.config, template = param.template, _param_colorScheme = param.colorScheme, colorScheme = _param_colorScheme === void 0 ? _squareMetastyle.defaultContext.colorMode : _param_colorScheme;
                var _this = this;
                var templateDataAccessPath = [
                    template,
                    this._style.screenSize
                ];
                var progress = (0, _progressutils.getProgress)(content.progress);
                if ((0, _templates.areContentItemsEqual)(this._item, content)) {
                    this._item = content;
                    this.patch({
                        Image: {
                            shader: {
                                progress: progress
                            }
                        }
                    });
                    return;
                }
                this._item = content;
                this._config = config || _object_spread._({}, (0, _get.default)(_squareMetaconstants.sizes, templateDataAccessPath, {}));
                if (colorScheme && colorScheme !== this._style.colorMode) {
                    this._style = {
                        screenSize: this._style.screenSize,
                        colorMode: colorScheme
                    };
                }
                var _this__item = this._item, title = _this__item.title, description = _this__item.description, pictos = _this__item.pictos;
                var wordWrapWidth = this.wordWrapWidth;
                var colorMode = this._style.colorMode;
                var templateImageOptions = (0, _get.default)(_squareMetaconstants.imageOptions, templateDataAccessPath, {});
                var imageUrl = (0, _get.default)(this._item, "image.src", "");
                var offset = _squareMetastyle.IMAGE_OFFSET[this._style.screenSize];
                var topLeftIcon = (0, _squareMetastyle.getIcon)(pictos, _templates.ICON_POSITION.TOP_LEFT);
                var topRightIcon = (0, _squareMetastyle.getIcon)(pictos, _templates.ICON_POSITION.TOP_RIGHT);
                var bottomRightIcon = (0, _squareMetastyle.getIcon)(pictos, _templates.ICON_POSITION.BOTTOM_RIGHT);
                var incentiveLines = (0, _incentiveutils.getLinesCount)(this._item.incentives);
                this._hasIncentives = incentiveLines > 0;
                this.patch({
                    w: this._config.w,
                    h: this._config.h,
                    Border: {
                        w: templateImageOptions.PRIMARY.width + offset,
                        h: templateImageOptions.PRIMARY.height + offset
                    },
                    Image: {
                        w: templateImageOptions.PRIMARY.width,
                        h: templateImageOptions.PRIMARY.height,
                        src: imageUrl,
                        shader: {
                            progress: progress
                        }
                    },
                    TopLeftIcon: {
                        visible: Boolean(topLeftIcon),
                        iconData: {
                            picto: topLeftIcon,
                            viewBox: (0, _squareMetastyle.getIconViewBox)(this._style.screenSize)
                        }
                    },
                    TopRightIcon: {
                        visible: Boolean(topRightIcon),
                        iconData: {
                            picto: topRightIcon,
                            viewBox: (0, _squareMetastyle.getIconViewBox)(this._style.screenSize)
                        }
                    },
                    BottomRightIcon: {
                        visible: Boolean(bottomRightIcon),
                        y: templateImageOptions.PRIMARY.height - _squareMetastyle.ICON_PADDING_VERTICAL - _squareMetastyle.PROGRESS_HEIGHT,
                        iconData: {
                            picto: bottomRightIcon,
                            viewBox: (0, _squareMetastyle.getIconViewBox)(this._style.screenSize)
                        }
                    },
                    Incentive: {
                        visible: this._hasIncentives,
                        y: templateImageOptions.PRIMARY.height + _squareMetastyle.IMAGE_MARGIN_BOTTOM,
                        data: {
                            w: templateImageOptions.PRIMARY.width,
                            linesCount: incentiveLines,
                            incentives: this._item.incentives,
                            colorMode: this._style.colorMode
                        }
                    },
                    Title: (0, _templates.makeTextPatch)(title || "", wordWrapWidth, _squareMetastyle.colors.title[colorMode]),
                    Description: (0, _templates.makeTextPatch)(description || "", wordWrapWidth, _squareMetastyle.colors.description[colorMode])
                });
                _squareMetastyle.TITLES_ORDER.forEach(function(id) {
                    var view = _this.tag(id);
                    if (view) {
                        view.on("txLoaded", _this._updateMetadataPosition.bind(_this));
                    }
                });
            }
        },
        {
            key: "wordWrapWidth",
            get: function get() {
                return this._config ? this._config.w : 0;
            }
        },
        {
            key: "_updateMetadataPosition",
            value: function _updateMetadataPosition() {
                // NOTE: we are using manual calculation instead of the "flex" layout in order to speed up tile creation
                var _TITLES_ORDER = _sliced_to_array._(_squareMetastyle.TITLES_ORDER, 2), firstLineTag = _TITLES_ORDER[0], secondLineTag = _TITLES_ORDER[1];
                var firstLine = this.tag(firstLineTag);
                var secondLine = this.tag(secondLineTag);
                var incentiveHeight = this._hasIncentives ? _incentivestyle.HEIGHT[this._style.screenSize] : 0;
                var offset = this.tag("Image").h + _squareMetastyle.IMAGE_MARGIN_BOTTOM + incentiveHeight;
                if (firstLine.visible) {
                    firstLine.y = offset;
                    offset += firstLine.finalH;
                }
                if (secondLine.visible) {
                    secondLine.y = offset;
                }
            }
        },
        {
            key: "_focus",
            value: function _focus() {
                this.patch((0, _squareMetastyle.getFocusedStyle)(this._style));
            }
        },
        {
            key: "_unfocus",
            value: function _unfocus() {
                this.patch(_squareMetastyle.unFocusedStyle);
            }
        },
        {
            key: "_handleEnter",
            value: function _handleEnter() {
                this.signal(_signals.SELECTED_SIGNAL, this._item);
                return true;
            }
        }
    ], [
        {
            key: "_template",
            value: /* istanbul ignore next */ function _template() {
                return (0, _merge.default)({
                    Border: {
                        rect: true,
                        shader: {
                            type: _focusshader.default
                        }
                    },
                    Image: {
                        shader: {
                            type: _imageshader.default
                        }
                    },
                    TopLeftIcon: {
                        type: _squareMetaconstants.ICONS_TYPES[_templates.ICON_POSITION.TOP_LEFT]
                    },
                    TopRightIcon: {
                        type: _squareMetaconstants.ICONS_TYPES[_templates.ICON_POSITION.TOP_RIGHT]
                    },
                    BottomRightIcon: {
                        type: _squareMetaconstants.ICONS_TYPES[_templates.ICON_POSITION.BOTTOM_RIGHT]
                    },
                    Incentive: {
                        type: _incentivecomponent.default
                    },
                    Title: {},
                    Description: {}
                }, (0, _squareMetastyle.getInitialStyle)());
            }
        }
    ]);
    return SquareMeta;
}(_sdk.Lightning.Component);
SquareMeta.Templates = _squareMetaconstants.templates;
SquareMeta.Sizes = _squareMetaconstants.sizes;
SquareMeta.ImageOptions = _squareMetaconstants.imageOptions;


/***/ }),

/***/ 15634:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DESCRIPTION_LINES: function() {
        return DESCRIPTION_LINES;
    },
    ICON_HEIGHT: function() {
        return ICON_HEIGHT;
    },
    ICON_PADDING_HORIZONTAL: function() {
        return ICON_PADDING_HORIZONTAL;
    },
    ICON_PADDING_VERTICAL: function() {
        return ICON_PADDING_VERTICAL;
    },
    IMAGE_MARGIN_BOTTOM: function() {
        return IMAGE_MARGIN_BOTTOM;
    },
    TITLES_ORDER: function() {
        return TITLES_ORDER;
    },
    TITLE_LINES: function() {
        return TITLE_LINES;
    },
    imageOptions: function() {
        return imageOptions;
    },
    sizes: function() {
        return sizes;
    },
    templates: function() {
        return templates;
    }
});
var _define_property = __webpack_require__(21228);
var _export_star = __webpack_require__(37668);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(37815);
var _constants = __webpack_require__(34952);
var _typography = __webpack_require__(18411);
var _incentivestyle = __webpack_require__(64443);
var _squareMetaconstants = _export_star._(__webpack_require__(37488), exports);
var _sizes = __webpack_require__(82699);
var IMAGE_MARGIN_BOTTOM = 8;
var ICON_PADDING_VERTICAL = 4;
var ICON_PADDING_HORIZONTAL = 8;
var _obj;
var ICON_HEIGHT = (_obj = {}, _define_property._(_obj, _constants.HD, 24), _define_property._(_obj, _constants.FULL_HD, 32), _obj);
var TITLES_ORDER = [
    "Title",
    "Description"
];
var TITLE_LINES = 2;
var DESCRIPTION_LINES = 2;
var templates = {
    SquareMeta: "SquareMeta"
};
var RATIO = 1;
var _obj1;
var metadataHeight = (_obj1 = {}, _define_property._(_obj1, _constants.HD, _incentivestyle.HEIGHT[_constants.HD] + (0, _typography.getFont)(_squareMetaconstants.TITLE_FONT_NAME, _constants.HD, _squareMetaconstants.TITLE_FONT_TYPE).lineHeight * TITLE_LINES + (0, _typography.getFont)(_squareMetaconstants.DESCRIPTION_FONT_NAME, _constants.HD, _squareMetaconstants.DESCRIPTION_FONT_TYPE).lineHeight * DESCRIPTION_LINES + IMAGE_MARGIN_BOTTOM), _define_property._(_obj1, _constants.FULL_HD, _incentivestyle.HEIGHT[_constants.FULL_HD] + (0, _typography.getFont)(_squareMetaconstants.TITLE_FONT_NAME, _constants.FULL_HD, _squareMetaconstants.TITLE_FONT_TYPE).lineHeight * TITLE_LINES + (0, _typography.getFont)(_squareMetaconstants.DESCRIPTION_FONT_NAME, _constants.FULL_HD, _squareMetaconstants.DESCRIPTION_FONT_TYPE).lineHeight * DESCRIPTION_LINES + IMAGE_MARGIN_BOTTOM), _obj1);
var imageOptions = (0, _sizes.getElementSize)(_squareMetaconstants.ITEMS_BY_BREAKPOINTS, RATIO, templates.SquareMeta).imageOptions;
var _obj2;
var sizes = _define_property._({}, templates.SquareMeta, (_obj2 = {}, _define_property._(_obj2, _constants.HD, {
    w: imageOptions[templates.SquareMeta][_constants.HD].PRIMARY.width,
    h: imageOptions[templates.SquareMeta][_constants.HD].PRIMARY.height + metadataHeight[_constants.HD]
}), _define_property._(_obj2, _constants.FULL_HD, {
    w: imageOptions[templates.SquareMeta][_constants.FULL_HD].PRIMARY.width,
    h: imageOptions[templates.SquareMeta][_constants.FULL_HD].PRIMARY.height + metadataHeight[_constants.HD]
}), _obj2));


/***/ }),

/***/ 60527:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ICON_HEIGHT: function() {
        return _squareMetaconstants.ICON_HEIGHT;
    },
    ICON_PADDING_VERTICAL: function() {
        return _squareMetaconstants.ICON_PADDING_VERTICAL;
    },
    IMAGE_MARGIN_BOTTOM: function() {
        return _squareMetaconstants.IMAGE_MARGIN_BOTTOM;
    },
    IMAGE_OFFSET: function() {
        return IMAGE_OFFSET;
    },
    PROGRESS_HEIGHT: function() {
        return _progressstyle.HEIGHT;
    },
    TITLES_ORDER: function() {
        return _squareMetaconstants.TITLES_ORDER;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getDetailsPosition: function() {
        return getDetailsPosition;
    },
    getFocusedStyle: function() {
        return getFocusedStyle;
    },
    getIcon: function() {
        return getIcon;
    },
    getIconViewBox: function() {
        return getIconViewBox;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    makeBasicIconStyle: function() {
        return makeBasicIconStyle;
    },
    unFocusedStyle: function() {
        return unFocusedStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(88801);
var _memoize = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34736));
var _typography = __webpack_require__(18411);
var _theme = __webpack_require__(51397);
var _constants = __webpack_require__(34952);
var _progressstyle = __webpack_require__(67614);
var _sizes = __webpack_require__(82699);
var _style = __webpack_require__(65082);
var _focus = __webpack_require__(78506);
var _squareMetaconstants = __webpack_require__(15634);
var _colors = __webpack_require__(8426);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var getIconViewBox = (0, _memoize.default)(function(screenSize) {
    return {
        h: _squareMetaconstants.ICON_HEIGHT[screenSize]
    };
});
var colors = {
    title: (0, _theme.makeThemeColor)(_theme.PRIMARY),
    description: (0, _theme.makeThemeColor)(_theme.PRIMARY, 0.6),
    border: _squareMetaconstants.BORDER_COLOR,
    innerBorder: _squareMetaconstants.INNER_BORDER_COLOR
};
var _obj;
var IMAGE_OFFSET = (_obj = {}, _define_property._(_obj, _constants.HD, _focus.BORDER_WIDTH[_constants.HD] * 2), _define_property._(_obj, _constants.FULL_HD, _focus.BORDER_WIDTH[_constants.FULL_HD] * 2), _obj);
var getIcon = function(icons, position) {
    return icons ? icons[_squareMetaconstants.ICONS[position]] : null;
};
var makeBasicIconStyle = function() {
    return {
        alpha: 0.8,
        y: _squareMetaconstants.ICON_PADDING_VERTICAL
    };
};
var getDetailsPosition = (0, _memoize.default)(function() {
    var hasHighlightText = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
    return hasHighlightText ? {
        mountX: 1,
        x: _sizes.identity
    } : {
        mountX: 0,
        x: 0
    };
});
var getInitialStyle = (0, _memoize.default)(function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext, _ref_screenSize = _ref.screenSize, screenSize = _ref_screenSize === void 0 ? _constants.FULL_HD : _ref_screenSize, _ref_colorMode = _ref.colorMode, colorMode = _ref_colorMode === void 0 ? _theme.DEFAULT_MODE : _ref_colorMode;
    return {
        zIndex: _style.UNFOCUSED_Z_INDEX,
        Border: {
            zIndex: 1,
            x: -_focus.BORDER_WIDTH[screenSize],
            y: -_focus.BORDER_WIDTH[screenSize],
            shader: {
                outline: _focus.BORDER_WIDTH[screenSize],
                radius: _focus.BORDER_RADIUS[screenSize],
                strokeColor: _colors.TRANSPARENT
            }
        },
        Image: {
            zIndex: 2,
            shader: {
                radius: _focus.BORDER_RADIUS[screenSize],
                progressHeight: _progressstyle.HEIGHT,
                progressBackgroundColor: _progressstyle.colors.background[colorMode],
                progressBarColor: _progressstyle.colors.bar[colorMode]
            }
        },
        TopLeftIcon: {
            zIndex: 3,
            x: _squareMetaconstants.ICON_PADDING_HORIZONTAL,
            y: _squareMetaconstants.ICON_PADDING_VERTICAL
        },
        TopRightIcon: _object_spread_props._(_object_spread._({
            zIndex: 3
        }, makeBasicIconStyle()), {
            mountX: 1,
            x: function(width) {
                return width - _squareMetaconstants.ICON_PADDING_HORIZONTAL;
            },
            y: _squareMetaconstants.ICON_PADDING_VERTICAL
        }),
        BottomRightIcon: {
            zIndex: 3,
            mount: 1,
            x: function(w) {
                return w - _squareMetaconstants.ICON_PADDING_HORIZONTAL;
            },
            alpha: 0.8
        },
        Incentive: {
            zIndex: 0
        },
        Title: {
            color: colors.title[colorMode],
            text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_squareMetaconstants.TITLE_FONT_NAME, screenSize, _squareMetaconstants.TITLE_FONT_TYPE)), {
                maxLines: _squareMetaconstants.TITLE_LINES,
                verticalAlign: "bottom",
                wordWrap: true,
                wordBreak: true,
                advancedRenderer: true,
                maxLinesSuffix: "..."
            })
        },
        Description: {
            color: colors.description[colorMode],
            text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_squareMetaconstants.DESCRIPTION_FONT_NAME, screenSize, _squareMetaconstants.DESCRIPTION_FONT_TYPE)), {
                maxLines: _squareMetaconstants.DESCRIPTION_LINES,
                verticalAlign: "middle",
                wordWrap: true,
                maxLinesSuffix: "..."
            })
        },
        ProgressBar: {
            mountY: 1
        }
    };
}, _style.cacheResolver);
var getFocusedStyle = (0, _memoize.default)(function(param) {
    var colorMode = param.colorMode;
    return {
        zIndex: _style.FOCUSED_Z_INDEX,
        Border: {
            smooth: {
                scale: _focus.SCALE_FOCUSED,
                "shader.strokeColor": colors.border[colorMode],
                "shader.innerColor": colors.innerBorder[colorMode],
                "shader.scale": _focus.SCALE_FOCUSED
            }
        },
        Image: {
            smooth: {
                scale: _focus.SCALE_FOCUSED,
                "shader.scale": _focus.SCALE_FOCUSED
            }
        }
    };
}, _style.cacheResolver);
var unFocusedStyle = {
    zIndex: _style.UNFOCUSED_Z_INDEX,
    Border: {
        smooth: {
            scale: 1,
            "shader.strokeColor": _colors.TRANSPARENT,
            "shader.innerColor": _colors.TRANSPARENT,
            "shader.scale": 1.0
        }
    },
    Image: {
        smooth: {
            scale: 1,
            "shader.scale": 1.0
        }
    }
};


/***/ }),

/***/ 54838:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BORDER_COLOR: function() {
        return BORDER_COLOR;
    },
    INNER_BORDER_COLOR: function() {
        return INNER_BORDER_COLOR;
    },
    ITEMS_BY_BREAKPOINTS: function() {
        return ITEMS_BY_BREAKPOINTS;
    },
    iconSizes: function() {
        return iconSizes;
    }
});
var _define_property = __webpack_require__(21228);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(42578);
var _constants = __webpack_require__(34952);
var _theme = __webpack_require__(51397);
var BORDER_COLOR = (0, _theme.makeThemeColor)(_theme.PRIMARY);
var INNER_BORDER_COLOR = (0, _theme.makeThemeColor)(_theme.TERTIARY);
var _obj;
var ITEMS_BY_BREAKPOINTS = (_obj = {}, _define_property._(_obj, _constants.HD, 8), _define_property._(_obj, _constants.FULL_HD, 8), _obj);
var _obj1;
var iconSizes = (_obj1 = {}, _define_property._(_obj1, _constants.HD, {
    h: 80,
    // width should be 1.6 * height
    w: 112
}), _define_property._(_obj1, _constants.FULL_HD, {
    h: 96,
    // width should be 1.6 * height
    w: 144
}), _obj1);


/***/ }),

/***/ 85520:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return Square;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _squareconstants = __webpack_require__(37049);
var _signals = __webpack_require__(2109);
var _squarestyle = __webpack_require__(49553);
var _focusshader = /*#__PURE__*/ _interop_require_default._(__webpack_require__(25906));
var _imageshader = /*#__PURE__*/ _interop_require_default._(__webpack_require__(17154));
var _templates = __webpack_require__(88229);
var Square = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(Square, _Lightning_Component);
    var _super = _create_super._(Square);
    function Square() {
        _class_call_check._(this, Square);
        return _super.apply(this, arguments);
    }
    _create_class._(Square, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _squarestyle.defaultContext;
            }
        },
        {
            key: "_inactive",
            value: function _inactive() {
                this.signal(_signals.INACTIVE_SIGNAL, this);
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                this._item = undefined;
                this.signal(_signals.DETACHED_SIGNAL, this);
                this.tag("Image").removeAllListeners("txLoaded");
            }
        },
        {
            key: "item",
            get: function get() {
                return this._item;
            },
            set: function set(param) {
                var content = param.content, config = param.config;
                if ((0, _templates.areContentItemsEqual)(this._item, content)) {
                    this._item = content;
                    return;
                }
                this._item = content;
                this._config = config || _squareconstants.sizes[_squareconstants.templates.Square][this._style.screenSize];
                var imageUrl = content.image && content.image.src || "";
                var offset = _squarestyle.IMAGE_OFFSET[this._style.screenSize];
                var image = this.tag("Image");
                image.once("txLoaded", function() {
                    image.setSmooth("alpha", 1);
                });
                this.patch({
                    w: this._config.w,
                    h: this._config.h,
                    Border: {
                        w: this._config.w + offset,
                        h: this._config.h + offset
                    },
                    Image: {
                        w: this._config.w,
                        h: this._config.h,
                        src: imageUrl,
                        alpha: 0.0001
                    }
                });
            }
        },
        {
            key: "_focus",
            value: function _focus() {
                this.patch((0, _squarestyle.getFocusedStyle)({
                    colorMode: this._style.colorMode
                }));
            }
        },
        {
            key: "_unfocus",
            value: function _unfocus() {
                this.patch(_squarestyle.unFocusedStyle);
            }
        },
        {
            key: "_handleEnter",
            value: function _handleEnter() {
                this.signal(_signals.SELECTED_SIGNAL, this._item);
                return true;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Border: {
                        rect: true,
                        shader: {
                            type: _focusshader.default
                        }
                    },
                    Image: {
                        shader: {
                            type: _imageshader.default
                        }
                    }
                }, (0, _squarestyle.getInitialStyle)());
            }
        }
    ]);
    return Square;
}(_sdk.Lightning.Component);
Square.Templates = _squareconstants.templates;
Square.Sizes = _squareconstants.sizes;
Square.ImageOptions = _squareconstants.imageOptions;


/***/ }),

/***/ 37049:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    imageOptions: function() {
        return imageOptions;
    },
    sizes: function() {
        return sizes;
    },
    templates: function() {
        return templates;
    }
});
var _export_star = __webpack_require__(37668);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
var _sizes = __webpack_require__(82699);
var _squareconstants = _export_star._(__webpack_require__(54838), exports);
var templates = {
    Square: "Square"
};
var RATIO = 1;
var _getElementSize = (0, _sizes.getElementSize)(_squareconstants.ITEMS_BY_BREAKPOINTS, RATIO, templates.Square), sizes = _getElementSize.sizes, imageOptions = _getElementSize.imageOptions;


/***/ }),

/***/ 49553:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BORDER_RADIUS: function() {
        return BORDER_RADIUS;
    },
    IMAGE_OFFSET: function() {
        return IMAGE_OFFSET;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getFocusedStyle: function() {
        return getFocusedStyle;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    unFocusedStyle: function() {
        return unFocusedStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(3009);
var _memoize = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34736));
var _theme = __webpack_require__(51397);
var _constants = __webpack_require__(34952);
var _progressstyle = __webpack_require__(67614);
var _style = __webpack_require__(65082);
var _focus = __webpack_require__(78506);
var _colors = __webpack_require__(8426);
var _squareconstants = __webpack_require__(37049);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var IMAGE_OFFSET = (_obj = {}, _define_property._(_obj, _constants.HD, _focus.BORDER_WIDTH[_constants.HD] * 2), _define_property._(_obj, _constants.FULL_HD, _focus.BORDER_WIDTH[_constants.FULL_HD] * 2), _obj);
var _obj1;
var BORDER_RADIUS = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 8), _define_property._(_obj1, _constants.FULL_HD, 8), _obj1);
var colors = {
    background: (0, _theme.makeThemeColor)(_theme.PRIMARY, 0.1),
    border: _squareconstants.BORDER_COLOR,
    innerBorder: _squareconstants.INNER_BORDER_COLOR
};
var getInitialStyle = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext, screenSize = _ref.screenSize, colorMode = _ref.colorMode;
    return {
        Border: {
            x: -_focus.BORDER_WIDTH[screenSize],
            y: -_focus.BORDER_WIDTH[screenSize],
            shader: {
                outline: _focus.BORDER_WIDTH[screenSize],
                radius: BORDER_RADIUS[screenSize],
                strokeColor: _colors.TRANSPARENT
            }
        },
        Image: {
            shader: {
                radius: BORDER_RADIUS[screenSize],
                progressHeight: _progressstyle.HEIGHT,
                progressBackgroundColor: _progressstyle.colors.background[colorMode],
                progressBarColor: _progressstyle.colors.bar[colorMode]
            }
        }
    };
};
var getFocusedStyle = (0, _memoize.default)(function(param) {
    var colorMode = param.colorMode;
    return {
        Border: {
            smooth: {
                scale: _focus.SCALE_FOCUSED,
                "shader.strokeColor": colors.border[colorMode],
                "shader.innerColor": colors.innerBorder[colorMode],
                "shader.scale": _focus.SCALE_FOCUSED
            }
        },
        Image: {
            smooth: {
                scale: _focus.SCALE_FOCUSED,
                "shader.scale": _focus.SCALE_FOCUSED
            }
        }
    };
}, _style.cacheResolver);
var unFocusedStyle = {
    Border: {
        smooth: {
            scale: 1,
            "shader.strokeColor": _colors.TRANSPARENT,
            "shader.innerColor": _colors.TRANSPARENT,
            "shader.scale": 1.0
        }
    },
    Image: {
        smooth: {
            scale: 1,
            "shader.scale": 1.0
        }
    }
};


/***/ }),

/***/ 56117:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return Stamp;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(52318);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _stampstyle = __webpack_require__(76103);
var Stamp = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(Stamp, _Lightning_Component);
    var _super = _create_super._(Stamp);
    function Stamp() {
        _class_call_check._(this, Stamp);
        return _super.apply(this, arguments);
    }
    _create_class._(Stamp, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _stampstyle.defaultContext;
            }
        },
        {
            key: "_build",
            value: function _build() {
                var _this = this;
                var label = this.tag("Label");
                var handleUpdate = function() {
                    var w = label.finalW + _stampstyle.PADDING[_this._style.screenSize] * 2;
                    var labelOffsetX = (w - label.finalW) / 2;
                    _this.patch({
                        w: w,
                        Label: {
                            x: labelOffsetX
                        }
                    });
                    _this.emit("txLoaded");
                };
                label.on("txLoaded", handleUpdate);
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                this.tag("Label").removeAllListeners("txLoaded");
            }
        },
        {
            key: "label",
            set: function set(value) {
                this.tag("Label").text.text = value;
            }
        },
        {
            key: "labelColor",
            set: function set(value) {
                this.tag("Label").color = value;
            }
        },
        {
            key: "backgroundColor",
            set: function set(value) {
                this.tag("Background").color = value;
            }
        },
        {
            key: "wordWrapWidth",
            set: function set(value) {
                this.tag("Label").text.wordWrapWidth = value;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Background: {
                        rect: true,
                        shader: {
                            type: _sdk.Lightning.shaders.RoundedRectangle
                        }
                    },
                    Label: {}
                }, (0, _stampstyle.getInitialStyle)());
            }
        }
    ]);
    return Stamp;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 97147:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DISPLAY_VARIANT_PRIMARY: function() {
        return DISPLAY_VARIANT_PRIMARY;
    },
    DISPLAY_VARIANT_SECONDARY: function() {
        return DISPLAY_VARIANT_SECONDARY;
    }
});
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(45538);
var DISPLAY_VARIANT_PRIMARY = "primary";
var DISPLAY_VARIANT_SECONDARY = "secondary";


/***/ }),

/***/ 76103:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BORDER_RADIUS: function() {
        return BORDER_RADIUS;
    },
    PADDING: function() {
        return PADDING;
    },
    TITLE_FONT_TYPE: function() {
        return TITLE_FONT_TYPE;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    getLabelFont: function() {
        return getLabelFont;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(3009);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _constants = __webpack_require__(34952);
var _typography = __webpack_require__(18411);
var _theme = __webpack_require__(51397);
var _style = __webpack_require__(65082);
var _sizes = __webpack_require__(82699);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var PADDING = (_obj = {}, _define_property._(_obj, _constants.HD, 4), _define_property._(_obj, _constants.FULL_HD, 4), _obj);
var _obj1;
var BORDER_RADIUS = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 2), _define_property._(_obj1, _constants.FULL_HD, 2), _obj1);
var colors = {
    text: (0, _theme.makeThemeColor)(_theme.PRIMARY),
    primary: (0, _theme.makeThemeColor)(_theme.CLOUD_NORMAL),
    secondary: (0, _theme.makeThemeColor)(_theme.QUINARY)
};
var TITLE_FONT_TYPE = _typography.FONT_TYPE.MAIN;
var getLabelFont = function(screenSize) {
    return (0, _typography.getFont)(_typography.FONT.BOSTON_2, screenSize, TITLE_FONT_TYPE);
};
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var screenSize = context.screenSize, colorMode = context.colorMode;
    var font = getLabelFont(screenSize);
    var h = font.lineHeight + PADDING[screenSize] * 2;
    return (0, _merge.default)({
        h: h,
        Background: {
            h: h,
            color: colors.primary[colorMode],
            shader: {
                radius: BORDER_RADIUS[screenSize]
            },
            w: _sizes.identity
        },
        Label: {
            y: PADDING[screenSize],
            color: colors.text[colorMode],
            text: _object_spread_props._(_object_spread._({}, font), {
                verticalAlign: "middle",
                wordWrap: false,
                textOverflow: "..."
            })
        }
    });
};


/***/ }),

/***/ 52273:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    HEADER_1: function() {
        return HEADER_1;
    },
    HEADER_2: function() {
        return HEADER_2;
    },
    HEADER_3: function() {
        return HEADER_3;
    },
    LIST: function() {
        return LIST;
    },
    LISTS: function() {
        return LISTS;
    },
    ORDERED_LIST: function() {
        return ORDERED_LIST;
    },
    PARAGRAPH: function() {
        return PARAGRAPH;
    },
    SINGLE_LINE_COMPONENTS: function() {
        return SINGLE_LINE_COMPONENTS;
    }
});
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
var HEADER_1 = "h1";
var HEADER_2 = "h2";
var HEADER_3 = "h3";
var PARAGRAPH = "p";
var LIST = "ul";
var ORDERED_LIST = "ol";
var SINGLE_LINE_COMPONENTS = [
    HEADER_1,
    HEADER_2,
    HEADER_3,
    PARAGRAPH
];
var LISTS = [
    LIST,
    ORDERED_LIST
];


/***/ }),

/***/ 94947:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    renderFile: function() {
        return renderFile;
    },
    renderNode: function() {
        return renderNode;
    }
});
var _interop_require_default = __webpack_require__(81200);
var _interop_require_wildcard = __webpack_require__(95316);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(37815);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _staticFilesstyles = /*#__PURE__*/ _interop_require_wildcard._(__webpack_require__(35711));
var _staticFilesconstants = __webpack_require__(52273);
var renderH1Node = function(node, config) {
    var content = node.content;
    var wordWrap = config.wordWrap;
    return (0, _merge.default)({
        text: {
            text: content,
            wordWrapWidth: wordWrap
        }
    }, _staticFilesstyles.header1NodeStyle(config));
};
var renderH2Node = function(node, config) {
    var content = node.content;
    var wordWrap = config.wordWrap;
    return (0, _merge.default)({
        text: {
            text: content,
            wordWrapWidth: wordWrap
        }
    }, _staticFilesstyles.header2NodeStyle(config));
};
var renderH3Node = function(node, config) {
    var content = node.content;
    var wordWrap = config.wordWrap;
    return (0, _merge.default)({
        text: {
            text: content,
            wordWrapWidth: wordWrap
        }
    }, _staticFilesstyles.header3NodeStyle(config));
};
var renderPNode = function(node, config) {
    var content = node.content;
    var wordWrap = config.wordWrap;
    return (0, _merge.default)({
        text: {
            text: content,
            wordWrapWidth: wordWrap
        }
    }, _staticFilesstyles.paragraphNodeStyle(config));
};
var renderListItem = function(node, config) {
    var content = node.content;
    var wordWrap = config.wordWrap;
    var text = typeof content === "object" && content.originalIndex ? "  ".concat(content.originalIndex, ".  ").concat(content.content) : "  •  ".concat(content.content);
    return (0, _merge.default)({
        text: {
            text: text,
            wordWrapWidth: wordWrap
        }
    }, _staticFilesstyles.paragraphNodeStyle(config));
};
var renderListNode = function(node, config) {
    var content = node.content;
    return (0, _merge.default)({
        children: content.map(function(item) {
            return renderListItem({
                content: item
            }, config);
        })
    }, _staticFilesstyles.listNodeStyle(config));
};
var renderOrderedListItem = function(node, config) {
    var content = node.content, index = node.index;
    var wordWrap = config.wordWrap;
    var text = typeof content === "object" && content.originalIndex ? "  ".concat(content.originalIndex, ".  ").concat(content.content) : "  ".concat(index + 1, ".  ").concat(content);
    return (0, _merge.default)({
        text: {
            text: text,
            wordWrapWidth: wordWrap
        }
    }, _staticFilesstyles.paragraphNodeStyle(config));
};
var renderOrderedListNode = function(node, config) {
    var content = node.content;
    return (0, _merge.default)({
        children: content.map(function(item, index) {
            return renderOrderedListItem({
                content: item,
                index: index
            }, config);
        })
    }, _staticFilesstyles.listNodeStyle(config));
};
var renderNode = function(node, config) {
    switch(node.tag){
        case _staticFilesconstants.HEADER_1:
            return renderH1Node(node, config);
        case _staticFilesconstants.HEADER_2:
            return renderH2Node(node, config);
        case _staticFilesconstants.HEADER_3:
            return renderH3Node(node, config);
        case _staticFilesconstants.PARAGRAPH:
            return renderPNode(node, config);
        case _staticFilesconstants.LIST:
            return renderListNode(node, config);
        case _staticFilesconstants.ORDERED_LIST:
            return renderOrderedListNode(node, config);
        default:
            return {};
    }
};
var renderFile = function(file, config) {
    var lastItemIndex = file.length - 1;
    return file.map(function(node, i) {
        var isLastItem = i === lastItemIndex;
        var newNode = renderNode(node, config);
        if (newNode.children && newNode.children.length > 0) {
            newNode.children[newNode.children.length - 1].flexItem.marginBottom = 0;
        }
        if (isLastItem) {
            newNode.flexItem.marginBottom = 0;
        }
        return newNode;
    });
};


/***/ }),

/***/ 35711:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    HEADER_1_MARGIN: function() {
        return HEADER_1_MARGIN;
    },
    HEADER_2_MARGIN: function() {
        return HEADER_2_MARGIN;
    },
    HEADER_3_MARGIN: function() {
        return HEADER_3_MARGIN;
    },
    LIST_NODE_MARGIN: function() {
        return LIST_NODE_MARGIN;
    },
    PARAGRAPH_MARGIN: function() {
        return PARAGRAPH_MARGIN;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getHeader1Font: function() {
        return getHeader1Font;
    },
    getHeader2Font: function() {
        return getHeader2Font;
    },
    getHeader3Font: function() {
        return getHeader3Font;
    },
    getParagraphFont: function() {
        return getParagraphFont;
    },
    header1NodeStyle: function() {
        return header1NodeStyle;
    },
    header2NodeStyle: function() {
        return header2NodeStyle;
    },
    header3NodeStyle: function() {
        return header3NodeStyle;
    },
    listNodeStyle: function() {
        return listNodeStyle;
    },
    paragraphNodeStyle: function() {
        return paragraphNodeStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(45538);
var _typography = __webpack_require__(18411);
var _constants = __webpack_require__(34952);
var _style = __webpack_require__(65082);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var getParagraphFont = function(screenSize) {
    return (0, _typography.getFont)(_typography.FONT.MADRID_1, screenSize);
};
var getHeader1Font = function(screenSize) {
    return (0, _typography.getFont)(_typography.FONT.KINSHASA_3, screenSize);
};
var getHeader2Font = function(screenSize) {
    return (0, _typography.getFont)(_typography.FONT.MADRID_3, screenSize);
};
var getHeader3Font = function(screenSize) {
    return (0, _typography.getFont)(_typography.FONT.KINSHASA_1, screenSize);
};
var _obj;
var PARAGRAPH_MARGIN = (_obj = {}, _define_property._(_obj, _constants.HD, 24), _define_property._(_obj, _constants.FULL_HD, 32), _obj);
var _obj1;
var HEADER_1_MARGIN = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 24), _define_property._(_obj1, _constants.FULL_HD, 56), _obj1);
var _obj2;
var HEADER_2_MARGIN = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 24), _define_property._(_obj2, _constants.FULL_HD, 32), _obj2);
var _obj3;
var HEADER_3_MARGIN = (_obj3 = {}, _define_property._(_obj3, _constants.HD, 24), _define_property._(_obj3, _constants.FULL_HD, 32), _obj3);
var _obj4;
var LIST_NODE_MARGIN = (_obj4 = {}, _define_property._(_obj4, _constants.HD, 24), _define_property._(_obj4, _constants.FULL_HD, 56), _obj4);
var paragraphNodeStyle = function() {
    var screenSize = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext).screenSize;
    return {
        flexItem: {
            marginBottom: PARAGRAPH_MARGIN[screenSize]
        },
        text: _object_spread_props._(_object_spread._({}, getParagraphFont(screenSize)), {
            verticalAlign: "bottom"
        })
    };
};
var header1NodeStyle = function() {
    var screenSize = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext).screenSize;
    return {
        flexItem: {
            marginBottom: HEADER_1_MARGIN[screenSize],
            alignSelf: "center"
        },
        text: _object_spread_props._(_object_spread._({}, getHeader1Font(screenSize)), {
            textAlign: "center",
            verticalAlign: "bottom"
        })
    };
};
var header2NodeStyle = function() {
    var screenSize = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext).screenSize;
    return {
        flexItem: {
            marginBottom: HEADER_2_MARGIN[screenSize],
            alignSelf: "center"
        },
        text: _object_spread_props._(_object_spread._({}, getHeader2Font(screenSize)), {
            textAlign: "center",
            verticalAlign: "bottom"
        })
    };
};
var header3NodeStyle = function() {
    var screenSize = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext).screenSize;
    return {
        flexItem: {
            marginBottom: HEADER_3_MARGIN[screenSize],
            alignSelf: "center"
        },
        text: _object_spread_props._(_object_spread._({}, getHeader3Font(screenSize)), {
            textAlign: "center",
            verticalAlign: "bottom"
        })
    };
};
var listNodeStyle = function() {
    var screenSize = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext).screenSize;
    return {
        flexItem: {
            marginBottom: LIST_NODE_MARGIN[screenSize]
        },
        flex: {
            direction: "column"
        }
    };
};


/***/ }),

/***/ 23269:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    filterNodes: function() {
        return filterNodes;
    },
    parseFile: function() {
        return parseFile;
    },
    renderHTML: function() {
        return renderHTML;
    }
});
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(42578);
var _superagent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(54247));
var _markdownit = /*#__PURE__*/ _interop_require_default._(__webpack_require__(19404));
var _staticFilesconstants = __webpack_require__(52273);
var parseInlineBlock = function(block) {
    var content = "";
    block.children.filter(function(n) {
        return n.type === "text" || n.type === "hardbreak";
    }).forEach(function(n) {
        content += n.type === "hardbreak" ? "\n" : n.content;
    });
    return content;
};
var prepareEnbeddedList = function(blocks) {
    var getEmptyNode = function() {
        return {
            originalIndex: undefined,
            content: ""
        };
    };
    var nodes = [];
    var node = getEmptyNode();
    blocks.forEach(function(block) {
        if (block.type === "list_item_open") {
            node.originalIndex = block.info;
        } else if (block.type === "list_item_close") {
            nodes.push(node);
            node = getEmptyNode();
        } else if (block.type === "inline") {
            node.content = block.content;
        }
    });
    return nodes;
};
var prepareBlockValue = function(type, blocks) {
    var node = {
        tag: type
    };
    if (_staticFilesconstants.SINGLE_LINE_COMPONENTS.includes(type)) {
        node.content = "";
        var block = blocks[0];
        if (block.type === "inline" && block.children) {
            node.content = parseInlineBlock(block);
        }
    } else if (_staticFilesconstants.LISTS.includes(type)) {
        node.content = [];
        node.content = prepareEnbeddedList(blocks);
    }
    return node;
};
var filterNodes = function(nodes) {
    var values = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var openNode = nodes[0];
    var closeType = openNode.type.replace("_open", "_close");
    var closeNode = nodes.find(function(n) {
        return n.type === closeType;
    });
    var stopIndex = nodes.indexOf(closeNode);
    var blockValue = nodes.slice(1, stopIndex);
    values.push(prepareBlockValue(openNode.tag, blockValue));
    var nextBlock = nodes.slice(stopIndex + 1);
    return nextBlock.length ? filterNodes(nextBlock, values) : values;
};
var parseFile = function(url) {
    return _superagent.default.get(url).then(function(data) {
        return new _markdownit.default().parse(data.text);
    });
};
var renderHTML = function(url) {
    var md = new _markdownit.default({
        linkify: false
    });
    md.renderer.rules.link_open = function() {
        return "";
    };
    md.renderer.rules.link_close = function() {
        return "";
    };
    return _superagent.default.get(url).then(function(data) {
        return md.render(data.text);
    });
};


/***/ }),

/***/ 31520:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return Belly;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(42578);
var _blockcomponent = __webpack_require__(89464);
var _bellyconstants = __webpack_require__(34066);
var _rowconstants = __webpack_require__(7395);
var _listcomponent = __webpack_require__(22093);
var Belly = /*#__PURE__*/ function(List) {
    "use strict";
    _inherits._(Belly, List);
    var _super = _create_super._(Belly);
    function Belly() {
        _class_call_check._(this, Belly);
        return _super.apply(this, arguments);
    }
    _create_class._(Belly, null, [
        {
            key: "_template",
            value: function _template() {
                return {
                    Block: {
                        type: _blockcomponent.Block,
                        startPointMode: _rowconstants.START_POINT_MODE_CENTER
                    }
                };
            }
        }
    ]);
    return Belly;
}(_listcomponent.List);
Belly.Templates = _bellyconstants.templates;


/***/ }),

/***/ 34066:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "templates", ({
    enumerable: true,
    get: function() {
        return templates;
    }
}));
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(3009);
var templates = {
    Belly: "Belly"
};


/***/ }),

/***/ 40696:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/* eslint-disable no-console */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    HorizontalEpg: function() {
        return HorizontalEpg;
    },
    default: function() {
        return _default;
    }
});
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _create_super = __webpack_require__(6400);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(88801);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _addHours = /*#__PURE__*/ _interop_require_default._(__webpack_require__(18964));
var _differenceInSeconds = /*#__PURE__*/ _interop_require_default._(__webpack_require__(5729));
var _startOfDay = /*#__PURE__*/ _interop_require_default._(__webpack_require__(35780));
var _blockcomponent = __webpack_require__(89464);
var _blockstyle = __webpack_require__(39623);
var _squarecomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(85520));
var _popupsconstants = __webpack_require__(60952);
var _popupactions = __webpack_require__(47531);
var _notifications = __webpack_require__(93831);
var _signals = __webpack_require__(2109);
var _i18n = __webpack_require__(14910);
var _block = __webpack_require__(3777);
var _epgBoxcomponent = __webpack_require__(42012);
var _epgTimelinecomponent = __webpack_require__(88269);
var _epgTimelinestyle = __webpack_require__(3782);
var _epgNavstyle = __webpack_require__(24199);
var _epgNavcomponent = __webpack_require__(84237);
var _epgNavconstants = __webpack_require__(23974);
var _epgstyle = __webpack_require__(81536);
var _epgconstants = __webpack_require__(64789);
var _epgutils = __webpack_require__(21783);
var _epgGridcomponent = __webpack_require__(9683);
var _epgGridconstants = __webpack_require__(95778);
var HorizontalEpg = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(HorizontalEpg, _Lightning_Component);
    var _super = _create_super._(HorizontalEpg);
    function HorizontalEpg() {
        _class_call_check._(this, HorizontalEpg);
        return _super.apply(this, arguments);
    }
    _create_class._(HorizontalEpg, [
        {
            key: "_construct",
            value: function _construct() {
                this._contentPadding = 0;
                this._style = _epgstyle.defaultContext;
                this._focusMode = _epgconstants.FOCUS_MODE_NAV;
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                this._data = undefined;
                this._rowsData = null;
                clearTimeout(this._itemFocusTimeout);
                cancelAnimationFrame(this._animationFrameHandle);
            }
        },
        {
            key: "rightPadding",
            get: function get() {
                return _epgstyle.RIGHT_PADDING[this._style.screenSize];
            }
        },
        {
            key: "contentPadding",
            get: function get() {
                return this._contentPadding;
            },
            set: function set(value) {
                if (this._contentPadding === value) {
                    return;
                }
                this._contentPadding = value;
                if (!this._data) {
                    return;
                }
                var x = this._contentPadding + _epgstyle.CHANNEL_SIZE[this._style.screenSize] + _epgstyle.GAP;
                this._gridWidth = this._data.rowSize.w - x;
                this.patch({
                    ChannelsVerticalClippingRoot: {
                        x: this._contentPadding
                    },
                    Nav: {
                        x: this._contentPadding,
                        w: this._data.rowSize.w - this._contentPadding - this.rightPadding
                    },
                    Grid: {
                        x: x,
                        w: this._gridWidth,
                        GridRoot: {
                            w: this._gridWidth
                        }
                    },
                    Title: {
                        x: this._contentPadding
                    }
                });
                this._goToLive();
            }
        },
        {
            key: "data",
            get: function get() {
                return this._data;
            },
            set: function set(value) {
                if (!value || !value.block || !value.block.content) {
                    this.patch(_epgstyle.EMPTY_VIEW);
                    return;
                }
                var _value_block = value.block, content = _value_block.content, pages = _value_block.pages, id = _value_block.id;
                var rows = (content.items || []).filter(function(block) {
                    return Boolean(block.epgBox && block.epgBox.length && block.epgBox.some(Boolean));
                });
                var currentDate = content.date;
                var text = (0, _block.getTitle)(value.block.title);
                var hasTitle = Boolean(text);
                // TODO: use colorMode
                // eslint-disable-next-line no-unused-vars
                var _this__style = this._style, screenSize = _this__style.screenSize, colorMode = _this__style.colorMode;
                var _getBlockStyle = (0, _blockstyle.getBlockStyle)({
                    hasTitle: hasTitle,
                    isFirstBlock: value.blockIndex === 0,
                    screenSize: screenSize
                }), items = _getBlockStyle.items, title = _getBlockStyle.title;
                var channelSize = _epgstyle.CHANNEL_SIZE[this._style.screenSize];
                var x = this._contentPadding + channelSize + _epgstyle.GAP;
                var w = value.rowSize.w - x;
                var rowsHeight = Math.min(rows.length, _epgstyle.MAX_VISIBLE_ROWS[screenSize]) * (channelSize + _epgstyle.GAP) - _epgstyle.GAP;
                var timelineOuterHeight = _epgTimelinestyle.HEIGHT[screenSize] + _epgstyle.TIMELINE_MARGIN_BOTTOM + _epgstyle.TIMELINE_MARGIN_TOP;
                var h = rowsHeight + timelineOuterHeight;
                var channelConfig = {
                    w: channelSize,
                    h: channelSize
                };
                this._gridWidth = w;
                console.log("[EPG] Setting grid width on data change to ".concat(this._gridWidth));
                var firstItem = rows[0].epgBox.find(Boolean);
                var start = (0, _addHours.default)((0, _startOfDay.default)(new Date(firstItem.start.date)), 6);
                var end = (0, _addHours.default)(start, 24);
                var isUpdate = (0, _differenceInSeconds.default)(this._start, start) <= 1;
                console.log("[EPG] Is update: ".concat(isUpdate));
                this._start = start;
                this._end = end;
                this._data = value;
                this._rowsData = rows.map(function(param, rowIndex) {
                    var box = param.epgBox;
                    var offset = 0;
                    var y = rowIndex * (channelSize + _epgstyle.GAP);
                    return {
                        h: channelSize,
                        y: y,
                        children: (0, _epgutils.trimEpg)(box, start, end).map(function(content, itemIndex, collection) {
                            var start = content.start, end = content.end;
                            var duration = Math.round((0, _differenceInSeconds.default)(end.date, start.date) / 60);
                            var itemWidth = duration * _epgconstants.PIXELS_PER_MINUTE;
                            var item = {
                                type: _epgBoxcomponent.EpgBox,
                                w: itemWidth,
                                h: channelSize,
                                x: offset,
                                y: y,
                                rowIndex: rowIndex,
                                itemIndex: itemIndex,
                                index: "".concat(rowIndex, "_").concat(itemIndex),
                                item: {
                                    content: content,
                                    itemWidth: itemWidth,
                                    itemHeight: channelSize,
                                    isLastItem: itemIndex === collection.length - 1,
                                    offset: offset
                                }
                            };
                            offset += itemWidth;
                            return item;
                        })
                    };
                });
                var channels = this.tag("Channels");
                var currentChannelsCount = channels.children.length;
                for(var i = 0; i < Math.min(currentChannelsCount, rows.length); i += 1){
                    channels.children[i].item = {
                        content: (0, _epgutils.getChannelContent)(rows[i].channel),
                        config: channelConfig
                    };
                }
                var channelsToCreate = rows.length - currentChannelsCount;
                if (channelsToCreate > 0) {
                    for(var i1 = 0; i1 < channelsToCreate; i1 += 1){
                        var channel = this.stage.c({
                            type: _squarecomponent.default,
                            item: {
                                content: (0, _epgutils.getChannelContent)(rows[currentChannelsCount + i1].channel),
                                config: channelConfig
                            },
                            y: (currentChannelsCount + i1) * (channelSize + _epgstyle.GAP)
                        });
                        channels.childList.add(channel);
                    }
                }
                this.patch({
                    ChannelsVerticalClippingRoot: {
                        x: this._contentPadding,
                        y: items.y + _epgNavstyle.HEIGHT[screenSize] + timelineOuterHeight,
                        h: rowsHeight
                    },
                    Nav: {
                        y: items.y,
                        date: currentDate
                    },
                    Grid: {
                        x: x,
                        y: items.y + _epgNavstyle.HEIGHT[screenSize],
                        w: w,
                        h: h,
                        Timeline: {
                            range: {
                                start: start,
                                end: end
                            }
                        },
                        GridRoot: {
                            w: w,
                            h: rowsHeight,
                            rows: {
                                id: id,
                                pages: pages,
                                pagination: content.pagination,
                                rows: this._rowsData,
                                rowHeight: channelSize,
                                start: start,
                                end: end
                            }
                        }
                    },
                    Title: _object_spread._({
                        visible: true,
                        text: {
                            text: text
                        }
                    }, title)
                });
                if (isUpdate) {
                    this.tag("Timeline").currentTime = new Date();
                } else {
                    this._goToLive();
                }
                this._refocus();
            }
        },
        {
            key: "_handleGridX",
            value: function _handleGridX(offset, maxOffset) {
                this.tag("Timeline").setSmooth("x", offset);
                this.tag("Nav").percentage = offset / maxOffset;
            }
        },
        {
            key: "_handleGridY",
            value: function _handleGridY(offset) {
                this.tag("Channels").setSmooth("y", offset);
            }
        },
        {
            key: "_goToLive",
            value: function _goToLive() {
                var animate = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                var now = new Date();
                this.tag("Timeline").currentTime = now;
                this.tag("GridRoot").goToTimestamp(now, !animate);
            }
        },
        {
            key: "_goLeft",
            value: function _goLeft() {
                this.tag("GridRoot").goLeft();
            }
        },
        {
            key: "_goRight",
            value: function _goRight() {
                this.tag("GridRoot").goRight();
            }
        },
        {
            key: "_handleDown",
            value: function _handleDown() {
                if (this._focusMode === _epgconstants.FOCUS_MODE_GRID) {
                    return false;
                }
                this._focusMode = _epgconstants.FOCUS_MODE_GRID;
                return true;
            }
        },
        {
            key: "_handleUp",
            value: function _handleUp() {
                if (this._focusMode === _epgconstants.FOCUS_MODE_NAV) {
                    return false;
                }
                this._focusMode = _epgconstants.FOCUS_MODE_NAV;
                return true;
            }
        },
        {
            key: "_handleBoxSelected",
            value: function _handleBoxSelected(content) {
                if (content.action) {
                    if (!(0, _epgutils.isActionAllowed)(content.action)) {
                        return;
                    }
                    if (content.action.target.type && content.action.target.value_modal) {
                        this._openEpgModal(content.action.target.value_modal.id);
                        return;
                    }
                    this.signal(_signals.SELECTED_SIGNAL, _object_spread._({
                        id: "".concat(this._row, "_").concat(this._index)
                    }, content));
                } else {
                    this.fireAncestors("$".concat(_signals.NOTIFICATION_SIGNAL), (0, _notifications.makeNotification)(_notifications.NOTIFICATION_LEVEL.SYSTEM, (0, _i18n.t)("epgGrid.noAction")));
                }
            }
        },
        {
            key: "_getFocused",
            value: function _getFocused() {
                return this._focusMode === _epgconstants.FOCUS_MODE_NAV ? this.tag("Nav") : this.tag("GridRoot");
            }
        },
        {
            key: "_handleGoToLive",
            value: function _handleGoToLive() {
                var now = new Date();
                if (now >= this._start && now <= this._end) {
                    this._goToLive(true);
                    return;
                }
                this.signal(_signals.EPG_SIGNAL, {
                    date: new Date(),
                    blockId: this._data.block.id
                });
            }
        },
        {
            key: "_openDateSelector",
            value: function _openDateSelector() {
                _lightningjsredux.default.dispatch((0, _popupactions.showPopupAction)(_popupsconstants.EPG_POPUP_ID, {
                    date: new Date(),
                    selectedDate: this._start,
                    blockId: this._data.block.id
                }));
            }
        },
        {
            key: "_openEpgModal",
            value: function _openEpgModal(value) {
                if (!value) {
                    return;
                }
                _lightningjsredux.default.dispatch((0, _popupactions.showPopupAction)(_popupsconstants.EPG_LAYOUT_POPUP_ID, {
                    blockId: value.toString()
                }));
            }
        },
        {
            key: "_goToHour",
            value: function _goToHour(hour) {
                this.tag("GridRoot").goToTimestamp((0, _epgutils.offsetFromStart)(this._start.getTime(), hour), false, false);
            }
        },
        {
            key: "_goToMorning",
            value: function _goToMorning() {
                this._goToHour(_epgconstants.MORNING_HOUR);
            }
        },
        {
            key: "_goToAfternoon",
            value: function _goToAfternoon() {
                this._goToHour(_epgconstants.AFTERNOON_HOUR);
            }
        },
        {
            key: "_goToEvening",
            value: function _goToEvening() {
                this._goToHour(_epgconstants.EVENING_HOUR);
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                var _obj, _obj1;
                return (0, _merge.default)({
                    Nav: {
                        type: _epgNavcomponent.EpgNav,
                        signals: (_obj = {}, _define_property._(_obj, _epgNavconstants.SIGNAL_GO_TO_MORNING, "_goToMorning"), _define_property._(_obj, _epgNavconstants.SIGNAL_GO_TO_AFTERNOON, "_goToAfternoon"), _define_property._(_obj, _epgNavconstants.SIGNAL_GO_TO_EVENING, "_goToEvening"), _define_property._(_obj, _epgNavconstants.SIGNAL_GO_TO_LIVE, "_handleGoToLive"), _define_property._(_obj, _epgNavconstants.SIGNAL_OPEN_DATE_SELECTOR, "_openDateSelector"), _define_property._(_obj, _epgNavconstants.SIGNAL_GO_LEFT, "_goLeft"), _define_property._(_obj, _epgNavconstants.SIGNAL_GO_RIGHT, "_goRight"), _obj)
                    },
                    ChannelsVerticalClippingRoot: {
                        clipping: true,
                        Channels: {}
                    },
                    Grid: {
                        clipping: true,
                        Timeline: {
                            type: _epgTimelinecomponent.EpgTimeline
                        },
                        GridRoot: {
                            type: _epgGridcomponent.EpgGrid,
                            passSignals: _define_property._({}, _signals.PORTION_REQUESTED_SIGNAL, true),
                            signals: (_obj1 = {}, _define_property._(_obj1, _epgGridconstants.SET_X_SIGNAL, "_handleGridX"), _define_property._(_obj1, _epgGridconstants.SET_Y_SIGNAL, "_handleGridY"), _define_property._(_obj1, _signals.SELECTED_SIGNAL, "_handleBoxSelected"), _obj1)
                        }
                    },
                    Title: {}
                }, (0, _epgstyle.getInitialStyle)());
            }
        },
        {
            key: "getOffsetsByBlockData",
            value: function getOffsetsByBlockData(value) {
                var result = _blockcomponent.Block.getOffsetsByBlockData(value);
                var count = (0, _get.default)(value, "data.content.items.length") || 0;
                var screenSize = value.screenSize;
                return _object_spread_props._(_object_spread._({}, result), {
                    h: Math.min(count, _epgstyle.MAX_VISIBLE_ROWS[screenSize]) * (_epgstyle.CHANNEL_SIZE[screenSize] + _epgstyle.GAP) - _epgstyle.GAP + _epgTimelinestyle.HEIGHT[screenSize] + _epgNavstyle.HEIGHT[screenSize] + _epgstyle.TIMELINE_MARGIN_BOTTOM + _epgstyle.TIMELINE_MARGIN_TOP
                });
            }
        }
    ]);
    return HorizontalEpg;
}(_sdk.Lightning.Component);
HorizontalEpg.Templates = _epgconstants.templates;
var _default = HorizontalEpg;


/***/ }),

/***/ 64789:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ABBREVIATION_I18N_KEY: function() {
        return ABBREVIATION_I18N_KEY;
    },
    AFTERNOON_HOUR: function() {
        return AFTERNOON_HOUR;
    },
    COMPLETE_I18N_KEY: function() {
        return COMPLETE_I18N_KEY;
    },
    DAYS_OF_THE_WEEK_I18N: function() {
        return DAYS_OF_THE_WEEK_I18N;
    },
    EVENING_HOUR: function() {
        return EVENING_HOUR;
    },
    FOCUS_MODE_GRID: function() {
        return FOCUS_MODE_GRID;
    },
    FOCUS_MODE_NAV: function() {
        return FOCUS_MODE_NAV;
    },
    MONTHS_I18N_KEY: function() {
        return MONTHS_I18N_KEY;
    },
    MORNING_HOUR: function() {
        return MORNING_HOUR;
    },
    PIXELS_PER_MINUTE: function() {
        return PIXELS_PER_MINUTE;
    },
    START_HOUR: function() {
        return START_HOUR;
    },
    TODAY_I18N_KEY: function() {
        return TODAY_I18N_KEY;
    },
    templates: function() {
        return templates;
    }
});
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(37815);
var templates = {
    HorizontalEpg: "HorizontalEpg"
};
var PIXELS_PER_MINUTE = 6;
var START_HOUR = 6;
var FOCUS_MODE_NAV = "navigation";
var FOCUS_MODE_GRID = "grid";
var MORNING_HOUR = 6;
var AFTERNOON_HOUR = 13;
var EVENING_HOUR = 19;
var TODAY_I18N_KEY = "epgGrid.today";
var DAYS_OF_THE_WEEK_I18N = [
    "date.days.sunday",
    "date.days.monday",
    "date.days.tuesday",
    "date.days.wednesday",
    "date.days.thursday",
    "date.days.friday",
    "date.days.saturday"
];
var MONTHS_I18N_KEY = [
    "date.months.january",
    "date.months.february",
    "date.months.march",
    "date.months.april",
    "date.months.may",
    "date.months.june",
    "date.months.july",
    "date.months.august",
    "date.months.september",
    "date.months.october",
    "date.months.november",
    "date.months.december"
];
var ABBREVIATION_I18N_KEY = "abbreviation";
var COMPLETE_I18N_KEY = "complete";


/***/ }),

/***/ 81536:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ARROW_SLIDE_INTERVAL: function() {
        return ARROW_SLIDE_INTERVAL;
    },
    CHANNEL_SIZE: function() {
        return CHANNEL_SIZE;
    },
    EMPTY_VIEW: function() {
        return EMPTY_VIEW;
    },
    GAP: function() {
        return GAP;
    },
    MAX_VISIBLE_ROWS: function() {
        return MAX_VISIBLE_ROWS;
    },
    RIGHT_PADDING: function() {
        return RIGHT_PADDING;
    },
    SCROLL_START_ROW: function() {
        return SCROLL_START_ROW;
    },
    TIMELINE_MARGIN_BOTTOM: function() {
        return TIMELINE_MARGIN_BOTTOM;
    },
    TIMELINE_MARGIN_TOP: function() {
        return TIMELINE_MARGIN_TOP;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
var _define_property = __webpack_require__(21228);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
var _constants = __webpack_require__(34952);
var _style = __webpack_require__(65082);
var _blockstyle = __webpack_require__(39623);
var _epgTimelinestyle = __webpack_require__(3782);
var _epgconstants = __webpack_require__(64789);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var MAX_VISIBLE_ROWS = (_obj = {}, _define_property._(_obj, _constants.HD, 4), _define_property._(_obj, _constants.FULL_HD, 5), _obj);
var SCROLL_START_ROW = 3;
var GAP = 16;
var RIGHT_PADDING = _constants.safetyMargins.horizontal;
var _obj1;
var CHANNEL_SIZE = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 96), _define_property._(_obj1, _constants.FULL_HD, 112), _obj1);
var TIMELINE_MARGIN_TOP = 32;
var TIMELINE_MARGIN_BOTTOM = 24;
var _obj2;
var ARROW_SLIDE_INTERVAL = (_obj2 = {}, _define_property._(_obj2, _constants.HD, _epgconstants.PIXELS_PER_MINUTE * 60), _define_property._(_obj2, _constants.FULL_HD, _epgconstants.PIXELS_PER_MINUTE * 90), _obj2);
var getInitialStyle = function() {
    var style = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    return {
        ChannelsVerticalClippingRoot: {
            w: CHANNEL_SIZE[style.screenSize]
        },
        Grid: {
            Timeline: {
                y: TIMELINE_MARGIN_TOP
            },
            GridRoot: {
                y: _epgTimelinestyle.HEIGHT[style.screenSize] + TIMELINE_MARGIN_BOTTOM + TIMELINE_MARGIN_TOP
            }
        },
        Title: (0, _blockstyle.getTitleStyle)(style)
    };
};
var EMPTY_VIEW = {
    Channels: {
        children: []
    },
    Grid: {
        GridRoot: {
            rows: {
                rows: [],
                pages: {},
                pagination: {}
            }
        }
    },
    Title: {
        text: {
            text: ""
        }
    }
};


/***/ }),

/***/ 21783:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/* eslint-disable no-continue */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    formatDate: function() {
        return formatDate;
    },
    getChannelContent: function() {
        return getChannelContent;
    },
    isActionAllowed: function() {
        return isActionAllowed;
    },
    makePlaceholder: function() {
        return makePlaceholder;
    },
    offsetFromStart: function() {
        return offsetFromStart;
    },
    trimEpg: function() {
        return trimEpg;
    }
});
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _object_without_properties = __webpack_require__(46537);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(45538);
var _constants = __webpack_require__(34952);
var _fidosdk = __webpack_require__(19804);
var _format = /*#__PURE__*/ _interop_require_default._(__webpack_require__(43069));
var _config = __webpack_require__(67958);
var _i18n = __webpack_require__(14910);
var _sizes = __webpack_require__(82699);
var _lockutils = __webpack_require__(78414);
var _squareconstants = __webpack_require__(37049);
var _epgconstants = __webpack_require__(64789);
var getChannelContent = function(base, size) {
    if (!base) {
        return {};
    }
    var image = base.image || {};
    var sizeFallback = size || _squareconstants.sizes[_squareconstants.templates.Square][(0, _sizes.getScreenSize)()].w;
    return _object_spread_props._(_object_spread._({}, base), {
        image: _object_spread_props._(_object_spread._({}, image), {
            src: _fidosdk.imageService.getUrl(base.image.id, sizeFallback, sizeFallback, {
                fit: _constants.IMAGE_FIT_SCALE_CROP,
                quality: _constants.IMAGE_QUALITY,
                format: _constants.DEFAULT_IMAGE_FORMAT
            })
        })
    });
};
var makePlaceholder = function(start, end) {
    return {
        start: {
            date: start,
            title: (0, _format.default)(start, "HH:mm")
        },
        end: {
            date: end,
            title: (0, _format.default)(end, "HH:mm")
        },
        title: (0, _i18n.t)("epgGrid.noProgram")
    };
};
var trimEpg = function(row, min, max) {
    var programs = row.map(function(_param) {
        var start = _param.start, end = _param.end, rest = _object_without_properties._(_param, [
            "start",
            "end"
        ]);
        var startDate = new Date(start.date);
        var endDate = new Date(end.date);
        return _object_spread._({
            start: {
                date: startDate,
                title: (0, _format.default)(startDate, "HH:mm")
            },
            end: {
                date: endDate,
                title: (0, _format.default)(endDate, "HH:mm")
            }
        }, rest);
    });
    var result = [];
    var lastIndex = programs.length - 1;
    var tail = min;
    for(var i = 0; i < programs.length; i += 1){
        var program = _object_spread._({}, programs[i]);
        var end = program.end.date;
        if (end <= min) {
            continue;
        }
        var start = program.start.date;
        if (start >= max) {
            if (tail < max) {
                result.push(makePlaceholder(tail, max));
            }
            break;
        }
        if (start < min) {
            program.start.date = min;
        }
        if (end > max) {
            program.end.date = max;
        }
        if (start > tail) {
            result.push(makePlaceholder(tail, start));
        }
        result.push(program);
        tail = end;
        if (i === lastIndex) {
            if (end < max) {
                result.push(makePlaceholder(end, max));
            }
        }
    }
    return result;
};
var offsetFromStart = function(start, hour) {
    return start + (hour - _epgconstants.START_HOUR) * 60 * 60 * 1000;
};
var formatDate = function(date) {
    var abbreviated = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var day = date.getDay();
    var month = date.getMonth();
    var tail = abbreviated ? _epgconstants.ABBREVIATION_I18N_KEY : _epgconstants.COMPLETE_I18N_KEY;
    var dayKey = "".concat(_epgconstants.DAYS_OF_THE_WEEK_I18N[day], ".").concat(tail);
    var monthKey = "".concat(_epgconstants.MONTHS_I18N_KEY[month], ".").concat(tail);
    return "".concat((0, _i18n.t)(dayKey), ", ").concat(date.getDate(), ". ").concat((0, _i18n.t)(monthKey));
};
var isActionAllowed = function(action) {
    if (!_config.featureFlipping.liveSuppressionOnEPGFeature || !action) {
        return true;
    }
    var target = (0, _lockutils.getNestedOriginalTarget)(action.target);
    // Could be modal action, just allowing the app to handle it
    if (!target) {
        return true;
    }
    return !target.startsWith(_fidosdk.LAYOUT_ENTITIES.live);
};


/***/ }),

/***/ 42012:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "EpgBox", ({
    enumerable: true,
    get: function() {
        return EpgBox;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(65759);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _fidosdk = __webpack_require__(19804);
var _constants = __webpack_require__(34952);
var _iconcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(70160));
var _progressutils = __webpack_require__(40779);
var _signals = __webpack_require__(2109);
var _imageshader = /*#__PURE__*/ _interop_require_default._(__webpack_require__(17154));
var _epgBoxstyle = __webpack_require__(96194);
var _epgBoxutils = __webpack_require__(47036);
var _epgBoxconstants = __webpack_require__(11242);
var EpgBox = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(EpgBox, _Lightning_Component);
    var _super = _create_super._(EpgBox);
    function EpgBox() {
        _class_call_check._(this, EpgBox);
        return _super.apply(this, arguments);
    }
    _create_class._(EpgBox, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _epgBoxstyle.defaultContext;
            }
        },
        {
            key: "_inactive",
            value: function _inactive() {
                this.tag("Title").removeAllListeners("txLoaded");
                this.tag("Time").removeAllListeners("txLoaded");
                this.tag("ExtraTitle").removeAllListeners("txLoaded");
                this.tag("Icon").removeAllListeners("txLoaded");
                this.signal(_signals.INACTIVE_SIGNAL, this);
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                this._item = undefined;
                this.signal(_signals.DETACHED_SIGNAL, this);
            }
        },
        {
            key: "item",
            get: function get() {
                return this._item;
            },
            set: function set(value) {
                if (!value) {
                    this._item = null;
                    return;
                }
                if ((0, _epgBoxutils.areEPGEntriesEqual)(this._item ? this._item.content : null, value.content)) {
                    this._item = value;
                    return;
                }
                this._item = value;
                var content = value.content, itemWidth = value.itemWidth, itemHeight = value.itemHeight, isLastItem = value.isLastItem, offset = value.offset;
                this._itemWidth = itemWidth;
                this._itemHeight = itemHeight;
                this._currentWidth = itemWidth;
                this._expandedWidth = 0;
                this._innerPaddingRight = isLastItem ? 0 : _epgBoxstyle.GAP;
                this._offset = offset;
                // NOTE: this is actually a gap in the EPG Grid's row, however we need the timeline
                // and the grid to be synced in time, so gaps should be inside the boxes
                var w = Math.max(this._itemWidth - this._innerPaddingRight, 1);
                var screenSize = this._style.screenSize;
                var image = content.image ? content.image.id : null;
                var progress = content.progressBar && content.progressBar.progressValue || 0;
                var picto = content.pictos ? content.pictos[1] : null;
                this._containerOffset = image ? _epgBoxstyle.IMAGE_WIDTH[screenSize] : 0;
                this._texturesToLoad = 0;
                if (content.start.title || content.end.title) {
                    this._texturesToLoad += 1;
                }
                if (content.title) {
                    this._texturesToLoad += 1;
                }
                if (content.extraTitle) {
                    this._texturesToLoad += 1;
                }
                var titleView = this.tag("Title");
                var timeView = this.tag("Time");
                var extraTitleView = this.tag("ExtraTitle");
                var handler = this._handleTextLoading.bind(this);
                titleView.once("txLoaded", handler);
                timeView.once("txLoaded", handler);
                extraTitleView.once("txLoaded", handler);
                if (picto) {
                    var icon = this.tag("Icon");
                    icon.once("txLoaded", handler);
                }
                this.patch({
                    w: w,
                    h: itemHeight,
                    Border: {
                        w: w,
                        h: itemHeight
                    },
                    Background: {
                        w: w,
                        h: itemHeight,
                        shader: {
                            progress: progress ? (0, _progressutils.getProgress)(progress) : 0
                        }
                    },
                    Image: {
                        h: itemHeight,
                        src: image ? _fidosdk.imageService.getUrl(image, _epgBoxstyle.IMAGE_WIDTH[screenSize], itemHeight, {
                            fit: _constants.IMAGE_FIT_SCALE_CROP,
                            quality: _constants.IMAGE_QUALITY,
                            format: _constants.DEFAULT_IMAGE_FORMAT
                        }) : null
                    },
                    Container: {
                        x: _epgBoxstyle.GAP + this._containerOffset,
                        h: itemHeight,
                        Time: {
                            visible: Boolean(content.start.title || content.end.title),
                            text: {
                                text: "".concat(content.start.title, " - ").concat(content.end.title)
                            }
                        },
                        Title: {
                            visible: Boolean(content.title),
                            text: {
                                text: content.title || ""
                            }
                        },
                        Row: {
                            visible: Boolean(content.title || picto),
                            ExtraTitle: {
                                visible: Boolean(content.title),
                                text: {
                                    text: content.extraTitle || ""
                                }
                            },
                            Icon: {
                                visible: Boolean(picto),
                                iconData: {
                                    picto: picto,
                                    viewBox: {
                                        w: _epgBoxstyle.ICON_SIZE,
                                        h: _epgBoxstyle.ICON_SIZE
                                    }
                                }
                            }
                        }
                    }
                });
            }
        },
        {
            key: "rowIndex",
            get: function get() {
                return this._rowIndex;
            },
            set: function set(value) {
                this._rowIndex = value;
            }
        },
        {
            key: "itemIndex",
            get: function get() {
                return this._itemIndex;
            },
            set: function set(value) {
                this._itemIndex = value;
            }
        },
        {
            key: "itemWidth",
            get: function get() {
                return this._itemWidth;
            }
        },
        {
            key: "collapsedWidth",
            get: function get() {
                return this._itemWidth - this._innerPaddingRight;
            }
        },
        {
            key: "expandedWidth",
            get: function get() {
                return this._expandedWidth;
            }
        },
        {
            key: "offset",
            get: function get() {
                return this._offset;
            }
        },
        {
            key: "currentWidth",
            get: function get() {
                return this._currentWidth;
            },
            set: function set(value) {
                this.patch({
                    w: value,
                    Background: {
                        w: value
                    },
                    Border: {
                        w: value
                    }
                });
                this._currentWidth = value;
            }
        },
        {
            key: "padding",
            get: function get() {
                return _epgBoxstyle.GAP;
            }
        },
        {
            key: "minInnerOffset",
            get: function get() {
                return this.padding + this._containerOffset;
            }
        },
        {
            key: "innerOffset",
            get: function get() {
                return this.tag("Container").x;
            },
            set: function set(value) {
                this.tag("Container").x = value;
            }
        },
        {
            key: "_handleTextLoading",
            value: function _handleTextLoading() {
                this._texturesToLoad -= 1;
                if (this._texturesToLoad > 0) {
                    return;
                }
                this._expandedWidth = 0;
                var timeView = this.tag("Time");
                var titleView = this.tag("Title");
                var extraTitleView = this.tag("ExtraTitle");
                var icon = this.tag("Icon");
                var rowView = this.tag("Row");
                var container = this.tag("Container");
                var height = 0;
                if (timeView.visible && timeView.texture && timeView.texture.source) {
                    var _timeView_texture_source = timeView.texture.source, w = _timeView_texture_source.w, h = _timeView_texture_source.h;
                    height += h;
                    this._expandedWidth = Math.max(this._expandedWidth, w);
                }
                if (titleView.visible && titleView.texture && titleView.texture.source) {
                    var _titleView_texture_source = titleView.texture.source, w1 = _titleView_texture_source.w, h1 = _titleView_texture_source.h;
                    var padding = height ? 8 : 0;
                    titleView.y = height + padding;
                    height += h1 + padding;
                    this._expandedWidth = Math.max(this._expandedWidth, w1);
                }
                if (rowView.visible) {
                    rowView.y = height;
                    var h2 = 0;
                    var w2 = 0;
                    if (extraTitleView.visible && extraTitleView.texture && extraTitleView.texture.source) {
                        var _extraTitleView_texture_source = extraTitleView.texture.source, textWidth = _extraTitleView_texture_source.w, textHeight = _extraTitleView_texture_source.h;
                        w2 += textWidth;
                        h2 = textHeight;
                    }
                    if (icon.visible) {
                        var _icon_texture_source = icon.texture.source, iconWidth = _icon_texture_source.w, iconHeight = _icon_texture_source.h;
                        w2 += iconWidth;
                        h2 = Math.max(h2, iconHeight);
                    }
                    this._expandedWidth = Math.max(this._expandedWidth, w2);
                    height += h2;
                }
                container.y = Math.round((this._itemHeight - height) / 2);
                this._expandedWidth += _epgBoxstyle.GAP * 2 + this._containerOffset;
            }
        },
        {
            key: "_focus",
            value: function _focus() {
                this._focused = true;
                this.patch((0, _epgBoxstyle.getFocusedStyle)(this._style));
            }
        },
        {
            key: "_unfocus",
            value: function _unfocus() {
                this._focused = false;
                this.currentWidth = Math.max(1, this.collapsedWidth);
                this.x = this.offset;
                this.patch((0, _epgBoxstyle.getUnFocusedStyle)(this._style));
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    clipping: true,
                    Background: {
                        rect: true,
                        shader: {
                            type: _imageshader.default
                        }
                    },
                    Image: {
                        shader: {
                            type: _sdk.Lightning.shaders.RoundedRectangle
                        }
                    },
                    Border: {
                        rect: true,
                        shader: {
                            type: _sdk.Lightning.shaders.RoundedRectangle
                        }
                    },
                    Container: {
                        Time: {},
                        Title: {},
                        Row: {
                            ExtraTitle: {},
                            Icon: {
                                type: _iconcomponent.default
                            }
                        }
                    }
                }, (0, _epgBoxstyle.getInitialStyle)());
            }
        }
    ]);
    return EpgBox;
}(_sdk.Lightning.Component);
EpgBox.templates = _epgBoxconstants.templates;


/***/ }),

/***/ 11242:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    EMPTY_VIEW: function() {
        return EMPTY_VIEW;
    },
    templates: function() {
        return templates;
    }
});
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(37815);
var templates = {
    EpgBox: "EpgBox"
};
var EMPTY_VIEW = {
    Image: {
        src: null,
        visible: false
    },
    Container: {
        visible: false,
        Time: {
            visible: false,
            text: {
                text: ""
            }
        },
        Title: {
            visible: false,
            text: {
                text: ""
            }
        },
        Row: {
            visible: false,
            ExtraTitle: {
                visible: false,
                text: {
                    text: ""
                }
            },
            Icon: {
                visible: false
            }
        }
    }
};


/***/ }),

/***/ 96194:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BORDER_RADIUS: function() {
        return BORDER_RADIUS;
    },
    GAP: function() {
        return GAP;
    },
    ICON_SIZE: function() {
        return ICON_SIZE;
    },
    IMAGE_WIDTH: function() {
        return IMAGE_WIDTH;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getFocusedStyle: function() {
        return getFocusedStyle;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    getUnFocusedStyle: function() {
        return getUnFocusedStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
var _theme = __webpack_require__(51397);
var _typography = __webpack_require__(18411);
var _constants = __webpack_require__(34952);
var _colors = __webpack_require__(8426);
var _style = __webpack_require__(65082);
var _progressstyle = __webpack_require__(67614);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var colors = {
    backgroundUnfocused: (0, _theme.makeThemeColor)(_theme.HIGHLIGHT),
    backgroundFocused: (0, _theme.makeThemeColor)(_theme.CLOUD_NORMAL),
    border: (0, _theme.makeThemeColor)(_theme.PRIMARY),
    text: (0, _theme.makeThemeColor)(_theme.PRIMARY)
};
var _obj;
var IMAGE_WIDTH = (_obj = {}, _define_property._(_obj, _constants.HD, 73), _define_property._(_obj, _constants.FULL_HD, 84), _obj);
var _obj1;
var BORDER_RADIUS = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 8), _define_property._(_obj1, _constants.FULL_HD, 8), _obj1);
var GAP = 8;
var ICON_SIZE = 16;
var getInitialStyle = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext, screenSize = _ref.screenSize, colorMode = _ref.colorMode;
    return {
        zIndex: _style.UNFOCUSED_Z_INDEX,
        Border: {
            shader: {
                radius: BORDER_RADIUS[screenSize],
                strokeColor: _colors.TRANSPARENT,
                fillColor: _colors.TRANSPARENT,
                stroke: 1.5
            }
        },
        Background: {
            color: colors.backgroundUnfocused[colorMode],
            shader: {
                radius: 8,
                progressHeight: _progressstyle.HEIGHT,
                progressBackgroundColor: _progressstyle.colors.background[colorMode],
                progressBarColor: _progressstyle.colors.bar[colorMode]
            }
        },
        Image: {
            w: IMAGE_WIDTH[screenSize],
            shader: {
                radius: [
                    BORDER_RADIUS[screenSize],
                    0,
                    0,
                    BORDER_RADIUS[screenSize]
                ]
            }
        },
        Container: {
            y: GAP,
            Time: {
                color: colors.text[colorMode],
                text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT.BOSTON_1, screenSize)), {
                    verticalAlign: "middle",
                    wordWrap: false,
                    textOverflow: "..."
                })
            },
            Title: {
                color: colors.text[colorMode],
                text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT.MADRID_3, screenSize)), {
                    verticalAlign: "middle",
                    wordWrap: false,
                    textOverflow: "..."
                })
            },
            Row: {
                flex: {
                    direction: "row",
                    alignItems: "center"
                },
                ExtraTitle: {
                    color: colors.text[colorMode],
                    text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT.BOSTON_1, screenSize)), {
                        verticalAlign: "middle",
                        wordWrap: false,
                        textOverflow: "..."
                    })
                },
                Icon: {}
            }
        }
    };
};
var getFocusedStyle = function() {
    var colorMode = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext).colorMode;
    return {
        zIndex: _style.FOCUSED_Z_INDEX,
        Border: {
            smooth: {
                "shader.strokeColor": colors.border[colorMode]
            }
        },
        Background: {
            smooth: {
                color: colors.backgroundFocused[colorMode]
            }
        }
    };
};
var getUnFocusedStyle = function() {
    var colorMode = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext).colorMode;
    return {
        zIndex: _style.UNFOCUSED_Z_INDEX,
        Border: {
            smooth: {
                "shader.strokeColor": _colors.TRANSPARENT
            }
        },
        Background: {
            smooth: {
                color: colors.backgroundUnfocused[colorMode]
            }
        }
    };
};


/***/ }),

/***/ 47036:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "areEPGEntriesEqual", ({
    enumerable: true,
    get: function() {
        return areEPGEntriesEqual;
    }
}));
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(3009);
var areEPGEntriesEqual = function(first, second) {
    if (!first || !second) {
        return false;
    }
    return first.start.title === second.start.title && first.end.title === second.end.title && first.title === second.title && first.extraTitle === second.extraTitle && (first.progressBar && second.progressBar ? first.progressBar.progressValue === second.progressBar.progressValue : !first.progressBar && !second.progressBar);
};


/***/ }),

/***/ 9683:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/* eslint-disable no-console, no-continue */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "EpgGrid", ({
    enumerable: true,
    get: function() {
        return EpgGrid;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(37815);
var _sdk = __webpack_require__(29956);
var _virtualization = __webpack_require__(11559);
var _signals = __webpack_require__(2109);
var _epgBoxcomponent = __webpack_require__(42012);
var _epgBoxstyle = __webpack_require__(96194);
var _epgstyle = __webpack_require__(81536);
var _epgGridconstants = __webpack_require__(95778);
var _epgconstants = __webpack_require__(64789);
var EpgGrid = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(EpgGrid, _Lightning_Component);
    var _super = _create_super._(EpgGrid);
    function EpgGrid() {
        _class_call_check._(this, EpgGrid);
        return _super.apply(this, arguments);
    }
    _create_class._(EpgGrid, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _epgstyle.defaultContext;
                this._resetVirtualization();
            }
        },
        {
            key: "_firstActive",
            value: function _firstActive() {
                this._step = this._animationLoop.bind(this);
                this.stage.on("frameStart", this._step);
            }
        },
        {
            key: "_attach",
            value: function _attach() {
                this._isGridAttached = true;
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                this.stage.removeListener("frameStart", this._step);
                this._step = null;
                clearTimeout(this._itemFocusTimeout);
                this._isGridAttached = false;
                this._resetVirtualization();
            }
        },
        {
            key: "rows",
            set: function set(value) {
                var _this = this;
                if (!value) {
                    return;
                }
                var id = value.id, rows = value.rows, pages = value.pages, pagination = value.pagination, rowHeight = value.rowHeight, start = value.start, end = value.end;
                if ((this._start ? this._start.getTime() : 0) !== start.getTime()) {
                    console.log("[EPG] New rows set, removing current views");
                    this.tag("Container").children.forEach(function(view) {
                        _this._backToBuffer(view);
                    });
                } else if (this._blockId !== id) {
                    this._refreshRequired = true;
                }
                var totalItems = pagination.totalItems, itemsPerPage = pagination.itemsPerPage;
                this._blockId = id;
                this._totalItems = totalItems;
                this._itemsPerPage = itemsPerPage;
                this._pages = pages;
                this._rows = rows;
                this._rowsCount = rows.length;
                this._rowHeight = rowHeight;
                this._start = start;
                this._end = end;
                this._limits = rows.map(function(param) {
                    var children = param.children;
                    var lastChild = children[children.length - 1];
                    return lastChild.x + lastChild.w;
                });
                for(var i = 0; i < this._rowsCount; i += 1){
                    if (!this._viewsByRows[i]) {
                        this._viewsByRows[i] = [];
                    }
                }
            }
        },
        {
            key: "rightPadding",
            get: function get() {
                return _epgstyle.RIGHT_PADDING[this._style.screenSize];
            }
        },
        {
            key: "rightmostOffset",
            get: function get() {
                return this.finalW - (this._limits[this._focusedRowIndex] || 0) - this.rightPadding;
            }
        },
        {
            key: "goToTimestamp",
            value: function goToTimestamp(value) {
                var skipAnimation = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, alignToCenter = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
                var container = this.tag("Container");
                var offset = alignToCenter ? Math.round(this.finalW / 2) : 0;
                if (value < this._start || value > this._end) {
                    this._focusedItemIndex = this._findNearestToPointInRow(offset - container.x, this._focusedRowIndex);
                    return;
                }
                var timeOffset = (value - this._start) / (this._end - this._start);
                var maxOffset = _epgconstants.PIXELS_PER_MINUTE * 24 * 60;
                var center = maxOffset * timeOffset;
                var targetPosition = Math.max(Math.min(0, Math.round(offset - center)), this.rightmostOffset);
                if (skipAnimation) {
                    container.x = targetPosition;
                } else {
                    container.setSmooth("x", targetPosition);
                }
                this._focusedItemIndex = this._findNearestToPointInRow(center, this._focusedRowIndex);
                this.signal(_epgGridconstants.SET_X_SIGNAL, targetPosition, this.rightmostOffset);
            }
        },
        {
            key: "goLeft",
            value: function goLeft() {
                var container = this.tag("Container");
                var target = Math.min(container.x + _epgstyle.ARROW_SLIDE_INTERVAL[this._style.screenSize], 0);
                container.setSmooth("x", target);
                this._focusedItemIndex = this._findNearestToPointInRow(-target, this._focusedRowIndex);
                this.signal(_epgGridconstants.SET_X_SIGNAL, target, this.rightmostOffset);
            }
        },
        {
            key: "goRight",
            value: function goRight() {
                var container = this.tag("Container");
                var maxOffset = this.rightmostOffset;
                var target = Math.max(container.x - _epgstyle.ARROW_SLIDE_INTERVAL[this._style.screenSize], maxOffset);
                container.setSmooth("x", target);
                this._focusedItemIndex = this._findNearestToPointInRow(-target, this._focusedRowIndex);
                this.signal(_epgGridconstants.SET_X_SIGNAL, target, maxOffset);
            }
        },
        {
            key: "_onViewBecomeInactive",
            value: function _onViewBecomeInactive(view) {
                if (this._isGridAttached) {
                    this._backToBuffer(view);
                }
            }
        },
        {
            key: "_onViewBecomeDetached",
            value: function _onViewBecomeDetached(view) {
                (0, _virtualization.cleanupBuffer)(view);
            }
        },
        {
            key: "_getViewFromBufferOrCreate",
            value: function _getViewFromBufferOrCreate() {
                var template = _epgBoxcomponent.EpgBox.templates.EpgBox;
                var existingView = (0, _virtualization.getFromBuffer)(template);
                if (existingView) {
                    return existingView;
                }
                var _obj;
                return this.stage.c({
                    type: _epgBoxcomponent.EpgBox,
                    template: template,
                    passSignals: {
                    },
                    signals: (_obj = {}, _define_property._(_obj, _signals.INACTIVE_SIGNAL, "_onViewBecomeInactive"), _define_property._(_obj, _signals.DETACHED_SIGNAL, "_onViewBecomeDetached"), _obj)
                });
            }
        },
        {
            key: "_backToBuffer",
            value: function _backToBuffer(view) {
                if (!view) {
                    return;
                }
                delete this._views[view.index];
                if (this._viewsByRows[view.rowIndex]) {
                    this._viewsByRows[view.rowIndex] = this._viewsByRows[view.rowIndex].filter(function(entry) {
                        return entry !== view;
                    });
                }
                (0, _virtualization.backToBuffer)(view);
                // view.alpha = 0;
                view.visible = false;
                this._renderList = this._renderList.filter(function(entry) {
                    return entry !== view;
                });
            }
        },
        {
            key: "_switchToCurrentRow",
            value: function _switchToCurrentRow(fromView) {
                this._focusedItemIndex = this._findNearestIndex(fromView, this._focusedRowIndex);
                var maxVisibleRows = _epgstyle.MAX_VISIBLE_ROWS[this._style.screenSize];
                var rows = Math.max(0, Math.min(this._focusedRowIndex - _epgstyle.SCROLL_START_ROW + 1, this._rowsCount - maxVisibleRows));
                var offset = -rows * (_epgstyle.CHANNEL_SIZE[this._style.screenSize] + _epgstyle.GAP);
                var container = this.tag("Container");
                container.setSmooth("y", offset);
                this.signal(_epgGridconstants.SET_Y_SIGNAL, offset);
                // In case a right/left-most is focused, scroll horizontally to the edge
                this._goTo(this._focusedItemIndex, false, true);
                this._startItemFocusTimeout();
                if (this._itemsPerPage > 0 && this._pages) {
                    var currentPage = Math.floor(this._focusedRowIndex / this._itemsPerPage);
                    // NOTE: the first page will be empty in case if the Row is used within a Selector block
                    var nextPage = this._pages[0] === _virtualization.PAGE_STATE.LOADED ? currentPage + 1 : 0;
                    if (currentPage !== nextPage) {
                        this._requestPage(currentPage);
                        // In case the row was restored with anchoring from a backward navigation
                        if (currentPage - 1 >= 0) {
                            this._requestPage(currentPage - 1);
                        }
                    }
                    this._requestPage(nextPage);
                }
            }
        },
        {
            /**
   * Sends a signal requesting a specific page of items
   *
   * @param {Number} page zero-based page index
   */ key: "_requestPage",
            value: function _requestPage(page) {
                if (this._pages[page] !== _virtualization.PAGE_STATE.MISSING) {
                    return;
                }
                this.signal(_signals.PORTION_REQUESTED_SIGNAL, {
                    // NOTE: BFF API requires the pages to be 1-based
                    page: page + 1,
                    start: page * this._itemsPerPage,
                    id: this._blockId,
                    date: this._start
                });
            }
        },
        {
            key: "_findNearestIndex",
            value: function _findNearestIndex(view, rowIndex) {
                var start = this._verticalTraverseStartPoint || (view ? view.offset : 0);
                if (!this._verticalTraverseStartPoint) {
                    this._verticalTraverseStartPoint = start;
                }
                start = Math.max(start, -this.tag("Container").x);
                return this._findNearestToPointInRow(start, rowIndex);
            }
        },
        {
            key: "_findNearestToPointInRow",
            value: function _findNearestToPointInRow(start, rowIndex) {
                var candidates = this._rows[rowIndex].children;
                for(var i = 0; i < candidates.length; i += 1){
                    var candidate = candidates[i];
                    if (candidate.x >= start) {
                        return candidate.itemIndex;
                    }
                    if (candidate.x + candidate.w > start) {
                        return candidate.itemIndex;
                    }
                }
                return candidates.length - 1;
            }
        },
        {
            key: "_animationLoop",
            value: function _animationLoop() {
                if (!this._rows) {
                    return;
                }
                var container = this.tag("Container");
                var paddingX = Math.round(this.finalW / 4);
                var paddingY = this._rowHeight;
                var left = Math.max(-container.x - paddingX, 0);
                var top = Math.max(-container.y - paddingY, 0);
                var right = this.finalW + paddingX - container.x;
                var bottom = this.finalH + paddingY - container.y;
                var toRender = [];
                // container.children.forEach(view => {
                //   if (view.y + view.h < top || view.y > bottom || view.x + view.w < left || view.x > right) {
                //     this._backToBuffer(view);
                //   }
                // });
                for(var row = 0; row < this._rows.length; row += 1){
                    var _this__rows_row = this._rows[row], y = _this__rows_row.y, h = _this__rows_row.h, children = _this__rows_row.children;
                    if (y + h < top) {
                        continue;
                    }
                    if (y > bottom) {
                        break;
                    }
                    for(var i = 0; i < children.length; i += 1){
                        var child = children[i];
                        var x = child.x, w = child.w;
                        if (x + w < left) {
                            continue;
                        }
                        if (x > right) {
                            break;
                        }
                        if (this._views[child.index]) {
                            this._updateInnerOffset(this._views[child.index], -container.x, true);
                            if (this._refreshRequired) {
                                toRender.push(child);
                            }
                        } else {
                            toRender.push(child);
                        }
                    }
                }
                var updatesCount = Math.min(toRender.length, _epgGridconstants.MAX_UPDATES_PER_FRAME);
                for(var i1 = 0; i1 < updatesCount; i1 += 1){
                    var data = toRender[i1];
                    var view = this._views[data.index];
                    if (!view) {
                        view = this._getViewFromBufferOrCreate();
                        this._renderList.push(view);
                        if (!this._viewsByRows[data.rowIndex]) {
                            this._viewsByRows[data.rowIndex] = [];
                        }
                        this._viewsByRows[data.rowIndex].push(view);
                    }
                    if (view.index !== data.index || !view.visible || this._refreshRequired) {
                        view.rowIndex = data.rowIndex;
                        view.itemIndex = data.itemIndex;
                        view.patch({
                            x: data.x,
                            y: data.y,
                            item: data.item,
                            index: data.index,
                            visible: true
                        });
                    }
                    if (view.parent !== container) {
                        container.childList.add(view);
                    }
                    this._views[data.index] = view;
                }
                if (container.x !== this._previousX || container.y !== this._previousY || updatesCount) {
                    this._refocus();
                    this._previousX = container.x;
                    this._previousY = container.y;
                    this._isMoving = true;
                } else if (this._isMoving) {
                    this._isMoving = false;
                }
                this._refreshRequired = false;
            }
        },
        {
            key: "_updateInnerOffsets",
            value: function _updateInnerOffsets(fringe) {
                var skipAnimation = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var views = this._renderList;
                for(var i = 0; i < views.length; i += 1){
                    this._updateInnerOffset(views[i], fringe, skipAnimation);
                }
            }
        },
        {
            key: "_updateInnerOffset",
            value: function _updateInnerOffset(view, fringe) {
                var skipAnimation = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                var value = view.offset >= fringe || view.offset + view.itemWidth >= fringe ? Math.max(fringe - view.offset + view.padding, view.minInnerOffset) : view.minInnerOffset;
                if (skipAnimation) {
                    view.innerOffset = value;
                } else {
                    view.setSmooth("innerOffset", value);
                }
            }
        },
        {
            key: "_goTo",
            value: function _goTo(index) {
                var skipAnimation = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, keepHorizontalBounds = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                clearTimeout(this._itemFocusTimeout);
                var rowIndex = this._focusedRowIndex;
                var row = this._rows ? this._rows[rowIndex] : null;
                if (!row) {
                    return;
                }
                var box = row.children[index];
                if (!box) {
                    return;
                }
                var container = this.tag("Container");
                var viewRight = box.item.offset + box.item.itemWidth;
                var containerLeft = container.x;
                var containerRight = this.finalW - this.rightPadding;
                // Positive offset along the same X line boxes are placed upon
                var containerRightOffset = containerRight - containerLeft;
                var maxOffset = this.rightmostOffset;
                var view = this._views[box.index];
                var viewWidth = keepHorizontalBounds || !view || !view.expandedWidth ? 0 : Math.min(view.collapsedWidth, view.expandedWidth);
                if (box.x + viewWidth > containerRightOffset || !keepHorizontalBounds && index === row.children.length - 1) {
                    var offset = containerRight - viewRight;
                    var constrainedOffset = Math.max(offset, maxOffset);
                    if (!skipAnimation) {
                        container.setSmooth("x", constrainedOffset);
                        this.signal(_epgGridconstants.SET_X_SIGNAL, constrainedOffset, maxOffset);
                    }
                } else if (box.x + box.w + containerLeft <= _epgBoxstyle.GAP || !keepHorizontalBounds && index === 0) {
                    var offset1 = -box.item.offset;
                    if (!skipAnimation) {
                        container.setSmooth("x", offset1);
                        this.signal(_epgGridconstants.SET_X_SIGNAL, offset1, maxOffset);
                    }
                }
                this._startItemFocusTimeout();
            }
        },
        {
            key: "_startItemFocusTimeout",
            value: function _startItemFocusTimeout() {
                var _this = this;
                clearTimeout(this._itemFocusTimeout);
                this._itemFocusTimeout = setTimeout(function() {
                    var view = _this._getFocused();
                    var right = _this.finalW - _this.rightPadding;
                    var left = _this.tag("Container").x;
                    var expandedWidth = Math.max(view.expandedWidth, Math.max(1, view.collapsedWidth));
                    var viewRight = view.offset + expandedWidth;
                    var itemWidth = expandedWidth + Math.max(0, view.innerOffset - (expandedWidth - view.expandedWidth));
                    if (viewRight > right - left) {
                        var overlap = view.offset + view.expandedWidth - _this.finalW + left;
                        view.x = Math.min(view.offset - overlap, view.offset - (itemWidth - view.collapsedWidth));
                    }
                    view.currentWidth = itemWidth;
                }, _epgGridconstants.ITEM_FOCUS_TIMEOUT_MS);
            }
        },
        {
            key: "_handleLeft",
            value: function _handleLeft() {
                if (this._focusedItemIndex > 0) {
                    this._focusedItemIndex -= 1;
                    this._verticalTraverseStartPoint = undefined;
                    this._goTo(this._focusedItemIndex);
                    return true;
                }
                if (this._verticalTraverseStartPoint) {
                    this._verticalTraverseStartPoint = undefined;
                    this._goTo(this._focusedItemIndex);
                }
                return false;
            }
        },
        {
            key: "_handleRight",
            value: function _handleRight() {
                var row = this._rows ? this._rows[this._focusedRowIndex] : null;
                if (!row) {
                    return false;
                }
                if (this._focusedItemIndex < row.children.length - 1) {
                    this._focusedItemIndex += 1;
                    this._verticalTraverseStartPoint = undefined;
                    this._goTo(this._focusedItemIndex);
                    return true;
                }
                if (this._verticalTraverseStartPoint) {
                    this._verticalTraverseStartPoint = undefined;
                    this._goTo(this._focusedItemIndex);
                }
                return false;
            }
        },
        {
            key: "_handleUp",
            value: function _handleUp() {
                if (this._focusedRowIndex > 0) {
                    var currentFocusedView = this._getFocused();
                    this._focusedRowIndex -= 1;
                    this._switchToCurrentRow(currentFocusedView);
                    return true;
                }
                return false;
            }
        },
        {
            key: "_handleDown",
            value: function _handleDown() {
                if (this._focusedRowIndex < this._rowsCount - 1) {
                    var currentFocusedView = this._getFocused();
                    this._focusedRowIndex += 1;
                    this._switchToCurrentRow(currentFocusedView);
                    return true;
                }
                return false;
            }
        },
        {
            key: "_handleEnter",
            value: function _handleEnter() {
                var box = this._getFocused();
                this.signal(_signals.SELECTED_SIGNAL, box && box.item ? box.item.content : null);
                return true;
            }
        },
        {
            key: "_getFocused",
            value: function _getFocused() {
                return this._views["".concat(this._focusedRowIndex, "_").concat(this._focusedItemIndex)];
            }
        },
        {
            key: "_focus",
            value: function _focus() {
                this._startItemFocusTimeout();
            }
        },
        {
            key: "_unfocus",
            value: function _unfocus() {
                clearTimeout(this._itemFocusTimeout);
                this._verticalTraverseStartPoint = undefined;
            }
        },
        {
            key: "_resetVirtualization",
            value: function _resetVirtualization() {
                this._verticalTraverseStartPoint = undefined;
                this._tickTime = null;
                this._views = {};
                this._viewsByRows = {};
                this._renderList = [];
                this._limits = [];
                this._focusedRowIndex = 0;
                this._focusedItemIndex = 0;
                this._previousX = null;
                this._previousY = null;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return {
                    clipping: true,
                    Container: {}
                };
            }
        }
    ]);
    return EpgGrid;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 95778:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
// How many items could be created or updated within a single animation frame tick

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ITEM_FOCUS_TIMEOUT_MS: function() {
        return ITEM_FOCUS_TIMEOUT_MS;
    },
    MAX_UPDATES_PER_FRAME: function() {
        return MAX_UPDATES_PER_FRAME;
    },
    SET_X_SIGNAL: function() {
        return SET_X_SIGNAL;
    },
    SET_Y_SIGNAL: function() {
        return SET_Y_SIGNAL;
    }
});
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(3009);
var MAX_UPDATES_PER_FRAME = 20;
var ITEM_FOCUS_TIMEOUT_MS = 800;
var SET_X_SIGNAL = "set_x";
var SET_Y_SIGNAL = "set_y";


/***/ }),

/***/ 84237:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "EpgNav", ({
    enumerable: true,
    get: function() {
        return EpgNav;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(42578);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _findLastIndex = /*#__PURE__*/ _interop_require_default._(__webpack_require__(31521));
var _sdk = __webpack_require__(29956);
var _isToday = /*#__PURE__*/ _interop_require_default._(__webpack_require__(66854));
var _i18n = __webpack_require__(14910);
var _buttoncomponent = __webpack_require__(31464);
var _navigationArrowcomponent = __webpack_require__(197);
var _navigationArrowconstants = __webpack_require__(61273);
var _selectorHeadercomponent = __webpack_require__(43590);
var _signals = __webpack_require__(2109);
var _epgutils = __webpack_require__(21783);
var _epgNavstyle = __webpack_require__(24199);
var _epgNavconstants = __webpack_require__(23974);
var EpgNav = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(EpgNav, _Lightning_Component);
    var _super = _create_super._(EpgNav);
    function EpgNav() {
        _class_call_check._(this, EpgNav);
        return _super.apply(this, arguments);
    }
    _create_class._(EpgNav, [
        {
            key: "_build",
            value: function _build() {
                this._style = _epgNavstyle.defaultContext;
                this._focusable = [
                    "DateSelector",
                    "Tabs",
                    "ToLive",
                    "ArrowLeft",
                    "ArrowRight"
                ];
                this._focusIndex = 0;
            }
        },
        {
            key: "date",
            set: function set(value) {
                var button = this.tag("DateSelector");
                if (value) {
                    var date = new Date(value);
                    button.label = (0, _isToday.default)(date) ? (0, _i18n.t)("epgGrid.today") : (0, _epgutils.formatDate)(date, true);
                } else {
                    button.label = (0, _i18n.t)("epgGrid.today");
                }
            }
        },
        {
            key: "percentage",
            set: function set(value) {
                var left = this.tag("ArrowLeft");
                var right = this.tag("ArrowRight");
                left.disabled = value <= 0;
                right.disabled = value >= 1;
                if (left.disabled) {
                    if (this._focusIndex === this._focusable.indexOf("ArrowLeft")) {
                        this._focusIndex = this._focusable.indexOf("ArrowRight");
                        this._waitForKeyUp = true;
                    }
                } else if (right.disabled) {
                    if (this._focusIndex === this._focusable.indexOf("ArrowRight")) {
                        this._focusIndex = this._focusable.indexOf("ArrowLeft");
                        this._waitForKeyUp = true;
                    }
                }
                this._refocus();
            }
        },
        {
            key: "_handleEnterRelease",
            value: function _handleEnterRelease() {
                this._waitForKeyUp = false;
            }
        },
        {
            key: "_handleEnter",
            value: function _handleEnter() {
                if (this._waitForKeyUp) {
                    return;
                }
                switch(this._focusable[this._focusIndex]){
                    case "DateSelector":
                        {
                            this.signal(_epgNavconstants.SIGNAL_OPEN_DATE_SELECTOR);
                            break;
                        }
                    case "ToLive":
                        {
                            this.signal(_epgNavconstants.SIGNAL_GO_TO_LIVE);
                            break;
                        }
                    case "ArrowLeft":
                        {
                            this.signal(_epgNavconstants.SIGNAL_GO_LEFT);
                            break;
                        }
                    case "ArrowRight":
                        {
                            this.signal(_epgNavconstants.SIGNAL_GO_RIGHT);
                            break;
                        }
                    default:
                        break;
                }
            }
        },
        {
            key: "_handleLeft",
            value: function _handleLeft() {
                var _this = this;
                var nextIndex = (0, _findLastIndex.default)(this._focusable, function(value, index) {
                    return index < _this._focusIndex && !_this.tag(value).disabled;
                });
                if (nextIndex < 0) {
                    return false;
                }
                this._focusIndex = nextIndex;
                return true;
            }
        },
        {
            key: "_handleRight",
            value: function _handleRight() {
                var _this = this;
                var nextIndex = this._focusable.findIndex(function(value, index) {
                    return index > _this._focusIndex && !_this.tag(value).disabled;
                });
                if (nextIndex < 0) {
                    return false;
                }
                this._focusIndex = nextIndex;
                return true;
            }
        },
        {
            key: "_handleSelectedTab",
            value: function _handleSelectedTab(index) {
                this.signal(_epgNavconstants.TABS[index]);
                // According to the design, tabs should not be in a selected state after a click
                this.tag("Tabs").selectedIndex = -1;
            }
        },
        {
            key: "_getFocused",
            value: function _getFocused() {
                return this.tag(this._focusable[this._focusIndex]);
            }
        },
        {
            key: "_focus",
            value: function _focus() {
                this._waitForKeyUp = false;
            }
        },
        {
            key: "_unfocus",
            value: function _unfocus() {
                this._waitForKeyUp = false;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    LeftContainer: {
                        DateSelector: {
                            type: _buttoncomponent.Button,
                            label: (0, _i18n.t)("epgGrid.today"),
                            picto: {
                                name: "Agenda"
                            }
                        },
                        Tabs: {
                            type: _selectorHeadercomponent.SelectorHeader,
                            signals: _define_property._({}, _signals.SELECTED_SIGNAL, "_handleSelectedTab"),
                            items: [
                                {
                                    title: (0, _i18n.t)("epgGrid.morning")
                                },
                                {
                                    title: (0, _i18n.t)("epgGrid.afternoon")
                                },
                                {
                                    title: (0, _i18n.t)("epgGrid.evening")
                                }
                            ],
                            selectedIndex: -1
                        }
                    },
                    ToLive: {
                        type: _buttoncomponent.Button,
                        label: (0, _i18n.t)("epgGrid.live"),
                        picto: {
                            name: "Live"
                        }
                    },
                    Arrows: {
                        ArrowLeft: {
                            type: _navigationArrowcomponent.NavigationArrow,
                            variant: _navigationArrowconstants.ARROW_LEFT
                        },
                        ArrowRight: {
                            type: _navigationArrowcomponent.NavigationArrow,
                            variant: _navigationArrowconstants.ARROW_RIGHT
                        }
                    }
                }, (0, _epgNavstyle.getInitialStyle)());
            }
        }
    ]);
    return EpgNav;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 23974:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    SIGNAL_GO_LEFT: function() {
        return SIGNAL_GO_LEFT;
    },
    SIGNAL_GO_RIGHT: function() {
        return SIGNAL_GO_RIGHT;
    },
    SIGNAL_GO_TO_AFTERNOON: function() {
        return SIGNAL_GO_TO_AFTERNOON;
    },
    SIGNAL_GO_TO_EVENING: function() {
        return SIGNAL_GO_TO_EVENING;
    },
    SIGNAL_GO_TO_LIVE: function() {
        return SIGNAL_GO_TO_LIVE;
    },
    SIGNAL_GO_TO_MORNING: function() {
        return SIGNAL_GO_TO_MORNING;
    },
    SIGNAL_OPEN_DATE_SELECTOR: function() {
        return SIGNAL_OPEN_DATE_SELECTOR;
    },
    TABS: function() {
        return TABS;
    }
});
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(3009);
var SIGNAL_GO_TO_LIVE = "to_live";
var SIGNAL_OPEN_DATE_SELECTOR = "open_date_selector";
var SIGNAL_GO_LEFT = "left";
var SIGNAL_GO_RIGHT = "right";
var SIGNAL_GO_TO_MORNING = "morning";
var SIGNAL_GO_TO_AFTERNOON = "afternoon";
var SIGNAL_GO_TO_EVENING = "evening";
var TABS = [
    SIGNAL_GO_TO_MORNING,
    SIGNAL_GO_TO_AFTERNOON,
    SIGNAL_GO_TO_EVENING
];


/***/ }),

/***/ 24199:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    GAP_LEFT: function() {
        return GAP_LEFT;
    },
    GAP_RIGHT: function() {
        return GAP_RIGHT;
    },
    HEIGHT: function() {
        return HEIGHT;
    },
    TO_LIVE_MARGIN_RIGHT: function() {
        return TO_LIVE_MARGIN_RIGHT;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    getTextStyle: function() {
        return getTextStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(52318);
var _constants = __webpack_require__(34952);
var _typography = __webpack_require__(18411);
var _style = __webpack_require__(65082);
var _sizes = __webpack_require__(82699);
var _buttonstyle = __webpack_require__(3211);
var _navigationArrowstyle = __webpack_require__(8692);
var _blockHeaderstyle = __webpack_require__(54344);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var HEIGHT = (_obj = {}, _define_property._(_obj, _constants.HD, 56), _define_property._(_obj, _constants.FULL_HD, 64), _obj);
var _obj1;
var TO_LIVE_MARGIN_RIGHT = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 0), _define_property._(_obj1, _constants.FULL_HD, 0), _obj1);
var GAP_RIGHT = 40;
var GAP_LEFT = 56;
var getTextStyle = function(screenSize) {
    return _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT.BERLIN_2, screenSize)), {
        verticalAlign: "middle"
    });
};
var getInitialStyle = function() {
    var screenSize = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext).screenSize;
    var arrowsWidth = _navigationArrowstyle.SIZE[screenSize] * 2 + GAP_RIGHT;
    var buttonY = Math.round((HEIGHT[screenSize] - _buttonstyle.HEIGHT[screenSize]) / 2);
    return {
        h: HEIGHT[screenSize],
        LeftContainer: {
            w: _sizes.SCREEN_WIDTH[screenSize],
            flex: {
                direction: "row"
            },
            DateSelector: {
                y: buttonY
            },
            Tabs: {
                w: _sizes.identity,
                y: Math.round((HEIGHT[screenSize] - (0, _blockHeaderstyle.getLabelFont)(screenSize).lineHeight) / 2),
                flexItem: {
                    grow: 1,
                    marginLeft: GAP_LEFT
                }
            }
        },
        ToLive: {
            mountX: 1,
            x: function(v) {
                return v - arrowsWidth - TO_LIVE_MARGIN_RIGHT[screenSize] - GAP_RIGHT;
            },
            y: buttonY
        },
        Arrows: {
            w: arrowsWidth,
            mountX: 1,
            x: _sizes.identity,
            ArrowRight: {
                x: _navigationArrowstyle.SIZE[screenSize] + GAP_RIGHT
            }
        }
    };
};


/***/ }),

/***/ 70059:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "EpgPopup", ({
    enumerable: true,
    get: function() {
        return EpgPopup;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(65759);
var _clamp = /*#__PURE__*/ _interop_require_default._(__webpack_require__(35636));
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _addDays = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65018));
var _startOfWeek = /*#__PURE__*/ _interop_require_default._(__webpack_require__(6737));
var _isSameDay = /*#__PURE__*/ _interop_require_default._(__webpack_require__(15878));
var _addWeeks = /*#__PURE__*/ _interop_require_default._(__webpack_require__(61005));
var _differenceInCalendarWeeks = /*#__PURE__*/ _interop_require_default._(__webpack_require__(84034));
var _i18n = __webpack_require__(14910);
var _signals = __webpack_require__(2109);
var _popupContainerconstants = __webpack_require__(54258);
var _layoutactions = __webpack_require__(8424);
var _epgutils = __webpack_require__(21783);
var _epgPopupHeadercomponent = __webpack_require__(7614);
var _epgPopupEntrycomponent = __webpack_require__(22829);
var _epgPopupstyle = __webpack_require__(94135);
var _analyticsutils = __webpack_require__(2693);
var EpgPopup = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(EpgPopup, _Lightning_Component);
    var _super = _create_super._(EpgPopup);
    function EpgPopup() {
        _class_call_check._(this, EpgPopup);
        return _super.apply(this, arguments);
    }
    _create_class._(EpgPopup, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _epgPopupstyle.defaultContext;
                this._offset = 0;
            }
        },
        {
            key: "_active",
            value: function _active() {
                this.patch({
                    Container: {
                        smooth: {
                            x: (0, _epgPopupstyle.getExpandedPosition)(this._style)
                        }
                    }
                });
                this._setState("List");
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                this._date = undefined;
            }
        },
        {
            key: "blockId",
            get: function get() {
                return this._blockId;
            },
            set: function set(value) {
                this._blockId = value;
            }
        },
        {
            key: "date",
            get: function get() {
                return this._date;
            },
            set: function set(value) {
                this._date = value;
                this._updateDate();
            }
        },
        {
            key: "selectedDate",
            get: function get() {
                return this._selectedDate;
            },
            set: function set(value) {
                this._selectedDate = value;
                (0, _analyticsutils.sendEvent)({
                    key: "epgDateSelect",
                    date: this._selectedDate
                });
                this._updateDate();
            }
        },
        {
            key: "_handleBack",
            value: function _handleBack() {
                this.signal(_popupContainerconstants.HIDE_POPUP_SIGNAL);
                return true;
            }
        },
        {
            key: "_handleEntrySelected",
            value: function _handleEntrySelected(date) {
                this.tag("List").children.forEach(function(child) {
                    child.selected = (0, _isSameDay.default)(child.date, date);
                });
                _lightningjsredux.default.dispatch((0, _layoutactions.fetchEPGLayout)({
                    date: date,
                    blockId: this.blockId
                }));
                this.signal(_popupContainerconstants.HIDE_POPUP_SIGNAL);
            }
        },
        {
            key: "_handleWeekSelected",
            value: function _handleWeekSelected(offset) {
                this._offset = offset;
                this._update();
            }
        },
        {
            key: "_updateDate",
            value: function _updateDate() {
                if (!this._date || !this._selectedDate) {
                    return;
                }
                this._offset = (0, _clamp.default)((0, _differenceInCalendarWeeks.default)(this._selectedDate, this._date, {
                    weekStartsOn: 1
                }), -1, 1);
                this.tag("Header").index = this._offset + 1;
                this._update();
            }
        },
        {
            key: "_update",
            value: function _update() {
                var _this = this;
                var start = (0, _startOfWeek.default)((0, _addWeeks.default)(this._date, this._offset), {
                    weekStartsOn: 1
                });
                var now = new Date();
                var days = [];
                for(var i = 0; i < 7; i += 1){
                    days.push((0, _addDays.default)(start, i));
                }
                this.tag("List").children = days.map(function(dayOfWeek) {
                    var isToday = (0, _isSameDay.default)(dayOfWeek, now);
                    var isSelected = (0, _isSameDay.default)(dayOfWeek, _this._selectedDate);
                    return {
                        type: _epgPopupEntrycomponent.EpgPopupEntry,
                        title: isToday ? (0, _i18n.t)("epgGrid.today") : (0, _epgutils.formatDate)(dayOfWeek),
                        selected: isSelected,
                        date: dayOfWeek,
                        signals: _define_property._({}, _signals.SELECTED_SIGNAL, "_handleEntrySelected"),
                        flexItem: {
                            marginBottom: _epgPopupstyle.LIST_GAP
                        }
                    };
                });
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    rect: true,
                    passSignals: _define_property._({}, _popupContainerconstants.HIDE_POPUP_SIGNAL, true),
                    Container: {
                        rect: true,
                        Header: {
                            type: _epgPopupHeadercomponent.EpgPopupHeader,
                            title: (0, _i18n.t)("epgGrid.currentWeek"),
                            signals: _define_property._({}, _signals.SELECTED_SIGNAL, "_handleWeekSelected")
                        }
                    },
                    List: {}
                }, (0, _epgPopupstyle.getInitialStyle)());
            }
        },
        {
            key: "_states",
            value: function _states() {
                return [
                    /*#__PURE__*/ function(_this) {
                        _inherits._(Header, _this);
                        var _super = _create_super._(Header);
                        function Header() {
                            _class_call_check._(this, Header);
                            return _super.apply(this, arguments);
                        }
                        _create_class._(Header, [
                            {
                                key: "_getFocused",
                                value: function _getFocused() {
                                    return this.tag("Header");
                                }
                            },
                            {
                                key: "_handleDown",
                                value: function _handleDown() {
                                    this._setState("List");
                                }
                            }
                        ]);
                        return Header;
                    }(this),
                    /*#__PURE__*/ function(_this) {
                        _inherits._(List, _this);
                        var _super = _create_super._(List);
                        function List() {
                            _class_call_check._(this, List);
                            return _super.apply(this, arguments);
                        }
                        _create_class._(List, [
                            {
                                key: "$enter",
                                value: function $enter() {
                                    this._index = 0;
                                }
                            },
                            {
                                key: "_handleUp",
                                value: function _handleUp() {
                                    if (this._index > 0) {
                                        this._index -= 1;
                                    } else {
                                        this._setState("Header");
                                    }
                                    return true;
                                }
                            },
                            {
                                key: "_handleDown",
                                value: function _handleDown() {
                                    if (this._index < this.tag("List").children.length - 1) {
                                        this._index += 1;
                                    }
                                    return true;
                                }
                            },
                            {
                                key: "_getFocused",
                                value: function _getFocused() {
                                    return this.tag("List").children[this._index];
                                }
                            }
                        ]);
                        return List;
                    }(this)
                ];
            }
        }
    ]);
    return EpgPopup;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 94135:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    GAP: function() {
        return GAP;
    },
    LIST_GAP: function() {
        return LIST_GAP;
    },
    PADDING_HORIZONTAL: function() {
        return PADDING_HORIZONTAL;
    },
    PADDING_VERTICAL: function() {
        return PADDING_VERTICAL;
    },
    WIDTH: function() {
        return WIDTH;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getExpandedPosition: function() {
        return getExpandedPosition;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
var _define_property = __webpack_require__(21228);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(88801);
var _constants = __webpack_require__(34952);
var _theme = __webpack_require__(51397);
var _style = __webpack_require__(65082);
var _sizes = __webpack_require__(82699);
var _navigationArrowstyle = __webpack_require__(8692);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var WIDTH = (_obj = {}, _define_property._(_obj, _constants.HD, 600), _define_property._(_obj, _constants.FULL_HD, 600), _obj);
var PADDING_VERTICAL = 56;
var PADDING_HORIZONTAL = 32;
var GAP = 32;
var LIST_GAP = 16;
var colors = {
    backdrop: (0, _theme.makeThemeColor)(_theme.TERTIARY, 0.5),
    background: (0, _theme.makeThemeColor)(_theme.TERTIARY)
};
var getExpandedPosition = function(param) {
    var screenSize = param.screenSize;
    return _sizes.SCREEN_WIDTH[screenSize] - WIDTH[screenSize];
};
var getInitialStyle = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext, colorMode = _ref.colorMode, screenSize = _ref.screenSize;
    var w = WIDTH[screenSize];
    var containerY = PADDING_VERTICAL + _navigationArrowstyle.SIZE[screenSize] + GAP;
    return {
        w: _sizes.SCREEN_WIDTH[screenSize],
        h: _sizes.SCREEN_HEIGHT[screenSize],
        color: colors.backdrop[colorMode],
        Container: {
            color: colors.background[colorMode],
            x: _sizes.SCREEN_WIDTH[screenSize],
            w: w,
            h: _sizes.SCREEN_HEIGHT[screenSize],
            Header: {
                x: PADDING_HORIZONTAL,
                y: PADDING_VERTICAL,
                w: w - PADDING_HORIZONTAL * 2
            },
            List: {
                x: PADDING_HORIZONTAL,
                y: containerY,
                w: w - PADDING_HORIZONTAL * 2,
                h: _sizes.SCREEN_HEIGHT[screenSize] - containerY - PADDING_VERTICAL,
                flex: {
                    direction: "column",
                    justifyContent: "center"
                }
            }
        }
    };
};


/***/ }),

/***/ 22829:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "EpgPopupEntry", ({
    enumerable: true,
    get: function() {
        return EpgPopupEntry;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(45538);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _signals = __webpack_require__(2109);
var _epgPopupEntrystyle = __webpack_require__(26331);
var EpgPopupEntry = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(EpgPopupEntry, _Lightning_Component);
    var _super = _create_super._(EpgPopupEntry);
    function EpgPopupEntry() {
        _class_call_check._(this, EpgPopupEntry);
        return _super.apply(this, arguments);
    }
    _create_class._(EpgPopupEntry, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _epgPopupEntrystyle.defaultContext;
                this._selected = false;
                this._focused = false;
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                this._date = undefined;
            }
        },
        {
            key: "date",
            get: function get() {
                return this._date;
            },
            set: function set(value) {
                this._date = value;
            }
        },
        {
            key: "title",
            set: function set(value) {
                this.tag("Title").text.text = value;
            }
        },
        {
            key: "selected",
            get: function get() {
                return this._selected;
            },
            set: function set(value) {
                this._selected = value;
                this._updateStyle();
            }
        },
        {
            key: "_focus",
            value: function _focus() {
                this._focused = true;
                this._updateStyle();
            }
        },
        {
            key: "_unfocus",
            value: function _unfocus() {
                this._focused = false;
                this._updateStyle();
            }
        },
        {
            key: "_updateStyle",
            value: function _updateStyle() {
                if (this._focused) {
                    this.patch((0, _epgPopupEntrystyle.getFocusedStyle)(this._style, this._selected));
                } else {
                    this.patch((0, _epgPopupEntrystyle.getUnFocusedStyle)(this._style, this._selected));
                }
            }
        },
        {
            key: "_handleEnter",
            value: function _handleEnter() {
                this.signal(_signals.SELECTED_SIGNAL, this.date);
                return true;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Background: {
                        rect: true,
                        shader: {
                            type: _sdk.Lightning.shaders.RoundedRectangle
                        }
                    },
                    Title: {}
                }, (0, _epgPopupEntrystyle.getInitialStyle)());
            }
        }
    ]);
    return EpgPopupEntry;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 26331:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    PADDING: function() {
        return PADDING;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getBasicFont: function() {
        return getBasicFont;
    },
    getFocusedSelectedFont: function() {
        return getFocusedSelectedFont;
    },
    getFocusedStyle: function() {
        return getFocusedStyle;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    getUnFocusedStyle: function() {
        return getUnFocusedStyle;
    }
});
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(3009);
var _theme = __webpack_require__(51397);
var _typography = __webpack_require__(18411);
var _style = __webpack_require__(65082);
var _sizes = __webpack_require__(82699);
var _colors = __webpack_require__(8426);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var colors = {
    backgroundFocused: (0, _theme.makeThemeColor)(_theme.PRIMARY, 0.3),
    backgroundSelected: (0, _theme.makeThemeColor)(_theme.PRIMARY, 0.8),
    backgroundFocusedSelected: (0, _theme.makeThemeColor)(_theme.PRIMARY, 0.9),
    text: (0, _theme.makeThemeColor)(_theme.PRIMARY),
    textSelected: (0, _theme.makeThemeColor)(_theme.TERTIARY)
};
var PADDING = 12;
var getBasicFont = function(screenSize) {
    return (0, _typography.getFont)(_typography.FONT.OTTAWA_2, screenSize);
};
var getFocusedSelectedFont = function(screenSize) {
    return (0, _typography.getFont)(_typography.FONT.OTTAWA_3, screenSize);
};
var getInitialStyle = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext, colorMode = _ref.colorMode, screenSize = _ref.screenSize;
    var font = getBasicFont(screenSize);
    var h = Math.max(font.lineHeight + PADDING * 2, 40);
    return {
        w: _sizes.identity,
        h: h,
        Background: {
            w: _sizes.identity,
            h: h,
            color: _colors.TRANSPARENT,
            shader: {
                radius: 8
            }
        },
        Title: {
            color: colors.text[colorMode],
            x: _sizes.middle,
            y: _sizes.middle,
            mount: 0.5,
            text: _object_spread_props._(_object_spread._({}, font), {
                verticalAlign: "middle",
                wordWrap: false,
                textOverflow: "..."
            })
        }
    };
};
var getUnFocusedStyle = function(param, selected) {
    var screenSize = param.screenSize, colorMode = param.colorMode;
    var font = selected ? getFocusedSelectedFont(screenSize) : getBasicFont(screenSize);
    return {
        Background: {
            smooth: {
                color: selected ? colors.backgroundSelected[colorMode] : _colors.TRANSPARENT
            }
        },
        Title: {
            smooth: {
                color: selected ? colors.textSelected[colorMode] : colors.text[colorMode]
            },
            text: _object_spread._({}, font)
        }
    };
};
var getFocusedStyle = function(param, selected) {
    var screenSize = param.screenSize, colorMode = param.colorMode;
    var font = selected ? getFocusedSelectedFont(screenSize) : getBasicFont(screenSize);
    return {
        Background: {
            smooth: {
                color: selected ? colors.backgroundFocusedSelected[colorMode] : colors.backgroundFocused[colorMode]
            }
        },
        Title: {
            smooth: {
                color: selected ? colors.textSelected[colorMode] : colors.text[colorMode]
            },
            text: _object_spread._({}, font)
        }
    };
};


/***/ }),

/***/ 7614:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "EpgPopupHeader", ({
    enumerable: true,
    get: function() {
        return EpgPopupHeader;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(45538);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _i18n = __webpack_require__(14910);
var _navigationArrowconstants = __webpack_require__(61273);
var _navigationArrowcomponent = __webpack_require__(197);
var _signals = __webpack_require__(2109);
var _epgPopupHeaderstyle = __webpack_require__(48772);
var EpgPopupHeader = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(EpgPopupHeader, _Lightning_Component);
    var _super = _create_super._(EpgPopupHeader);
    function EpgPopupHeader() {
        _class_call_check._(this, EpgPopupHeader);
        return _super.apply(this, arguments);
    }
    _create_class._(EpgPopupHeader, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _epgPopupHeaderstyle.defaultContext;
                this._titles = [
                    (0, _i18n.t)("epgGrid.lastWeek"),
                    (0, _i18n.t)("epgGrid.currentWeek"),
                    (0, _i18n.t)("epgGrid.nextWeek")
                ];
                this._index = 1;
            }
        },
        {
            key: "_build",
            value: function _build() {
                this._focused = "ArrowLeft";
                this.title = this._titles[this._index];
            }
        },
        {
            key: "title",
            set: function set(value) {
                this.tag("Title").text.text = value;
            }
        },
        {
            key: "index",
            set: function set(value) {
                if (value !== this._index) {
                    this._index = value;
                    this.title = this._titles[this._index];
                    this.tag("ArrowLeft").disabled = this._index < 1;
                    this.tag("ArrowRight").disabled = this._index > 1;
                    if (this.tag("ArrowLeft").disabled) {
                        this._focused = "ArrowRight";
                    } else if (this.tag("ArrowRight").disabled) {
                        this._focused = "ArrowLeft";
                    }
                    // transforming 0..2 into -1..1
                    this.signal(_signals.SELECTED_SIGNAL, this._index - 1);
                }
            }
        },
        {
            key: "_handleLeft",
            value: function _handleLeft() {
                if (this.tag("ArrowLeft").disabled) {
                    return true;
                }
                this._focused = "ArrowLeft";
                return true;
            }
        },
        {
            key: "_handleRight",
            value: function _handleRight() {
                if (this.tag("ArrowRight").disabled) {
                    return true;
                }
                this._focused = "ArrowRight";
                return true;
            }
        },
        {
            key: "_handleEnter",
            value: function _handleEnter() {
                if (this._focused === "ArrowLeft") {
                    this.index = Math.max(this._index - 1, 0);
                } else if (this._focused === "ArrowRight") {
                    this.index = Math.min(this._index + 1, this._titles.length - 1);
                }
                return true;
            }
        },
        {
            key: "_getFocused",
            value: function _getFocused() {
                return this.tag(this._focused);
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    ArrowLeft: {
                        type: _navigationArrowcomponent.NavigationArrow,
                        variant: _navigationArrowconstants.ARROW_LEFT
                    },
                    ArrowRight: {
                        type: _navigationArrowcomponent.NavigationArrow,
                        variant: _navigationArrowconstants.ARROW_RIGHT
                    },
                    Title: {}
                }, (0, _epgPopupHeaderstyle.getInitialStyle)());
            }
        }
    ]);
    return EpgPopupHeader;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 48772:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    GAP: function() {
        return GAP;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(65759);
var _theme = __webpack_require__(51397);
var _typography = __webpack_require__(18411);
var _style = __webpack_require__(65082);
var _sizes = __webpack_require__(82699);
var _navigationArrowstyle = __webpack_require__(8692);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var colors = {
    backdrop: (0, _theme.makeThemeColor)(_theme.TERTIARY, 0.5),
    background: (0, _theme.makeThemeColor)(_theme.TERTIARY),
    text: (0, _theme.makeThemeColor)(_theme.PRIMARY)
};
var GAP = 8;
var getInitialStyle = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext, colorMode = _ref.colorMode, screenSize = _ref.screenSize;
    var font = (0, _typography.getFont)(_typography.FONT.KINSHASA_2, screenSize);
    return {
        ArrowLeft: {},
        ArrowRight: {
            x: _sizes.identity,
            mountX: 1
        },
        Title: {
            color: colors.text[colorMode],
            x: _navigationArrowstyle.SIZE[screenSize] + GAP,
            y: Math.round((_navigationArrowstyle.SIZE[screenSize] - font.lineHeight) / 2),
            w: function(v) {
                return v - _navigationArrowstyle.SIZE[screenSize] * 2 - GAP * 2;
            },
            text: _object_spread_props._(_object_spread._({}, font), {
                textAlign: "center",
                verticalAlign: "middle",
                wordWrap: false,
                textOverflow: "..."
            })
        }
    };
};


/***/ }),

/***/ 88269:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "EpgTimeline", ({
    enumerable: true,
    get: function() {
        return EpgTimeline;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _create_super = __webpack_require__(6400);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _utils = __webpack_require__(64188);
var _pillcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34999));
var _epgTimelinestyle = __webpack_require__(3782);
var EpgTimeline = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(EpgTimeline, _Lightning_Component);
    var _super = _create_super._(EpgTimeline);
    function EpgTimeline() {
        _class_call_check._(this, EpgTimeline);
        return _super.apply(this, arguments);
    }
    _create_class._(EpgTimeline, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _epgTimelinestyle.defaultContext;
                this._maxOffset = 0;
            }
        },
        {
            key: "_build",
            value: function _build() {
                var end = 24 * 60;
                var marks = end / 15;
                var children = [];
                var textStyle = (0, _epgTimelinestyle.getTextStyle)(this._style.screenSize);
                var textY = Math.round((32 - textStyle.lineHeight) / 2);
                this._maxOffset = 0;
                for(var i = 0; i <= marks; i += 1){
                    var isHour = i % 4 === 0;
                    var h = isHour ? 32 : 16;
                    var x = i * 15 * 6;
                    children.push({
                        rect: true,
                        w: 2,
                        h: h,
                        x: x,
                        y: (32 - h) / 2
                    });
                    if (isHour) {
                        var hour = (6 + i * 15 / 60) % 24;
                        children.push({
                            x: x + 4,
                            y: textY,
                            text: _object_spread_props._(_object_spread._({}, textStyle), {
                                text: "".concat((0, _utils.withLeadingZero)(hour), ":00")
                            })
                        });
                    }
                    this._maxOffset = x;
                }
                this.tag("Marks").children = children;
            }
        },
        {
            key: "range",
            set: function set(value) {
                if (!value) {
                    return;
                }
                var start = value.start, end = value.end;
                if (!start || !end) {
                    return;
                }
                this._start = start.getTime();
                this._end = end.getTime();
            }
        },
        {
            key: "currentTime",
            set: function set(value) {
                var hour = value.getHours();
                var minute = value.getMinutes();
                var time = value.getTime();
                var offset = (time - this._start) / (this._end - this._start);
                var x = this._maxOffset * offset;
                this.tag("Current").patch({
                    visible: x > 0,
                    x: this._maxOffset * offset,
                    label: "".concat((0, _utils.withLeadingZero)(hour), ":").concat((0, _utils.withLeadingZero)(minute))
                });
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Marks: {},
                    Current: {
                        type: _pillcomponent.default
                    }
                }, (0, _epgTimelinestyle.getInitialStyle)());
            }
        }
    ]);
    return EpgTimeline;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 3782:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    HEIGHT: function() {
        return HEIGHT;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    getTextStyle: function() {
        return getTextStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(3009);
var _constants = __webpack_require__(34952);
var _typography = __webpack_require__(18411);
var _theme = __webpack_require__(51397);
var _style = __webpack_require__(65082);
var _pillstyle = __webpack_require__(24932);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var HEIGHT = (_obj = {}, _define_property._(_obj, _constants.HD, 32), _define_property._(_obj, _constants.FULL_HD, 32), _obj);
var getTextStyle = function(screenSize) {
    return _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT.BERLIN_2, screenSize)), {
        verticalAlign: "middle"
    });
};
var colors = {
    incentive: (0, _theme.makeThemeColor)(_theme.LIVE)
};
var getInitialStyle = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext, colorMode = _ref.colorMode, screenSize = _ref.screenSize;
    return {
        Current: {
            backgroundColor: colors.incentive[colorMode],
            y: Math.round((HEIGHT[screenSize] - _pillstyle.HEIGHT[screenSize]) / 2)
        }
    };
};


/***/ }),

/***/ 34999:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return Pill;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(3009);
var _sdk = __webpack_require__(29956);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _pillstyle = __webpack_require__(24932);
var Pill = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(Pill, _Lightning_Component);
    var _super = _create_super._(Pill);
    function Pill() {
        _class_call_check._(this, Pill);
        return _super.apply(this, arguments);
    }
    _create_class._(Pill, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _pillstyle.defaultContext;
            }
        },
        {
            key: "_init",
            value: function _init() {
                var _this = this;
                var label = this.tag("Label");
                var handleUpdate = function() {
                    var incentiveWidth = label.finalW + _pillstyle.INCENTIVE_PADDING[_this._style.screenSize] * 2;
                    var labelOffsetX = (incentiveWidth - label.finalW) / 2;
                    _this.patch({
                        w: incentiveWidth,
                        Label: {
                            x: labelOffsetX
                        }
                    });
                };
                label.on("txLoaded", handleUpdate);
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                this.tag("Label").removeAllListeners("txLoaded");
            }
        },
        {
            key: "label",
            set: function set(value) {
                this.tag("Label").text.text = value;
            }
        },
        {
            key: "backgroundColor",
            set: function set(value) {
                this.tag("Background").color = value;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Background: {
                        rect: true,
                        shader: {
                            type: _sdk.Lightning.shaders.RoundedRectangle
                        }
                    },
                    Label: {}
                }, (0, _pillstyle.getInitialStyle)());
            }
        }
    ]);
    return Pill;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 24932:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BORDER_RADIUS: function() {
        return BORDER_RADIUS;
    },
    HEIGHT: function() {
        return HEIGHT;
    },
    INCENTIVE_PADDING: function() {
        return INCENTIVE_PADDING;
    },
    TITLE_FONT_TYPE: function() {
        return TITLE_FONT_TYPE;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    makeBasicTextStyle: function() {
        return makeBasicTextStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(37815);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _constants = __webpack_require__(34952);
var _typography = __webpack_require__(18411);
var _theme = __webpack_require__(51397);
var _style = __webpack_require__(65082);
var _sizes = __webpack_require__(82699);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var HEIGHT = (_obj = {}, _define_property._(_obj, _constants.HD, 24), _define_property._(_obj, _constants.FULL_HD, 32), _obj);
var _obj1;
var INCENTIVE_PADDING = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 16), _define_property._(_obj1, _constants.FULL_HD, 24), _obj1);
var _obj2;
var BORDER_RADIUS = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 12), _define_property._(_obj2, _constants.FULL_HD, 16), _obj2);
var colors = {
    text: (0, _theme.makeThemeColor)(_theme.PRIMARY),
    background: (0, _theme.makeThemeColor)(_theme.QUINARY)
};
var makeBasicTextStyle = function(param) {
    var font = param.font, _param_colorMode = param.colorMode, colorMode = _param_colorMode === void 0 ? _theme.DEFAULT_MODE : _param_colorMode;
    return {
        color: colors.text[colorMode],
        text: _object_spread_props._(_object_spread._({}, font), {
            verticalAlign: "middle",
            wordWrap: false
        })
    };
};
var TITLE_FONT_TYPE = _typography.FONT_TYPE.MAIN;
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var screenSize = context.screenSize, colorMode = context.colorMode;
    var h = HEIGHT[screenSize];
    var font = (0, _typography.getFont)(_typography.FONT.BOSTON_3, screenSize, TITLE_FONT_TYPE);
    return (0, _merge.default)({
        h: h,
        Background: {
            h: h,
            color: colors.background[colorMode],
            shader: {
                radius: BORDER_RADIUS[screenSize]
            },
            w: _sizes.identity
        },
        Label: _object_spread._({
            y: Math.round((h - font.lineHeight) / 2)
        }, makeBasicTextStyle({
            font: (0, _typography.getFont)(_typography.FONT.BOSTON_3, screenSize, TITLE_FONT_TYPE),
            colorMode: colorMode
        }))
    });
};


/***/ }),

/***/ 79961:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "ProgramCard", ({
    enumerable: true,
    get: function() {
        return ProgramCard;
    }
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(52318);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _fidosdk = __webpack_require__(19804);
var _constants = __webpack_require__(34952);
var _utils = __webpack_require__(64188);
var _iconcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(70160));
var _signals = __webpack_require__(2109);
var _buttoncomponent = __webpack_require__(31464);
var _callToActioncomponent = __webpack_require__(91743);
var _callToActioncomponent1 = __webpack_require__(28518);
var _progresscomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(45926));
var _progressutils = __webpack_require__(40779);
var _programCardErrorcomponent = __webpack_require__(73385);
var _apputils = __webpack_require__(3613);
var _popupContainerconstants = __webpack_require__(54258);
var _myListCallToActionutils = __webpack_require__(50650);
var _ctaconstants = /*#__PURE__*/ _interop_require_default._(__webpack_require__(77713));
var _analyticsutils = __webpack_require__(2693);
var _textures = __webpack_require__(67179);
var _epgutils = __webpack_require__(21783);
var _programCardstyle = __webpack_require__(97570);
var _programCardconstants = __webpack_require__(35997);
var ProgramCard = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(ProgramCard, _Lightning_Component);
    var _super = _create_super._(ProgramCard);
    function ProgramCard() {
        _class_call_check._(this, ProgramCard);
        return _super.apply(this, arguments);
    }
    _create_class._(ProgramCard, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _programCardstyle.defaultContext;
            }
        },
        {
            key: "_init",
            value: function _init() {
                this._index = 0;
                this._focused = this.tag("CTAContainer").children[this._index];
            }
        },
        {
            key: "_inactive",
            value: function _inactive() {
                this.signal(_signals.INACTIVE_SIGNAL, this);
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                this._item = undefined;
                this.signal(_signals.DETACHED_SIGNAL, this);
                this._focused = undefined;
            }
        },
        {
            key: "blockId",
            get: function get() {
                return this._blockId;
            },
            set: function set(value) {
                this._blockId = value;
                this._getDataForCard(value);
            }
        },
        {
            key: "_showEpgModal",
            value: function _showEpgModal(content) {
                this.content = content;
                var screenSize = this._style.screenSize;
                var _this_content = this.content, title = _this_content.title, details = _this_content.details, extraDetails = _this_content.extraDetails, action = _this_content.action, pictos = _this_content.pictos, progressBar = _this_content.progressBar, logo = _this_content.logo, image = _this_content.image, contentAdvisory = _this_content.contentAdvisory, description = _this_content.description, secondaryActions = _this_content.secondaryActions, bookmark = _this_content.bookmark;
                // Icons
                var csaPicto = (0, _utils.getCSAPicto)(contentAdvisory.pictos);
                var servicePicto = (0, _utils.getServicePicto)(pictos);
                var isBasicIconVisible = Boolean(csaPicto);
                var serviceIconVisible = Boolean(servicePicto);
                var logoSrc = _fidosdk.imageService.getUrl(logo.id, _programCardstyle.LOGO_DIMENSIONS[screenSize].width, _programCardstyle.LOGO_DIMENSIONS[screenSize].height, {
                    fit: _constants.IMAGE_FIT_MAX,
                    quality: _constants.IMAGE_QUALITY,
                    format: _constants.TRANSPARENT_IMAGE_FORMAT
                });
                var myListItem = secondaryActions[0];
                var isPrimaryActionSupported = (0, _epgutils.isActionAllowed)(action);
                var patch = {
                    Image: {
                        src: _fidosdk.imageService.getUrl(image.id, _programCardstyle.IMAGE_DIMENSIONS[screenSize].width, _programCardstyle.IMAGE_DIMENSIONS[screenSize].height, {
                            fit: _constants.IMAGE_FIT_SCALE_CROP,
                            quality: _constants.IMAGE_QUALITY,
                            format: _constants.DEFAULT_IMAGE_FORMAT
                        })
                    },
                    Gradient: {},
                    Container: {
                        LogoWrapper: {
                            Logo: {
                                texture: _object_spread_props._(_object_spread._({}, (0, _textures.contain)(logoSrc, _programCardstyle.LOGO_DIMENSIONS[screenSize].width, _programCardstyle.LOGO_DIMENSIONS[screenSize].height)), {
                                    hasAlpha: true
                                })
                            }
                        },
                        Title: {
                            visible: Boolean(title),
                            text: {
                                text: title
                            }
                        },
                        ProgramCardError: {
                            visible: false,
                            type: _programCardErrorcomponent.ProgramCardError
                        },
                        CTAContainer: {
                            visible: Boolean(action && isPrimaryActionSupported),
                            PlayButton: {
                                visible: isPrimaryActionSupported,
                                label: action ? action.label : "",
                                picto: action ? action.picto : ""
                            },
                            MyListButton: {
                                visible: Boolean(myListItem),
                                picto: myListItem ? myListItem.picto : ""
                            }
                        },
                        DetailsContainer: {
                            Details: {
                                visible: Boolean(details),
                                text: {
                                    text: details
                                }
                            },
                            Time: {},
                            ProgressBar: _object_spread._({}, (0, _progressutils.makeProgressBarProperties)(progressBar)),
                            Description: {
                                visible: Boolean(description),
                                text: {
                                    text: description
                                }
                            },
                            ExtraDetails: {
                                visible: Boolean(extraDetails),
                                text: {
                                    text: extraDetails
                                }
                            },
                            IconRow: {
                                ServiceIcon: {
                                    visible: serviceIconVisible,
                                    iconData: {
                                        picto: servicePicto,
                                        viewBox: (0, _programCardstyle.getBasicIconViewBox)(screenSize)
                                    }
                                },
                                Picto1: {
                                    visible: isBasicIconVisible,
                                    iconData: {
                                        picto: csaPicto,
                                        viewBox: (0, _programCardstyle.getBasicIconViewBox)(screenSize)
                                    }
                                }
                            },
                            Button: {
                                visible: true,
                                label: secondaryActions[1].label
                            }
                        }
                    }
                };
                this.patch(patch);
                if (!action) {
                    this._handleNoContentState(secondaryActions);
                }
                if (!this.tag("CTAContainer").visible) {
                    this._index = undefined;
                    this._focused = this.tag("Button");
                }
                this._refocus();
                if (bookmark) {
                    bookmark.action = (0, _myListCallToActionutils.makeBookmarkAction)(bookmark.id, bookmark.state ? _ctaconstants.default.UNBOOKMARK : _ctaconstants.default.BOOKMARK);
                }
                (0, _analyticsutils.sendEvent)({
                    key: "epgModalOpen"
                });
            }
        },
        {
            key: "_getDataForCard",
            value: function _getDataForCard(id) {
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _fidosdk.layoutService.fetchEpgModal({
                                        SECTION_CODE: _programCardconstants.SECTION_CODE,
                                        id: id
                                    }).then(function(response) {
                                        return _this._showEpgModal(response.blocks[0].content.items[0].itemContent);
                                    }).catch(function(error) {
                                        return _this._handleErrorState(error);
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_handleErrorState",
            value: function _handleErrorState(error) {
                // eslint-disable-next-line no-console
                console.log("Handle error", error);
            }
        },
        {
            key: "_handleNoContentState",
            value: function _handleNoContentState(context) {
                this.patch({
                    Container: {
                        CTAContainer: {
                            visible: false
                        },
                        ProgramCardError: {
                            visible: true
                        },
                        DetailsContainer: {
                            Button: {
                                visible: true,
                                label: context[1].label
                            }
                        }
                    }
                });
            }
        },
        {
            key: "_getFocused",
            value: function _getFocused() {
                return this._focused;
            }
        },
        {
            key: "_handleRight",
            value: function _handleRight() {
                if (this._index < this.tag("CTAContainer").children.filter(function(child) {
                    return child.visible;
                }).length - 1) {
                    this._index += 1;
                    this._setIndex(this._index);
                    return true;
                }
                return false;
            }
        },
        {
            key: "_handleLeft",
            value: function _handleLeft() {
                if (this._index > 0) {
                    this._index -= 1;
                    this._setIndex(this._index);
                    return true;
                }
                return false;
            }
        },
        {
            key: "_setIndex",
            value: function _setIndex(index) {
                this._focused = this.tag("CTAContainer").children[index];
            }
        },
        {
            key: "_handleDown",
            value: function _handleDown() {
                if (this.tag("Button").visible) {
                    this._focused = this.tag("Button");
                }
                return true;
            }
        },
        {
            key: "_handleUp",
            value: function _handleUp() {
                if (this.tag("CTAContainer").visible) {
                    this._focused = this.tag("CTAContainer").children[this._index];
                }
                return true;
            }
        },
        {
            key: "_handleEnter",
            value: function _handleEnter() {
                if (this._focused === this.tag("PlayButton")) {
                    (0, _apputils.handleInteraction)(this.content, this);
                    this.signal(_popupContainerconstants.HIDE_POPUP_SIGNAL);
                } else if (this._focused === this.tag("MyListButton")) {
                    (0, _apputils.handleInteraction)(this.content.bookmark, this);
                    // eslint-disable-next-line
                    this.picto = this.content.bookmark.state ? _programCardconstants.MY_LIST_ICONS.MY_LIST_ICON_UNBOOKED : _programCardconstants.MY_LIST_ICONS.MY_LIST_ICON_BOOKED;
                    this.tag("Container.CTAContainer.MyListButton").patch({
                        picto: this.picto
                    });
                    this._modifyBookmark();
                } else if (this._focused === this.tag("Container.DetailsContainer.Button")) {
                    this.content.action = this.content.secondaryActions[1];
                    (0, _apputils.handleInteraction)(this.content, this);
                    this.signal(_popupContainerconstants.HIDE_POPUP_SIGNAL);
                }
                (0, _analyticsutils.sendEvent)({
                    key: "epgModalClose"
                });
                return true;
            }
        },
        {
            key: "_modifyBookmark",
            value: function _modifyBookmark() {
                if (this.content.bookmark) {
                    this.content.bookmark.state = !this.content.bookmark.state;
                    // eslint-disable-next-line
                    this.content.bookmark.action = (0, _myListCallToActionutils.makeBookmarkAction)(this.content.bookmark.id, this.content.bookmark.state ? _ctaconstants.default.UNBOOKMARK : _ctaconstants.default.BOOKMARK);
                }
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    passSignals: _define_property._({}, _popupContainerconstants.HIDE_POPUP_SIGNAL, true),
                    Background: {},
                    Image: {},
                    Gradient: {},
                    Container: {
                        LogoWrapper: {
                            Logo: {}
                        },
                        Title: {},
                        ProgramCardError: {
                            visible: false,
                            type: _programCardErrorcomponent.ProgramCardError
                        },
                        CTAContainer: {
                            visible: false,
                            PlayButton: {
                                type: _callToActioncomponent.CallToAction
                            },
                            MyListButton: {
                                visible: false,
                                type: _callToActioncomponent1.CallToAction
                            }
                        },
                        DetailsContainer: {
                            Details: {},
                            Time: {},
                            ProgressBar: {
                                visible: false,
                                type: _progresscomponent.default
                            },
                            Description: {},
                            ExtraDetails: {},
                            IconRow: {
                                ServiceIcon: {
                                    type: _iconcomponent.default
                                },
                                Picto1: {
                                    type: _iconcomponent.default
                                }
                            },
                            Button: {
                                visible: false,
                                type: _buttoncomponent.Button
                            }
                        }
                    }
                }, (0, _programCardstyle.getInitialStyle)());
            }
        }
    ]);
    return ProgramCard;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 35997:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    MY_LIST_ICONS: function() {
        return MY_LIST_ICONS;
    },
    SECTION_CODE: function() {
        return SECTION_CODE;
    }
});
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(42578);
var SECTION_CODE = "main";
var MY_LIST_ICONS = {
    MY_LIST_ICON_BOOKED: {
        name: "Check",
        type: " icon"
    },
    MY_LIST_ICON_UNBOOKED: {
        name: "Plus",
        type: "icon"
    }
};


/***/ }),

/***/ 97570:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BASIC_PICTO_DIMENSION: function() {
        return BASIC_PICTO_DIMENSION;
    },
    CTA_BUTTON_MARGIN_RIGHT: function() {
        return CTA_BUTTON_MARGIN_RIGHT;
    },
    CTA_GAP: function() {
        return CTA_GAP;
    },
    DESCRIPTION_MAX_LINES: function() {
        return DESCRIPTION_MAX_LINES;
    },
    GAP: function() {
        return GAP;
    },
    IMAGE_DIMENSIONS: function() {
        return IMAGE_DIMENSIONS;
    },
    ITEM_HEIGHT: function() {
        return ITEM_HEIGHT;
    },
    ITEM_WIDTH: function() {
        return ITEM_WIDTH;
    },
    LOGO_DIMENSIONS: function() {
        return LOGO_DIMENSIONS;
    },
    LOGO_PADDING: function() {
        return LOGO_PADDING;
    },
    PICTO_MARGIN_RIGHT: function() {
        return PICTO_MARGIN_RIGHT;
    },
    SCREEN_SIZE: function() {
        return SCREEN_SIZE;
    },
    SPACER_END: function() {
        return SPACER_END;
    },
    SPACER_START: function() {
        return SPACER_START;
    },
    SPACER_TOP: function() {
        return SPACER_TOP;
    },
    SPECIAL_PADDING: function() {
        return SPECIAL_PADDING;
    },
    TITLE_MAX_LINES: function() {
        return TITLE_MAX_LINES;
    },
    TWELVE_PIXELS_PADDING: function() {
        return TWELVE_PIXELS_PADDING;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getBasicIconViewBox: function() {
        return getBasicIconViewBox;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(3009);
var _memoize = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34736));
var _theme = __webpack_require__(51397);
var _typography = __webpack_require__(18411);
var _constants = __webpack_require__(34952);
var _style = __webpack_require__(65082);
var _progressstyle = __webpack_require__(67614);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var colors = {
    backgroundUnfocused: (0, _theme.makeThemeColor)(_theme.HIGHLIGHT),
    backgroundFocused: (0, _theme.makeThemeColor)(_theme.CLOUD_NORMAL),
    border: (0, _theme.makeThemeColor)(_theme.PRIMARY),
    text: (0, _theme.makeThemeColor)(_theme.PRIMARY),
    filledColor: (0, _theme.makeThemeColor)(_theme.TERTIARY),
    gradientFill: (0, _theme.makeThemeColor)(_theme.TERTIARY),
    transparent: (0, _theme.makeThemeColor)(_theme.TERTIARY, 0)
};
var _obj, _obj1;
var SCREEN_SIZE = {
    WIDTH: (_obj = {}, _define_property._(_obj, _constants.HD, 1280), _define_property._(_obj, _constants.FULL_HD, 1920), _obj),
    HEIGHT: (_obj1 = {}, _define_property._(_obj1, _constants.HD, 720), _define_property._(_obj1, _constants.FULL_HD, 1080), _obj1)
};
var _obj2;
var ITEM_WIDTH = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 616), _define_property._(_obj2, _constants.FULL_HD, 680), _obj2);
var _obj3;
var IMAGE_DIMENSIONS = (_obj3 = {}, _define_property._(_obj3, _constants.HD, {
    width: 616,
    height: 346
}), _define_property._(_obj3, _constants.FULL_HD, {
    width: 680,
    height: 382
}), _obj3);
var _obj4;
var ITEM_HEIGHT = (_obj4 = {}, _define_property._(_obj4, _constants.HD, 720), _define_property._(_obj4, _constants.FULL_HD, 1080), _obj4);
var _obj5;
var GAP = (_obj5 = {}, _define_property._(_obj5, _constants.HD, 32), _define_property._(_obj5, _constants.FULL_HD, 32), _obj5);
var _obj6;
var SPACER_TOP = (_obj6 = {}, _define_property._(_obj6, _constants.HD, 18), _define_property._(_obj6, _constants.FULL_HD, 32), _obj6);
var _obj7;
var CTA_GAP = (_obj7 = {}, _define_property._(_obj7, _constants.HD, 9), _define_property._(_obj7, _constants.FULL_HD, 16), _obj7);
var _obj8;
var PICTO_MARGIN_RIGHT = (_obj8 = {}, _define_property._(_obj8, _constants.HD, 9), _define_property._(_obj8, _constants.FULL_HD, 16), _obj8);
var _obj9;
var CTA_BUTTON_MARGIN_RIGHT = (_obj9 = {}, _define_property._(_obj9, _constants.HD, 24), _define_property._(_obj9, _constants.FULL_HD, 32), _obj9);
var _obj10;
var LOGO_DIMENSIONS = (_obj10 = {}, _define_property._(_obj10, _constants.HD, {
    width: 152,
    height: 86
}), _define_property._(_obj10, _constants.FULL_HD, {
    width: 248,
    height: 140
}), _obj10);
var _obj11;
var LOGO_PADDING = (_obj11 = {}, _define_property._(_obj11, _constants.HD, 260), _define_property._(_obj11, _constants.FULL_HD, 242), _obj11);
var _obj12;
var TWELVE_PIXELS_PADDING = (_obj12 = {}, _define_property._(_obj12, _constants.HD, 7), _define_property._(_obj12, _constants.FULL_HD, 12), _obj12);
var SPECIAL_PADDING = 168;
var BASIC_PICTO_DIMENSION = 24;
var _obj13;
var DESCRIPTION_MAX_LINES = (_obj13 = {}, _define_property._(_obj13, _constants.HD, 2), _define_property._(_obj13, _constants.FULL_HD, 5), _obj13);
var _obj14;
var TITLE_MAX_LINES = (_obj14 = {}, _define_property._(_obj14, _constants.HD, 1), _define_property._(_obj14, _constants.FULL_HD, 2), _obj14);
var _obj15;
var SPACER_START = (_obj15 = {}, _define_property._(_obj15, _constants.HD, 64), _define_property._(_obj15, _constants.FULL_HD, 96), _obj15);
var _obj16;
var SPACER_END = (_obj16 = {}, _define_property._(_obj16, _constants.HD, 64), _define_property._(_obj16, _constants.FULL_HD, 96), _obj16);
var getInitialStyle = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext, screenSize = _ref.screenSize, colorMode = _ref.colorMode;
    return {
        x: SCREEN_SIZE.WIDTH[screenSize] - ITEM_WIDTH[screenSize],
        Background: {
            rect: true,
            color: colors.filledColor[colorMode],
            w: ITEM_WIDTH[screenSize],
            h: ITEM_HEIGHT[screenSize]
        },
        Image: {
            w: IMAGE_DIMENSIONS[screenSize].width,
            h: IMAGE_DIMENSIONS[screenSize].height
        },
        Gradient: {
            rect: true,
            colorUl: colors.transparent[colorMode],
            colorUr: colors.transparent[colorMode],
            colorBr: colors.gradientFill[colorMode],
            colorBl: colors.gradientFill[colorMode],
            w: IMAGE_DIMENSIONS[screenSize].width,
            h: IMAGE_DIMENSIONS[screenSize].height
        },
        Container: {
            x: SPACER_START[screenSize],
            flex: {
                direction: "column"
            },
            LogoWrapper: {
                w: LOGO_DIMENSIONS[screenSize].width,
                h: LOGO_DIMENSIONS[screenSize].height,
                flexItem: {
                    marginTop: LOGO_PADDING[screenSize]
                },
                Logo: {}
            },
            Title: {
                color: colors.text[colorMode],
                flexItem: {
                    marginTop: SPACER_TOP[screenSize]
                },
                text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT.PARIS_3, screenSize)), {
                    verticalAlign: "middle",
                    wordWrapWidth: ITEM_WIDTH[screenSize] - SPACER_START[screenSize] - SPACER_END[screenSize],
                    maxLines: TITLE_MAX_LINES[screenSize],
                    textOverflow: "..."
                })
            },
            ProgramCardError: {
                flexItem: {
                    marginTop: SPACER_TOP[screenSize]
                },
                w: ITEM_WIDTH[screenSize] - SPACER_START[screenSize] - SPACER_END[screenSize]
            },
            CTAContainer: {
                w: ITEM_WIDTH[screenSize] - SPACER_START[screenSize],
                flexItem: {
                    marginTop: SPACER_TOP[screenSize]
                },
                flex: {
                    direction: "row"
                },
                PlayButton: {
                    flexItem: {
                        marginRight: CTA_BUTTON_MARGIN_RIGHT[screenSize]
                    }
                },
                MyListButton: {
                    flexItem: {
                        marginRight: CTA_BUTTON_MARGIN_RIGHT[screenSize]
                    }
                }
            },
            DetailsContainer: {
                flexItem: {
                    marginTop: SPACER_TOP[screenSize]
                },
                flex: {
                    direction: "column"
                },
                w: ITEM_WIDTH[screenSize] - SPACER_START[screenSize] - SPACER_END[screenSize],
                Details: {
                    color: colors.text[colorMode],
                    w: ITEM_WIDTH[screenSize] - SPACER_START[screenSize] - SPACER_END[screenSize],
                    text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT.OTTAWA_3, screenSize)), {
                        verticalAlign: "middle",
                        wordWrapWidth: ITEM_WIDTH[screenSize] - SPACER_START[screenSize] - SPACER_END[screenSize],
                        wordWrap: false,
                        textOverflow: "..."
                    })
                },
                Time: {
                    color: colors.text[colorMode],
                    flexItem: {
                        marginTop: CTA_GAP[screenSize]
                    },
                    text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT.OTTAWA_3, screenSize)), {
                        verticalAlign: "middle",
                        wordWrap: false,
                        textOverflow: "..."
                    })
                },
                ProgressBar: {
                    color: colors.backgroundUnfocused[colorMode],
                    w: ITEM_WIDTH[screenSize] - SPACER_START[screenSize] - SPACER_END[screenSize],
                    h: _progressstyle.HEIGHT,
                    flexItem: {
                        marginTop: CTA_GAP[screenSize]
                    }
                },
                Description: {
                    color: colors.text[colorMode],
                    w: ITEM_WIDTH[screenSize] - SPACER_START[screenSize] - SPACER_END[screenSize],
                    text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT.OTTAWA_1, screenSize)), {
                        verticalAlign: "middle",
                        maxLines: DESCRIPTION_MAX_LINES[screenSize],
                        textOverflow: "..."
                    })
                },
                ExtraDetails: {
                    color: colors.text[colorMode],
                    flexItem: {
                        marginTop: TWELVE_PIXELS_PADDING[screenSize]
                    },
                    w: ITEM_WIDTH[screenSize] - SPACER_START[screenSize] - SPACER_END[screenSize],
                    text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT.BERLIN_2, screenSize)), {
                        verticalAlign: "middle",
                        maxLines: 3,
                        textOverflow: "..."
                    })
                },
                IconRow: {
                    flex: {
                        direction: "row"
                    },
                    ServiceIcon: {
                        flexItem: {
                            marginTop: TWELVE_PIXELS_PADDING[screenSize],
                            marginRight: PICTO_MARGIN_RIGHT[screenSize]
                        }
                    },
                    Picto1: {
                        flexItem: {
                            marginTop: TWELVE_PIXELS_PADDING[screenSize],
                            marginRight: PICTO_MARGIN_RIGHT[screenSize]
                        }
                    }
                },
                Button: {
                    flexItem: {
                        marginTop: TWELVE_PIXELS_PADDING[screenSize]
                    }
                }
            }
        }
    };
};
var getBasicIconViewBox = (0, _memoize.default)(function() {
    return {
        h: BASIC_PICTO_DIMENSION
    };
});


/***/ }),

/***/ 73385:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ERROR_ICON: function() {
        return ERROR_ICON;
    },
    ICON_SIZE: function() {
        return ICON_SIZE;
    },
    ProgramCardError: function() {
        return ProgramCardError;
    },
    getIconViewBox: function() {
        return getIconViewBox;
    },
    screenSize: function() {
        return screenSize;
    }
});
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _create_super = __webpack_require__(6400);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(45538);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _memoize = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34736));
var _sdk = __webpack_require__(29956);
var _typography = __webpack_require__(18411);
var _constants = __webpack_require__(34952);
var _i18n = __webpack_require__(14910);
var _iconcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(70160));
var screenSize = "FULL_HD";
var _obj, _obj1;
var ICON_SIZE = {
    WIDTH: (_obj = {}, _define_property._(_obj, _constants.HD, 24), _define_property._(_obj, _constants.FULL_HD, 32), _obj),
    HEIGHT: (_obj1 = {}, _define_property._(_obj1, _constants.HD, 24), _define_property._(_obj1, _constants.FULL_HD, 32), _obj1)
};
var ERROR_ICON = {
    name: "ErrorEmoji",
    type: "icon"
};
var getIconViewBox = (0, _memoize.default)(function(screenSize) {
    return {
        w: ICON_SIZE.WIDTH[screenSize],
        h: ICON_SIZE.HEIGHT[screenSize]
    };
});
var ProgramCardError = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(ProgramCardError, _Lightning_Component);
    var _super = _create_super._(ProgramCardError);
    function ProgramCardError() {
        _class_call_check._(this, ProgramCardError);
        return _super.apply(this, arguments);
    }
    _create_class._(ProgramCardError, null, [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    flex: {
                        direction: "row",
                        justifyContent: "center"
                    },
                    Icon: {
                        flexItem: {
                            marginRight: 12
                        },
                        type: _iconcomponent.default,
                        iconData: {
                            picto: ERROR_ICON,
                            viewBox: getIconViewBox(screenSize)
                        }
                    },
                    Title: {
                        flexItem: {
                            marginTop: 6,
                            marginRight: 12
                        },
                        text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT.OTTAWA_3, screenSize)), {
                            text: (0, _i18n.t)("programCard.noContent")
                        })
                    }
                });
            }
        }
    ]);
    return ProgramCardError;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 36997:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return Grid;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _inherits = __webpack_require__(71648);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _create_super = __webpack_require__(6400);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(45538);
var _sdk = __webpack_require__(29956);
var _constants = __webpack_require__(34952);
var _buttoncomponent = __webpack_require__(31464);
var _theme = __webpack_require__(74314);
var _signals = __webpack_require__(2109);
var _i18n = __webpack_require__(14910);
var _virtualization = __webpack_require__(11559);
var _sizes = __webpack_require__(82699);
var _block = __webpack_require__(3777);
var _gridstyle = __webpack_require__(10402);
var _gridconstants = __webpack_require__(78930);
var Grid = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(Grid, _Lightning_Component);
    var _super = _create_super._(Grid);
    function Grid() {
        _class_call_check._(this, Grid);
        return _super.apply(this, arguments);
    }
    _create_class._(Grid, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _gridstyle.defaultContext;
                this._viewport = {
                    w: _sizes.SCREEN_WIDTH[this._style.screenSize],
                    h: _sizes.SCREEN_HEIGHT[this._style.screenSize]
                };
                this._contentGap = _gridstyle.CONTENT_GAP[this._style.screenSize];
                this._isRowActive = false;
                this._isRowAttached = false;
                this._resetVirtualization();
            }
        },
        {
            key: "_active",
            value: function _active() {
                var _this = this;
                this._isRowActive = true;
                if (this._data) {
                    if (this._isDataApplied) {
                        this._placeItems();
                    } else {
                        // NOTE: an ugly hack allowing quick vertical scroll
                        this._timeout = setTimeout(function() {
                            _this.data = _this._data;
                        }, _gridconstants.ITEMS_PLACEMENT_TIMEOUT);
                    }
                }
            }
        },
        {
            key: "_build",
            value: function _build() {
                this.patch((0, _gridstyle.getInitialStyle)(this._style));
            }
        },
        {
            key: "_attach",
            value: function _attach() {
                this._isGridAttached = true;
            }
        },
        {
            key: "_inactive",
            value: function _inactive() {
                this._isGridActive = false;
                clearTimeout(this._timeout);
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                this._isGridAttached = false;
                this._resetVirtualization();
            }
        },
        {
            key: "contentGap",
            get: function get() {
                return this._contentGap;
            },
            set: function set(value) {
                this._contentGap = value;
                this._placeItems();
            }
        },
        {
            key: "contentPadding",
            get: function get() {
                return this.tag("Content").x;
            },
            set: function set(value) {
                this.tag("Content").x = value;
            }
        },
        {
            key: "itemsPerRow",
            get: function get() {
                if (this._itemsPerRow) {
                    return this._itemsPerRow;
                }
                var _this__data = this._data, itemsPerRow = _this__data.itemsPerRow, itemTemplate = _this__data.itemTemplate;
                var screenSize = this._style.screenSize;
                this._itemsPerRow = itemsPerRow || _gridconstants.ITEMS_PER_ROW[itemTemplate][screenSize];
                return this._itemsPerRow;
            }
        },
        {
            key: "data",
            get: function get() {
                return this._data;
            },
            set: function set(value) {
                var _this = this;
                if (!value) {
                    return;
                }
                this._data = value;
                if (!this._isRowActive) {
                    return;
                }
                var isUpdating = this._isDataApplied;
                this._isDataApplied = true;
                this._blockIndex = value.blockIndex;
                var block = value.block, blockIndex = value.blockIndex, itemSize = value.itemSize, itemTemplate = value.itemTemplate, theme = value.theme, rowSize = value.rowSize, showAllItems = value.showAllItems, displayShowMore = value.displayShowMore;
                var _block_content = block.content, items = _block_content.items, pagination = _block_content.pagination;
                var blockTheme = (0, _theme.getLayoutTheme)(block.theme, theme);
                var totalItems = pagination.totalItems, itemsPerPage = pagination.itemsPerPage;
                var colorScheme = blockTheme.colorScheme;
                this._id = block.id;
                this._itemSize = itemSize;
                this._style = _object_spread_props._(_object_spread._({}, this._style), {
                    colorMode: blockTheme.colorScheme
                });
                this._items = (showAllItems || !displayShowMore ? items : items.slice(0, _gridconstants.MAX_PREVIEW_ITEMS)).map(function(item, index) {
                    var existingItem = _this._items[index];
                    // NOTE: It's faster than creation of a new object
                    if (existingItem) {
                        existingItem.content = item;
                        existingItem.config = itemSize;
                        existingItem.template = itemTemplate;
                        existingItem.colorScheme = _this._colorScheme;
                        return existingItem;
                    }
                    return _this._makeItemData(item, index);
                });
                this._pages = block.pages;
                // Pagination is disable when a Grid id displayed within a regular layout
                this._totalItems = showAllItems ? totalItems : this._items.length;
                this._itemsPerPage = showAllItems ? itemsPerPage : 0;
                var titleText = (0, _block.getTitle)(block.title);
                var hasTitle = Boolean(titleText);
                var blockStyle = (0, _gridstyle.getBlockStyle)({
                    hasTitle: hasTitle,
                    isFirstBlock: blockIndex === 0,
                    screenSize: this._style.screenSize
                });
                var displayShowMoreButton = displayShowMore && !showAllItems && items.length > _gridconstants.MAX_PREVIEW_ITEMS;
                this.patch({
                    Content: {
                        Title: _object_spread._({
                            visible: hasTitle,
                            color: _gridstyle.colors.title[colorScheme],
                            text: {
                                text: titleText
                            }
                        }, blockStyle.title),
                        Container: _object_spread._({}, blockStyle.items)
                    },
                    More: {
                        visible: displayShowMoreButton,
                        y: rowSize.h - _gridstyle.PADDING.BOTTOM[this._style.screenSize]
                    }
                });
                // Placing the Show More button properly
                // const showMoreButton = this.tag('More');
                this._setIndex(Math.min(this._focusedItemIndex, Math.max(this._totalItems - (displayShowMoreButton ? 0 : 1), 0)));
                // Remove extra items in case of a row data update
                if (isUpdating) {
                    var views = Object.keys(this._views);
                    if (views.length > this._totalItems) {
                        for(var i = 0; i < views.length; i += 1){
                            var viewIndex = views[i];
                            if (viewIndex >= this._totalItems) {
                                this._backToBuffer(this._views[viewIndex]);
                            }
                        }
                    }
                }
                this._refocus();
            }
        },
        {
            key: "_makeItemData",
            value: function _makeItemData(content, index) {
                var _this__data = this._data, itemSize = _this__data.itemSize, itemTemplate = _this__data.itemTemplate;
                return {
                    content: content,
                    index: index,
                    config: itemSize,
                    template: itemTemplate,
                    colorScheme: this._colorScheme
                };
            }
        },
        {
            key: "focusedIndex",
            get: function get() {
                return this._focusedItemIndex;
            },
            set: function set(value) {
                if (this._totalItems) {
                    this._focusedItemIndex = Math.min(this.maxIndex, Math.max(value, 0));
                } else {
                    this._focusedItemIndex = value;
                }
            }
        },
        {
            key: "maxIndex",
            get: function get() {
                if (!Number.isFinite(this._totalItems)) {
                    return 0;
                }
                return this._totalItems - (this.tag("More").visible ? 0 : 1);
            }
        },
        {
            key: "goTo",
            value: function goTo(index) {
                this._setIndex(index);
            }
        },
        {
            key: "_setIndex",
            value: function _setIndex(index) {
                this._focusedItemIndex = index;
                if (!this._totalItems) {
                    return;
                }
                if (this._isRowActive) {
                    this._placeItems();
                }
                this.signal(_signals.FOCUSED_SIGNAL, index);
                if (this._itemsPerPage > 0) {
                    var rowHeight = this._data.itemSize.h + this._contentGap;
                    var visibleRows = Math.ceil(this._viewport.h / rowHeight) + 1;
                    var bufferSize = visibleRows * this.itemsPerRow;
                    var nextPage = Math.floor(Math.min(this._focusedItemIndex + bufferSize, this._totalItems - 1) / this._itemsPerPage);
                    // NOTE: use only strict equality here to ensure redundant page requests will not be created
                    for(var i = nextPage; i > 0; i -= 1){
                        var isLoaded = this._pages[i] !== _virtualization.PAGE_STATE.MISSING;
                        if (isLoaded) {
                            continue;
                        }
                        var start = i * this._itemsPerPage;
                        this.signal(_signals.PORTION_REQUESTED_SIGNAL, {
                            id: this._id,
                            // NOTE: pages are 1-based
                            page: i + 1,
                            start: start
                        });
                    }
                }
            }
        },
        {
            key: "_getFromBufferOrCreate",
            value: function _getFromBufferOrCreate() {
                var _this__data = this._data, itemType = _this__data.itemType, itemSize = _this__data.itemSize, itemTemplate = _this__data.itemTemplate;
                var existingView = (0, _virtualization.getFromBuffer)(itemTemplate);
                if (existingView) {
                    return existingView;
                }
                var _obj;
                return this.stage.c({
                    type: itemType,
                    w: itemSize.w,
                    h: itemSize.h,
                    template: itemTemplate,
                    passSignals: _define_property._({}, _signals.SELECTED_SIGNAL, true),
                    signals: (_obj = {}, _define_property._(_obj, _signals.INACTIVE_SIGNAL, "_onViewBecomeInactive"), _define_property._(_obj, _signals.DETACHED_SIGNAL, "_onViewBecomeDetached"), _obj)
                });
            }
        },
        {
            key: "_onViewBecomeInactive",
            value: function _onViewBecomeInactive(view) {
                if (this._isRowAttached) {
                    this._backToBuffer(view);
                }
            }
        },
        {
            key: "_onViewBecomeDetached",
            value: function _onViewBecomeDetached(view) {
                (0, _virtualization.cleanupBuffer)(view);
            }
        },
        {
            key: "_backToBuffer",
            value: function _backToBuffer(view) {
                var _this = this;
                Object.keys(this._views).filter(function(key) {
                    return _this._views[key].id === view.id;
                }).forEach(function(key) {
                    delete _this._views[key];
                });
                (0, _virtualization.backToBuffer)(view);
                view.visible = false;
            }
        },
        {
            key: "_calculateItemPosition",
            value: function _calculateItemPosition(itemSize, index) {
                return {
                    x: (itemSize.w + this._contentGap) * (index % this.itemsPerRow),
                    y: (itemSize.h + this._contentGap) * Math.floor(index / this.itemsPerRow)
                };
            }
        },
        {
            key: "_makeItemRenderer",
            value: function _makeItemRenderer(item, index) {
                var _this__data = this._data, itemSize = _this__data.itemSize, itemType = _this__data.itemType;
                return _object_spread_props._(_object_spread._({
                    type: itemType,
                    w: itemSize.w,
                    h: itemSize.h
                }, this._calculateItemPosition(itemSize, index)), {
                    item: item,
                    passSignals: _define_property._({}, _signals.SELECTED_SIGNAL, true)
                });
            }
        },
        {
            key: "_placeItems",
            value: function _placeItems() {
                if (!this._data) {
                    return;
                }
                var container = this.tag("Container");
                var rowHeight = this._data.itemSize.h + this._contentGap;
                var visibleRows = Math.ceil(this._viewport.h / rowHeight) + 1;
                var bufferSize = visibleRows * this.itemsPerRow;
                var toRender = [];
                var startIndex = Math.max(this._focusedItemIndex - bufferSize, 0);
                var endIndex = Math.min(this._focusedItemIndex + bufferSize, this._totalItems - 1);
                for(var i = startIndex; i <= endIndex; i += 1){
                    toRender.push(i);
                }
                var tracked = [];
                for(var i1 = 0; i1 < toRender.length; i1 += 1){
                    var index = toRender[i1];
                    var view = this._views[index];
                    if (!view) {
                        view = this._getFromBufferOrCreate();
                    }
                    var row = Math.floor(index / this.itemsPerRow);
                    var column = index % this.itemsPerRow;
                    view.index = index;
                    if (this._items[index]) {
                        view.item = this._items[index];
                        tracked.push(index);
                    } else {
                        view.item = this._makeItemData(_virtualization.PLACEHOLDER, index);
                    }
                    view.x = column * (this._data.itemSize.w + this._contentGap);
                    view.y = row * (this._data.itemSize.h + this._contentGap);
                    view.visible = true;
                    if (view.parent !== container) {
                        container.childList.add(view);
                    }
                    this._views[index] = view;
                }
                if (tracked.length) {
                    this.signal(_signals.IMPRESSION_TRACK_SIGNAL, this._blockIndex, tracked);
                }
            }
        },
        {
            key: "_handleUp",
            value: function _handleUp() {
                if (this._focusedItemIndex === this._totalItems) {
                    this._setIndex(Number.isFinite(this._lastGridIndex) ? this._lastGridIndex : this._totalItems - 1);
                    this._lastGridIndex = undefined;
                    return true;
                }
                if (this._focusedItemIndex >= this.itemsPerRow) {
                    this._setIndex(this._focusedItemIndex - this.itemsPerRow);
                    return false;
                }
                return false;
            }
        },
        {
            key: "_handleDown",
            value: function _handleDown() {
                var index = this._focusedItemIndex + this.itemsPerRow;
                if (index <= this._totalItems - 1) {
                    this._setIndex(index, true);
                } else {
                    var rowCount = Math.ceil(this._totalItems / this.itemsPerRow);
                    var currentRow = Math.floor(this._focusedItemIndex / this.itemsPerRow);
                    if (currentRow < rowCount - 1) {
                        this._setIndex(this._totalItems - 1, true);
                    } else if (this._focusedItemIndex < this._totalItems && this.tag("More").visible) {
                        this._lastGridIndex = this._focusedItemIndex;
                        this._focusedItemIndex = this._totalItems;
                        return true;
                    }
                }
                return false;
            }
        },
        {
            key: "_handleLeft",
            value: function _handleLeft() {
                if (this._focusedItemIndex % this.itemsPerRow === 0) {
                    return false;
                }
                if (this._focusedItemIndex > 0) {
                    this._setIndex(this._focusedItemIndex - 1);
                    return true;
                }
                return false;
            }
        },
        {
            key: "_handleRight",
            value: function _handleRight() {
                if (this._focusedItemIndex % this.itemsPerRow === this.itemsPerRow - 1) {
                    return false;
                }
                if (this._focusedItemIndex < this.tag("Container").children.length - 1) {
                    this._setIndex(this._focusedItemIndex + 1);
                    return true;
                }
                return false;
            }
        },
        {
            key: "_handleEnter",
            value: function _handleEnter() {
                if (this._focusedItemIndex === this._totalItems) {
                    this.signal(_signals.SHOW_GRID_SIGNAL, this._data);
                    return true;
                }
                this.signal(_signals.SELECTED_SIGNAL, this._items[this._focusedItemIndex]);
                return true;
            }
        },
        {
            key: "_focus",
            value: function _focus() {
                this._placeItems();
            }
        },
        {
            key: "_getFocused",
            value: function _getFocused() {
                if (this._focusedItemIndex >= this._totalItems) {
                    return this._tag("More");
                }
                return this._views[this._focusedItemIndex];
            }
        },
        {
            key: "_resetVirtualization",
            value: function _resetVirtualization() {
                this._data = undefined;
                this._isDataApplied = false;
                this._focusedItemIndex = 0;
                this._offset = 0;
                this._itemsPerPage = 0;
                this._startPoint = 0;
                // Indicates an item index in the bottom row in case there is a Show More button
                this._lastGridIndex = undefined;
                this._items = [];
                this._views = {};
                this._pages = {};
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return {
                    Content: {
                        Title: {},
                        Container: {}
                    },
                    More: {
                        type: _buttoncomponent.Button,
                        label: (0, _i18n.t)("global.showMore"),
                        x: function(v) {
                            return v / 2;
                        }
                    }
                };
            }
        },
        {
            key: "getOffsetsByBlockData",
            value: function getOffsetsByBlockData(param) {
                var data = param.data, blockIndex = param.blockIndex, _param_screenSize = param.screenSize, screenSize = _param_screenSize === void 0 ? _constants.FULL_HD : _param_screenSize, showAllItems = param.showAllItems, displayShowMore = param.displayShowMore;
                var title = data.title, content = data.content;
                var hasTitle = Boolean((0, _block.getTitle)(title));
                var _getBlockStyle = (0, _gridstyle.getBlockStyle)({
                    hasTitle: hasTitle,
                    isFirstBlock: blockIndex === 0,
                    screenSize: screenSize
                }), items = _getBlockStyle.items, bottom = _getBlockStyle.padding.bottom;
                return {
                    top: items.y,
                    bottom: bottom + (!showAllItems && displayShowMore && content.items.length > _gridconstants.MAX_PREVIEW_ITEMS ? _gridstyle.BUTTON_HEIGHT[screenSize] + _gridstyle.PADDING.BOTTOM[screenSize] : 0)
                };
            }
        },
        {
            key: "getRowCount",
            value: function getRowCount(param, screenSize) {
                var content = param.content, showAllItems = param.showAllItems, displayShowMore = param.displayShowMore;
                var contentTemplateId = content.contentTemplateId, items = content.items, pagination = content.pagination;
                var slicedCount = displayShowMore ? Math.min(_gridconstants.MAX_PREVIEW_ITEMS, items.length) : items.length;
                var count = showAllItems ? pagination.totalItems : slicedCount;
                return Math.ceil(count / _gridconstants.ITEMS_PER_ROW[contentTemplateId][screenSize]);
            }
        },
        {
            key: "getContentGap",
            value: function getContentGap(screenSize) {
                return _gridstyle.CONTENT_GAP[screenSize];
            }
        }
    ]);
    return Grid;
}(_sdk.Lightning.Component);
Grid.Templates = _gridconstants.templates;


/***/ }),

/***/ 78930:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ITEMS_PER_ROW: function() {
        return ITEMS_PER_ROW;
    },
    ITEMS_PLACEMENT_TIMEOUT: function() {
        return ITEMS_PLACEMENT_TIMEOUT;
    },
    MAX_PREVIEW_ITEMS: function() {
        return MAX_PREVIEW_ITEMS;
    },
    templates: function() {
        return templates;
    }
});
var _define_property = __webpack_require__(21228);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(88801);
var _posterconstants = __webpack_require__(99246);
var _portraitconstants = __webpack_require__(45338);
var _jacketconstants = __webpack_require__(29946);
var _cardconstants = __webpack_require__(20910);
var _totemconstants = __webpack_require__(85110);
var _horizontalCardconstants = __webpack_require__(75827);
var _horizontalSquareconstants = __webpack_require__(13448);
var _flatRectangleconstants = __webpack_require__(29687);
var _squareconstants = __webpack_require__(37049);
var _squareMetaconstants = __webpack_require__(15634);
var _bigSquareconstants = __webpack_require__(83278);
var templates = {
    Grid: "Grid"
};
var MAX_PREVIEW_ITEMS = 4;
var ITEMS_PLACEMENT_TIMEOUT = 100;
var _obj;
var ITEMS_PER_ROW = (_obj = {}, _define_property._(_obj, _cardconstants.templates.CardS, _cardconstants.ITEMS_BY_BREAKPOINTS[_cardconstants.templates.CardS]), _define_property._(_obj, _cardconstants.templates.CardM, _cardconstants.ITEMS_BY_BREAKPOINTS[_cardconstants.templates.CardM]), _define_property._(_obj, _cardconstants.templates.CardL, _cardconstants.ITEMS_BY_BREAKPOINTS[_cardconstants.templates.CardL]), _define_property._(_obj, _horizontalCardconstants.templates.HorizontalCard, _horizontalCardconstants.ITEMS_BY_BREAKPOINTS), _define_property._(_obj, _horizontalSquareconstants.templates.HorizontalSquare, _horizontalSquareconstants.ITEMS_BY_BREAKPOINTS), _define_property._(_obj, _jacketconstants.templates.Jacket, _jacketconstants.ITEMS_BY_BREAKPOINTS), _define_property._(_obj, _posterconstants.templates.PosterS, _posterconstants.ITEMS_BY_BREAKPOINTS[_posterconstants.templates.PosterS]), _define_property._(_obj, _posterconstants.templates.PosterM, _posterconstants.ITEMS_BY_BREAKPOINTS[_posterconstants.templates.PosterM]), _define_property._(_obj, _posterconstants.templates.PosterL, _posterconstants.ITEMS_BY_BREAKPOINTS[_posterconstants.templates.PosterL]), _define_property._(_obj, _portraitconstants.templates.Portrait, _portraitconstants.ITEMS_BY_BREAKPOINTS), _define_property._(_obj, _totemconstants.templates.Totem, _totemconstants.ITEMS_BY_BREAKPOINTS), _define_property._(_obj, _flatRectangleconstants.templates.FlatRectangle, _flatRectangleconstants.ITEMS_BY_BREAKPOINTS), _define_property._(_obj, _squareconstants.templates.Square, _squareconstants.ITEMS_BY_BREAKPOINTS), _define_property._(_obj, _squareMetaconstants.templates.SquareMeta, _squareMetaconstants.ITEMS_BY_BREAKPOINTS), _define_property._(_obj, _bigSquareconstants.templates.BigSquare, _bigSquareconstants.ITEMS_BY_BREAKPOINTS), _obj);


/***/ }),

/***/ 10402:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BUTTON_HEIGHT: function() {
        return _buttonstyle.HEIGHT;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getBlockStyle: function() {
        return getBlockStyle;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    getTitleStyle: function() {
        return getTitleStyle;
    }
});
var _export_star = __webpack_require__(37668);
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
var _memoize = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34736));
var _theme = __webpack_require__(51397);
var _typography = __webpack_require__(18411);
var _style = __webpack_require__(65082);
var _colors = __webpack_require__(8426);
var _sizes = __webpack_require__(82699);
var _buttonstyle = __webpack_require__(3211);
var _blockconstants = _export_star._(__webpack_require__(48954), exports);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var colors = {
    title: (0, _theme.makeThemeColor)(_theme.PRIMARY)
};
var getTitleStyle = (0, _memoize.default)(function(param) {
    var screenSize = param.screenSize, colorMode = param.colorMode;
    return {
        y: _blockconstants.TITLE_PADDING.TOP[screenSize],
        color: colors.title[colorMode],
        text: (0, _typography.getFont)(_typography.FONT.KINSHASA_3, screenSize)
    };
});
var getBlockStyle = (0, _memoize.default)(function(context) {
    var hasTitle = context.hasTitle, isFirstBlock = context.isFirstBlock, screenSize = context.screenSize;
    var padding = {
        top: _blockconstants.PADDING.TOP[screenSize],
        bottom: _blockconstants.PADDING.BOTTOM[screenSize],
        left: _blockconstants.PADDING.LEFT[screenSize]
    };
    var firstBlockPadding = _blockconstants.FIRST_BLOCK_PADDING[screenSize];
    var titleStyle = getTitleStyle(context);
    var items = {
        y: padding.top
    };
    var title = {
        y: titleStyle.y
    };
    if (hasTitle) {
        items.y = titleStyle.text.lineHeight + _blockconstants.TITLE_PADDING.BOTTOM[screenSize];
        if (isFirstBlock) {
            items.y += firstBlockPadding;
            title.y = firstBlockPadding;
        } else {
            items.y += titleStyle.y;
        }
    } else if (isFirstBlock) {
        items.y = firstBlockPadding;
    }
    return {
        title: title,
        items: items,
        padding: padding
    };
});
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    return {
        color: _colors.TRANSPARENT,
        Background: {
            w: _sizes.identity,
            h: _sizes.identity
        },
        Content: {
            Title: getTitleStyle(context)
        },
        More: {
            visible: false,
            mountY: 1
        }
    };
};


/***/ }),

/***/ 18356:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    blockFallback: function() {
        return blockFallback;
    },
    blockTemplates: function() {
        return blockTemplates;
    },
    getBlockTemplateById: function() {
        return getBlockTemplateById;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(3009);
var _listcomponent = __webpack_require__(22093);
var _bellycomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(31520));
var _solocomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(96686));
var _slideShowcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(28844));
var _gridcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(36997));
var _epgcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(40696));
var blockFallback = _listcomponent.List.Templates.List;
var _obj;
var blockTemplates = (_obj = {}, _define_property._(_obj, _listcomponent.List.Templates.List, _listcomponent.List), _define_property._(_obj, _bellycomponent.default.Templates.Belly, _bellycomponent.default), _define_property._(_obj, _solocomponent.default.Templates.Solo, _solocomponent.default), _define_property._(_obj, _slideShowcomponent.default.Templates.SlideShow, _slideShowcomponent.default), _define_property._(_obj, _gridcomponent.default.Templates.Grid, _gridcomponent.default), _define_property._(_obj, _epgcomponent.default.Templates.HorizontalEpg, _epgcomponent.default), _obj);
var getBlockTemplateById = function(id) {
    return blockTemplates[id] || blockTemplates[blockFallback];
};


/***/ }),

/***/ 22093:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "List", ({
    enumerable: true,
    get: function() {
        return List;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _create_super = __webpack_require__(6400);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(42578);
var _sdk = __webpack_require__(29956);
var _blockcomponent = __webpack_require__(89464);
var _listconstants = __webpack_require__(52487);
var List = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(List, _Lightning_Component);
    var _super = _create_super._(List);
    function List() {
        _class_call_check._(this, List);
        return _super.apply(this, arguments);
    }
    _create_class._(List, [
        {
            key: "_detach",
            value: function _detach() {
                this._data = undefined;
            }
        },
        {
            key: "data",
            get: function get() {
                return this._data;
            },
            set: function set(value) {
                this._data = value;
                this.patch(_object_spread_props._(_object_spread._({}, value.rowSize), {
                    Block: {
                        data: value
                    }
                }));
            }
        },
        {
            key: "contentPadding",
            get: function get() {
                return this.tag("Block").contentPadding;
            },
            set: function set(value) {
                this.tag("Block").contentPadding = value;
            }
        },
        {
            key: "focusMode",
            get: function get() {
                return this.tag("Block").focusMode;
            },
            set: function set(value) {
                this.tag("Block").focusMode = value;
            }
        },
        {
            key: "contentGap",
            get: function get() {
                return this.tag("Block").contentGap;
            },
            set: function set(value) {
                this.tag("Block").contentGap = value;
            }
        },
        {
            key: "focusedIndex",
            get: function get() {
                return this.tag("Block").focusedIndex;
            },
            set: function set(value) {
                this.tag("Block").focusedIndex = value;
            }
        },
        {
            key: "_getFocused",
            value: function _getFocused() {
                return this.tag("Block");
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return {
                    Block: {
                        type: _blockcomponent.Block
                    }
                };
            }
        },
        {
            key: "getOffsetsByBlockData",
            value: function getOffsetsByBlockData(data) {
                return _blockcomponent.Block.getOffsetsByBlockData(data);
            }
        }
    ]);
    return List;
}(_sdk.Lightning.Component);
List.Templates = _listconstants.templates;


/***/ }),

/***/ 52487:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "templates", ({
    enumerable: true,
    get: function() {
        return templates;
    }
}));
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
var templates = {
    List: "List"
};


/***/ }),

/***/ 18793:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "ListSkeleton", ({
    enumerable: true,
    get: function() {
        return ListSkeleton;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _to_consumable_array = __webpack_require__(30005);
var _create_super = __webpack_require__(6400);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(42578);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _blockstyle = __webpack_require__(39623);
var _rowstyle = __webpack_require__(23593);
var _skeletonrectanglecomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(82149));
var _content = __webpack_require__(48030);
var _listcomponent = __webpack_require__(22093);
var _listskeletonstyle = __webpack_require__(16756);
var ListSkeleton = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(ListSkeleton, _Lightning_Component);
    var _super = _create_super._(ListSkeleton);
    function ListSkeleton() {
        _class_call_check._(this, ListSkeleton);
        return _super.apply(this, arguments);
    }
    _create_class._(ListSkeleton, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _listskeletonstyle.defaultContext;
            }
        },
        {
            key: "items",
            set: function set(value) {
                var _this = this;
                if (value) {
                    var blockIndex = value.blockIndex, itemSize = value.itemSize, count = value.count;
                    var blockStyle = Number.isFinite(blockIndex) ? (0, _blockstyle.getBlockStyle)({
                        hasTitle: true,
                        isFirstBlock: blockIndex === 0,
                        screenSize: this._style.screenSize
                    }) : _blockstyle.EMPTY_BLOCK_STYLE;
                    this.patch({
                        Title: _object_spread._({}, blockStyle.title),
                        Items: _object_spread_props._(_object_spread._({}, blockStyle.items), {
                            children: _to_consumable_array._(Array(count)).map(function(_, i) {
                                return _object_spread_props._(_object_spread._({
                                    type: _skeletonrectanglecomponent.default
                                }, itemSize), {
                                    x: i * (itemSize.w + _rowstyle.CONTENT_GAP[_this._style.screenSize])
                                });
                            })
                        })
                    });
                } else {
                    this.tag("Items").children = [];
                }
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Title: {
                        type: _skeletonrectanglecomponent.default
                    },
                    Items: {}
                }, (0, _listskeletonstyle.getInitialStyle)());
            }
        },
        {
            key: "getHeight",
            value: function getHeight(param) {
                var screenSize = param.screenSize, itemTemplate = param.itemTemplate, blockIndex = param.blockIndex;
                var _List_getOffsetsByBlockData = _listcomponent.List.getOffsetsByBlockData({
                    screenSize: screenSize,
                    data: {
                        title: "mock"
                    },
                    blockIndex: blockIndex
                }), top = _List_getOffsetsByBlockData.top, bottom = _List_getOffsetsByBlockData.bottom;
                var h = (0, _content.getContentSizeByContentTemplateId)(itemTemplate).h;
                return h + top + bottom;
            }
        }
    ]);
    return ListSkeleton;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 16756:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(3009);
var _blockstyle = __webpack_require__(39623);
var _style = __webpack_require__(65082);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var titleStyle = (0, _blockstyle.getTitleStyle)(context);
    return {
        Title: {
            h: titleStyle.text.lineHeight,
            w: 600
        },
        Items: {}
    };
};


/***/ }),

/***/ 3478:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return MosaicGrid;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _inherits = __webpack_require__(71648);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _create_super = __webpack_require__(6400);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
var _sdk = __webpack_require__(29956);
var _mosaicGridconstant = __webpack_require__(16166);
var _signals = __webpack_require__(2109);
var _mosaicGridstyle = __webpack_require__(67143);
var MosaicGrid = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(MosaicGrid, _Lightning_Component);
    var _super = _create_super._(MosaicGrid);
    function MosaicGrid() {
        _class_call_check._(this, MosaicGrid);
        return _super.apply(this, arguments);
    }
    _create_class._(MosaicGrid, [
        {
            key: "_init",
            value: function _init() {
                this._index = 0;
                this._items = [];
                this._itemsPerRow = 0;
                this._style = _mosaicGridstyle.defaultContext;
                this._contentGap = _mosaicGridconstant.CONTENT_GAP[this._style.screenSize];
            }
        },
        {
            key: "data",
            set: function set(value) {
                var _this = this;
                var items = value.items, itemType = value.itemType, itemSize = value.itemSize;
                this._items = items;
                this._itemsPerRow = _mosaicGridstyle.ITEMS_PER_ROW[this._style.screenSize];
                var currentItemsCount = this.items.length;
                if (currentItemsCount === items.length) {
                    return;
                }
                this.tag("Items").children = items.map(function(item, index) {
                    return _object_spread_props._(_object_spread._({
                        item: item,
                        type: itemType,
                        w: itemSize.w,
                        h: itemSize.h
                    }, _this._calculateItemPosition(itemSize, index)), {
                        passSignals: _define_property._({}, _signals.SELECTED_SIGNAL, true)
                    });
                });
                this._refocus();
            }
        },
        {
            key: "items",
            get: function get() {
                return this.tag("Items").children;
            }
        },
        {
            key: "_calculateItemPosition",
            value: function _calculateItemPosition(itemSize, index) {
                return {
                    x: (itemSize.w + this._contentGap) * (index % this._itemsPerRow),
                    y: (itemSize.h + this._contentGap) * Math.floor(index / this._itemsPerRow)
                };
            }
        },
        {
            key: "_handleUp",
            value: function _handleUp() {
                if (this._index >= this._itemsPerRow) {
                    this._setIndex(this._index - this._itemsPerRow);
                    return true;
                }
                return false;
            }
        },
        {
            key: "_handleDown",
            value: function _handleDown() {
                if (this._index + this._itemsPerRow <= this.items.length - 1) {
                    this._setIndex(this._index + this._itemsPerRow);
                }
                return false;
            }
        },
        {
            key: "_handleLeft",
            value: function _handleLeft() {
                if (this._index % this._itemsPerRow === 0) {
                    return false;
                }
                if (this._index > 0) {
                    this._setIndex(this._index - 1);
                    return true;
                }
                return false;
            }
        },
        {
            key: "_handleRight",
            value: function _handleRight() {
                if (this._index < this.items.length - 1) {
                    this._setIndex(this._index + 1);
                    return true;
                }
                return false;
            }
        },
        {
            key: "_handleEnter",
            value: function _handleEnter() {
                this.signal(_signals.SELECTED_SIGNAL, this._items[this._index]);
                return true;
            }
        },
        {
            key: "_setIndex",
            value: function _setIndex() {
                var index = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._index;
                this._index = index;
            }
        },
        {
            key: "_getFocused",
            value: function _getFocused() {
                return this.items[this._index];
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return {
                    Items: {},
                    signals: _define_property._({}, _signals.SELECTED_SIGNAL, true)
                };
            }
        }
    ]);
    return MosaicGrid;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 16166:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "CONTENT_GAP", ({
    enumerable: true,
    get: function() {
        return CONTENT_GAP;
    }
}));
var _define_property = __webpack_require__(21228);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(88801);
var _constants = __webpack_require__(34952);
var _obj;
var CONTENT_GAP = (_obj = {}, _define_property._(_obj, _constants.HD, 16), _define_property._(_obj, _constants.FULL_HD, 24), _obj);


/***/ }),

/***/ 67143:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ITEMS_PER_ROW: function() {
        return ITEMS_PER_ROW;
    },
    defaultContext: function() {
        return defaultContext;
    }
});
var _define_property = __webpack_require__(21228);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(3009);
var _constants = __webpack_require__(34952);
var _style = __webpack_require__(65082);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var ITEMS_PER_ROW = (_obj = {}, _define_property._(_obj, _constants.HD, 3), _define_property._(_obj, _constants.FULL_HD, 4), _obj);


/***/ }),

/***/ 28844:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return SlideShow;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _inherits = __webpack_require__(71648);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _sliced_to_array = __webpack_require__(28966);
var _create_super = __webpack_require__(6400);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(65759);
var _sdk = __webpack_require__(29956);
var _slideShowconstants = __webpack_require__(74837);
var _signals = __webpack_require__(2109);
var _slideShowstyle = __webpack_require__(63680);
var SlideShow = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(SlideShow, _Lightning_Component);
    var _super = _create_super._(SlideShow);
    function SlideShow() {
        _class_call_check._(this, SlideShow);
        return _super.apply(this, arguments);
    }
    _create_class._(SlideShow, [
        {
            key: "_init",
            value: function _init() {
                this._contentPadding = 0;
            }
        },
        {
            key: "data",
            get: function get() {
                return this._data;
            },
            set: function set(value) {
                this._data = value;
                var _this__data = this._data, itemSize = _this__data.itemSize, itemType = _this__data.itemType;
                var _this_children = _sliced_to_array._(this.children, 1), currentView = _this_children[0];
                if (currentView) {
                    currentView.data = value;
                    return;
                }
                var _obj;
                this.patch(_object_spread_props._(_object_spread._({}, itemSize), {
                    children: [
                        _object_spread_props._(_object_spread._({}, itemSize), {
                            type: itemType,
                            focusMode: this._focusMode,
                            data: value,
                            passSignals: (_obj = {}, _define_property._(_obj, _signals.SELECTED_SIGNAL, true), _define_property._(_obj, _signals.PORTION_REQUESTED_SIGNAL, true), _define_property._(_obj, _signals.IMPRESSION_TRACK_SIGNAL, true), _define_property._(_obj, _signals.IMPRESSION_UNTRACK_SIGNAL, true), _obj)
                        })
                    ]
                }));
            }
        },
        {
            key: "contentPadding",
            get: function get() {
                return this._contentPadding;
            },
            set: function set(value) {
                this._contentPadding = Number.isFinite(value) ? value : 0;
                if (this.children[0]) {
                    this.children[0].contentPadding = this._contentPadding;
                }
            }
        },
        {
            key: "focusMode",
            get: function get() {
                if (!this.children[0]) {
                    return null;
                }
                return this.children[0].focusMode;
            },
            set: function set(value) {
                if (value !== this._focusMode) {
                    if (this.children[0]) {
                        this.children[0].focusMode = value;
                    }
                    this._focusMode = value;
                }
            }
        },
        {
            key: "focusedIndex",
            get: function get() {
                if (!this.children[0]) {
                    return 0;
                }
                return this.children[0].focusedIndex;
            },
            set: function set(value) {
                if (this.children[0]) {
                    this.children[0].focusedIndex = value;
                }
            }
        },
        {
            key: "_getFocused",
            value: function _getFocused() {
                return this.children[0];
            }
        }
    ], [
        {
            key: "getOffsetsByBlockData",
            value: function getOffsetsByBlockData() {
                return _slideShowstyle.padding;
            }
        }
    ]);
    return SlideShow;
}(_sdk.Lightning.Component);
SlideShow.Templates = _object_spread._({}, _slideShowconstants.templates);


/***/ }),

/***/ 74837:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "templates", ({
    enumerable: true,
    get: function() {
        return templates;
    }
}));
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(3009);
var templates = {
    SlideShow: "SlideShow"
};


/***/ }),

/***/ 63680:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "padding", ({
    enumerable: true,
    get: function() {
        return padding;
    }
}));
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(37815);
var padding = {
    top: 0,
    bottom: 48
};


/***/ }),

/***/ 96686:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return Solo;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _inherits = __webpack_require__(71648);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _create_super = __webpack_require__(6400);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(37815);
var _sdk = __webpack_require__(29956);
var _soloconstants = __webpack_require__(89583);
var _signals = __webpack_require__(2109);
var Solo = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(Solo, _Lightning_Component);
    var _super = _create_super._(Solo);
    function Solo() {
        _class_call_check._(this, Solo);
        return _super.apply(this, arguments);
    }
    _create_class._(Solo, [
        {
            key: "_init",
            value: function _init() {
                this._contentPadding = 0;
                this._itemType = "";
            }
        },
        {
            key: "_active",
            value: function _active() {
                if (Number.isFinite(this._blockIndex)) {
                    this.signal(_signals.IMPRESSION_TRACK_SIGNAL, this._blockIndex, [
                        0
                    ]);
                }
            }
        },
        {
            key: "_inactive",
            value: function _inactive() {
                if (Number.isFinite(this._blockIndex)) {
                    this.signal(_signals.IMPRESSION_UNTRACK_SIGNAL, this._blockIndex, [
                        0
                    ]);
                }
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                this._data = undefined;
            }
        },
        {
            key: "data",
            get: function get() {
                return this._data;
            },
            set: function set(value) {
                this._data = value;
                var _this__data = this._data, block = _this__data.block, blockIndex = _this__data.blockIndex, itemSize = _this__data.itemSize, itemType = _this__data.itemType;
                var _block_content = block.content, allItems = _block_content.items;
                var items = allItems.slice(0, 1).map(function(item, itemIndex) {
                    return {
                        content: item,
                        blockIndex: blockIndex,
                        itemIndex: itemIndex,
                        config: _object_spread._({}, itemSize)
                    };
                });
                this._blockIndex = blockIndex;
                if (this.children.length === items.length) {
                    for(var i = 0; i < items.length; i += 1){
                        this.children[i].item = items[i];
                    }
                    return;
                }
                this.patch(_object_spread_props._(_object_spread._({}, itemSize), {
                    children: items.map(function(item) {
                        var _obj;
                        return _object_spread_props._(_object_spread._({}, itemSize), {
                            type: itemType,
                            item: item,
                            passSignals: (_obj = {}, _define_property._(_obj, _signals.SELECTED_SIGNAL, true), _define_property._(_obj, _signals.HIDE_BACKGROUND_SIGNAL, true), _define_property._(_obj, _signals.SHOW_BACKGROUND_SIGNAL, true), _obj)
                        });
                    })
                }));
            }
        },
        {
            key: "contentPadding",
            get: function get() {
                return this._contentPadding;
            },
            set: function set(value) {
                this._contentPadding = Number.isFinite(value) ? value : 0;
                if (this.children[0]) {
                    this.children[0].contentPadding = this._contentPadding;
                }
            }
        },
        {
            key: "_getFocused",
            value: function _getFocused() {
                return this.children[0];
            }
        }
    ], [
        {
            key: "getOffsetsByBlockData",
            value: function getOffsetsByBlockData(layoutData) {
                var itemType = (layoutData || {}).itemType;
                var bottom = itemType && typeof itemType.getBottomMargin === "function" ? itemType.getBottomMargin(layoutData) : 0;
                return {
                    top: 0,
                    bottom: Number.isFinite(bottom) ? bottom : 0
                };
            }
        }
    ]);
    return Solo;
}(_sdk.Lightning.Component);
Solo.Templates = _object_spread._({}, _soloconstants.templates);


/***/ }),

/***/ 89583:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "templates", ({
    enumerable: true,
    get: function() {
        return templates;
    }
}));
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(88801);
var templates = {
    Solo: "Solo"
};


/***/ }),

/***/ 3777:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "getTitle", ({
    enumerable: true,
    get: function() {
        return getTitle;
    }
}));
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(45538);
var getTitle = function(title) {
    if (!title) {
        return "";
    }
    if (typeof title.long === "string") {
        return title.long;
    }
    return title.short || "";
};


/***/ }),

/***/ 48030:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    contentFallback: function() {
        return contentFallback;
    },
    contentTemplates: function() {
        return contentTemplates;
    },
    getContentSizeByContentTemplateId: function() {
        return getContentSizeByContentTemplateId;
    },
    getContentTemplateByTemplateId: function() {
        return getContentTemplateByTemplateId;
    },
    getContentTemplateOptions: function() {
        return getContentTemplateOptions;
    },
    getImageOptionsByContentTemplateId: function() {
        return getImageOptionsByContentTemplateId;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _memoize = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34736));
var _sizes = __webpack_require__(82699);
var _postercomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(63205));
var _portraitcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(8289));
var _jacketcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(54656));
var _cardcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(87487));
var _totemcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81665));
var _covercomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(14530));
var _herocomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(26908));
var _solocomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(3843));
var _jumbotroncomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(71665));
var _jumbotronSquarecomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(10050));
var _horizontalCardcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(16348));
var _horizontalSquarecomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(73876));
var _squarecomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(85520));
var _bigSquarecomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(84931));
var _flatRectanglecomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65602));
var _bannercomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(4441));
var _AlertViewcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(92561));
var _squareMetacomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(57286));
var contentFallback = _jacketcomponent.default.Templates.Jacket;
var _obj;
var contentTemplates = (_obj = {}, _define_property._(_obj, _portraitcomponent.default.Templates.Portrait, _portraitcomponent.default), _define_property._(_obj, _postercomponent.default.Templates.PosterS, _postercomponent.default), _define_property._(_obj, _postercomponent.default.Templates.PosterM, _postercomponent.default), _define_property._(_obj, _postercomponent.default.Templates.PosterL, _postercomponent.default), _define_property._(_obj, _jacketcomponent.default.Templates.Jacket, _jacketcomponent.default), _define_property._(_obj, _cardcomponent.default.Templates.CardS, _cardcomponent.default), _define_property._(_obj, _cardcomponent.default.Templates.CardM, _cardcomponent.default), _define_property._(_obj, _cardcomponent.default.Templates.CardL, _cardcomponent.default), _define_property._(_obj, _totemcomponent.default.Templates.Totem, _totemcomponent.default), _define_property._(_obj, _covercomponent.default.Templates.Cover, _covercomponent.default), _define_property._(_obj, _herocomponent.default.Templates.Hero, _herocomponent.default), _define_property._(_obj, _solocomponent.default.Templates.Solo, _solocomponent.default), _define_property._(_obj, _jumbotroncomponent.default.Templates.Jumbotron, _jumbotroncomponent.default), _define_property._(_obj, _jumbotronSquarecomponent.default.Templates.JumbotronSquare, _jumbotronSquarecomponent.default), _define_property._(_obj, _horizontalCardcomponent.default.Templates.HorizontalCard, _horizontalCardcomponent.default), _define_property._(_obj, _horizontalSquarecomponent.default.Templates.HorizontalSquare, _horizontalSquarecomponent.default), _define_property._(_obj, _squarecomponent.default.Templates.Square, _squarecomponent.default), _define_property._(_obj, _bigSquarecomponent.default.Templates.BigSquare, _bigSquarecomponent.default), _define_property._(_obj, _flatRectanglecomponent.default.Templates.FlatRectangle, _flatRectanglecomponent.default), _define_property._(_obj, _bannercomponent.default.Templates.Banner, _bannercomponent.default), _define_property._(_obj, _AlertViewcomponent.default.Templates.AlertView, _AlertViewcomponent.default), _define_property._(_obj, _squareMetacomponent.default.Templates.SquareMeta, _squareMetacomponent.default), _obj);
var getContentTemplateByTemplateId = function(templateId) {
    return contentTemplates[templateId] || contentTemplates[contentFallback];
};
var getContentSizeByContentTemplateId = function(contentTemplateId) {
    var contentTemplate = getContentTemplateByTemplateId(contentTemplateId);
    var sizes = (0, _get.default)(contentTemplate, "Sizes.".concat(contentTemplateId)) || (0, _get.default)(contentTemplate, "Sizes.".concat(contentFallback));
    return sizes[(0, _sizes.getScreenSize)()] || sizes;
};
var getImageOptionsByContentTemplateId = function(contentTemplateId) {
    var contentTemplate = getContentTemplateByTemplateId(contentTemplateId);
    return (0, _get.default)(contentTemplate, "ImageOptions.".concat(contentTemplateId)) || (0, _get.default)(contentTemplate, "ImageOptions.".concat(contentFallback));
};
var getContentTemplateOptions = (0, _memoize.default)(function() {
    return Object.keys(contentTemplates).reduce(function(result, key) {
        return _object_spread_props._(_object_spread._({}, result), _define_property._({}, key, {
            imageOptions: getImageOptionsByContentTemplateId(key),
            size: getContentSizeByContentTemplateId(key)
        }));
    }, {});
});


/***/ }),

/***/ 63555:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _export_star = __webpack_require__(37668);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
_export_star._(__webpack_require__(18356), exports);
_export_star._(__webpack_require__(12747), exports);
_export_star._(__webpack_require__(48030), exports);


/***/ }),

/***/ 12747:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    getSelectorTemplateById: function() {
        return getSelectorTemplateById;
    },
    selectorTemplates: function() {
        return selectorTemplates;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(88801);
var _selectorcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(6951));
var _obj;
var selectorTemplates = (_obj = {}, _define_property._(_obj, _selectorcomponent.default.Templates.Selector, _selectorcomponent.default), _define_property._(_obj, _selectorcomponent.default.Templates.Tab, _selectorcomponent.default), _obj);
var getSelectorTemplateById = function(id) {
    return selectorTemplates[id];
};


/***/ }),

/***/ 92906:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "BlockHeader", ({
    enumerable: true,
    get: function() {
        return BlockHeader;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(42578);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _blockHeaderstyle = __webpack_require__(54344);
var _block = __webpack_require__(3777);
var BlockHeader = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(BlockHeader, _Lightning_Component);
    var _super = _create_super._(BlockHeader);
    function BlockHeader() {
        _class_call_check._(this, BlockHeader);
        return _super.apply(this, arguments);
    }
    _create_class._(BlockHeader, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _blockHeaderstyle.defaultContext;
                this._isFocused = false;
                this._isSelected = false;
            }
        },
        {
            key: "_attach",
            value: function _attach() {
                var _this = this;
                var label = this.tag("Label");
                label.on("txLoaded", function() {
                    _this.w = label.finalW;
                });
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                this.tag("Label").removeAllListeners("txLoaded");
                this._item = undefined;
            }
        },
        {
            key: "item",
            get: function get() {
                return this._item;
            },
            set: function set(value) {
                var title = value.title;
                this._item = value;
                this.tag("Label").text = {
                    text: typeof title === "string" ? title : (0, _block.getTitle)(title)
                };
            }
        },
        {
            key: "isSelected",
            get: function get() {
                return this._isSelected;
            },
            set: function set(value) {
                this._isSelected = value;
                this._updateStyle();
            }
        },
        {
            key: "_updateStyle",
            value: function _updateStyle() {
                this.patch(this._isFocused ? (0, _blockHeaderstyle.getFocusedStyle)(this._isSelected) : (0, _blockHeaderstyle.getUnFocusedStyle)(this._isSelected));
            }
        },
        {
            key: "_focus",
            value: function _focus() {
                this._isFocused = true;
                this._updateStyle();
            }
        },
        {
            key: "_unfocus",
            value: function _unfocus() {
                this._isFocused = false;
                this._updateStyle();
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Label: {},
                    Line: {
                        rect: true
                    }
                }, (0, _blockHeaderstyle.getInitialStyle)());
            }
        }
    ]);
    return BlockHeader;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 54344:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DEFAULT_ALPHA: function() {
        return DEFAULT_ALPHA;
    },
    LABEL_MARGIN_BOTTOM: function() {
        return LABEL_MARGIN_BOTTOM;
    },
    LINE_HEIGHT: function() {
        return LINE_HEIGHT;
    },
    SELECTED_ALPHA: function() {
        return SELECTED_ALPHA;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getFocusedStyle: function() {
        return getFocusedStyle;
    },
    getHeight: function() {
        return getHeight;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    getLabelFont: function() {
        return getLabelFont;
    },
    getUnFocusedStyle: function() {
        return getUnFocusedStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(88801);
var _memoize = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34736));
var _constants = __webpack_require__(34952);
var _theme = __webpack_require__(51397);
var _typography = __webpack_require__(18411);
var _sizes = __webpack_require__(82699);
var _style = __webpack_require__(65082);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var LINE_HEIGHT = (_obj = {}, _define_property._(_obj, _constants.HD, 4), _define_property._(_obj, _constants.FULL_HD, 4), _obj);
var _obj1;
var LABEL_MARGIN_BOTTOM = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 3), _define_property._(_obj1, _constants.FULL_HD, 4), _obj1);
var colors = {
    text: (0, _theme.makeThemeColor)(_theme.PRIMARY),
    line: (0, _theme.makeThemeColor)(_theme.SECONDARY)
};
var DEFAULT_ALPHA = 0.6;
var SELECTED_ALPHA = 1;
var getLabelFont = function(screenSize) {
    return (0, _typography.getFont)(_typography.FONT.OTTAWA_2, screenSize);
};
var getHeight = function(screenSize) {
    return getLabelFont(screenSize).lineHeight + LABEL_MARGIN_BOTTOM[screenSize] + LINE_HEIGHT[screenSize];
};
var getInitialStyle = (0, _memoize.default)(function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext, screenSize = _ref.screenSize, colorMode = _ref.colorMode;
    return {
        h: getHeight(screenSize),
        Label: {
            alpha: DEFAULT_ALPHA,
            color: colors.text[colorMode],
            text: _object_spread_props._(_object_spread._({}, getLabelFont(screenSize)), {
                verticalAlign: "middle"
            })
        },
        Line: {
            mountY: 1,
            h: LINE_HEIGHT[screenSize],
            w: _sizes.identity,
            y: function(height) {
                return height - LINE_HEIGHT[screenSize];
            },
            color: colors.line[colorMode],
            scaleX: 0
        }
    };
});
var getFocusedStyle = function(isSelected) {
    return {
        Label: {
            smooth: {
                alpha: SELECTED_ALPHA
            }
        },
        Line: {
            smooth: {
                alpha: isSelected ? SELECTED_ALPHA : DEFAULT_ALPHA,
                scaleX: isSelected ? 1 : 0
            }
        }
    };
};
var getUnFocusedStyle = function(isSelected) {
    return {
        Label: {
            smooth: {
                alpha: DEFAULT_ALPHA
            }
        },
        Line: {
            smooth: {
                alpha: DEFAULT_ALPHA,
                scaleX: isSelected ? 1 : 0
            }
        }
    };
};


/***/ }),

/***/ 6951:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/* eslint-disable no-bitwise */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return Selector;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _get = __webpack_require__(60528);
var _get_prototype_of = __webpack_require__(35196);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _set = __webpack_require__(81364);
var _create_super = __webpack_require__(6400);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(88801);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _get1 = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _sdk = __webpack_require__(29956);
var _selectorHeadercomponent = __webpack_require__(43590);
var _selectorstyle = __webpack_require__(13544);
var _selectorutils = __webpack_require__(70640);
var _selectorconstants = __webpack_require__(94497);
var _blocks = __webpack_require__(18356);
var _signals = __webpack_require__(2109);
var _analyticsutils = __webpack_require__(2693);
var _rowcomponent = __webpack_require__(53565);
var Selector = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(Selector, _Lightning_Component);
    var _super = _create_super._(Selector);
    function Selector() {
        _class_call_check._(this, Selector);
        return _super.apply(this, arguments);
    }
    _create_class._(Selector, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _selectorstyle.defaultContext;
                this._contentPadding = 0;
                this._index = 0;
                this._selectedTabIndex = 0;
                this._rowHeight = 0;
                this._focusableTags = [
                    "Tabs",
                    (0, _selectorutils.getRendererRefByIndex)(this._selectedTabIndex)
                ];
                this._renderers = {};
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                this._data = undefined;
                this._blocks = undefined;
                this._renderers = {};
            }
        },
        {
            key: "id",
            get: function get() {
                return this._id;
            }
        },
        {
            key: "data",
            get: function get() {
                return this._data;
            },
            set: function set(value) {
                if (!value) {
                    return;
                }
                var _getSelectorTabs = (0, _selectorutils.getSelectorTabs)(value), tabs = _getSelectorTabs.tabs, blocks = _getSelectorTabs.blocks;
                var header = this.tag("Tabs");
                header.w = value.rowSize.w;
                header.items = tabs;
                this._id = value.block.id;
                this._blockIndex = value.blockIndex;
                this._rowHeight = value.rowSize.h - (0, _selectorstyle.getTopBlockHeight)();
                this._data = value;
                this._blocks = blocks;
                this._handleSelectedTab(this._selectedTabIndex);
            }
        },
        {
            key: "contentPadding",
            get: function get() {
                return this._contentPadding;
            },
            set: function set(value) {
                if (this._contentPadding !== value) {
                    this._contentPadding = value;
                    this.tag("Tabs").patch({
                        x: value,
                        leftPadding: value
                    });
                    this.tag("Content").children.forEach(function(child) {
                        child.patch({
                            x: value,
                            leftPadding: value
                        });
                    });
                }
            }
        },
        {
            key: "focusMode",
            get: function get() {
                return this._focusMode;
            },
            set: function set(value) {
                if (value !== this._focusMode) {
                    this.tag("Content").children.forEach(function(child) {
                        child.focusMode = value;
                    });
                    this._focusMode = value;
                }
            }
        },
        {
            key: "focusedIndex",
            get: function get() {
                var renderer = this._renderers[this._selectedTabIndex];
                if (!renderer) {
                    return 0;
                }
                return this._selectedTabIndex << 16 | renderer.focusedIndex & 0xffff;
            },
            set: function set(value) {
                var index = value & 0xffff;
                var tab = value >> 16;
                var renderer = this._getOrCreateRendererAtIndex(tab);
                var tabsView = this.tag("Tabs");
                if (!renderer) {
                    return;
                }
                renderer.focusedIndex = index;
                tabsView.selectedIndex = tab;
                tabsView.goTo(tab);
                this._handleSelectedTab(tab);
                this._index = 1;
                this._refocus();
                var block = this._blocks[tab];
                if (!block || !block.content) {
                    return;
                }
                var _block_content = block.content, itemsPerPage = _block_content.pagination.itemsPerPage;
                var page = Math.ceil(index / itemsPerPage) || 1;
                // Setting a focused index means a routing history restoration, hence we may need to refresh a progress bar, requesting current page
                this._handlePortionRequest({
                    page: page,
                    start: (page - 1) * itemsPerPage,
                    id: block.id
                });
            }
        },
        {
            key: "w",
            get: function get() {
                return _get._(_get_prototype_of._(Selector.prototype), "w", this);
            },
            set: function set(value) {
                _set._(_get_prototype_of._(Selector.prototype), "w", value, this, true);
                this.tag("Content").children.forEach(function(child) {
                    child.w = value;
                });
            }
        },
        {
            key: "_getOrCreateRendererAtIndex",
            value: function _getOrCreateRendererAtIndex(index) {
                if (this._renderers[index]) {
                    return this._renderers[index];
                }
                var _obj;
                var renderer = this.stage.c({
                    type: _rowcomponent.Row,
                    ref: (0, _selectorutils.getRendererRefByIndex)(index),
                    focusMode: this._focusMode,
                    x: this._contentPadding,
                    leftPadding: this._contentPadding,
                    rightPadding: _selectorstyle.RIGHT_PADDING[this._style.screenSize],
                    signals: (_obj = {}, _define_property._(_obj, _signals.PORTION_REQUESTED_SIGNAL, "_handlePortionRequest"), _define_property._(_obj, _signals.SELECTED_SIGNAL, "_handleConcurrentBlockSelect"), _define_property._(_obj, _signals.IMPRESSION_TRACK_SIGNAL, "_handleImpressionTrack"), _define_property._(_obj, _signals.IMPRESSION_UNTRACK_SIGNAL, "_handleImpressionUnTrack"), _obj)
                });
                this.tag("Content").childList.add(renderer);
                this._renderers[index] = renderer;
                return renderer;
            }
        },
        {
            key: "_removeRendererAtIndex",
            value: function _removeRendererAtIndex(index) {
                var renderer = this._renderers[index];
                if (!renderer) {
                    return;
                }
                try {
                    this.tag("Content").childList.remove(renderer);
                } finally{
                    this._renderers[index] = null;
                }
            }
        },
        {
            key: "_handleSelectedTab",
            value: function _handleSelectedTab() {
                var tabIndex = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._selectedTabIndex;
                var block = this._blocks[tabIndex];
                var renderer = this._getOrCreateRendererAtIndex(tabIndex);
                renderer.contentPadding = this._contentPadding;
                renderer.w = this.finalW;
                renderer.h = this._rowHeight;
                renderer.data = _object_spread_props._(_object_spread._({}, this._data), {
                    block: block,
                    blockIndex: undefined
                });
                Object.values(this._renderers).filter(Boolean).forEach(function(view) {
                    view.visible = view === renderer;
                });
                if (this._selectedTabIndex !== tabIndex) {
                    (0, _analyticsutils.sendEvent)((0, _get1.default)(this._data, "block.alternativeContent.analytics"));
                }
                this._focusableTags[1] = renderer.ref;
                if (this._selectedTabIndex !== tabIndex) {
                    this._removeRendererAtIndex(this._selectedTabIndex);
                }
                this._selectedTabIndex = tabIndex;
            }
        },
        {
            key: "_handleConcurrentBlockSelect",
            value: function _handleConcurrentBlockSelect(item) {
                (0, _analyticsutils.sendEvent)((0, _get1.default)(this._blocks, "[".concat(this._selectedTabIndex, "].analytics")));
                this.signal(_signals.SELECTED_SIGNAL, item);
            }
        },
        {
            key: "_handlePortionRequest",
            value: function _handlePortionRequest(portion) {
                this.signal(_signals.PORTION_REQUESTED_SIGNAL, _object_spread_props._(_object_spread._({}, portion), {
                    parentId: this.id
                }));
            }
        },
        {
            key: "_handleImpressionTrack",
            value: function _handleImpressionTrack(_, items) {
                this.signal(_signals.IMPRESSION_TRACK_SIGNAL, this._blockIndex, items);
            }
        },
        {
            key: "_handleImpressionUnTrack",
            value: function _handleImpressionUnTrack(_, items) {
                this.signal(_signals.IMPRESSION_UNTRACK_SIGNAL, this._blockIndex, items);
            }
        },
        {
            key: "_handleUp",
            value: function _handleUp() {
                if (this._index > 0) {
                    this._index -= 1;
                    return true;
                }
                return false;
            }
        },
        {
            key: "_handleDown",
            value: function _handleDown() {
                if (this._index < this._focusableTags.length - 1) {
                    this._index += 1;
                    return true;
                }
                return false;
            }
        },
        {
            key: "_getFocused",
            value: function _getFocused() {
                return this.tag(this._focusableTags[this._index]);
            }
        }
    ], [
        {
            key: "getOffsetsByBlockData",
            value: function getOffsetsByBlockData(layoutData) {
                var data = layoutData.data;
                var blockType = (0, _blocks.getBlockTemplateById)(data.blockTemplateId);
                var blockOffsets = blockType.getOffsetsByBlockData ? blockType.getOffsetsByBlockData(_object_spread_props._(_object_spread._({}, layoutData), {
                    blockIndex: undefined
                })) : {
                    top: 0,
                    bottom: 0
                };
                return _object_spread_props._(_object_spread._({}, blockOffsets), {
                    top: (0, _selectorstyle.getTopBlockHeight)()
                });
            }
        },
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Tabs: {
                        type: _selectorHeadercomponent.SelectorHeader,
                        signals: _define_property._({}, _signals.SELECTED_SIGNAL, "_handleSelectedTab")
                    },
                    Content: {}
                }, (0, _selectorstyle.getInitialStyle)());
            }
        }
    ]);
    return Selector;
}(_sdk.Lightning.Component);
Selector.Templates = _selectorconstants.templates;


/***/ }),

/***/ 94497:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "templates", ({
    enumerable: true,
    get: function() {
        return templates;
    }
}));
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(37815);
var templates = {
    Selector: "Selector",
    Tab: "Tab"
};


/***/ }),

/***/ 13544:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    HEADER_MARGIN_BOTTOM: function() {
        return HEADER_MARGIN_BOTTOM;
    },
    RIGHT_PADDING: function() {
        return RIGHT_PADDING;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    getTopBlockHeight: function() {
        return getTopBlockHeight;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(3009);
var _memoize = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34736));
var _constants = __webpack_require__(34952);
var _blockHeaderstyle = __webpack_require__(54344);
var _style = __webpack_require__(65082);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var HEADER_MARGIN_BOTTOM = (_obj = {}, _define_property._(_obj, _constants.HD, 12), _define_property._(_obj, _constants.FULL_HD, 16), _obj);
var _obj1;
var RIGHT_PADDING = (_obj1 = {}, _define_property._(_obj1, _constants.HD, _constants.safetyMargins.horizontal.HD), _define_property._(_obj1, _constants.FULL_HD, _constants.safetyMargins.horizontal.FULL_HD), _obj1);
var getTopBlockHeight = function() {
    var screenSize = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext).screenSize;
    return (0, _blockHeaderstyle.getHeight)(screenSize) + HEADER_MARGIN_BOTTOM[screenSize];
};
var getInitialStyle = (0, _memoize.default)(function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    return {
        Tabs: {
            rightPadding: _constants.safetyMargins.horizontal[context.screenSize]
        },
        Content: {
            y: getTopBlockHeight(context)
        }
    };
}, _style.cacheResolver);


/***/ }),

/***/ 70640:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    getRendererRefByIndex: function() {
        return getRendererRefByIndex;
    },
    getSelectorTabs: function() {
        return getSelectorTabs;
    }
});
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var getSelectorTabs = function(data) {
    var blocks = (0, _get.default)(data, "block.alternativeContent.concurrentBlocks") || [];
    return {
        tabs: blocks.map(function(param) {
            var id = param.id, title = param.title;
            return {
                id: id,
                title: title
            };
        }),
        blocks: blocks
    };
};
var getRendererRefByIndex = function(index) {
    return "Renderer_".concat(index);
};


/***/ }),

/***/ 43590:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "SelectorHeader", ({
    enumerable: true,
    get: function() {
        return SelectorHeader;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _create_super = __webpack_require__(6400);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(52318);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _blockHeadercomponent = __webpack_require__(92906);
var _selectorHeaderstyle = __webpack_require__(75944);
var _signals = __webpack_require__(2109);
var SelectorHeader = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(SelectorHeader, _Lightning_Component);
    var _super = _create_super._(SelectorHeader);
    function SelectorHeader() {
        _class_call_check._(this, SelectorHeader);
        return _super.apply(this, arguments);
    }
    _create_class._(SelectorHeader, [
        {
            key: "_construct",
            value: function _construct() {
                this._focusedTabIndex = 0;
                this._selectedTabIndex = 0;
                this._leftPadding = 0;
                this._rightPadding = 0;
                this._containerWidth = 0;
                this._style = _selectorHeaderstyle.defaultContext;
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                this.tag("Container").onUpdate = null;
            }
        },
        {
            key: "items",
            set: function set(value) {
                var _this = this;
                var tabStyle = (0, _selectorHeaderstyle.getTabStyle)(this._style.screenSize);
                var container = this.tag("Container");
                if (container.children.length === value.length && value.length) {
                    container.children.forEach(function(child, index) {
                        child.item = value[index];
                    });
                    return;
                }
                container.children = value.map(function(item) {
                    return _object_spread._({
                        type: _blockHeadercomponent.BlockHeader,
                        item: item
                    }, tabStyle);
                });
                container.children[this._selectedTabIndex].isSelected = true;
                container.onUpdate = function() {
                    _this._containerWidth = container.flex && container.flex.item && container.flex.item.w || 0;
                    _this.goTo(_this._focusedTabIndex, false);
                };
            }
        },
        {
            key: "selectedIndex",
            get: function get() {
                return this._selectedTabIndex;
            },
            set: function set(value) {
                var _this = this;
                this._selectedTabIndex = value;
                this.tag("Container").children.forEach(function(child, index) {
                    child.isSelected = _this._selectedTabIndex === index;
                });
            }
        },
        {
            key: "focusedIndex",
            get: function get() {
                return this._focusedTabIndex;
            },
            set: function set(value) {
                this._focusedTabIndex = value;
            }
        },
        {
            key: "leftPadding",
            get: function get() {
                return this._leftPadding;
            },
            set: function set(value) {
                this._leftPadding = value;
                this.goTo(this._focusedItemIndex);
            }
        },
        {
            key: "rightPadding",
            get: function get() {
                return this._rightPadding;
            },
            set: function set(value) {
                this._rightPadding = value;
                this.goTo(this._focusedItemIndex);
            }
        },
        {
            key: "_handleEnter",
            value: function _handleEnter() {
                if (this._focusedTabIndex === this._selectedTabIndex) {
                    return false;
                }
                var container = this.tag("Container");
                if (container.children[this._selectedTabIndex]) {
                    container.children[this._selectedTabIndex].isSelected = false;
                }
                if (container.children[this._focusedTabIndex]) {
                    container.children[this._focusedTabIndex].isSelected = true;
                }
                this._selectedTabIndex = this._focusedTabIndex;
                this.signal(_signals.SELECTED_SIGNAL, this._selectedTabIndex);
                return true;
            }
        },
        {
            key: "goTo",
            value: function goTo() {
                var index = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._focusedTabIndex, animate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                var container = this.tag("Container");
                if (!container.children.length) {
                    return;
                }
                var flexItem = (0, _get.default)(container, "flex._layout.items.".concat(index));
                if (!flexItem) {
                    return;
                }
                var totalWidth = container.flex.item.w || this._containerWidth;
                var maxOffset = Math.min(this.finalW - this._leftPadding - this._rightPadding, totalWidth) - totalWidth;
                var offset = -flexItem.x;
                var result = Math.max(Math.min(0, offset), maxOffset);
                if (animate) {
                    container.setSmooth("x", result);
                } else {
                    container.x = result;
                }
                this._focusedTabIndex = index;
            }
        },
        {
            key: "_handleLeft",
            value: function _handleLeft() {
                if (this._focusedTabIndex > 0) {
                    this.goTo(this._focusedTabIndex - 1);
                    return true;
                }
                return false;
            }
        },
        {
            key: "_handleRight",
            value: function _handleRight() {
                if (this._focusedTabIndex < this.tag("Container").children.length - 1) {
                    this.goTo(this._focusedTabIndex + 1);
                    return true;
                }
                return false;
            }
        },
        {
            key: "_captureKey",
            value: function _captureKey() {
                this.tag("Container").onUpdate = null;
                return false;
            }
        },
        {
            key: "_getFocused",
            value: function _getFocused() {
                return this.tag("Container").children[this._focusedTabIndex];
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Container: {}
                }, (0, _selectorHeaderstyle.getInitialStyle)());
            }
        }
    ]);
    return SelectorHeader;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 75944:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    GAP: function() {
        return GAP;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getHeight: function() {
        return _blockHeaderstyle.getHeight;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    getTabStyle: function() {
        return getTabStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
var _memoize = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34736));
var _constants = __webpack_require__(34952);
var _style = __webpack_require__(65082);
var _blockHeaderstyle = __webpack_require__(54344);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var GAP = (_obj = {}, _define_property._(_obj, _constants.HD, 32), _define_property._(_obj, _constants.FULL_HD, 40), _obj);
var getInitialStyle = (0, _memoize.default)(function() {
    return {
        Container: {
            flex: {
                direction: "row"
            }
        }
    };
});
var getTabStyle = (0, _memoize.default)(function(screenSize) {
    return {
        flexItem: {
            marginRight: GAP[screenSize]
        }
    };
});


/***/ }),

/***/ 43581:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    blockTemplateTypes: function() {
        return blockTemplateTypes;
    },
    selectorTemplateTypes: function() {
        return selectorTemplateTypes;
    },
    templateTypes: function() {
        return templateTypes;
    }
});
var _define_property = __webpack_require__(21228);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(88801);
var _index = __webpack_require__(63555);
var templateTypes = _object_spread_props._(_object_spread._({}, Object.keys(_index.contentTemplates).reduce(function(result, key) {
    return _object_spread_props._(_object_spread._({}, result), _define_property._({}, key, key));
}, {})), {
    // The Player template is not a part of catalog layout, however it shouldn't be filtered out upon layout parsing
    Player: "Player",
    HorizontalEpg: "HorizontalEpg"
});
var selectorTemplateTypes = {
    Selector: "Selector",
    Tab: "Selector"
};
var blockTemplateTypes = {
    List: "List",
    SlideShow: "SlideShow",
    Solo: "Solo",
    Grid: "Grid",
    Belly: "Belly",
    // The SideGlass template is not a part of catalog layout, however it shouldn't be filtered out upon layout parsing
    SideGlass: "SideGlass",
    HorizontalEpg: "HorizontalEpg"
};


/***/ }),

/***/ 45449:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ICONS: function() {
        return ICONS;
    },
    ICONS_TYPES: function() {
        return ICONS_TYPES;
    },
    ITEMS_BY_BREAKPOINTS: function() {
        return ITEMS_BY_BREAKPOINTS;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);
var _constants = __webpack_require__(34952);
var _iconcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(70160));
var _badgecomponent = __webpack_require__(69289);
var _templates = __webpack_require__(88229);
var _obj;
var ICONS = (_obj = {}, _define_property._(_obj, _templates.ICON_POSITION.TOP_RIGHT, 4), _define_property._(_obj, _templates.ICON_POSITION.BOTTOM_RIGHT, 1), _obj);
var _obj1;
var ICONS_TYPES = (_obj1 = {}, _define_property._(_obj1, _templates.ICON_POSITION.TOP_LEFT, _iconcomponent.default), _define_property._(_obj1, _templates.ICON_POSITION.TOP_RIGHT, _badgecomponent.Badge), _define_property._(_obj1, _templates.ICON_POSITION.BOTTOM_RIGHT, _iconcomponent.default), _obj1);
var _obj2;
var ITEMS_BY_BREAKPOINTS = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 7), _define_property._(_obj2, _constants.FULL_HD, 7), _obj2);


/***/ }),

/***/ 81665:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return Totem;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(45538);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _sdk = __webpack_require__(29956);
var _focusshader = /*#__PURE__*/ _interop_require_default._(__webpack_require__(25906));
var _imageshader = /*#__PURE__*/ _interop_require_default._(__webpack_require__(17154));
var _templates = __webpack_require__(88229);
var _signals = __webpack_require__(2109);
var _incentivecomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(9077));
var _incentiveutils = __webpack_require__(72823);
var _incentiveconstants = __webpack_require__(37212);
var _totemstyle = __webpack_require__(13063);
var _totemconstants = __webpack_require__(85110);
var Totem = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(Totem, _Lightning_Component);
    var _super = _create_super._(Totem);
    function Totem() {
        _class_call_check._(this, Totem);
        return _super.apply(this, arguments);
    }
    _create_class._(Totem, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _totemstyle.defaultContext;
            }
        },
        {
            key: "_inactive",
            value: function _inactive() {
                this.signal(_signals.INACTIVE_SIGNAL, this);
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                this._item = undefined;
                this.signal(_signals.DETACHED_SIGNAL, this);
            }
        },
        {
            key: "item",
            get: function get() {
                return this._item;
            },
            set: function set(param) {
                var content = param.content, config = param.config, template = param.template, _param_colorScheme = param.colorScheme, colorScheme = _param_colorScheme === void 0 ? this._style.colorMode : _param_colorScheme;
                if ((0, _templates.areContentItemsEqual)(this._item, content)) {
                    this._item = content;
                    return;
                }
                var templateDataAccessPath = [
                    template,
                    this._style.screenSize
                ];
                var screenSize = this._style.screenSize;
                this._item = content;
                this._config = config || (0, _get.default)(_totemconstants.sizes, templateDataAccessPath, {});
                if (colorScheme && colorScheme !== this._style.colorMode) {
                    this._style = {
                        screenSize: this._style.screenSize,
                        colorMode: colorScheme
                    };
                }
                var _this__item = this._item, pictos = _this__item.pictos, image = _this__item.image, incentives = _this__item.incentives;
                var imageUrl = image && image.src || "";
                var viewBox = (0, _totemstyle.getIconViewBox)(screenSize);
                var incentiveLines = (0, _incentiveutils.getLinesCount)(incentives);
                this.patch({
                    Image: {
                        src: imageUrl
                    },
                    TopLeftIcon: {
                        iconData: {
                            picto: (0, _totemstyle.getIcon)(pictos, _templates.ICON_POSITION.TOP_LEFT),
                            viewBox: viewBox
                        }
                    },
                    TopRightIcon: {
                        iconData: {
                            picto: (0, _totemstyle.getIcon)(pictos, _templates.ICON_POSITION.TOP_RIGHT),
                            viewBox: viewBox
                        }
                    },
                    BottomRightIcon: {
                        iconData: {
                            picto: (0, _totemstyle.getIcon)(pictos, _templates.ICON_POSITION.BOTTOM_RIGHT),
                            viewBox: viewBox
                        }
                    },
                    Incentive: {
                        visible: incentiveLines > 0,
                        data: {
                            incentives: incentives,
                            linesCount: incentiveLines,
                            w: this._config.w,
                            colorMode: this._style.colorMOde,
                            alignment: _incentiveconstants.ALIGNMENT_VERTICAL
                        }
                    }
                });
            }
        },
        {
            key: "_focus",
            value: function _focus() {
                this.patch((0, _totemstyle.getFocusedStyle)(this._style));
            }
        },
        {
            key: "_unfocus",
            value: function _unfocus() {
                this.patch(_totemstyle.unFocusedStyle);
            }
        },
        {
            key: "_handleEnter",
            value: function _handleEnter() {
                this.signal(_signals.SELECTED_SIGNAL, this._item);
                return true;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Border: {
                        rect: true,
                        shader: {
                            type: _focusshader.default
                        }
                    },
                    Image: {
                        shader: {
                            type: _imageshader.default
                        }
                    },
                    TopLeftIcon: {
                        type: _totemconstants.ICONS_TYPES[_templates.ICON_POSITION.TOP_LEFT]
                    },
                    TopRightIcon: {
                        type: _totemconstants.ICONS_TYPES[_templates.ICON_POSITION.TOP_RIGHT]
                    },
                    BottomRightIcon: {
                        type: _totemconstants.ICONS_TYPES[_templates.ICON_POSITION.BOTTOM_RIGHT]
                    },
                    Incentive: {
                        type: _incentivecomponent.default
                    }
                }, (0, _totemstyle.getInitialStyle)());
            }
        }
    ]);
    return Totem;
}(_sdk.Lightning.Component);
Totem.Templates = _totemconstants.templates;
Totem.Sizes = _totemconstants.sizes;
Totem.ImageOptions = _totemconstants.imageOptions;


/***/ }),

/***/ 85110:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    imageOptions: function() {
        return imageOptions;
    },
    sizes: function() {
        return sizes;
    },
    templates: function() {
        return templates;
    }
});
var _export_star = __webpack_require__(37668);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(52318);
var _sizes = __webpack_require__(82699);
var _totemconstants = _export_star._(__webpack_require__(45449), exports);
var templates = {
    Totem: "Totem"
};
var RATIO = 5 / 2;
var _getElementSize = (0, _sizes.getElementSize)(_totemconstants.ITEMS_BY_BREAKPOINTS, RATIO, templates.Totem), sizes = _getElementSize.sizes, imageOptions = _getElementSize.imageOptions;


/***/ }),

/***/ 13063:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ICON_HEIGHT: function() {
        return ICON_HEIGHT;
    },
    LOCK_ICON_HEIGHT: function() {
        return LOCK_ICON_HEIGHT;
    },
    PADDING_HORIZONTAL: function() {
        return PADDING_HORIZONTAL;
    },
    PADDING_VERTICAL: function() {
        return PADDING_VERTICAL;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getFocusedStyle: function() {
        return getFocusedStyle;
    },
    getIcon: function() {
        return getIcon;
    },
    getIconViewBox: function() {
        return getIconViewBox;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    unFocusedStyle: function() {
        return unFocusedStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(37815);
var _constants = __webpack_require__(34952);
var _memoize = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34736));
var _style = __webpack_require__(65082);
var _focus = __webpack_require__(78506);
var _colors = __webpack_require__(8426);
var _totemconstants = __webpack_require__(85110);
var _sizes = __webpack_require__(82699);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var ICON_HEIGHT = (_obj = {}, _define_property._(_obj, _constants.HD, 24), _define_property._(_obj, _constants.FULL_HD, 32), _obj);
var _obj1;
var LOCK_ICON_HEIGHT = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 32), _define_property._(_obj1, _constants.FULL_HD, 40), _obj1);
var PADDING_VERTICAL = 4;
var PADDING_HORIZONTAL = 8;
var getIcon = function(icons, position) {
    return icons ? icons[_totemconstants.ICONS[position]] : null;
};
var getIconViewBox = (0, _memoize.default)(function(screenSize) {
    return {
        h: ICON_HEIGHT[screenSize]
    };
});
var getInitialStyle = function() {
    var screenSize = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext).screenSize;
    var _sizes_templates_Totem_screenSize = _totemconstants.sizes[_totemconstants.templates.Totem][screenSize], w = _sizes_templates_Totem_screenSize.w, h = _sizes_templates_Totem_screenSize.h;
    var borderSize = _focus.BORDER_WIDTH[screenSize];
    var borderOffset = borderSize * 2;
    return {
        Border: {
            w: w + borderOffset,
            h: h + borderOffset,
            x: -borderSize,
            y: -borderSize,
            color: _colors.TRANSPARENT,
            shader: {
                radius: _focus.BORDER_RADIUS[screenSize],
                outline: _focus.BORDER_WIDTH[screenSize],
                strokeColor: _colors.TRANSPARENT,
                innerColor: _colors.TRANSPARENT
            }
        },
        Image: {
            w: w,
            h: h,
            shader: {
                radius: _focus.BORDER_RADIUS[screenSize]
            }
        },
        TopLeftIcon: {
            x: PADDING_HORIZONTAL,
            y: PADDING_VERTICAL
        },
        TopRightIcon: {
            alpha: 0.8,
            x: w - PADDING_HORIZONTAL - ICON_HEIGHT[screenSize],
            y: PADDING_VERTICAL
        },
        BottomRightIcon: {
            mountX: 1,
            x: w - PADDING_HORIZONTAL,
            y: h - PADDING_VERTICAL - ICON_HEIGHT[screenSize]
        },
        Incentive: {
            x: _sizes.middle,
            y: _sizes.middle,
            mount: 0.5
        }
    };
};
var getFocusedStyle = (0, _memoize.default)(function(param) {
    var colorMode = param.colorMode;
    return {
        Border: {
            smooth: {
                scale: _focus.SCALE_FOCUSED,
                "shader.strokeColor": _focus.BORDER_COLOR[colorMode],
                "shader.innerColor": _focus.INNER_BORDER_COLOR[colorMode],
                "shader.scale": _focus.SCALE_FOCUSED
            }
        },
        Image: {
            smooth: {
                scale: _focus.SCALE_FOCUSED,
                "shader.scale": _focus.SCALE_FOCUSED
            }
        }
    };
}, _style.cacheResolver);
var unFocusedStyle = {
    Border: {
        smooth: {
            scale: 1,
            "shader.strokeColor": _colors.TRANSPARENT,
            "shader.innerColor": _colors.TRANSPARENT,
            "shader.scale": 1.0
        }
    },
    Image: {
        smooth: {
            scale: 1,
            "shader.scale": 1.0
        }
    }
};


/***/ }),

/***/ 8426:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/**
 * NOTE: The colors listed here are not part of any theme but a set of utility constants
 * that is provided for a better readability when managing some colors-related math
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    TRANSPARENT: function() {
        return TRANSPARENT;
    },
    WHITE: function() {
        return WHITE;
    }
});
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(52318);
var WHITE = 0xffffffff;
var TRANSPARENT = 0x00000000;


/***/ }),

/***/ 41445:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BORDER_COLOR: function() {
        return BORDER_COLOR;
    },
    BORDER_RADIUS: function() {
        return BORDER_RADIUS;
    },
    BORDER_WIDTH: function() {
        return BORDER_WIDTH;
    },
    INNER_BORDER_COLOR: function() {
        return INNER_BORDER_COLOR;
    }
});
var _define_property = __webpack_require__(21228);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(45538);
var _constants = __webpack_require__(34952);
var _theme = __webpack_require__(51397);
var _obj;
var BORDER_WIDTH = (_obj = {}, _define_property._(_obj, _constants.HD, 4), _define_property._(_obj, _constants.FULL_HD, 6), _obj);
var _obj1;
var BORDER_RADIUS = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 4), _define_property._(_obj1, _constants.FULL_HD, 4), _obj1);
var BORDER_COLOR = (0, _theme.makeThemeColor)(_theme.PRIMARY);
var INNER_BORDER_COLOR = (0, _theme.makeThemeColor)(_theme.TERTIARY);


/***/ }),

/***/ 78506:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "SCALE_FOCUSED", ({
    enumerable: true,
    get: function() {
        return SCALE_FOCUSED;
    }
}));
var _export_star = __webpack_require__(37668);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(3009);
_export_star._(__webpack_require__(41445), exports);
var SCALE_FOCUSED = 1.05;


/***/ }),

/***/ 62117:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/* eslint-disable camelcase */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    resetImpressions: function() {
        return resetImpressions;
    },
    track: function() {
        return track;
    },
    trackImpressions: function() {
        return trackImpressions;
    },
    untrack: function() {
        return untrack;
    }
});
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(3009);
var _config = __webpack_require__(67958);
var _analyticsutils = __webpack_require__(2693);
var TRACKING_DEBOUNCE_MS = 1000;
var ANALYTICS_KEY = "tealiumImpression";
var registry = {};
var resetImpressions = function() {
    registry = {};
};
var track = function(block, items) {
    var _loop = function(i) {
        if (!registry[block].some(function(entry) {
            return entry.index === items[i];
        })) {
            registry[block].push({
                index: items[i],
                trackedAt: now
            });
        }
    };
    if (!_config.featureFlipping.impressionTracking) {
        return;
    }
    if (!registry[block]) {
        registry[block] = [];
    }
    var now = Date.now();
    for(var i = 0; i < items.length; i += 1)_loop(i);
};
var untrack = function(block, items) {
    if (!_config.featureFlipping.impressionTracking) {
        return;
    }
    if (!registry[block]) {
        return;
    }
    var now = Date.now();
    registry[block] = registry[block].filter(items ? function(entry) {
        return items.includes(entry.index) ? now - entry.trackedAt > TRACKING_DEBOUNCE_MS : true;
    } : function(entry) {
        return now - entry.trackedAt > TRACKING_DEBOUNCE_MS;
    });
};
var trackImpressions = function(layout) {
    if (!_config.featureFlipping.impressionTracking) {
        return;
    }
    if (!layout || !layout.blocks || !layout.blocks.length) {
        return;
    }
    var blockIndexMap = Object.keys(registry).map(function(value) {
        return parseInt(value, 10);
    });
    var list_of_block_viewed = [];
    var list_of_item_viewed = [];
    for(var i = 0; i < blockIndexMap.length; i += 1){
        var blockIndex = blockIndexMap[i];
        var block = layout.blocks[blockIndex];
        if (!block || !block.content || !block.content.items) {
            continue;
        }
        var blockImpression = _object_spread_props._(_object_spread._({}, block.analytics && block.analytics[ANALYTICS_KEY]), {
            block_rank: blockIndex
        });
        var minTimestamp = Number.POSITIVE_INFINITY;
        for(var j = 0; j < registry[blockIndex].length; j += 1){
            var registryEntry = registry[blockIndex][j];
            var item = block.content.items[registryEntry.index];
            if (!item) {
                continue;
            }
            if (registryEntry.trackedAt < minTimestamp) {
                minTimestamp = registryEntry.trackedAt;
            }
            list_of_item_viewed.push(_object_spread_props._(_object_spread._({}, item.analytics && item.analytics[ANALYTICS_KEY]), {
                hit_timestamp: registryEntry.trackedAt,
                block_rank: blockIndex,
                item_rank: registryEntry.index
            }));
        }
        blockImpression.hit_timestamp = minTimestamp;
        list_of_block_viewed.push(blockImpression);
    }
    (0, _analyticsutils.sendImpressionEvent)(layout.analytics || {}, list_of_block_viewed, list_of_item_viewed);
    resetImpressions();
};


/***/ }),

/***/ 82699:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    SCREEN_HEIGHT: function() {
        return _constants.SCREEN_HEIGHT;
    },
    SCREEN_WIDTH: function() {
        return _constants.SCREEN_WIDTH;
    },
    getCenter: function() {
        return getCenter;
    },
    getElementSize: function() {
        return getElementSize;
    },
    getScreenSize: function() {
        return getScreenSize;
    },
    identity: function() {
        return identity;
    },
    middle: function() {
        return middle;
    },
    proportional: function() {
        return proportional;
    }
});
var _define_property = __webpack_require__(21228);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
var _constants = __webpack_require__(34952);
var identity = function(value) {
    return value;
};
var proportional = function(percent) {
    return function(value) {
        return Math.round(value * percent);
    };
};
var middle = proportional(0.5);
var getScreenSize = function() {
    return window.innerHeight <= 720 ? _constants.HD : _constants.FULL_HD;
};
var getCenter = function(parentSize, childSize) {
    return Math.round((parentSize - childSize) / 2);
};
var getElementSize = function(itemsByBreakpoints, ratio, templateName) {
    var _sizes = [
        _constants.HD,
        _constants.FULL_HD
    ].reduce(function(_, screenSize) {
        if (!itemsByBreakpoints[screenSize]) {
            throw new Error("Items per breakpoint for size ".concat(screenSize, " is not defined"));
        }
        var width = (_constants.SCREEN_WIDTH[screenSize] - (_constants.SIDENAV_WIDTH[screenSize] + _constants.LAYOUT_LEFT_PADDING[screenSize] + _constants.safetyMargins.horizontal[screenSize]) - _constants.CONTENT_GAP[screenSize] * (itemsByBreakpoints[screenSize] - 1)) / itemsByBreakpoints[screenSize];
        var height = Math.round(width * ratio);
        return _object_spread_props._(_object_spread._({}, _), _define_property._({}, screenSize, {
            w: Math.round(width),
            h: height
        }));
    }, {});
    var _imageOptions = [
        _constants.HD,
        _constants.FULL_HD
    ].reduce(function(_, screenSize) {
        return _object_spread_props._(_object_spread._({}, _), _define_property._({}, screenSize, {
            PRIMARY: {
                width: _sizes[screenSize].w,
                height: _sizes[screenSize].h
            }
        }));
    }, {});
    return {
        sizes: _define_property._({}, templateName, _sizes),
        imageOptions: _define_property._({}, templateName, _imageOptions)
    };
};


/***/ }),

/***/ 65082:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    FOCUSED_Z_INDEX: function() {
        return FOCUSED_Z_INDEX;
    },
    UNFOCUSED_Z_INDEX: function() {
        return UNFOCUSED_Z_INDEX;
    },
    cacheResolver: function() {
        return cacheResolver;
    },
    makeDefaultStylingContext: function() {
        return makeDefaultStylingContext;
    }
});
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
var _theme = __webpack_require__(51397);
var _sizes = __webpack_require__(82699);
var FOCUSED_Z_INDEX = 10;
var UNFOCUSED_Z_INDEX = 0;
var cacheResolver = function(context) {
    return context ? Object.keys(context).map(function(key) {
        return "".concat(key, "=").concat(context[key]);
    }).join(",") : "";
};
var makeDefaultStylingContext = function() {
    return {
        screenSize: (0, _sizes.getScreenSize)(),
        colorMode: _theme.DEFAULT_MODE
    };
};


/***/ }),

/***/ 88229:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/**
 * Creates Lightning template patch for applying of a text string to a content template label
 * @see https://rdkcentral.github.io/Lightning/docs/textures/text
 *
 * @param {string} text string to display
 * @param {number} wordWrapWidth maximal text width after which there will be a line break
 * @param {number} color text color to apply
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ICON_POSITION: function() {
        return ICON_POSITION;
    },
    areContentItemsEqual: function() {
        return areContentItemsEqual;
    },
    makeTextPatch: function() {
        return makeTextPatch;
    }
});
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
var makeTextPatch = function(text, wordWrapWidth, color) {
    return {
        visible: Boolean(text),
        color: color,
        text: {
            text: text,
            wordWrapWidth: wordWrapWidth
        }
    };
};
var areContentItemsEqual = function(first, second) {
    return first && second ? first.id === second.id : false;
};
var ICON_POSITION = {
    TOP_LEFT: 0,
    TOP_RIGHT: 1,
    BOTTOM_RIGHT: 3,
    BOTTOM_LEFT: 4,
    CENTER: 5
};


/***/ }),

/***/ 67179:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    UNLOADED_TEXTURE_ALPHA: function() {
        return UNLOADED_TEXTURE_ALPHA;
    },
    contain: function() {
        return contain;
    },
    cover: function() {
        return cover;
    },
    makeTextureDescriptor: function() {
        return makeTextureDescriptor;
    }
});
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
var _sdk = __webpack_require__(29956);
var UNLOADED_TEXTURE_ALPHA = 0.00001;
var makeTextureDescriptor = function(src, w, h, resizeMode) {
    return {
        type: _sdk.Lightning.textures.ImageTexture,
        src: src,
        resizeMode: {
            type: resizeMode,
            w: w,
            h: h
        }
    };
};
var cover = function(src, w, h) {
    return makeTextureDescriptor(src, w, h, "cover");
};
var contain = function(src, w, h) {
    return makeTextureDescriptor(src, w, h, "contain");
};


/***/ }),

/***/ 74314:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "getLayoutTheme", ({
    enumerable: true,
    get: function() {
        return getLayoutTheme;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(52318);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _theme = __webpack_require__(51397);
var getLayoutTheme = function(theme) {
    var parentTheme = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : undefined;
    var source = theme || {};
    var parent = parentTheme || {};
    var result = {
        backgroundColor: (0, _theme.hexToARGB)(source.backgroundColor, 1),
        backgroundImage: (0, _get.default)(source, "backgroundImage.id") || "",
        foregroundImage: (0, _get.default)(source, "foregroundImage.id") || "",
        colorScheme: source.colorScheme || parent.colorScheme || _theme.DEFAULT_MODE
    };
    return result;
};


/***/ }),

/***/ 11559:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    HOLDER: function() {
        return HOLDER;
    },
    ITEMS_TO_KEEP_BETWEEN_SCREENS: function() {
        return ITEMS_TO_KEEP_BETWEEN_SCREENS;
    },
    PAGE_STATE: function() {
        return PAGE_STATE;
    },
    PLACEHOLDER: function() {
        return PLACEHOLDER;
    },
    backToBuffer: function() {
        return backToBuffer;
    },
    cleanupBuffer: function() {
        return cleanupBuffer;
    },
    cleanupVirtualizationCache: function() {
        return cleanupVirtualizationCache;
    },
    getFromBuffer: function() {
        return getFromBuffer;
    },
    getOrCreateTemplatesHolder: function() {
        return getOrCreateTemplatesHolder;
    }
});
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(88801);
var PLACEHOLDER = Object.freeze({
    id: "placeholder"
});
var ITEMS_TO_KEEP_BETWEEN_SCREENS = 10;
var HOLDER = {};
var PAGE_STATE = {
    LOADED: "loaded",
    MISSING: "missing",
    LOADING: "loading"
};
var getOrCreateTemplatesHolder = function(template) {
    if (!HOLDER[template]) {
        HOLDER[template] = [];
    }
    return HOLDER[template];
};
var getFromBuffer = function(template) {
    var holder = getOrCreateTemplatesHolder(template);
    if (holder.length) {
        return holder.pop();
    }
    return null;
};
var backToBuffer = function(view) {
    if (!view || !view.template) {
        return;
    }
    var holder = getOrCreateTemplatesHolder(view.template);
    if (!holder.includes(view)) {
        holder.push(view);
    }
};
var cleanupBuffer = function(view) {
    if (!view || !view.template) {
        return;
    }
    var holder = HOLDER[view.template];
    if (!holder || holder.length <= ITEMS_TO_KEEP_BETWEEN_SCREENS) {
        return;
    }
    HOLDER[view.template] = holder.filter(function(bufferedView) {
        return bufferedView !== view;
    });
};
var cleanupVirtualizationCache = function() {
    Object.keys(HOLDER).forEach(function(key) {
        if (Array.isArray(HOLDER[key])) {
            HOLDER[key].forEach(function(view) {
                if (view && view.parent) {
                    view.parent.childList.remove(view);
                }
            });
        }
        delete HOLDER[key];
    });
};


/***/ }),

/***/ 62959:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "Account", ({
    enumerable: true,
    get: function() {
        return Account;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _create_super = __webpack_require__(6400);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(37815);
var _sdk = __webpack_require__(29956);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _accountconnector = /*#__PURE__*/ _interop_require_default._(__webpack_require__(76135));
var _mosaicGridcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(3478));
var _apputils = __webpack_require__(60368);
var _accountutils = __webpack_require__(12779);
var _accountstyle = __webpack_require__(55336);
var _ctaactions = __webpack_require__(32067);
var _signals = __webpack_require__(2109);
var _mosaicGridconstant = __webpack_require__(16166);
var _mosaicGridstyle = __webpack_require__(67143);
var _userInfoBarcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(18559));
var _deviceInfoBarcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(98154));
var _sizes = __webpack_require__(82699);
var _accountconstants = __webpack_require__(23630);
var _accountCardcomponent = __webpack_require__(17547);
var _accountCardstyle = __webpack_require__(9097);
var Account = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(Account, _Lightning_Component);
    var _super = _create_super._(Account);
    function Account() {
        _class_call_check._(this, Account);
        return _super.apply(this, arguments);
    }
    _create_class._(Account, [
        {
            key: "_construct",
            value: function _construct() {
                this._navigation = null;
                this._isProfileSelected = null;
                this._style = _accountstyle.defaultContext;
            }
        },
        {
            key: "_active",
            value: function _active() {
                (0, _apputils.removeSplashScreen)();
            }
        },
        {
            key: "_attach",
            value: function _attach() {
                this._unsubscribe = (0, _accountconnector.default)(this);
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                if (this._unsubscribe) {
                    this._unsubscribe();
                    this._unsubscribe = null;
                }
            }
        },
        {
            key: "navigation",
            set: function set(value) {
                if (!value || this._navigation === value) {
                    return;
                }
                this._navigation = value;
                this._fillGrid((0, _accountutils.filterNavigationEntries)(value, _lightningjsredux.default.getState()));
            }
        },
        {
            key: "profileUsername",
            set: function set(value) {
                if (!value) {
                    return;
                }
                this.tag("UserInfoBar").userName = value;
            }
        },
        {
            key: "profilePhotoId",
            set: function set(value) {
                this.tag("UserInfoBar").photoId = value;
            }
        },
        {
            key: "selectedProfile",
            set: function set(value) {
                this._isProfileSelected = Boolean(value);
                this.tag("UserInfoBar").visible = this._isProfileSelected;
            }
        },
        {
            key: "_fillGrid",
            value: function _fillGrid(items) {
                if (!items) {
                    this._setState("InfoBar");
                    return;
                }
                var screenSize = this._style.screenSize;
                var rowsCount = Math.ceil(items.length / _mosaicGridstyle.ITEMS_PER_ROW[screenSize]);
                var itemSize = _accountCardstyle.MOSAIC_CARD_SIZE[screenSize];
                var gap = _mosaicGridconstant.CONTENT_GAP[screenSize];
                var mosaicHeight = rowsCount * (itemSize.h + gap) - gap;
                var mosaicContainerHeight = _sizes.SCREEN_HEIGHT[screenSize];
                this.tag("Grid").patch({
                    y: Math.max(Math.round((mosaicContainerHeight - mosaicHeight) / 2), _accountstyle.GRID_MARGIN_TOP[screenSize]),
                    data: {
                        items: items,
                        itemType: _accountCardcomponent.AccountCard,
                        itemSize: itemSize
                    },
                    signals: _define_property._({}, _signals.SELECTED_SIGNAL, "_handleSelected")
                });
                this._setState("Grid");
            }
        },
        {
            key: "_handleUp",
            value: function _handleUp() {
                if (this._isProfileSelected) this._setState("InfoBar");
                return true;
            }
        },
        {
            key: "_handleDown",
            value: function _handleDown() {
                if (this.state === "InfoBar") {
                    this._setState("Grid");
                }
                return true;
            }
        },
        {
            key: "_handleSelected",
            value: function _handleSelected(item) {
                _lightningjsredux.default.dispatch((0, _ctaactions.createItemAction)({
                    item: _object_spread_props._(_object_spread._({}, item), {
                        action: item
                    })
                }));
            }
        },
        {
            key: "_handleChangeProfile",
            value: function _handleChangeProfile() {
                _lightningjsredux.default.dispatch((0, _ctaactions.createItemAction)((0, _accountutils.makeProfilesGateAction)()));
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Background: {
                        rect: true
                    },
                    ProfileInfo: {},
                    UserInfoBar: {
                        type: _userInfoBarcomponent.default,
                        signals: _define_property._({}, _accountconstants.CHANGE_PROFILE_SIGNAL, "_handleChangeProfile")
                    },
                    Grid: {
                        type: _mosaicGridcomponent.default,
                        signals: _define_property._({}, _signals.SELECTED_SIGNAL, "_handleSelected")
                    },
                    DeviceInfo: {
                        type: _deviceInfoBarcomponent.default
                    }
                }, (0, _accountstyle.getInitialStyle)());
            }
        },
        {
            key: "_states",
            value: function _states() {
                return [
                    /*#__PURE__*/ function(_this) {
                        _inherits._(Grid, _this);
                        var _super = _create_super._(Grid);
                        function Grid() {
                            _class_call_check._(this, Grid);
                            return _super.apply(this, arguments);
                        }
                        _create_class._(Grid, [
                            {
                                key: "_getFocused",
                                value: function _getFocused() {
                                    return this.tag("Grid");
                                }
                            }
                        ]);
                        return Grid;
                    }(this),
                    /*#__PURE__*/ function(_this) {
                        _inherits._(InfoBar, _this);
                        var _super = _create_super._(InfoBar);
                        function InfoBar() {
                            _class_call_check._(this, InfoBar);
                            return _super.apply(this, arguments);
                        }
                        _create_class._(InfoBar, [
                            {
                                key: "_getFocused",
                                value: function _getFocused() {
                                    return this.tag("UserInfoBar");
                                }
                            }
                        ]);
                        return InfoBar;
                    }(this)
                ];
            }
        }
    ]);
    return Account;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 76135:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(37815);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _layoutselectors = __webpack_require__(53368);
var _userselectors = __webpack_require__(41845);
var mapControllers = function(instance) {
    return {
        layoutNavigation: {
            selector: _layoutselectors.getLayoutNavigation,
            shouldBeInvokedOnConnect: true,
            callback: function(value) {
                instance.navigation = value;
            }
        },
        profileUsername: {
            selector: _userselectors.getProfileUsername,
            shouldBeInvokedOnConnect: true,
            callback: function(value) {
                instance.profileUsername = value;
            }
        },
        profileSelected: {
            selector: _userselectors.getSelectedProfile,
            shouldBeInvokedOnConnect: true,
            callback: function(value) {
                instance.selectedProfile = value;
            }
        },
        profilePhotoId: {
            selector: _userselectors.getProfilePhotoId,
            shouldBeInvokedOnConnect: true,
            callback: function(value) {
                instance.profilePhotoId = value;
            }
        }
    };
};
var _default = _lightningjsredux.default.control(mapControllers);


/***/ }),

/***/ 23630:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "CHANGE_PROFILE_SIGNAL", ({
    enumerable: true,
    get: function() {
        return CHANGE_PROFILE_SIGNAL;
    }
}));
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(3009);
var CHANGE_PROFILE_SIGNAL = "changeProfile";


/***/ }),

/***/ 55336:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    GRID_MARGIN_TOP: function() {
        return GRID_MARGIN_TOP;
    },
    GRID_PADDING_LEFT: function() {
        return GRID_PADDING_LEFT;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(45538);
var _memoize = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34736));
var _constants = __webpack_require__(34952);
var _theme = __webpack_require__(51397);
var _sizes = __webpack_require__(82699);
var _style = __webpack_require__(65082);
var _sidenavconstants = __webpack_require__(74842);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var GRID_MARGIN_TOP = (_obj = {}, _define_property._(_obj, _constants.HD, 112), _define_property._(_obj, _constants.FULL_HD, 256), _obj);
var _obj1;
var GRID_PADDING_LEFT = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 40), _define_property._(_obj1, _constants.FULL_HD, 40), _obj1);
var colors = {
    background: (0, _theme.makeThemeColor)(_theme.TERTIARY)
};
var getInitialStyle = (0, _memoize.default)(function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext, screenSize = _ref.screenSize, colorMode = _ref.colorMode;
    return {
        Background: {
            w: _sizes.SCREEN_WIDTH[screenSize],
            h: _sizes.SCREEN_HEIGHT[screenSize],
            color: colors.background[colorMode]
        },
        Grid: {
            y: GRID_MARGIN_TOP[screenSize],
            x: _sidenavconstants.WIDTH[screenSize] + GRID_PADDING_LEFT[screenSize]
        }
    };
}, _style.cacheResolver);


/***/ }),

/***/ 12779:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    filterNavigationEntries: function() {
        return filterNavigationEntries;
    },
    getExtraItem: function() {
        return getExtraItem;
    },
    getMapProfileLocks: function() {
        return getMapProfileLocks;
    },
    getProfileEntriesFilter: function() {
        return getProfileEntriesFilter;
    },
    isActionSupported: function() {
        return isActionSupported;
    },
    makeAuthLockAction: function() {
        return makeAuthLockAction;
    },
    makeProfilesGateAction: function() {
        return makeProfilesGateAction;
    },
    mapProfileEntries: function() {
        return mapProfileEntries;
    },
    mapProfileLocks: function() {
        return mapProfileLocks;
    },
    mapProfileUnpairedLocks: function() {
        return mapProfileUnpairedLocks;
    }
});
var _interop_require_default = __webpack_require__(81200);
var _to_consumable_array = __webpack_require__(30005);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(52318);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _constants = __webpack_require__(34952);
var _config = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67958));
var _fidosdk = __webpack_require__(19804);
var _index = __webpack_require__(14910);
var _ctaconstants = /*#__PURE__*/ _interop_require_default._(__webpack_require__(77713));
var _ctautils = __webpack_require__(42533);
var _pairingselectors = __webpack_require__(59739);
var _featuresselectors = __webpack_require__(76109);
var _pairingconstants = __webpack_require__(25994);
var _accountutils = __webpack_require__(59544);
var _userselectors = __webpack_require__(41845);
var REPLACEMENT_MAP = {
    account_consentmanagement: _constants.OPTOUT
};
var makeProfilesGateAction = function() {
    return {
        item: {
            action: {
                target: {
                    type: "layout",
                    value_layout: {
                        type: _constants.FRONTSPACE,
                        id: _constants.PROFILES_GATE
                    }
                },
                analytics: {
                    key: "pressSwitchProfileButton",
                    googleAnalytics: {
                        eventAction: "menu_account",
                        eventCategory: "browsing",
                        eventLabel: (0, _index.t)("profile.switch")
                    },
                    tealium: {
                        event_action: "menu_account",
                        event_category: "browsing",
                        event_label: (0, _index.t)("profile.switch")
                    }
                }
            }
        }
    };
};
var makeAuthLockAction = function() {
    return {
        id: "login",
        picto: {
            type: "icon",
            name: "Disconnected"
        },
        groups: [],
        label: (0, _index.t)("user.login"),
        target: {
            type: "lock",
            value_lock: {
                reason: _pairingconstants.REQUIRE_AUTH,
                originalTarget: {
                    type: "layout",
                    value_layout: {
                        type: _fidosdk.LAYOUT_ENTITIES.alias,
                        id: "home"
                    }
                }
            }
        }
    };
};
var mapProfileUnpairedLocks = function(item) {
    return item;
};
var getProfileEntriesFilter = function(state) {
    var profileNavigationFeatures = (0, _accountutils.getNavigationFeatures)(state);
    return function(entry) {
        return profileNavigationFeatures[entry.id] !== false;
    };
};
var mapProfileEntries = function(item, state) {
    var profileEntriesFilter = getProfileEntriesFilter(state);
    return (0, _get.default)(item, "subEntries", []).filter(profileEntriesFilter);
};
var mapProfileLocks = function(item) {
    var isLockAction = (0, _get.default)(item, "target.type", "") === _ctaconstants.default.LOCK;
    var isReasonRequireAuth = (0, _get.default)(item, "target.value_lock.reason", "") === _pairingconstants.REQUIRE_AUTH;
    var originalTarget = (0, _get.default)(item, "target.value_lock.originalTarget", null);
    item.target = isLockAction && isReasonRequireAuth && originalTarget ? originalTarget : item.target;
    return item;
};
var getMapProfileLocks = function(state) {
    var isUserPaired = (0, _pairingselectors.getPairingStatus)(state) === _pairingconstants.PAIRING_STATUS_PAIRED;
    return isUserPaired ? mapProfileLocks : mapProfileUnpairedLocks;
};
var isActionSupported = function(entry) {
    return _config.default.cta.supportedActions.some(function(actionType) {
        return actionType === (0, _ctautils.getItemActionType)({
            action: entry
        });
    });
};
var getExtraItem = function(state) {
    if (!(0, _featuresselectors.getOpenCatalogFeature)(state) || (0, _userselectors.getPairingUid)(state)) {
        return [];
    }
    return [
        makeAuthLockAction()
    ];
};
var filterNavigationEntries = function(value, state) {
    var _mapProfileEntries_map_map_filter;
    var result = value && value.entries && value.entries.flatMap(function(entry) {
        return entry;
    }).find(function(item) {
        return (0, _ctautils.getItemActionType)(item.entry) === _constants.PROFILE;
    });
    if (!(0, _get.default)(result, "subEntries.length")) {
        return null;
    }
    return (_mapProfileEntries_map_map_filter = mapProfileEntries(result, state).map(getMapProfileLocks(state)).map(function(item) {
        if (!item.target || !item.target.type) {
            return item;
        }
        var action = item.target["value_".concat(item.target.type)];
        if (action) {
            action.reference = REPLACEMENT_MAP[action.reference] || action.reference;
        }
        return item;
    }).filter(isActionSupported)).concat.apply(_mapProfileEntries_map_map_filter, _to_consumable_array._(getExtraItem(state)));
};


/***/ }),

/***/ 17547:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "AccountCard", ({
    enumerable: true,
    get: function() {
        return AccountCard;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _sdk = __webpack_require__(29956);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _iconcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(70160));
var _accountCardstyle = __webpack_require__(9097);
var _signals = __webpack_require__(2109);
var _focusshader = /*#__PURE__*/ _interop_require_default._(__webpack_require__(25906));
var _textures = __webpack_require__(67179);
var AccountCard = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(AccountCard, _Lightning_Component);
    var _super = _create_super._(AccountCard);
    function AccountCard() {
        _class_call_check._(this, AccountCard);
        return _super.apply(this, arguments);
    }
    _create_class._(AccountCard, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _accountCardstyle.defaultContext;
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                this.tag("Icon").removeAllListeners("txLoaded");
            }
        },
        {
            key: "item",
            set: function set(value) {
                var _this = this;
                this._item = value;
                var imageUrl = (0, _get.default)(this._item, "image.src", "");
                this.tag("Icon").once("txLoaded", function() {
                    _this.tag("Icon").setSmooth("alpha", 1);
                });
                this.patch({
                    Image: {
                        texture: imageUrl && imageUrl.length ? (0, _textures.cover)(imageUrl, _accountCardstyle.MOSAIC_CARD_SIZE[this._style.screenSize].w, _accountCardstyle.MOSAIC_CARD_SIZE[this._style.screenSize].h) : null
                    },
                    Content: {
                        Label: {
                            text: {
                                text: value.label
                            }
                        },
                        IconWrapper: {
                            Icon: {
                                alpha: 0.0001,
                                iconData: {
                                    picto: value.picto,
                                    viewBox: (0, _accountCardstyle.getIconViewBox)(this._style.screenSize)
                                }
                            }
                        }
                    }
                });
            }
        },
        {
            key: "_focus",
            value: function _focus() {
                this.patch((0, _accountCardstyle.getFocusedStyle)(this._style));
            }
        },
        {
            key: "_unfocus",
            value: function _unfocus() {
                this.patch((0, _accountCardstyle.getUnfocusedStyle)(this._style));
            }
        },
        {
            key: "_handleEnter",
            value: function _handleEnter() {
                this.signal(_signals.SELECTED_SIGNAL, this._item);
                return true;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Border: {
                        rect: true,
                        shader: {
                            type: _focusshader.default
                        }
                    },
                    Background: {
                        rect: true,
                        shader: {
                            type: _sdk.Lightning.shaders.RoundedRectangle
                        }
                    },
                    Image: {
                        shader: {
                            type: _sdk.Lightning.shaders.RoundedRectangle
                        }
                    },
                    Content: {
                        IconWrapper: {
                            Icon: {
                                type: _iconcomponent.default
                            }
                        },
                        Label: {}
                    }
                }, (0, _accountCardstyle.getInitialStyle)());
            }
        }
    ]);
    return AccountCard;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 9097:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BORDER_RADIUS: function() {
        return BORDER_RADIUS;
    },
    GAP: function() {
        return GAP;
    },
    ICON_SIZES: function() {
        return ICON_SIZES;
    },
    MOSAIC_CARD_SIZE: function() {
        return MOSAIC_CARD_SIZE;
    },
    PADDING: function() {
        return PADDING;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getFocusedStyle: function() {
        return getFocusedStyle;
    },
    getIconViewBox: function() {
        return getIconViewBox;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    },
    getUnfocusedStyle: function() {
        return getUnfocusedStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(52318);
var _memoize = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34736));
var _theme = __webpack_require__(51397);
var _constants = __webpack_require__(34952);
var _typography = __webpack_require__(18411);
var _sizes = __webpack_require__(82699);
var _style = __webpack_require__(65082);
var _focus = __webpack_require__(78506);
var _colors = __webpack_require__(8426);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var MOSAIC_CARD_SIZE = (_obj = {}, _define_property._(_obj, _constants.HD, {
    w: 279,
    h: 135
}), _define_property._(_obj, _constants.FULL_HD, {
    w: 336,
    h: 189
}), _obj);
var PADDING = 8;
var colors = {
    background: (0, _theme.makeThemeColor)(_theme.PRIMARY, 0.1),
    backgroundFocused: (0, _theme.makeThemeColor)(_theme.PRIMARY, 0.3),
    icon: (0, _theme.makeThemeColor)(_theme.PRIMARY),
    label: (0, _theme.makeThemeColor)(_theme.PRIMARY)
};
var _obj1;
var ICON_SIZES = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 48), _define_property._(_obj1, _constants.FULL_HD, 56), _obj1);
var _obj2;
var GAP = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 12), _define_property._(_obj2, _constants.FULL_HD, 24), _obj2);
var _obj3;
var BORDER_RADIUS = (_obj3 = {}, _define_property._(_obj3, _constants.HD, 4), _define_property._(_obj3, _constants.FULL_HD, 4), _obj3);
var getIconViewBox = (0, _memoize.default)(function(screenSize) {
    return {
        h: ICON_SIZES[screenSize]
    };
});
var getInitialStyle = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext, screenSize = _ref.screenSize, colorMode = _ref.colorMode;
    var _MOSAIC_CARD_SIZE_screenSize = MOSAIC_CARD_SIZE[screenSize], w = _MOSAIC_CARD_SIZE_screenSize.w, h = _MOSAIC_CARD_SIZE_screenSize.h;
    var borderSize = _focus.BORDER_WIDTH[screenSize];
    var borderOffset = borderSize * 2;
    return {
        Border: {
            w: w + borderOffset,
            h: h + borderOffset,
            x: -borderSize,
            y: -borderSize,
            color: _colors.TRANSPARENT,
            shader: {
                radius: BORDER_RADIUS[screenSize],
                outline: _focus.BORDER_WIDTH[screenSize],
                strokeColor: _colors.TRANSPARENT,
                innerColor: _colors.TRANSPARENT
            }
        },
        Background: {
            w: w,
            h: h,
            shader: {
                fillColor: colors.background[colorMode],
                radius: BORDER_RADIUS[screenSize]
            }
        },
        Image: {
            w: w,
            h: h,
            shader: {
                radius: BORDER_RADIUS[screenSize]
            }
        },
        Content: {
            w: w,
            h: h,
            flex: {
                direction: "column",
                alignItems: "center",
                justifyContent: "center"
            },
            IconWrapper: {
                w: w,
                h: ICON_SIZES[screenSize] + GAP[screenSize],
                Icon: {
                    mountX: 0.5,
                    x: _sizes.middle,
                    color: colors.icon[colorMode]
                }
            },
            Label: {
                color: colors.label[colorMode],
                text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT.BERLIN_2, screenSize)), {
                    wordWrapWidth: w - PADDING * 2,
                    wordWrap: true,
                    wordBreak: true,
                    advancedRenderer: true,
                    textAlign: "center",
                    verticalAlign: "bottom",
                    maxLines: 2,
                    maxLinesSuffix: "..."
                })
            }
        }
    };
};
var getFocusedStyle = function(param) {
    var colorMode = param.colorMode;
    return {
        Border: {
            smooth: {
                scale: _focus.SCALE_FOCUSED,
                "shader.strokeColor": _focus.BORDER_COLOR[colorMode],
                "shader.innerColor": _focus.INNER_BORDER_COLOR[colorMode],
                "shader.scale": _focus.SCALE_FOCUSED
            }
        },
        Background: {
            smooth: {
                scale: _focus.SCALE_FOCUSED,
                "shader.scale": _focus.SCALE_FOCUSED,
                "shader.fillColor": colors.backgroundFocused[colorMode]
            }
        },
        Image: {
            smooth: {
                scale: _focus.SCALE_FOCUSED,
                "shader.scale": _focus.SCALE_FOCUSED
            }
        }
    };
};
var getUnfocusedStyle = function(param) {
    var colorMode = param.colorMode;
    return {
        Border: {
            smooth: {
                scale: 1,
                "shader.strokeColor": _colors.TRANSPARENT,
                "shader.innerColor": _colors.TRANSPARENT,
                "shader.scale": 1.0
            }
        },
        Background: {
            smooth: {
                scale: 1,
                "shader.fillColor": colors.background[colorMode],
                "shader.scale": 1.0
            }
        },
        Image: {
            smooth: {
                scale: 1,
                "shader.scale": 1.0
            }
        }
    };
};


/***/ }),

/***/ 59544:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "getNavigationFeatures", ({
    enumerable: true,
    get: function() {
        return getNavigationFeatures;
    }
}));
var _define_property = __webpack_require__(21228);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(37815);
var _userselectors = __webpack_require__(41845);
var _featuresselectors = __webpack_require__(76109);
var AUTHENTICATED_ONLY = [
    "info",
    "logout"
];
var getNavigationFeatures = function(state) {
    var gdprNoticeFeatureEnabled = (0, _featuresselectors.getGdprNoticeFeature)(state);
    var isAuthenticated = (0, _userselectors.getPairingUid)(state);
    return _object_spread_props._(_object_spread._({}, isAuthenticated ? undefined : AUTHENTICATED_ONLY.reduce(function(acc, entry) {
        return _object_spread_props._(_object_spread._({}, acc), _define_property._({}, entry, false));
    }, {})), {
        privacysettings: gdprNoticeFeatureEnabled,
        // NOTE: we are adding this one on the frontend side
        login: false,
        parentalcontrol: false,
        profilesgate: false
    });
};


/***/ }),

/***/ 53183:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "UserInformation", ({
    enumerable: true,
    get: function() {
        return _qrCodecomponent.QRCodePage;
    }
}));
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(37815);
var _qrCodecomponent = __webpack_require__(37276);


/***/ }),

/***/ 34783:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "UserInformation", ({
    enumerable: true,
    get: function() {
        return _userInformationcomponent.UserInformation;
    }
}));
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(3009);
var _userInformationcomponent = __webpack_require__(53183);


/***/ }),

/***/ 18559:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return UserInfoBar;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(3009);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _buttoncomponent = __webpack_require__(31464);
var _userInfoBarstyle = __webpack_require__(54652);
var _i18n = __webpack_require__(14910);
var _avatarcomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(47094));
var _accountconstants = __webpack_require__(23630);
var UserInfoBar = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(UserInfoBar, _Lightning_Component);
    var _super = _create_super._(UserInfoBar);
    function UserInfoBar() {
        _class_call_check._(this, UserInfoBar);
        return _super.apply(this, arguments);
    }
    _create_class._(UserInfoBar, [
        {
            key: "photoId",
            set: function set(value) {
                this.tag("Avatar").photoId = value;
            }
        },
        {
            key: "userName",
            set: function set(value) {
                this.tag("Name").text.text = value;
            }
        },
        {
            key: "_getFocused",
            value: function _getFocused() {
                return this.tag("ProfileChangeButton");
            }
        },
        {
            key: "_handleEnter",
            value: function _handleEnter() {
                this.signal(_accountconstants.CHANGE_PROFILE_SIGNAL);
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Content: {
                        Avatar: {
                            type: _avatarcomponent.default
                        },
                        Name: {},
                        ProfileChangeButton: {
                            type: _buttoncomponent.Button,
                            label: (0, _i18n.t)("profile.switch")
                        }
                    }
                }, (0, _userInfoBarstyle.getInitialStyle)());
            }
        }
    ]);
    return UserInfoBar;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 54652:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BUTTON_HEIGHT: function() {
        return BUTTON_HEIGHT;
    },
    BUTTON_MARGING_RIGHT: function() {
        return BUTTON_MARGING_RIGHT;
    },
    BUTTON_MARGIN_LEFT: function() {
        return BUTTON_MARGIN_LEFT;
    },
    CONTENT_HEIGHT: function() {
        return CONTENT_HEIGHT;
    },
    CONTENT_WIDTH: function() {
        return CONTENT_WIDTH;
    },
    NAME_MARGIN_LEFT: function() {
        return NAME_MARGIN_LEFT;
    },
    NAME_MARGIN_TOP: function() {
        return NAME_MARGIN_TOP;
    },
    NAME_TEXT_COLOR: function() {
        return NAME_TEXT_COLOR;
    },
    OFFSET_RIGHT: function() {
        return OFFSET_RIGHT;
    },
    OFFSET_TOP: function() {
        return OFFSET_TOP;
    },
    WIDTH: function() {
        return WIDTH;
    },
    getButtonPaddingTop: function() {
        return getButtonPaddingTop;
    },
    getInfoBarOffsetX: function() {
        return getInfoBarOffsetX;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(3009);
var _constants = __webpack_require__(34952);
var _theme = __webpack_require__(51397);
var _typography = __webpack_require__(18411);
var _style = __webpack_require__(65082);
var _makeDefaultStylingContext = (0, _style.makeDefaultStylingContext)(), screenSize = _makeDefaultStylingContext.screenSize, colorMode = _makeDefaultStylingContext.colorMode;
var _obj;
var WIDTH = (_obj = {}, _define_property._(_obj, _constants.HD, 1280), _define_property._(_obj, _constants.FULL_HD, 1920), _obj);
var _obj1;
var OFFSET_TOP = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 44), _define_property._(_obj1, _constants.FULL_HD, 88), _obj1);
var _obj2;
var OFFSET_RIGHT = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 64), _define_property._(_obj2, _constants.FULL_HD, 88), _obj2);
var _obj3;
var CONTENT_HEIGHT = (_obj3 = {}, _define_property._(_obj3, _constants.HD, 48), _define_property._(_obj3, _constants.FULL_HD, 56), _obj3);
var _obj4;
var BUTTON_HEIGHT = (_obj4 = {}, _define_property._(_obj4, _constants.HD, 40), _define_property._(_obj4, _constants.FULL_HD, 56), _obj4);
var _obj5;
var BUTTON_MARGIN_LEFT = (_obj5 = {}, _define_property._(_obj5, _constants.HD, 56), _define_property._(_obj5, _constants.FULL_HD, 72), _obj5);
var _obj6;
var NAME_MARGIN_TOP = (_obj6 = {}, _define_property._(_obj6, _constants.HD, 16), _define_property._(_obj6, _constants.FULL_HD, 18), _obj6);
var _obj7;
var BUTTON_MARGING_RIGHT = (_obj7 = {}, _define_property._(_obj7, _constants.HD, 64), _define_property._(_obj7, _constants.FULL_HD, 88), _obj7);
var NAME_MARGIN_LEFT = 16;
var NAME_TEXT_COLOR = (0, _theme.makeThemeColor)(_theme.PRIMARY)[colorMode];
var CONTENT_WIDTH = (WIDTH[screenSize] - OFFSET_RIGHT[screenSize]) / 2;
var getInfoBarOffsetX = function() {
    return WIDTH[screenSize] - OFFSET_RIGHT[screenSize] - CONTENT_WIDTH;
};
var getButtonPaddingTop = function() {
    return (CONTENT_HEIGHT[screenSize] - BUTTON_HEIGHT[screenSize]) / 2;
};
var getInitialStyle = function() {
    return {
        Content: {
            x: getInfoBarOffsetX(),
            y: OFFSET_TOP[screenSize],
            w: CONTENT_WIDTH,
            h: CONTENT_HEIGHT[screenSize],
            flex: {
                direction: "row",
                wrap: true,
                justifyContent: "flex-end",
                alignContent: "center"
            },
            Avatar: {},
            Name: {
                flexItem: {
                    marginLeft: NAME_MARGIN_LEFT,
                    marginTop: NAME_MARGIN_TOP[screenSize]
                },
                text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT.BERLIN_2, screenSize)), {
                    textColor: NAME_TEXT_COLOR
                })
            },
            ProfileChangeButton: {
                flexItem: {
                    marginLeft: BUTTON_MARGIN_LEFT[screenSize],
                    marginTop: getButtonPaddingTop(),
                    marginRight: BUTTON_MARGING_RIGHT[screenSize]
                }
            }
        }
    };
};


/***/ }),

/***/ 80910:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "VideoControls", ({
    enumerable: true,
    get: function() {
        return VideoControls;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _get = __webpack_require__(60528);
var _get_prototype_of = __webpack_require__(35196);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _create_super = __webpack_require__(6400);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _i18n = __webpack_require__(14910);
var _callToActioncomponent = __webpack_require__(91743);
var _controlscomponent = __webpack_require__(92371);
var _controlsconstants = __webpack_require__(55197);
var _controlsstyle = __webpack_require__(21176);
var _analyticsutils = __webpack_require__(2693);
var _controlsconstants1 = __webpack_require__(40951);
var VideoControls = /*#__PURE__*/ function(Controls) {
    "use strict";
    _inherits._(VideoControls, Controls);
    var _super = _create_super._(VideoControls);
    function VideoControls() {
        _class_call_check._(this, VideoControls);
        return _super.apply(this, arguments);
    }
    _create_class._(VideoControls, [
        {
            key: "_detach",
            value: function _detach() {
                _get._(_get_prototype_of._(VideoControls.prototype), "_detach", this).call(this);
                this._chapter = null;
            }
        },
        {
            key: "chapter",
            set: function set(value) {
                this._chapter = value;
                if (!this._chapter) {
                    this._setSkipButtonVisibilityState(false);
                    return;
                }
                switch(this._chapter.type){
                    case _controlsconstants1.CHAPTERS.INTRO:
                        {
                            this._setSkipButtonVisibilityState(true, (0, _i18n.t)("player.skipIntro"));
                            break;
                        }
                    case _controlsconstants1.CHAPTERS.OPENING_CREDITS:
                        {
                            this._setSkipButtonVisibilityState(true, (0, _i18n.t)("player.skipRecap"));
                            break;
                        }
                    case _controlsconstants1.CHAPTERS.ENDING_CREDITS:
                        {
                            this._setSkipButtonVisibilityState(true, (0, _i18n.t)("player.skipCredits"));
                            break;
                        }
                    default:
                        this._setSkipButtonVisibilityState(false);
                        break;
                }
            }
        },
        {
            key: "_setSkipButtonVisibilityState",
            value: function _setSkipButtonVisibilityState(showButton) {
                var label = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
                var button = this.tag("SkipChapterButton");
                button.label = label || "";
                button.visible = showButton;
                if (this._autoHideDisablingViews.includes(this._focused)) {
                    this._visibleFocusableItems = this._focusableItems.filter(function(item) {
                        return item.visible;
                    });
                    return;
                }
                if (showButton && this.isHidden) {
                    this._visibleFocusableItems = this._focusableItems.filter(function(item) {
                        return item.visible;
                    });
                    this._setIndex(this._visibleFocusableItems.indexOf(button), false);
                } else {
                    this._checkFocusableItems(false);
                    // The _checkFocusableItems moves focus to the first focusable item (i.e. TopBar) while the Player requirements says we need to focus on the ProgressBar
                    if (!showButton) {
                        this._focusTag("Progress");
                    }
                }
                this._refocus();
            }
        },
        {
            key: "_handleEnter",
            value: function _handleEnter() {
                if (!this._chapter || this._focused !== this.tag("SkipChapterButton")) {
                    return false;
                }
                var event = _controlsconstants1.EVENTS[this._chapter.type];
                if (event) {
                    (0, _analyticsutils.sendEvent)({
                        key: event
                    });
                    this.signal(_controlsconstants.SEEK_SIGNAL, this._chapter.tcEnd);
                    this._setSkipButtonVisibilityState(false);
                    return true;
                }
                return false;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                var base = _get._(_get_prototype_of._(VideoControls), "_template", this).call(this);
                return (0, _merge.default)(_object_spread_props._(_object_spread._({}, base), {
                    AuxiliaryButtons: _object_spread_props._(_object_spread._({}, base.AuxiliaryButtons), {
                        SkipChapterButton: {
                            type: _callToActioncomponent.CallToAction
                        }
                    })
                }), (0, _controlsstyle.getInitialStyle)());
            }
        }
    ]);
    return VideoControls;
}(_controlscomponent.Controls);


/***/ }),

/***/ 40951:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    CHAPTERS: function() {
        return CHAPTERS;
    },
    EVENTS: function() {
        return EVENTS;
    }
});
var _define_property = __webpack_require__(21228);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(42578);
var CHAPTERS = {
    INTRO: "intro",
    OPENING_CREDITS: "opening_credits",
    ENDING_CREDITS: "ending_credits"
};
var _obj;
var EVENTS = (_obj = {}, _define_property._(_obj, CHAPTERS.INTRO, "skipIntro"), _define_property._(_obj, CHAPTERS.OPENING_CREDITS, "skipIntro"), _define_property._(_obj, CHAPTERS.ENDING_CREDITS, "skipCredits"), _obj);


/***/ }),

/***/ 21176:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "getInitialStyle", ({
    enumerable: true,
    get: function() {
        return getInitialStyle;
    }
}));
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
var getInitialStyle = function() {
    return {
        AuxiliaryButtons: {
            zIndex: 1,
            SkipChapterButton: {
                mount: 1
            }
        }
    };
};


/***/ }),

/***/ 7503:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "LBanner", ({
    enumerable: true,
    get: function() {
        return LBanner;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(3009);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _lBannerstyle = __webpack_require__(37041);
var _lBannerconnector = /*#__PURE__*/ _interop_require_default._(__webpack_require__(54905));
var _playerconstants = __webpack_require__(7602);
var _http = __webpack_require__(40057);
var _lBannerutils = __webpack_require__(14625);
var LOAD_OFFSET = 10;
var LBanner = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(LBanner, _Lightning_Component);
    var _super = _create_super._(LBanner);
    function LBanner() {
        _class_call_check._(this, LBanner);
        return _super.apply(this, arguments);
    }
    _create_class._(LBanner, [
        {
            key: "_construct",
            value: function _construct() {
                this._trackers = [];
                this._cuePoints = [];
            }
        },
        {
            key: "_attach",
            value: function _attach() {
                this._unsubscribe = (0, _lBannerconnector.default)(this);
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                if (this._unsubscribe) {
                    this._unsubscribe();
                    this._unsubscribe = null;
                }
                if (this._displayTimeout) {
                    clearTimeout(this._displayTimeout);
                }
                this._shown = null;
                this._loaded = null;
                this._loadPoints = [];
                this._trackers = [];
                this._cuePoints = [];
            }
        },
        {
            key: "show",
            value: function show() {
                this.visible = true;
                (0, _lBannerutils.track)(this._trackers);
            }
        },
        {
            key: "hide",
            value: function hide() {
                this.visible = false;
            }
        },
        {
            key: "elapsed",
            set: function set(value) {
                var _this = this;
                if (this._lBannerState || !this._data || !this._cuePoints.length > 0) {
                    return;
                }
                this._elapsed = value;
                // NEED TO LOAD
                if (!this._loaded && this._loadPoints.includes(value)) {
                    this.loadData();
                    this._loaded = true;
                }
                if (this._cuePoints.includes(value)) {
                    if (this._shown[value] || !this.src) {
                        return;
                    }
                    this._shown[value] = true;
                    _lightningjsredux.default.dispatch((0, _playerconstants.setLBannerShow)());
                    this._displayTimeout = setTimeout(function() {
                        if (_this._isPlayingAds) {
                            return;
                        }
                        _lightningjsredux.default.dispatch((0, _playerconstants.setLBannerHide)());
                    }, this._data.duration * 1000);
                }
            }
        },
        {
            key: "provider",
            set: function set(value) {
                this._provider = value;
            }
        },
        {
            key: "isPlayingAds",
            set: function set(value) {
                this._isPlayingAds = value;
                if (this._isPlayingAds && this._elapsed) {
                    this._cuePoints = (0, _lBannerutils.validateCuePoints)(this._cuePoints, [
                        this._elapsed
                    ]);
                    this.processLoadPoints();
                }
                if (this._lBannerState && this._isPlayingAds) {
                    _lightningjsredux.default.dispatch((0, _playerconstants.setLBannerHide)());
                }
            }
        },
        {
            key: "advertising",
            set: function set(value) {
                this._advertising = value;
                if (!this._advertising || !this._advertising[this._provider]) {
                    return;
                }
                this._data = this._advertising[this._provider];
                this._shown = {};
                this._cuePoints = this._data.cuePoints || [];
                this.processLoadPoints();
            // this._data.host = 'https://ad-ipd.sxp.smartclip.net/select?ang_api=2.7&ang_plrh=1080&ang_plrw=1920&ang_streamid=6c6fd006-4e0c-4063-afc2-3df9e7e97187&fwd_adb=0&fwd_br=1&fwd_cf=content_form&fwd_chc=b6e02b8c-d862-4ec7-8ba5-234c26447bcb&fwd_comp=0&fwd_conid=1269049&fwd_fsk=12&fwd_ip_test=nonlinear_test_image&fwd_j4=1%3A2&fwd_j5=1%3A2%3A3%3A4%3A5%3A6&fwd_mtc=22&fwd_nltype=sz&fwd_reqid=0c1155b9-2677-4d16-a763-3921506b11a3&fwd_vcd=2783&fwd_vpaid=1&plcmt=1&rnd=2855956570&s=rtlp_rtlplus%2Fsofties&schain=1.0%2C1%21ad-alliance.de%2Ccsid_22328928714%2C1%2C%2C&sz=over&tagver=6.4.11-release.1&type=vast4&vodid=cnJuOndhdGNoOnZpZGVvaHViOmVwaXNvZGU6MTAwOTg4Nw&vodprfx=10036a&fwd_reqid=838b839e-67f0-4668-bb96-bd0adea0e438';
            }
        },
        {
            key: "loadData",
            value: function loadData() {
                var _this = this;
                (0, _http.requestGet)(this._data.host).responseType("document").then(function(response) {
                    var manifest = response.body;
                    var src = manifest.querySelector("StaticResource").textContent;
                    _this._trackers = (0, _lBannerutils.fetchTrackers)(manifest);
                    _this.src = src;
                    _this.loadTexture();
                }).catch(function() {
                    _this.src = "";
                });
            }
        },
        {
            key: "lBannerState",
            set: function set(value) {
                this._lBannerState = value;
            }
        },
        {
            key: "adMarkers",
            set: function set(value) {
                if (!value.length) return;
                this._cuePoints = (0, _lBannerutils.validateCuePoints)(this._cuePoints, value);
                this.processLoadPoints();
            }
        },
        {
            key: "processLoadPoints",
            value: function processLoadPoints() {
                if (!this._cuePoints.length) {
                    this._loadPoints = [];
                    return;
                }
                this._loadPoints = this._cuePoints.flatMap(function(point) {
                    return Array.from({
                        length: LOAD_OFFSET
                    }, function(_, index) {
                        return point - index;
                    });
                });
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    rect: true,
                    shader: {
                        // In case if an L-Banner image is opaque
                        type: _sdk.Lightning.shaders.Hole
                    }
                }, (0, _lBannerstyle.getInitialStyle)());
            }
        }
    ]);
    return LBanner;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 54905:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(37815);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _playerselectors = __webpack_require__(83318);
var mapControllers = function(instance) {
    return [
        {
            selector: _playerselectors.getElapsedTimeInSeconds,
            shouldBeInvokedOnConnect: true,
            callback: function(value) {
                instance.elapsed = value;
            }
        },
        {
            selector: _playerselectors.getLBannerProvider,
            callback: function(value) {
                instance.provider = value;
            },
            shouldBeInvokedOnConnect: true
        },
        {
            selector: _playerselectors.getAdvertising,
            callback: function(value) {
                instance.advertising = value;
            },
            shouldBeInvokedOnConnect: true
        },
        {
            selector: _playerselectors.getLBannerState,
            callback: function(value) {
                instance.lBannerState = value;
            },
            shouldBeInvokedOnConnect: true
        },
        {
            selector: _playerselectors.isPlayingAds,
            callback: function(value) {
                instance.isPlayingAds = value;
            },
            shouldBeInvokedOnConnect: true
        },
        {
            selector: _playerselectors.getAdMarkers,
            callback: function(value) {
                instance.adMarkers = value || [];
            },
            shouldBeInvokedOnConnect: true
        }
    ];
};
var _default = _lightningjsredux.default.control(mapControllers);


/***/ }),

/***/ 84117:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    L_BANNER_HEIGHT_SCALE: function() {
        return L_BANNER_HEIGHT_SCALE;
    },
    L_BANNER_SAFEGUARD_PERIOD: function() {
        return L_BANNER_SAFEGUARD_PERIOD;
    },
    L_BANNER_WIDTH_SCALE: function() {
        return L_BANNER_WIDTH_SCALE;
    }
});
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(3009);
var L_BANNER_WIDTH_SCALE = 0.2218;
var L_BANNER_HEIGHT_SCALE = 0.2222;
var L_BANNER_SAFEGUARD_PERIOD = 30;


/***/ }),

/***/ 37041:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(3009);
var _style = __webpack_require__(65082);
var _sizes = __webpack_require__(82699);
var _lBannerutils = __webpack_require__(14625);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var screenSize = context.screenSize;
    var left = (0, _lBannerutils.getLBannerWidth)();
    var bottom = (0, _lBannerutils.getLBannerHeight)();
    return {
        w: _sizes.SCREEN_WIDTH[screenSize],
        h: _sizes.SCREEN_HEIGHT[screenSize],
        visible: false,
        zIndex: 3,
        shader: {
            // NOTE: adding a pixel to ensure sub-pixel offset compensation in GLSL shader
            x: left + 1,
            y: 0,
            w: _sizes.SCREEN_WIDTH[screenSize] - left - 1,
            h: _sizes.SCREEN_HEIGHT[screenSize] - bottom - 1
        }
    };
};


/***/ }),

/***/ 14625:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    fetchTrackers: function() {
        return fetchTrackers;
    },
    getLBannerHeight: function() {
        return getLBannerHeight;
    },
    getLBannerHeightScale: function() {
        return getLBannerHeightScale;
    },
    getLBannerWidth: function() {
        return getLBannerWidth;
    },
    getLBannerWidthScale: function() {
        return getLBannerWidthScale;
    },
    track: function() {
        return track;
    },
    validateCuePoints: function() {
        return validateCuePoints;
    }
});
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(52318);
var _superagent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(54247));
var _lBannerconstants = __webpack_require__(84117);
var _sizes = __webpack_require__(82699);
var getLBannerWidth = function() {
    var screenSize = (0, _sizes.getScreenSize)();
    return Math.floor(_sizes.SCREEN_WIDTH[screenSize] * _lBannerconstants.L_BANNER_WIDTH_SCALE);
};
var getLBannerHeight = function() {
    var screenSize = (0, _sizes.getScreenSize)();
    return Math.floor(_sizes.SCREEN_HEIGHT[screenSize] * _lBannerconstants.L_BANNER_HEIGHT_SCALE);
};
var getLBannerWidthScale = function() {
    return _lBannerconstants.L_BANNER_WIDTH_SCALE;
};
var getLBannerHeightScale = function() {
    return _lBannerconstants.L_BANNER_HEIGHT_SCALE;
};
var fetchTrackers = function(manifest) {
    try {
        return Array.from(manifest.querySelectorAll("Impression")).map(function(node) {
            return node.textContent;
        }).filter(Boolean);
    } catch (error) {
        return [];
    }
};
var track = function(urls) {
    return urls ? urls.map(function(url) {
        return _superagent.default.get(url).catch(function() {});
    }) : [];
};
var validateCuePoints = function(cuePoints, adCuePoints) {
    if (!cuePoints.length) {
        return [];
    }
    return cuePoints.filter(function(cuePoint) {
        return adCuePoints.every(function(adCuePoint) {
            return Math.abs(adCuePoint - cuePoint) > _lBannerconstants.L_BANNER_SAFEGUARD_PERIOD;
        });
    });
};


/***/ }),

/***/ 92281:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "NextVideo", ({
    enumerable: true,
    get: function() {
        return NextVideo;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _get = __webpack_require__(60528);
var _get_prototype_of = __webpack_require__(35196);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _set = __webpack_require__(81364);
var _create_super = __webpack_require__(6400);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(42578);
var _get1 = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _fidosdk = __webpack_require__(19804);
var _constants = __webpack_require__(34952);
var _i18n = __webpack_require__(14910);
var _overlaycomponent = __webpack_require__(6859);
var _buttoncomponent = __webpack_require__(31464);
var _textures = __webpack_require__(67179);
var _signals = __webpack_require__(2109);
var _nextVideoconnector = /*#__PURE__*/ _interop_require_default._(__webpack_require__(15842));
var _nextVideoconstants = __webpack_require__(51791);
var _analyticsutils = __webpack_require__(2693);
var _nextVideoItemcomponent = __webpack_require__(96831);
var _nextVideostyle = __webpack_require__(97459);
var _nextVideoutils = __webpack_require__(92936);
var _sizes = __webpack_require__(82699);
var NextVideo = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(NextVideo, _Lightning_Component);
    var _super = _create_super._(NextVideo);
    function NextVideo() {
        _class_call_check._(this, NextVideo);
        return _super.apply(this, arguments);
    }
    _create_class._(NextVideo, [
        {
            key: "_construct",
            value: function _construct() {
                this._style = _nextVideostyle.defaultContext;
                this._withWatchAgain = false;
                this._reset();
            }
        },
        {
            key: "_active",
            value: function _active() {
                var _this = this;
                clearInterval(this._intervalId);
                this.countdown = _nextVideoconstants.NEXT_VIDEO_COUNTDOWN;
                this._intervalId = setInterval(function() {
                    _this.countdown -= 1;
                    if (_this._countdown <= 0) {
                        clearInterval(_this._intervalId);
                    }
                }, 1000);
                this._setState("Content");
            }
        },
        {
            key: "_attach",
            value: function _attach() {
                this._unsubscribe = (0, _nextVideoconnector.default)(this);
                this.tag("Current").visible = false;
                this.tag("Next").visible = false;
            }
        },
        {
            key: "_inactive",
            value: function _inactive() {
                if (this._intervalId) {
                    clearInterval(this._intervalId);
                }
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                if (this._unsubscribe) {
                    this._unsubscribe();
                    this._unsubscribe = null;
                }
                this._reset();
            }
        },
        {
            key: "_handleNextVideoSelected",
            value: function _handleNextVideoSelected(item) {
                (0, _analyticsutils.sendEvent)({
                    key: "playNextVideo"
                });
                this.signal(_nextVideoconstants.NEXT_VIDEO_SIGNAL, item);
            }
        },
        {
            key: "_handleCurrentVideoSelected",
            value: function _handleCurrentVideoSelected(item) {
                (0, _analyticsutils.sendEvent)({
                    key: "replayNextVideo"
                });
                this.signal(_nextVideoconstants.REPLAY_VIDEO_SIGNAL, item);
            }
        },
        {
            key: "watchAgain",
            set: function set(value) {
                this._withWatchAgain = value;
                this._setCurrentVideoAsItem();
            }
        },
        {
            key: "currentVideo",
            set: function set(value) {
                this._currentVideoItem = value;
                this._setCurrentVideoAsItem();
                var imageId = (0, _get1.default)(value, "image.id", "");
                this._setProgramImage(imageId);
            }
        },
        {
            key: "nextVideo",
            set: function set(value) {
                this._nextVideoItem = value;
                this._setVideoPosterContent("Next", value);
            }
        },
        {
            key: "isAvailable",
            get: function get() {
                return this._withWatchAgain || this.tag("Next").visible;
            }
        },
        {
            key: "countdown",
            get: function get() {
                return this._countdown;
            },
            set: function set(value) {
                this._countdown = Math.max(value, 0);
                this.tag("Next").label = [
                    (0, _i18n.t)("player.nextVideo.nextCountdown"),
                    this._countdown,
                    (0, _i18n.t)("player.nextVideo.unit")
                ].join(" ");
                if (this._countdown <= 0 && this._nextVideoItem) {
                    this.signal(_nextVideoconstants.NEXT_VIDEO_SIGNAL, this._nextVideoItem);
                    (0, _analyticsutils.sendEvent)({
                        key: "autoPlayNextVideo"
                    });
                }
            }
        },
        {
            key: "visible",
            get: function get() {
                return _get._(_get_prototype_of._(NextVideo.prototype), "visible", this);
            },
            set: function set(value) {
                _set._(_get_prototype_of._(NextVideo.prototype), "visible", value, this, true);
                if (value) {
                    (0, _analyticsutils.sendEvent)({
                        key: "endscreenDisplayed"
                    });
                }
            }
        },
        {
            key: "_setProgramImage",
            value: function _setProgramImage(imageId) {
                if (!imageId) {
                    this.tag("ProgramImage").texture = null;
                    return;
                }
                var _this = this, finalW = _this.finalW, finalH = _this.finalH;
                this.tag("ProgramImage").texture = (0, _textures.cover)(_fidosdk.imageService.getUrl(imageId, finalW, finalH, {
                    fit: _constants.IMAGE_FIT_SCALE_CROP,
                    quality: _constants.IMAGE_QUALITY,
                    format: _constants.DEFAULT_IMAGE_FORMAT
                }), finalW, finalH);
            }
        },
        {
            key: "_setVideoPosterContent",
            value: function _setVideoPosterContent(tag, content) {
                var view = this.tag(tag);
                if (content) {
                    view.visible = true;
                    view.item = (0, _nextVideoutils.makeVideoItem)(content, this._style.screenSize);
                } else {
                    view.visible = false;
                }
                this._updateViewsPositions();
            }
        },
        {
            key: "_updateViewsPositions",
            value: function _updateViewsPositions() {
                var views = [
                    this.tag("Current"),
                    this.tag("Next")
                ].filter(function(param) {
                    var visible = param.visible;
                    return visible;
                });
                var gap = _nextVideostyle.GAP[this._style.screenSize];
                var totalWidth = 0;
                views.forEach(function(view) {
                    view.x = totalWidth;
                    totalWidth += view.w + gap;
                });
                this.tag("Content").x = (0, _sizes.getCenter)(this.w, totalWidth - gap);
            }
        },
        {
            key: "_setCurrentVideoAsItem",
            value: function _setCurrentVideoAsItem() {
                if (this._withWatchAgain && this._currentVideoItem) {
                    // Current video should have 100% progress since it's fully watched
                    this._setVideoPosterContent("Current", (0, _nextVideoutils.getVideoItemWithProgress)(this._currentVideoItem, 100));
                }
            }
        },
        {
            key: "_reset",
            value: function _reset() {
                this._focused = null;
                this._withWatchAgain = false;
            }
        },
        {
            key: "_getFocused",
            value: function _getFocused() {
                return this._focused;
            }
        },
        {
            key: "_handleBack",
            value: function _handleBack() {
                (0, _analyticsutils.sendEvent)({
                    key: "backNextVideo"
                });
                return false;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    rect: true,
                    Overlay: {
                        type: _overlaycomponent.Overlay
                    },
                    ProgramImage: {},
                    BackButton: {
                        type: _buttoncomponent.Button,
                        label: (0, _i18n.t)("global.back"),
                        picto: {
                            name: "ArrowLeft"
                        }
                    },
                    Content: {
                        Current: {
                            type: _nextVideoItemcomponent.NextVideoItem,
                            label: (0, _i18n.t)("player.nextVideo.askReplay"),
                            signals: _define_property._({}, _signals.SELECTED_SIGNAL, "_handleCurrentVideoSelected")
                        },
                        Next: {
                            type: _nextVideoItemcomponent.NextVideoItem,
                            signals: _define_property._({}, _signals.SELECTED_SIGNAL, "_handleNextVideoSelected")
                        }
                    }
                }, (0, _nextVideostyle.getInitialStyle)());
            }
        },
        {
            key: "_states",
            value: function _states() {
                return [
                    /*#__PURE__*/ function(_this) {
                        _inherits._(Content, _this);
                        var _super = _create_super._(Content);
                        function Content() {
                            _class_call_check._(this, Content);
                            return _super.apply(this, arguments);
                        }
                        _create_class._(Content, [
                            {
                                key: "$enter",
                                value: function $enter() {
                                    this._updateDefaultFocus();
                                }
                            },
                            {
                                key: "currentVideo",
                                set: function set(value) {
                                    _set._(_get_prototype_of._(Content.prototype), "currentVideo", value, this, true);
                                    this._updateDefaultFocus();
                                }
                            },
                            {
                                key: "nextVideo",
                                set: function set(value) {
                                    _set._(_get_prototype_of._(Content.prototype), "nextVideo", value, this, true);
                                    this._updateDefaultFocus();
                                }
                            },
                            {
                                key: "_active",
                                value: function _active() {
                                    _get._(_get_prototype_of._(Content.prototype), "_active", this).call(this);
                                    this._updateDefaultFocus();
                                }
                            },
                            {
                                key: "_updateDefaultFocus",
                                value: function _updateDefaultFocus() {
                                    this._focused = [
                                        this.tag("Next"),
                                        this.tag("Current")
                                    ].find(function(param) {
                                        var visible = param.visible;
                                        return visible;
                                    });
                                }
                            },
                            {
                                key: "_handleLeft",
                                value: function _handleLeft() {
                                    if (this.tag("Current").visible) {
                                        this._focused = this.tag("Current");
                                    }
                                    return true;
                                }
                            },
                            {
                                key: "_handleRight",
                                value: function _handleRight() {
                                    if (this.tag("Next").visible) {
                                        this._focused = this.tag("Next");
                                    }
                                    return true;
                                }
                            },
                            {
                                key: "_handleUp",
                                value: function _handleUp() {
                                    this._setState("BackButton");
                                    return true;
                                }
                            }
                        ]);
                        return Content;
                    }(this),
                    /*#__PURE__*/ function(_this) {
                        _inherits._(BackButton, _this);
                        var _super = _create_super._(BackButton);
                        function BackButton() {
                            _class_call_check._(this, BackButton);
                            return _super.apply(this, arguments);
                        }
                        _create_class._(BackButton, [
                            {
                                key: "_getFocused",
                                value: function _getFocused() {
                                    return this.tag("BackButton");
                                }
                            },
                            {
                                key: "_handleEnter",
                                value: function _handleEnter() {
                                    this.signal(_nextVideoconstants.CLOSE_SIGNAL);
                                    (0, _analyticsutils.sendEvent)({
                                        key: "backNextVideo"
                                    });
                                    return true;
                                }
                            },
                            {
                                key: "_handleDown",
                                value: function _handleDown() {
                                    this._setState("Content");
                                    return true;
                                }
                            }
                        ]);
                        return BackButton;
                    }(this)
                ];
            }
        }
    ]);
    return NextVideo;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 15842:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _featuresselectors = __webpack_require__(76109);
var _videoselectors = __webpack_require__(23035);
var mapControllers = function(instance) {
    return {
        currentVideo: {
            selector: _videoselectors.getCurrentVideoItem,
            shouldBeInvokedOnConnect: true,
            callback: function(value) {
                instance.currentVideo = value;
            }
        },
        nextVideo: {
            selector: _videoselectors.getNextVideoItem,
            shouldBeInvokedOnConnect: true,
            callback: function(value) {
                instance.nextVideo = value;
            }
        },
        currentVideoAvailable: {
            selector: _featuresselectors.getWatchAgainFeature,
            shouldBeInvokedOnConnect: true,
            callback: function(value) {
                instance.watchAgain = value;
            }
        }
    };
};
var _default = _lightningjsredux.default.control(mapControllers);


/***/ }),

/***/ 51791:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    CLOSE_SIGNAL: function() {
        return CLOSE_SIGNAL;
    },
    NEXT_VIDEO_COUNTDOWN: function() {
        return NEXT_VIDEO_COUNTDOWN;
    },
    NEXT_VIDEO_SIGNAL: function() {
        return NEXT_VIDEO_SIGNAL;
    },
    REPLAY_VIDEO_SIGNAL: function() {
        return REPLAY_VIDEO_SIGNAL;
    }
});
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(42578);
var CLOSE_SIGNAL = "close";
var REPLAY_VIDEO_SIGNAL = "replayCurrentVideo";
var NEXT_VIDEO_SIGNAL = "playNextVideo";
var NEXT_VIDEO_COUNTDOWN = 10;


/***/ }),

/***/ 97459:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    CONTENT_MARGIN_TOP: function() {
        return CONTENT_MARGIN_TOP;
    },
    GAP: function() {
        return GAP;
    },
    POSTER_MARGIN_BOTTOM: function() {
        return POSTER_MARGIN_BOTTOM;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
var _define_property = __webpack_require__(21228);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(65759);
var _constants = __webpack_require__(34952);
var _theme = __webpack_require__(51397);
var _style = __webpack_require__(65082);
var _sizes = __webpack_require__(82699);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var GAP = (_obj = {}, _define_property._(_obj, _constants.HD, 64), _define_property._(_obj, _constants.FULL_HD, 96), _obj);
var _obj1;
var CONTENT_MARGIN_TOP = (_obj1 = {}, _define_property._(_obj1, _constants.HD, 266), _define_property._(_obj1, _constants.FULL_HD, 396), _obj1);
var _obj2;
var POSTER_MARGIN_BOTTOM = (_obj2 = {}, _define_property._(_obj2, _constants.HD, 16), _define_property._(_obj2, _constants.FULL_HD, 24), _obj2);
var colors = {
    label: (0, _theme.makeThemeColor)(_theme.PRIMARY)
};
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var screenSize = context.screenSize;
    return {
        w: _sizes.SCREEN_WIDTH[screenSize],
        h: _sizes.SCREEN_HEIGHT[screenSize],
        BackButton: {
            x: _constants.safetyMargins.horizontal[screenSize],
            y: _constants.safetyMargins.vertical[screenSize]
        },
        Content: {
            y: CONTENT_MARGIN_TOP[screenSize]
        }
    };
};


/***/ }),

/***/ 92936:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    getVideoItemWithProgress: function() {
        return getVideoItemWithProgress;
    },
    makeVideoItem: function() {
        return makeVideoItem;
    }
});
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
var _get = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _fidosdk = __webpack_require__(19804);
var _constants = __webpack_require__(34952);
var _posterconstants = __webpack_require__(99246);
var getVideoItemWithProgress = function(content) {
    var progress = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return content ? _object_spread_props._(_object_spread._({}, content), {
        progress: progress
    }) : null;
};
var makeVideoItem = function(content, screenSize) {
    if (!content) {
        return null;
    }
    var image = (0, _get.default)(content, "image", {});
    var imageSize = (0, _get.default)(_posterconstants.imageOptions, [
        _posterconstants.templates.PosterL,
        screenSize,
        "PRIMARY"
    ], {});
    return {
        content: _object_spread_props._(_object_spread._({}, content), {
            image: _object_spread_props._(_object_spread._({}, image), {
                src: _fidosdk.imageService.getUrl(image.id, imageSize.width, imageSize.height, {
                    fit: _constants.IMAGE_FIT_SCALE_CROP,
                    quality: _constants.IMAGE_QUALITY,
                    format: _constants.DEFAULT_IMAGE_FORMAT
                })
            })
        }),
        template: _posterconstants.templates.PosterL
    };
};


/***/ }),

/***/ 96831:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "NextVideoItem", ({
    enumerable: true,
    get: function() {
        return NextVideoItem;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(3009);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _nextVideoItemstyle = __webpack_require__(87842);
var _signals = __webpack_require__(2109);
var _postercomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(63205));
var NextVideoItem = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(NextVideoItem, _Lightning_Component);
    var _super = _create_super._(NextVideoItem);
    function NextVideoItem() {
        _class_call_check._(this, NextVideoItem);
        return _super.apply(this, arguments);
    }
    _create_class._(NextVideoItem, [
        {
            key: "item",
            set: function set(value) {
                this.tag("Poster").item = value;
            }
        },
        {
            key: "label",
            set: function set(value) {
                this.tag("Label").text.text = value;
            }
        },
        {
            key: "_getFocused",
            value: function _getFocused() {
                return this.tag("Poster");
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    Poster: {
                        type: _postercomponent.default,
                        passSignals: _define_property._({}, _signals.SELECTED_SIGNAL, true)
                    },
                    Label: {}
                }, (0, _nextVideoItemstyle.getInitialStyle)());
            }
        }
    ]);
    return NextVideoItem;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 87842:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    POSTER_MARGIN_BOTTOM: function() {
        return POSTER_MARGIN_BOTTOM;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
var _define_property = __webpack_require__(21228);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(42578);
var _constants = __webpack_require__(34952);
var _typography = __webpack_require__(18411);
var _theme = __webpack_require__(51397);
var _style = __webpack_require__(65082);
var _sizes = __webpack_require__(82699);
var _posterconstants = __webpack_require__(99246);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var POSTER_MARGIN_BOTTOM = (_obj = {}, _define_property._(_obj, _constants.HD, 16), _define_property._(_obj, _constants.FULL_HD, 24), _obj);
var colors = {
    label: (0, _theme.makeThemeColor)(_theme.PRIMARY)
};
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var screenSize = context.screenSize, colorMode = context.colorMode;
    var posterSize = _posterconstants.sizes[_posterconstants.templates.PosterL][screenSize];
    return {
        w: posterSize.w,
        h: _sizes.SCREEN_HEIGHT[screenSize],
        Poster: {
            w: posterSize.w,
            h: posterSize.h
        },
        Label: {
            y: posterSize.h + POSTER_MARGIN_BOTTOM[screenSize],
            text: _object_spread_props._(_object_spread._({}, (0, _typography.getFont)(_typography.FONT.KINSHASA_2, screenSize)), {
                maxLines: 2,
                wordWrapWidth: posterSize.w
            }),
            color: colors.label[colorMode]
        }
    };
};


/***/ }),

/***/ 78926:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "Video", ({
    enumerable: true,
    get: function() {
        return Video;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _get = __webpack_require__(60528);
var _get_prototype_of = __webpack_require__(35196);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(37815);
var _get1 = /*#__PURE__*/ _interop_require_default._(__webpack_require__(65439));
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _fidosdk = __webpack_require__(19804);
var _ctaactions = __webpack_require__(32067);
var _videoLoadercomponent = __webpack_require__(46647);
var _nextVideocomponent = __webpack_require__(92281);
var _playercomponent = __webpack_require__(52811);
var _lBannercomponent = __webpack_require__(7503);
var _controlscomponent = __webpack_require__(80910);
var _videoLoaderconstants = __webpack_require__(90616);
var _controlsconstants = __webpack_require__(55197);
var _tracksconstants = __webpack_require__(75702);
var _nextVideoconstants = __webpack_require__(51791);
var _videoconnector = /*#__PURE__*/ _interop_require_default._(__webpack_require__(6547));
var _videostyle = __webpack_require__(68542);
var _videoutils = __webpack_require__(69208);
var _videoconstants = __webpack_require__(70223);
var _contentAdvisorycomponent = __webpack_require__(22122);
var _csaIconcomponent = __webpack_require__(69295);
var _playerconstants = __webpack_require__(7602);
var _layoutactions = __webpack_require__(8424);
var _playeractions = __webpack_require__(90120);
var _analyticsutils = __webpack_require__(2693);
var _tracksutils = __webpack_require__(76793);
var _screenSaveractions = __webpack_require__(90962);
var _googlePauseAdscomponent = __webpack_require__(72415);
var _lBannerutils = __webpack_require__(14625);
var Video = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(Video, _Lightning_Component);
    var _super = _create_super._(Video);
    function Video() {
        _class_call_check._(this, Video);
        return _super.apply(this, arguments);
    }
    _create_class._(Video, [
        {
            key: "_onUrlParams",
            value: function _onUrlParams(param) {
                var videoId = param.videoId;
                _lightningjsredux.default.dispatch((0, _playerconstants.reset)());
                _lightningjsredux.default.dispatch((0, _layoutactions.fetchLayout)(_fidosdk.LAYOUT_ENTITIES.video, videoId));
            }
        },
        {
            key: "_active",
            value: function _active() {
                this._canPlay = false;
                this._hasRelatedVideos = false;
                this._hasTracks = false;
                this._hasProgramInformation = false;
                this._isShowingControls = false;
                this._isShowingLBanner = false;
                this._isVideoEnding = false;
                this._pauseAdState = null;
                this._isSeeking = false;
                this._setState("Loading");
                this._unsubscribe = (0, _videoconnector.default)(this);
                // NOTE: memory clean is used to prevent disappearing image textures on next video screen
                this.stage.gc(true);
            }
        },
        {
            key: "_inactive",
            value: function _inactive() {
                if (this._unsubscribe) {
                    this._unsubscribe();
                    this._unsubscribe = null;
                }
            }
        },
        {
            key: "isLoadingContent",
            set: function set(value) {
                if (value) {
                    this._setState("Loading");
                }
            }
        },
        {
            key: "canPlay",
            set: function set(value) {
                this._canPlay = value;
                if (this._canPlay) {
                    this._handleVideoStart();
                }
            }
        },
        {
            key: "playbackState",
            set: function set(value) {
                if (value === _playerconstants.PLAYBACK_STATE_PLAYING) {
                    this._setState("Playback.Playing");
                }
            }
        },
        {
            key: "shouldHideVideoLoader",
            set: function set(value) {
                if (value) {
                    this.tag("Loader").hide();
                }
            }
        },
        {
            key: "hasRelatedVideos",
            set: function set(value) {
                this._hasRelatedVideos = value;
                this._updateTopBarItems();
            }
        },
        {
            key: "audioTracks",
            set: function set(value) {
                this._hasTracks = this._hasTracks || value && value.length > 1;
                this._updateTopBarItems(value);
            }
        },
        {
            key: "subtitleTracks",
            set: function set(value) {
                this._hasTracks = this._hasTracks || value && value.length > 0 && !(0, _tracksutils.areForcedSubtitlesOnly)(value);
                this._updateTopBarItems(value);
            }
        },
        {
            key: "shouldDisplayNextVideo",
            set: function set(value) {
                var nextVideo = this.tag("NextVideo");
                nextVideo.visible = value && nextVideo.isAvailable;
                if (value) {
                    if (nextVideo.isAvailable) {
                        this._setState("NextVideo");
                    } else {
                        _sdk.Router.back();
                    }
                }
            }
        },
        {
            key: "shouldDisplayLBanner",
            set: function set(value) {
                this._isLBannerEnabled = Boolean(value);
                this._updateTopBarItems();
                if (value) {
                    var playerScale = 1 - (0, _lBannerutils.getLBannerWidthScale)();
                    var playerX = (0, _lBannerutils.getLBannerWidth)();
                    this.tag("Player").setlBannerState(true);
                    this.tag("Wrapper").patch({
                        smooth: {
                            scale: playerScale,
                            x: playerX
                        }
                    });
                    this.tag("LBanner").show();
                } else {
                    this.tag("Player").setlBannerState(false);
                    this.tag("Wrapper").patch({
                        smooth: {
                            scale: 1,
                            x: 0
                        }
                    });
                    this.tag("LBanner").hide();
                }
            }
        },
        {
            key: "programInformation",
            set: function set(value) {
                this._hasProgramInformation = Boolean(value && (value.description || value.title));
                this._updateTopBarItems();
            }
        },
        {
            key: "isAdBreakDisplayed",
            set: function set(value) {
                if (value) {
                    this._setState("Ads");
                }
            }
        },
        {
            key: "isSeeking",
            get: function get() {
                return this._isSeeking;
            },
            set: function set(value) {
                this._isSeeking = value;
            }
        },
        {
            key: "start",
            value: function start() {
                _lightningjsredux.default.dispatch((0, _playeractions.fetchPlayerLayout)());
            }
        },
        {
            key: "_handleVideoStart",
            value: function _handleVideoStart() {
                this.tag("NextVideo").visible = false;
                this.tag("Player").play();
            }
        },
        {
            key: "_handleBack",
            value: function _handleBack() {
                (0, _analyticsutils.sendEvent)({
                    key: "pressBackButtonDuringVideo"
                });
                return false;
            }
        },
        {
            key: "_handleStop",
            value: function _handleStop() {
                _sdk.Router.back();
                return true;
            }
        },
        {
            key: "_pause",
            value: function _pause() {
                this.tag("Player").pause();
                this.tag("Controls").show(_controlsconstants.PAUSED_STATE);
            }
        },
        {
            key: "_play",
            value: function _play() {
                this.tag("Player").play();
                this.tag("Controls").show(_controlsconstants.PLAYING_STATE);
            }
        },
        {
            key: "_updateTopBarItems",
            value: function _updateTopBarItems() {
                this.tag("Controls").topBarItems = (0, _videoutils.getTopBarItems)({
                    hasTracks: this._hasTracks,
                    hasRelatedVideos: this._hasRelatedVideos,
                    hasProgramInformation: this._hasProgramInformation,
                    hasStartOver: !this._isLBannerEnabled
                });
            }
        },
        {
            key: "_handleLoaderSequenceComplete",
            value: function _handleLoaderSequenceComplete() {
                this._isLoadingSequenceComplete = true;
            }
        },
        {
            key: "_handleSeek",
            value: function _handleSeek(position) {
                var forceRestart = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                // eslint-disable-next-line no-console
                console.log("[video.component] content position on seek ", position);
                this.tag("Player").seek(position, forceRestart);
            }
        },
        {
            key: "_handleTopBarItemSelection",
            value: function _handleTopBarItemSelection(item) {
                var id = (0, _get1.default)(item, "id", "");
                if (id === _videoconstants.TOP_BAR_ITEMS.BACK) {
                    _sdk.Router.back();
                } else if (id === _videoconstants.TOP_BAR_ITEMS.START_OVER) {
                    this._handleSeek(0);
                    this._play();
                } else if (id === _videoconstants.TOP_BAR_ITEMS.TRACKS) {
                    this.tag("Controls").showTracks();
                } else if (id === _videoconstants.TOP_BAR_ITEMS.RELATED_VIDEOS) {
                    this.tag("Controls").showSideGlass();
                } else if (id === _videoconstants.TOP_BAR_ITEMS.INFO_PAGE) {
                    this.tag("Controls").showProgramInformation();
                }
            }
        },
        {
            key: "_handleItemAction",
            value: function _handleItemAction(item) {
                (0, _ctaactions.dispatchItemAction)(item);
            }
        },
        {
            key: "_handleAudioTrackSelection",
            value: function _handleAudioTrackSelection(track) {
                if (track) {
                    _lightningjsredux.default.dispatch((0, _playeractions.selectAudioTrack)(track));
                }
            }
        },
        {
            key: "_handleSubtitlesTrackSelection",
            value: function _handleSubtitlesTrackSelection(track) {
                _lightningjsredux.default.dispatch((0, _playeractions.selectSubtitlesTrack)(track));
            }
        },
        {
            key: "_handleVideoReplaySelection",
            value: function _handleVideoReplaySelection() {
                this._handleSeek(0, true);
                this._handleVideoStart();
            }
        },
        {
            key: "_handleNextVideoClose",
            value: function _handleNextVideoClose() {
                _sdk.Router.back();
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                var _obj, _obj1;
                return (0, _merge.default)({
                    LBanner: {
                        type: _lBannercomponent.LBanner
                    },
                    Wrapper: {
                        Player: {
                            type: _playercomponent.Player
                        },
                        Controls: {
                            type: _controlscomponent.VideoControls,
                            topBarItems: [],
                            signals: (_obj = {}, _define_property._(_obj, _controlsconstants.SEEK_SIGNAL, "_handleSeek"), _define_property._(_obj, _controlsconstants.PAUSE_SIGNAL, "_handleProgressBarLongSeek"), _define_property._(_obj, _controlsconstants.TOP_BAR_ITEM_SELECTED_SIGNAL, "_handleTopBarItemSelection"), _define_property._(_obj, _controlsconstants.SIDE_GLASS_ITEM_SELECTED_SIGNAL, "_handleItemAction"), _define_property._(_obj, _tracksconstants.AUDIO_TRACK_SELECTED_SIGNAL, "_handleAudioTrackSelection"), _define_property._(_obj, _tracksconstants.SUBTITLES_TRACK_SELECTED_SIGNAL, "_handleSubtitlesTrackSelection"), _define_property._(_obj, _controlsconstants.CONTROLS_SHOW_SIGNAL, "_onControlsShown"), _define_property._(_obj, _controlsconstants.CONTROLS_HIDE_SIGNAL, "_onControlsHidden"), _obj)
                        },
                        ContentAdvisory: {
                            type: _contentAdvisorycomponent.ContentAdvisory
                        },
                        CsaIcon: {
                            type: _csaIconcomponent.CsaIcon
                        },
                        PauseAds: {
                            type: _googlePauseAdscomponent.GooglePauseAds,
                            visible: false
                        },
                        NextVideo: {
                            type: _nextVideocomponent.NextVideo,
                            signals: (_obj1 = {}, _define_property._(_obj1, _nextVideoconstants.CLOSE_SIGNAL, "_handleNextVideoClose"), _define_property._(_obj1, _nextVideoconstants.REPLAY_VIDEO_SIGNAL, "_handleVideoReplaySelection"), _define_property._(_obj1, _nextVideoconstants.NEXT_VIDEO_SIGNAL, "_handleItemAction"), _obj1)
                        },
                        Loader: {
                            type: _videoLoadercomponent.VideoLoader,
                            signals: _define_property._({}, _videoLoaderconstants.COMPLETE_SIGNAL, "_handleLoaderSequenceComplete")
                        }
                    }
                }, (0, _videostyle.getInitialStyle)());
            }
        },
        {
            key: "_states",
            value: function _states() {
                return [
                    /*#__PURE__*/ function(_this) {
                        _inherits._(Loading, _this);
                        var _super = _create_super._(Loading);
                        function Loading() {
                            _class_call_check._(this, Loading);
                            return _super.apply(this, arguments);
                        }
                        _create_class._(Loading, [
                            {
                                key: "$enter",
                                value: function $enter() {
                                    this._isLoadingSequenceComplete = false;
                                    this.tag("Loader").show();
                                }
                            }
                        ]);
                        return Loading;
                    }(this),
                    /*#__PURE__*/ function(_this) {
                        _inherits._(Playback, _this);
                        var _super = _create_super._(Playback);
                        function Playback() {
                            _class_call_check._(this, Playback);
                            return _super.apply(this, arguments);
                        }
                        _create_class._(Playback, [
                            {
                                key: "displayPauseAds",
                                set: function set(value) {
                                    var pauseAds = this.tag("PauseAds");
                                    var controls = this.tag("Controls");
                                    if (!pauseAds.isAvailable) {
                                        controls.visible = true;
                                        pauseAds.visible = false;
                                        return;
                                    }
                                    if (value) {
                                        _lightningjsredux.default.dispatch((0, _playeractions.refreshPauseAd)());
                                    }
                                    controls.visible = !value;
                                    pauseAds.visible = value;
                                }
                            },
                            {
                                key: "isVideoEnding",
                                set: function set(value) {
                                    this._isVideoEnding = value;
                                    this._displayContentAdvisoryIfRequired();
                                }
                            },
                            {
                                key: "_getFocused",
                                value: function _getFocused() {
                                    return this.tag("Controls");
                                }
                            },
                            {
                                key: "_onControlsShown",
                                value: function _onControlsShown() {
                                    this.tag("ContentAdvisory").pause();
                                    this._isShowingControls = true;
                                    this.tag("CsaIcon").handleIcon(false);
                                }
                            },
                            {
                                key: "_onControlsHidden",
                                value: function _onControlsHidden() {
                                    this._isShowingControls = false;
                                    this.tag("CsaIcon").handleIcon(true);
                                }
                            },
                            {
                                key: "_displayContentAdvisoryIfRequired",
                                value: function _displayContentAdvisoryIfRequired() {
                                    if (this._isVideoEnding && !this._isShowingControls) {
                                        this.tag("ContentAdvisory").start();
                                    }
                                }
                            }
                        ], [
                            {
                                key: "_states",
                                value: function _states() {
                                    return [
                                        /*#__PURE__*/ function(_this) {
                                            _inherits._(Playing, _this);
                                            var _super = _create_super._(Playing);
                                            function Playing() {
                                                _class_call_check._(this, Playing);
                                                return _super.apply(this, arguments);
                                            }
                                            _create_class._(Playing, [
                                                {
                                                    key: "$enter",
                                                    value: function $enter(states) {
                                                        var previousState = (0, _get1.default)(states, "prevState", "");
                                                        // According to requirements, the Content Advisory component should be displayed "after each break"
                                                        this.tag("ContentAdvisory").start();
                                                        if (previousState === "Loading") {
                                                            // Once video is started, controls should be shown
                                                            this.tag("Controls").showControls();
                                                        } else if (previousState === "Playback.Paused") {
                                                            // When player is switching to Playing state from Paused it means, a Play button was triggered and controls were shown
                                                            // According to the requirements, Content Advisory should be hidden when controls are visible
                                                            this.tag("ContentAdvisory").pause();
                                                        }
                                                        _lightningjsredux.default.dispatch((0, _screenSaveractions.setScreenSaverIsLocked)(true));
                                                        this.isSeeking = false;
                                                        this.displayPauseAds = false;
                                                    }
                                                },
                                                {
                                                    key: "$exit",
                                                    value: function $exit() {
                                                        this.tag("ContentAdvisory").pause();
                                                    }
                                                },
                                                {
                                                    key: "_handleEnter",
                                                    value: function _handleEnter() {
                                                        this._handlePauseControl();
                                                        return true;
                                                    }
                                                },
                                                {
                                                    key: "_handlePause",
                                                    value: function _handlePause() {
                                                        this._handlePauseControl();
                                                        return true;
                                                    }
                                                },
                                                {
                                                    key: "_handlePlayPause",
                                                    value: function _handlePlayPause() {
                                                        this._handlePauseControl();
                                                        return true;
                                                    }
                                                },
                                                {
                                                    key: "_handlePauseControl",
                                                    value: function _handlePauseControl() {
                                                        this._pause();
                                                        this.displayPauseAds = true;
                                                    }
                                                },
                                                {
                                                    key: "_handleProgressBarLongSeek",
                                                    value: function _handleProgressBarLongSeek() {
                                                        this.isSeeking = true;
                                                        this._pause();
                                                    }
                                                },
                                                {
                                                    key: "_onControlsHidden",
                                                    value: function _onControlsHidden() {
                                                        this.tag("ContentAdvisory").resume();
                                                        _get._(_get_prototype_of._(Playing.prototype), "_onControlsHidden", this).call(this);
                                                    }
                                                },
                                                {
                                                    key: "playbackState",
                                                    set: function set(value) {
                                                        if (value === _playerconstants.PLAYBACK_STATE_PAUSED) {
                                                            this._setState("Playback.Paused");
                                                        }
                                                    }
                                                }
                                            ]);
                                            return Playing;
                                        }(this),
                                        /*#__PURE__*/ function(_this) {
                                            _inherits._(Paused, _this);
                                            var _super = _create_super._(Paused);
                                            function Paused() {
                                                _class_call_check._(this, Paused);
                                                return _super.apply(this, arguments);
                                            }
                                            _create_class._(Paused, [
                                                {
                                                    key: "$exit",
                                                    value: function $exit() {
                                                        this.tag("Controls").visible = true;
                                                    }
                                                },
                                                {
                                                    key: "_getFocused",
                                                    value: function _getFocused() {
                                                        if (this.isSeeking) {
                                                            return _get._(_get_prototype_of._(Paused.prototype), "_getFocused", this).call(this);
                                                        }
                                                        var pauseAds = this.tag("PauseAds");
                                                        return pauseAds.isAvailable && this._pauseAdState !== _playerconstants.PAUSE_AD_STATE.ERROR ? pauseAds : _get._(_get_prototype_of._(Paused.prototype), "_getFocused", this).call(this);
                                                    }
                                                },
                                                {
                                                    key: "_handleEnter",
                                                    value: function _handleEnter() {
                                                        this._play();
                                                        return true;
                                                    }
                                                },
                                                {
                                                    key: "_handlePlay",
                                                    value: function _handlePlay() {
                                                        this._play();
                                                        return true;
                                                    }
                                                },
                                                {
                                                    key: "_handlePlayPause",
                                                    value: function _handlePlayPause() {
                                                        this._play();
                                                        return true;
                                                    }
                                                },
                                                {
                                                    key: "_play",
                                                    value: function _play() {
                                                        _get._(_get_prototype_of._(Paused.prototype), "_play", this).call(this);
                                                        this.tag("Controls").showControls();
                                                    }
                                                },
                                                {
                                                    key: "pauseAdState",
                                                    set: function set(value) {
                                                        this._pauseAdState = value;
                                                        if (value === _playerconstants.PAUSE_AD_STATE.ERROR) {
                                                            var pauseAds = this.tag("PauseAds");
                                                            var controls = this.tag("Controls");
                                                            pauseAds.visible = false;
                                                            controls.visible = true;
                                                            controls.showControls();
                                                        }
                                                    }
                                                }
                                            ]);
                                            return Paused;
                                        }(this)
                                    ];
                                }
                            }
                        ]);
                        return Playback;
                    }(this),
                    /*#__PURE__*/ function(_this) {
                        _inherits._(Ads, _this);
                        var _super = _create_super._(Ads);
                        function Ads() {
                            _class_call_check._(this, Ads);
                            return _super.apply(this, arguments);
                        }
                        _create_class._(Ads, [
                            {
                                key: "$enter",
                                value: function $enter() {
                                    this.tag("Loader").hide();
                                }
                            },
                            {
                                key: "_getFocused",
                                value: function _getFocused() {
                                    return this.tag("Player");
                                }
                            }
                        ]);
                        return Ads;
                    }(this),
                    /*#__PURE__*/ function(_this) {
                        _inherits._(NextVideo, _this);
                        var _super = _create_super._(NextVideo);
                        function NextVideo() {
                            _class_call_check._(this, NextVideo);
                            return _super.apply(this, arguments);
                        }
                        _create_class._(NextVideo, [
                            {
                                key: "$enter",
                                value: function $enter() {
                                    this.tag("Controls").visible = false;
                                }
                            },
                            {
                                key: "_getFocused",
                                value: function _getFocused() {
                                    return this.tag("NextVideo");
                                }
                            }
                        ]);
                        return NextVideo;
                    }(this)
                ];
            }
        }
    ]);
    return Video;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 6547:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(3009);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _layoutselectors = __webpack_require__(53368);
var _playerselectors = __webpack_require__(83318);
var _videoselectors = __webpack_require__(23035);
var mapControllers = function(instance) {
    return {
        layout: {
            selector: _layoutselectors.getCurrentLayout,
            shouldBeInvokedOnConnect: true,
            callback: function() {
                instance.start();
            }
        },
        canPlay: {
            selector: _playerselectors.getCanPlay,
            callback: function(value) {
                instance.canPlay = value;
            }
        },
        playbackState: {
            selector: _playerselectors.getPlaybackState,
            callback: function(value) {
                instance.playbackState = value;
            }
        },
        isLoadingContent: {
            selector: _playerselectors.getIsLoadingContent,
            shouldBeInvokedOnConnect: true,
            callback: function(value) {
                instance.isLoadingContent = value;
            }
        },
        shouldHideVideoLoader: {
            selector: _playerselectors.shouldHideVideoLoader,
            shouldBeInvokedOnConnect: true,
            callback: function(value) {
                instance.shouldHideVideoLoader = value;
            }
        },
        isAdBreakDisplayed: {
            selector: _playerselectors.isPlayingAds,
            callback: function(value) {
                instance.isAdBreakDisplayed = value;
            },
            shouldBeInvokedOnConnect: true
        },
        sideGlass: {
            selector: _playerselectors.getSideGlassContent,
            callback: function(value) {
                instance.hasRelatedVideos = value;
            }
        },
        audioTracks: {
            selector: _playerselectors.getAudioTracks,
            callback: function(value) {
                instance.audioTracks = value;
            }
        },
        subtitleTracks: {
            selector: _playerselectors.getSubtitleTracks,
            callback: function(value) {
                instance.subtitleTracks = value;
            }
        },
        nextVideo: {
            selector: _playerselectors.getIsEnded,
            shouldBeInvokedOnConnect: true,
            callback: function(value) {
                instance.shouldDisplayNextVideo = value;
            }
        },
        programInformation: {
            selector: _videoselectors.getCurrentVideoItem,
            callback: function(value) {
                instance.programInformation = value;
            }
        },
        isVideoEnding: {
            selector: _videoselectors.isVideoEnding,
            callback: function(value) {
                instance.isVideoEnding = value;
            }
        },
        pauseAdState: {
            selector: _playerselectors.getPauseAdState,
            callback: function(value) {
                instance.pauseAdState = value;
            }
        },
        shouldDisplayLBanner: {
            selector: _playerselectors.getLBannerState,
            callback: function(value) {
                instance.shouldDisplayLBanner = value;
            }
        }
    };
};
var _default = _lightningjsredux.default.control(mapControllers);


/***/ }),

/***/ 70223:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    TOP_BAR_ITEMS: function() {
        return TOP_BAR_ITEMS;
    },
    TRACK_KEYS: function() {
        return TRACK_KEYS;
    }
});
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(37815);
var TOP_BAR_ITEMS = {
    BACK: "BACK",
    START_OVER: "START_OVER",
    TRACKS: "TRACKS",
    RELATED_VIDEOS: "RELATED_VIDEOS",
    INFO_PAGE: "INFO_PAGE"
};
var TRACK_KEYS = {
    PREFERRED_AUDIO_TRACK_LANGUAGE: "preferredAudioTrackLanguage",
    PREFERRED_SUBTITLE_TRACK_LANGUAGE: "preferredSubtitleTrackLanguage"
};


/***/ }),

/***/ 68542:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(65759);
var _style = __webpack_require__(65082);
var _sizes = __webpack_require__(82699);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var screenSize = context.screenSize;
    return {
        w: _sizes.SCREEN_WIDTH[screenSize],
        h: _sizes.SCREEN_HEIGHT[screenSize]
    };
};


/***/ }),

/***/ 69208:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "getTopBarItems", ({
    enumerable: true,
    get: function() {
        return getTopBarItems;
    }
}));
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(65759);
var _playerconstants = __webpack_require__(7602);
var _i18n = __webpack_require__(14910);
var _videoconstants = __webpack_require__(70223);
var defaultTopBarItems = [
    {
        id: _videoconstants.TOP_BAR_ITEMS.BACK,
        icon: "ArrowLeftWithBase",
        text: (0, _i18n.t)("nav.backToNav"),
        action: _playerconstants.TOP_BAR_BACK
    },
    {
        id: _videoconstants.TOP_BAR_ITEMS.START_OVER,
        icon: "StartOver",
        text: (0, _i18n.t)("player.replay"),
        action: _playerconstants.TOP_BAR_START_OVER
    },
    {
        id: _videoconstants.TOP_BAR_ITEMS.TRACKS,
        icon: "Tracks",
        text: (0, _i18n.t)("nav.subtitles"),
        action: _playerconstants.TOP_BAR_TRACKS
    },
    {
        id: _videoconstants.TOP_BAR_ITEMS.RELATED_VIDEOS,
        icon: "RelatedVideos",
        text: (0, _i18n.t)("nav.relatedItems"),
        action: _playerconstants.TOP_BAR_RELATED_VIDEOS
    },
    {
        id: _videoconstants.TOP_BAR_ITEMS.INFO_PAGE,
        icon: "Info",
        text: (0, _i18n.t)("nav.synopsis"),
        action: _playerconstants.TOP_BAR_INFO_PAGE
    }
];
var getTopBarItems = function(param) {
    var hasTracks = param.hasTracks, hasRelatedVideos = param.hasRelatedVideos, hasProgramInformation = param.hasProgramInformation, hasStartOver = param.hasStartOver;
    return defaultTopBarItems.filter(function(param) {
        var id = param.id;
        switch(id){
            case _videoconstants.TOP_BAR_ITEMS.TRACKS:
                return hasTracks;
            case _videoconstants.TOP_BAR_ITEMS.RELATED_VIDEOS:
                return hasRelatedVideos;
            case _videoconstants.TOP_BAR_ITEMS.INFO_PAGE:
                return hasProgramInformation;
            case _videoconstants.TOP_BAR_ITEMS.START_OVER:
                return hasStartOver;
            default:
                return true;
        }
    });
};


/***/ }),

/***/ 46647:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "VideoLoader", ({
    enumerable: true,
    get: function() {
        return VideoLoader;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(37815);
var _merge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67929));
var _sdk = __webpack_require__(29956);
var _fidosdk = __webpack_require__(19804);
var _constants = __webpack_require__(34952);
var _textures = __webpack_require__(67179);
var _spinnercomponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(76976));
var _playerconstants = __webpack_require__(28824);
var _videoLoaderstyle = __webpack_require__(59485);
var _videoLoaderconnector = /*#__PURE__*/ _interop_require_default._(__webpack_require__(49634));
var _videoLoaderconstants = __webpack_require__(90616);
var VideoLoader = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(VideoLoader, _Lightning_Component);
    var _super = _create_super._(VideoLoader);
    function VideoLoader() {
        _class_call_check._(this, VideoLoader);
        return _super.apply(this, arguments);
    }
    _create_class._(VideoLoader, [
        {
            key: "_attach",
            value: function _attach() {
                var _this = this;
                this._hideAnimation = this.animation({
                    duration: 0.5,
                    actions: [
                        {
                            p: "alpha",
                            v: {
                                0: 1,
                                1: 0
                            }
                        }
                    ]
                });
                this._hideAnimation.on("finish", function() {
                    var jingleImage = _this.tag("JingleImage");
                    var programImage = _this.tag("ProgramImage");
                    try {
                        if (jingleImage.texture) jingleImage.texture.free();
                        if (programImage.texture) programImage.texture.free();
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.error("Can not free Jingle textures:", error);
                    } finally{
                        jingleImage.texture = null;
                        programImage.texture = null;
                    }
                });
            }
        },
        {
            key: "_active",
            value: function _active() {
                var _this = this;
                this._jingleImageAvailable = false;
                this._programImageAvailable = false;
                var jingleImage = this.tag("JingleImage");
                var programImage = this.tag("ProgramImage");
                jingleImage.on("txLoaded", function() {
                    jingleImage.removeAllListeners("txLoaded");
                    _this._jingleImageAvailable = true;
                });
                programImage.on("txLoaded", function() {
                    programImage.removeAllListeners("txLoaded");
                    _this._programImageAvailable = true;
                    // If image was loaded before it is needed, hide it till a moment Program state will be enabled
                    if (_this.state === "Program") {
                        _this._hideImage("JingleImage");
                    } else {
                        programImage.alpha = 0;
                    }
                });
                this._setState("Spinner");
                this._unsubscribe = (0, _videoLoaderconnector.default)(this);
            }
        },
        {
            key: "_inactive",
            value: function _inactive() {
                if (this._unsubscribe) {
                    this._unsubscribe();
                    this._unsubscribe = null;
                }
                this._reset();
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                this._hideAnimation.removeAllListeners("finish");
                this._hideAnimation = null;
            }
        },
        {
            key: "jingleImageId",
            set: function set(value) {
                this._jingleImageAvailable = false;
                this._setImage(value, "JingleImage");
            }
        },
        {
            key: "programImageId",
            set: function set(value) {
                this._programImageAvailable = false;
                this._setImage(value, "ProgramImage");
            }
        },
        {
            key: "isLoadingContent",
            set: function set(value) {
                if (value) {
                    this._setState("Jingle");
                }
            }
        },
        {
            key: "show",
            value: function show() {
                this.alpha = 1;
                [
                    this.tag("JingleImage"),
                    this.tag("ProgramImage"),
                    this.tag("Spinner")
                ].forEach(function(view) {
                    view.alpha = _videoLoaderstyle.STARTING_ALPHA;
                });
                this._setState("Spinner");
            }
        },
        {
            key: "hide",
            value: function hide() {
                var _this = this;
                setTimeout(function() {
                    _this._reset();
                    if (_this.alpha) {
                        _this._hideAnimation.start();
                    }
                }, _playerconstants.LOADER_DELAY);
            }
        },
        {
            key: "_reset",
            value: function _reset() {
                this._clearTimeouts();
                this.tag("JingleImage").removeAllListeners("txLoaded");
                this.tag("ProgramImage").removeAllListeners("txLoaded");
            }
        },
        {
            key: "_setImage",
            value: function _setImage(imageId, tag) {
                if (imageId) {
                    var _this = this, finalW = _this.finalW, finalH = _this.finalH;
                    this.tag(tag).texture = (0, _textures.cover)(_fidosdk.imageService.getUrl(imageId, finalW, finalH, {
                        fit: _constants.IMAGE_FIT_SCALE_CROP,
                        quality: _constants.IMAGE_QUALITY,
                        format: _constants.DEFAULT_IMAGE_FORMAT
                    }), finalW, finalH);
                } else {
                    this.tag(tag).texture = null;
                }
            }
        },
        {
            key: "_hideSpinner",
            value: function _hideSpinner() {
                this.tag("Spinner").setSmooth("alpha", 0);
            }
        },
        {
            key: "_hideImage",
            value: function _hideImage(tag) {
                this.tag(tag).setSmooth("alpha", 0, _videoLoaderstyle.IMAGE_OUT_TRANSITION);
            }
        },
        {
            key: "_clearTimeouts",
            value: function _clearTimeouts() {
                if (this._jingleTimeout) {
                    clearTimeout(this._jingleTimeout);
                }
                if (this._programImageTimeout) {
                    clearTimeout(this._programImageTimeout);
                }
                this._jingleTimeout = null;
                this._programImageTimeout = null;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return (0, _merge.default)({
                    rect: true,
                    Spinner: {
                        type: _spinnercomponent.default,
                        zIndex: 1
                    },
                    JingleImage: {
                        zIndex: 2
                    },
                    ProgramImage: {
                        zIndex: 3
                    }
                }, (0, _videoLoaderstyle.getInitialStyle)());
            }
        },
        {
            key: "_states",
            value: function _states() {
                return [
                    /*#__PURE__*/ function(_this) {
                        _inherits._(Spinner, _this);
                        var _super = _create_super._(Spinner);
                        function Spinner() {
                            _class_call_check._(this, Spinner);
                            return _super.apply(this, arguments);
                        }
                        _create_class._(Spinner, [
                            {
                                key: "$enter",
                                value: function $enter() {
                                    // Show the Spinner
                                    this.tag("Spinner").setSmooth("alpha", 1, _videoLoaderstyle.SPINNER_IN_TRANSITION);
                                }
                            },
                            {
                                key: "$exit",
                                value: function $exit() {
                                    if (this._jingleImageAvailable) {
                                        this._hideSpinner();
                                    }
                                }
                            }
                        ]);
                        return Spinner;
                    }(this),
                    /*#__PURE__*/ function(_this) {
                        _inherits._(Jingle, _this);
                        var _super = _create_super._(Jingle);
                        function Jingle() {
                            _class_call_check._(this, Jingle);
                            return _super.apply(this, arguments);
                        }
                        _create_class._(Jingle, [
                            {
                                key: "$enter",
                                value: function $enter() {
                                    var _$_this = this;
                                    // Show the Jingle image
                                    this.tag("JingleImage").setSmooth("alpha", 1);
                                    // And switch to a next step with some delay
                                    this._jingleTimeout = setTimeout(function() {
                                        _$_this._setState("Program");
                                    }, _videoLoaderconstants.JINGLE_DURATION);
                                }
                            },
                            {
                                key: "$exit",
                                value: function $exit() {
                                    if (this._programImageAvailable) {
                                        this._hideSpinner();
                                    }
                                }
                            }
                        ]);
                        return Jingle;
                    }(this),
                    /*#__PURE__*/ function(_this) {
                        _inherits._(Program, _this);
                        var _super = _create_super._(Program);
                        function Program() {
                            _class_call_check._(this, Program);
                            return _super.apply(this, arguments);
                        }
                        _create_class._(Program, [
                            {
                                key: "$enter",
                                value: function $enter() {
                                    // Show the Program image
                                    this.tag("ProgramImage").setSmooth("alpha", 1);
                                }
                            }
                        ]);
                        return Program;
                    }(this),
                    /*#__PURE__*/ function(_this) {
                        _inherits._(Complete, _this);
                        var _super = _create_super._(Complete);
                        function Complete() {
                            _class_call_check._(this, Complete);
                            return _super.apply(this, arguments);
                        }
                        _create_class._(Complete, [
                            {
                                key: "$enter",
                                value: function $enter() {
                                    this._reset();
                                    this.signal(_videoLoaderconstants.COMPLETE_SIGNAL);
                                }
                            }
                        ]);
                        return Complete;
                    }(this)
                ];
            }
        }
    ]);
    return VideoLoader;
}(_sdk.Lightning.Component);


/***/ }),

/***/ 49634:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
var _lightningjsredux = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81345));
var _playerselectors = __webpack_require__(83318);
var mapControllers = function(instance) {
    return [
        {
            selector: _playerselectors.getIsLoadingContent,
            shouldBeInvokedOnConnect: true,
            callback: function(value) {
                instance.isLoadingContent = value;
            }
        },
        {
            selector: _playerselectors.getJingleImageId,
            shouldBeInvokedOnConnect: true,
            callback: function(value) {
                instance.jingleImageId = value;
            }
        },
        {
            selector: _playerselectors.getProgramImageId,
            shouldBeInvokedOnConnect: true,
            callback: function(value) {
                instance.programImageId = value;
            }
        }
    ];
};
var _default = _lightningjsredux.default.control(mapControllers);


/***/ }),

/***/ 90616:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/** Defines how long a jingle image should be shown, in milliseconds */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    COMPLETE_SIGNAL: function() {
        return COMPLETE_SIGNAL;
    },
    JINGLE_DURATION: function() {
        return JINGLE_DURATION;
    },
    PROGRAM_IMAGE_DURATION: function() {
        return PROGRAM_IMAGE_DURATION;
    },
    SAFE_COMPETE_TIMEOUT: function() {
        return SAFE_COMPETE_TIMEOUT;
    }
});
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(52318);
var JINGLE_DURATION = 2000;
var PROGRAM_IMAGE_DURATION = 2000;
var SAFE_COMPETE_TIMEOUT = JINGLE_DURATION + PROGRAM_IMAGE_DURATION + 500;
var COMPLETE_SIGNAL = "complete";


/***/ }),

/***/ 59485:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    IMAGE_OUT_TRANSITION: function() {
        return IMAGE_OUT_TRANSITION;
    },
    SPINNER_IN_TRANSITION: function() {
        return SPINNER_IN_TRANSITION;
    },
    SPINNER_SIZE: function() {
        return SPINNER_SIZE;
    },
    STARTING_ALPHA: function() {
        return STARTING_ALPHA;
    },
    colors: function() {
        return colors;
    },
    defaultContext: function() {
        return defaultContext;
    },
    getInitialStyle: function() {
        return getInitialStyle;
    }
});
var _define_property = __webpack_require__(21228);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(37815);
var _constants = __webpack_require__(34952);
var _theme = __webpack_require__(51397);
var _style = __webpack_require__(65082);
var _sizes = __webpack_require__(82699);
var defaultContext = (0, _style.makeDefaultStylingContext)();
var _obj;
var SPINNER_SIZE = (_obj = {}, _define_property._(_obj, _constants.HD, 200), _define_property._(_obj, _constants.FULL_HD, 200), _obj);
var STARTING_ALPHA = 0.001;
var SPINNER_IN_TRANSITION = {
    delay: 0.25
};
var IMAGE_OUT_TRANSITION = {
    duration: 0.3
};
var colors = {
    background: (0, _theme.makeThemeColor)(_theme.TERTIARY)
};
var getInitialStyle = function() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultContext;
    var screenSize = context.screenSize, colorMode = context.colorMode;
    var spinnerSize = SPINNER_SIZE[screenSize];
    return {
        w: _sizes.SCREEN_WIDTH[screenSize],
        h: _sizes.SCREEN_HEIGHT[screenSize],
        color: colors.background[colorMode],
        Spinner: {
            alpha: STARTING_ALPHA,
            mount: 0.5,
            w: spinnerSize,
            h: spinnerSize,
            x: _sizes.middle,
            y: _sizes.middle
        },
        JingleImage: {
            alpha: STARTING_ALPHA
        }
    };
};


/***/ }),

/***/ 3581:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(37815);
var _analyticsreducer = /*#__PURE__*/ _interop_require_default._(__webpack_require__(17842));
var _appreducer = /*#__PURE__*/ _interop_require_default._(__webpack_require__(44831));
var _featuresreducer = /*#__PURE__*/ _interop_require_default._(__webpack_require__(2939));
var _userreducer = /*#__PURE__*/ _interop_require_default._(__webpack_require__(44612));
var _layoutreducer = /*#__PURE__*/ _interop_require_default._(__webpack_require__(60325));
var _lifecyclesreducer = /*#__PURE__*/ _interop_require_default._(__webpack_require__(90678));
var _lockreducer = /*#__PURE__*/ _interop_require_default._(__webpack_require__(59706));
var _pairingreducer = /*#__PURE__*/ _interop_require_default._(__webpack_require__(53308));
var _playerreducer = /*#__PURE__*/ _interop_require_default._(__webpack_require__(42822));
var _routingreducer = /*#__PURE__*/ _interop_require_default._(__webpack_require__(10093));
var _searchreducer = /*#__PURE__*/ _interop_require_default._(__webpack_require__(28320));
var _gdprNoticereducer = /*#__PURE__*/ _interop_require_default._(__webpack_require__(82596));
var _popupreducer = /*#__PURE__*/ _interop_require_default._(__webpack_require__(44269));
var _screenSaverreducer = /*#__PURE__*/ _interop_require_default._(__webpack_require__(294));
// TODO: retire the fakes
var fakeInitialState = {};
var fakeReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : fakeInitialState;
    return _object_spread._({}, state);
};
var _default = {
    analytics: _analyticsreducer.default,
    app: _appreducer.default,
    features: _featuresreducer.default,
    error: function() {
        return fakeReducer;
    },
    layout: _layoutreducer.default,
    lifecycles: _lifecyclesreducer.default,
    lock: _lockreducer.default,
    parentalCode: function() {
        return fakeReducer;
    },
    pairing: _pairingreducer.default,
    player: _playerreducer.default,
    routing: _routingreducer.default,
    search: _searchreducer.default,
    user: _userreducer.default,
    gdpr: _gdprNoticereducer.default,
    popup: _popupreducer.default,
    screenSaver: _screenSaverreducer.default
};


/***/ }),

/***/ 15426:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "initStore", ({
    enumerable: true,
    get: function() {
        return initStore;
    }
}));
var _interop_require_default = __webpack_require__(81200);
var _to_consumable_array = __webpack_require__(30005);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
var _redux = __webpack_require__(4238);
var _reduxthunk = /*#__PURE__*/ _interop_require_default._(__webpack_require__(50536));
var _reducers = /*#__PURE__*/ _interop_require_default._(__webpack_require__(3581));
var _storagemiddleware = /*#__PURE__*/ _interop_require_default._(__webpack_require__(29572));
var _routingmiddleware = /*#__PURE__*/ _interop_require_default._(__webpack_require__(17104));
var _heartbeatmiddleware = /*#__PURE__*/ _interop_require_default._(__webpack_require__(95225));
var _analyticsmiddleware = /*#__PURE__*/ _interop_require_default._(__webpack_require__(98107));
var composeEnhancers =  false ? 0 : _redux.compose;
var middlewares = [
    _reduxthunk.default,
    _storagemiddleware.default,
    _routingmiddleware.default,
    _heartbeatmiddleware.default,
    _analyticsmiddleware.default
].filter(Boolean);
var initStore = function() {
    return (0, _redux.createStore)((0, _redux.combineReducers)(_reducers.default), composeEnhancers(_redux.applyMiddleware.apply(void 0, _to_consumable_array._(middlewares))));
};


/***/ }),

/***/ 11696:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _interop_require_default = __webpack_require__(81200);
var _interop_require_wildcard = __webpack_require__(95316);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
var _config = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67958));
var _searchconstants = __webpack_require__(78884);
var _default = new /*#__PURE__*/ (function() {
    "use strict";
    function Algolia() {
        _class_call_check._(this, Algolia);
        this.sdk = null;
        this.client = null;
        this.indices = null;
    }
    _create_class._(Algolia, [
        {
            key: "_buildSearchQueryParams",
            value: function _buildSearchQueryParams(query, index) {
                var _this = this;
                if (!this.indices[index]) return [];
                var algolia = _config.default.algolia;
                var queryResult = Object.values(_searchconstants.facets).map(function(facet) {
                    return {
                        indexName: _this.indices[index],
                        query: query,
                        params: {
                            hitsPerPage: 20,
                            facetFilters: algolia.platformCode ? [
                                [
                                    "metadata.item_type:".concat(facet)
                                ],
                                [
                                    "metadata.platforms_assets:".concat(algolia.platformCode)
                                ]
                            ] : [
                                "metadata.item_type:".concat(facet)
                            ]
                        }
                    };
                });
                return queryResult;
            }
        },
        {
            key: "init",
            value: function init() {
                var _this = this;
                return _async_to_generator._(function() {
                    var _config_algolia, id, key, indices;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    Promise.resolve().then(function() {
                                        return /*#__PURE__*/ _interop_require_wildcard._(__webpack_require__(6927));
                                    })
                                ];
                            case 1:
                                _this.sdk = _state.sent();
                                _config_algolia = _config.default.algolia, id = _config_algolia.id, key = _config_algolia.key, indices = _config_algolia.indices;
                                _this.client = _this.sdk.default(id, key);
                                _this.indices = indices;
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "extractFacetFromQuery",
            value: function extractFacetFromQuery(query) {
                var facetResult = null;
                Object.values(_searchconstants.facets).forEach(function(facet) {
                    if (query.search(facet) !== -1) {
                        facetResult = facet;
                    }
                });
                return facetResult;
            }
        },
        {
            key: "search",
            value: function search(input) {
                var index = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "default";
                var queryParams = this._buildSearchQueryParams(input, index);
                return this.client.multipleQueries(queryParams);
            }
        }
    ]);
    return Algolia;
}())();


/***/ }),

/***/ 23887:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(88801);
var _invoke = /*#__PURE__*/ _interop_require_default._(__webpack_require__(8957));
var _default = new /*#__PURE__*/ (function() {
    "use strict";
    function NewrelicEngine() {
        _class_call_check._(this, NewrelicEngine);
    }
    _create_class._(NewrelicEngine, [
        {
            /**
   *
   * @param {Object|String} error Can be an Error object or the reason property of PromiseRejectionEvent interface.
   * @param {*} customAttributes Optional. An object containing name/value pairs representing custom attributes.
   */ key: "sendError",
            value: function sendError(error) {
                var customAttributes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                (0, _invoke.default)(window, "newrelic.noticeError", error, customAttributes);
            }
        }
    ]);
    return NewrelicEngine;
}())();


/***/ }),

/***/ 40339:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    handleBootErrors: function() {
        return handleBootErrors;
    },
    switchToThirdPartyHandlers: function() {
        return switchToThirdPartyHandlers;
    },
    unsubscribeBootErrorHandlers: function() {
        return unsubscribeBootErrorHandlers;
    },
    unsubscribeThirdPartyErrorHandlers: function() {
        return unsubscribeThirdPartyErrorHandlers;
    }
});
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(37815);
var _fidosdk = __webpack_require__(19804);
var _newrelicengine = /*#__PURE__*/ _interop_require_default._(__webpack_require__(23887));
var ERROR = "error";
var UNHANDLED_REJECTION = "unhandledrejection";
var errorEventHandler = function(error) {
    _newrelicengine.default.sendError(error.error);
};
var unhandledRejectionEventHandler = function(error) {
    _newrelicengine.default.sendError(error.reason);
};
var thirdPartyErrorEventHandler = function(error) {
    _fidosdk.thirdPartyWithLayoutService.sendErrorEvent(error.error);
};
var thirdPartyUnhandledRejectionEventHandler = function(error) {
    _fidosdk.thirdPartyWithLayoutService.sendErrorEvent(error.reason);
};
var handleBootErrors = function() {
    window.addEventListener(ERROR, errorEventHandler);
    window.addEventListener(UNHANDLED_REJECTION, unhandledRejectionEventHandler);
};
var unsubscribeBootErrorHandlers = function() {
    window.removeEventListener(ERROR, errorEventHandler);
    window.removeEventListener(UNHANDLED_REJECTION, unhandledRejectionEventHandler);
};
var switchToThirdPartyHandlers = function() {
    window.addEventListener(ERROR, thirdPartyErrorEventHandler);
    window.addEventListener(UNHANDLED_REJECTION, thirdPartyUnhandledRejectionEventHandler);
    unsubscribeBootErrorHandlers();
};
var unsubscribeThirdPartyErrorHandlers = function() {
    window.removeEventListener(ERROR, thirdPartyErrorEventHandler);
    window.removeEventListener(UNHANDLED_REJECTION, thirdPartyUnhandledRejectionEventHandler);
};


/***/ }),

/***/ 37165:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Accessibility.3f01f1ca.svg";

/***/ }),

/***/ 27839:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/ActionPlan.b671873e.svg";

/***/ }),

/***/ 23298:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/AddUser.cc2808c5.svg";

/***/ }),

/***/ 64665:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Ages.2e7aaf9d.svg";

/***/ }),

/***/ 43667:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/AirPlay.59da0576.svg";

/***/ }),

/***/ 63398:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/AirPlayOff.59da0576.svg";

/***/ }),

/***/ 16738:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/AirPlayOn.8ee4b338.svg";

/***/ }),

/***/ 96484:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Android.c1c47c4e.svg";

/***/ }),

/***/ 55689:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Apple.d7b1cd91.svg";

/***/ }),

/***/ 46966:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Approved.0d3ac7cd.svg";

/***/ }),

/***/ 93476:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/AudioDescriptionTag.fa443889.svg";

/***/ }),

/***/ 88448:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Audiobook.d5e3acc4.svg";

/***/ }),

/***/ 97034:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Cancel.6a8cad74.svg";

/***/ }),

/***/ 7031:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Chapter.3e4d37fc.svg";

/***/ }),

/***/ 10117:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Chromecast.70471c47.svg";

/***/ }),

/***/ 87272:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/ChromecastOff.70471c47.svg";

/***/ }),

/***/ 53393:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/ChromecastOff1.82a5c113.svg";

/***/ }),

/***/ 28269:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/ChromecastOff2.83de6ef9.svg";

/***/ }),

/***/ 8116:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/ChromecastOn.e40dc116.svg";

/***/ }),

/***/ 90123:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/ChromecastOn1.7a22a973.svg";

/***/ }),

/***/ 67682:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/ChromecastOn2.5250aac6.svg";

/***/ }),

/***/ 20637:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Cookie.f96e9e45.svg";

/***/ }),

/***/ 53467:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Exclamation.80c0597a.svg";

/***/ }),

/***/ 65565:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/FIFA2026.e8e2da12.svg";

/***/ }),

/***/ 57662:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Facebook.abd1f461.svg";

/***/ }),

/***/ 7551:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/FacebookRectangle.e79df523.svg";

/***/ }),

/***/ 78252:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Fire.5f6b9079.svg";

/***/ }),

/***/ 52721:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/FontType.010c054c.svg";

/***/ }),

/***/ 81979:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Friends.54813cda.svg";

/***/ }),

/***/ 22410:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Google.2ba98535.svg";

/***/ }),

/***/ 83248:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/GooglePodcast.d9f03a09.svg";

/***/ }),

/***/ 31648:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/IdealColor.5d84fef7.svg";

/***/ }),

/***/ 9557:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/IdealDefault.5d84fef7.svg";

/***/ }),

/***/ 56634:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Instagram.c1174cb7.svg";

/***/ }),

/***/ 28634:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Itunes.e5ad4d2c.svg";

/***/ }),

/***/ 31089:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Kids.fb35edd5.svg";

/***/ }),

/***/ 80263:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/KidsAge1.f9097369.svg";

/***/ }),

/***/ 8397:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/KidsAge3.eee3e5a4.svg";

/***/ }),

/***/ 90431:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/KidsAge4.c4256189.svg";

/***/ }),

/***/ 89704:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/KidsAge6.88074c7d.svg";

/***/ }),

/***/ 61114:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/KidsAge7.d2c31272.svg";

/***/ }),

/***/ 21627:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/KidsFamily.2675a42e.svg";

/***/ }),

/***/ 42157:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/KidsHome.5fc54cd2.svg";

/***/ }),

/***/ 15628:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/KidsLeave.f589b794.svg";

/***/ }),

/***/ 15624:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/KidsMovie.ee1abcfc.svg";

/***/ }),

/***/ 51506:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/KidsSearch.421575bc.svg";

/***/ }),

/***/ 54661:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/KidsSeries.a1013f7f.svg";

/***/ }),

/***/ 22885:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/MagicWand.87db276e.svg";

/***/ }),

/***/ 74193:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Monogram.25201bd6.svg";

/***/ }),

/***/ 94890:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/One.897d874e.svg";

/***/ }),

/***/ 9274:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/OneColor.9f3cec32.svg";

/***/ }),

/***/ 86143:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Paypal.f8838067.svg";

/***/ }),

/***/ 75001:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Pinterest.12c4ddfc.svg";

/***/ }),

/***/ 47063:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Privacy.06c97f0e.svg";

/***/ }),

/***/ 73039:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Share_Android.9dcbe71d.svg";

/***/ }),

/***/ 63882:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Share_iOS.a53140e9.svg";

/***/ }),

/***/ 18270:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/SkipNextFocused.a0011677.svg";

/***/ }),

/***/ 88485:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/SkipPreviousFocused.1c6ff669.svg";

/***/ }),

/***/ 30211:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Slot.1c3e5c15.svg";

/***/ }),

/***/ 59963:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Star.4aec07a1.svg";

/***/ }),

/***/ 57981:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/TextIncrease.48e580f9.svg";

/***/ }),

/***/ 46644:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Tiktok.87d66c0f.svg";

/***/ }),

/***/ 15507:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Trash.5ec2abe7.svg";

/***/ }),

/***/ 57419:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Twitter.0254069d.svg";

/***/ }),

/***/ 62571:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/UEFA.62eec7ae.svg";

/***/ }),

/***/ 72887:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Voting.06cc4244.svg";

/***/ }),

/***/ 9867:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/WhatsApp.dad95280.svg";

/***/ }),

/***/ 95408:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Youtube.91e1e3c0.svg";

/***/ }),

/***/ 49011:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/AirPlay.ff34072c.svg";

/***/ }),

/***/ 27834:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/AirPlayOff.31aaff43.svg";

/***/ }),

/***/ 73943:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/AirPlayOn.531e8597.svg";

/***/ }),

/***/ 22654:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Chapter.17f896f4.svg";

/***/ }),

/***/ 17031:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Chromecast.f64ca20c.svg";

/***/ }),

/***/ 86775:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/ChromecastOff.f64ca20c.svg";

/***/ }),

/***/ 54413:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/ChromecastOff1.19b79b5c.svg";

/***/ }),

/***/ 7340:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/ChromecastOff2.8885f29d.svg";

/***/ }),

/***/ 40390:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/ChromecastOn.0027e48c.svg";

/***/ }),

/***/ 22120:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/ChromecastOn1.6a35057e.svg";

/***/ }),

/***/ 47942:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/ChromecastOn2.57329cf1.svg";

/***/ }),

/***/ 90179:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/PictureInPicture.bd8c4e11.svg";

/***/ }),

/***/ 18261:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/SkipNextFocused.e18de880.svg";

/***/ }),

/***/ 53883:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/SkipPreviousFocused.871557f2.svg";

/***/ }),

/***/ 6113:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Chapter.8ce3ec9e.svg";

/***/ }),

/***/ 66481:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Live.3c45df6e.svg";

/***/ }),

/***/ 85645:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/SkipNextFocused.40d33463.svg";

/***/ }),

/***/ 61827:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/SkipPrevious.1e469de5.svg";

/***/ }),

/***/ 70963:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/SkipPreviousFocused.1e469de5.svg";

/***/ }),

/***/ 96569:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Agenda.51bba883.svg";

/***/ }),

/***/ 12275:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Alert.2eb73e88.svg";

/***/ }),

/***/ 88242:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/AlertOff.eec16dc5.svg";

/***/ }),

/***/ 27724:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/AlertOn.aae665ab.svg";

/***/ }),

/***/ 98351:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/AlertUnread.68e34eb7.svg";

/***/ }),

/***/ 53421:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/ArrowDown.dc418c28.svg";

/***/ }),

/***/ 75564:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/ArrowLeft.701bb55d.svg";

/***/ }),

/***/ 52968:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/ArrowLeftWithBase.e6a2cbc5.svg";

/***/ }),

/***/ 82236:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/ArrowRight.91479f31.svg";

/***/ }),

/***/ 99680:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/ArrowRightWithBase.e11dc139.svg";

/***/ }),

/***/ 12656:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/ArrowSideNav.91479f31.svg";

/***/ }),

/***/ 53738:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/ArrowUp.57cca1bd.svg";

/***/ }),

/***/ 15131:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Article.24e019d3.svg";

/***/ }),

/***/ 2631:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Audio.96483395.svg";

/***/ }),

/***/ 77228:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/BackSpace.f70b565e.svg";

/***/ }),

/***/ 17883:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/BackToLive.a51a1c1a.svg";

/***/ }),

/***/ 60186:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/BankCard.560a95bb.svg";

/***/ }),

/***/ 7513:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Brightness.12a1c007.svg";

/***/ }),

/***/ 88234:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Brightness1.7ddc253f.svg";

/***/ }),

/***/ 41448:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Brightness2.b18cd040.svg";

/***/ }),

/***/ 39121:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Brightness3.12a1c007.svg";

/***/ }),

/***/ 8870:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Brightness4.36bdb7f9.svg";

/***/ }),

/***/ 71451:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/BrightnessFilled.36bdb7f9.svg";

/***/ }),

/***/ 6639:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Buffering.f768e774.svg";

/***/ }),

/***/ 53488:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/CapsLock.c8decaa2.svg";

/***/ }),

/***/ 82989:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Category.6e0ab06c.svg";

/***/ }),

/***/ 3387:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/CategoryFocused.d4181b61.svg";

/***/ }),

/***/ 38251:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Check.9bbf6ece.svg";

/***/ }),

/***/ 61148:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/CheckFocused.a227dc10.svg";

/***/ }),

/***/ 43497:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/CheckLight.c9bc7868.svg";

/***/ }),

/***/ 67623:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Clock.1f28e722.svg";

/***/ }),

/***/ 90294:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/ClosedCaption.502cca3b.svg";

/***/ }),

/***/ 34692:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Connected.2d1875f6.svg";

/***/ }),

/***/ 2182:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/ConnectedFocused.47a8f31e.svg";

/***/ }),

/***/ 85569:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/ConnectedPremium.d259f374.svg";

/***/ }),

/***/ 55158:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/ConnectedPremiumColor.6dfb1b49.svg";

/***/ }),

/***/ 2926:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/ConnectedPremiumFocused.5e35aa60.svg";

/***/ }),

/***/ 88324:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/ConnectedPremiumFocusedColor.6dfb1b49.svg";

/***/ }),

/***/ 83202:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Contact.d59e0b8e.svg";

/***/ }),

/***/ 78463:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Cross.0e935258.svg";

/***/ }),

/***/ 11737:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Csa10.218028de.svg";

/***/ }),

/***/ 15954:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Csa12.c92fda9d.svg";

/***/ }),

/***/ 85256:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Csa14.b5260e24.svg";

/***/ }),

/***/ 48558:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Csa15.e7eac622.svg";

/***/ }),

/***/ 36230:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Csa16.042df594.svg";

/***/ }),

/***/ 71725:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Csa18.308ecfdf.svg";

/***/ }),

/***/ 33150:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Csa6.8ed662f9.svg";

/***/ }),

/***/ 52874:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Csa9.1ca71ac2.svg";

/***/ }),

/***/ 39803:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/CsaAL.69e843ef.svg";

/***/ }),

/***/ 12194:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Disconnected.47a8f31e.svg";

/***/ }),

/***/ 10378:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Download.f159b918.svg";

/***/ }),

/***/ 75016:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/DownloadIssue.50fd0ba4.svg";

/***/ }),

/***/ 81727:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/DownloadPause.bb452e61.svg";

/***/ }),

/***/ 48965:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/DownloadToGo.f159b918.svg";

/***/ }),

/***/ 19873:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Downloaded.dc7d3e9d.svg";

/***/ }),

/***/ 49169:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Downloading.aa89c972.svg";

/***/ }),

/***/ 5629:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Ear.e5553986.svg";

/***/ }),

/***/ 31554:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Edit.4098c025.svg";

/***/ }),

/***/ 12484:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/EditFocused.c4899380.svg";

/***/ }),

/***/ 97648:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Embed.aaa9f1fd.svg";

/***/ }),

/***/ 28594:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Error.3d838715.svg";

/***/ }),

/***/ 76468:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/ErrorEmoji.786b51cb.svg";

/***/ }),

/***/ 39804:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/EyeOff.0867e3ce.svg";

/***/ }),

/***/ 97231:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/EyeOn.65ddfbf6.svg";

/***/ }),

/***/ 97387:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Football.b2476838.svg";

/***/ }),

/***/ 50260:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/FootballFocused.642a2829.svg";

/***/ }),

/***/ 16542:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/FreemiumLock.dce9335d.svg";

/***/ }),

/***/ 63075:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Genres.d3cf2dce.svg";

/***/ }),

/***/ 60428:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Gift.8b792f8b.svg";

/***/ }),

/***/ 77508:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/GoBack.701bb55d.svg";

/***/ }),

/***/ 90344:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Help.d56df2f3.svg";

/***/ }),

/***/ 63606:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/History.4ce97f77.svg";

/***/ }),

/***/ 29291:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Home.f0e76f65.svg";

/***/ }),

/***/ 26244:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/HomeFocused.70dd3403.svg";

/***/ }),

/***/ 67720:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Info.4b463f32.svg";

/***/ }),

/***/ 84935:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/InfoFocused.8a5a6c4d.svg";

/***/ }),

/***/ 27975:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/InfoLight.39a740d6.svg";

/***/ }),

/***/ 802:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/JustIn.2c86094e.svg";

/***/ }),

/***/ 38660:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/KebabMenu.574cfca0.svg";

/***/ }),

/***/ 9907:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Laptop.ee2a78c0.svg";

/***/ }),

/***/ 5398:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Leaf1.c45ecb44.svg";

/***/ }),

/***/ 49585:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Leaf2.a272da10.svg";

/***/ }),

/***/ 4854:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Like.8dce879c.svg";

/***/ }),

/***/ 80821:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Liked.31ccb34a.svg";

/***/ }),

/***/ 54468:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Link.c8f099e4.svg";

/***/ }),

/***/ 98655:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/ListAdd.8dce879c.svg";

/***/ }),

/***/ 71891:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/ListAdded.31ccb34a.svg";

/***/ }),

/***/ 69805:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/ListRemoved.8dce879c.svg";

/***/ }),

/***/ 49367:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Live.bfc0cdc4.svg";

/***/ }),

/***/ 68684:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Loading.f768e774.svg";

/***/ }),

/***/ 2925:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Lock.48998dee.svg";

/***/ }),

/***/ 14124:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Logout.dc53a946.svg";

/***/ }),

/***/ 42272:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Movies.4d309d4f.svg";

/***/ }),

/***/ 60531:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Offline.57a84db8.svg";

/***/ }),

/***/ 23657:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/ParentalGuidanceDiscrimination.fe8ccaf0.svg";

/***/ }),

/***/ 26129:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/ParentalGuidanceDrugs.839ecdf0.svg";

/***/ }),

/***/ 27209:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/ParentalGuidanceFoulLanguage.855beb50.svg";

/***/ }),

/***/ 44644:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/ParentalGuidanceScary.4d20dafd.svg";

/***/ }),

/***/ 20278:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/ParentalGuidanceSex.4dda3902.svg";

/***/ }),

/***/ 77894:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/ParentalGuidanceViolence.f5039447.svg";

/***/ }),

/***/ 70966:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Pause.ce2552e7.svg";

/***/ }),

/***/ 1888:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Phone.6391e561.svg";

/***/ }),

/***/ 47402:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Play.dbd48217.svg";

/***/ }),

/***/ 16849:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Playlist.e2219c0d.svg";

/***/ }),

/***/ 89440:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/PlaylistFocused.bd9d628e.svg";

/***/ }),

/***/ 38408:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Plus.81838775.svg";

/***/ }),

/***/ 94042:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Podcast.c6f6038b.svg";

/***/ }),

/***/ 43038:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Premium.a809bd90.svg";

/***/ }),

/***/ 44639:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/PremiumColor.077678ee.svg";

/***/ }),

/***/ 32629:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/PrincipalProfile.0ddf32b5.svg";

/***/ }),

/***/ 14796:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/ProductPlacement.757b8cf5.svg";

/***/ }),

/***/ 49134:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Programs.e3e66f47.svg";

/***/ }),

/***/ 42841:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Purchase.7fcc50cf.svg";

/***/ }),

/***/ 57177:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/QRCode.fa4e7703.svg";

/***/ }),

/***/ 57288:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/RSS.1556f067.svg";

/***/ }),

/***/ 96973:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Refresh.22716b43.svg";

/***/ }),

/***/ 28682:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/RelatedVideos.c01a79da.svg";

/***/ }),

/***/ 95922:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/RelatedVideosFocused.368f06ba.svg";

/***/ }),

/***/ 74808:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Remote.6e849ee4.svg";

/***/ }),

/***/ 20174:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Remove.99a4505d.svg";

/***/ }),

/***/ 64324:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Search.c369209d.svg";

/***/ }),

/***/ 81365:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/SearchFocused.f7a1ee64.svg";

/***/ }),

/***/ 28834:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/SeekBackward.2eedae38.svg";

/***/ }),

/***/ 13127:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/SeekBackwardFeedback.8f2c4654.svg";

/***/ }),

/***/ 96856:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/SeekForward.3bdcbb6e.svg";

/***/ }),

/***/ 80716:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/SeekForwardFeedback.c6deac2e.svg";

/***/ }),

/***/ 98823:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Series.83a552fc.svg";

/***/ }),

/***/ 30867:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Settings.593cf370.svg";

/***/ }),

/***/ 54032:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/SettingsEco1.9772158c.svg";

/***/ }),

/***/ 60688:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/SettingsEco2.8a3ad2e3.svg";

/***/ }),

/***/ 9184:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Share.eb551fc1.svg";

/***/ }),

/***/ 92840:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Shield.c04be000.svg";

/***/ }),

/***/ 50729:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/SkipNext.4c0c5c7d.svg";

/***/ }),

/***/ 44262:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/SkipPrevious.30fc6402.svg";

/***/ }),

/***/ 99639:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Sliders.29e351e5.svg";

/***/ }),

/***/ 16940:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Space.7e3d7271.svg";

/***/ }),

/***/ 4711:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Speed.d43c749a.svg";

/***/ }),

/***/ 91632:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/StartOver.78e63f1a.svg";

/***/ }),

/***/ 17638:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Television.f7b6acb9.svg";

/***/ }),

/***/ 21651:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/TelevisionFocused.3cdcfd85.svg";

/***/ }),

/***/ 79090:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Timer.d3caf82c.svg";

/***/ }),

/***/ 64024:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/TimerFocused.65d5087f.svg";

/***/ }),

/***/ 40300:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Tracks.db48f176.svg";

/***/ }),

/***/ 30494:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/TracksFilled.ec92a309.svg";

/***/ }),

/***/ 65727:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Trailer.6b7f9678.svg";

/***/ }),

/***/ 97625:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Univers.434cd91c.svg";

/***/ }),

/***/ 4847:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Unlock.a4534c45.svg";

/***/ }),

/***/ 78254:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Usabilla.b63e5a10.svg";

/***/ }),

/***/ 91564:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Vocal.96483395.svg";

/***/ }),

/***/ 45046:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Volume.768880c2.svg";

/***/ }),

/***/ 50405:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Volume1.48fe1d19.svg";

/***/ }),

/***/ 86573:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Volume2.92c430ba.svg";

/***/ }),

/***/ 4913:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Volume3.bb8116df.svg";

/***/ }),

/***/ 72712:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Volume4.768880c2.svg";

/***/ }),

/***/ 67501:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/VolumeDown.bb8116df.svg";

/***/ }),

/***/ 49576:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/VolumeFilled.6ab9624b.svg";

/***/ }),

/***/ 62155:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/VolumeOff.01981d0e.svg";

/***/ }),

/***/ 85674:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/VolumeUp.6ab9624b.svg";

/***/ }),

/***/ 43133:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Warning.ef0ec3d3.svg";

/***/ }),

/***/ 88344:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Wave.29e3dc6f.svg";

/***/ }),

/***/ 80567:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Wave1.0dd0fc26.svg";

/***/ }),

/***/ 61838:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Wave2.b19a7326.svg";

/***/ }),

/***/ 27640:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Wave3.1d8560fa.svg";

/***/ }),

/***/ 56752:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Wave4.8d956451.svg";

/***/ }),

/***/ 13594:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/ArrowDown.a508a30f.svg";

/***/ }),

/***/ 57383:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/ArrowLeftWithBase.62bbf707.svg";

/***/ }),

/***/ 46855:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/ArrowUp.2a83c7d9.svg";

/***/ }),

/***/ 59028:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/AudioDescription.6b1009a9.svg";

/***/ }),

/***/ 34493:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/BackSpace.9f0552b2.svg";

/***/ }),

/***/ 90461:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/BackToLive.a529dfff.svg";

/***/ }),

/***/ 30665:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/BackToLiveHBBTV.2f344c33.svg";

/***/ }),

/***/ 41422:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Brightness.1a6ac378.svg";

/***/ }),

/***/ 66465:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Brightness1.95d2e3d1.svg";

/***/ }),

/***/ 6814:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Brightness2.4314ce4e.svg";

/***/ }),

/***/ 81877:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Brightness3.1a6ac378.svg";

/***/ }),

/***/ 39180:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Brightness4.e8bd1d2e.svg";

/***/ }),

/***/ 51722:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/BrightnessFilled.e8bd1d2e.svg";

/***/ }),

/***/ 27455:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Contact.ee88c7d9.svg";

/***/ }),

/***/ 55679:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/ErrorEmoji.945cd0ed.svg";

/***/ }),

/***/ 65435:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/FullscreenOff.a7227844.svg";

/***/ }),

/***/ 91952:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/FullscreenOn.b497bd2a.svg";

/***/ }),

/***/ 9542:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Info.516b8f41.svg";

/***/ }),

/***/ 79421:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Pause.c41cf297.svg";

/***/ }),

/***/ 64886:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Play.f4bfa5a9.svg";

/***/ }),

/***/ 65736:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Playlist.2b02214e.svg";

/***/ }),

/***/ 8043:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/PlaylistFocused.1e4eeb53.svg";

/***/ }),

/***/ 93142:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/RelatedVideos.c370539d.svg";

/***/ }),

/***/ 31860:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Remote.8b7928a0.svg";

/***/ }),

/***/ 73118:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Replay.b3064056.svg";

/***/ }),

/***/ 74108:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/SeekBackward.889f7129.svg";

/***/ }),

/***/ 51423:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/SeekBackwardFeedback.71381e29.svg";

/***/ }),

/***/ 35260:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/SeekForward.58aa0f30.svg";

/***/ }),

/***/ 45105:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/SeekForwardFeedback.a7323810.svg";

/***/ }),

/***/ 73988:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Settings.4b321d40.svg";

/***/ }),

/***/ 32396:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/SettingsEco1.858a78c2.svg";

/***/ }),

/***/ 66871:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/SettingsEco2.00b683f5.svg";

/***/ }),

/***/ 49058:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Share.a5c1f298.svg";

/***/ }),

/***/ 82078:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/SkipNext.1f871238.svg";

/***/ }),

/***/ 57785:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/SkipPrevious.72cd2fc7.svg";

/***/ }),

/***/ 18355:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Space.2d0bbd6b.svg";

/***/ }),

/***/ 34618:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Speed.9a7cbc89.svg";

/***/ }),

/***/ 79139:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/StartOver.df618be0.svg";

/***/ }),

/***/ 50961:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/SwitchAudioIcon.24133bd1.svg";

/***/ }),

/***/ 52071:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/SwitchVideoIcon.766f5524.svg";

/***/ }),

/***/ 38605:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Timer.e46c70d1.svg";

/***/ }),

/***/ 92083:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/TimerFocused.9df49df5.svg";

/***/ }),

/***/ 75987:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Tracks.9a615419.svg";

/***/ }),

/***/ 31666:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/TracksFilled.d6b83940.svg";

/***/ }),

/***/ 24610:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Usabilla.6eaeaf75.svg";

/***/ }),

/***/ 94066:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/VOST.b6430488.svg";

/***/ }),

/***/ 83902:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Volume.f7ec8669.svg";

/***/ }),

/***/ 53845:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Volume1.b5d8cd46.svg";

/***/ }),

/***/ 29758:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Volume2.e855fb0d.svg";

/***/ }),

/***/ 37200:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Volume3.13d70696.svg";

/***/ }),

/***/ 6500:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Volume4.c42ad370.svg";

/***/ }),

/***/ 93770:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/VolumeDown.c2c8ba31.svg";

/***/ }),

/***/ 29112:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/VolumeFilled.dacf91a5.svg";

/***/ }),

/***/ 11890:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/VolumeOff.095d6cd1.svg";

/***/ }),

/***/ 49175:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/VolumeUp.c42ad370.svg";

/***/ }),

/***/ 10463:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/ArrowLeftWithBase.f7fc7769.svg";

/***/ }),

/***/ 29682:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/AudioDescription.c5c7ebb4.svg";

/***/ }),

/***/ 44158:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/BackToLive.6ed55b8f.svg";

/***/ }),

/***/ 94881:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Cross.e6075448.svg";

/***/ }),

/***/ 80448:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Info.fe68d825.svg";

/***/ }),

/***/ 47805:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/MultiDevices.e62cbb30.svg";

/***/ }),

/***/ 27872:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/RelatedVideos.99ceaac8.svg";

/***/ }),

/***/ 62791:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Remote.eb832505.svg";

/***/ }),

/***/ 17748:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/SkipNext.2c6cabd0.svg";

/***/ }),

/***/ 28224:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/StartOver.dad39133.svg";

/***/ }),

/***/ 30464:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Tracks.573bc853.svg";

/***/ }),

/***/ 39499:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/Usabilla.144e136f.svg";

/***/ }),

/***/ 40471:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/VOST.f3221cae.svg";

/***/ }),

/***/ 20836:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/RTLUnitedText-Bold.26c120c5.woff";

/***/ }),

/***/ 23713:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/RTLUnitedText-Regular.086ac38f.woff";

/***/ }),

/***/ 2372:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/landing-background-FULL_HD.62473114.jpg";

/***/ }),

/***/ 87362:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "static/media/landing-background-HD.8219ed5c.jpg";

/***/ }),

/***/ 12611:
/***/ ((module) => {

"use strict";
module.exports = _;

/***/ }),

/***/ 91054:
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ 53827:
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ 57002:
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ 87942:
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ 82880:
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ 47401:
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ 94823:
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ 27259:
/***/ ((module) => {

"use strict";
module.exports = JSON.parse('{"account_settings":{"qrcode":{"infos":"Scan the QR code with your smartphone camera to access the settings page or go to ","title":"account_settings.title"},"title":"Settings"},"bookmarks":{"actionLabel":"My list","added":"Bookmark added","noContentAction":"Explore the catalog","noContentDescription":"The content you will add to your list will appear here!","noContentTitle":"Your catalogue is a bit empty.","removed":"Bookmark removed","title":"My list"},"contentInfo":{"actionLabel":"Info"},"date":{"days":{"friday":{"abbreviation":"Fri","complete":"Friday"},"monday":{"abbreviation":"Mon","complete":"Monday"},"saturday":{"abbreviation":"Sat","complete":"Saturday"},"sunday":{"abbreviation":"Sun","complete":"Sunday"},"thursday":{"abbreviation":"Thu","complete":"Thursday"},"tuesday":{"abbreviation":"Tue","complete":"Tuesday"},"wednesday":{"abbreviation":"Wed","complete":"Wednesday"}},"months":{"april":{"abbreviation":"Apr","complete":"April"},"august":{"abbreviation":"Aug","complete":"August"},"december":{"abbreviation":"Dec","complete":"December"},"february":{"abbreviation":"Feb","complete":"February"},"january":{"abbreviation":"Jan","complete":"January"},"july":{"abbreviation":"Jul","complete":"July"},"june":{"abbreviation":"Jun","complete":"June"},"march":{"abbreviation":"Mar","complete":"March"},"may":{"abbreviation":"May","complete":"May"},"november":{"abbreviation":"Nov","complete":"November"},"october":{"abbreviation":"Oct","complete":"October"},"september":{"abbreviation":"Sep","complete":"September"}}},"device":{"a1":"A1","kpn":"KPN","magenta":"Magenta","sky":"Sky","vodafone":"Vodafone","ziggo":"Ziggo"},"epgGrid":{"afternoon":"Afternoon","currentWeek":"This week","evening":"Evening","lastWeek":"Last week","live":"Live","morning":"Morning","nextWeek":"Next week","noAction":"This content is not available on live, nor catch up","noProgram":"No program available","today":"Today"},"error":{"csl":"This video has been interrupted because you have exceeded the simultaneous viewing limit allowed by your account.","general":"Oups, something went wrong, please try later.","pairing":"An error occurred during pairing, please try later.","player":"An error occurred during video loading, please try later.","podcast":"Unable to play the podcast. Please try again.","retry":"Retry"},"faq":{"qrcode":{"infos":"Scan the QR code with your smartphone camera to access the FAQ or go to ","title":"Looking for help?"},"title":"FAQ"},"feedback":{"qrcode":{"infos":"Scan the QR code with your smartphone camera to access the feedback form or go to","title":"Share something with us!"},"title":"Send Feedback"},"gdprNotice":{"decline":"Decline all","description":"If you agree, cookies or others trackers are used on this platform by Bedrock and its partners for the purpose of making statistics of visits and to offer you advertisements, services and offers adapted to your centers of interest. For more information and to exercise your rights, please visit our cookies policy page. There you can manage your preferences regarding the use and deposit of cookies and others trackers at any time.","ok":"Accept all","parameters":"Setting my choices"},"global":{"back":"Back","backSave":"Save and go back","backToNavigation":"Back to navigation","cancel":"Cancel","close":"Close","confirmExit":"Do you want to quit?","confirmLive":" Are you sure you want to return to live ?","continue":"Continue","hide":"Hide","isLive":"LIVE","loading":"Loading...","no":"No","numbers":{"number_eight":"eight","number_five":"five","number_four":"four","number_nine":"nine","number_one":"one","number_seven":"seven","number_six":"six","number_three":"three","number_two":"two","number_zero":"zero"},"ok":"OK","open":"Open the application","pressBlue":"Press the blue button","pressRed":"Press the red button","quit":"Quit","returnHome":"Back to home","returnHomeSaved":"Save and back to live","returnSettings":"Back to settings","save":"Save","service":"Service","settings":"Settings","show":"Show","showMore":"Show more","yes":"Yes"},"helpAndContact":{"text":"The help center isn\'t available on TV application. To access it, got to \\"My account\\" on your mobile application, on the web site, or from a web browser, smartphone, tablet or computer, to the page : bedrockstreaming.com","title":"Help and contact"},"information":{"qrcode":{"infos":"Scan the QR code with your smartphone camera to access the account page or go to","title":"information.title"},"title":"Information"},"informations":{"account":"Your account","description":"To update your account information, go on bedrockstreaming.com from your mobile or desktop","parentalFilter":"Parental filter","parentalFilterDescription":"All contents under %(age)s years old are currently protected by your code, on all profiles.","parentalFilterOff":"Deactivated","parentalFilterOn":"Activated","paymentRecurrence":"/ Month","subscription":"Your subscription","title":"My information"},"layout":{"locks":{"live":{"unavailableNotAiring":"Broadcasting not started yet."}}},"leavingKidsSection":{"title":"To leave the children\'s area, enter the following numbers.","wrongCode":"The code is incorrect, please try again."},"legalNotice":{"button":"settings/privacy","title":"Privacy Policy"},"misc":{"scaffold":{"markers":"markers","remote":"remote"}},"nav":{"backToLive":"Back to live","backToNav":"Back to navigation","channelSelector":"Channels","episodes":"Episodes","relatedVideos":"You may also like","subtitles":"Audio and subtitles"},"network":{"failedSubTitle":"Please check your internet connection","failedTitle":"Connection Failed"},"pairing":{"completion":{"button":"OK","description":"Account completion description","title":"Account completion"},"landing":{"catchPhrase":"Unlimited TV and Streaming in a single platform.","connect":"Please do pairing to watch video, use my list and watch profile information.","description":"Watch more than 10,000 hours of series, films, documentaries and kids shows in streaming. And find your favourite TV channels and shows live, replay, previews or full seasons. Enjoy of a free one-month trial.","enter":"Enter","help":"A question ? go to some-url.com/help","pricing":"","signIn":"Connect","signOn":"Subscribe","subscribeOffer":"30 days free trial"},"ssi":{"accept":"Accept","decline":"Decline","description":"Description of SSI plan","title":"Use SSI on this platform"},"subscribe":{"expired":{"description":"You can subscribe to the Bedrock website and application from your computer, tablet or smartphone","redirection":"Visit www.bedrockstreaming.com or the Bedrock mobile application available on the App store","switchAccount":"Change your account","title":"You are no longer subscribed to Bedrock"},"finally":"Once subscribed, it will be sufficient to connect to your account to enjoy Bedrock on your TV","goWeb":"Go to the Bedrock mobile app or the website\\nhttps://www.bedrockstreaming.com to subscribe","how":"How to subscribe to Bedrock?","offers":{"offer1":{"description":"","feature1":"","feature10":"","feature2":"","feature3":"","feature4":"","feature5":"","feature6":"","feature7":"","feature8":"","feature9":"","title":""},"offer2":{"description":"","feature1":"","feature10":"","feature2":"","feature3":"","feature4":"","feature5":"","feature6":"","feature7":"","feature8":"","feature9":"","title":""},"offer3":{"description":"","feature1":"","feature10":"","feature2":"","feature3":"","feature4":"","feature5":"","feature6":"","feature7":"","feature8":"","feature9":"","title":""}}},"token":{"callToActionText":"Enter the following code:","connect":"Connect your TV","magenta":{"accept":"Use with MagentaTV","button":"Via MagentaTV","title":"If you are already a Magenta SMART customer and RTL+ is part of your Magenta package, you can easily log in using this button"},"synchRedirection":"Go to your \\"My Profile\\" space on the website www.bedrockstreaming.com or to the section \\"Synchronize my profile\\" on the Bedrock mobile application"},"welcome":{"disconnect":"Logout","profileChoice":"Choose your profile","title":"Welcome on Bedrock","titleBack":"Welcome back!"}},"parentalCode":{"forgottenCode":"Forgot your parental code?","incorrectCode":"The code is invalid, please try again","instruction":"Enter your parental code to start watching your content","lost":{"catalogReturn":"Go back to the catalogue","instruction":"You can retrieve or change your 4-digit PIN code on Bedrock website or mobile applications. Go to \\"My account\\", \\"Parental Filter\\" section"},"title":"This content is locked","wrongCode":"The parental code seems incorrect. Try again."},"parentalFilter":{"content":"Activate the filter to see public content only.","label":"Parental filter","title":"Trust space"},"player":{"adExtraTitle":"%(contentTitle)s will start soon","adMessage":"Advertisement: Your program will resume soon","advertisement":"Advertisement","audio":"Audio","audioDescription":"Audio description","closedCaption":"Closed caption","info":"Info","loader":"LOADING...","nextVideo":{"askReplay":"Replay video?","nextCountdown":"Next video in","unit":"seconds"},"originalSoundtrack":"Original soundtrack","other":"Other","pauseAdMessage":"Press enter to resume the program","replay":"Start again","skipCredits":"Skip credits","skipIntro":"Skip introduction","subDisable":"Disable","subtitles":"Subtitles"},"popups":{"ageGate":{"body":"By pressing CONTINUE you certify that you are at least 18 years old.","heading":"You are about to watch a content that may contain adult-only scenes."},"geoBlocking":{"body":"Sorry\\nThis content is not available in your area"}},"privacySettings":{"cgu":{"title":"Privacy Policy"},"cookie":{"audienceMeasurement":{"content":"The purpose of these cookies is to analyze the traffic and the use of the Bedrock Platform, to better understand how it is used and to improve your browsing experience and use of the Platform. In particular, these cookies may process data relating to the pages visited, the content viewed, the length of time the pages are visited, the browser you are using to visit these pages, etc.","id":"audienceMeasurement","title":"Cookies for audience measurement"},"description":"This page allows you to configure your choices regarding the use of cookies and other tracking devices. With your consent, cookies or other tracking devices are used on this platform by Bedrock and its partners to generate visit statistics, customize the platform\'s services and provide you with services and offers tailored to your interests. To learn more, please visit our Cookie Policy. The settings made via this module apply to this device only, whether or not you are connected to your Bedrock account. If you have a Bedrock account, the cookie settings will not affect the use of your user profile information provided when you created your account to personalize your editorial and advertising experience based on your interests. We invite you to connect to your account if you wish to control their use. For more information, please visit our Privacy Policy.","personalization":{"content":"The purpose of these cookies is to identify content that may be of interest to you with respect to your activity on the Bedrock Platform in order to offer you a personalized editorial experience based on your interests. Disabling these cookies will prevent Bedrock from offering you a personalized experience and content through cookies.","id":"personalization","title":"Platform customization cookies"},"targetedAdvertising":{"content":"The purpose of these cookies is to improve the relevance of the advertisements and advertising content displayed on the Bedrock Platform as well as on third-party media. When we send you promotional messages or broadcast such messages, our goal is to send you the most relevant advertisements and offers possible, adapted to your needs or truly likely to interest you. Deactivating these cookies has no impact on the volume of advertising you will receive.","id":"targetedAdvertising","title":"Advertising cookies"},"text":""},"title":"Privacy settings"},"profile":{"switch":"Change profile"},"search":{"empty":"There is no search history for now","hint":"Search for programs, videos and thematic","history":"Your latest search","placeholder":"A program, a video, a thematic...","playlist":"Playlist","podcast":"Podcasts","program":"Programs","vc":"short videos","vi":"integral videos"},"sidenav":{"channel":"Channels","home":"Home","profile":"Profile","search":"Search","settings":"Settings"},"startover":{"restart":"Restart program over"},"trailer":{"actionLabel":"Trailer"},"upsell":{"computer":{"button":"From Web","pairedButton":"Already booked? Continue to the content","step1":"Go to %(url)s","step2":"Book the RTL Package that suits for you","step3":"Once your subscription is complete, click on the button below","title":"To play this content","unpairedButton":"Already have the right RTL+ package? Sign in"},"error":"To access this content, a higher plan is required","mobile":{"button":"From your mobile","pairedButton":"Already booked? Continue to the content","step1":"Scan the QR code","step2":"Book the RTL Package that suits for you","step3":"Once your subscription is complete, click on the button below","title":"To play this content","unpairedButton":"Already have the right RTL+ package? Sign in"},"title":"Found what you were looking for"},"userInformation":{"appVersion":"App version","deviceId":"Television id","isp":"Internet service provider","title":"User information","userAgent":"User-Agent"}}');

/***/ }),

/***/ 2462:
/***/ ((module) => {

"use strict";
module.exports = JSON.parse('{"accountInformation":{"qrcode":{"infos":"Scanne den QR-Code mit deinem Smartphone, oder öffne dein Konto unter:","title":"Mein Konto"},"title":"Konto"},"accountSettings":{"qrcode":{"infos":"Scanne den QR-Code mit deinem Smartphone, oder öffne die Einstellungen unter:","title":"Einstellungen"},"title":"Einstellungen"},"auth":{"sessionExpired":"Deine Sitzung ist abgelaufen. Bitte melde dich erneut an.","sessionRefreshedForProfile":"Etwas ist schiefgelaufen. Bitte wählen Sie erneut ein Profil aus."},"blocking":{"blockedLive":"Fr"},"bookmarks":{"actionLabel":"Meine Inhalte","added":"Du hast dieses Programm zu deinen Inhalten hinzugefügt.","noContentAction":"Fülle deine persönliche Bibliothek mit deinen Lieblingsinhalten","noContentDescription":"Inhalte, die du gemerkt hast, werden hier angezeigt!","noContentTitle":"Noch nichts da","removed":"Du hast dieses Programm aus deinen Inhalten entfernt.","title":"Meine Inhalte"},"confirmation":{"description":"Du hast jetzt vollen Zugriff von diesem Gerät/Netzwerk aus.\\nJedes Gerät, das mit diesem Netzwerk verbunden ist, wird nun als Teil deines Haushalts betrachtet.","title":"Dieses {Gerät/Netzwerk} wurde zu deinem Haushalt hinzugefügt"},"consentLock":{"cta":"Datenschutzeinstellungen","description":"Du musst der Anzeige zielgerichteter Werbung zustimmen, um dieses Programm ansehen zu können."},"contentInfo":{"actionLabel":"Info"},"contentRatingAdvisory":{"subTextMessage":"Durch das Klicken auf \\"WEITER\\" bestätigst du, dass du über 18 Jahre alt bist.","textMessage":"Die Ansicht des folgenden Programms wird Personen über 18 Jahren empfohlen."},"date":{"days":{"friday":{"abbreviation":"Fr.","complete":"Freitag"},"monday":{"abbreviation":"Mo.","complete":"Montag"},"saturday":{"abbreviation":"Sa.","complete":"Samstag"},"sunday":{"abbreviation":"So.","complete":"Sonntag"},"thursday":{"abbreviation":"Do.","complete":"Donnerstag"},"tuesday":{"abbreviation":"Di.","complete":"Dienstag"},"wednesday":{"abbreviation":"Mi.","complete":"Mittwoch"}},"months":{"april":{"abbreviation":"Apr.","complete":"April"},"august":{"abbreviation":"Aug.","complete":"August"},"december":{"abbreviation":"Dez.","complete":"Dezember"},"february":{"abbreviation":"Feb.","complete":"Februar"},"january":{"abbreviation":"Jan.","complete":"Januar"},"july":{"abbreviation":"Jul.","complete":"Juli"},"june":{"abbreviation":"Jun.","complete":"Juni"},"march":{"abbreviation":"Mär.","complete":"März"},"may":{"abbreviation":"Mai","complete":"Mai"},"november":{"abbreviation":"Nov.","complete":"November"},"october":{"abbreviation":"Okt.","complete":"Oktober"},"september":{"abbreviation":"Sep.","complete":"September"}}},"detection":{"action":"Account bestätigen","description":"Haushalt mit dem Bestätigungscode aktualisieren, der dir gesendet wurde","extraDescription":"Gehörst du zu diesem Account-Haushalt?","logout":"Abmelden","secondaryAction":"Später bestätigen","tertiaryAction":"Neuen Account erstellen","title":"Dieser Account wird offenbar außerhalb des Haupt-Haushalts genutzt"},"devicesGate":{"action":"Erneut versuchen","description":"Du hast die maximale Anzahl an Geräten erreicht, die mit deinem Account verbunden sind. Um fortzufahren, trenne eines der Geräte über die mobile Anwendung oder die Website RTL+ in den Einstellungen. ","secondaryAction":"Abmelden","title":"Gerät entfernen"},"epg":{"noAction":"Dieser Inhalt ist weder im Livestream noch auf Abruf verfügbar"},"epgGrid":{"afternoon":"Nachmittag","currentWeek":"Diese Woche","evening":"Abend","lastWeek":"Letzte Woche","live":"Live","modal":{"april":"April","august":"August","december":"Dezember","february":"Februar","friday":"Freitag","january":"Januar","july":"Juli","june":"Juni","march":"März","may":"Mai","monday":"Montag","november":"November","october":"Oktober","saturday":"Samstag","september":"September","sunday":"Sonntag","thursday":"Donnerstag","tuesday":"Dienstag","wednesday":"Mittwoch"},"morning":"Morgens","nextWeek":"Nächste Woche","noAction":"Dieser Inhalt ist weder im Livestream noch auf Abruf verfügbar","noProgram":"Kein Programm verfügbar","today":"Heute"},"error":{"csl":"Dieses Video wurde unterbrochen, weil du die für dein Account zulässige Anzahl an gleichzeitigen Aufrufen überschritten hast.","general":"Es ist etwas schiefgelaufen, bitte versuche es später erneut.","layout":"Es ist etwas schiefgelaufen, bitte versuche es später erneut.","maxParentalCode":"Die maximale Anzahl an Versuchen zur Eingabe des Jugendschutz-Codes wurde erreicht. Sie können es in 30 Minuten erneut versuchen oder den Code jetzt auf der RTL+ Webseite ändern: rtlplus.de/account","noAvailableDetails":"Keine verfügbaren Details zu diesem Fehler","pairing":"Beim Koppeln ist ein Fehler aufgetreten, bitte versuche es später noch einmal.","permanent":"Ups, etwas ist schief gelaufen, bitte starten Sie die Anwendung neu.","player":"Beim Laden des Videos ist ein Fehler aufgetreten, bitte versuche es später.","podcast":"Der Podcast konnte nicht abgespielt werden. Bitte versuche es erneut.","premium":"Scanne den QR-Code mit deiner Smartphone-Kamera oder geh zu folgender Adresse","pressKeyUpToExit":"Drücken Sie die UP-Taste, um dieses Popup zu schließen","retry":"Wiederholen"},"faq":{"qrcode":{"infos":"Scanne den QR-Code mit deinem Smartphone, oder öffne die FAQ unter:","link":"www.bit.ly/1a2b3c","title":"Brauchst du Hilfe?"},"title":"FAQ"},"feedback":{"qrcode":{"infos":"Scanne den QR-Code mit deinem Smartphone, oder öffne das Feedback-Formular unter:","title":"Feedback teilen"},"title":"Feedback"},"gdprNotice":{"decline":"Alle ablehnen","description":"Wenn du einverstanden bist, werden RTL+ und seinen Partnern Cookies oder andere Tracker verwendet, um Besucherstatistiken zu erstellen und dir Werbung, Dienstleistungen und Angebote anzubieten, die auf deine Interessen zugeschnitten sind. Weitere Informationen und die Möglichkeit, deine Rechte auszuüben, findest du auf unserer Seite zur Cookie-Richtlinie. Dort kannst du jederzeit deine Einstellungen bezüglich der Verwendung und Speicherung von Cookies und anderen Trackern verwalten.","ok":"Alle akzeptieren","parameters":"Meine Einstellungen"},"geoblocking":{"errorMessage":"RTL+ ist leider nur in Deutschland, Österreich und der Schweiz verfügbar.","exitApplication":"Anwendung beenden","videoErrorMessage":"Zurücksetzen"},"global":{"back":"Zurück","backSave":"Speichern und zurückgehen","backToNavigation":"Zurück zur Navigation","cancel":"Abbrechen","close":"Schließen","confirmExit":"Möchtest du beenden?","confirmLive":"Bist du sicher, dass du zurück zu Live willst?","continue":"Fortsetzen","hide":"Ausblenden","info":"Mehr Details","isLive":"Live","loading":"Wird geladen ...","no":"Nein","numbers":{"number_eight":"acht","number_five":"fünf","number_four":"vier","number_nine":"neun","number_one":"eins","number_seven":"sieben","number_six":"sechs","number_three":"drei","number_two":"zwei","number_zero":"null"},"ok":"OK","open":"Öffne die App","pressBlue":"Drücke die blaue Taste","pressRed":"Drücke die rote Taste","quit":"Schließen","reset":"Zurücksetzen","returnHome":"Zurück zur Startseite","returnHomeSaved":"Speichern und zurück zu Live","returnHome_hbbtv":"Zurück zu Live","returnSettings":"Zurück zu den Einstellungen","save":"Speichern","selected":"Ausgewählt","service":"Service","settings":"Einstellungen","show":"Anzeigen","showMore":"Mehr anzeigen","yes":"Ja"},"helpAndContact":{"text":"Das Hilfe-Center ist in der TV-App nicht verfügbar. Um darauf zuzugreifen, gehe in deiner mobilen App oder auf der Website „plus.rtl.de“  zu „Mein Account“.","title":"Hilfe & Kontakt"},"informations":{"account":"Dein Account","description":"Um deine Account-Informationen zu aktualisieren, rufe „rtlplus.com/account“ in deinem Webbrowser auf.","freeTrial":"Kostenlose Testphase","noSubscription":"Kein Abonnement","parentalFilter":"Jugendschutz-Filter","parentalFilterDescription":"In allen Profilen sind Inhalte unter %(age)s Jahren derzeit durch deinen Jugendschutz-Pin geschützt.","parentalFilterOff":"Deaktiviert","parentalFilterOn":"Aktiviert","paymentRecurrence":"/ Monat","subscription":"Dein Paket","title":"Meine Informationen"},"keyboard":{"addSpace":"Abstand einfügen","deleteAll":"Suchfeld leeren","deleteCharacter":"Ein Zeichen löschen"},"layout":{"locks":{"contentRating":{"message":"Aus Jugendschutzgründen sind Inhalte ab 16 Jahren ab 22:00 Uhr verfügbar, Inhalte ab 18 Jahren ab 23:00 Uhr. Melde dich an oder schließe ein Abo ab, um jederzeit Zugang zu allen Inhalten zu haben."},"geoBlocked":{"message":"Dieser Inhalt ist in deiner Region nicht verfügbar."},"live":{"message":"Live ist derzeit nicht verfügbar. Bitte warte oder versuche es später erneut.","timeMessage":"Die nächste Show beginnt heute bei %(liveLockTimestamp)s","unavailableNotAiring":"Die Ausstrahlung hat noch nicht begonnen."},"parentalFilter":{"message":"Dieses Video ist aufgrund der Aktivierung des Jugendschutzes nicht zugänglich."},"playerDefault":{"message":"Dieses Video ist nicht verfügbar."},"requireAdvertisingConsent":{"message":"Um dein Programm abzuspielen, benötigen wir deine Zustimmung zur zielgerichteten Werbung."}}},"leavingKidsSection":{"title":"Um den Kinderbereich zu verlassen, gib die folgenden Zahlen ein.","wrongCode":"Der Code ist falsch, bitte versuche es erneut."},"legalNotice":{"button":"Einstellungen/Datenschutz","title":"Datenschutzerklärung"},"legalPages":{"cga":{"subTitle":"Bitte lies die Allgemeinen Geschäftsbedingungen des RTL+ Abonnements sorgfältig durch und bewahre eine Kopie auf.","subTitleLow":"Aktualisiert am 1. Oktober 2020","title":"ALLGEMEINE ABONNEMENTBEDINGUNGEN"},"cgu":{"subTitle":"BITTE LIES DIESE GESCHÄFTSBEDINGUNGEN SORGFÄLTIG DURCH UND BEWAHRE EINE KOPIE AUF","subTitleLow":"Aktualisiert am 1. Oktober 2020","title":"AGB"},"privacyPolicy":{"title":"Datenschutzerklärung"}},"lock":{"contentRating":"Zur Website von %(appDisplayName)s","parentalFilter":"Dieses Video ist aufgrund der Aktivierung des Jugendschutzes nicht zugänglich."},"misc":{"scaffold":{"debug":"Debug","markers":"Markierungen","remote":"Fernbedienung"}},"nav":{"backToLive":"Zurück zu Live","backToNav":"Zurück zur Navigation","channelSelector":"Kanäle","episodes":"Folgen","nextVideo":"Nächstes Video","playNext":"Nächste abspielen","relatedItems":"Das könnte dir auch gefallen","relatedVideos":"Die könnte auch gefallen","subtitles":"Audio und Untertitel","synopsis":"Mehr lesen"},"network":{"failedSubTitle":"Bitte überprüfe deine Internetverbindung","failedTitle":"Verbindung fehlgeschlagen"},"notice":{"button":"Ich verstehe, fortfahren","description":"Um weiterhin auf deine Inhalte auf diesem Gerät zugreifen zu können, müsst du bestätigen, dass du Teil eines Haushaltskontos bist, oder einen neuen Account erstellen.","title":"Dieses Gerät verliert bald den Zugriff auf diesen Account."},"pairing":{"completion":{"description":"Um alle Premium Formate auf allen Geräten nutzen zu können, vervollständige jetzt deinen Account. Nutze dazu den Link aus der Registrierungs-Email, die du von der Telekom erhalten hast. Du kannst den Link auch auf  dieser website aufrufen: www.telekom.de/kundencenter/partner. Und keine Sorge - es entstehen keine zusätzlichen Kosten.","title":"Sichere dir jetzt alle Premium Vorteile mit Magenta TV"},"devicesGate":{"description":"Du hast die maximale Anzahl an Geräten erreicht, die mit deinem Konto verbunden sind. Um fortzufahren, trenne eines der Geräte über die mobile Anwendung oder die Website RTL+ in den Einstellungen. ","title":"Gerät entfernen"},"landing":{"catchPhrase":"Unbegrenztes TV und Streaming auf einer Plattform.","description":"Sieh dir mehr als 10.000 Stunden Serien, Filme, Dokumentationen und Kindersendungen im Streaming an. Finde deine Lieblingssender und -shows live, im Replay, als Vorschau oder komplette Staffeln. Genieße einen kostenlosen Probemonat.","help":"Fragen? Gehe zu „community.plus.rtl.de“","paymentRecurrence":"/ Monat","pricing":"Ab 6,99 € / Monat. Ohne Bindung und jederzeit kündbar.","signIn":"Verbinden","signOn":"Abonnieren","subscribeOffer":"30 Tage kostenlos testen"},"ssi":{"accept":"Zustimmen","decline":"Ablehnen","description":"Mit meiner Registrierung akzeptiere ich die AGB und habe die Datenschutzrichtlinie zur Kenntnis genommen.\\nAls registrierter Kunde erhalte ich regelmäßig den RTL+Insider mit Informationen zu Produktleistungen. Dies kann ich jederzeit in meinen Einstellungen ändern. Darüber hinaus erhalte ich vertragsrelevante Kundeninformationen.\\nDieser Verwendung meiner E-Mail-Adresse kann ich jederzeit unter support@rtl.de widersprechen, ohne dass hierfür andere als die Übermittlungskosten nach dem Basistarif entstehen.","title":"Aktiviere jetzt dein RTL+ Paket"},"subscribe":{"button":"Schon gebucht? Zum Inhalt","computer":{"steps":{"step1":"Gehe zu https://my.plus.rtl.de/buchen","step2":"Buche das passende %(appDisplayName)s Paket","step3":"Sobald dein Abo abgeschlossen ist, klicke auf den Button unten"}},"continue":{"content":"Du hast schon das passende Paket? Zum Inhalt","login":"Du hast schon das passende Paket? Anmelden"},"expired":{"description":"Du kannst RTL+ auf der Website von deinem Computer, Tablet oder Smartphone aus abonnieren.","redirection":"Besuche plus.rtl.de oder öffne die mobile App aus dem App Store.","redirectionQrCode":"Scanne mit deinem Handy den QR-Code auf dem Bildschirm","switchAccount":"Account wechseln","title":"Du hast aktuell kein RTL+ abonniert"},"finally":"Sobald du ein Abo abgeschlossen hast, musst du dich nur noch mit deinem Account verbinden, um RTL+ auf deinem Fernseher zu genießen.","goWeb":"Gehe auf plus.rtl.de um RTL+ zu abonnieren","goWebQrCode":"Folge den Schritten auf deinem Handy, um dein Abo abzuschließen","how":"Um diesen Inhalt abzuspielen","mobile":{"steps":{"step1":"QR-Code scannen","step2":"Buche das passende RTL+ Paket","step3":"Sobald dein Abo abgeschlossen ist, klicke auf den Button unten"}},"offer":{"back":"Zurück","title":"Dieses Programm ist nur für Abonnenten verfügbar."},"offers":{"offer1":"Serien, Filme & Shows","offer2":"Vor TV-Ausstrahlung schauen","offer3":"RTL+ Originals","title":"Fündig geworden"},"qrCaption":"Scanne den QR-Code mit deinem Handy, um deine App zu öffnen."},"token":{"callToActionText":"Gebe folgenden Code ein:","computer":{"button":"Über das Web","steps":{"step1":"Öffne rtlplus.com/tv-login auf deinem Smartphone, Tablet oder Computer","step2":"Gib den unten stehenden Code auf der Webseite ein","step3":"Klicke auf \\"Absenden\\" – fertig! Dein Fernseher ist jetzt mit deinem RTL+ Account verbunden."}},"connect":"Bei RTL+ anmelden oder registrieren","magenta":{"accept":"Mit MagentaTV nutzen","button":"Über MagentaTV","title":"Du bist Magenta Kunde? Wenn RTL+ bereits Teil deines MagentaTV-Tarifs ist, kannst du dich ganz einfach über diesen Button einloggen."},"mobile":{"button":"Über dein Smartphone","steps":{"step1":"Scanne mit deinem Handy den QR Code","step2":"Folge den Anweisungen auf deinem Handy und melde dich bei %(appDisplayName)s an. Dein Fernseher wird automatisch verbunden.","step3":"Abgelaufene Zeit: %(currentTime)s von %(contentDuration)s"}},"shouldUpgradePlan":"Um auf diesen Inhalt zuzugreifen, ist ein höherer Plan erforderlich","synchRedirection":"Melde dich bei RTL+ an, um loszulegen.\\nSo geht’s:"},"welcome":{"disconnect":"Abmelden","profileChoice":"Wähle dein Profil","title":"Willkommen bei RTL+","titleBack":"Willkommen zurück!"}},"parentalCode":{"forgottenCode":"Jugendschutz-Pin vergessen?","incorrectCode":"Der Jugendschutz-Code scheint falsch zu sein. Versuche es erneut.","instruction":"Bitte gib deine Jugendschutz-PIN ein, um den Inhalt freizuschalten","lost":{"catalogReturn":"Zurück zur Übersicht","instruction":"Du kannst deinen 4-stelligen PIN-Code auf der RTL+-Website oder in den mobilen App abrufen oder ändern. Gehe dazu zu „Mein Account“ und dann zum Abschnitt „Jugendschutz“.\\n"},"title":"Dieser Inhalt ist gesperrt","wrongCode":"Der Jugendschutz-Code scheint falsch zu sein. Versuche es erneut."},"parentalFilter":{"content":"Aktiviere den Filter, um nur öffentliche Inhalte zu sehen.","label":"Jugendschutz-Filter","title":"Vertrauensbereich"},"player":{"adExtraTitle":"%(contentTitle)s startet bald","adMessage":"Werbung","advertisement":"Werbung","audio":"Audio","audioDescription":"Audiodeskription","closedCaption":"Untertitel","elapsedTime":"Abgelaufene Zeit: %(currentTime)s von %(contentDuration)s","endScreen":{"askAudioReplay":"Audio erneut abspielen?","askReplay":"Video erneut abspielen?","askVideoReplay":"Video erneut abspielen?","nextAudioCountdown":"Nächstes Audio in","nextCountdown":"Nächstes Video in","nextVideoCountdown":"Nächstes Video in","unit":"Sekunden"},"info":"Info","loader":"Wird geladen ...","nextVideo":{"askReplay":"Wiederholen?","nextCountdown":"Nächstes Video in","unit":"Sekunden"},"one":"Video erneut abspielen?","originalSoundtrack":"Original-Tonspur","other":"Sonstiges","pauseAdMessage":"Drücken die Eingabetaste, um fortzusetzen","replay":"Erneut abspielen","skipAd":"Werbung überspringen","skipAllAds":"Alle Werbungen überspringen","skipCredits":"Abspann überspringen","skipIn":"Überspringen in","skipIntro":"Vorspann überspringen","skipRecap":"Vorspann überspringen","subDisable":"Deaktivieren","subtitles":"Untertitel","subtitlesSettings":{"background":{"title":"Hintergrund der Untertitel"},"color":{"black":"Schwarz","blue":"Blau","cyan":"Cyan","green":"Grün","magenta":"Magenta","red":"Rot","title":"Farbe der Untertitel","white":"Weiß","yellow":"Gelb"},"font":{"default":"Standard","title":"Schriftart der Untertitel"},"preview":"Untertitel-Vorschau","reset":"Stile zurücksetzen","size":{"large":"Groß","medium":"Mittel","small":"Klein","title":"Größe der Untertitel","xlarge":"Sehr groß"},"title":"Stil der Untertitel"},"zero":"Nächstes Video in"},"popups":{"ageGate":{"body":"Durch Drücken von „Weiter“ bestätigst du, dass du mindestens 18 Jahre alt bist.","heading":"Du bist im Begriff, einen Inhalt anzusehen, der möglicherweise Szenen nur für Erwachsene enthält."},"geoBlocking":{"body":"Es tut uns Leid\\nDieser Inhalt ist in deiner Region nicht verfügbar"}},"privacySettings":{"cgu":{"title":"Datenschutzerklärung"},"cookie":{"audienceMeasurement":{"content":"Der Zweck dieser Cookies besteht darin, den Datenverkehr und die Nutzung der RTL+-Plattform zu analysieren, um besser zu verstehen, wie sie genutzt wird, und um dein Browsing-Erlebnis und die Nutzung der Plattform zu verbessern. Insbesondere können diese Cookies Daten über die besuchten Seiten, die angesehenen Inhalte, die Dauer des Besuchs der Seiten, den Browser, den Sie zum Besuch dieser Seiten verwenden, usw. verarbeiten.","id":"audienceMeasurement","title":"Cookies zur Messung der Reichweite"},"description":"Auf dieser Seite kannst du deine Einstellungen für die Verwendung von Cookies und anderen Tracking-Tools festlegen. Mit deiner Zustimmung werden Cookies oder andere Tracking-Tools auf dieser Plattform von RTL+ und seinen Partnern verwendet, um Besucherstatistiken zu erstellen, die Dienste der Plattform anzupassen und dir auf deine Interessen zugeschnittene Dienste und Angebote bereitzustellen. Weitere Informationen findest du in unserer Cookie-Richtlinie. Die über dieses Modul vorgenommenen Einstellungen gelten nur für dieses Gerät, unabhängig davon, ob du mit deinem RTL+-Account verbunden bist oder nicht. Wenn du ein RTL+-Account hast, haben die Cookie-Einstellungen keinen Einfluss auf die Verwendung deiner Benutzerprofilinformationen, die du bei der Erstellung deines Accounts angegeben hast, um dein redaktionelles und werbliches Erlebnis auf der Grundlage deiner Interessen zu personalisieren. Verbinde dich mit deinem Account, wenn du deren Verwendung steuern möchtest. Weitere Informationen findest du in unserer Datenschutzerklärung.\\n","devicePairing":{"content":"Diese Funktion ermöglicht es uns, Browserdaten von diesem Gerät, für das du zugestimmt hast, mit Browserdaten von einem oder mehreren anderen Geräten zu verknüpfen, die mit deinem Netzwerk verbunden sind und für die du ebenfalls zugestimmt hast. Diese Verknüpfung ermöglicht es uns, unsere Reichweitenmessung zu verfeinern und die Personalisierung deiner Erfahrung auf deinen verschiedenen Geräten zu harmonisieren, je nach den getroffenen Entscheidungen zur Verwendung von Cookies (Reichweitenmessung, Personalisierung, Werbung, die auf deine Interessen zugeschnitten ist).","id":"devicePairing","title":"Verknüpfung verbundener Geräte"},"personalization":{"content":"Der Zweck dieser Cookies besteht darin, Inhalte zu identifizieren, die für Sie hinsichtlich Ihrer Aktivitäten auf der RTL+-Plattform von Interesse sein könnten, um dir ein personalisiertes redaktionelles Erlebnis basierend auf deinen Interessen zu bieten. Wenn du diese Cookies deaktivierst, kann Bedrock dir keine personalisierten Erlebnisse und Inhalte über Cookies anbieten.","id":"Personalisierung","title":"Cookies zur Plattformanpassung"},"targetedAdvertising":{"content":"Der Zweck dieser Cookies besteht darin, die Relevanz der auf der RTL+-Plattform sowie in Medien von Drittanbietern angezeigten Werbeanzeigen und Werbeinhalte zu verbessern. Wenn wir dir Werbebotschaften senden oder solche Botschaften ausstrahlen, ist es unser Ziel, dir möglichst relevante Werbeanzeigen und Angebote zu senden, die auf deine Bedürfnisse zugeschnitten sind oder dich wirklich interessieren könnten. Die Deaktivierung dieser Cookies hat keinen Einfluss auf die Menge der Werbung, die Sie erhalten.","id":"targetedAdvertising","title":"Werbe-Cookies"},"text":"Diese Seite ermöglicht es dir, deine Auswahl bezüglich der Verwendung von Cookies und anderen Trackern zu konfigurieren. Wenn du zustimmst, werden auf dieser Plattform von RTL+ und seinen Partnern Cookies oder andere Tracker verwendet, um Besuchsstatistiken zu erstellen, die Plattformdienste zu personalisieren und dir Dienstleistungen und Angebote anzuzeigen, die auf deine Interessen zugeschnitten sind. Um mehr zu erfahren, gehe zu unserer Cookie-Richtlinie. Die über dieses Modul getroffenen Einstellungen gelten nur für dieses Gerät, unabhängig davon, ob du mit deinem RTL+ Account verbunden bist oder nicht. Wenn du ein RTL+ Account hast, hat die Cookie-Einstellung keinen Einfluss auf die Nutzung der Informationen, die in deinem Benutzerprofil bei der Erstellung deines Accounts bereitgestellt wurden, um deine redaktionelle und Werbeerfahrung gemäß deinen Interessen zu personalisieren. Melde dich in deinem Account an, wenn du deren Nutzung kontrollieren möchtest. Weitere Informationen findest du in unserer Datenschutzrichtlinie auf plus.rtl.de.","title":"Profil"},"geoblocking":{"errorMessage":"Element %(position)s von %(totalItems)s"},"title":"Datenschutzeinstellungen"},"profile":{"edit":{"avatar":"Avatar aktualisieren","delete":"Löschen","done":"Fertig","kid":"Kinderprofil aktualisieren","name":"Name aktualisieren","title":"Profil aktualisieren"},"select":"Profil","switch":"Profil wechseln"},"programCard":{"noContent":"Der Inhalt ist nicht mehr verfügbar"},"screenReader":{"categories":"Kategorien","checked":"Geprüft","listOfElements":"Element %(position)s von %(totalItems)s","unchecked":"Ungeprüft"},"scroll":{"button":{"down":"Nach unten scrollen zum Inhalt","up":"Zurück zum Inhalt"}},"search":{"empty":"Derzeit gibt es keinen Suchverlauf","hint":"Suche in RTL+","history":"Deine letzten Suchanfragen","placeholder":"Suche in RTL+","playlist":"Playlists","podcast":"Podcasts","program":"Videos, Podcasts & Hörbücher","vc":"Episoden","vi":"Videos"},"sidenav":{"channel":"Kanäle","home":"Start","profile":"Profil","quit":"Ausblenden","search":"Suche","settings":"Einstellungen","title":"Hauptnavigation"},"startover":{"restart":"Neu starten"},"trailer":{"actionLabel":"Trailer"},"upsell":{"computer":{"button":"Über das Web","pairedButton":"Schon gebucht? Zum Inhalt","step1":"Gehe zu %(url)s","step2":"Buche das passende RTL+ Paket","step3":"Sobald dein Abo abgeschlossen ist, klicke auf den Button unten","title":"Um diesen Inhalt abzuspielen","unpairedButton":"Du hast das passende RTL+ Paket? Anmelden"},"error":"Ein höheres Paket ist erforderlich, um diesen Inhalt zu sehen","mobile":{"button":"Über dein Smartphone","pairedButton":"Schon gebucht? Zum Inhalt","step1":"QR-Code scannen","step2":"Buche das passende RTL+ Paket","step3":"Sobald dein Abo abgeschlossen ist, klicke auf den Button unten","title":"Um diesen Inhalt abzuspielen","unpairedButton":"Du hast das passende RTL+ Paket? Anmelden"},"title":"Fündig geworden"},"user":{"login":"Anmelden"},"userInformation":{"appVersion":"App-Version","deviceId":"Fernseh-ID","isp":"Internetdienstanbieter","title":"Nutzer Informationen","userAgent":"User-Agent"},"verification":{"countdown":"Code erneut senden in %(time)s","description":"Bestätige dieses Gerät mit dem Code, den wir an %(email)s gesendet haben. Der Code ist 15 Minuten gültig.","logout":"Abmelden","resend":"Code erneut senden","title":"Bitte gib den Code aus der E-Mail ein"}}');

/***/ }),

/***/ 83635:
/***/ ((module) => {

"use strict";
module.exports = JSON.parse('{"aa":"afar","ab":"abchasisch","ae":"avestisch","af":"afrikaans","ak":"akan","am":"amharisch","an":"aragonesisch","ar":"arabisch","as":"assamesisch","av":"awarisch","ay":"aymara","az":"aserbaidschanisch","ba":"baschkirisch","be":"belarussisch","bg":"bulgarisch","bh":"bihari","bi":"bislama","bm":"bambara","bn":"bengalisch","bo":"tibetisch","br":"bretonisch","bs":"bosnisch","ca":"katalanisch","ce":"tschetschenisch","ch":"chamorro","co":"korsisch","cr":"cree","cs":"tschechisch","cu":"kirchenslawisch","cv":"tschuwaschisch","cy":"walisisch","da":"dänisch","de":"deutsch","dv":"divehi","dz":"bhutanisch","ee":"ewe","el":"griechisch","en":"englisch","eo":"esperanto","es":"spanisch","et":"estnisch","eu":"baskisch","fa":"persisch","ff":"ful","fi":"finnisch","fj":"fidschi","fo":"färöisch","fr":"französisch","fy":"westfriesisch","ga":"irisch","gd":"schottisch-gälisch","gl":"galicisch","gn":"guaraní","gu":"gujarati","gv":"manx","ha":"hausa","he":"hebräisch","hi":"hindi","ho":"hiri motu","hr":"kroatisch","ht":"haitianisch","hu":"ungarisch","hy":"armenisch","hz":"herero","ia":"interlingua","id":"indonesisch","ie":"interlingue","ig":"igbo","ii":"yi","ik":"inupiak","io":"ido","is":"isländisch","it":"italienisch","iu":"inuktitut","ja":"japanisch","jv":"javanisch","ka":"georgisch","kg":"kongo","ki":"kikuyu","kj":"kwanyama","kk":"kasachisch","kl":"grönländisch","km":"khmer","kn":"kannada","ko":"koreanisch","kr":"kanuri","ks":"kaschmiri","ku":"kurdisch","kv":"komi","kw":"kornisch","ky":"kirgisisch","la":"latein","lb":"luxemburgisch","lg":"luganda","li":"limburgisch","ln":"lingala","lo":"laotisch","lt":"litauisch","lu":"luba-katanga","lv":"lettisch","mg":"malagasy","mh":"marschallesisch","mi":"maori","mk":"mazedonisch","ml":"malayalam","mn":"mongolisch","mr":"marathi","ms":"malaiisch","mt":"maltesisch","my":"birmanisch","na":"nauruisch","nb":"norwegisch Bokmål","nd":"nord-ndebele","ne":"nepalesisch","ng":"ndonga","nl":"niederländisch","nn":"nynorsk","no":"norwegisch","nr":"süd-ndebele","nv":"navajo","ny":"chichewa","oc":"okzitanisch","oj":"ojibwe","om":"oromo","or":"oriya","os":"ossetisch","pa":"punjabi","pi":"pali","pl":"polnisch","ps":"paschtu","pt":"portugiesisch","qu":"quechua","rm":"rätoromanisch","rn":"kirundi","ro":"rumänisch","ru":"russisch","rw":"kinyarwanda","sa":"sanskrit","sc":"sardisch","sd":"sindhi","se":"nordsamisch","sg":"sango","si":"singhalesisch","sk":"slowakisch","sl":"slowenisch","sm":"samoanisch","sn":"shona","so":"somali","sq":"albanisch","sr":"serbisch","ss":"siswati","st":"südsotho","su":"sundanesisch","sv":"schwedisch","sw":"swahili","ta":"tamil","te":"telugu","tg":"tadschikisch","th":"thailändisch","ti":"tigrinya","tk":"turkmenisch","tl":"tagalog","tn":"tswana","to":"tongaisch","tr":"türkisch","ts":"tsonga","tt":"tatarisch","tw":"twi","ty":"tahitianisch","ug":"uigurisch","uk":"ukrainisch","ur":"urdu","uz":"usbekisch","ve":"venda","vi":"vietnamesisch","vo":"volapük","wa":"wallonisch","wo":"wolof","xh":"xhosa","yi":"jiddisch","yo":"yoruba","za":"zhuang","zh":"chinesische Sprachen","zu":"zulu"}');

/***/ }),

/***/ 12208:
/***/ ((module) => {

"use strict";
module.exports = JSON.parse('{"ads":{"adJingleDurationInMilliseconds":1500,"pauseAdRefreshTimeoutInSeconds":30},"algolia":{"id":"NHACVIVXXK","indices":{"default":"rtlde_prod_bedrock_layout_items_v2_rtlde_main","kids":"rtlde_prod_bedrock_layout_items_v2_rtlde_kids"},"key":"5fce02cb376fb2cda773be8a8404598a","platformCode":"ott_boxes"},"analytics":{"attributesKeysMapping":{"googleAnalytics":{"adBlockEnabled":"dimension30","authentified":"dimension5","appVersion":"dimension43","authMethod":"dimension9","boxType":"dimension47","deviceBrand":"dimension38","deviceID":"dimension2","deviceModel":"dimension40","deviceVersion":"dimension44","entityType":"dimension10","GigyaID":"dimension1","IPhash":"dimension3","platformCode":"dimension4","playerActiveAudioLanguage":"dimension18","playerActiveTextLanguage":"dimension19","userAgent":"dimension39","userStatus":"dimension34","dimension73":"dimension73","dimension75":"dimension75"},"newrelic":{"appCustomer":"customer","appPlatform":"platform","deviceBrand":"deviceBrand","deviceModel":"deviceModel","deviceID":"deviceId","userId":"userId","homeId":"homeId","appVersion":"appVersion","project":"project","appTenant":"tenant","appEnv":"env"},"ssaTealiumHttp":{"adBlockEnabled":"ad_blocker","appVersion":"app_version","authMethod":"auth_method","authentified":"authenticated","currentTime":"player_current_timecode","deviceBrand":"box_type","dimension73":"program_customer_key_id","dimension50":"heartbeat_session","dimension75":"clip_customer_key_id","heartbeatSessionId":"heartbeat_session","ga_session_id":"ga_session_id","ga_session_number":"ga_session_number","ga_client_id":"client_id","platformCode":"bedrock_platform_code","support":"support","duration":"duration","subtitle_active":"subtitle_active","player_audio":"player_audio","switch_language":"switch_language","player_subtitles":"player_subtitles"},"snowplow":{"rtlUserId":"dimension1","platformName":"dimension4","title":"dimension75","clipId":"dimension75","profileId":"dimension32","platformSection":"dimension35","customerKeyId":"dimension73"}},"initParams":{"gemius":{"gemiusAgeBrackets":[],"gemiusParams":[],"gemiusUserMetrics":false,"usePPGemius":false,"useLayout":false,"lang":"fr","i18nNames":{"appDisplayName":"Bedrock"},"globals":{"pp_gemius_identifier":null,"pp_gemius_prefix":null}},"gemiusPlayer":{"id":""},"krxd":{"appId":"","consent":{"al":false,"cd":false,"dc":false,"re":false,"sh":false,"tg":false},"ns":""},"lotame":{"lotameClientId":""},"onesdk":{"appId":""},"snowplow":{"appId":"tv","contexts":{"webPage":true,"session":true,"browser":true,"performanceTiming":true},"platform":"web","plugins":[],"thirdPartyKey":"googleAnalytics"},"ssaTealiumHttp":{"account":"bedrock","dataSource":"aclwgy","endpoint":"https://collect.tealiumiq.com/event","env":"prod","httpMethod":"POST","isDeviceBrowser":true,"profile":"rtlde","thirdPartyKey":"tealium"},"nielsenMediametrie":{"appId":"P00544254-6A96-41A7-9F36-C4F3477D1FBC","instanceName":"streaming_ott_boxes","shouldLoadMetadataAfterInterruption":true,"shouldTrackAudio":false,"sdkDebugEnabled":false},"nielsenStatic":{"appId":"PD517DA22-226C-499E-96DA-905E5FCC3B21","instanceName":"static_ott_boxes","sdkDebugEnabled":false}},"taggingPlans":{"gemiusPlayer":{"autoPlay":{"action":"programstart","category":"player","label":"programstart"},"start":{"action":"start","category":"player","label":"start"},"playVideo":{"action":"play","category":"player","label":"play"},"pauseVideo":{"action":"pause","category":"player","label":"pause"},"pressBackButtonDuringVideo":{"action":"close","category":"player","label":"close"},"buffering":{"action":"buffering","category":"player","label":"buffering"},"seek":{"action":"seek","category":"player","label":"seek"},"complete":{"action":"complete","category":"player","label":"complete"}},"gemius":{"ViewContent":{}},"googleAnalytics":{"appInit":{"category":"Application","label":"AppInit"},"autoPlay":{"action":"start","category":"player","label":"effective"},"autoPlayNextVideo":{"action":"endscreen","category":"player","label":"auto_play"},"audioTrackChanged":{"action":"tracks_modal","category":"player","label":"language_%(language)s"},"backNextVideo":{"action":"endscreen","category":"player","label":"back"},"backward":{"action":"seek","category":"player","label":"backward"},"bookmarksListBack":{"action":"bookmark_list","category":"account","label":"back"},"closeMoreInfo":{"action":"browsing","category":"feature.info_by_program","label":"close_info"},"completion25":{"action":"completion","category":"player","label":"25"},"completion50":{"action":"completion","category":"player","label":"50"},"completion75":{"action":"completion","category":"player","label":"75"},"endscreenDisplayed":{"action":"endscreen","category":"player","label":"displayed"},"forward":{"action":"seek","category":"player","label":"forward"},"language_en":{"action":"tracks_modal","category":"player","label":"language_en"},"language_fr":{"action":"tracks_modal","category":"player","label":"language_fr"},"language_qaa":{"action":"tracks_modal","category":"player","label":"language_qaa"},"language_qad":{"action":"tracks_modal","category":"player","label":"language_qad"},"migrateDeviceID":{"category":"Cookie","label":"NewDeviceID"},"navigationPanelReplay":{"action":"navigation_panel_replay","category":"player","label":"%(clipId)s"},"pairingFail":{"action":"pairing","category":"onboarding","label":"fail"},"pairingSuccess":{"action":"pairing","category":"onboarding","label":"success"},"pauseVideo":{"action":"remote_control","category":"player","label":"pause"},"playNextVideo":{"action":"endscreen","category":"player","label":"manual_play"},"playVideo":{"action":"remote_control","category":"player","label":"play"},"pressAudioSettingsVideo":{"action":"tracks_modal","category":"player","label":"open_tracks_modal"},"pressBackButtonDuringVideo":{"action":"remote_control","category":"player","label":"back"},"prerollBegins":{"action":"advertising","category":"player","label":"preroll"},"midrollBegins":{"action":"advertising","category":"player","label":"midroll"},"postMidroll":{"action":"start","category":"player","label":"post_midroll"},"pressBackButtonDuringPreroll":{"action":"advertising","category":"player","label":"back_preroll"},"pressBackButtonDuringMidroll":{"action":"advertising","category":"player","label":"back_midroll"},"pressBlueButtonLive":{"category":"Startover","label":"Live"},"pressBookmarksButton":{"action":"bookmark","category":"account","label":"explore"},"pressConnectButton":{"action":"pairing","category":"onboarding","label":"login_pairing"},"pressCookieBannerConsentButton":{"action":"cookie","category":"data_collection","label":"consent"},"pressCookieBannerSetupButton":{"action":"cookie","category":"data_collection","label":"setup"},"pressGreenButtonLive":{"category":"Service","label":"Live"},"pressLoginRetryBackButton":{"action":"pairing","category":"onboarding","label":"login_retry"},"pressLogoutButton":{"action":"menu","category":"account","label":"log_out"},"pressMoreInfo":{"action":"browsing","category":"feature.info_by_program","label":"more_info"},"pressParametersButtonMenu":{"category":"Parameters","label":"Interface"},"pressProfileSwitchButton":{"action":"menu","category":"account","label":"profile_switch"},"pressRedButtonLive":{"action":"click","category":"onboarding","label":"live"},"pressRedButtonMenu":{"category":"RedButton","label":"Interface"},"pressRedButtonPopup":{"action":"click","category":"onboarding","label":"pop_up"},"pressRegisterBackButton":{"action":"register","category":"onboarding","label":"back"},"pressServiceButtonMenu":{"category":"Service","label":"Interface"},"pressStartOverVideo":{"action":"control_screen","category":"player","label":"startover"},"pressSynopsis":{"eventName":"player_information"},"pressBackToLiveVideo":{"action":"control_screen","category":"player","label":"back_to_live"},"pressStartoverButtonMenu":{"category":"Startover","label":"Interface"},"pressStartoverButtonPopup":{"category":"Startover","label":"Popup"},"pressSubscribeButton":{"action":"register","category":"onboarding","label":"register_pairing"},"pressSwitchProfileButton":{"action":"menu","category":"account","label":"switch_profile"},"pressTokenBackButton":{"action":"pairing","category":"onboarding","label":"back"},"pressViewRelatedVideo":{"action":"control_player","category":"player","label":"open_recommandation"},"pressYellowButtonLive":{"category":"Parameters","label":"Live"},"replayNextVideo":{"action":"endscreen","category":"player","label":"replay"},"searchInput":{"action":"search","category":"search","label":"%(input)s"},"showApplicationPopup":{"category":"Popup","label":"Application"},"showCookiePreferences":{"category":"CookiesPreferences","label":"CookiesPreferencesScreen"},"showGdprNotice":{"category":"GdprNotice","label":"GdprNoticeScreen"},"showLegalNotice":{"category":"LegalNotice","label":"LegalNoticeScreen"},"showPlayer":{"category":"Player","label":"PlayerScreen"},"showStartoverPopup":{"category":"Popup","label":"Startover"},"skipCredits":{"action":"skip","category":"player","label":"skip_credits"},"skipIntro":{"action":"skip","category":"player","label":"skip_intro"},"smartclipDisplay":{"category":"Campaign","label":"Smartclip"},"storageError":{"category":"Device","label":"StorageSpace"},"storageSupport":{"category":"Device","label":"StorageSupport"},"subtitlesTrackChanged":{"action":"tracks_modal","category":"player","label":"subtitle_%(language)s"}},"krxd":{"bookmarkAdd":{"eventId":"N-2UrtJA","label":"videoWatchListAdd","device":"TV","OS":"%(appPlatform)s","configID":"%(configID)s","profileType_kids":"%(profileType_kids)s","Gender":"%(Gender)s","Birthyear":"%(Birthyear)s","RTL_ID":"%(RTL_ID)s","Video_Genre_1":"%(Video_Genre_1)s","Video_Genre_2":"%(Video_Genre_2)s","Video_Genre_3":"%(Video_Genre_3)s","program_title":"%(program_title)s","video_title":"%(video_title)s","registration_available":"%(registration_available)s","registration_price":"%(registration_price)s","registration_rateplan":"%(registration_rateplan)s","registration_subscription_amount":"%(registration_subscription_amount)s","tier":"%(tier)s","personContactId":"%(personContactId)s","HEM":"%(HEM)s","appname":"%(appname)s","screenview":"%(screenview)s","screentitle":"%(screentitle)s","navigation_1":"%(navigation_1)s","navigation_2":"%(navigation_2)s","category":"%(category)s","visitor_type":"%(visitor_type)s","account_holder":"%(account_holder)s","platform_code":"%(platform_code)s","key":"%(key)s"},"bookmarkRemove":{"eventId":"N-2ViIZm","label":"videoWatchListRemove","device":"TV","OS":"%(appPlatform)s","configID":"%(configID)s","profileType_kids":"%(profileType_kids)s","Gender":"%(Gender)s","Birthyear":"%(Birthyear)s","RTL_ID":"%(RTL_ID)s","Video_Genre_1":"%(Video_Genre_1)s","Video_Genre_2":"%(Video_Genre_2)s","Video_Genre_3":"%(Video_Genre_3)s","program_title":"%(program_title)s","video_title":"%(video_title)s","registration_available":"%(registration_available)s","registration_price":"%(registration_price)s","registration_rateplan":"%(registration_rateplan)s","registration_subscription_amount":"%(registration_subscription_amount)s","tier":"%(tier)s","personContactId":"%(personContactId)s","HEM":"%(HEM)s","appname":"%(appname)s","screenview":"%(screenview)s","screentitle":"%(screentitle)s","navigation_1":"%(navigation_1)s","navigation_2":"%(navigation_2)s","category":"%(category)s","visitor_type":"%(visitor_type)s","account_holder":"%(account_holder)s","platform_code":"%(platform_code)s","key":"%(key)s"}},"ssaTealiumHttp":{"bookmark":{"eventName":"block_bookmark"},"folder":{"eventName":"block_page_folders","service":"%(eventLabel)s"},"gdprAccept":{"consent_name":"%(consentNames)s","eventName":"gdpr_accept"},"gdprChangeConsents":{"consent_name":"%(consentNames)s","eventName":"gdpr_change_consent"},"gdprRefuse":{"eventName":"gdpr_refusal"},"gdprSetup":{"eventName":"gdpr_setup"},"menu":{"content_type":"%(eventLabel)s","eventName":"entry_nav_bar"},"menu_account":{"content_type":"%(eventLabel)s","eventName":"entry_nav_bar"},"menu_channel":{"content_type":"%(eventLabel)s","eventName":"select_channel_folder"},"pressMoreInfo":{"eventName":"block_program_info"},"program":{"content_name":"%(eventLabel)s","eventName":"block_page_program"},"searchInput":{"eventName":"search_bar","search_result_number":"%(results)s","search_term":"%(input)s"},"searchResult":{"content_id":"%(id)s","content_name":"%(name)s","eventName":"search_result_clicked","search_term":"%(input)s"},"service":{"eventName":"block_page_services","service":"%(eventLabel)s"},"showStartoverPopup":{"category":"Popup","label":"Startover"},"unbookmark":{"eventName":"block_unbookmark"},"epgDateSelect":{"eventName":"epg_date_select","label":"%(date)s"},"epgModalOpen":{"eventName":"epg_modal_open","label":"%(date)s"},"epgModalClose":{"eventName":"epg_modal_close","label":"%(date)s"},"upsellMessageViewed":{"eventName":"upsell_message_viewed"},"upsellRegisterClick":{"eventName":"upsell_register_click"},"autoPlayNextVideo":{"eventName":"player_next_video","player_control_system":"remote"},"backNextVideo":{"eventName":"player_endscreen_back","player_control_system":"remote"},"backward":{"direction":"backward","eventName":"player_seek","player_control_system":"remote"},"closeSideGlass":{"eventName":"player_sideglass_close","player_control_system":"remote"},"completion100":{"duration":"100","eventName":"player_completion_100","player_control_system":"remote"},"completion25":{"duration":"25","eventName":"player_completion_25","player_control_system":"remote"},"completion50":{"duration":"50","eventName":"player_completion_50","player_control_system":"remote"},"completion75":{"duration":"75","eventName":"player_completion_75","player_control_system":"remote"},"forward":{"direction":"forward","eventName":"player_seek","player_control_system":"remote"},"midrollBegins":{"eventName":"ad_midroll_start","player_control_system":"remote"},"openSideGlass":{"eventName":"player_sideglass_open","player_control_system":"remote"},"pauseVideo":{"duration":"%(duration)s","eventName":"player_pause","player_control_system":"remote"},"playbackStarted":{"eventName":"player_play_effective","player_control_system":"remote"},"playNextVideo":{"eventName":"player_next_video","player_control_system":"remote"},"playVideo":{"eventName":"player_play","player_control_system":"remote"},"prerollBegins":{"eventName":"ad_preroll_start","player_control_system":"remote"},"postMidroll":{"eventName":"ad_midroll_end","player_control_system":"remote"},"postPreroll":{"eventName":"ad_preroll_end","player_control_system":"remote"},"playerTracksPanelClose":{"eventName":"player_modal_close","player_control_system":"remote","player_type":"subtitle"},"playerTracksPanelOpen":{"eventName":"player_modal_open","player_control_system":"remote","player_type":"subtitle"},"pressBackButtonDuringMidroll":{"break_type":"midroll","eventName":"ad_break_back","player_control_system":"remote"},"pressBackButtonDuringPreroll":{"break_type":"preroll","eventName":"ad_break_back","player_control_system":"remote"},"pressBackButtonDuringVideo":{"eventName":"player_back","player_control_system":"remote"},"pressBackToLiveVideo":{"eventName":"player_backtolive","player_control_system":"remote"},"pressStartOverLive":{"eventName":"player_startover_live","player_control_system":"remote"},"pressSynopsis":{"eventName":"player_information","player_control_system":"remote"},"replayNextVideo":{"eventName":"player_endscreen_replay","player_control_system":"remote"},"skipCredits":{"eventName":"player_ignore_credit","player_control_system":"remote"},"skipIntro":{"eventName":"player_ignore_introduction","player_control_system":"remote"},"skipRecap":{"eventName":"player_ignore_recap","player_control_system":"remote"},"skipToNextVideo":{"eventName":"player_next_video","player_control_system":"remote"}}},"engines":["ssaTealiumHttp","nielsenMediametrie","nielsenStatic"]},"assetsBundle":{"bundleBaseUrl":"https://assets-bundle.rtlde.bedrock.tech","bundleVersion":9},"bannedFeatures":[],"cta":{"supportedActions":["bookmark","account_bookmarks","unbookmark","live","lives","program","video","service","alias","services","season","account","search","settings","account_settings","tos","termsofsubscription","account_legalconditions","folders","folder","account_informations","close","consentsmanagement_device","privacy_policy","account_confidentiality","lock","logout","frontspace","help","feedback","profilesgate","play"]},"customizer":"https://customizer.rtlde.bedrock.tech/v2/platforms/%(platform)s/users/%(uid)s/apps/%(app)s/versions/%(version)s","debug":false,"featureFlipping":{"adFeature":true,"animateFeature":true,"bffSearchFeature":false,"bookmarksFeature":true,"broadcastLiveFeature":true,"browsingByChannelFeature":true,"checkGeoFeature":true,"concurrentStreamFeature":true,"contentAdvisorFeature":true,"customizerFeature":true,"displayLostConnectionFeature":true,"endingCreditsFeature":true,"freemiumFeature":true,"gaFeature":true,"gdprNoticeFeature":true,"heartbeatFeature":true,"homeLiveFeature":true,"impressionTracking":true,"kidsScreensaverFeature":true,"kidsSectionFeature":true,"kidsSectionLeaveFeature":true,"leftCornerFocus":false,"liveSeekFeature":false,"liveSuppressionOnEPGFeature":false,"menuFeature":true,"menuPopupFeature":true,"monitoringFeature":true,"multiAudioFeature":true,"multiProfilesGateAlwaysDisplayed":true,"multiSubtitlesFeature":true,"multiprofile":true,"newRelicFeature":true,"nextVideoFeature":true,"openCatalogFeature":true,"openCreditsFeature":true,"pairingFeature":true,"parentalFilterFeature":true,"player_adFeature":true,"player_adLazyVmap":true,"player_adsCount":true,"player_analyticsFeature":true,"player_antiFF":false,"player_jingleFeature":true,"player_lBanner":true,"player_liveHideRelatedChannels":true,"player_longSeek":true,"player_midrollMarkers":false,"player_nextVideoFeature":true,"player_pauseAd":false,"player_relatedVideosFeature":true,"player_returnFeature":true,"player_skippableAd":false,"player_startOverFeature":true,"player_thirdPartiesFeature":true,"player_timeShiftingFeature":true,"player_trackPreferencesFeature":false,"player_trailer":false,"player_trailer_sound":false,"premiumFeature":true,"privilegeNavigationFeature":true,"profileFeature":true,"promptBeforeExitFeature":true,"screensaverFeature":true,"searchFeature":true,"servicePageFeature":true,"sideGlassRecomendationsFeature":true,"singleModeAdFeature":true,"smartclipFeature":true,"splashScreenFeature":true,"startoverFeature":true,"startoverPopupFeature":true,"storyboardFeature":true,"topMenuFeature":true,"upsellFlow":true,"userApiFeature":true,"watchAgainFeature":true,"youboraAdsAdapter":false},"fido":{"applaunch":{"maxAge":60,"timeout":5000,"version":"1.0.0"},"baseUrlsByAPIType":{"applaunch":"https://d16w83149ahatb.6cloud.fr","auth":"https://front-auth.rtlde.bedrock.tech/v2","drm":"https://drm.rtlde.bedrock.tech/v1","geo":"https://geo.rtlde.bedrock.tech/v1","heartbeatv2":"https://heartbeat-v2.rtlde.bedrock.tech/v2","heartbeatv3":"https://heartbeat-v3.rtlde.bedrock.tech/v3","image":"https://images-fio.rtlde.bedrock.tech/v2","layout":"https://layout.rtlde.bedrock.tech/front/v1","linkConverter":"https://link-converter.rtlde.bedrock.tech","middlewarev2":"https://hbbtv.middleware.rtlde.bedrock.tech/6play/v2","stores":"https://stores.rtlde.bedrock.tech/premium/v4","time":"https://time.rtlde.bedrock.tech","userv2":"https://users.rtlde.bedrock.tech/v2","userv3":"https://users.rtlde.bedrock.tech/v3","userv4":"https://users.rtlde.bedrock.tech/v4"},"layoutService":{"capacityToken":"token-magenta-ott-boxes-2"},"imageSalt":"x9vGg4RNeNBqV2nBfhqLV6cN4n","saltAndSugar":"f57894679724c3ee04083f2e38707653667e61e1","serviceImageUrl":"https://images-fio.rtlde.bedrock.tech/v2/images/%(id)d/raw"},"gdpr":{"gdprNoticeDuration":20000,"consentVersion":0},"i18nNames":{"appDisplayName":"RTLDE"},"heartbeat":{"heartbeatInterval":240000},"monitoring":{"pattern":{"increment":"https://mon.m6web.fr/statsd/%(node)s/increment?token=%(token)s","timer":"https://mon.m6web.fr/statsd/%(node)s/timer/%(time)d?token=%(token)s"},"prefix":"m6web.hbbtv.client","salt":"e56f5a32a32a65232"},"newRelic":{"applicationID":null},"oidc":{"baseUrl":"https://auth.rtl.de/auth/realms/rtlplus/protocol/openid-connect","clientId":"bedrock-ott-magenta","clientSecret":"4bfeb73f-1c4a-4e9f-a7fa-96aa1ad3d94c","customApi":"https://auth.rtl.de/auth/realms/rtlplus/api","endpoints":{"AUTHORIZATION":"auth","CUSTOM_LOGOUT":"custom-logout","DEVICE_AUTHORIZATION":"auth/device","LOGOUT":"logout","REVOCATION":"revoke","TOKEN":"token","USERINFO":"userinfo"},"ssiApi":"https://dtag.partner.prod.r5s.aws-cbc.cloud"},"pairing":{"pairingPollInterval":10000,"pairingTimeout":300000,"upsellURL":"https://my.plus.rtl.de/buchen/initial/","ssiURL":"https://www.telekom.de/zubuchoptionen/magenta-tv/rtl-plus","subscriptionURL":"https://my.plus.rtl.de/buchen"},"parentalCode":{"length":4,"reinitializedCodeTimeout":2500},"qrCode":{"links":{"account_settings":{"short":"https://bit.ly/4hHSa8Z","long":"https://rtlplus-front.rtlde.bedrock.tech/mein-konto/tv-synchronisierung?platformCode=ott_boxes"},"faq":{"short":"https://bit.ly/4bhC7xm","long":"https://community.plus.rtl.de/s/hilfecenter?platformCode=ott_boxes"},"feedback":{"short":"https://bit.ly/43ba0xv","long":"http://rtlplus.com/austausch?platformCode=ott_boxes"},"information":{"short":"https://bit.ly/43Fny4H","long":"https://my.plus.rtl.de/account?platformCode=ott_boxes"}}},"search":{"charactersToSearch":3},"skeleton":{"patterns":[{"path":"app/alias/home","preset":"generic"},{"path":"app/service/.*","preset":"generic"}]},"staticFiles":{"base":"https://static-content.rtlde.bedrock.tech","files":{"termsOfUsage":"5/67cafaa27e803.md","legalConditions":"4/67cafa871d686.md","privacyPolicy":"2/6776ac5eac22f.md"}},"startover":{"startoverJingleDuration":1000,"startoverMaxDepth":60,"startoverMaxPercentage":90,"startoverMinDepth":10,"startoverMinPercentage":10},"thirdParties":{"engines":[]},"video":{"programParams":{"with":"links,subcats,rights"},"drm":{"com.microsoft.playready":{"serverURL":"https://lic.drmtoday.com/license-proxy-headerauth/drmtoday/RightsManager.asmx"},"com.widevine.alpha":{"serverURL":"https://lic.drmtoday.com/license-proxy-widevine/cenc/"},"merchantId":"m6","sessionId":"6play"}},"youbora":{"accountCode":"m6","playheadMonitoringInterval":1800},"clientCode":"local_stb","country":"nl","customerCode":"rtlde","defaultService":"rtlde","gdprCookies":["audienceMeasurement","personalization","targetedAdvertising"],"language":"de","platformCode":"magenta_ott_boxes","tenant":"rtlde","app":"rtlde-magenta"}');

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/harmony module decorator */
/******/ 	(() => {
/******/ 		__webpack_require__.hmd = (module) => {
/******/ 			module = Object.create(module);
/******/ 			if (!module.children) module.children = [];
/******/ 			Object.defineProperty(module, 'exports', {
/******/ 				enumerable: true,
/******/ 				set: () => {
/******/ 					throw new Error('ES Modules may not assign module.exports or exports.*, Use ESM export syntax, instead: ' + module.id);
/******/ 				}
/******/ 			});
/******/ 			return module;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	(() => {
/******/ 		__webpack_require__.nmd = (module) => {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	(() => {
/******/ 		__webpack_require__.p = "/";
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			179: 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkapp_bedrock_rdk"] = self["webpackChunkapp_bedrock_rdk"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, [206,996,427,967,736], () => (__webpack_require__(20747)))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;